// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
/*
Author         : G-axon
Template Name  : Wieldy Antd React - Admin Template
Version        : 1.0
*/
/*=============================================================
    Table of Contents:
    =============================
    A. Globals
        01. Custom Animation
        02. Colors Class

    B. Base
        01. Base Styles
        02. Row Col Styles
        03. Margin Padding Styles
        04. Typography Styles
        05. Flex Styles

    C. Layouts
        01. Ant Layout Style
        02. Header Style
        03. Sidebar Style
        04. Navbar(Ant Menu) Style
        05. Footer Styles
        06. Customizer Style
        07. Drawer Style

    D. UI Components
        01. Alert Styles
        02. Avatar Styles
        03. BackTop Styles
        04. Badges Styles
        05. Button Styles
        06. Cards Styles
        07. Cascader Styles
        08. Chart Styles
        09. Form Styles
        10. Icon Styles
        11. Input Styles
        12. List Styles
        13. Loader Styles
        14. Pagination Styles
        15. Pickers Styles
        16. Progress Styles
        17. Slider Styles
        18. Steps Styles
        19. Tables Styles
        20. Tabs Styles
        21. Time Lines Style

    E. Apps
        01. Apps Style
        02. Mails Apps Styles
        03. Chat Apps Styles
        04. Contact Apps Styles
        05. Calendar Apps Style
        06. Profile App Style
        07. Wall App Style

    F. Pages
        01. Callout Styles
        02. E-commerce Styles
        03. Pricing Tables Styles
        04. Login Styles
        05. Dashboard Styles
        06. Error Styles
        07. Editor Styles
        08. Testimonial Styles
        09. Algolia Styles

  =============================================================*/
[class^=ant-]::-ms-clear,
[class*= ant-]::-ms-clear,
[class^=ant-] input::-ms-clear,
[class*= ant-] input::-ms-clear,
[class^=ant-] input::-ms-reveal,
[class*= ant-] input::-ms-reveal {
  display: none;
}
/* stylelint-disable property-no-vendor-prefix, at-rule-no-vendor-prefix */
html,
body {
  width: 100%;
  height: 100%;
}
input::-ms-clear,
input::-ms-reveal {
  display: none;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
@-ms-viewport {
  width: device-width;
}
body {
  margin: 0;
  color: #545454;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  font-variant: tabular-nums;
  line-height: 1.3;
  background-color: #f5f5f5;
  font-feature-settings: 'tnum';
}
[tabindex='-1']:focus {
  outline: none !important;
}
hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 500;
}
p {
  margin-top: 0;
  margin-bottom: 1em;
}
abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  border-bottom: 0;
  cursor: help;
}
address {
  margin-bottom: 1em;
  font-style: normal;
  line-height: inherit;
}
input[type='text'],
input[type='password'],
input[type='number'],
textarea {
  -webkit-appearance: none;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1em;
}
ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}
dt {
  font-weight: 500;
}
dd {
  margin-bottom: 0.5em;
  margin-left: 0;
}
blockquote {
  margin: 0 0 1em;
}
dfn {
  font-style: italic;
}
b,
strong {
  font-weight: bolder;
}
small {
  font-size: 80%;
}
sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
a {
  color: var(--app-primary-color);
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}
a:hover {
  color: #0d0d0d;
}
a:active {
  color: #000000;
}
a:active,
a:hover {
  text-decoration: none;
  outline: 0;
}
a:focus {
  text-decoration: none;
  outline: 0;
}
a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
pre,
code,
kbd,
samp {
  font-size: 1em;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
}
pre {
  margin-top: 0;
  margin-bottom: 1em;
  overflow: auto;
}
figure {
  margin: 0 0 1em;
}
img {
  vertical-align: middle;
  border-style: none;
}
a,
area,
button,
[role='button'],
input:not([type='range']),
label,
select,
summary,
textarea {
  touch-action: manipulation;
}
table {
  border-collapse: collapse;
}
caption {
  padding-top: 0.75em;
  padding-bottom: 0.3em;
  color: #595959;
  text-align: left;
  caption-side: bottom;
}
input,
button,
select,
optgroup,
textarea {
  margin: 0;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
button,
input {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}
button::-moz-focus-inner,
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
input[type='radio'],
input[type='checkbox'] {
  box-sizing: border-box;
  padding: 0;
}
input[type='date'],
input[type='time'],
input[type='datetime-local'],
input[type='month'] {
  -webkit-appearance: listbox;
}
textarea {
  overflow: auto;
  resize: vertical;
}
fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.5em;
  padding: 0;
  color: inherit;
  font-size: 1.5em;
  line-height: inherit;
  white-space: normal;
}
progress {
  vertical-align: baseline;
}
[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
  height: auto;
}
[type='search'] {
  outline-offset: -2px;
  -webkit-appearance: none;
}
[type='search']::-webkit-search-cancel-button,
[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}
output {
  display: inline-block;
}
summary {
  display: list-item;
}
template {
  display: none;
}
[hidden] {
  display: none !important;
}
mark {
  padding: 0.2em;
  background-color: #feffe6;
}
::selection {
  color: #fff;
  background: #351a55;
}
.clearfix::before {
  display: table;
  content: '';
}
.clearfix::after {
  display: table;
  clear: both;
  content: '';
}
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.anticon > * {
  line-height: 1;
}
.anticon svg {
  display: inline-block;
}
.anticon::before {
  display: none;
}
.anticon .anticon-icon {
  display: block;
}
.anticon > .anticon {
  line-height: 0;
  vertical-align: 0;
}
.anticon[tabindex] {
  cursor: pointer;
}
.anticon-spin,
.anticon-spin::before {
  display: inline-block;
  animation: loadingCircle 1s infinite linear;
}
.ant-fade-enter,
.ant-fade-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-fade-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-fade-enter.ant-fade-enter-active,
.ant-fade-appear.ant-fade-appear-active {
  animation-name: antFadeIn;
  animation-play-state: running;
}
.ant-fade-leave.ant-fade-leave-active {
  animation-name: antFadeOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-fade-enter,
.ant-fade-appear {
  opacity: 0;
  animation-timing-function: linear;
}
.ant-fade-leave {
  animation-timing-function: linear;
}
@keyframes antFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes antFadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.ant-move-up-enter,
.ant-move-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-up-enter.ant-move-up-enter-active,
.ant-move-up-appear.ant-move-up-appear-active {
  animation-name: antMoveUpIn;
  animation-play-state: running;
}
.ant-move-up-leave.ant-move-up-leave-active {
  animation-name: antMoveUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-move-up-enter,
.ant-move-up-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-move-up-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.ant-move-down-enter,
.ant-move-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-down-enter.ant-move-down-enter-active,
.ant-move-down-appear.ant-move-down-appear-active {
  animation-name: antMoveDownIn;
  animation-play-state: running;
}
.ant-move-down-leave.ant-move-down-leave-active {
  animation-name: antMoveDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-move-down-enter,
.ant-move-down-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-move-down-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.ant-move-left-enter,
.ant-move-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-left-enter.ant-move-left-enter-active,
.ant-move-left-appear.ant-move-left-appear-active {
  animation-name: antMoveLeftIn;
  animation-play-state: running;
}
.ant-move-left-leave.ant-move-left-leave-active {
  animation-name: antMoveLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-move-left-enter,
.ant-move-left-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-move-left-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.ant-move-right-enter,
.ant-move-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-right-enter.ant-move-right-enter-active,
.ant-move-right-appear.ant-move-right-appear-active {
  animation-name: antMoveRightIn;
  animation-play-state: running;
}
.ant-move-right-leave.ant-move-right-leave-active {
  animation-name: antMoveRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-move-right-enter,
.ant-move-right-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-move-right-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
@keyframes antMoveDownIn {
  0% {
    transform: translateY(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveDownOut {
  0% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateY(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveLeftIn {
  0% {
    transform: translateX(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveLeftOut {
  0% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateX(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveRightIn {
  0% {
    transform: translateX(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveRightOut {
  0% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveUpIn {
  0% {
    transform: translateY(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveUpOut {
  0% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateY(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes loadingCircle {
  100% {
    transform: rotate(360deg);
  }
}
[ant-click-animating='true'],
[ant-click-animating-without-extra-node='true'] {
  position: relative;
}
html {
  --antd-wave-shadow-color: #351a55;
  --scroll-bar: 0;
}
[ant-click-animating-without-extra-node='true']::after,
.ant-click-animating-node {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  border-radius: inherit;
  box-shadow: 0 0 0 0 #351a55;
  box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);
  opacity: 0.2;
  animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);
  animation-fill-mode: forwards;
  content: '';
  pointer-events: none;
}
@keyframes waveEffect {
  100% {
    box-shadow: 0 0 0 #351a55;
    box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);
  }
}
@keyframes fadeEffect {
  100% {
    opacity: 0;
  }
}
.ant-slide-up-enter,
.ant-slide-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-up-enter.ant-slide-up-enter-active,
.ant-slide-up-appear.ant-slide-up-appear-active {
  animation-name: antSlideUpIn;
  animation-play-state: running;
}
.ant-slide-up-leave.ant-slide-up-leave-active {
  animation-name: antSlideUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-slide-up-enter,
.ant-slide-up-appear {
  transform: scale(0);
  transform-origin: 0% 0%;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.ant-slide-up-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.ant-slide-down-enter,
.ant-slide-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-down-enter.ant-slide-down-enter-active,
.ant-slide-down-appear.ant-slide-down-appear-active {
  animation-name: antSlideDownIn;
  animation-play-state: running;
}
.ant-slide-down-leave.ant-slide-down-leave-active {
  animation-name: antSlideDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-slide-down-enter,
.ant-slide-down-appear {
  transform: scale(0);
  transform-origin: 0% 0%;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.ant-slide-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.ant-slide-left-enter,
.ant-slide-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-left-enter.ant-slide-left-enter-active,
.ant-slide-left-appear.ant-slide-left-appear-active {
  animation-name: antSlideLeftIn;
  animation-play-state: running;
}
.ant-slide-left-leave.ant-slide-left-leave-active {
  animation-name: antSlideLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-slide-left-enter,
.ant-slide-left-appear {
  transform: scale(0);
  transform-origin: 0% 0%;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.ant-slide-left-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.ant-slide-right-enter,
.ant-slide-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-right-enter.ant-slide-right-enter-active,
.ant-slide-right-appear.ant-slide-right-appear-active {
  animation-name: antSlideRightIn;
  animation-play-state: running;
}
.ant-slide-right-leave.ant-slide-right-leave-active {
  animation-name: antSlideRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-slide-right-enter,
.ant-slide-right-appear {
  transform: scale(0);
  transform-origin: 0% 0%;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.ant-slide-right-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
@keyframes antSlideUpIn {
  0% {
    transform: scaleY(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
  100% {
    transform: scaleY(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
}
@keyframes antSlideUpOut {
  0% {
    transform: scaleY(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleY(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
}
@keyframes antSlideDownIn {
  0% {
    transform: scaleY(0.8);
    transform-origin: 100% 100%;
    opacity: 0;
  }
  100% {
    transform: scaleY(1);
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@keyframes antSlideDownOut {
  0% {
    transform: scaleY(1);
    transform-origin: 100% 100%;
    opacity: 1;
  }
  100% {
    transform: scaleY(0.8);
    transform-origin: 100% 100%;
    opacity: 0;
  }
}
@keyframes antSlideLeftIn {
  0% {
    transform: scaleX(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
  100% {
    transform: scaleX(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
}
@keyframes antSlideLeftOut {
  0% {
    transform: scaleX(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleX(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
}
@keyframes antSlideRightIn {
  0% {
    transform: scaleX(0.8);
    transform-origin: 100% 0%;
    opacity: 0;
  }
  100% {
    transform: scaleX(1);
    transform-origin: 100% 0%;
    opacity: 1;
  }
}
@keyframes antSlideRightOut {
  0% {
    transform: scaleX(1);
    transform-origin: 100% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleX(0.8);
    transform-origin: 100% 0%;
    opacity: 0;
  }
}
.ant-zoom-enter,
.ant-zoom-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-enter.ant-zoom-enter-active,
.ant-zoom-appear.ant-zoom-appear-active {
  animation-name: antZoomIn;
  animation-play-state: running;
}
.ant-zoom-leave.ant-zoom-leave-active {
  animation-name: antZoomOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-enter,
.ant-zoom-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-enter-prepare,
.ant-zoom-appear-prepare {
  transform: none;
}
.ant-zoom-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-big-enter,
.ant-zoom-big-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-big-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-big-enter.ant-zoom-big-enter-active,
.ant-zoom-big-appear.ant-zoom-big-appear-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}
.ant-zoom-big-leave.ant-zoom-big-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-big-enter,
.ant-zoom-big-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-big-enter-prepare,
.ant-zoom-big-appear-prepare {
  transform: none;
}
.ant-zoom-big-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-big-fast-enter,
.ant-zoom-big-fast-appear {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-big-fast-leave {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-big-fast-enter.ant-zoom-big-fast-enter-active,
.ant-zoom-big-fast-appear.ant-zoom-big-fast-appear-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}
.ant-zoom-big-fast-leave.ant-zoom-big-fast-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-big-fast-enter,
.ant-zoom-big-fast-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-big-fast-enter-prepare,
.ant-zoom-big-fast-appear-prepare {
  transform: none;
}
.ant-zoom-big-fast-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-up-enter,
.ant-zoom-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-up-enter.ant-zoom-up-enter-active,
.ant-zoom-up-appear.ant-zoom-up-appear-active {
  animation-name: antZoomUpIn;
  animation-play-state: running;
}
.ant-zoom-up-leave.ant-zoom-up-leave-active {
  animation-name: antZoomUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-up-enter,
.ant-zoom-up-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-up-enter-prepare,
.ant-zoom-up-appear-prepare {
  transform: none;
}
.ant-zoom-up-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-down-enter,
.ant-zoom-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-down-enter.ant-zoom-down-enter-active,
.ant-zoom-down-appear.ant-zoom-down-appear-active {
  animation-name: antZoomDownIn;
  animation-play-state: running;
}
.ant-zoom-down-leave.ant-zoom-down-leave-active {
  animation-name: antZoomDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-down-enter,
.ant-zoom-down-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-down-enter-prepare,
.ant-zoom-down-appear-prepare {
  transform: none;
}
.ant-zoom-down-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-left-enter,
.ant-zoom-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-left-enter.ant-zoom-left-enter-active,
.ant-zoom-left-appear.ant-zoom-left-appear-active {
  animation-name: antZoomLeftIn;
  animation-play-state: running;
}
.ant-zoom-left-leave.ant-zoom-left-leave-active {
  animation-name: antZoomLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-left-enter,
.ant-zoom-left-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-left-enter-prepare,
.ant-zoom-left-appear-prepare {
  transform: none;
}
.ant-zoom-left-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-right-enter,
.ant-zoom-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-right-enter.ant-zoom-right-enter-active,
.ant-zoom-right-appear.ant-zoom-right-appear-active {
  animation-name: antZoomRightIn;
  animation-play-state: running;
}
.ant-zoom-right-leave.ant-zoom-right-leave-active {
  animation-name: antZoomRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-right-enter,
.ant-zoom-right-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-right-enter-prepare,
.ant-zoom-right-appear-prepare {
  transform: none;
}
.ant-zoom-right-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
@keyframes antZoomIn {
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes antZoomOut {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.2);
    opacity: 0;
  }
}
@keyframes antZoomBigIn {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes antZoomBigOut {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}
@keyframes antZoomUpIn {
  0% {
    transform: scale(0.8);
    transform-origin: 50% 0%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 50% 0%;
  }
}
@keyframes antZoomUpOut {
  0% {
    transform: scale(1);
    transform-origin: 50% 0%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 50% 0%;
    opacity: 0;
  }
}
@keyframes antZoomLeftIn {
  0% {
    transform: scale(0.8);
    transform-origin: 0% 50%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 0% 50%;
  }
}
@keyframes antZoomLeftOut {
  0% {
    transform: scale(1);
    transform-origin: 0% 50%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 0% 50%;
    opacity: 0;
  }
}
@keyframes antZoomRightIn {
  0% {
    transform: scale(0.8);
    transform-origin: 100% 50%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 100% 50%;
  }
}
@keyframes antZoomRightOut {
  0% {
    transform: scale(1);
    transform-origin: 100% 50%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 100% 50%;
    opacity: 0;
  }
}
@keyframes antZoomDownIn {
  0% {
    transform: scale(0.8);
    transform-origin: 50% 100%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
}
@keyframes antZoomDownOut {
  0% {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 50% 100%;
    opacity: 0;
  }
}
.ant-motion-collapse-legacy {
  overflow: hidden;
}
.ant-motion-collapse-legacy-active {
  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}
.ant-motion-collapse {
  overflow: hidden;
  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}
.ant-affix {
  position: fixed;
  z-index: 10;
}
.ant-alert {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  word-wrap: break-word;
  border-radius: 6px;
}
.ant-alert-content {
  flex: 1;
  min-width: 0;
}
.ant-alert-icon {
  margin-right: 8px;
}
.ant-alert-description {
  display: none;
  font-size: 14px;
  line-height: 22px;
}
.ant-alert-success {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
}
.ant-alert-success .ant-alert-icon {
  color: #52c41a;
}
.ant-alert-info {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}
.ant-alert-info .ant-alert-icon {
  color: #1890ff;
}
.ant-alert-warning {
  background-color: #fff7e6;
  border: 1px solid #ffd591;
}
.ant-alert-warning .ant-alert-icon {
  color: #fa8c16;
}
.ant-alert-error {
  background-color: #fff1f0;
  border: 1px solid #ffa39e;
}
.ant-alert-error .ant-alert-icon {
  color: #f5222d;
}
.ant-alert-error .ant-alert-description > pre {
  margin: 0;
  padding: 0;
}
.ant-alert-action {
  margin-left: 8px;
}
.ant-alert-close-icon {
  margin-left: 8px;
  padding: 0;
  overflow: hidden;
  font-size: 12px;
  line-height: 12px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}
.ant-alert-close-icon .anticon-close {
  color: #595959;
  transition: color 0.3s;
}
.ant-alert-close-icon .anticon-close:hover {
  color: rgba(0, 0, 0, 0.75);
}
.ant-alert-close-text {
  color: #595959;
  transition: color 0.3s;
}
.ant-alert-close-text:hover {
  color: rgba(0, 0, 0, 0.75);
}
.ant-alert-with-description {
  align-items: flex-start;
  padding: 15px 15px 15px 24px;
}
.ant-alert-with-description.ant-alert-no-icon {
  padding: 15px 15px;
}
.ant-alert-with-description .ant-alert-icon {
  margin-right: 15px;
  font-size: 24px;
}
.ant-alert-with-description .ant-alert-message {
  display: block;
  margin-bottom: 4px;
  color: #535353;
  font-size: 16px;
}
.ant-alert-message {
  color: #535353;
}
.ant-alert-with-description .ant-alert-description {
  display: block;
}
.ant-alert.ant-alert-motion-leave {
  overflow: hidden;
  opacity: 1;
  transition: max-height 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), opacity 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), padding-top 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), padding-bottom 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), margin-bottom 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-alert.ant-alert-motion-leave-active {
  max-height: 0;
  margin-bottom: 0 !important;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}
.ant-alert-banner {
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
}
.ant-alert.ant-alert-rtl {
  direction: rtl;
}
.ant-alert-rtl .ant-alert-icon {
  margin-right: auto;
  margin-left: 8px;
}
.ant-alert-rtl .ant-alert-action {
  margin-right: 8px;
  margin-left: auto;
}
.ant-alert-rtl .ant-alert-close-icon {
  margin-right: 8px;
  margin-left: auto;
}
.ant-alert-rtl.ant-alert-with-description {
  padding-right: 24px;
  padding-left: 15px;
}
.ant-alert-rtl.ant-alert-with-description .ant-alert-icon {
  margin-right: auto;
  margin-left: 15px;
}
.ant-anchor {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  padding-left: 2px;
}
.ant-anchor-wrapper {
  margin-left: -4px;
  padding-left: 4px;
  overflow: auto;
  background-color: transparent;
}
.ant-anchor-ink {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}
.ant-anchor-ink::before {
  position: relative;
  display: block;
  width: 2px;
  height: 100%;
  margin: 0 auto;
  background-color: #e8e8e8;
  content: ' ';
}
.ant-anchor-ink-ball {
  position: absolute;
  left: 50%;
  display: none;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border: 2px solid #351a55;
  border-radius: 8px;
  transform: translateX(-50%);
  transition: top 0.3s ease-in-out;
}
.ant-anchor-ink-ball.ant-anchor-ink-ball-visible {
  display: inline-block;
}
.ant-anchor-fixed .ant-anchor-ink .ant-anchor-ink-ball {
  display: none;
}
.ant-anchor-link {
  padding: 4px 0 4px 16px;
}
.ant-anchor-link-title {
  position: relative;
  display: block;
  margin-bottom: 3px;
  overflow: hidden;
  color: #545454;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.3s;
}
.ant-anchor-link-title:only-child {
  margin-bottom: 0;
}
.ant-anchor-link-active > .ant-anchor-link-title {
  color: #351a55;
}
.ant-anchor-link .ant-anchor-link {
  padding-top: 2px;
  padding-bottom: 2px;
}
.ant-anchor-rtl {
  direction: rtl;
}
.ant-anchor-rtl.ant-anchor-wrapper {
  margin-right: -4px;
  margin-left: 0;
  padding-right: 4px;
  padding-left: 0;
}
.ant-anchor-rtl .ant-anchor-ink {
  right: 0;
  left: auto;
}
.ant-anchor-rtl .ant-anchor-ink-ball {
  right: 50%;
  left: 0;
  transform: translateX(50%);
}
.ant-anchor-rtl .ant-anchor-link {
  padding: 4px 16px 4px 0;
}
.ant-select-auto-complete {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-select-auto-complete .ant-select-clear {
  right: 13px;
}
.ant-avatar {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  background: #ccc;
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 50%;
}
.ant-avatar-image {
  background: transparent;
}
.ant-avatar .ant-image-img {
  display: block;
}
.ant-avatar-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}
.ant-avatar.ant-avatar-icon {
  font-size: 18px;
}
.ant-avatar.ant-avatar-icon > .anticon {
  margin: 0;
}
.ant-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
}
.ant-avatar-lg-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}
.ant-avatar-lg.ant-avatar-icon {
  font-size: 24px;
}
.ant-avatar-lg.ant-avatar-icon > .anticon {
  margin: 0;
}
.ant-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
}
.ant-avatar-sm-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}
.ant-avatar-sm.ant-avatar-icon {
  font-size: 14px;
}
.ant-avatar-sm.ant-avatar-icon > .anticon {
  margin: 0;
}
.ant-avatar-square {
  border-radius: 6px;
}
.ant-avatar > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ant-avatar-group {
  display: inline-flex;
}
.ant-avatar-group .ant-avatar {
  border: 1px solid #fff;
}
.ant-avatar-group .ant-avatar:not(:first-child) {
  margin-left: -8px;
}
.ant-avatar-group-popover .ant-avatar + .ant-avatar {
  margin-left: 3px;
}
.ant-avatar-group-rtl .ant-avatar:not(:first-child) {
  margin-right: -8px;
  margin-left: 0;
}
.ant-avatar-group-popover.ant-popover-rtl .ant-avatar + .ant-avatar {
  margin-right: 3px;
  margin-left: 0;
}
.ant-back-top {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: fixed;
  right: 100px;
  bottom: 50px;
  z-index: 10;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.ant-back-top:empty {
  display: none;
}
.ant-back-top-rtl {
  right: auto;
  left: 100px;
  direction: rtl;
}
.ant-back-top-content {
  width: 40px;
  height: 40px;
  overflow: hidden;
  color: #fff;
  text-align: center;
  background-color: #595959;
  border-radius: 20px;
  transition: all 0.3s;
}
.ant-back-top-content:hover {
  background-color: #545454;
  transition: all 0.3s;
}
.ant-back-top-icon {
  font-size: 24px;
  line-height: 40px;
}
@media screen and (max-width: 768px) {
  .ant-back-top {
    right: 60px;
  }
  .ant-back-top-rtl {
    right: auto;
    left: 60px;
  }
}
@media screen and (max-width: 480px) {
  .ant-back-top {
    right: 20px;
  }
  .ant-back-top-rtl {
    right: auto;
    left: 20px;
  }
}
.ant-badge {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  line-height: 1;
}
.ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #f5222d;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}
.ant-badge-count a,
.ant-badge-count a:hover {
  color: #fff;
}
.ant-badge-count-sm {
  min-width: 14px;
  height: 14px;
  padding: 0;
  font-size: 12px;
  line-height: 14px;
  border-radius: 7px;
}
.ant-badge-multiple-words {
  padding: 0 8px;
}
.ant-badge-dot {
  z-index: auto;
  width: 6px;
  min-width: 6px;
  height: 6px;
  background: #f5222d;
  border-radius: 100%;
  box-shadow: 0 0 0 1px #fff;
}
.ant-badge-dot.ant-scroll-number {
  transition: background 1.5s;
}
.ant-badge-count,
.ant-badge-dot,
.ant-badge .ant-scroll-number-custom-component {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  transform-origin: 100% 0%;
}
.ant-badge-count.anticon-spin,
.ant-badge-dot.anticon-spin,
.ant-badge .ant-scroll-number-custom-component.anticon-spin {
  animation: antBadgeLoadingCircle 1s infinite linear;
}
.ant-badge-status {
  line-height: inherit;
  vertical-align: baseline;
}
.ant-badge-status-dot {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 6px;
  height: 6px;
  vertical-align: middle;
  border-radius: 50%;
}
.ant-badge-status-success {
  background-color: #52c41a;
}
.ant-badge-status-processing {
  position: relative;
  background-color: var(--app-primary-color);
}
.ant-badge-status-processing::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid var(--app-primary-color);
  border-radius: 50%;
  animation: antStatusProcessing 1.2s infinite ease-in-out;
  content: '';
}
.ant-badge-status-default {
  background-color: #d9d9d9;
}
.ant-badge-status-error {
  background-color: #f5222d;
}
.ant-badge-status-warning {
  background-color: #fa8c16;
}
.ant-badge-status-pink {
  background: #eb2f96;
}
.ant-badge-status-magenta {
  background: #eb2f96;
}
.ant-badge-status-red {
  background: #f5222d;
}
.ant-badge-status-volcano {
  background: #fa541c;
}
.ant-badge-status-orange {
  background: #fa8c16;
}
.ant-badge-status-yellow {
  background: #fadb14;
}
.ant-badge-status-gold {
  background: #faad14;
}
.ant-badge-status-cyan {
  background: #13c2c2;
}
.ant-badge-status-lime {
  background: #a0d911;
}
.ant-badge-status-green {
  background: #52c41a;
}
.ant-badge-status-blue {
  background: #1890ff;
}
.ant-badge-status-geekblue {
  background: #2f54eb;
}
.ant-badge-status-purple {
  background: #722ed1;
}
.ant-badge-status-text {
  margin-left: 8px;
  color: #545454;
  font-size: 14px;
}
.ant-badge-zoom-appear,
.ant-badge-zoom-enter {
  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  animation-fill-mode: both;
}
.ant-badge-zoom-leave {
  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);
  animation-fill-mode: both;
}
.ant-badge-not-a-wrapper .ant-badge-zoom-appear,
.ant-badge-not-a-wrapper .ant-badge-zoom-enter {
  animation: antNoWrapperZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
}
.ant-badge-not-a-wrapper .ant-badge-zoom-leave {
  animation: antNoWrapperZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);
}
.ant-badge-not-a-wrapper:not(.ant-badge-status) {
  vertical-align: middle;
}
.ant-badge-not-a-wrapper .ant-scroll-number-custom-component,
.ant-badge-not-a-wrapper .ant-badge-count {
  transform: none;
}
.ant-badge-not-a-wrapper .ant-scroll-number-custom-component,
.ant-badge-not-a-wrapper .ant-scroll-number {
  position: relative;
  top: auto;
  display: block;
  transform-origin: 50% 50%;
}
@keyframes antStatusProcessing {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(2.4);
    opacity: 0;
  }
}
.ant-scroll-number {
  overflow: hidden;
  direction: ltr;
}
.ant-scroll-number-only {
  position: relative;
  display: inline-block;
  height: 20px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  /* stylelint-disable property-no-vendor-prefix */
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  /* stylelint-enable property-no-vendor-prefix */
}
.ant-scroll-number-only > p.ant-scroll-number-only-unit {
  height: 20px;
  margin: 0;
  /* stylelint-disable property-no-vendor-prefix */
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  /* stylelint-enable property-no-vendor-prefix */
}
.ant-scroll-number-symbol {
  vertical-align: top;
}
@keyframes antZoomBadgeIn {
  0% {
    transform: scale(0) translate(50%, -50%);
    opacity: 0;
  }
  100% {
    transform: scale(1) translate(50%, -50%);
  }
}
@keyframes antZoomBadgeOut {
  0% {
    transform: scale(1) translate(50%, -50%);
  }
  100% {
    transform: scale(0) translate(50%, -50%);
    opacity: 0;
  }
}
@keyframes antNoWrapperZoomBadgeIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
  }
}
@keyframes antNoWrapperZoomBadgeOut {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}
@keyframes antBadgeLoadingCircle {
  0% {
    transform-origin: 50%;
  }
  100% {
    transform: translate(50%, -50%) rotate(360deg);
    transform-origin: 50%;
  }
}
.ant-ribbon-wrapper {
  position: relative;
}
.ant-ribbon {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: 8px;
  height: 22px;
  padding: 0 8px;
  color: #fff;
  line-height: 22px;
  white-space: nowrap;
  background-color: #351a55;
  border-radius: 4px;
}
.ant-ribbon-text {
  color: #fff;
}
.ant-ribbon-corner {
  position: absolute;
  top: 100%;
  width: 8px;
  height: 8px;
  color: currentcolor;
  border: 4px solid;
  transform: scaleY(0.75);
  transform-origin: top;
}
.ant-ribbon-corner::after {
  position: absolute;
  top: -4px;
  left: -4px;
  width: inherit;
  height: inherit;
  color: rgba(0, 0, 0, 0.25);
  border: inherit;
  content: '';
}
.ant-ribbon-color-pink {
  color: #eb2f96;
  background: #eb2f96;
}
.ant-ribbon-color-magenta {
  color: #eb2f96;
  background: #eb2f96;
}
.ant-ribbon-color-red {
  color: #f5222d;
  background: #f5222d;
}
.ant-ribbon-color-volcano {
  color: #fa541c;
  background: #fa541c;
}
.ant-ribbon-color-orange {
  color: #fa8c16;
  background: #fa8c16;
}
.ant-ribbon-color-yellow {
  color: #fadb14;
  background: #fadb14;
}
.ant-ribbon-color-gold {
  color: #faad14;
  background: #faad14;
}
.ant-ribbon-color-cyan {
  color: #13c2c2;
  background: #13c2c2;
}
.ant-ribbon-color-lime {
  color: #a0d911;
  background: #a0d911;
}
.ant-ribbon-color-green {
  color: #52c41a;
  background: #52c41a;
}
.ant-ribbon-color-blue {
  color: #1890ff;
  background: #1890ff;
}
.ant-ribbon-color-geekblue {
  color: #2f54eb;
  background: #2f54eb;
}
.ant-ribbon-color-purple {
  color: #722ed1;
  background: #722ed1;
}
.ant-ribbon.ant-ribbon-placement-end {
  right: -8px;
  border-bottom-right-radius: 0;
}
.ant-ribbon.ant-ribbon-placement-end .ant-ribbon-corner {
  right: 0;
  border-color: currentcolor transparent transparent currentcolor;
}
.ant-ribbon.ant-ribbon-placement-start {
  left: -8px;
  border-bottom-left-radius: 0;
}
.ant-ribbon.ant-ribbon-placement-start .ant-ribbon-corner {
  left: 0;
  border-color: currentcolor currentcolor transparent transparent;
}
.ant-badge-rtl {
  direction: rtl;
}
.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-badge-count,
.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-badge-dot,
.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-scroll-number-custom-component {
  right: auto;
  left: 0;
  direction: ltr;
  transform: translate(-50%, -50%);
  transform-origin: 0% 0%;
}
.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-scroll-number-custom-component {
  right: auto;
  left: 0;
  transform: translate(-50%, -50%);
  transform-origin: 0% 0%;
}
.ant-badge-rtl .ant-badge-status-text {
  margin-right: 8px;
  margin-left: 0;
}
.ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-appear,
.ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-enter {
  animation-name: antZoomBadgeInRtl;
}
.ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-leave {
  animation-name: antZoomBadgeOutRtl;
}
.ant-ribbon-rtl {
  direction: rtl;
}
.ant-ribbon-rtl.ant-ribbon-placement-end {
  right: unset;
  left: -8px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 0;
}
.ant-ribbon-rtl.ant-ribbon-placement-end .ant-ribbon-corner {
  right: unset;
  left: 0;
  border-color: currentcolor currentcolor transparent transparent;
}
.ant-ribbon-rtl.ant-ribbon-placement-end .ant-ribbon-corner::after {
  border-color: currentcolor currentcolor transparent transparent;
}
.ant-ribbon-rtl.ant-ribbon-placement-start {
  right: -8px;
  left: unset;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 4px;
}
.ant-ribbon-rtl.ant-ribbon-placement-start .ant-ribbon-corner {
  right: 0;
  left: unset;
  border-color: currentcolor transparent transparent currentcolor;
}
.ant-ribbon-rtl.ant-ribbon-placement-start .ant-ribbon-corner::after {
  border-color: currentcolor transparent transparent currentcolor;
}
@keyframes antZoomBadgeInRtl {
  0% {
    transform: scale(0) translate(-50%, -50%);
    opacity: 0;
  }
  100% {
    transform: scale(1) translate(-50%, -50%);
  }
}
@keyframes antZoomBadgeOutRtl {
  0% {
    transform: scale(1) translate(-50%, -50%);
  }
  100% {
    transform: scale(0) translate(-50%, -50%);
    opacity: 0;
  }
}
.ant-breadcrumb {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  color: #595959;
  font-size: 14px;
}
.ant-breadcrumb .anticon {
  font-size: 14px;
}
.ant-breadcrumb ol {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-breadcrumb a {
  color: #595959;
  transition: color 0.3s;
}
.ant-breadcrumb a:hover {
  color: #545454;
}
.ant-breadcrumb li:last-child {
  color: #545454;
}
.ant-breadcrumb li:last-child a {
  color: #545454;
}
li:last-child > .ant-breadcrumb-separator {
  display: none;
}
.ant-breadcrumb-separator {
  margin: 0 8px;
  color: #595959;
}
.ant-breadcrumb-link > .anticon + span,
.ant-breadcrumb-link > .anticon + a {
  margin-left: 4px;
}
.ant-breadcrumb-overlay-link > .anticon {
  margin-left: 4px;
}
.ant-breadcrumb-rtl {
  direction: rtl;
}
.ant-breadcrumb-rtl::before {
  display: table;
  content: '';
}
.ant-breadcrumb-rtl::after {
  display: table;
  clear: both;
  content: '';
}
.ant-breadcrumb-rtl::before {
  display: table;
  content: '';
}
.ant-breadcrumb-rtl::after {
  display: table;
  clear: both;
  content: '';
}
.ant-breadcrumb-rtl > span {
  float: right;
}
.ant-breadcrumb-rtl .ant-breadcrumb-link > .anticon + span,
.ant-breadcrumb-rtl .ant-breadcrumb-link > .anticon + a {
  margin-right: 4px;
  margin-left: 0;
}
.ant-breadcrumb-rtl .ant-breadcrumb-overlay-link > .anticon {
  margin-right: 4px;
  margin-left: 0;
}
.ant-btn {
  line-height: 1.3;
  position: relative;
  background-image: none;
  border: 1px solid transparent;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
  padding: 7.9px 15px;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: solid 1px #d9d9d9;
  padding: 0 15px;
  height: 36px;
  font-size: 14px;
  line-height: 34px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 15px;
  color: #545454;
  border-color: #d9d9d9;
  background: #fff;
}
.ant-btn > .anticon {
  line-height: 1;
}
.ant-btn,
.ant-btn:active,
.ant-btn:focus {
  outline: 0;
}
.ant-btn:not([disabled]):hover {
  text-decoration: none;
}
.ant-btn:not([disabled]):active {
  outline: 0;
  box-shadow: none;
}
.ant-btn[disabled] {
  cursor: not-allowed;
}
.ant-btn[disabled] > * {
  pointer-events: none;
}
.ant-btn-lg {
  height: 40px;
  padding: 8.6px 15px;
  font-size: 16px;
  border-radius: 4px;
}
.ant-btn-sm {
  height: 24px;
  padding: 3.2px 7px;
  font-size: 12px;
  border-radius: 4px;
}
.ant-btn:not(:last-child) {
  margin-right: 15px;
}
@media screen and (max-width: 575px) {
  .ant-btn:not(:last-child) {
    margin-right: 10px;
  }
}
@media screen and (max-width: 575px) {
  .ant-btn {
    margin-bottom: 10px;
  }
}
.ant-btn:focus,
.ant-btn:hover {
  text-decoration: none;
}
.ant-btn:focus,
.ant-btn.focus {
  outline: 0;
}
.ant-btn.disabled,
.ant-btn:disabled {
  opacity: 0.65;
}
.ant-btn:not([disabled]):not(.disabled) {
  cursor: pointer;
}
.gx-btn-list .ant-btn {
  margin-bottom: 6px;
}
.gx-sub-popover .ant-btn {
  border: 0 none;
  margin-bottom: 5px;
}
.gx-sub-popover .ant-btn:focus,
.gx-sub-popover .ant-btn:hover {
  background-color: #f5f5f5;
}
.gx-sub-popover .ant-btn:not(:last-child) {
  margin-right: 5px;
}
.gx-login-content .ant-btn {
  padding: 9px 20px !important;
  height: auto;
  line-height: 1;
}
.ant-btn > a:only-child {
  color: currentcolor;
}
.ant-btn > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn:hover,
.ant-btn:focus {
  color: #462e61;
  border-color: #462e61;
  background: #fff;
}
.ant-btn:hover > a:only-child,
.ant-btn:focus > a:only-child {
  color: currentcolor;
}
.ant-btn:hover > a:only-child::after,
.ant-btn:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn:active {
  color: #1a0c2e;
  border-color: #1a0c2e;
  background: #fff;
}
.ant-btn:active > a:only-child {
  color: currentcolor;
}
.ant-btn:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn[disabled],
.ant-btn[disabled]:hover,
.ant-btn[disabled]:focus,
.ant-btn[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn[disabled] > a:only-child,
.ant-btn[disabled]:hover > a:only-child,
.ant-btn[disabled]:focus > a:only-child,
.ant-btn[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn[disabled] > a:only-child::after,
.ant-btn[disabled]:hover > a:only-child::after,
.ant-btn[disabled]:focus > a:only-child::after,
.ant-btn[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn:hover,
.ant-btn:focus,
.ant-btn:active {
  text-decoration: none;
  background: #fff;
}
.ant-btn > span {
  display: inline-block;
}
.ant-btn-primary {
  color: #fff;
  border-color: #351a55;
  background: #351a55;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  color: #ffffff !important;
  background-color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
}
.ant-btn-primary > a:only-child {
  color: currentcolor;
}
.ant-btn-primary > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary:hover,
.ant-btn-primary:focus {
  color: #fff;
  border-color: #462e61;
  background: #462e61;
}
.ant-btn-primary:hover > a:only-child,
.ant-btn-primary:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-primary:hover > a:only-child::after,
.ant-btn-primary:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary:active {
  color: #fff;
  border-color: #1a0c2e;
  background: #1a0c2e;
}
.ant-btn-primary:active > a:only-child {
  color: currentcolor;
}
.ant-btn-primary:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:hover,
.ant-btn-primary[disabled]:focus,
.ant-btn-primary[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-primary[disabled] > a:only-child,
.ant-btn-primary[disabled]:hover > a:only-child,
.ant-btn-primary[disabled]:focus > a:only-child,
.ant-btn-primary[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-primary[disabled] > a:only-child::after,
.ant-btn-primary[disabled]:hover > a:only-child::after,
.ant-btn-primary[disabled]:focus > a:only-child::after,
.ant-btn-primary[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary:hover,
.ant-btn-primary:focus {
  color: #ffffff !important;
  background-color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
}
.ant-btn-primary.disabled,
.ant-btn-primary:disabled {
  background-color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
}
.ant-btn-primary:not([disabled]):not(.disabled):active,
.ant-btn-primary:not([disabled]):not(.disabled).active {
  color: #ffffff;
  background-color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
}
.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {
  border-right-color: #462e61;
  border-left-color: #462e61;
}
.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {
  border-color: #d9d9d9;
}
.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {
  border-right-color: #462e61;
}
.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {
  border-right-color: #d9d9d9;
}
.ant-btn-group .ant-btn-primary:last-child:not(:first-child),
.ant-btn-group .ant-btn-primary + .ant-btn-primary {
  border-left-color: #462e61;
}
.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],
.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {
  border-left-color: #d9d9d9;
}
.ant-btn-ghost {
  color: #545454;
  border-color: #d9d9d9;
  background: transparent;
}
.ant-btn-ghost > a:only-child {
  color: currentcolor;
}
.ant-btn-ghost > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-ghost:hover,
.ant-btn-ghost:focus {
  color: #462e61;
  border-color: #462e61;
  background: transparent;
}
.ant-btn-ghost:hover > a:only-child,
.ant-btn-ghost:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-ghost:hover > a:only-child::after,
.ant-btn-ghost:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-ghost:active {
  color: #1a0c2e;
  border-color: #1a0c2e;
  background: transparent;
}
.ant-btn-ghost:active > a:only-child {
  color: currentcolor;
}
.ant-btn-ghost:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-ghost[disabled],
.ant-btn-ghost[disabled]:hover,
.ant-btn-ghost[disabled]:focus,
.ant-btn-ghost[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-ghost[disabled] > a:only-child,
.ant-btn-ghost[disabled]:hover > a:only-child,
.ant-btn-ghost[disabled]:focus > a:only-child,
.ant-btn-ghost[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-ghost[disabled] > a:only-child::after,
.ant-btn-ghost[disabled]:hover > a:only-child::after,
.ant-btn-ghost[disabled]:focus > a:only-child::after,
.ant-btn-ghost[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed {
  color: #545454;
  border-color: #d9d9d9;
  background: #fff;
  border-style: dashed;
}
.ant-btn-dashed > a:only-child {
  color: currentcolor;
}
.ant-btn-dashed > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed:hover,
.ant-btn-dashed:focus {
  color: #462e61;
  border-color: #462e61;
  background: #fff;
}
.ant-btn-dashed:hover > a:only-child,
.ant-btn-dashed:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-dashed:hover > a:only-child::after,
.ant-btn-dashed:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed:active {
  color: #1a0c2e;
  border-color: #1a0c2e;
  background: #fff;
}
.ant-btn-dashed:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dashed:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed[disabled],
.ant-btn-dashed[disabled]:hover,
.ant-btn-dashed[disabled]:focus,
.ant-btn-dashed[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dashed[disabled] > a:only-child,
.ant-btn-dashed[disabled]:hover > a:only-child,
.ant-btn-dashed[disabled]:focus > a:only-child,
.ant-btn-dashed[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dashed[disabled] > a:only-child::after,
.ant-btn-dashed[disabled]:hover > a:only-child::after,
.ant-btn-dashed[disabled]:focus > a:only-child::after,
.ant-btn-dashed[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger {
  color: #fff;
  border-color: #f5222d;
  background: #f5222d;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.ant-btn-danger > a:only-child {
  color: currentcolor;
}
.ant-btn-danger > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger:hover,
.ant-btn-danger:focus {
  color: #fff;
  border-color: #ff4d4f;
  background: #ff4d4f;
}
.ant-btn-danger:hover > a:only-child,
.ant-btn-danger:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-danger:hover > a:only-child::after,
.ant-btn-danger:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger:active {
  color: #fff;
  border-color: #cf1322;
  background: #cf1322;
}
.ant-btn-danger:active > a:only-child {
  color: currentcolor;
}
.ant-btn-danger:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger[disabled],
.ant-btn-danger[disabled]:hover,
.ant-btn-danger[disabled]:focus,
.ant-btn-danger[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-danger[disabled] > a:only-child,
.ant-btn-danger[disabled]:hover > a:only-child,
.ant-btn-danger[disabled]:focus > a:only-child,
.ant-btn-danger[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-danger[disabled] > a:only-child::after,
.ant-btn-danger[disabled]:hover > a:only-child::after,
.ant-btn-danger[disabled]:focus > a:only-child::after,
.ant-btn-danger[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link {
  color: var(--app-primary-color);
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.ant-btn-link > a:only-child {
  color: currentcolor;
}
.ant-btn-link > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link:hover,
.ant-btn-link:focus {
  color: #462e61;
  border-color: #462e61;
  background: transparent;
}
.ant-btn-link:hover > a:only-child,
.ant-btn-link:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-link:hover > a:only-child::after,
.ant-btn-link:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link:active {
  color: #1a0c2e;
  border-color: #1a0c2e;
  background: transparent;
}
.ant-btn-link:active > a:only-child {
  color: currentcolor;
}
.ant-btn-link:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link[disabled],
.ant-btn-link[disabled]:hover,
.ant-btn-link[disabled]:focus,
.ant-btn-link[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-link[disabled] > a:only-child,
.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-link[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-link[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link:hover {
  background: transparent;
}
.ant-btn-link:hover,
.ant-btn-link:focus,
.ant-btn-link:active {
  border-color: transparent;
}
.ant-btn-link[disabled],
.ant-btn-link[disabled]:hover,
.ant-btn-link[disabled]:focus,
.ant-btn-link[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-link[disabled] > a:only-child,
.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-link[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-link[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-text {
  color: #545454;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.ant-btn-text > a:only-child {
  color: currentcolor;
}
.ant-btn-text > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-text:hover,
.ant-btn-text:focus {
  color: #462e61;
  border-color: #462e61;
  background: transparent;
}
.ant-btn-text:hover > a:only-child,
.ant-btn-text:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-text:hover > a:only-child::after,
.ant-btn-text:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-text:active {
  color: #1a0c2e;
  border-color: #1a0c2e;
  background: transparent;
}
.ant-btn-text:active > a:only-child {
  color: currentcolor;
}
.ant-btn-text:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-text[disabled],
.ant-btn-text[disabled]:hover,
.ant-btn-text[disabled]:focus,
.ant-btn-text[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-text[disabled] > a:only-child,
.ant-btn-text[disabled]:hover > a:only-child,
.ant-btn-text[disabled]:focus > a:only-child,
.ant-btn-text[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-text[disabled] > a:only-child::after,
.ant-btn-text[disabled]:hover > a:only-child::after,
.ant-btn-text[disabled]:focus > a:only-child::after,
.ant-btn-text[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-text:hover,
.ant-btn-text:focus {
  color: #545454;
  background: rgba(0, 0, 0, 0.018);
  border-color: transparent;
}
.ant-btn-text:active {
  color: #545454;
  background: rgba(0, 0, 0, 0.028);
  border-color: transparent;
}
.ant-btn-text[disabled],
.ant-btn-text[disabled]:hover,
.ant-btn-text[disabled]:focus,
.ant-btn-text[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-text[disabled] > a:only-child,
.ant-btn-text[disabled]:hover > a:only-child,
.ant-btn-text[disabled]:focus > a:only-child,
.ant-btn-text[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-text[disabled] > a:only-child::after,
.ant-btn-text[disabled]:hover > a:only-child::after,
.ant-btn-text[disabled]:focus > a:only-child::after,
.ant-btn-text[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous {
  color: #f5222d;
  border-color: #f5222d;
  background: #fff;
}
.ant-btn-dangerous > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous:hover,
.ant-btn-dangerous:focus {
  color: #ff4d4f;
  border-color: #ff4d4f;
  background: #fff;
}
.ant-btn-dangerous:hover > a:only-child,
.ant-btn-dangerous:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous:hover > a:only-child::after,
.ant-btn-dangerous:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous:active {
  color: #cf1322;
  border-color: #cf1322;
  background: #fff;
}
.ant-btn-dangerous:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous[disabled],
.ant-btn-dangerous[disabled]:hover,
.ant-btn-dangerous[disabled]:focus,
.ant-btn-dangerous[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous[disabled] > a:only-child,
.ant-btn-dangerous[disabled]:hover > a:only-child,
.ant-btn-dangerous[disabled]:focus > a:only-child,
.ant-btn-dangerous[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous[disabled] > a:only-child::after,
.ant-btn-dangerous[disabled]:hover > a:only-child::after,
.ant-btn-dangerous[disabled]:focus > a:only-child::after,
.ant-btn-dangerous[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-primary {
  color: #fff;
  border-color: #f5222d;
  background: #f5222d;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.ant-btn-dangerous.ant-btn-primary > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-primary > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-primary:hover,
.ant-btn-dangerous.ant-btn-primary:focus {
  color: #fff;
  border-color: #ff4d4f;
  background: #ff4d4f;
}
.ant-btn-dangerous.ant-btn-primary:hover > a:only-child,
.ant-btn-dangerous.ant-btn-primary:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-primary:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-primary:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-primary:active {
  color: #fff;
  border-color: #cf1322;
  background: #cf1322;
}
.ant-btn-dangerous.ant-btn-primary:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-primary:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-primary[disabled],
.ant-btn-dangerous.ant-btn-primary[disabled]:hover,
.ant-btn-dangerous.ant-btn-primary[disabled]:focus,
.ant-btn-dangerous.ant-btn-primary[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-primary[disabled] > a:only-child,
.ant-btn-dangerous.ant-btn-primary[disabled]:hover > a:only-child,
.ant-btn-dangerous.ant-btn-primary[disabled]:focus > a:only-child,
.ant-btn-dangerous.ant-btn-primary[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-primary[disabled] > a:only-child::after,
.ant-btn-dangerous.ant-btn-primary[disabled]:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-primary[disabled]:focus > a:only-child::after,
.ant-btn-dangerous.ant-btn-primary[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link {
  color: #f5222d;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-link > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-link > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link:hover,
.ant-btn-dangerous.ant-btn-link:focus {
  color: #462e61;
  border-color: #462e61;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-link:hover > a:only-child,
.ant-btn-dangerous.ant-btn-link:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-link:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-link:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link:active {
  color: #1a0c2e;
  border-color: #1a0c2e;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-link:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-link:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link[disabled],
.ant-btn-dangerous.ant-btn-link[disabled]:hover,
.ant-btn-dangerous.ant-btn-link[disabled]:focus,
.ant-btn-dangerous.ant-btn-link[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link:hover,
.ant-btn-dangerous.ant-btn-link:focus {
  color: #ff4d4f;
  border-color: transparent;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-link:hover > a:only-child,
.ant-btn-dangerous.ant-btn-link:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-link:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-link:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link:active {
  color: #cf1322;
  border-color: transparent;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-link:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-link:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link[disabled],
.ant-btn-dangerous.ant-btn-link[disabled]:hover,
.ant-btn-dangerous.ant-btn-link[disabled]:focus,
.ant-btn-dangerous.ant-btn-link[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text {
  color: #f5222d;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-text > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-text > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text:hover,
.ant-btn-dangerous.ant-btn-text:focus {
  color: #462e61;
  border-color: #462e61;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-text:hover > a:only-child,
.ant-btn-dangerous.ant-btn-text:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-text:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-text:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text:active {
  color: #1a0c2e;
  border-color: #1a0c2e;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-text:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-text:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text[disabled],
.ant-btn-dangerous.ant-btn-text[disabled]:hover,
.ant-btn-dangerous.ant-btn-text[disabled]:focus,
.ant-btn-dangerous.ant-btn-text[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text:hover,
.ant-btn-dangerous.ant-btn-text:focus {
  color: #ff4d4f;
  border-color: transparent;
  background: rgba(0, 0, 0, 0.018);
}
.ant-btn-dangerous.ant-btn-text:hover > a:only-child,
.ant-btn-dangerous.ant-btn-text:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-text:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-text:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text:active {
  color: #cf1322;
  border-color: transparent;
  background: rgba(0, 0, 0, 0.028);
}
.ant-btn-dangerous.ant-btn-text:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-text:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text[disabled],
.ant-btn-dangerous.ant-btn-text[disabled]:hover,
.ant-btn-dangerous.ant-btn-text[disabled]:focus,
.ant-btn-dangerous.ant-btn-text[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-icon-only {
  width: 36px;
  height: 36px;
  padding: 6.6px 0;
  font-size: 16px;
  border-radius: 4px;
  vertical-align: -3px;
}
.ant-btn-icon-only > * {
  font-size: 16px;
}
.ant-btn-icon-only.ant-btn-lg {
  width: 40px;
  height: 40px;
  padding: 7.3px 0;
  font-size: 18px;
  border-radius: 4px;
}
.ant-btn-icon-only.ant-btn-lg > * {
  font-size: 18px;
}
.ant-btn-icon-only.ant-btn-sm {
  width: 24px;
  height: 24px;
  padding: 1.9px 0;
  font-size: 14px;
  border-radius: 4px;
}
.ant-btn-icon-only.ant-btn-sm > * {
  font-size: 14px;
}
.ant-btn-icon-only > .anticon {
  display: flex;
  justify-content: center;
}
.ant-btn-icon-only .anticon-loading {
  padding: 0 !important;
}
a.ant-btn-icon-only {
  vertical-align: -1px;
}
a.ant-btn-icon-only > .anticon {
  display: inline;
}
.ant-btn-round {
  height: 36px;
  padding: 7.9px 18px;
  font-size: 14px;
  border-radius: 36px;
}
.ant-btn-round.ant-btn-lg {
  height: 40px;
  padding: 8.6px 20px;
  font-size: 16px;
  border-radius: 40px;
}
.ant-btn-round.ant-btn-sm {
  height: 24px;
  padding: 1.9px 12px;
  font-size: 14px;
  border-radius: 24px;
}
.ant-btn-round.ant-btn-icon-only {
  width: auto;
}
.ant-btn-circle {
  min-width: 36px;
  padding-right: 0;
  padding-left: 0;
  text-align: center;
  border-radius: 50%;
}
.ant-btn-circle.ant-btn-lg {
  min-width: 40px;
  border-radius: 50%;
}
.ant-btn-circle.ant-btn-sm {
  min-width: 24px;
  border-radius: 50%;
}
.ant-btn::before {
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  z-index: 1;
  display: none;
  background: #fff;
  border-radius: inherit;
  opacity: 0.35;
  transition: opacity 0.2s;
  content: '';
  pointer-events: none;
}
.ant-btn .anticon {
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-btn .anticon.anticon-plus > svg,
.ant-btn .anticon.anticon-minus > svg {
  shape-rendering: optimizespeed;
}
.ant-btn.ant-btn-loading {
  position: relative;
  cursor: default;
}
.ant-btn.ant-btn-loading::before {
  display: block;
}
.ant-btn > .ant-btn-loading-icon {
  transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-btn > .ant-btn-loading-icon .anticon {
  padding-right: 8px;
  animation: none;
}
.ant-btn > .ant-btn-loading-icon .anticon svg {
  animation: loadingCircle 1s infinite linear;
}
.ant-btn-group {
  position: relative;
  display: inline-flex;
}
.ant-btn-group > .ant-btn,
.ant-btn-group > span > .ant-btn {
  position: relative;
}
.ant-btn-group > .ant-btn:hover,
.ant-btn-group > span > .ant-btn:hover,
.ant-btn-group > .ant-btn:focus,
.ant-btn-group > span > .ant-btn:focus,
.ant-btn-group > .ant-btn:active,
.ant-btn-group > span > .ant-btn:active {
  z-index: 2;
}
.ant-btn-group > .ant-btn[disabled],
.ant-btn-group > span > .ant-btn[disabled] {
  z-index: 0;
}
.ant-btn-group .ant-btn-icon-only {
  font-size: 14px;
}
.ant-btn-group .ant-btn + .ant-btn,
.ant-btn + .ant-btn-group,
.ant-btn-group span + .ant-btn,
.ant-btn-group .ant-btn + span,
.ant-btn-group > span + span,
.ant-btn-group + .ant-btn,
.ant-btn-group + .ant-btn-group {
  margin-left: -1px;
}
.ant-btn-group .ant-btn-primary + .ant-btn:not(.ant-btn-primary):not([disabled]) {
  border-left-color: transparent;
}
.ant-btn-group .ant-btn {
  border-radius: 0;
}
.ant-btn-group > .ant-btn:first-child,
.ant-btn-group > span:first-child > .ant-btn {
  margin-left: 0;
}
.ant-btn-group > .ant-btn:only-child {
  border-radius: 4px;
}
.ant-btn-group > span:only-child > .ant-btn {
  border-radius: 4px;
}
.ant-btn-group > .ant-btn:first-child:not(:last-child),
.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.ant-btn-group > .ant-btn:last-child:not(:first-child),
.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ant-btn-group-sm > .ant-btn:only-child {
  border-radius: 4px;
}
.ant-btn-group-sm > span:only-child > .ant-btn {
  border-radius: 4px;
}
.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),
.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),
.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ant-btn-group > .ant-btn-group {
  float: left;
}
.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {
  border-radius: 0;
}
.ant-btn-group > .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {
  padding-right: 8px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-btn-group > .ant-btn-group:last-child:not(:first-child) > .ant-btn:first-child {
  padding-left: 8px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-btn-rtl.ant-btn-group .ant-btn + .ant-btn,
.ant-btn-rtl.ant-btn + .ant-btn-group,
.ant-btn-rtl.ant-btn-group span + .ant-btn,
.ant-btn-rtl.ant-btn-group .ant-btn + span,
.ant-btn-rtl.ant-btn-group > span + span,
.ant-btn-rtl.ant-btn-group + .ant-btn,
.ant-btn-rtl.ant-btn-group + .ant-btn-group,
.ant-btn-group-rtl.ant-btn-group .ant-btn + .ant-btn,
.ant-btn-group-rtl.ant-btn + .ant-btn-group,
.ant-btn-group-rtl.ant-btn-group span + .ant-btn,
.ant-btn-group-rtl.ant-btn-group .ant-btn + span,
.ant-btn-group-rtl.ant-btn-group > span + span,
.ant-btn-group-rtl.ant-btn-group + .ant-btn,
.ant-btn-group-rtl.ant-btn-group + .ant-btn-group {
  margin-right: -1px;
  margin-left: auto;
}
.ant-btn-group.ant-btn-group-rtl {
  direction: rtl;
}
.ant-btn-group-rtl.ant-btn-group > .ant-btn:first-child:not(:last-child),
.ant-btn-group-rtl.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border-radius: 0 4px 4px 0;
}
.ant-btn-group-rtl.ant-btn-group > .ant-btn:last-child:not(:first-child),
.ant-btn-group-rtl.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {
  border-radius: 4px 0 0 4px;
}
.ant-btn-group-rtl.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),
.ant-btn-group-rtl.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {
  border-radius: 0 4px 4px 0;
}
.ant-btn-group-rtl.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),
.ant-btn-group-rtl.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {
  border-radius: 4px 0 0 4px;
}
.ant-btn:focus > span,
.ant-btn:active > span {
  position: relative;
}
.ant-btn > .anticon + span,
.ant-btn > span + .anticon {
  margin-left: 8px;
}
.ant-btn.ant-btn-background-ghost {
  color: #fff;
  border-color: #fff;
}
.ant-btn.ant-btn-background-ghost,
.ant-btn.ant-btn-background-ghost:hover,
.ant-btn.ant-btn-background-ghost:active,
.ant-btn.ant-btn-background-ghost:focus {
  background: transparent;
}
.ant-btn.ant-btn-background-ghost:hover,
.ant-btn.ant-btn-background-ghost:focus {
  color: #462e61;
  border-color: #462e61;
}
.ant-btn.ant-btn-background-ghost:active {
  color: #1a0c2e;
  border-color: #1a0c2e;
}
.ant-btn.ant-btn-background-ghost[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  border-color: #d9d9d9;
}
.ant-btn-background-ghost.ant-btn-primary {
  color: #351a55;
  border-color: #351a55;
  text-shadow: none;
}
.ant-btn-background-ghost.ant-btn-primary > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-primary > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-primary:hover,
.ant-btn-background-ghost.ant-btn-primary:focus {
  color: #462e61;
  border-color: #462e61;
}
.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-primary:active {
  color: #1a0c2e;
  border-color: #1a0c2e;
}
.ant-btn-background-ghost.ant-btn-primary:active > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-primary:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-primary[disabled],
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger {
  color: #f5222d;
  border-color: #f5222d;
  text-shadow: none;
}
.ant-btn-background-ghost.ant-btn-danger > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-danger > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger:hover,
.ant-btn-background-ghost.ant-btn-danger:focus {
  color: #ff4d4f;
  border-color: #ff4d4f;
}
.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger:active {
  color: #cf1322;
  border-color: #cf1322;
}
.ant-btn-background-ghost.ant-btn-danger:active > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-danger:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger[disabled],
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous {
  color: #f5222d;
  border-color: #f5222d;
  text-shadow: none;
}
.ant-btn-background-ghost.ant-btn-dangerous > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-dangerous > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous:hover,
.ant-btn-background-ghost.ant-btn-dangerous:focus {
  color: #ff4d4f;
  border-color: #ff4d4f;
}
.ant-btn-background-ghost.ant-btn-dangerous:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-dangerous:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous:active {
  color: #cf1322;
  border-color: #cf1322;
}
.ant-btn-background-ghost.ant-btn-dangerous:active > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-dangerous:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous[disabled],
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-dangerous[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-dangerous[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link {
  color: #f5222d;
  border-color: transparent;
  text-shadow: none;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus {
  color: #ff4d4f;
  border-color: transparent;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active {
  color: #cf1322;
  border-color: transparent;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled],
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child {
  color: currentcolor;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-two-chinese-chars::first-letter {
  letter-spacing: 0.34em;
}
.ant-btn-two-chinese-chars > *:not(.anticon) {
  margin-right: -0.34em;
  letter-spacing: 0.34em;
}
.ant-btn.ant-btn-block {
  width: 100%;
}
.ant-btn:empty {
  display: inline-block;
  width: 0;
  visibility: hidden;
  content: '\\a0';
}
a.ant-btn {
  padding-top: 0.01px !important;
  line-height: 34px;
}
a.ant-btn-disabled {
  cursor: not-allowed;
}
a.ant-btn-disabled > * {
  pointer-events: none;
}
a.ant-btn-disabled,
a.ant-btn-disabled:hover,
a.ant-btn-disabled:focus,
a.ant-btn-disabled:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}
a.ant-btn-disabled > a:only-child,
a.ant-btn-disabled:hover > a:only-child,
a.ant-btn-disabled:focus > a:only-child,
a.ant-btn-disabled:active > a:only-child {
  color: currentcolor;
}
a.ant-btn-disabled > a:only-child::after,
a.ant-btn-disabled:hover > a:only-child::after,
a.ant-btn-disabled:focus > a:only-child::after,
a.ant-btn-disabled:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
a.ant-btn-lg {
  line-height: 38px;
}
a.ant-btn-sm {
  line-height: 22px;
}
.ant-btn-compact-item:not(.ant-btn-compact-last-item):not(.ant-btn-compact-item-rtl) {
  margin-right: -1px;
}
.ant-btn-compact-item:not(.ant-btn-compact-last-item).ant-btn-compact-item-rtl {
  margin-left: -1px;
}
.ant-btn-compact-item:hover,
.ant-btn-compact-item:focus,
.ant-btn-compact-item:active {
  z-index: 2;
}
.ant-btn-compact-item[disabled] {
  z-index: 0;
}
.ant-btn-compact-item:not(.ant-btn-compact-first-item):not(.ant-btn-compact-last-item).ant-btn {
  border-radius: 0;
}
.ant-btn-compact-item.ant-btn.ant-btn-compact-first-item:not(.ant-btn-compact-last-item):not(.ant-btn-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-btn-compact-item.ant-btn.ant-btn-compact-last-item:not(.ant-btn-compact-first-item):not(.ant-btn-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-btn-compact-item.ant-btn.ant-btn-compact-item-rtl.ant-btn-compact-first-item:not(.ant-btn-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-btn-compact-item.ant-btn.ant-btn-compact-item-rtl.ant-btn-compact-last-item:not(.ant-btn-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-btn-icon-only.ant-btn-compact-item {
  flex: none;
}
.ant-btn-compact-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-item.ant-btn-primary:not([disabled]) {
  position: relative;
}
.ant-btn-compact-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-item.ant-btn-primary:not([disabled])::after {
  position: absolute;
  top: -1px;
  left: -1px;
  display: inline-block;
  width: 1px;
  height: calc(100% + 1px * 2);
  background-color: #462e61;
  content: ' ';
}
.ant-btn-compact-item-rtl.ant-btn-compact-first-item.ant-btn-compact-item-rtl:not(.ant-btn-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-btn-compact-item-rtl.ant-btn-compact-last-item.ant-btn-compact-item-rtl:not(.ant-btn-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-btn-compact-item-rtl.ant-btn-sm.ant-btn-compact-first-item.ant-btn-compact-item-rtl.ant-btn-sm:not(.ant-btn-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-btn-compact-item-rtl.ant-btn-sm.ant-btn-compact-last-item.ant-btn-compact-item-rtl.ant-btn-sm:not(.ant-btn-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-btn-compact-item-rtl.ant-btn-primary:not([disabled]) + .ant-btn-compact-item-rtl.ant-btn-primary:not([disabled])::after {
  right: -1px;
}
.ant-btn-compact-vertical-item:not(.ant-btn-compact-vertical-last-item) {
  margin-bottom: -1px;
}
.ant-btn-compact-vertical-item:hover,
.ant-btn-compact-vertical-item:focus,
.ant-btn-compact-vertical-item:active {
  z-index: 2;
}
.ant-btn-compact-vertical-item[disabled] {
  z-index: 0;
}
.ant-btn-compact-vertical-item:not(.ant-btn-compact-vertical-first-item):not(.ant-btn-compact-vertical-last-item) {
  border-radius: 0;
}
.ant-btn-compact-vertical-item.ant-btn-compact-vertical-first-item:not(.ant-btn-compact-vertical-last-item) {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-btn-compact-vertical-item.ant-btn-compact-vertical-last-item:not(.ant-btn-compact-vertical-first-item) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) {
  position: relative;
}
.ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-vertical-item.ant-btn-primary:not([disabled])::after {
  position: absolute;
  top: -1px;
  left: -1px;
  display: inline-block;
  width: calc(100% + 1px * 2);
  height: 1px;
  background-color: #462e61;
  content: ' ';
}
.ant-btn-rtl {
  direction: rtl;
}
.ant-btn-group-rtl.ant-btn-group .ant-btn-primary:last-child:not(:first-child),
.ant-btn-group-rtl.ant-btn-group .ant-btn-primary + .ant-btn-primary {
  border-right-color: #462e61;
  border-left-color: #d9d9d9;
}
.ant-btn-group-rtl.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],
.ant-btn-group-rtl.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {
  border-right-color: #d9d9d9;
  border-left-color: #462e61;
}
.ant-btn-rtl.ant-btn > .ant-btn-loading-icon .anticon {
  padding-right: 0;
  padding-left: 8px;
}
.ant-btn-rtl.ant-btn > .anticon + span,
.ant-btn-rtl.ant-btn > span + .anticon {
  margin-right: 8px;
  margin-left: 0;
}
.ant-picker-calendar {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  background: #fff;
}
.ant-picker-calendar-header {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
}
.ant-picker-calendar-header .ant-picker-calendar-year-select {
  min-width: 80px;
}
.ant-picker-calendar-header .ant-picker-calendar-month-select {
  min-width: 70px;
  margin-left: 8px;
}
.ant-picker-calendar-header .ant-picker-calendar-mode-switch {
  margin-left: 8px;
}
.ant-picker-calendar .ant-picker-panel {
  background: #fff;
  border: 0;
  border-top: 1px solid #e8e8e8;
  border-radius: 0;
}
.ant-picker-calendar .ant-picker-panel .ant-picker-month-panel,
.ant-picker-calendar .ant-picker-panel .ant-picker-date-panel {
  width: auto;
}
.ant-picker-calendar .ant-picker-panel .ant-picker-body {
  padding: 8px 0;
}
.ant-picker-calendar .ant-picker-panel .ant-picker-content {
  width: 100%;
}
.ant-picker-calendar-mini {
  border-radius: 6px;
}
.ant-picker-calendar-mini .ant-picker-calendar-header {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-picker-calendar-mini .ant-picker-panel {
  border-radius: 0 0 6px 6px;
}
.ant-picker-calendar-mini .ant-picker-content {
  height: 256px;
}
.ant-picker-calendar-mini .ant-picker-content th {
  height: auto;
  padding: 0;
  line-height: 18px;
}
.ant-picker-calendar-mini .ant-picker-cell::before {
  pointer-events: none;
}
.ant-picker-calendar-full .ant-picker-panel {
  display: block;
  width: 100%;
  text-align: right;
  background: #fff;
  border: 0;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th,
.ant-picker-calendar-full .ant-picker-panel .ant-picker-body td {
  padding: 0;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {
  height: auto;
  padding: 0 12px 5px 0;
  line-height: 18px;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell::before {
  display: none;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell:hover .ant-picker-calendar-date {
  background: #f5f5f5;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell .ant-picker-calendar-date-today::before {
  display: none;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date,
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date,
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today,
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today {
  background: #908b94;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date .ant-picker-calendar-date-value,
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date .ant-picker-calendar-date-value,
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today .ant-picker-calendar-date-value,
.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today .ant-picker-calendar-date-value {
  color: #351a55;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date {
  display: block;
  width: auto;
  height: auto;
  margin: 0 4px;
  padding: 4px 8px 0;
  border: 0;
  border-top: 2px solid #e8e8e8;
  border-radius: 0;
  transition: background 0.3s;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-value {
  line-height: 24px;
  transition: color 0.3s;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content {
  position: static;
  width: auto;
  height: 86px;
  overflow-y: auto;
  color: #545454;
  line-height: 1.3;
  text-align: left;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-today {
  border-color: #351a55;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-today .ant-picker-calendar-date-value {
  color: #545454;
}
@media only screen and (max-width: 480px) {
  .ant-picker-calendar-header {
    display: block;
  }
  .ant-picker-calendar-header .ant-picker-calendar-year-select {
    width: 50%;
  }
  .ant-picker-calendar-header .ant-picker-calendar-month-select {
    width: calc(50% - 8px);
  }
  .ant-picker-calendar-header .ant-picker-calendar-mode-switch {
    width: 100%;
    margin-top: 8px;
    margin-left: 0;
  }
  .ant-picker-calendar-header .ant-picker-calendar-mode-switch > label {
    width: 50%;
    text-align: center;
  }
}
.ant-picker-calendar-rtl {
  direction: rtl;
}
.ant-picker-calendar-rtl .ant-picker-calendar-header .ant-picker-calendar-month-select {
  margin-right: 8px;
  margin-left: 0;
}
.ant-picker-calendar-rtl .ant-picker-calendar-header .ant-picker-calendar-mode-switch {
  margin-right: 8px;
  margin-left: 0;
}
.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel {
  text-align: left;
}
.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {
  padding: 0 0 5px 12px;
}
.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content {
  text-align: right;
}
.ant-card {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  background: #fff;
  border-radius: 6px;
}
.ant-card-rtl {
  direction: rtl;
}
.ant-card-hoverable {
  cursor: pointer;
  transition: box-shadow 0.3s, border-color 0.3s;
}
.ant-card-hoverable:hover {
  border-color: transparent;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}
.ant-card-bordered {
  border: 1px solid #e8e8e8;
}
.ant-card-head {
  min-height: 48px;
  margin-bottom: -1px;
  padding: 0 24px;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 6px 6px 0 0;
}
.ant-card-head::before {
  display: table;
  content: '';
}
.ant-card-head::after {
  display: table;
  clear: both;
  content: '';
}
.ant-card-head::before {
  display: table;
  content: '';
}
.ant-card-head::after {
  display: table;
  clear: both;
  content: '';
}
.ant-card-head-wrapper {
  display: flex;
  align-items: center;
}
.ant-card-head-title {
  display: inline-block;
  flex: 1;
  padding: 16px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-card-head-title > .ant-typography,
.ant-card-head-title > .ant-typography-edit-content {
  left: 0;
  margin-top: 0;
  margin-bottom: 0;
}
.ant-card-head .ant-tabs-top {
  clear: both;
  margin-bottom: -17px;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
}
.ant-card-head .ant-tabs-top-bar {
  border-bottom: 1px solid #e8e8e8;
}
.ant-card-extra {
  margin-left: auto;
  padding: 16px 0;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
}
.ant-card-rtl .ant-card-extra {
  margin-right: auto;
  margin-left: 0;
}
.ant-card-body {
  padding: 24px;
}
.ant-card-body::before {
  display: table;
  content: '';
}
.ant-card-body::after {
  display: table;
  clear: both;
  content: '';
}
.ant-card-body::before {
  display: table;
  content: '';
}
.ant-card-body::after {
  display: table;
  clear: both;
  content: '';
}
.ant-card-contain-grid .ant-card-body {
  display: flex;
  flex-wrap: wrap;
}
.ant-card-contain-grid:not(.ant-card-loading) .ant-card-body {
  margin: -1px 0 0 -1px;
  padding: 0;
}
.ant-card-grid {
  width: 33.33%;
  padding: 24px;
  border: 0;
  border-radius: 0;
  box-shadow: 1px 0 0 0 #e8e8e8, 0 1px 0 0 #e8e8e8, 1px 1px 0 0 #e8e8e8, 1px 0 0 0 #e8e8e8 inset, 0 1px 0 0 #e8e8e8 inset;
  transition: all 0.3s;
}
.ant-card-grid-hoverable:hover {
  position: relative;
  z-index: 1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}
.ant-card-contain-tabs > .ant-card-head .ant-card-head-title {
  min-height: 32px;
  padding-bottom: 0;
}
.ant-card-contain-tabs > .ant-card-head .ant-card-extra {
  padding-bottom: 0;
}
.ant-card-bordered .ant-card-cover {
  margin-top: -1px;
  margin-right: -1px;
  margin-left: -1px;
}
.ant-card-cover > * {
  display: block;
  width: 100%;
}
.ant-card-cover img {
  border-radius: 6px 6px 0 0;
}
.ant-card-actions {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fafafa;
  border-top: 1px solid #e8e8e8;
}
.ant-card-actions::before {
  display: table;
  content: '';
}
.ant-card-actions::after {
  display: table;
  clear: both;
  content: '';
}
.ant-card-actions::before {
  display: table;
  content: '';
}
.ant-card-actions::after {
  display: table;
  clear: both;
  content: '';
}
.ant-card-actions > li {
  margin: 12px 0;
  color: #595959;
  text-align: center;
}
.ant-card-actions > li > span {
  position: relative;
  display: block;
  min-width: 32px;
  font-size: 14px;
  line-height: 1.3;
  cursor: pointer;
}
.ant-card-actions > li > span:hover {
  color: #351a55;
  transition: color 0.3s;
}
.ant-card-actions > li > span a:not(.ant-btn),
.ant-card-actions > li > span > .anticon {
  display: inline-block;
  width: 100%;
  color: #595959;
  line-height: 22px;
  transition: color 0.3s;
}
.ant-card-actions > li > span a:not(.ant-btn):hover,
.ant-card-actions > li > span > .anticon:hover {
  color: #351a55;
}
.ant-card-actions > li > span > .anticon {
  font-size: 16px;
  line-height: 22px;
}
.ant-card-actions > li:not(:last-child) {
  border-right: 1px solid #e8e8e8;
}
.ant-card-rtl .ant-card-actions > li:not(:last-child) {
  border-right: none;
  border-left: 1px solid #e8e8e8;
}
.ant-card-type-inner .ant-card-head {
  padding: 0 24px;
  background: #fafafa;
}
.ant-card-type-inner .ant-card-head-title {
  padding: 12px 0;
  font-size: 14px;
}
.ant-card-type-inner .ant-card-body {
  padding: 16px 24px;
}
.ant-card-type-inner .ant-card-extra {
  padding: 13.5px 0;
}
.ant-card-meta {
  display: flex;
  margin: -4px 0;
}
.ant-card-meta::before {
  display: table;
  content: '';
}
.ant-card-meta::after {
  display: table;
  clear: both;
  content: '';
}
.ant-card-meta::before {
  display: table;
  content: '';
}
.ant-card-meta::after {
  display: table;
  clear: both;
  content: '';
}
.ant-card-meta-avatar {
  padding-right: 16px;
}
.ant-card-rtl .ant-card-meta-avatar {
  padding-right: 0;
  padding-left: 16px;
}
.ant-card-meta-detail {
  flex: 1;
  overflow: hidden;
}
.ant-card-meta-detail > div:not(:last-child) {
  margin-bottom: 8px;
}
.ant-card-meta-title {
  overflow: hidden;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-card-meta-description {
  color: #595959;
}
.ant-card-loading {
  overflow: hidden;
}
.ant-card-loading .ant-card-body {
  user-select: none;
}
.ant-card-small > .ant-card-head {
  min-height: 36px;
  padding: 0 12px;
  font-size: 14px;
}
.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-head-title {
  padding: 8px 0;
}
.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-extra {
  padding: 8px 0;
  font-size: 14px;
}
.ant-card-small > .ant-card-body {
  padding: 12px;
}
.ant-carousel {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-carousel .slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  touch-action: pan-y;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}
.ant-carousel .slick-list {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.ant-carousel .slick-list:focus {
  outline: none;
}
.ant-carousel .slick-list.dragging {
  cursor: pointer;
}
.ant-carousel .slick-list .slick-slide {
  pointer-events: none;
}
.ant-carousel .slick-list .slick-slide input.ant-radio-input,
.ant-carousel .slick-list .slick-slide input.ant-checkbox-input {
  visibility: hidden;
}
.ant-carousel .slick-list .slick-slide.slick-active {
  pointer-events: auto;
}
.ant-carousel .slick-list .slick-slide.slick-active input.ant-radio-input,
.ant-carousel .slick-list .slick-slide.slick-active input.ant-checkbox-input {
  visibility: visible;
}
.ant-carousel .slick-list .slick-slide > div > div {
  vertical-align: bottom;
}
.ant-carousel .slick-slider .slick-track,
.ant-carousel .slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
  touch-action: pan-y;
}
.ant-carousel .slick-track {
  position: relative;
  top: 0;
  left: 0;
  display: block;
}
.ant-carousel .slick-track::before,
.ant-carousel .slick-track::after {
  display: table;
  content: '';
}
.ant-carousel .slick-track::after {
  clear: both;
}
.slick-loading .ant-carousel .slick-track {
  visibility: hidden;
}
.ant-carousel .slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
}
.ant-carousel .slick-slide img {
  display: block;
}
.ant-carousel .slick-slide.slick-loading img {
  display: none;
}
.ant-carousel .slick-slide.dragging img {
  pointer-events: none;
}
.ant-carousel .slick-initialized .slick-slide {
  display: block;
}
.ant-carousel .slick-loading .slick-slide {
  visibility: hidden;
}
.ant-carousel .slick-vertical .slick-slide {
  display: block;
  height: auto;
}
.ant-carousel .slick-arrow.slick-hidden {
  display: none;
}
.ant-carousel .slick-prev,
.ant-carousel .slick-next {
  position: absolute;
  top: 50%;
  display: block;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  padding: 0;
  color: transparent;
  font-size: 0;
  line-height: 0;
  background: transparent;
  border: 0;
  outline: none;
  cursor: pointer;
}
.ant-carousel .slick-prev:hover,
.ant-carousel .slick-next:hover,
.ant-carousel .slick-prev:focus,
.ant-carousel .slick-next:focus {
  color: transparent;
  background: transparent;
  outline: none;
}
.ant-carousel .slick-prev:hover::before,
.ant-carousel .slick-next:hover::before,
.ant-carousel .slick-prev:focus::before,
.ant-carousel .slick-next:focus::before {
  opacity: 1;
}
.ant-carousel .slick-prev.slick-disabled::before,
.ant-carousel .slick-next.slick-disabled::before {
  opacity: 0.25;
}
.ant-carousel .slick-prev {
  left: -25px;
}
.ant-carousel .slick-prev::before {
  content: '←';
}
.ant-carousel .slick-next {
  right: -25px;
}
.ant-carousel .slick-next::before {
  content: '→';
}
.ant-carousel .slick-dots {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex !important;
  justify-content: center;
  margin-right: 15%;
  margin-bottom: 0;
  margin-left: 15%;
  padding-left: 0;
  list-style: none;
}
.ant-carousel .slick-dots-bottom {
  bottom: 12px;
}
.ant-carousel .slick-dots-top {
  top: 12px;
  bottom: auto;
}
.ant-carousel .slick-dots li {
  position: relative;
  display: inline-block;
  flex: 0 1 auto;
  box-sizing: content-box;
  width: 16px;
  height: 3px;
  margin: 0 4px;
  padding: 0;
  text-align: center;
  text-indent: -999px;
  vertical-align: top;
  transition: all 0.5s;
}
.ant-carousel .slick-dots li button {
  position: relative;
  display: block;
  width: 100%;
  height: 3px;
  padding: 0;
  color: transparent;
  font-size: 0;
  background: #fff;
  border: 0;
  border-radius: 1px;
  outline: none;
  cursor: pointer;
  opacity: 0.3;
  transition: all 0.5s;
}
.ant-carousel .slick-dots li button:hover,
.ant-carousel .slick-dots li button:focus {
  opacity: 0.75;
}
.ant-carousel .slick-dots li button::after {
  position: absolute;
  top: -4px;
  right: -4px;
  bottom: -4px;
  left: -4px;
  content: '';
}
.ant-carousel .slick-dots li.slick-active {
  width: 24px;
}
.ant-carousel .slick-dots li.slick-active button {
  background: #fff;
  opacity: 1;
}
.ant-carousel .slick-dots li.slick-active:hover,
.ant-carousel .slick-dots li.slick-active:focus {
  opacity: 1;
}
.ant-carousel-vertical .slick-dots {
  top: 50%;
  bottom: auto;
  flex-direction: column;
  width: 3px;
  height: auto;
  margin: 0;
  transform: translateY(-50%);
}
.ant-carousel-vertical .slick-dots-left {
  right: auto;
  left: 12px;
}
.ant-carousel-vertical .slick-dots-right {
  right: 12px;
  left: auto;
}
.ant-carousel-vertical .slick-dots li {
  width: 3px;
  height: 16px;
  margin: 4px 0;
  vertical-align: baseline;
}
.ant-carousel-vertical .slick-dots li button {
  width: 3px;
  height: 16px;
}
.ant-carousel-vertical .slick-dots li.slick-active {
  width: 3px;
  height: 24px;
}
.ant-carousel-vertical .slick-dots li.slick-active button {
  width: 3px;
  height: 24px;
}
.ant-carousel-rtl {
  direction: rtl;
}
.ant-carousel-rtl .ant-carousel .slick-track {
  right: 0;
  left: auto;
}
.ant-carousel-rtl .ant-carousel .slick-prev {
  right: -25px;
  left: auto;
}
.ant-carousel-rtl .ant-carousel .slick-prev::before {
  content: '→';
}
.ant-carousel-rtl .ant-carousel .slick-next {
  right: auto;
  left: -25px;
}
.ant-carousel-rtl .ant-carousel .slick-next::before {
  content: '←';
}
.ant-carousel-rtl.ant-carousel .slick-dots {
  flex-direction: row-reverse;
}
.ant-carousel-rtl.ant-carousel-vertical .slick-dots {
  flex-direction: column;
}
@keyframes antCheckboxEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}
.ant-cascader-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}
.ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox-inner,
.ant-cascader-checkbox:hover .ant-cascader-checkbox-inner,
.ant-cascader-checkbox-input:focus + .ant-cascader-checkbox-inner {
  border-color: #351a55;
}
.ant-cascader-checkbox-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #351a55;
  border-radius: 4px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: '';
}
.ant-cascader-checkbox:hover::after,
.ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox::after {
  visibility: visible;
}
.ant-cascader-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  border-collapse: separate;
  transition: all 0.3s;
}
.ant-cascader-checkbox-inner::after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: ' ';
}
.ant-cascader-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner::after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: ' ';
}
.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner {
  background-color: #351a55;
  border-color: #351a55;
}
.ant-cascader-checkbox-disabled {
  cursor: not-allowed;
}
.ant-cascader-checkbox-disabled.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner::after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}
.ant-cascader-checkbox-disabled .ant-cascader-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}
.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}
.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner::after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}
.ant-cascader-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-cascader-checkbox-disabled:hover::after,
.ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox-disabled::after {
  visibility: hidden;
}
.ant-cascader-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}
.ant-cascader-checkbox-wrapper::after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: '\\a0';
}
.ant-cascader-checkbox-wrapper.ant-cascader-checkbox-wrapper-disabled {
  cursor: not-allowed;
}
.ant-cascader-checkbox-wrapper + .ant-cascader-checkbox-wrapper {
  margin-left: 8px;
}
.ant-cascader-checkbox-wrapper.ant-cascader-checkbox-wrapper-in-form-item input[type='checkbox'] {
  width: 14px;
  height: 14px;
}
.ant-cascader-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-cascader-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.ant-cascader-checkbox-group-item {
  margin-right: 8px;
}
.ant-cascader-checkbox-group-item:last-child {
  margin-right: 0;
}
.ant-cascader-checkbox-group-item + .ant-cascader-checkbox-group-item {
  margin-left: 0;
}
.ant-cascader-checkbox-indeterminate .ant-cascader-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}
.ant-cascader-checkbox-indeterminate .ant-cascader-checkbox-inner::after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #351a55;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: ' ';
}
.ant-cascader-checkbox-indeterminate.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner::after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-cascader-checkbox-rtl {
  direction: rtl;
}
.ant-cascader-checkbox-group-rtl .ant-cascader-checkbox-group-item {
  margin-right: 0;
  margin-left: 8px;
}
.ant-cascader-checkbox-group-rtl .ant-cascader-checkbox-group-item:last-child {
  margin-left: 0 !important;
}
.ant-cascader-checkbox-group-rtl .ant-cascader-checkbox-group-item + .ant-cascader-checkbox-group-item {
  margin-left: 8px;
}
.ant-cascader {
  width: 184px;
}
.ant-cascader-checkbox {
  top: 0;
  margin-right: 8px;
}
.ant-cascader-menus {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
}
.ant-cascader-menus.ant-cascader-menu-empty .ant-cascader-menu {
  width: 100%;
  height: auto;
}
.ant-cascader-menu {
  flex-grow: 1;
  min-width: 111px;
  height: 180px;
  margin: 0;
  margin: -4px 0;
  padding: 4px 0;
  overflow: auto;
  vertical-align: top;
  list-style: none;
  border-right: 1px solid #e8e8e8;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.ant-cascader-menu-item {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px 12px;
  overflow: hidden;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-cascader-menu-item:hover {
  background: #f5f5f5;
}
.ant-cascader-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-cascader-menu-item-disabled:hover {
  background: transparent;
}
.ant-cascader-menu-empty .ant-cascader-menu-item {
  color: rgba(0, 0, 0, 0.25);
  cursor: default;
  pointer-events: none;
}
.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled),
.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {
  font-weight: 600;
  background-color: #908b94;
}
.ant-cascader-menu-item-content {
  flex: auto;
}
.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon,
.ant-cascader-menu-item-loading-icon {
  margin-left: 4px;
  color: #595959;
  font-size: 10px;
}
.ant-cascader-menu-item-disabled.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon,
.ant-cascader-menu-item-disabled.ant-cascader-menu-item-loading-icon {
  color: rgba(0, 0, 0, 0.25);
}
.ant-cascader-menu-item-keyword {
  color: #f5222d;
}
.ant-cascader-compact-item:not(.ant-cascader-compact-last-item):not(.ant-cascader-compact-item-rtl) {
  margin-right: -1px;
}
.ant-cascader-compact-item:not(.ant-cascader-compact-last-item).ant-cascader-compact-item-rtl {
  margin-left: -1px;
}
.ant-cascader-compact-item:hover,
.ant-cascader-compact-item:focus,
.ant-cascader-compact-item:active {
  z-index: 2;
}
.ant-cascader-compact-item[disabled] {
  z-index: 0;
}
.ant-cascader-compact-item:not(.ant-cascader-compact-first-item):not(.ant-cascader-compact-last-item).ant-cascader {
  border-radius: 0;
}
.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-first-item:not(.ant-cascader-compact-last-item):not(.ant-cascader-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-last-item:not(.ant-cascader-compact-first-item):not(.ant-cascader-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-item-rtl.ant-cascader-compact-first-item:not(.ant-cascader-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-item-rtl.ant-cascader-compact-last-item:not(.ant-cascader-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-cascader-rtl .ant-cascader-menu-item-expand-icon,
.ant-cascader-rtl .ant-cascader-menu-item-loading-icon {
  margin-right: 4px;
  margin-left: 0;
}
.ant-cascader-rtl .ant-cascader-checkbox {
  top: 0;
  margin-right: 0;
  margin-left: 8px;
}
.ant-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}
.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #351a55;
}
.ant-checkbox-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #351a55;
  border-radius: 4px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: '';
}
.ant-checkbox:hover::after,
.ant-checkbox-wrapper:hover .ant-checkbox::after {
  visibility: visible;
}
.ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  border-collapse: separate;
  transition: all 0.3s;
}
.ant-checkbox-inner::after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: ' ';
}
.ant-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
.ant-checkbox-checked .ant-checkbox-inner::after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: ' ';
}
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #351a55;
  border-color: #351a55;
}
.ant-checkbox-disabled {
  cursor: not-allowed;
}
.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}
.ant-checkbox-disabled .ant-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}
.ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}
.ant-checkbox-disabled .ant-checkbox-inner::after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}
.ant-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-checkbox-disabled:hover::after,
.ant-checkbox-wrapper:hover .ant-checkbox-disabled::after {
  visibility: hidden;
}
.ant-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}
.ant-checkbox-wrapper::after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: '\\a0';
}
.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {
  cursor: not-allowed;
}
.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 8px;
}
.ant-checkbox-wrapper.ant-checkbox-wrapper-in-form-item input[type='checkbox'] {
  width: 14px;
  height: 14px;
}
.ant-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.ant-checkbox-group-item {
  margin-right: 8px;
}
.ant-checkbox-group-item:last-child {
  margin-right: 0;
}
.ant-checkbox-group-item + .ant-checkbox-group-item {
  margin-left: 0;
}
.ant-checkbox-indeterminate .ant-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}
.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #351a55;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: ' ';
}
.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner::after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-checkbox-rtl {
  direction: rtl;
}
.ant-checkbox-group-rtl .ant-checkbox-group-item {
  margin-right: 0;
  margin-left: 8px;
}
.ant-checkbox-group-rtl .ant-checkbox-group-item:last-child {
  margin-left: 0 !important;
}
.ant-checkbox-group-rtl .ant-checkbox-group-item + .ant-checkbox-group-item {
  margin-left: 8px;
}
.ant-collapse {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-bottom: 0;
  border-radius: 6px;
}
.ant-collapse > .ant-collapse-item {
  border-bottom: 1px solid #d9d9d9;
}
.ant-collapse > .ant-collapse-item:last-child,
.ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
  border-radius: 0 0 6px 6px;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: 12px 16px;
  color: #535353;
  line-height: 1.3;
  cursor: pointer;
  transition: all 0.3s, visibility 0s;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  display: inline-block;
  margin-right: 12px;
  font-size: 12px;
  vertical-align: -1px;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {
  transition: transform 0.24s;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-header-text {
  flex: auto;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {
  margin-left: auto;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header:focus {
  outline: none;
}
.ant-collapse > .ant-collapse-item .ant-collapse-header-collapsible-only {
  cursor: default;
}
.ant-collapse > .ant-collapse-item .ant-collapse-header-collapsible-only .ant-collapse-header-text {
  flex: none;
  cursor: pointer;
}
.ant-collapse > .ant-collapse-item .ant-collapse-icon-collapsible-only {
  cursor: default;
}
.ant-collapse > .ant-collapse-item .ant-collapse-icon-collapsible-only .ant-collapse-expand-icon {
  cursor: pointer;
}
.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
  padding-left: 12px;
}
.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  padding: 12px 16px;
  padding-right: 40px;
}
.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  position: absolute;
  top: 50%;
  right: 16px;
  left: auto;
  margin: 0;
  transform: translateY(-50%);
}
.ant-collapse-content {
  color: #545454;
  background-color: #fff;
  border-top: 1px solid #d9d9d9;
}
.ant-collapse-content > .ant-collapse-content-box {
  padding: 16px;
}
.ant-collapse-content-hidden {
  display: none;
}
.ant-collapse-item:last-child > .ant-collapse-content {
  border-radius: 0 0 6px 6px;
}
.ant-collapse-borderless {
  background-color: #fafafa;
  border: 0;
}
.ant-collapse-borderless > .ant-collapse-item {
  border-bottom: 1px solid #d9d9d9;
}
.ant-collapse-borderless > .ant-collapse-item:last-child,
.ant-collapse-borderless > .ant-collapse-item:last-child .ant-collapse-header {
  border-radius: 0;
}
.ant-collapse-borderless > .ant-collapse-item:last-child {
  border-bottom: 0;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
  background-color: transparent;
  border-top: 0;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding-top: 4px;
}
.ant-collapse-ghost {
  background-color: transparent;
  border: 0;
}
.ant-collapse-ghost > .ant-collapse-item {
  border-bottom: 0;
}
.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content {
  background-color: transparent;
  border-top: 0;
}
.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding-top: 12px;
  padding-bottom: 12px;
}
.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header,
.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-collapse-rtl {
  direction: rtl;
}
.ant-collapse-rtl.ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  padding: 12px 16px;
  padding-left: 40px;
}
.ant-collapse-rtl.ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  position: absolute;
  top: 50%;
  right: auto;
  left: 16px;
  margin: 0;
  transform: translateY(-50%);
}
.ant-collapse-rtl .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 12px 16px;
  padding-right: 40px;
}
.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  margin-right: 0;
  margin-left: 12px;
}
.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {
  transform: rotate(180deg);
}
.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {
  margin-right: auto;
  margin-left: 0;
}
.ant-collapse-rtl.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
  padding-right: 12px;
  padding-left: 0;
}
.ant-comment {
  position: relative;
  background-color: inherit;
}
.ant-comment-inner {
  display: flex;
  padding: 16px 0;
}
.ant-comment-avatar {
  position: relative;
  flex-shrink: 0;
  margin-right: 12px;
  cursor: pointer;
}
.ant-comment-avatar img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.ant-comment-content {
  position: relative;
  flex: 1 1 auto;
  min-width: 1px;
  font-size: 14px;
  word-wrap: break-word;
}
.ant-comment-content-author {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 4px;
  font-size: 14px;
}
.ant-comment-content-author > a,
.ant-comment-content-author > span {
  padding-right: 8px;
  font-size: 12px;
  line-height: 18px;
}
.ant-comment-content-author-name {
  color: #595959;
  font-size: 14px;
  transition: color 0.3s;
}
.ant-comment-content-author-name > * {
  color: #595959;
}
.ant-comment-content-author-name > *:hover {
  color: #595959;
}
.ant-comment-content-author-time {
  color: #ccc;
  white-space: nowrap;
  cursor: auto;
}
.ant-comment-content-detail p {
  margin-bottom: inherit;
  white-space: pre-wrap;
}
.ant-comment-actions {
  margin-top: 12px;
  margin-bottom: inherit;
  padding-left: 0;
}
.ant-comment-actions > li {
  display: inline-block;
  color: #595959;
}
.ant-comment-actions > li > span {
  margin-right: 10px;
  color: #595959;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.3s;
  user-select: none;
}
.ant-comment-actions > li > span:hover {
  color: #595959;
}
.ant-comment-nested {
  margin-left: 44px;
}
.ant-comment-rtl {
  direction: rtl;
}
.ant-comment-rtl .ant-comment-avatar {
  margin-right: 0;
  margin-left: 12px;
}
.ant-comment-rtl .ant-comment-content-author > a,
.ant-comment-rtl .ant-comment-content-author > span {
  padding-right: 0;
  padding-left: 8px;
}
.ant-comment-rtl .ant-comment-actions {
  padding-right: 0;
}
.ant-comment-rtl .ant-comment-actions > li > span {
  margin-right: 0;
  margin-left: 10px;
}
.ant-comment-rtl .ant-comment-nested {
  margin-right: 44px;
  margin-left: 0;
}
.ant-picker-status-error.ant-picker,
.ant-picker-status-error.ant-picker:not(.ant-picker-disabled):hover {
  background-color: #fff;
  border-color: #f5222d;
}
.ant-picker-status-error.ant-picker-focused,
.ant-picker-status-error.ant-picker:focus {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-picker-status-error.ant-picker .ant-picker-active-bar {
  background: #ff4d4f;
}
.ant-picker-status-warning.ant-picker,
.ant-picker-status-warning.ant-picker:not(.ant-picker-disabled):hover {
  background-color: #fff;
  border-color: #fa8c16;
}
.ant-picker-status-warning.ant-picker-focused,
.ant-picker-status-warning.ant-picker:focus {
  border-color: #ffa940;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-picker-status-warning.ant-picker .ant-picker-active-bar {
  background: #ffa940;
}
.ant-picker {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  padding: 8px 11px 8px;
  position: relative;
  display: inline-flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: border 0.3s, box-shadow 0.3s;
}
.ant-picker:hover,
.ant-picker-focused {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-picker:hover,
.ant-input-rtl .ant-picker-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-picker-focused {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-picker-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-picker.ant-picker-disabled {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-picker.ant-picker-disabled .ant-picker-suffix {
  color: rgba(0, 0, 0, 0.25);
}
.ant-picker.ant-picker-borderless {
  background-color: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
}
.ant-picker-input {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
}
.ant-picker-input > input {
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7.9px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
  flex: auto;
  min-width: 1px;
  height: auto;
  padding: 0;
  background: transparent;
  border: 0;
}
.ant-picker-input > input::placeholder {
  color: #bfbfbf;
  user-select: none;
}
.ant-picker-input > input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-picker-input > input:hover {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-picker-input > input:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-picker-input > input:focus,
.ant-picker-input > input-focused {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-picker-input > input:focus,
.ant-input-rtl .ant-picker-input > input-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-picker-input > input-disabled {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-picker-input > input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-picker-input > input[disabled] {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-picker-input > input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-picker-input > input-borderless,
.ant-picker-input > input-borderless:hover,
.ant-picker-input > input-borderless:focus,
.ant-picker-input > input-borderless-focused,
.ant-picker-input > input-borderless-disabled,
.ant-picker-input > input-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
textarea.ant-picker-input > input {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-picker-input > input-lg {
  padding: 8.6px 11px;
  font-size: 16px;
}
.ant-picker-input > input-sm {
  padding: 1.9px 7px;
}
.ant-picker-input > input-rtl {
  direction: rtl;
}
.ant-picker-input > input:focus {
  box-shadow: none;
}
.ant-picker-input > input[disabled] {
  background: transparent;
}
.ant-picker-input:hover .ant-picker-clear {
  opacity: 1;
}
.ant-picker-input-placeholder > input {
  color: #bfbfbf;
}
.ant-picker-large {
  padding: 9px 11px 9px;
}
.ant-picker-large .ant-picker-input > input {
  font-size: 16px;
}
.ant-picker-small {
  padding: 2px 7px 2px;
}
.ant-picker-suffix {
  display: flex;
  flex: none;
  align-self: center;
  margin-left: 4px;
  color: rgba(0, 0, 0, 0.25);
  line-height: 1;
  pointer-events: none;
}
.ant-picker-suffix > * {
  vertical-align: top;
}
.ant-picker-suffix > *:not(:last-child) {
  margin-right: 8px;
}
.ant-picker-clear {
  position: absolute;
  top: 50%;
  right: 0;
  color: rgba(0, 0, 0, 0.25);
  line-height: 1;
  background: #fff;
  transform: translateY(-50%);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s, color 0.3s;
}
.ant-picker-clear > * {
  vertical-align: top;
}
.ant-picker-clear:hover {
  color: #595959;
}
.ant-picker-separator {
  position: relative;
  display: inline-block;
  width: 1em;
  height: 16px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 16px;
  vertical-align: top;
  cursor: default;
}
.ant-picker-focused .ant-picker-separator {
  color: #595959;
}
.ant-picker-disabled .ant-picker-range-separator .ant-picker-separator {
  cursor: not-allowed;
}
.ant-picker-range {
  position: relative;
  display: inline-flex;
}
.ant-picker-range .ant-picker-clear {
  right: 11px;
}
.ant-picker-range:hover .ant-picker-clear {
  opacity: 1;
}
.ant-picker-range .ant-picker-active-bar {
  bottom: -1px;
  height: 2px;
  margin-left: 11px;
  background: #351a55;
  opacity: 0;
  transition: all 0.3s ease-out;
  pointer-events: none;
}
.ant-picker-range.ant-picker-focused .ant-picker-active-bar {
  opacity: 1;
}
.ant-picker-range-separator {
  align-items: center;
  padding: 0 8px;
  line-height: 1;
}
.ant-picker-range.ant-picker-small .ant-picker-clear {
  right: 7px;
}
.ant-picker-range.ant-picker-small .ant-picker-active-bar {
  margin-left: 7px;
}
.ant-picker-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
}
.ant-picker-dropdown-hidden {
  display: none;
}
.ant-picker-dropdown-placement-bottomLeft .ant-picker-range-arrow {
  top: 2.58561808px;
  display: block;
  transform: rotate(-135deg) translateY(1px);
}
.ant-picker-dropdown-placement-topLeft .ant-picker-range-arrow {
  bottom: 2.58561808px;
  display: block;
  transform: rotate(45deg);
}
.ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-topLeft,
.ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-topRight,
.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-topLeft,
.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-topRight {
  animation-name: antSlideDownIn;
}
.ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-bottomLeft,
.ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-bottomRight,
.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-bottomLeft,
.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-bottomRight {
  animation-name: antSlideUpIn;
}
.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-topLeft,
.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-topRight {
  animation-name: antSlideDownOut;
}
.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-bottomLeft,
.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-bottomRight {
  animation-name: antSlideUpOut;
}
.ant-picker-dropdown-range {
  padding: 7.54247233px 0;
}
.ant-picker-dropdown-range-hidden {
  display: none;
}
.ant-picker-dropdown .ant-picker-panel > .ant-picker-time-panel {
  padding-top: 4px;
}
.ant-picker-ranges {
  margin-bottom: 0;
  padding: 4px 12px;
  overflow: hidden;
  line-height: 34px;
  text-align: left;
  list-style: none;
}
.ant-picker-ranges > li {
  display: inline-block;
}
.ant-picker-ranges .ant-picker-preset > .ant-tag-blue {
  color: #351a55;
  background: #908b94;
  border-color: #6f617a;
  cursor: pointer;
}
.ant-picker-ranges .ant-picker-ok {
  float: right;
  margin-left: 8px;
}
.ant-picker-range-wrapper {
  display: flex;
}
.ant-picker-range-arrow {
  position: absolute;
  z-index: 1;
  width: 11.3137085px;
  height: 11.3137085px;
  margin-left: 16.5px;
  box-shadow: 2px 2px 6px -2px rgba(0, 0, 0, 0.1);
  transition: left 0.3s ease-out;
  border-radius: 0 0 2px;
  pointer-events: none;
}
.ant-picker-range-arrow::before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: #fff;
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: '';
  clip-path: inset(33% 33%);
  clip-path: path('M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z');
}
.ant-picker-panel-container {
  overflow: hidden;
  vertical-align: top;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  transition: margin 0.3s;
}
.ant-picker-panel-container .ant-picker-panels {
  display: inline-flex;
  flex-wrap: nowrap;
  direction: ltr;
}
.ant-picker-panel-container .ant-picker-panel {
  vertical-align: top;
  background: transparent;
  border-width: 0 0 1px 0;
  border-radius: 0;
}
.ant-picker-panel-container .ant-picker-panel .ant-picker-content,
.ant-picker-panel-container .ant-picker-panel table {
  text-align: center;
}
.ant-picker-panel-container .ant-picker-panel-focused {
  border-color: #e8e8e8;
}
.ant-picker-compact-item:not(.ant-picker-compact-last-item):not(.ant-picker-compact-item-rtl) {
  margin-right: -1px;
}
.ant-picker-compact-item:not(.ant-picker-compact-last-item).ant-picker-compact-item-rtl {
  margin-left: -1px;
}
.ant-picker-compact-item:hover,
.ant-picker-compact-item:focus,
.ant-picker-compact-item:active {
  z-index: 2;
}
.ant-picker-compact-item.ant-picker-focused {
  z-index: 2;
}
.ant-picker-compact-item[disabled] {
  z-index: 0;
}
.ant-picker-compact-item:not(.ant-picker-compact-first-item):not(.ant-picker-compact-last-item).ant-picker {
  border-radius: 0;
}
.ant-picker-compact-item.ant-picker.ant-picker-compact-first-item:not(.ant-picker-compact-last-item):not(.ant-picker-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-picker-compact-item.ant-picker.ant-picker-compact-last-item:not(.ant-picker-compact-first-item):not(.ant-picker-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-picker-compact-item.ant-picker.ant-picker-compact-item-rtl.ant-picker-compact-first-item:not(.ant-picker-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-picker-compact-item.ant-picker.ant-picker-compact-item-rtl.ant-picker-compact-last-item:not(.ant-picker-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-picker-panel {
  display: inline-flex;
  flex-direction: column;
  text-align: center;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  outline: none;
}
.ant-picker-panel-focused {
  border-color: #351a55;
}
.ant-picker-decade-panel,
.ant-picker-year-panel,
.ant-picker-quarter-panel,
.ant-picker-month-panel,
.ant-picker-week-panel,
.ant-picker-date-panel,
.ant-picker-time-panel {
  display: flex;
  flex-direction: column;
  width: 280px;
}
.ant-picker-header {
  display: flex;
  padding: 0 8px;
  color: #535353;
  border-bottom: 1px solid #e8e8e8;
}
.ant-picker-header > * {
  flex: none;
}
.ant-picker-header button {
  padding: 0;
  color: rgba(0, 0, 0, 0.25);
  line-height: 40px;
  background: transparent;
  border: 0;
  cursor: pointer;
  transition: color 0.3s;
}
.ant-picker-header > button {
  min-width: 1.6em;
  font-size: 14px;
}
.ant-picker-header > button:hover {
  color: #545454;
}
.ant-picker-header-view {
  flex: auto;
  font-weight: 500;
  line-height: 40px;
}
.ant-picker-header-view button {
  color: inherit;
  font-weight: inherit;
}
.ant-picker-header-view button:not(:first-child) {
  margin-left: 8px;
}
.ant-picker-header-view button:hover {
  color: #351a55;
}
.ant-picker-prev-icon,
.ant-picker-next-icon,
.ant-picker-super-prev-icon,
.ant-picker-super-next-icon {
  position: relative;
  display: inline-block;
  width: 7px;
  height: 7px;
}
.ant-picker-prev-icon::before,
.ant-picker-next-icon::before,
.ant-picker-super-prev-icon::before,
.ant-picker-super-next-icon::before {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 7px;
  height: 7px;
  border: 0 solid currentcolor;
  border-width: 1.5px 0 0 1.5px;
  content: '';
}
.ant-picker-super-prev-icon::after,
.ant-picker-super-next-icon::after {
  position: absolute;
  top: 4px;
  left: 4px;
  display: inline-block;
  width: 7px;
  height: 7px;
  border: 0 solid currentcolor;
  border-width: 1.5px 0 0 1.5px;
  content: '';
}
.ant-picker-prev-icon,
.ant-picker-super-prev-icon {
  transform: rotate(-45deg);
}
.ant-picker-next-icon,
.ant-picker-super-next-icon {
  transform: rotate(135deg);
}
.ant-picker-content {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
.ant-picker-content th,
.ant-picker-content td {
  position: relative;
  min-width: 24px;
  font-weight: 400;
}
.ant-picker-content th {
  height: 30px;
  color: #545454;
  line-height: 30px;
}
.ant-picker-cell {
  padding: 3px 0;
  color: rgba(0, 0, 0, 0.25);
  cursor: pointer;
}
.ant-picker-cell-in-view {
  color: #545454;
}
.ant-picker-cell::before {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  z-index: 1;
  height: 24px;
  transform: translateY(-50%);
  transition: all 0.3s;
  content: '';
}
.ant-picker-cell .ant-picker-cell-inner {
  position: relative;
  z-index: 2;
  display: inline-block;
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 6px;
  transition: background 0.3s, border 0.3s;
}
.ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,
.ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner {
  background: #f5f5f5;
}
.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  border: 1px solid #351a55;
  border-radius: 6px;
  content: '';
}
.ant-picker-cell-in-view.ant-picker-cell-in-range {
  position: relative;
}
.ant-picker-cell-in-view.ant-picker-cell-in-range::before {
  background: #908b94;
}
.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
  color: #fff;
  background: #351a55;
}
.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {
  background: #908b94;
}
.ant-picker-cell-in-view.ant-picker-cell-range-start::before {
  left: 50%;
}
.ant-picker-cell-in-view.ant-picker-cell-range-end::before {
  right: 50%;
}
.ant-picker-cell-in-view.ant-picker-cell-range-hover-start:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,
.ant-picker-cell-in-view.ant-picker-cell-range-hover-end:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,
.ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start-single::after,
.ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-end-near-hover::after,
.ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-start-near-hover::after,
.ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-end-single::after,
.ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-in-range)::after {
  position: absolute;
  top: 50%;
  z-index: 0;
  height: 24px;
  border-top: 1px dashed #6632a3;
  border-bottom: 1px dashed #6632a3;
  transform: translateY(-50%);
  transition: all 0.3s;
  content: '';
}
.ant-picker-cell-range-hover-start::after,
.ant-picker-cell-range-hover-end::after,
.ant-picker-cell-range-hover::after {
  right: 0;
  left: 2px;
}
.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before,
.ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-hover::before,
.ant-picker-cell-in-view.ant-picker-cell-range-end.ant-picker-cell-range-hover::before,
.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before,
.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before,
.ant-picker-panel > :not(.ant-picker-date-panel) .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start::before,
.ant-picker-panel > :not(.ant-picker-date-panel) .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end::before {
  background: #8c56cb;
}
.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {
  border-radius: 6px 0 0 6px;
}
.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):not(.ant-picker-cell-range-start) .ant-picker-cell-inner {
  border-radius: 0 6px 6px 0;
}
.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after,
.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: -1;
  background: #8c56cb;
  transition: all 0.3s;
  content: '';
}
.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after {
  right: -6px;
  left: 0;
}
.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after {
  right: 0;
  left: -6px;
}
.ant-picker-cell-range-hover.ant-picker-cell-range-start::after {
  right: 50%;
}
.ant-picker-cell-range-hover.ant-picker-cell-range-end::after {
  left: 50%;
}
tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:first-child::after,
tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child::after,
.ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range::after,
.ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range)::after,
.ant-picker-cell-in-view.ant-picker-cell-range-hover-start::after {
  left: 6px;
  border-left: 1px dashed #6632a3;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:last-child::after,
tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child::after,
.ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range::after,
.ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range)::after,
.ant-picker-cell-in-view.ant-picker-cell-range-hover-end::after {
  right: 6px;
  border-right: 1px dashed #6632a3;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.ant-picker-cell-disabled {
  color: rgba(0, 0, 0, 0.25);
  pointer-events: none;
}
.ant-picker-cell-disabled .ant-picker-cell-inner {
  background: transparent;
}
.ant-picker-cell-disabled::before {
  background: rgba(0, 0, 0, 0.04);
}
.ant-picker-cell-disabled.ant-picker-cell-today .ant-picker-cell-inner::before {
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-picker-decade-panel .ant-picker-content,
.ant-picker-year-panel .ant-picker-content,
.ant-picker-quarter-panel .ant-picker-content,
.ant-picker-month-panel .ant-picker-content {
  height: 264px;
}
.ant-picker-decade-panel .ant-picker-cell-inner,
.ant-picker-year-panel .ant-picker-cell-inner,
.ant-picker-quarter-panel .ant-picker-cell-inner,
.ant-picker-month-panel .ant-picker-cell-inner {
  padding: 0 8px;
}
.ant-picker-quarter-panel .ant-picker-content {
  height: 56px;
}
.ant-picker-footer {
  width: min-content;
  min-width: 100%;
  line-height: 38px;
  text-align: center;
  border-bottom: 1px solid transparent;
}
.ant-picker-panel .ant-picker-footer {
  border-top: 1px solid #e8e8e8;
}
.ant-picker-footer-extra {
  padding: 0 12px;
  line-height: 38px;
  text-align: left;
}
.ant-picker-footer-extra:not(:last-child) {
  border-bottom: 1px solid #e8e8e8;
}
.ant-picker-now {
  text-align: left;
}
.ant-picker-today-btn {
  color: var(--app-primary-color);
}
.ant-picker-today-btn:hover {
  color: #0d0d0d;
}
.ant-picker-today-btn:active {
  color: #000000;
}
.ant-picker-today-btn.ant-picker-today-btn-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-picker-decade-panel .ant-picker-cell-inner {
  padding: 0 4px;
}
.ant-picker-decade-panel .ant-picker-cell::before {
  display: none;
}
.ant-picker-year-panel .ant-picker-body,
.ant-picker-quarter-panel .ant-picker-body,
.ant-picker-month-panel .ant-picker-body {
  padding: 0 8px;
}
.ant-picker-year-panel .ant-picker-cell-inner,
.ant-picker-quarter-panel .ant-picker-cell-inner,
.ant-picker-month-panel .ant-picker-cell-inner {
  width: 60px;
}
.ant-picker-year-panel .ant-picker-cell-range-hover-start::after,
.ant-picker-quarter-panel .ant-picker-cell-range-hover-start::after,
.ant-picker-month-panel .ant-picker-cell-range-hover-start::after {
  left: 14px;
  border-left: 1px dashed #6632a3;
  border-radius: 6px 0 0 6px;
}
.ant-picker-panel-rtl .ant-picker-year-panel .ant-picker-cell-range-hover-start::after,
.ant-picker-panel-rtl .ant-picker-quarter-panel .ant-picker-cell-range-hover-start::after,
.ant-picker-panel-rtl .ant-picker-month-panel .ant-picker-cell-range-hover-start::after {
  right: 14px;
  border-right: 1px dashed #6632a3;
  border-radius: 0 6px 6px 0;
}
.ant-picker-year-panel .ant-picker-cell-range-hover-end::after,
.ant-picker-quarter-panel .ant-picker-cell-range-hover-end::after,
.ant-picker-month-panel .ant-picker-cell-range-hover-end::after {
  right: 14px;
  border-right: 1px dashed #6632a3;
  border-radius: 0 6px 6px 0;
}
.ant-picker-panel-rtl .ant-picker-year-panel .ant-picker-cell-range-hover-end::after,
.ant-picker-panel-rtl .ant-picker-quarter-panel .ant-picker-cell-range-hover-end::after,
.ant-picker-panel-rtl .ant-picker-month-panel .ant-picker-cell-range-hover-end::after {
  left: 14px;
  border-left: 1px dashed #6632a3;
  border-radius: 6px 0 0 6px;
}
.ant-picker-week-panel .ant-picker-body {
  padding: 8px 12px;
}
.ant-picker-week-panel .ant-picker-cell:hover .ant-picker-cell-inner,
.ant-picker-week-panel .ant-picker-cell-selected .ant-picker-cell-inner,
.ant-picker-week-panel .ant-picker-cell .ant-picker-cell-inner {
  background: transparent !important;
}
.ant-picker-week-panel-row td {
  transition: background 0.3s;
}
.ant-picker-week-panel-row:hover td {
  background: #f5f5f5;
}
.ant-picker-week-panel-row-selected td,
.ant-picker-week-panel-row-selected:hover td {
  background: #351a55;
}
.ant-picker-week-panel-row-selected td.ant-picker-cell-week,
.ant-picker-week-panel-row-selected:hover td.ant-picker-cell-week {
  color: rgba(255, 255, 255, 0.5);
}
.ant-picker-week-panel-row-selected td.ant-picker-cell-today .ant-picker-cell-inner::before,
.ant-picker-week-panel-row-selected:hover td.ant-picker-cell-today .ant-picker-cell-inner::before {
  border-color: #fff;
}
.ant-picker-week-panel-row-selected td .ant-picker-cell-inner,
.ant-picker-week-panel-row-selected:hover td .ant-picker-cell-inner {
  color: #fff;
}
.ant-picker-date-panel .ant-picker-body {
  padding: 8px 12px;
}
.ant-picker-date-panel .ant-picker-content {
  width: 252px;
}
.ant-picker-date-panel .ant-picker-content th {
  width: 36px;
}
.ant-picker-datetime-panel {
  display: flex;
}
.ant-picker-datetime-panel .ant-picker-time-panel {
  border-left: 1px solid #e8e8e8;
}
.ant-picker-datetime-panel .ant-picker-date-panel,
.ant-picker-datetime-panel .ant-picker-time-panel {
  transition: opacity 0.3s;
}
.ant-picker-datetime-panel-active .ant-picker-date-panel,
.ant-picker-datetime-panel-active .ant-picker-time-panel {
  opacity: 0.3;
}
.ant-picker-datetime-panel-active .ant-picker-date-panel-active,
.ant-picker-datetime-panel-active .ant-picker-time-panel-active {
  opacity: 1;
}
.ant-picker-time-panel {
  width: auto;
  min-width: auto;
}
.ant-picker-time-panel .ant-picker-content {
  display: flex;
  flex: auto;
  height: 224px;
}
.ant-picker-time-panel-column {
  flex: 1 0 auto;
  width: 56px;
  margin: 0;
  padding: 0;
  overflow-y: hidden;
  text-align: left;
  list-style: none;
  transition: background 0.3s;
}
.ant-picker-time-panel-column::after {
  display: block;
  height: 196px;
  content: '';
}
.ant-picker-datetime-panel .ant-picker-time-panel-column::after {
  height: 198px;
}
.ant-picker-time-panel-column:not(:first-child) {
  border-left: 1px solid #e8e8e8;
}
.ant-picker-time-panel-column-active {
  background: rgba(144, 139, 148, 0.2);
}
.ant-picker-time-panel-column:hover {
  overflow-y: auto;
}
.ant-picker-time-panel-column > li {
  margin: 0;
  padding: 0;
}
.ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner {
  display: block;
  width: 100%;
  height: 28px;
  margin: 0;
  padding: 0 0 0 14px;
  color: #545454;
  line-height: 28px;
  border-radius: 0;
  cursor: pointer;
  transition: background 0.3s;
}
.ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover {
  background: #f5f5f5;
}
.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
  background: #908b94;
}
.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-disabled .ant-picker-time-panel-cell-inner {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  cursor: not-allowed;
}
/* stylelint-disable selector-type-no-unknown,selector-no-vendor-prefix */
_:-ms-fullscreen .ant-picker-range-wrapper .ant-picker-month-panel .ant-picker-cell,
:root .ant-picker-range-wrapper .ant-picker-month-panel .ant-picker-cell,
_:-ms-fullscreen .ant-picker-range-wrapper .ant-picker-year-panel .ant-picker-cell,
:root .ant-picker-range-wrapper .ant-picker-year-panel .ant-picker-cell {
  padding: 21px 0;
}
.ant-picker-rtl {
  direction: rtl;
}
.ant-picker-rtl .ant-picker-suffix {
  margin-right: 4px;
  margin-left: 0;
}
.ant-picker-rtl .ant-picker-clear {
  right: auto;
  left: 0;
}
.ant-picker-rtl .ant-picker-separator {
  transform: rotate(180deg);
}
.ant-picker-panel-rtl .ant-picker-header-view button:not(:first-child) {
  margin-right: 8px;
  margin-left: 0;
}
.ant-picker-rtl.ant-picker-range .ant-picker-clear {
  right: auto;
  left: 11px;
}
.ant-picker-rtl.ant-picker-range .ant-picker-active-bar {
  margin-right: 11px;
  margin-left: 0;
}
.ant-picker-rtl.ant-picker-range.ant-picker-small .ant-picker-active-bar {
  margin-right: 7px;
}
.ant-picker-dropdown-rtl .ant-picker-ranges {
  text-align: right;
}
.ant-picker-dropdown-rtl .ant-picker-ranges .ant-picker-ok {
  float: left;
  margin-right: 8px;
  margin-left: 0;
}
.ant-picker-panel-rtl {
  direction: rtl;
}
.ant-picker-panel-rtl .ant-picker-prev-icon,
.ant-picker-panel-rtl .ant-picker-super-prev-icon {
  transform: rotate(135deg);
}
.ant-picker-panel-rtl .ant-picker-next-icon,
.ant-picker-panel-rtl .ant-picker-super-next-icon {
  transform: rotate(-45deg);
}
.ant-picker-cell .ant-picker-cell-inner {
  position: relative;
  z-index: 2;
  display: inline-block;
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 6px;
  transition: background 0.3s, border 0.3s;
}
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start::before {
  right: 50%;
  left: 0;
}
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-end::before {
  right: 0;
  left: 50%;
}
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-end::before {
  right: 50%;
  left: 50%;
}
.ant-picker-panel-rtl .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after {
  right: 0;
  left: -6px;
}
.ant-picker-panel-rtl .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after {
  right: -6px;
  left: 0;
}
.ant-picker-panel-rtl .ant-picker-cell-range-hover.ant-picker-cell-range-start::after {
  right: 0;
  left: 50%;
}
.ant-picker-panel-rtl .ant-picker-cell-range-hover.ant-picker-cell-range-end::after {
  right: 50%;
  left: 0;
}
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {
  border-radius: 0 6px 6px 0;
}
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):not(.ant-picker-cell-range-start) .ant-picker-cell-inner {
  border-radius: 6px 0 0 6px;
}
.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-selected):first-child::after,
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range::after,
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range)::after,
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-start::after {
  right: 6px;
  left: 0;
  border-right: 1px dashed #6632a3;
  border-left: none;
  border-radius: 0 6px 6px 0;
}
.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-selected):last-child::after,
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range::after,
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range)::after,
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-end::after {
  right: 0;
  left: 6px;
  border-right: none;
  border-left: 1px dashed #6632a3;
  border-radius: 6px 0 0 6px;
}
.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child::after,
.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child::after,
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover)::after,
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-end.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover)::after,
.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-start.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover)::after,
.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover.ant-picker-cell-range-hover-edge-start:last-child::after,
.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover.ant-picker-cell-range-hover-edge-end:first-child::after {
  right: 6px;
  left: 6px;
  border-right: 1px dashed #6632a3;
  border-left: 1px dashed #6632a3;
  border-radius: 6px;
}
.ant-picker-dropdown-rtl .ant-picker-footer-extra {
  direction: rtl;
  text-align: right;
}
.ant-picker-panel-rtl .ant-picker-time-panel {
  direction: ltr;
}
.ant-descriptions-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.ant-descriptions-title {
  flex: auto;
  overflow: hidden;
  color: #535353;
  font-weight: bold;
  font-size: 16px;
  line-height: 1.3;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-descriptions-extra {
  margin-left: auto;
  color: #545454;
  font-size: 14px;
}
.ant-descriptions-view {
  width: 100%;
  border-radius: 6px;
}
.ant-descriptions-view table {
  width: 100%;
  table-layout: fixed;
}
.ant-descriptions-row > th,
.ant-descriptions-row > td {
  padding-bottom: 16px;
}
.ant-descriptions-row:last-child {
  border-bottom: none;
}
.ant-descriptions-item-label {
  color: #535353;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.3;
  text-align: start;
}
.ant-descriptions-item-label::after {
  content: ':';
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}
.ant-descriptions-item-label.ant-descriptions-item-no-colon::after {
  content: ' ';
}
.ant-descriptions-item-no-label::after {
  margin: 0;
  content: '';
}
.ant-descriptions-item-content {
  display: table-cell;
  flex: 1;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  word-break: break-word;
  overflow-wrap: break-word;
}
.ant-descriptions-item {
  padding-bottom: 0;
  vertical-align: top;
}
.ant-descriptions-item-container {
  display: flex;
}
.ant-descriptions-item-container .ant-descriptions-item-label,
.ant-descriptions-item-container .ant-descriptions-item-content {
  display: inline-flex;
  align-items: baseline;
}
.ant-descriptions-middle .ant-descriptions-row > th,
.ant-descriptions-middle .ant-descriptions-row > td {
  padding-bottom: 12px;
}
.ant-descriptions-small .ant-descriptions-row > th,
.ant-descriptions-small .ant-descriptions-row > td {
  padding-bottom: 8px;
}
.ant-descriptions-bordered .ant-descriptions-view {
  border: 1px solid #e8e8e8;
}
.ant-descriptions-bordered .ant-descriptions-view > table {
  table-layout: auto;
  border-collapse: collapse;
}
.ant-descriptions-bordered .ant-descriptions-item-label,
.ant-descriptions-bordered .ant-descriptions-item-content {
  padding: 16px 24px;
  border-right: 1px solid #e8e8e8;
}
.ant-descriptions-bordered .ant-descriptions-item-label:last-child,
.ant-descriptions-bordered .ant-descriptions-item-content:last-child {
  border-right: none;
}
.ant-descriptions-bordered .ant-descriptions-item-label {
  background-color: #fafafa;
}
.ant-descriptions-bordered .ant-descriptions-item-label::after {
  display: none;
}
.ant-descriptions-bordered .ant-descriptions-row {
  border-bottom: 1px solid #e8e8e8;
}
.ant-descriptions-bordered .ant-descriptions-row:last-child {
  border-bottom: none;
}
.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-label,
.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-content {
  padding: 12px 24px;
}
.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-label,
.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-content {
  padding: 8px 16px;
}
.ant-descriptions-rtl {
  direction: rtl;
}
.ant-descriptions-rtl .ant-descriptions-item-label::after {
  margin: 0 2px 0 8px;
}
.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-label,
.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-content {
  border-right: none;
  border-left: 1px solid #e8e8e8;
}
.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-label:last-child,
.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-content:last-child {
  border-left: none;
}
.ant-divider {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
.ant-divider-vertical {
  position: relative;
  top: -0.06em;
  display: inline-block;
  height: 0.9em;
  margin: 0 8px;
  vertical-align: middle;
  border-top: 0;
  border-left: 1px solid rgba(0, 0, 0, 0.06);
}
.ant-divider-horizontal {
  display: flex;
  clear: both;
  width: 100%;
  min-width: 100%;
  margin: 24px 0;
}
.ant-divider-horizontal.ant-divider-with-text {
  display: flex;
  align-items: center;
  margin: 16px 0;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  text-align: center;
  border-top: 0;
  border-top-color: rgba(0, 0, 0, 0.06);
}
.ant-divider-horizontal.ant-divider-with-text::before,
.ant-divider-horizontal.ant-divider-with-text::after {
  position: relative;
  width: 50%;
  border-top: 1px solid transparent;
  border-top-color: inherit;
  border-bottom: 0;
  transform: translateY(50%);
  content: '';
}
.ant-divider-horizontal.ant-divider-with-text-left::before {
  width: 5%;
}
.ant-divider-horizontal.ant-divider-with-text-left::after {
  width: 95%;
}
.ant-divider-horizontal.ant-divider-with-text-right::before {
  width: 95%;
}
.ant-divider-horizontal.ant-divider-with-text-right::after {
  width: 5%;
}
.ant-divider-inner-text {
  display: inline-block;
  padding: 0 1em;
}
.ant-divider-dashed {
  background: none;
  border-color: rgba(0, 0, 0, 0.06);
  border-style: dashed;
  border-width: 1px 0 0;
}
.ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed::before,
.ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed::after {
  border-style: dashed none none;
}
.ant-divider-vertical.ant-divider-dashed {
  border-width: 0 0 0 1px;
}
.ant-divider-plain.ant-divider-with-text {
  color: #545454;
  font-weight: normal;
  font-size: 14px;
}
.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left::before {
  width: 0;
}
.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left::after {
  width: 100%;
}
.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left .ant-divider-inner-text {
  padding-left: 0;
}
.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right::before {
  width: 100%;
}
.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right::after {
  width: 0;
}
.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right .ant-divider-inner-text {
  padding-right: 0;
}
.ant-divider-rtl {
  direction: rtl;
}
.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-left::before {
  width: 95%;
}
.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-left::after {
  width: 5%;
}
.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-right::before {
  width: 5%;
}
.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-right::after {
  width: 95%;
}
.ant-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  pointer-events: none;
}
.ant-drawer-inline {
  position: absolute;
}
.ant-drawer-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  pointer-events: auto;
}
.ant-drawer-content-wrapper {
  position: absolute;
  z-index: 1000;
  transition: all 0.3s;
}
.ant-drawer-content-wrapper-hidden {
  display: none;
}
.ant-drawer-left > .ant-drawer-content-wrapper {
  top: 0;
  bottom: 0;
  left: 0;
  box-shadow: 6px 0 16px -8px rgba(0, 0, 0, 0.08), 9px 0 28px 0 rgba(0, 0, 0, 0.05), 12px 0 48px 16px rgba(0, 0, 0, 0.03);
}
.ant-drawer-right > .ant-drawer-content-wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  box-shadow: -6px 0 16px -8px rgba(0, 0, 0, 0.08), -9px 0 28px 0 rgba(0, 0, 0, 0.05), -12px 0 48px 16px rgba(0, 0, 0, 0.03);
}
.ant-drawer-top > .ant-drawer-content-wrapper {
  top: 0;
  right: 0;
  left: 0;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px 0 rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
}
.ant-drawer-bottom > .ant-drawer-content-wrapper {
  right: 0;
  bottom: 0;
  left: 0;
  box-shadow: 0 -6px 16px -8px rgba(0, 0, 0, 0.08), 0 -9px 28px 0 rgba(0, 0, 0, 0.05), 0 -12px 48px 16px rgba(0, 0, 0, 0.03);
}
.ant-drawer-content {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  pointer-events: auto;
}
.ant-drawer-wrapper-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.ant-drawer-header {
  display: flex;
  flex: 0;
  align-items: center;
  padding: 16px 24px;
  font-size: 16px;
  line-height: 22px;
  border-bottom: 1px solid #e8e8e8;
}
.ant-drawer-header-title {
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
  min-height: 0;
}
.ant-drawer-extra {
  flex: none;
}
.ant-drawer-close {
  display: inline-block;
  margin-right: 12px;
  color: #595959;
  font-weight: 700;
  font-size: 16px;
  font-style: normal;
  line-height: 1;
  text-align: center;
  text-transform: none;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
  text-rendering: auto;
}
.ant-drawer-close:focus,
.ant-drawer-close:hover {
  color: rgba(0, 0, 0, 0.75);
  text-decoration: none;
}
.ant-drawer-title {
  flex: 1;
  margin: 0;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
}
.ant-drawer-body {
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 24px;
  overflow: auto;
}
.ant-drawer-footer {
  flex-shrink: 0;
  padding: 10px 16px;
  border-top: 1px solid #e8e8e8;
}
.panel-motion-enter-start,
.panel-motion-appear-start,
.panel-motion-leave-start {
  transition: none;
}
.panel-motion-enter-active,
.panel-motion-appear-active,
.panel-motion-leave-active {
  transition: all 0.3s;
}
.ant-drawer-mask-motion-enter-active,
.ant-drawer-mask-motion-appear-active,
.ant-drawer-mask-motion-leave-active {
  transition: all 0.3s;
}
.ant-drawer-mask-motion-enter,
.ant-drawer-mask-motion-appear {
  opacity: 0;
}
.ant-drawer-mask-motion-enter-active,
.ant-drawer-mask-motion-appear-active {
  opacity: 1;
}
.ant-drawer-mask-motion-leave {
  opacity: 1;
}
.ant-drawer-mask-motion-leave-active {
  opacity: 0;
}
.ant-drawer-panel-motion-left-enter-start,
.ant-drawer-panel-motion-left-appear-start,
.ant-drawer-panel-motion-left-leave-start {
  transition: none;
}
.ant-drawer-panel-motion-left-enter-active,
.ant-drawer-panel-motion-left-appear-active,
.ant-drawer-panel-motion-left-leave-active {
  transition: all 0.3s;
}
.ant-drawer-panel-motion-left-enter-start,
.ant-drawer-panel-motion-left-appear-start {
  transform: translateX(-100%) !important;
}
.ant-drawer-panel-motion-left-enter-active,
.ant-drawer-panel-motion-left-appear-active {
  transform: translateX(0);
}
.ant-drawer-panel-motion-left-leave {
  transform: translateX(0);
}
.ant-drawer-panel-motion-left-leave-active {
  transform: translateX(-100%);
}
.ant-drawer-panel-motion-right-enter-start,
.ant-drawer-panel-motion-right-appear-start,
.ant-drawer-panel-motion-right-leave-start {
  transition: none;
}
.ant-drawer-panel-motion-right-enter-active,
.ant-drawer-panel-motion-right-appear-active,
.ant-drawer-panel-motion-right-leave-active {
  transition: all 0.3s;
}
.ant-drawer-panel-motion-right-enter-start,
.ant-drawer-panel-motion-right-appear-start {
  transform: translateX(100%) !important;
}
.ant-drawer-panel-motion-right-enter-active,
.ant-drawer-panel-motion-right-appear-active {
  transform: translateX(0);
}
.ant-drawer-panel-motion-right-leave {
  transform: translateX(0);
}
.ant-drawer-panel-motion-right-leave-active {
  transform: translateX(100%);
}
.ant-drawer-panel-motion-top-enter-start,
.ant-drawer-panel-motion-top-appear-start,
.ant-drawer-panel-motion-top-leave-start {
  transition: none;
}
.ant-drawer-panel-motion-top-enter-active,
.ant-drawer-panel-motion-top-appear-active,
.ant-drawer-panel-motion-top-leave-active {
  transition: all 0.3s;
}
.ant-drawer-panel-motion-top-enter-start,
.ant-drawer-panel-motion-top-appear-start {
  transform: translateY(-100%) !important;
}
.ant-drawer-panel-motion-top-enter-active,
.ant-drawer-panel-motion-top-appear-active {
  transform: translateY(0);
}
.ant-drawer-panel-motion-top-leave {
  transform: translateY(0);
}
.ant-drawer-panel-motion-top-leave-active {
  transform: translateY(-100%);
}
.ant-drawer-panel-motion-bottom-enter-start,
.ant-drawer-panel-motion-bottom-appear-start,
.ant-drawer-panel-motion-bottom-leave-start {
  transition: none;
}
.ant-drawer-panel-motion-bottom-enter-active,
.ant-drawer-panel-motion-bottom-appear-active,
.ant-drawer-panel-motion-bottom-leave-active {
  transition: all 0.3s;
}
.ant-drawer-panel-motion-bottom-enter-start,
.ant-drawer-panel-motion-bottom-appear-start {
  transform: translateY(100%) !important;
}
.ant-drawer-panel-motion-bottom-enter-active,
.ant-drawer-panel-motion-bottom-appear-active {
  transform: translateY(0);
}
.ant-drawer-panel-motion-bottom-leave {
  transform: translateY(0);
}
.ant-drawer-panel-motion-bottom-leave-active {
  transform: translateY(100%);
}
.ant-drawer-rtl {
  direction: rtl;
}
.ant-drawer-rtl .ant-drawer-close {
  margin-right: 0;
  margin-left: 12px;
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-danger {
  color: #f5222d;
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-danger:hover {
  color: #fff;
  background-color: #f5222d;
}
.ant-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  display: block;
}
.ant-dropdown::before {
  position: absolute;
  top: -4px;
  right: 0;
  bottom: -4px;
  left: -7px;
  z-index: -9999;
  opacity: 0.0001;
  content: ' ';
}
.ant-dropdown-wrap {
  position: relative;
}
.ant-dropdown-wrap .ant-btn > .anticon-down {
  font-size: 10px;
}
.ant-dropdown-wrap .anticon-down::before {
  transition: transform 0.2s;
}
.ant-dropdown-wrap-open .anticon-down::before {
  transform: rotate(180deg);
}
.ant-dropdown-hidden,
.ant-dropdown-menu-hidden,
.ant-dropdown-menu-submenu-hidden {
  display: none;
}
.ant-dropdown-show-arrow.ant-dropdown-placement-topLeft,
.ant-dropdown-show-arrow.ant-dropdown-placement-top,
.ant-dropdown-show-arrow.ant-dropdown-placement-topRight {
  padding-bottom: 15.3137085px;
}
.ant-dropdown-show-arrow.ant-dropdown-placement-bottomLeft,
.ant-dropdown-show-arrow.ant-dropdown-placement-bottom,
.ant-dropdown-show-arrow.ant-dropdown-placement-bottomRight {
  padding-top: 15.3137085px;
}
.ant-dropdown-arrow {
  position: absolute;
  z-index: 1;
  display: block;
  width: 11.3137085px;
  height: 11.3137085px;
  border-radius: 0 0 2px;
  pointer-events: none;
}
.ant-dropdown-arrow::before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: #fff;
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: '';
  clip-path: inset(33% 33%);
  clip-path: path('M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z');
}
.ant-dropdown-placement-top > .ant-dropdown-arrow,
.ant-dropdown-placement-topLeft > .ant-dropdown-arrow,
.ant-dropdown-placement-topRight > .ant-dropdown-arrow {
  bottom: 10px;
  box-shadow: 3px 3px 7px -3px rgba(0, 0, 0, 0.1);
  transform: rotate(45deg);
}
.ant-dropdown-placement-top > .ant-dropdown-arrow {
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}
.ant-dropdown-placement-topLeft > .ant-dropdown-arrow {
  left: 16px;
}
.ant-dropdown-placement-topRight > .ant-dropdown-arrow {
  right: 16px;
}
.ant-dropdown-placement-bottom > .ant-dropdown-arrow,
.ant-dropdown-placement-bottomLeft > .ant-dropdown-arrow,
.ant-dropdown-placement-bottomRight > .ant-dropdown-arrow {
  top: 9.41421356px;
  box-shadow: 2px 2px 5px -2px rgba(0, 0, 0, 0.1);
  transform: rotate(-135deg) translateY(-0.5px);
}
.ant-dropdown-placement-bottom > .ant-dropdown-arrow {
  left: 50%;
  transform: translateX(-50%) rotate(-135deg) translateY(-0.5px);
}
.ant-dropdown-placement-bottomLeft > .ant-dropdown-arrow {
  left: 16px;
}
.ant-dropdown-placement-bottomRight > .ant-dropdown-arrow {
  right: 16px;
}
.ant-dropdown-menu {
  position: relative;
  margin: 0;
  padding: 4px 0;
  text-align: left;
  list-style-type: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 6px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.ant-dropdown-menu-item-group-title {
  padding: 5px 12px;
  color: #595959;
  transition: all 0.3s;
}
.ant-dropdown-menu-submenu-popup {
  position: absolute;
  z-index: 1050;
  background: transparent;
  box-shadow: none;
  transform-origin: 0 0;
}
.ant-dropdown-menu-submenu-popup ul,
.ant-dropdown-menu-submenu-popup li {
  list-style: none;
}
.ant-dropdown-menu-submenu-popup ul {
  margin-right: 0.3em;
  margin-left: 0.3em;
}
.ant-dropdown-menu-item {
  position: relative;
  display: flex;
  align-items: center;
}
.ant-dropdown-menu-item-icon {
  min-width: 12px;
  margin-right: 8px;
  font-size: 12px;
}
.ant-dropdown-menu-title-content {
  flex: auto;
}
.ant-dropdown-menu-title-content > a {
  color: inherit;
  transition: all 0.3s;
}
.ant-dropdown-menu-title-content > a:hover {
  color: inherit;
}
.ant-dropdown-menu-title-content > a::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: '';
}
.ant-dropdown-menu-item,
.ant-dropdown-menu-submenu-title {
  clear: both;
  margin: 0;
  padding: 5px 12px;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-dropdown-menu-item-selected,
.ant-dropdown-menu-submenu-title-selected {
  color: #351a55;
  background-color: #908b94;
}
.ant-dropdown-menu-item:hover,
.ant-dropdown-menu-submenu-title:hover,
.ant-dropdown-menu-item.ant-dropdown-menu-item-active,
.ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-active,
.ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-active,
.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-active {
  background-color: #f5f5f5;
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled,
.ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled,
.ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled,
.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover,
.ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled:hover,
.ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled:hover,
.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled a,
.ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled a,
.ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled a,
.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled a {
  pointer-events: none;
}
.ant-dropdown-menu-item-divider,
.ant-dropdown-menu-submenu-title-divider {
  height: 1px;
  margin: 4px 0;
  overflow: hidden;
  line-height: 0;
  background-color: #e8e8e8;
}
.ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon,
.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon {
  position: absolute;
  right: 8px;
}
.ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon,
.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon {
  margin-right: 0 !important;
  color: #595959;
  font-size: 10px;
  font-style: normal;
}
.ant-dropdown-menu-item-group-list {
  margin: 0 8px;
  padding: 0;
  list-style: none;
}
.ant-dropdown-menu-submenu-title {
  padding-right: 24px;
}
.ant-dropdown-menu-submenu-vertical {
  position: relative;
}
.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 100%;
  margin-left: 4px;
  transform-origin: 0 0;
}
.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,
.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}
.ant-dropdown-menu-submenu-selected .ant-dropdown-menu-submenu-title {
  color: #351a55;
}
.ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottom,
.ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottom,
.ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottomRight,
.ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpIn;
}
.ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-topLeft,
.ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-topLeft,
.ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-top,
.ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-top,
.ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-topRight,
.ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownIn;
}
.ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottom,
.ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpOut;
}
.ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-topLeft,
.ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-top,
.ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownOut;
}
.ant-dropdown-trigger > .anticon.anticon-down,
.ant-dropdown-link > .anticon.anticon-down,
.ant-dropdown-button > .anticon.anticon-down {
  font-size: 10px;
  vertical-align: baseline;
}
.ant-dropdown-button {
  white-space: nowrap;
}
.ant-dropdown-button.ant-btn-group > .ant-btn-loading,
.ant-dropdown-button.ant-btn-group > .ant-btn-loading + .ant-btn {
  cursor: default;
  pointer-events: none;
}
.ant-dropdown-button.ant-btn-group > .ant-btn-loading + .ant-btn::before {
  display: block;
}
.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child):not(.ant-btn-icon-only) {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-dropdown-menu-dark,
.ant-dropdown-menu-dark .ant-dropdown-menu {
  background: var(--app-primary-color);
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a {
  color: rgba(255, 255, 255, 0.65);
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow::after,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow::after,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a .ant-dropdown-menu-submenu-arrow::after,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a .ant-dropdown-menu-submenu-arrow::after {
  color: rgba(255, 255, 255, 0.65);
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a:hover {
  color: #fff;
  background: transparent;
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {
  color: #fff;
  background: #351a55;
}
.ant-dropdown-rtl {
  direction: rtl;
}
.ant-dropdown-rtl.ant-dropdown::before {
  right: -7px;
  left: 0;
}
.ant-dropdown-menu.ant-dropdown-menu-rtl {
  direction: rtl;
  text-align: right;
}
.ant-dropdown-rtl .ant-dropdown-menu-item-group-title,
.ant-dropdown-menu-submenu-rtl .ant-dropdown-menu-item-group-title {
  direction: rtl;
  text-align: right;
}
.ant-dropdown-menu-submenu-popup.ant-dropdown-menu-submenu-rtl {
  transform-origin: 100% 0;
}
.ant-dropdown-rtl .ant-dropdown-menu-submenu-popup ul,
.ant-dropdown-rtl .ant-dropdown-menu-submenu-popup li {
  text-align: right;
}
.ant-dropdown-rtl .ant-dropdown-menu-item,
.ant-dropdown-rtl .ant-dropdown-menu-submenu-title {
  text-align: right;
}
.ant-dropdown-rtl .ant-dropdown-menu-item > .anticon:first-child,
.ant-dropdown-rtl .ant-dropdown-menu-submenu-title > .anticon:first-child,
.ant-dropdown-rtl .ant-dropdown-menu-item > span > .anticon:first-child,
.ant-dropdown-rtl .ant-dropdown-menu-submenu-title > span > .anticon:first-child {
  margin-right: 0;
  margin-left: 8px;
}
.ant-dropdown-rtl .ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon,
.ant-dropdown-rtl .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon {
  right: auto;
  left: 8px;
}
.ant-dropdown-rtl .ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon,
.ant-dropdown-rtl .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon {
  margin-left: 0 !important;
  transform: scaleX(-1);
}
.ant-dropdown-rtl .ant-dropdown-menu-submenu-title {
  padding-right: 12px;
  padding-left: 24px;
}
.ant-dropdown-rtl .ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {
  right: 100%;
  left: 0;
  margin-right: 4px;
  margin-left: 0;
}
.ant-empty {
  margin: 0 8px;
  font-size: 14px;
  line-height: 1.3;
  text-align: center;
}
.ant-empty-image {
  height: 100px;
  margin-bottom: 8px;
}
.ant-empty-image img {
  height: 100%;
}
.ant-empty-image svg {
  height: 100%;
  margin: auto;
}
.ant-empty-footer {
  margin-top: 16px;
}
.ant-empty-normal {
  margin: 32px 0;
  color: rgba(0, 0, 0, 0.25);
}
.ant-empty-normal .ant-empty-image {
  height: 40px;
}
.ant-empty-small {
  margin: 8px 0;
  color: rgba(0, 0, 0, 0.25);
}
.ant-empty-small .ant-empty-image {
  height: 35px;
}
.ant-empty-img-default-ellipse {
  fill: #f5f5f5;
  fill-opacity: 0.8;
}
.ant-empty-img-default-path-1 {
  fill: #aeb8c2;
}
.ant-empty-img-default-path-2 {
  fill: url('#linearGradient-1');
}
.ant-empty-img-default-path-3 {
  fill: #f5f5f7;
}
.ant-empty-img-default-path-4 {
  fill: #dce0e6;
}
.ant-empty-img-default-path-5 {
  fill: #dce0e6;
}
.ant-empty-img-default-g {
  fill: #fff;
}
.ant-empty-img-simple-ellipse {
  fill: #f5f5f5;
}
.ant-empty-img-simple-g {
  stroke: #d9d9d9;
}
.ant-empty-img-simple-path {
  fill: #fafafa;
}
.ant-empty-rtl {
  direction: rtl;
}
.ant-form-item .ant-input-number + .ant-form-text {
  margin-left: 8px;
}
.ant-form-inline {
  display: flex;
  flex-wrap: wrap;
}
.ant-form-inline .ant-form-item {
  flex: none;
  flex-wrap: nowrap;
  margin-right: 16px;
  margin-bottom: 0;
}
.ant-form-inline .ant-form-item-with-help {
  margin-bottom: 20px;
}
.ant-form-inline .ant-form-item > .ant-form-item-label,
.ant-form-inline .ant-form-item > .ant-form-item-control {
  display: inline-block;
  vertical-align: top;
}
.ant-form-inline .ant-form-item > .ant-form-item-label {
  flex: none;
}
.ant-form-inline .ant-form-item .ant-form-text {
  display: inline-block;
}
.ant-form-inline .ant-form-item .ant-form-item-has-feedback {
  display: inline-block;
}
.ant-form-horizontal .ant-form-item-label {
  flex-grow: 0;
}
.ant-form-horizontal .ant-form-item-control {
  flex: 1 1 0;
  min-width: 0;
}
.ant-form-horizontal .ant-form-item-label[class\$='-24'] + .ant-form-item-control,
.ant-form-horizontal .ant-form-item-label[class*='-24 '] + .ant-form-item-control {
  min-width: unset;
}
.ant-form-vertical .ant-form-item-row {
  flex-direction: column;
}
.ant-form-vertical .ant-form-item-label > label {
  height: auto;
}
.ant-form-vertical .ant-form-item .ant-form-item-control {
  width: 100%;
}
.ant-form-vertical .ant-form-item-label,
.ant-col-24.ant-form-item-label,
.ant-col-xl-24.ant-form-item-label {
  padding: 0 0 8px;
  line-height: 1.3;
  white-space: initial;
  text-align: left;
}
.ant-form-vertical .ant-form-item-label > label,
.ant-col-24.ant-form-item-label > label,
.ant-col-xl-24.ant-form-item-label > label {
  margin: 0;
}
.ant-form-vertical .ant-form-item-label > label::after,
.ant-col-24.ant-form-item-label > label::after,
.ant-col-xl-24.ant-form-item-label > label::after {
  display: none;
}
.ant-form-rtl.ant-form-vertical .ant-form-item-label,
.ant-form-rtl.ant-col-24.ant-form-item-label,
.ant-form-rtl.ant-col-xl-24.ant-form-item-label {
  text-align: right;
}
@media (max-width: 575px) {
  .ant-form-item .ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-form-item .ant-form-item-label > label {
    margin: 0;
  }
  .ant-form-item .ant-form-item-label > label::after {
    display: none;
  }
  .ant-form-rtl.ant-form-item .ant-form-item-label {
    text-align: right;
  }
  .ant-form .ant-form-item {
    flex-wrap: wrap;
  }
  .ant-form .ant-form-item .ant-form-item-label,
  .ant-form .ant-form-item .ant-form-item-control {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-xs-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-col-xs-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-xs-24.ant-form-item-label > label::after {
    display: none;
  }
  .ant-form-rtl.ant-col-xs-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 767px) {
  .ant-col-sm-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-col-sm-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-sm-24.ant-form-item-label > label::after {
    display: none;
  }
  .ant-form-rtl.ant-col-sm-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 991px) {
  .ant-col-md-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-col-md-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-md-24.ant-form-item-label > label::after {
    display: none;
  }
  .ant-form-rtl.ant-col-md-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 1199px) {
  .ant-col-lg-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-col-lg-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-lg-24.ant-form-item-label > label::after {
    display: none;
  }
  .ant-form-rtl.ant-col-lg-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 1599px) {
  .ant-col-xl-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-col-xl-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-xl-24.ant-form-item-label > label::after {
    display: none;
  }
  .ant-form-rtl.ant-col-xl-24.ant-form-item-label {
    text-align: right;
  }
}
.ant-form-item {
  /* Some non-status related component style is in \`components.less\` */
  /* To support leave along ErrorList. We add additional className to handle explain style */
}
.ant-form-item-explain-error {
  color: #f5222d;
}
.ant-form-item-explain-warning {
  color: #fa8c16;
}
.ant-form-item-has-feedback .ant-switch {
  margin: 2px 0 4px;
}
.ant-form-item-has-warning .ant-form-item-split {
  color: #fa8c16;
}
.ant-form-item-has-error .ant-form-item-split {
  color: #f5222d;
}
.ant-form {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-form legend {
  display: block;
  width: 100%;
  margin-bottom: 20px;
  padding: 0;
  color: #595959;
  font-size: 16px;
  line-height: inherit;
  border: 0;
  border-bottom: 1px solid #d9d9d9;
}
.ant-form label {
  font-size: 14px;
}
.ant-form input[type='search'] {
  box-sizing: border-box;
}
.ant-form input[type='radio'],
.ant-form input[type='checkbox'] {
  line-height: normal;
}
.ant-form input[type='file'] {
  display: block;
}
.ant-form input[type='range'] {
  display: block;
  width: 100%;
}
.ant-form select[multiple],
.ant-form select[size] {
  height: auto;
}
.ant-form input[type='file']:focus,
.ant-form input[type='radio']:focus,
.ant-form input[type='checkbox']:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.ant-form output {
  display: block;
  padding-top: 15px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
}
.ant-form .ant-form-text {
  display: inline-block;
  padding-right: 8px;
}
.ant-form-small .ant-form-item-label > label {
  height: 24px;
}
.ant-form-small .ant-form-item-control-input {
  min-height: 24px;
}
.ant-form-large .ant-form-item-label > label {
  height: 40px;
}
.ant-form-large .ant-form-item-control-input {
  min-height: 40px;
}
.ant-form-item {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  margin-bottom: 20px;
  vertical-align: top;
}
.ant-form-item-with-help {
  transition: none;
}
.ant-form-item-hidden,
.ant-form-item-hidden.ant-row {
  display: none;
}
.ant-form-item-label {
  display: inline-block;
  flex-grow: 0;
  overflow: hidden;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}
.ant-form-item-label-left {
  text-align: left;
}
.ant-form-item-label-wrap {
  overflow: unset;
  line-height: 1.05em;
  white-space: unset;
}
.ant-form-item-label > label {
  position: relative;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  height: 36px;
  color: #535353;
  font-size: 14px;
}
.ant-form-item-label > label > .anticon {
  font-size: 14px;
  vertical-align: top;
}
.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
.ant-form-hide-required-mark .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  display: none;
}
.ant-form-item-label > label .ant-form-item-optional {
  display: inline-block;
  margin-left: 4px;
  color: #595959;
}
.ant-form-hide-required-mark .ant-form-item-label > label .ant-form-item-optional {
  display: none;
}
.ant-form-item-label > label .ant-form-item-tooltip {
  color: #595959;
  cursor: help;
  writing-mode: horizontal-tb;
  margin-inline-start: 4px;
}
.ant-form-item-label > label::after {
  content: ':';
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}
.ant-form-item-label > label.ant-form-item-no-colon::after {
  content: ' ';
}
.ant-form-item-control {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.ant-form-item-control:first-child:not([class^='ant-col-']):not([class*=' ant-col-']) {
  width: 100%;
}
.ant-form-item-control-input {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 36px;
}
.ant-form-item-control-input-content {
  flex: auto;
  max-width: 100%;
}
.ant-form-item-explain,
.ant-form-item-extra {
  clear: both;
  color: #595959;
  font-size: 14px;
  line-height: 1.3;
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.ant-form-item-explain-connected {
  width: 100%;
}
.ant-form-item-extra {
  min-height: 20px;
}
.ant-form-item-with-help .ant-form-item-explain {
  height: auto;
  opacity: 1;
}
.ant-form-item-feedback-icon {
  font-size: 14px;
  text-align: center;
  visibility: visible;
  animation: zoomIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  pointer-events: none;
}
.ant-form-item-feedback-icon-success {
  color: #52c41a;
}
.ant-form-item-feedback-icon-error {
  color: #f5222d;
}
.ant-form-item-feedback-icon-warning {
  color: #fa8c16;
}
.ant-form-item-feedback-icon-validating {
  color: #351a55;
}
.ant-show-help {
  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-show-help-appear,
.ant-show-help-enter {
  opacity: 0;
}
.ant-show-help-appear-active,
.ant-show-help-enter-active {
  opacity: 1;
}
.ant-show-help-leave {
  opacity: 1;
}
.ant-show-help-leave-active {
  opacity: 0;
}
.ant-show-help-item {
  overflow: hidden;
  transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}
.ant-show-help-item-appear,
.ant-show-help-item-enter {
  transform: translateY(-5px);
  opacity: 0;
}
.ant-show-help-item-appear-active,
.ant-show-help-item-enter-active {
  transform: translateY(0);
  opacity: 1;
}
.ant-show-help-item-leave {
  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}
.ant-show-help-item-leave-active {
  transform: translateY(-5px);
}
@keyframes diffZoomIn1 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes diffZoomIn2 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes diffZoomIn3 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.ant-form-rtl {
  direction: rtl;
}
.ant-form-rtl .ant-form-item-label {
  text-align: left;
}
.ant-form-rtl .ant-form-item-label > label.ant-form-item-required::before {
  margin-right: 0;
  margin-left: 4px;
}
.ant-form-rtl .ant-form-item-label > label::after {
  margin: 0 2px 0 8px;
}
.ant-form-rtl .ant-form-item-label > label .ant-form-item-optional {
  margin-right: 4px;
  margin-left: 0;
}
.ant-col-rtl .ant-form-item-control:first-child {
  width: 100%;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-input {
  padding-right: 11px;
  padding-left: 24px;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-input-affix-wrapper .ant-input-suffix {
  padding-right: 11px;
  padding-left: 18px;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-input-affix-wrapper .ant-input {
  padding: 0;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-input-number-affix-wrapper .ant-input-number {
  padding: 0;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-input-search:not(.ant-input-search-enter-button) .ant-input-suffix {
  right: auto;
  left: 28px;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-input-number {
  padding-left: 18px;
}
.ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-arrow,
.ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-clear,
.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow,
.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-clear,
.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-arrow,
.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-clear {
  right: auto;
  left: 32px;
}
.ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-selection-selected-value,
.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection-selected-value,
.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-selection-selected-value {
  padding-right: 0;
  padding-left: 42px;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-cascader-picker-arrow {
  margin-right: 0;
  margin-left: 19px;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-cascader-picker-clear {
  right: auto;
  left: 32px;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-picker {
  padding-right: 11px;
  padding-left: 29.2px;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-picker-large {
  padding-right: 11px;
  padding-left: 29.2px;
}
.ant-form-rtl .ant-form-item-has-feedback .ant-picker-small {
  padding-right: 7px;
  padding-left: 25.2px;
}
.ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-success .ant-form-item-children-icon,
.ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-warning .ant-form-item-children-icon,
.ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-error .ant-form-item-children-icon,
.ant-form-rtl .ant-form-item-has-feedback.ant-form-item-is-validating .ant-form-item-children-icon {
  right: auto;
  left: 0;
}
.ant-form-rtl.ant-form-inline .ant-form-item {
  margin-right: 0;
  margin-left: 16px;
}
.ant-row {
  display: flex;
  flex-flow: row wrap;
  min-width: 0;
}
.ant-row::before,
.ant-row::after {
  display: flex;
}
.ant-row-no-wrap {
  flex-wrap: nowrap;
}
.ant-row-start {
  justify-content: flex-start;
}
.ant-row-center {
  justify-content: center;
}
.ant-row-end {
  justify-content: flex-end;
}
.ant-row-space-between {
  justify-content: space-between;
}
.ant-row-space-around {
  justify-content: space-around;
}
.ant-row-space-evenly {
  justify-content: space-evenly;
}
.ant-row-top {
  align-items: flex-start;
}
.ant-row-middle {
  align-items: center;
}
.ant-row-bottom {
  align-items: flex-end;
}
.ant-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
}
.ant-col-24 {
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
}
.ant-col-push-24 {
  left: 100%;
}
.ant-col-pull-24 {
  right: 100%;
}
.ant-col-offset-24 {
  margin-left: 100%;
}
.ant-col-order-24 {
  order: 24;
}
.ant-col-23 {
  display: block;
  flex: 0 0 95.83333333%;
  max-width: 95.83333333%;
}
.ant-col-push-23 {
  left: 95.83333333%;
}
.ant-col-pull-23 {
  right: 95.83333333%;
}
.ant-col-offset-23 {
  margin-left: 95.83333333%;
}
.ant-col-order-23 {
  order: 23;
}
.ant-col-22 {
  display: block;
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}
.ant-col-push-22 {
  left: 91.66666667%;
}
.ant-col-pull-22 {
  right: 91.66666667%;
}
.ant-col-offset-22 {
  margin-left: 91.66666667%;
}
.ant-col-order-22 {
  order: 22;
}
.ant-col-21 {
  display: block;
  flex: 0 0 87.5%;
  max-width: 87.5%;
}
.ant-col-push-21 {
  left: 87.5%;
}
.ant-col-pull-21 {
  right: 87.5%;
}
.ant-col-offset-21 {
  margin-left: 87.5%;
}
.ant-col-order-21 {
  order: 21;
}
.ant-col-20 {
  display: block;
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}
.ant-col-push-20 {
  left: 83.33333333%;
}
.ant-col-pull-20 {
  right: 83.33333333%;
}
.ant-col-offset-20 {
  margin-left: 83.33333333%;
}
.ant-col-order-20 {
  order: 20;
}
.ant-col-19 {
  display: block;
  flex: 0 0 79.16666667%;
  max-width: 79.16666667%;
}
.ant-col-push-19 {
  left: 79.16666667%;
}
.ant-col-pull-19 {
  right: 79.16666667%;
}
.ant-col-offset-19 {
  margin-left: 79.16666667%;
}
.ant-col-order-19 {
  order: 19;
}
.ant-col-18 {
  display: block;
  flex: 0 0 75%;
  max-width: 75%;
}
.ant-col-push-18 {
  left: 75%;
}
.ant-col-pull-18 {
  right: 75%;
}
.ant-col-offset-18 {
  margin-left: 75%;
}
.ant-col-order-18 {
  order: 18;
}
.ant-col-17 {
  display: block;
  flex: 0 0 70.83333333%;
  max-width: 70.83333333%;
}
.ant-col-push-17 {
  left: 70.83333333%;
}
.ant-col-pull-17 {
  right: 70.83333333%;
}
.ant-col-offset-17 {
  margin-left: 70.83333333%;
}
.ant-col-order-17 {
  order: 17;
}
.ant-col-16 {
  display: block;
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}
.ant-col-push-16 {
  left: 66.66666667%;
}
.ant-col-pull-16 {
  right: 66.66666667%;
}
.ant-col-offset-16 {
  margin-left: 66.66666667%;
}
.ant-col-order-16 {
  order: 16;
}
.ant-col-15 {
  display: block;
  flex: 0 0 62.5%;
  max-width: 62.5%;
}
.ant-col-push-15 {
  left: 62.5%;
}
.ant-col-pull-15 {
  right: 62.5%;
}
.ant-col-offset-15 {
  margin-left: 62.5%;
}
.ant-col-order-15 {
  order: 15;
}
.ant-col-14 {
  display: block;
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}
.ant-col-push-14 {
  left: 58.33333333%;
}
.ant-col-pull-14 {
  right: 58.33333333%;
}
.ant-col-offset-14 {
  margin-left: 58.33333333%;
}
.ant-col-order-14 {
  order: 14;
}
.ant-col-13 {
  display: block;
  flex: 0 0 54.16666667%;
  max-width: 54.16666667%;
}
.ant-col-push-13 {
  left: 54.16666667%;
}
.ant-col-pull-13 {
  right: 54.16666667%;
}
.ant-col-offset-13 {
  margin-left: 54.16666667%;
}
.ant-col-order-13 {
  order: 13;
}
.ant-col-12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}
.ant-col-push-12 {
  left: 50%;
}
.ant-col-pull-12 {
  right: 50%;
}
.ant-col-offset-12 {
  margin-left: 50%;
}
.ant-col-order-12 {
  order: 12;
}
.ant-col-11 {
  display: block;
  flex: 0 0 45.83333333%;
  max-width: 45.83333333%;
}
.ant-col-push-11 {
  left: 45.83333333%;
}
.ant-col-pull-11 {
  right: 45.83333333%;
}
.ant-col-offset-11 {
  margin-left: 45.83333333%;
}
.ant-col-order-11 {
  order: 11;
}
.ant-col-10 {
  display: block;
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}
.ant-col-push-10 {
  left: 41.66666667%;
}
.ant-col-pull-10 {
  right: 41.66666667%;
}
.ant-col-offset-10 {
  margin-left: 41.66666667%;
}
.ant-col-order-10 {
  order: 10;
}
.ant-col-9 {
  display: block;
  flex: 0 0 37.5%;
  max-width: 37.5%;
}
.ant-col-push-9 {
  left: 37.5%;
}
.ant-col-pull-9 {
  right: 37.5%;
}
.ant-col-offset-9 {
  margin-left: 37.5%;
}
.ant-col-order-9 {
  order: 9;
}
.ant-col-8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
.ant-col-push-8 {
  left: 33.33333333%;
}
.ant-col-pull-8 {
  right: 33.33333333%;
}
.ant-col-offset-8 {
  margin-left: 33.33333333%;
}
.ant-col-order-8 {
  order: 8;
}
.ant-col-7 {
  display: block;
  flex: 0 0 29.16666667%;
  max-width: 29.16666667%;
}
.ant-col-push-7 {
  left: 29.16666667%;
}
.ant-col-pull-7 {
  right: 29.16666667%;
}
.ant-col-offset-7 {
  margin-left: 29.16666667%;
}
.ant-col-order-7 {
  order: 7;
}
.ant-col-6 {
  display: block;
  flex: 0 0 25%;
  max-width: 25%;
}
.ant-col-push-6 {
  left: 25%;
}
.ant-col-pull-6 {
  right: 25%;
}
.ant-col-offset-6 {
  margin-left: 25%;
}
.ant-col-order-6 {
  order: 6;
}
.ant-col-5 {
  display: block;
  flex: 0 0 20.83333333%;
  max-width: 20.83333333%;
}
.ant-col-push-5 {
  left: 20.83333333%;
}
.ant-col-pull-5 {
  right: 20.83333333%;
}
.ant-col-offset-5 {
  margin-left: 20.83333333%;
}
.ant-col-order-5 {
  order: 5;
}
.ant-col-4 {
  display: block;
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}
.ant-col-push-4 {
  left: 16.66666667%;
}
.ant-col-pull-4 {
  right: 16.66666667%;
}
.ant-col-offset-4 {
  margin-left: 16.66666667%;
}
.ant-col-order-4 {
  order: 4;
}
.ant-col-3 {
  display: block;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}
.ant-col-push-3 {
  left: 12.5%;
}
.ant-col-pull-3 {
  right: 12.5%;
}
.ant-col-offset-3 {
  margin-left: 12.5%;
}
.ant-col-order-3 {
  order: 3;
}
.ant-col-2 {
  display: block;
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}
.ant-col-push-2 {
  left: 8.33333333%;
}
.ant-col-pull-2 {
  right: 8.33333333%;
}
.ant-col-offset-2 {
  margin-left: 8.33333333%;
}
.ant-col-order-2 {
  order: 2;
}
.ant-col-1 {
  display: block;
  flex: 0 0 4.16666667%;
  max-width: 4.16666667%;
}
.ant-col-push-1 {
  left: 4.16666667%;
}
.ant-col-pull-1 {
  right: 4.16666667%;
}
.ant-col-offset-1 {
  margin-left: 4.16666667%;
}
.ant-col-order-1 {
  order: 1;
}
.ant-col-0 {
  display: none;
}
.ant-col-push-0 {
  left: auto;
}
.ant-col-pull-0 {
  right: auto;
}
.ant-col-push-0 {
  left: auto;
}
.ant-col-pull-0 {
  right: auto;
}
.ant-col-offset-0 {
  margin-left: 0;
}
.ant-col-order-0 {
  order: 0;
}
.ant-col-push-0.ant-col-rtl {
  right: auto;
}
.ant-col-pull-0.ant-col-rtl {
  left: auto;
}
.ant-col-push-0.ant-col-rtl {
  right: auto;
}
.ant-col-pull-0.ant-col-rtl {
  left: auto;
}
.ant-col-offset-0.ant-col-rtl {
  margin-right: 0;
}
.ant-col-push-1.ant-col-rtl {
  right: 4.16666667%;
  left: auto;
}
.ant-col-pull-1.ant-col-rtl {
  right: auto;
  left: 4.16666667%;
}
.ant-col-offset-1.ant-col-rtl {
  margin-right: 4.16666667%;
  margin-left: 0;
}
.ant-col-push-2.ant-col-rtl {
  right: 8.33333333%;
  left: auto;
}
.ant-col-pull-2.ant-col-rtl {
  right: auto;
  left: 8.33333333%;
}
.ant-col-offset-2.ant-col-rtl {
  margin-right: 8.33333333%;
  margin-left: 0;
}
.ant-col-push-3.ant-col-rtl {
  right: 12.5%;
  left: auto;
}
.ant-col-pull-3.ant-col-rtl {
  right: auto;
  left: 12.5%;
}
.ant-col-offset-3.ant-col-rtl {
  margin-right: 12.5%;
  margin-left: 0;
}
.ant-col-push-4.ant-col-rtl {
  right: 16.66666667%;
  left: auto;
}
.ant-col-pull-4.ant-col-rtl {
  right: auto;
  left: 16.66666667%;
}
.ant-col-offset-4.ant-col-rtl {
  margin-right: 16.66666667%;
  margin-left: 0;
}
.ant-col-push-5.ant-col-rtl {
  right: 20.83333333%;
  left: auto;
}
.ant-col-pull-5.ant-col-rtl {
  right: auto;
  left: 20.83333333%;
}
.ant-col-offset-5.ant-col-rtl {
  margin-right: 20.83333333%;
  margin-left: 0;
}
.ant-col-push-6.ant-col-rtl {
  right: 25%;
  left: auto;
}
.ant-col-pull-6.ant-col-rtl {
  right: auto;
  left: 25%;
}
.ant-col-offset-6.ant-col-rtl {
  margin-right: 25%;
  margin-left: 0;
}
.ant-col-push-7.ant-col-rtl {
  right: 29.16666667%;
  left: auto;
}
.ant-col-pull-7.ant-col-rtl {
  right: auto;
  left: 29.16666667%;
}
.ant-col-offset-7.ant-col-rtl {
  margin-right: 29.16666667%;
  margin-left: 0;
}
.ant-col-push-8.ant-col-rtl {
  right: 33.33333333%;
  left: auto;
}
.ant-col-pull-8.ant-col-rtl {
  right: auto;
  left: 33.33333333%;
}
.ant-col-offset-8.ant-col-rtl {
  margin-right: 33.33333333%;
  margin-left: 0;
}
.ant-col-push-9.ant-col-rtl {
  right: 37.5%;
  left: auto;
}
.ant-col-pull-9.ant-col-rtl {
  right: auto;
  left: 37.5%;
}
.ant-col-offset-9.ant-col-rtl {
  margin-right: 37.5%;
  margin-left: 0;
}
.ant-col-push-10.ant-col-rtl {
  right: 41.66666667%;
  left: auto;
}
.ant-col-pull-10.ant-col-rtl {
  right: auto;
  left: 41.66666667%;
}
.ant-col-offset-10.ant-col-rtl {
  margin-right: 41.66666667%;
  margin-left: 0;
}
.ant-col-push-11.ant-col-rtl {
  right: 45.83333333%;
  left: auto;
}
.ant-col-pull-11.ant-col-rtl {
  right: auto;
  left: 45.83333333%;
}
.ant-col-offset-11.ant-col-rtl {
  margin-right: 45.83333333%;
  margin-left: 0;
}
.ant-col-push-12.ant-col-rtl {
  right: 50%;
  left: auto;
}
.ant-col-pull-12.ant-col-rtl {
  right: auto;
  left: 50%;
}
.ant-col-offset-12.ant-col-rtl {
  margin-right: 50%;
  margin-left: 0;
}
.ant-col-push-13.ant-col-rtl {
  right: 54.16666667%;
  left: auto;
}
.ant-col-pull-13.ant-col-rtl {
  right: auto;
  left: 54.16666667%;
}
.ant-col-offset-13.ant-col-rtl {
  margin-right: 54.16666667%;
  margin-left: 0;
}
.ant-col-push-14.ant-col-rtl {
  right: 58.33333333%;
  left: auto;
}
.ant-col-pull-14.ant-col-rtl {
  right: auto;
  left: 58.33333333%;
}
.ant-col-offset-14.ant-col-rtl {
  margin-right: 58.33333333%;
  margin-left: 0;
}
.ant-col-push-15.ant-col-rtl {
  right: 62.5%;
  left: auto;
}
.ant-col-pull-15.ant-col-rtl {
  right: auto;
  left: 62.5%;
}
.ant-col-offset-15.ant-col-rtl {
  margin-right: 62.5%;
  margin-left: 0;
}
.ant-col-push-16.ant-col-rtl {
  right: 66.66666667%;
  left: auto;
}
.ant-col-pull-16.ant-col-rtl {
  right: auto;
  left: 66.66666667%;
}
.ant-col-offset-16.ant-col-rtl {
  margin-right: 66.66666667%;
  margin-left: 0;
}
.ant-col-push-17.ant-col-rtl {
  right: 70.83333333%;
  left: auto;
}
.ant-col-pull-17.ant-col-rtl {
  right: auto;
  left: 70.83333333%;
}
.ant-col-offset-17.ant-col-rtl {
  margin-right: 70.83333333%;
  margin-left: 0;
}
.ant-col-push-18.ant-col-rtl {
  right: 75%;
  left: auto;
}
.ant-col-pull-18.ant-col-rtl {
  right: auto;
  left: 75%;
}
.ant-col-offset-18.ant-col-rtl {
  margin-right: 75%;
  margin-left: 0;
}
.ant-col-push-19.ant-col-rtl {
  right: 79.16666667%;
  left: auto;
}
.ant-col-pull-19.ant-col-rtl {
  right: auto;
  left: 79.16666667%;
}
.ant-col-offset-19.ant-col-rtl {
  margin-right: 79.16666667%;
  margin-left: 0;
}
.ant-col-push-20.ant-col-rtl {
  right: 83.33333333%;
  left: auto;
}
.ant-col-pull-20.ant-col-rtl {
  right: auto;
  left: 83.33333333%;
}
.ant-col-offset-20.ant-col-rtl {
  margin-right: 83.33333333%;
  margin-left: 0;
}
.ant-col-push-21.ant-col-rtl {
  right: 87.5%;
  left: auto;
}
.ant-col-pull-21.ant-col-rtl {
  right: auto;
  left: 87.5%;
}
.ant-col-offset-21.ant-col-rtl {
  margin-right: 87.5%;
  margin-left: 0;
}
.ant-col-push-22.ant-col-rtl {
  right: 91.66666667%;
  left: auto;
}
.ant-col-pull-22.ant-col-rtl {
  right: auto;
  left: 91.66666667%;
}
.ant-col-offset-22.ant-col-rtl {
  margin-right: 91.66666667%;
  margin-left: 0;
}
.ant-col-push-23.ant-col-rtl {
  right: 95.83333333%;
  left: auto;
}
.ant-col-pull-23.ant-col-rtl {
  right: auto;
  left: 95.83333333%;
}
.ant-col-offset-23.ant-col-rtl {
  margin-right: 95.83333333%;
  margin-left: 0;
}
.ant-col-push-24.ant-col-rtl {
  right: 100%;
  left: auto;
}
.ant-col-pull-24.ant-col-rtl {
  right: auto;
  left: 100%;
}
.ant-col-offset-24.ant-col-rtl {
  margin-right: 100%;
  margin-left: 0;
}
.ant-col-xs-24 {
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
}
.ant-col-xs-push-24 {
  left: 100%;
}
.ant-col-xs-pull-24 {
  right: 100%;
}
.ant-col-xs-offset-24 {
  margin-left: 100%;
}
.ant-col-xs-order-24 {
  order: 24;
}
.ant-col-xs-23 {
  display: block;
  flex: 0 0 95.83333333%;
  max-width: 95.83333333%;
}
.ant-col-xs-push-23 {
  left: 95.83333333%;
}
.ant-col-xs-pull-23 {
  right: 95.83333333%;
}
.ant-col-xs-offset-23 {
  margin-left: 95.83333333%;
}
.ant-col-xs-order-23 {
  order: 23;
}
.ant-col-xs-22 {
  display: block;
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}
.ant-col-xs-push-22 {
  left: 91.66666667%;
}
.ant-col-xs-pull-22 {
  right: 91.66666667%;
}
.ant-col-xs-offset-22 {
  margin-left: 91.66666667%;
}
.ant-col-xs-order-22 {
  order: 22;
}
.ant-col-xs-21 {
  display: block;
  flex: 0 0 87.5%;
  max-width: 87.5%;
}
.ant-col-xs-push-21 {
  left: 87.5%;
}
.ant-col-xs-pull-21 {
  right: 87.5%;
}
.ant-col-xs-offset-21 {
  margin-left: 87.5%;
}
.ant-col-xs-order-21 {
  order: 21;
}
.ant-col-xs-20 {
  display: block;
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}
.ant-col-xs-push-20 {
  left: 83.33333333%;
}
.ant-col-xs-pull-20 {
  right: 83.33333333%;
}
.ant-col-xs-offset-20 {
  margin-left: 83.33333333%;
}
.ant-col-xs-order-20 {
  order: 20;
}
.ant-col-xs-19 {
  display: block;
  flex: 0 0 79.16666667%;
  max-width: 79.16666667%;
}
.ant-col-xs-push-19 {
  left: 79.16666667%;
}
.ant-col-xs-pull-19 {
  right: 79.16666667%;
}
.ant-col-xs-offset-19 {
  margin-left: 79.16666667%;
}
.ant-col-xs-order-19 {
  order: 19;
}
.ant-col-xs-18 {
  display: block;
  flex: 0 0 75%;
  max-width: 75%;
}
.ant-col-xs-push-18 {
  left: 75%;
}
.ant-col-xs-pull-18 {
  right: 75%;
}
.ant-col-xs-offset-18 {
  margin-left: 75%;
}
.ant-col-xs-order-18 {
  order: 18;
}
.ant-col-xs-17 {
  display: block;
  flex: 0 0 70.83333333%;
  max-width: 70.83333333%;
}
.ant-col-xs-push-17 {
  left: 70.83333333%;
}
.ant-col-xs-pull-17 {
  right: 70.83333333%;
}
.ant-col-xs-offset-17 {
  margin-left: 70.83333333%;
}
.ant-col-xs-order-17 {
  order: 17;
}
.ant-col-xs-16 {
  display: block;
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}
.ant-col-xs-push-16 {
  left: 66.66666667%;
}
.ant-col-xs-pull-16 {
  right: 66.66666667%;
}
.ant-col-xs-offset-16 {
  margin-left: 66.66666667%;
}
.ant-col-xs-order-16 {
  order: 16;
}
.ant-col-xs-15 {
  display: block;
  flex: 0 0 62.5%;
  max-width: 62.5%;
}
.ant-col-xs-push-15 {
  left: 62.5%;
}
.ant-col-xs-pull-15 {
  right: 62.5%;
}
.ant-col-xs-offset-15 {
  margin-left: 62.5%;
}
.ant-col-xs-order-15 {
  order: 15;
}
.ant-col-xs-14 {
  display: block;
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}
.ant-col-xs-push-14 {
  left: 58.33333333%;
}
.ant-col-xs-pull-14 {
  right: 58.33333333%;
}
.ant-col-xs-offset-14 {
  margin-left: 58.33333333%;
}
.ant-col-xs-order-14 {
  order: 14;
}
.ant-col-xs-13 {
  display: block;
  flex: 0 0 54.16666667%;
  max-width: 54.16666667%;
}
.ant-col-xs-push-13 {
  left: 54.16666667%;
}
.ant-col-xs-pull-13 {
  right: 54.16666667%;
}
.ant-col-xs-offset-13 {
  margin-left: 54.16666667%;
}
.ant-col-xs-order-13 {
  order: 13;
}
.ant-col-xs-12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}
.ant-col-xs-push-12 {
  left: 50%;
}
.ant-col-xs-pull-12 {
  right: 50%;
}
.ant-col-xs-offset-12 {
  margin-left: 50%;
}
.ant-col-xs-order-12 {
  order: 12;
}
.ant-col-xs-11 {
  display: block;
  flex: 0 0 45.83333333%;
  max-width: 45.83333333%;
}
.ant-col-xs-push-11 {
  left: 45.83333333%;
}
.ant-col-xs-pull-11 {
  right: 45.83333333%;
}
.ant-col-xs-offset-11 {
  margin-left: 45.83333333%;
}
.ant-col-xs-order-11 {
  order: 11;
}
.ant-col-xs-10 {
  display: block;
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}
.ant-col-xs-push-10 {
  left: 41.66666667%;
}
.ant-col-xs-pull-10 {
  right: 41.66666667%;
}
.ant-col-xs-offset-10 {
  margin-left: 41.66666667%;
}
.ant-col-xs-order-10 {
  order: 10;
}
.ant-col-xs-9 {
  display: block;
  flex: 0 0 37.5%;
  max-width: 37.5%;
}
.ant-col-xs-push-9 {
  left: 37.5%;
}
.ant-col-xs-pull-9 {
  right: 37.5%;
}
.ant-col-xs-offset-9 {
  margin-left: 37.5%;
}
.ant-col-xs-order-9 {
  order: 9;
}
.ant-col-xs-8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
.ant-col-xs-push-8 {
  left: 33.33333333%;
}
.ant-col-xs-pull-8 {
  right: 33.33333333%;
}
.ant-col-xs-offset-8 {
  margin-left: 33.33333333%;
}
.ant-col-xs-order-8 {
  order: 8;
}
.ant-col-xs-7 {
  display: block;
  flex: 0 0 29.16666667%;
  max-width: 29.16666667%;
}
.ant-col-xs-push-7 {
  left: 29.16666667%;
}
.ant-col-xs-pull-7 {
  right: 29.16666667%;
}
.ant-col-xs-offset-7 {
  margin-left: 29.16666667%;
}
.ant-col-xs-order-7 {
  order: 7;
}
.ant-col-xs-6 {
  display: block;
  flex: 0 0 25%;
  max-width: 25%;
}
.ant-col-xs-push-6 {
  left: 25%;
}
.ant-col-xs-pull-6 {
  right: 25%;
}
.ant-col-xs-offset-6 {
  margin-left: 25%;
}
.ant-col-xs-order-6 {
  order: 6;
}
.ant-col-xs-5 {
  display: block;
  flex: 0 0 20.83333333%;
  max-width: 20.83333333%;
}
.ant-col-xs-push-5 {
  left: 20.83333333%;
}
.ant-col-xs-pull-5 {
  right: 20.83333333%;
}
.ant-col-xs-offset-5 {
  margin-left: 20.83333333%;
}
.ant-col-xs-order-5 {
  order: 5;
}
.ant-col-xs-4 {
  display: block;
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}
.ant-col-xs-push-4 {
  left: 16.66666667%;
}
.ant-col-xs-pull-4 {
  right: 16.66666667%;
}
.ant-col-xs-offset-4 {
  margin-left: 16.66666667%;
}
.ant-col-xs-order-4 {
  order: 4;
}
.ant-col-xs-3 {
  display: block;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}
.ant-col-xs-push-3 {
  left: 12.5%;
}
.ant-col-xs-pull-3 {
  right: 12.5%;
}
.ant-col-xs-offset-3 {
  margin-left: 12.5%;
}
.ant-col-xs-order-3 {
  order: 3;
}
.ant-col-xs-2 {
  display: block;
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}
.ant-col-xs-push-2 {
  left: 8.33333333%;
}
.ant-col-xs-pull-2 {
  right: 8.33333333%;
}
.ant-col-xs-offset-2 {
  margin-left: 8.33333333%;
}
.ant-col-xs-order-2 {
  order: 2;
}
.ant-col-xs-1 {
  display: block;
  flex: 0 0 4.16666667%;
  max-width: 4.16666667%;
}
.ant-col-xs-push-1 {
  left: 4.16666667%;
}
.ant-col-xs-pull-1 {
  right: 4.16666667%;
}
.ant-col-xs-offset-1 {
  margin-left: 4.16666667%;
}
.ant-col-xs-order-1 {
  order: 1;
}
.ant-col-xs-0 {
  display: none;
}
.ant-col-push-0 {
  left: auto;
}
.ant-col-pull-0 {
  right: auto;
}
.ant-col-xs-push-0 {
  left: auto;
}
.ant-col-xs-pull-0 {
  right: auto;
}
.ant-col-xs-offset-0 {
  margin-left: 0;
}
.ant-col-xs-order-0 {
  order: 0;
}
.ant-col-push-0.ant-col-rtl {
  right: auto;
}
.ant-col-pull-0.ant-col-rtl {
  left: auto;
}
.ant-col-xs-push-0.ant-col-rtl {
  right: auto;
}
.ant-col-xs-pull-0.ant-col-rtl {
  left: auto;
}
.ant-col-xs-offset-0.ant-col-rtl {
  margin-right: 0;
}
.ant-col-xs-push-1.ant-col-rtl {
  right: 4.16666667%;
  left: auto;
}
.ant-col-xs-pull-1.ant-col-rtl {
  right: auto;
  left: 4.16666667%;
}
.ant-col-xs-offset-1.ant-col-rtl {
  margin-right: 4.16666667%;
  margin-left: 0;
}
.ant-col-xs-push-2.ant-col-rtl {
  right: 8.33333333%;
  left: auto;
}
.ant-col-xs-pull-2.ant-col-rtl {
  right: auto;
  left: 8.33333333%;
}
.ant-col-xs-offset-2.ant-col-rtl {
  margin-right: 8.33333333%;
  margin-left: 0;
}
.ant-col-xs-push-3.ant-col-rtl {
  right: 12.5%;
  left: auto;
}
.ant-col-xs-pull-3.ant-col-rtl {
  right: auto;
  left: 12.5%;
}
.ant-col-xs-offset-3.ant-col-rtl {
  margin-right: 12.5%;
  margin-left: 0;
}
.ant-col-xs-push-4.ant-col-rtl {
  right: 16.66666667%;
  left: auto;
}
.ant-col-xs-pull-4.ant-col-rtl {
  right: auto;
  left: 16.66666667%;
}
.ant-col-xs-offset-4.ant-col-rtl {
  margin-right: 16.66666667%;
  margin-left: 0;
}
.ant-col-xs-push-5.ant-col-rtl {
  right: 20.83333333%;
  left: auto;
}
.ant-col-xs-pull-5.ant-col-rtl {
  right: auto;
  left: 20.83333333%;
}
.ant-col-xs-offset-5.ant-col-rtl {
  margin-right: 20.83333333%;
  margin-left: 0;
}
.ant-col-xs-push-6.ant-col-rtl {
  right: 25%;
  left: auto;
}
.ant-col-xs-pull-6.ant-col-rtl {
  right: auto;
  left: 25%;
}
.ant-col-xs-offset-6.ant-col-rtl {
  margin-right: 25%;
  margin-left: 0;
}
.ant-col-xs-push-7.ant-col-rtl {
  right: 29.16666667%;
  left: auto;
}
.ant-col-xs-pull-7.ant-col-rtl {
  right: auto;
  left: 29.16666667%;
}
.ant-col-xs-offset-7.ant-col-rtl {
  margin-right: 29.16666667%;
  margin-left: 0;
}
.ant-col-xs-push-8.ant-col-rtl {
  right: 33.33333333%;
  left: auto;
}
.ant-col-xs-pull-8.ant-col-rtl {
  right: auto;
  left: 33.33333333%;
}
.ant-col-xs-offset-8.ant-col-rtl {
  margin-right: 33.33333333%;
  margin-left: 0;
}
.ant-col-xs-push-9.ant-col-rtl {
  right: 37.5%;
  left: auto;
}
.ant-col-xs-pull-9.ant-col-rtl {
  right: auto;
  left: 37.5%;
}
.ant-col-xs-offset-9.ant-col-rtl {
  margin-right: 37.5%;
  margin-left: 0;
}
.ant-col-xs-push-10.ant-col-rtl {
  right: 41.66666667%;
  left: auto;
}
.ant-col-xs-pull-10.ant-col-rtl {
  right: auto;
  left: 41.66666667%;
}
.ant-col-xs-offset-10.ant-col-rtl {
  margin-right: 41.66666667%;
  margin-left: 0;
}
.ant-col-xs-push-11.ant-col-rtl {
  right: 45.83333333%;
  left: auto;
}
.ant-col-xs-pull-11.ant-col-rtl {
  right: auto;
  left: 45.83333333%;
}
.ant-col-xs-offset-11.ant-col-rtl {
  margin-right: 45.83333333%;
  margin-left: 0;
}
.ant-col-xs-push-12.ant-col-rtl {
  right: 50%;
  left: auto;
}
.ant-col-xs-pull-12.ant-col-rtl {
  right: auto;
  left: 50%;
}
.ant-col-xs-offset-12.ant-col-rtl {
  margin-right: 50%;
  margin-left: 0;
}
.ant-col-xs-push-13.ant-col-rtl {
  right: 54.16666667%;
  left: auto;
}
.ant-col-xs-pull-13.ant-col-rtl {
  right: auto;
  left: 54.16666667%;
}
.ant-col-xs-offset-13.ant-col-rtl {
  margin-right: 54.16666667%;
  margin-left: 0;
}
.ant-col-xs-push-14.ant-col-rtl {
  right: 58.33333333%;
  left: auto;
}
.ant-col-xs-pull-14.ant-col-rtl {
  right: auto;
  left: 58.33333333%;
}
.ant-col-xs-offset-14.ant-col-rtl {
  margin-right: 58.33333333%;
  margin-left: 0;
}
.ant-col-xs-push-15.ant-col-rtl {
  right: 62.5%;
  left: auto;
}
.ant-col-xs-pull-15.ant-col-rtl {
  right: auto;
  left: 62.5%;
}
.ant-col-xs-offset-15.ant-col-rtl {
  margin-right: 62.5%;
  margin-left: 0;
}
.ant-col-xs-push-16.ant-col-rtl {
  right: 66.66666667%;
  left: auto;
}
.ant-col-xs-pull-16.ant-col-rtl {
  right: auto;
  left: 66.66666667%;
}
.ant-col-xs-offset-16.ant-col-rtl {
  margin-right: 66.66666667%;
  margin-left: 0;
}
.ant-col-xs-push-17.ant-col-rtl {
  right: 70.83333333%;
  left: auto;
}
.ant-col-xs-pull-17.ant-col-rtl {
  right: auto;
  left: 70.83333333%;
}
.ant-col-xs-offset-17.ant-col-rtl {
  margin-right: 70.83333333%;
  margin-left: 0;
}
.ant-col-xs-push-18.ant-col-rtl {
  right: 75%;
  left: auto;
}
.ant-col-xs-pull-18.ant-col-rtl {
  right: auto;
  left: 75%;
}
.ant-col-xs-offset-18.ant-col-rtl {
  margin-right: 75%;
  margin-left: 0;
}
.ant-col-xs-push-19.ant-col-rtl {
  right: 79.16666667%;
  left: auto;
}
.ant-col-xs-pull-19.ant-col-rtl {
  right: auto;
  left: 79.16666667%;
}
.ant-col-xs-offset-19.ant-col-rtl {
  margin-right: 79.16666667%;
  margin-left: 0;
}
.ant-col-xs-push-20.ant-col-rtl {
  right: 83.33333333%;
  left: auto;
}
.ant-col-xs-pull-20.ant-col-rtl {
  right: auto;
  left: 83.33333333%;
}
.ant-col-xs-offset-20.ant-col-rtl {
  margin-right: 83.33333333%;
  margin-left: 0;
}
.ant-col-xs-push-21.ant-col-rtl {
  right: 87.5%;
  left: auto;
}
.ant-col-xs-pull-21.ant-col-rtl {
  right: auto;
  left: 87.5%;
}
.ant-col-xs-offset-21.ant-col-rtl {
  margin-right: 87.5%;
  margin-left: 0;
}
.ant-col-xs-push-22.ant-col-rtl {
  right: 91.66666667%;
  left: auto;
}
.ant-col-xs-pull-22.ant-col-rtl {
  right: auto;
  left: 91.66666667%;
}
.ant-col-xs-offset-22.ant-col-rtl {
  margin-right: 91.66666667%;
  margin-left: 0;
}
.ant-col-xs-push-23.ant-col-rtl {
  right: 95.83333333%;
  left: auto;
}
.ant-col-xs-pull-23.ant-col-rtl {
  right: auto;
  left: 95.83333333%;
}
.ant-col-xs-offset-23.ant-col-rtl {
  margin-right: 95.83333333%;
  margin-left: 0;
}
.ant-col-xs-push-24.ant-col-rtl {
  right: 100%;
  left: auto;
}
.ant-col-xs-pull-24.ant-col-rtl {
  right: auto;
  left: 100%;
}
.ant-col-xs-offset-24.ant-col-rtl {
  margin-right: 100%;
  margin-left: 0;
}
@media (min-width: 576px) {
  .ant-col-sm-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-sm-push-24 {
    left: 100%;
  }
  .ant-col-sm-pull-24 {
    right: 100%;
  }
  .ant-col-sm-offset-24 {
    margin-left: 100%;
  }
  .ant-col-sm-order-24 {
    order: 24;
  }
  .ant-col-sm-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-sm-push-23 {
    left: 95.83333333%;
  }
  .ant-col-sm-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-sm-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-sm-order-23 {
    order: 23;
  }
  .ant-col-sm-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-sm-push-22 {
    left: 91.66666667%;
  }
  .ant-col-sm-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-sm-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-sm-order-22 {
    order: 22;
  }
  .ant-col-sm-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-sm-push-21 {
    left: 87.5%;
  }
  .ant-col-sm-pull-21 {
    right: 87.5%;
  }
  .ant-col-sm-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-sm-order-21 {
    order: 21;
  }
  .ant-col-sm-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-sm-push-20 {
    left: 83.33333333%;
  }
  .ant-col-sm-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-sm-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-sm-order-20 {
    order: 20;
  }
  .ant-col-sm-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-sm-push-19 {
    left: 79.16666667%;
  }
  .ant-col-sm-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-sm-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-sm-order-19 {
    order: 19;
  }
  .ant-col-sm-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-sm-push-18 {
    left: 75%;
  }
  .ant-col-sm-pull-18 {
    right: 75%;
  }
  .ant-col-sm-offset-18 {
    margin-left: 75%;
  }
  .ant-col-sm-order-18 {
    order: 18;
  }
  .ant-col-sm-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-sm-push-17 {
    left: 70.83333333%;
  }
  .ant-col-sm-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-sm-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-sm-order-17 {
    order: 17;
  }
  .ant-col-sm-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-sm-push-16 {
    left: 66.66666667%;
  }
  .ant-col-sm-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-sm-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-sm-order-16 {
    order: 16;
  }
  .ant-col-sm-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-sm-push-15 {
    left: 62.5%;
  }
  .ant-col-sm-pull-15 {
    right: 62.5%;
  }
  .ant-col-sm-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-sm-order-15 {
    order: 15;
  }
  .ant-col-sm-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-sm-push-14 {
    left: 58.33333333%;
  }
  .ant-col-sm-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-sm-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-sm-order-14 {
    order: 14;
  }
  .ant-col-sm-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-sm-push-13 {
    left: 54.16666667%;
  }
  .ant-col-sm-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-sm-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-sm-order-13 {
    order: 13;
  }
  .ant-col-sm-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-sm-push-12 {
    left: 50%;
  }
  .ant-col-sm-pull-12 {
    right: 50%;
  }
  .ant-col-sm-offset-12 {
    margin-left: 50%;
  }
  .ant-col-sm-order-12 {
    order: 12;
  }
  .ant-col-sm-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-sm-push-11 {
    left: 45.83333333%;
  }
  .ant-col-sm-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-sm-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-sm-order-11 {
    order: 11;
  }
  .ant-col-sm-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-sm-push-10 {
    left: 41.66666667%;
  }
  .ant-col-sm-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-sm-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-sm-order-10 {
    order: 10;
  }
  .ant-col-sm-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-sm-push-9 {
    left: 37.5%;
  }
  .ant-col-sm-pull-9 {
    right: 37.5%;
  }
  .ant-col-sm-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-sm-order-9 {
    order: 9;
  }
  .ant-col-sm-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-sm-push-8 {
    left: 33.33333333%;
  }
  .ant-col-sm-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-sm-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-sm-order-8 {
    order: 8;
  }
  .ant-col-sm-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-sm-push-7 {
    left: 29.16666667%;
  }
  .ant-col-sm-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-sm-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-sm-order-7 {
    order: 7;
  }
  .ant-col-sm-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-sm-push-6 {
    left: 25%;
  }
  .ant-col-sm-pull-6 {
    right: 25%;
  }
  .ant-col-sm-offset-6 {
    margin-left: 25%;
  }
  .ant-col-sm-order-6 {
    order: 6;
  }
  .ant-col-sm-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-sm-push-5 {
    left: 20.83333333%;
  }
  .ant-col-sm-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-sm-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-sm-order-5 {
    order: 5;
  }
  .ant-col-sm-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-sm-push-4 {
    left: 16.66666667%;
  }
  .ant-col-sm-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-sm-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-sm-order-4 {
    order: 4;
  }
  .ant-col-sm-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-sm-push-3 {
    left: 12.5%;
  }
  .ant-col-sm-pull-3 {
    right: 12.5%;
  }
  .ant-col-sm-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-sm-order-3 {
    order: 3;
  }
  .ant-col-sm-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-sm-push-2 {
    left: 8.33333333%;
  }
  .ant-col-sm-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-sm-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-sm-order-2 {
    order: 2;
  }
  .ant-col-sm-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-sm-push-1 {
    left: 4.16666667%;
  }
  .ant-col-sm-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-sm-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-sm-order-1 {
    order: 1;
  }
  .ant-col-sm-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-sm-push-0 {
    left: auto;
  }
  .ant-col-sm-pull-0 {
    right: auto;
  }
  .ant-col-sm-offset-0 {
    margin-left: 0;
  }
  .ant-col-sm-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-sm-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-sm-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-sm-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-sm-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-sm-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-sm-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-sm-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-sm-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-sm-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-sm-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-sm-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-sm-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-sm-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-sm-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-sm-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-sm-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-sm-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-sm-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-sm-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-sm-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-sm-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-sm-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-sm-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-sm-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-sm-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-sm-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-sm-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-sm-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-sm-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-sm-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-sm-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-sm-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-sm-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-sm-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-sm-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-sm-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-sm-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-sm-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-sm-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 768px) {
  .ant-col-md-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-md-push-24 {
    left: 100%;
  }
  .ant-col-md-pull-24 {
    right: 100%;
  }
  .ant-col-md-offset-24 {
    margin-left: 100%;
  }
  .ant-col-md-order-24 {
    order: 24;
  }
  .ant-col-md-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-md-push-23 {
    left: 95.83333333%;
  }
  .ant-col-md-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-md-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-md-order-23 {
    order: 23;
  }
  .ant-col-md-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-md-push-22 {
    left: 91.66666667%;
  }
  .ant-col-md-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-md-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-md-order-22 {
    order: 22;
  }
  .ant-col-md-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-md-push-21 {
    left: 87.5%;
  }
  .ant-col-md-pull-21 {
    right: 87.5%;
  }
  .ant-col-md-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-md-order-21 {
    order: 21;
  }
  .ant-col-md-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-md-push-20 {
    left: 83.33333333%;
  }
  .ant-col-md-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-md-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-md-order-20 {
    order: 20;
  }
  .ant-col-md-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-md-push-19 {
    left: 79.16666667%;
  }
  .ant-col-md-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-md-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-md-order-19 {
    order: 19;
  }
  .ant-col-md-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-md-push-18 {
    left: 75%;
  }
  .ant-col-md-pull-18 {
    right: 75%;
  }
  .ant-col-md-offset-18 {
    margin-left: 75%;
  }
  .ant-col-md-order-18 {
    order: 18;
  }
  .ant-col-md-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-md-push-17 {
    left: 70.83333333%;
  }
  .ant-col-md-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-md-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-md-order-17 {
    order: 17;
  }
  .ant-col-md-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-md-push-16 {
    left: 66.66666667%;
  }
  .ant-col-md-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-md-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-md-order-16 {
    order: 16;
  }
  .ant-col-md-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-md-push-15 {
    left: 62.5%;
  }
  .ant-col-md-pull-15 {
    right: 62.5%;
  }
  .ant-col-md-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-md-order-15 {
    order: 15;
  }
  .ant-col-md-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-md-push-14 {
    left: 58.33333333%;
  }
  .ant-col-md-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-md-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-md-order-14 {
    order: 14;
  }
  .ant-col-md-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-md-push-13 {
    left: 54.16666667%;
  }
  .ant-col-md-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-md-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-md-order-13 {
    order: 13;
  }
  .ant-col-md-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-md-push-12 {
    left: 50%;
  }
  .ant-col-md-pull-12 {
    right: 50%;
  }
  .ant-col-md-offset-12 {
    margin-left: 50%;
  }
  .ant-col-md-order-12 {
    order: 12;
  }
  .ant-col-md-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-md-push-11 {
    left: 45.83333333%;
  }
  .ant-col-md-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-md-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-md-order-11 {
    order: 11;
  }
  .ant-col-md-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-md-push-10 {
    left: 41.66666667%;
  }
  .ant-col-md-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-md-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-md-order-10 {
    order: 10;
  }
  .ant-col-md-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-md-push-9 {
    left: 37.5%;
  }
  .ant-col-md-pull-9 {
    right: 37.5%;
  }
  .ant-col-md-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-md-order-9 {
    order: 9;
  }
  .ant-col-md-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-md-push-8 {
    left: 33.33333333%;
  }
  .ant-col-md-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-md-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-md-order-8 {
    order: 8;
  }
  .ant-col-md-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-md-push-7 {
    left: 29.16666667%;
  }
  .ant-col-md-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-md-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-md-order-7 {
    order: 7;
  }
  .ant-col-md-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-md-push-6 {
    left: 25%;
  }
  .ant-col-md-pull-6 {
    right: 25%;
  }
  .ant-col-md-offset-6 {
    margin-left: 25%;
  }
  .ant-col-md-order-6 {
    order: 6;
  }
  .ant-col-md-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-md-push-5 {
    left: 20.83333333%;
  }
  .ant-col-md-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-md-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-md-order-5 {
    order: 5;
  }
  .ant-col-md-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-md-push-4 {
    left: 16.66666667%;
  }
  .ant-col-md-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-md-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-md-order-4 {
    order: 4;
  }
  .ant-col-md-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-md-push-3 {
    left: 12.5%;
  }
  .ant-col-md-pull-3 {
    right: 12.5%;
  }
  .ant-col-md-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-md-order-3 {
    order: 3;
  }
  .ant-col-md-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-md-push-2 {
    left: 8.33333333%;
  }
  .ant-col-md-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-md-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-md-order-2 {
    order: 2;
  }
  .ant-col-md-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-md-push-1 {
    left: 4.16666667%;
  }
  .ant-col-md-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-md-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-md-order-1 {
    order: 1;
  }
  .ant-col-md-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-md-push-0 {
    left: auto;
  }
  .ant-col-md-pull-0 {
    right: auto;
  }
  .ant-col-md-offset-0 {
    margin-left: 0;
  }
  .ant-col-md-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-md-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-md-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-md-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-md-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-md-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-md-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-md-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-md-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-md-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-md-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-md-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-md-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-md-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-md-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-md-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-md-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-md-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-md-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-md-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-md-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-md-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-md-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-md-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-md-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-md-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-md-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-md-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-md-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-md-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-md-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-md-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-md-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-md-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-md-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-md-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-md-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-md-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-md-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-md-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-md-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-md-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-md-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-md-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-md-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-md-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-md-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-md-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-md-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-md-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-md-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-md-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-md-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-md-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-md-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-md-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-md-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-md-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-md-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-md-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 992px) {
  .ant-col-lg-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-lg-push-24 {
    left: 100%;
  }
  .ant-col-lg-pull-24 {
    right: 100%;
  }
  .ant-col-lg-offset-24 {
    margin-left: 100%;
  }
  .ant-col-lg-order-24 {
    order: 24;
  }
  .ant-col-lg-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-lg-push-23 {
    left: 95.83333333%;
  }
  .ant-col-lg-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-lg-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-lg-order-23 {
    order: 23;
  }
  .ant-col-lg-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-lg-push-22 {
    left: 91.66666667%;
  }
  .ant-col-lg-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-lg-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-lg-order-22 {
    order: 22;
  }
  .ant-col-lg-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-lg-push-21 {
    left: 87.5%;
  }
  .ant-col-lg-pull-21 {
    right: 87.5%;
  }
  .ant-col-lg-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-lg-order-21 {
    order: 21;
  }
  .ant-col-lg-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-lg-push-20 {
    left: 83.33333333%;
  }
  .ant-col-lg-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-lg-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-lg-order-20 {
    order: 20;
  }
  .ant-col-lg-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-lg-push-19 {
    left: 79.16666667%;
  }
  .ant-col-lg-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-lg-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-lg-order-19 {
    order: 19;
  }
  .ant-col-lg-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-lg-push-18 {
    left: 75%;
  }
  .ant-col-lg-pull-18 {
    right: 75%;
  }
  .ant-col-lg-offset-18 {
    margin-left: 75%;
  }
  .ant-col-lg-order-18 {
    order: 18;
  }
  .ant-col-lg-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-lg-push-17 {
    left: 70.83333333%;
  }
  .ant-col-lg-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-lg-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-lg-order-17 {
    order: 17;
  }
  .ant-col-lg-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-lg-push-16 {
    left: 66.66666667%;
  }
  .ant-col-lg-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-lg-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-lg-order-16 {
    order: 16;
  }
  .ant-col-lg-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-lg-push-15 {
    left: 62.5%;
  }
  .ant-col-lg-pull-15 {
    right: 62.5%;
  }
  .ant-col-lg-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-lg-order-15 {
    order: 15;
  }
  .ant-col-lg-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-lg-push-14 {
    left: 58.33333333%;
  }
  .ant-col-lg-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-lg-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-lg-order-14 {
    order: 14;
  }
  .ant-col-lg-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-lg-push-13 {
    left: 54.16666667%;
  }
  .ant-col-lg-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-lg-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-lg-order-13 {
    order: 13;
  }
  .ant-col-lg-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-lg-push-12 {
    left: 50%;
  }
  .ant-col-lg-pull-12 {
    right: 50%;
  }
  .ant-col-lg-offset-12 {
    margin-left: 50%;
  }
  .ant-col-lg-order-12 {
    order: 12;
  }
  .ant-col-lg-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-lg-push-11 {
    left: 45.83333333%;
  }
  .ant-col-lg-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-lg-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-lg-order-11 {
    order: 11;
  }
  .ant-col-lg-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-lg-push-10 {
    left: 41.66666667%;
  }
  .ant-col-lg-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-lg-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-lg-order-10 {
    order: 10;
  }
  .ant-col-lg-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-lg-push-9 {
    left: 37.5%;
  }
  .ant-col-lg-pull-9 {
    right: 37.5%;
  }
  .ant-col-lg-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-lg-order-9 {
    order: 9;
  }
  .ant-col-lg-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-lg-push-8 {
    left: 33.33333333%;
  }
  .ant-col-lg-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-lg-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-lg-order-8 {
    order: 8;
  }
  .ant-col-lg-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-lg-push-7 {
    left: 29.16666667%;
  }
  .ant-col-lg-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-lg-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-lg-order-7 {
    order: 7;
  }
  .ant-col-lg-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-lg-push-6 {
    left: 25%;
  }
  .ant-col-lg-pull-6 {
    right: 25%;
  }
  .ant-col-lg-offset-6 {
    margin-left: 25%;
  }
  .ant-col-lg-order-6 {
    order: 6;
  }
  .ant-col-lg-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-lg-push-5 {
    left: 20.83333333%;
  }
  .ant-col-lg-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-lg-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-lg-order-5 {
    order: 5;
  }
  .ant-col-lg-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-lg-push-4 {
    left: 16.66666667%;
  }
  .ant-col-lg-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-lg-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-lg-order-4 {
    order: 4;
  }
  .ant-col-lg-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-lg-push-3 {
    left: 12.5%;
  }
  .ant-col-lg-pull-3 {
    right: 12.5%;
  }
  .ant-col-lg-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-lg-order-3 {
    order: 3;
  }
  .ant-col-lg-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-lg-push-2 {
    left: 8.33333333%;
  }
  .ant-col-lg-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-lg-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-lg-order-2 {
    order: 2;
  }
  .ant-col-lg-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-lg-push-1 {
    left: 4.16666667%;
  }
  .ant-col-lg-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-lg-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-lg-order-1 {
    order: 1;
  }
  .ant-col-lg-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-lg-push-0 {
    left: auto;
  }
  .ant-col-lg-pull-0 {
    right: auto;
  }
  .ant-col-lg-offset-0 {
    margin-left: 0;
  }
  .ant-col-lg-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-lg-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-lg-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-lg-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-lg-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-lg-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-lg-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-lg-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-lg-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-lg-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-lg-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-lg-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-lg-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-lg-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-lg-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-lg-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-lg-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-lg-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-lg-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-lg-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-lg-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-lg-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-lg-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-lg-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-lg-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-lg-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-lg-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-lg-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-lg-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-lg-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-lg-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-lg-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-lg-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-lg-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-lg-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-lg-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-lg-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-lg-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-lg-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-lg-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 1200px) {
  .ant-col-xl-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-xl-push-24 {
    left: 100%;
  }
  .ant-col-xl-pull-24 {
    right: 100%;
  }
  .ant-col-xl-offset-24 {
    margin-left: 100%;
  }
  .ant-col-xl-order-24 {
    order: 24;
  }
  .ant-col-xl-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-xl-push-23 {
    left: 95.83333333%;
  }
  .ant-col-xl-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-xl-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-xl-order-23 {
    order: 23;
  }
  .ant-col-xl-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-xl-push-22 {
    left: 91.66666667%;
  }
  .ant-col-xl-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-xl-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-xl-order-22 {
    order: 22;
  }
  .ant-col-xl-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-xl-push-21 {
    left: 87.5%;
  }
  .ant-col-xl-pull-21 {
    right: 87.5%;
  }
  .ant-col-xl-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-xl-order-21 {
    order: 21;
  }
  .ant-col-xl-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-xl-push-20 {
    left: 83.33333333%;
  }
  .ant-col-xl-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-xl-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-xl-order-20 {
    order: 20;
  }
  .ant-col-xl-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-xl-push-19 {
    left: 79.16666667%;
  }
  .ant-col-xl-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-xl-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-xl-order-19 {
    order: 19;
  }
  .ant-col-xl-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-xl-push-18 {
    left: 75%;
  }
  .ant-col-xl-pull-18 {
    right: 75%;
  }
  .ant-col-xl-offset-18 {
    margin-left: 75%;
  }
  .ant-col-xl-order-18 {
    order: 18;
  }
  .ant-col-xl-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-xl-push-17 {
    left: 70.83333333%;
  }
  .ant-col-xl-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-xl-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-xl-order-17 {
    order: 17;
  }
  .ant-col-xl-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-xl-push-16 {
    left: 66.66666667%;
  }
  .ant-col-xl-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-xl-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-xl-order-16 {
    order: 16;
  }
  .ant-col-xl-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-xl-push-15 {
    left: 62.5%;
  }
  .ant-col-xl-pull-15 {
    right: 62.5%;
  }
  .ant-col-xl-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-xl-order-15 {
    order: 15;
  }
  .ant-col-xl-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-xl-push-14 {
    left: 58.33333333%;
  }
  .ant-col-xl-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-xl-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-xl-order-14 {
    order: 14;
  }
  .ant-col-xl-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-xl-push-13 {
    left: 54.16666667%;
  }
  .ant-col-xl-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-xl-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-xl-order-13 {
    order: 13;
  }
  .ant-col-xl-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-xl-push-12 {
    left: 50%;
  }
  .ant-col-xl-pull-12 {
    right: 50%;
  }
  .ant-col-xl-offset-12 {
    margin-left: 50%;
  }
  .ant-col-xl-order-12 {
    order: 12;
  }
  .ant-col-xl-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-xl-push-11 {
    left: 45.83333333%;
  }
  .ant-col-xl-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-xl-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-xl-order-11 {
    order: 11;
  }
  .ant-col-xl-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-xl-push-10 {
    left: 41.66666667%;
  }
  .ant-col-xl-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-xl-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-xl-order-10 {
    order: 10;
  }
  .ant-col-xl-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-xl-push-9 {
    left: 37.5%;
  }
  .ant-col-xl-pull-9 {
    right: 37.5%;
  }
  .ant-col-xl-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-xl-order-9 {
    order: 9;
  }
  .ant-col-xl-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-xl-push-8 {
    left: 33.33333333%;
  }
  .ant-col-xl-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-xl-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-xl-order-8 {
    order: 8;
  }
  .ant-col-xl-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-xl-push-7 {
    left: 29.16666667%;
  }
  .ant-col-xl-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-xl-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-xl-order-7 {
    order: 7;
  }
  .ant-col-xl-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-xl-push-6 {
    left: 25%;
  }
  .ant-col-xl-pull-6 {
    right: 25%;
  }
  .ant-col-xl-offset-6 {
    margin-left: 25%;
  }
  .ant-col-xl-order-6 {
    order: 6;
  }
  .ant-col-xl-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-xl-push-5 {
    left: 20.83333333%;
  }
  .ant-col-xl-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-xl-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-xl-order-5 {
    order: 5;
  }
  .ant-col-xl-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-xl-push-4 {
    left: 16.66666667%;
  }
  .ant-col-xl-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-xl-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-xl-order-4 {
    order: 4;
  }
  .ant-col-xl-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-xl-push-3 {
    left: 12.5%;
  }
  .ant-col-xl-pull-3 {
    right: 12.5%;
  }
  .ant-col-xl-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-xl-order-3 {
    order: 3;
  }
  .ant-col-xl-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-xl-push-2 {
    left: 8.33333333%;
  }
  .ant-col-xl-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-xl-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-xl-order-2 {
    order: 2;
  }
  .ant-col-xl-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-xl-push-1 {
    left: 4.16666667%;
  }
  .ant-col-xl-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-xl-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-xl-order-1 {
    order: 1;
  }
  .ant-col-xl-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-xl-push-0 {
    left: auto;
  }
  .ant-col-xl-pull-0 {
    right: auto;
  }
  .ant-col-xl-offset-0 {
    margin-left: 0;
  }
  .ant-col-xl-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xl-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-xl-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xl-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-xl-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-xl-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-xl-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-xl-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-xl-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-xl-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-xl-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-xl-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-xl-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-xl-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-xl-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-xl-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-xl-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-xl-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-xl-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-xl-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-xl-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-xl-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-xl-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-xl-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-xl-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-xl-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-xl-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-xl-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-xl-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-xl-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-xl-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-xl-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-xl-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-xl-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-xl-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-xl-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-xl-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-xl-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-xl-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-xl-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 1600px) {
  .ant-col-xxl-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-xxl-push-24 {
    left: 100%;
  }
  .ant-col-xxl-pull-24 {
    right: 100%;
  }
  .ant-col-xxl-offset-24 {
    margin-left: 100%;
  }
  .ant-col-xxl-order-24 {
    order: 24;
  }
  .ant-col-xxl-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-xxl-push-23 {
    left: 95.83333333%;
  }
  .ant-col-xxl-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-xxl-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-xxl-order-23 {
    order: 23;
  }
  .ant-col-xxl-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-xxl-push-22 {
    left: 91.66666667%;
  }
  .ant-col-xxl-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-xxl-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-xxl-order-22 {
    order: 22;
  }
  .ant-col-xxl-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-xxl-push-21 {
    left: 87.5%;
  }
  .ant-col-xxl-pull-21 {
    right: 87.5%;
  }
  .ant-col-xxl-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-xxl-order-21 {
    order: 21;
  }
  .ant-col-xxl-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-xxl-push-20 {
    left: 83.33333333%;
  }
  .ant-col-xxl-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-xxl-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-xxl-order-20 {
    order: 20;
  }
  .ant-col-xxl-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-xxl-push-19 {
    left: 79.16666667%;
  }
  .ant-col-xxl-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-xxl-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-xxl-order-19 {
    order: 19;
  }
  .ant-col-xxl-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-xxl-push-18 {
    left: 75%;
  }
  .ant-col-xxl-pull-18 {
    right: 75%;
  }
  .ant-col-xxl-offset-18 {
    margin-left: 75%;
  }
  .ant-col-xxl-order-18 {
    order: 18;
  }
  .ant-col-xxl-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-xxl-push-17 {
    left: 70.83333333%;
  }
  .ant-col-xxl-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-xxl-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-xxl-order-17 {
    order: 17;
  }
  .ant-col-xxl-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-xxl-push-16 {
    left: 66.66666667%;
  }
  .ant-col-xxl-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-xxl-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-xxl-order-16 {
    order: 16;
  }
  .ant-col-xxl-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-xxl-push-15 {
    left: 62.5%;
  }
  .ant-col-xxl-pull-15 {
    right: 62.5%;
  }
  .ant-col-xxl-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-xxl-order-15 {
    order: 15;
  }
  .ant-col-xxl-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-xxl-push-14 {
    left: 58.33333333%;
  }
  .ant-col-xxl-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-xxl-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-xxl-order-14 {
    order: 14;
  }
  .ant-col-xxl-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-xxl-push-13 {
    left: 54.16666667%;
  }
  .ant-col-xxl-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-xxl-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-xxl-order-13 {
    order: 13;
  }
  .ant-col-xxl-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-xxl-push-12 {
    left: 50%;
  }
  .ant-col-xxl-pull-12 {
    right: 50%;
  }
  .ant-col-xxl-offset-12 {
    margin-left: 50%;
  }
  .ant-col-xxl-order-12 {
    order: 12;
  }
  .ant-col-xxl-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-xxl-push-11 {
    left: 45.83333333%;
  }
  .ant-col-xxl-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-xxl-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-xxl-order-11 {
    order: 11;
  }
  .ant-col-xxl-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-xxl-push-10 {
    left: 41.66666667%;
  }
  .ant-col-xxl-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-xxl-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-xxl-order-10 {
    order: 10;
  }
  .ant-col-xxl-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-xxl-push-9 {
    left: 37.5%;
  }
  .ant-col-xxl-pull-9 {
    right: 37.5%;
  }
  .ant-col-xxl-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-xxl-order-9 {
    order: 9;
  }
  .ant-col-xxl-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-xxl-push-8 {
    left: 33.33333333%;
  }
  .ant-col-xxl-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-xxl-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-xxl-order-8 {
    order: 8;
  }
  .ant-col-xxl-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-xxl-push-7 {
    left: 29.16666667%;
  }
  .ant-col-xxl-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-xxl-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-xxl-order-7 {
    order: 7;
  }
  .ant-col-xxl-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-xxl-push-6 {
    left: 25%;
  }
  .ant-col-xxl-pull-6 {
    right: 25%;
  }
  .ant-col-xxl-offset-6 {
    margin-left: 25%;
  }
  .ant-col-xxl-order-6 {
    order: 6;
  }
  .ant-col-xxl-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-xxl-push-5 {
    left: 20.83333333%;
  }
  .ant-col-xxl-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-xxl-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-xxl-order-5 {
    order: 5;
  }
  .ant-col-xxl-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-xxl-push-4 {
    left: 16.66666667%;
  }
  .ant-col-xxl-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-xxl-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-xxl-order-4 {
    order: 4;
  }
  .ant-col-xxl-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-xxl-push-3 {
    left: 12.5%;
  }
  .ant-col-xxl-pull-3 {
    right: 12.5%;
  }
  .ant-col-xxl-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-xxl-order-3 {
    order: 3;
  }
  .ant-col-xxl-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-xxl-push-2 {
    left: 8.33333333%;
  }
  .ant-col-xxl-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-xxl-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-xxl-order-2 {
    order: 2;
  }
  .ant-col-xxl-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-xxl-push-1 {
    left: 4.16666667%;
  }
  .ant-col-xxl-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-xxl-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-xxl-order-1 {
    order: 1;
  }
  .ant-col-xxl-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-xxl-push-0 {
    left: auto;
  }
  .ant-col-xxl-pull-0 {
    right: auto;
  }
  .ant-col-xxl-offset-0 {
    margin-left: 0;
  }
  .ant-col-xxl-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xxl-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-xxl-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xxl-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-xxl-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-xxl-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-xxl-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-xxl-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-xxl-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-xxl-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-xxl-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-xxl-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-xxl-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-xxl-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-xxl-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-xxl-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-xxl-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-xxl-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-xxl-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-xxl-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-xxl-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-xxl-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-xxl-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-xxl-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-xxl-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-xxl-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-xxl-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-xxl-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-xxl-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-xxl-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-xxl-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-xxl-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-xxl-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-xxl-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-xxl-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-xxl-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-xxl-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-xxl-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-xxl-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-xxl-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
.ant-row-rtl {
  direction: rtl;
}
.ant-image {
  position: relative;
  display: inline-block;
}
.ant-image-img {
  width: 100%;
  height: auto;
  vertical-align: middle;
}
.ant-image-img-placeholder {
  background-color: #f5f5f5;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 30%;
}
.ant-image-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
}
.ant-image-mask-info {
  padding: 0 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-image-mask-info .anticon {
  margin-inline-end: 4px;
}
.ant-image-mask:hover {
  opacity: 1;
}
.ant-image-placeholder {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.ant-image-preview {
  pointer-events: none;
  height: 100%;
  text-align: center;
}
.ant-image-preview.ant-zoom-enter,
.ant-image-preview.ant-zoom-appear {
  transform: none;
  opacity: 0;
  animation-duration: 0.3s;
  user-select: none;
}
.ant-image-preview-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
}
.ant-image-preview-mask-hidden {
  display: none;
}
.ant-image-preview-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  outline: 0;
}
.ant-image-preview-body {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}
.ant-image-preview-img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  transform: scale3d(1, 1, 1);
  cursor: grab;
  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
  user-select: none;
  pointer-events: auto;
}
.ant-image-preview-img-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
}
.ant-image-preview-img-wrapper::before {
  display: inline-block;
  width: 1px;
  height: 50%;
  margin-right: -1px;
  content: '';
}
.ant-image-preview-moving .ant-image-preview-img {
  cursor: grabbing;
}
.ant-image-preview-moving .ant-image-preview-img-wrapper {
  transition-duration: 0s;
}
.ant-image-preview-wrap {
  z-index: 1080;
}
.ant-image-preview-operations-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1081;
  width: 100%;
}
.ant-image-preview-operations {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  font-feature-settings: 'tnum';
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  color: rgba(255, 255, 255, 0.85);
  list-style: none;
  background: rgba(0, 0, 0, 0.1);
  pointer-events: auto;
}
.ant-image-preview-operations-operation {
  margin-left: 12px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-image-preview-operations-operation:hover {
  background: rgba(0, 0, 0, 0.2);
}
.ant-image-preview-operations-operation-disabled {
  color: rgba(255, 255, 255, 0.25);
  pointer-events: none;
}
.ant-image-preview-operations-operation:last-of-type {
  margin-left: 0;
}
.ant-image-preview-operations-progress {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.ant-image-preview-operations-icon {
  font-size: 18px;
}
.ant-image-preview-switch-left,
.ant-image-preview-switch-right {
  position: fixed;
  top: 50%;
  right: 8px;
  z-index: 1081;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: rgba(255, 255, 255, 0.85);
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  transition: all 0.3s;
  pointer-events: auto;
}
.ant-image-preview-switch-left:hover,
.ant-image-preview-switch-right:hover {
  background: rgba(0, 0, 0, 0.2);
}
.ant-image-preview-switch-left-disabled,
.ant-image-preview-switch-right-disabled,
.ant-image-preview-switch-left-disabled:hover,
.ant-image-preview-switch-right-disabled:hover {
  color: rgba(255, 255, 255, 0.25);
  background: rgba(0, 0, 0, 0.1);
  cursor: not-allowed;
}
.ant-image-preview-switch-left-disabled > .anticon,
.ant-image-preview-switch-right-disabled > .anticon,
.ant-image-preview-switch-left-disabled:hover > .anticon,
.ant-image-preview-switch-right-disabled:hover > .anticon {
  cursor: not-allowed;
}
.ant-image-preview-switch-left > .anticon,
.ant-image-preview-switch-right > .anticon {
  font-size: 18px;
}
.ant-image-preview-switch-left {
  left: 8px;
}
.ant-image-preview-switch-right {
  right: 8px;
}
.ant-input-affix-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7.9px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
  display: inline-flex;
}
.ant-input-affix-wrapper::placeholder {
  color: #bfbfbf;
  user-select: none;
}
.ant-input-affix-wrapper:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-input-affix-wrapper:hover {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-input-affix-wrapper:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper-focused {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-input-affix-wrapper:focus,
.ant-input-rtl .ant-input-affix-wrapper-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input-affix-wrapper-disabled {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-affix-wrapper-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-input-affix-wrapper[disabled] {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-affix-wrapper[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-input-affix-wrapper-borderless,
.ant-input-affix-wrapper-borderless:hover,
.ant-input-affix-wrapper-borderless:focus,
.ant-input-affix-wrapper-borderless-focused,
.ant-input-affix-wrapper-borderless-disabled,
.ant-input-affix-wrapper-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
textarea.ant-input-affix-wrapper {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-input-affix-wrapper-lg {
  padding: 8.6px 11px;
  font-size: 16px;
}
.ant-input-affix-wrapper-sm {
  padding: 1.9px 7px;
}
.ant-input-affix-wrapper-rtl {
  direction: rtl;
}
.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  border-color: #462e61;
  border-right-width: 1px;
  z-index: 1;
}
.ant-input-rtl .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input-search-with-button .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  z-index: 0;
}
.ant-input-affix-wrapper-focused,
.ant-input-affix-wrapper:focus {
  z-index: 1;
}
.ant-input-affix-wrapper-disabled .ant-input[disabled] {
  background: rgba(255, 255, 255, 0);
}
.ant-input-affix-wrapper > .ant-input {
  font-size: inherit;
  border: none;
  outline: none;
}
.ant-input-affix-wrapper > .ant-input:focus {
  box-shadow: none !important;
}
.ant-input-affix-wrapper > .ant-input:not(textarea) {
  padding: 0;
}
.ant-input-affix-wrapper::before {
  display: inline-block;
  width: 0;
  visibility: hidden;
  content: '\\a0';
}
.ant-input-prefix,
.ant-input-suffix {
  display: flex;
  flex: none;
  align-items: center;
}
.ant-input-prefix > *:not(:last-child),
.ant-input-suffix > *:not(:last-child) {
  margin-right: 8px;
}
.ant-input-show-count-suffix {
  color: #595959;
}
.ant-input-show-count-has-suffix {
  margin-right: 2px;
}
.ant-input-prefix {
  margin-right: 4px;
}
.ant-input-suffix {
  margin-left: 4px;
}
.anticon.ant-input-clear-icon,
.ant-input-clear-icon {
  margin: 0;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  vertical-align: -1px;
  cursor: pointer;
  transition: color 0.3s;
}
.anticon.ant-input-clear-icon:hover,
.ant-input-clear-icon:hover {
  color: #595959;
}
.anticon.ant-input-clear-icon:active,
.ant-input-clear-icon:active {
  color: #545454;
}
.anticon.ant-input-clear-icon-hidden,
.ant-input-clear-icon-hidden {
  visibility: hidden;
}
.anticon.ant-input-clear-icon-has-suffix,
.ant-input-clear-icon-has-suffix {
  margin: 0 4px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn {
  padding: 0;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn .ant-input-clear-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}
.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input,
.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
  background: #fff;
  border-color: #f5222d;
}
.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus,
.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-focused {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-status-error .ant-input-prefix {
  color: #f5222d;
}
.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input,
.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
  background: #fff;
  border-color: #fa8c16;
}
.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus,
.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-focused {
  border-color: #ffa940;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-status-warning .ant-input-prefix {
  color: #fa8c16;
}
.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,
.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
  background: #fff;
  border-color: #f5222d;
}
.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-affix-wrapper-status-error .ant-input-prefix {
  color: #f5222d;
}
.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,
.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
  background: #fff;
  border-color: #fa8c16;
}
.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused {
  border-color: #ffa940;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-affix-wrapper-status-warning .ant-input-prefix {
  color: #fa8c16;
}
.ant-input-textarea-status-error.ant-input-textarea-has-feedback .ant-input,
.ant-input-textarea-status-warning.ant-input-textarea-has-feedback .ant-input,
.ant-input-textarea-status-success.ant-input-textarea-has-feedback .ant-input,
.ant-input-textarea-status-validating.ant-input-textarea-has-feedback .ant-input {
  padding-right: 24px;
}
.ant-input-group-wrapper-status-error .ant-input-group-addon {
  color: #f5222d;
  border-color: #f5222d;
}
.ant-input-group-wrapper-status-warning .ant-input-group-addon {
  color: #fa8c16;
  border-color: #fa8c16;
}
.ant-input {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7.9px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
}
.ant-input::placeholder {
  color: #bfbfbf;
  user-select: none;
}
.ant-input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-input:hover {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-input:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input:focus,
.ant-input-focused {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-input:focus,
.ant-input-rtl .ant-input-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input-disabled {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-input[disabled] {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-input-borderless,
.ant-input-borderless:hover,
.ant-input-borderless:focus,
.ant-input-borderless-focused,
.ant-input-borderless-disabled,
.ant-input-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
textarea.ant-input {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-input-lg {
  padding: 8.6px 11px;
  font-size: 16px;
}
.ant-input-sm {
  padding: 1.9px 7px;
}
.ant-input-rtl {
  direction: rtl;
}
.ant-input-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-input-group[class*='col-'] {
  float: none;
  padding-right: 0;
  padding-left: 0;
}
.ant-input-group > [class*='col-'] {
  padding-right: 8px;
}
.ant-input-group > [class*='col-']:last-child {
  padding-right: 0;
}
.ant-input-group-addon,
.ant-input-group-wrap,
.ant-input-group > .ant-input {
  display: table-cell;
}
.ant-input-group-addon:not(:first-child):not(:last-child),
.ant-input-group-wrap:not(:first-child):not(:last-child),
.ant-input-group > .ant-input:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.ant-input-group-addon,
.ant-input-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}
.ant-input-group-wrap > * {
  display: block !important;
}
.ant-input-group .ant-input {
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
}
.ant-input-group .ant-input:focus {
  z-index: 1;
  border-right-width: 1px;
}
.ant-input-group .ant-input:hover {
  z-index: 1;
  border-right-width: 1px;
}
.ant-input-search-with-button .ant-input-group .ant-input:hover {
  z-index: 0;
}
.ant-input-group-addon {
  position: relative;
  padding: 0 11px;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
}
.ant-input-group-addon .ant-select {
  margin: -8.9px -11px;
}
.ant-input-group-addon .ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  background-color: inherit;
  border: 1px solid transparent;
  box-shadow: none;
}
.ant-input-group-addon .ant-select-open .ant-select-selector,
.ant-input-group-addon .ant-select-focused .ant-select-selector {
  color: #351a55;
}
.ant-input-group-addon .ant-cascader-picker {
  margin: -9px -12px;
  background-color: transparent;
}
.ant-input-group-addon .ant-cascader-picker .ant-cascader-input {
  text-align: left;
  border: 0;
  box-shadow: none;
}
.ant-input-group > .ant-input:first-child,
.ant-input-group-addon:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-group > .ant-input:first-child .ant-select .ant-select-selector,
.ant-input-group-addon:first-child .ant-select .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-group-addon:first-child {
  border-right: 0;
}
.ant-input-group-addon:last-child {
  border-left: 0;
}
.ant-input-group > .ant-input:last-child,
.ant-input-group-addon:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-group > .ant-input:last-child .ant-select .ant-select-selector,
.ant-input-group-addon:last-child .ant-select .ant-select-selector {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-group-lg .ant-input,
.ant-input-group-lg > .ant-input-group-addon {
  padding: 8.6px 11px;
  font-size: 16px;
}
.ant-input-group-sm .ant-input,
.ant-input-group-sm > .ant-input-group-addon {
  padding: 1.9px 7px;
}
.ant-input-group-lg .ant-select-single .ant-select-selector {
  height: 40px;
}
.ant-input-group-sm .ant-select-single .ant-select-selector {
  height: 24px;
}
.ant-input-group .ant-input-affix-wrapper:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:last-child) {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.ant-input-group .ant-input-affix-wrapper:not(:first-child),
.ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-group.ant-input-group-compact {
  display: block;
}
.ant-input-group.ant-input-group-compact::before {
  display: table;
  content: '';
}
.ant-input-group.ant-input-group-compact::after {
  display: table;
  clear: both;
  content: '';
}
.ant-input-group.ant-input-group-compact::before {
  display: table;
  content: '';
}
.ant-input-group.ant-input-group-compact::after {
  display: table;
  clear: both;
  content: '';
}
.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child),
.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child),
.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child) {
  border-right-width: 1px;
}
.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):hover,
.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):hover,
.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):hover {
  z-index: 1;
}
.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):focus,
.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):focus,
.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):focus {
  z-index: 1;
}
.ant-input-group.ant-input-group-compact > * {
  display: inline-block;
  float: none;
  vertical-align: top;
  border-radius: 0;
}
.ant-input-group.ant-input-group-compact > .ant-input-affix-wrapper,
.ant-input-group.ant-input-group-compact > .ant-input-number-affix-wrapper,
.ant-input-group.ant-input-group-compact > .ant-picker-range {
  display: inline-flex;
}
.ant-input-group.ant-input-group-compact > *:not(:last-child) {
  margin-right: -1px;
  border-right-width: 1px;
}
.ant-input-group.ant-input-group-compact .ant-input {
  float: none;
}
.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector,
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,
.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input {
  border-right-width: 1px;
  border-radius: 0;
}
.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector:hover,
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:hover,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:hover,
.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:hover {
  z-index: 1;
}
.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector:focus,
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:focus,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:focus,
.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:focus {
  z-index: 1;
}
.ant-input-group.ant-input-group-compact > .ant-select-focused {
  z-index: 1;
}
.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-arrow {
  z-index: 1;
}
.ant-input-group.ant-input-group-compact > *:first-child,
.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selector,
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.ant-input-group.ant-input-group-compact > *:last-child,
.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selector,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input {
  border-right-width: 1px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input {
  vertical-align: top;
}
.ant-input-group.ant-input-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper {
  margin-left: -1px;
}
.ant-input-group.ant-input-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper .ant-input-affix-wrapper {
  border-radius: 0;
}
.ant-input-group.ant-input-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input-group-addon > .ant-input-search-button {
  border-radius: 0;
}
.ant-input-group.ant-input-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input {
  border-radius: 6px 0 0 6px;
}
.ant-input-group > .ant-input-rtl:first-child,
.ant-input-group-rtl .ant-input-group-addon:first-child {
  border-radius: 0 6px 6px 0;
}
.ant-input-group-rtl .ant-input-group-addon:first-child {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
}
.ant-input-group-rtl .ant-input-group-addon:last-child {
  border-right: 0;
  border-left: 1px solid #d9d9d9;
  border-radius: 6px 0 0 6px;
}
.ant-input-group-rtl.ant-input-group > .ant-input:last-child,
.ant-input-group-rtl.ant-input-group-addon:last-child {
  border-radius: 6px 0 0 6px;
}
.ant-input-group-rtl.ant-input-group .ant-input-affix-wrapper:not(:first-child) {
  border-radius: 6px 0 0 6px;
}
.ant-input-group-rtl.ant-input-group .ant-input-affix-wrapper:not(:last-child) {
  border-radius: 0 6px 6px 0;
}
.ant-input-group-rtl.ant-input-group.ant-input-group-compact > *:not(:last-child) {
  margin-right: 0;
  margin-left: -1px;
  border-left-width: 1px;
}
.ant-input-group-rtl.ant-input-group.ant-input-group-compact > *:first-child,
.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selector,
.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,
.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input {
  border-radius: 0 6px 6px 0;
}
.ant-input-group-rtl.ant-input-group.ant-input-group-compact > *:last-child,
.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selector,
.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,
.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,
.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input {
  border-left-width: 1px;
  border-radius: 6px 0 0 6px;
}
.ant-input-group.ant-input-group-compact .ant-input-group-wrapper-rtl + .ant-input-group-wrapper-rtl {
  margin-right: -1px;
  margin-left: 0;
}
.ant-input-group.ant-input-group-compact .ant-input-group-wrapper-rtl:not(:last-child).ant-input-search > .ant-input-group > .ant-input {
  border-radius: 0 6px 6px 0;
}
.ant-input-group > .ant-input-rtl:first-child {
  border-radius: 0 6px 6px 0;
}
.ant-input-group > .ant-input-rtl:last-child {
  border-radius: 6px 0 0 6px;
}
.ant-input-group-rtl .ant-input-group-addon:first-child {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
  border-radius: 0 6px 6px 0;
}
.ant-input-group-rtl .ant-input-group-addon:last-child {
  border-right: 0;
  border-left: 1px solid #d9d9d9;
  border-radius: 6px 0 0 6px;
}
.ant-input-group-wrapper {
  display: inline-block;
  width: 100%;
  text-align: start;
  vertical-align: top;
}
.ant-input-password-icon.anticon {
  color: #595959;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-input-password-icon.anticon:hover {
  color: rgba(0, 0, 0, 0.85);
}
.ant-input[type='color'] {
  height: 36px;
}
.ant-input[type='color'].ant-input-lg {
  height: 40px;
}
.ant-input[type='color'].ant-input-sm {
  height: 24px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.ant-input-textarea-show-count > .ant-input {
  height: 100%;
}
.ant-input-textarea-show-count::after {
  float: right;
  color: #595959;
  white-space: nowrap;
  content: attr(data-count);
  pointer-events: none;
}
.ant-input-textarea-show-count.ant-input-textarea-in-form-item::after {
  margin-bottom: -22px;
}
.ant-input-textarea-suffix {
  position: absolute;
  top: 0;
  right: 11px;
  bottom: 0;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  margin: auto;
}
.ant-input-compact-item:not(.ant-input-compact-last-item):not(.ant-input-compact-item-rtl) {
  margin-right: -1px;
}
.ant-input-compact-item:not(.ant-input-compact-last-item).ant-input-compact-item-rtl {
  margin-left: -1px;
}
.ant-input-compact-item:hover,
.ant-input-compact-item:focus,
.ant-input-compact-item:active {
  z-index: 2;
}
.ant-input-compact-item[disabled] {
  z-index: 0;
}
.ant-input-compact-item:not(.ant-input-compact-first-item):not(.ant-input-compact-last-item).ant-input {
  border-radius: 0;
}
.ant-input-compact-item.ant-input.ant-input-compact-first-item:not(.ant-input-compact-last-item):not(.ant-input-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-compact-item.ant-input.ant-input-compact-last-item:not(.ant-input-compact-first-item):not(.ant-input-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-compact-item.ant-input.ant-input-compact-item-rtl.ant-input-compact-first-item:not(.ant-input-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-compact-item.ant-input.ant-input-compact-item-rtl.ant-input-compact-last-item:not(.ant-input-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-search .ant-input:hover,
.ant-input-search .ant-input:focus {
  border-color: #462e61;
}
.ant-input-search .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary),
.ant-input-search .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary) {
  border-left-color: #462e61;
}
.ant-input-search .ant-input-affix-wrapper {
  border-radius: 0;
}
.ant-input-search .ant-input-lg {
  line-height: 1.2998;
}
.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
  left: -1px;
  padding: 0;
  border: 0;
}
.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 0 6px 6px 0;
}
.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button:not(.ant-btn-primary) {
  color: #595959;
}
.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button:not(.ant-btn-primary).ant-btn-loading::before {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.ant-input-search-button {
  height: 36px;
}
.ant-input-search-button:hover,
.ant-input-search-button:focus {
  z-index: 1;
}
.ant-input-search-large .ant-input-search-button {
  height: 40px;
}
.ant-input-search-small .ant-input-search-button {
  height: 24px;
}
.ant-input-search.ant-input-compact-item:not(.ant-input-compact-item-rtl):not(.ant-input-compact-last-item) .ant-input-group-addon .ant-input-search-button {
  margin-right: -1px;
  border-radius: 0;
}
.ant-input-search.ant-input-compact-item:not(.ant-input-compact-first-item) .ant-input,
.ant-input-search.ant-input-compact-item:not(.ant-input-compact-first-item) .ant-input-affix-wrapper {
  border-radius: 0;
}
.ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:hover,
.ant-input-search.ant-input-compact-item > .ant-input:hover,
.ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:hover,
.ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:focus,
.ant-input-search.ant-input-compact-item > .ant-input:focus,
.ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:focus,
.ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:active,
.ant-input-search.ant-input-compact-item > .ant-input:active,
.ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:active {
  z-index: 2;
}
.ant-input-search.ant-input-compact-item > .ant-input-affix-wrapper-focused {
  z-index: 2;
}
.ant-input-search.ant-input-compact-item-rtl:not(.ant-input-compact-last-item) .ant-input-group-addon:last-child .ant-input-search-button {
  margin-left: -1px;
  border-radius: 0;
}
.ant-input-group-wrapper-rtl {
  direction: rtl;
}
.ant-input-group-rtl {
  direction: rtl;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-rtl > input.ant-input {
  border: none;
  outline: none;
}
.ant-input-affix-wrapper-rtl .ant-input-prefix {
  margin: 0 0 0 4px;
}
.ant-input-affix-wrapper-rtl .ant-input-suffix {
  margin: 0 4px 0 0;
}
.ant-input-textarea-rtl {
  direction: rtl;
}
.ant-input-textarea-rtl.ant-input-textarea-show-count::after {
  text-align: left;
}
.ant-input-affix-wrapper-rtl .ant-input-clear-icon-has-suffix {
  margin-right: 0;
  margin-left: 4px;
}
.ant-input-affix-wrapper-rtl .ant-input-clear-icon {
  right: auto;
  left: 8px;
}
.ant-input-search-rtl {
  direction: rtl;
}
.ant-input-search-rtl .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary),
.ant-input-search-rtl .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary) {
  border-left-color: #d9d9d9;
}
.ant-input-search-rtl .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary):hover,
.ant-input-search-rtl .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary):hover {
  border-left-color: #462e61;
}
.ant-input-search-rtl > .ant-input-group > .ant-input-affix-wrapper:hover,
.ant-input-search-rtl > .ant-input-group > .ant-input-affix-wrapper-focused {
  border-right-color: #462e61;
}
.ant-input-search-rtl > .ant-input-group > .ant-input-group-addon:last-child {
  right: -1px;
  left: auto;
}
.ant-input-search-rtl > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {
  border-radius: 6px 0 0 6px;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ant-input {
    height: 36px;
  }
  .ant-input-lg {
    height: 40px;
  }
  .ant-input-sm {
    height: 24px;
  }
  .ant-input-affix-wrapper > input.ant-input {
    height: auto;
  }
}
.ant-input-number-affix-wrapper {
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7.9px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
  position: relative;
  display: inline-flex;
  width: 90px;
  padding: 0;
  padding-inline-start: 11px;
}
.ant-input-number-affix-wrapper::placeholder {
  color: #bfbfbf;
  user-select: none;
}
.ant-input-number-affix-wrapper:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-input-number-affix-wrapper:hover {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-input-number-affix-wrapper:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input-number-affix-wrapper:focus,
.ant-input-number-affix-wrapper-focused {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-input-number-affix-wrapper:focus,
.ant-input-rtl .ant-input-number-affix-wrapper-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input-number-affix-wrapper-disabled {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-number-affix-wrapper-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-input-number-affix-wrapper[disabled] {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-number-affix-wrapper[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-input-number-affix-wrapper-borderless,
.ant-input-number-affix-wrapper-borderless:hover,
.ant-input-number-affix-wrapper-borderless:focus,
.ant-input-number-affix-wrapper-borderless-focused,
.ant-input-number-affix-wrapper-borderless-disabled,
.ant-input-number-affix-wrapper-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
textarea.ant-input-number-affix-wrapper {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-input-number-affix-wrapper-lg {
  padding: 8.6px 11px;
  font-size: 16px;
}
.ant-input-number-affix-wrapper-sm {
  padding: 1.9px 7px;
}
.ant-input-number-affix-wrapper-rtl {
  direction: rtl;
}
.ant-input-number-affix-wrapper:not(.ant-input-number-affix-wrapper-disabled):hover {
  border-color: #462e61;
  border-right-width: 1px;
  z-index: 1;
}
.ant-input-rtl .ant-input-number-affix-wrapper:not(.ant-input-number-affix-wrapper-disabled):hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input-number-affix-wrapper-focused,
.ant-input-number-affix-wrapper:focus {
  z-index: 1;
}
.ant-input-number-affix-wrapper-disabled .ant-input-number[disabled] {
  background: transparent;
}
.ant-input-number-affix-wrapper > div.ant-input-number {
  width: 100%;
  border: none;
  outline: none;
}
.ant-input-number-affix-wrapper > div.ant-input-number.ant-input-number-focused {
  box-shadow: none !important;
}
.ant-input-number-affix-wrapper input.ant-input-number-input {
  padding: 0;
}
.ant-input-number-affix-wrapper::before {
  display: inline-block;
  width: 0;
  visibility: hidden;
  content: '\\a0';
}
.ant-input-number-affix-wrapper .ant-input-number-handler-wrap {
  z-index: 2;
}
.ant-input-number-prefix,
.ant-input-number-suffix {
  display: flex;
  flex: none;
  align-items: center;
  pointer-events: none;
}
.ant-input-number-prefix {
  margin-inline-end: 4px;
}
.ant-input-number-suffix {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  height: 100%;
  margin-right: 11px;
  margin-left: 4px;
}
.ant-input-number-group-wrapper .ant-input-number-affix-wrapper {
  width: 100%;
}
.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number,
.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover {
  background: #fff;
  border-color: #f5222d;
}
.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:focus,
.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number-focused {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-number-status-error .ant-input-number-prefix {
  color: #f5222d;
}
.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number,
.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover {
  background: #fff;
  border-color: #fa8c16;
}
.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:focus,
.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number-focused {
  border-color: #ffa940;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-number-status-warning .ant-input-number-prefix {
  color: #fa8c16;
}
.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper,
.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:hover {
  background: #fff;
  border-color: #f5222d;
}
.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:focus,
.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper-focused {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-number-affix-wrapper-status-error .ant-input-number-prefix {
  color: #f5222d;
}
.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper,
.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:hover {
  background: #fff;
  border-color: #fa8c16;
}
.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:focus,
.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper-focused {
  border-color: #ffa940;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-number-affix-wrapper-status-warning .ant-input-number-prefix {
  color: #fa8c16;
}
.ant-input-number-group-wrapper-status-error .ant-input-number-group-addon {
  color: #f5222d;
  border-color: #f5222d;
}
.ant-input-number-group-wrapper-status-warning .ant-input-number-group-addon {
  color: #fa8c16;
  border-color: #fa8c16;
}
.ant-input-number {
  box-sizing: border-box;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  width: 100%;
  min-width: 0;
  padding: 7.9px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  transition: all 0.3s;
  display: inline-block;
  width: 90px;
  margin: 0;
  padding: 0;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
.ant-input-number::placeholder {
  color: #bfbfbf;
  user-select: none;
}
.ant-input-number:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-input-number:hover {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-input-number:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input-number:focus,
.ant-input-number-focused {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-input-number:focus,
.ant-input-rtl .ant-input-number-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input-number-disabled {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-number-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-input-number[disabled] {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-number[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-input-number-borderless,
.ant-input-number-borderless:hover,
.ant-input-number-borderless:focus,
.ant-input-number-borderless-focused,
.ant-input-number-borderless-disabled,
.ant-input-number-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
textarea.ant-input-number {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-input-number-lg {
  padding: 8.6px 11px;
  font-size: 16px;
}
.ant-input-number-sm {
  padding: 1.9px 7px;
}
.ant-input-number-rtl {
  direction: rtl;
}
.ant-input-number-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-input-number-group[class*='col-'] {
  float: none;
  padding-right: 0;
  padding-left: 0;
}
.ant-input-number-group > [class*='col-'] {
  padding-right: 8px;
}
.ant-input-number-group > [class*='col-']:last-child {
  padding-right: 0;
}
.ant-input-number-group-addon,
.ant-input-number-group-wrap,
.ant-input-number-group > .ant-input-number {
  display: table-cell;
}
.ant-input-number-group-addon:not(:first-child):not(:last-child),
.ant-input-number-group-wrap:not(:first-child):not(:last-child),
.ant-input-number-group > .ant-input-number:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.ant-input-number-group-addon,
.ant-input-number-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}
.ant-input-number-group-wrap > * {
  display: block !important;
}
.ant-input-number-group .ant-input-number {
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
}
.ant-input-number-group .ant-input-number:focus {
  z-index: 1;
  border-right-width: 1px;
}
.ant-input-number-group .ant-input-number:hover {
  z-index: 1;
  border-right-width: 1px;
}
.ant-input-search-with-button .ant-input-number-group .ant-input-number:hover {
  z-index: 0;
}
.ant-input-number-group-addon {
  position: relative;
  padding: 0 11px;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
}
.ant-input-number-group-addon .ant-select {
  margin: -8.9px -11px;
}
.ant-input-number-group-addon .ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  background-color: inherit;
  border: 1px solid transparent;
  box-shadow: none;
}
.ant-input-number-group-addon .ant-select-open .ant-select-selector,
.ant-input-number-group-addon .ant-select-focused .ant-select-selector {
  color: #351a55;
}
.ant-input-number-group-addon .ant-cascader-picker {
  margin: -9px -12px;
  background-color: transparent;
}
.ant-input-number-group-addon .ant-cascader-picker .ant-cascader-input {
  text-align: left;
  border: 0;
  box-shadow: none;
}
.ant-input-number-group > .ant-input-number:first-child,
.ant-input-number-group-addon:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-number-group > .ant-input-number:first-child .ant-select .ant-select-selector,
.ant-input-number-group-addon:first-child .ant-select .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-number-group > .ant-input-number-affix-wrapper:not(:first-child) .ant-input-number {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-number-group > .ant-input-number-affix-wrapper:not(:last-child) .ant-input-number {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-number-group-addon:first-child {
  border-right: 0;
}
.ant-input-number-group-addon:last-child {
  border-left: 0;
}
.ant-input-number-group > .ant-input-number:last-child,
.ant-input-number-group-addon:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-number-group > .ant-input-number:last-child .ant-select .ant-select-selector,
.ant-input-number-group-addon:last-child .ant-select .ant-select-selector {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-number-group-lg .ant-input-number,
.ant-input-number-group-lg > .ant-input-number-group-addon {
  padding: 8.6px 11px;
  font-size: 16px;
}
.ant-input-number-group-sm .ant-input-number,
.ant-input-number-group-sm > .ant-input-number-group-addon {
  padding: 1.9px 7px;
}
.ant-input-number-group-lg .ant-select-single .ant-select-selector {
  height: 40px;
}
.ant-input-number-group-sm .ant-select-single .ant-select-selector {
  height: 24px;
}
.ant-input-number-group .ant-input-number-affix-wrapper:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-search .ant-input-number-group .ant-input-number-affix-wrapper:not(:last-child) {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.ant-input-number-group .ant-input-number-affix-wrapper:not(:first-child),
.ant-input-search .ant-input-number-group .ant-input-number-affix-wrapper:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-number-group.ant-input-number-group-compact {
  display: block;
}
.ant-input-number-group.ant-input-number-group-compact::before {
  display: table;
  content: '';
}
.ant-input-number-group.ant-input-number-group-compact::after {
  display: table;
  clear: both;
  content: '';
}
.ant-input-number-group.ant-input-number-group-compact::before {
  display: table;
  content: '';
}
.ant-input-number-group.ant-input-number-group-compact::after {
  display: table;
  clear: both;
  content: '';
}
.ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child),
.ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child),
.ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child) {
  border-right-width: 1px;
}
.ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child):hover,
.ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child):hover,
.ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child):hover {
  z-index: 1;
}
.ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child):focus,
.ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child):focus,
.ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child):focus {
  z-index: 1;
}
.ant-input-number-group.ant-input-number-group-compact > * {
  display: inline-block;
  float: none;
  vertical-align: top;
  border-radius: 0;
}
.ant-input-number-group.ant-input-number-group-compact > .ant-input-number-affix-wrapper,
.ant-input-number-group.ant-input-number-group-compact > .ant-input-number-number-affix-wrapper,
.ant-input-number-group.ant-input-number-group-compact > .ant-picker-range {
  display: inline-flex;
}
.ant-input-number-group.ant-input-number-group-compact > *:not(:last-child) {
  margin-right: -1px;
  border-right-width: 1px;
}
.ant-input-number-group.ant-input-number-group-compact .ant-input-number {
  float: none;
}
.ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector,
.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input,
.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input,
.ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input {
  border-right-width: 1px;
  border-radius: 0;
}
.ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector:hover,
.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input:hover,
.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input:hover,
.ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input:hover {
  z-index: 1;
}
.ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector:focus,
.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input:focus,
.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input:focus,
.ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input:focus {
  z-index: 1;
}
.ant-input-number-group.ant-input-number-group-compact > .ant-select-focused {
  z-index: 1;
}
.ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-arrow {
  z-index: 1;
}
.ant-input-number-group.ant-input-number-group-compact > *:first-child,
.ant-input-number-group.ant-input-number-group-compact > .ant-select:first-child > .ant-select-selector,
.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete:first-child .ant-input,
.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:first-child .ant-input {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.ant-input-number-group.ant-input-number-group-compact > *:last-child,
.ant-input-number-group.ant-input-number-group-compact > .ant-select:last-child > .ant-select-selector,
.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:last-child .ant-input,
.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker-focused:last-child .ant-input {
  border-right-width: 1px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input {
  vertical-align: top;
}
.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper {
  margin-left: -1px;
}
.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper .ant-input-affix-wrapper {
  border-radius: 0;
}
.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input-group-addon > .ant-input-search-button {
  border-radius: 0;
}
.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input {
  border-radius: 6px 0 0 6px;
}
.ant-input-number-group > .ant-input-number-rtl:first-child,
.ant-input-number-group-rtl .ant-input-number-group-addon:first-child {
  border-radius: 0 6px 6px 0;
}
.ant-input-number-group-rtl .ant-input-number-group-addon:first-child {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
}
.ant-input-number-group-rtl .ant-input-number-group-addon:last-child {
  border-right: 0;
  border-left: 1px solid #d9d9d9;
  border-radius: 6px 0 0 6px;
}
.ant-input-number-group-rtl.ant-input-number-group > .ant-input-number:last-child,
.ant-input-number-group-rtl.ant-input-number-group-addon:last-child {
  border-radius: 6px 0 0 6px;
}
.ant-input-number-group-rtl.ant-input-number-group .ant-input-number-affix-wrapper:not(:first-child) {
  border-radius: 6px 0 0 6px;
}
.ant-input-number-group-rtl.ant-input-number-group .ant-input-number-affix-wrapper:not(:last-child) {
  border-radius: 0 6px 6px 0;
}
.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > *:not(:last-child) {
  margin-right: 0;
  margin-left: -1px;
  border-left-width: 1px;
}
.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > *:first-child,
.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-select:first-child > .ant-select-selector,
.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete:first-child .ant-input,
.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:first-child .ant-input {
  border-radius: 0 6px 6px 0;
}
.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > *:last-child,
.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-select:last-child > .ant-select-selector,
.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete:last-child .ant-input,
.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:last-child .ant-input,
.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker-focused:last-child .ant-input {
  border-left-width: 1px;
  border-radius: 6px 0 0 6px;
}
.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper-rtl + .ant-input-group-wrapper-rtl {
  margin-right: -1px;
  margin-left: 0;
}
.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper-rtl:not(:last-child).ant-input-search > .ant-input-group > .ant-input {
  border-radius: 0 6px 6px 0;
}
.ant-input-number-group > .ant-input-number-rtl:first-child {
  border-radius: 0 6px 6px 0;
}
.ant-input-number-group > .ant-input-number-rtl:last-child {
  border-radius: 6px 0 0 6px;
}
.ant-input-number-group-rtl .ant-input-number-group-addon:first-child {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
  border-radius: 0 6px 6px 0;
}
.ant-input-number-group-rtl .ant-input-number-group-addon:last-child {
  border-right: 0;
  border-left: 1px solid #d9d9d9;
  border-radius: 6px 0 0 6px;
}
.ant-input-number-group-wrapper {
  display: inline-block;
  text-align: start;
  vertical-align: top;
}
.ant-input-number-handler {
  position: relative;
  display: block;
  width: 100%;
  height: 50%;
  overflow: hidden;
  color: #595959;
  font-weight: bold;
  line-height: 0;
  text-align: center;
  border-left: 1px solid #d9d9d9;
  transition: all 0.1s linear;
}
.ant-input-number-handler:active {
  background: #f4f4f4;
}
.ant-input-number-handler:hover .ant-input-number-handler-up-inner,
.ant-input-number-handler:hover .ant-input-number-handler-down-inner {
  color: #462e61;
}
.ant-input-number-handler-up-inner,
.ant-input-number-handler-down-inner {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  right: 4px;
  width: 12px;
  height: 12px;
  color: #595959;
  line-height: 12px;
  transition: all 0.1s linear;
  user-select: none;
}
.ant-input-number-handler-up-inner > *,
.ant-input-number-handler-down-inner > * {
  line-height: 1;
}
.ant-input-number-handler-up-inner svg,
.ant-input-number-handler-down-inner svg {
  display: inline-block;
}
.ant-input-number-handler-up-inner::before,
.ant-input-number-handler-down-inner::before {
  display: none;
}
.ant-input-number-handler-up-inner .ant-input-number-handler-up-inner-icon,
.ant-input-number-handler-up-inner .ant-input-number-handler-down-inner-icon,
.ant-input-number-handler-down-inner .ant-input-number-handler-up-inner-icon,
.ant-input-number-handler-down-inner .ant-input-number-handler-down-inner-icon {
  display: block;
}
.ant-input-number:hover {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-number:hover + .ant-form-item-children-icon {
  opacity: 0;
  transition: opacity 0.24s linear 0.24s;
}
.ant-input-number-focused {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-input-number-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-input-number-disabled {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-number-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-input-number-disabled .ant-input-number-input {
  cursor: not-allowed;
}
.ant-input-number-disabled .ant-input-number-handler-wrap {
  display: none;
}
.ant-input-number-readonly .ant-input-number-handler-wrap {
  display: none;
}
.ant-input-number-input {
  width: 100%;
  height: 34px;
  padding: 0 11px;
  text-align: left;
  background-color: transparent;
  border: 0;
  border-radius: 6px;
  outline: 0;
  transition: all 0.3s linear;
  appearance: textfield !important;
}
.ant-input-number-input::placeholder {
  color: #bfbfbf;
  user-select: none;
}
.ant-input-number-input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-input-number-input[type='number']::-webkit-inner-spin-button,
.ant-input-number-input[type='number']::-webkit-outer-spin-button {
  margin: 0;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-appearance: none;
  appearance: none;
}
.ant-input-number-lg {
  padding: 0;
  font-size: 16px;
}
.ant-input-number-lg input {
  height: 38px;
}
.ant-input-number-sm {
  padding: 0;
}
.ant-input-number-sm input {
  height: 22px;
  padding: 0 7px;
}
.ant-input-number-handler-wrap {
  position: absolute;
  top: 0;
  right: 0;
  width: 22px;
  height: 100%;
  background: #fff;
  border-radius: 0 6px 6px 0;
  opacity: 0;
  transition: opacity 0.24s linear 0.1s;
}
.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner,
.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  margin-right: 0;
  font-size: 7px;
}
.ant-input-number-borderless .ant-input-number-handler-wrap {
  border-left-width: 0;
}
.ant-input-number-handler-wrap:hover .ant-input-number-handler {
  height: 40%;
}
.ant-input-number:hover .ant-input-number-handler-wrap,
.ant-input-number-focused .ant-input-number-handler-wrap {
  opacity: 1;
}
.ant-input-number-handler-up {
  border-top-right-radius: 6px;
  cursor: pointer;
}
.ant-input-number-handler-up-inner {
  top: 50%;
  margin-top: -5px;
  text-align: center;
}
.ant-input-number-handler-up:hover {
  height: 60% !important;
}
.ant-input-number-handler-down {
  top: 0;
  border-top: 1px solid #d9d9d9;
  border-bottom-right-radius: 6px;
  cursor: pointer;
}
.ant-input-number-handler-down-inner {
  top: 50%;
  text-align: center;
  transform: translateY(-50%);
}
.ant-input-number-handler-down:hover {
  height: 60% !important;
}
.ant-input-number-borderless .ant-input-number-handler-down {
  border-top-width: 0;
}
.ant-input-number:hover:not(.ant-input-number-borderless) .ant-input-number-handler-down,
.ant-input-number-focused:not(.ant-input-number-borderless) .ant-input-number-handler-down {
  border-top: 1px solid #d9d9d9;
}
.ant-input-number-handler-up-disabled,
.ant-input-number-handler-down-disabled {
  cursor: not-allowed;
}
.ant-input-number-handler-up-disabled:hover .ant-input-number-handler-up-inner,
.ant-input-number-handler-down-disabled:hover .ant-input-number-handler-down-inner {
  color: rgba(0, 0, 0, 0.25);
}
.ant-input-number-borderless {
  box-shadow: none;
}
.ant-input-number-out-of-range input {
  color: #f5222d;
}
.ant-input-number-compact-item:not(.ant-input-number-compact-last-item):not(.ant-input-number-compact-item-rtl) {
  margin-right: -1px;
}
.ant-input-number-compact-item:not(.ant-input-number-compact-last-item).ant-input-number-compact-item-rtl {
  margin-left: -1px;
}
.ant-input-number-compact-item:hover,
.ant-input-number-compact-item:focus,
.ant-input-number-compact-item:active {
  z-index: 2;
}
.ant-input-number-compact-item.ant-input-number-focused {
  z-index: 2;
}
.ant-input-number-compact-item[disabled] {
  z-index: 0;
}
.ant-input-number-compact-item:not(.ant-input-number-compact-first-item):not(.ant-input-number-compact-last-item).ant-input-number {
  border-radius: 0;
}
.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-first-item:not(.ant-input-number-compact-last-item):not(.ant-input-number-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-last-item:not(.ant-input-number-compact-first-item):not(.ant-input-number-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-item-rtl.ant-input-number-compact-first-item:not(.ant-input-number-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-item-rtl.ant-input-number-compact-last-item:not(.ant-input-number-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-number-rtl {
  direction: rtl;
}
.ant-input-number-rtl .ant-input-number-handler {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
}
.ant-input-number-rtl .ant-input-number-handler-wrap {
  right: auto;
  left: 0;
}
.ant-input-number-rtl.ant-input-number-borderless .ant-input-number-handler-wrap {
  border-right-width: 0;
}
.ant-input-number-rtl .ant-input-number-handler-up {
  border-top-right-radius: 0;
}
.ant-input-number-rtl .ant-input-number-handler-down {
  border-bottom-right-radius: 0;
}
.ant-input-number-rtl .ant-input-number-input {
  direction: ltr;
  text-align: right;
}
.ant-layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  /* fix firefox can't set height smaller than content on flex item */
  min-height: 0;
  background: #f5f5f5;
}
.ant-layout,
.ant-layout * {
  box-sizing: border-box;
}
.ant-layout.ant-layout-has-sider {
  flex-direction: row;
}
.ant-layout.ant-layout-has-sider > .ant-layout,
.ant-layout.ant-layout-has-sider > .ant-layout-content {
  width: 0;
}
.ant-layout-header,
.ant-layout-footer {
  flex: 0 0 auto;
}
.ant-layout-header {
  height: 72px;
  padding: 0 32px;
  color: #545454;
  line-height: 72px;
  background: #fefefe;
}
.ant-layout-footer {
  padding: 14px 32px;
  color: #545454;
  font-size: 14px;
  background: #fffffe;
}
.ant-layout-content {
  flex: auto;
  /* fix firefox can't set height smaller than content on flex item */
  min-height: 0;
}
.ant-layout-sider {
  position: relative;
  /* fix firefox can't set width smaller than content on flex item */
  min-width: 0;
  background: var(--app-primary-color);
  transition: all 0.2s;
}
.ant-layout-sider-children {
  height: 100%;
  margin-top: -0.1px;
  padding-top: 0.1px;
}
.ant-layout-sider-children .ant-menu.ant-menu-inline-collapsed {
  width: auto;
}
.ant-layout-sider-has-trigger {
  padding-bottom: 30px;
}
.ant-layout-sider-right {
  order: 1;
}
.ant-layout-sider-trigger {
  position: fixed;
  bottom: 0;
  z-index: 1;
  height: 30px;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
  background: #002140;
  cursor: pointer;
  transition: all 0.2s;
}
.ant-layout-sider-zero-width > * {
  overflow: hidden;
}
.ant-layout-sider-zero-width-trigger {
  position: absolute;
  top: 72px;
  right: -36px;
  z-index: 1;
  width: 36px;
  height: 28px;
  color: #ffffff;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  background: var(--app-primary-color);
  border-radius: 0 6px 6px 0;
  cursor: pointer;
  transition: background 0.3s ease;
}
.ant-layout-sider-zero-width-trigger::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  transition: all 0.3s;
  content: '';
}
.ant-layout-sider-zero-width-trigger:hover::after {
  background: rgba(255, 255, 255, 0.1);
}
.ant-layout-sider-zero-width-trigger-right {
  left: -36px;
  border-radius: 6px 0 0 6px;
}
.ant-layout-sider-light {
  background: #fff;
}
.ant-layout-sider-light .ant-layout-sider-trigger {
  color: #545454;
  background: #fff;
}
.ant-layout-sider-light .ant-layout-sider-zero-width-trigger {
  color: #545454;
  background: #fff;
}
.ant-layout-rtl {
  direction: rtl;
}
.ant-list {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
}
.ant-list * {
  outline: none;
}
.ant-list-pagination {
  margin-top: 24px;
  text-align: right;
}
.ant-list-pagination .ant-pagination-options {
  text-align: left;
}
.ant-list-more {
  margin-top: 12px;
  text-align: center;
}
.ant-list-more button {
  padding-right: 32px;
  padding-left: 32px;
}
.ant-list-spin {
  min-height: 40px;
  text-align: center;
}
.ant-list-empty-text {
  padding: 16px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  text-align: center;
}
.ant-list-items {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  color: #545454;
}
.ant-list-item-meta {
  display: flex;
  flex: 1;
  align-items: flex-start;
  max-width: 100%;
}
.ant-list-item-meta-avatar {
  margin-right: 16px;
}
.ant-list-item-meta-content {
  flex: 1 0;
  width: 0;
  color: #545454;
}
.ant-list-item-meta-title {
  margin-bottom: 4px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
}
.ant-list-item-meta-title > a {
  color: #545454;
  transition: all 0.3s;
}
.ant-list-item-meta-title > a:hover {
  color: #351a55;
}
.ant-list-item-meta-description {
  color: #595959;
  font-size: 14px;
  line-height: 1.3;
}
.ant-list-item-action {
  flex: 0 0 auto;
  margin-left: 48px;
  padding: 0;
  font-size: 0;
  list-style: none;
}
.ant-list-item-action > li {
  position: relative;
  display: inline-block;
  padding: 0 8px;
  color: #595959;
  font-size: 14px;
  line-height: 1.3;
  text-align: center;
}
.ant-list-item-action > li:first-child {
  padding-left: 0;
}
.ant-list-item-action-split {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 14px;
  margin-top: -7px;
  background-color: #e8e8e8;
}
.ant-list-header {
  background: transparent;
}
.ant-list-footer {
  background: transparent;
}
.ant-list-header,
.ant-list-footer {
  padding-top: 12px;
  padding-bottom: 12px;
}
.ant-list-empty {
  padding: 16px 0;
  color: #595959;
  font-size: 12px;
  text-align: center;
}
.ant-list-split .ant-list-item {
  border-bottom: 1px solid #e8e8e8;
}
.ant-list-split .ant-list-item:last-child {
  border-bottom: none;
}
.ant-list-split .ant-list-header {
  border-bottom: 1px solid #e8e8e8;
}
.ant-list-split.ant-list-empty .ant-list-footer {
  border-top: 1px solid #e8e8e8;
}
.ant-list-loading .ant-list-spin-nested-loading {
  min-height: 32px;
}
.ant-list-split.ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {
  border-bottom: 1px solid #e8e8e8;
}
.ant-list-lg .ant-list-item {
  padding: 16px 24px;
}
.ant-list-sm .ant-list-item {
  padding: 8px 16px;
}
.ant-list-vertical .ant-list-item {
  align-items: initial;
}
.ant-list-vertical .ant-list-item-main {
  display: block;
  flex: 1;
}
.ant-list-vertical .ant-list-item-extra {
  margin-left: 40px;
}
.ant-list-vertical .ant-list-item-meta {
  margin-bottom: 16px;
}
.ant-list-vertical .ant-list-item-meta-title {
  margin-bottom: 12px;
  color: #535353;
  font-size: 16px;
  line-height: 24px;
}
.ant-list-vertical .ant-list-item-action {
  margin-top: 16px;
  margin-left: auto;
}
.ant-list-vertical .ant-list-item-action > li {
  padding: 0 16px;
}
.ant-list-vertical .ant-list-item-action > li:first-child {
  padding-left: 0;
}
.ant-list-grid .ant-col > .ant-list-item {
  display: block;
  max-width: 100%;
  margin-bottom: 16px;
  padding-top: 0;
  padding-bottom: 0;
  border-bottom: none;
}
.ant-list-item-no-flex {
  display: block;
}
.ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {
  float: right;
}
.ant-list-bordered {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
.ant-list-bordered .ant-list-header {
  padding-right: 24px;
  padding-left: 24px;
}
.ant-list-bordered .ant-list-footer {
  padding-right: 24px;
  padding-left: 24px;
}
.ant-list-bordered .ant-list-item {
  padding-right: 24px;
  padding-left: 24px;
}
.ant-list-bordered .ant-list-pagination {
  margin: 16px 24px;
}
.ant-list-bordered.ant-list-sm .ant-list-item {
  padding: 8px 16px;
}
.ant-list-bordered.ant-list-sm .ant-list-header,
.ant-list-bordered.ant-list-sm .ant-list-footer {
  padding: 8px 16px;
}
.ant-list-bordered.ant-list-lg .ant-list-item {
  padding: 16px 24px;
}
.ant-list-bordered.ant-list-lg .ant-list-header,
.ant-list-bordered.ant-list-lg .ant-list-footer {
  padding: 16px 24px;
}
@media screen and (max-width: 768px) {
  .ant-list-item-action {
    margin-left: 24px;
  }
  .ant-list-vertical .ant-list-item-extra {
    margin-left: 24px;
  }
}
@media screen and (max-width: 576px) {
  .ant-list-item {
    flex-wrap: wrap;
  }
  .ant-list-item-action {
    margin-left: 12px;
  }
  .ant-list-vertical .ant-list-item {
    flex-wrap: wrap-reverse;
  }
  .ant-list-vertical .ant-list-item-main {
    min-width: 220px;
  }
  .ant-list-vertical .ant-list-item-extra {
    margin: auto auto 16px;
  }
}
.ant-list-rtl {
  direction: rtl;
  text-align: right;
}
.ant-list-rtl .ReactVirtualized__List .ant-list-item {
  direction: rtl;
}
.ant-list-rtl .ant-list-pagination {
  text-align: left;
}
.ant-list-rtl .ant-list-item-meta-avatar {
  margin-right: 0;
  margin-left: 16px;
}
.ant-list-rtl .ant-list-item-action {
  margin-right: 48px;
  margin-left: 0;
}
.ant-list.ant-list-rtl .ant-list-item-action > li:first-child {
  padding-right: 0;
  padding-left: 16px;
}
.ant-list-rtl .ant-list-item-action-split {
  right: auto;
  left: 0;
}
.ant-list-rtl.ant-list-vertical .ant-list-item-extra {
  margin-right: 40px;
  margin-left: 0;
}
.ant-list-rtl.ant-list-vertical .ant-list-item-action {
  margin-right: auto;
}
.ant-list-rtl .ant-list-vertical .ant-list-item-action > li:first-child {
  padding-right: 0;
  padding-left: 16px;
}
.ant-list-rtl .ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {
  float: left;
}
@media screen and (max-width: 768px) {
  .ant-list-rtl .ant-list-item-action {
    margin-right: 24px;
    margin-left: 0;
  }
  .ant-list-rtl .ant-list-vertical .ant-list-item-extra {
    margin-right: 24px;
    margin-left: 0;
  }
}
@media screen and (max-width: 576px) {
  .ant-list-rtl .ant-list-item-action {
    margin-right: 22px;
    margin-left: 0;
  }
  .ant-list-rtl.ant-list-vertical .ant-list-item-extra {
    margin: auto auto 16px;
  }
}
.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions,
.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:hover {
  background: #fff;
  border-color: #f5222d;
}
.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:focus,
.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions-focused {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-mentions-status-error .ant-input-prefix {
  color: #f5222d;
}
.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions,
.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:hover {
  background: #fff;
  border-color: #fa8c16;
}
.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:focus,
.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions-focused {
  border-color: #ffa940;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-mentions-status-warning .ant-input-prefix {
  color: #fa8c16;
}
.ant-mentions {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  width: 100%;
  min-width: 0;
  padding: 7.9px 11px;
  color: #545454;
  font-size: 14px;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
  position: relative;
  display: inline-block;
  height: auto;
  padding: 0;
  overflow: hidden;
  line-height: 1.3;
  white-space: pre-wrap;
  vertical-align: bottom;
}
.ant-mentions::placeholder {
  color: #bfbfbf;
  user-select: none;
}
.ant-mentions:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-mentions:hover {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-mentions:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-mentions:focus,
.ant-mentions-focused {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-mentions:focus,
.ant-input-rtl .ant-mentions-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-mentions-disabled {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-mentions-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-mentions[disabled] {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-mentions[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-mentions-borderless,
.ant-mentions-borderless:hover,
.ant-mentions-borderless:focus,
.ant-mentions-borderless-focused,
.ant-mentions-borderless-disabled,
.ant-mentions-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
textarea.ant-mentions {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-mentions-lg {
  padding: 8.6px 11px;
  font-size: 16px;
}
.ant-mentions-sm {
  padding: 1.9px 7px;
}
.ant-mentions-rtl {
  direction: rtl;
}
.ant-mentions-disabled > textarea {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-mentions-disabled > textarea:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-mentions-focused {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-mentions-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-mentions > textarea,
.ant-mentions-measure {
  min-height: 34px;
  margin: 0;
  padding: 7.9px 11px;
  overflow: inherit;
  overflow-x: hidden;
  overflow-y: auto;
  /* stylelint-disable declaration-block-no-redundant-longhand-properties */
  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;
  font-style: inherit;
  font-variant: inherit;
  font-size-adjust: inherit;
  font-stretch: inherit;
  line-height: inherit;
  /* stylelint-enable declaration-block-no-redundant-longhand-properties */
  direction: inherit;
  letter-spacing: inherit;
  white-space: inherit;
  text-align: inherit;
  vertical-align: top;
  word-wrap: break-word;
  word-break: inherit;
  tab-size: inherit;
}
.ant-mentions > textarea {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
}
.ant-mentions > textarea::placeholder {
  color: #bfbfbf;
  user-select: none;
}
.ant-mentions > textarea:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-mentions-measure {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  color: transparent;
  pointer-events: none;
}
.ant-mentions-measure > span {
  display: inline-block;
  min-height: 1em;
}
.ant-mentions-dropdown {
  margin: 0;
  padding: 0;
  color: #545454;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  box-sizing: border-box;
  font-size: 14px;
  font-variant: initial;
  background-color: #fff;
  border-radius: 6px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.ant-mentions-dropdown-hidden {
  display: none;
}
.ant-mentions-dropdown-menu {
  max-height: 250px;
  margin-bottom: 0;
  padding-left: 0;
  overflow: auto;
  list-style: none;
  outline: none;
}
.ant-mentions-dropdown-menu-item {
  position: relative;
  display: block;
  min-width: 100px;
  padding: 5px 12px;
  overflow: hidden;
  color: #545454;
  font-weight: normal;
  line-height: 1.3;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background 0.3s ease;
}
.ant-mentions-dropdown-menu-item:hover {
  background-color: #f5f5f5;
}
.ant-mentions-dropdown-menu-item:first-child {
  border-radius: 6px 6px 0 0;
}
.ant-mentions-dropdown-menu-item:last-child {
  border-radius: 0 0 6px 6px;
}
.ant-mentions-dropdown-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-mentions-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}
.ant-mentions-dropdown-menu-item-selected {
  color: #545454;
  font-weight: 600;
  background-color: #fafafa;
}
.ant-mentions-dropdown-menu-item-active {
  background-color: #f5f5f5;
}
.ant-mentions-suffix {
  position: absolute;
  top: 0;
  right: 11px;
  bottom: 0;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  margin: auto;
}
.ant-mentions-rtl {
  direction: rtl;
}
.ant-menu-item-danger.ant-menu-item {
  color: #f5222d;
}
.ant-menu-item-danger.ant-menu-item:hover,
.ant-menu-item-danger.ant-menu-item-active {
  color: #f5222d;
}
.ant-menu-item-danger.ant-menu-item:active {
  background: #fff1f0;
}
.ant-menu-item-danger.ant-menu-item-selected {
  color: #f5222d;
}
.ant-menu-item-danger.ant-menu-item-selected > a,
.ant-menu-item-danger.ant-menu-item-selected > a:hover {
  color: #f5222d;
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-danger.ant-menu-item-selected {
  background-color: #fff1f0;
}
.ant-menu-inline .ant-menu-item-danger.ant-menu-item::after {
  border-right-color: #f5222d;
}
.ant-menu-dark .ant-menu-item-danger.ant-menu-item,
.ant-menu-dark .ant-menu-item-danger.ant-menu-item:hover,
.ant-menu-dark .ant-menu-item-danger.ant-menu-item > a {
  color: #f5222d;
}
.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-danger.ant-menu-item-selected {
  color: var(--app-secondary-color);
  background-color: #f5222d;
}
.ant-menu {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  line-height: 1.3;
  font-feature-settings: 'tnum';
  margin-bottom: 0;
  padding-left: 0;
  color: #545454;
  font-size: 14px;
  line-height: 0;
  text-align: left;
  list-style: none;
  background: #fff;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  transition: background 0.3s, width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
}
.ant-menu::before {
  display: table;
  content: '';
}
.ant-menu::after {
  display: table;
  clear: both;
  content: '';
}
.ant-menu::before {
  display: table;
  content: '';
}
.ant-menu::after {
  display: table;
  clear: both;
  content: '';
}
.ant-menu.ant-menu-root:focus-visible {
  box-shadow: 0 0 0 2px #847f87;
}
.ant-menu ul,
.ant-menu ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-menu-overflow {
  display: flex;
}
.ant-menu-overflow-item {
  flex: none;
}
.ant-menu-hidden,
.ant-menu-submenu-hidden {
  display: none;
}
.ant-menu-item-group-title {
  height: 1.3;
  padding: 8px 16px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  transition: all 0.3s;
}
.ant-menu-horizontal .ant-menu-submenu {
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu,
.ant-menu-submenu-inline {
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu-selected {
  color: var(--app-primary-color);
}
.ant-menu-item:active,
.ant-menu-submenu-title:active {
  background: #908b94;
}
.ant-menu-submenu .ant-menu-sub {
  cursor: initial;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-title-content {
  transition: color 0.3s;
}
.ant-menu-item a {
  color: #545454;
}
.ant-menu-item a:hover {
  color: var(--app-primary-color);
}
.ant-menu-item a::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
  content: '';
}
.ant-menu-item > .ant-badge a {
  color: #545454;
}
.ant-menu-item > .ant-badge a:hover {
  color: var(--app-primary-color);
}
.ant-menu-item-divider {
  overflow: hidden;
  line-height: 0;
  border-color: #e8e8e8;
  border-style: solid;
  border-width: 1px 0 0;
}
.ant-menu-item-divider-dashed {
  border-style: dashed;
}
.ant-menu-horizontal .ant-menu-item,
.ant-menu-horizontal .ant-menu-submenu {
  margin-top: -1px;
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {
  background-color: transparent;
}
.ant-menu-item-selected {
  color: var(--app-primary-color);
}
.ant-menu-item-selected a,
.ant-menu-item-selected a:hover {
  color: var(--app-primary-color);
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #908b94;
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: 1px solid #e8e8e8;
}
.ant-menu-vertical-right {
  border-left: 1px solid #e8e8e8;
}
.ant-menu-vertical.ant-menu-sub,
.ant-menu-vertical-left.ant-menu-sub,
.ant-menu-vertical-right.ant-menu-sub {
  min-width: 160px;
  max-height: calc(100vh - 100px);
  padding: 0;
  overflow: hidden;
  border-right: 0;
}
.ant-menu-vertical.ant-menu-sub:not([class*='-active']),
.ant-menu-vertical-left.ant-menu-sub:not([class*='-active']),
.ant-menu-vertical-right.ant-menu-sub:not([class*='-active']) {
  overflow-x: hidden;
  overflow-y: auto;
}
.ant-menu-vertical.ant-menu-sub .ant-menu-item,
.ant-menu-vertical-left.ant-menu-sub .ant-menu-item,
.ant-menu-vertical-right.ant-menu-sub .ant-menu-item {
  left: 0;
  margin-left: 0;
  border-right: 0;
}
.ant-menu-vertical.ant-menu-sub .ant-menu-item::after,
.ant-menu-vertical-left.ant-menu-sub .ant-menu-item::after,
.ant-menu-vertical-right.ant-menu-sub .ant-menu-item::after {
  border-right: 0;
}
.ant-menu-vertical.ant-menu-sub > .ant-menu-item,
.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item,
.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item,
.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu,
.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu,
.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu {
  transform-origin: 0 0;
}
.ant-menu-horizontal.ant-menu-sub {
  min-width: 114px;
}
.ant-menu-horizontal .ant-menu-item,
.ant-menu-horizontal .ant-menu-submenu-title {
  transition: border-color 0.3s, background 0.3s;
}
.ant-menu-item,
.ant-menu-submenu-title {
  position: relative;
  display: block;
  margin: 0;
  padding: 0 20px;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-item .ant-menu-item-icon,
.ant-menu-submenu-title .ant-menu-item-icon,
.ant-menu-item .anticon,
.ant-menu-submenu-title .anticon {
  min-width: 14px;
  font-size: 14px;
  transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s;
}
.ant-menu-item .ant-menu-item-icon + span,
.ant-menu-submenu-title .ant-menu-item-icon + span,
.ant-menu-item .anticon + span,
.ant-menu-submenu-title .anticon + span {
  margin-left: 10px;
  opacity: 1;
  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), margin 0.3s, color 0.3s;
}
.ant-menu-item .ant-menu-item-icon.svg,
.ant-menu-submenu-title .ant-menu-item-icon.svg {
  vertical-align: -0.125em;
}
.ant-menu-item.ant-menu-item-only-child > .anticon,
.ant-menu-submenu-title.ant-menu-item-only-child > .anticon,
.ant-menu-item.ant-menu-item-only-child > .ant-menu-item-icon,
.ant-menu-submenu-title.ant-menu-item-only-child > .ant-menu-item-icon {
  margin-right: 0;
}
.ant-menu-item:not(.ant-menu-item-disabled):focus-visible,
.ant-menu-submenu-title:not(.ant-menu-item-disabled):focus-visible {
  box-shadow: 0 0 0 2px #847f87;
}
.ant-menu > .ant-menu-item-divider {
  margin: 1px 0;
  padding: 0;
}
.ant-menu-submenu-popup {
  position: absolute;
  z-index: 1050;
  background: transparent;
  border-radius: 6px;
  box-shadow: none;
  transform-origin: 0 0;
}
.ant-menu-submenu-popup::before {
  position: absolute;
  top: -7px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 0.0001;
  content: ' ';
}
.ant-menu-submenu-placement-rightTop::before {
  top: 0;
  left: -7px;
}
.ant-menu-submenu > .ant-menu {
  background-color: #fff;
  border-radius: 6px;
}
.ant-menu-submenu > .ant-menu-submenu-title::after {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu-popup > .ant-menu {
  background-color: #fff;
}
.ant-menu-submenu-expand-icon,
.ant-menu-submenu-arrow {
  position: absolute;
  top: 50%;
  right: 16px;
  width: 10px;
  color: #545454;
  transform: translateY(-50%);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu-arrow::before,
.ant-menu-submenu-arrow::after {
  position: absolute;
  width: 6px;
  height: 1.5px;
  background-color: currentcolor;
  border-radius: 2px;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  content: '';
}
.ant-menu-submenu-arrow::before {
  transform: rotate(45deg) translateY(-2.5px);
}
.ant-menu-submenu-arrow::after {
  transform: rotate(-45deg) translateY(2.5px);
}
.ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-expand-icon,
.ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  color: var(--app-primary-color);
}
.ant-menu-inline-collapsed .ant-menu-submenu-arrow::before,
.ant-menu-submenu-inline .ant-menu-submenu-arrow::before {
  transform: rotate(-45deg) translateX(2.5px);
}
.ant-menu-inline-collapsed .ant-menu-submenu-arrow::after,
.ant-menu-submenu-inline .ant-menu-submenu-arrow::after {
  transform: rotate(45deg) translateX(-2.5px);
}
.ant-menu-submenu-horizontal .ant-menu-submenu-arrow {
  display: none;
}
.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  transform: translateY(-2px);
}
.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {
  transform: rotate(-45deg) translateX(-2.5px);
}
.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before {
  transform: rotate(45deg) translateX(2.5px);
}
.ant-menu-vertical .ant-menu-submenu-selected,
.ant-menu-vertical-left .ant-menu-submenu-selected,
.ant-menu-vertical-right .ant-menu-submenu-selected {
  color: var(--app-primary-color);
}
.ant-menu-horizontal {
  line-height: 46px;
  border: 0;
  border-bottom: 1px solid #e8e8e8;
  box-shadow: none;
}
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {
  margin-top: -1px;
  margin-bottom: 0;
  padding: 0 20px;
}
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected {
  color: var(--app-primary-color);
}
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected::after {
  border-bottom: 2px solid var(--app-primary-color);
}
.ant-menu-horizontal > .ant-menu-item,
.ant-menu-horizontal > .ant-menu-submenu {
  position: relative;
  top: 1px;
  display: inline-block;
  vertical-align: bottom;
}
.ant-menu-horizontal > .ant-menu-item::after,
.ant-menu-horizontal > .ant-menu-submenu::after {
  position: absolute;
  right: 20px;
  bottom: 0;
  left: 20px;
  border-bottom: 2px solid transparent;
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  content: '';
}
.ant-menu-horizontal > .ant-menu-submenu > .ant-menu-submenu-title {
  padding: 0;
}
.ant-menu-horizontal > .ant-menu-item a {
  color: #545454;
}
.ant-menu-horizontal > .ant-menu-item a:hover {
  color: var(--app-primary-color);
}
.ant-menu-horizontal > .ant-menu-item a::before {
  bottom: -2px;
}
.ant-menu-horizontal > .ant-menu-item-selected a {
  color: var(--app-primary-color);
}
.ant-menu-horizontal::after {
  display: block;
  clear: both;
  height: 0;
  content: '\\20';
}
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item {
  position: relative;
}
.ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-right: 3px solid var(--app-primary-color);
  transform: scaleY(0.0001);
  opacity: 0;
  transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  content: '';
}
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-submenu-title,
.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu-title {
  height: 42px;
  margin-top: 4px;
  margin-bottom: 4px;
  padding: 0 16px;
  overflow: hidden;
  line-height: 42px;
  text-overflow: ellipsis;
}
.ant-menu-vertical .ant-menu-submenu,
.ant-menu-vertical-left .ant-menu-submenu,
.ant-menu-vertical-right .ant-menu-submenu,
.ant-menu-inline .ant-menu-submenu {
  padding-bottom: 0.02px;
}
.ant-menu-vertical .ant-menu-item:not(:last-child),
.ant-menu-vertical-left .ant-menu-item:not(:last-child),
.ant-menu-vertical-right .ant-menu-item:not(:last-child),
.ant-menu-inline .ant-menu-item:not(:last-child) {
  margin-bottom: 8px;
}
.ant-menu-vertical > .ant-menu-item,
.ant-menu-vertical-left > .ant-menu-item,
.ant-menu-vertical-right > .ant-menu-item,
.ant-menu-inline > .ant-menu-item,
.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 42px;
  line-height: 42px;
}
.ant-menu-vertical .ant-menu-item-group-list .ant-menu-submenu-title,
.ant-menu-vertical .ant-menu-submenu-title {
  padding-right: 34px;
}
.ant-menu-inline {
  width: 100%;
}
.ant-menu-inline .ant-menu-selected::after,
.ant-menu-inline .ant-menu-item-selected::after {
  transform: scaleY(1);
  opacity: 1;
  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-inline .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title {
  width: calc(100% + 1px);
}
.ant-menu-inline .ant-menu-item-group-list .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu-title {
  padding-right: 34px;
}
.ant-menu-inline.ant-menu-root .ant-menu-item,
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
  display: flex;
  align-items: center;
  transition: border-color 0.3s, background 0.3s, padding 0.1s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.ant-menu-inline.ant-menu-root .ant-menu-item > .ant-menu-title-content,
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title > .ant-menu-title-content {
  flex: auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ant-menu-inline.ant-menu-root .ant-menu-item > *,
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title > * {
  flex: none;
}
.ant-menu.ant-menu-inline-collapsed {
  width: 80px;
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  left: 0;
  padding: 0 calc(50% - 16px / 2);
  text-overflow: clip;
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  opacity: 0;
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .anticon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon {
  margin: 0;
  font-size: 16px;
  line-height: 42px;
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .anticon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span {
  display: inline-block;
  opacity: 0;
}
.ant-menu.ant-menu-inline-collapsed .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed .anticon {
  display: inline-block;
}
.ant-menu.ant-menu-inline-collapsed-tooltip {
  pointer-events: none;
}
.ant-menu.ant-menu-inline-collapsed-tooltip .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed-tooltip .anticon {
  display: none;
}
.ant-menu.ant-menu-inline-collapsed-tooltip a {
  color: rgba(255, 255, 255, 0.85);
}
.ant-menu.ant-menu-inline-collapsed .ant-menu-item-group-title {
  padding-right: 4px;
  padding-left: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-menu-item-group-list {
  margin: 0;
  padding: 0;
}
.ant-menu-item-group-list .ant-menu-item,
.ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 16px 0 28px;
}
.ant-menu-root.ant-menu-vertical,
.ant-menu-root.ant-menu-vertical-left,
.ant-menu-root.ant-menu-vertical-right,
.ant-menu-root.ant-menu-inline {
  box-shadow: none;
}
.ant-menu-root.ant-menu-inline-collapsed .ant-menu-item > .ant-menu-inline-collapsed-noicon,
.ant-menu-root.ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-submenu-title > .ant-menu-inline-collapsed-noicon {
  font-size: 16px;
  text-align: center;
}
.ant-menu-sub.ant-menu-inline {
  padding: 0;
  background: #fafafa;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item,
.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 42px;
  line-height: 42px;
  list-style-position: inside;
  list-style-type: disc;
}
.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding-left: 32px;
}
.ant-menu-item-disabled,
.ant-menu-submenu-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
  background: none;
  cursor: not-allowed;
}
.ant-menu-item-disabled::after,
.ant-menu-submenu-disabled::after {
  border-color: transparent !important;
}
.ant-menu-item-disabled a,
.ant-menu-submenu-disabled a {
  color: rgba(0, 0, 0, 0.25) !important;
  pointer-events: none;
}
.ant-menu-item-disabled > .ant-menu-submenu-title,
.ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed;
}
.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {
  background: rgba(0, 0, 0, 0.25) !important;
}
.ant-layout-header .ant-menu {
  line-height: inherit;
}
.ant-menu-inline-collapsed-tooltip a,
.ant-menu-inline-collapsed-tooltip a:hover {
  color: #fff;
}
.ant-menu-light .ant-menu-item:hover,
.ant-menu-light .ant-menu-item-active,
.ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-light .ant-menu-submenu-active,
.ant-menu-light .ant-menu-submenu-title:hover {
  color: var(--app-primary-color);
}
.ant-menu.ant-menu-root:focus-visible {
  box-shadow: 0 0 0 2px #1a0c2e;
}
.ant-menu-dark .ant-menu-item:focus-visible,
.ant-menu-dark .ant-menu-submenu-title:focus-visible {
  box-shadow: 0 0 0 2px #1a0c2e;
}
.ant-menu.ant-menu-dark,
.ant-menu-dark .ant-menu-sub,
.ant-menu.ant-menu-dark .ant-menu-sub {
  color: #ffffff;
  background: var(--app-primary-color);
}
.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow {
  opacity: 0.45;
  transition: all 0.3s;
}
.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  background: #ffffff;
}
.ant-menu-dark.ant-menu-submenu-popup {
  background: transparent;
}
.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  background: #000c17;
}
.ant-menu-dark.ant-menu-horizontal {
  border-bottom: 0;
}
.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,
.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {
  top: 0;
  margin-top: 0;
  padding: 0 20px;
  border-color: var(--app-primary-color);
  border-bottom: 0;
}
.ant-menu-dark.ant-menu-horizontal > .ant-menu-item:hover {
  background-color: #ffffff;
}
.ant-menu-dark.ant-menu-horizontal > .ant-menu-item > a::before {
  bottom: 0;
}
.ant-menu-dark .ant-menu-item,
.ant-menu-dark .ant-menu-item-group-title,
.ant-menu-dark .ant-menu-item > a,
.ant-menu-dark .ant-menu-item > span > a {
  color: #ffffff;
}
.ant-menu-dark.ant-menu-inline,
.ant-menu-dark.ant-menu-vertical,
.ant-menu-dark.ant-menu-vertical-left,
.ant-menu-dark.ant-menu-vertical-right {
  border-right: 0;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item,
.ant-menu-dark.ant-menu-vertical .ant-menu-item,
.ant-menu-dark.ant-menu-vertical-left .ant-menu-item,
.ant-menu-dark.ant-menu-vertical-right .ant-menu-item {
  left: 0;
  margin-left: 0;
  border-right: 0;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item::after,
.ant-menu-dark.ant-menu-vertical .ant-menu-item::after,
.ant-menu-dark.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-dark.ant-menu-vertical-right .ant-menu-item::after {
  border-right: 0;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item,
.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
  width: 100%;
}
.ant-menu-dark .ant-menu-item:hover,
.ant-menu-dark .ant-menu-item-active,
.ant-menu-dark .ant-menu-submenu-active,
.ant-menu-dark .ant-menu-submenu-open,
.ant-menu-dark .ant-menu-submenu-selected,
.ant-menu-dark .ant-menu-submenu-title:hover {
  color: var(--app-secondary-color);
  background-color: transparent;
}
.ant-menu-dark .ant-menu-item:hover > a,
.ant-menu-dark .ant-menu-item-active > a,
.ant-menu-dark .ant-menu-submenu-active > a,
.ant-menu-dark .ant-menu-submenu-open > a,
.ant-menu-dark .ant-menu-submenu-selected > a,
.ant-menu-dark .ant-menu-submenu-title:hover > a,
.ant-menu-dark .ant-menu-item:hover > span > a,
.ant-menu-dark .ant-menu-item-active > span > a,
.ant-menu-dark .ant-menu-submenu-active > span > a,
.ant-menu-dark .ant-menu-submenu-open > span > a,
.ant-menu-dark .ant-menu-submenu-selected > span > a,
.ant-menu-dark .ant-menu-submenu-title:hover > span > a {
  color: var(--app-secondary-color);
}
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  opacity: 1;
}
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before {
  background: var(--app-secondary-color);
}
.ant-menu-dark .ant-menu-item:hover {
  background-color: transparent;
}
.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #ffffff;
}
.ant-menu-dark .ant-menu-item-selected {
  color: var(--app-secondary-color);
  border-right: 0;
}
.ant-menu-dark .ant-menu-item-selected::after {
  border-right: 0;
}
.ant-menu-dark .ant-menu-item-selected > a,
.ant-menu-dark .ant-menu-item-selected > span > a,
.ant-menu-dark .ant-menu-item-selected > a:hover,
.ant-menu-dark .ant-menu-item-selected > span > a:hover {
  color: var(--app-secondary-color);
}
.ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon,
.ant-menu-dark .ant-menu-item-selected .anticon {
  color: #fff;
}
.ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon + span,
.ant-menu-dark .ant-menu-item-selected .anticon + span {
  color: #fff;
}
.ant-menu.ant-menu-dark .ant-menu-item-selected,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  background-color: #ffffff;
}
.ant-menu-dark .ant-menu-item-disabled,
.ant-menu-dark .ant-menu-submenu-disabled,
.ant-menu-dark .ant-menu-item-disabled > a,
.ant-menu-dark .ant-menu-submenu-disabled > a,
.ant-menu-dark .ant-menu-item-disabled > span > a,
.ant-menu-dark .ant-menu-submenu-disabled > span > a {
  color: rgba(255, 255, 255, 0.35) !important;
  opacity: 0.8;
}
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(255, 255, 255, 0.35) !important;
}
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {
  background: rgba(255, 255, 255, 0.35) !important;
}
.ant-menu.ant-menu-rtl {
  direction: rtl;
  text-align: right;
}
.ant-menu-rtl .ant-menu-item-group-title {
  text-align: right;
}
.ant-menu-rtl.ant-menu-inline,
.ant-menu-rtl.ant-menu-vertical {
  border-right: none;
  border-left: 1px solid #e8e8e8;
}
.ant-menu-rtl.ant-menu-dark.ant-menu-inline,
.ant-menu-rtl.ant-menu-dark.ant-menu-vertical {
  border-left: none;
}
.ant-menu-rtl.ant-menu-vertical.ant-menu-sub > .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu,
.ant-menu-rtl.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu,
.ant-menu-rtl.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu {
  transform-origin: top right;
}
.ant-menu-rtl .ant-menu-item .ant-menu-item-icon,
.ant-menu-rtl .ant-menu-submenu-title .ant-menu-item-icon,
.ant-menu-rtl .ant-menu-item .anticon,
.ant-menu-rtl .ant-menu-submenu-title .anticon {
  margin-right: auto;
  margin-left: 10px;
}
.ant-menu-rtl .ant-menu-item.ant-menu-item-only-child > .ant-menu-item-icon,
.ant-menu-rtl .ant-menu-submenu-title.ant-menu-item-only-child > .ant-menu-item-icon,
.ant-menu-rtl .ant-menu-item.ant-menu-item-only-child > .anticon,
.ant-menu-rtl .ant-menu-submenu-title.ant-menu-item-only-child > .anticon {
  margin-left: 0;
}
.ant-menu-submenu-rtl.ant-menu-submenu-popup {
  transform-origin: 100% 0;
}
.ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-rtl .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  right: auto;
  left: 16px;
}
.ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  transform: rotate(-45deg) translateY(-2px);
}
.ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  transform: rotate(45deg) translateY(2px);
}
.ant-menu-rtl.ant-menu-vertical .ant-menu-item::after,
.ant-menu-rtl.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-rtl.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-rtl.ant-menu-inline .ant-menu-item::after {
  right: auto;
  left: 0;
}
.ant-menu-rtl.ant-menu-vertical .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical-left .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical-right .ant-menu-item,
.ant-menu-rtl.ant-menu-inline .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical .ant-menu-submenu-title,
.ant-menu-rtl.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-rtl.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-rtl.ant-menu-inline .ant-menu-submenu-title {
  text-align: right;
}
.ant-menu-rtl.ant-menu-inline .ant-menu-submenu-title {
  padding-right: 0;
  padding-left: 34px;
}
.ant-menu-rtl.ant-menu-vertical .ant-menu-submenu-title {
  padding-right: 16px;
  padding-left: 34px;
}
.ant-menu-rtl.ant-menu-inline-collapsed.ant-menu-vertical .ant-menu-submenu-title {
  padding: 0 calc(50% - 16px / 2);
}
.ant-menu-rtl .ant-menu-item-group-list .ant-menu-item,
.ant-menu-rtl .ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 28px 0 16px;
}
.ant-menu-sub.ant-menu-inline {
  border: 0;
}
.ant-menu-rtl.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding-right: 32px;
  padding-left: 0;
}
.ant-message {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: fixed;
  top: 8px;
  left: 0;
  z-index: 1010;
  width: 100%;
  pointer-events: none;
}
.ant-message-notice {
  padding: 8px;
  text-align: center;
}
.ant-message-notice-content {
  display: inline-block;
  padding: 10px 16px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  pointer-events: all;
}
.ant-message-success .anticon {
  color: #52c41a;
}
.ant-message-error .anticon {
  color: #f5222d;
}
.ant-message-warning .anticon {
  color: #fa8c16;
}
.ant-message-info .anticon,
.ant-message-loading .anticon {
  color: #1890ff;
}
.ant-message .anticon {
  position: relative;
  top: 1px;
  margin-right: 8px;
  font-size: 16px;
}
.ant-message-notice.ant-move-up-leave.ant-move-up-leave-active {
  animation-name: MessageMoveOut;
  animation-duration: 0.3s;
}
@keyframes MessageMoveOut {
  0% {
    max-height: 150px;
    padding: 8px;
    opacity: 1;
  }
  100% {
    max-height: 0;
    padding: 0;
    opacity: 0;
  }
}
.ant-message-rtl {
  direction: rtl;
}
.ant-message-rtl span {
  direction: rtl;
}
.ant-message-rtl .anticon {
  margin-right: 0;
  margin-left: 8px;
}
.ant-modal {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  pointer-events: none;
  position: relative;
  top: 100px;
  width: auto;
  max-width: calc(100vw - 32px);
  margin: 0 auto;
  padding-bottom: 24px;
}
.ant-modal.ant-zoom-enter,
.ant-modal.ant-zoom-appear {
  transform: none;
  opacity: 0;
  animation-duration: 0.3s;
  user-select: none;
}
.ant-modal-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
}
.ant-modal-mask-hidden {
  display: none;
}
.ant-modal-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  outline: 0;
}
.ant-modal-wrap {
  z-index: 1000;
}
.ant-modal-title {
  margin: 0;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  word-wrap: break-word;
}
.ant-modal-content {
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-radius: 6px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  pointer-events: auto;
}
.ant-modal-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 0;
  color: #595959;
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
}
.ant-modal-close-x {
  display: block;
  width: 54px;
  height: 54px;
  font-size: 16px;
  font-style: normal;
  line-height: 54px;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
}
.ant-modal-close:focus,
.ant-modal-close:hover {
  color: rgba(0, 0, 0, 0.75);
  text-decoration: none;
}
.ant-modal-header {
  padding: 16px 24px;
  color: #545454;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 6px 6px 0 0;
}
.ant-modal-body {
  padding: 24px;
  font-size: 14px;
  line-height: 1.3;
  word-wrap: break-word;
}
.ant-modal-footer {
  padding: 10px 16px;
  text-align: right;
  background: transparent;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 6px 6px;
}
.ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {
  margin-bottom: 0;
  margin-left: 8px;
}
.ant-modal-open {
  overflow: hidden;
}
.ant-modal-centered {
  text-align: center;
}
.ant-modal-centered::before {
  display: inline-block;
  width: 0;
  height: 100%;
  vertical-align: middle;
  content: '';
}
.ant-modal-centered .ant-modal {
  top: 0;
  display: inline-block;
  padding-bottom: 0;
  text-align: left;
  vertical-align: middle;
}
@media (max-width: 767px) {
  .ant-modal {
    max-width: calc(100vw - 16px);
    margin: 8px auto;
  }
  .ant-modal-centered .ant-modal {
    flex: 1;
  }
}
.ant-modal-confirm .ant-modal-header {
  display: none;
}
.ant-modal-confirm .ant-modal-body {
  padding: 32px 32px 24px;
}
.ant-modal-confirm-body-wrapper::before {
  display: table;
  content: '';
}
.ant-modal-confirm-body-wrapper::after {
  display: table;
  clear: both;
  content: '';
}
.ant-modal-confirm-body-wrapper::before {
  display: table;
  content: '';
}
.ant-modal-confirm-body-wrapper::after {
  display: table;
  clear: both;
  content: '';
}
.ant-modal-confirm-body .ant-modal-confirm-title {
  display: block;
  overflow: hidden;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.4;
}
.ant-modal-confirm-body .ant-modal-confirm-content {
  margin-top: 8px;
  color: #545454;
  font-size: 14px;
}
.ant-modal-confirm-body > .anticon {
  float: left;
  margin-right: 16px;
  font-size: 22px;
}
.ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
  margin-left: 38px;
}
.ant-modal-confirm .ant-modal-confirm-btns {
  margin-top: 24px;
  text-align: right;
}
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn + .ant-btn {
  margin-bottom: 0;
  margin-left: 8px;
}
.ant-modal-confirm-error .ant-modal-confirm-body > .anticon {
  color: #f5222d;
}
.ant-modal-confirm-warning .ant-modal-confirm-body > .anticon,
.ant-modal-confirm-confirm .ant-modal-confirm-body > .anticon {
  color: #fa8c16;
}
.ant-modal-confirm-info .ant-modal-confirm-body > .anticon {
  color: #1890ff;
}
.ant-modal-confirm-success .ant-modal-confirm-body > .anticon {
  color: #52c41a;
}
.ant-modal-confirm .ant-zoom-leave .ant-modal-confirm-btns {
  pointer-events: none;
}
.ant-modal-wrap-rtl {
  direction: rtl;
}
.ant-modal-wrap-rtl .ant-modal-close {
  right: initial;
  left: 0;
}
.ant-modal-wrap-rtl .ant-modal-footer {
  text-align: left;
}
.ant-modal-wrap-rtl .ant-modal-footer .ant-btn + .ant-btn {
  margin-right: 8px;
  margin-left: 0;
}
.ant-modal-wrap-rtl .ant-modal-confirm-body {
  direction: rtl;
}
.ant-modal-wrap-rtl .ant-modal-confirm-body > .anticon {
  float: right;
  margin-right: 0;
  margin-left: 16px;
}
.ant-modal-wrap-rtl .ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
  margin-right: 38px;
  margin-left: 0;
}
.ant-modal-wrap-rtl .ant-modal-confirm-btns {
  text-align: left;
}
.ant-modal-wrap-rtl .ant-modal-confirm-btns .ant-btn + .ant-btn {
  margin-right: 8px;
  margin-left: 0;
}
.ant-modal-wrap-rtl.ant-modal-centered .ant-modal {
  text-align: right;
}
.ant-notification {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: fixed;
  z-index: 1010;
  margin-right: 24px;
}
.ant-notification-close-icon {
  font-size: 14px;
  cursor: pointer;
}
.ant-notification-hook-holder {
  position: relative;
}
.ant-notification-notice {
  position: relative;
  width: 384px;
  max-width: calc(100vw - 24px * 2);
  margin-bottom: 16px;
  margin-left: auto;
  padding: 16px 24px;
  overflow: hidden;
  line-height: 1.3;
  word-wrap: break-word;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.ant-notification-top .ant-notification-notice,
.ant-notification-bottom .ant-notification-notice {
  margin-right: auto;
  margin-left: auto;
}
.ant-notification-topLeft .ant-notification-notice,
.ant-notification-bottomLeft .ant-notification-notice {
  margin-right: auto;
  margin-left: 0;
}
.ant-notification-notice-message {
  margin-bottom: 8px;
  color: #535353;
  font-size: 16px;
  line-height: 24px;
}
.ant-notification-notice-message-single-line-auto-margin {
  display: block;
  width: calc(384px - 24px * 2 - 24px - 48px - 100%);
  max-width: 4px;
  background-color: transparent;
  pointer-events: none;
}
.ant-notification-notice-message-single-line-auto-margin::before {
  display: block;
  content: '';
}
.ant-notification-notice-description {
  font-size: 14px;
}
.ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 24px;
}
.ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-bottom: 4px;
  margin-left: 48px;
  font-size: 16px;
}
.ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-left: 48px;
  font-size: 14px;
}
.ant-notification-notice-icon {
  position: absolute;
  margin-left: 4px;
  font-size: 24px;
  line-height: 24px;
}
.anticon.ant-notification-notice-icon-success {
  color: #52c41a;
}
.anticon.ant-notification-notice-icon-info {
  color: #1890ff;
}
.anticon.ant-notification-notice-icon-warning {
  color: #fa8c16;
}
.anticon.ant-notification-notice-icon-error {
  color: #f5222d;
}
.ant-notification-notice-close {
  position: absolute;
  top: 16px;
  right: 22px;
  color: #595959;
  outline: none;
}
.ant-notification-notice-close:hover {
  color: #353535;
}
.ant-notification-notice-btn {
  float: right;
  margin-top: 16px;
}
.ant-notification .notification-fade-effect {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
}
.ant-notification-fade-enter,
.ant-notification-fade-appear {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
  opacity: 0;
  animation-play-state: paused;
}
.ant-notification-fade-leave {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
  animation-duration: 0.2s;
  animation-play-state: paused;
}
.ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationFadeIn;
  animation-play-state: running;
}
.ant-notification-fade-leave.ant-notification-fade-leave-active {
  animation-name: NotificationFadeOut;
  animation-play-state: running;
}
@keyframes NotificationFadeIn {
  0% {
    left: 384px;
    opacity: 0;
  }
  100% {
    left: 0;
    opacity: 1;
  }
}
@keyframes NotificationFadeOut {
  0% {
    max-height: 150px;
    margin-bottom: 16px;
    opacity: 1;
  }
  100% {
    max-height: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    opacity: 0;
  }
}
.ant-notification-rtl {
  direction: rtl;
}
.ant-notification-rtl .ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 0;
  padding-left: 24px;
}
.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-right: 48px;
  margin-left: 0;
}
.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-right: 48px;
  margin-left: 0;
}
.ant-notification-rtl .ant-notification-notice-icon {
  margin-right: 4px;
  margin-left: 0;
}
.ant-notification-rtl .ant-notification-notice-close {
  right: auto;
  left: 22px;
}
.ant-notification-rtl .ant-notification-notice-btn {
  float: left;
}
.ant-notification-top,
.ant-notification-bottom {
  margin-right: 0;
  margin-left: 0;
}
.ant-notification-top .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-top .ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationTopFadeIn;
}
.ant-notification-bottom .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-bottom .ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationBottomFadeIn;
}
.ant-notification-topLeft,
.ant-notification-bottomLeft {
  margin-right: 0;
  margin-left: 24px;
}
.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,
.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationLeftFadeIn;
}
@keyframes NotificationTopFadeIn {
  0% {
    margin-top: -100%;
    opacity: 0;
  }
  100% {
    margin-top: 0;
    opacity: 1;
  }
}
@keyframes NotificationBottomFadeIn {
  0% {
    margin-bottom: -100%;
    opacity: 0;
  }
  100% {
    margin-bottom: 0;
    opacity: 1;
  }
}
@keyframes NotificationLeftFadeIn {
  0% {
    right: 384px;
    opacity: 0;
  }
  100% {
    right: 0;
    opacity: 1;
  }
}
.ant-page-header {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  padding: 16px 24px;
  background-color: #fff;
}
.ant-page-header-ghost {
  background-color: inherit;
}
.ant-page-header.has-breadcrumb {
  padding-top: 12px;
}
.ant-page-header.has-footer {
  padding-bottom: 0;
}
.ant-page-header-back {
  margin-right: 16px;
  font-size: 16px;
  line-height: 1;
}
.ant-page-header-back-button {
  color: var(--app-primary-color);
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  color: #000;
}
.ant-page-header-back-button:focus-visible,
.ant-page-header-back-button:hover {
  color: #0d0d0d;
}
.ant-page-header-back-button:active {
  color: #000000;
}
.ant-page-header .ant-divider-vertical {
  height: 14px;
  margin: 0 12px;
  vertical-align: middle;
}
.ant-breadcrumb + .ant-page-header-heading {
  margin-top: 8px;
}
.ant-page-header-heading {
  display: flex;
  justify-content: space-between;
}
.ant-page-header-heading-left {
  display: flex;
  align-items: center;
  margin: 4px 0;
  overflow: hidden;
}
.ant-page-header-heading-title {
  margin-right: 12px;
  margin-bottom: 0;
  color: #535353;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-page-header-heading .ant-avatar {
  margin-right: 12px;
}
.ant-page-header-heading-sub-title {
  margin-right: 12px;
  color: #595959;
  font-size: 14px;
  line-height: 1.3;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-page-header-heading-extra {
  margin: 4px 0;
  white-space: nowrap;
}
.ant-page-header-heading-extra > * {
  white-space: unset;
}
.ant-page-header-content {
  padding-top: 12px;
}
.ant-page-header-footer {
  margin-top: 16px;
}
.ant-page-header-footer .ant-tabs > .ant-tabs-nav {
  margin: 0;
}
.ant-page-header-footer .ant-tabs > .ant-tabs-nav::before {
  border: none;
}
.ant-page-header-footer .ant-tabs .ant-tabs-tab {
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 16px;
}
.ant-page-header-compact .ant-page-header-heading {
  flex-wrap: wrap;
}
.ant-page-header-rtl {
  direction: rtl;
}
.ant-page-header-rtl .ant-page-header-back {
  float: right;
  margin-right: 0;
  margin-left: 16px;
}
.ant-page-header-rtl .ant-page-header-heading-title {
  margin-right: 0;
  margin-left: 12px;
}
.ant-page-header-rtl .ant-page-header-heading .ant-avatar {
  margin-right: 0;
  margin-left: 12px;
}
.ant-page-header-rtl .ant-page-header-heading-sub-title {
  float: right;
  margin-right: 0;
  margin-left: 12px;
}
.ant-page-header-rtl .ant-page-header-heading-tags {
  float: right;
}
.ant-page-header-rtl .ant-page-header-heading-extra {
  float: left;
}
.ant-page-header-rtl .ant-page-header-heading-extra > * {
  margin-right: 12px;
  margin-left: 0;
}
.ant-page-header-rtl .ant-page-header-heading-extra > *:first-child {
  margin-right: 0;
}
.ant-page-header-rtl .ant-page-header-footer .ant-tabs-bar .ant-tabs-nav {
  float: right;
}
.ant-pagination {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-pagination ul,
.ant-pagination ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-pagination::after {
  display: block;
  clear: both;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  content: ' ';
}
.ant-pagination-total-text {
  display: inline-block;
  height: 32px;
  margin-right: 8px;
  line-height: 30px;
  vertical-align: middle;
}
.ant-pagination-item {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  margin-right: 8px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  outline: 0;
  cursor: pointer;
  user-select: none;
}
.ant-pagination-item a {
  display: block;
  padding: 0 6px;
  color: #545454;
  transition: none;
}
.ant-pagination-item a:hover {
  text-decoration: none;
}
.ant-pagination-item:hover {
  border-color: #351a55;
  transition: all 0.3s;
}
.ant-pagination-item:hover a {
  color: #351a55;
}
.ant-pagination-item:focus-visible {
  border-color: #351a55;
  transition: all 0.3s;
}
.ant-pagination-item:focus-visible a {
  color: #351a55;
}
.ant-pagination-item-active {
  font-weight: 500;
  background: #fff;
  border-color: #351a55;
}
.ant-pagination-item-active a {
  color: #351a55;
}
.ant-pagination-item-active:hover {
  border-color: #462e61;
}
.ant-pagination-item-active:focus-visible {
  border-color: #462e61;
}
.ant-pagination-item-active:hover a {
  color: #462e61;
}
.ant-pagination-item-active:focus-visible a {
  color: #462e61;
}
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  outline: 0;
}
.ant-pagination-jump-prev .ant-pagination-item-container,
.ant-pagination-jump-next .ant-pagination-item-container {
  position: relative;
}
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
  color: #351a55;
  font-size: 12px;
  letter-spacing: -1px;
  opacity: 0;
  transition: all 0.2s;
}
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon-svg,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon-svg {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  margin: auto;
  color: rgba(0, 0, 0, 0.25);
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: 2px;
  text-align: center;
  text-indent: 0.13em;
  opacity: 1;
  transition: all 0.2s;
}
.ant-pagination-jump-prev:hover .ant-pagination-item-link-icon,
.ant-pagination-jump-next:hover .ant-pagination-item-link-icon {
  opacity: 1;
}
.ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis,
.ant-pagination-jump-next:hover .ant-pagination-item-ellipsis {
  opacity: 0;
}
.ant-pagination-jump-prev:focus-visible .ant-pagination-item-link-icon,
.ant-pagination-jump-next:focus-visible .ant-pagination-item-link-icon {
  opacity: 1;
}
.ant-pagination-jump-prev:focus-visible .ant-pagination-item-ellipsis,
.ant-pagination-jump-next:focus-visible .ant-pagination-item-ellipsis {
  opacity: 0;
}
.ant-pagination-prev,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  margin-right: 8px;
}
.ant-pagination-prev,
.ant-pagination-next,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  color: #545454;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  line-height: 32px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-pagination-prev,
.ant-pagination-next {
  font-family: Arial, Helvetica, sans-serif;
  outline: 0;
}
.ant-pagination-prev button,
.ant-pagination-next button {
  color: #545454;
  cursor: pointer;
  user-select: none;
}
.ant-pagination-prev:hover button,
.ant-pagination-next:hover button {
  border-color: #462e61;
}
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  outline: none;
  transition: all 0.3s;
}
.ant-pagination-prev:focus-visible .ant-pagination-item-link,
.ant-pagination-next:focus-visible .ant-pagination-item-link {
  color: #351a55;
  border-color: #351a55;
}
.ant-pagination-prev:hover .ant-pagination-item-link,
.ant-pagination-next:hover .ant-pagination-item-link {
  color: #351a55;
  border-color: #351a55;
}
.ant-pagination-disabled,
.ant-pagination-disabled:hover {
  cursor: not-allowed;
}
.ant-pagination-disabled .ant-pagination-item-link,
.ant-pagination-disabled:hover .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination-disabled:focus-visible {
  cursor: not-allowed;
}
.ant-pagination-disabled:focus-visible .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination-slash {
  margin: 0 10px 0 5px;
}
.ant-pagination-options {
  display: inline-block;
  margin-left: 16px;
  vertical-align: middle;
}
@media all and (-ms-high-contrast: none) {
  .ant-pagination-options *::-ms-backdrop,
  .ant-pagination-options {
    vertical-align: top;
  }
}
.ant-pagination-options-size-changer.ant-select {
  display: inline-block;
  width: auto;
}
.ant-pagination-options-quick-jumper {
  display: inline-block;
  height: 36px;
  margin-left: 8px;
  line-height: 36px;
  vertical-align: top;
}
.ant-pagination-options-quick-jumper input {
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7.9px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
  width: 50px;
  height: 36px;
  margin: 0 8px;
}
.ant-pagination-options-quick-jumper input::placeholder {
  color: #bfbfbf;
  user-select: none;
}
.ant-pagination-options-quick-jumper input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-pagination-options-quick-jumper input:hover {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-pagination-options-quick-jumper input:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-pagination-options-quick-jumper input:focus,
.ant-pagination-options-quick-jumper input-focused {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-pagination-options-quick-jumper input:focus,
.ant-input-rtl .ant-pagination-options-quick-jumper input-focused {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-pagination-options-quick-jumper input-disabled {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-pagination-options-quick-jumper input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-pagination-options-quick-jumper input[disabled] {
  color: #999;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-pagination-options-quick-jumper input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}
.ant-pagination-options-quick-jumper input-borderless,
.ant-pagination-options-quick-jumper input-borderless:hover,
.ant-pagination-options-quick-jumper input-borderless:focus,
.ant-pagination-options-quick-jumper input-borderless-focused,
.ant-pagination-options-quick-jumper input-borderless-disabled,
.ant-pagination-options-quick-jumper input-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
textarea.ant-pagination-options-quick-jumper input {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-pagination-options-quick-jumper input-lg {
  padding: 8.6px 11px;
  font-size: 16px;
}
.ant-pagination-options-quick-jumper input-sm {
  padding: 1.9px 7px;
}
.ant-pagination-options-quick-jumper input-rtl {
  direction: rtl;
}
.ant-pagination-simple .ant-pagination-prev,
.ant-pagination-simple .ant-pagination-next {
  height: 24px;
  line-height: 24px;
  vertical-align: top;
}
.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link {
  height: 24px;
  background-color: transparent;
  border: 0;
}
.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link::after,
.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link::after {
  height: 24px;
  line-height: 24px;
}
.ant-pagination-simple .ant-pagination-simple-pager {
  display: inline-block;
  height: 24px;
  margin-right: 8px;
}
.ant-pagination-simple .ant-pagination-simple-pager input {
  box-sizing: border-box;
  height: 100%;
  margin-right: 8px;
  padding: 0 6px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.3s;
}
.ant-pagination-simple .ant-pagination-simple-pager input:hover {
  border-color: #351a55;
}
.ant-pagination-simple .ant-pagination-simple-pager input:focus {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
}
.ant-pagination-simple .ant-pagination-simple-pager input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-mini .ant-pagination-total-text,
.ant-pagination.ant-pagination-mini .ant-pagination-simple-pager {
  height: 24px;
  line-height: 24px;
}
.ant-pagination.ant-pagination-mini .ant-pagination-item {
  min-width: 24px;
  height: 24px;
  margin: 0;
  line-height: 22px;
}
.ant-pagination.ant-pagination-mini .ant-pagination-item:not(.ant-pagination-item-active) {
  background: transparent;
  border-color: transparent;
}
.ant-pagination.ant-pagination-mini .ant-pagination-prev,
.ant-pagination.ant-pagination-mini .ant-pagination-next {
  min-width: 24px;
  height: 24px;
  margin: 0;
  line-height: 24px;
}
.ant-pagination.ant-pagination-mini .ant-pagination-prev .ant-pagination-item-link,
.ant-pagination.ant-pagination-mini .ant-pagination-next .ant-pagination-item-link {
  background: transparent;
  border-color: transparent;
}
.ant-pagination.ant-pagination-mini .ant-pagination-prev .ant-pagination-item-link::after,
.ant-pagination.ant-pagination-mini .ant-pagination-next .ant-pagination-item-link::after {
  height: 24px;
  line-height: 24px;
}
.ant-pagination.ant-pagination-mini .ant-pagination-jump-prev,
.ant-pagination.ant-pagination-mini .ant-pagination-jump-next {
  height: 24px;
  margin-right: 0;
  line-height: 24px;
}
.ant-pagination.ant-pagination-mini .ant-pagination-options {
  margin-left: 2px;
}
.ant-pagination.ant-pagination-mini .ant-pagination-options-size-changer {
  top: 0px;
}
.ant-pagination.ant-pagination-mini .ant-pagination-options-quick-jumper {
  height: 24px;
  line-height: 24px;
}
.ant-pagination.ant-pagination-mini .ant-pagination-options-quick-jumper input {
  padding: 1.9px 7px;
  width: 44px;
  height: 24px;
}
.ant-pagination.ant-pagination-disabled {
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item a {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  border: none;
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-active {
  background: #e6e6e6;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {
  color: rgba(0, 0, 0, 0.25);
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination-simple.ant-pagination.ant-pagination-disabled .ant-pagination-item-link {
  background: transparent;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-link-icon {
  opacity: 0;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-ellipsis {
  opacity: 1;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-simple-pager {
  color: rgba(0, 0, 0, 0.25);
}
@media only screen and (max-width: 992px) {
  .ant-pagination-item-after-jump-prev,
  .ant-pagination-item-before-jump-next {
    display: none;
  }
}
@media only screen and (max-width: 576px) {
  .ant-pagination-options {
    display: none;
  }
}
.ant-pagination-rtl .ant-pagination-total-text {
  margin-right: 0;
  margin-left: 8px;
}
.ant-pagination-rtl .ant-pagination-item,
.ant-pagination-rtl .ant-pagination-prev,
.ant-pagination-rtl .ant-pagination-jump-prev,
.ant-pagination-rtl .ant-pagination-jump-next {
  margin-right: 0;
  margin-left: 8px;
}
.ant-pagination-rtl .ant-pagination-slash {
  margin: 0 5px 0 10px;
}
.ant-pagination-rtl .ant-pagination-options {
  margin-right: 16px;
  margin-left: 0;
}
.ant-pagination-rtl .ant-pagination-options .ant-pagination-options-size-changer.ant-select {
  margin-right: 0;
  margin-left: 8px;
}
.ant-pagination-rtl .ant-pagination-options .ant-pagination-options-quick-jumper {
  margin-left: 0;
}
.ant-pagination-rtl.ant-pagination-simple .ant-pagination-simple-pager {
  margin-right: 0;
  margin-left: 8px;
}
.ant-pagination-rtl.ant-pagination-simple .ant-pagination-simple-pager input {
  margin-right: 0;
  margin-left: 8px;
}
.ant-pagination-rtl.ant-pagination.mini .ant-pagination-options {
  margin-right: 2px;
  margin-left: 0;
}
.ant-popconfirm {
  z-index: 1060;
}
.ant-popover {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1030;
  max-width: 100vw;
  font-weight: normal;
  white-space: normal;
  text-align: left;
  cursor: auto;
  user-select: text;
}
.ant-popover-content {
  position: relative;
}
.ant-popover::after {
  position: absolute;
  background: rgba(255, 255, 255, 0.01);
  content: '';
}
.ant-popover-hidden {
  display: none;
}
.ant-popover-placement-top,
.ant-popover-placement-topLeft,
.ant-popover-placement-topRight {
  padding-bottom: 15.3137085px;
}
.ant-popover-placement-right,
.ant-popover-placement-rightTop,
.ant-popover-placement-rightBottom {
  padding-left: 15.3137085px;
}
.ant-popover-placement-bottom,
.ant-popover-placement-bottomLeft,
.ant-popover-placement-bottomRight {
  padding-top: 15.3137085px;
}
.ant-popover-placement-left,
.ant-popover-placement-leftTop,
.ant-popover-placement-leftBottom {
  padding-right: 15.3137085px;
}
.ant-popover-inner {
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 6px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ant-popover {
    /* IE10+ */
  }
  .ant-popover-inner {
    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  }
}
.ant-popover-title {
  min-width: 177px;
  min-height: 32px;
  margin: 0;
  padding: 5px 16px 4px;
  color: #535353;
  font-weight: 500;
  border-bottom: 1px solid #e8e8e8;
}
.ant-popover-inner-content {
  width: max-content;
  max-width: 100%;
  padding: 12px 16px;
  color: #545454;
}
.ant-popover-message {
  display: flex;
  padding: 4px 0 12px;
  color: #545454;
  font-size: 14px;
}
.ant-popover-message-icon {
  display: inline-block;
  margin-right: 8px;
  color: #fa8c16;
  font-size: 14px;
}
.ant-popover-buttons {
  margin-bottom: 4px;
  text-align: right;
}
.ant-popover-buttons button:not(:first-child) {
  margin-left: 8px;
}
.ant-popover-arrow {
  position: absolute;
  display: block;
  width: 22px;
  height: 22px;
  overflow: hidden;
  background: transparent;
  pointer-events: none;
}
.ant-popover-arrow-content {
  --antd-arrow-background-color: #fff;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 11.3137085px;
  height: 11.3137085px;
  margin: auto;
  content: '';
  pointer-events: auto;
  border-radius: 0 0 2px;
  pointer-events: none;
}
.ant-popover-arrow-content::before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: var(--antd-arrow-background-color);
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: '';
  clip-path: inset(33% 33%);
  clip-path: path('M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z');
}
.ant-popover-placement-top .ant-popover-arrow,
.ant-popover-placement-topLeft .ant-popover-arrow,
.ant-popover-placement-topRight .ant-popover-arrow {
  bottom: 0;
  transform: translateY(100%);
}
.ant-popover-placement-top .ant-popover-arrow-content,
.ant-popover-placement-topLeft .ant-popover-arrow-content,
.ant-popover-placement-topRight .ant-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(-11px) rotate(45deg);
}
.ant-popover-placement-top .ant-popover-arrow {
  left: 50%;
  transform: translateY(100%) translateX(-50%);
}
.ant-popover-placement-topLeft .ant-popover-arrow {
  left: 16px;
}
.ant-popover-placement-topRight .ant-popover-arrow {
  right: 16px;
}
.ant-popover-placement-right .ant-popover-arrow,
.ant-popover-placement-rightTop .ant-popover-arrow,
.ant-popover-placement-rightBottom .ant-popover-arrow {
  left: 0;
  transform: translateX(-100%);
}
.ant-popover-placement-right .ant-popover-arrow-content,
.ant-popover-placement-rightTop .ant-popover-arrow-content,
.ant-popover-placement-rightBottom .ant-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(11px) rotate(135deg);
}
.ant-popover-placement-right .ant-popover-arrow {
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
}
.ant-popover-placement-rightTop .ant-popover-arrow {
  top: 12px;
}
.ant-popover-placement-rightBottom .ant-popover-arrow {
  bottom: 12px;
}
.ant-popover-placement-bottom .ant-popover-arrow,
.ant-popover-placement-bottomLeft .ant-popover-arrow,
.ant-popover-placement-bottomRight .ant-popover-arrow {
  top: 0;
  transform: translateY(-100%);
}
.ant-popover-placement-bottom .ant-popover-arrow-content,
.ant-popover-placement-bottomLeft .ant-popover-arrow-content,
.ant-popover-placement-bottomRight .ant-popover-arrow-content {
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.06);
  transform: translateY(11px) rotate(-135deg);
}
.ant-popover-placement-bottom .ant-popover-arrow {
  left: 50%;
  transform: translateY(-100%) translateX(-50%);
}
.ant-popover-placement-bottomLeft .ant-popover-arrow {
  left: 16px;
}
.ant-popover-placement-bottomRight .ant-popover-arrow {
  right: 16px;
}
.ant-popover-placement-left .ant-popover-arrow,
.ant-popover-placement-leftTop .ant-popover-arrow,
.ant-popover-placement-leftBottom .ant-popover-arrow {
  right: 0;
  transform: translateX(100%);
}
.ant-popover-placement-left .ant-popover-arrow-content,
.ant-popover-placement-leftTop .ant-popover-arrow-content,
.ant-popover-placement-leftBottom .ant-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(-11px) rotate(-45deg);
}
.ant-popover-placement-left .ant-popover-arrow {
  top: 50%;
  transform: translateX(100%) translateY(-50%);
}
.ant-popover-placement-leftTop .ant-popover-arrow {
  top: 12px;
}
.ant-popover-placement-leftBottom .ant-popover-arrow {
  bottom: 12px;
}
.ant-popover-pink .ant-popover-inner {
  background-color: #eb2f96;
}
.ant-popover-pink .ant-popover-arrow-content {
  background-color: #eb2f96;
}
.ant-popover-magenta .ant-popover-inner {
  background-color: #eb2f96;
}
.ant-popover-magenta .ant-popover-arrow-content {
  background-color: #eb2f96;
}
.ant-popover-red .ant-popover-inner {
  background-color: #f5222d;
}
.ant-popover-red .ant-popover-arrow-content {
  background-color: #f5222d;
}
.ant-popover-volcano .ant-popover-inner {
  background-color: #fa541c;
}
.ant-popover-volcano .ant-popover-arrow-content {
  background-color: #fa541c;
}
.ant-popover-orange .ant-popover-inner {
  background-color: #fa8c16;
}
.ant-popover-orange .ant-popover-arrow-content {
  background-color: #fa8c16;
}
.ant-popover-yellow .ant-popover-inner {
  background-color: #fadb14;
}
.ant-popover-yellow .ant-popover-arrow-content {
  background-color: #fadb14;
}
.ant-popover-gold .ant-popover-inner {
  background-color: #faad14;
}
.ant-popover-gold .ant-popover-arrow-content {
  background-color: #faad14;
}
.ant-popover-cyan .ant-popover-inner {
  background-color: #13c2c2;
}
.ant-popover-cyan .ant-popover-arrow-content {
  background-color: #13c2c2;
}
.ant-popover-lime .ant-popover-inner {
  background-color: #a0d911;
}
.ant-popover-lime .ant-popover-arrow-content {
  background-color: #a0d911;
}
.ant-popover-green .ant-popover-inner {
  background-color: #52c41a;
}
.ant-popover-green .ant-popover-arrow-content {
  background-color: #52c41a;
}
.ant-popover-blue .ant-popover-inner {
  background-color: #1890ff;
}
.ant-popover-blue .ant-popover-arrow-content {
  background-color: #1890ff;
}
.ant-popover-geekblue .ant-popover-inner {
  background-color: #2f54eb;
}
.ant-popover-geekblue .ant-popover-arrow-content {
  background-color: #2f54eb;
}
.ant-popover-purple .ant-popover-inner {
  background-color: #722ed1;
}
.ant-popover-purple .ant-popover-arrow-content {
  background-color: #722ed1;
}
.ant-popover-rtl {
  direction: rtl;
  text-align: right;
}
.ant-popover-rtl .ant-popover-message-icon {
  margin-right: 0;
  margin-left: 8px;
}
.ant-popover-rtl .ant-popover-message-title {
  padding-left: 16px;
}
.ant-popover-rtl .ant-popover-buttons {
  text-align: left;
}
.ant-popover-rtl .ant-popover-buttons button {
  margin-right: 8px;
  margin-left: 0;
}
.ant-progress {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.ant-progress-line {
  position: relative;
  width: 100%;
  font-size: 14px;
}
.ant-progress-steps {
  display: inline-block;
}
.ant-progress-steps-outer {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ant-progress-steps-item {
  flex-shrink: 0;
  min-width: 2px;
  margin-right: 2px;
  background: #f3f3f3;
  transition: all 0.3s;
}
.ant-progress-steps-item-active {
  background: var(--app-primary-color);
}
.ant-progress-small.ant-progress-line,
.ant-progress-small.ant-progress-line .ant-progress-text .anticon {
  font-size: 12px;
}
.ant-progress-outer {
  display: inline-block;
  width: 100%;
  margin-right: 0;
  padding-right: 0;
}
.ant-progress-show-info .ant-progress-outer {
  margin-right: calc(-2em - 8px);
  padding-right: calc(2em + 8px);
}
.ant-progress-inner {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  vertical-align: middle;
  background-color: #f5f5f5;
  border-radius: 100px;
}
.ant-progress-circle-trail {
  stroke: #f5f5f5;
}
.ant-progress-circle-path {
  animation: ant-progress-appear 0.3s;
}
.ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: var(--app-primary-color);
}
.ant-progress-success-bg,
.ant-progress-bg {
  position: relative;
  background-color: var(--app-primary-color);
  border-radius: 100px;
  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
}
.ant-progress-success-bg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #52c41a;
}
.ant-progress-text {
  display: inline-block;
  width: 2em;
  margin-left: 8px;
  color: #545454;
  font-size: 1em;
  line-height: 1;
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
  word-break: normal;
}
.ant-progress-text .anticon {
  font-size: 14px;
}
.ant-progress-status-active .ant-progress-bg::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 10px;
  opacity: 0;
  animation: ant-progress-active 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
  content: '';
}
.ant-progress-status-exception .ant-progress-bg {
  background-color: #f5222d;
}
.ant-progress-status-exception .ant-progress-text {
  color: #f5222d;
}
.ant-progress-status-exception .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #f5222d;
}
.ant-progress-status-success .ant-progress-bg {
  background-color: #52c41a;
}
.ant-progress-status-success .ant-progress-text {
  color: #52c41a;
}
.ant-progress-status-success .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #52c41a;
}
.ant-progress-circle .ant-progress-inner {
  position: relative;
  line-height: 1;
  background-color: transparent;
}
.ant-progress-circle .ant-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 1em;
  line-height: 1;
  white-space: normal;
  text-align: center;
  transform: translate(-50%, -50%);
}
.ant-progress-circle .ant-progress-text .anticon {
  font-size: 1.16666667em;
}
.ant-progress-circle.ant-progress-status-exception .ant-progress-text {
  color: #f5222d;
}
.ant-progress-circle.ant-progress-status-success .ant-progress-text {
  color: #52c41a;
}
@keyframes ant-progress-active {
  0% {
    transform: translateX(-100%) scaleX(0);
    opacity: 0.1;
  }
  20% {
    transform: translateX(-100%) scaleX(0);
    opacity: 0.5;
  }
  100% {
    transform: translateX(0) scaleX(1);
    opacity: 0;
  }
}
.ant-progress-rtl {
  direction: rtl;
}
.ant-progress-rtl.ant-progress-show-info .ant-progress-outer {
  margin-right: 0;
  margin-left: calc(-2em - 8px);
  padding-right: 0;
  padding-left: calc(2em + 8px);
}
.ant-progress-rtl .ant-progress-success-bg {
  right: 0;
  left: auto;
}
.ant-progress-rtl.ant-progress-line .ant-progress-text,
.ant-progress-rtl.ant-progress-steps .ant-progress-text {
  margin-right: 8px;
  margin-left: 0;
  text-align: right;
}
.ant-radio-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
  font-size: 0;
}
.ant-radio-group .ant-badge-count {
  z-index: 1;
}
.ant-radio-group > .ant-badge:not(:first-child) > .ant-radio-button-wrapper {
  border-left: none;
}
.ant-radio-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-flex;
  align-items: baseline;
  margin-right: 8px;
  cursor: pointer;
}
.ant-radio-wrapper-disabled {
  cursor: not-allowed;
}
.ant-radio-wrapper::after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: '\\a0';
}
.ant-radio-wrapper.ant-radio-wrapper-in-form-item input[type='radio'] {
  width: 14px;
  height: 14px;
}
.ant-radio {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: 0.2em;
  display: inline-block;
  outline: none;
  cursor: pointer;
}
.ant-radio-wrapper:hover .ant-radio,
.ant-radio:hover .ant-radio-inner,
.ant-radio-input:focus + .ant-radio-inner {
  border-color: #351a55;
}
.ant-radio-input:focus + .ant-radio-inner {
  box-shadow: 0 0 0 3px rgba(53, 26, 85, 0.12);
}
.ant-radio-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #351a55;
  border-radius: 50%;
  visibility: hidden;
  animation: antRadioEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  content: '';
}
.ant-radio:hover::after,
.ant-radio-wrapper:hover .ant-radio::after {
  visibility: visible;
}
.ant-radio-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-color: #d9d9d9;
  border-style: solid;
  border-width: 1px;
  border-radius: 50%;
  transition: all 0.3s;
}
.ant-radio-inner::after {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 16px;
  height: 16px;
  margin-top: -8px;
  margin-left: -8px;
  background-color: #351a55;
  border-top: 0;
  border-left: 0;
  border-radius: 16px;
  transform: scale(0);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  content: ' ';
}
.ant-radio-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}
.ant-radio.ant-radio-disabled .ant-radio-inner {
  border-color: #d9d9d9;
}
.ant-radio-checked .ant-radio-inner {
  border-color: #351a55;
}
.ant-radio-checked .ant-radio-inner::after {
  transform: scale(0.5);
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-radio-disabled {
  cursor: not-allowed;
}
.ant-radio-disabled .ant-radio-inner {
  background-color: #f5f5f5;
  cursor: not-allowed;
}
.ant-radio-disabled .ant-radio-inner::after {
  background-color: rgba(0, 0, 0, 0.2);
}
.ant-radio-disabled .ant-radio-input {
  cursor: not-allowed;
}
.ant-radio-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
span.ant-radio + * {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-radio-button-wrapper {
  position: relative;
  display: inline-block;
  height: 36px;
  margin: 0;
  padding: 0 15px;
  color: #545454;
  font-size: 14px;
  line-height: 34px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-top-width: 1.02px;
  border-left-width: 0;
  cursor: pointer;
  transition: color 0.3s, background 0.3s, border-color 0.3s, box-shadow 0.3s;
}
.ant-radio-button-wrapper a {
  color: #545454;
}
.ant-radio-button-wrapper > .ant-radio-button {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
}
.ant-radio-group-large .ant-radio-button-wrapper {
  height: 40px;
  font-size: 16px;
  line-height: 38px;
}
.ant-radio-group-small .ant-radio-button-wrapper {
  height: 24px;
  padding: 0 7px;
  line-height: 22px;
}
.ant-radio-button-wrapper:not(:first-child)::before {
  position: absolute;
  top: -1px;
  left: -1px;
  display: block;
  box-sizing: content-box;
  width: 1px;
  height: 100%;
  padding: 1px 0;
  background-color: #d9d9d9;
  transition: background-color 0.3s;
  content: '';
}
.ant-radio-button-wrapper:first-child {
  border-left: 1px solid #d9d9d9;
  border-radius: 6px 0 0 6px;
}
.ant-radio-button-wrapper:last-child {
  border-radius: 0 6px 6px 0;
}
.ant-radio-button-wrapper:first-child:last-child {
  border-radius: 6px;
}
.ant-radio-button-wrapper:hover {
  position: relative;
  color: #351a55;
}
.ant-radio-button-wrapper:focus-within {
  box-shadow: 0 0 0 3px rgba(53, 26, 85, 0.12);
}
.ant-radio-button-wrapper .ant-radio-inner,
.ant-radio-button-wrapper input[type='checkbox'],
.ant-radio-button-wrapper input[type='radio'] {
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  z-index: 1;
  color: #351a55;
  background: #fff;
  border-color: #351a55;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
  background-color: #351a55;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {
  border-color: #351a55;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #462e61;
  border-color: #462e61;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover::before {
  background-color: #462e61;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
  color: #1a0c2e;
  border-color: #1a0c2e;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active::before {
  background-color: #1a0c2e;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
  box-shadow: 0 0 0 3px rgba(53, 26, 85, 0.12);
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #fff;
  background: #351a55;
  border-color: #351a55;
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #fff;
  background: #462e61;
  border-color: #462e61;
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
  color: #fff;
  background: #1a0c2e;
  border-color: #1a0c2e;
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
  box-shadow: 0 0 0 3px rgba(53, 26, 85, 0.12);
}
.ant-radio-button-wrapper-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-radio-button-wrapper-disabled:first-child,
.ant-radio-button-wrapper-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}
.ant-radio-button-wrapper-disabled:first-child {
  border-left-color: #d9d9d9;
}
.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {
  color: rgba(0, 0, 0, 0.25);
  background-color: #e6e6e6;
  border-color: #d9d9d9;
  box-shadow: none;
}
@keyframes antRadioEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}
.ant-radio-group.ant-radio-group-rtl {
  direction: rtl;
}
.ant-radio-wrapper.ant-radio-wrapper-rtl {
  margin-right: 0;
  margin-left: 8px;
  direction: rtl;
}
.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl {
  border-right-width: 0;
  border-left-width: 1px;
}
.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:not(:first-child)::before {
  right: -1px;
  left: 0;
}
.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:first-child {
  border-right: 1px solid #d9d9d9;
  border-radius: 0 6px 6px 0;
}
.ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {
  border-right-color: #462e61;
}
.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:last-child {
  border-radius: 6px 0 0 6px;
}
.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper-disabled:first-child {
  border-right-color: #d9d9d9;
}
.ant-rate {
  box-sizing: border-box;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  font-feature-settings: 'tnum';
  display: inline-block;
  margin: 0;
  padding: 0;
  color: #fadb14;
  font-size: 20px;
  line-height: unset;
  list-style: none;
  outline: none;
}
.ant-rate-disabled .ant-rate-star {
  cursor: default;
}
.ant-rate-disabled .ant-rate-star > div:hover {
  transform: scale(1);
}
.ant-rate-star {
  position: relative;
  display: inline-block;
  color: inherit;
  cursor: pointer;
}
.ant-rate-star:not(:last-child) {
  margin-right: 8px;
}
.ant-rate-star > div {
  transition: all 0.3s, outline 0s;
}
.ant-rate-star > div:hover {
  transform: scale(1.1);
}
.ant-rate-star > div:focus {
  outline: 0;
}
.ant-rate-star > div:focus-visible {
  outline: 1px dashed #fadb14;
  transform: scale(1.1);
}
.ant-rate-star-first,
.ant-rate-star-second {
  color: #e8e8e8;
  transition: all 0.3s;
  user-select: none;
}
.ant-rate-star-first .anticon,
.ant-rate-star-second .anticon {
  vertical-align: middle;
}
.ant-rate-star-first {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
  opacity: 0;
}
.ant-rate-star-half .ant-rate-star-first,
.ant-rate-star-half .ant-rate-star-second {
  opacity: 1;
}
.ant-rate-star-half .ant-rate-star-first,
.ant-rate-star-full .ant-rate-star-second {
  color: inherit;
}
.ant-rate-text {
  display: inline-block;
  margin: 0 8px;
  font-size: 14px;
}
.ant-rate-rtl {
  direction: rtl;
}
.ant-rate-rtl .ant-rate-star:not(:last-child) {
  margin-right: 0;
  margin-left: 8px;
}
.ant-rate-rtl .ant-rate-star-first {
  right: 0;
  left: auto;
}
.ant-result {
  padding: 48px 32px;
}
.ant-result-success .ant-result-icon > .anticon {
  color: #52c41a;
}
.ant-result-error .ant-result-icon > .anticon {
  color: #f5222d;
}
.ant-result-info .ant-result-icon > .anticon {
  color: #1890ff;
}
.ant-result-warning .ant-result-icon > .anticon {
  color: #fa8c16;
}
.ant-result-image {
  width: 250px;
  height: 295px;
  margin: auto;
}
.ant-result-icon {
  margin-bottom: 24px;
  text-align: center;
}
.ant-result-icon > .anticon {
  font-size: 72px;
}
.ant-result-title {
  color: #535353;
  font-size: 24px;
  line-height: 1.8;
  text-align: center;
}
.ant-result-subtitle {
  color: #595959;
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
}
.ant-result-extra {
  margin: 24px 0 0 0;
  text-align: center;
}
.ant-result-extra > * {
  margin-right: 8px;
}
.ant-result-extra > *:last-child {
  margin-right: 0;
}
.ant-result-content {
  margin-top: 24px;
  padding: 24px 40px;
  background-color: #fafafa;
}
.ant-result-rtl {
  direction: rtl;
}
.ant-result-rtl .ant-result-extra > * {
  margin-right: 0;
  margin-left: 8px;
}
.ant-result-rtl .ant-result-extra > *:last-child {
  margin-left: 0;
}
.segmented-disabled-item,
.segmented-disabled-item:hover,
.segmented-disabled-item:focus {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.segmented-item-selected {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);
}
.segmented-text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
}
.ant-segmented {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
  padding: 2px;
  color: rgba(0, 0, 0, 0.65);
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 6px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-segmented-group {
  position: relative;
  display: flex;
  align-items: stretch;
  justify-items: flex-start;
  width: 100%;
}
.ant-segmented.ant-segmented-block {
  display: flex;
}
.ant-segmented.ant-segmented-block .ant-segmented-item {
  flex: 1;
  min-width: 0;
}
.ant-segmented:not(.ant-segmented-disabled):hover,
.ant-segmented:not(.ant-segmented-disabled):focus {
  background-color: rgba(0, 0, 0, 0.06);
}
.ant-segmented-item {
  position: relative;
  text-align: center;
  cursor: pointer;
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-segmented-item-selected {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);
  color: #262626;
}
.ant-segmented-item:hover,
.ant-segmented-item:focus {
  color: #262626;
}
.ant-segmented-item-label {
  min-height: 32px;
  padding: 0 11px;
  line-height: 32px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
}
.ant-segmented-item-icon + * {
  margin-left: 6px;
}
.ant-segmented-item-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}
.ant-segmented.ant-segmented-lg .ant-segmented-item-label {
  min-height: 36px;
  padding: 0 11px;
  font-size: 16px;
  line-height: 36px;
}
.ant-segmented.ant-segmented-sm .ant-segmented-item-label {
  min-height: 20px;
  padding: 0 7px;
  line-height: 20px;
}
.ant-segmented-item-disabled,
.ant-segmented-item-disabled:hover,
.ant-segmented-item-disabled:focus {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-segmented-thumb {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  padding: 4px 0;
}
.ant-segmented-thumb-motion-appear-active {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  will-change: transform, width;
}
.ant-segmented.ant-segmented-rtl {
  direction: rtl;
}
.ant-segmented.ant-segmented-rtl .ant-segmented-item-icon {
  margin-right: 0;
  margin-left: 6px;
}
.ant-select-single .ant-select-selector {
  display: flex;
}
.ant-select-single .ant-select-selector .ant-select-selection-search {
  position: absolute;
  top: 0;
  right: 11px;
  bottom: 0;
  left: 11px;
}
.ant-select-single .ant-select-selector .ant-select-selection-search-input {
  width: 100%;
}
.ant-select-single .ant-select-selector .ant-select-selection-item,
.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  padding: 0;
  line-height: 34px;
  transition: all 0.3s, visibility 0s;
}
.ant-select-single .ant-select-selector .ant-select-selection-item {
  position: relative;
  user-select: none;
}
.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  transition: none;
  pointer-events: none;
}
.ant-select-single .ant-select-selector::after,
.ant-select-single .ant-select-selector .ant-select-selection-item::after,
.ant-select-single .ant-select-selector .ant-select-selection-placeholder::after {
  display: inline-block;
  width: 0;
  visibility: hidden;
  content: '\\a0';
}
.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
  right: 25px;
}
.ant-select-single.ant-select-show-arrow .ant-select-selection-item,
.ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 18px;
}
.ant-select-single.ant-select-open .ant-select-selection-item {
  color: #bfbfbf;
}
.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  width: 100%;
  height: 36px;
  padding: 0 11px;
}
.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
  height: 34px;
}
.ant-select-single:not(.ant-select-customize-input) .ant-select-selector::after {
  line-height: 34px;
}
.ant-select-single.ant-select-customize-input .ant-select-selector::after {
  display: none;
}
.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-search {
  position: static;
  width: 100%;
}
.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-placeholder {
  position: absolute;
  right: 0;
  left: 0;
  padding: 0 11px;
}
.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-placeholder::after {
  display: none;
}
.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
  height: 40px;
}
.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector::after,
.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item,
.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder {
  line-height: 38px;
}
.ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input) .ant-select-selection-search-input {
  height: 38px;
}
.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {
  height: 24px;
}
.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector::after,
.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item,
.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder {
  line-height: 22px;
}
.ant-select-single.ant-select-sm:not(.ant-select-customize-input):not(.ant-select-customize-input) .ant-select-selection-search-input {
  height: 22px;
}
.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selection-search {
  right: 7px;
  left: 7px;
}
.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {
  padding: 0 7px;
}
.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-search {
  right: 28px;
}
.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-item,
.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 21px;
}
.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
  padding: 0 11px;
}
/**
 * Do not merge \`height\` & \`line-height\` under style with \`selection\` & \`search\`,
 * since chrome may update to redesign with its align logic.
 */
.ant-select-selection-overflow {
  position: relative;
  display: flex;
  flex: auto;
  flex-wrap: wrap;
  max-width: 100%;
}
.ant-select-selection-overflow-item {
  flex: none;
  align-self: center;
  max-width: 100%;
}
.ant-select-multiple .ant-select-selector {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 2.9px 7.9px;
}
.ant-select-show-search.ant-select-multiple .ant-select-selector {
  cursor: text;
}
.ant-select-disabled.ant-select-multiple .ant-select-selector {
  background: #f5f5f5;
  cursor: not-allowed;
}
.ant-select-multiple .ant-select-selector::after {
  display: inline-block;
  width: 0;
  margin: 4px 0;
  line-height: 20.2px;
  visibility: hidden;
  content: '\\a0';
}
.ant-select-multiple.ant-select-show-arrow .ant-select-selector,
.ant-select-multiple.ant-select-allow-clear .ant-select-selector {
  padding-right: 24px;
}
.ant-select-multiple .ant-select-selection-item {
  position: relative;
  display: flex;
  flex: none;
  box-sizing: border-box;
  max-width: 100%;
  height: 20.2px;
  margin-top: 4px;
  margin-bottom: 4px;
  line-height: 18.2px;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  cursor: default;
  transition: font-size 0.3s, line-height 0.3s, height 0.3s;
  user-select: none;
  margin-inline-end: 7.9px;
  padding-inline-start: 8px;
  padding-inline-end: 4px;
}
.ant-select-disabled.ant-select-multiple .ant-select-selection-item {
  color: #bfbfbf;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-select-multiple .ant-select-selection-item-content {
  display: inline-block;
  margin-right: 4px;
  overflow: hidden;
  white-space: pre;
  text-overflow: ellipsis;
}
.ant-select-multiple .ant-select-selection-item-remove {
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-flex;
  align-items: center;
  color: #595959;
  font-weight: bold;
  font-size: 10px;
  line-height: inherit;
  cursor: pointer;
}
.ant-select-multiple .ant-select-selection-item-remove > * {
  line-height: 1;
}
.ant-select-multiple .ant-select-selection-item-remove svg {
  display: inline-block;
}
.ant-select-multiple .ant-select-selection-item-remove::before {
  display: none;
}
.ant-select-multiple .ant-select-selection-item-remove .ant-select-multiple .ant-select-selection-item-remove-icon {
  display: block;
}
.ant-select-multiple .ant-select-selection-item-remove > .anticon {
  vertical-align: middle;
}
.ant-select-multiple .ant-select-selection-item-remove:hover {
  color: rgba(0, 0, 0, 0.75);
}
.ant-select-multiple .ant-select-selection-overflow-item + .ant-select-selection-overflow-item .ant-select-selection-search {
  margin-inline-start: 0;
}
.ant-select-multiple .ant-select-selection-search {
  position: relative;
  max-width: 100%;
  margin-inline-start: 3.1px;
}
.ant-select-multiple .ant-select-selection-search-input,
.ant-select-multiple .ant-select-selection-search-mirror {
  height: 20.2px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  line-height: 20.2px;
  transition: all 0.3s;
}
.ant-select-multiple .ant-select-selection-search-input {
  width: 100%;
  min-width: 4.1px;
}
.ant-select-multiple .ant-select-selection-search-mirror {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  white-space: pre;
  visibility: hidden;
}
.ant-select-multiple .ant-select-selection-placeholder {
  position: absolute;
  top: 50%;
  right: 11px;
  left: 11px;
  transform: translateY(-50%);
  transition: all 0.3s;
}
.ant-select-multiple.ant-select-lg .ant-select-selector::after {
  line-height: 24.2px;
}
.ant-select-multiple.ant-select-lg .ant-select-selection-item {
  height: 24.2px;
  line-height: 22.2px;
}
.ant-select-multiple.ant-select-lg .ant-select-selection-search {
  height: 24.2px;
  line-height: 24.2px;
}
.ant-select-multiple.ant-select-lg .ant-select-selection-search-input,
.ant-select-multiple.ant-select-lg .ant-select-selection-search-mirror {
  height: 24.2px;
  line-height: 22.2px;
}
.ant-select-multiple.ant-select-sm .ant-select-selector::after {
  line-height: 8.2px;
}
.ant-select-multiple.ant-select-sm .ant-select-selection-item {
  height: 8.2px;
  line-height: 6.2px;
}
.ant-select-multiple.ant-select-sm .ant-select-selection-search {
  height: 8.2px;
  line-height: 8.2px;
}
.ant-select-multiple.ant-select-sm .ant-select-selection-search-input,
.ant-select-multiple.ant-select-sm .ant-select-selection-search-mirror {
  height: 8.2px;
  line-height: 6.2px;
}
.ant-select-multiple.ant-select-sm .ant-select-selection-placeholder {
  left: 7px;
}
.ant-select-multiple.ant-select-sm .ant-select-selection-search {
  margin-inline-start: 3px;
}
.ant-select-disabled .ant-select-selection-item-remove {
  display: none;
}
.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  background-color: #fff;
  border-color: #f5222d !important;
}
.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector,
.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  background-color: #fff;
  border-color: #fa8c16 !important;
}
.ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector,
.ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector {
  border-color: #ffa940;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-select-status-error.ant-select-has-feedback .ant-select-clear,
.ant-select-status-warning.ant-select-has-feedback .ant-select-clear,
.ant-select-status-success.ant-select-has-feedback .ant-select-clear,
.ant-select-status-validating.ant-select-has-feedback .ant-select-clear {
  right: 32px;
}
.ant-select-status-error.ant-select-has-feedback .ant-select-selection-selected-value,
.ant-select-status-warning.ant-select-has-feedback .ant-select-selection-selected-value,
.ant-select-status-success.ant-select-has-feedback .ant-select-selection-selected-value,
.ant-select-status-validating.ant-select-has-feedback .ant-select-selection-selected-value {
  padding-right: 42px;
}
/* Reset search input style */
.ant-select {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  position: relative;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
  cursor: pointer;
}
.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  cursor: text;
}
.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
  cursor: auto;
}
.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  cursor: not-allowed;
}
.ant-select-multiple.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background: #f5f5f5;
}
.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
  cursor: not-allowed;
}
.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  appearance: none;
}
.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input::-webkit-search-cancel-button {
  display: none;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-appearance: none;
}
.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-select-selection-item {
  flex: 1;
  overflow: hidden;
  font-weight: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media all and (-ms-high-contrast: none) {
  .ant-select-selection-item *::-ms-backdrop,
  .ant-select-selection-item {
    flex: auto;
  }
}
.ant-select-selection-placeholder {
  flex: 1;
  overflow: hidden;
  color: #bfbfbf;
  white-space: nowrap;
  text-overflow: ellipsis;
  pointer-events: none;
}
@media all and (-ms-high-contrast: none) {
  .ant-select-selection-placeholder *::-ms-backdrop,
  .ant-select-selection-placeholder {
    flex: auto;
  }
}
.ant-select-arrow {
  display: inline-flex;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  right: 11px;
  display: flex;
  align-items: center;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 1;
  text-align: center;
  pointer-events: none;
}
.ant-select-arrow > * {
  line-height: 1;
}
.ant-select-arrow svg {
  display: inline-block;
}
.ant-select-arrow::before {
  display: none;
}
.ant-select-arrow .ant-select-arrow-icon {
  display: block;
}
.ant-select-arrow .anticon {
  vertical-align: top;
  transition: transform 0.3s;
}
.ant-select-arrow .anticon > svg {
  vertical-align: top;
}
.ant-select-arrow .anticon:not(.ant-select-suffix) {
  pointer-events: auto;
}
.ant-select-disabled .ant-select-arrow {
  cursor: not-allowed;
}
.ant-select-arrow > *:not(:last-child) {
  margin-inline-end: 8px;
}
.ant-select-clear {
  position: absolute;
  top: 50%;
  right: 11px;
  z-index: 1;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  font-style: normal;
  line-height: 1;
  text-align: center;
  text-transform: none;
  background: #fff;
  cursor: pointer;
  opacity: 0;
  transition: color 0.3s ease, opacity 0.15s ease;
  text-rendering: auto;
}
.ant-select-clear::before {
  display: block;
}
.ant-select-clear:hover {
  color: #595959;
}
.ant-select:hover .ant-select-clear {
  opacity: 1;
}
.ant-select-dropdown {
  margin: 0;
  padding: 0;
  color: #545454;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  box-sizing: border-box;
  padding: 4px 0;
  overflow: hidden;
  font-size: 14px;
  font-variant: initial;
  background-color: #fff;
  border-radius: 6px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.ant-select-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-select-dropdown-placement-bottomLeft,
.ant-select-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpIn;
}
.ant-select-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-select-dropdown-placement-topLeft,
.ant-select-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownIn;
}
.ant-select-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpOut;
}
.ant-select-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownOut;
}
.ant-select-dropdown-hidden {
  display: none;
}
.ant-select-dropdown-empty {
  color: rgba(0, 0, 0, 0.25);
}
.ant-select-item-empty {
  position: relative;
  display: block;
  min-height: 32px;
  padding: 5px 12px;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.25);
}
.ant-select-item {
  position: relative;
  display: block;
  min-height: 32px;
  padding: 5px 12px;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
  transition: background 0.3s ease;
}
.ant-select-item-group {
  color: #595959;
  font-size: 12px;
  cursor: default;
}
.ant-select-item-option {
  display: flex;
}
.ant-select-item-option-content {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-select-item-option-state {
  flex: none;
}
.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background-color: #f5f5f5;
}
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  color: #545454;
  font-weight: 600;
  background-color: #908b94;
}
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {
  color: #351a55;
}
.ant-select-item-option-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-item-option-disabled.ant-select-item-option-selected {
  background-color: #f5f5f5;
}
.ant-select-item-option-grouped {
  padding-left: 24px;
}
.ant-select-lg {
  font-size: 16px;
}
.ant-select-borderless .ant-select-selector {
  background-color: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
}
.ant-select.ant-select-in-form-item {
  width: 100%;
}
.ant-select-compact-item:not(.ant-select-compact-last-item) {
  margin-right: -1px;
}
.ant-select-compact-item:not(.ant-select-compact-last-item).ant-select-compact-item-rtl {
  margin-right: 0;
  margin-left: -1px;
}
.ant-select-compact-item:hover > *,
.ant-select-compact-item:focus > *,
.ant-select-compact-item:active > * {
  z-index: 2;
}
.ant-select-compact-item.ant-select-focused > * {
  z-index: 2;
}
.ant-select-compact-item[disabled] > * {
  z-index: 0;
}
.ant-select-compact-item:not(.ant-select-compact-first-item):not(.ant-select-compact-last-item).ant-select > .ant-select-selector {
  border-radius: 0;
}
.ant-select-compact-item.ant-select-compact-first-item.ant-select:not(.ant-select-compact-last-item):not(.ant-select-compact-item-rtl) > .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-select-compact-item.ant-select-compact-last-item.ant-select:not(.ant-select-compact-first-item):not(.ant-select-compact-item-rtl) > .ant-select-selector {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-select-compact-item.ant-select.ant-select-compact-first-item.ant-select-compact-item-rtl:not(.ant-select-compact-last-item) > .ant-select-selector {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-select-compact-item.ant-select.ant-select-compact-last-item.ant-select-compact-item-rtl:not(.ant-select-compact-first-item) > .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-select-rtl {
  direction: rtl;
}
.ant-select-rtl .ant-select-arrow {
  right: initial;
  left: 11px;
}
.ant-select-rtl .ant-select-clear {
  right: initial;
  left: 11px;
}
.ant-select-dropdown-rtl {
  direction: rtl;
}
.ant-select-dropdown-rtl .ant-select-item-option-grouped {
  padding-right: 24px;
  padding-left: 12px;
}
.ant-select-rtl.ant-select-multiple.ant-select-show-arrow .ant-select-selector,
.ant-select-rtl.ant-select-multiple.ant-select-allow-clear .ant-select-selector {
  padding-right: 7.9px;
  padding-left: 24px;
}
.ant-select-rtl.ant-select-multiple .ant-select-selection-item {
  text-align: right;
}
.ant-select-rtl.ant-select-multiple .ant-select-selection-item-content {
  margin-right: 0;
  margin-left: 4px;
  text-align: right;
}
.ant-select-rtl.ant-select-multiple .ant-select-selection-search-mirror {
  right: 0;
  left: auto;
}
.ant-select-rtl.ant-select-multiple .ant-select-selection-placeholder {
  right: 11px;
  left: auto;
}
.ant-select-rtl.ant-select-multiple.ant-select-sm .ant-select-selection-placeholder {
  right: 7px;
}
.ant-select-rtl.ant-select-single .ant-select-selector .ant-select-selection-item,
.ant-select-rtl.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  right: 0;
  left: 9px;
  text-align: right;
}
.ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
  right: 11px;
  left: 25px;
}
.ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-item,
.ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 0;
  padding-left: 18px;
}
.ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-search {
  right: 6px;
}
.ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-item,
.ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 0;
  padding-left: 21px;
}
.ant-skeleton {
  display: table;
  width: 100%;
}
.ant-skeleton-header {
  display: table-cell;
  padding-right: 16px;
  vertical-align: top;
}
.ant-skeleton-header .ant-skeleton-avatar {
  display: inline-block;
  vertical-align: top;
  background: rgba(190, 190, 190, 0.2);
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.ant-skeleton-header .ant-skeleton-avatar.ant-skeleton-avatar-circle {
  border-radius: 50%;
}
.ant-skeleton-header .ant-skeleton-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
.ant-skeleton-header .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {
  border-radius: 50%;
}
.ant-skeleton-header .ant-skeleton-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
.ant-skeleton-header .ant-skeleton-avatar-sm.ant-skeleton-avatar-circle {
  border-radius: 50%;
}
.ant-skeleton-content {
  display: table-cell;
  width: 100%;
  vertical-align: top;
}
.ant-skeleton-content .ant-skeleton-title {
  width: 100%;
  height: 16px;
  background: rgba(190, 190, 190, 0.2);
  border-radius: 6px;
}
.ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
  margin-top: 24px;
}
.ant-skeleton-content .ant-skeleton-paragraph {
  padding: 0;
}
.ant-skeleton-content .ant-skeleton-paragraph > li {
  width: 100%;
  height: 16px;
  list-style: none;
  background: rgba(190, 190, 190, 0.2);
  border-radius: 6px;
}
.ant-skeleton-content .ant-skeleton-paragraph > li:last-child:not(:first-child):not(:nth-child(2)) {
  width: 61%;
}
.ant-skeleton-content .ant-skeleton-paragraph > li + li {
  margin-top: 16px;
}
.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title {
  margin-top: 12px;
}
.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
  margin-top: 28px;
}
.ant-skeleton-round .ant-skeleton-content .ant-skeleton-title,
.ant-skeleton-round .ant-skeleton-content .ant-skeleton-paragraph > li {
  border-radius: 100px;
}
.ant-skeleton-active .ant-skeleton-title,
.ant-skeleton-active .ant-skeleton-paragraph > li,
.ant-skeleton-active .ant-skeleton-avatar,
.ant-skeleton-active .ant-skeleton-button,
.ant-skeleton-active .ant-skeleton-input,
.ant-skeleton-active .ant-skeleton-image {
  position: relative;
  /* stylelint-disable-next-line property-no-vendor-prefix,value-no-vendor-prefix */
  z-index: 0;
  overflow: hidden;
  background: transparent;
}
.ant-skeleton-active .ant-skeleton-title::after,
.ant-skeleton-active .ant-skeleton-paragraph > li::after,
.ant-skeleton-active .ant-skeleton-avatar::after,
.ant-skeleton-active .ant-skeleton-button::after,
.ant-skeleton-active .ant-skeleton-input::after,
.ant-skeleton-active .ant-skeleton-image::after {
  position: absolute;
  top: 0;
  right: -150%;
  bottom: 0;
  left: -150%;
  background: linear-gradient(90deg, rgba(190, 190, 190, 0.2) 25%, rgba(129, 129, 129, 0.24) 37%, rgba(190, 190, 190, 0.2) 63%);
  animation: ant-skeleton-loading 1.4s ease infinite;
  content: '';
}
.ant-skeleton.ant-skeleton-block {
  width: 100%;
}
.ant-skeleton.ant-skeleton-block .ant-skeleton-button {
  width: 100%;
}
.ant-skeleton.ant-skeleton-block .ant-skeleton-input {
  width: 100%;
}
.ant-skeleton-element {
  display: inline-block;
  width: auto;
}
.ant-skeleton-element .ant-skeleton-button {
  display: inline-block;
  vertical-align: top;
  background: rgba(190, 190, 190, 0.2);
  border-radius: 6px;
  width: 72px;
  min-width: 72px;
  height: 36px;
  line-height: 36px;
}
.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-square {
  width: 36px;
  min-width: 36px;
}
.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-circle {
  width: 36px;
  min-width: 36px;
  border-radius: 50%;
}
.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-round {
  border-radius: 36px;
}
.ant-skeleton-element .ant-skeleton-button-lg {
  width: 80px;
  min-width: 80px;
  height: 40px;
  line-height: 40px;
}
.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-square {
  width: 40px;
  min-width: 40px;
}
.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-circle {
  width: 40px;
  min-width: 40px;
  border-radius: 50%;
}
.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-round {
  border-radius: 40px;
}
.ant-skeleton-element .ant-skeleton-button-sm {
  width: 48px;
  min-width: 48px;
  height: 24px;
  line-height: 24px;
}
.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-square {
  width: 24px;
  min-width: 24px;
}
.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-circle {
  width: 24px;
  min-width: 24px;
  border-radius: 50%;
}
.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-round {
  border-radius: 24px;
}
.ant-skeleton-element .ant-skeleton-avatar {
  display: inline-block;
  vertical-align: top;
  background: rgba(190, 190, 190, 0.2);
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.ant-skeleton-element .ant-skeleton-avatar.ant-skeleton-avatar-circle {
  border-radius: 50%;
}
.ant-skeleton-element .ant-skeleton-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
.ant-skeleton-element .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {
  border-radius: 50%;
}
.ant-skeleton-element .ant-skeleton-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
.ant-skeleton-element .ant-skeleton-avatar-sm.ant-skeleton-avatar-circle {
  border-radius: 50%;
}
.ant-skeleton-element .ant-skeleton-input {
  display: inline-block;
  vertical-align: top;
  background: rgba(190, 190, 190, 0.2);
  width: 180px;
  min-width: 180px;
  height: 36px;
  line-height: 36px;
}
.ant-skeleton-element .ant-skeleton-input-lg {
  width: 200px;
  min-width: 200px;
  height: 40px;
  line-height: 40px;
}
.ant-skeleton-element .ant-skeleton-input-sm {
  width: 120px;
  min-width: 120px;
  height: 24px;
  line-height: 24px;
}
.ant-skeleton-element .ant-skeleton-image {
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: top;
  background: rgba(190, 190, 190, 0.2);
  width: 96px;
  height: 96px;
  line-height: 96px;
}
.ant-skeleton-element .ant-skeleton-image.ant-skeleton-image-circle {
  border-radius: 50%;
}
.ant-skeleton-element .ant-skeleton-image-path {
  fill: #bfbfbf;
}
.ant-skeleton-element .ant-skeleton-image-svg {
  width: 48px;
  height: 48px;
  line-height: 48px;
  max-width: 192px;
  max-height: 192px;
}
.ant-skeleton-element .ant-skeleton-image-svg.ant-skeleton-image-circle {
  border-radius: 50%;
}
@keyframes ant-skeleton-loading {
  0% {
    transform: translateX(-37.5%);
  }
  100% {
    transform: translateX(37.5%);
  }
}
.ant-skeleton-rtl {
  direction: rtl;
}
.ant-skeleton-rtl .ant-skeleton-header {
  padding-right: 0;
  padding-left: 16px;
}
.ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title,
.ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph > li {
  animation-name: ant-skeleton-loading-rtl;
}
.ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-avatar {
  animation-name: ant-skeleton-loading-rtl;
}
@keyframes ant-skeleton-loading-rtl {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
.ant-slider {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  height: 12px;
  margin: 10px 6px 10px;
  padding: 4px 0;
  cursor: pointer;
  touch-action: none;
}
.ant-slider-vertical {
  width: 12px;
  height: 100%;
  margin: 6px 10px;
  padding: 0 4px;
}
.ant-slider-vertical .ant-slider-rail {
  width: 4px;
  height: 100%;
}
.ant-slider-vertical .ant-slider-track {
  width: 4px;
}
.ant-slider-vertical .ant-slider-handle {
  margin-top: -6px;
  margin-left: -5px;
}
.ant-slider-vertical .ant-slider-mark {
  top: 0;
  left: 12px;
  width: 18px;
  height: 100%;
}
.ant-slider-vertical .ant-slider-mark-text {
  left: 4px;
  white-space: nowrap;
}
.ant-slider-vertical .ant-slider-step {
  width: 4px;
  height: 100%;
}
.ant-slider-vertical .ant-slider-dot {
  top: auto;
  margin-left: -2px;
}
.ant-slider-tooltip .ant-tooltip-inner {
  min-width: unset;
}
.ant-slider-rtl.ant-slider-vertical .ant-slider-handle {
  margin-right: -5px;
  margin-left: 0;
}
.ant-slider-rtl.ant-slider-vertical .ant-slider-mark {
  right: 12px;
  left: auto;
}
.ant-slider-rtl.ant-slider-vertical .ant-slider-mark-text {
  right: 4px;
  left: auto;
}
.ant-slider-rtl.ant-slider-vertical .ant-slider-dot {
  right: 2px;
  left: auto;
}
.ant-slider-with-marks {
  margin-bottom: 28px;
}
.ant-slider-rail {
  position: absolute;
  width: 100%;
  height: 4px;
  background-color: #f5f5f5;
  border-radius: 6px;
  transition: background-color 0.3s;
}
.ant-slider-track {
  position: absolute;
  height: 4px;
  background-color: #6f617a;
  border-radius: 6px;
  transition: background-color 0.3s;
}
.ant-slider-handle {
  position: absolute;
  width: 14px;
  height: 14px;
  margin-top: -5px;
  background-color: #fff;
  border: solid 2px #6f617a;
  border-radius: 50%;
  box-shadow: 0;
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.6s, transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}
.ant-slider-handle-dragging {
  z-index: 1;
}
.ant-slider-handle:focus {
  border-color: #5d4877;
  outline: none;
  box-shadow: 0 0 0 5px rgba(53, 26, 85, 0.12);
}
.ant-slider-handle.ant-tooltip-open {
  border-color: #351a55;
}
.ant-slider-handle::after {
  position: absolute;
  top: -6px;
  right: -6px;
  bottom: -6px;
  left: -6px;
  content: '';
}
.ant-slider:hover .ant-slider-rail {
  background-color: #e1e1e1;
}
.ant-slider:hover .ant-slider-track {
  background-color: #5a456e;
}
.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
  border-color: #5a456e;
}
.ant-slider-mark {
  position: absolute;
  top: 14px;
  left: 0;
  width: 100%;
  font-size: 14px;
}
.ant-slider-mark-text {
  position: absolute;
  display: inline-block;
  color: #595959;
  text-align: center;
  word-break: keep-all;
  cursor: pointer;
  user-select: none;
}
.ant-slider-mark-text-active {
  color: #545454;
}
.ant-slider-step {
  position: absolute;
  width: 100%;
  height: 4px;
  background: transparent;
  pointer-events: none;
}
.ant-slider-dot {
  position: absolute;
  top: -2px;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border: 2px solid #e8e8e8;
  border-radius: 50%;
  cursor: pointer;
}
.ant-slider-dot-active {
  border-color: #9a8daa;
}
.ant-slider-disabled {
  cursor: not-allowed;
}
.ant-slider-disabled .ant-slider-rail {
  background-color: #f5f5f5 !important;
}
.ant-slider-disabled .ant-slider-track {
  background-color: rgba(0, 0, 0, 0.25) !important;
}
.ant-slider-disabled .ant-slider-handle,
.ant-slider-disabled .ant-slider-dot {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.25) !important;
  box-shadow: none;
  cursor: not-allowed;
}
.ant-slider-disabled .ant-slider-mark-text,
.ant-slider-disabled .ant-slider-dot {
  cursor: not-allowed !important;
}
.ant-slider-rtl {
  direction: rtl;
}
.ant-slider-rtl .ant-slider-mark {
  right: 0;
  left: auto;
}
.ant-space {
  display: inline-flex;
}
.ant-space-vertical {
  flex-direction: column;
}
.ant-space-align-center {
  align-items: center;
}
.ant-space-align-start {
  align-items: flex-start;
}
.ant-space-align-end {
  align-items: flex-end;
}
.ant-space-align-baseline {
  align-items: baseline;
}
.ant-space-item:empty {
  display: none;
}
.ant-space-compact {
  display: inline-flex;
}
.ant-space-compact-block {
  display: flex;
  width: 100%;
}
.ant-space-compact-vertical {
  flex-direction: column;
}
.ant-space-rtl {
  direction: rtl;
}
.ant-space-compact-rtl {
  direction: rtl;
}
.ant-spin {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  display: none;
  color: #351a55;
  font-size: 0;
  text-align: center;
  vertical-align: middle;
  opacity: 0;
  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-spin-spinning {
  position: static;
  display: inline-block;
  opacity: 1;
}
.ant-spin-nested-loading {
  position: relative;
}
.ant-spin-nested-loading > div > .ant-spin {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: block;
  width: 100%;
  height: 100%;
  max-height: 400px;
}
.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px;
}
.ant-spin-nested-loading > div > .ant-spin .ant-spin-text {
  position: absolute;
  top: 50%;
  width: 100%;
  padding-top: 5px;
  font-size: 14px;
  text-shadow: 0 1px 2px #fff;
}
.ant-spin-nested-loading > div > .ant-spin.ant-spin-show-text .ant-spin-dot {
  margin-top: -20px;
}
.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-dot {
  margin: -7px;
}
.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-text {
  padding-top: 2px;
}
.ant-spin-nested-loading > div > .ant-spin-sm.ant-spin-show-text .ant-spin-dot {
  margin-top: -17px;
}
.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-dot {
  margin: -16px;
}
.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {
  padding-top: 11px;
}
.ant-spin-nested-loading > div > .ant-spin-lg.ant-spin-show-text .ant-spin-dot {
  margin-top: -26px;
}
.ant-spin-container {
  position: relative;
  transition: opacity 0.3s;
}
.ant-spin-container::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: none \\9;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0;
  transition: all 0.3s;
  content: '';
  pointer-events: none;
}
.ant-spin-blur {
  clear: both;
  opacity: 0.5;
  user-select: none;
  pointer-events: none;
}
.ant-spin-blur::after {
  opacity: 0.4;
  pointer-events: auto;
}
.ant-spin-tip {
  color: #595959;
}
.ant-spin-dot {
  position: relative;
  display: inline-block;
  font-size: 20px;
  width: 1em;
  height: 1em;
}
.ant-spin-dot-item {
  position: absolute;
  display: block;
  width: 9px;
  height: 9px;
  background-color: #351a55;
  border-radius: 100%;
  transform: scale(0.75);
  transform-origin: 50% 50%;
  opacity: 0.3;
  animation: antSpinMove 1s infinite linear alternate;
}
.ant-spin-dot-item:nth-child(1) {
  top: 0;
  left: 0;
}
.ant-spin-dot-item:nth-child(2) {
  top: 0;
  right: 0;
  animation-delay: 0.4s;
}
.ant-spin-dot-item:nth-child(3) {
  right: 0;
  bottom: 0;
  animation-delay: 0.8s;
}
.ant-spin-dot-item:nth-child(4) {
  bottom: 0;
  left: 0;
  animation-delay: 1.2s;
}
.ant-spin-dot-spin {
  transform: rotate(0deg);
  animation: antRotate 1.2s infinite linear;
}
.ant-spin-sm .ant-spin-dot {
  font-size: 14px;
}
.ant-spin-sm .ant-spin-dot i {
  width: 6px;
  height: 6px;
}
.ant-spin-lg .ant-spin-dot {
  font-size: 32px;
}
.ant-spin-lg .ant-spin-dot i {
  width: 14px;
  height: 14px;
}
.ant-spin.ant-spin-show-text .ant-spin-text {
  display: block;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ */
  .ant-spin-blur {
    background: #fff;
    opacity: 0.5;
  }
}
@keyframes antSpinMove {
  to {
    opacity: 1;
  }
}
@keyframes antRotate {
  to {
    transform: rotate(360deg);
  }
}
.ant-spin-rtl {
  direction: rtl;
}
.ant-spin-rtl .ant-spin-dot-spin {
  transform: rotate(-45deg);
  animation-name: antRotateRtl;
}
@keyframes antRotateRtl {
  to {
    transform: rotate(-405deg);
  }
}
.ant-statistic {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-statistic-title {
  margin-bottom: 4px;
  color: #595959;
  font-size: 14px;
}
.ant-statistic-skeleton {
  padding-top: 16px;
}
.ant-statistic-content {
  color: #535353;
  font-size: 24px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
}
.ant-statistic-content-value {
  display: inline-block;
  direction: ltr;
}
.ant-statistic-content-prefix,
.ant-statistic-content-suffix {
  display: inline-block;
}
.ant-statistic-content-prefix {
  margin-right: 4px;
}
.ant-statistic-content-suffix {
  margin-left: 4px;
}
.ant-statistic-rtl {
  direction: rtl;
}
.ant-statistic-rtl .ant-statistic-content-prefix {
  margin-right: 0;
  margin-left: 4px;
}
.ant-statistic-rtl .ant-statistic-content-suffix {
  margin-right: 4px;
  margin-left: 0;
}
.ant-steps {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: flex;
  width: 100%;
  font-size: 0;
  text-align: initial;
}
.ant-steps-item {
  position: relative;
  display: inline-block;
  flex: 1;
  overflow: hidden;
  vertical-align: top;
}
.ant-steps-item-container {
  outline: none;
}
.ant-steps-item:last-child {
  flex: none;
}
.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-tail,
.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  display: none;
}
.ant-steps-item-icon,
.ant-steps-item-content {
  display: inline-block;
  vertical-align: top;
}
.ant-steps-item-icon {
  width: 32px;
  height: 32px;
  margin: 0 8px 0 0;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  line-height: 32px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 32px;
  transition: background-color 0.3s, border-color 0.3s;
}
.ant-steps-item-icon .ant-steps-icon {
  position: relative;
  top: -0.5px;
  color: #351a55;
  line-height: 1;
}
.ant-steps-item-tail {
  position: absolute;
  top: 12px;
  left: 0;
  width: 100%;
  padding: 0 10px;
}
.ant-steps-item-tail::after {
  display: inline-block;
  width: 100%;
  height: 1px;
  background: #e8e8e8;
  border-radius: 1px;
  transition: background 0.3s;
  content: '';
}
.ant-steps-item-title {
  position: relative;
  display: inline-block;
  padding-right: 16px;
  color: #545454;
  font-size: 16px;
  line-height: 32px;
}
.ant-steps-item-title::after {
  position: absolute;
  top: 16px;
  left: 100%;
  display: block;
  width: 9999px;
  height: 1px;
  background: #e8e8e8;
  content: '';
}
.ant-steps-item-subtitle {
  display: inline;
  margin-left: 8px;
  color: #595959;
  font-weight: normal;
  font-size: 14px;
}
.ant-steps-item-description {
  color: #595959;
  font-size: 14px;
}
.ant-steps-item-wait .ant-steps-item-icon {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
  color: rgba(0, 0, 0, 0.25);
}
.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: rgba(0, 0, 0, 0.25);
}
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: #595959;
}
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #e8e8e8;
}
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: #595959;
}
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: #e8e8e8;
}
.ant-steps-item-process .ant-steps-item-icon {
  background-color: #fff;
  border-color: #351a55;
}
.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #351a55;
}
.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #351a55;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: #535353;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #e8e8e8;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: #545454;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: #e8e8e8;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
  background: #351a55;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon .ant-steps-icon {
  color: #fff;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-title {
  font-weight: 500;
}
.ant-steps-item-finish .ant-steps-item-icon {
  background-color: #fff;
  border-color: #351a55;
}
.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #351a55;
}
.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #351a55;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: #545454;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #351a55;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: #595959;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: #351a55;
}
.ant-steps-item-error .ant-steps-item-icon {
  background-color: #fff;
  border-color: #f5222d;
}
.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon {
  color: #f5222d;
}
.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #f5222d;
}
.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: #f5222d;
}
.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #e8e8e8;
}
.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: #f5222d;
}
.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: #e8e8e8;
}
.ant-steps-item.ant-steps-next-error .ant-steps-item-title::after {
  background: #f5222d;
}
.ant-steps-item-disabled {
  cursor: not-allowed;
}
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] {
  cursor: pointer;
}
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-title,
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-subtitle,
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-description,
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-icon .ant-steps-icon {
  transition: color 0.3s;
}
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-title,
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-subtitle,
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-description {
  color: #351a55;
}
.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon {
  border-color: #351a55;
}
.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon .ant-steps-icon {
  color: #351a55;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-left: 16px;
  white-space: nowrap;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-left: 0;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {
  padding-right: 0;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-tail {
  display: none;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
  max-width: 140px;
  white-space: normal;
}
.ant-steps-item-custom > .ant-steps-item-container > .ant-steps-item-icon {
  height: auto;
  background: none;
  border: 0;
}
.ant-steps-item-custom > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {
  top: 0px;
  left: 0.5px;
  width: 32px;
  height: 32px;
  font-size: 24px;
  line-height: 32px;
}
.ant-steps-item-custom.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #351a55;
}
.ant-steps:not(.ant-steps-vertical) .ant-steps-item-custom .ant-steps-item-icon {
  width: auto;
  background: none;
}
.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-left: 12px;
}
.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-left: 0;
}
.ant-steps-small .ant-steps-item-icon {
  width: 24px;
  height: 24px;
  margin: 0 8px 0 0;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  border-radius: 24px;
}
.ant-steps-small .ant-steps-item-title {
  padding-right: 12px;
  font-size: 14px;
  line-height: 24px;
}
.ant-steps-small .ant-steps-item-title::after {
  top: 12px;
}
.ant-steps-small .ant-steps-item-description {
  color: #595959;
  font-size: 14px;
}
.ant-steps-small .ant-steps-item-tail {
  top: 8px;
}
.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon {
  width: inherit;
  height: inherit;
  line-height: inherit;
  background: none;
  border: 0;
  border-radius: 0;
}
.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
  font-size: 24px;
  line-height: 24px;
  transform: none;
}
.ant-steps-vertical {
  display: flex;
  flex-direction: column;
}
.ant-steps-vertical > .ant-steps-item {
  display: block;
  flex: 1 0 auto;
  padding-left: 0;
  overflow: visible;
}
.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {
  float: left;
  margin-right: 16px;
}
.ant-steps-vertical > .ant-steps-item .ant-steps-item-content {
  display: block;
  min-height: 48px;
  overflow: hidden;
}
.ant-steps-vertical > .ant-steps-item .ant-steps-item-title {
  line-height: 32px;
}
.ant-steps-vertical > .ant-steps-item .ant-steps-item-description {
  padding-bottom: 12px;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  position: absolute;
  top: 0;
  left: 15px;
  width: 1px;
  height: 100%;
  padding: 38px 0 6px;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after {
  width: 1px;
  height: 100%;
}
.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail {
  display: block;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  display: none;
}
.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {
  position: absolute;
  top: 0;
  left: 11px;
  padding: 30px 0 6px;
}
.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-title {
  line-height: 24px;
}
.ant-steps-label-vertical .ant-steps-item {
  overflow: visible;
}
.ant-steps-label-vertical .ant-steps-item-tail {
  margin-left: 58px;
  padding: 3.5px 24px;
}
.ant-steps-label-vertical .ant-steps-item-content {
  display: block;
  width: 116px;
  margin-top: 8px;
  text-align: center;
}
.ant-steps-label-vertical .ant-steps-item-icon {
  display: inline-block;
  margin-left: 42px;
}
.ant-steps-label-vertical .ant-steps-item-title {
  padding-right: 0;
  padding-left: 0;
}
.ant-steps-label-vertical .ant-steps-item-title::after {
  display: none;
}
.ant-steps-label-vertical .ant-steps-item-subtitle {
  display: block;
  margin-bottom: 4px;
  margin-left: 0;
  line-height: 1.3;
}
.ant-steps-label-vertical.ant-steps-small:not(.ant-steps-dot) .ant-steps-item-icon {
  margin-left: 46px;
}
.ant-steps-dot .ant-steps-item-title,
.ant-steps-dot.ant-steps-small .ant-steps-item-title {
  line-height: 1.3;
}
.ant-steps-dot .ant-steps-item-tail,
.ant-steps-dot.ant-steps-small .ant-steps-item-tail {
  top: 2px;
  width: 100%;
  margin: 0 0 0 70px;
  padding: 0;
}
.ant-steps-dot .ant-steps-item-tail::after,
.ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {
  width: calc(100% - 20px);
  height: 3px;
  margin-left: 12px;
}
.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot,
.ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {
  left: 2px;
}
.ant-steps-dot .ant-steps-item-icon,
.ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  width: 8px;
  height: 8px;
  margin-left: 67px;
  padding-right: 0;
  line-height: 8px;
  background: transparent;
  border: 0;
}
.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot,
.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  border-radius: 100px;
  transition: all 0.3s;
  /* expand hover area */
}
.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot::after,
.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot::after {
  position: absolute;
  top: -12px;
  left: -26px;
  width: 60px;
  height: 32px;
  background: rgba(0, 0, 0, 0.001);
  content: '';
}
.ant-steps-dot .ant-steps-item-content,
.ant-steps-dot.ant-steps-small .ant-steps-item-content {
  width: 140px;
}
.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon,
.ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon {
  position: relative;
  top: -1px;
  width: 10px;
  height: 10px;
  line-height: 10px;
  background: none;
}
.ant-steps-dot .ant-steps-item-process .ant-steps-icon:first-child .ant-steps-icon-dot,
.ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-icon:first-child .ant-steps-icon-dot {
  left: 0;
}
.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {
  margin-top: 13px;
  margin-left: 0;
  background: none;
}
.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  top: 6.5px;
  left: -9px;
  margin: 0;
  padding: 22px 0 4px;
}
.ant-steps-vertical.ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  margin-top: 10px;
}
.ant-steps-vertical.ant-steps-dot.ant-steps-small .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  top: 3.5px;
}
.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {
  left: 0;
}
.ant-steps-vertical.ant-steps-dot .ant-steps-item-content {
  width: inherit;
}
.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-item-container .ant-steps-item-icon .ant-steps-icon-dot {
  top: -1px;
  left: -1px;
}
.ant-steps-navigation {
  padding-top: 12px;
}
.ant-steps-navigation.ant-steps-small .ant-steps-item-container {
  margin-left: -12px;
}
.ant-steps-navigation .ant-steps-item {
  overflow: visible;
  text-align: center;
}
.ant-steps-navigation .ant-steps-item-container {
  display: inline-block;
  height: 100%;
  margin-left: -16px;
  padding-bottom: 12px;
  text-align: left;
  transition: opacity 0.3s;
}
.ant-steps-navigation .ant-steps-item-container .ant-steps-item-content {
  max-width: auto;
}
.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {
  max-width: 100%;
  padding-right: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title::after {
  display: none;
}
.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role='button'] {
  cursor: pointer;
}
.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role='button']:hover {
  opacity: 0.85;
}
.ant-steps-navigation .ant-steps-item:last-child {
  flex: 1;
}
.ant-steps-navigation .ant-steps-item:last-child::after {
  display: none;
}
.ant-steps-navigation .ant-steps-item::after {
  position: absolute;
  top: 50%;
  left: 100%;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-top: -14px;
  margin-left: -2px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-bottom: none;
  border-left: none;
  transform: rotate(45deg);
  content: '';
}
.ant-steps-navigation .ant-steps-item::before {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: inline-block;
  width: 0;
  height: 2px;
  background-color: #351a55;
  transition: width 0.3s, left 0.3s;
  transition-timing-function: ease-out;
  content: '';
}
.ant-steps-navigation .ant-steps-item.ant-steps-item-active::before {
  left: 0;
  width: 100%;
}
.ant-steps-navigation.ant-steps-vertical > .ant-steps-item {
  margin-right: 0 !important;
}
.ant-steps-navigation.ant-steps-vertical > .ant-steps-item::before {
  display: none;
}
.ant-steps-navigation.ant-steps-vertical > .ant-steps-item.ant-steps-item-active::before {
  top: 0;
  right: 0;
  left: unset;
  display: block;
  width: 3px;
  height: calc(100% - 24px);
}
.ant-steps-navigation.ant-steps-vertical > .ant-steps-item::after {
  position: relative;
  top: -2px;
  left: 50%;
  display: block;
  width: 8px;
  height: 8px;
  margin-bottom: 8px;
  text-align: center;
  transform: rotate(135deg);
}
.ant-steps-navigation.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  visibility: hidden;
}
.ant-steps-navigation.ant-steps-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  visibility: hidden;
}
.ant-steps-rtl {
  direction: rtl;
}
.ant-steps.ant-steps-rtl .ant-steps-item-icon {
  margin-right: 0;
  margin-left: 8px;
}
.ant-steps-rtl .ant-steps-item-tail {
  right: 0;
  left: auto;
}
.ant-steps-rtl .ant-steps-item-title {
  padding-right: 0;
  padding-left: 16px;
}
.ant-steps-rtl .ant-steps-item-title .ant-steps-item-subtitle {
  float: left;
  margin-right: 8px;
  margin-left: 0;
}
.ant-steps-rtl .ant-steps-item-title::after {
  right: 100%;
  left: auto;
}
.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-right: 16px;
  padding-left: 0;
}
.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-right: 0;
}
.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {
  padding-left: 0;
}
.ant-steps-rtl .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
  right: 0.5px;
  left: auto;
}
.ant-steps-rtl.ant-steps-navigation.ant-steps-small .ant-steps-item-container {
  margin-right: -12px;
  margin-left: 0;
}
.ant-steps-rtl.ant-steps-navigation .ant-steps-item-container {
  margin-right: -16px;
  margin-left: 0;
  text-align: right;
}
.ant-steps-rtl.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {
  padding-left: 0;
}
.ant-steps-rtl.ant-steps-navigation .ant-steps-item::after {
  right: 100%;
  left: auto;
  margin-right: -2px;
  margin-left: 0;
  transform: rotate(225deg);
}
.ant-steps-rtl.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-right: 12px;
  padding-left: 0;
}
.ant-steps-rtl.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-right: 0;
}
.ant-steps-rtl.ant-steps-small .ant-steps-item-title {
  padding-right: 0;
  padding-left: 12px;
}
.ant-steps-rtl.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {
  float: right;
  margin-right: 0;
  margin-left: 16px;
}
.ant-steps-rtl.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: 16px;
  left: auto;
}
.ant-steps-rtl.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {
  right: 12px;
  left: auto;
}
.ant-steps-rtl.ant-steps-label-vertical .ant-steps-item-title {
  padding-left: 0;
}
.ant-steps-rtl.ant-steps-dot .ant-steps-item-tail,
.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-tail {
  margin: 0 70px 0 0;
}
.ant-steps-rtl.ant-steps-dot .ant-steps-item-tail::after,
.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {
  margin-right: 12px;
  margin-left: 0;
}
.ant-steps-rtl.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot,
.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {
  right: 2px;
  left: auto;
}
.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon,
.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  margin-right: 67px;
  margin-left: 0;
}
.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot,
.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {
  /* expand hover area */
}
.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot,
.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {
  float: right;
}
.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot::after,
.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot::after {
  right: -26px;
  left: auto;
}
.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {
  margin-right: 0;
  margin-left: 16px;
}
.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: -9px;
  left: auto;
}
.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {
  right: 0;
  left: auto;
}
.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-icon-dot {
  right: -2px;
  left: auto;
}
.ant-steps-rtl.ant-steps-with-progress.ant-steps-vertical > .ant-steps-item {
  padding-right: 4px;
}
.ant-steps-rtl.ant-steps-with-progress.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: 19px;
}
.ant-steps-rtl.ant-steps-with-progress.ant-steps-small.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: 15px;
}
.ant-steps-rtl.ant-steps-with-progress.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item:first-child {
  padding-right: 4px;
  padding-left: 0;
}
.ant-steps-rtl.ant-steps-with-progress.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item:first-child.ant-steps-item-active {
  padding-right: 4px;
}
.ant-steps-with-progress .ant-steps-item {
  padding-top: 4px;
}
.ant-steps-with-progress .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  top: 4px;
  left: 19px;
}
.ant-steps-with-progress.ant-steps-horizontal .ant-steps-item:first-child,
.ant-steps-with-progress.ant-steps-small.ant-steps-horizontal .ant-steps-item:first-child {
  padding-bottom: 4px;
  padding-left: 4px;
}
.ant-steps-with-progress.ant-steps-small > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  left: 15px;
}
.ant-steps-with-progress.ant-steps-vertical .ant-steps-item {
  padding-left: 4px;
}
.ant-steps-with-progress.ant-steps-label-vertical .ant-steps-item .ant-steps-item-tail {
  top: 14px !important;
}
.ant-steps-with-progress .ant-steps-item-icon {
  position: relative;
}
.ant-steps-with-progress .ant-steps-item-icon .ant-progress {
  position: absolute;
  top: -5px;
  right: -5px;
  bottom: -5px;
  left: -5px;
}
.ant-switch {
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  min-width: 44px;
  height: 22px;
  line-height: 22px;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, 0.25);
  border: 0;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}
.ant-switch:focus {
  outline: 0;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}
.ant-switch-checked:focus {
  box-shadow: 0 0 0 2px #908b94;
}
.ant-switch:focus:hover {
  box-shadow: none;
}
.ant-switch-checked {
  background-color: #351a55;
}
.ant-switch-loading,
.ant-switch-disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
.ant-switch-loading *,
.ant-switch-disabled * {
  box-shadow: none;
  cursor: not-allowed;
}
.ant-switch-inner {
  display: block;
  margin: 0 7px 0 25px;
  color: #fff;
  font-size: 12px;
  transition: margin 0.2s;
}
.ant-switch-checked .ant-switch-inner {
  margin: 0 25px 0 7px;
}
.ant-switch-handle {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  transition: all 0.2s ease-in-out;
}
.ant-switch-handle::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
  border-radius: 9px;
  box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);
  transition: all 0.2s ease-in-out;
  content: '';
}
.ant-switch-checked .ant-switch-handle {
  left: calc(100% - 18px - 2px);
}
.ant-switch:not(.ant-switch-disabled):active .ant-switch-handle::before {
  right: -30%;
  left: 0;
}
.ant-switch:not(.ant-switch-disabled):active.ant-switch-checked .ant-switch-handle::before {
  right: 0;
  left: -30%;
}
.ant-switch-loading-icon.anticon {
  position: relative;
  top: 2px;
  color: rgba(0, 0, 0, 0.65);
  vertical-align: top;
}
.ant-switch-checked .ant-switch-loading-icon {
  color: #351a55;
}
.ant-switch-small {
  min-width: 28px;
  height: 16px;
  line-height: 16px;
}
.ant-switch-small .ant-switch-inner {
  margin: 0 5px 0 18px;
  font-size: 12px;
}
.ant-switch-small .ant-switch-handle {
  width: 12px;
  height: 12px;
}
.ant-switch-small .ant-switch-loading-icon {
  top: 1.5px;
  font-size: 9px;
}
.ant-switch-small.ant-switch-checked .ant-switch-inner {
  margin: 0 18px 0 5px;
}
.ant-switch-small.ant-switch-checked .ant-switch-handle {
  left: calc(100% - 12px - 2px);
}
.ant-switch-rtl {
  direction: rtl;
}
.ant-switch-rtl .ant-switch-inner {
  margin: 0 25px 0 7px;
}
.ant-switch-rtl .ant-switch-handle {
  right: 2px;
  left: auto;
}
.ant-switch-rtl:not(.ant-switch-rtl-disabled):active .ant-switch-handle::before {
  right: 0;
  left: -30%;
}
.ant-switch-rtl:not(.ant-switch-rtl-disabled):active.ant-switch-checked .ant-switch-handle::before {
  right: -30%;
  left: 0;
}
.ant-switch-rtl.ant-switch-checked .ant-switch-inner {
  margin: 0 7px 0 25px;
}
.ant-switch-rtl.ant-switch-checked .ant-switch-handle {
  right: calc(100% - 18px - 2px);
}
.ant-switch-rtl.ant-switch-small.ant-switch-checked .ant-switch-handle {
  right: calc(100% - 12px - 2px);
}
.ant-table.ant-table-middle {
  font-size: 14px;
}
.ant-table.ant-table-middle .ant-table-title,
.ant-table.ant-table-middle .ant-table-footer,
.ant-table.ant-table-middle .ant-table-thead > tr > th,
.ant-table.ant-table-middle .ant-table-tbody > tr > td,
.ant-table.ant-table-middle tfoot > tr > th,
.ant-table.ant-table-middle tfoot > tr > td {
  padding: 12px 8px;
}
.ant-table.ant-table-middle .ant-table-filter-trigger {
  margin-right: -4px;
}
.ant-table.ant-table-middle .ant-table-expanded-row-fixed {
  margin: -12px -8px;
}
.ant-table.ant-table-middle .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
  margin: -12px -8px -12px 40px;
}
.ant-table.ant-table-middle .ant-table-selection-column {
  padding-inline-start: 2px;
}
.ant-table.ant-table-small {
  font-size: 14px;
}
.ant-table.ant-table-small .ant-table-title,
.ant-table.ant-table-small .ant-table-footer,
.ant-table.ant-table-small .ant-table-thead > tr > th,
.ant-table.ant-table-small .ant-table-tbody > tr > td,
.ant-table.ant-table-small tfoot > tr > th,
.ant-table.ant-table-small tfoot > tr > td {
  padding: 8px 8px;
}
.ant-table.ant-table-small .ant-table-filter-trigger {
  margin-right: -4px;
}
.ant-table.ant-table-small .ant-table-expanded-row-fixed {
  margin: -8px -8px;
}
.ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
  margin: -8px -8px -8px 40px;
}
.ant-table.ant-table-small .ant-table-selection-column {
  padding-inline-start: 2px;
}
.ant-table.ant-table-bordered > .ant-table-title {
  border: 1px solid #e8e8e8;
  border-bottom: 0;
}
.ant-table.ant-table-bordered > .ant-table-container {
  border-left: 1px solid #e8e8e8;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > td {
  border-right: 1px solid #e8e8e8;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr:not(:last-child) > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr:not(:last-child) > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr:not(:last-child) > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr:not(:last-child) > th {
  border-bottom: 1px solid #e8e8e8;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th::before,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th::before,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th::before,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th::before {
  background-color: transparent !important;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > .ant-table-cell-fix-right-first::after {
  border-right: 1px solid #e8e8e8;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td > .ant-table-expanded-row-fixed,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -16px -17px;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td > .ant-table-expanded-row-fixed::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td > .ant-table-expanded-row-fixed::after {
  position: absolute;
  top: 0;
  right: 1px;
  bottom: 0;
  border-right: 1px solid #e8e8e8;
  content: '';
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table {
  border-top: 1px solid #e8e8e8;
}
.ant-table.ant-table-bordered.ant-table-scroll-horizontal > .ant-table-container > .ant-table-body > table > tbody > tr.ant-table-expanded-row > td,
.ant-table.ant-table-bordered.ant-table-scroll-horizontal > .ant-table-container > .ant-table-body > table > tbody > tr.ant-table-placeholder > td {
  border-right: 0;
}
.ant-table.ant-table-bordered.ant-table-middle > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed,
.ant-table.ant-table-bordered.ant-table-middle > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -12px -9px;
}
.ant-table.ant-table-bordered.ant-table-small > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed,
.ant-table.ant-table-bordered.ant-table-small > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -8px -9px;
}
.ant-table.ant-table-bordered > .ant-table-footer {
  border: 1px solid #e8e8e8;
  border-top: 0;
}
.ant-table-cell .ant-table-container:first-child {
  border-top: 0;
}
.ant-table-cell-scrollbar:not([rowspan]) {
  box-shadow: 0 1px 0 1px #fafafa;
}
.ant-table-wrapper {
  clear: both;
  max-width: 100%;
}
.ant-table-wrapper::before {
  display: table;
  content: '';
}
.ant-table-wrapper::after {
  display: table;
  clear: both;
  content: '';
}
.ant-table-wrapper::before {
  display: table;
  content: '';
}
.ant-table-wrapper::after {
  display: table;
  clear: both;
  content: '';
}
.ant-table {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  font-size: 14px;
  background: #fff;
  border-radius: 6px;
}
.ant-table table {
  width: 100%;
  text-align: left;
  border-radius: 6px 6px 0 0;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td,
.ant-table tfoot > tr > th,
.ant-table tfoot > tr > td {
  position: relative;
  padding: 16px 16px;
  overflow-wrap: break-word;
}
.ant-table-cell-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
}
.ant-table-cell-ellipsis.ant-table-cell-fix-left-last,
.ant-table-cell-ellipsis.ant-table-cell-fix-right-first {
  overflow: visible;
}
.ant-table-cell-ellipsis.ant-table-cell-fix-left-last .ant-table-cell-content,
.ant-table-cell-ellipsis.ant-table-cell-fix-right-first .ant-table-cell-content {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ant-table-cell-ellipsis .ant-table-column-title {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
}
.ant-table-title {
  padding: 16px 16px;
}
.ant-table-footer {
  padding: 16px 16px;
  color: #535353;
  background: #fafafa;
}
.ant-table-thead > tr > th {
  position: relative;
  color: #535353;
  font-weight: 500;
  text-align: left;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  transition: background 0.3s ease;
}
.ant-table-thead > tr > th[colspan]:not([colspan='1']) {
  text-align: center;
}
.ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 1.6em;
  background-color: rgba(0, 0, 0, 0.06);
  transform: translateY(-50%);
  transition: background-color 0.3s;
  content: '';
}
.ant-table-thead > tr:not(:last-child) > th[colspan] {
  border-bottom: 0;
}
.ant-table-tbody > tr > td {
  border-bottom: 1px solid #e8e8e8;
  transition: background 0.3s;
}
.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table,
.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table {
  margin: -16px -16px -16px 32px;
}
.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td,
.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td {
  border-bottom: 0;
}
.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:first-child,
.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:first-child,
.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:last-child,
.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:last-child {
  border-radius: 0;
}
.ant-table-tbody > tr.ant-table-row:hover > td,
.ant-table-tbody > tr > td.ant-table-cell-row-hover {
  background: #fafafa;
}
.ant-table-tbody > tr.ant-table-row-selected > td {
  background: #908b94;
  border-color: rgba(0, 0, 0, 0.03);
}
.ant-table-tbody > tr.ant-table-row-selected:hover > td {
  background: #8b868f;
}
.ant-table-summary {
  position: relative;
  z-index: 2;
  background: #fff;
}
div.ant-table-summary {
  box-shadow: 0 -1px 0 #e8e8e8;
}
.ant-table-summary > tr > th,
.ant-table-summary > tr > td {
  border-bottom: 1px solid #e8e8e8;
}
.ant-table-pagination.ant-pagination {
  margin: 16px 0;
}
.ant-table-pagination {
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
}
.ant-table-pagination > * {
  flex: none;
}
.ant-table-pagination-left {
  justify-content: flex-start;
}
.ant-table-pagination-center {
  justify-content: center;
}
.ant-table-pagination-right {
  justify-content: flex-end;
}
.ant-table-thead th.ant-table-column-has-sorters {
  outline: none;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-table-thead th.ant-table-column-has-sorters:hover {
  background: rgba(0, 0, 0, 0.04);
}
.ant-table-thead th.ant-table-column-has-sorters:hover::before {
  background-color: transparent !important;
}
.ant-table-thead th.ant-table-column-has-sorters:focus-visible {
  color: #351a55;
}
.ant-table-thead th.ant-table-column-has-sorters.ant-table-cell-fix-left:hover,
.ant-table-thead th.ant-table-column-has-sorters.ant-table-cell-fix-right:hover {
  background: #f5f5f5;
}
.ant-table-thead th.ant-table-column-sort {
  background: #f5f5f5;
}
.ant-table-thead th.ant-table-column-sort::before {
  background-color: transparent !important;
}
td.ant-table-column-sort {
  background: #fafafa;
}
.ant-table-column-title {
  position: relative;
  z-index: 1;
  flex: 1;
}
.ant-table-column-sorters {
  display: flex;
  flex: auto;
  align-items: center;
  justify-content: space-between;
}
.ant-table-column-sorters::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: '';
}
.ant-table-column-sorter {
  margin-left: 4px;
  color: #bfbfbf;
  font-size: 0;
  transition: color 0.3s;
}
.ant-table-column-sorter-inner {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
.ant-table-column-sorter-up,
.ant-table-column-sorter-down {
  font-size: 11px;
}
.ant-table-column-sorter-up.active,
.ant-table-column-sorter-down.active {
  color: #351a55;
}
.ant-table-column-sorter-up + .ant-table-column-sorter-down {
  margin-top: -0.3em;
}
.ant-table-column-sorters:hover .ant-table-column-sorter {
  color: #a6a6a6;
}
.ant-table-filter-column {
  display: flex;
  justify-content: space-between;
}
.ant-table-filter-trigger {
  position: relative;
  display: flex;
  align-items: center;
  margin: -4px -8px -4px 4px;
  padding: 0 4px;
  color: #bfbfbf;
  font-size: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-table-filter-trigger:hover {
  color: #595959;
  background: rgba(0, 0, 0, 0.04);
}
.ant-table-filter-trigger.active {
  color: #351a55;
}
.ant-table-filter-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  min-width: 120px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.ant-table-filter-dropdown .ant-dropdown-menu {
  max-height: 264px;
  overflow-x: hidden;
  border: 0;
  box-shadow: none;
}
.ant-table-filter-dropdown .ant-dropdown-menu:empty::after {
  display: block;
  padding: 8px 0;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  text-align: center;
  content: 'Not Found';
}
.ant-table-filter-dropdown-tree {
  padding: 8px 8px 0;
}
.ant-table-filter-dropdown-tree .ant-tree-treenode .ant-tree-node-content-wrapper:hover {
  background-color: #f5f5f5;
}
.ant-table-filter-dropdown-tree .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper,
.ant-table-filter-dropdown-tree .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper:hover {
  background-color: #847f87;
}
.ant-table-filter-dropdown-search {
  padding: 8px;
  border-bottom: 1px #e8e8e8 solid;
}
.ant-table-filter-dropdown-search-input input {
  min-width: 140px;
}
.ant-table-filter-dropdown-search-input .anticon {
  color: rgba(0, 0, 0, 0.25);
}
.ant-table-filter-dropdown-checkall {
  width: 100%;
  margin-bottom: 4px;
  margin-left: 4px;
}
.ant-table-filter-dropdown-submenu > ul {
  max-height: calc(100vh - 130px);
  overflow-x: hidden;
  overflow-y: auto;
}
.ant-table-filter-dropdown .ant-checkbox-wrapper + span,
.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span {
  padding-left: 8px;
}
.ant-table-filter-dropdown-btns {
  display: flex;
  justify-content: space-between;
  padding: 7px 8px;
  overflow: hidden;
  background-color: inherit;
  border-top: 1px solid #e8e8e8;
}
.ant-table-selection-col {
  width: 32px;
}
.ant-table-bordered .ant-table-selection-col {
  width: 50px;
}
table tr th.ant-table-selection-column,
table tr td.ant-table-selection-column {
  padding-right: 8px;
  padding-left: 8px;
  text-align: center;
}
table tr th.ant-table-selection-column .ant-radio-wrapper,
table tr td.ant-table-selection-column .ant-radio-wrapper {
  margin-right: 0;
}
table tr th.ant-table-selection-column.ant-table-cell-fix-left {
  z-index: 3;
}
table tr th.ant-table-selection-column::after {
  background-color: transparent !important;
}
.ant-table-selection {
  position: relative;
  display: inline-flex;
  flex-direction: column;
}
.ant-table-selection-extra {
  position: absolute;
  top: 0;
  z-index: 1;
  cursor: pointer;
  transition: all 0.3s;
  margin-inline-start: 100%;
  padding-inline-start: 4px;
}
.ant-table-selection-extra .anticon {
  color: #bfbfbf;
  font-size: 10px;
}
.ant-table-selection-extra .anticon:hover {
  color: #a6a6a6;
}
.ant-table-expand-icon-col {
  width: 48px;
}
.ant-table-row-expand-icon-cell {
  text-align: center;
}
.ant-table-row-expand-icon-cell .ant-table-row-expand-icon {
  display: inline-flex;
  float: none;
  vertical-align: sub;
}
.ant-table-row-indent {
  float: left;
  height: 1px;
}
.ant-table-row-expand-icon {
  color: var(--app-primary-color);
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  position: relative;
  float: left;
  box-sizing: border-box;
  width: 17px;
  height: 17px;
  padding: 0;
  color: inherit;
  line-height: 17px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  transform: scale(0.94117647);
  transition: all 0.3s;
  user-select: none;
}
.ant-table-row-expand-icon:focus-visible,
.ant-table-row-expand-icon:hover {
  color: #0d0d0d;
}
.ant-table-row-expand-icon:active {
  color: #000000;
}
.ant-table-row-expand-icon:focus,
.ant-table-row-expand-icon:hover,
.ant-table-row-expand-icon:active {
  border-color: currentcolor;
}
.ant-table-row-expand-icon::before,
.ant-table-row-expand-icon::after {
  position: absolute;
  background: currentcolor;
  transition: transform 0.3s ease-out;
  content: '';
}
.ant-table-row-expand-icon::before {
  top: 7px;
  right: 3px;
  left: 3px;
  height: 1px;
}
.ant-table-row-expand-icon::after {
  top: 3px;
  bottom: 3px;
  left: 7px;
  width: 1px;
  transform: rotate(90deg);
}
.ant-table-row-expand-icon-collapsed::before {
  transform: rotate(-180deg);
}
.ant-table-row-expand-icon-collapsed::after {
  transform: rotate(0deg);
}
.ant-table-row-expand-icon-spaced {
  background: transparent;
  border: 0;
  visibility: hidden;
}
.ant-table-row-expand-icon-spaced::before,
.ant-table-row-expand-icon-spaced::after {
  display: none;
  content: none;
}
.ant-table-row-indent + .ant-table-row-expand-icon {
  margin-top: 0.6px;
  margin-right: 8px;
}
tr.ant-table-expanded-row > td,
tr.ant-table-expanded-row:hover > td {
  background: #fbfbfb;
}
tr.ant-table-expanded-row .ant-descriptions-view {
  display: flex;
}
tr.ant-table-expanded-row .ant-descriptions-view table {
  flex: auto;
  width: auto;
}
.ant-table .ant-table-expanded-row-fixed {
  position: relative;
  margin: -16px -16px;
  padding: 16px 16px;
}
.ant-table-tbody > tr.ant-table-placeholder {
  text-align: center;
}
.ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.ant-table-tbody > tr.ant-table-placeholder:hover > td {
  background: #fff;
}
.ant-table-cell-fix-left,
.ant-table-cell-fix-right {
  position: sticky !important;
  z-index: 2;
  background: #fff;
}
.ant-table-cell-fix-left-first::after,
.ant-table-cell-fix-left-last::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: -1px;
  width: 30px;
  transform: translateX(100%);
  transition: box-shadow 0.3s;
  content: '';
  pointer-events: none;
}
.ant-table-cell-fix-left-all::after {
  display: none;
}
.ant-table-cell-fix-right-first::after,
.ant-table-cell-fix-right-last::after {
  position: absolute;
  top: 0;
  bottom: -1px;
  left: 0;
  width: 30px;
  transform: translateX(-100%);
  transition: box-shadow 0.3s;
  content: '';
  pointer-events: none;
}
.ant-table .ant-table-container::before,
.ant-table .ant-table-container::after {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: calc(calc(2 + 1) + 1);
  width: 30px;
  transition: box-shadow 0.3s;
  content: '';
  pointer-events: none;
}
.ant-table .ant-table-container::before {
  left: 0;
}
.ant-table .ant-table-container::after {
  right: 0;
}
.ant-table-ping-left:not(.ant-table-has-fix-left) > .ant-table-container {
  position: relative;
}
.ant-table-ping-left:not(.ant-table-has-fix-left) > .ant-table-container::before {
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);
}
.ant-table-ping-left .ant-table-cell-fix-left-first::after,
.ant-table-ping-left .ant-table-cell-fix-left-last::after {
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);
}
.ant-table-ping-left .ant-table-cell-fix-left-last::before {
  background-color: transparent !important;
}
.ant-table-ping-right:not(.ant-table-has-fix-right) > .ant-table-container {
  position: relative;
}
.ant-table-ping-right:not(.ant-table-has-fix-right) > .ant-table-container::after {
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.15);
}
.ant-table-ping-right .ant-table-cell-fix-right-first::after,
.ant-table-ping-right .ant-table-cell-fix-right-last::after {
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.15);
}
.ant-table-sticky-holder {
  position: sticky;
  z-index: calc(2 + 1);
  background: #fff;
}
.ant-table-sticky-scroll {
  position: sticky;
  bottom: 0;
  z-index: calc(2 + 1);
  display: flex;
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #e8e8e8;
  opacity: 0.6;
}
.ant-table-sticky-scroll:hover {
  transform-origin: center bottom;
}
.ant-table-sticky-scroll-bar {
  height: 8px;
  background-color: rgba(0, 0, 0, 0.35);
  border-radius: 4px;
}
.ant-table-sticky-scroll-bar:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.ant-table-sticky-scroll-bar-active {
  background-color: rgba(0, 0, 0, 0.8);
}
@media all and (-ms-high-contrast: none) {
  .ant-table-ping-left .ant-table-cell-fix-left-last::after {
    box-shadow: none !important;
  }
  .ant-table-ping-right .ant-table-cell-fix-right-first::after {
    box-shadow: none !important;
  }
}
.ant-table {
  /* title + table */
  /* table */
  /* table + footer */
}
.ant-table-title {
  border-radius: 6px 6px 0 0;
}
.ant-table-title + .ant-table-container {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ant-table-title + .ant-table-container table {
  border-radius: 0;
}
.ant-table-title + .ant-table-container table > thead > tr:first-child th:first-child {
  border-radius: 0;
}
.ant-table-title + .ant-table-container table > thead > tr:first-child th:last-child {
  border-radius: 0;
}
.ant-table-container {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.ant-table-container table > thead > tr:first-child th:first-child {
  border-top-left-radius: 6px;
}
.ant-table-container table > thead > tr:first-child th:last-child {
  border-top-right-radius: 6px;
}
.ant-table-footer {
  border-radius: 0 0 6px 6px;
}
.ant-table-wrapper-rtl {
  direction: rtl;
}
.ant-table-rtl {
  direction: rtl;
}
.ant-table-wrapper-rtl .ant-table table {
  text-align: right;
}
.ant-table-wrapper-rtl .ant-table-thead > tr > th[colspan]:not([colspan='1']) {
  text-align: center;
}
.ant-table-wrapper-rtl .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  right: auto;
  left: 0;
}
.ant-table-wrapper-rtl .ant-table-thead > tr > th {
  text-align: right;
}
.ant-table-tbody > tr .ant-table-wrapper:only-child .ant-table.ant-table-rtl {
  margin: -16px 33px -16px -16px;
}
.ant-table-wrapper.ant-table-wrapper-rtl .ant-table-pagination-left {
  justify-content: flex-end;
}
.ant-table-wrapper.ant-table-wrapper-rtl .ant-table-pagination-right {
  justify-content: flex-start;
}
.ant-table-wrapper-rtl .ant-table-column-sorter {
  margin-right: 4px;
  margin-left: 0;
}
.ant-table-wrapper-rtl .ant-table-filter-column-title {
  padding: 16px 16px 16px 2.3em;
}
.ant-table-rtl .ant-table-thead tr th.ant-table-column-has-sorters .ant-table-filter-column-title {
  padding: 0 0 0 2.3em;
}
.ant-table-wrapper-rtl .ant-table-filter-trigger {
  margin: -4px 4px -4px -8px;
}
.ant-dropdown-rtl .ant-table-filter-dropdown .ant-checkbox-wrapper + span,
.ant-dropdown-rtl .ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span,
.ant-dropdown-menu-submenu-rtl.ant-table-filter-dropdown .ant-checkbox-wrapper + span,
.ant-dropdown-menu-submenu-rtl.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span {
  padding-right: 8px;
  padding-left: 0;
}
.ant-table-wrapper-rtl .ant-table-selection {
  text-align: center;
}
.ant-table-wrapper-rtl .ant-table-row-indent {
  float: right;
}
.ant-table-wrapper-rtl .ant-table-row-expand-icon {
  float: right;
}
.ant-table-wrapper-rtl .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 0;
  margin-left: 8px;
}
.ant-table-wrapper-rtl .ant-table-row-expand-icon::after {
  transform: rotate(-90deg);
}
.ant-table-wrapper-rtl .ant-table-row-expand-icon-collapsed::before {
  transform: rotate(180deg);
}
.ant-table-wrapper-rtl .ant-table-row-expand-icon-collapsed::after {
  transform: rotate(0deg);
}
.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
  padding: 8px 0;
  font-size: 14px;
}
.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
  padding: 16px 0;
  font-size: 16px;
}
.ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
  padding: 6px 16px;
}
.ant-tabs-card.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
  padding: 7px 16px 6px;
}
.ant-tabs-rtl {
  direction: rtl;
}
.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab {
  margin: 0 0 0 32px;
}
.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab:last-of-type {
  margin-left: 0;
}
.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .anticon {
  margin-right: 0;
  margin-left: 12px;
}
.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {
  margin-right: 8px;
  margin-left: -4px;
}
.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove .anticon {
  margin: 0;
}
.ant-tabs-rtl.ant-tabs-left > .ant-tabs-nav {
  order: 1;
}
.ant-tabs-rtl.ant-tabs-left > .ant-tabs-content-holder {
  order: 0;
}
.ant-tabs-rtl.ant-tabs-right > .ant-tabs-nav {
  order: 0;
}
.ant-tabs-rtl.ant-tabs-right > .ant-tabs-content-holder {
  order: 1;
}
.ant-tabs-rtl.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-rtl.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin-right: 2px;
  margin-left: 0;
}
.ant-tabs-rtl.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-add,
.ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-add,
.ant-tabs-rtl.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-add,
.ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-add {
  margin-right: 2px;
  margin-left: 0;
}
.ant-tabs-dropdown-rtl {
  direction: rtl;
}
.ant-tabs-dropdown-rtl .ant-tabs-dropdown-menu-item {
  text-align: right;
}
.ant-tabs-top,
.ant-tabs-bottom {
  flex-direction: column;
}
.ant-tabs-top > .ant-tabs-nav,
.ant-tabs-bottom > .ant-tabs-nav,
.ant-tabs-top > div > .ant-tabs-nav,
.ant-tabs-bottom > div > .ant-tabs-nav {
  margin: 0 0 16px 0;
}
.ant-tabs-top > .ant-tabs-nav::before,
.ant-tabs-bottom > .ant-tabs-nav::before,
.ant-tabs-top > div > .ant-tabs-nav::before,
.ant-tabs-bottom > div > .ant-tabs-nav::before {
  position: absolute;
  right: 0;
  left: 0;
  border-bottom: 1px solid #e8e8e8;
  content: '';
}
.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar {
  height: 2px;
}
.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar-animated,
.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar-animated,
.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar-animated,
.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar-animated {
  transition: width 0.3s, left 0.3s, right 0.3s;
}
.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {
  top: 0;
  bottom: 0;
  width: 30px;
}
.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap::before {
  left: 0;
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.08);
}
.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {
  right: 0;
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.08);
}
.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before,
.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before,
.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before,
.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before {
  opacity: 1;
}
.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after,
.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after,
.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after,
.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after {
  opacity: 1;
}
.ant-tabs-top > .ant-tabs-nav::before,
.ant-tabs-top > div > .ant-tabs-nav::before {
  bottom: 0;
}
.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar {
  bottom: 0;
}
.ant-tabs-bottom > .ant-tabs-nav,
.ant-tabs-bottom > div > .ant-tabs-nav {
  order: 1;
  margin-top: 16px;
  margin-bottom: 0;
}
.ant-tabs-bottom > .ant-tabs-nav::before,
.ant-tabs-bottom > div > .ant-tabs-nav::before {
  top: 0;
}
.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar {
  top: 0;
}
.ant-tabs-bottom > .ant-tabs-content-holder,
.ant-tabs-bottom > div > .ant-tabs-content-holder {
  order: 0;
}
.ant-tabs-left > .ant-tabs-nav,
.ant-tabs-right > .ant-tabs-nav,
.ant-tabs-left > div > .ant-tabs-nav,
.ant-tabs-right > div > .ant-tabs-nav {
  flex-direction: column;
  min-width: 50px;
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab {
  padding: 8px 24px;
  text-align: center;
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin: 16px 0 0 0;
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap {
  flex-direction: column;
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {
  right: 0;
  left: 0;
  height: 30px;
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap::before {
  top: 0;
  box-shadow: inset 0 10px 8px -8px rgba(0, 0, 0, 0.08);
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {
  bottom: 0;
  box-shadow: inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08);
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top::before,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top::before,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top::before,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top::before {
  opacity: 1;
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom::after,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom::after,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom::after,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom::after {
  opacity: 1;
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar {
  width: 2px;
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar-animated,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar-animated,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar-animated,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar-animated {
  transition: height 0.3s, top 0.3s;
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-list,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-list,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-list,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-list,
.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-operations,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-operations,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-operations,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-operations {
  flex: 1 0 auto;
  flex-direction: column;
}
.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar {
  right: 0;
}
.ant-tabs-left > .ant-tabs-content-holder,
.ant-tabs-left > div > .ant-tabs-content-holder {
  margin-left: -1px;
  border-left: 1px solid #e8e8e8;
}
.ant-tabs-left > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane,
.ant-tabs-left > div > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
  padding-left: 24px;
}
.ant-tabs-right > .ant-tabs-nav,
.ant-tabs-right > div > .ant-tabs-nav {
  order: 1;
}
.ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar {
  left: 0;
}
.ant-tabs-right > .ant-tabs-content-holder,
.ant-tabs-right > div > .ant-tabs-content-holder {
  order: 0;
  margin-right: -1px;
  border-right: 1px solid #e8e8e8;
}
.ant-tabs-right > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane,
.ant-tabs-right > div > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
  padding-right: 24px;
}
.ant-tabs-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  display: block;
}
.ant-tabs-dropdown-hidden {
  display: none;
}
.ant-tabs-dropdown-menu {
  max-height: 200px;
  margin: 0;
  padding: 4px 0;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: left;
  list-style-type: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 6px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.ant-tabs-dropdown-menu-item {
  display: flex;
  align-items: center;
  min-width: 120px;
  margin: 0;
  padding: 5px 12px;
  overflow: hidden;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-tabs-dropdown-menu-item > span {
  flex: 1;
  white-space: nowrap;
}
.ant-tabs-dropdown-menu-item-remove {
  flex: none;
  margin-left: 12px;
  color: #595959;
  font-size: 12px;
  background: transparent;
  border: 0;
  cursor: pointer;
}
.ant-tabs-dropdown-menu-item-remove:hover {
  color: #462e61;
}
.ant-tabs-dropdown-menu-item:hover {
  background: #f5f5f5;
}
.ant-tabs-dropdown-menu-item-disabled,
.ant-tabs-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  cursor: not-allowed;
}
.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab,
.ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
  margin: 0;
  padding: 10px 16px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active,
.ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {
  color: #351a55;
  background: #fff;
}
.ant-tabs-card > .ant-tabs-nav .ant-tabs-ink-bar,
.ant-tabs-card > div > .ant-tabs-nav .ant-tabs-ink-bar {
  visibility: hidden;
}
.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin-left: 2px;
}
.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab,
.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 6px 6px 0 0;
}
.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active,
.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-bottom-color: #fff;
}
.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab,
.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 0 0 6px 6px;
}
.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab-active,
.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-top-color: #fff;
}
.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin-top: 2px;
}
.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab,
.ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 6px 0 0 6px;
}
.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab-active,
.ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-right-color: #fff;
}
.ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab,
.ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 0 6px 6px 0;
}
.ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab-active,
.ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-left-color: #fff;
}
.ant-tabs {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: flex;
}
.ant-tabs > .ant-tabs-nav,
.ant-tabs > div > .ant-tabs-nav {
  position: relative;
  display: flex;
  flex: none;
  align-items: center;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap {
  position: relative;
  display: inline-block;
  display: flex;
  flex: auto;
  align-self: stretch;
  overflow: hidden;
  white-space: nowrap;
  transform: translate(0);
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {
  position: absolute;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
  content: '';
  pointer-events: none;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {
  position: relative;
  display: flex;
  transition: transform 0.3s;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-operations,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-operations {
  display: flex;
  align-self: stretch;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-operations-hidden,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-operations-hidden {
  position: absolute;
  visibility: hidden;
  pointer-events: none;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-more,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more {
  position: relative;
  padding: 10px 16px;
  background: transparent;
  border: 0;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-more::after,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 5px;
  transform: translateY(100%);
  content: '';
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add {
  min-width: 40px;
  margin-left: 2px;
  padding: 0 8px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 6px 6px 0 0;
  outline: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:hover,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:hover {
  color: #462e61;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:active,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:active,
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:focus,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:focus {
  color: #1a0c2e;
}
.ant-tabs-extra-content {
  flex: none;
}
.ant-tabs-centered > .ant-tabs-nav .ant-tabs-nav-wrap:not([class*='ant-tabs-nav-wrap-ping']),
.ant-tabs-centered > div > .ant-tabs-nav .ant-tabs-nav-wrap:not([class*='ant-tabs-nav-wrap-ping']) {
  justify-content: center;
}
.ant-tabs-ink-bar {
  position: absolute;
  background: #351a55;
  pointer-events: none;
}
.ant-tabs-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 12px 0;
  font-size: 14px;
  background: transparent;
  border: 0;
  outline: none;
  cursor: pointer;
}
.ant-tabs-tab-btn:focus,
.ant-tabs-tab-remove:focus,
.ant-tabs-tab-btn:active,
.ant-tabs-tab-remove:active {
  color: #1a0c2e;
}
.ant-tabs-tab-btn {
  outline: none;
  transition: all 0.3s;
}
.ant-tabs-tab-remove {
  flex: none;
  margin-right: -4px;
  margin-left: 8px;
  color: #595959;
  font-size: 12px;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-tabs-tab-remove:hover {
  color: #535353;
}
.ant-tabs-tab:hover {
  color: #462e61;
}
.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #351a55;
  text-shadow: 0 0 0.25px currentcolor;
}
.ant-tabs-tab.ant-tabs-tab-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn:focus,
.ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-remove:focus,
.ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn:active,
.ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-remove:active {
  color: rgba(0, 0, 0, 0.25);
}
.ant-tabs-tab .ant-tabs-tab-remove .anticon {
  margin: 0;
}
.ant-tabs-tab .anticon {
  margin-right: 12px;
}
.ant-tabs-tab + .ant-tabs-tab {
  margin: 0 0 0 32px;
}
.ant-tabs-content {
  position: relative;
  width: 100%;
}
.ant-tabs-content-holder {
  flex: auto;
  min-width: 0;
  min-height: 0;
}
.ant-tabs-tabpane {
  outline: none;
}
.ant-tabs-tabpane-hidden {
  display: none;
}
.ant-tabs-switch-appear,
.ant-tabs-switch-enter {
  transition: none;
}
.ant-tabs-switch-appear-start,
.ant-tabs-switch-enter-start {
  opacity: 0;
}
.ant-tabs-switch-appear-active,
.ant-tabs-switch-enter-active {
  opacity: 1;
  transition: opacity 0.3s;
}
.ant-tabs-switch-leave {
  position: absolute;
  transition: none;
  inset: 0;
}
.ant-tabs-switch-leave-start {
  opacity: 1;
}
.ant-tabs-switch-leave-active {
  opacity: 0;
  transition: opacity 0.3s;
}
.ant-tag {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
  height: auto;
  margin-right: 8px;
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  opacity: 1;
  transition: all 0.3s;
}
.ant-tag,
.ant-tag a,
.ant-tag a:hover {
  color: #545454;
}
.ant-tag > a:first-child:last-child {
  display: inline-block;
  margin: 0 -8px;
  padding: 0 8px;
}
.ant-tag-close-icon {
  margin-left: 3px;
  color: #595959;
  font-size: 10px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-tag-close-icon:hover {
  color: #535353;
}
.ant-tag-has-color {
  border-color: transparent;
}
.ant-tag-has-color,
.ant-tag-has-color a,
.ant-tag-has-color a:hover,
.ant-tag-has-color .anticon-close,
.ant-tag-has-color .anticon-close:hover {
  color: #fff;
}
.ant-tag-checkable {
  background-color: transparent;
  border-color: transparent;
  cursor: pointer;
}
.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {
  color: #351a55;
}
.ant-tag-checkable:active,
.ant-tag-checkable-checked {
  color: #fff;
}
.ant-tag-checkable-checked {
  background-color: #351a55;
}
.ant-tag-checkable:active {
  background-color: #1a0c2e;
}
.ant-tag-hidden {
  display: none;
}
.ant-tag-pink {
  color: #c41d7f;
  background: #fff0f6;
  border-color: #ffadd2;
}
.ant-tag-pink-inverse {
  color: #fff;
  background: #eb2f96;
  border-color: #eb2f96;
}
.ant-tag-magenta {
  color: #c41d7f;
  background: #fff0f6;
  border-color: #ffadd2;
}
.ant-tag-magenta-inverse {
  color: #fff;
  background: #eb2f96;
  border-color: #eb2f96;
}
.ant-tag-red {
  color: #cf1322;
  background: #fff1f0;
  border-color: #ffa39e;
}
.ant-tag-red-inverse {
  color: #fff;
  background: #f5222d;
  border-color: #f5222d;
}
.ant-tag-volcano {
  color: #d4380d;
  background: #fff2e8;
  border-color: #ffbb96;
}
.ant-tag-volcano-inverse {
  color: #fff;
  background: #fa541c;
  border-color: #fa541c;
}
.ant-tag-orange {
  color: #d46b08;
  background: #fff7e6;
  border-color: #ffd591;
}
.ant-tag-orange-inverse {
  color: #fff;
  background: #fa8c16;
  border-color: #fa8c16;
}
.ant-tag-yellow {
  color: #d4b106;
  background: #feffe6;
  border-color: #fffb8f;
}
.ant-tag-yellow-inverse {
  color: #fff;
  background: #fadb14;
  border-color: #fadb14;
}
.ant-tag-gold {
  color: #d48806;
  background: #fffbe6;
  border-color: #ffe58f;
}
.ant-tag-gold-inverse {
  color: #fff;
  background: #faad14;
  border-color: #faad14;
}
.ant-tag-cyan {
  color: #08979c;
  background: #e6fffb;
  border-color: #87e8de;
}
.ant-tag-cyan-inverse {
  color: #fff;
  background: #13c2c2;
  border-color: #13c2c2;
}
.ant-tag-lime {
  color: #7cb305;
  background: #fcffe6;
  border-color: #eaff8f;
}
.ant-tag-lime-inverse {
  color: #fff;
  background: #a0d911;
  border-color: #a0d911;
}
.ant-tag-green {
  color: #389e0d;
  background: #f6ffed;
  border-color: #b7eb8f;
}
.ant-tag-green-inverse {
  color: #fff;
  background: #52c41a;
  border-color: #52c41a;
}
.ant-tag-blue {
  color: #096dd9;
  background: #e6f7ff;
  border-color: #91d5ff;
}
.ant-tag-blue-inverse {
  color: #fff;
  background: #1890ff;
  border-color: #1890ff;
}
.ant-tag-geekblue {
  color: #1d39c4;
  background: #f0f5ff;
  border-color: #adc6ff;
}
.ant-tag-geekblue-inverse {
  color: #fff;
  background: #2f54eb;
  border-color: #2f54eb;
}
.ant-tag-purple {
  color: #531dab;
  background: #f9f0ff;
  border-color: #d3adf7;
}
.ant-tag-purple-inverse {
  color: #fff;
  background: #722ed1;
  border-color: #722ed1;
}
.ant-tag-success {
  color: #52c41a;
  background: #f6ffed;
  border-color: #b7eb8f;
}
.ant-tag-processing {
  color: #1890ff;
  background: #e6f7ff;
  border-color: #91d5ff;
}
.ant-tag-error {
  color: #f5222d;
  background: #fff1f0;
  border-color: #ffa39e;
}
.ant-tag-warning {
  color: #fa8c16;
  background: #fff7e6;
  border-color: #ffd591;
}
.ant-tag > .anticon + span,
.ant-tag > span + .anticon {
  margin-left: 7px;
}
.ant-tag.ant-tag-rtl {
  margin-right: 0;
  margin-left: 8px;
  direction: rtl;
  text-align: right;
}
.ant-tag-rtl .ant-tag-close-icon {
  margin-right: 3px;
  margin-left: 0;
}
.ant-tag-rtl.ant-tag > .anticon + span,
.ant-tag-rtl.ant-tag > span + .anticon {
  margin-right: 7px;
  margin-left: 0;
}
.ant-timeline {
  box-sizing: border-box;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  font-feature-settings: 'tnum';
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-timeline-item {
  position: relative;
  margin: 0;
  padding-bottom: 20px;
  font-size: 14px;
  list-style: none;
}
.ant-timeline-item-tail {
  position: absolute;
  top: 10px;
  left: 4px;
  height: calc(100% - 10px);
  border-left: 2px solid #e8e8e8;
}
.ant-timeline-item-pending .ant-timeline-item-head {
  font-size: 12px;
  background-color: transparent;
}
.ant-timeline-item-pending .ant-timeline-item-tail {
  display: none;
}
.ant-timeline-item-head {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #fff;
  border: 2px solid transparent;
  border-radius: 100px;
}
.ant-timeline-item-head-blue {
  color: #351a55;
  border-color: #351a55;
}
.ant-timeline-item-head-red {
  color: #f5222d;
  border-color: #f5222d;
}
.ant-timeline-item-head-green {
  color: #52c41a;
  border-color: #52c41a;
}
.ant-timeline-item-head-gray {
  color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-timeline-item-head-custom {
  position: absolute;
  top: 5.5px;
  left: 5px;
  width: auto;
  height: auto;
  margin-top: 0;
  padding: 3px 1px;
  line-height: 1;
  text-align: center;
  border: 0;
  border-radius: 0;
  transform: translate(-50%, -50%);
}
.ant-timeline-item-content {
  position: relative;
  top: -3.2px;
  margin: 0 0 0 26px;
  word-break: break-word;
}
.ant-timeline-item-last > .ant-timeline-item-tail {
  display: none;
}
.ant-timeline-item-last > .ant-timeline-item-content {
  min-height: 48px;
}
.ant-timeline.ant-timeline-alternate .ant-timeline-item-tail,
.ant-timeline.ant-timeline-right .ant-timeline-item-tail,
.ant-timeline.ant-timeline-label .ant-timeline-item-tail,
.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,
.ant-timeline.ant-timeline-right .ant-timeline-item-head,
.ant-timeline.ant-timeline-label .ant-timeline-item-head,
.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,
.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom,
.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom {
  left: 50%;
}
.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,
.ant-timeline.ant-timeline-right .ant-timeline-item-head,
.ant-timeline.ant-timeline-label .ant-timeline-item-head {
  margin-left: -4px;
}
.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,
.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom,
.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom {
  margin-left: 1px;
}
.ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content,
.ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content,
.ant-timeline.ant-timeline-label .ant-timeline-item-left .ant-timeline-item-content {
  left: calc(50% - 4px);
  width: calc(50% - 14px);
  text-align: left;
}
.ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content,
.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content,
.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-content {
  width: calc(50% - 12px);
  margin: 0;
  text-align: right;
}
.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-tail,
.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head,
.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head-custom {
  left: calc(100% - 4px - 2px);
}
.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  width: calc(100% - 18px);
}
.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail {
  display: block;
  height: calc(100% - 14px);
  border-left: 2px dotted #e8e8e8;
}
.ant-timeline.ant-timeline-reverse .ant-timeline-item-last .ant-timeline-item-tail {
  display: none;
}
.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-tail {
  top: 15px;
  display: block;
  height: calc(100% - 15px);
  border-left: 2px dotted #e8e8e8;
}
.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-content {
  min-height: 48px;
}
.ant-timeline.ant-timeline-label .ant-timeline-item-label {
  position: absolute;
  top: -3.2px;
  width: calc(50% - 12px);
  text-align: right;
}
.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-label {
  left: calc(50% + 14px);
  width: calc(50% - 14px);
  text-align: left;
}
.ant-timeline-rtl {
  direction: rtl;
}
.ant-timeline-rtl .ant-timeline-item-tail {
  right: 4px;
  left: auto;
  border-right: 2px solid #e8e8e8;
  border-left: none;
}
.ant-timeline-rtl .ant-timeline-item-head-custom {
  right: 5px;
  left: auto;
  transform: translate(50%, -50%);
}
.ant-timeline-rtl .ant-timeline-item-content {
  margin: 0 18px 0 0;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-tail,
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-tail,
.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-tail,
.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head,
.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head,
.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom,
.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom {
  right: 50%;
  left: auto;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head,
.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head {
  margin-right: -4px;
  margin-left: 0;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom,
.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom {
  margin-right: 1px;
  margin-left: 0;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content,
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content,
.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-left .ant-timeline-item-content {
  right: calc(50% - 4px);
  left: auto;
  text-align: right;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content,
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content,
.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-content {
  text-align: left;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-tail,
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head,
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head-custom {
  right: 0;
  left: auto;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  width: 100%;
  margin-right: 18px;
  text-align: right;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail {
  border-right: 2px dotted #e8e8e8;
  border-left: none;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-tail {
  border-right: 2px dotted #e8e8e8;
  border-left: none;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-label {
  text-align: left;
}
.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-label {
  right: calc(50% + 14px);
  text-align: right;
}
.ant-tooltip {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  z-index: 1070;
  display: block;
  width: max-content;
  width: intrinsic;
  max-width: 250px;
  visibility: visible;
}
.ant-tooltip-content {
  position: relative;
}
.ant-tooltip-hidden {
  display: none;
}
.ant-tooltip-placement-top,
.ant-tooltip-placement-topLeft,
.ant-tooltip-placement-topRight {
  padding-bottom: 14.3137085px;
}
.ant-tooltip-placement-right,
.ant-tooltip-placement-rightTop,
.ant-tooltip-placement-rightBottom {
  padding-left: 14.3137085px;
}
.ant-tooltip-placement-bottom,
.ant-tooltip-placement-bottomLeft,
.ant-tooltip-placement-bottomRight {
  padding-top: 14.3137085px;
}
.ant-tooltip-placement-left,
.ant-tooltip-placement-leftTop,
.ant-tooltip-placement-leftBottom {
  padding-right: 14.3137085px;
}
.ant-tooltip-inner {
  min-width: 30px;
  min-height: 32px;
  padding: 6px 8px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  word-wrap: break-word;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 6px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.ant-tooltip-arrow {
  position: absolute;
  z-index: 2;
  display: block;
  width: 22px;
  height: 22px;
  overflow: hidden;
  background: transparent;
  pointer-events: none;
}
.ant-tooltip-arrow-content {
  --antd-arrow-background-color: linear-gradient(to right bottom, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.75));
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 11.3137085px;
  height: 11.3137085px;
  margin: auto;
  content: '';
  pointer-events: auto;
  border-radius: 0 0 2px;
  pointer-events: none;
}
.ant-tooltip-arrow-content::before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: var(--antd-arrow-background-color);
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: '';
  clip-path: inset(33% 33%);
  clip-path: path('M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z');
}
.ant-tooltip-placement-top .ant-tooltip-arrow,
.ant-tooltip-placement-topLeft .ant-tooltip-arrow,
.ant-tooltip-placement-topRight .ant-tooltip-arrow {
  bottom: 0;
  transform: translateY(100%);
}
.ant-tooltip-placement-top .ant-tooltip-arrow-content,
.ant-tooltip-placement-topLeft .ant-tooltip-arrow-content,
.ant-tooltip-placement-topRight .ant-tooltip-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(-11px) rotate(45deg);
}
.ant-tooltip-placement-top .ant-tooltip-arrow {
  left: 50%;
  transform: translateY(100%) translateX(-50%);
}
.ant-tooltip-placement-topLeft .ant-tooltip-arrow {
  left: 13px;
}
.ant-tooltip-placement-topRight .ant-tooltip-arrow {
  right: 13px;
}
.ant-tooltip-placement-right .ant-tooltip-arrow,
.ant-tooltip-placement-rightTop .ant-tooltip-arrow,
.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {
  left: 0;
  transform: translateX(-100%);
}
.ant-tooltip-placement-right .ant-tooltip-arrow-content,
.ant-tooltip-placement-rightTop .ant-tooltip-arrow-content,
.ant-tooltip-placement-rightBottom .ant-tooltip-arrow-content {
  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(11px) rotate(135deg);
}
.ant-tooltip-placement-right .ant-tooltip-arrow {
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
}
.ant-tooltip-placement-rightTop .ant-tooltip-arrow {
  top: 5px;
}
.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {
  bottom: 5px;
}
.ant-tooltip-placement-left .ant-tooltip-arrow,
.ant-tooltip-placement-leftTop .ant-tooltip-arrow,
.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {
  right: 0;
  transform: translateX(100%);
}
.ant-tooltip-placement-left .ant-tooltip-arrow-content,
.ant-tooltip-placement-leftTop .ant-tooltip-arrow-content,
.ant-tooltip-placement-leftBottom .ant-tooltip-arrow-content {
  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(-11px) rotate(315deg);
}
.ant-tooltip-placement-left .ant-tooltip-arrow {
  top: 50%;
  transform: translateX(100%) translateY(-50%);
}
.ant-tooltip-placement-leftTop .ant-tooltip-arrow {
  top: 5px;
}
.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {
  bottom: 5px;
}
.ant-tooltip-placement-bottom .ant-tooltip-arrow,
.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,
.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  top: 0;
  transform: translateY(-100%);
}
.ant-tooltip-placement-bottom .ant-tooltip-arrow-content,
.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow-content,
.ant-tooltip-placement-bottomRight .ant-tooltip-arrow-content {
  box-shadow: -3px -3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(11px) rotate(225deg);
}
.ant-tooltip-placement-bottom .ant-tooltip-arrow {
  left: 50%;
  transform: translateY(-100%) translateX(-50%);
}
.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow {
  left: 13px;
}
.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  right: 13px;
}
.ant-tooltip-pink .ant-tooltip-inner {
  background-color: #eb2f96;
}
.ant-tooltip-pink .ant-tooltip-arrow-content::before {
  background: #eb2f96;
}
.ant-tooltip-magenta .ant-tooltip-inner {
  background-color: #eb2f96;
}
.ant-tooltip-magenta .ant-tooltip-arrow-content::before {
  background: #eb2f96;
}
.ant-tooltip-red .ant-tooltip-inner {
  background-color: #f5222d;
}
.ant-tooltip-red .ant-tooltip-arrow-content::before {
  background: #f5222d;
}
.ant-tooltip-volcano .ant-tooltip-inner {
  background-color: #fa541c;
}
.ant-tooltip-volcano .ant-tooltip-arrow-content::before {
  background: #fa541c;
}
.ant-tooltip-orange .ant-tooltip-inner {
  background-color: #fa8c16;
}
.ant-tooltip-orange .ant-tooltip-arrow-content::before {
  background: #fa8c16;
}
.ant-tooltip-yellow .ant-tooltip-inner {
  background-color: #fadb14;
}
.ant-tooltip-yellow .ant-tooltip-arrow-content::before {
  background: #fadb14;
}
.ant-tooltip-gold .ant-tooltip-inner {
  background-color: #faad14;
}
.ant-tooltip-gold .ant-tooltip-arrow-content::before {
  background: #faad14;
}
.ant-tooltip-cyan .ant-tooltip-inner {
  background-color: #13c2c2;
}
.ant-tooltip-cyan .ant-tooltip-arrow-content::before {
  background: #13c2c2;
}
.ant-tooltip-lime .ant-tooltip-inner {
  background-color: #a0d911;
}
.ant-tooltip-lime .ant-tooltip-arrow-content::before {
  background: #a0d911;
}
.ant-tooltip-green .ant-tooltip-inner {
  background-color: #52c41a;
}
.ant-tooltip-green .ant-tooltip-arrow-content::before {
  background: #52c41a;
}
.ant-tooltip-blue .ant-tooltip-inner {
  background-color: #1890ff;
}
.ant-tooltip-blue .ant-tooltip-arrow-content::before {
  background: #1890ff;
}
.ant-tooltip-geekblue .ant-tooltip-inner {
  background-color: #2f54eb;
}
.ant-tooltip-geekblue .ant-tooltip-arrow-content::before {
  background: #2f54eb;
}
.ant-tooltip-purple .ant-tooltip-inner {
  background-color: #722ed1;
}
.ant-tooltip-purple .ant-tooltip-arrow-content::before {
  background: #722ed1;
}
.ant-tooltip-rtl {
  direction: rtl;
}
.ant-tooltip-rtl .ant-tooltip-inner {
  text-align: right;
}
.ant-transfer-customize-list .ant-transfer-list {
  flex: 1 1 50%;
  width: auto;
  height: auto;
  min-height: 200px;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-small {
  border: 0;
  border-radius: 0;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-selection-column {
  width: 40px;
  min-width: 40px;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
  background: #fafafa;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content .ant-table-row:last-child td {
  border-bottom: 1px solid #e8e8e8;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-body {
  margin: 0;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-pagination.ant-pagination {
  margin: 16px 0 4px;
}
.ant-transfer-customize-list .ant-input[disabled] {
  background-color: transparent;
}
.ant-transfer-status-error .ant-transfer-list {
  border-color: #f5222d;
}
.ant-transfer-status-error .ant-transfer-list-search:not([disabled]) {
  border-color: #d9d9d9;
}
.ant-transfer-status-error .ant-transfer-list-search:not([disabled]):hover {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-transfer-status-error .ant-transfer-list-search:not([disabled]):hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-transfer-status-error .ant-transfer-list-search:not([disabled]):focus {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-transfer-status-error .ant-transfer-list-search:not([disabled]):focus {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-transfer-status-warning .ant-transfer-list {
  border-color: #fa8c16;
}
.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]) {
  border-color: #d9d9d9;
}
.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):hover {
  border-color: #462e61;
  border-right-width: 1px;
}
.ant-input-rtl .ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):focus {
  border-color: #462e61;
  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);
  border-right-width: 1px;
  outline: 0;
}
.ant-input-rtl .ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):focus {
  border-right-width: 0;
  border-left-width: 1px !important;
}
.ant-transfer {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: flex;
  align-items: stretch;
}
.ant-transfer-disabled .ant-transfer-list {
  background: #f5f5f5;
}
.ant-transfer-list {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 200px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
.ant-transfer-list-with-pagination {
  width: 250px;
  height: auto;
}
.ant-transfer-list-search .anticon-search {
  color: rgba(0, 0, 0, 0.25);
}
.ant-transfer-list-header {
  display: flex;
  flex: none;
  align-items: center;
  height: 40px;
  padding: 10px 12px 11px;
  color: #545454;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 6px 6px 0 0;
}
.ant-transfer-list-header > *:not(:last-child) {
  margin-right: 4px;
}
.ant-transfer-list-header > * {
  flex: none;
}
.ant-transfer-list-header-title {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-align: right;
  text-overflow: ellipsis;
}
.ant-transfer-list-header-dropdown {
  font-size: 10px;
  transform: translateY(10%);
  cursor: pointer;
}
.ant-transfer-list-header-dropdown[disabled] {
  cursor: not-allowed;
}
.ant-transfer-list-body {
  display: flex;
  flex: auto;
  flex-direction: column;
  overflow: hidden;
  font-size: 14px;
}
.ant-transfer-list-body-search-wrapper {
  position: relative;
  flex: none;
  padding: 12px;
}
.ant-transfer-list-content {
  flex: auto;
  margin: 0;
  padding: 0;
  overflow: auto;
  list-style: none;
}
.ant-transfer-list-content-item {
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 6px 12px;
  line-height: 20px;
  transition: all 0.3s;
}
.ant-transfer-list-content-item > *:not(:last-child) {
  margin-right: 8px;
}
.ant-transfer-list-content-item > * {
  flex: none;
}
.ant-transfer-list-content-item-text {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-transfer-list-content-item-remove {
  position: relative;
  color: #d9d9d9;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-transfer-list-content-item-remove:hover {
  color: #0d0d0d;
}
.ant-transfer-list-content-item-remove::after {
  position: absolute;
  top: -6px;
  right: -50%;
  bottom: -6px;
  left: -50%;
  content: '';
}
.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled).ant-transfer-list-content-item-checked:hover {
  background-color: #8b868f;
}
.ant-transfer-list-content-show-remove .ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {
  background: transparent;
  cursor: default;
}
.ant-transfer-list-content-item-checked {
  background-color: #908b94;
}
.ant-transfer-list-content-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-transfer-list-pagination {
  padding: 8px 0;
  text-align: right;
  border-top: 1px solid #e8e8e8;
}
.ant-transfer-list-body-not-found {
  flex: none;
  width: 100%;
  margin: auto 0;
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
}
.ant-transfer-list-footer {
  border-top: 1px solid #e8e8e8;
}
.ant-transfer-operation {
  display: flex;
  flex: none;
  flex-direction: column;
  align-self: center;
  margin: 0 8px;
  vertical-align: middle;
}
.ant-transfer-operation .ant-btn {
  display: block;
}
.ant-transfer-operation .ant-btn:first-child {
  margin-bottom: 4px;
}
.ant-transfer-operation .ant-btn .anticon {
  font-size: 12px;
}
.ant-transfer .ant-empty-image {
  max-height: -2px;
}
.ant-transfer-rtl {
  direction: rtl;
}
.ant-transfer-rtl .ant-transfer-list-search {
  padding-right: 8px;
  padding-left: 24px;
}
.ant-transfer-rtl .ant-transfer-list-search-action {
  right: auto;
  left: 12px;
}
.ant-transfer-rtl .ant-transfer-list-header > *:not(:last-child) {
  margin-right: 0;
  margin-left: 4px;
}
.ant-transfer-rtl .ant-transfer-list-header {
  right: 0;
  left: auto;
}
.ant-transfer-rtl .ant-transfer-list-header-title {
  text-align: left;
}
.ant-transfer-rtl .ant-transfer-list-content-item > *:not(:last-child) {
  margin-right: 0;
  margin-left: 8px;
}
.ant-transfer-rtl .ant-transfer-list-pagination {
  text-align: left;
}
.ant-transfer-rtl .ant-transfer-list-footer {
  right: 0;
  left: auto;
}
@keyframes ant-tree-node-fx-do-not-use {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.ant-tree.ant-tree-directory .ant-tree-treenode {
  position: relative;
}
.ant-tree.ant-tree-directory .ant-tree-treenode::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 4px;
  left: 0;
  transition: background-color 0.3s;
  content: '';
  pointer-events: none;
}
.ant-tree.ant-tree-directory .ant-tree-treenode:hover::before {
  background: #f5f5f5;
}
.ant-tree.ant-tree-directory .ant-tree-treenode > * {
  z-index: 1;
}
.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-switcher {
  transition: color 0.3s;
}
.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper {
  border-radius: 0;
  user-select: none;
}
.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper:hover {
  background: transparent;
}
.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper.ant-tree-node-selected {
  color: #fff;
  background: transparent;
}
.ant-tree.ant-tree-directory .ant-tree-treenode-selected:hover::before,
.ant-tree.ant-tree-directory .ant-tree-treenode-selected::before {
  background: #351a55;
}
.ant-tree.ant-tree-directory .ant-tree-treenode-selected .ant-tree-switcher {
  color: #fff;
}
.ant-tree.ant-tree-directory .ant-tree-treenode-selected .ant-tree-node-content-wrapper {
  color: #fff;
  background: transparent;
}
.ant-tree-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}
.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner,
.ant-tree-checkbox:hover .ant-tree-checkbox-inner,
.ant-tree-checkbox-input:focus + .ant-tree-checkbox-inner {
  border-color: #351a55;
}
.ant-tree-checkbox-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #351a55;
  border-radius: 4px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: '';
}
.ant-tree-checkbox:hover::after,
.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox::after {
  visibility: visible;
}
.ant-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  border-collapse: separate;
  transition: all 0.3s;
}
.ant-tree-checkbox-inner::after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: ' ';
}
.ant-tree-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: ' ';
}
.ant-tree-checkbox-checked .ant-tree-checkbox-inner {
  background-color: #351a55;
  border-color: #351a55;
}
.ant-tree-checkbox-disabled {
  cursor: not-allowed;
}
.ant-tree-checkbox-disabled.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}
.ant-tree-checkbox-disabled .ant-tree-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}
.ant-tree-checkbox-disabled .ant-tree-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}
.ant-tree-checkbox-disabled .ant-tree-checkbox-inner::after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}
.ant-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-tree-checkbox-disabled:hover::after,
.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-disabled::after {
  visibility: hidden;
}
.ant-tree-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}
.ant-tree-checkbox-wrapper::after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: '\\a0';
}
.ant-tree-checkbox-wrapper.ant-tree-checkbox-wrapper-disabled {
  cursor: not-allowed;
}
.ant-tree-checkbox-wrapper + .ant-tree-checkbox-wrapper {
  margin-left: 8px;
}
.ant-tree-checkbox-wrapper.ant-tree-checkbox-wrapper-in-form-item input[type='checkbox'] {
  width: 14px;
  height: 14px;
}
.ant-tree-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-tree-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.ant-tree-checkbox-group-item {
  margin-right: 8px;
}
.ant-tree-checkbox-group-item:last-child {
  margin-right: 0;
}
.ant-tree-checkbox-group-item + .ant-tree-checkbox-group-item {
  margin-left: 0;
}
.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}
.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #351a55;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: ' ';
}
.ant-tree-checkbox-indeterminate.ant-tree-checkbox-disabled .ant-tree-checkbox-inner::after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-tree-checkbox-rtl {
  direction: rtl;
}
.ant-tree-checkbox-group-rtl .ant-tree-checkbox-group-item {
  margin-right: 0;
  margin-left: 8px;
}
.ant-tree-checkbox-group-rtl .ant-tree-checkbox-group-item:last-child {
  margin-left: 0 !important;
}
.ant-tree-checkbox-group-rtl .ant-tree-checkbox-group-item + .ant-tree-checkbox-group-item {
  margin-left: 8px;
}
.ant-tree {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  background: #fff;
  border-radius: 6px;
  transition: background-color 0.3s;
}
.ant-tree-focused:not(:hover):not(.ant-tree-active-focused) {
  background: #908b94;
}
.ant-tree-list-holder-inner {
  align-items: flex-start;
}
.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner {
  align-items: stretch;
}
.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-node-content-wrapper {
  flex: auto;
}
.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-treenode.dragging {
  position: relative;
}
.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-treenode.dragging::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 4px;
  left: 0;
  border: 1px solid #351a55;
  opacity: 0;
  animation: ant-tree-node-fx-do-not-use 0.3s;
  animation-play-state: running;
  animation-fill-mode: forwards;
  content: '';
  pointer-events: none;
}
.ant-tree .ant-tree-treenode {
  display: flex;
  align-items: flex-start;
  padding: 0 0 4px 0;
  outline: none;
}
.ant-tree .ant-tree-treenode-disabled .ant-tree-node-content-wrapper {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-tree .ant-tree-treenode-disabled .ant-tree-node-content-wrapper:hover {
  background: transparent;
}
.ant-tree .ant-tree-treenode-active .ant-tree-node-content-wrapper {
  background: #f5f5f5;
}
.ant-tree .ant-tree-treenode:not(.ant-tree .ant-tree-treenode-disabled).filter-node .ant-tree-title {
  color: inherit;
  font-weight: 500;
}
.ant-tree .ant-tree-treenode-draggable .ant-tree-draggable-icon {
  width: 24px;
  line-height: 24px;
  text-align: center;
  visibility: visible;
  opacity: 0.2;
  transition: opacity 0.3s;
}
.ant-tree-treenode:hover .ant-tree .ant-tree-treenode-draggable .ant-tree-draggable-icon {
  opacity: 0.45;
}
.ant-tree .ant-tree-treenode-draggable.ant-tree-treenode-disabled .ant-tree-draggable-icon {
  visibility: hidden;
}
.ant-tree-indent {
  align-self: stretch;
  white-space: nowrap;
  user-select: none;
}
.ant-tree-indent-unit {
  display: inline-block;
  width: 24px;
}
.ant-tree-draggable-icon {
  visibility: hidden;
}
.ant-tree-switcher {
  position: relative;
  flex: none;
  align-self: stretch;
  width: 24px;
  margin: 0;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  user-select: none;
}
.ant-tree-switcher .ant-tree-switcher-icon,
.ant-tree-switcher .ant-select-tree-switcher-icon {
  display: inline-block;
  font-size: 10px;
  vertical-align: baseline;
}
.ant-tree-switcher .ant-tree-switcher-icon svg,
.ant-tree-switcher .ant-select-tree-switcher-icon svg {
  transition: transform 0.3s;
}
.ant-tree-switcher-noop {
  cursor: default;
}
.ant-tree-switcher_close .ant-tree-switcher-icon svg {
  transform: rotate(-90deg);
}
.ant-tree-switcher-loading-icon {
  color: #351a55;
}
.ant-tree-switcher-leaf-line {
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 100%;
  height: 100%;
}
.ant-tree-switcher-leaf-line::before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  margin-left: -1px;
  border-right: 1px solid #d9d9d9;
  content: ' ';
}
.ant-tree-switcher-leaf-line::after {
  position: absolute;
  width: 10px;
  height: 14px;
  border-bottom: 1px solid #d9d9d9;
  content: ' ';
}
.ant-tree-checkbox {
  top: initial;
  margin: 4px 8px 0 0;
}
.ant-tree .ant-tree-node-content-wrapper {
  position: relative;
  z-index: auto;
  min-height: 24px;
  margin: 0;
  padding: 0 4px;
  color: inherit;
  line-height: 24px;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s, border 0s, line-height 0s, box-shadow 0s;
}
.ant-tree .ant-tree-node-content-wrapper:hover {
  background-color: #f5f5f5;
}
.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background-color: #847f87;
}
.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  vertical-align: top;
}
.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle:empty {
  display: none;
}
.ant-tree-unselectable .ant-tree-node-content-wrapper:hover {
  background-color: transparent;
}
.ant-tree-node-content-wrapper {
  line-height: 24px;
  user-select: none;
}
.ant-tree-node-content-wrapper .ant-tree-drop-indicator {
  position: absolute;
  z-index: 1;
  height: 2px;
  background-color: #351a55;
  border-radius: 1px;
  pointer-events: none;
}
.ant-tree-node-content-wrapper .ant-tree-drop-indicator::after {
  position: absolute;
  top: -3px;
  left: -6px;
  width: 8px;
  height: 8px;
  background-color: transparent;
  border: 2px solid #351a55;
  border-radius: 50%;
  content: '';
}
.ant-tree .ant-tree-treenode.drop-container > [draggable] {
  box-shadow: 0 0 0 2px #351a55;
}
.ant-tree-show-line .ant-tree-indent-unit {
  position: relative;
  height: 100%;
}
.ant-tree-show-line .ant-tree-indent-unit::before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  border-right: 1px solid #d9d9d9;
  content: '';
}
.ant-tree-show-line .ant-tree-indent-unit-end::before {
  display: none;
}
.ant-tree-show-line .ant-tree-switcher {
  background: #fff;
}
.ant-tree-show-line .ant-tree-switcher-line-icon {
  vertical-align: -0.15em;
}
.ant-tree .ant-tree-treenode-leaf-last .ant-tree-switcher-leaf-line::before {
  top: auto !important;
  bottom: auto !important;
  height: 14px !important;
}
.ant-tree-rtl {
  direction: rtl;
}
.ant-tree-rtl .ant-tree-node-content-wrapper[draggable='true'] .ant-tree-drop-indicator::after {
  right: -6px;
  left: unset;
}
.ant-tree .ant-tree-treenode-rtl {
  direction: rtl;
}
.ant-tree-rtl .ant-tree-switcher_close .ant-tree-switcher-icon svg {
  transform: rotate(90deg);
}
.ant-tree-rtl.ant-tree-show-line .ant-tree-indent-unit::before {
  right: auto;
  left: -13px;
  border-right: none;
  border-left: 1px solid #d9d9d9;
}
.ant-tree-rtl .ant-tree-checkbox {
  margin: 4px 0 0 8px;
}
.ant-tree-select-dropdown-rtl .ant-select-tree-checkbox {
  margin: 4px 0 0 8px;
}
.ant-select-tree-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox-input:focus + .ant-select-tree-checkbox-inner {
  border-color: #351a55;
}
.ant-select-tree-checkbox-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #351a55;
  border-radius: 4px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: '';
}
.ant-select-tree-checkbox:hover::after,
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox::after {
  visibility: visible;
}
.ant-select-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  border-collapse: separate;
  transition: all 0.3s;
}
.ant-select-tree-checkbox-inner::after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: ' ';
}
.ant-select-tree-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner::after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: ' ';
}
.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {
  background-color: #351a55;
  border-color: #351a55;
}
.ant-select-tree-checkbox-disabled {
  cursor: not-allowed;
}
.ant-select-tree-checkbox-disabled.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner::after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner::after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}
.ant-select-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-tree-checkbox-disabled:hover::after,
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-disabled::after {
  visibility: hidden;
}
.ant-select-tree-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}
.ant-select-tree-checkbox-wrapper::after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: '\\a0';
}
.ant-select-tree-checkbox-wrapper.ant-select-tree-checkbox-wrapper-disabled {
  cursor: not-allowed;
}
.ant-select-tree-checkbox-wrapper + .ant-select-tree-checkbox-wrapper {
  margin-left: 8px;
}
.ant-select-tree-checkbox-wrapper.ant-select-tree-checkbox-wrapper-in-form-item input[type='checkbox'] {
  width: 14px;
  height: 14px;
}
.ant-select-tree-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-select-tree-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.ant-select-tree-checkbox-group-item {
  margin-right: 8px;
}
.ant-select-tree-checkbox-group-item:last-child {
  margin-right: 0;
}
.ant-select-tree-checkbox-group-item + .ant-select-tree-checkbox-group-item {
  margin-left: 0;
}
.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}
.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner::after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #351a55;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: ' ';
}
.ant-select-tree-checkbox-indeterminate.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner::after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-select-tree-checkbox-rtl {
  direction: rtl;
}
.ant-select-tree-checkbox-group-rtl .ant-select-tree-checkbox-group-item {
  margin-right: 0;
  margin-left: 8px;
}
.ant-select-tree-checkbox-group-rtl .ant-select-tree-checkbox-group-item:last-child {
  margin-left: 0 !important;
}
.ant-select-tree-checkbox-group-rtl .ant-select-tree-checkbox-group-item + .ant-select-tree-checkbox-group-item {
  margin-left: 8px;
}
.ant-tree-select-dropdown {
  padding: 8px 4px;
}
.ant-tree-select-dropdown-rtl {
  direction: rtl;
}
.ant-tree-select-dropdown .ant-select-tree {
  border-radius: 0;
}
.ant-tree-select-dropdown .ant-select-tree-list-holder-inner {
  align-items: stretch;
}
.ant-tree-select-dropdown .ant-select-tree-list-holder-inner .ant-select-tree-treenode .ant-select-tree-node-content-wrapper {
  flex: auto;
}
.ant-select-tree {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  background: #fff;
  border-radius: 6px;
  transition: background-color 0.3s;
}
.ant-select-tree-focused:not(:hover):not(.ant-select-tree-active-focused) {
  background: #908b94;
}
.ant-select-tree-list-holder-inner {
  align-items: flex-start;
}
.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner {
  align-items: stretch;
}
.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-node-content-wrapper {
  flex: auto;
}
.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-treenode.dragging {
  position: relative;
}
.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-treenode.dragging::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 4px;
  left: 0;
  border: 1px solid #351a55;
  opacity: 0;
  animation: ant-tree-node-fx-do-not-use 0.3s;
  animation-play-state: running;
  animation-fill-mode: forwards;
  content: '';
  pointer-events: none;
}
.ant-select-tree .ant-select-tree-treenode {
  display: flex;
  align-items: flex-start;
  padding: 0 0 4px 0;
  outline: none;
}
.ant-select-tree .ant-select-tree-treenode-disabled .ant-select-tree-node-content-wrapper {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-tree .ant-select-tree-treenode-disabled .ant-select-tree-node-content-wrapper:hover {
  background: transparent;
}
.ant-select-tree .ant-select-tree-treenode-active .ant-select-tree-node-content-wrapper {
  background: #f5f5f5;
}
.ant-select-tree .ant-select-tree-treenode:not(.ant-select-tree .ant-select-tree-treenode-disabled).filter-node .ant-select-tree-title {
  color: inherit;
  font-weight: 500;
}
.ant-select-tree .ant-select-tree-treenode-draggable .ant-select-tree-draggable-icon {
  width: 24px;
  line-height: 24px;
  text-align: center;
  visibility: visible;
  opacity: 0.2;
  transition: opacity 0.3s;
}
.ant-select-tree-treenode:hover .ant-select-tree .ant-select-tree-treenode-draggable .ant-select-tree-draggable-icon {
  opacity: 0.45;
}
.ant-select-tree .ant-select-tree-treenode-draggable.ant-select-tree-treenode-disabled .ant-select-tree-draggable-icon {
  visibility: hidden;
}
.ant-select-tree-indent {
  align-self: stretch;
  white-space: nowrap;
  user-select: none;
}
.ant-select-tree-indent-unit {
  display: inline-block;
  width: 24px;
}
.ant-select-tree-draggable-icon {
  visibility: hidden;
}
.ant-select-tree-switcher {
  position: relative;
  flex: none;
  align-self: stretch;
  width: 24px;
  margin: 0;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  user-select: none;
}
.ant-select-tree-switcher .ant-tree-switcher-icon,
.ant-select-tree-switcher .ant-select-tree-switcher-icon {
  display: inline-block;
  font-size: 10px;
  vertical-align: baseline;
}
.ant-select-tree-switcher .ant-tree-switcher-icon svg,
.ant-select-tree-switcher .ant-select-tree-switcher-icon svg {
  transition: transform 0.3s;
}
.ant-select-tree-switcher-noop {
  cursor: default;
}
.ant-select-tree-switcher_close .ant-select-tree-switcher-icon svg {
  transform: rotate(-90deg);
}
.ant-select-tree-switcher-loading-icon {
  color: #351a55;
}
.ant-select-tree-switcher-leaf-line {
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 100%;
  height: 100%;
}
.ant-select-tree-switcher-leaf-line::before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  margin-left: -1px;
  border-right: 1px solid #d9d9d9;
  content: ' ';
}
.ant-select-tree-switcher-leaf-line::after {
  position: absolute;
  width: 10px;
  height: 14px;
  border-bottom: 1px solid #d9d9d9;
  content: ' ';
}
.ant-select-tree-checkbox {
  top: initial;
  margin: 4px 8px 0 0;
}
.ant-select-tree .ant-select-tree-node-content-wrapper {
  position: relative;
  z-index: auto;
  min-height: 24px;
  margin: 0;
  padding: 0 4px;
  color: inherit;
  line-height: 24px;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s, border 0s, line-height 0s, box-shadow 0s;
}
.ant-select-tree .ant-select-tree-node-content-wrapper:hover {
  background-color: #f5f5f5;
}
.ant-select-tree .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
  background-color: #847f87;
}
.ant-select-tree .ant-select-tree-node-content-wrapper .ant-select-tree-iconEle {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  vertical-align: top;
}
.ant-select-tree .ant-select-tree-node-content-wrapper .ant-select-tree-iconEle:empty {
  display: none;
}
.ant-select-tree-unselectable .ant-select-tree-node-content-wrapper:hover {
  background-color: transparent;
}
.ant-select-tree-node-content-wrapper {
  line-height: 24px;
  user-select: none;
}
.ant-select-tree-node-content-wrapper .ant-tree-drop-indicator {
  position: absolute;
  z-index: 1;
  height: 2px;
  background-color: #351a55;
  border-radius: 1px;
  pointer-events: none;
}
.ant-select-tree-node-content-wrapper .ant-tree-drop-indicator::after {
  position: absolute;
  top: -3px;
  left: -6px;
  width: 8px;
  height: 8px;
  background-color: transparent;
  border: 2px solid #351a55;
  border-radius: 50%;
  content: '';
}
.ant-select-tree .ant-select-tree-treenode.drop-container > [draggable] {
  box-shadow: 0 0 0 2px #351a55;
}
.ant-select-tree-show-line .ant-select-tree-indent-unit {
  position: relative;
  height: 100%;
}
.ant-select-tree-show-line .ant-select-tree-indent-unit::before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  border-right: 1px solid #d9d9d9;
  content: '';
}
.ant-select-tree-show-line .ant-select-tree-indent-unit-end::before {
  display: none;
}
.ant-select-tree-show-line .ant-select-tree-switcher {
  background: #fff;
}
.ant-select-tree-show-line .ant-select-tree-switcher-line-icon {
  vertical-align: -0.15em;
}
.ant-select-tree .ant-select-tree-treenode-leaf-last .ant-select-tree-switcher-leaf-line::before {
  top: auto !important;
  bottom: auto !important;
  height: 14px !important;
}
.ant-tree-select-dropdown-rtl .ant-select-tree .ant-select-tree-switcher_close .ant-select-tree-switcher-icon svg {
  transform: rotate(90deg);
}
.ant-tree-select-dropdown-rtl .ant-select-tree .ant-select-tree-switcher-loading-icon {
  transform: scaleY(-1);
}
.ant-typography {
  color: #545454;
  word-break: break-word;
}
.ant-typography.ant-typography-secondary {
  color: #595959;
}
.ant-typography.ant-typography-success {
  color: #52c41a;
}
.ant-typography.ant-typography-warning {
  color: #fa8c16;
}
.ant-typography.ant-typography-danger {
  color: #f5222d;
}
a.ant-typography.ant-typography-danger:active,
a.ant-typography.ant-typography-danger:focus {
  color: #cf1322;
}
a.ant-typography.ant-typography-danger:hover {
  color: #ff4d4f;
}
.ant-typography.ant-typography-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  user-select: none;
}
div.ant-typography,
.ant-typography p {
  margin-bottom: 1em;
}
h1.ant-typography,
div.ant-typography-h1,
div.ant-typography-h1 > textarea,
.ant-typography h1 {
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 600;
  font-size: 38px;
  line-height: 1.23;
}
h2.ant-typography,
div.ant-typography-h2,
div.ant-typography-h2 > textarea,
.ant-typography h2 {
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 600;
  font-size: 30px;
  line-height: 1.35;
}
h3.ant-typography,
div.ant-typography-h3,
div.ant-typography-h3 > textarea,
.ant-typography h3 {
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.35;
}
h4.ant-typography,
div.ant-typography-h4,
div.ant-typography-h4 > textarea,
.ant-typography h4 {
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
}
h5.ant-typography,
div.ant-typography-h5,
div.ant-typography-h5 > textarea,
.ant-typography h5 {
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
}
.ant-typography + h1.ant-typography,
.ant-typography + h2.ant-typography,
.ant-typography + h3.ant-typography,
.ant-typography + h4.ant-typography,
.ant-typography + h5.ant-typography {
  margin-top: 1.2em;
}
.ant-typography div + h1,
.ant-typography ul + h1,
.ant-typography li + h1,
.ant-typography p + h1,
.ant-typography h1 + h1,
.ant-typography h2 + h1,
.ant-typography h3 + h1,
.ant-typography h4 + h1,
.ant-typography h5 + h1,
.ant-typography div + h2,
.ant-typography ul + h2,
.ant-typography li + h2,
.ant-typography p + h2,
.ant-typography h1 + h2,
.ant-typography h2 + h2,
.ant-typography h3 + h2,
.ant-typography h4 + h2,
.ant-typography h5 + h2,
.ant-typography div + h3,
.ant-typography ul + h3,
.ant-typography li + h3,
.ant-typography p + h3,
.ant-typography h1 + h3,
.ant-typography h2 + h3,
.ant-typography h3 + h3,
.ant-typography h4 + h3,
.ant-typography h5 + h3,
.ant-typography div + h4,
.ant-typography ul + h4,
.ant-typography li + h4,
.ant-typography p + h4,
.ant-typography h1 + h4,
.ant-typography h2 + h4,
.ant-typography h3 + h4,
.ant-typography h4 + h4,
.ant-typography h5 + h4,
.ant-typography div + h5,
.ant-typography ul + h5,
.ant-typography li + h5,
.ant-typography p + h5,
.ant-typography h1 + h5,
.ant-typography h2 + h5,
.ant-typography h3 + h5,
.ant-typography h4 + h5,
.ant-typography h5 + h5 {
  margin-top: 1.2em;
}
a.ant-typography-ellipsis,
span.ant-typography-ellipsis {
  display: inline-block;
  max-width: 100%;
}
a.ant-typography,
.ant-typography a {
  color: var(--app-primary-color);
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  text-decoration: none;
}
a.ant-typography:focus-visible,
.ant-typography a:focus-visible,
a.ant-typography:hover,
.ant-typography a:hover {
  color: #0d0d0d;
}
a.ant-typography:active,
.ant-typography a:active {
  color: #000000;
}
a.ant-typography:active,
.ant-typography a:active,
a.ant-typography:hover,
.ant-typography a:hover {
  text-decoration: none;
}
a.ant-typography[disabled],
.ant-typography a[disabled],
a.ant-typography.ant-typography-disabled,
.ant-typography a.ant-typography-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
a.ant-typography[disabled]:active,
.ant-typography a[disabled]:active,
a.ant-typography.ant-typography-disabled:active,
.ant-typography a.ant-typography-disabled:active,
a.ant-typography[disabled]:hover,
.ant-typography a[disabled]:hover,
a.ant-typography.ant-typography-disabled:hover,
.ant-typography a.ant-typography-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
}
a.ant-typography[disabled]:active,
.ant-typography a[disabled]:active,
a.ant-typography.ant-typography-disabled:active,
.ant-typography a.ant-typography-disabled:active {
  pointer-events: none;
}
.ant-typography code {
  margin: 0 0.2em;
  padding: 0.2em 0.4em 0.1em;
  font-size: 85%;
  background: rgba(150, 150, 150, 0.1);
  border: 1px solid rgba(100, 100, 100, 0.2);
  border-radius: 3px;
}
.ant-typography kbd {
  margin: 0 0.2em;
  padding: 0.15em 0.4em 0.1em;
  font-size: 90%;
  background: rgba(150, 150, 150, 0.06);
  border: 1px solid rgba(100, 100, 100, 0.2);
  border-bottom-width: 2px;
  border-radius: 3px;
}
.ant-typography mark {
  padding: 0;
  background-color: #ffe58f;
}
.ant-typography u,
.ant-typography ins {
  text-decoration: underline;
  text-decoration-skip-ink: auto;
}
.ant-typography s,
.ant-typography del {
  text-decoration: line-through;
}
.ant-typography strong {
  font-weight: 600;
}
.ant-typography-expand,
.ant-typography-edit,
.ant-typography-copy {
  color: var(--app-primary-color);
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  margin-left: 4px;
}
.ant-typography-expand:focus-visible,
.ant-typography-edit:focus-visible,
.ant-typography-copy:focus-visible,
.ant-typography-expand:hover,
.ant-typography-edit:hover,
.ant-typography-copy:hover {
  color: #0d0d0d;
}
.ant-typography-expand:active,
.ant-typography-edit:active,
.ant-typography-copy:active {
  color: #000000;
}
.ant-typography-copy-success,
.ant-typography-copy-success:hover,
.ant-typography-copy-success:focus {
  color: #52c41a;
}
.ant-typography-edit-content {
  position: relative;
}
div.ant-typography-edit-content {
  left: -12px;
  margin-top: -8.9px;
  margin-bottom: calc(1em - 7.9px - 1px);
}
.ant-typography-edit-content-confirm {
  position: absolute;
  right: 10px;
  bottom: 8px;
  color: #595959;
  font-weight: normal;
  font-size: 14px;
  font-style: normal;
  pointer-events: none;
}
.ant-typography-edit-content textarea {
  height: 1em;
  margin: 0 !important;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -moz-transition: none;
}
.ant-typography ul,
.ant-typography ol {
  margin: 0 0 1em;
  padding: 0;
}
.ant-typography ul li,
.ant-typography ol li {
  margin: 0 0 0 20px;
  padding: 0 0 0 4px;
}
.ant-typography ul {
  list-style-type: circle;
}
.ant-typography ul ul {
  list-style-type: disc;
}
.ant-typography ol {
  list-style-type: decimal;
}
.ant-typography pre,
.ant-typography blockquote {
  margin: 1em 0;
}
.ant-typography pre {
  padding: 0.4em 0.6em;
  white-space: pre-wrap;
  word-wrap: break-word;
  background: rgba(150, 150, 150, 0.1);
  border: 1px solid rgba(100, 100, 100, 0.2);
  border-radius: 3px;
}
.ant-typography pre code {
  display: inline;
  margin: 0;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  background: transparent;
  border: 0;
}
.ant-typography blockquote {
  padding: 0 0 0 0.6em;
  border-left: 4px solid rgba(100, 100, 100, 0.2);
  opacity: 0.85;
}
.ant-typography-single-line {
  white-space: nowrap;
}
.ant-typography-ellipsis-single-line {
  overflow: hidden;
  text-overflow: ellipsis;
}
a.ant-typography-ellipsis-single-line,
span.ant-typography-ellipsis-single-line {
  vertical-align: bottom;
}
.ant-typography-ellipsis-multiple-line {
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  /*! autoprefixer: ignore next */
  -webkit-box-orient: vertical;
}
.ant-typography-rtl {
  direction: rtl;
}
.ant-typography-rtl .ant-typography-expand,
.ant-typography-rtl .ant-typography-edit,
.ant-typography-rtl .ant-typography-copy {
  margin-right: 4px;
  margin-left: 0;
}
.ant-typography-rtl .ant-typography-expand {
  float: left;
}
div.ant-typography-edit-content.ant-typography-rtl {
  right: -12px;
  left: auto;
}
.ant-typography-rtl .ant-typography-edit-content-confirm {
  right: auto;
  left: 10px;
}
.ant-typography-rtl.ant-typography ul li,
.ant-typography-rtl.ant-typography ol li {
  margin: 0 20px 0 0;
  padding: 0 4px 0 0;
}
.ant-upload {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  outline: 0;
}
.ant-upload p {
  margin: 0;
}
.ant-upload-btn {
  display: block;
  width: 100%;
  outline: none;
}
.ant-upload input[type='file'] {
  cursor: pointer;
}
.ant-upload.ant-upload-select {
  display: inline-block;
}
.ant-upload.ant-upload-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-upload.ant-upload-select-picture-card {
  width: 104px;
  height: 104px;
  margin-right: 8px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: top;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.3s;
}
.ant-upload.ant-upload-select-picture-card > .ant-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}
.ant-upload.ant-upload-select-picture-card:hover {
  border-color: #351a55;
}
.ant-upload-disabled.ant-upload.ant-upload-select-picture-card:hover {
  border-color: #d9d9d9;
}
.ant-upload.ant-upload-drag {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.3s;
}
.ant-upload.ant-upload-drag .ant-upload {
  padding: 16px 0;
}
.ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {
  border-color: #1a0c2e;
}
.ant-upload.ant-upload-drag.ant-upload-disabled {
  cursor: not-allowed;
}
.ant-upload.ant-upload-drag .ant-upload-btn {
  display: table;
  height: 100%;
}
.ant-upload.ant-upload-drag .ant-upload-drag-container {
  display: table-cell;
  vertical-align: middle;
}
.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {
  border-color: #462e61;
}
.ant-upload.ant-upload-drag p.ant-upload-drag-icon {
  margin-bottom: 20px;
}
.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
  color: #462e61;
  font-size: 48px;
}
.ant-upload.ant-upload-drag p.ant-upload-text {
  margin: 0 0 4px;
  color: #535353;
  font-size: 16px;
}
.ant-upload.ant-upload-drag p.ant-upload-hint {
  color: #595959;
  font-size: 14px;
}
.ant-upload.ant-upload-drag .anticon-plus {
  color: rgba(0, 0, 0, 0.25);
  font-size: 30px;
  transition: all 0.3s;
}
.ant-upload.ant-upload-drag .anticon-plus:hover {
  color: #595959;
}
.ant-upload.ant-upload-drag:hover .anticon-plus {
  color: #595959;
}
.ant-upload-picture-card-wrapper {
  display: inline-block;
  width: 100%;
}
.ant-upload-picture-card-wrapper::before {
  display: table;
  content: '';
}
.ant-upload-picture-card-wrapper::after {
  display: table;
  clear: both;
  content: '';
}
.ant-upload-picture-card-wrapper::before {
  display: table;
  content: '';
}
.ant-upload-picture-card-wrapper::after {
  display: table;
  clear: both;
  content: '';
}
.ant-upload-list {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  line-height: 1.3;
}
.ant-upload-list::before {
  display: table;
  content: '';
}
.ant-upload-list::after {
  display: table;
  clear: both;
  content: '';
}
.ant-upload-list::before {
  display: table;
  content: '';
}
.ant-upload-list::after {
  display: table;
  clear: both;
  content: '';
}
.ant-upload-list-item {
  position: relative;
  height: 18.2px;
  margin-top: 8px;
  font-size: 14px;
}
.ant-upload-list-item-name {
  display: inline-block;
  width: 100%;
  padding-left: 22px;
  overflow: hidden;
  line-height: 1.3;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-upload-list-item-card-actions {
  position: absolute;
  right: 0;
}
.ant-upload-list-item-card-actions-btn {
  opacity: 0;
}
.ant-upload-list-item-card-actions-btn.ant-btn-sm {
  height: 18.2px;
  line-height: 1;
  vertical-align: top;
}
.ant-upload-list-item-card-actions.picture {
  top: 22px;
  line-height: 0;
}
.ant-upload-list-item-card-actions-btn:focus,
.ant-upload-list-item-card-actions.picture .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}
.ant-upload-list-item-card-actions .anticon {
  color: #595959;
  transition: all 0.3s;
}
.ant-upload-list-item-card-actions:hover .anticon {
  color: #545454;
}
.ant-upload-list-item-info {
  height: 100%;
  transition: background-color 0.3s;
}
.ant-upload-list-item-info > span {
  display: block;
  width: 100%;
  height: 100%;
}
.ant-upload-list-item-info .anticon-loading .anticon,
.ant-upload-list-item-info .ant-upload-text-icon .anticon {
  position: absolute;
  top: 5px;
  color: #595959;
  font-size: 14px;
}
.ant-upload-list-item:hover .ant-upload-list-item-info {
  background-color: #f5f5f5;
}
.ant-upload-list-item:hover .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}
.ant-upload-list-item-error,
.ant-upload-list-item-error .ant-upload-text-icon > .anticon,
.ant-upload-list-item-error .ant-upload-list-item-name {
  color: #f5222d;
}
.ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
  color: #f5222d;
}
.ant-upload-list-item-error .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}
.ant-upload-list-item-progress {
  position: absolute;
  bottom: -12px;
  width: 100%;
  padding-left: 26px;
  font-size: 14px;
  line-height: 0;
}
.ant-upload-list-picture .ant-upload-list-item,
.ant-upload-list-picture-card .ant-upload-list-item {
  position: relative;
  height: 66px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
.ant-upload-list-picture .ant-upload-list-item:hover,
.ant-upload-list-picture-card .ant-upload-list-item:hover {
  background: transparent;
}
.ant-upload-list-picture .ant-upload-list-item-error,
.ant-upload-list-picture-card .ant-upload-list-item-error {
  border-color: #f5222d;
}
.ant-upload-list-picture .ant-upload-list-item-info,
.ant-upload-list-picture-card .ant-upload-list-item-info {
  padding: 0;
}
.ant-upload-list-picture .ant-upload-list-item:hover .ant-upload-list-item-info,
.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info {
  background: transparent;
}
.ant-upload-list-picture .ant-upload-list-item-uploading,
.ant-upload-list-picture-card .ant-upload-list-item-uploading {
  border-style: dashed;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
  width: 48px;
  height: 48px;
  line-height: 60px;
  text-align: center;
  opacity: 0.8;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail .anticon,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail .anticon {
  font-size: 26px;
}
.ant-upload-list-picture .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#e6f7ff'],
.ant-upload-list-picture-card .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#e6f7ff'] {
  fill: #fff1f0;
}
.ant-upload-list-picture .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#1890ff'],
.ant-upload-list-picture-card .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#1890ff'] {
  fill: #f5222d;
}
.ant-upload-list-picture .ant-upload-list-item-icon,
.ant-upload-list-picture-card .ant-upload-list-item-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 26px;
  transform: translate(-50%, -50%);
}
.ant-upload-list-picture .ant-upload-list-item-icon .anticon,
.ant-upload-list-picture-card .ant-upload-list-item-icon .anticon {
  font-size: 26px;
}
.ant-upload-list-picture .ant-upload-list-item-image,
.ant-upload-list-picture-card .ant-upload-list-item-image {
  max-width: 100%;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail img,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  display: block;
  width: 48px;
  height: 48px;
  overflow: hidden;
}
.ant-upload-list-picture .ant-upload-list-item-name,
.ant-upload-list-picture-card .ant-upload-list-item-name {
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0 0 0 8px;
  padding-right: 8px;
  padding-left: 48px;
  overflow: hidden;
  line-height: 44px;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.3s;
}
.ant-upload-list-picture .ant-upload-list-item-uploading .ant-upload-list-item-name,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-name {
  margin-bottom: 12px;
}
.ant-upload-list-picture .ant-upload-list-item-progress,
.ant-upload-list-picture-card .ant-upload-list-item-progress {
  bottom: 14px;
  width: calc(100% - 24px);
  margin-top: 0;
  padding-left: 56px;
}
.ant-upload-list-picture-card-container {
  display: inline-block;
  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  vertical-align: top;
}
.ant-upload-list-picture-card .ant-upload-list-item {
  height: 100%;
  margin: 0;
}
.ant-upload-list-picture-card .ant-upload-list-item-info {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.ant-upload-list-picture-card .ant-upload-list-item-info::before {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: all 0.3s;
  content: ' ';
}
.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info::before {
  opacity: 1;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  white-space: nowrap;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.3s;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete {
  z-index: 10;
  width: 16px;
  margin: 0 4px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye:hover,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download:hover,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete:hover {
  color: #fff;
}
.ant-upload-list-picture-card .ant-upload-list-item-info:hover + .ant-upload-list-item-actions,
.ant-upload-list-picture-card .ant-upload-list-item-actions:hover {
  opacity: 1;
}
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  position: static;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.ant-upload-list-picture-card .ant-upload-list-item-name {
  display: none;
  margin: 8px 0 0;
  padding: 0;
  line-height: 1.3;
  text-align: center;
}
.ant-upload-list-picture-card .ant-upload-list-item-file + .ant-upload-list-item-name {
  position: absolute;
  bottom: 10px;
  display: block;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading.ant-upload-list-item {
  background-color: #fafafa;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info {
  height: auto;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info::before,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-eye,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-delete {
  display: none;
}
.ant-upload-list-picture-card .ant-upload-list-item-progress {
  bottom: 32px;
  width: calc(100% - 14px);
  padding-left: 0;
}
.ant-upload-list-text-container,
.ant-upload-list-picture-container {
  transition: opacity 0.3s, height 0.3s;
}
.ant-upload-list-text-container::before,
.ant-upload-list-picture-container::before {
  display: table;
  width: 0;
  height: 0;
  content: '';
}
.ant-upload-list-text-container .ant-upload-span,
.ant-upload-list-picture-container .ant-upload-span {
  display: block;
  flex: auto;
}
.ant-upload-list-text .ant-upload-span,
.ant-upload-list-picture .ant-upload-span {
  display: flex;
  align-items: center;
}
.ant-upload-list-text .ant-upload-span > *,
.ant-upload-list-picture .ant-upload-span > * {
  flex: none;
}
.ant-upload-list-text .ant-upload-list-item-name,
.ant-upload-list-picture .ant-upload-list-item-name {
  flex: auto;
  margin: 0;
  padding: 0 8px;
}
.ant-upload-list-text .ant-upload-list-item-card-actions,
.ant-upload-list-picture .ant-upload-list-item-card-actions {
  position: static;
}
.ant-upload-list-text .ant-upload-text-icon .anticon {
  position: static;
}
.ant-upload-list .ant-upload-animate-inline-appear,
.ant-upload-list .ant-upload-animate-inline-enter,
.ant-upload-list .ant-upload-animate-inline-leave {
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
  animation-fill-mode: forwards;
}
.ant-upload-list .ant-upload-animate-inline-appear,
.ant-upload-list .ant-upload-animate-inline-enter {
  animation-name: uploadAnimateInlineIn;
}
.ant-upload-list .ant-upload-animate-inline-leave {
  animation-name: uploadAnimateInlineOut;
}
@keyframes uploadAnimateInlineIn {
  from {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
@keyframes uploadAnimateInlineOut {
  to {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
.ant-upload-rtl {
  direction: rtl;
}
.ant-upload-rtl.ant-upload.ant-upload-select-picture-card {
  margin-right: auto;
  margin-left: 8px;
}
.ant-upload-list-rtl {
  direction: rtl;
}
.ant-upload-list-rtl .ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-1 {
  padding-right: 22px;
  padding-left: 14px;
}
.ant-upload-list-rtl .ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-2 {
  padding-right: 22px;
  padding-left: 28px;
}
.ant-upload-list-rtl .ant-upload-list-item-name {
  padding-right: 22px;
  padding-left: 0;
}
.ant-upload-list-rtl .ant-upload-list-item-name-icon-count-1 {
  padding-left: 14px;
}
.ant-upload-list-rtl .ant-upload-list-item-card-actions {
  right: auto;
  left: 0;
}
.ant-upload-list-rtl .ant-upload-list-item-card-actions .anticon {
  padding-right: 0;
  padding-left: 5px;
}
.ant-upload-list-rtl .ant-upload-list-item-info {
  padding: 0 4px 0 12px;
}
.ant-upload-list-rtl .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
  padding-right: 0;
  padding-left: 5px;
}
.ant-upload-list-rtl .ant-upload-list-item-progress {
  padding-right: 26px;
  padding-left: 0;
}
.ant-upload-list-picture .ant-upload-list-item-info,
.ant-upload-list-picture-card .ant-upload-list-item-info {
  padding: 0;
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-thumbnail,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
  right: 8px;
  left: auto;
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-icon,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-icon {
  right: 50%;
  left: auto;
  transform: translate(50%, -50%);
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name {
  margin: 0 8px 0 0;
  padding-right: 48px;
  padding-left: 8px;
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name-icon-count-1,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-1 {
  padding-right: 48px;
  padding-left: 18px;
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name-icon-count-2,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-2 {
  padding-right: 48px;
  padding-left: 36px;
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-progress,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-progress {
  padding-right: 0;
  padding-left: 0;
}
.ant-upload-list-rtl .ant-upload-list-picture-card-container {
  margin: 0 0 8px 8px;
}
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-actions {
  right: 50%;
  left: auto;
  transform: translate(50%, -50%);
}
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-file + .ant-upload-list-item-name {
  margin: 8px 0 0;
  padding: 0;
}
/* color classes */
.gx-bg-primary {
  background-color: var(--app-primary-color) !important;
}
a.gx-bg-primary:hover,
a.gx-bg-primary:focus {
  background-color: var(--app-primary-color) !important;
}
.gx-bg-primary-light {
  background-color: #5a456e !important;
}
.gx-bg-secondary {
  background-color: var(--app-secondary-color) !important;
}
a.gx-bg-secondary:hover,
a.gx-bg-secondary:focus {
  background-color: var(--app-secondary-color) !important;
}
.gx-bg-success {
  background-color: #52c41a !important;
}
a.gx-bg-success:hover,
a.gx-bg-success:focus {
  background-color: #3f9714 !important;
}
.gx-bg-success-dark {
  background-color: #368011 !important;
}
a.gx-bg-success-dark:hover,
a.gx-bg-success-dark:focus {
  background-color: #2c6a0e !important;
}
.gx-bg-info {
  background-color: #1890ff !important;
}
a.gx-bg-info:hover,
a.gx-bg-info:focus {
  background-color: #0076e4 !important;
}
.gx-bg-warning {
  background-color: #fa8c16 !important;
}
a.gx-bg-warning:hover,
a.gx-bg-warning:focus {
  background-color: #d87205 !important;
}
.gx-bg-danger {
  background-color: #f44336 !important;
}
a.gx-bg-danger:hover,
a.gx-bg-danger:focus {
  background-color: #ea1c0d !important;
}
.gx-bg-light {
  background-color: #e8e8e8 !important;
}
a.gx-bg-light:hover,
a.gx-bg-light:focus {
  background-color: #d9d9d9 !important;
}
.gx-bg-dark {
  background-color: #000000 !important;
}
a.gx-bg-dark:hover,
a.gx-bg-dark:focus {
  background-color: #1a1a1a !important;
}
.gx-bg-white {
  background-color: #ffffff !important;
}
a.gx-bg-white:hover,
a.gx-bg-white:focus {
  background-color: #f2f2f2 !important;
}
.gx-bg-grey {
  background-color: #cccccc !important;
}
a.gx-bg-grey:hover,
a.gx-bg-grey:focus {
  background-color: #b2b2b2 !important;
}
.gx-bg-light-grey {
  background-color: #fafafa !important;
}
.gx-bg-transparent {
  background-color: transparent !important;
}
.gx-bg-pink {
  background-color: #eb2f96 !important;
}
a.gx-bg-pink:hover,
a.gx-bg-pink:focus {
  background-color: #d3147d !important;
}
.gx-bg-green {
  background-color: #52c41a !important;
}
a.gx-bg-green:hover,
a.gx-bg-green:focus {
  background-color: #3f9714 !important;
}
.gx-bg-green-light {
  background-color: #caf5b5 !important;
}
a.gx-bg-green-light:hover,
a.gx-bg-green-light:focus {
  background-color: #8ae95b !important;
}
.gx-bg-red {
  background-color: #f5222d !important;
}
a.gx-bg-red:hover,
a.gx-bg-red:focus {
  background-color: #da0a15 !important;
}
.gx-bg-amber {
  background-color: #fadb14 !important;
}
a.gx-bg-amber:hover,
a.gx-bg-amber:focus {
  background-color: #d6ba05 !important;
}
.gx-bg-amber-light {
  background-color: #fdf2aa !important;
}
a.gx-bg-amber-light:hover,
a.gx-bg-amber-light:focus {
  background-color: #fcea78 !important;
}
.gx-bg-blue {
  background-color: #1890ff !important;
}
a.gx-bg-blue:hover,
a.gx-bg-blue:focus {
  background-color: #0076e4 !important;
}
.gx-bg-light-blue {
  background-color: #329cff !important;
}
a.gx-bg-light-blue:hover,
a.gx-bg-light-blue:focus {
  background-color: #4ba9ff !important;
}
.gx-bg-indigo {
  background-color: #3c1991 !important;
}
a.gx-bg-indigo:hover,
a.gx-bg-indigo:focus {
  background-color: #2a1166 !important;
}
.gx-bg-purple {
  background-color: #722ed1 !important;
}
a.gx-bg-purple:hover,
a.gx-bg-purple:focus {
  background-color: #5b25a7 !important;
}
.gx-bg-orange {
  background-color: #fa8c16 !important;
}
a.gx-bg-orange:hover,
a.gx-bg-orange:focus {
  background-color: #d87205 !important;
}
.gx-bg-yellow {
  background-color: #fadb14 !important;
}
a.gx-bg-yellow:hover,
a.gx-bg-yellow:focus {
  background-color: #d6ba05 !important;
}
.gx-bg-teal {
  background-color: #20c997 !important;
}
a.gx-bg-teal:hover,
a.gx-bg-teal:focus {
  background-color: #199d76 !important;
}
.gx-bg-cyan {
  background-color: #13c2c2 !important;
}
a.gx-bg-cyan:hover,
a.gx-bg-cyan:focus {
  background-color: #0e9494 !important;
}
.gx-bg-sepia {
  background-color: #7c3535 !important;
}
a.gx-bg-sepia:hover,
a.gx-bg-sepia:focus {
  background-color: #582626 !important;
}
.gx-bg-geekblue {
  background-color: #030852 !important;
}
a.gx-bg-geekblue:hover,
a.gx-bg-geekblue:focus {
  background-color: #010321 !important;
}
.gx-text-white {
  color: #ffffff !important;
}
.gx-text-primary {
  color: var(--app-primary-color) !important;
}
a.gx-text-primary:hover,
a.gx-text-primary:focus {
  color: var(--app-primary-color) !important;
}
.gx-text-secondary {
  color: var(--app-secondary-color) !important;
}
a.gx-text-secondary:hover,
a.gx-text-secondary:focus {
  color: var(--app-secondary-color) !important;
}
.gx-text-success {
  color: #52c41a !important;
}
a.gx-text-success:hover,
a.gx-text-success:focus {
  color: #49ad17 !important;
}
.gx-text-success-dark {
  color: #368011 !important;
}
a.gx-text-success-dark:hover,
a.gx-text-success-dark:focus {
  color: #2c6a0e !important;
}
.gx-text-info {
  color: #1890ff !important;
}
a.gx-text-info:hover,
a.gx-text-info:focus {
  color: #0084fe !important;
}
.gx-text-warning {
  color: #fa8c16 !important;
}
a.gx-text-warning:hover,
a.gx-text-warning:focus {
  color: #f17f05 !important;
}
.gx-text-danger {
  color: #f44336 !important;
}
a.gx-text-danger:hover,
a.gx-text-danger:focus {
  color: #f32c1e !important;
}
.gx-text-light {
  color: #ababab !important;
}
a.gx-text-light:hover,
a.gx-text-light:focus {
  color: #787878 !important;
}
.gx-text-light-grey {
  color: #cccccc !important;
}
a.gx-text-light-grey:hover,
a.gx-text-light-grey:focus {
  color: #bfbfbf !important;
}
.gx-text-grey {
  color: #8c8c8c !important;
}
a.gx-text-grey:hover,
a.gx-text-grey:focus {
  color: #262626 !important;
}
.gx-text-dark {
  color: #595959 !important;
}
a.gx-text-dark:hover,
a.gx-text-dark:focus {
  color: #4c4c4c !important;
}
.gx-text-black {
  color: #000000 !important;
}
a.gx-text-black:hover,
a.gx-text-black:focus {
  color: #4c4c4c !important;
}
.gx-text-pink {
  color: #eb2f96 !important;
}
a.gx-text-pink:hover,
a.gx-text-pink:focus {
  color: #e9188a !important;
}
.gx-text-green {
  color: #52c41a !important;
}
a.gx-text-green:hover,
a.gx-text-green:focus {
  color: #49ad17 !important;
}
.gx-text-red {
  color: #f5222d !important;
}
a.gx-text-red:hover,
a.gx-text-red:focus {
  color: #f30b17 !important;
}
.gx-text-amber {
  color: #fadb14 !important;
}
a.gx-text-amber:hover,
a.gx-text-amber:focus {
  color: #efd005 !important;
}
.gx-text-blue {
  color: #1890ff !important;
}
a.gx-text-blue:hover,
a.gx-text-blue:focus {
  color: #0084fe !important;
}
.gx-text-indigo {
  color: #3c1991 !important;
}
a.gx-text-indigo:hover,
a.gx-text-indigo:focus {
  color: #33157b !important;
}
.gx-text-purple {
  color: #722ed1 !important;
}
a.gx-text-purple:hover,
a.gx-text-purple:focus {
  color: #6729bc !important;
}
.gx-text-orange {
  color: #fa8c16 !important;
}
a.gx-text-orange:hover,
a.gx-text-orange:focus {
  color: #f17f05 !important;
}
.gx-text-yellow {
  color: #fadb14 !important;
}
a.gx-text-yellow:hover,
a.gx-text-yellow:focus {
  color: #efd005 !important;
}
.gx-text-teal {
  color: #20c997 !important;
}
a.gx-text-teal:hover,
a.gx-text-teal:focus {
  color: #1cb386 !important;
}
.gx-text-cyan {
  color: #13c2c2 !important;
}
a.gx-text-cyan:hover,
a.gx-text-cyan:focus {
  color: #11abab !important;
}
.gx-text-muted {
  color: #8c8c8c !important;
}
.gx-text-geekblue {
  color: #030852 !important;
}
a.gx-text-geekblue:hover,
a.gx-text-geekblue:focus {
  color: #10239e !important;
}
.gx-text-sepia {
  color: #7c3535 !important;
}
a.gx-text-sepia:hover,
a.gx-text-sepia:focus {
  color: #7c3535 !important;
}
.gx-icon-white {
  color: #ffffff !important;
}
.gx-border-primary {
  border-color: var(--app-primary-color) !important;
}
.gx-border-secondary {
  border-color: var(--app-secondary-color) !important;
}
.gx-border-success {
  border-color: #52c41a !important;
}
.gx-border-success-dark {
  border-color: #368011 !important;
}
.gx-border-info {
  border-color: #1890ff !important;
}
.gx-border-warning {
  border-color: #fa8c16 !important;
}
.gx-border-danger {
  border-color: #f44336 !important;
}
.gx-border-light {
  border-color: #bfbfbf !important;
}
.gx-border-dark {
  border-color: #595959 !important;
}
.gx-border-white {
  border-color: #ffffff !important;
}
.gx-border-grey {
  border-color: #bfbfbf !important;
}
.gx-border-pink {
  border-color: #eb2f96 !important;
}
.gx-border-green {
  border-color: #52c41a !important;
}
.gx-border-red {
  border-color: #f5222d !important;
}
.gx-border-amber {
  border-color: #fadb14 !important;
}
.gx-border-blue {
  border-color: #1890ff !important;
}
.gx-border-indigo {
  border-color: #3c1991 !important;
}
.gx-border-purple {
  border-color: #722ed1 !important;
}
.gx-border-orange {
  border-color: #fa8c16 !important;
}
.gx-border-yellow {
  border-color: #fadb14 !important;
}
.gx-border-teal {
  border-color: #1890ff !important;
}
.gx-border-cyan {
  border-color: #13c2c2 !important;
}
.gx-border-sepia {
  border-color: #7c3535 !important;
}
.gx-border-geekblue {
  border-color: #030852 !important;
}
.gx-btn-primary,
a.gx-btn-primary,
.btn-primary {
  color: #ffffff !important;
  background-color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
}
.gx-btn-primary:hover,
a.gx-btn-primary:hover,
.btn-primary:hover,
.gx-btn-primary:focus,
a.gx-btn-primary:focus,
.btn-primary:focus {
  color: #ffffff !important;
  background-color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
}
.gx-btn-primary.disabled,
a.gx-btn-primary.disabled,
.btn-primary.disabled,
.gx-btn-primary:disabled,
a.gx-btn-primary:disabled,
.btn-primary:disabled {
  background-color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
}
.gx-btn-primary:not([disabled]):not(.disabled):active,
a.gx-btn-primary:not([disabled]):not(.disabled):active,
.btn-primary:not([disabled]):not(.disabled):active,
.gx-btn-primary:not([disabled]):not(.disabled).active,
a.gx-btn-primary:not([disabled]):not(.disabled).active,
.btn-primary:not([disabled]):not(.disabled).active {
  color: #ffffff;
  background-color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
}
.gx-btn-primary-light,
a.gx-btn-primary-light,
.btn-primary-light {
  color: #595959 !important;
}
.gx-btn-primary-light:hover,
a.gx-btn-primary-light:hover,
.btn-primary-light:hover,
.gx-btn-primary-light:focus,
a.gx-btn-primary-light:focus,
.btn-primary-light:focus {
  color: #595959 !important;
}
.gx-btn-primary-light:not([disabled]):not(.disabled):active,
a.gx-btn-primary-light:not([disabled]):not(.disabled):active,
.btn-primary-light:not([disabled]):not(.disabled):active,
.gx-btn-primary-light:not([disabled]):not(.disabled).active,
a.gx-btn-primary-light:not([disabled]):not(.disabled).active,
.btn-primary-light:not([disabled]):not(.disabled).active {
  color: #595959;
}
.gx-btn-secondary,
a.gx-btn-secondary {
  color: #ffffff !important;
  background-color: var(--app-secondary-color) !important;
  border-color: var(--app-secondary-color) !important;
}
.gx-btn-secondary:hover,
a.gx-btn-secondary:hover,
.gx-btn-secondary:focus,
a.gx-btn-secondary:focus {
  color: #ffffff;
  background-color: var(--app-secondary-color) !important;
  border-color: var(--app-secondary-color) !important;
}
.gx-btn-secondary.disabled,
a.gx-btn-secondary.disabled,
.gx-btn-secondary:disabled,
a.gx-btn-secondary:disabled {
  background-color: var(--app-secondary-color) !important;
  border-color: var(--app-secondary-color) !important;
}
.gx-btn-secondary:not([disabled]):not(.disabled):active,
a.gx-btn-secondary:not([disabled]):not(.disabled):active,
.gx-btn-secondary:not([disabled]):not(.disabled).active,
a.gx-btn-secondary:not([disabled]):not(.disabled).active {
  color: #ffffff;
  background-color: var(--app-secondary-color) !important;
  border-color: var(--app-secondary-color) !important;
}
.gx-btn-success,
a.gx-btn-success {
  color: #ffffff !important;
  background-color: #52c41a !important;
  border-color: #52c41a !important;
}
.gx-btn-success:hover,
a.gx-btn-success:hover,
.gx-btn-success:focus,
a.gx-btn-success:focus {
  color: #ffffff !important;
  background-color: #3f9714 !important;
  border-color: #3f9714 !important;
}
.gx-btn-success.disabled,
a.gx-btn-success.disabled,
.gx-btn-success:disabled,
a.gx-btn-success:disabled {
  background-color: #52c41a !important;
  border-color: #52c41a !important;
}
.gx-btn-success:not([disabled]):not(.disabled):active,
a.gx-btn-success:not([disabled]):not(.disabled):active,
.gx-btn-success:not([disabled]):not(.disabled).active,
a.gx-btn-success:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #3f9714 !important;
  border-color: #3f9714 !important;
}
.gx-btn-success-dark,
a.gx-btn-success-dark {
  color: #ffffff !important;
  background-color: #368011 !important;
  border-color: #368011 !important;
}
.gx-btn-success-dark:hover,
a.gx-btn-success-dark:hover,
.gx-btn-success-dark:focus,
a.gx-btn-success-dark:focus {
  color: #ffffff !important;
  background-color: #2c6a0e !important;
  border-color: #2c6a0e !important;
}
.gx-btn-success-dark.disabled,
a.gx-btn-success-dark.disabled,
.gx-btn-success-dark:disabled,
a.gx-btn-success-dark:disabled {
  background-color: #52c41a !important;
  border-color: #52c41a !important;
}
.gx-btn-success-dark:not([disabled]):not(.disabled):active,
a.gx-btn-success-dark:not([disabled]):not(.disabled):active,
.gx-btn-success-dark:not([disabled]):not(.disabled).active,
a.gx-btn-success-dark:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #2c6a0e !important;
  border-color: #2c6a0e !important;
}
.gx-btn-info,
a.gx-btn-info {
  color: #ffffff !important;
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}
.gx-btn-info:hover,
a.gx-btn-info:hover,
.gx-btn-info:focus,
a.gx-btn-info:focus {
  color: #ffffff !important;
  background-color: #0076e4 !important;
  border-color: #0076e4 !important;
}
.gx-btn-info.disabled,
a.gx-btn-info.disabled,
.gx-btn-info:disabled,
a.gx-btn-info:disabled {
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}
.gx-btn-info:not([disabled]):not(.disabled):active,
a.gx-btn-info:not([disabled]):not(.disabled):active,
.gx-btn-info:not([disabled]):not(.disabled).active,
a.gx-btn-info:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #0076e4 !important;
  border-color: #0076e4 !important;
}
.gx-btn-warning,
a.gx-btn-warning {
  color: #ffffff !important;
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-warning:hover,
a.gx-btn-warning:hover,
.gx-btn-warning:focus,
a.gx-btn-warning:focus {
  color: #ffffff !important;
  background-color: #d87205 !important;
  border-color: #d87205 !important;
}
.gx-btn-warning.disabled,
a.gx-btn-warning.disabled,
.gx-btn-warning:disabled,
a.gx-btn-warning:disabled {
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-warning:not([disabled]):not(.disabled):active,
a.gx-btn-warning:not([disabled]):not(.disabled):active,
.gx-btn-warning:not([disabled]):not(.disabled).active,
a.gx-btn-warning:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #d87205 !important;
  border-color: #d87205 !important;
}
.gx-btn-yellow,
a.gx-btn-yellow {
  color: #262626 !important;
  background-color: #fadb14 !important;
  border-color: #fadb14 !important;
}
.gx-btn-yellow:hover,
a.gx-btn-yellow:hover,
.gx-btn-yellow:focus,
a.gx-btn-yellow:focus {
  color: #ffffff !important;
  background-color: #d6ba05 !important;
  border-color: #d6ba05 !important;
}
.gx-btn-yellow.disabled,
a.gx-btn-yellow.disabled,
.gx-btn-yellow:disabled,
a.gx-btn-yellow:disabled {
  background-color: #fadb14 !important;
  border-color: #fadb14 !important;
}
.gx-btn-yellow:not([disabled]):not(.disabled):active,
a.gx-btn-yellow:not([disabled]):not(.disabled):active,
.gx-btn-yellow:not([disabled]):not(.disabled).active,
a.gx-btn-yellow:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #d6ba05 !important;
  border-color: #d6ba05 !important;
}
.gx-btn-danger,
a.gx-btn-danger,
.gx-btn-red,
a.gx-btn-red {
  color: #ffffff !important;
  background-color: #f44336 !important;
  border-color: #f44336 !important;
}
.gx-btn-danger:hover,
a.gx-btn-danger:hover,
.gx-btn-red:hover,
a.gx-btn-red:hover,
.gx-btn-danger:focus,
a.gx-btn-danger:focus,
.gx-btn-red:focus,
a.gx-btn-red:focus {
  color: #ffffff !important;
  background-color: #ea1c0d !important;
  border-color: #ea1c0d !important;
}
.gx-btn-danger.disabled,
a.gx-btn-danger.disabled,
.gx-btn-red.disabled,
a.gx-btn-red.disabled,
.gx-btn-danger:disabled,
a.gx-btn-danger:disabled,
.gx-btn-red:disabled,
a.gx-btn-red:disabled {
  background-color: #f44336 !important;
  border-color: #f44336 !important;
}
.gx-btn-danger:not([disabled]):not(.disabled):active,
a.gx-btn-danger:not([disabled]):not(.disabled):active,
.gx-btn-red:not([disabled]):not(.disabled):active,
a.gx-btn-red:not([disabled]):not(.disabled):active,
.gx-btn-danger:not([disabled]):not(.disabled).active,
a.gx-btn-danger:not([disabled]):not(.disabled).active,
.gx-btn-red:not([disabled]):not(.disabled).active,
a.gx-btn-red:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #ea1c0d !important;
  border-color: #ea1c0d !important;
}
.gx-btn-light,
a.gx-btn-light {
  color: #8c8c8c !important;
  background-color: #e8e8e8 !important;
  border-color: #e8e8e8 !important;
}
.gx-btn-light:hover,
a.gx-btn-light:hover,
.gx-btn-light:focus,
a.gx-btn-light:focus {
  color: #8c8c8c !important;
  background-color: #d9d9d9 !important;
  border-color: #d9d9d9 !important;
}
.gx-btn-light.disabled,
a.gx-btn-light.disabled,
.gx-btn-light:disabled,
a.gx-btn-light:disabled {
  background-color: #f5f5f5 !important;
  border-color: #f5f5f5 !important;
}
.gx-btn-light:not([disabled]):not(.disabled):active,
a.gx-btn-light:not([disabled]):not(.disabled):active,
.gx-btn-light:not([disabled]):not(.disabled).active,
a.gx-btn-light:not([disabled]):not(.disabled).active {
  color: #262626 !important;
  background-color: #e8e8e8 !important;
  border-color: #e8e8e8 !important;
}
.gx-btn-dark,
a.gx-btn-dark {
  color: #ffffff !important;
  background-color: #262626 !important;
  border-color: #262626 !important;
}
.gx-btn-dark:hover,
a.gx-btn-dark:hover,
.gx-btn-dark:focus,
a.gx-btn-dark:focus {
  color: #ffffff !important;
  background-color: #0c0c0c !important;
  border-color: #0c0c0c !important;
}
.gx-btn-dark.disabled,
a.gx-btn-dark.disabled,
.gx-btn-dark:disabled,
a.gx-btn-dark:disabled {
  background-color: #262626 !important;
  border-color: #262626 !important;
}
.gx-btn-dark:not([disabled]):not(.disabled):active,
a.gx-btn-dark:not([disabled]):not(.disabled):active,
.gx-btn-dark:not([disabled]):not(.disabled).active,
a.gx-btn-dark:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #0c0c0c !important;
  border-color: #0c0c0c !important;
}
.gx-btn-purple,
a.gx-btn-purple {
  color: #ffffff !important;
  background-color: #722ed1 !important;
  border-color: #722ed1 !important;
}
.gx-btn-purple:hover,
a.gx-btn-purple:hover,
.gx-btn-purple:focus,
a.gx-btn-purple:focus {
  color: #ffffff !important;
  background-color: #5b25a7 !important;
  border-color: #5b25a7 !important;
}
.gx-btn-purple.disabled,
a.gx-btn-purple.disabled,
.gx-btn-purple:disabled,
a.gx-btn-purple:disabled {
  background-color: #722ed1 !important;
  border-color: #722ed1 !important;
}
.gx-btn-purple:not([disabled]):not(.disabled):active,
a.gx-btn-purple:not([disabled]):not(.disabled):active,
.gx-btn-purple:not([disabled]):not(.disabled).active,
a.gx-btn-purple:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #5b25a7 !important;
  border-color: #5b25a7 !important;
}
.gx-btn-sepia,
a.gx-btn-sepia {
  color: #ffffff !important;
  background-color: #7c3535 !important;
  border-color: #7c3535 !important;
}
.gx-btn-sepia:hover,
a.gx-btn-sepia:hover,
.gx-btn-sepia:focus,
a.gx-btn-sepia:focus {
  color: #ffffff !important;
  background-color: #461e1e !important;
  border-color: #461e1e !important;
}
.gx-btn-sepia.disabled,
a.gx-btn-sepia.disabled,
.gx-btn-sepia:disabled,
a.gx-btn-sepia:disabled {
  background-color: #7c3535 !important;
  border-color: #7c3535 !important;
}
.gx-btn-sepia:not([disabled]):not(.disabled):active,
a.gx-btn-sepia:not([disabled]):not(.disabled):active,
.gx-btn-sepia:not([disabled]):not(.disabled).active,
a.gx-btn-sepia:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #461e1e !important;
  border-color: #461e1e !important;
}
.gx-btn-geekblue,
a.gx-btn-geekblue {
  color: #ffffff !important;
  background-color: #10239e !important;
  border-color: #10239e !important;
}
.gx-btn-geekblue:hover,
a.gx-btn-geekblue:hover,
.gx-btn-geekblue:focus,
a.gx-btn-geekblue:focus {
  color: #ffffff !important;
  background-color: #0b1970 !important;
  border-color: #0b1970 !important;
}
.gx-btn-geekblue.disabled,
a.gx-btn-geekblue.disabled,
.gx-btn-geekblue:disabled,
a.gx-btn-geekblue:disabled {
  background-color: #10239e !important;
  border-color: #10239e !important;
}
.gx-btn-geekblue:not([disabled]):not(.disabled):active,
a.gx-btn-geekblue:not([disabled]):not(.disabled):active,
.gx-btn-geekblue:not([disabled]):not(.disabled).active,
a.gx-btn-geekblue:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #091459 !important;
  border-color: #091459 !important;
}
.gx-btn-cyan,
a.gx-btn-cyan {
  color: #ffffff !important;
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
}
.gx-btn-cyan:hover,
a.gx-btn-cyan:hover,
.gx-btn-cyan:focus,
a.gx-btn-cyan:focus {
  color: #ffffff !important;
  background-color: #0e9494 !important;
  border-color: #0e9494 !important;
}
.gx-btn-cyan.disabled,
a.gx-btn-cyan.disabled,
.gx-btn-cyan:disabled,
a.gx-btn-cyan:disabled {
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
}
.gx-btn-cyan:not([disabled]):not(.disabled):active,
a.gx-btn-cyan:not([disabled]):not(.disabled):active,
.gx-btn-cyan:not([disabled]):not(.disabled).active,
a.gx-btn-cyan:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #0e8a8a !important;
  border-color: #0e8a8a !important;
}
.gx-btn-white,
a.gx-btn-white {
  color: #545454 !important;
  background-color: #ffffff !important;
  border-color: #ffffff !important;
}
.gx-btn-white:hover,
a.gx-btn-white:hover,
.gx-btn-white:focus,
a.gx-btn-white:focus {
  color: #545454 !important;
  background-color: #e6e6e6 !important;
  border-color: #e6e6e6 !important;
}
.gx-btn-white.disabled,
a.gx-btn-white.disabled,
.gx-btn-white:disabled,
a.gx-btn-white:disabled {
  background-color: #ffffff !important;
  border-color: #ffffff !important;
}
.gx-btn-white:not([disabled]):not(.disabled):active,
a.gx-btn-white:not([disabled]):not(.disabled):active,
.gx-btn-white:not([disabled]):not(.disabled).active,
a.gx-btn-white:not([disabled]):not(.disabled).active {
  color: #545454 !important;
  background-color: #e6e6e6 !important;
  border-color: #e6e6e6 !important;
}
.gx-btn-orange,
a.gx-btn-orange {
  color: #ffffff !important;
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-orange:hover,
a.gx-btn-orange:hover,
.gx-btn-orange:focus,
a.gx-btn-orange:focus {
  color: #ffffff !important;
  background-color: #d87205 !important;
  border-color: #d87205 !important;
}
.gx-btn-orange.disabled,
a.gx-btn-orange.disabled,
.gx-btn-orange:disabled,
a.gx-btn-orange:disabled {
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-orange:not([disabled]):not(.disabled):active,
a.gx-btn-orange:not([disabled]):not(.disabled):active,
.gx-btn-orange:not([disabled]):not(.disabled).active,
a.gx-btn-orange:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #ce6d04 !important;
  border-color: #ce6d04 !important;
}
.gx-btn-outline-primary,
a.gx-btn-outline-primary {
  color: var(--app-primary-color) !important;
  background-color: transparent !important;
  border-color: var(--app-primary-color) !important;
}
.gx-btn-outline-primary:hover,
a.gx-btn-outline-primary:hover,
.gx-btn-outline-primary:focus,
a.gx-btn-outline-primary:focus {
  color: #ffffff !important;
  background-color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
}
.gx-btn-outline-primary.disabled,
a.gx-btn-outline-primary.disabled,
.gx-btn-outline-primary:disabled,
a.gx-btn-outline-primary:disabled {
  color: var(--app-primary-color) !important;
  background-color: transparent !important;
}
.gx-btn-outline-secondary,
a.gx-btn-outline-secondary {
  color: var(--app-secondary-color) !important;
  background-color: transparent !important;
  border-color: var(--app-secondary-color) !important;
}
.gx-btn-outline-secondary:hover,
a.gx-btn-outline-secondary:hover,
.gx-btn-outline-secondary:focus,
a.gx-btn-outline-secondary:focus {
  color: #ffffff !important;
  background-color: var(--app-secondary-color) !important;
  border-color: var(--app-secondary-color) !important;
}
.gx-btn-outline-secondary.disabled,
a.gx-btn-outline-secondary.disabled,
.gx-btn-outline-secondary:disabled,
a.gx-btn-outline-secondary:disabled {
  color: var(--app-secondary-color) !important;
  background-color: transparent !important;
}
.gx-btn-outline-success,
a.gx-btn-outline-success {
  color: #52c41a !important;
  background-color: transparent !important;
  border-color: #52c41a !important;
}
.gx-btn-outline-success:hover,
a.gx-btn-outline-success:hover,
.gx-btn-outline-success:focus,
a.gx-btn-outline-success:focus {
  color: #ffffff !important;
  background-color: #52c41a !important;
  border-color: #52c41a !important;
}
.gx-btn-outline-success.disabled,
a.gx-btn-outline-success.disabled,
.gx-btn-outline-success:disabled,
a.gx-btn-outline-success:disabled {
  color: #52c41a !important;
  background-color: transparent !important;
}
.gx-btn-outline-success-dark,
a.gx-btn-outline-success-dark {
  color: #52c41a !important;
  background-color: transparent !important;
  border-color: #368011 !important;
}
.gx-btn-outline-success-dark:hover,
a.gx-btn-outline-success-dark:hover,
.gx-btn-outline-success-dark:focus,
a.gx-btn-outline-success-dark:focus {
  color: #ffffff !important;
  background-color: #2c6a0e !important;
  border-color: #2c6a0e !important;
}
.gx-btn-outline-success-dark.disabled,
a.gx-btn-outline-success-dark.disabled,
.gx-btn-outline-success-dark:disabled,
a.gx-btn-outline-success-dark:disabled {
  color: #2c6a0e !important;
  background-color: transparent !important;
}
.gx-btn-outline-info,
a.gx-btn-outline-info {
  color: #1890ff !important;
  background-color: transparent !important;
  border-color: #1890ff !important;
}
.gx-btn-outline-info:hover,
a.gx-btn-outline-info:hover,
.gx-btn-outline-info:focus,
a.gx-btn-outline-info:focus {
  color: #ffffff !important;
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}
.gx-btn-outline-info.disabled,
a.gx-btn-outline-info.disabled,
.gx-btn-outline-info:disabled,
a.gx-btn-outline-info:disabled {
  color: #1890ff !important;
  background-color: transparent !important;
}
.gx-btn-outline-warning,
a.gx-btn-outline-warning {
  color: #fa8c16 !important;
  background-color: transparent !important;
  border-color: #fa8c16 !important;
}
.gx-btn-outline-warning:hover,
a.gx-btn-outline-warning:hover,
.gx-btn-outline-warning:focus,
a.gx-btn-outline-warning:focus {
  color: #262626 !important;
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-outline-warning.disabled,
a.gx-btn-outline-warning.disabled,
.gx-btn-outline-warning:disabled,
a.gx-btn-outline-warning:disabled {
  color: #fa8c16 !important;
  background-color: transparent !important;
}
.gx-btn-outline-danger,
a.gx-btn-outline-danger,
.gx-btn-outline-red,
a.gx-btn-outline-red {
  color: #f44336 !important;
  background-color: transparent !important;
  border-color: #f44336 !important;
}
.gx-btn-outline-danger:hover,
a.gx-btn-outline-danger:hover,
.gx-btn-outline-red:hover,
a.gx-btn-outline-red:hover,
.gx-btn-outline-danger:focus,
a.gx-btn-outline-danger:focus,
.gx-btn-outline-red:focus,
a.gx-btn-outline-red:focus {
  color: #ffffff !important;
  background-color: #f44336 !important;
  border-color: #f44336 !important;
}
.gx-btn-outline-danger.disabled,
a.gx-btn-outline-danger.disabled,
.gx-btn-outline-red.disabled,
a.gx-btn-outline-red.disabled,
.gx-btn-outline-danger:disabled,
a.gx-btn-outline-danger:disabled,
.gx-btn-outline-red:disabled,
a.gx-btn-outline-red:disabled {
  color: #f44336 !important;
  background-color: transparent !important;
}
.gx-btn-outline-light,
a.gx-btn-outline-light {
  color: #8c8c8c !important;
  background-color: transparent !important;
  border-color: #d9d9d9 !important;
}
.gx-btn-outline-light:hover,
a.gx-btn-outline-light:hover,
.gx-btn-outline-light:focus,
a.gx-btn-outline-light:focus {
  color: #8c8c8c !important;
  background-color: #d9d9d9 !important;
  border-color: #d9d9d9 !important;
}
.gx-btn-outline-light.disabled,
a.gx-btn-outline-light.disabled,
.gx-btn-outline-light:disabled,
a.gx-btn-outline-light:disabled {
  color: #e8e8e8 !important;
  background-color: transparent !important;
}
.gx-btn-outline-dark,
a.gx-btn-outline-dark {
  color: #262626 !important;
  background-color: transparent !important;
  border-color: #262626 !important;
}
.gx-btn-outline-dark:hover,
a.gx-btn-outline-dark:hover,
.gx-btn-outline-dark:focus,
a.gx-btn-outline-dark:focus {
  color: #ffffff !important;
  background-color: #262626 !important;
  border-color: #262626 !important;
}
.gx-btn-outline-dark.disabled,
a.gx-btn-outline-dark.disabled,
.gx-btn-outline-dark:disabled,
a.gx-btn-outline-dark:disabled {
  color: #262626 !important;
  background-color: transparent !important;
}
.gx-btn-outline-sepia,
a.gx-btn-outline-sepia {
  color: #ffffff !important;
  background-color: transparent !important;
  border-color: #7c3535 !important;
}
.gx-btn-outline-sepia:hover,
a.gx-btn-outline-sepia:hover,
.gx-btn-outline-sepia:focus,
a.gx-btn-outline-sepia:focus {
  color: #ffffff !important;
  background-color: #7c3535 !important;
  border-color: #7c3535 !important;
}
.gx-btn-outline-sepia.disabled,
a.gx-btn-outline-sepia.disabled,
.gx-btn-outline-sepia:disabled,
a.gx-btn-outline-sepia:disabled {
  color: #7c3535 !important;
  background-color: transparent !important;
}
.gx-btn-outline-geekblue,
a.gx-btn-outline-geekblue {
  color: #ffffff !important;
  background-color: transparent !important;
  border-color: #030852 !important;
}
.gx-btn-outline-geekblue:hover,
a.gx-btn-outline-geekblue:hover,
.gx-btn-outline-geekblue:focus,
a.gx-btn-outline-geekblue:focus {
  color: #ffffff !important;
  background-color: #030852 !important;
  border-color: #030852 !important;
}
.gx-btn-outline-geekblue.disabled,
a.gx-btn-outline-geekblue.disabled,
.gx-btn-outline-geekblue:disabled,
a.gx-btn-outline-geekblue:disabled {
  color: #2f54eb !important;
  background-color: transparent !important;
}
.gx-btn-outline-orange,
a.gx-btn-outline-orange {
  color: #ffffff !important;
  background-color: transparent !important;
  border-color: #fa8c16 !important;
}
.gx-btn-outline-orange:hover,
a.gx-btn-outline-orange:hover,
.gx-btn-outline-orange:focus,
a.gx-btn-outline-orange:focus {
  color: #ffffff !important;
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-outline-orange.disabled,
a.gx-btn-outline-orange.disabled,
.gx-btn-outline-orange:disabled,
a.gx-btn-outline-orange:disabled {
  color: #fa8c16 !important;
  background-color: transparent !important;
}
.gx-badge-primary {
  background-color: var(--app-primary-color) !important;
}
.gx-badge-primary-light {
  background-color: #5a456e !important;
}
.gx-badge-secondary {
  background-color: var(--app-secondary-color) !important;
}
.gx-badge-success {
  background-color: #52c41a !important;
}
.gx-badge-success-dark {
  background-color: #368011 !important;
}
.gx-badge-info {
  background-color: #1890ff !important;
}
.gx-badge-warning {
  background-color: #fa8c16 !important;
}
.gx-badge-danger {
  background-color: #f44336 !important;
}
.gx-badge-light {
  background-color: #e8e8e8 !important;
}
.gx-badge-dark {
  background-color: #000000 !important;
}
.gx-badge-white {
  background-color: #ffffff !important;
}
.gx-badge-grey {
  background-color: #bfbfbf !important;
}
.gx-badge-light-grey {
  background-color: #d9d9d9 !important;
}
.gx-badge-pink {
  background-color: #eb2f96 !important;
}
.gx-badge-green {
  background-color: #52c41a !important;
}
.gx-badge-green-light {
  background-color: #caf5b5 !important;
}
.gx-badge-red {
  background-color: #f5222d !important;
}
.gx-badge-amber {
  background-color: #fadb14 !important;
}
.gx-badge-amber-light {
  background-color: #fdf2aa !important;
}
.gx-badge-blue {
  background-color: #1890ff !important;
}
.gx-badge-light-blue {
  background-color: #329cff !important;
}
.gx-badge-indigo {
  background-color: #3c1991 !important;
}
.gx-badge-purple {
  background-color: #722ed1 !important;
}
.gx-badge-orange {
  background-color: #fa8c16 !important;
}
.gx-badge-yellow {
  background-color: #fadb14 !important;
}
.gx-badge-teal {
  background-color: #20c997 !important;
}
.gx-badge-cyan {
  background-color: #13c2c2 !important;
}
.gx-badge-sepia {
  background-color: #7c3535 !important;
}
.gx-badge-geekblue {
  background-color: #030852 !important;
}
/* Ripple magic */
.gx-ripple-effect {
  position: relative;
  overflow: hidden;
}
.gx-ripple-effect:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}
.gx-ripple-effect:hover:after {
  animation: ripple 1s ease-out;
}
@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(60, 60);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(100, 100);
  }
}
@-webkit-keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(60, 60);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(100, 100);
  }
}
.gx-pulse-effect {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  -moz-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  animation: pulse 2s infinite;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
.gx-online-effect {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  animation: online 2s infinite;
}
@-webkit-keyframes online {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
  }
}
@keyframes online {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);
    box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
  }
}
.gx-away-effect {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  -moz-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  animation: away 2s infinite;
}
@-webkit-keyframes away {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);
  }
}
@keyframes away {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);
    box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);
    box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);
    box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);
  }
}
.gx-orange-effect {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  -moz-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  animation: away 2s infinite;
}
@-webkit-keyframes away {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);
  }
}
@keyframes away {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);
    box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);
    box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);
    box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);
  }
}
@-webkit-keyframes fxicon-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes fxicon-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.fxicon-hc-spin {
  -webkit-animation: fxicon-spin 1.5s infinite linear;
  animation: fxicon-spin 1.5s infinite linear;
}
@-webkit-keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fadein {
  -webkit-animation-name: fadein;
  animation-name: fadein;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
}
@-webkit-keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.fadeout {
  -webkit-animation-name: fadeout;
  animation-name: fadeout;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
}
/* global custom styles (overwritten by developers) */
.card--height {
  min-height: 75vh !important;
}
.card-title {
  width: 100%;
  float: right;
  display: flex;
  position: absolute;
  top: 10px;
  justify-content: center;
  align-items: center;
  padding-right: 50px;
}
.card-table-search {
  margin-right: 25px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
/* Change input blue background color of chrome for input elements*/
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}
/* ant form global styles */
/* form's button back and submit */
.form-button {
  float: right;
  margin-top: 20px;
}
.form-button-pr {
  padding-right: 40px;
}
.form-button-pr21 {
  padding-right: 21px;
}
/* form search field */
.card-list-data-wrapper {
  width: 100%;
  display: flex;
}
.card-list-data-container {
  margin-right: 25px;
  justify-content: flex-end;
  width: 100%;
  display: flex;
}
.ant-table-column-title,
.ant-table-thead > tr > th {
  color: #000000;
  font-weight: bold;
  background-color: #fff !important;
}
.ant-table-tbody > tr.ant-table-row:hover > td,
.ant-table-tbody > tr > td.ant-table-cell-row-hover {
  background: #ebe7e7 !important;
}
.ant-steps-item-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px !important;
  height: 36px !important;
  font-size: 13px !important;
  line-height: 36px !important;
}
.ant-steps-item-process .ant-steps-item-icon {
  background: var(--app-primary-color) !important;
  border: var(--app-primary-color) !important;
}
.ant-steps-item-content {
  width: 100% !important;
  padding: 0% 10px;
}
.ant-steps-vertical {
  display: flex;
  flex-direction: row !important;
}
.ant-steps-item-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 112%;
  letter-spacing: -0.04em;
  color: #ffffff !important;
  margin-left: 20px;
}
.ant-steps-item-finish .ant-steps-item-icon {
  border-color: var(--app-primary-color) !important;
}
.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: var(--app-primary-color) !important;
}
.ant-steps-item-tail {
  position: absolute;
  top: 13px;
  left: 0;
  width: 100%;
}
.ant-steps {
  width: 100%;
  padding: 0% 5% !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media only screen and (min-width: 300px) and (max-width: 600px) {
  .ant-steps-vertical {
    display: flex;
    flex-direction: row !important;
  }
  .ant-steps-item-tail {
    position: absolute;
    top: 12px !important;
    left: 0;
    width: 100%;
    transform-origin: top right;
    transform: rotate(-90deg);
  }
  .ant-steps-item-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
  .ant-steps-item-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px !important;
    height: 24px !important;
    font-size: 12px !important;
    line-height: 32px !important;
    font-style: normal;
    font-weight: 700;
    font-size: 7px;
    line-height: 112%;
  }
  .ant-steps {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0% !important;
  }
  .ant-steps-item-tail {
    position: absolute;
    top: 20px;
    left: 0;
    width: 100%;
  }
  .ant-steps-vertical > .ant-steps-item .ant-steps-item-content {
    overflow: visible;
  }
  .ant-steps-item-content {
    width: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ant-steps-item-title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-style: normal;
    font-weight: 500;
    font-size: 8.5px;
    line-height: 90%;
    text-align: center;
    letter-spacing: -0.06em;
    margin: 0%;
  }
  .ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
    position: absolute;
    top: 15px;
    left: auto;
    height: 100%;
    padding: 0px 0px 0px 12px;
  }
}
.ant-steps-item-process .ant-steps-item-icon {
  background: var(--app-secondary-color) !important;
  border: var(--app-primary-color) !important;
}
.ant-steps-item-wait .ant-steps-item-icon {
  background-color: #ffffff !important;
  border-color: var(--app-primary-color);
}
.ant-steps-item-finish .ant-steps-item-icon {
  background-color: var(--app-secondary-color) !important;
  border-color: var(--app-primary-color) !important;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: var(--app-secondary-color) !important;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title,
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: var(--app-secondary-color) !important;
}
.ant-steps-icon {
  color: #000000 !important;
}
.ant-menu {
  padding: 10px !important;
}
.gx-app-sidebar .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  left: auto !important;
  right: 22px !important;
  margin-bottom: -20px !important;
}
.ant-menu-submenu-inline .ant-menu-title-content {
  margin-left: -5px !important;
}
.ant-menu-sub .ant-menu-item .ant-menu-item-icon {
  margin-left: -50px !important;
  font-size: 17px !important;
}
.ant-menu-sub .ant-menu-item .ant-menu-title-content {
  margin-left: 5px !important;
}
.ant-menu-item,
.ant-menu-submenu-inline .ant-menu-item {
  width: 100% !important;
  margin: 5px 0px !important;
  padding: 0px !important;
  border-radius: 12px !important;
}
.ant-menu-item:hover,
.ant-menu-submenu-inline .ant-menu-item:hover {
  width: 100% !important;
  margin: 5px 0px !important;
  margin-right: 10px !important;
  padding: 0px !important;
  background-color: var(--app-secondary-color) !important;
  font-weight: bold;
  color: #ffffff !important;
}
.ant-menu-inline-collapsed .ant-menu-submenu-title {
  margin-left: 15px !important;
}
.ant-menu-inline-collapsed .ant-menu-item .ant-menu-item-icon {
  margin-left: -10px !important;
}
.ant-menu-item .ant-menu-item-icon,
.ant-menu-submenu .ant-menu-item-icon {
  margin-left: -25px !important;
  font-size: 17px !important;
}
.ant-menu-item .ant-menu-title-content {
  margin-left: -5px !important;
}
.ant-menu-item-selected,
.ant-menu-item > .ant-menu-item-selected > .ant-menu-item-icon,
.ant-menu-item > .ant-menu-item-selected > .ant-menu-title-content {
  background-color: var(--app-secondary-color) !important;
  font-weight: bold !important;
  border-radius: 12px;
  padding: 0% !important;
}
.gx-layout-sider-dark .gx-layout-sider-header,
.gx-drawer-sidebar-dark .gx-layout-sider-header {
  background-color: #ffffff !important;
}
.ant-select-item-option-selected {
  color: #fff !important;
  background-color: var(--app-primary-color) !important;
}
.ant-select .ant-select-selector:focus {
  border-color: var(--app-secondary-color) !important;
}
.ant-select .ant-select-selector:hover {
  border-color: var(--app-secondary-color) !important;
}
.ant-select.ant-select-focused .ant-select-selector {
  border-color: var(--app-secondary-color) !important;
}
@media only screen and (max-width: 600px) {
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 30px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.ant-col {
  width: 100% !important;
}
/* override chrome scrollbar styles */
@media only screen and(min-width: 1200px) {
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
/* this styles is for all the listing pages */
.entity-name {
  font-weight: normal;
  font-size: 14px;
}
.entity-name-selected {
  font-weight: bolder;
  font-size: 18px;
  color: var(--app-primary-color) !important;
  cursor: pointer;
}
.link {
  cursor: pointer;
  color: #038fde;
  transition: all 0.2s ease-in-out;
}
.link:hover {
  color: #A43072;
}
.ant-input-disabled {
  color: #999 !important;
}
.ant-picker-disabled {
  color: #999 !important;
}
.ant-select-disabled {
  color: #999 !important;
}
.ant-picker-disabled > .ant-picker-input > input {
  color: #999 !important;
}
.ant-select-disabled > .ant-select-selector > .ant-select-selection-item {
  color: #999 !important;
}
.ant-form-item-label > label {
  position: relative;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  height: 36px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -0.04em;
  color: #000000 !important;
}
.ant-input-affix-wrapper-focused {
  border-color: var(--app-primary-color) !important;
}
.ant-input-affix-wrapper:hover {
  border-color: var(--app-primary-color) !important;
}
.ant-collapse-content > .ant-collapse-content-box {
  padding: 0px !important;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 5px !important;
}
@media only screen and (min-width: 300px) and (max-width: 600px) {
  font-size: 11px !important;
}
.icon-disabled {
  color: grey !important;
  cursor: not-allowed !important;
}
.spin-loadding {
  margin-left: 10% !important;
}
.ant-spin-dot-item {
  background-color: var(--app-primary-color) !important;
}
.ant-table-column-sorter-up.active,
.ant-table-column-sorter-down.active {
  color: var(--app-primary-color) !important;
}
.ant-pagination-item-active a {
  color: var(--app-primary-color) !important;
}
.ant-pagination-item-active {
  border-color: var(--app-primary-color) !important;
}
.button-gradiant {
  background: var(--app-primary-color);
  color: #ffffff;
  border-radius: 6px;
  border: 1px solid var(--app-primary-color);
  transition: all 0.2s ease-in-out;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  text-align: center;
}
.button-gradiant:focus {
  color: #ffffff !important;
  border: 1px solid var(--app-primary-color);
  background: var(--app-primary-color) !important;
}
.button-gradiant:hover {
  color: var(--app-primary-color) !important;
  border: 1px solid var(--app-primary-color);
  background: #ffffff !important;
}
.ant-switch-checked {
  background-color: var(--app-primary-color) !important;
}
.ant-input-search-button:hover,
.ant-input-search-button:focus {
  color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
  background: #fff;
}
.wordWrapWordBreak {
  word-wrap: break-word;
  word-break: break-word;
}
.display-flex {
  display: flex;
}
.ml10 {
  margin-left: 10px;
}
.color-red {
  color: #f5222d;
}
.mb8 {
  margin-bottom: 8px;
}
.search-component__width {
  width: 320px !important;
}
.gx-title-container {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.gx-title-right-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}
.gx-parking-history-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  margin-top: -1rem;
}
.add-button {
  font-weight: 500px;
  min-width: 140px;
  max-width: fit-content;
}
.card-title-style {
  font-weight: bold;
  text-transform: uppercase;
  font-weight: 600px;
}
.select-option-dropdownStyle {
  max-height: "200px";
  overflow-y: "auto";
}
.mt0 {
  margin-top: 0px;
}
.mb0 {
  margin-bottom: 0px;
}
.mr17 {
  margin-left: 17px;
}
.width100 {
  width: 100%;
}
.columnChartHeading {
  margin-bottom: 10px;
  font-size: 14px;
  text-align: center;
}
.fs15 {
  font-size: 16px;
}
.modalForm {
  margin-top: 0.2rem;
  padding-bottom: 5rem;
  padding-top: 2rem;
}
.modal-container {
  cursor: move;
}
.table-data-ellipse {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
@media only screen and (max-width: 1600px) {
  .search-component__width {
    width: 270px !important;
  }
}
/* For small mobile devices */
@media (max-width: 580px) {
  .gx-title-container,
  .gx-title-right-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
/* Mobile styles */
@media (max-width: 480px) {
  .gx-parking-history-filters {
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .gx-parking-history-filters > div {
    width: calc(50% - 0.25rem);
    /* 2 columns */
  }
}
.gx-layout-sider-header {
  padding: 10px 10px 10px 50px !important;
}
.ant-radio-button-checked {
  background-color: var(--app-secondary-color) !important;
  border-color: var(--app-secondary-color) !important;
}
.ant-radio-button-wrapper-checked {
  border-color: var(--app-secondary-color) !important;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
  background-color: var(--app-secondary-color) !important;
}
/*Base Styles*/
body {
  overflow: hidden;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  width: 100% !important;
  position: relative;
  font-weight: 400;
}
body.framed-layout {
  padding: 20px;
  background-color: var(--app-primary-color);
}
@media screen and (max-width: 991px) {
  body.framed-layout {
    padding: 0;
  }
}
body.boxed-layout {
  background-color: var(--app-primary-color);
  max-width: 1280px;
  margin: 0 auto;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
}
@media screen and (min-width: 1600px) {
  body.boxed-layout {
    max-width: 1500px;
  }
}
body.full-scroll #root {
  overflow: auto;
}
#root {
  height: 100vh;
}
.framed-layout #root {
  height: calc(100vh - 2 * 20px);
  overflow: hidden;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
}
@media screen and (max-width: 991px) {
  .framed-layout #root {
    height: 100vh;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    -webkit-border-radius: 0 !important;
    -moz-border-radius: 0 !important;
    border-radius: 0 !important;
  }
}
.gx-pointer,
.gx-link {
  cursor: pointer;
}
a,
.gx-link {
  color: var(--app-primary-color);
}
a:hover,
.gx-link:hover,
a:focus,
.gx-link:focus {
  color: var(--app-primary-color);
}
a:focus {
  text-decoration: none;
}
ol,
ul,
dl {
  padding-left: 30px;
  margin-bottom: 10px;
}
img {
  max-width: 100%;
}
.gx-w-25 {
  width: 25% !important;
}
.gx-w-50 {
  width: 50% !important;
}
.gx-w-75 {
  width: 75% !important;
}
.gx-w-100 {
  width: 100% !important;
}
.gx-h-25 {
  height: 25% !important;
}
.gx-h-50 {
  height: 50% !important;
}
.gx-h-75 {
  height: 75% !important;
}
.gx-h-100 {
  height: 100% !important;
}
.gx-mw-100 {
  max-width: 100% !important;
}
.gx-mh-100 {
  max-height: 100% !important;
}
.gx-minw50 {
  min-width: 50px;
}
.gx-border {
  border: solid 1px #e8e8e8;
}
.gx-border-2 {
  border: solid 2px #e8e8e8;
}
.gx-border-top {
  border-top: solid 1px #e8e8e8;
}
.gx-border-bottom {
  border-bottom: solid 1px #e8e8e8;
}
.gx-border-bottom-2 {
  border-bottom: solid 2px #e8e8e8;
}
.gx-border-left {
  border-left: solid 1px #e8e8e8;
}
.gx-border-right {
  border-right: solid 1px #e8e8e8;
}
.gx-border-0 {
  border: 0 none !important;
}
.gx-page-heading {
  margin-bottom: 32px;
}
@media screen and (max-width: 575px) {
  .gx-page-heading {
    margin-bottom: 20px;
  }
}
.gx-page-title {
  font-size: 20px;
  margin-bottom: 0;
}
.gx-size-200 {
  height: 200px !important;
  width: 200px !important;
  line-height: 200px !important;
}
.gx-size-150 {
  height: 150px !important;
  width: 150px !important;
  line-height: 150px !important;
}
.gx-size-120 {
  height: 120px !important;
  width: 120px !important;
  line-height: 120px !important;
}
.gx-size-100 {
  height: 100px !important;
  width: 100px !important;
  line-height: 100px !important;
}
.gx-size-90 {
  height: 90px !important;
  width: 90px !important;
  line-height: 90px !important;
}
.gx-size-80 {
  height: 80px !important;
  width: 80px !important;
  line-height: 80px !important;
}
.gx-size-60 {
  height: 60px !important;
  width: 60px !important;
  line-height: 60px !important;
}
.gx-size-50 {
  height: 50px !important;
  width: 50px !important;
  line-height: 50px !important;
}
.gx-size-40 {
  height: 40px !important;
  width: 40px !important;
  line-height: 40px !important;
}
.gx-size-36 {
  height: 36px !important;
  width: 36px !important;
  line-height: 36px !important;
}
.gx-size-30 {
  height: 30px !important;
  width: 30px !important;
  line-height: 30px !important;
}
.gx-size-24 {
  height: 24px !important;
  width: 24px !important;
  line-height: 24px !important;
}
.gx-size-20 {
  height: 20px !important;
  width: 20px !important;
  line-height: 20px !important;
}
.gx-size-15 {
  height: 15px !important;
  width: 15px !important;
  line-height: 14px !important;
}
.gx-size-10 {
  height: 10px !important;
  width: 10px !important;
  line-height: 10px !important;
}
.gx-size-8 {
  height: 8px !important;
  width: 8px !important;
  line-height: 8px !important;
}
.gx-width-175 {
  width: 175px !important;
}
.gx-img-fluid,
.gx-img-thumbnail {
  max-width: 100%;
  height: auto;
}
.gx-img-fluid-full {
  width: 100%;
}
/*Social Style*/
.gx-social-link {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin: 0 -5px 10px;
}
.gx-social-link li {
  padding: 0 5px;
  margin-bottom: 5px;
  line-height: 1;
}
.gx-social-link li a,
.gx-social-link li .gx-link,
.gx-social-link li i,
.gx-social-link li .anticon {
  cursor: pointer;
  width: 30px;
  height: 30px;
  line-height: 34px;
  font-size: 16px;
  text-align: center;
  color: var(--app-primary-color);
  border: solid 1px var(--app-primary-color);
  border-radius: 50%;
}
.gx-social-link li.active a,
.gx-social-link li.active .gx-link,
.gx-social-link li.active i,
.gx-social-link li.active .anticon,
.gx-social-link li a:hover,
.gx-social-link li .gx-link:hover,
.gx-social-link li i:hover,
.gx-social-link li .anticon:hover,
.gx-social-link li a:focus,
.gx-social-link li .gx-link:focus,
.gx-social-link li i:focus .gx-social-link li .anticon:focus {
  color: #ffffff;
  background: var(--app-primary-color);
}
.gx-card-social .gx-social-link {
  margin-bottom: 0;
  -webkit-justify-content: space-around;
  -ms-justify-content: space-around;
  justify-content: space-around;
}
.gx-float-left {
  float: left !important;
}
.gx-float-right {
  float: right !important;
}
.gx-float-none {
  float: none !important;
}
@media (min-width: 576px) {
  .gx-float-sm-left {
    float: left !important;
  }
  .gx-float-sm-right {
    float: right !important;
  }
  .gx-float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .gx-float-md-left {
    float: left !important;
  }
  .gx-float-md-right {
    float: right !important;
  }
  .gx-float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .gx-float-lg-left {
    float: left !important;
  }
  .gx-float-lg-right {
    float: right !important;
  }
  .gx-float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .gx-float-xl-left {
    float: left !important;
  }
  .gx-float-xl-right {
    float: right !important;
  }
  .gx-float-xl-none {
    float: none !important;
  }
}
.gx-position-static {
  position: static !important;
}
.gx-position-relative {
  position: relative !important;
}
.gx-position-absolute {
  position: absolute !important;
}
.gx-position-fixed {
  position: fixed !important;
}
.gx-position-sticky {
  position: sticky !important;
}
.gx-fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.gx-fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
.gx-top-0 {
  top: 0 !important;
}
.gx-bottom-0 {
  bottom: 0 !important;
}
.gx-left-0 {
  left: 0 !important;
}
.gx-right-0 {
  right: 0 !important;
}
/*Embed Responsive Classes*/
.gx-embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.gx-embed-responsive:before {
  display: block;
  content: "";
}
.gx-embed-responsive .gx-embed-responsive-item,
.gx-embed-responsive iframe,
.gx-embed-responsive embed,
.gx-embed-responsive object,
.gx-embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.gx-embed-responsive-21by9:before {
  padding-top: 42.85714286%;
}
.gx-embed-responsive-16by9:before {
  padding-top: 56.25%;
}
.gx-embed-responsive-4by3:before {
  padding-top: 75%;
}
.gx-embed-responsive-1by1:before {
  padding-top: 100%;
}
/*Media Object Classes*/
.gx-media {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: flex-start;
  -ms-align-items: flex-start;
  align-items: flex-start;
}
.gx-media-body {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
/*Overflow styles*/
.gx-overflow-auto {
  overflow: auto;
}
.gx-z-index-20 {
  position: relative;
  z-index: 20;
}
/*Hr style*/
hr {
  border-color: rgba(250, 250, 250, 0.2);
  margin: 15px 0;
}
/*Status style*/
.gx-status-pos {
  position: relative;
}
.gx-status-pos .gx-status {
  display: block;
  position: absolute;
  left: 0;
  top: 2px;
  z-index: 1;
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.gx-status-pos .gx-status.gx-small {
  width: 8px;
  height: 8px;
}
.gx-status-pos .gx-status.gx-status-rtl {
  top: -4px;
  left: auto;
  right: -4px;
}
.gx-status-pos .gx-status.gx-online {
  background-color: #52c41a;
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  animation: online 2s infinite;
}
.gx-status-pos .gx-status.gx-offline {
  background-color: #ffffff;
  border: solid 1px #52c41a;
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  animation: online 2s infinite;
}
.gx-status-pos .gx-status.gx-away {
  background-color: #fadb14;
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  -moz-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  animation: away 2s infinite;
}
.gx-status-pos .gx-status.gx-orange {
  background-color: #fa8c16;
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  -moz-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  animation: away 2s infinite;
}
.gx-box-shadow {
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
}
.gx-no-box-shadow {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.gx-rounded-xs {
  -webkit-border-radius: 2px !important;
  -moz-border-radius: 2px !important;
  border-radius: 2px !important;
}
.gx-rounded-sm {
  -webkit-border-radius: 4px !important;
  -moz-border-radius: 4px !important;
  border-radius: 4px !important;
}
.gx-rounded-base {
  -webkit-border-radius: 6px !important;
  -moz-border-radius: 6px !important;
  border-radius: 6px !important;
}
.gx-rounded-lg {
  -webkit-border-radius: 10px !important;
  -moz-border-radius: 10px !important;
  border-radius: 10px !important;
}
.gx-rounded-xxl {
  -webkit-border-radius: 30px !important;
  -moz-border-radius: 30px !important;
  border-radius: 30px !important;
}
.gx-rounded-circle {
  -webkit-border-radius: 50% !important;
  -moz-border-radius: 50% !important;
  border-radius: 50% !important;
}
.gx-border-radius-top-left-0 {
  -moz-border-top-left-radius: 0;
  -webkit-border-top-left-radius: 0;
  border-top-left-radius: 0;
}
.gx-border-radius-top-right-0 {
  -moz-border-top-right-radius: 0;
  -webkit-border-top-right-radius: 0;
  border-top-right-radius: 0;
}
.gx-border-radius-bottom-left-0 {
  -moz-border-bottom-left-radius: 0;
  -webkit-border-bottom-left-radius: 0;
  border-bottom-left-radius: 0;
}
.gx-border-radius-bottom-right-0 {
  -moz-border-bottom-right-radius: 0;
  -webkit-border-bottom-right-radius: 0;
  border-bottom-right-radius: 0;
}
.gx-vertical-align-top {
  vertical-align: top;
}
.gx-vertical-align-middle {
  vertical-align: middle;
}
.gx-vertical-align-bottom {
  vertical-align: bottom;
}
.gx-separator {
  background-color: var(--app-primary-color);
  width: 20px;
  height: 2px;
  margin: 0 auto 10px;
}
.gx-loader-400 {
  height: 400px;
}
@media screen and (max-width: 1199px) {
  .gx-loader-400 {
    height: 300px;
  }
}
.gx-object-cover {
  object-fit: cover;
}
.cke_editable,
.cke_editor_editor2 {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji' !important;
}
.gx-top2 {
  position: relative;
  top: 2px;
}
.ant-collapse-content-box > :last-child {
  margin-bottom: 0;
}
.react-stickies-wrapper {
  padding-bottom: 16px;
}
@media screen and (max-width: 1366px) {
  .gx-hide-1366 {
    display: none;
  }
}
/*flex Styles*/
.gx-d-flex {
  display: flex !important;
}
.gx-d-none {
  display: none !important;
}
.gx-d-inline-block {
  display: inline-block !important;
}
.gx-d-block {
  display: block !important;
}
.gx-d-inline-flex {
  display: inline-flex !important;
}
.gx-flex-1 {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
/*Display Flex Classes*/
.gx-flex-row {
  display: -webkit-flex !important;
  display: -ms-flexbox !important;
  display: -ms-flex !important;
  display: flex !important;
  -webkit-flex-direction: row !important;
  -ms-flex-direction: row !important;
  flex-direction: row !important;
  -webkit-flex-wrap: wrap !important;
  -ms-flex-wrap: wrap !important;
  flex-wrap: wrap !important;
}
.gx-flex-column {
  display: -webkit-flex !important;
  display: -ms-flexbox !important;
  display: -ms-flex !important;
  display: flex !important;
  -webkit-flex-direction: column !important;
  -ms-flex-direction: column !important;
  flex-direction: column !important;
  -webkit-flex-wrap: nowrap !important;
  -ms-flex-wrap: nowrap !important;
  flex-wrap: nowrap !important;
}
.gx-flex-nowrap {
  flex-wrap: nowrap !important;
}
.gx-flex-row-reverse {
  flex-direction: row-reverse !important;
}
.gx-flex-column-reverse {
  flex-direction: column-reverse !important;
}
.gx-justify-content-start {
  -webkit-justify-content: flex-start !important;
  -ms-justify-content: flex-start !important;
  justify-content: flex-start !important;
}
.gx-justify-content-end {
  -webkit-justify-content: flex-end !important;
  -ms-justify-content: flex-end !important;
  justify-content: flex-end !important;
}
.gx-justify-content-center {
  -webkit-justify-content: center !important;
  -ms-justify-content: center !important;
  justify-content: center !important;
}
.gx-justify-content-between {
  -webkit-justify-content: space-between !important;
  -ms-justify-content: space-between !important;
  justify-content: space-between !important;
}
.gx-justify-content-around {
  -webkit-justify-content: space-around !important;
  -ms-justify-content: space-around !important;
  justify-content: space-around !important;
}
.gx-align-items-start {
  -webkit-align-items: flex-start !important;
  -ms-align-items: flex-start !important;
  align-items: flex-start !important;
}
.gx-align-items-end {
  -webkit-align-items: flex-end !important;
  -ms-align-items: flex-end !important;
  align-items: flex-end !important;
}
.gx-align-items-center {
  -webkit-align-items: center !important;
  -ms-align-items: center !important;
  align-items: center !important;
}
.gx-align-items-stretch {
  -webkit-align-items: stretch !important;
  -ms-align-items: stretch !important;
  align-items: stretch !important;
}
.gx-align-content-start {
  -webkit-align-content: flex-start !important;
  -ms-align-content: flex-start !important;
  align-content: flex-start !important;
}
.gx-align-content-end {
  -webkit-align-content: flex-end !important;
  -ms-align-content: flex-end !important;
  align-content: flex-end !important;
}
.gx-align-content-center {
  -webkit-align-content: center !important;
  -ms-align-content: center !important;
  align-content: center !important;
}
.gx-align-content-between {
  -webkit-align-content: space-between !important;
  -ms-align-content: space-between !important;
  align-content: space-between !important;
}
.gx-align-content-around {
  -webkit-align-content: space-around !important;
  -ms-align-content: space-around !important;
  align-content: space-around !important;
}
.gx-align-content-stretch {
  -webkit-align-content: stretch !important;
  -ms-align-content: stretch !important;
  align-content: stretch !important;
}
.gx-align-self-auto {
  -webkit-align-self: auto !important;
  -ms-align-self: auto !important;
  align-self: auto !important;
}
.gx-align-self-start {
  -webkit-align-self: flex-start !important;
  -ms-align-self: flex-start !important;
  align-self: flex-start !important;
}
.gx-align-self-end {
  -webkit-align-self: flex-end !important;
  -ms-align-self: flex-end !important;
  align-self: flex-end !important;
}
.gx-align-self-center {
  -webkit-align-self: center !important;
  -ms-align-self: center !important;
  align-self: center !important;
}
.gx-align-self-baseline {
  -webkit-align-self: baseline !important;
  -ms-align-self: baseline !important;
  align-self: baseline !important;
}
.gx-align-self-stretch {
  -webkit-align-self: stretch !important;
  -ms-align-self: stretch !important;
  align-self: stretch !important;
}
.gx-order-first {
  -ms-flex-order: -1;
  order: -1;
}
.gx-order-1 {
  -ms-flex-order: 1;
  order: 1;
}
.gx-order-2 {
  -ms-flex-order: 2;
  order: 2;
}
.gx-order-3 {
  -ms-flex-order: 3;
  order: 3;
}
.gx-order-4 {
  -ms-flex-order: 4;
  order: 4;
}
.gx-order-5 {
  -ms-flex-order: 5;
  order: 5;
}
.gx-order-6 {
  -ms-flex-order: 6;
  order: 6;
}
.gx-order-7 {
  -ms-flex-order: 7;
  order: 7;
}
.gx-order-8 {
  -ms-flex-order: 8;
  order: 8;
}
.gx-order-9 {
  -ms-flex-order: 9;
  order: 9;
}
.gx-order-10 {
  -ms-flex-order: 10;
  order: 10;
}
.gx-order-11 {
  -ms-flex-order: 11;
  order: 11;
}
.gx-order-12 {
  -ms-flex-order: 12;
  order: 12;
}
.gx-offset-1 {
  margin-left: 8.333333%;
}
.gx-offset-2 {
  margin-left: 16.666667%;
}
.gx-offset-3 {
  margin-left: 25%;
}
.gx-offset-4 {
  margin-left: 33.333333%;
}
.gx-offset-5 {
  margin-left: 41.666667%;
}
.gx-offset-6 {
  margin-left: 50%;
}
.gx-offset-7 {
  margin-left: 58.333333%;
}
.gx-offset-8 {
  margin-left: 66.666667%;
}
.gx-offset-9 {
  margin-left: 75%;
}
.gx-offset-10 {
  margin-left: 83.333333%;
}
.gx-offset-11 {
  margin-left: 91.666667%;
}
@media screen and (min-width: 576px) {
  .gx-d-sm-none {
    display: none !important;
  }
  .gx-d-sm-inline-block {
    display: inline-block !important;
  }
  .gx-d-sm-block {
    display: block !important;
  }
  .gx-d-sm-flex {
    display: flex !important;
  }
  .gx-d-sm-inline-flex {
    display: inline-flex !important;
  }
  .gx-flex-sm-row {
    flex-direction: row !important;
  }
  .gx-flex-sm-column {
    flex-direction: column !important;
  }
  .gx-flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .gx-flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .gx-flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .gx-flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .gx-flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gx-justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .gx-justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .gx-justify-content-sm-center {
    justify-content: center !important;
  }
  .gx-justify-content-sm-between {
    justify-content: space-between !important;
  }
  .gx-justify-content-sm-around {
    justify-content: space-around !important;
  }
  .gx-align-items-sm-start {
    align-items: flex-start !important;
  }
  .gx-align-items-sm-end {
    align-items: flex-end !important;
  }
  .gx-align-items-sm-center {
    align-items: center !important;
  }
  .gx-align-items-sm-baseline {
    align-items: baseline !important;
  }
  .gx-align-items-sm-stretch {
    align-items: stretch !important;
  }
  .gx-align-content-sm-start {
    align-content: flex-start !important;
  }
  .gx-align-content-sm-end {
    align-content: flex-end !important;
  }
  .gx-align-content-sm-center {
    align-content: center !important;
  }
  .gx-align-content-sm-between {
    align-content: space-between !important;
  }
  .gx-align-content-sm-around {
    align-content: space-around !important;
  }
  .gx-align-content-sm-stretch {
    align-content: stretch !important;
  }
  .gx-align-self-sm-auto {
    align-self: auto !important;
  }
  .gx-align-self-sm-start {
    align-self: flex-start !important;
  }
  .gx-align-self-sm-end {
    align-self: flex-end !important;
  }
  .gx-align-self-sm-center {
    align-self: center !important;
  }
  .gx-align-self-sm-baseline {
    align-self: baseline !important;
  }
  .gx-align-self-sm-stretch {
    align-self: stretch !important;
  }
  .gx-order-sm-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .gx-order-sm-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .gx-order-sm-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .gx-order-sm-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .gx-order-sm-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .gx-order-sm-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .gx-order-sm-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .gx-order-sm-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .gx-order-sm-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .gx-order-sm-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .gx-order-sm-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .gx-order-sm-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .gx-order-sm-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .gx-offset-sm-0 {
    margin-left: 0;
  }
  .gx-offset-sm-1 {
    margin-left: 8.333333%;
  }
  .gx-offset-sm-2 {
    margin-left: 16.666667%;
  }
  .gx-offset-sm-3 {
    margin-left: 25%;
  }
  .gx-offset-sm-4 {
    margin-left: 33.333333%;
  }
  .gx-offset-sm-5 {
    margin-left: 41.666667%;
  }
  .gx-offset-sm-6 {
    margin-left: 50%;
  }
  .gx-offset-sm-7 {
    margin-left: 58.333333%;
  }
  .gx-offset-sm-8 {
    margin-left: 66.666667%;
  }
  .gx-offset-sm-9 {
    margin-left: 75%;
  }
  .gx-offset-sm-10 {
    margin-left: 83.333333%;
  }
  .gx-offset-sm-11 {
    margin-left: 91.666667%;
  }
}
@media screen and (min-width: 768px) {
  .gx-d-md-none {
    display: none !important;
  }
  .gx-d-md-inline-block {
    display: inline-block !important;
  }
  .gx-d-md-block {
    display: block !important;
  }
  .gx-d-md-flex {
    display: flex !important;
  }
  .gx-d-md-inline-flex {
    display: inline-flex !important;
  }
  .gx-flex-md-row {
    flex-direction: row !important;
  }
  .gx-flex-md-column {
    flex-direction: column !important;
  }
  .gx-flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .gx-flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .gx-flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .gx-flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .gx-flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gx-justify-content-md-start {
    justify-content: flex-start !important;
  }
  .gx-justify-content-md-end {
    justify-content: flex-end !important;
  }
  .gx-justify-content-md-center {
    justify-content: center !important;
  }
  .gx-justify-content-md-between {
    justify-content: space-between !important;
  }
  .gx-justify-content-md-around {
    justify-content: space-around !important;
  }
  .gx-align-items-md-start {
    align-items: flex-start !important;
  }
  .gx-align-items-md-end {
    align-items: flex-end !important;
  }
  .gx-align-items-md-center {
    align-items: center !important;
  }
  .gx-align-items-md-baseline {
    align-items: baseline !important;
  }
  .gx-align-items-md-stretch {
    align-items: stretch !important;
  }
  .gx-align-content-md-start {
    align-content: flex-start !important;
  }
  .gx-align-content-md-end {
    align-content: flex-end !important;
  }
  .gx-align-content-md-center {
    align-content: center !important;
  }
  .gx-align-content-md-between {
    align-content: space-between !important;
  }
  .gx-align-content-md-around {
    align-content: space-around !important;
  }
  .gx-align-content-md-stretch {
    align-content: stretch !important;
  }
  .gx-align-self-md-auto {
    align-self: auto !important;
  }
  .gx-align-self-md-start {
    align-self: flex-start !important;
  }
  .gx-align-self-md-end {
    align-self: flex-end !important;
  }
  .gx-align-self-md-center {
    align-self: center !important;
  }
  .gx-align-self-md-baseline {
    align-self: baseline !important;
  }
  .gx-align-self-md-stretch {
    align-self: stretch !important;
  }
  .gx-order-md-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .gx-order-md-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .gx-order-md-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .gx-order-md-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .gx-order-md-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .gx-order-md-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .gx-order-md-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .gx-order-md-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .gx-order-md-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .gx-order-md-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .gx-order-md-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .gx-order-md-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .gx-order-md-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .gx-offset-md-0 {
    margin-left: 0;
  }
  .gx-offset-md-1 {
    margin-left: 8.333333%;
  }
  .gx-offset-md-2 {
    margin-left: 16.666667%;
  }
  .gx-offset-md-3 {
    margin-left: 25%;
  }
  .gx-offset-md-4 {
    margin-left: 33.333333%;
  }
  .gx-offset-md-5 {
    margin-left: 41.666667%;
  }
  .gx-offset-md-6 {
    margin-left: 50%;
  }
  .gx-offset-md-7 {
    margin-left: 58.333333%;
  }
  .gx-offset-md-8 {
    margin-left: 66.666667%;
  }
  .gx-offset-md-9 {
    margin-left: 75%;
  }
  .gx-offset-md-10 {
    margin-left: 83.333333%;
  }
  .gx-offset-md-11 {
    margin-left: 91.666667%;
  }
}
@media screen and (min-width: 992px) {
  .gx-d-lg-none {
    display: none !important;
  }
  .gx-d-lg-inline-block {
    display: inline-block !important;
  }
  .gx-d-lg-block {
    display: block !important;
  }
  .gx-d-lg-flex {
    display: flex !important;
  }
  .gx-d-lg-inline-flex {
    display: inline-flex !important;
  }
  .gx-flex-lg-row {
    flex-direction: row !important;
  }
  .gx-flex-lg-column {
    flex-direction: column !important;
  }
  .gx-flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .gx-flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .gx-flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .gx-flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .gx-flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gx-justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .gx-justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .gx-justify-content-lg-center {
    justify-content: center !important;
  }
  .gx-justify-content-lg-between {
    justify-content: space-between !important;
  }
  .gx-justify-content-lg-around {
    justify-content: space-around !important;
  }
  .gx-align-items-lg-start {
    align-items: flex-start !important;
  }
  .gx-align-items-lg-end {
    align-items: flex-end !important;
  }
  .gx-align-items-lg-center {
    align-items: center !important;
  }
  .gx-align-items-lg-baseline {
    align-items: baseline !important;
  }
  .gx-align-items-lg-stretch {
    align-items: stretch !important;
  }
  .gx-align-content-lg-start {
    align-content: flex-start !important;
  }
  .gx-align-content-lg-end {
    align-content: flex-end !important;
  }
  .gx-align-content-lg-center {
    align-content: center !important;
  }
  .gx-align-content-lg-between {
    align-content: space-between !important;
  }
  .gx-align-content-lg-around {
    align-content: space-around !important;
  }
  .gx-align-content-lg-stretch {
    align-content: stretch !important;
  }
  .gx-align-self-lg-auto {
    align-self: auto !important;
  }
  .gx-align-self-lg-start {
    align-self: flex-start !important;
  }
  .gx-align-self-lg-end {
    align-self: flex-end !important;
  }
  .gx-align-self-lg-center {
    align-self: center !important;
  }
  .gx-align-self-lg-baseline {
    align-self: baseline !important;
  }
  .gx-align-self-lg-stretch {
    align-self: stretch !important;
  }
  .gx-order-lg-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .gx-order-lg-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .gx-order-lg-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .gx-order-lg-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .gx-order-lg-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .gx-order-lg-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .gx-order-lg-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .gx-order-lg-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .gx-order-lg-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .gx-order-lg-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .gx-order-lg-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .gx-order-lg-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .gx-order-lg-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .gx-offset-lg-0 {
    margin-left: 0;
  }
  .gx-offset-lg-1 {
    margin-left: 8.333333%;
  }
  .gx-offset-lg-2 {
    margin-left: 16.666667%;
  }
  .gx-offset-lg-3 {
    margin-left: 25%;
  }
  .gx-offset-lg-4 {
    margin-left: 33.333333%;
  }
  .gx-offset-lg-5 {
    margin-left: 41.666667%;
  }
  .gx-offset-lg-6 {
    margin-left: 50%;
  }
  .gx-offset-lg-7 {
    margin-left: 58.333333%;
  }
  .gx-offset-lg-8 {
    margin-left: 66.666667%;
  }
  .gx-offset-lg-9 {
    margin-left: 75%;
  }
  .gx-offset-lg-10 {
    margin-left: 83.333333%;
  }
  .gx-offset-lg-11 {
    margin-left: 91.666667%;
  }
}
@media screen and (min-width: 1200px) {
  .gx-d-xl-none {
    display: none !important;
  }
  .gx-d-xl-inline-block {
    display: inline-block !important;
  }
  .gx-d-xl-block {
    display: block !important;
  }
  .gx-d-xl-flex {
    display: flex !important;
  }
  .gx-d-xl-inline-flex {
    display: inline-flex !important;
  }
  .gx-flex-xl-row {
    flex-direction: row !important;
  }
  .gx-flex-xl-column {
    flex-direction: column !important;
  }
  .gx-flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .gx-flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .gx-flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .gx-flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .gx-flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gx-justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .gx-justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .gx-justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .gx-justify-content-xl-around {
    justify-content: space-around !important;
  }
  .gx-align-items-xl-start {
    align-items: flex-start !important;
  }
  .gx-align-items-xl-end {
    align-items: flex-end !important;
  }
  .gx-align-items-xl-center {
    align-items: center !important;
  }
  .gx-align-items-xl-baseline {
    align-items: baseline !important;
  }
  .gx-align-items-xl-stretch {
    align-items: stretch !important;
  }
  .gx-align-content-xl-start {
    align-content: flex-start !important;
  }
  .gx-align-content-xl-end {
    align-content: flex-end !important;
  }
  .gx-align-content-xl-center {
    align-content: center !important;
  }
  .gx-align-content-xl-between {
    align-content: space-between !important;
  }
  .gx-align-content-xl-around {
    align-content: space-around !important;
  }
  .gx-align-content-xl-stretch {
    align-content: stretch !important;
  }
  .gx-align-self-xl-auto {
    align-self: auto !important;
  }
  .gx-align-self-xl-start {
    align-self: flex-start !important;
  }
  .gx-align-self-xl-end {
    align-self: flex-end !important;
  }
  .gx-align-self-xl-center {
    align-self: center !important;
  }
  .gx-align-self-xl-baseline {
    align-self: baseline !important;
  }
  .gx-align-self-xl-stretch {
    align-self: stretch !important;
  }
  .gx-order-xl-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .gx-order-xl-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .gx-order-xl-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .gx-order-xl-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .gx-order-xl-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .gx-order-xl-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .gx-order-xl-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .gx-order-xl-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .gx-order-xl-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .gx-order-xl-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .gx-order-xl-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .gx-order-xl-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .gx-order-xl-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .gx-offset-xl-0 {
    margin-left: 0;
  }
  .gx-offset-xl-1 {
    margin-left: 8.333333%;
  }
  .gx-offset-xl-2 {
    margin-left: 16.666667%;
  }
  .gx-offset-xl-3 {
    margin-left: 25%;
  }
  .gx-offset-xl-4 {
    margin-left: 33.333333%;
  }
  .gx-offset-xl-5 {
    margin-left: 41.666667%;
  }
  .gx-offset-xl-6 {
    margin-left: 50%;
  }
  .gx-offset-xl-7 {
    margin-left: 58.333333%;
  }
  .gx-offset-xl-8 {
    margin-left: 66.666667%;
  }
  .gx-offset-xl-9 {
    margin-left: 75%;
  }
  .gx-offset-xl-10 {
    margin-left: 83.333333%;
  }
  .gx-offset-xl-11 {
    margin-left: 91.666667%;
  }
}
.ant-row {
  margin-left: -16px;
  margin-right: -16px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.ant-row > [class*=ant-col-] {
  margin: 0 -0.3px;
}
.ant-col-1,
.ant-col-xs-1,
.ant-col-sm-1,
.ant-col-md-1,
.ant-col-lg-1,
.ant-col-2,
.ant-col-xs-2,
.ant-col-sm-2,
.ant-col-md-2,
.ant-col-lg-2,
.ant-col-3,
.ant-col-xs-3,
.ant-col-sm-3,
.ant-col-md-3,
.ant-col-lg-3,
.ant-col-4,
.ant-col-xs-4,
.ant-col-sm-4,
.ant-col-md-4,
.ant-col-lg-4,
.ant-col-5,
.ant-col-xs-5,
.ant-col-sm-5,
.ant-col-md-5,
.ant-col-lg-5,
.ant-col-6,
.ant-col-xs-6,
.ant-col-sm-6,
.ant-col-md-6,
.ant-col-lg-6,
.ant-col-7,
.ant-col-xs-7,
.ant-col-sm-7,
.ant-col-md-7,
.ant-col-lg-7,
.ant-col-8,
.ant-col-xs-8,
.ant-col-sm-8,
.ant-col-md-8,
.ant-col-lg-8,
.ant-col-9,
.ant-col-xs-9,
.ant-col-sm-9,
.ant-col-md-9,
.ant-col-lg-9,
.ant-col-10,
.ant-col-xs-10,
.ant-col-sm-10,
.ant-col-md-10,
.ant-col-lg-10,
.ant-col-11,
.ant-col-xs-11,
.ant-col-sm-11,
.ant-col-md-11,
.ant-col-lg-11,
.ant-col-12,
.ant-col-xs-12,
.ant-col-sm-12,
.ant-col-md-12,
.ant-col-lg-12,
.ant-col-13,
.ant-col-xs-13,
.ant-col-sm-13,
.ant-col-md-13,
.ant-col-lg-13,
.ant-col-14,
.ant-col-xs-14,
.ant-col-sm-14,
.ant-col-md-14,
.ant-col-lg-14,
.ant-col-15,
.ant-col-xs-15,
.ant-col-sm-15,
.ant-col-md-15,
.ant-col-lg-15,
.ant-col-16,
.ant-col-xs-16,
.ant-col-sm-16,
.ant-col-md-16,
.ant-col-lg-16,
.ant-col-17,
.ant-col-xs-17,
.ant-col-sm-17,
.ant-col-md-17,
.ant-col-lg-17,
.ant-col-18,
.ant-col-xs-18,
.ant-col-sm-18,
.ant-col-md-18,
.ant-col-lg-18,
.ant-col-19,
.ant-col-xs-19,
.ant-col-sm-19,
.ant-col-md-19,
.ant-col-lg-19,
.ant-col-20,
.ant-col-xs-20,
.ant-col-sm-20,
.ant-col-md-20,
.ant-col-lg-20,
.ant-col-21,
.ant-col-xs-21,
.ant-col-sm-21,
.ant-col-md-21,
.ant-col-lg-21,
.ant-col-22,
.ant-col-xs-22,
.ant-col-sm-22,
.ant-col-md-22,
.ant-col-lg-22,
.ant-col-23,
.ant-col-xs-23,
.ant-col-sm-23,
.ant-col-md-23,
.ant-col-lg-23,
.ant-col-24,
.ant-col-xs-24,
.ant-col-sm-24,
.ant-col-md-24,
.ant-col-lg-24 {
  padding-right: 16px;
  float: none !important;
}
.gx-col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  padding-right: 16px;
}
@media screen and (max-width: 480px) {
  .gx-col-full {
    width: 100%;
  }
}
.ant-row-flex {
  display: flex;
  flex-flow: row wrap;
}
/*Margin Padding Styles*/
.gx-mb-30 {
  margin-bottom: 30px !important;
}
.gx-mb-10 {
  margin-bottom: 10px !important;
}
.gx-m-0 {
  margin: 0 !important;
}
.gx-mt-0,
.gx-my-0 {
  margin-top: 0 !important;
}
.gx-mr-0,
.gx-mx-0 {
  margin-right: 0 !important;
}
.gx-mb-0,
.gx-my-0 {
  margin-bottom: 0 !important;
}
.gx-ml-0,
.gx-mx-0 {
  margin-left: 0 !important;
}
.gx-m-1 {
  margin: 0.25rem !important;
}
.gx-mt-1,
.gx-my-1 {
  margin-top: 0.25rem !important;
}
.gx-mr-1,
.gx-mx-1 {
  margin-right: 0.25rem !important;
}
.gx-mb-1,
.gx-my-1 {
  margin-bottom: 0.25rem !important;
}
.gx-ml-1,
.gx-mx-1 {
  margin-left: 0.25rem !important;
}
.gx-m-2 {
  margin: 0.5rem !important;
}
.gx-mt-2,
.gx-my-2 {
  margin-top: 0.5rem !important;
}
.gx-mr-2,
.gx-mx-2 {
  margin-right: 0.5rem !important;
}
.gx-mb-2,
.gx-my-2 {
  margin-bottom: 0.5rem !important;
}
.gx-ml-2,
.gx-mx-2 {
  margin-left: 0.5rem !important;
}
.gx-m-3 {
  margin: 1rem !important;
}
.gx-mt-3,
.gx-my-3 {
  margin-top: 1rem !important;
}
.gx-mr-3,
.gx-mx-3 {
  margin-right: 1rem !important;
}
.gx-mb-3,
.gx-my-3 {
  margin-bottom: 1rem !important;
}
.gx-ml-3,
.gx-mx-3 {
  margin-left: 1rem !important;
}
.gx-m-4 {
  margin: 1.5rem !important;
}
.gx-mt-4,
.gx-my-4 {
  margin-top: 1.5rem !important;
}
.gx-mr-4,
.gx-mx-4 {
  margin-right: 1.5rem !important;
}
.gx-mb-4,
.gx-my-4 {
  margin-bottom: 1.5rem !important;
}
.gx-ml-4,
.gx-mx-4 {
  margin-left: 1.5rem !important;
}
.gx-m-5 {
  margin: 3rem !important;
}
.gx-mt-5,
.gx-my-5 {
  margin-top: 3rem !important;
}
.gx-mr-5,
.gx-mx-5 {
  margin-right: 3rem !important;
}
.gx-mb-5,
.gx-my-5 {
  margin-bottom: 3rem !important;
}
.gx-ml-5,
.gx-mx-5 {
  margin-left: 3rem !important;
}
.gx-p-0 {
  padding: 0 !important;
}
.gx-pt-0,
.gx-py-0 {
  padding-top: 0 !important;
}
.gx-pr-0,
.gx-px-0 {
  padding-right: 0 !important;
}
.gx-pb-0,
.gx-py-0 {
  padding-bottom: 0 !important;
}
.gx-pl-0,
.gx-px-0 {
  padding-left: 0 !important;
}
.gx-p-1 {
  padding: 0.25rem !important;
}
.gx-pt-1,
.gx-py-1 {
  padding-top: 0.25rem !important;
}
.gx-pr-1,
.gx-px-1 {
  padding-right: 0.25rem !important;
}
.gx-pb-1,
.gx-py-1 {
  padding-bottom: 0.25rem !important;
}
.gx-pl-1,
.gx-px-1 {
  padding-left: 0.25rem !important;
}
.gx-p-2 {
  padding: 0.5rem !important;
}
.gx-pt-2,
.gx-py-2 {
  padding-top: 0.5rem !important;
}
.gx-pr-2,
.gx-px-2 {
  padding-right: 0.5rem !important;
}
.gx-pb-2,
.gx-py-2 {
  padding-bottom: 0.5rem !important;
}
.gx-pl-2,
.gx-px-2 {
  padding-left: 0.5rem !important;
}
.gx-p-3 {
  padding: 1rem !important;
}
.gx-pt-3,
.gx-py-3 {
  padding-top: 1rem !important;
}
.gx-pr-3,
.gx-px-3 {
  padding-right: 1rem !important;
}
.gx-pb-3,
.gx-py-3 {
  padding-bottom: 1rem !important;
}
.gx-pl-3,
.gx-px-3 {
  padding-left: 1rem !important;
}
.gx-p-4 {
  padding: 1.5rem !important;
}
.gx-pt-4,
.gx-py-4 {
  padding-top: 1.5rem !important;
}
.gx-pr-4,
.gx-px-4 {
  padding-right: 1.5rem !important;
}
.gx-pb-4,
.gx-py-4 {
  padding-bottom: 1.5rem !important;
}
.gx-pl-4,
.gx-px-4 {
  padding-left: 1.5rem !important;
}
.gx-p-5 {
  padding: 2rem !important;
}
.gx-pt-5,
.gx-py-5 {
  padding-top: 2rem !important;
}
.gx-pr-5,
.gx-px-5 {
  padding-right: 2rem !important;
}
.gx-pb-5,
.gx-py-5 {
  padding-bottom: 2rem !important;
}
.gx-pl-5,
.gx-px-5 {
  padding-left: 2rem !important;
}
.gx-m-auto {
  margin: auto !important;
}
.gx-mt-auto,
.gx-my-auto {
  margin-top: auto !important;
}
.gx-mr-auto,
.gx-mx-auto {
  margin-right: auto !important;
}
.gx-mb-auto,
.gx-my-auto {
  margin-bottom: auto !important;
}
.gx-ml-auto,
.gx-mx-auto {
  margin-left: auto !important;
}
@media (min-width: 576px) {
  .gx-m-sm-0 {
    margin: 0 !important;
  }
  .gx-mt-sm-0,
  .gx-my-sm-0 {
    margin-top: 0 !important;
  }
  .gx-mr-sm-0,
  .gx-mx-sm-0 {
    margin-right: 0 !important;
  }
  .gx-mb-sm-0,
  .gx-my-sm-0 {
    margin-bottom: 0 !important;
  }
  .gx-ml-sm-0,
  .gx-mx-sm-0 {
    margin-left: 0 !important;
  }
  .gx-m-sm-1 {
    margin: 0.25rem !important;
  }
  .gx-mt-sm-1,
  .gx-my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .gx-mr-sm-1,
  .gx-mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .gx-mb-sm-1,
  .gx-my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .gx-ml-sm-1,
  .gx-mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .gx-m-sm-2 {
    margin: 0.5rem !important;
  }
  .gx-mt-sm-2,
  .gx-my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .gx-mr-sm-2,
  .gx-mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .gx-mb-sm-2,
  .gx-my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .gx-ml-sm-2,
  .gx-mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .gx-m-sm-3 {
    margin: 1rem !important;
  }
  .gx-mt-sm-3,
  .gx-my-sm-3 {
    margin-top: 1rem !important;
  }
  .gx-mr-sm-3,
  .gx-mx-sm-3 {
    margin-right: 1rem !important;
  }
  .gx-mb-sm-3,
  .gx-my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .gx-ml-sm-3,
  .gx-mx-sm-3 {
    margin-left: 1rem !important;
  }
  .gx-m-sm-4 {
    margin: 1.5rem !important;
  }
  .gx-mt-sm-4,
  .gx-my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .gx-mr-sm-4,
  .gx-mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .gx-mb-sm-4,
  .gx-my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .gx-ml-sm-4,
  .gx-mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .gx-m-sm-5 {
    margin: 3rem !important;
  }
  .gx-mt-sm-5,
  .gx-my-sm-5 {
    margin-top: 3rem !important;
  }
  .gx-mr-sm-5,
  .gx-mx-sm-5 {
    margin-right: 3rem !important;
  }
  .gx-mb-sm-5,
  .gx-my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .gx-ml-sm-5,
  .gx-mx-sm-5 {
    margin-left: 3rem !important;
  }
  .gx-p-sm-0 {
    padding: 0 !important;
  }
  .gx-pt-sm-0,
  .gx-py-sm-0 {
    padding-top: 0 !important;
  }
  .gx-pr-sm-0,
  .gx-px-sm-0 {
    padding-right: 0 !important;
  }
  .gx-pb-sm-0,
  .gx-py-sm-0 {
    padding-bottom: 0 !important;
  }
  .gx-pl-sm-0,
  .gx-px-sm-0 {
    padding-left: 0 !important;
  }
  .gx-p-sm-1 {
    padding: 0.25rem !important;
  }
  .gx-pt-sm-1,
  .gx-py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .gx-pr-sm-1,
  .gx-px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .gx-pb-sm-1,
  .gx-py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .gx-pl-sm-1,
  .gx-px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .gx-p-sm-2 {
    padding: 0.5rem !important;
  }
  .gx-pt-sm-2,
  .gx-py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .gx-pr-sm-2,
  .gx-px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .gx-pb-sm-2,
  .gx-py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .gx-pl-sm-2,
  .gx-px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .gx-p-sm-3 {
    padding: 1rem !important;
  }
  .gx-pt-sm-3,
  .gx-py-sm-3 {
    padding-top: 1rem !important;
  }
  .gx-pr-sm-3,
  .gx-px-sm-3 {
    padding-right: 1rem !important;
  }
  .gx-pb-sm-3,
  .gx-py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .gx-pl-sm-3,
  .gx-px-sm-3 {
    padding-left: 1rem !important;
  }
  .gx-p-sm-4 {
    padding: 1.5rem !important;
  }
  .gx-pt-sm-4,
  .gx-py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .gx-pr-sm-4,
  .gx-px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .gx-pb-sm-4,
  .gx-py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .gx-pl-sm-4,
  .gx-px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .gx-p-sm-5 {
    padding: 2rem !important;
  }
  .gx-pt-sm-5,
  .gx-py-sm-5 {
    padding-top: 2rem !important;
  }
  .gx-pr-sm-5,
  .gx-px-sm-5 {
    padding-right: 2rem !important;
  }
  .gx-pb-sm-5,
  .gx-py-sm-5 {
    padding-bottom: 2rem !important;
  }
  .gx-pl-sm-5,
  .gx-px-sm-5 {
    padding-left: 2rem !important;
  }
  .gx-m-sm-auto {
    margin: auto !important;
  }
  .gx-mt-sm-auto,
  .gx-my-sm-auto {
    margin-top: auto !important;
  }
  .gx-mr-sm-auto,
  .gx-mx-sm-auto {
    margin-right: auto !important;
  }
  .gx-mb-sm-auto,
  .gx-my-sm-auto {
    margin-bottom: auto !important;
  }
  .gx-ml-sm-auto,
  .gx-mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .gx-m-md-0 {
    margin: 0 !important;
  }
  .gx-mt-md-0,
  .gx-my-md-0 {
    margin-top: 0 !important;
  }
  .gx-mr-md-0,
  .gx-mx-md-0 {
    margin-right: 0 !important;
  }
  .gx-mb-md-0,
  .gx-my-md-0 {
    margin-bottom: 0 !important;
  }
  .gx-ml-md-0,
  .gx-mx-md-0 {
    margin-left: 0 !important;
  }
  .gx-m-md-1 {
    margin: 0.25rem !important;
  }
  .gx-mt-md-1,
  .gx-my-md-1 {
    margin-top: 0.25rem !important;
  }
  .gx-mr-md-1,
  .gx-mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .gx-mb-md-1,
  .gx-my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .gx-ml-md-1,
  .gx-mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .gx-m-md-2 {
    margin: 0.5rem !important;
  }
  .gx-mt-md-2,
  .gx-my-md-2 {
    margin-top: 0.5rem !important;
  }
  .gx-mr-md-2,
  .gx-mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .gx-mb-md-2,
  .gx-my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .gx-ml-md-2,
  .gx-mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .gx-m-md-3 {
    margin: 1rem !important;
  }
  .gx-mt-md-3,
  .gx-my-md-3 {
    margin-top: 1rem !important;
  }
  .gx-mr-md-3,
  .gx-mx-md-3 {
    margin-right: 1rem !important;
  }
  .gx-mb-md-3,
  .gx-my-md-3 {
    margin-bottom: 1rem !important;
  }
  .gx-ml-md-3,
  .gx-mx-md-3 {
    margin-left: 1rem !important;
  }
  .gx-m-md-4 {
    margin: 1.5rem !important;
  }
  .gx-mt-md-4,
  .gx-my-md-4 {
    margin-top: 1.5rem !important;
  }
  .gx-mr-md-4,
  .gx-mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .gx-mb-md-4,
  .gx-my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .gx-ml-md-4,
  .gx-mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .gx-m-md-5 {
    margin: 3rem !important;
  }
  .gx-mt-md-5,
  .gx-my-md-5 {
    margin-top: 3rem !important;
  }
  .gx-mr-md-5,
  .gx-mx-md-5 {
    margin-right: 3rem !important;
  }
  .gx-mb-md-5,
  .gx-my-md-5 {
    margin-bottom: 3rem !important;
  }
  .gx-ml-md-5,
  .gx-mx-md-5 {
    margin-left: 3rem !important;
  }
  .gx-p-md-0 {
    padding: 0 !important;
  }
  .gx-pt-md-0,
  .gx-py-md-0 {
    padding-top: 0 !important;
  }
  .gx-pr-md-0,
  .gx-px-md-0 {
    padding-right: 0 !important;
  }
  .gx-pb-md-0,
  .gx-py-md-0 {
    padding-bottom: 0 !important;
  }
  .gx-pl-md-0,
  .gx-px-md-0 {
    padding-left: 0 !important;
  }
  .gx-p-md-1 {
    padding: 0.25rem !important;
  }
  .gx-pt-md-1,
  .gx-py-md-1 {
    padding-top: 0.25rem !important;
  }
  .gx-pr-md-1,
  .gx-px-md-1 {
    padding-right: 0.25rem !important;
  }
  .gx-pb-md-1,
  .gx-py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .gx-pl-md-1,
  .gx-px-md-1 {
    padding-left: 0.25rem !important;
  }
  .gx-p-md-2 {
    padding: 0.5rem !important;
  }
  .gx-pt-md-2,
  .gx-py-md-2 {
    padding-top: 0.5rem !important;
  }
  .gx-pr-md-2,
  .gx-px-md-2 {
    padding-right: 0.5rem !important;
  }
  .gx-pb-md-2,
  .gx-py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .gx-pl-md-2,
  .gx-px-md-2 {
    padding-left: 0.5rem !important;
  }
  .gx-p-md-3 {
    padding: 1rem !important;
  }
  .gx-pt-md-3,
  .gx-py-md-3 {
    padding-top: 1rem !important;
  }
  .gx-pr-md-3,
  .gx-px-md-3 {
    padding-right: 1rem !important;
  }
  .gx-pb-md-3,
  .gx-py-md-3 {
    padding-bottom: 1rem !important;
  }
  .gx-pl-md-3,
  .gx-px-md-3 {
    padding-left: 1rem !important;
  }
  .gx-p-md-4 {
    padding: 1.5rem !important;
  }
  .gx-pt-md-4,
  .gx-py-md-4 {
    padding-top: 1.5rem !important;
  }
  .gx-pr-md-4,
  .gx-px-md-4 {
    padding-right: 1.5rem !important;
  }
  .gx-pb-md-4,
  .gx-py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .gx-pl-md-4,
  .gx-px-md-4 {
    padding-left: 1.5rem !important;
  }
  .gx-p-md-5 {
    padding: 2rem !important;
  }
  .gx-pt-md-5,
  .gx-py-md-5 {
    padding-top: 2rem !important;
  }
  .gx-pr-md-5,
  .gx-px-md-5 {
    padding-right: 2rem !important;
  }
  .gx-pb-md-5,
  .gx-py-md-5 {
    padding-bottom: 2rem !important;
  }
  .gx-pl-md-5,
  .gx-px-md-5 {
    padding-left: 2rem !important;
  }
  .gx-m-md-auto {
    margin: auto !important;
  }
  .gx-mt-md-auto,
  .gx-my-md-auto {
    margin-top: auto !important;
  }
  .gx-mr-md-auto,
  .gx-mx-md-auto {
    margin-right: auto !important;
  }
  .gx-mb-md-auto,
  .gx-my-md-auto {
    margin-bottom: auto !important;
  }
  .gx-ml-md-auto,
  .gx-mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .gx-m-lg-0 {
    margin: 0 !important;
  }
  .gx-mt-lg-0,
  .gx-my-lg-0 {
    margin-top: 0 !important;
  }
  .gx-mr-lg-0,
  .gx-mx-lg-0 {
    margin-right: 0 !important;
  }
  .gx-mb-lg-0,
  .gx-my-lg-0 {
    margin-bottom: 0 !important;
  }
  .gx-ml-lg-0,
  .gx-mx-lg-0 {
    margin-left: 0 !important;
  }
  .gx-m-lg-1 {
    margin: 0.25rem !important;
  }
  .gx-mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .gx-mr-lg-1,
  .gx-mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .gx-mb-lg-1,
  .gx-my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .gx-ml-lg-1,
  .gx-mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .gx-m-lg-2 {
    margin: 0.5rem !important;
  }
  .gx-mt-lg-2,
  .gx-my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .gx-mr-lg-2,
  .gx-mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .gx-mb-lg-2,
  .gx-my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .gx-ml-lg-2,
  .gx-mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .gx-m-lg-3 {
    margin: 1rem !important;
  }
  .gx-mt-lg-3,
  .gx-my-lg-3 {
    margin-top: 1rem !important;
  }
  .gx-mr-lg-3,
  .gx-mx-lg-3 {
    margin-right: 1rem !important;
  }
  .gx-mb-lg-3,
  .gx-my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .gx-ml-lg-3,
  .gx-mx-lg-3 {
    margin-left: 1rem !important;
  }
  .gx-m-lg-4 {
    margin: 1.5rem !important;
  }
  .gx-mt-lg-4,
  .gx-my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .gx-mr-lg-4,
  .gx-mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .gx-mb-lg-4,
  .gx-my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .gx-ml-lg-4,
  .gx-mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .gx-m-lg-5 {
    margin: 3rem !important;
  }
  .gx-mt-lg-5,
  .gx-my-lg-5 {
    margin-top: 3rem !important;
  }
  .gx-mr-lg-5,
  .gx-mx-lg-5 {
    margin-right: 3rem !important;
  }
  .gx-mb-lg-5,
  .gx-my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .gx-ml-lg-5,
  .gx-mx-lg-5 {
    margin-left: 3rem !important;
  }
  .gx-p-lg-0 {
    padding: 0 !important;
  }
  .gx-pt-lg-0,
  .gx-py-lg-0 {
    padding-top: 0 !important;
  }
  .gx-pr-lg-0,
  .gx-px-lg-0 {
    padding-right: 0 !important;
  }
  .gx-pb-lg-0,
  .gx-py-lg-0 {
    padding-bottom: 0 !important;
  }
  .gx-pl-lg-0,
  .gx-px-lg-0 {
    padding-left: 0 !important;
  }
  .gx-p-lg-1 {
    padding: 0.25rem !important;
  }
  .gx-pt-lg-1,
  .gx-py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .gx-pr-lg-1,
  .gx-px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .gx-pb-lg-1,
  .gx-py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .gx-pl-lg-1,
  .gx-px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .gx-p-lg-2 {
    padding: 0.5rem !important;
  }
  .gx-pt-lg-2,
  .gx-py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .gx-pr-lg-2,
  .gx-px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .gx-pb-lg-2,
  .gx-py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .gx-pl-lg-2,
  .gx-px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .gx-p-lg-3 {
    padding: 1rem !important;
  }
  .gx-pt-lg-3,
  .gx-py-lg-3 {
    padding-top: 1rem !important;
  }
  .gx-pr-lg-3,
  .gx-px-lg-3 {
    padding-right: 1rem !important;
  }
  .gx-pb-lg-3,
  .gx-py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .gx-pl-lg-3,
  .gx-px-lg-3 {
    padding-left: 1rem !important;
  }
  .gx-p-lg-4 {
    padding: 1.5rem !important;
  }
  .gx-pt-lg-4,
  .gx-py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .gx-pr-lg-4,
  .gx-px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .gx-pb-lg-4,
  .gx-py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .gx-pl-lg-4,
  .gx-px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .gx-p-lg-5 {
    padding: 2rem !important;
  }
  .gx-pt-lg-5,
  .gx-py-lg-5 {
    padding-top: 2rem !important;
  }
  .gx-pr-lg-5,
  .gx-px-lg-5 {
    padding-right: 2rem !important;
  }
  .gx-pb-lg-5,
  .gx-py-lg-5 {
    padding-bottom: 2rem !important;
  }
  .gx-pl-lg-5,
  .gx-px-lg-5 {
    padding-left: 2rem !important;
  }
  .gx-m-lg-auto {
    margin: auto !important;
  }
  .gx-mt-lg-auto,
  .gx-my-lg-auto {
    margin-top: auto !important;
  }
  .gx-mr-lg-auto,
  .gx-mx-lg-auto {
    margin-right: auto !important;
  }
  .gx-mb-lg-auto,
  .gx-my-lg-auto {
    margin-bottom: auto !important;
  }
  .gx-ml-lg-auto,
  .gx-mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .gx-m-xl-0 {
    margin: 0 !important;
  }
  .gx-mt-xl-0,
  .gx-my-xl-0 {
    margin-top: 0 !important;
  }
  .gx-mr-xl-0,
  .gx-mx-xl-0 {
    margin-right: 0 !important;
  }
  .gx-mb-xl-0,
  .gx-my-xl-0 {
    margin-bottom: 0 !important;
  }
  .gx-ml-xl-0,
  .gx-mx-xl-0 {
    margin-left: 0 !important;
  }
  .gx-m-xl-1 {
    margin: 0.25rem !important;
  }
  .gx-mt-xl-1,
  .gx-my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .gx-mr-xl-1,
  .gx-mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .gx-mb-xl-1,
  .gx-my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .gx-ml-xl-1,
  .gx-mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .gx-m-xl-2 {
    margin: 0.5rem !important;
  }
  .gx-mt-xl-2,
  .gx-my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .gx-mr-xl-2,
  .gx-mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .gx-mb-xl-2,
  .gx-my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .gx-ml-xl-2,
  .gx-mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .gx-m-xl-3 {
    margin: 1rem !important;
  }
  .gx-mt-xl-3,
  .gx-my-xl-3 {
    margin-top: 1rem !important;
  }
  .gx-mr-xl-3,
  .gx-mx-xl-3 {
    margin-right: 1rem !important;
  }
  .gx-mb-xl-3,
  .gx-my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .gx-ml-xl-3,
  .gx-mx-xl-3 {
    margin-left: 1rem !important;
  }
  .gx-m-xl-4 {
    margin: 1.5rem !important;
  }
  .gx-mt-xl-4,
  .gx-my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .gx-mr-xl-4,
  .gx-mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .gx-mb-xl-4,
  .gx-my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .gx-ml-xl-4,
  .gx-mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .gx-m-xl-5 {
    margin: 3rem !important;
  }
  .gx-mt-xl-5,
  .gx-my-xl-5 {
    margin-top: 3rem !important;
  }
  .gx-mr-xl-5,
  .gx-mx-xl-5 {
    margin-right: 3rem !important;
  }
  .gx-mb-xl-5,
  .gx-my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .gx-ml-xl-5,
  .gx-mx-xl-5 {
    margin-left: 3rem !important;
  }
  .gx-p-xl-0 {
    padding: 0 !important;
  }
  .gx-pt-xl-0,
  .gx-py-xl-0 {
    padding-top: 0 !important;
  }
  .gx-pr-xl-0,
  .gx-px-xl-0 {
    padding-right: 0 !important;
  }
  .gx-pb-xl-0,
  .gx-py-xl-0 {
    padding-bottom: 0 !important;
  }
  .gx-pl-xl-0,
  .gx-px-xl-0 {
    padding-left: 0 !important;
  }
  .gx-p-xl-1 {
    padding: 0.25rem !important;
  }
  .gx-pt-xl-1,
  .gx-py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .gx-pr-xl-1,
  .gx-px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .gx-pb-xl-1,
  .gx-py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .gx-pl-xl-1,
  .gx-px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .gx-p-xl-2 {
    padding: 0.5rem !important;
  }
  .gx-pt-xl-2,
  .gx-py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .gx-pr-xl-2,
  .gx-px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .gx-pb-xl-2,
  .gx-py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .gx-pl-xl-2,
  .gx-px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .gx-p-xl-3 {
    padding: 1rem !important;
  }
  .gx-pt-xl-3,
  .gx-py-xl-3 {
    padding-top: 1rem !important;
  }
  .gx-pr-xl-3,
  .gx-px-xl-3 {
    padding-right: 1rem !important;
  }
  .gx-pb-xl-3,
  .gx-py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .gx-pl-xl-3,
  .gx-px-xl-3 {
    padding-left: 1rem !important;
  }
  .gx-p-xl-4 {
    padding: 1.5rem !important;
  }
  .gx-pt-xl-4,
  .gx-py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .gx-pr-xl-4,
  .gx-px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .gx-pb-xl-4,
  .gx-py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .gx-pl-xl-4,
  .gx-px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .gx-p-xl-5 {
    padding: 2rem !important;
  }
  .gx-pt-xl-5,
  .gx-py-xl-5 {
    padding-top: 2rem !important;
  }
  .gx-pr-xl-5,
  .gx-px-xl-5 {
    padding-right: 2rem !important;
  }
  .gx-pb-xl-5,
  .gx-py-xl-5 {
    padding-bottom: 2rem !important;
  }
  .gx-pl-xl-5,
  .gx-px-xl-5 {
    padding-left: 2rem !important;
  }
  .gx-m-xl-auto {
    margin: auto !important;
  }
  .gx-mt-xl-auto,
  .gx-my-xl-auto {
    margin-top: auto !important;
  }
  .gx-mr-xl-auto,
  .gx-mx-xl-auto {
    margin-right: auto !important;
  }
  .gx-mb-xl-auto,
  .gx-my-xl-auto {
    margin-bottom: auto !important;
  }
  .gx-ml-xl-auto,
  .gx-mx-xl-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1368px) {
  .gx-m-xxl-0 {
    margin: 0 !important;
  }
  .gx-mt-xxl-0,
  .gx-my-xxl-0 {
    margin-top: 0 !important;
  }
  .gx-mr-xxl-0,
  .gx-mx-xxl-0 {
    margin-right: 0 !important;
  }
  .gx-mb-xxl-0,
  .gx-my-xxl-0 {
    margin-bottom: 0 !important;
  }
  .gx-ml-xxl-0,
  .gx-mx-xxl-0 {
    margin-left: 0 !important;
  }
  .gx-m-xxl-1 {
    margin: 0.25rem !important;
  }
  .gx-mt-xxl-1,
  .gx-my-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .gx-mr-xxl-1,
  .gx-mx-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .gx-mb-xxl-1,
  .gx-my-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .gx-ml-xxl-1,
  .gx-mx-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .gx-m-xxl-2 {
    margin: 0.5rem !important;
  }
  .gx-mt-xxl-2,
  .gx-my-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .gx-mr-xxl-2,
  .gx-mx-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .gx-mb-xxl-2,
  .gx-my-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .gx-ml-xxl-2,
  .gx-mx-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .gx-m-xxl-3 {
    margin: 1rem !important;
  }
  .gx-mt-xxl-3,
  .gx-my-xxl-3 {
    margin-top: 1rem !important;
  }
  .gx-mr-xxl-3,
  .gx-mx-xxl-3 {
    margin-right: 1rem !important;
  }
  .gx-mb-xxl-3,
  .gx-my-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .gx-ml-xxl-3,
  .gx-mx-xxl-3 {
    margin-left: 1rem !important;
  }
  .gx-m-xxl-4 {
    margin: 1.5rem !important;
  }
  .gx-mt-xxl-4,
  .gx-my-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .gx-mr-xxl-4,
  .gx-mx-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .gx-mb-xxl-4,
  .gx-my-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .gx-ml-xxl-4,
  .gx-mx-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .gx-m-xxl-5 {
    margin: 3rem !important;
  }
  .gx-mt-xxl-5,
  .gx-my-xxl-5 {
    margin-top: 3rem !important;
  }
  .gx-mr-xxl-5,
  .gx-mx-xxl-5 {
    margin-right: 3rem !important;
  }
  .gx-mb-xxl-5,
  .gx-my-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .gx-ml-xxl-5,
  .gx-mx-xxl-5 {
    margin-left: 3rem !important;
  }
  .gx-p-xxl-0 {
    padding: 0 !important;
  }
  .gx-pt-xxl-0,
  .gx-py-xxl-0 {
    padding-top: 0 !important;
  }
  .gx-pr-xxl-0,
  .gx-px-xxl-0 {
    padding-right: 0 !important;
  }
  .gx-pb-xxl-0,
  .gx-py-xxl-0 {
    padding-bottom: 0 !important;
  }
  .gx-pl-xxl-0,
  .gx-px-xxl-0 {
    padding-left: 0 !important;
  }
  .gx-p-xxl-1 {
    padding: 0.25rem !important;
  }
  .gx-pt-xxl-1,
  .gx-py-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .gx-pr-xxl-1,
  .gx-px-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .gx-pb-xxl-1,
  .gx-py-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .gx-pl-xxl-1,
  .gx-px-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .gx-p-xxl-2 {
    padding: 0.5rem !important;
  }
  .gx-pt-xxl-2,
  .gx-py-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .gx-pr-xxl-2,
  .gx-px-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .gx-pb-xxl-2,
  .gx-py-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .gx-pl-xxl-2,
  .gx-px-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .gx-p-xxl-3 {
    padding: 1rem !important;
  }
  .gx-pt-xxl-3,
  .gx-py-xxl-3 {
    padding-top: 1rem !important;
  }
  .gx-pr-xxl-3,
  .gx-px-xxl-3 {
    padding-right: 1rem !important;
  }
  .gx-pb-xxl-3,
  .gx-py-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .gx-pl-xxl-3,
  .gx-px-xxl-3 {
    padding-left: 1rem !important;
  }
  .gx-p-xxl-4 {
    padding: 1.5rem !important;
  }
  .gx-pt-xxl-4,
  .gx-py-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .gx-pr-xxl-4,
  .gx-px-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .gx-pb-xxl-4,
  .gx-py-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .gx-pl-xxl-4,
  .gx-px-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .gx-p-xxl-5 {
    padding: 2rem !important;
  }
  .gx-pt-xxl-5,
  .gx-py-xxl-5 {
    padding-top: 2rem !important;
  }
  .gx-pr-xxl-5,
  .gx-px-xxl-5 {
    padding-right: 2rem !important;
  }
  .gx-pb-xxl-5,
  .gx-py-xxl-5 {
    padding-bottom: 2rem !important;
  }
  .gx-pl-xxl-5,
  .gx-px-xxl-5 {
    padding-left: 2rem !important;
  }
  .gx-m-xxl-auto {
    margin: auto !important;
  }
  .gx-mt-xxl-auto,
  .gx-my-xxl-auto {
    margin-top: auto !important;
  }
  .gx-mr-xxl-auto,
  .gx-mx-xxl-auto {
    margin-right: auto !important;
  }
  .gx-mb-xxl-auto,
  .gx-my-xxl-auto {
    margin-bottom: auto !important;
  }
  .gx-ml-xxl-auto,
  .gx-mx-xxl-auto {
    margin-left: auto !important;
  }
}
/*Typography Styles*/
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  color: #262626;
  font-weight: 400;
  line-height: 1.2;
}
h1,
.h1 {
  font-size: 22px;
}
.framed-layout h1,
.framed-layout .h1 {
  font-size: 20px;
}
@media screen and (max-width: 767px) {
  .framed-layout h1,
  .framed-layout .h1 {
    font-size: 18px;
  }
}
.boxed-layout h1,
.boxed-layout .h1 {
  font-size: 18px;
}
@media screen and (max-width: 767px) {
  .boxed-layout h1,
  .boxed-layout .h1 {
    font-size: 16px;
  }
}
@media screen and (min-width: 1600px) {
  h1,
  .h1 {
    font-size: 28px;
  }
  .boxed-layout h1,
  .boxed-layout .h1 {
    font-size: 18px;
  }
}
h2,
.h2 {
  font-size: 20px;
}
h3,
.h3 {
  font-size: 18px;
}
h4,
.h4 {
  font-size: 16px;
}
h5,
.h5 {
  font-size: 14px;
}
h6,
.h6 {
  font-size: 12px;
}
.gx-h1-lg {
  font-size: 28px;
}
.gx-text-strikethrough {
  text-decoration: line-through !important;
}
.gx-text-underline {
  text-decoration: underline !important;
}
/*Font size Classes*/
/*8px*/
.gx-fs-xxs {
  font-size: 8px;
}
/*10px*/
.gx-fs-xs {
  font-size: 10px;
}
/*11px*/
.gx-fs-11 {
  font-size: 11px;
}
/*12px*/
.gx-fs-sm {
  font-size: 12px;
  line-height: 1.5;
}
/*14px*/
.gx-fs-md {
  font-size: 14px;
  line-height: 1;
}
/*16px*/
.gx-fs-lg {
  font-size: 16px;
  line-height: 1;
}
/*20px*/
.gx-fs-xl {
  font-size: 20px;
  line-height: 1;
}
/*24px*/
.gx-fs-xxl {
  font-size: 24px;
  line-height: 1.3;
}
@media screen and (max-width: 1199px) {
  .gx-fs-xxl {
    font-size: 20px;
  }
}
/*28px*/
.gx-fs-2xl {
  font-size: 28px !important;
  line-height: 1;
}
@media screen and (max-width: 1199px) {
  .gx-fs-2xl {
    font-size: 20px !important;
  }
}
/*30px*/
.gx-fs-xxxl {
  font-size: 30px;
  line-height: 1;
}
@media screen and (max-width: 1366px) {
  .gx-fs-xxxl {
    font-size: 28px;
  }
}
@media screen and (max-width: 1199px) {
  .gx-fs-xxxl {
    font-size: 26px;
  }
}
@media screen and (max-width: 991px) {
  .gx-fs-xxxl {
    font-size: 24px;
  }
}
/*40px*/
.gx-fs-xlxl {
  font-size: 40px;
  line-height: 1;
}
@media screen and (max-width: 1199px) {
  .gx-fs-xlxl {
    font-size: 32px;
  }
}
@media screen and (max-width: 991px) {
  .gx-fs-xlxl {
    font-size: 28px;
  }
}
/*50px*/
.gx-fs-icon-lg {
  font-size: 50px;
  line-height: 1;
}
@media screen and (max-width: 1366px) {
  .gx-fs-icon-lg {
    font-size: 38px;
  }
}
@media screen and (max-width: 575px) {
  .gx-fs-icon-lg {
    font-size: 30px;
  }
}
/*54px*/
.gx-fs-iconcard {
  font-size: 54px;
  line-height: 1;
}
@media screen and (max-width: 1366px) {
  .gx-fs-iconcard {
    font-size: 34px;
  }
}
.gx-text-lowercase {
  text-transform: lowercase;
}
.gx-text-uppercase {
  text-transform: uppercase;
}
.gx-text-capitalize {
  text-transform: capitalize;
}
.gx-font-weight-light {
  font-weight: 300;
}
.gx-font-weight-normal {
  font-weight: 400;
}
.gx-font-weight-medium {
  font-weight: 500;
}
.gx-font-weight-semi-bold {
  font-weight: 600;
}
.gx-font-weight-bold {
  font-weight: 700;
}
.gx-font-weight-heavy {
  font-weight: 900;
}
.gx-font-italic {
  font-style: italic;
}
.gx-letter-spacing-base {
  letter-spacing: 3px;
}
.gx-letter-spacing-lg {
  letter-spacing: 6px;
}
.gx-letter-spacing-xl {
  letter-spacing: 8px;
}
.gx-text-justify {
  text-align: justify !important;
}
.gx-text-nowrap {
  white-space: nowrap !important;
}
.gx-text-left {
  text-align: left !important;
}
.gx-text-right {
  text-align: right !important;
}
.gx-text-center {
  text-align: center !important;
}
.gx-text-truncate {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Ant Layout Style */
.ant-layout {
  position: relative;
  background: none;
}
.ant-layout > .gx-layout-content {
  overflow-x: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.full-scroll .ant-layout > .gx-layout-content {
  overflow-x: inherit;
}
.ant-layout.ant-layout-has-sider > .ant-layout {
  position: relative;
  background: #f5f5f5;
}
.framed-layout .ant-layout,
.boxed-layout .ant-layout {
  background: #f5f5f5;
}
.framed-layout .ant-layout,
.boxed-layout .ant-layout {
  background: #f5f5f5;
}
.ant-layout.gx-app-layout {
  height: 100vh;
}
.framed-layout .ant-layout.gx-app-layout {
  height: calc(100vh - 2 * 20px);
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-layout.gx-app-layout {
    height: 100vh;
  }
}
.framed-layout.full-scroll .ant-layout.gx-app-layout,
.boxed-layout.full-scroll .ant-layout.gx-app-layout {
  overflow-y: scroll;
}
.ant-layout.gx-app-layout > .ant-layout {
  height: 100vh;
}
.framed-layout .ant-layout.gx-app-layout > .ant-layout {
  height: calc(100vh - 2 * 20px);
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-layout.gx-app-layout > .ant-layout {
    height: 100vh;
  }
}
.full-scroll .ant-layout.ant-layout-has-sider > .ant-layout,
.full-scroll .ant-layout.ant-layout-has-sider > .ant-layout-content {
  overflow-x: inherit;
}
.gx-main-content-wrapper {
  top: 0;
  left: 0;
  padding: 32px 16px 0;
  flex: 1;
}
@media screen and (max-width: 575px) {
  .gx-main-content-wrapper {
    padding: 20px 15px 0;
  }
}
.gx-container-wrap .gx-main-content-wrapper {
  width: 94vw;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
}
@media screen and (min-width: 768px) {
  .gx-container-wrap .gx-main-content-wrapper {
    width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .gx-container-wrap .gx-main-content-wrapper {
    width: 920px;
  }
}
@media screen and (min-width: 1200px) {
  .gx-container-wrap .gx-main-content-wrapper {
    width: 1100px;
  }
}
@media screen and (min-width: 1367px) {
  .gx-container-wrap .gx-main-content-wrapper {
    width: 1200px;
  }
}
@media screen and (min-width: 1600px) {
  .gx-container-wrap .gx-main-content-wrapper {
    width: 1400px;
  }
}
.gx-main-content {
  height: 100%;
}
.gx-container {
  width: 94vw;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
}
@media screen and (min-width: 768px) {
  .gx-container {
    width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .gx-container {
    width: 920px;
  }
}
@media screen and (min-width: 1200px) {
  .gx-container {
    width: 1100px;
  }
}
@media screen and (min-width: 1367px) {
  .gx-container {
    width: 1200px;
  }
}
@media screen and (min-width: 1600px) {
  .gx-container {
    width: 1400px;
  }
}
/* Header Style */
.ant-layout-header {
  -webkit-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
  line-height: 1;
  padding: 0 32px;
  height: 72px;
  position: relative;
  z-index: 10;
  color: #262626;
}
@media screen and (max-width: 991px) {
  .ant-layout-header {
    padding: 0 15px;
  }
}
@media screen and (max-width: 575px) {
  .ant-layout-header {
    height: 50px;
  }
}
.gx-nav-header {
  padding: 0 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  background-color: #fefefe;
}
.gx-nav-header .ant-menu-horizontal {
  margin-bottom: -1px;
  border-bottom-color: transparent;
}
.gx-nav-header-below {
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);
  -moz-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);
  position: relative;
  z-index: 999;
}
.ant-dropdown-menu-item {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-linebar {
  font-size: 20px;
}
.gx-header-horizontal-dark .gx-linebar {
  color: #ffffff;
}
.gx-header-notifications {
  list-style: none;
  margin: 0;
  padding-left: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-header-notifications > li {
  font-size: 18px;
}
.gx-header-notifications > li:not(:last-child) {
  margin-right: 42px;
}
.gx-inside-header-horizontal .gx-header-notifications > li:not(:last-child) {
  margin-right: 20px;
}
.gx-header-horizontal-main .gx-header-notifications > li:not(:last-child),
.gx-header-horizontal-nav .gx-header-notifications > li:not(:last-child) {
  margin-right: 30px;
}
@media screen and (max-width: 991px) {
  .gx-header-horizontal-main .gx-header-notifications > li:not(:last-child),
  .gx-header-horizontal-nav .gx-header-notifications > li:not(:last-child) {
    margin-right: 16px;
  }
}
@media screen and (max-width: 991px) {
  .gx-header-notifications > li:not(:last-child) {
    margin-right: 16px;
  }
}
.gx-header-notifications > li.gx-notify {
  margin-right: 22px;
}
.gx-header-horizontal-main .gx-header-notifications > li.gx-notify {
  margin-right: 30px;
}
@media screen and (max-width: 991px) {
  .gx-header-horizontal-main .gx-header-notifications > li.gx-notify {
    margin-right: 16px;
  }
}
.gx-inside-header-horizontal .gx-header-notifications > li.gx-notify {
  margin-right: 20px;
}
@media screen and (max-width: 991px) {
  .gx-header-notifications > li.gx-notify {
    margin-right: 16px;
  }
}
.gx-header-notifications > li.gx-language {
  font-size: 14px;
}
@media screen and (max-width: 575px) {
  .gx-header-notifications > li.gx-language .gx-language-name,
  .gx-header-notifications > li.gx-language .icon {
    display: none;
  }
  .gx-header-notifications > li.gx-language .flag.flag-24 {
    width: 20px;
    height: 20px;
    margin-top: -4px;
  }
}
@media screen and (max-width: 575px) {
  .gx-header-notifications > li.gx-notify,
  .gx-header-notifications > li.gx-msg {
    margin-top: 2px;
  }
  .gx-header-notifications > li.gx-language {
    margin-bottom: 2px;
  }
}
.gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {
  margin-left: 50px;
}
@media screen and (max-width: 991px) {
  .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {
    margin-left: 0;
  }
}
@media screen and (max-width: 1199px) {
  .gx-inside-header-horizontal .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {
    margin-left: 0;
  }
}
.gx-header-horizontal-main .gx-header-notifications li > span {
  color: #545454;
}
.gx-header-horizontal-dark .gx-header-horizontal-main .gx-header-notifications li > span {
  color: var(--app-secondary-color);
}
.gx-popover-scroll {
  height: 280px !important;
  width: 300px !important;
  margin: 0 -16px;
}
@media screen and (max-width: 575px) {
  .gx-popover-scroll {
    height: 280px !important;
    width: 200px !important;
  }
}
.gx-popover-lang-scroll {
  height: 220px !important;
  width: 160px !important;
  margin: 0 -16px;
}
.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
  right: 10px;
}
.gx-popover-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
  border-bottom: solid 1px #e8e8e8;
  margin: 0 -16px;
  padding: 0 16px 12px;
}
.gx-sub-popover {
  list-style: none;
  margin: 0 16px;
  padding-left: 0;
}
.gx-sub-popover li {
  padding: 20px 0 14px;
}
.gx-popover-lang-scroll .gx-sub-popover li {
  padding: 5px 0;
}
.gx-sub-popover li:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
}
.gx-user-popover {
  margin: -12px -16px;
  padding: 7px 0;
  list-style: none;
}
.gx-user-popover li {
  cursor: pointer;
  padding: 3px 15px;
  width: 150px;
}
.gx-user-popover li:hover,
.gx-user-popover li:focus {
  background-color: #fafafa;
}
@media screen and (max-width: 575px) {
  .gx-user-popover li {
    width: 100%;
  }
}
.gx-header-horizontal {
  position: relative;
  color: var(--app-secondary-color);
  background-color: #ffffff;
}
.gx-header-horizontal-dark {
  position: relative;
  background-color: var(--app-primary-color);
  color: var(--app-secondary-color);
}
.gx-header-horizontal-dark:before {
  content: '';
  position: absolute;
  right: 169px;
  top: -212px;
  background-color: rgba(255, 255, 255, 0.2);
  width: 280px;
  height: 350px;
  -webkit-border-radius: 0 0 135px 135px;
  -moz-border-radius: 0 0 135px 135px;
  border-radius: 0 0 135px 135px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  z-index: 1;
}
@media screen and (max-width: 1049px) {
  .gx-header-horizontal-dark:before {
    right: 110px;
  }
}
@media screen and (max-width: 1199px) {
  .gx-header-horizontal-dark:before {
    top: -184px;
    right: 80px;
    height: 300px;
  }
}
@media screen and (max-width: 991px) {
  .gx-header-horizontal-dark:before {
    top: -154px;
    right: 140px;
    height: 240px;
    width: 200px;
  }
}
@media screen and (max-width: 575px) {
  .gx-header-horizontal-dark:before {
    right: 60px;
    display: none;
  }
}
.gx-header-horizontal-dark > div {
  position: relative;
  z-index: 2;
}
.gx-header-horizontal-top {
  padding: 12px 0;
  font-size: 14px;
}
.gx-header-horizontal-top-flex,
.gx-header-horizontal-nav-flex,
.gx-header-horizontal-main-flex {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-header-horizontal-top-left {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-right: 15px;
}
@media screen and (max-width: 767px) {
  .gx-header-horizontal-top-left {
    margin-right: 0;
    width: 100%;
  }
}
.gx-header-horizontal-main {
  display: -webkit-block;
  display: -ms-blockbox;
  display: -ms-block;
  display: block;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  padding: 25px 0 35px;
  height: auto;
  background-color: transparent;
}
@media screen and (max-width: 1199px) {
  .gx-header-horizontal-main {
    padding: 20px 0;
  }
  .gx-header-horizontal-main .gx-w-logo {
    padding: 7px 5px;
  }
}
@media screen and (max-width: 991px) {
  .gx-header-horizontal-main {
    padding: 0;
  }
}
@media screen and (max-width: 575px) {
  .gx-header-horizontal-main .gx-w-logo {
    padding-right: 0;
  }
}
.gx-inside-header-horizontal .gx-header-horizontal-main {
  padding: 0;
}
.gx-header-horizontal-nav {
  background-color: var(--app-primary-color);
  color: #fffffd;
}
.gx-header-horizontal-dark .gx-header-horizontal-nav {
  background-color: transparent;
}
.gx-below-header-horizontal .gx-header-horizontal-nav,
.gx-above-header-horizontal .gx-header-horizontal-nav {
  background-color: #fefefe;
  color: #7a7a7a;
}
.gx-inside-header-horizontal .gx-logo {
  margin-right: 25px;
}
.gx-inside-header-horizontal:before {
  top: -230px;
}
@media screen and (max-width: 1199px) {
  .gx-inside-header-horizontal:before {
    top: -190px;
  }
}
@media screen and (max-width: 991px) {
  .gx-inside-header-horizontal:before {
    top: -154px;
  }
}
.gx-above-header-horizontal:before {
  top: -165px;
}
@media screen and (max-width: 991px) {
  .gx-above-header-horizontal:before {
    top: -154px;
  }
}
.gx-login-list {
  list-style: none;
  margin-left: auto;
  margin-bottom: 0;
  padding-left: 0;
}
.gx-login-list li {
  padding: 0 10px;
  text-transform: uppercase;
  color: var(--app-secondary-color);
  font-size: 12px;
  line-height: 12px;
  display: inline-block;
  cursor: pointer;
}
.gx-login-list li:not(:first-child) {
  border-left: solid 1px #e8e8e8;
}
.gx-header-horizontal-dark .gx-login-list li:not(:first-child) {
  border: 0 none;
}
@media screen and (max-width: 767px) {
  .gx-login-list {
    display: none;
  }
}
.gx-header-search {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-left: 28px;
}
.gx-header-search .ant-select-selection,
.gx-header-search .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  -webkit-border-radius: 0 4px 4px 0;
  -moz-border-radius: 0 4px 4px 0;
  border-radius: 0 4px 4px 0;
  background-color: var(--app-primary-color);
  border-color: var(--app-primary-color);
  color: #fffffd;
  margin-bottom: 0;
}
.gx-header-search .ant-select-selection:focus,
.gx-header-search .ant-select-single:not(.ant-select-customize-input) .ant-select-selector:focus {
  background-color: var(--app-primary-color);
  border-color: var(--app-primary-color);
  color: #fffffd;
}
.gx-header-horizontal-dark .gx-header-search .ant-select-selection,
.gx-header-horizontal-dark .gx-header-search .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  color: #fffffd;
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.2);
  margin-left: 1px;
}
.gx-header-horizontal-dark .gx-header-search .ant-select-selection:focus,
.gx-header-horizontal-dark .gx-header-search .ant-select-single:not(.ant-select-customize-input) .ant-select-selector:focus {
  color: #fffffd;
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.2);
}
.gx-header-search .ant-select-arrow {
  color: #fffffd;
}
.gx-popover-horizantal .ant-btn {
  margin: 0 !important;
  border: 0 none;
  border-right: solid 1px #e8e8e8;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  height: 24px;
  line-height: 24px;
}
.gx-popover-horizantal .gx-popover-search-bar {
  margin: 0;
}
.gx-popover-horizantal .gx-popover-search-bar .ant-input {
  height: 24px;
  line-height: 24px;
}
@media screen and (max-width: 575px) {
  .gx-popover-horizantal {
    left: 0 !important;
    padding-top: 0;
    margin-top: -9px;
  }
  .gx-popover-horizantal .ant-popover-inner-content {
    width: 100vw;
  }
  .gx-popover-horizantal .ant-popover-arrow {
    display: none;
  }
  .gx-popover-horizantal .gx-popover-search-bar {
    width: 100%;
  }
  .gx-popover-horizantal .gx-popover-scroll,
  .gx-popover-horizantal .gx-popover-lang-scroll {
    width: 100% !important;
    margin: 0;
  }
  .gx-popover-horizantal .gx-sub-popover {
    margin: 0;
    padding-left: 5px;
  }
}
.gx-no-header-horizontal {
  padding: 14px 32px 13px 79px;
  text-align: center;
  position: relative;
}
.gx-no-header-horizontal-top {
  padding: 10px 20px;
  background-color: #d9f7be;
  color: #237804;
  border-radius: 4px;
  display: inline-block;
}
@media screen and (max-width: 575px) {
  .gx-no-header-horizontal-top {
    width: 100%;
    font-size: 12px;
  }
}
.gx-no-header-horizontal-top-center {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-no-header-horizontal .gx-linebar {
  position: absolute;
  left: 32px;
  top: 15px;
  z-index: 1;
}
@media screen and (max-width: 575px) {
  .gx-no-header-horizontal .gx-linebar {
    left: 15px;
  }
}
@media screen and (max-width: 575px) {
  .gx-no-header-horizontal {
    padding: 14px 15px 13px 60px;
  }
}
/* Sidebar Style */
.gx-app-sidebar {
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.ant-layout-sider {
  background-color: #fffffc;
  color: #545454;
  flex: 0 0 auto !important;
  max-width: none !important;
  min-width: 10px !important;
  width: 240px !important;
  overflow: hidden;
}
@media screen and (max-width: 1366px) {
  .ant-layout-sider {
    width: 200px !important;
  }
}
.ant-layout-sider-collapsed {
  width: 80px !important;
}
@media screen and (max-width: 991px) {
  .ant-layout-sider-collapsed.gx-mini-custom-sidebar {
    width: 0 !important;
    min-width: 0 !important;
  }
}
.ant-layout-sider.gx-collapsed-sidebar {
  width: 0 !important;
  min-width: 0 !important;
}
@media screen and (max-width: 991px) {
  .ant-layout-sider {
    width: 0 !important;
    min-width: 0 !important;
  }
}
.gx-layout-sider-dark {
  background-color: var(--app-primary-color);
  color: #ffffff;
}
.gx-layout-sider-header {
  padding: 10px 30px 10px 70px;
  height: 72px;
  -webkit-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media screen and (max-width: 575px) {
  .gx-layout-sider-header {
    height: 50px;
  }
}
.gx-layout-sider-header .gx-site-logo {
  display: block;
}
.ant-layout-sider-collapsed .gx-layout-sider-header .gx-site-logo {
  display: none;
}
.gx-mini-custom-sidebar .gx-layout-sider-header .gx-site-logo {
  display: block;
}
.gx-layout-sider-header .gx-linebar {
  position: absolute;
  left: 20px;
  z-index: 1;
  top: 15px;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.ant-layout-sider-collapsed .gx-layout-sider-header .gx-linebar {
  left: 20px;
}
@media screen and (max-width: 991px) {
  .gx-layout-sider-header .gx-linebar {
    display: none;
  }
}
.ant-layout-sider-collapsed .gx-layout-sider-header {
  padding-left: 20px;
  padding-right: 20px;
}
.gx-drawer-sidebar .gx-layout-sider-header {
  padding-left: 30px;
}
.gx-drawer-sidebar-dark .gx-layout-sider-header {
  background-color: rgba(0, 0, 0, 0.3);
}
.gx-layout-sider-dark .gx-layout-sider-header {
  background-color: rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.gx-mini-custom-sidebar .gx-layout-sider-header {
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  background-color: transparent;
}
.gx-custom-sidebar .gx-layout-sider-header {
  padding-left: 30px;
  background-color: transparent;
}
.gx-mini-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header,
.gx-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border-right: 1px solid #e8e8e8;
}
@media screen and (max-width: 991px) {
  .gx-layout-sider-header {
    padding-left: 30px;
  }
}
.gx-sidebar-content {
  border-right: 1px solid #e8e8e8;
}
.gx-layout-sider-dark .gx-sidebar-content,
.gx-drawer-sidebar-dark .gx-sidebar-content {
  border-right: 0 none;
}
.gx-layout-sider-scrollbar {
  height: calc(100vh - 72px - 145px) !important;
}
.framed-layout .gx-layout-sider-scrollbar {
  height: calc(100vh - 72px - 2 * 20px - 145px) !important;
}
@media screen and (max-width: 991px) {
  .framed-layout .gx-layout-sider-scrollbar {
    height: calc(100vh - 72px) !important;
  }
}
.ant-layout-sider-collapsed .gx-layout-sider-scrollbar {
  height: calc(100vh - 72px - 91px) !important;
}
.framed-layout .ant-layout-sider-collapsed .gx-layout-sider-scrollbar {
  height: calc(100vh - 72px - 2 * 20px - 91px) !important;
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-layout-sider-collapsed .gx-layout-sider-scrollbar {
    height: calc(100vh - 72px) !important;
  }
}
@media screen and (max-width: 991px) {
  .ant-layout-sider-collapsed .gx-layout-sider-scrollbar {
    height: calc(100vh - 72px) !important;
  }
}
@media screen and (max-width: 575px) {
  .ant-layout-sider-collapsed .gx-layout-sider-scrollbar {
    height: calc(100vh - 50px) !important;
  }
}
.gx-mini-custom-sidebar .gx-layout-sider-scrollbar {
  height: calc(100vh - 72px - 206px) !important;
}
.framed-layout .gx-mini-custom-sidebar .gx-layout-sider-scrollbar {
  height: calc(100vh - 72px - 2 * 20px - 206px) !important;
}
@media screen and (max-width: 991px) {
  .framed-layout .gx-mini-custom-sidebar .gx-layout-sider-scrollbar {
    height: calc(100vh - 72px) !important;
  }
}
@media screen and (max-width: 991px) {
  .gx-layout-sider-scrollbar {
    height: calc(100vh - 72px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-layout-sider-scrollbar {
    height: calc(100vh - 50px) !important;
  }
}
@media screen and (max-width: 991px) {
  .gx-no-header-notifications + .gx-layout-sider-scrollbar {
    height: calc(100vh - 72px - 145px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-no-header-notifications + .gx-layout-sider-scrollbar {
    height: calc(100vh - 50px - 145px) !important;
  }
}
.gx-sidebar-notifications {
  padding: 30px 10px 10px;
  margin: 0 20px 10px;
  border-bottom: solid 1px #e8e8e8;
}
.ant-layout-sider-dark .gx-sidebar-notifications,
.gx-drawer-sidebar-dark .gx-sidebar-notifications {
  border-bottom-color: #ffffff;
}
@media screen and (max-width: 991px) {
  .gx-sidebar-notifications {
    display: none;
  }
}
@media screen and (max-width: 991px) {
  .gx-sidebar-notifications.gx-no-header-notifications {
    display: block;
  }
}
.gx-app-nav {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin: 0 -20px;
  color: var(--app-primary-color);
}
.ant-layout-sider-dark .gx-app-nav,
.gx-drawer-sidebar-dark .gx-app-nav {
  color: #ffffff;
}
.gx-app-nav li {
  padding: 0 20px;
  font-size: 20px;
}
.gx-app-nav li .icon {
  cursor: pointer;
}
.ant-layout-sider-collapsed .gx-app-nav {
  display: none;
}
.gx-mini-custom-sidebar .gx-app-nav {
  display: block;
  margin-top: 15px;
}
.gx-mini-custom-sidebar .gx-app-nav li:not(:last-child) {
  margin-bottom: 5px;
}
.gx-avatar-name {
  cursor: pointer;
}
.ant-layout-sider-collapsed .gx-avatar-name {
  display: none;
}
.ant-layout-sider-collapsed .gx-avatar-row {
  margin-bottom: 0 !important;
}
.gx-avatar-row .ant-avatar {
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  position: relative;
  left: 0;
}
.ant-layout-sider-collapsed .gx-avatar-row .ant-avatar {
  margin: 0 !important;
  left: -10px;
}
.gx-menu-group .ant-menu-item-group-title {
  font-size: 16px;
  padding-top: 30px !important;
}
.gx-layouts-view .gx-pointer {
  display: block;
  margin-bottom: 15px;
}
.gx-layouts-view .gx-pointer img {
  width: 100%;
}
.gx-layouts-view .gx-pointer.active {
  box-shadow: 0 0 10px 0 var(--app-primary-color);
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
}
/* Ant Menu Style */
.ant-menu {
  color: #545454;
  background: #fff;
}
.ant-menu-horizontal {
  background: none;
}
.ant-menu-item-group-title {
  color: #545454;
  font-size: 11px;
  line-height: 1.3;
  padding: 10px 30px;
}
.ant-menu-submenu-popup .ant-menu-item-group-title {
  padding-left: 20px;
}
.ant-layout-sider .ant-menu-item-group-title {
  padding-top: 40px;
}
.ant-menu-item:active,
.ant-menu-submenu-title:active {
  background: #908b94;
}
.ant-menu-item .icon {
  min-width: 14px;
  margin-right: 20px;
  display: inline-block;
  vertical-align: middle;
}
.ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-item .icon[class*=" icon-"]::before {
  position: relative;
  top: 2px;
}
.ant-menu-sub .ant-menu-item .icon {
  font-size: 12px;
}
.ant-menu-item > a {
  color: #545454;
}
.ant-menu-item > a:hover {
  color: var(--app-primary-color);
}
.ant-menu-item-divider {
  background-color: #e8e8e8;
}
.ant-menu-submenu-inline {
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.ant-menu-item:hover,
.ant-menu-item-active,
.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-submenu-active,
.ant-menu-submenu-title:hover {
  color: var(--app-primary-color);
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {
  background-color: transparent;
}
.ant-menu-item-selected {
  color: var(--app-primary-color);
}
.ant-menu-item-selected > a {
  color: #545454;
}
.ant-menu-item-selected > a:hover {
  color: var(--app-primary-color);
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #908b94;
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: 1px solid #e8e8e8;
}
.ant-layout-sider .ant-menu-inline,
.ant-layout-sider .ant-menu-vertical,
.ant-layout-sider .ant-menu-vertical-left,
.gx-drawer-sidebar .ant-menu-inline,
.gx-drawer-sidebar .ant-menu-vertical,
.gx-drawer-sidebar .ant-menu-vertical-left {
  border-right: 0 none;
}
.ant-menu-vertical-right {
  border-left: 1px solid #e8e8e8;
}
.ant-menu-item,
.ant-menu-submenu-title {
  padding: 0 20px;
}
.gx-inside-header-horizontal .ant-menu-item,
.gx-inside-header-horizontal .ant-menu-submenu-title {
  padding: 0 10px;
}
@media screen and (max-width: 1199px) {
  .gx-inside-header-horizontal .ant-menu-item,
  .gx-inside-header-horizontal .ant-menu-submenu-title {
    padding: 0 6px;
  }
}
.ant-menu-item .anticon,
.ant-menu-submenu-title .anticon {
  margin-right: 20px;
}
.gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,
.gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {
  padding: 0;
}
@media screen and (max-width: 1199px) {
  .gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,
  .gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {
    padding: 0;
  }
}
.gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item .ant-menu-submenu-title,
.gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu .ant-menu-submenu-title {
  padding: 0 10px;
}
@media screen and (max-width: 1199px) {
  .gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item .ant-menu-submenu-title,
  .gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu .ant-menu-submenu-title {
    padding: 0 6px;
  }
}
.ant-menu > .ant-menu-item-divider {
  background-color: #e8e8e8;
}
.ant-menu-sub > li > a {
  position: relative;
}
.ant-menu-submenu > .ant-menu {
  background-color: #fff;
  border-radius: 0;
}
.ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {
  padding-left: 54px !important;
}
.ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item,
.ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {
  padding-left: 80px !important;
}
.ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item,
.ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item {
  padding-left: 106px !important;
}
.ant-menu-submenu-popup {
  border-radius: 0;
  z-index: 1050 !important;
}
.ant-menu-submenu-popup .ant-menu-sub.ant-menu .ant-menu-item {
  padding-left: 20px !important;
}
.ant-menu-submenu-vertical .ant-menu-item:not(:last-child),
.ant-menu-submenu-vertical-left .ant-menu-item:not(:last-child),
.ant-menu-submenu-vertical-right .ant-menu-item:not(:last-child),
.ant-menu-submenu-inline .ant-menu-item:not(:last-child) {
  margin-bottom: 0;
}
.gx-app-sidebar .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  left: 22px;
  right: auto;
}
.ant-drawer .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  left: 22px;
  right: auto;
}
.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow:after {
  background-image: linear-gradient(to right, #545454, #545454);
}
.gx-app-sidebar .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {
  left: 60px;
}
.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,
.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,
.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,
.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before {
  background: linear-gradient(to right, var(--app-primary-color), var(--app-primary-color));
}
.ant-menu-vertical .ant-menu-submenu-selected,
.ant-menu-vertical-left .ant-menu-submenu-selected,
.ant-menu-vertical-right .ant-menu-submenu-selected {
  color: var(--app-primary-color);
}
.ant-menu-vertical .ant-menu-submenu-selected > a,
.ant-menu-vertical-left .ant-menu-submenu-selected > a,
.ant-menu-vertical-right .ant-menu-submenu-selected > a {
  color: var(--app-primary-color);
}
.ant-menu-horizontal {
  border-bottom: 1px solid #e8e8e8;
  line-height: 46px;
  padding: 0;
}
.ant-layout-header .ant-menu-horizontal {
  border-bottom: 0 none;
  line-height: 70px;
}
.ant-menu-horizontal > .ant-menu-item,
.ant-menu-horizontal > .ant-menu-submenu {
  border-bottom: 2px solid transparent;
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-submenu:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu-active,
.ant-menu-horizontal > .ant-menu-item-open,
.ant-menu-horizontal > .ant-menu-submenu-open,
.ant-menu-horizontal > .ant-menu-item-selected,
.ant-menu-horizontal > .ant-menu-submenu-selected {
  border-bottom: 2px solid var(--app-primary-color);
  color: var(--app-primary-color);
}
.ant-menu-horizontal > .ant-menu-item > a,
.ant-menu-horizontal > .ant-menu-submenu > a {
  color: #545454;
}
.ant-menu-horizontal > .ant-menu-item > a:hover,
.ant-menu-horizontal > .ant-menu-submenu > a:hover {
  color: var(--app-primary-color);
}
.ant-menu-horizontal > .ant-menu-item > a:before,
.ant-menu-horizontal > .ant-menu-submenu > a:before {
  bottom: -2px;
}
.ant-menu-vertical .ant-menu-item:not(:last-child),
.ant-menu-vertical-left .ant-menu-item:not(:last-child),
.ant-menu-vertical-right .ant-menu-item:not(:last-child),
.ant-menu-inline .ant-menu-item:not(:last-child) {
  margin-bottom: 0;
}
.ant-menu-vertical .ant-menu-item:after,
.ant-menu-vertical-left .ant-menu-item:after,
.ant-menu-vertical-right .ant-menu-item:after,
.ant-menu-inline .ant-menu-item:after {
  border-right: 3px solid var(--app-primary-color);
}
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-submenu-title,
.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu-title {
  padding: 0 30px 0 20px !important;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0;
  text-overflow: inherit;
}
.ant-layout-sider .ant-menu-vertical .ant-menu-item,
.ant-layout-sider .ant-menu-vertical-left .ant-menu-item,
.ant-layout-sider .ant-menu-vertical-right .ant-menu-item,
.ant-layout-sider .ant-menu-inline .ant-menu-item,
.ant-layout-sider .ant-menu-vertical .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-vertical-left .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-vertical-right .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-inline .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical .ant-menu-item,
.ant-drawer .ant-menu-vertical-left .ant-menu-item,
.ant-drawer .ant-menu-vertical-right .ant-menu-item,
.ant-drawer .ant-menu-inline .ant-menu-item,
.ant-drawer .ant-menu-vertical .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical-left .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical-right .ant-menu-submenu-title,
.ant-drawer .ant-menu-inline .ant-menu-submenu-title {
  padding-left: 40px !important;
}
.ant-menu-vertical .ant-menu-item .icon,
.ant-menu-vertical-left .ant-menu-item .icon,
.ant-menu-vertical-right .ant-menu-item .icon,
.ant-menu-inline .ant-menu-item .icon,
.ant-menu-vertical .ant-menu-submenu-title .icon,
.ant-menu-vertical-left .ant-menu-submenu-title .icon,
.ant-menu-vertical-right .ant-menu-submenu-title .icon,
.ant-menu-inline .ant-menu-submenu-title .icon {
  min-width: 14px;
  margin-right: 20px;
}
.ant-menu-vertical .ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-vertical-left .ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-vertical-right .ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-inline .ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-vertical .ant-menu-submenu-title .icon[class^="icon-"]::before,
.ant-menu-vertical-left .ant-menu-submenu-title .icon[class^="icon-"]::before,
.ant-menu-vertical-right .ant-menu-submenu-title .icon[class^="icon-"]::before,
.ant-menu-inline .ant-menu-submenu-title .icon[class^="icon-"]::before,
.ant-menu-vertical .ant-menu-item .icon[class*=" icon-"]::before,
.ant-menu-vertical-left .ant-menu-item .icon[class*=" icon-"]::before,
.ant-menu-vertical-right .ant-menu-item .icon[class*=" icon-"]::before,
.ant-menu-inline .ant-menu-item .icon[class*=" icon-"]::before,
.ant-menu-vertical .ant-menu-submenu-title .icon[class*=" icon-"]::before,
.ant-menu-vertical-left .ant-menu-submenu-title .icon[class*=" icon-"]::before,
.ant-menu-vertical-right .ant-menu-submenu-title .icon[class*=" icon-"]::before,
.ant-menu-inline .ant-menu-submenu-title .icon[class*=" icon-"]::before {
  position: relative;
  top: 2px;
}
.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item .icon + span,
.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item .icon + span,
.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item .icon + span,
.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item .icon + span,
.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title .icon + span,
.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title .icon + span,
.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title .icon + span,
.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title .icon + span {
  max-width: 0;
  display: inline-block;
  opacity: 0;
}
.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {
  display: none;
}
.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item,
.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item,
.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item,
.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item,
.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title,
.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title,
.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title,
.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title {
  padding: 0 calc((80px - 20px) / 2) !important;
}
.ant-card .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,
.ant-card .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,
.ant-card .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,
.ant-card .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {
  padding-left: 54px !important;
}
.ant-layout-sider .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,
.ant-drawer .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {
  padding-left: 80px !important;
}
.ant-menu-inline .ant-menu-submenu-title {
  padding-right: 30px !important;
}
.ant-menu-inline-collapsed {
  width: 80px;
}
.ant-menu-inline-collapsed > .ant-menu-item,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  left: 0;
  padding: 0 64px / 2 !important;
}
.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  display: none;
}
.ant-menu-inline-collapsed > .ant-menu-item .icon + span,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .icon + span,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .icon + span {
  max-width: 0;
  display: inline-block;
  opacity: 0;
}
.ant-menu-inline-collapsed-tooltip .icon {
  display: none;
}
.ant-menu-inline-collapsed-tooltip a {
  color: rgba(255, 255, 255, 0.85);
}
.ant-menu-inline-collapsed .ant-menu-item-group-title {
  padding-left: 4px;
  padding-right: 4px;
  display: none;
}
.ant-menu-item-group-list .ant-menu-item,
.ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 16px 0 28px;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item,
.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  line-height: 42px;
  height: 42px;
}
.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding: 0 30px 0 80px;
  line-height: 42px;
  height: 42px;
  text-transform: uppercase;
}
.ant-menu-item-disabled,
.ant-menu-submenu-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}
.ant-menu-item-disabled > a,
.ant-menu-submenu-disabled > a {
  color: rgba(0, 0, 0, 0.25) !important;
}
.ant-menu-item-disabled > .ant-menu-submenu-title,
.ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(0, 0, 0, 0.25) !important;
}
.ant-menu-submenu-selected .ant-menu-submenu-title {
  color: var(--app-primary-color);
}
.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow:before {
  background: linear-gradient(to right, var(--app-primary-color), var(--app-primary-color));
}
.ant-menu-dark,
.ant-menu-dark .ant-menu-sub {
  color: #ffffff;
  background: var(--app-primary-color);
}
.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:before {
  background: #ffffff;
}
.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  background: none;
  box-shadow: none;
}
.ant-menu-dark.ant-menu-horizontal {
  border-bottom-color: var(--app-primary-color);
}
.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,
.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {
  border-color: var(--app-primary-color);
}
.ant-menu-dark .ant-menu-item .icon {
  min-width: 14px;
  margin-right: 20px;
}
.ant-menu-dark .ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-dark .ant-menu-item .icon[class*=" icon-"]::before {
  position: relative;
  top: 2px;
}
.ant-menu-dark .ant-menu-item-group-title {
  color: #ffffff;
}
.ant-menu-dark .ant-menu-item {
  color: #ffffff;
}
.ant-menu-dark .ant-menu-item > a {
  color: #ffffff;
}
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a {
  color: #ffffff;
}
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-item-selected > a {
  color: var(--app-secondary-color);
}
.ant-menu-dark .ant-menu-item:hover,
.ant-menu-dark .ant-menu-item-active,
.ant-menu-dark .ant-menu-submenu-active,
.ant-menu-dark .ant-menu-submenu-selected,
.ant-menu-dark .ant-menu-submenu-title:hover,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover {
  color: var(--app-secondary-color);
}
.ant-menu-dark .ant-menu-item:hover > a,
.ant-menu-dark .ant-menu-item-active > a,
.ant-menu-dark .ant-menu-submenu-active > a,
.ant-menu-dark .ant-menu-submenu-selected > a,
.ant-menu-dark .ant-menu-submenu-title:hover > a,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > a {
  color: var(--app-secondary-color);
}
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  background: #ffffff;
}
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before {
  background: var(--app-secondary-color);
}
.ant-menu-dark .ant-menu-submenu-open {
  color: #ffffff;
}
.ant-menu-dark.ant-menu-inline-collapsed .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open .ant-menu-submenu-title span,
.ant-menu-dark.ant-menu-inline-collapsed .ant-menu-submenu-active .ant-menu-submenu-title span {
  color: #ffffff;
}
.ant-menu-dark .ant-menu-item-selected {
  color: var(--app-secondary-color);
}
.ant-menu-dark .ant-menu-item-selected > a,
.ant-menu-dark .ant-menu-item-selected > a:hover {
  color: var(--app-secondary-color);
}
.ant-menu-dark .ant-menu-item-selected span {
  color: inherit;
}
.ant-menu.ant-menu-dark .ant-menu-item-selected,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  background-color: transparent;
}
.ant-menu-dark .ant-menu-item-disabled,
.ant-menu-dark .ant-menu-submenu-disabled,
.ant-menu-dark .ant-menu-item-disabled > a,
.ant-menu-dark .ant-menu-submenu-disabled > a {
  color: rgba(255, 255, 255, 0.35) !important;
}
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(255, 255, 255, 0.35) !important;
}
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-title {
  color: #ffffff;
}
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-open .ant-menu-submenu-title,
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title,
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-submenu-title {
  color: #ffffff;
}
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-open .ant-menu-submenu-title:hover,
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title:hover,
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-submenu-title:hover {
  color: var(--app-secondary-color);
}
.ant-menu-submenu-horizontal > .ant-menu-submenu-title {
  color: #262626;
}
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  background: #ffffff;
}
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-vertical:hover > .ant-menu-submenu-title {
  color: #ffffff;
}
.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-submenu-title .icon,
.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-submenu-title .icon,
.ant-layout-sider .ant-menu .ant-menu-item .icon,
.ant-drawer .ant-menu .ant-menu-item .icon {
  font-size: 20px;
}
.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,
.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,
.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-item .icon,
.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-item .icon {
  font-size: 14px;
  margin-right: 12px;
}
.ant-layout-sider .ant-menu .ant-menu-submenu-title span,
.ant-drawer .ant-menu .ant-menu-submenu-title span {
  display: flex;
}
.ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  background-image: linear-gradient(to right, var(--app-primary-color), var(--app-primary-color));
}
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before {
  background: #ffffff;
}
.gx-navbar-nav {
  list-style: none;
  padding-left: 0;
  margin: 0 -5px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-navbar-nav li {
  padding: 0 5px;
}
.gx-navbar-nav li a {
  display: block;
  padding: 4px 10px;
  background-color: var(--app-primary-color);
  color: #ffffff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.gx-profile-banner .gx-navbar-nav li a {
  background-color: transparent;
  color: #ffffff;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  padding: 0;
}
.gx-navbar-nav li a * {
  color: #bfbfbf;
}
.gx-navbar-nav li a:hover,
.gx-navbar-nav li a:focus {
  color: #ffffff;
}
.gx-profile-banner .gx-navbar-nav li a:hover,
.gx-profile-banner .gx-navbar-nav li a:focus {
  background-color: transparent;
  color: var(--app-secondary-color);
}
.gx-profile-banner .gx-navbar-nav li {
  padding: 0 15px;
}
@media screen and (max-width: 575px) {
  .gx-profile-banner .gx-navbar-nav li {
    padding: 0 6px;
  }
}
.gx-profile-banner .gx-navbar-nav {
  margin: 0 -15px;
}
@media screen and (max-width: 575px) {
  .gx-profile-banner .gx-navbar-nav {
    -webkit-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
    margin: 0 -6px;
  }
}
.gx-menu-horizontal {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.gx-menu-horizontal:before {
  display: none;
}
.gx-header-horizontal-nav .ant-menu-horizontal {
  border-bottom: 0 none;
}
.gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title {
  color: #ffffff;
}
.gx-below-header-horizontal .gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title,
.gx-above-header-horizontal .gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title {
  color: #7a7a7a;
}
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item:hover,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu:hover,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-active,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-active,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-open,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-open,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-selected,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-selected {
  border-bottom-color: var(--app-secondary-color);
  color: var(--app-secondary-color);
}
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title {
  color: var(--app-secondary-color);
}
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item:hover::after,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu:hover::after,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-active::after,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-active::after,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-open::after,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-open::after,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-selected::after,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-selected::after {
  border-bottom-color: transparent;
}
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu {
  border-bottom: 0 none;
  margin-top: 0;
  top: 0;
}
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected {
  position: relative;
  border-bottom: 0 none;
}
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title {
  position: relative;
}
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {
  content: "\\e049";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  text-align: center;
  font-family: "gaxon" !important;
  font-size: 31px;
  line-height: 5px;
}
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {
  color: var(--app-primary-color);
}
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover::after,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover::after,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active::after,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active::after,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open::after,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open::after,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected::after,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected::after {
  border-bottom-color: transparent;
}
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {
  color: var(--app-secondary-color);
}
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {
  color: #ffffff;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  margin-top: -7px;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu .ant-menu-item:first-child {
  -webkit-border-radius: 10px 10px 0 0;
  -moz-border-radius: 10px 10px 0 0;
  border-radius: 10px 10px 0 0;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu .ant-menu-item:last-child {
  -webkit-border-radius: 0 0 10px 10px;
  -moz-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu > .ant-menu {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: var(--app-secondary-color);
  color: var(--app-primary-color);
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a {
  color: var(--app-primary-color);
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title {
  color: var(--app-secondary-color);
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  background-image: linear-gradient(to right, var(--app-secondary-color), var(--app-secondary-color));
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  background-image: linear-gradient(to right, var(--app-secondary-color), var(--app-secondary-color));
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item > a:hover,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item:hover,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item-active,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-active,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-title:hover {
  color: var(--app-secondary-color);
}
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-inside-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-below-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-above-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: transparent;
  color: var(--app-secondary-color);
}
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-inside-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a,
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-below-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a,
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-above-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a {
  color: var(--app-secondary-color);
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed {
  padding-bottom: 10px;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  padding: 0 30px !important;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item > span,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item > span,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title > span {
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item > a,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item > a {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item.ant-menu-item-selected > a,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item.ant-menu-item-selected > a {
  color: var(--app-primary-color);
  background-color: var(--app-secondary-color);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu.ant-menu-submenu-selected > .ant-menu-submenu-title > span {
  color: var(--app-primary-color);
  background-color: var(--app-secondary-color);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}
.gx-mini-custom-sidebar .ant-menu-vertical .ant-menu-item .icon,
.gx-mini-custom-sidebar .ant-menu-vertical-left .ant-menu-item .icon,
.gx-mini-custom-sidebar .ant-menu-vertical-right .ant-menu-item .icon,
.gx-mini-custom-sidebar .ant-menu-inline .ant-menu-item .icon,
.gx-mini-custom-sidebar .ant-menu-vertical .ant-menu-submenu-title .icon,
.gx-mini-custom-sidebar .ant-menu-vertical-left .ant-menu-submenu-title .icon,
.gx-mini-custom-sidebar .ant-menu-vertical-right .ant-menu-submenu-title .icon,
.gx-mini-custom-sidebar .ant-menu-inline .ant-menu-submenu-title .icon {
  margin-right: 0;
}
.gx-no-header-submenu-popup .ant-menu-sub {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: transparent;
}
/* Footer Style */
.ant-layout-footer {
  border-top: solid 1px #e8e8e8;
}
@media screen and (max-width: 575px) {
  .ant-layout-footer {
    padding: 14px 15px;
  }
}
.gx-container-wrap .ant-layout-footer {
  padding-left: 0;
  padding-right: 0;
}
.gx-container-wrap .gx-layout-footer-content {
  width: 94vw;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
}
@media screen and (min-width: 768px) {
  .gx-container-wrap .gx-layout-footer-content {
    width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .gx-container-wrap .gx-layout-footer-content {
    width: 920px;
  }
}
@media screen and (min-width: 1200px) {
  .gx-container-wrap .gx-layout-footer-content {
    width: 1100px;
  }
}
@media screen and (min-width: 1367px) {
  .gx-container-wrap .gx-layout-footer-content {
    width: 1200px;
  }
}
@media screen and (min-width: 1600px) {
  .gx-container-wrap .gx-layout-footer-content {
    width: 1400px;
  }
}
/* Customizer Style */
.gx-customizer {
  height: calc(100vh - 30px) !important;
}
.gx-customizer-item:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.gx-customizer-item .ant-radio-group .ant-radio-button {
  display: none;
}
.gx-customizer-option {
  position: absolute;
  right: 0;
  top: 150px;
  z-index: 99;
}
.full-scroll .gx-customizer-option {
  position: fixed;
}
.full-scroll.boxed-layout .gx-customizer-option {
  position: absolute;
}
.full-scroll.framed-layout .gx-customizer-option {
  right: 20px;
}
@media screen and (max-width: 991px) {
  .full-scroll.framed-layout .gx-customizer-option {
    right: 0;
  }
}
.horizontal-layout.full-scroll .gx-customizer-option {
  top: 200px;
}
@media screen and (max-width: 575px) {
  .gx-customizer {
    width: 250px !important;
  }
  .gx-customizer .ant-radio-button-wrapper {
    padding: 0 10px;
  }
}
.gx-customizer .gx-list-inline {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.framed-layout .gx-customizer {
  height: calc(100vh - 30px - 2 * 20px) !important;
}
@media screen and (max-width: 991px) {
  .framed-layout .gx-customizer {
    height: calc(100vh - 30px) !important;
  }
}
.gx-color-option {
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
}
.gx-color-option li {
  font-size: 36px;
  line-height: 1;
}
.gx-color-option li .gx-link {
  width: 40px;
  height: 40px;
  display: block;
  position: relative;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  overflow: hidden;
}
.gx-color-option li .gx-link:before {
  font-family: "gaxon";
  font-size: 20px;
  content: "\\30";
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  display: none;
}
.gx-color-option li .gx-link.active:before {
  display: block;
}
.gx-color-option li .gx-link:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 20px;
  height: 40px;
  background-color: #9283D4;
}
.gx-color-option li .gx-link.gx-color-red:after {
  background-color: #FF2B7A;
}
.gx-color-option li .gx-link.gx-color-blue:after {
  background-color: #3DA4E6;
}
.gx-color-option li .gx-link.gx-color-dark-blue:after {
  background-color: #0469B9;
}
.gx-color-option li .gx-link.gx-color-orange:after {
  background-color: #F18805;
}
.gx-color-option li .gx-link.gx-color-light-blue:after {
  background-color: #6A95FF;
}
.gx-color-option li .gx-link.gx-color-deep-orange:after {
  background-color: #F87060;
}
.gx-color-option li .gx-link.gx-color-light-purple1:after {
  background-color: #A172E7;
}
.gx-color-option li .gx-link.gx-color-light-purple2:after {
  background-color: #956FE7;
}
.gx-cus-customiz {
  padding-right: 20px;
}
.gx-layout-option li,
.gx-nav-option li {
  margin-bottom: 10px;
}
.gx-layout-option li span,
.gx-nav-option li span {
  position: relative;
  display: block;
}
.gx-layout-option li span:before,
.gx-nav-option li span:before {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  font-family: "gaxon" !important;
  content: "\\30";
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  display: none;
  width: 20px;
  font-size: 12px;
  height: 20px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: var(--app-primary-color);
  text-align: center;
  padding: 2px;
  color: #ffffff;
}
.gx-layout-option li span.active:before,
.gx-nav-option li span.active:before {
  display: block;
}
/* Drawer Style */
.ant-drawer {
  overflow: hidden;
}
.ant-drawer-body {
  padding: 0;
}
.gx-drawer-sidebar-dark .ant-drawer-content {
  background-color: var(--app-primary-color);
  color: #ffffff;
}
.ant-drawer-content-wrapper {
  width: 240px !important;
}
@media screen and (max-width: 991px) {
  .ant-drawer-content-wrapper {
    width: 220px !important;
  }
}
.framed-layout .ant-drawer-content-wrapper {
  top: 20px;
  bottom: 20px;
  height: calc(100vh - 2 * 20px);
  -webkit-border-radius: 11px 0 0 11px;
  -moz-border-radius: 11px 0 0 11px;
  border-radius: 11px 0 0 11px;
  overflow: hidden;
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-drawer-content-wrapper {
    top: 0;
    bottom: 0;
    height: 100vh;
    -webkit-border-radius: 0 !important;
    -moz-border-radius: 0 !important;
    border-radius: 0 !important;
  }
}
.ant-drawer-right .ant-drawer-content-wrapper {
  width: 370px !important;
  padding: 15px;
  background: #ffffff;
}
@media screen and (max-width: 991px) {
  .ant-drawer-right .ant-drawer-content-wrapper {
    width: 300px !important;
  }
}
@media screen and (max-width: 575px) {
  .ant-drawer-right .ant-drawer-content-wrapper {
    width: 280px !important;
  }
}
.framed-layout .ant-drawer-right .ant-drawer-content-wrapper {
  top: 20px;
  bottom: 20px;
  height: calc(100vh - 2 * 20px);
  -webkit-border-radius: 0 11px 11px 0;
  -moz-border-radius: 0 11px 11px 0;
  border-radius: 0 11px 11px 0;
  overflow: hidden;
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-drawer-right .ant-drawer-content-wrapper {
    top: 0;
    bottom: 0;
    height: 100vh;
    -webkit-border-radius: 0 !important;
    -moz-border-radius: 0 !important;
    border-radius: 0 !important;
  }
}
.framed-layout .ant-drawer-content-wrapper,
.boxed-layout .ant-drawer-content-wrapper {
  position: absolute;
}
.boxed-layout .ant-drawer {
  max-width: 1280px;
  margin: 0 auto;
}
@media screen and (min-width: 1600px) {
  .boxed-layout .ant-drawer {
    max-width: 1500px;
  }
}
.framed-layout .ant-drawer-open.ant-drawer-left,
.framed-layout .ant-drawer-open.ant-drawer-right,
.boxed-layout .ant-drawer-open.ant-drawer-left,
.boxed-layout .ant-drawer-open.ant-drawer-right {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.framed-layout .ant-drawer-open {
  width: calc(100% - 2 * 20px);
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-drawer-open {
    width: 100%;
  }
}
@media screen and (min-width: 1600px) {
  .boxed-layout .ant-drawer.ant-drawer-left,
  .boxed-layout .ant-drawer.ant-drawer-right {
    position: absolute;
  }
}
@media screen and (min-width: 991px) {
  .framed-layout .ant-drawer.ant-drawer-left,
  .framed-layout .ant-drawer.ant-drawer-right {
    position: absolute;
  }
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-drawer.ant-drawer-left,
  .framed-layout .ant-drawer.ant-drawer-right {
    right: 20px;
    left: 20px;
    margin: 0;
  }
}
.ant-drawer-close {
  top: -11px;
}
.ant-drawer-close-x {
  width: 35px;
  height: 35px;
  line-height: 35px;
}
.ant-drawer-mask {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
}
/*Alert Styles*/
.ant-alert {
  margin-bottom: 16px;
}
.gx-custom-sweet-alert h2,
.gx-custom-sweet-alert .text-muted {
  color: #ffffff !important;
}
.notification {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.notification .title {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
}
.gx-sweet-alert-top-space {
  padding-top: 40px !important;
}
.sweet-alert h2 {
  font-size: 20px !important;
  font-weight: 400 !important;
}
/*Avatar Styles*/
.gx-avatar-img {
  height: 50px;
  width: 50px;
  position: relative;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: solid 1px #e8e8e8;
}
.gx-avatar-img-lg {
  height: 100px;
  width: 100px;
}
.ant-avatar {
  position: relative;
}
.ant-avatar.gx-size-150 > * {
  line-height: 150px;
}
.ant-avatar.gx-size-120 > * {
  line-height: 120px;
}
.ant-avatar.gx-size-100 > * {
  line-height: 100px;
}
.ant-avatar.gx-size-80 > * {
  line-height: 80px;
}
.ant-avatar.gx-size-60 > * {
  line-height: 60px;
}
.ant-avatar.gx-size-50 > * {
  line-height: 50px;
}
.ant-avatar.gx-size-40 > * {
  line-height: 40px;
}
.ant-avatar.gx-size-36 > * {
  line-height: 36px;
}
.ant-avatar.gx-size-30 > * {
  line-height: 30px;
}
.ant-avatar.gx-size-24 > * {
  line-height: 24px;
}
.ant-avatar.gx-size-20 > * {
  line-height: 20px;
}
.ant-avatar.gx-size-15 > * {
  line-height: 14px;
}
.gx-clients-list .ant-avatar {
  width: 70px;
  height: 70px;
}
@media (max-width: 1500px) {
  .gx-clients-list .ant-avatar {
    width: 60px;
    height: 60px;
  }
}
@media (max-width: 1366px) {
  .gx-clients-list .ant-avatar {
    width: 48px;
    height: 48px;
  }
}
@media (max-width: 1199px) {
  .gx-clients-list .ant-avatar {
    width: 60px;
    height: 60px;
  }
}
@media screen and (max-width: 400px) {
  .gx-clients-list .ant-avatar {
    width: 52px;
    height: 52px;
  }
}
.gx-avatar {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  overflow: hidden;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  height: 50px;
  width: 50px;
  position: relative;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: solid 1px #e8e8e8;
}
@media screen and (max-width: 991px) {
  .gx-user-nav .gx-avatar {
    height: 40px;
    width: 40px;
    line-height: 40px;
  }
}
@media screen and (max-width: 575px) {
  .gx-user-nav .gx-avatar {
    height: 30px;
    width: 30px;
    line-height: 30px;
  }
}
.gx-header-horizontal-main .gx-avatar {
  height: 40px;
  width: 40px;
  line-height: 40px;
}
@media screen and (max-width: 991px) {
  .gx-header-horizontal-main .gx-avatar {
    height: 30px;
    width: 30px;
    line-height: 30px;
  }
}
.gx-user-thumb {
  position: relative;
}
/*Badge Styles*/
.ant-badge {
  margin-bottom: 6px;
}
.ant-badge:not(:last-child) {
  margin-right: 12px;
}
.ant-tag {
  margin-bottom: 8px;
}
.gx-badge {
  display: inline-block;
  padding: 5px 8px 4px;
  font-size: 75%;
  margin-bottom: 6px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.gx-badge:not(:last-child) {
  margin-right: 12px;
}
.gx-chat-date .gx-badge {
  margin-bottom: 0;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 16px;
  padding: 2px;
}
.gx-user-thumb .gx-badge {
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 1;
  margin: 0;
  display: block;
  width: 16px;
  height: 16px;
  padding: 0;
  line-height: 16px;
}
.gx-badge-outline {
  background-color: transparent;
  border: solid 1px #e8e8e8;
}
.gx-badge-radius-sm .ant-badge-count {
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}
#components-back-top-demo-custom .ant-back-top {
  bottom: 100px;
}
#components-back-top-demo-custom .ant-back-top-inner {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 4px;
  background-color: #1088e9;
  color: #fff;
  text-align: center;
  font-size: 20px;
}
/*Button Styles*/
.ant-btn {
  line-height: 34px;
  display: inline-block;
  vertical-align: middle;
}
.ant-btn-group-sm .ant-btn {
  line-height: 24px;
}
.ant-btn-group-lg .ant-btn {
  line-height: 40px;
}
.ant-btn-sm {
  line-height: 24px;
  padding-top: 0;
  padding-bottom: 0;
}
.ant-btn-group > .ant-btn-sm {
  line-height: 24px;
}
.ant-btn-sm.ant-btn-icon-only {
  line-height: 1;
}
.ant-btn-lg {
  line-height: 40px;
  padding-top: 0;
  padding-bottom: 0;
}
.ant-btn-group > .ant-btn-lg {
  line-height: 40px;
}
.ant-btn-lg.ant-btn-icon-only {
  padding-top: 0;
  padding-bottom: 0;
}
.ant-btn-group-lg > .ant-btn,
.ant-btn-group-lg > span > .ant-btn {
  padding-top: 0;
  padding-bottom: 0;
}
.ant-btn:not(:last-child) {
  margin-right: 15px;
}
@media screen and (max-width: 575px) {
  .ant-btn:not(:last-child) {
    margin-right: 10px;
  }
}
.ant-btn-group .ant-btn:not(:last-child),
.ant-transfer-operation .ant-btn:not(:last-child) {
  margin-right: 0;
}
@media (max-width: 1599px) {
  .gx-product-footer .ant-btn:not(:last-child) {
    margin-right: 6px;
  }
}
.ant-input-group-addon .ant-btn {
  margin-right: 0;
}
@media screen and (max-width: 575px) {
  .ant-btn {
    margin-bottom: 10px;
  }
}
.ant-input-search .ant-btn {
  margin-bottom: 0;
}
.gx-customizer-option .ant-btn {
  padding: 0 18px;
  font-size: 18px;
  height: 42px;
  line-height: 42px;
  margin: 0;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);
  -webkit-border-radius: 30px 0 0 30px;
  -moz-border-radius: 30px 0 0 30px;
  border-radius: 30px 0 0 30px;
  background-color: #fa8c16;
  background: -webkit-gradient(linear, left top, right top, from(#fa8c16), to(#f5222d));
  background: -webkit-linear-gradient(left, #fa8c16, #f5222d);
  background: -moz-linear-gradient(left, #fa8c16, #f5222d);
  background: -ms-linear-gradient(left, #fa8c16, #f5222d);
  background: -o-linear-gradient(left, #fa8c16, #f5222d);
  border: 0 none;
  color: #ffffff;
}
.gx-customizer-option .ant-btn:hover,
.gx-customizer-option .ant-btn:focus {
  background-color: #f5222d;
  background: -webkit-gradient(linear, left top, right top, from(#f5222d), to(#fa8c16));
  background: -webkit-linear-gradient(left, #f5222d, #fa8c16);
  background: -moz-linear-gradient(left, #f5222d, #fa8c16);
  background: -ms-linear-gradient(left, #f5222d, #fa8c16);
  background: -o-linear-gradient(left, #f5222d, #fa8c16);
}
.gx-customizer-option .ant-btn .icon:before {
  display: block;
}
.horizontal-layout.full-scroll .gx-customizer-option .ant-btn {
  margin-right: 0;
}
.gx-module-add-task .ant-btn {
  height: 36px;
}
.gx-module-add-task .ant-btn .icon:before {
  position: relative;
  top: 2px;
}
.ant-modal-footer .ant-btn,
.ant-modal-confirm-btns .ant-btn {
  margin-bottom: 0;
}
.gx-login-content .ant-btn {
  padding: 9px 20px !important;
  height: auto;
  line-height: 1;
}
.boxed-layout .ant-btn-group .ant-btn {
  padding: 0 12px;
}
@media (max-width: 1366px) {
  .ant-btn-group .ant-btn {
    padding: 0 12px;
  }
}
@media (max-width: 1366px) {
  .gx-product-footer .ant-btn {
    padding: 0 10px;
    height: 32px;
    font-size: 12px;
    line-height: 32px;
  }
}
.ant-btn-background-ghost.ant-btn-primary {
  border-color: var(--app-primary-color) !important;
  color: var(--app-primary-color) !important;
}
.ant-btn-background-ghost.ant-btn-primary:hover,
.ant-btn-background-ghost.ant-btn-primary:focus {
  background-color: var(--app-primary-color) !important;
  border-color: var(--app-primary-color) !important;
  color: #ffffff !important;
}
.ant-btn-group:not(:last-child) {
  margin-right: 15px;
}
@media screen and (max-width: 575px) {
  .ant-btn-group:not(:last-child) {
    margin-right: 10px;
  }
}
.ant-radio-group .ant-radio-button-wrapper {
  margin-bottom: 6px;
}
button {
  outline: none;
}
.ant-confirm .ant-confirm-btns button + button {
  margin-bottom: 8px;
}
.ant-modal.ant-confirm .ant-confirm-btns button + button,
.ant-modal.ant-confirm .ant-btn {
  margin-bottom: 0;
}
.gx-btn,
.btn {
  display: inline-block;
  font-weight: 400;
  color: #545454;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: solid 1px #d9d9d9;
  padding: 0 15px;
  height: 36px;
  font-size: 14px;
  line-height: 34px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 15px;
}
.gx-btn:not(:last-child),
.btn:not(:last-child) {
  margin-right: 15px;
}
@media screen and (max-width: 575px) {
  .gx-btn:not(:last-child),
  .btn:not(:last-child) {
    margin-right: 10px;
  }
}
@media screen and (max-width: 575px) {
  .gx-btn,
  .btn {
    margin-bottom: 10px;
  }
}
.gx-btn:focus,
.btn:focus,
.gx-btn:hover,
.btn:hover {
  text-decoration: none;
}
.gx-btn:focus,
.btn:focus,
.gx-btn.focus,
.btn.focus {
  outline: 0;
}
.gx-btn.disabled,
.btn.disabled,
.gx-btn:disabled,
.btn:disabled {
  opacity: 0.65;
}
.gx-btn:not([disabled]):not(.disabled),
.btn:not([disabled]):not(.disabled) {
  cursor: pointer;
}
.gx-btn-list .gx-btn,
.gx-btn-list .btn {
  margin-bottom: 6px;
}
.gx-sub-popover .gx-btn,
.gx-sub-popover .btn {
  border: 0 none;
  margin-bottom: 5px;
}
.gx-sub-popover .gx-btn:focus,
.gx-sub-popover .btn:focus,
.gx-sub-popover .gx-btn:hover,
.gx-sub-popover .btn:hover {
  background-color: #f5f5f5;
}
.gx-sub-popover .gx-btn:not(:last-child),
.gx-sub-popover .btn:not(:last-child) {
  margin-right: 5px;
}
.gx-login-content .gx-btn,
.gx-login-content .btn {
  padding: 9px 20px !important;
  height: auto;
  line-height: 1;
}
.gx-btn-block {
  display: block;
  width: 100%;
}
a.gx-btn.disabled,
fieldset[disabled] a.gx-btn {
  pointer-events: none;
}
.gx-btn-rounded {
  -webkit-border-radius: 50px !important;
  -moz-border-radius: 50px !important;
  border-radius: 50px !important;
}
.gx-btn-link {
  font-size: 14px;
  font-weight: 400;
  color: var(--app-primary-color);
  background-color: transparent;
}
.gx-btn-link:hover {
  color: var(--app-primary-color);
  text-decoration: underline;
  background-color: transparent;
  border-color: transparent;
}
.gx-btn-link:focus,
.gx-btn-link.focus {
  text-decoration: underline;
  border-color: transparent;
}
.gx-btn-link:disabled,
.gx-btn-link.disabled {
  color: #bfbfbf;
}
.gx-btn-lg,
.gx-btn-group-lg > .gx-btn {
  padding: 0 15px;
  font-size: 16px;
  line-height: 40px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  height: 40px;
}
.gx-btn-sm,
.gx-btn-group-sm > .gx-btn {
  padding: 0 7px;
  font-size: 12px;
  line-height: 24px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  height: 24px;
}
.gx-btn-xs {
  font-size: 10px;
  padding: 0 6px;
  height: 26px;
  line-height: 25px;
}
.gx-btn-block {
  display: block;
  width: 100%;
}
.gx-btn-block + .gx-btn-block {
  margin-top: 0.5rem;
}
.gx-icon-btn {
  width: 40px;
  height: 40px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  cursor: pointer;
}
.gx-icon-btn:focus,
.gx-icon-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.gx-layout-sider-dark .gx-icon-btn:focus,
.gx-layout-sider-dark .gx-icon-btn:hover {
  background-color: var(--app-primary-color);
}
.gx-popover-header .gx-icon-btn {
  width: 30px;
  height: 30px;
}
.gx-icon-btn .icon-star-o:before,
.gx-icon-btn .icon-star:before {
  position: relative;
  top: 3px;
}
@media screen and (max-width: 575px) {
  .gx-module-box-content .gx-icon-btn.icon {
    font-size: 16px;
  }
}
.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper {
  height: 24px;
  line-height: 24px;
  border: 0 none;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  margin-left: 0;
}
.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
  background-color: var(--app-primary-color);
  color: #ffffff;
}
.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper:not(:first-child)::before {
  display: none;
}
@media screen and (max-width: 575px) {
  .gx-radio-group-link-news {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 575px) {
  .gx-radio-group-link .ant-radio-button-wrapper {
    padding: 0 8px;
  }
}
.gx-radio-group-link-bg-light {
  margin-left: -5px;
  margin-right: -5px;
}
.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper {
  padding: 0 10px;
  margin-left: 5px;
  margin-right: 5px;
  background-color: #e8e8e8;
}
.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
  background-color: var(--app-primary-color);
  color: #ffffff;
}
.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper:not(:first-child)::before {
  display: none;
}
/*Card Styles*/
.ant-card {
  margin-bottom: 32px;
}
.ant-card-head {
  background: none;
}
.ant-card-head-title {
  font-weight: 400;
}
.ant-card-grid {
  text-align: center;
  width: 25%;
}
@media screen and (max-width: 767px) {
  .ant-card-grid {
    width: 33.33%;
  }
}
@media screen and (max-width: 575px) {
  .ant-card-grid {
    width: 50%;
  }
}
@media screen and (max-width: 575px) {
  .ant-card {
    margin-bottom: 20px;
  }
}
.ant-card-body .ant-card-head {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.ant-card-type-inner .ant-card-head {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.ant-card-wider-padding .ant-card-body > :last-child {
  margin-bottom: 0;
}
.gx-card-center-vertical {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-card-img {
  position: relative;
  overflow: hidden;
}
.gx-card-img .ant-card-body {
  position: relative;
}
.gx-card-img .gx-badge-up {
  position: absolute;
  right: 60px;
  top: -20px;
  z-index: 1;
  padding: 5px;
  margin: 0;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  line-height: 36px;
  text-align: center;
}
.gx-card-img .gx-badge-up-right {
  right: 10px;
  top: -15px;
  -webkit-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  line-height: 32px !important;
}
.gx-card-img-center .ant-card-cover {
  text-align: center;
}
.gx-card-img-center .ant-card-cover > * {
  width: auto;
  display: inline-block;
}
.gx-card-body-border-top .ant-card-cover {
  padding-top: 24px;
}
.gx-card-body-border-top .ant-card-body {
  border-top: solid 1px #e8e8e8;
  margin-top: 32px;
}
@media screen and (max-width: 575px) {
  .gx-card-body-border-top .ant-card-body {
    margin-bottom: 20px;
  }
}
.gx-ant-card-actions {
  list-style: none;
  margin: 0 -10px 10px;
  padding-left: 0;
}
.gx-ant-card-actions li {
  display: inline-block;
  vertical-align: top;
  padding: 0 10px;
}
.gx-ant-card-actions li:not(:last-child) {
  border-right: solid 1px #e8e8e8;
}
.gx-card {
  margin-bottom: 32px;
  background-color: #ffffff;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
@media screen and (max-width: 575px) {
  .gx-card {
    margin-bottom: 20px;
  }
}
.gx-card-head {
  padding: 24px;
}
.gx-card-head .gx-card-title {
  margin-bottom: 0;
}
.gx-card-head + .gx-card-body {
  padding-top: 0;
}
.gx-card .ant-card-head {
  border-bottom: 0 none;
  min-height: 10px;
  padding: 0 24px;
}
@media screen and (max-width: 991px) {
  .gx-card .ant-card-head {
    padding: 0 24px;
  }
}
.gx-card .ant-card-head-title {
  padding: 25px 0 0;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
}
@media screen and (max-width: 991px) {
  .gx-card .ant-card-head-title {
    padding-top: 20px;
  }
}
.gx-card-body,
.gx-card .ant-card-body {
  padding: 24px;
}
@media screen and (max-width: 991px) {
  .gx-card-body,
  .gx-card .ant-card-body {
    padding: 24px;
  }
}
.gx-card.ant-card-bordered {
  border: 0 none;
}
.gx-card.ant-card-hoverable:hover {
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);
  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);
}
.gx-card .ant-card-cover {
  padding: 24px;
  padding-bottom: 0;
}
@media screen and (max-width: 991px) {
  .gx-card .ant-card-cover {
    padding: 24px;
    padding-bottom: 0;
  }
}
.gx-card-metrics {
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.gx-card-metrics.ant-card-bordered {
  border: 0 none;
}
.gx-card-metrics .ant-card-head {
  border-bottom: 0 none;
  min-height: 10px;
}
.gx-card-metrics .ant-card-head-title {
  padding: 20px 0 0;
  text-transform: uppercase;
  font-size: 14px;
}
.gx-card-widget {
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.gx-card-widget.ant-card-bordered {
  border: 0 none;
}
.gx-card-widget .ant-card-head {
  border-bottom: 0 none;
  min-height: 24px;
  padding: 24px 24px 0;
}
.gx-card-widget .ant-card-head-wrapper {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-card-widget .ant-card-head-title {
  padding: 0;
  text-transform: uppercase;
  font-size: 14px;
}
.gx-card-widget.gx-ch-capitalize .ant-card-head-title {
  text-transform: capitalize;
  font-size: 14px;
}
.gx-card-widget .ant-card-extra {
  padding: 0;
}
.gx-card-widget .ant-card-extra .gx-btn {
  margin-bottom: 0;
}
.gx-card-widget .ant-card-body {
  padding: 24px;
}
.gx-card-equal-height {
  height: calc(100% - 32px);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
@media screen and (max-width: 575px) {
  .gx-card-equal-height {
    height: calc(100% - 20px);
  }
}
.gx-card-equal-height .ant-card-body {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-card-equal-height .ant-card-body .gx-rechart {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-card-equal-height .ant-card-body .gx-rechart .recharts-responsive-container {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: flex;
}
.gx-card-sm-p .ant-card-head {
  min-height: 10px;
}
.gx-card-sm-p .ant-card-head-title {
  padding: 14px 14px 0;
}
.gx-card-sm-p .ant-card-body {
  padding: 14px;
}
.gx-card-sm-px .ant-card-head {
  min-height: 10px;
}
.gx-card-sm-px .ant-card-head-title {
  padding-left: 10px;
  padding-right: 10px;
}
.gx-card-sm-px .ant-card-body {
  padding-left: 10px;
  padding-right: 10px;
}
.gx-entry-header {
  margin-bottom: 32px;
}
@media screen and (max-width: 575px) {
  .gx-entry-header {
    margin-bottom: 20px;
  }
}
.gx-entry-header .gx-entry-heading {
  margin-bottom: 0;
}
.gx-entry-header .gx-entry-description {
  margin-bottom: 0;
  font-size: 13px;
}
.gx-card-full {
  overflow: hidden;
}
.gx-card-full .gx-card-body {
  padding: 0;
}
.gx-card-full .gx-card-body .recharts-legend-wrapper {
  padding: 0 24px;
}
.gx-card-full .ant-card-body {
  padding: 0;
}
.gx-card-full .ant-card-body .recharts-legend-wrapper {
  padding: 0 24px;
}
.gx-card-full .recharts-default-legend {
  margin: 0 -10px !important;
}
.gx-card-full .recharts-default-legend li {
  padding: 0 10px;
  margin: 0 !important;
  display: inline-block;
  vertical-align: top;
}
.gx-card-full .recharts-default-legend li .recharts-legend-item-text {
  margin-left: 10px;
}
.gx-card-overview {
  margin-bottom: 32px;
  background-color: #ffffff;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  padding: 24px;
}
@media screen and (max-width: 575px) {
  .gx-card-overview {
    margin-bottom: 20px;
  }
}
.gx-card-overview .gx-card-title {
  margin-bottom: 20px;
}
.gx-card-profile .ant-card-head {
  padding-top: 15px;
  padding-bottom: 16px;
}
.gx-card-profile.gx-card-tabs .ant-card-head {
  border-bottom: 1px solid #e8e8e8;
}
@media screen and (max-width: 575px) {
  .gx-card-profile.gx-card-tabs .ant-card-head {
    border-bottom: 0 none;
  }
}
.gx-card-profile .ant-card-body,
.gx-card-profile.gx-card-tabs .ant-card-body {
  padding-top: 0;
}
.gx-card-profile.gx-card-tabs .ant-tabs {
  margin-top: -50px;
}
@media screen and (max-width: 575px) {
  .gx-card-profile.gx-card-tabs .ant-tabs {
    margin-top: 0;
  }
}
.gx-card-profile .ant-tabs-tab {
  padding-top: 15px;
  padding-bottom: 18px;
}
.gx-card-profile .ant-card-head-title,
.gx-card-profile.gx-card-tabs .ant-card-head-title {
  font-size: 20px;
  text-transform: capitalize;
}
.gx-card-profile.gx-card-tabs .ant-tabs-nav-container {
  font-size: 14px;
  color: #8c8c8c;
}
.gx-card-profile-sm.gx-card-widget .ant-card-body {
  padding-top: 10px;
}
@media (max-width: 1366px) {
  .gx-card-1367-p .ant-card-head {
    min-height: 10px;
  }
  .gx-card-1367-p .ant-card-head-title {
    padding-left: 14px;
    padding-right: 14px;
  }
  .gx-card-1367-p .ant-card-body {
    padding-left: 14px;
    padding-right: 14px;
  }
}
.ant-divider-horizontal.ant-divider-with-text,
.ant-divider-horizontal.ant-divider-with-text-left,
.ant-divider-horizontal.ant-divider-with-text-right {
  font-size: 14px;
}
/*Cascader Styles*/
.ant-cascader-picker {
  width: 100%;
}
/*Chart Styles*/
.recharts-default-tooltip {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.8) !important;
  color: var(--app-secondary-color);
}
.recharts-tooltip-item-list li {
  color: var(--app-primary-color) !important;
}
/*Form Styles*/
.ant-form .ant-row {
  margin-left: 0;
  margin-right: 0;
}
.ant-form-inline {
  margin-left: -8px;
  margin-right: -8px;
}
.ant-form-inline .ant-row {
  padding-left: 8px;
  padding-right: 8px;
}
.ant-form-inline .ant-form-item {
  margin-bottom: 10px;
}
@media screen and (max-width: 575px) {
  .ant-form-inline .ant-form-item {
    display: block;
  }
}
.ant-form-horizontal .ant-row {
  margin-left: -15px;
  margin-right: -15px;
}
.ant-form-vertical .ant-form-item {
  padding-bottom: 0;
}
.ant-form-vertical .ant-row {
  -ms-flex-direction: column;
  flex-direction: column;
}
.ant-form-extra {
  word-break: break-all;
}
@media (max-width: 575px) {
  .ant-form-item-label {
    padding-bottom: 0;
  }
}
.ant-form-item-with-help {
  margin-bottom: 20px;
}
.ant-advanced-search-form .gx-btn-link:hover {
  text-decoration: none;
}
.ant-form-item-control > .ant-form-item:last-child,
.ant-form-item [class^="ant-col-"] > .ant-form-item:only-child {
  margin-bottom: 0;
}
.gx-form-row0 .ant-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.gx-login-form {
  max-width: 350px;
}
.gx-login-form .ant-form-item-control-wrapper {
  width: 100%;
}
.ant-form-inline .gx-form-item-one-fourth {
  width: 25%;
}
@media (max-width: 575px) {
  .ant-form-inline .gx-form-item-one-fourth {
    width: 100%;
  }
}
.ant-form-inline .gx-form-item-two-fourth {
  width: 50%;
}
@media (max-width: 575px) {
  .ant-form-inline .gx-form-item-two-fourth {
    width: 100%;
  }
}
.gx-form-inline-currency {
  margin: 0 -8px;
}
.gx-form-inline-currency .ant-form-item {
  padding: 0 8px;
}
.gx-form-inline-currency .gx-form-item-one-fourth {
  width: 30%;
}
@media (max-width: 575px) {
  .gx-form-inline-currency .gx-form-item-one-fourth {
    width: 40%;
    display: inline-block;
  }
}
.gx-form-inline-currency .gx-form-item-two-fourth {
  width: 40%;
}
@media (max-width: 575px) {
  .gx-form-inline-currency .gx-form-item-two-fourth {
    width: 100%;
    display: block;
  }
}
.gx-radio-wrapper {
  white-space: normal;
  margin-bottom: 10px;
  margin-right: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: flex-start;
  -ms-align-items: flex-start;
  align-items: flex-start;
}
@media (max-width: 1599px) {
  .ant-form-item-label[class*='ant-col-'] {
    padding: 0 0;
  }
}
@media (max-width: 1199px) {
  .ant-form-item-label[class*='ant-col-'] {
    padding: 0 0;
  }
  .ant-form-item,
  .ant-form-item-with-help {
    margin-bottom: 12px;
  }
  .ant-advanced-search-form .ant-form-item {
    margin-bottom: 12px;
  }
}
@media (max-width: 991px) {
  .ant-form-item-label[class*='ant-col-'] {
    padding: 0 0;
  }
}
@media (max-width: 767px) {
  .ant-form-item-label[class*='ant-col-'] {
    padding: 0 0;
  }
}
@media (max-width: 575px) {
  .ant-form-item-label[class*='ant-col-'] {
    padding: 0 0;
    margin-bottom: 8px;
  }
  .ant-advanced-search-form .ant-btn,
  .ant-advanced-search-form .gx-btn-link {
    display: block;
    margin: 0 0 10px !important;
  }
}
.secondary-color {
  color: var(--app-secondary-color);
}
.primary-border {
  border: 1px solid var(--app-primary-color) !important;
  box-shadow: none !important;
}
/*Input Styles*/
.ant-input-search {
  margin-bottom: 16px;
}
.ant-input-search > .ant-input-suffix > .ant-input-search-button {
  margin-right: 0;
}
.ant-input-group > [class*="col-"] {
  padding-left: 0;
  float: left !important;
}
.ant-transfer-list {
  margin-bottom: 10px;
}
.ant-input-number {
  margin-right: 10px;
}
.gx-form-group {
  margin-bottom: 10px;
}
.gx-search-bar {
  position: relative;
}
.gx-search-bar .gx-form-group {
  width: 100%;
  height: 100%;
  margin-bottom: 0;
}
.gx-search-bar input[type="search"] {
  padding-right: 35px;
  background: rgba(250, 250, 250, 0.1);
}
.ant-layout-header .gx-search-bar input[type="search"],
.ant-popover-content .gx-search-bar input[type="search"] {
  border: 0 none;
}
.gx-search-bar input[type="search"]:focus {
  box-shadow: none;
  background-color: rgba(250, 250, 250, 0.3);
}
.gx-search-bar .gx-search-icon {
  background-color: transparent;
  border: 0 none;
  color: #d9d9d9;
  height: 32px;
  width: 30px;
  line-height: 36px;
  text-align: center;
  position: absolute;
  right: 0;
  top: 0;
}
.gx-algolia-header .gx-search-bar .gx-search-icon {
  margin-top: 2px;
  text-align: left;
}
.gx-search-bar .ant-input-lg + .gx-search-icon {
  height: 40px;
  line-height: 45px;
}
.gx-lt-icon-search-bar input[type="search"] {
  padding-right: 16px;
  padding-left: 35px;
  border: 0 none;
}
.gx-lt-icon-search-bar .gx-search-icon {
  left: 0;
  right: auto;
}
.gx-algolia-header .gx-lt-icon-search-bar {
  margin-right: 10px;
}
@media screen and (max-width: 1199px) {
  .gx-algolia-header .gx-lt-icon-search-bar {
    width: 140px;
  }
}
@media screen and (max-width: 400px) {
  .gx-algolia-header .gx-lt-icon-search-bar {
    margin-right: 0;
    margin-bottom: 10px;
    width: auto;
  }
}
.gx-lt-icon-search-bar-lg {
  width: 350px;
}
.gx-lt-icon-search-bar-lg input[type="search"] {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  height: 46px;
  padding: 10px 18px 10px 40px;
}
@media screen and (max-width: 991px) {
  .gx-lt-icon-search-bar-lg input[type="search"] {
    height: 38px;
    padding: 5px 18px 5px 40px;
  }
}
.gx-header-search .gx-lt-icon-search-bar-lg input[type="search"] {
  background-color: #f5f5f5;
  height: 36px;
  -webkit-border-radius: 4px 0 0 4px;
  -moz-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
  border: solid 1px #e8e8e8;
}
.gx-header-search .gx-lt-icon-search-bar-lg input[type="search"]:focus {
  background-color: #f2f2f2;
}
.gx-header-horizontal-dark .gx-header-search .gx-lt-icon-search-bar-lg input[type="search"] {
  border-color: rgba(255, 255, 255, 0.2);
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.gx-header-horizontal-dark .gx-header-search .gx-lt-icon-search-bar-lg input[type="search"]:focus {
  background-color: transparent;
}
.gx-lt-icon-search-bar-lg .gx-search-icon {
  width: 35px;
  height: 46px;
  line-height: 50px;
  font-size: 16px;
  left: 0;
  right: auto;
}
@media screen and (max-width: 991px) {
  .gx-lt-icon-search-bar-lg .gx-search-icon {
    height: 38px;
    line-height: 40px;
  }
}
.gx-header-search .gx-lt-icon-search-bar-lg .gx-search-icon {
  height: 36px;
  line-height: 40px;
}
.gx-inside-header-horizontal .gx-lt-icon-search-bar-lg {
  width: 200px;
  margin-right: 10px;
}
@media screen and (max-width: 1199px) {
  .gx-inside-header-horizontal .gx-lt-icon-search-bar-lg {
    width: 120px;
  }
}
@media screen and (max-width: 1199px) {
  .gx-lt-icon-search-bar-lg {
    width: 150px;
  }
}
.gx-popover-search-bar {
  width: 150px;
  margin: -10px -14px;
}
.gx-chat-search-bar {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-width: 100px;
  width: auto;
}
.gx-chat-search-bar input[type="search"] {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  height: 40px;
  border: 0 none;
}
.gx-chat-search-bar input[type="search"]:focus {
  background-color: #ffffff;
}
.gx-chat-search-bar .gx-search-icon {
  height: 40px;
  line-height: 44px;
}
.ant-transfer-list {
  width: 150px;
}
@media screen and (max-width: 575px) {
  .ant-transfer-list {
    width: 100%;
  }
}
.gx-select-sm {
  font-size: 12px;
}
.gx-select-sm .ant-select-selection {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.gx-select-sm .ant-select-selection--single,
.gx-select-sm.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 24px;
  padding: 0 7px;
}
.gx-select-sm.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
  height: 22px;
}
.gx-select-sm.ant-select-single .ant-select-selector .ant-select-selection-item,
.gx-select-sm.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 22px;
}
.gx-select-sm .ant-select-selection__rendered {
  line-height: 22px;
  margin-left: 6px;
  margin-right: 6px;
}
.gx-select-sm .ant-select-selection-selected-value {
  padding-right: 20px;
}
.gx-select-sm .ant-select-arrow {
  right: 6px;
}
.gx-select-sm .ant-select-dropdown {
  font-size: 12px;
}
.gx-form-inline-label-up .ant-form-item,
.gx-form-inline-label-up .ant-form-item > .ant-form-item-control-wrapper,
.gx-form-inline-label-up .ant-form-item > .ant-form-item-label {
  display: block;
}
.gx-form-inline-label-up .ant-form-item-label {
  text-align: left;
  color: #bfbfbf;
  line-height: 1;
  margin-bottom: 4px;
}
.gx-form-inline-label-up .ant-select-selection--single,
.gx-form-inline-label-up .ant-input {
  height: 30px;
}
.gx-form-inline-label-up .ant-select-selection__rendered {
  line-height: 28px;
}
.gx-form-inline-label-up .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 30px;
}
.gx-form-inline-label-up .ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
  height: 28px;
}
.gx-form-inline-label-up .ant-select-single .ant-select-selector .ant-select-selection-item,
.gx-form-inline-label-up .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 28px;
}
.gx-form-inline-label-up.ant-form-inline .ant-form-item > .ant-form-item-label,
.gx-form-inline-label-up.ant-form-inline .ant-form-item > .ant-form-item-control {
  display: block;
}
.gx-form-inline-label-up .ant-form-item-label > label {
  height: auto;
}
.gx-input-lineheight {
  line-height: 36px;
}
.ant-mention-wrapper {
  border: solid 1px #e8e8e8;
  padding: 8.6px 11px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}
@media screen and (max-width: 575px) {
  .gx-ant-transfer-width .ant-transfer-list {
    width: 100% !important;
  }
}
@media screen and (max-width: 475px) {
  .ant-input-group.ant-input-group-compact > * {
    -webkit-border-radius: 4px !important;
    -moz-border-radius: 4px !important;
    border-radius: 4px !important;
    width: 100% !important;
    border-right-width: 1px;
  }
  .ant-input-group.ant-input-group-compact > *:not(:last-child) {
    margin-bottom: 10px;
  }
  .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,
  .ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,
  .ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,
  .ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,
  .ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,
  .ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input {
    border-radius: 4px;
    border-right-width: 1px;
  }
  .ant-input-group.ant-input-group-compact .gx-border-lt-xs {
    border-left: 1px solid #d9d9d9 !important;
  }
}
/*Icon Styles*/
.gx-icon-views {
  position: relative;
  text-align: center;
  padding: 16px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  margin-bottom: 15px;
  height: calc(100% - 15px);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-icon-views .icon {
  margin-bottom: 12px;
  font-size: 20px;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  line-height: 1;
  display: block;
}
.gx-icon-views:hover {
  background-color: var(--app-primary-color);
  cursor: pointer;
  color: #ffffff;
}
.gx-icon-views:hover .icon {
  -webkit-transform: scale(1.4);
  -moz-transform: scale(1.4);
  -ms-transform: scale(1.4);
  -o-transform: scale(1.4);
  transform: scale(1.4);
}
.gx-icon-text {
  display: block;
  font-size: 12px;
}
.ant-btn-icon-only {
  padding: 0;
}
/*List Styles*/
.ant-list-vertical .ant-list-item-main {
  min-width: 200px;
}
@media screen and (max-width: 480px) {
  .ant-list-vertical .ant-list-item-extra {
    margin-bottom: 10px;
  }
}
.gx-list-item .ant-list-item-extra-wrap {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra {
  margin-left: 20px;
}
@media screen and (max-width: 575px) {
  .gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra {
    margin-left: 0;
    margin-top: 10px;
  }
  .gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra img {
    width: 100%;
  }
}
@media screen and (max-width: 575px) {
  .gx-list-item .ant-list-item-extra-wrap {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
.gx-user-list {
  width: 100%;
  padding-bottom: 10px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-user-list:not(:first-child) {
  padding-top: 20px;
}
@media screen and (max-width: 575px) {
  .gx-user-list:not(:first-child) {
    padding-top: 0;
  }
}
.gx-user-list.gx-card-list {
  padding: 30px;
  background: #fff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 32px;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
}
.gx-user-list.gx-card-list .gx-avatar-img {
  margin-right: 25px;
}
@media screen and (max-width: 767px) {
  .gx-user-list.gx-card-list {
    padding: 20px;
  }
}
@media screen and (max-width: 575px) {
  .gx-user-list.gx-card-list {
    margin-bottom: 20px;
  }
}
.gx-user-list .gx-avatar-img {
  margin-right: 20px;
  margin-bottom: 10px;
}
.gx-user-list h3 {
  font-weight: 500;
  margin-bottom: 8px;
}
.gx-user-list .gx-link[class*="gx-meta-"] {
  display: inline-block;
  color: #545454;
  font-size: 12px;
  font-weight: 500;
}
.gx-user-list .gx-link[class*="gx-meta-"] i {
  margin-right: 6px;
  vertical-align: middle;
}
.gx-user-list .gx-description {
  width: calc(100% - 120px);
}
@media screen and (max-width: 575px) {
  .gx-user-list .gx-description {
    width: 100%;
  }
}
.gx-user-list .gx-btn-list li:not(:last-child) {
  margin-right: 10px;
}
.gx-list-inline {
  margin-left: -5px;
  margin-right: -5px;
  padding-left: 0;
  list-style: none;
}
.gx-list-inline li {
  padding: 0 5px;
  display: inline-block;
}
.gx-list-inline-lg {
  margin-left: -10px;
  margin-right: -10px;
  padding-left: 0;
  list-style: none;
}
.gx-list-inline-lg li {
  padding: 0 10px;
  display: inline-block;
}
.gx-card-strip {
  margin-bottom: 10px;
}
.gx-card-strip:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
}
.gx-card-list .gx-description {
  width: calc(100% - 230px);
  margin-top: 5px;
}
@media screen and (max-width: 767px) {
  .gx-card-list .gx-description {
    width: calc(100% - 80px);
  }
}
.gx-card-list .gx-card-list-footer {
  padding-left: 15px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  min-width: 150px;
}
.gx-card-list .gx-card-list-footer .ant-btn {
  display: block;
  margin-right: 0;
  width: 120px;
}
.gx-card-list .gx-card-list-footer .ant-btn:last-child {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .gx-card-list .gx-card-list-footer {
    padding-left: 0;
    min-width: 10px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .gx-card-list .gx-card-list-footer .ant-btn {
    width: auto;
    margin-right: 12px;
    margin-bottom: 0;
  }
}
.gx-list-group {
  list-style: none;
  padding-left: 0;
}
.gx-list-group li {
  margin-bottom: 6px;
}
.gx-list-group li i,
.gx-list-group li .anticon {
  margin-right: 12px;
}
.gx-dot-list {
  list-style: none;
  margin: 0 -3px 10px;
  padding-left: 0;
}
.gx-dot-list li {
  display: inline-block;
  vertical-align: top;
  padding: 0 3px;
}
@media screen and (max-width: 575px) {
  .gx-dot-list {
    margin-bottom: 5px;
  }
}
/*Loader Styles*/
.ant-spin {
  margin-right: 16px;
  margin-bottom: 10px;
}
.gx-loader-container {
  text-align: center;
  background-color: #f5f5f5;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 30px 50px;
  margin-right: 0;
  display: block;
}
/*Pagination Styles*/
.ant-pagination > li {
  margin-bottom: 10px;
}
.ant-pagination.mini:not(:last-child) {
  margin-bottom: 10px;
}
.ant-pagination.mini li {
  margin-bottom: 5px !important;
}
.ant-pagination-prev,
.ant-pagination-next,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  line-height: 30px;
}
/*Pickers Styles*/
.photoshop-picker,
.swatches-picker,
.alpha-picker,
.hue-picker {
  width: 100% !important;
}
.gx-alpha-pickers {
  position: relative;
  min-height: 250px;
}
.ant-calendar-footer .ant-calendar-ok-btn {
  margin-bottom: 0;
}
/*Progress Styles*/
.ant-progress-line {
  margin-right: 8px;
  margin-bottom: 8px;
}
.ant-progress-circle {
  margin-right: 8px;
  margin-bottom: 8px;
}
/*Steps Styles*/
.ant-steps-dot {
  flex-wrap: wrap;
  overflow: hidden;
  padding: 10px 0;
}
.ant-steps-dot .ant-steps-item {
  margin-bottom: 10px;
}
@media screen and (max-width: 575px) {
  .ant-steps-dot .ant-steps-item-description {
    display: none;
  }
}
/*Slider Styles*/
.ant-carousel h1,
.ant-carousel h2,
.ant-carousel h3,
.ant-carousel h4,
.ant-carousel h5,
.ant-carousel h6 {
  line-height: inherit;
  margin-bottom: 0;
}
.ant-carousel .slick-dots {
  margin-left: 0;
  margin-right: 0;
}
.gx-vertical-slider {
  position: relative;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0 -15px;
}
.gx-vertical-slider-item {
  width: 33.33%;
  padding: 0 15px;
  height: 300px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media screen and (max-width: 575px) {
  .gx-vertical-slider-item {
    width: 50%;
    margin-bottom: 15px;
  }
}
.ant-carousel-vertical .gx-vertical-slide .slick-slide {
  height: 160px;
}
.slick-slider {
  margin-bottom: 32px;
}
@media screen and (max-width: 575px) {
  .slick-slider {
    margin-bottom: 20px;
  }
}
.slick-slider .slick-prev {
  left: -10px;
}
.slick-slider .slick-prev:before {
  color: #000000;
}
.slick-slider .slick-next {
  right: -10px;
}
.slick-slider .slick-next:before {
  color: #000000;
}
.slick-slider img {
  width: 100%;
  object-fit: cover;
}
.slick-dots li button:before {
  display: none;
}
.gx-slick-slider .slick-dots {
  bottom: 26px;
  padding: 0 24px;
  text-align: left;
}
.gx-slick-slider .slick-dots li {
  width: 10px !important;
  height: 10px !important;
}
.gx-slick-slider .slick-dots li button {
  width: 10px !important;
  height: 10px !important;
}
.gx-slick-slider .slick-dots li button:before {
  width: 10px !important;
  height: 10px !important;
  line-height: 10px !important;
  color: transparent;
  border: solid 2px #000000;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  display: block;
}
.gx-slick-slider .slick-dots li.slick-active button {
  width: 12px !important;
  height: 12px !important;
}
.gx-slick-slider .slick-dots li.slick-active button:before {
  color: transparent;
  border-color: var(--app-primary-color);
  width: 12px !important;
  height: 12px !important;
  line-height: 12px !important;
}
.gx-slide-item {
  margin-left: 15px;
  margin-right: 15px;
}
@media screen and (max-width: 480px) {
  .gx-slide-item {
    margin-left: 10px;
    margin-right: 10px;
  }
}
.gx-slider {
  position: relative;
}
.gx-slider-img {
  position: relative;
  padding-bottom: 24px;
}
.gx-slider-img .gx-img-up {
  position: absolute;
  left: 24px;
  bottom: -5px;
  z-index: 1;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  width: auto;
  max-width: 64px;
}
.gx-slider-content {
  padding: 24px;
}
.gx-slick-slider {
  margin-bottom: 0;
  padding-bottom: 24px;
}
.gx-slick-slider-dot-top {
  padding-top: 70px;
  padding-right: 24px;
  padding-bottom: 58px;
}
@media (max-width: 1366px) {
  .gx-slick-slider-dot-top {
    padding-top: 40px;
    padding-bottom: 10px;
  }
}
.gx-slick-slider-dot-top .slick-dots {
  bottom: auto;
  top: 30px;
  padding-left: 0;
}
@media (max-width: 1366px) {
  .gx-slick-slider-dot-top .slick-dots {
    top: 10px;
  }
}
@media screen and (max-width: 575px) {
  .gx-slick-slider-dot-top {
    padding-left: 24px;
  }
}
.gx-slick-slider-lt-thumb {
  height: 100%;
  position: relative;
}
.gx-slick-slider-lt-thumb img {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
@media screen and (max-width: 575px) {
  .gx-slick-slider-lt-thumb img {
    position: relative;
    left: auto;
    top: auto;
  }
}
.ant-modal .slides {
  position: relative;
}
.ant-modal .slides .slick-prev,
.ant-modal .slides .slick-next {
  position: absolute;
  top: 50%;
  z-index: 1;
  margin-top: -10px;
}
.ant-modal .slides .slick-prev {
  left: 20px;
}
.ant-modal .slides .slick-next {
  right: 20px;
}
.ant-modal .slick-slider {
  margin-bottom: 0;
}
/*Tables Styles*/
.ant-table-small .ant-table-thead > tr > th {
  background-color: transparent;
}
.ant-table-small > .ant-table-content > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-body > table,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table {
  padding: 0;
}
.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  word-break: normal;
}
.gx-table-responsive .ant-table {
  min-height: 0.01%;
  overflow-x: auto;
}
@media screen and (max-width: 767px) {
  .gx-table-responsive .ant-table {
    width: 100%;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: solid 1px #e8e8e8;
  }
  .ant-card-bordered.gx-card-full .gx-table-responsive .ant-table {
    border: 0 none;
    border-bottom: solid 1px #e8e8e8;
  }
  .gx-table-responsive .ant-table .ant-table-tbody > tr:last-child > td {
    border-bottom: 0 none;
  }
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-header > table,
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-body > table,
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-fixed-left table,
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-fixed-right table {
    border-top: 0 none;
    border-left: 0 none;
  }
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-title {
    border: 0 none;
  }
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-footer {
    border: 0 none;
    border-top: solid 1px #e8e8e8;
  }
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-thead > tr > th:last-child,
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-tbody > tr > td:last-child {
    border-right: 0 none;
  }
  .gx-table-responsive .ant-table-body > table > thead > tr > th,
  .gx-table-responsive .ant-table-body > table > tbody > tr > th,
  .gx-table-responsive .ant-table-body > table > tfoot > tr > th,
  .gx-table-responsive .ant-table-body > table > thead > tr > td,
  .gx-table-responsive .ant-table-body > table > tbody > tr > td,
  .gx-table-responsive .ant-table-body > table > tfoot > tr > td {
    white-space: nowrap;
  }
}
.gx-table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}
.gx-table th,
.gx-table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: solid 1px #e8e8e8;
}
.gx-table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #e8e8e8;
}
.gx-table tbody + tbody {
  border-top: 2px solid #e8e8e8;
}
.gx-table-bordered {
  border: 1px solid #e8e8e8;
}
.gx-table-bordered th,
.gx-table-bordered td {
  border: 1px solid #e8e8e8;
}
.gx-table-bordered thead th,
.gx-table-bordered thead td {
  border-bottom-width: 2px;
}
.gx-table-no-bordered {
  border: 0 none;
}
.gx-table-no-bordered th,
.gx-table-no-bordered td {
  border: 0 none;
}
.gx-table-no-bordered thead th,
.gx-table-no-bordered thead td {
  border-bottom-width: 2px;
}
.gx-table-no-bordered .ant-table {
  border: 0 none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.gx-table-no-bordered .ant-table-thead > tr > th {
  font-weight: 300;
  text-transform: uppercase;
  font-size: 11px;
}
.gx-table-no-bordered .ant-table-tbody > tr > td {
  border-bottom: 0 none;
}
.gx-table-thead-uppercase thead th {
  text-transform: uppercase;
}
.gx-table-padding-lg thead th,
.gx-table-padding-lg tbody td {
  padding: 20px 30px !important;
}
@media screen and (max-width: 991px) {
  .gx-table-padding-lg thead th,
  .gx-table-padding-lg tbody td {
    padding: 15px 20px !important;
  }
}
@media screen and (max-width: 767px) {
  .gx-table-padding-lg thead th,
  .gx-table-padding-lg tbody td {
    padding: 10px !important;
  }
}
.gx-table-padding-lg .ant-table-pagination {
  float: none;
  text-align: center;
  margin: 22px 0;
}
@media screen and (max-width: 991px) {
  .gx-table-padding-lg .ant-table-pagination {
    margin: 16px 0;
  }
}
/*Time Lines Style*/
/*Antd Time Lines Style*/
.ant-timeline-item {
  padding: 0;
}
.ant-timeline-item:not(:last-child) {
  padding-bottom: 20px;
}
@media screen and (max-width: 575px) {
  .ant-timeline-item:not(:last-child) {
    padding-bottom: 15px;
  }
}
.gx-timeline-info {
  position: relative;
}
.gx-timeline-info:not(:last-child) {
  padding-bottom: 20px;
}
.gx-timeline-info-day {
  margin-bottom: 15px;
  font-size: 12px;
  color: #595959;
}
.gx-timeline-info .ant-timeline {
  padding-top: 0;
  padding-left: 0;
}
.gx-timeline-info .ant-timeline-item-head-custom {
  padding: 0;
  margin-right: 15px;
  position: relative;
  left: 0;
  top: 0;
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.gx-timeline-info .ant-timeline-item {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: flex-start;
  -ms-align-items: flex-start;
  align-items: flex-start;
}
.gx-timeline-info .ant-timeline-item-content {
  padding-left: 0;
  top: 0;
  margin-left: 0;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: #595959;
}
.gx-timeline-info .ant-timeline-item-content .gx-link {
  color: #262626;
}
.gx-timeline-info .ant-timeline-item-content .gx-link:hover,
.gx-timeline-info .ant-timeline-item-content .gx-link:focus {
  color: var(--app-primary-color);
}
.gx-timeline-info .ant-timeline-item-tail {
  display: none;
}
.gx-img-more {
  width: 60px;
  height: 40px;
  background-color: #ffffff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  border: solid 1px #e8e8e8;
}
/*Custom Time Lines Style*/
.gx-timeline-left {
  float: left;
  margin-right: 20px;
}
.gx-timeline-right {
  float: right;
  margin-left: 20px;
}
.gx-timeline-circle {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.gx-timeline-section {
  margin-bottom: 25px;
  overflow: hidden;
}
.gx-timeline-item {
  padding-bottom: 25px;
  padding-left: 80px;
  position: relative;
}
.gx-timeline-item:before {
  border-left: solid 2px #e8e8e8;
  content: "";
  left: 25px;
  position: absolute;
  top: 25px;
  bottom: -20px;
  width: 2px;
  z-index: 1;
}
.gx-timeline-item:first-child:before {
  border-left-style: dashed;
}
.gx-timeline-item:last-child:before {
  border-left-style: dashed;
  bottom: 25px;
}
.gx-timeline-badge {
  height: 50px;
  width: 50px;
  position: absolute;
  left: 0;
  top: 16px;
  z-index: 2;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.gx-timeline-badge.gx-timeline-img {
  background-color: transparent;
}
.gx-timeline-badge.gx-timeline-img:after {
  display: none;
}
.gx-timeline-badge:after {
  position: absolute;
  content: "";
  width: 42px;
  height: 42px;
  background-color: transparent;
  border: 4px solid #e8e8e8;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  left: 4px;
  top: 4px;
  z-index: 1;
}
.gx-timeline-badge [class^="gx-"]:before,
.gx-timeline-badge [class*="gx-"]:before {
  line-height: 50px;
}
.gx-timeline-img > img,
.gx-timeline-header-img > img {
  display: inline-block;
  max-width: 100%;
  height: auto;
}
.gx-timeline-panel {
  padding: 20px 30px;
  position: relative;
  background-color: #ffffff;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  border: solid 1px #e8e8e8;
}
.gx-timeline-panel:after,
.gx-timeline-panel:before {
  content: "";
  position: absolute;
  border-style: solid;
  display: inline-block;
  top: 30px;
}
.gx-timeline-panel:before {
  border-color: transparent #e8e8e8;
  border-width: 10px 17px 10px 0;
  left: -18px;
}
.gx-timeline-panel:after {
  border-color: transparent #ffffff;
  border-width: 10px 16px 10px 0;
  left: -16px;
}
.gx-timeline-no-padding {
  padding: 0;
}
.gx-timeline-panel-header {
  margin-bottom: 10px;
}
.gx-timeline-header-img {
  margin-bottom: 10px;
}
.gx-timeline-inverted .gx-timeline-left {
  float: right;
  margin-right: 0;
  margin-left: 20px;
}
.gx-timeline-heading {
  overflow: hidden;
  margin-bottom: 10px;
}
.gx-timeline-body {
  clear: both;
}
/*Gxtl Center Style*/
.gx-timeline-center .gx-timeline-item {
  clear: both;
  float: right;
  width: 50%;
  padding-left: 55px;
}
.gx-timeline-center .gx-timeline-item:before {
  left: 0;
}
.gx-timeline-center .gx-timeline-badge {
  left: -25px;
  right: auto;
}
.gx-timeline-center .gx-timeline-time {
  position: absolute;
  top: 32px;
  left: -150px;
  right: auto;
  z-index: 2;
}
.gx-timeline-center .gx-timeline-inverted {
  float: left;
  text-align: right;
  padding-left: 0;
  padding-right: 55px;
}
.gx-timeline-center .gx-timeline-inverted:before {
  border-left: 0 none;
  border-right: solid 2px #e8e8e8;
  left: auto;
  right: -2px;
}
.gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {
  left: auto;
  right: -25px;
}
.gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:before {
  border-width: 10px 0 10px 17px;
  left: auto;
  right: -18px;
}
.gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:after {
  border-width: 10px 0 10px 16px;
  left: auto;
  right: -16px;
}
.gx-timeline-center .gx-timeline-inverted .gx-timeline-time {
  position: absolute;
  top: 32px;
  right: -150px;
  left: auto;
  z-index: 2;
}
/*Gxtl Zigzag Style*/
.gx-timeline-zigzag .gx-timeline-item {
  padding-left: 150px;
}
.gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {
  margin-top: -80px;
}
.gx-timeline-zigzag .gx-timeline-img {
  width: 90px;
  height: 90px;
  left: 5px;
}
.gx-timeline-zigzag .gx-timeline-img > img {
  width: 100%;
}
.gx-timeline-zigzag .gx-timeline-inverted .gx-timeline-img {
  right: 5px !important;
}
.gx-timeline-zigzag .gx-timeline-item:before {
  -webkit-transform: rotate(35deg);
  -moz-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  -o-transform: rotate(35deg);
  transform: rotate(35deg);
  top: 20px;
  bottom: 20px;
}
.gx-timeline-zigzag .gx-timeline-inverted {
  padding-left: 0;
  padding-right: 150px;
}
.gx-timeline-zigzag .gx-timeline-inverted:before {
  -webkit-transform: rotate(-35deg);
  -moz-transform: rotate(-35deg);
  -ms-transform: rotate(-35deg);
  -o-transform: rotate(-35deg);
  transform: rotate(-35deg);
}
.gx-timeline-zigzag .gx-timeline-item:first-child:before {
  border-left-style: solid;
}
.gx-timeline-zigzag .gx-timeline-item:last-child:before {
  display: none;
}
.gx-timeline-item:last-child:before {
  bottom: 25px;
}
@media screen and (max-width: 991px) {
  .gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {
    margin-top: -60px;
  }
  .gx-timeline-zigzag .gx-timeline-item:before {
    bottom: 0;
  }
  .gx-timeline-zigzag .gx-timeline-item {
    padding-left: 120px;
  }
  .gx-timeline-zigzag .gx-timeline-inverted {
    padding-right: 120px;
    padding-left: 0;
  }
}
@media screen and (max-width: 767px) {
  .gx-timeline-center .gx-timeline-item {
    float: none;
    padding-left: 80px;
    width: auto;
  }
  .gx-timeline-center .gx-timeline-item:before {
    left: 25px;
  }
  .gx-timeline-center .gx-timeline-badge {
    left: 0;
  }
  .gx-timeline-center .gx-timeline-inverted {
    float: none;
    text-align: left;
    padding-right: 0;
  }
  .gx-timeline-center .gx-timeline-inverted:before {
    border-left: solid 2px #e8e8e8;
    border-right: 0 none;
    left: 24px;
    right: auto;
  }
  .gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {
    right: auto;
    left: 0;
  }
  .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:before {
    border-width: 10px 17px 10px 0 !important;
    left: -18px;
    right: auto;
  }
  .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:after {
    border-width: 10px 16px 10px 0 !important;
    left: -16px;
    right: auto;
  }
  .gx-timeline-inverted .gx-timeline-panel-header {
    float: none;
  }
  .gx-timeline-inverted .gx-timeline-left {
    float: left;
    margin-left: 0;
    margin-right: 20px;
  }
  .gx-timeline-zigzag .gx-timeline-panel {
    max-height: none;
    min-height: 10px;
    overflow-y: visible;
  }
  .gx-timeline-zigzag .gx-timeline-item {
    padding-left: 100px;
  }
  .gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {
    margin-top: 0;
  }
  .gx-timeline-zigzag .gx-timeline-item:before {
    transform: none;
    top: 25px;
    bottom: -25px;
    left: 45px;
  }
  .gx-timeline-zigzag .gx-timeline-item:last-child:before {
    bottom: 0;
  }
  .gx-timeline-zigzag .gx-timeline-inverted:before {
    transform: none;
  }
  .gx-timeline-center .gx-timeline-time,
  .gx-timeline-center .gx-timeline-inverted .gx-timeline-time {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    margin-bottom: 6px;
  }
  .gx-timeline-center .gx-timeline-time-item .gx-timeline-panel::before,
  .gx-timeline-center .gx-timeline-time-item .gx-timeline-panel::after {
    top: 10px;
  }
}
@media screen and (max-width: 399px) {
  .gx-timeline-left {
    float: none;
    margin-right: 0;
  }
  .gx-timeline-right {
    float: none;
    margin-left: 0;
  }
  .gx-timeline-inverted .gx-timeline-left {
    float: none;
    margin-right: 0;
  }
}
/*Tabs Styles*/
.gx-tabs-half .ant-tabs-bar {
  margin-bottom: 0;
}
.gx-tabs-half .ant-tabs-nav {
  display: block;
}
.gx-tabs-half .ant-tabs-nav .ant-tabs-tab {
  margin: 0;
  width: 50%;
  text-align: center;
  display: block;
}
.gx-tabs-half .ant-tabs-nav .ant-tabs-ink-bar {
  width: 50%;
}
.gx-card-tabs .ant-card-head-title {
  text-transform: capitalize;
  font-size: 16px;
}
.gx-card-tabs .ant-card-extra {
  position: relative;
  z-index: 2;
}
.gx-card-tabs .ant-tabs {
  margin-top: -40px;
}
@media screen and (max-width: 575px) {
  .gx-card-tabs .ant-tabs {
    margin-top: 0;
  }
}
.gx-card-tabs .ant-tabs-tab {
  padding-left: 5px;
  padding-right: 5px;
  margin-right: 15px;
}
.gx-card-tabs .ant-tabs-tab-active {
  font-weight: 400;
}
.gx-card-tabs .ant-tabs-nav-wrap {
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  font-size: 16px;
}
@media screen and (max-width: 575px) {
  .gx-card-tabs .ant-tabs-nav-wrap {
    -webkit-justify-content: flex-start;
    -ms-justify-content: flex-start;
    justify-content: flex-start;
  }
}
.gx-card-tabs .ant-card-body {
  padding-top: 4px;
}
.gx-tabs-right .ant-tabs-nav-wrap {
  -webkit-justify-content: flex-end;
  -ms-justify-content: flex-end;
  justify-content: flex-end;
}
@media screen and (max-width: 575px) {
  .gx-tabs-right .ant-tabs-nav-wrap {
    -webkit-justify-content: flex-start;
    -ms-justify-content: flex-start;
    justify-content: flex-start;
  }
}
/* Apps Style */
.gx-app-module {
  position: relative;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: -32px -32px 0;
  flex: 1;
}
@media screen and (max-width: 575px) {
  .gx-app-module {
    margin: -20px -15px 0;
  }
}
.gx-container-wrap .gx-app-module {
  margin: 0;
  margin-bottom: 32px;
}
.gx-module-side {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 230px;
  -ms-flex: 0 1 230px;
  flex: 0 1 230px;
  min-width: 230px;
}
@media screen and (max-width: 991px) {
  .gx-module-side {
    min-width: 220px;
    background-color: #ffffff;
  }
}
.gx-module-side-header {
  padding: 10px;
  min-height: 79px;
  border-bottom: solid 1px #e8e8e8;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  background-color: #fbfbfb;
  color: #545454;
}
@media screen and (max-width: 991px) {
  .gx-module-side-header {
    min-height: 72px;
  }
}
.gx-module-logo {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  font-size: 20px;
}
.gx-module-logo i {
  font-size: 28px;
  line-height: 18px;
}
.gx-module-user-info,
.gx-module-side-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-module-user-detail {
  font-size: 12px;
}
.gx-module-add-task {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 24px;
}
.gx-module-add-task .ant-btn {
  margin-bottom: 0;
}
.gx-module-nav {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-module-nav li {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-module-nav li .gx-link {
  padding: 5px 29px;
  color: #999999;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  text-decoration: none;
}
.gx-module-nav li .gx-link:hover,
.gx-module-nav li .gx-link:focus {
  color: #000000;
}
.gx-module-nav li .gx-link.active {
  color: var(--app-primary-color);
}
.gx-module-nav li i {
  margin-right: 16px;
  font-size: 16px;
}
.gx-module-nav li i[class^="icon-"]::before,
.gx-module-nav li i[class*=" icon-"]::before {
  display: block;
}
.gx-module-nav li span {
  display: inline-block;
  vertical-align: middle;
}
.gx-module-nav li.gx-module-nav-label {
  padding: 12px 29px;
}
.gx-module-box {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: calc(100% - 230px - 1px);
}
@media screen and (max-width: 991px) {
  .gx-module-box {
    max-width: 100%;
  }
}
.gx-module-box-header {
  padding: 10px 26px;
  min-height: 79px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  background-color: #ffffff;
  border-bottom: solid 1px #e8e8e8;
}
@media screen and (max-width: 991px) {
  .gx-module-box-header {
    position: relative;
    min-height: 58px;
    padding: 5px 26px 5px 110px;
  }
}
@media screen and (max-width: 991px) {
  .gx-module-box-header .gx-drawer-btn {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    border-right: solid 1px #e8e8e8;
    height: 58px;
    width: 98px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    -ms-align-items: center;
    align-items: center;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
    font-size: 22px;
    text-align: center;
  }
}
.gx-module-box-header-inner {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}
.gx-module-box-header-right {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-left: auto;
}
.gx-module-box-content {
  background-color: #ffffff;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.gx-module-box-topbar {
  padding: 8px 28px;
  min-height: 65px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  border-bottom: solid 1px #e8e8e8;
}
.gx-module-box-topbar label.ant-checkbox-wrapper {
  margin-right: 10px;
}
.gx-module-box-topbar .ant-dropdown-trigger {
  cursor: pointer;
  margin-right: 10px;
}
.gx-module-box-topbar .ant-dropdown-trigger .icon:before {
  position: relative;
  top: 3px;
}
.gx-module-box-topbar-todo {
  padding-left: 28px;
}
@media screen and (max-width: 991px) {
  .gx-module-box-topbar {
    min-height: 58px;
    padding-left: 28px;
    padding-right: 28px;
  }
}
.gx-module-list-icon {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  padding-right: 10px;
}
.gx-module-list-icon .gx-bar-icon .gx-icon-menu:before {
  top: 3px;
  position: relative;
}
.gx-toolbar-separator {
  border-left: solid 1px #e8e8e8;
  height: 100%;
  width: 1px;
  margin: 0 12px;
}
.gx-module-list {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-module-list-item {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  padding: 15px 28px;
  z-index: 5;
  position: relative;
  cursor: pointer;
}
.gx-module-list-item:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
}
.gx-module-list-item.gx-mail-cell {
  -webkit-align-items: start;
  -ms-align-items: start;
  align-items: start;
}
@media screen and (max-width: 575px) {
  .gx-module-list-item {
    padding-bottom: 10px;
    padding-top: 10px;
  }
}
.gx-module-detail-header {
  margin-bottom: 10px;
}
@media screen and (max-width: 575px) {
  .gx-module-detail-header {
    margin-bottom: 0;
  }
}
.gx-module-list-info {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: calc(100% - 140px);
}
@media screen and (max-width: 575px) {
  .gx-module-list-info {
    max-width: calc(100% - 100px);
  }
}
.gx-module-todo-content {
  position: relative;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.gx-module-todo-content .gx-subject {
  margin-bottom: 5px;
}
.gx-module-todo-right {
  margin-left: 8px;
}
.gx-module-sidenav {
  background-color: #ffffff;
  border-right: solid 1px #e8e8e8;
  position: relative;
  z-index: 9;
}
.gx-module-sidenav .gx-chat-sidenav-main {
  max-width: 300px;
  min-width: 300px;
  width: 90%;
}
.gx-module-date {
  max-width: 160px;
}
.gx-module-detail-item {
  padding: 10px 28px;
}
.gx-task-title {
  font-size: 18px;
}
@media screen and (max-width: 991px) {
  .gx-task-title {
    font-size: 16px;
  }
}
.gx-chat-todo-avatar {
  margin-right: 15px;
}
.gx-module-side-scroll {
  height: calc(100vh - 201px) !important;
}
.framed-layout .gx-module-side-scroll {
  height: calc(100vh - 201px - 2 * 20px) !important;
}
@media screen and (max-width: 991px) {
  .gx-module-side-scroll {
    height: calc(100vh - 72px) !important;
  }
  .framed-layout .gx-module-side-scroll {
    height: calc(100vh - 72px) !important;
  }
}
.gx-module-side-scroll > div:first-child {
  overflow-y: scroll !important;
}
.gx-module-content-scroll {
  height: calc(100vh - 266px) !important;
}
.framed-layout .gx-module-content-scroll {
  height: calc(100vh - 266px - 2 * 20px) !important;
}
@media screen and (max-width: 991px) {
  .gx-module-content-scroll {
    height: calc(100vh - 238px) !important;
  }
  .framed-layout .gx-module-content-scroll {
    height: calc(100vh - 238px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-module-content-scroll {
    height: calc(100vh - 216px) !important;
  }
}
.gx-module-content-scroll > div:first-child {
  overflow-y: scroll !important;
}
.gx-todo-detail-content-scroll {
  height: calc(100vh - 319px) !important;
}
.framed-layout .gx-todo-detail-content-scroll {
  height: calc(100vh - 319px - 2 * 20px) !important;
}
@media screen and (max-width: 991px) {
  .gx-todo-detail-content-scroll {
    height: calc(100vh - 291px) !important;
  }
  .framed-layout .gx-todo-detail-content-scroll {
    height: calc(100vh - 291px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-todo-detail-content-scroll {
    height: calc(100vh - 270px) !important;
  }
}
.gx-todo-detail-content-scroll > div:first-child {
  overflow-y: scroll !important;
}
.gx-loader-view {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.gx-loader-view .ant-spin {
  margin: 0;
}
.gx-app-module .gx-loader-view {
  height: calc(100vh - 266px) !important;
}
.framed-layout .gx-app-module .gx-loader-view {
  height: calc(100vh - 266px - 2 * 20px) !important;
}
@media screen and (max-width: 991px) {
  .gx-app-module .gx-loader-view {
    height: calc(100vh - 238px) !important;
  }
  .framed-layout .gx-app-module .gx-loader-view {
    height: calc(100vh - 238px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-app-module .gx-loader-view {
    height: calc(100vh - 244px) !important;
  }
}
.gx-chat-module .gx-loader-view {
  height: calc(100vh - 122px) !important;
}
.framed-layout .gx-chat-module .gx-loader-view {
  height: calc(100vh - 122px - 2 * 20px) !important;
}
@media screen and (max-width: 991px) {
  .framed-layout .gx-chat-module .gx-loader-view {
    height: calc(100vh - 122px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-chat-module .gx-loader-view {
    height: calc(100vh - 100px) !important;
  }
}
.gx-loader-position {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 10;
  bottom: 0;
}
.gx-module-default {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  height: 100%;
  padding: 15px;
}
.gx-no-content-found {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 16px;
}
.gx-task-des,
.gx-task-input {
  padding-left: 0;
}
/*Mails Apps Styles*/
.gx-module-box-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}
.gx-module-box-column,
.gx-module-list-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-mail-list-info {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding-left: 10px;
  max-width: calc(100% - 150px);
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
@media screen and (max-width: 575px) {
  .gx-mail-list-info {
    max-width: 100%;
    margin-top: 10px;
    padding-left: 0;
  }
}
.gx-mail-user-info {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-left: 10px;
}
.gx-mail-user-info .gx-avatar {
  margin-right: 10px;
}
.gx-mail-user-info .gx-badge {
  margin-bottom: 0;
}
.gx-mail-user-des {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-bottom: 3px;
}
.gx-mail-user-des .gx-time,
.gx-mail-user-des .gx-icon-btn {
  margin-left: auto;
}
.gx-mail-detail-inner {
  padding: 24px;
}
@media screen and (max-width: 991px) {
  .gx-mail-detail-inner {
    padding-right: 28px;
    padding-left: 28px;
  }
}
.gx-mail-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media screen and (max-width: 498px) {
  .gx-mail-header {
    display: block;
    -webkit-align-items: flex-start;
    -ms-align-items: flex-start;
    align-items: flex-start;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
.gx-mail-header-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-mail-header-content .gx-subject {
  margin-bottom: 5px;
}
.gx-show-link {
  cursor: pointer;
  margin-bottom: 8px;
  color: var(--app-primary-color);
}
.gx-show-detail {
  margin-bottom: 12px;
}
.gx-module-list-content .gx-subject {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-module-list-content .gx-message {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  color: #8d8d8d;
  font-size: 13px;
}
.gx-module-list-content .gx-message p {
  margin-bottom: 8px;
}
.gx-size {
  margin: 5px 0;
}
.gx-sender-name {
  margin-right: 0;
  font-weight: 500;
  font-size: 15px;
}
.gx-send-subject {
  width: calc(100% - 220px);
}
@media screen and (max-width: 575px) {
  .gx-send-subject {
    width: calc(100% - 180px);
    margin-right: 6px;
  }
}
.gx-mail-header-actions {
  -webkit-justify-content: flex-end;
  -ms-justify-content: flex-end;
  justify-content: flex-end;
  min-width: 100px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-mail-header-actions .icon-btn:not(:last-child) {
  margin-right: 3px;
}
@media screen and (max-width: 498px) {
  .gx-mail-header-actions {
    -webkit-justify-content: flex-start;
    -ms-justify-content: flex-start;
    justify-content: flex-start;
    min-width: 10px;
  }
}
.gx-attachment-block {
  position: relative;
}
.gx-attachment-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0 -10px;
}
@media screen and (max-width: 575px) {
  .gx-attachment-row {
    margin: 0 -5px;
  }
}
.gx-attachment-col {
  padding: 0 10px;
}
.gx-attachment-col img {
  width: 80px;
}
.gx-attachment-col .size {
  padding-top: 5px;
}
@media screen and (max-width: 575px) {
  .gx-attachment-col {
    padding: 0 5px;
  }
}
@media screen and (max-width: 575px) {
  .gx-mail-list {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
    border-right: 0 none;
  }
  .gx-mail-detail {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
  }
}
/*Chat Apps Styles*/
.gx-chat-module {
  position: relative;
}
.gx-chat-module-box {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  background-color: #fafafa;
  position: relative;
  width: 100%;
}
.gx-chat-sidenav {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 315px;
  -ms-flex: 0 1 315px;
  flex: 0 1 315px;
  min-width: 315px;
  border-right: solid 1px #e8e8e8;
}
.gx-chat-sidenav-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 25px 20px 12px;
  background-color: #fbfbfb;
  border-bottom: solid 1px #e8e8e8;
}
.gx-chat-user-hd {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-bottom: 25px;
}
.gx-chat-search-wrapper {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-bottom: 0;
}
.gx-chat-avatar {
  min-width: 50px;
}
.gx-chat-user-row .gx-chat-avatar {
  padding: 0 5px;
  min-width: 10px;
}
.gx-chat-user-hd .gx-chat-avatar {
  cursor: pointer;
}
.gx-chat-sidenav-scroll {
  height: calc(100vh - 295px) !important;
}
.framed-layout .gx-chat-sidenav-scroll {
  height: calc(100vh - 295px - 2 * 20px) !important;
}
@media screen and (max-width: 991px) {
  .gx-chat-sidenav-scroll {
    height: calc(100vh - 175px) !important;
  }
  .framed-layout .gx-chat-sidenav-scroll {
    height: calc(100vh - 175px) !important;
  }
}
.gx-chat-sidenav-scroll > div:first-child {
  overflow-y: scroll !important;
}
.gx-chat-sidenav-scroll-tab-1,
.gx-chat-sidenav-scroll-tab-2 {
  height: calc(100vh - 320px) !important;
}
.framed-layout .gx-chat-sidenav-scroll-tab-1,
.framed-layout .gx-chat-sidenav-scroll-tab-2 {
  height: calc(100vh - 320px - 2 * 20px) !important;
}
@media screen and (max-width: 991px) {
  .gx-chat-sidenav-scroll-tab-1,
  .gx-chat-sidenav-scroll-tab-2 {
    height: calc(100vh - 198px) !important;
  }
  .framed-layout .gx-chat-sidenav-scroll-tab-1,
  .framed-layout .gx-chat-sidenav-scroll-tab-2 {
    height: calc(100vh - 198px) !important;
  }
}
.gx-chat-sidenav-scroll-tab-1 > div:first-child,
.gx-chat-sidenav-scroll-tab-2 > div:first-child {
  overflow-y: scroll !important;
}
.gx-chat-list-scroll {
  height: calc(100vh - 268px) !important;
}
.framed-layout .gx-chat-list-scroll {
  height: calc(100vh - 268px - 2 * 20px) !important;
}
@media screen and (max-width: 1199px) {
  .gx-chat-list-scroll {
    height: calc(100vh - 242px) !important;
  }
  .framed-layout .gx-chat-list-scroll {
    height: calc(100vh - 242px - 2 * 20px) !important;
  }
}
@media screen and (max-width: 991px) {
  .framed-layout .gx-chat-list-scroll {
    height: calc(100vh - 242px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-chat-list-scroll {
    height: calc(100vh - 220px) !important;
  }
}
.gx-chat-list-scroll > div:first-child {
  overflow-y: scroll !important;
}
.gx-chat-sidenav-content {
  background-color: #ffffff;
}
.gx-chat-sidenav-title {
  padding: 10px 16px;
  font-size: 14px;
  color: #1890ff;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
@media screen and (max-width: 1199px) {
  .gx-chat-sidenav-title {
    font-size: 16px;
  }
}
@media screen and (max-width: 767px) {
  .gx-chat-sidenav-title {
    font-size: 15px;
  }
}
.gx-chat-tabs-header {
  background-color: #fbfbfb !important;
}
.gx-chat-user {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-chat-user.gx-chat-user-center {
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-chat-user.gx-chat-user-center .gx-chat-avatar {
  margin-left: auto;
}
.gx-chat-user-item {
  padding: 16px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  cursor: pointer;
  max-height: 96px;
}
.gx-chat-user-item:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
}
.gx-chat-user-item.active,
.gx-chat-user-item:hover {
  background-color: #908b94;
}
.gx-chat-user-row {
  margin: 0 -5px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-tabs-half .ant-tabs-nav-list,
.gx-tabs-half .ant-tabs-nav:before {
  width: 100%;
}
.gx-chat-info {
  max-width: calc(100% - 80px);
  padding: 0 5px;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-chat-info p {
  margin-bottom: 0;
}
.gx-chat-info .h4 {
  display: block;
  margin-bottom: 3px;
}
.gx-chat-info-des {
  color: #595959;
  font-size: 13px;
}
.gx-chat-contact-col {
  max-width: calc(100% - 50px);
  padding: 0 5px;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-chat-contact-col p {
  margin-bottom: 0;
}
.gx-chat-contact-col .h4 {
  display: block;
  margin-bottom: 3px;
}
.gx-chat-date {
  padding: 0 5px;
  text-align: right;
}
.gx-fs-80 {
  font-size: 80px !important;
  line-height: 80px !important;
}
.gx-comment-box .gx-fs-80 {
  text-align: center;
  margin-bottom: 12px;
}
@media screen and (max-width: 575px) {
  .gx-fs-80 {
    font-size: 60px !important;
    line-height: 60px !important;
  }
}
.gx-comment-box {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  height: calc(100vh - 122px) !important;
}
.framed-layout .gx-comment-box {
  height: calc(100vh - 122px - 2 * 20px) !important;
}
@media screen and (max-width: 991px) {
  .framed-layout .gx-comment-box {
    height: calc(100vh - 122px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-comment-box {
    height: calc(100vh - 100px) !important;
  }
}
.gx-chat-box {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: 100%;
  position: relative;
  z-index: 2;
}
.gx-chat-main {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-chat-main-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  border-bottom: solid 1px #e8e8e8;
  padding: 16px;
  background-color: #ffffff;
  width: 100%;
}
@media screen and (max-width: 1199px) {
  .gx-chat-main-header {
    padding: 8px 16px;
  }
}
@media screen and (max-width: 991px) {
  .gx-chat-main-header {
    padding: 8px 30px;
  }
}
.gx-chat-main-header-info {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-right: auto;
}
.gx-chat-contact-name {
  font-size: 20px;
  font-weight: 500;
}
@media screen and (max-width: 1199px) {
  .gx-chat-contact-name {
    font-size: 16px;
  }
}
@media screen and (max-width: 767px) {
  .gx-chat-contact-name {
    font-size: 15px;
  }
}
.gx-chat-main-footer {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  border-top: solid 1px #e8e8e8;
  padding: 6px 16px;
  background-color: #ffffff;
  width: 100%;
}
.gx-chat-main-footer .gx-form-group {
  margin-bottom: 0;
}
.gx-chat-item {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 16px;
}
@media screen and (max-width: 991px) {
  .gx-chat-item {
    padding: 16px 30px;
  }
}
.gx-chat-item .gx-bubble-block {
  width: calc(100% - 40px);
}
.gx-chat-item .gx-bubble {
  padding: 12px 15px;
  background-color: #ffffff;
  -webkit-border-radius: 20px 20px 20px 0px;
  -moz-border-radius: 20px 20px 20px 0px;
  border-radius: 20px 20px 20px 0px;
  position: relative;
  margin-left: 16px;
  max-width: 600px;
  border: solid 1px #d9d9d9;
  display: inline-block;
}
.gx-chat-item.gx-flex-row-reverse .gx-bubble-block {
  text-align: right;
}
.gx-chat-item.gx-flex-row-reverse .gx-bubble {
  margin-right: 16px;
  margin-left: 0;
  background-color: #908b94;
  -webkit-border-radius: 20px 20px 0 20px;
  -moz-border-radius: 20px 20px 0 20px;
  border-radius: 20px 20px 0 20px;
  text-align: left;
}
.gx-chat-item .ant-avatar {
  display: block;
}
.gx-chat-btn {
  font-size: 38px !important;
  margin-right: 20px;
}
textarea.gx-chat-textarea {
  height: 40px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.gx-chat-sent {
  min-width: 40px;
  line-height: 40px;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
}
.gx-last-message-time {
  font-size: 11px;
  color: #8c8c8c;
}
@media screen and (max-width: 1199px) {
  .gx-chat-main-header .gx-size-60 {
    height: 50px !important;
    width: 50px !important;
    line-height: 50px;
  }
  .gx-chat-main-header button {
    margin-bottom: 0;
  }
  .gx-chat-main-header-info .gx-status-pos {
    max-width: 50px;
  }
}
@media screen and (max-width: 575px) {
  .gx-module-default h1 {
    font-size: 17px;
  }
}
/*Contact Apps Styles*/
.gx-contact-item {
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 8px 28px;
}
.gx-contact-item:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
}
.gx-dragndrop-item {
  padding: 24px 16px;
}
.gx-dragndrop-item .gx-draggable-icon {
  margin-left: -16px;
}
@media screen and (max-width: 575px) {
  .gx-dragndrop-item {
    padding-right: 5px;
  }
}
.gx-contact-list-info {
  padding-left: 10px;
}
.gx-contact-list-info .gx-email {
  word-break: break-all;
}
.gx-contact-list-info .gx-toolbar-separator {
  display: inline-block;
}
@media screen and (max-width: 575px) {
  .gx-contact-list-info .gx-toolbar-separator {
    display: none;
  }
}
@media screen and (max-width: 575px) {
  .gx-contact-list-info {
    padding-left: 0;
    max-width: calc(100% - 50px);
  }
  .gx-contact-list-info .gx-job-title {
    display: none;
  }
}
.gx-module-contact-content {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-module-contact-right {
  margin-left: 8px;
}
.gx-contact-name {
  font-size: 15px;
}
.gx-draggable-icon {
  cursor: all-scroll;
  color: #8c8c8c;
}
.gx-draggable-icon:hover,
.gx-draggable-icon:focus,
.gx-draggable-icon:active {
  cursor: all-scroll;
  color: #262626;
}
.gx-module-side-nav {
  padding: 20px 0;
}
.gx-modal-box-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-modal-box-row .gx-modal-box-avatar {
  -webkit-order: 2;
  -ms-order: 2;
  order: 2;
  margin-left: 16px;
}
.gx-modal-box-row .gx-modal-box-avatar .ant-avatar {
  width: 120px;
  height: 120px;
}
@media screen and (max-width: 575px) {
  .gx-modal-box-row .gx-modal-box-avatar {
    -webkit-order: 1;
    -ms-order: 1;
    order: 1;
    margin-left: 0;
    margin-bottom: 16px;
    text-align: center;
  }
}
.gx-modal-box-row .gx-modal-box-form-item {
  -webkit-order: 1;
  -ms-order: 1;
  order: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
@media screen and (max-width: 575px) {
  .gx-modal-box-row .gx-modal-box-form-item {
    -webkit-order: 2;
    -ms-order: 2;
    order: 2;
  }
}
@media screen and (max-width: 575px) {
  .gx-modal-box-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
.gx-dragndrop-actions {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
/* Calendar Apps Style */
.gx-rbc-calendar {
  overflow: hidden;
  padding-bottom: 32px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
@media screen and (max-width: 575px) {
  .gx-rbc-calendar {
    margin-bottom: 20px;
  }
}
.gx-rbc-calendar .rbc-calendar {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  height: 100%;
}
.rbc-event {
  background-color: var(--app-primary-color);
}
.rbc-event.rbc-selected {
  background-color: #1a0c2e;
}
.rbc-slot-selection {
  background-color: #6f617a;
}
.rbc-toolbar button:active,
.rbc-toolbar button.rbc-active {
  color: #ffffff;
  background-image: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  background-color: #5a456e;
  border-color: var(--app-primary-color);
}
.rbc-toolbar button:active:hover,
.rbc-toolbar button.rbc-active:hover,
.rbc-toolbar button:active:focus,
.rbc-toolbar button.rbc-active:focus,
.rbc-toolbar button:focus,
.rbc-toolbar button:hover {
  color: #ffffff;
  background-color: #5a456e;
  border-color: var(--app-primary-color);
}
.rbc-month-row {
  min-height: 100px;
}
.rbc-event {
  min-height: 50px;
}
.rbc-btn-group button {
  cursor: pointer;
}
@media screen and (max-width: 867px) {
  .rbc-toolbar {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-align-items: flex-start;
    -ms-align-items: flex-start;
    align-items: flex-start;
  }
  .rbc-toolbar .rbc-toolbar-label {
    margin: 8px 0;
  }
}
@media screen and (max-width: 467px) {
  .rbc-toolbar {
    font-size: 12px;
  }
  .rbc-toolbar button {
    padding: 5px 10px;
  }
}
/* Calendar Components Style */
.gx-com-calendar .ant-fullcalendar-header .ant-select {
  margin-left: 8px;
  margin-bottom: 8px;
}
.gx-com-calendar .ant-picker-calendar-header {
  flex-wrap: wrap;
}
.gx-com-calendar .ant-picker-calendar-header .ant-select {
  margin-bottom: 8px;
}
@media screen and (max-width: 349px) {
  .gx-com-calendar {
    margin: 0 -20px;
  }
}
.gx-com-calendar .ant-select .ant-select-arrow {
  top: 50%;
}
.gx-com-calendar-card {
  border: solid 1px #e8e8e8;
  max-width: 300px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
@media screen and (max-width: 349px) {
  .gx-com-calendar-card .gx-com-calendar {
    margin: 0;
  }
}
.gx-profileon {
  margin-bottom: 20px;
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.gx-profileon-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 20px;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0);
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.9)));
  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  background: -o-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
}
.gx-profileon-content * {
  color: #ffffff;
}
.gx-agents-list .gx-profileon-content {
  padding: 10px;
}
.gx-profileon-thumb {
  position: relative;
}
.gx-profileon-thumb > img {
  width: 100%;
}
.gx-profileon-thumb-htctrcrop {
  overflow: hidden;
  padding-bottom: 80%;
  position: relative;
}
.gx-profileon-thumb-htctrcrop > img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  width: 100%;
}
.gx-profileon-title {
  margin-bottom: 5px;
}
.gx-agents-list .gx-profileon {
  margin-bottom: 0;
}
.gx-follower {
  border-bottom: solid 1px #d9d9d9;
  padding-bottom: 20px;
  margin-bottom: 15px;
}
.gx-follower-list {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  list-style: none;
  padding-left: 0;
  margin: 0 -5px;
}
.gx-profile-banner .gx-follower-list {
  margin: 0 -20px;
}
.gx-follower-list li {
  color: #8c8c8c;
  font-size: 14px;
  padding: 0 5px;
  width: 33.33%;
}
.gx-profile-banner .gx-follower-list li {
  color: #ffffff;
  padding: 0 20px;
  width: auto;
}
.gx-follower-list li:not(:first-child) {
  border-left: solid 1px #d9d9d9;
}
.gx-profile-banner .gx-follower-list li:not(:first-child) {
  border-left-color: #ffffff;
}
.gx-follower-title {
  display: block;
  color: #262626;
  font-size: 14px;
}
.gx-profile-banner .gx-follower-title {
  color: #ffffff;
}
.gx-wall-scroll {
  height: calc(100vh - 154px) !important;
}
.framed-layout .gx-wall-scroll {
  height: calc(100vh - 152px - 2 * 20px) !important;
}
@media screen and (max-width: 991px) {
  .gx-wall-scroll {
    height: calc(100vh - 124px) !important;
  }
  .framed-layout .gx-wall-scroll {
    height: calc(100vh - 124px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-wall-scroll {
    height: calc(100vh - 132px) !important;
  }
}
.gx-wall-postlist {
  padding: 5px;
}
.gx-entry-sec {
  position: relative;
  margin-bottom: 20px;
}
.ant-card .gx-entry-sec,
.gx-card .gx-entry-sec {
  margin-bottom: 0;
}
.gx-entry-title {
  border-bottom: solid 1px #d9d9d9;
  padding-bottom: 15px;
  margin-bottom: 20px;
  font-size: 16px;
  position: relative;
}
.gx-entry-title:before {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  z-index: 1;
  height: 3px;
  width: 42px;
  background-color: var(--app-primary-color);
}
.ant-card .gx-entry-title:before,
.gx-card .gx-entry-title:before {
  display: none;
}
.ant-card .gx-entry-title,
.gx-card .gx-entry-title {
  border-bottom: 0 none;
  margin-bottom: 15px;
  padding-bottom: 0;
}
.gx-fnd-list {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0 -5px 20px;
}
.gx-fnd-list li {
  width: 33.33%;
  padding: 0 5px;
}
@media (max-width: 399px) {
  .gx-fnd-list li {
    width: 50%;
  }
}
.gx-user-fnd {
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.gx-user-fnd > img {
  width: 100%;
}
.gx-user-fnd-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.1);
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.1)), to(rgba(0, 0, 0, 0.95)));
  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));
  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));
  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));
  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));
  color: #ffffff;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-user-fnd-content h6 {
  color: #ffffff;
  -ms-flex-item-align: end;
  align-self: flex-end;
  margin-bottom: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-user-fnd-content .ant-badge {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
  margin: 0;
  width: 10px;
  height: 10px;
  display: block;
}
.gx-user-fnd-content .ant-badge-status-dot {
  width: 10px;
  height: 10px;
  display: block;
  top: 0;
  border: solid 1px #ffffff;
}
.gx-gallery-list {
  list-style: none;
  padding-left: 0;
  margin: 0 -0.5px 15px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  overflow: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-gallery-list li {
  padding: 0 0.5px;
  margin-bottom: 1px;
  width: 33.33%;
}
@media (max-width: 399px) {
  .gx-gallery-list li {
    width: 50%;
  }
}
.gx-gallery-list li > img {
  width: 100%;
}
.gx-gallery-thumb {
  position: relative;
  cursor: pointer;
}
.gx-gallery-thumb:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.01);
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.01)), to(rgba(0, 0, 0, 0.95)));
  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));
  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));
  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));
  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));
}
.gx-gallery-thumb-content {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  padding: 10px;
  color: #ffffff;
}
.gx-gallery-thumb-content h6 {
  color: #ffffff;
  margin-bottom: 0;
  font-size: 10px;
}
.gx-wall-user-info {
  margin-bottom: 6px;
}
.gx-wall-user-title {
  margin-bottom: 4px;
}
.gx-gallery-item {
  position: relative;
  margin-bottom: 15px;
}
.gx-gallery-item img {
  width: 100%;
  cursor: pointer;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.gx-gallery-item-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.7);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  color: #ffffff;
}
.gx-gallery-grid {
  margin: 0 -5px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-gallery-grid .gx-gallery-item {
  padding: 0 5px;
}
.gx-gallery-grid .gx-gallery-item-content {
  left: 5px;
  right: 5px;
}
.gx-gallery-2 .gx-gallery-item,
.gx-gallery-4 .gx-gallery-item,
.gx-gallery-4-more .gx-gallery-item {
  width: 50%;
}
.gx-gallery-3 .gx-gallery-item {
  width: 33.33%;
}
.gx-wall-comment-box {
  padding: 0 30px;
}
@media screen and (max-width: 1199px) {
  .gx-wall-comment-box {
    padding: 0 20px;
  }
}
@media screen and (max-width: 1100px) {
  .gx-wall-comment-box {
    padding: 0;
  }
}
@media screen and (max-width: 991px) {
  .gx-wall-comment-box {
    padding: 0 30px;
  }
}
@media screen and (max-width: 767px) {
  .gx-wall-comment-box {
    padding-right: 0;
    padding-left: 15px;
  }
}
.gx-profile-banner {
  padding: 32px;
  padding-bottom: 88px;
  margin: -32px;
  margin-bottom: -58px;
  background-color: var(--app-primary-color);
  color: #ffffff;
  position: relative;
}
@media screen and (max-width: 575px) {
  .gx-profile-banner {
    padding: 20px 15px;
    padding-bottom: 83px;
    margin: -20px -15px;
    margin-bottom: -58px;
  }
}
.gx-profile-banner:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
.gx-profile-banner > div {
  position: relative;
  z-index: 2;
}
.gx-profile-banner-top {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-bottom: 40px;
}
@media (max-width: 575px) {
  .gx-profile-banner-top {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    margin-bottom: 25px;
  }
}
.gx-profile-banner-top-left {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media (max-width: 575px) {
  .gx-profile-banner-top-left {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    margin-bottom: 25px;
  }
}
.gx-profile-banner-avatar {
  margin-right: 1.5rem;
}
@media (max-width: 575px) {
  .gx-profile-banner-avatar {
    margin-bottom: 8px;
    margin-right: 0;
  }
}
.gx-profile-banner-top-right {
  text-align: center;
  margin-left: auto;
}
@media (max-width: 575px) {
  .gx-profile-banner-top-right {
    margin-left: 0;
  }
}
.gx-profile-banner-bottom {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media (max-width: 575px) {
  .gx-profile-banner-bottom {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .gx-profile-banner-bottom .gx-tab-list {
    margin-bottom: 10px;
  }
}
.gx-profile-banner h1,
.gx-profile-banner h2,
.gx-profile-banner h3,
.gx-profile-banner h4,
.gx-profile-banner h5,
.gx-profile-banner h6,
.gx-profile-banner .h1,
.gx-profile-banner .h2,
.gx-profile-banner .h3,
.gx-profile-banner .h4,
.gx-profile-banner .h5,
.gx-profile-banner .h6 {
  color: #ffffff;
}
.gx-profile-banner .gx-link {
  color: #ffffff;
}
.gx-profile-banner .gx-link:hover,
.gx-profile-banner .gx-link:focus {
  color: var(--app-secondary-color);
}
.gx-profile-content {
  position: relative;
  z-index: 2;
}
.gx-profile-setting {
  margin-left: auto;
}
@media (max-width: 575px) {
  .gx-profile-setting {
    margin-left: 0;
  }
}
@media (max-width: 575px) {
  .gx-profile-content-right {
    display: -webkit-flex !important;
    display: -ms-flexbox !important;
    display: -ms-flex !important;
    display: flex !important;
    -webkit-flex-direction: row !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
    -webkit-flex-wrap: wrap !important;
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
    -webkit-align-items: center !important;
    -ms-align-items: center !important;
    align-items: center !important;
  }
  .gx-profile-content-right .gx-text-truncate {
    width: auto;
    margin-left: auto;
  }
}
.gx-pro-contact-list:not(:last-child) {
  margin-bottom: 1rem;
}
/*Callout Styles*/
/*Different size images set in Equal block height and width*/
.gx-thumb-equal,
.gx-grid-thumb-equal {
  position: relative;
  padding-bottom: 68%;
  height: 0;
  width: 100%;
  overflow: hidden;
}
.gx-thumb-cover,
.gx-grid-thumb-cover {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
}
.gx-thumb-cover-img,
.gx-grid-thumb-cover img {
  height: auto;
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  width: 100%;
}
.gx-product-image .gx-grid-thumb-equal {
  padding-bottom: 82%;
}
/*Product listing page styles*/
.gx-product-row {
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  text-align: right;
}
.gx-product-row.even {
  text-align: left;
}
.gx-product-col {
  order: 1;
  width: 50%;
}
.odd .gx-product-thumb {
  order: 2;
}
.gx-product-content {
  padding: 20px 55px;
}
.gx-product-content p {
  margin-bottom: 10px;
}
.gx-product-row .gx-grid-thumb-equal {
  padding-bottom: 69%;
}
.gx-product-thumb img {
  width: 100%;
}
.gx-product-content h4 {
  margin-bottom: 25px;
}
@media screen and (max-width: 1230px) {
  .gx-product-row .gx-grid-thumb-equal {
    padding-bottom: 71%;
  }
}
@media screen and (max-width: 1199px) {
  .gx-product-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    text-align: center;
  }
  .gx-product-row.even {
    text-align: center;
  }
  .gx-product-content h4 {
    margin-bottom: 10px;
  }
  .gx-product-content {
    padding: 20px 35px;
  }
  .gx-product-col,
  .odd .gx-product-thumb {
    order: 1;
    width: 100%;
  }
  .gx-product-row .gx-grid-thumb-equal {
    padding-bottom: 40%;
  }
}
@media screen and (max-width: 991px) {
  .gx-product-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: right;
  }
  .gx-product-row.even {
    text-align: left;
  }
  .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 120%;
  }
  .gx-product-col,
  .odd .gx-product-thumb {
    order: 1;
    width: 50%;
  }
  .odd .gx-product-thumb {
    order: 2;
  }
  .gx-product-row .gx-grid-thumb-equal {
    padding-bottom: 70%;
  }
}
@media screen and (max-width: 767px) {
  .gx-product-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    text-align: center;
  }
  .gx-product-row.even {
    text-align: center;
  }
  .gx-product-row:last-child .gx-product-col {
    padding-bottom: 0;
  }
  .gx-product-row:last-child .ant-btn {
    margin-bottom: 0;
  }
  .gx-product-content {
    padding: 20px 0;
  }
  .gx-product-col,
  .odd .gx-product-thumb {
    order: 1;
    width: 100%;
  }
  .gx-product-row .gx-grid-thumb-equal {
    padding-bottom: 44%;
  }
  .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 44%;
  }
}
/*E-commerce Styles*/
.gx-product-item {
  overflow: hidden;
  background: #fff;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  margin-bottom: 32px;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
}
@media screen and (max-width: 575px) {
  .gx-product-item {
    margin-bottom: 20px;
  }
}
.gx-product-body {
  padding: 24px;
}
.gx-product-body + .gx-product-footer {
  padding-top: 0;
}
.gx-product-body :last-child {
  margin-bottom: 0;
}
.gx-product-image > img {
  width: 100%;
}
.gx-product-footer {
  padding: 24px;
  padding-bottom: 15px;
}
.gx-product-horizontal {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-product-horizontal .gx-product-image {
  width: 25%;
}
@media screen and (max-width: 1199px) {
  .gx-product-horizontal .gx-product-image {
    width: 33.33333%;
  }
}
@media screen and (max-width: 991px) {
  .gx-product-horizontal .gx-product-image {
    width: 25%;
  }
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-image {
    width: 100%;
  }
}
.gx-product-horizontal .gx-product-body {
  width: 53%;
}
@media screen and (min-width: 1400px) {
  .gx-product-horizontal .gx-product-body {
    width: 55%;
  }
}
@media screen and (max-width: 1199px) {
  .gx-product-horizontal .gx-product-body {
    width: 41.66667%;
  }
}
@media screen and (max-width: 991px) {
  .gx-product-horizontal .gx-product-body {
    width: 50%;
  }
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-body {
    width: 100%;
  }
}
.gx-product-horizontal .gx-product-body + .gx-product-footer {
  padding-top: 24px;
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-body + .gx-product-footer {
    padding-top: 0;
  }
}
.gx-product-horizontal .gx-product-footer {
  width: 22%;
  text-align: center;
}
@media screen and (min-width: 1400px) {
  .gx-product-horizontal .gx-product-footer {
    width: 20%;
  }
}
.gx-product-horizontal .gx-product-footer .ant-btn:not(:last-child) {
  margin-left: 8px;
  margin-right: 8px;
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-footer .ant-btn:not(:last-child) {
    margin-left: 0;
  }
}
.gx-product-horizontal .gx-product-footer .ant-btn:last-child {
  margin-left: 8px;
  margin-right: 8px;
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-footer {
    width: 100%;
    text-align: left;
  }
}
.gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
  padding-bottom: 82%;
}
@media screen and (min-width: 1400px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 55%;
  }
}
@media screen and (max-width: 1199px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 80%;
  }
}
@media screen and (max-width: 1080px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 90%;
  }
}
@media screen and (max-width: 1000px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 110%;
  }
  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 80%;
  }
}
@media screen and (max-width: 991px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 88%;
  }
  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 128%;
  }
}
@media screen and (max-width: 849px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 110%;
  }
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 44%;
  }
  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 44%;
  }
}
.gx-product-vertical {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: calc(100% - 32px);
}
@media screen and (max-width: 575px) {
  .gx-product-vertical {
    height: calc(100% - 20px);
  }
}
.gx-product-vertical .gx-product-body {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-product-title {
  font-size: 18px;
}
/*Pricing Tables Styles*/
.gx-price-tables {
  position: relative;
}
.gx-package {
  position: relative;
  margin-bottom: 15px;
  overflow: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  height: calc(100% - 15px);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
  -ms-transform: scale(0.95);
  -o-transform: scale(0.95);
  transform: scale(0.95);
}
.gx-package:hover,
.gx-package:focus,
.gx-package:active {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);
  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);
}
.gx-pt-dark .gx-package:hover,
.gx-pt-dark .gx-package:focus,
.gx-pt-dark .gx-package:active {
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}
.gx-pt-classic .gx-package {
  border: 0 none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.gx-package.gx-highlight {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
  z-index: 2;
}
.gx-package-header {
  padding: 30px;
  text-align: center;
}
.gx-package-header > .gx-price {
  display: inline-block;
  font-size: 36px;
  font-weight: 500;
  margin-left: 0;
  margin-bottom: 12px;
  color: #ffffff;
}
.gx-package-header > .gx-price > i {
  display: inline-block;
  margin-right: 6px;
  font-weight: bold;
}
.gx-package-header h5 {
  color: inherit;
}
.gx-package-header.gx-text-black > .gx-price {
  color: #595959 !important;
}
@media only screen and (max-width: 991px) {
  .gx-package-header {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.gx-package-body {
  padding: 50px 30px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  .gx-package-body {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.gx-package-items {
  list-style: none;
  font-size: 14px;
  margin: 0 0 20px;
  padding-left: 0;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-package-items li {
  margin-bottom: 16px;
  line-height: inherit;
}
.gx-package-items li::before {
  display: table;
  content: '';
}
.gx-package-items li::after {
  display: table;
  clear: both;
  content: '';
}
.gx-package-items li::before {
  display: table;
  content: '';
}
.gx-package-items li::after {
  display: table;
  clear: both;
  content: '';
}
.gx-package-items li i {
  float: left;
  min-width: 20px;
  margin-right: 16px;
  line-height: inherit;
}
.gx-package-items li span {
  display: block;
  overflow: hidden;
}
.gx-package-footer {
  padding-top: 30px;
}
.gx-package-footer .ant-btn {
  text-transform: capitalize;
  border: 0 none;
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .gx-package:hover,
  .gx-package:focus,
  .gx-package:active,
  .gx-package.gx-highlight {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}
.gx-text-black .gx-text-white {
  color: #595959 !important;
}
.gx-pt-circle .gx-package-header {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  height: 224px;
  width: 224px;
  margin: 40px auto 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-pt-circle .gx-package-header .gx-price {
  margin-top: -5px;
}
@media only screen and (max-width: 991px) {
  .gx-pt-circle .gx-package-header .gx-price {
    font-size: 26px;
    margin-bottom: 6px;
  }
}
@media only screen and (max-width: 991px) {
  .gx-pt-circle .gx-package-header .gx-letter-spacing-base {
    letter-spacing: 1px;
  }
}
@media only screen and (max-width: 991px) {
  .gx-pt-circle .gx-package-header {
    height: 150px;
    width: 150px;
  }
}
/*Login Styles*/
.gx-login-container {
  position: relative;
  height: 100%;
  padding-bottom: 30px;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-login-content {
  max-width: 420px;
  width: 94%;
  margin: auto;
  padding: 35px 35px 20px;
  background-color: #ffffff;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  font-size: 14px;
}
.gx-login-content .ant-input {
  background-color: #f5f5f5;
  height: auto;
  padding: 6px 12px;
}
.gx-login-content .ant-input:focus {
  box-shadow: none;
  border-color: var(--app-primary-color);
}
.gx-login-content .ant-input-affix-wrapper {
  background-color: #f5f5f5;
  max-height: none;
}
.gx-login-content .ant-form-item-control-wrapper {
  width: 100%;
}
.gx-login-content .ant-form-item-children {
  display: block;
}
@media screen and (max-width: 575px) {
  .gx-login-content {
    padding: 20px 20px 10px;
  }
}
.gx-login-header {
  margin-bottom: 30px;
}
@media screen and (max-width: 575px) {
  .gx-login-header {
    margin-bottom: 15px;
  }
}
.gx-app-login-wrap {
  height: 100%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  overflow-x: hidden;
}
@media screen and (max-width: 575px) {
  .gx-app-login-wrap {
    padding-top: 20px;
    -webkit-justify-content: flex-start;
    -ms-justify-content: flex-start;
    justify-content: flex-start;
  }
}
.gx-app-login-container {
  position: relative;
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
}
@media screen and (max-width: 575px) {
  .gx-app-login-container {
    padding-bottom: 20px;
  }
}
.gx-app-login-container .gx-loader-view {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  z-index: 2;
}
.gx-app-login-main-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background-color: #ffffff;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  font-size: 14px;
  overflow: hidden;
}
.gx-app-login-content {
  padding: 35px 51px 20px;
  width: 50%;
}
.gx-app-login-content .gx-btn {
  padding: 6px 35px !important;
  height: auto;
}
.gx-app-login-content .ant-form-item-control-wrapper {
  width: 100%;
}
.gx-app-login-content .ant-form-item-children {
  display: block;
}
@media screen and (max-width: 575px) {
  .gx-app-login-content {
    width: 100%;
    padding: 20px 20px 10px;
  }
}
.gx-app-login-header {
  margin-bottom: 30px;
}
@media screen and (max-width: 575px) {
  .gx-app-login-header {
    margin-bottom: 15px;
  }
}
.gx-app-logo-content {
  color: #ffffff;
  width: 50%;
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: nowrap;
  -ms-flex-direction: nowrap;
  flex-direction: nowrap;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-app-logo-content > * {
  position: relative;
  z-index: 2;
}
.gx-app-logo-content h1 {
  color: #ffffff;
}
@media screen and (max-width: 575px) {
  .gx-app-logo-content {
    width: 100%;
    padding: 20px 20px 10px;
  }
}
.gx-app-logo-content-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.gx-app-logo-content-bg:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  right: 0;
  bottom: 0;
}
.gx-app-logo-content-bg img {
  width: 100%;
  height: 100%;
}
.gx-app-logo-wid {
  margin-bottom: auto;
}
.gx-app-social-block {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}
.gx-app-social-block .gx-social-link,
.gx-app-social-block .gx-social-link li {
  margin: 0;
}
.gx-app-social-block .gx-social-link span {
  border: solid 1px var(--app-primary-color);
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  color: var(--app-primary-color);
}
.gx-app-social-block .gx-social-link span:hover,
.gx-app-social-block .gx-social-link span:focus {
  color: #ffffff;
  background-color: var(--app-primary-color);
}
.gx-app-social-block p {
  margin-bottom: 0;
}
.gx-signin-form .ant-form-item-control-input {
  min-height: 40px;
}
/*Dashboard Styles*/
.ant-list-item-meta {
  flex-wrap: wrap;
}
.gx-task-list-item {
  position: relative;
}
.gx-task-list-item:not(:last-child) {
  margin-bottom: 15px;
}
.gx-card-ticketlist .gx-task-list-item:not(:last-child) {
  margin-bottom: 20px;
}
.gx-card-tabs .gx-task-list-item:last-child {
  margin-bottom: 15px;
}
.gx-card-ticketlist .gx-task-list-item .gx-hover {
  display: none;
}
@media screen and (max-width: 575px) {
  .gx-card-ticketlist .gx-task-list-item .gx-hover {
    display: block;
  }
}
@media screen and (max-width: 575px) {
  .gx-card-ticketlist .gx-task-list-item .gx-nonhover {
    display: none;
  }
}
.gx-card-ticketlist .gx-task-list-item:hover .gx-hover {
  display: inline-block;
}
.gx-card-ticketlist .gx-task-list-item:hover .gx-nonhover {
  display: none;
}
.gx-card-ticketlist .gx-task-list-item:hover .gx-task-item-title {
  color: var(--app-primary-color);
}
.gx-task-list-item:hover {
  cursor: pointer;
}
.gx-task-list-item:hover .gx-text-hover {
  color: var(--app-primary-color);
}
.gx-task-item-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
  max-width: calc(100% - 40px);
}
.gx-task-item-content-left {
  width: calc(100% - 250px);
}
@media screen and (max-width: 575px) {
  .gx-task-item-content-left {
    width: 100%;
    margin-bottom: 10px;
    padding-right: 60px;
  }
}
.gx-card-ticketlist .gx-task-item-content-left {
  width: calc(100% - 100px);
}
@media screen and (max-width: 575px) {
  .gx-card-ticketlist .gx-task-item-content-left {
    width: 100%;
    padding-right: 0;
  }
}
.gx-task-item-content-right {
  width: 250px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: flex-end;
  -ms-justify-content: flex-end;
  justify-content: flex-end;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  padding-left: 10px;
}
@media screen and (max-width: 575px) {
  .gx-task-item-content-right {
    width: 100%;
    padding-left: 0;
    -webkit-justify-content: flex-start;
    -ms-justify-content: flex-start;
    justify-content: flex-start;
  }
}
.gx-card-ticketlist .gx-task-item-content-right {
  padding-top: 8px;
  width: 100px;
}
@media screen and (max-width: 575px) {
  .gx-card-ticketlist .gx-task-item-content-right {
    width: 100%;
    padding-top: 0;
  }
}
.gx-card-ticketlist .gx-task-item-content {
  max-width: calc(100% - 52px);
}
.gx-task-item-content .gx-task-date {
  min-width: 55px;
  text-align: right;
}
.gx-task-item-content .ant-tag {
  min-width: 60px;
  text-align: center;
}
@media screen and (max-width: 575px) {
  .gx-task-item-content {
    flex-direction: column;
    position: relative;
  }
  .gx-task-item-content .gx-task-date {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
  .gx-card-ticketlist .gx-task-item-content {
    padding-right: 0;
  }
}
.gx-card-ticketlist .gx-link {
  color: var(--app-primary-color);
}
.gx-card-testimonial {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
  margin-bottom: 12px;
}
.gx-card-testimonial-img {
  margin-right: 10px;
  margin-bottom: 10px;
}
.gx-card-testimonial-content {
  background-color: #f5f5f5;
  padding: 15px;
  position: relative;
  margin-left: 10px;
  width: calc(100% - 70px);
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.gx-card-testimonial-content:before {
  content: "";
  position: absolute;
  left: -10px;
  top: 10px;
  z-index: 1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-right: 10px solid #f5f5f5;
}
.gx-card-testimonial-content > :last-child {
  margin-bottom: 0;
}
.gx-progress-task {
  position: relative;
}
.gx-progress-task :last-child {
  margin-bottom: 0;
}
.gx-progress-task-list {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-bottom: 15px;
}
.gx-progress-task-list + .gx-progress-task-list {
  border-top: solid 1px #e8e8e8;
  padding-top: 15px;
}
.gx-progress-task-list .ant-progress {
  margin-bottom: 15px;
}
.gx-progress-task-list-content {
  margin-left: 20px;
  margin-bottom: 15px;
}
@media screen and (max-width: 575px) {
  .gx-progress-task-list {
    margin-bottom: 0;
  }
}
.gx-act-task {
  position: relative;
}
.gx-act-task-cell {
  margin-bottom: 20px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}
@media screen and (max-width: 575px) {
  .gx-act-task-cell {
    margin-bottom: 10px;
  }
}
.gx-act-task-content {
  width: calc(100% - 72px);
}
.gx-act-task-content label.ant-checkbox-wrapper span {
  display: block;
  overflow: hidden;
}
.gx-act-task-content label.ant-checkbox-wrapper span.ant-checkbox {
  float: left;
  padding: 6px 5px 0 0;
}
.gx-act-task-btn-view {
  margin-left: 8px;
  width: 65px;
  text-align: right;
}
@media screen and (max-width: 575px) {
  .gx-act-task-btn-view {
    margin-left: 0;
    margin-top: 10px;
  }
}
.gx-line-indicator {
  list-style: none;
  margin: 0;
  padding-left: 0;
}
.gx-line-indicator li:not(:last-child) {
  margin-bottom: 10px;
}
@media screen and (max-width: 575px) {
  .gx-line-indicator li:not(:last-child) {
    margin-bottom: 5px;
  }
}
.gx-line-indicator li p {
  margin-bottom: 0;
}
.gx-line-indicator-half {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0 -12px;
}
.gx-line-indicator-half li {
  width: 50%;
  padding: 0 12px;
}
.gx-line-indicator-col {
  width: 25%;
  padding-right: 10px;
}
@media screen and (max-width: 767px) {
  .gx-line-indicator-col {
    width: 100%;
    padding-right: 0;
  }
}
.gx-line-indi {
  height: 3px;
}
.gx-line-indi-info {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-wel-ema {
  position: relative;
}
.gx-overview-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
@media screen and (max-width: 767px) {
  .gx-overview-row {
    flex-direction: column;
  }
}
.gx-overview-description {
  width: 32%;
  color: #8c8c8c;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin: -24px;
  margin-left: 0;
  border-left: solid 1px #e8e8e8;
  order: 2;
}
@media screen and (max-width: 767px) {
  .gx-overview-description {
    order: 1;
    width: 100%;
    border-left: 0 none !important;
    border-top: solid 1px #e8e8e8;
    border-bottom: solid 1px #e8e8e8;
    margin: 15px 0 0;
  }
}
.gx-map-col {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 50px 10px 0;
  order: 1;
}
@media screen and (max-width: 767px) {
  .gx-map-col {
    order: 2;
    padding: 15px 0 0;
  }
}
.gx-revenu {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 15px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-revenu-total {
  border-bottom: solid 1px #e8e8e8;
}
.gx-revenu-total h1 {
  font-size: 34px;
  font-weight: 600;
  margin-bottom: 5px;
}
@media screen and (max-width: 767px) {
  .gx-revenu-total h1 {
    font-size: 22px;
  }
}
.gx-revenu-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}
.gx-revenu-col {
  width: 50%;
  padding: 0 15px;
  text-align: center;
}
.gx-revenu-col:not(:last-child) {
  border-right: solid 1px #e8e8e8;
}
.gx-revenu h3 {
  font-size: 20px;
  margin-bottom: 0;
  font-weight: 500;
}
.ant-divider-horizontal {
  margin: 12px 0;
}
.gx-visit-col {
  order: 1;
}
@media screen and (max-width: 1199px) {
  .gx-visit-col {
    order: 2;
    margin-top: 20px;
  }
}
.gx-audi-col {
  order: 2;
}
@media screen and (max-width: 1199px) {
  .gx-audi-col {
    order: 1;
  }
}
@media screen and (max-width: 575px) {
  .gx-audi-col {
    margin-top: 20px;
  }
}
.gx-rechart {
  position: relative;
}
.gx-rechart-prod {
  position: absolute;
  left: 30px;
  top: 0;
  z-index: 1;
}
@media (max-width: 1366px) {
  .gx-rechart-prod {
    left: 20px;
  }
}
.gx-pink-purple-gradient {
  background-color: #564093;
  background: -webkit-gradient(linear, left top, right top, from(#564093), to(#d2449d));
  background: -webkit-linear-gradient(left, #564093, #d2449d);
  background: -moz-linear-gradient(left, #564093, #d2449d);
  background: -ms-linear-gradient(left, #564093, #d2449d);
  background: -o-linear-gradient(left, #564093, #d2449d);
}
.gx-pink-purple-gradient-reverse {
  background-color: #872776;
  background: -webkit-gradient(linear, left top, right top, from(#872776), to(#352883));
  background: -webkit-linear-gradient(left, #872776, #352883);
  background: -moz-linear-gradient(left, #872776, #352883);
  background: -ms-linear-gradient(left, #872776, #352883);
  background: -o-linear-gradient(left, #872776, #352883);
}
.gx-blue-cyan-gradient {
  background: -moz-linear-gradient(125deg, #45d1e6 0%, #4363c6 100%);
  background: -webkit-gradient(linear, left top, right bottom, color-stop(0%, #45d1e6), color-stop(100%, #4363c6));
  background: -webkit-linear-gradient(125deg, #45d1e6 0%, #4363c6 100%);
  background: -o-linear-gradient(125deg, #45d1e6 0%, #4363c6 100%);
  background: -ms-linear-gradient(125deg, #45d1e6 0%, #4363c6 100%);
  background: linear-gradient(325deg, #45d1e6 0%, #4363c6 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='@hstartColor', endColorstr='@hendColor', GradientType=0);
}
.gx-app-thumb {
  display: inline-block;
}
.gx-card-cover-black .ant-card-head {
  background-color: #000000;
  color: #ffffff;
  padding-top: 20px;
}
.gx-card-cover-black .ant-card-head h1 {
  color: #ffffff;
}
.gx-card-cover-black .ant-card-head-title {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-card-cover-black .ant-card-body {
  padding: 1rem;
}
.gx-dot-arrow-hover {
  position: relative;
  overflow: hidden;
}
.gx-dot-arrow-hover:hover .gx-hover-arrow {
  left: -15px;
}
.gx-dot-arrow {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
  padding-right: 10px;
  cursor: pointer;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-dot-arrow .gx-dot {
  cursor: pointer;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-hover-arrow {
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  cursor: pointer;
  -webkit-border-radius: 50% 0 0 50%;
  -moz-border-radius: 50% 0 0 50%;
  border-radius: 50% 0 0 50%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: flex-start;
  -ms-justify-content: flex-start;
  justify-content: flex-start;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  width: 107px;
  height: 107px;
  position: absolute;
  left: 15px;
  padding: 10px;
  font-size: 20px;
}
.gx-hover-arrow .icon {
  display: flex;
}
.gx-actchart {
  margin-bottom: -4px;
}
.gx-user-wid {
  width: 80px;
  position: relative;
}
.gx-user-wid img {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
.gx-user-wid-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-user-wid-body {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.boxed-layout .gx-build-box-lay,
.framed-layout .gx-build-box-lay {
  padding: 0 10px !important;
}
.boxed-layout .gx-build-box-lay img,
.framed-layout .gx-build-box-lay img {
  width: 50px;
}
@media (max-width: 1366px) {
  .gx-build-box-lay {
    padding: 0 10px !important;
  }
  .gx-build-box-lay img {
    width: 50px;
  }
}
.gx-build-box-lay-content {
  max-width: calc(100% - 70px);
}
.gx-chart-title {
  font-size: 14px;
}
@media (max-width: 1366px) {
  .gx-chart-title {
    font-size: 12px;
  }
}
.gx-widget-bg {
  background-color: #4c429a;
  background: -webkit-gradient(linear, left top, right top, from(#4c429a), to(#9956ce));
  background: -webkit-linear-gradient(left, #4c429a, #9956ce);
  background: -moz-linear-gradient(left, #4c429a, #9956ce);
  background: -ms-linear-gradient(left, #4c429a, #9956ce);
  background: -o-linear-gradient(left, #4c429a, #9956ce);
  color: #ffffff;
  position: relative;
}
.gx-widget-bg h1 {
  color: #ffffff;
}
.gx-widget-badge {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  background-color: #ff6bb3;
  color: #ffffff;
  padding: 5px 12px;
  -webkit-border-radius: 0 10px 0 10px;
  -moz-border-radius: 0 10px 0 10px;
  border-radius: 0 10px 0 10px;
}
.gx-fnd-content {
  padding-right: 40px;
}
@media (max-width: 1366px) {
  .gx-fnd-content {
    padding-right: 0;
  }
}
@media screen and (max-width: 575px) {
  .gx-fnd-content {
    margin-top: 20px;
  }
}
.gx-fnd-gallery-list {
  list-style: none;
  padding-left: 0;
  margin: 0 -6px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-fnd-gallery-list li {
  padding: 0 6px;
}
.gx-fnd-gallery-list li > img {
  width: 65px;
}
@media (max-width: 1366px) {
  .gx-fnd-gallery-list li > img {
    width: 50px;
  }
}
.gx-fnd-title {
  font-size: 24px;
  margin-bottom: 15px;
}
@media (max-width: 1366px) {
  .gx-fnd-title {
    font-size: 20px;
    margin-bottom: 5px;
  }
}
.gx-chart-up {
  color: #52c41a;
}
.gx-bg-geekblue .gx-chart-up {
  color: #ffffff;
}
.gx-chart-down {
  color: #f5222d;
}
.gx-chart-down .icon {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  display: inline-block;
}
.gx-barchart {
  margin-top: -15px;
}
@media screen and (max-width: 1199px) {
  .gx-barchart {
    margin-top: 0;
  }
}
.gx-clients {
  margin-top: -7px;
  margin-bottom: -7px;
}
@media (max-width: 1366px) {
  .gx-clients {
    margin-top: -2px;
    margin-bottom: -2px;
  }
  .gx-clients .gx-size-60 {
    height: 50px !important;
    width: 50px !important;
    line-height: 50px !important;
  }
}
@media (max-width: 575px) {
  .gx-clients {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.gx-fillchart {
  position: relative;
  color: #ffffff;
  min-height: 122px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: flex-end;
  -ms-align-items: flex-end;
  align-items: flex-end;
  -webkit-transition: all 0.7s ease-out;
  -moz-transition: all 0.7s ease-out;
  -ms-transition: all 0.7s ease-out;
  -o-transition: all 0.7s ease-out;
  transition: all 0.7s ease-out;
}
.gx-fillchart-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  padding: 15px 20px;
}
.gx-overlay-fillchart .gx-fillchart-content {
  background-color: rgba(255, 255, 255, 0.35);
}
.gx-fillchart .ant-card-head-title,
.gx-fillchart h2,
.gx-fillchart .gx-chart-up,
.gx-fillchart .gx-chart-down {
  color: #ffffff;
}
.gx-fillchart .gx-chart-up,
.gx-fillchart .gx-chart-down {
  margin-right: 6px;
}
.gx-fillchart-btn {
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 1;
  -webkit-opacity: 0;
  -moz-opacity: 0;
  opacity: 0;
  visibility: hidden;
  cursor: pointer;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.gx-fillchart-btn .icon:before {
  line-height: 30px;
}
.gx-fillchart-btn-close {
  position: absolute;
  right: 10px;
  top: 10px;
  color: var(--app-primary-color);
  background-color: #ffffff;
  width: 30px;
  height: 30px;
  text-align: center;
  -webkit-opacity: 0;
  -moz-opacity: 0;
  opacity: 0;
  visibility: hidden;
  cursor: pointer;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  font-size: 16px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.gx-fillchart-btn-close .icon {
  font-size: 24px;
  width: 30px;
  height: 30px;
  line-height: 38px;
}
.gx-fillchart:hover .gx-fillchart-btn {
  -webkit-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
  visibility: visible;
}
.gx-fillchart-nocontent .gx-fillchart-content,
.gx-fillchart-nocontent .gx-fillchart-btn,
.gx-fillchart-nocontent:hover .gx-fillchart-btn {
  -webkit-opacity: 0;
  -moz-opacity: 0;
  opacity: 0;
  visibility: hidden;
}
.gx-fillchart-nocontent .gx-fillchart-btn-close {
  -webkit-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
  visibility: visible;
}
.gx-fillchart-nocontent .ant-card-head-title {
  position: absolute;
  left: 20px;
  top: 15px;
  z-index: 1;
}
.gx-agents-list {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0 -15px;
  list-style: none;
  padding-left: 0;
}
.gx-agents-list li {
  width: 20%;
  padding: 0 15px;
  margin-bottom: 30px;
}
@media screen and (max-width: 1199px) {
  .gx-agents-list li {
    width: 25%;
  }
}
@media screen and (max-width: 991px) {
  .gx-agents-list li {
    width: 20%;
  }
}
@media screen and (max-width: 767px) {
  .gx-agents-list li {
    width: 33.33%;
  }
}
@media screen and (max-width: 575px) {
  .gx-agents-list li {
    width: 50%;
    padding: 0 10px;
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 575px) {
  .gx-agents-list {
    margin: 0 -10px;
  }
}
.gx-featured-item:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
  padding-bottom: 10px;
  margin-bottom: 30px;
}
.gx-card-profile .gx-featured-item:not(:last-child) {
  padding-bottom: 8px;
  margin-bottom: 25px;
}
@media (max-width: 575px) {
  .gx-featured-item:not(:last-child) {
    margin-bottom: 27px;
  }
}
.gx-featured-item:last-child .gx-featured-thumb {
  margin-bottom: 0;
}
@media (max-width: 575px) {
  .gx-featured-item:last-child .gx-featured-thumb {
    margin-bottom: 15px;
  }
}
@media (max-width: 575px) {
  .gx-featured-item {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-align-items: normal;
    -ms-align-items: normal;
    align-items: normal;
  }
}
.gx-featured-thumb {
  position: relative;
  margin-right: 25px;
  margin-bottom: 10px;
}
@media (max-width: 575px) {
  .gx-featured-thumb {
    margin-right: 0;
    margin-bottom: 15px;
  }
  .gx-featured-thumb > img {
    width: 100% !important;
    height: auto !important;
  }
}
.gx-featured-thumb .ant-tag {
  position: absolute;
  left: 15px;
  top: 15px;
  z-index: 1;
  margin: 0;
}
.gx-card-profile .gx-featured-thumb {
  max-width: 130px;
}
@media (max-width: 575px) {
  .gx-card-profile .gx-featured-thumb {
    max-width: none;
  }
}
.gx-featured-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
@media (max-width: 1366px) {
  .gx-featured-content {
    font-size: 13px;
  }
}
@media (max-width: 1199px) {
  .gx-featured-content {
    font-size: 14px;
  }
  .gx-card-profile .gx-featured-content {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
@media (max-width: 767px) {
  .gx-featured-content {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
.gx-featured-content-right {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-left: auto;
  text-align: right;
}
.gx-card-profile .gx-featured-content-right {
  font-size: 14px;
}
@media (max-width: 1199px) {
  .gx-card-profile .gx-featured-content-right {
    text-align: left;
    margin-left: 0;
  }
  .gx-card-profile .gx-featured-content-right h2 {
    font-size: 16px;
  }
  .gx-card-profile .gx-featured-content-right h2 .gx-fs-lg {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  .gx-featured-content-right {
    margin-left: 0;
    text-align: left;
    margin-top: 15px;
  }
}
@media (max-width: 575px) {
  .gx-card-profile .gx-featured-content-right h2 {
    font-size: 14px;
  }
}
.gx-news-item {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-news-item:not(:last-child) {
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .gx-news-item:not(:last-child) {
    margin-bottom: 26px;
  }
}
@media (max-width: 575px) {
  .gx-news-item:not(:last-child) {
    margin-bottom: 22px;
  }
}
@media (max-width: 575px) {
  .gx-news-item {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
.gx-news-thumb {
  position: relative;
  margin-right: 25px;
}
@media (max-width: 1366px) {
  .gx-news-thumb {
    margin-right: 15px;
  }
}
@media (max-width: 575px) {
  .gx-news-thumb {
    margin-right: 0;
    margin-bottom: 12px;
  }
  .gx-news-thumb > img {
    width: 100% !important;
    height: auto !important;
  }
}
.gx-news-content {
  color: #686868;
  width: calc(100% - 200px);
}
@media (max-width: 1366px) {
  .gx-news-content {
    width: calc(100% - 190px);
  }
}
@media (max-width: 575px) {
  .gx-news-content {
    width: 100%;
  }
}
.gx-news-tags-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
@media (max-width: 1366px) {
  .gx-news-tags-row {
    font-size: 12px;
  }
}
.gx-news-tags-left {
  width: calc(100% - 180px);
}
@media (max-width: 1366px) {
  .gx-news-tags-left {
    width: calc(100% - 130px);
  }
}
.gx-news-tags-right {
  width: 180px;
  padding-left: 8px;
  text-align: right;
}
@media (max-width: 1366px) {
  .gx-news-tags-right {
    width: 130px;
  }
}
.gx-currentplan-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0 -5px;
}
.gx-currentplan-col {
  width: 50%;
  padding: 0 5px;
}
@media (max-width: 1366px) {
  .gx-currentplan-col {
    width: 100%;
  }
}
@media (max-width: 991px) {
  .gx-currentplan-col {
    width: 50%;
  }
}
@media (max-width: 575px) {
  .gx-currentplan-col {
    width: 100%;
  }
}
.gx-currentplan-right {
  border-left: solid 1px #e8e8e8;
}
@media (max-width: 1366px) {
  .gx-currentplan-right {
    border-left: 0 none !important;
    border-top: solid 1px #e8e8e8;
    padding-top: 10px;
  }
}
@media (max-width: 991px) {
  .gx-currentplan-right {
    border-left: solid 1px #e8e8e8 !important;
    border-top: 0 none;
    padding-top: 0;
  }
}
@media (max-width: 575px) {
  .gx-currentplan-right {
    border-left: 0 none !important;
    border-top: solid 1px #e8e8e8;
    padding-top: 22px;
  }
}
.gx-currentplan-right-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: flex-end;
  -ms-justify-content: flex-end;
  justify-content: flex-end;
  -webkit-align-items: flex-end;
  -ms-align-items: flex-end;
  align-items: flex-end;
  height: 100%;
  text-align: right;
}
@media (max-width: 1366px) {
  .gx-currentplan-right-content {
    -webkit-justify-content: flex-start;
    -ms-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-align-items: flex-start;
    -ms-align-items: flex-start;
    align-items: flex-start;
    text-align: left;
  }
}
@media (max-width: 991px) {
  .gx-currentplan-right-content {
    -webkit-justify-content: flex-end;
    -ms-justify-content: flex-end;
    justify-content: flex-end;
    -webkit-align-items: flex-end;
    -ms-align-items: flex-end;
    align-items: flex-end;
    text-align: right;
  }
}
@media (max-width: 575px) {
  .gx-currentplan-right-content {
    -webkit-justify-content: flex-start;
    -ms-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-align-items: flex-start;
    -ms-align-items: flex-start;
    align-items: flex-start;
    text-align: left;
  }
}
.gx-oth-plans-down {
  display: none;
}
@media (max-width: 1366px) {
  .gx-oth-plans-down {
    display: block;
    margin-top: 15px;
  }
}
@media (max-width: 991px) {
  .gx-oth-plans-down {
    display: none;
    margin-top: 0;
  }
}
@media (max-width: 575px) {
  .gx-oth-plans-down {
    display: block;
    margin-top: 20px;
  }
}
@media (max-width: 1366px) {
  .gx-oth-plans-up {
    display: none;
  }
}
@media (max-width: 991px) {
  .gx-oth-plans-up {
    display: block;
  }
}
@media (max-width: 575px) {
  .gx-oth-plans-up {
    display: none;
  }
}
.gx-revenue-title {
  font-weight: 600;
  font-size: 30px;
  line-height: 1;
  color: #000000;
}
@media (max-width: 1366px) {
  .gx-revenue-title {
    font-size: 28px;
  }
}
@media (max-width: 575px) {
  .gx-revenue-title {
    padding-top: 15px;
  }
}
.gx-dealclose-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-dealclose-header-right {
  margin-left: auto;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
@media (max-width: 1366px) {
  .gx-dealclose-header-right {
    margin-left: 0;
    margin-bottom: 20px;
    margin-top: 15px;
  }
}
@media (max-width: 991px) {
  .gx-dealclose-header-right {
    margin-left: auto;
    margin-bottom: 0;
    margin-top: 0;
  }
}
@media (max-width: 575px) {
  .gx-dealclose-header-right {
    margin-left: 0;
  }
}
@media (max-width: 1366px) {
  .gx-dealclose-header {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
@media (max-width: 991px) {
  .gx-dealclose-header {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
}
@media (max-width: 575px) {
  .gx-dealclose-header {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
@media (max-width: 1366px) {
  .gx-order-history .ant-table {
    font-size: 12px;
  }
}
.gx-icon-img {
  width: 60px;
  height: 60px;
}
@media screen and (max-width: 1366px) {
  .gx-icon-img {
    width: 40px;
    height: 40px;
  }
}
.gx-smart-img {
  max-height: 90px;
  width: 100%;
  object-fit: cover;
}
@media screen and (max-width: 575px) {
  .gx-smart-img {
    max-height: 180px;
  }
}
.gx-ayurveda-thumb {
  max-height: 150px;
}
.gx-ayurveda-thumb > img {
  object-fit: cover;
}
.gx-dash-search {
  position: relative;
}
@media screen and (max-width: 575px) {
  .gx-dash-search {
    padding-right: 30px;
  }
  .gx-dash-search .gx-search-icon {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }
}
.gx-bg-dark-primary {
  background-color: var(--app-primary-color);
  position: relative;
  overflow: hidden;
}
.gx-bg-dark-primary > * {
  position: relative;
  z-index: 1;
}
.gx-bg-dark-primary:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.72);
}
@media screen and (max-width: 1366px) {
  .recharts-text {
    font-size: 12px;
  }
}
@media screen and (max-width: 575px) {
  .gx-list-item .ant-list-item-content {
    flex-direction: column;
  }
}
/*Algolia Styles*/
.gx-algolia-sidebar {
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  margin-bottom: 32px;
  width: 240px !important;
}
@media screen and (max-width: 767px) {
  .gx-algolia-sidebar {
    width: 100% !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-algolia-sidebar {
    margin-bottom: 20px;
  }
}
.gx-algolia-sidebar [class^="ais-"] {
  font-size: 14px;
}
.gx-algolia-sidebar-content {
  padding: 24px;
}
.gx-algolia-sidebar .ais-ClearRefinements {
  margin-bottom: 20px;
}
.gx-algolia-sidebar .ais-HierarchicalMenu {
  margin-bottom: 20px;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-list li {
  margin-bottom: 5px;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-list li a {
  color: #545454;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-list li a:hover,
.gx-algolia-sidebar .ais-HierarchicalMenu-list li a:focus {
  color: var(--app-primary-color);
}
.gx-algolia-sidebar .ais-HierarchicalMenu-count {
  padding: 0 5px;
  font-size: 12px;
  color: #8c8c8c;
  background-color: transparent;
  border-radius: 0;
}
.gx-algolia-sidebar .ais-Panel {
  margin-bottom: 20px;
}
.gx-algolia-sidebar .ais-Panel-header {
  margin-bottom: 8px;
  padding-bottom: 0;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: 0 none;
}
.gx-algolia-sidebar .ais-RefinementList-list li {
  margin-bottom: 5px;
}
.gx-algolia-sidebar .ais-RefinementList-checkbox {
  margin-right: 12px;
}
.gx-algolia-sidebar .ais-RefinementList-labelText {
  font-size: 14px;
}
.gx-algolia-sidebar .ais-RefinementList-count {
  padding: 0 5px;
  font-size: 14px;
  color: #8c8c8c;
  background-color: transparent;
  border-radius: 0;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Breadcrumb-item--selected,
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-HierarchicalMenu-item--selected,
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Menu-item--selected {
  font-weight: normal;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Breadcrumb-item--selected > a,
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-HierarchicalMenu-item--selected > a,
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Menu-item--selected > a {
  color: var(--app-primary-color);
}
.gx-algolia-sidebar .ais-RatingMenu-item--selected {
  font-weight: 600;
}
.gx-algolia-layout-has-sider {
  flex-wrap: nowrap;
}
@media screen and (max-width: 767px) {
  .gx-algolia-layout-has-sider {
    flex-wrap: wrap;
  }
}
.gx-algolia-category-title {
  font-size: 14px;
  margin-bottom: 10px;
  color: #8c8c8c;
}
.gx-algolia-main {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: 30px;
  margin-bottom: 32px;
}
.gx-algolia-main [class^="ais-"] {
  font-size: 14px;
}
@media screen and (max-width: 767px) {
  .gx-algolia-main {
    padding-left: 0;
  }
}
@media screen and (max-width: 575px) {
  .gx-algolia-main {
    margin-bottom: 20px;
  }
}
.gx-algolia-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.gx-algolia-sort-by {
  margin-left: auto;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-algolia-sort-by label {
  margin-right: 15px;
}
@media screen and (max-width: 400px) {
  .gx-algolia-sort-by {
    margin-left: 0;
  }
}
.gx-algolia-footer {
  padding: 10px;
}
.gx-algolia-footer .ais-Pagination-list {
  flex-wrap: wrap;
}
.gx-algolia-footer .ais-Pagination-list li {
  margin-bottom: 5px;
}
.gx-algolia-content .ais-Stats {
  margin-bottom: 10px;
}
.gx-product-name [class^="ais-"] {
  font-size: 16px;
}
.gx-algolia-refinementList {
  width: 100%;
}
.gx-algolia-refinementList li.ais-RefinementList-item {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ais-RangeInput-submit,
.ais-ClearRefinements-button,
.ais-CurrentRefinements-reset,
.ais-GeoSearch-redo,
.ais-GeoSearch-reset,
.ais-HierarchicalMenu-showMore,
.ais-InfiniteHits-loadMore,
.ais-InfiniteResults-loadMore,
.ais-Menu-showMore,
.ais-RefinementList-showMore {
  background-color: var(--app-primary-color);
}
.ais-RangeInput-submit:focus,
.ais-ClearRefinements-button:focus,
.ais-CurrentRefinements-reset:focus,
.ais-GeoSearch-redo:focus,
.ais-GeoSearch-reset:focus,
.ais-HierarchicalMenu-showMore:focus,
.ais-InfiniteHits-loadMore:focus,
.ais-InfiniteResults-loadMore:focus,
.ais-Menu-showMore:focus,
.ais-RefinementList-showMore:focus,
.ais-RangeInput-submit:hover,
.ais-ClearRefinements-button:hover,
.ais-CurrentRefinements-reset:hover,
.ais-GeoSearch-redo:hover,
.ais-GeoSearch-reset:hover,
.ais-HierarchicalMenu-showMore:hover,
.ais-InfiniteHits-loadMore:hover,
.ais-InfiniteResults-loadMore:hover,
.ais-Menu-showMore:hover,
.ais-RefinementList-showMore:hover {
  background-color: var(--app-primary-color);
}
.ais-Breadcrumb-link,
.ais-HierarchicalMenu-link,
.ais-Menu-link,
.ais-Pagination-link,
.ais-RatingMenu-link {
  color: var(--app-primary-color);
}
.ais-Breadcrumb-link:focus,
.ais-HierarchicalMenu-link:focus,
.ais-Menu-link:focus,
.ais-Pagination-link:focus,
.ais-RatingMenu-link:focus,
.ais-Breadcrumb-link:hover,
.ais-HierarchicalMenu-link:hover,
.ais-Menu-link:hover,
.ais-Pagination-link:hover,
.ais-RatingMenu-link:hover {
  color: var(--app-primary-color);
}
.ais-Pagination-item--selected .ais-Pagination-link {
  background-color: var(--app-primary-color);
  border-color: var(--app-primary-color);
}
/*Error Styles*/
.gx-page-error-container {
  position: relative;
  height: 100%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-page-error-content {
  margin: 0 auto;
  width: 380px;
  max-width: 94%;
}
.gx-page-error-content h2 {
  margin-bottom: 50px;
}
@media screen and (max-width: 767px) {
  .gx-page-error-content h2 {
    margin-bottom: 20px;
  }
}
.gx-error-code {
  color: #595959;
  font-size: 160px;
  text-align: center;
  line-height: 1;
  font-weight: 500;
  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);
}
@media screen and (max-width: 991px) {
  .gx-error-code {
    font-size: 130px;
  }
}
@media screen and (max-width: 767px) {
  .gx-error-code {
    font-size: 100px;
  }
}
@media screen and (max-width: 575px) {
  .gx-error-code {
    font-size: 80px;
  }
}
/*Editor Styles*/
.rdw-editor-toolbar .rdw-inline-wrapper {
  flex-wrap: wrap;
}
@media screen and (max-width: 399px) {
  .rdw-editor-toolbar .rdw-inline-wrapper .rdw-option-wrapper {
    margin-bottom: 8px;
  }
}
/*Testimonial Styles*/
.gx-testimonial {
  margin-bottom: 32px;
}
@media screen and (max-width: 575px) {
  .gx-testimonial {
    margin-bottom: 20px;
  }
}
.gx-classic-testimonial .ant-avatar {
  margin: 0 auto;
  margin-bottom: 30px;
  width: 120px;
  height: 120px;
}
.gx-classic-testimonial .ant-avatar img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 575px) {
  .gx-classic-testimonial .ant-avatar {
    width: 80px;
    height: 80px;
    margin-bottom: 15px;
  }
}
.gx-testimonial-bg {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 30px;
  overflow: hidden;
  position: relative;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}
@media screen and (max-width: 575px) {
  .gx-testimonial-bg {
    padding: 16px;
  }
}
.gx-testimonial-bg .ant-avatar {
  display: inline-block;
  width: 80px;
  height: 80px;
  overflow: hidden;
  border: 4px solid var(--app-primary-color);
}
.gx-testimonial-bg .ant-avatar img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 450px) {
  .gx-testimonial-bg .ant-avatar {
    width: 50px;
    height: 50px;
  }
}
.gx-testimonial-bg .gx-description {
  color: #d9d9d9;
  font-style: italic;
  font-weight: 400;
  line-height: 25px;
  margin-bottom: 15px;
}
.gx-testimonial-bg .gx-title {
  color: var(--app-primary-color);
  margin-bottom: 2px;
}
.gx-testimonial-des {
  position: relative;
  padding-left: 30px;
}
.gx-testimonial-des:before {
  font-family: "gaxon";
  font-size: 20px;
  content: "\\e066";
  color: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
}
@media screen and (max-width: 475px) {
  .gx-standard .gx-media {
    flex-direction: column;
  }
}
.rtl {
  direction: rtl;
  text-align: right;
  unicode-bidi: bidi-override;
  /*Status style*/
  /* Customizer Style */
  /* & .ant-popover-placement-bottomRight {
    & > .ant-popover-content {
      & > .ant-popover-arrow {
        right: auto;
        left: 10px;
      }
    }
  }*/
}
.rtl ol,
.rtl ul,
.rtl dl {
  padding-left: 0;
  padding-right: 30px;
}
.rtl .gx-mr-1 {
  margin-right: 0 !important;
  margin-left: 0.25rem !important;
}
.rtl .gx-ml-1 {
  margin-left: 0 !important;
  margin-right: 0.25rem !important;
}
.rtl .gx-mr-2 {
  margin-right: 0 !important;
  margin-left: 0.5rem !important;
}
.rtl .gx-ml-2 {
  margin-left: 0 !important;
  margin-right: 0.5rem !important;
}
.rtl .gx-mr-3 {
  margin-right: 0 !important;
  margin-left: 1rem !important;
}
.rtl .gx-ml-3 {
  margin-left: 0 !important;
  margin-right: 1rem !important;
}
.rtl .gx-mr-4 {
  margin-right: 0 !important;
  margin-left: 1.5rem !important;
}
.rtl .gx-ml-4 {
  margin-left: 0 !important;
  margin-right: 1.5rem !important;
}
.rtl .gx-mr-5 {
  margin-right: 0 !important;
  margin-left: 3rem !important;
}
.rtl .gx-ml-5 {
  margin-left: 0 !important;
  margin-right: 3rem !important;
}
.rtl .gx-pr-1 {
  padding-right: 0 !important;
  padding-left: 0.25rem !important;
}
.rtl .gx-pl-1 {
  padding-left: 0 !important;
  padding-right: 0.25rem !important;
}
.rtl .gx-pr-2 {
  padding-right: 0 !important;
  padding-left: 0.5rem !important;
}
.rtl .gx-pl-2 {
  padding-left: 0 !important;
  padding-right: 0.5rem !important;
}
.rtl .gx-pr-3 {
  padding-right: 0 !important;
  padding-left: 1rem !important;
}
.rtl .gx-pl-3 {
  padding-left: 0 !important;
  padding-right: 1rem !important;
}
.rtl .gx-pr-4 {
  padding-right: 0 !important;
  padding-left: 1.5rem !important;
}
.rtl .gx-pl-4 {
  padding-left: 0 !important;
  padding-right: 1.5rem !important;
}
.rtl .gx-pr-5 {
  padding-right: 0 !important;
  padding-left: 2rem !important;
}
.rtl .gx-pl-5 {
  padding-left: 0 !important;
  padding-right: 2rem !important;
}
.rtl .gx-mr-auto {
  margin-right: 0 !important;
  margin-left: auto !important;
}
.rtl .gx-ml-auto {
  margin-left: 0 !important;
  margin-right: auto !important;
}
.rtl .gx-float-left {
  float: right !important;
}
.rtl .gx-float-right {
  float: left !important;
}
.rtl .gx-customizer-option {
  right: auto;
  left: 0;
}
.rtl .gx-customizer-option .ant-btn {
  -webkit-border-radius: 0 30px 30px 0;
  -moz-border-radius: 0 30px 30px 0;
  border-radius: 0 30px 30px 0;
  margin-left: 0;
}
.rtl .gx-app-nav {
  padding-right: 0;
}
.rtl .gx-border-left {
  border-left: 0 none;
  border-right: solid 1px #e8e8e8;
}
.rtl .gx-border-right {
  border-right: 0 none;
  border-left: solid 1px #e8e8e8;
}
.rtl .gx-social-link {
  padding-right: 0;
}
.rtl .gx-left-0 {
  left: auto !important;
  right: 0 !important;
}
.rtl .gx-right-0 {
  right: auto !important;
  left: 0 !important;
}
.rtl .gx-status-pos .gx-status {
  left: auto;
  right: 0;
}
.rtl .gx-status-pos .gx-status.gx-status-rtl {
  right: auto;
  left: -4px;
}
@media screen and (max-width: 991px) {
  .rtl .framed-layout .ant-drawer-left {
    right: 0;
    left: auto;
  }
}
@media screen and (max-width: 991px) {
  .rtl .framed-layout .ant-drawer-right {
    left: 0;
    right: auto;
  }
}
.rtl .framed-layout .ant-drawer-right .ant-drawer-content-wrapper {
  -webkit-border-radius: 11px 0 0 11px;
  -moz-border-radius: 11px 0 0 11px;
  border-radius: 11px 0 0 11px;
}
.rtl .ant-drawer-right .ant-drawer-content-wrapper {
  right: auto;
  left: 0;
  transform: translateX(-100%) !important;
}
.rtl .ant-drawer-right.ant-drawer-open .ant-drawer-content-wrapper {
  transform: translateX(0) !important;
}
.rtl .ant-drawer-left .ant-drawer-content-wrapper {
  right: 0;
  left: auto;
  transform: translateX(100%) !important;
}
.rtl .ant-drawer-left.ant-drawer-open .ant-drawer-content-wrapper {
  transform: translateX(0) !important;
}
.rtl .ant-rate,
.rtl .ant-menu-rtl,
.rtl .ant-list-items,
.rtl .ant-menu-rtl ul,
.rtl .ant-list-item-action,
.rtl .ant-transfer-list-content {
  padding-right: 0 !important;
}
.rtl .ant-menu-submenu-popup .ant-menu-item-group-title {
  padding-left: 30px;
  padding-right: 20px;
}
.rtl .ant-menu-item .icon {
  margin-right: 0;
  margin-left: 20px;
}
.rtl .ant-menu-inline,
.rtl .ant-menu-vertical,
.rtl .ant-menu-vertical-left {
  border-right: 0 none;
  border-left: 1px solid #e8e8e8;
}
.rtl .ant-layout-sider .ant-menu-inline,
.rtl .ant-layout-sider .ant-menu-vertical,
.rtl .ant-layout-sider .ant-menu-vertical-left,
.rtl .gx-drawer-sidebar .ant-menu-inline,
.rtl .gx-drawer-sidebar .ant-menu-vertical,
.rtl .gx-drawer-sidebar .ant-menu-vertical-left {
  border-left: 0 none;
}
.rtl .ant-menu-vertical-right {
  border-right: 0 none;
  border-left: 1px solid #e8e8e8;
}
.rtl .ant-menu-sub.ant-menu-inline {
  border-left: none !important;
}
.rtl .ant-menu-item .anticon,
.rtl .ant-menu-submenu-title .anticon {
  margin-right: 0;
  margin-left: 20px;
}
.rtl .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {
  padding-left: 30px !important;
  padding-right: 54px !important;
}
.rtl .ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item,
.rtl .ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {
  padding-left: 30px !important;
  padding-right: 80px !important;
}
.rtl .ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item,
.rtl .ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item {
  padding-left: 30px !important;
  padding-right: 106px !important;
}
.rtl .ant-menu-submenu-popup .ant-menu-sub.ant-menu .ant-menu-item {
  padding-left: 30px !important;
  padding-right: 20px !important;
  text-align: right;
}
.rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  right: auto;
  left: 16px;
}
.rtl .gx-app-sidebar .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .gx-app-sidebar .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .gx-app-sidebar .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .gx-app-sidebar .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-drawer .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-drawer .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-drawer .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-drawer .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  left: auto;
  right: 22px;
}
.rtl .gx-app-sidebar .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .gx-app-sidebar .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .gx-app-sidebar .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .gx-app-sidebar .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-drawer .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-drawer .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-drawer .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.rtl .ant-drawer .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {
  left: auto;
  right: 60px;
}
.rtl .ant-menu-vertical .ant-menu-item:after,
.rtl .ant-menu-vertical-left .ant-menu-item:after,
.rtl .ant-menu-vertical-right .ant-menu-item:after,
.rtl .ant-menu-inline .ant-menu-item:after {
  border-right: 0 none;
  border-left: 3px solid var(--app-primary-color);
}
.rtl .ant-menu-vertical .ant-menu-item,
.rtl .ant-menu-vertical-left .ant-menu-item,
.rtl .ant-menu-vertical-right .ant-menu-item,
.rtl .ant-menu-inline .ant-menu-item,
.rtl .ant-menu-vertical .ant-menu-submenu-title,
.rtl .ant-menu-vertical-left .ant-menu-submenu-title,
.rtl .ant-menu-vertical-right .ant-menu-submenu-title,
.rtl .ant-menu-inline .ant-menu-submenu-title {
  padding: 0 20px 0 30px !important;
}
.rtl .ant-menu-vertical .ant-menu-item .icon,
.rtl .ant-menu-vertical-left .ant-menu-item .icon,
.rtl .ant-menu-vertical-right .ant-menu-item .icon,
.rtl .ant-menu-inline .ant-menu-item .icon,
.rtl .ant-menu-vertical .ant-menu-submenu-title .icon,
.rtl .ant-menu-vertical-left .ant-menu-submenu-title .icon,
.rtl .ant-menu-vertical-right .ant-menu-submenu-title .icon,
.rtl .ant-menu-inline .ant-menu-submenu-title .icon {
  margin-right: 0;
  margin-left: 20px;
}
.rtl .ant-layout-sider .ant-menu-vertical .ant-menu-item,
.rtl .ant-layout-sider .ant-menu-vertical-left .ant-menu-item,
.rtl .ant-layout-sider .ant-menu-vertical-right .ant-menu-item,
.rtl .ant-layout-sider .ant-menu-inline .ant-menu-item,
.rtl .ant-drawer .ant-menu-vertical .ant-menu-item,
.rtl .ant-drawer .ant-menu-vertical-left .ant-menu-item,
.rtl .ant-drawer .ant-menu-vertical-right .ant-menu-item,
.rtl .ant-drawer .ant-menu-inline .ant-menu-item,
.rtl .ant-layout-sider .ant-menu-vertical .ant-menu-submenu-title,
.rtl .ant-layout-sider .ant-menu-vertical-left .ant-menu-submenu-title,
.rtl .ant-layout-sider .ant-menu-vertical-right .ant-menu-submenu-title,
.rtl .ant-layout-sider .ant-menu-inline .ant-menu-submenu-title,
.rtl .ant-drawer .ant-menu-vertical .ant-menu-submenu-title,
.rtl .ant-drawer .ant-menu-vertical-left .ant-menu-submenu-title,
.rtl .ant-drawer .ant-menu-vertical-right .ant-menu-submenu-title,
.rtl .ant-drawer .ant-menu-inline .ant-menu-submenu-title {
  padding-left: 30px !important;
  padding-right: 40px !important;
}
.rtl .ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item,
.rtl .ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item,
.rtl .ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item,
.rtl .ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item,
.rtl .ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title,
.rtl .ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title,
.rtl .ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title,
.rtl .ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title {
  padding: 0 calc((80px - 20px) / 2) !important;
}
.rtl .ant-card .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,
.rtl .ant-card .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,
.rtl .ant-card .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,
.rtl .ant-card .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {
  padding-left: 30px !important;
  padding-right: 54px !important;
}
.rtl .ant-layout-sider .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,
.rtl .ant-layout-sider.ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,
.rtl .ant-layout-sider .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,
.rtl .ant-layout-sider .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title,
.rtl .ant-drawer .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,
.rtl .ant-drawer .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,
.rtl .ant-drawer .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,
.rtl .ant-drawer .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {
  padding-left: 30px !important;
  padding-right: 80px !important;
}
.rtl .ant-menu-inline .ant-menu-submenu-title {
  padding-right: 20px !important;
  padding-left: 30px !important;
}
.rtl .ant-menu-item-group-list .ant-menu-item,
.rtl .ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 28px 0 16px;
}
.rtl .ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding: 0 80px 0 30px;
}
.rtl .ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,
.rtl .ant-drawer .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,
.rtl .ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-item .icon,
.rtl .ant-drawer .ant-menu .ant-menu-submenu .ant-menu-item .icon {
  margin-right: 0;
  margin-left: 12px;
}
.rtl .ant-menu-dark .ant-menu-item .icon {
  margin-right: 0;
  margin-left: 20px;
}
.rtl .ant-btn:not(:last-child) {
  margin-right: 0;
  margin-left: 15px;
}
@media screen and (max-width: 575px) {
  .rtl .ant-btn:not(:last-child) {
    margin-right: 0;
    margin-left: 10px;
  }
}
.rtl .ant-btn-group .ant-btn:not(:last-child),
.rtl .ant-transfer-operation .ant-btn:not(:last-child) {
  margin-left: 0;
}
@media (max-width: 1599px) {
  .rtl .gx-product-footer .ant-btn:not(:last-child) {
    margin-right: 0;
    margin-left: 6px;
  }
}
.rtl .ant-radio-button-wrapper:last-child {
  border-radius: 6px 0 0 6px;
}
.rtl .ant-radio-button-wrapper:first-child {
  border-radius: 0 6px 6px 0;
}
.rtl .ant-table-thead > tr > th,
.rtl .ant-table table {
  text-align: right;
}
.rtl .ant-table-pagination.ant-pagination {
  float: left;
}
.rtl .ant-pagination-item,
.rtl .ant-pagination-prev,
.rtl .ant-pagination-jump-prev,
.rtl .ant-pagination-jump-next {
  margin-right: 0;
  margin-left: 8px;
}
.rtl .anticon-left,
.rtl .anticon-right {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.rtl .ant-table-thead > tr > th.ant-table-selection-column,
.rtl .ant-table-tbody > tr > td.ant-table-selection-column {
  text-align: center;
}
.rtl .ant-table-thead > tr > th.ant-table-selection-column-custom .ant-table-selection {
  margin-right: 0;
  margin-left: -15px;
}
.rtl .ant-table-selection-select-all-custom {
  margin-right: 0 !important;
  margin-left: 4px !important;
}
.rtl .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters,
.rtl .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters {
  padding-right: 16px !important;
  padding-left: 30px !important;
}
.rtl .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters.ant-table-column-has-filters {
  padding-right: 16px !important;
  padding-left: 54px !important;
}
.rtl .ant-table-thead > tr > th .ant-table-column-sorter {
  right: auto;
  left: 6px;
}
.rtl .ant-table-thead > tr > th.ant-table-column-has-filters .ant-table-column-sorter {
  right: auto;
  left: 34px;
}
.rtl .ant-table-thead > tr > th .anticon-filter,
.rtl .ant-table-thead > tr > th .ant-table-filter-icon {
  right: auto;
  left: 0;
}
.rtl .ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {
  padding-right: 8px;
  padding-left: 0;
}
.rtl .ant-table-filter-dropdown-link.confirm {
  float: right;
}
.rtl .ant-table-filter-dropdown-link.clear {
  float: left;
}
.rtl .ant-table .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 0;
  margin-left: 8px;
}
.rtl .ant-table-fixed-left {
  left: auto;
  right: 0;
  -webkit-box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.15);
  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.15);
}
.rtl .ant-table.ant-table-scroll-position-left .ant-table-fixed-left {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.rtl .ant-table-fixed-right {
  right: auto;
  left: 0;
  -webkit-box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.15);
  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.15);
}
.rtl .ant-table.ant-table-scroll-position-right .ant-table-fixed-right {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.rtl .ant-select-selection-selected-value {
  float: right;
  padding-right: 0;
  padding-left: 20px;
}
.rtl .ant-select-arrow {
  right: auto;
  left: 11px;
}
.rtl .ant-badge:not(:last-child),
.rtl .gx-badge:not(:last-child) {
  margin-right: 0;
  margin-left: 12px;
}
.rtl .gx-user-list .gx-avatar-img {
  margin-right: 0;
  margin-left: 20px;
}
.rtl .gx-user-list .gx-link[class*="gx-meta-"] i {
  margin-right: 0;
  margin-left: 6px;
}
.rtl .gx-user-list .gx-btn-list li:not(:last-child) {
  margin-right: 0;
  margin-left: 10px;
}
.rtl .gx-card-list .gx-card-list-footer {
  padding-left: 0;
  padding-right: 15px;
}
.rtl .gx-card-list .gx-card-list-footer .ant-btn {
  margin-left: 0;
}
@media screen and (max-width: 767px) {
  .rtl .gx-card-list .gx-card-list-footer {
    padding-left: 0;
    padding-right: 0;
  }
  .rtl .gx-card-list .gx-card-list-footer .ant-btn {
    margin-left: 12px;
    margin-right: 0;
  }
}
.rtl .ant-timeline {
  padding-right: 0;
}
.rtl .ant-timeline-item-head-custom {
  margin-right: 0;
  right: 0;
  left: auto;
}
.rtl .gx-timeline-panel::before {
  border-width: 10px 0 10px 17px;
  left: auto;
  right: -18px;
}
.rtl .gx-timeline-panel::after {
  border-width: 10px 0 10px 16px;
  left: auto;
  right: -16px;
}
.rtl .gx-timeline-item {
  padding-right: 80px;
  padding-left: 0;
}
.rtl .gx-timeline-item::before {
  right: 25px;
  left: auto;
}
.rtl .gx-timeline-badge {
  right: 0;
  left: auto;
}
.rtl .gx-timeline-badge .icon {
  display: inline !important;
}
.rtl .gx-timeline-center .gx-timeline-item {
  float: left;
  padding-left: 0;
  padding-right: 55px;
}
@media screen and (max-width: 767px) {
  .rtl .gx-timeline-center .gx-timeline-item {
    float: none;
    padding-right: 80px;
  }
}
.rtl .gx-timeline-center .gx-timeline-item .gx-timeline-badge {
  right: -25px;
  left: auto;
}
@media screen and (max-width: 767px) {
  .rtl .gx-timeline-center .gx-timeline-item .gx-timeline-badge {
    right: 0;
  }
}
.rtl .gx-timeline-center .gx-timeline-item::before {
  right: 0;
}
@media screen and (max-width: 767px) {
  .rtl .gx-timeline-center .gx-timeline-item::before {
    right: 25px;
  }
}
.rtl .gx-timeline-center .gx-timeline-time {
  left: auto;
  right: -150px;
}
@media screen and (max-width: 767px) {
  .rtl .gx-timeline-center .gx-timeline-time {
    right: auto;
  }
}
.rtl .gx-timeline-center .gx-timeline-inverted {
  float: right;
  padding-left: 55px;
  padding-right: 0;
  text-align: left;
}
@media screen and (max-width: 767px) {
  .rtl .gx-timeline-center .gx-timeline-inverted {
    float: none;
    padding-left: 0;
    padding-right: 80px;
    text-align: right;
  }
}
.rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {
  left: -25px;
  right: auto;
}
@media screen and (max-width: 767px) {
  .rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {
    left: auto;
    right: 0;
  }
}
.rtl .gx-timeline-center .gx-timeline-inverted::before {
  left: -2px;
  right: auto;
}
@media screen and (max-width: 767px) {
  .rtl .gx-timeline-center .gx-timeline-inverted::before {
    left: auto;
    right: 25px;
  }
}
.rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel::before {
  border-width: 10px 16px 10px 0;
  left: -18px;
  right: auto;
}
@media screen and (max-width: 767px) {
  .rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel::before {
    border-width: 10px 0 10px 17px !important;
    right: -18px;
    left: auto;
  }
}
.rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel::after {
  border-width: 10px 0 10px 16px;
  left: -16px;
  right: auto;
}
@media screen and (max-width: 767px) {
  .rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel::after {
    right: -16px;
    left: auto;
    border-width: 10px 0 10px 16px !important;
  }
}
.rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-time {
  left: -150px;
  right: auto;
}
@media screen and (max-width: 767px) {
  .rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-time {
    left: auto;
  }
}
.rtl .gx-timeline-left {
  float: right;
  margin-left: 20px;
  margin-right: 0;
}
.rtl .gx-timeline-right {
  float: left;
  margin-right: 20px;
  margin-left: 0;
}
.rtl .gx-customizer > div:first-child,
.rtl .gx-wall-scroll > div:first-child,
.rtl .gx-popover-scroll > div:first-child,
.rtl .gx-popover-lang-scroll > div:first-child,
.rtl .gx-module-side-scroll > div:first-child,
.rtl .gx-module-content-scroll > div:first-child,
.rtl .gx-layout-sider-scrollbar > div:first-child,
.rtl .gx-chat-sidenav-scroll-tab-1 > div:first-child,
.rtl .gx-chat-sidenav-scroll-tab-2 > div:first-child {
  margin-left: -17px;
  margin-right: 0 !important;
}
.rtl .gx-customizer > div:last-child,
.rtl .gx-wall-scroll > div:last-child,
.rtl .gx-popover-scroll > div:last-child,
.rtl .gx-popover-lang-scroll > div:last-child,
.rtl .gx-module-side-scroll > div:last-child,
.rtl .gx-module-content-scroll > div:last-child,
.rtl .gx-layout-sider-scrollbar > div:last-child,
.rtl .gx-chat-sidenav-scroll-tab-1 > div:last-child,
.rtl .gx-chat-sidenav-scroll-tab-2 > div:last-child {
  right: auto !important;
  left: 2px;
}
.rtl .icon:not(.gx-icon-btn) {
  display: inline-block;
  vertical-align: middle;
}
.rtl .ant-menu-inline-collapsed-tooltip .icon {
  display: none;
}
.rtl .icon-ellipse-v::before {
  content: "\\7b";
}
.rtl .icon-editor::before {
  content: "\\7d";
}
.rtl .gx-module-sidenav {
  border-left: solid 1px #e8e8e8;
  border-right: none;
}
.rtl .gx-module-list-icon {
  padding-right: 0;
  padding-left: 10px;
}
.rtl .gx-module-nav {
  padding-right: 0;
}
.rtl .gx-module-nav li i {
  margin-left: 16px;
  margin-right: 0;
}
.rtl .gx-module-box-topbar label.ant-checkbox-wrapper,
.rtl .gx-module-box-topbar .ant-dropdown-trigger {
  margin-right: 0;
  margin-left: 10px;
}
.rtl .gx-mail-list-info {
  padding-right: 10px;
  padding-left: 0;
}
@media screen and (max-width: 575px) {
  .rtl .gx-mail-list-info {
    padding-right: 0;
  }
}
.rtl .gx-chat-sidenav {
  border-left: solid 1px #e8e8e8;
  border-right: none;
}
.rtl .gx-profile-banner-avatar {
  margin-right: 0;
  margin-left: 1.5rem;
}
@media (max-width: 575px) {
  .rtl .gx-profile-banner-avatar {
    margin-left: 0;
  }
}
.rtl .gx-profile-banner-top-right {
  margin-right: auto;
  margin-left: 0;
}
.rtl .gx-profile-banner .gx-navbar-nav {
  padding-right: 0;
}
.rtl .gx-profile-banner .gx-follower-list {
  padding-right: 0;
}
.rtl .gx-profile-banner .gx-follower-list li:not(:first-child) {
  border-left: none;
  border-right: solid 1px #ffffff;
}
.rtl .gx-profile-setting {
  margin-left: 0;
  margin-right: auto;
}
.rtl .gx-algolia-sidebar ul {
  padding-right: 0;
}
.rtl .gx-algolia-sidebar .ais-RefinementList-checkbox {
  margin-left: 12px;
  margin-right: 0;
}
.rtl .gx-algolia-sidebar .ais-RefinementList-labelText {
  display: inline-block;
  vertical-align: top;
}
.rtl .gx-algolia-main {
  padding-right: 30px;
  padding-left: 0;
}
@media screen and (max-width: 767px) {
  .rtl .gx-algolia-main {
    padding-right: 0;
  }
}
.rtl .gx-algolia-sort-by {
  margin-right: auto;
  margin-left: 0;
}
.rtl .gx-algolia-sort-by label {
  margin-right: 0;
  margin-left: 15px;
}
.rtl .gx-algolia-header .gx-lt-icon-search-bar {
  margin-left: 10px;
  margin-right: 0;
}
.rtl .ais-RangeInput-submit {
  margin-right: 0.3rem;
  margin-left: 0;
}
.rtl .gx-testimonial-des {
  padding-right: 30px;
  padding-left: 0;
}
.rtl .gx-testimonial-des:before {
  left: auto;
  right: 0;
}
.rtl .slick-slider .gx-slide-item {
  direction: rtl;
}
.rtl .login-form-forgot {
  float: left;
}
.rtl .ant-input-number {
  margin-left: 10px;
  margin-right: 0;
}
.rtl .ant-input-group > [class*="col-"] {
  float: right !important;
  padding-left: 8px;
  padding-right: 0;
}
.rtl .ant-input-group > [class*="col-"]:last-child {
  padding-left: 0;
}
.rtl .gx-search-bar:not(.gx-lt-icon-search-bar-lg) input[type="search"] {
  padding-left: 35px;
  padding-right: 9px;
}
.rtl .gx-search-bar:not(.gx-lt-icon-search-bar-lg) .gx-search-icon {
  right: auto;
  left: 0;
}
.rtl .gx-header-search .ant-select-selection,
.rtl .gx-header-search .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  -webkit-border-radius: 4px 0 0 4px;
  -moz-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
}
.rtl .gx-header-search .gx-lt-icon-search-bar-lg input[type="search"] {
  -webkit-border-radius: 0 4px 4px 0;
  -moz-border-radius: 0 4px 4px 0;
  border-radius: 0 4px 4px 0;
}
.rtl .ant-input-group > .ant-input:last-child,
.rtl .ant-input-group-addon:last-child {
  border-radius: 6px 0 0 6px;
}
.rtl .ant-input-search-rtl > .ant-input-group > .ant-input-group-addon .ant-input-search-button {
  border-radius: 6px 0 0 6px;
}
.rtl .rbc-btn-group button + button {
  margin-right: -1px;
  margin-left: 0;
}
.rtl .rbc-btn-group button:last-child:not(:first-child) {
  border-radius: 4px 0 0 4px;
}
.rtl .rbc-btn-group button:first-child:not(:last-child) {
  border-radius: 0 4px 4px 0;
}
.rtl .rbc-header + .rbc-header,
.rtl .rbc-day-bg + .rbc-day-bg {
  border-right: 1px solid #DDD;
  border-left: none;
}
.rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  text-align: right;
}
.rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-right: 1px solid #DDD;
}
.rtl .gx-entry-title::before {
  right: 0;
  left: auto;
}
.rtl .ant-btn {
  margin-left: 8px;
  margin-right: 0;
}
.rtl .ant-btn-group:not(:last-child) {
  margin-left: 15px;
  margin-right: 0;
}
.rtl .ant-menu {
  text-align: right;
}
.rtl .ant-dropdown-menu {
  padding-right: 4px;
}
.rtl .ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon,
.rtl .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon {
  right: auto;
  left: 8px;
}
.rtl .ant-pagination,
.rtl .ant-cascader-menu,
.rtl .ant-menu-item-group-list {
  padding-right: 0;
}
.rtl .gx-package-items li i {
  float: right;
  margin-right: 0;
  margin-left: 16px;
}
.rtl .gx-product-row {
  text-align: left;
}
.rtl .gx-product-row.even {
  text-align: right;
}
.rtl .gx-product-row .ant-btn {
  margin-left: 0;
}
.rtl .amcharts-export-menu ul {
  padding-right: 0;
}
.rtl .amcharts-export-menu .export-main > a,
.rtl .amcharts-export-menu .export-drawing > a,
.rtl .amcharts-export-menu .export-delayed-capturing > a {
  text-indent: 13333337px;
}
.rtl .public-DraftStyleDefault-ltr {
  direction: rtl;
  text-align: right;
}
.rtl .rdw-dropdown-carettoopen {
  left: 10%;
  right: auto;
}
.rtl .gx-dragndrop-item .gx-draggable-icon {
  margin-right: -16px;
  margin-left: 0;
}
.rtl .ant-select-dropdown-menu,
.rtl .gx-fnd-gallery-list,
.rtl .gx-agents-list,
.rtl .gx-sub-popover,
.rtl .gx-user-popover,
.rtl .gx-app-nav {
  padding-right: 0;
}
.rtl .gx-form-inline-label-up .ant-form-item-label {
  text-align: right;
}
.rtl .ant-form-rtl.ant-form-inline .ant-form-item {
  margin-left: 0;
}
.rtl .gx-news-thumb {
  margin-right: 0;
  margin-left: 25px;
}
@media (max-width: 1366px) {
  .rtl .gx-news-thumb {
    margin-right: 0;
    margin-left: 15px;
  }
}
@media (max-width: 575px) {
  .rtl .gx-news-thumb {
    margin-left: 0;
  }
}
.rtl .gx-news-tags-right {
  padding-left: 0;
  padding-right: 8px;
  text-align: left;
}
@media screen and (max-width: 575px) {
  .rtl .gx-card-ticketlist .gx-task-item-content {
    padding-left: 0;
  }
}
.rtl .gx-task-item-content .gx-task-date {
  text-align: left;
}
@media screen and (max-width: 575px) {
  .rtl .gx-task-item-content .gx-task-date {
    right: auto;
    left: 0;
  }
}
@media screen and (max-width: 575px) {
  .rtl .gx-task-item-content-left {
    padding-right: 0;
    padding-left: 60px;
  }
}
@media screen and (max-width: 575px) {
  .rtl .gx-card-ticketlist .gx-task-item-content-left {
    padding-left: 0;
  }
}
.rtl .gx-task-item-content-right {
  padding-left: 0;
  padding-right: 10px;
}
@media screen and (max-width: 575px) {
  .rtl .gx-task-item-content-right {
    padding-right: 0;
  }
}
.rtl .gx-card-testimonial-img {
  margin-right: 0;
  margin-left: 10px;
}
.rtl .gx-card-testimonial-content {
  margin-left: 0;
  margin-right: 10px;
}
.rtl .gx-card-testimonial-content:before {
  left: auto;
  right: -10px;
  border-right: 0 none;
  border-left: 10px solid #f5f5f5;
}
.rtl .gx-progress-task-list-content {
  margin-left: 0;
  margin-right: 20px;
}
.rtl .gx-act-task-content label.ant-checkbox-wrapper span.ant-checkbox {
  float: right;
  padding-right: 0;
  padding-left: 5px;
}
.rtl .gx-act-task-btn-view {
  margin-left: 0;
  margin-right: 8px;
  text-align: left;
}
@media screen and (max-width: 575px) {
  .rtl .gx-act-task-btn-view {
    margin-right: 0;
  }
}
.rtl .gx-line-indicator {
  padding-right: 0;
}
.rtl .gx-line-indicator-col {
  padding-right: 0;
  padding-left: 10px;
}
@media screen and (max-width: 767px) {
  .rtl .gx-line-indicator-col {
    padding-left: 0;
  }
}
.rtl .gx-overview-description {
  margin-left: -24px;
  margin-right: 0;
  border-left: 0 none;
  border-right: solid 1px #e8e8e8;
}
@media screen and (max-width: 767px) {
  .rtl .gx-overview-description {
    border-right: 0 none !important;
  }
}
.rtl .gx-revenu-col:not(:last-child) {
  border-right: 0 none;
  border-left: solid 1px #e8e8e8;
}
.rtl .gx-rechart-prod {
  left: 0;
  right: 30px;
}
@media (max-width: 1366px) {
  .rtl .gx-rechart-prod {
    left: 0;
  }
}
.rtl .gx-dot-arrow {
  right: auto;
  left: 0;
  padding-right: 0;
  padding-left: 10px;
}
.rtl .gx-hover-arrow {
  left: 0;
  right: 15px;
  -webkit-border-radius: 0 50% 50% 0;
  -moz-border-radius: 0 50% 50% 0;
  border-radius: 0 50% 50% 0;
}
.rtl .gx-dot-arrow-hover:hover .gx-hover-arrow {
  left: auto;
  right: -15px;
}
.rtl .gx-user-wid img {
  left: auto;
  right: 0;
}
.rtl .gx-widget-badge {
  right: auto;
  left: 0;
  -webkit-border-radius: 10px 0 10px 0;
  -moz-border-radius: 10px 0 10px 0;
  border-radius: 10px 0 10px 0;
}
.rtl .gx-fnd-content {
  padding-right: 0;
  padding-left: 40px;
}
@media (max-width: 1366px) {
  .rtl .gx-fnd-content {
    padding-left: 0;
  }
}
.rtl .gx-fillchart-content {
  left: auto;
  right: 0;
}
.rtl .gx-fillchart .gx-chart-up,
.rtl .gx-fillchart .gx-chart-down {
  margin-right: 0;
  margin-left: 6px;
}
.rtl .gx-fillchart-btn,
.rtl .gx-fillchart-btn-close {
  right: 0;
  left: 10px;
}
.rtl .gx-fillchart-nocontent .ant-card-head-title {
  left: 0;
}
.rtl .gx-featured-thumb {
  margin-right: 0;
  margin-left: 25px;
}
@media (max-width: 575px) {
  .rtl .gx-featured-thumb {
    margin-left: 0;
  }
}
.rtl .gx-featured-thumb .ant-tag {
  left: auto;
  right: 15px;
}
.rtl .gx-featured-content-right {
  margin-left: 0;
  margin-right: auto;
  text-align: left;
}
@media (max-width: 767px) {
  .rtl .gx-featured-content-right {
    margin-right: 0;
    text-align: right;
  }
}
@media (max-width: 1199px) {
  .rtl .gx-card-profile .gx-featured-content-right {
    text-align: right;
    margin-right: 0;
  }
}
.rtl .gx-currentplan-right {
  border-left: 0 none;
  border-right: solid 1px #e8e8e8;
}
@media (max-width: 1366px) {
  .rtl .gx-currentplan-right {
    border-right: 0 none !important;
  }
}
@media (max-width: 991px) {
  .rtl .gx-currentplan-right {
    border-left: 0 none !important;
    border-right: solid 1px #e8e8e8 !important;
  }
}
@media (max-width: 575px) {
  .rtl .gx-currentplan-right {
    border-right: 0 none !important;
  }
}
.rtl .gx-currentplan-right-content {
  text-align: left;
}
@media (max-width: 1366px) {
  .rtl .gx-currentplan-right-content {
    text-align: right;
  }
}
@media (max-width: 991px) {
  .rtl .gx-currentplan-right-content {
    text-align: left;
  }
}
@media (max-width: 575px) {
  .rtl .gx-currentplan-right-content {
    text-align: right;
  }
}
.rtl .gx-dealclose-header-right {
  margin-left: 0;
  margin-right: auto;
}
@media (max-width: 1366px) {
  .rtl .gx-dealclose-header-right {
    margin-right: 0;
  }
}
@media (max-width: 991px) {
  .rtl .gx-dealclose-header-right {
    margin-left: 0;
    margin-right: auto;
  }
}
@media (max-width: 575px) {
  .rtl .gx-dealclose-header-right {
    margin-right: 0;
  }
}
@media screen and (max-width: 575px) {
  .rtl .gx-dash-search {
    padding-right: 0;
    padding-left: 30px;
  }
  .rtl .gx-dash-search .gx-search-icon {
    right: auto;
    left: 0;
  }
}
.rtl .gx-bg-dark-primary:before {
  left: auto;
  right: 0;
}
.rtl .icon-long-arrow-right:before {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.rtl .icon-search-new:before,
.rtl .icon-search:before {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
  display: inline-block;
}
.rtl span.gx-chart-up,
.rtl span.gx-chart-down {
  display: inline-block;
}
.rtl .gx-slick-slider-dot-top {
  padding-left: 24px;
  padding-right: 0;
}
@media screen and (max-width: 575px) {
  .rtl .gx-slick-slider-dot-top {
    padding-right: 24px;
  }
}
.rtl .gx-customizer-option {
  right: auto;
  left: 0;
}
.rtl .full-scroll.framed-layout .gx-customizer-option {
  right: auto;
  left: 20px;
}
@media screen and (max-width: 991px) {
  .rtl .full-scroll.framed-layout .gx-customizer-option {
    left: 0;
  }
}
.rtl .gx-color-option {
  padding-right: 0;
}
.rtl .gx-color-option li .gx-link:before,
.rtl .gx-color-option li .gx-link:after {
  left: auto;
  right: 0;
}
.rtl .gx-cus-customiz {
  padding-right: 0;
  padding-left: 20px;
}
.rtl .gx-header-notifications {
  padding-right: 0;
}
.rtl .gx-header-notifications > li:not(:last-child) {
  margin-right: 0;
  margin-left: 42px;
}
@media screen and (max-width: 991px) {
  .rtl .gx-header-notifications > li:not(:last-child) {
    margin-right: 0;
    margin-left: 16px;
  }
}
.rtl .gx-inside-header-horizontal .gx-header-notifications > li:not(:last-child) {
  margin-right: 0;
  margin-left: 20px;
}
.rtl .gx-header-horizontal-main .gx-header-notifications > li:not(:last-child),
.rtl .gx-header-horizontal-nav .gx-header-notifications > li:not(:last-child) {
  margin-right: 0;
  margin-left: 30px;
}
@media screen and (max-width: 991px) {
  .rtl .gx-header-horizontal-main .gx-header-notifications > li:not(:last-child),
  .rtl .gx-header-horizontal-nav .gx-header-notifications > li:not(:last-child) {
    margin-right: 0;
    margin-left: 16px;
  }
}
.rtl .gx-header-notifications > li.gx-notify {
  margin-right: 0;
  margin-left: 22px;
}
@media screen and (max-width: 991px) {
  .rtl .gx-header-notifications > li.gx-notify {
    margin-right: 0;
    margin-left: 16px;
  }
}
.rtl .gx-header-horizontal-main .gx-header-notifications > li.gx-notify {
  margin-right: 0;
  margin-left: 30px;
}
@media screen and (max-width: 991px) {
  .rtl .gx-header-horizontal-main .gx-header-notifications > li.gx-notify {
    margin-right: 0;
    margin-left: 16px;
  }
}
.rtl .gx-inside-header-horizontal .gx-header-notifications > li.gx-notify {
  margin-right: 0;
  margin-left: 20px;
}
.rtl .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {
  margin-left: 0;
  margin-right: 50px;
}
@media screen and (max-width: 991px) {
  .rtl .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {
    margin-right: 0;
  }
}
@media screen and (max-width: 1199px) {
  .rtl .gx-inside-header-horizontal .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {
    margin-right: 0;
  }
}
.rtl .gx-header-horizontal-dark:before {
  right: auto;
  left: 169px;
}
@media screen and (max-width: 1049px) {
  .rtl .gx-header-horizontal-dark:before {
    right: auto;
    left: 110px;
  }
}
@media screen and (max-width: 1199px) {
  .rtl .gx-header-horizontal-dark:before {
    right: auto;
    left: 80px;
  }
}
@media screen and (max-width: 991px) {
  .rtl .gx-header-horizontal-dark:before {
    right: auto;
    left: 140px;
  }
}
@media screen and (max-width: 575px) {
  .rtl .gx-header-horizontal-dark:before {
    right: auto;
    left: 60px;
  }
}
.rtl .gx-header-horizontal-top-left {
  margin-right: 0;
  margin-left: 15px;
}
@media screen and (max-width: 767px) {
  .rtl .gx-header-horizontal-top-left {
    margin-left: 0;
  }
}
@media screen and (max-width: 575px) {
  .rtl .gx-header-horizontal-main .gx-w-logo {
    padding-left: 0;
  }
}
.rtl .gx-inside-header-horizontal .gx-logo {
  margin-right: 0;
  margin-left: 25px;
}
.rtl .gx-login-list {
  margin-left: 0;
  margin-right: auto;
  padding-right: 0;
}
.rtl .gx-login-list li:not(:first-child) {
  border-left: 0 none;
  border-right: solid 1px #e8e8e8;
}
.rtl .gx-header-horizontal-dark .gx-login-list li:not(:first-child) {
  border: 0 none;
}
.rtl .gx-header-search {
  margin-left: 0;
  margin-right: 28px;
}
.rtl .gx-header-horizontal-dark .gx-header-search .ant-select-selection {
  margin-left: 0;
  margin-right: 1px;
}
.rtl .gx-popover-horizantal .ant-btn {
  border-right: 0 none;
  border-left: solid 1px #e8e8e8;
}
@media screen and (max-width: 575px) {
  .rtl .gx-popover-horizantal {
    left: auto !important;
    right: 0 !important;
  }
  .rtl .gx-popover-horizantal .gx-sub-popover {
    padding-left: 0;
    padding-right: 5px;
  }
}
.rtl .gx-no-header-horizontal {
  padding-right: 79px;
  padding-left: 32px;
}
.rtl .gx-no-header-horizontal .gx-linebar {
  left: auto;
  right: 32px;
}
@media screen and (max-width: 575px) {
  .rtl .gx-no-header-horizontal .gx-linebar {
    left: auto;
    right: 15px;
  }
}
@media screen and (max-width: 575px) {
  .rtl .gx-no-header-horizontal {
    padding-right: 60px;
    padding-left: 15px;
  }
}
.rtl .gx-layout-sider-header {
  padding-right: 70px;
  padding-left: 30px;
}
.rtl .gx-layout-sider-header .gx-linebar {
  left: auto;
  right: 20px;
}
@media screen and (max-width: 991px) {
  .rtl .gx-layout-sider-header {
    padding-right: 30px;
  }
}
.rtl .ant-layout-sider-collapsed .gx-layout-sider-header {
  padding-left: 20px;
  padding-right: 20px;
}
.rtl .gx-drawer-sidebar .gx-layout-sider-header,
.rtl .gx-custom-sidebar .gx-layout-sider-header {
  padding-left: 30px;
}
.rtl .gx-mini-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header,
.rtl .gx-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header {
  border-right: 1px solid #e8e8e8;
}
.rtl .ant-layout-sider-collapsed .gx-layout-sider-header .gx-linebar {
  left: auto;
}
.rtl .gx-mini-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header,
.rtl .gx-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header {
  border-right: 0 none;
  border-left: 1px solid #e8e8e8;
}
.rtl .gx-sidebar-content {
  border-right: 0 none;
  border-left: 1px solid #e8e8e8;
}
.rtl .gx-layout-sider-dark .gx-sidebar-content,
.rtl .gx-drawer-sidebar-dark .gx-sidebar-content {
  border-left: 0 none;
}
.rtl .gx-avatar-row .ant-avatar {
  left: auto;
  right: 0;
}
.rtl .ant-layout-sider-collapsed .gx-avatar-row .ant-avatar {
  left: auto;
  right: -10px;
}
.rtl .gx-list-group,
.rtl .gx-dot-list,
.rtl .gx-fnd-list,
.rtl .gx-follower-list,
.rtl .gx-gallery-list,
.rtl .gx-package-items,
.rtl .gx-list-inline {
  padding-right: 0;
}
.rtl .gx-list-group li i,
.rtl .gx-list-group li .anticon {
  margin-left: 12px;
  margin-right: 0;
}
.rtl .gx-dot-list {
  margin-right: -3px !important;
}
.rtl .gx-text-left {
  text-align: right !important;
}
.rtl .gx-text-right {
  text-align: left !important;
}
@media (min-width: 576px) {
  .rtl .gx-mr-sm-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }
  .rtl .gx-ml-sm-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }
  .rtl .gx-mr-sm-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }
  .rtl .gx-ml-sm-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }
  .rtl .gx-mr-sm-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }
  .rtl .gx-ml-sm-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }
  .rtl .gx-mr-sm-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }
  .rtl .gx-ml-sm-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }
  .rtl .gx-mr-sm-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }
  .rtl .gx-ml-sm-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }
  .rtl .gx-pr-sm-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }
  .rtl .gx-pl-sm-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }
  .rtl .gx-pr-sm-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }
  .rtl .gx-pl-sm-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }
  .rtl .gx-pr-sm-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }
  .rtl .gx-pl-sm-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }
  .rtl .gx-pr-sm-4 {
    padding-right: 1.5rem !important;
  }
  .rtl .gx-pl-sm-4 {
    padding-left: 1.5rem !important;
  }
  .rtl .gx-pr-sm-5 {
    padding-right: 0 !important;
    padding-left: 2rem !important;
  }
  .rtl .gx-pl-sm-5 {
    padding-left: 0 !important;
    padding-right: 2rem !important;
  }
  .rtl .gx-mr-sm-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }
  .rtl .gx-ml-sm-auto {
    margin-left: 0 !important;
    margin-right: auto !important;
  }
  .rtl .gx-float-sm-left {
    float: right !important;
  }
  .rtl .gx-float-sm-right {
    float: left !important;
  }
}
@media (min-width: 768px) {
  .rtl .gx-mr-md-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }
  .rtl .gx-ml-md-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }
  .rtl .gx-mr-md-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }
  .rtl .gx-ml-md-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }
  .rtl .gx-mr-md-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }
  .rtl .gx-ml-md-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }
  .rtl .gx-mr-md-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }
  .rtl .gx-ml-md-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }
  .rtl .gx-mr-md-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }
  .rtl .gx-ml-md-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }
  .rtl .gx-pr-md-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }
  .rtl .gx-pl-md-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }
  .rtl .gx-pr-md-2,
  .rtl .gx-px-md-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }
  .rtl .gx-pl-md-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }
  .rtl .gx-pr-md-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }
  .rtl .gx-pl-md-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }
  .rtl .gx-pr-md-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }
  .rtl .gx-pl-md-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }
  .rtl .gx-pr-md-5 {
    padding-right: 0 !important;
    padding-left: 2rem !important;
  }
  .rtl .gx-pl-md-5 {
    padding-left: 0 !important;
    padding-right: 2rem !important;
  }
  .rtl .gx-mr-md-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }
  .rtl .gx-ml-md-auto {
    margin-left: 0 !important;
    margin-right: auto !important;
  }
  .rtl .gx-float-md-left {
    float: right !important;
  }
  .rtl .gx-float-md-right {
    float: left !important;
  }
  .rtl .ant-col-rtl.ant-col-md-15.gx-pr-md-2 {
    padding-right: 16px !important;
  }
}
@media (min-width: 992px) {
  .rtl .gx-mr-lg-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }
  .rtl .gx-ml-lg-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }
  .rtl .gx-mr-lg-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }
  .rtl .gx-ml-lg-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }
  .rtl .gx-mr-lg-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }
  .rtl .gx-ml-lg-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }
  .rtl .gx-mr-lg-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }
  .rtl .gx-ml-lg-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }
  .rtl .gx-mr-lg-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }
  .rtl .gx-ml-lg-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }
  .rtl .gx-pr-lg-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }
  .rtl .gx-pl-lg-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }
  .rtl .gx-pr-lg-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }
  .rtl .gx-pl-lg-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }
  .rtl .gx-pr-lg-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }
  .rtl .gx-pl-lg-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }
  .rtl .gx-pr-lg-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }
  .rtl .gx-pl-lg-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }
  .rtl .gx-pr-lg-5 {
    padding-right: 0 !important;
    padding-left: 2rem !important;
  }
  .rtl .gx-pl-lg-5 {
    padding-left: 0 !important;
    padding-right: 2rem !important;
  }
  .rtl .gx-mr-lg-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }
  .rtl .gx-ml-lg-auto {
    margin-left: 0 !important;
    margin-right: auto !important;
  }
  .rtl .gx-float-lg-left {
    float: right !important;
  }
  .rtl .gx-float-lg-right {
    float: left !important;
  }
}
@media (min-width: 1200px) {
  .rtl .gx-mr-xl-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }
  .rtl .gx-ml-xl-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }
  .rtl .gx-mr-xl-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }
  .rtl .gx-ml-xl-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }
  .rtl .gx-mr-xl-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }
  .rtl .gx-ml-xl-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }
  .rtl .gx-mr-xl-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }
  .rtl .gx-ml-xl-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }
  .rtl .gx-mr-xl-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }
  .rtl .gx-ml-xl-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }
  .rtl .gx-pr-xl-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }
  .rtl .gx-pl-xl-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }
  .rtl .gx-pr-xl-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }
  .rtl .gx-pl-xl-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }
  .rtl .gx-pr-xl-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }
  .rtl .gx-pl-xl-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }
  .rtl .gx-pr-xl-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }
  .rtl .gx-pl-xl-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }
  .rtl .gx-pr-xl-5 {
    padding-right: 0 !important;
    padding-left: 2rem !important;
  }
  .rtl .gx-pl-xl-5 {
    padding-left: 0 !important;
    padding-right: 2rem !important;
  }
  .rtl .gx-mr-xl-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }
  .rtl .gx-ml-xl-auto {
    margin-left: 0 !important;
    margin-right: auto !important;
  }
  .rtl .gx-float-xl-left {
    float: right !important;
  }
  .rtl .gx-float-xl-right {
    float: left !important;
  }
}
@media (min-width: 1368px) {
  .rtl .gx-mr-xxl-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }
  .rtl .gx-ml-xxl-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }
  .rtl .gx-mr-xxl-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }
  .rtl .gx-ml-xxl-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }
  .rtl .gx-mr-xxl-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }
  .rtl .gx-ml-xxl-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }
  .rtl .gx-mr-xxl-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }
  .rtl .gx-ml-xxl-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }
  .rtl .gx-mr-xxl-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }
  .rtl .gx-ml-xxl-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }
  .rtl .gx-pr-xxl-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }
  .rtl .gx-pl-xxl-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }
  .rtl .gx-pr-xxl-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }
  .rtl .gx-pl-xxl-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }
  .rtl .gx-pr-xxl-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }
  .rtl .gx-pl-xxl-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }
  .rtl .gx-pr-xxl-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }
  .rtl .gx-pl-xxl-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }
  .rtl .gx-pr-xxl-5 {
    padding-right: 0 !important;
    padding-left: 2rem !important;
  }
  .rtl .gx-pl-xxl-5 {
    padding-left: 0 !important;
    padding-right: 2rem !important;
  }
  .rtl .gx-mr-xxl-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }
  .rtl .gx-ml-xxl-auto {
    margin-left: 0 !important;
    margin-right: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/wieldy.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;;;;CAIC;AACD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;gEAkEgE;AAChE;;;;;;EAME,aAAa;AACf;AACA,0EAA0E;AAC1E;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,kMAAkM;EAClM,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;;;;;;EAME,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;;;EAIE,wBAAwB;AAC1B;AACA;;;EAGE,aAAa;EACb,kBAAkB;AACpB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;;;EAIE,cAAc;EACd,qFAAqF;AACvF;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;;;;;;;;;EASE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;;;;EAKE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;AACtB;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;;;;EAIE,UAAU;EACV,kBAAkB;AACpB;AACA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;AACA;;;;EAIE,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,8DAA8D;AAChE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,8DAA8D;AAChE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,8DAA8D;AAChE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,8DAA8D;AAChE;AACA;EACE;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,iDAAiD;EACjD,YAAY;EACZ,6GAA6G;EAC7G,6BAA6B;EAC7B,WAAW;EACX,oBAAoB;AACtB;AACA;EACE;IACE,yBAAyB;IACzB,mDAAmD;EACrD;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,iEAAiE;AACnE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,iEAAiE;AACnE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,iEAAiE;AACnE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,iEAAiE;AACnE;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;AACF;AACA;EACE;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;EACZ;AACF;AACA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,2BAA2B;IAC3B,UAAU;EACZ;AACF;AACA;EACE;IACE,oBAAoB;IACpB,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;EACZ;AACF;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;AACF;AACA;EACE;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;EACZ;AACF;AACA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,UAAU;EACZ;AACF;AACA;EACE;IACE,oBAAoB;IACpB,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;EACZ;AACF;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;;EAEE,eAAe;AACjB;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;;EAEE,eAAe;AACjB;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;;EAEE,eAAe;AACjB;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;;EAEE,eAAe;AACjB;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;;EAEE,eAAe;AACjB;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;;EAEE,eAAe;AACjB;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;;EAEE,eAAe;AACjB;AACA;EACE,+DAA+D;AACjE;AACA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;IACrB,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;IACrB,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0HAA0H;AAC5H;AACA;EACE,gBAAgB;EAChB,0HAA0H;AAC5H;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,6RAA6R;AAC/R;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,UAAU;EACV,OAAO;EACP,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;;EAEE,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,UAAU;EACV,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;;;EAGE,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,wDAAwD;EACxD,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,kEAAkE;EAClE,yBAAyB;AAC3B;AACA;EACE,oEAAoE;EACpE,yBAAyB;AAC3B;AACA;;EAEE,2EAA2E;AAC7E;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,yDAAyD;EACzD,gDAAgD;EAChD,oCAAoC;EACpC,mCAAmC;EACnC,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,SAAS;EACT,gDAAgD;EAChD,oCAAoC;EACpC,mCAAmC;EACnC,+CAA+C;AACjD;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,wCAAwC;IACxC,UAAU;EACZ;EACA;IACE,wCAAwC;EAC1C;AACF;AACA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;IACxC,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,8CAA8C;IAC9C,qBAAqB;EACvB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,QAAQ;EACR,+DAA+D;AACjE;AACA;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,OAAO;EACP,+DAA+D;AACjE;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,WAAW;EACX,OAAO;EACP,cAAc;EACd,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,OAAO;EACP,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,OAAO;EACP,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,QAAQ;EACR,WAAW;EACX,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE;IACE,yCAAyC;IACzC,UAAU;EACZ;EACA;IACE,yCAAyC;EAC3C;AACF;AACA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,wCAAwC;EACxC,eAAe;EACf,yDAAyD;EACzD,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;EAGE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;EACzC,wCAAwC;EACxC,yBAAyB;EACzB,qDAAqD;EACrD,iDAAiD;AACnD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,qDAAqD;EACrD,iDAAiD;AACnD;AACA;;EAEE,qDAAqD;EACrD,iDAAiD;AACnD;AACA;;EAEE,cAAc;EACd,qDAAqD;EACrD,iDAAiD;AACnD;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;;EAIE,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;;;;EAIE,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,gCAAgC;AAClC;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,iEAAiE;AACnE;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,8GAA8G;AAChH;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;AACpB;AACA;;;;;;EAME,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;;;;;;;EAOE,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;;;;;;;;;;;;;EAcE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;;;;EAIE,uBAAuB;AACzB;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;;;;EAIE,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,2BAA2B;EAC3B,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;;EAEE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;;EAEE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;AACA;;EAEE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,eAAe;IACf,cAAc;EAChB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uHAAuH;EACvH,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;AACjB;AACA;;;;EAIE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,8BAA8B;EAC9B,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,uEAAuE;EACvE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,yCAAyC;EACzC,UAAU;EACV,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,MAAM;EACN,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,cAAc;EACd,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,MAAM;EACN,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,8BAA8B;EAC9B,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,uEAAuE;EACvE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,yCAAyC;EACzC,UAAU;EACV,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;;EAEE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;;;;;EAME,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,wBAAwB;AAC1B;AACA;;;;EAIE,8BAA8B;AAChC;AACA;;;;EAIE,4BAA4B;AAC9B;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,+CAA+C;EAC/C,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC,WAAW;EACX,yBAAyB;EACzB,8WAA8W;AAChX;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oHAAoH;EACpH,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;;;;;;;EAOE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,WAAW;AACb;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,OAAO;EACP,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;;;;;;;EAOE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;AACb;AACA;;;EAGE,QAAQ;EACR,SAAS;AACX;AACA;;;;;;;EAOE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;;;;;EAKE,SAAS;EACT,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;;;;EAKE,UAAU;EACV,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;;;;EAIE,aAAa;AACf;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,WAAW;AACb;AACA;;;EAGE,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;;;EAGE,WAAW;EACX,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;;;EAGE,WAAW;EACX,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;;;EAGE,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,kCAAkC;AACpC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,UAAU;EACV,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;AACrB;AACA,yEAAyE;AACzE;;;;EAIE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,OAAO;AACT;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,UAAU;EACV,OAAO;AACT;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;;;;EAIE,UAAU;EACV,OAAO;EACP,gCAAgC;EAChC,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;;;;EAIE,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;;;;;;;EAOE,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,OAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,+BAA+B;AACjC;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,MAAM;EACN,SAAS;EACT,OAAO;EACP,uHAAuH;AACzH;AACA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,0HAA0H;AAC5H;AACA;EACE,MAAM;EACN,QAAQ;EACR,OAAO;EACP,uHAAuH;AACzH;AACA;EACE,QAAQ;EACR,SAAS;EACT,OAAO;EACP,0HAA0H;AAC5H;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;AACA;;EAEE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,OAAO;EACP,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;AACtB;AACA;;;EAGE,oBAAoB;AACtB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;AACtB;AACA;;EAEE,uCAAuC;AACzC;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;AACtB;AACA;;EAEE,sCAAsC;AACxC;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;AACtB;AACA;;EAEE,uCAAuC;AACzC;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;AACtB;AACA;;EAEE,sCAAsC;AACxC;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,4BAA4B;AAC9B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC,WAAW;EACX,yBAAyB;EACzB,8WAA8W;AAChX;AACA;;;EAGE,YAAY;EACZ,+CAA+C;EAC/C,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,yCAAyC;AAC3C;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;EAGE,iBAAiB;EACjB,+CAA+C;EAC/C,6CAA6C;AAC/C;AACA;EACE,SAAS;EACT,8DAA8D;AAChE;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,oHAAoH;AACtH;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;AACb;AACA;;EAEE,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;AACA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;;;EAIE,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;;;EAIE,oBAAoB;AACtB;AACA;;EAEE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;;;;EAME,4BAA4B;AAC9B;AACA;;;;;;EAME,8BAA8B;AAChC;AACA;;;EAGE,6BAA6B;AAC/B;AACA;;;EAGE,+BAA+B;AACjC;AACA;;;EAGE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,oCAAoC;AACtC;AACA;;;;EAIE,gCAAgC;AAClC;AACA;;;;EAIE,gCAAgC;AAClC;AACA;;;;EAIE,WAAW;EACX,uBAAuB;AACzB;AACA;;;EAGE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;;;;EAIE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,SAAS;AACX;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,OAAO;EACP,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;;;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,cAAc;IACd,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,oEAAoE;EACpE,0FAA0F;AAC5F;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;;EAEE,YAAY;AACd;AACA;;;EAGE,oBAAoB;EACpB,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,0DAA0D;EAC1D,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,6DAA6D;AAC/D;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,+KAA+K;AACjL;AACA;;EAEE,2BAA2B;EAC3B,UAAU;AACZ;AACA;;EAEE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,+KAA+K;AACjL;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;EAME,WAAW;EACX,UAAU;AACZ;AACA;;;EAGE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;;;EAIE,WAAW;EACX,OAAO;AACT;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,yDAA+pB;EAC/pB,4BAA4B;EAC5B,kCAAkC;EAClC,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,UAAU;EACV,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,iEAAiE;EACjE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,iEAAiE;AACnE;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;AACA;;EAEE,8BAA8B;AAChC;AACA;;;;EAIE,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;;EAEE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;;;;;EAME,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,sBAAsB;AACxB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;AACZ;AACA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;;EAEE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;;;;;EAME,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;EAEE,UAAU;EACV,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;;;EAGE,uBAAuB;AACzB;AACA;;;EAGE,UAAU;AACZ;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;;;EAIE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;;;EAIE,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;;;;;EAKE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;;EAEE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;;;;;;;;;EASE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;;EAEE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;;;;;EAME,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;;EAEE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;;EAEE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;;;;;EAME,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;EAEE,UAAU;EACV,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;;;EAGE,uBAAuB;AACzB;AACA;;;EAGE,UAAU;AACZ;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;;;EAIE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;;;EAIE,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;;;;;EAKE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,sCAAsC;AACxC;AACA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,SAAS;EACT,0DAA0D;EAC1D,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;EACV,qCAAqC;AACvC;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;;EAEE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,MAAM;EACN,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,mEAAmE;EACnE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,QAAQ;AACV;AACA;;EAEE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,mEAAmE;EACnE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kEAAkE;EAClE,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,OAAO;EACP,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,QAAQ;EACR,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,OAAO;AACT;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;;EAEE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;;;;;EAME,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;;EAEE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yEAAyE;EACzE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,wEAAwE;EACxE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,oHAAoH;AACtH;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,oHAAoH;EACpH,qEAAqE;AACvE;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,wHAAwH;AAC1H;AACA;;EAEE,4KAA4K;AAC9K;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mHAAmH;AACrH;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;AAClB;AACA;;;EAGE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;;;EAGE,gBAAgB;EAChB,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;;;EAGE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;EAGE,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;;;EAGE,eAAe;AACjB;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,8CAA8C;AAChD;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,iGAAiG;AACnG;AACA;;;;EAIE,eAAe;EACf,eAAe;EACf,6HAA6H;AAC/H;AACA;;;;EAIE,iBAAiB;EACjB,UAAU;EACV,sFAAsF;AACxF;AACA;;EAEE,wBAAwB;AAC1B;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,MAAM;EACN,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,+DAA+D;AACjE;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,cAAc;EACd,2BAA2B;EAC3B,+DAA+D;AACjE;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,qNAAqN;EACrN,WAAW;AACb;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,2CAA2C;AAC7C;AACA;;EAEE,2CAA2C;AAC7C;AACA;EACE,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,0CAA0C;AAC5C;AACA;;;EAGE,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;;;;;;;;EAQE,+BAA+B;AACjC;AACA;;;;;;;;EAQE,iDAAiD;AACnD;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,kEAAkE;EAClE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,cAAc;AAChB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,gDAAgD;EAChD,yBAAyB;EACzB,UAAU;EACV,kHAAkH;EAClH,WAAW;AACb;AACA;;;;;;;;EAQE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;;;;EAIE,sBAAsB;AACxB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;;;;;;;EAQE,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;;EAEE,oBAAoB;EACpB,UAAU;EACV,oHAAoH;AACtH;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,gGAAgG;AAClG;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,OAAO;EACP,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;;;;;EAQE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;;;;EAQE,qBAAqB;EACrB,UAAU;AACZ;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,sBAAsB;AACxB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,qCAAqC;EACrC,oBAAoB;AACtB;AACA;;EAEE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;;;;EAIE,0CAA0C;AAC5C;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,WAAW;AACb;AACA;;;;;EAKE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;;EAGE,cAAc;EACd,oCAAoC;AACtC;AACA;;;EAGE,aAAa;EACb,oBAAoB;AACtB;AACA;;;;;;EAME,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,MAAM;EACN,aAAa;EACb,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;;;;EAIE,cAAc;AAChB;AACA;;;;EAIE,eAAe;AACjB;AACA;;;;EAIE,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,WAAW;AACb;AACA;;;;;;EAME,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;;;;;;;;;;;;EAYE,iCAAiC;AACnC;AACA;;;;;;EAME,UAAU;AACZ;AACA;;;;;;;;;;;;EAYE,sCAAsC;AACxC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;;;EAIE,iCAAiC;AACnC;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;;;;EAME,2CAA2C;EAC3C,YAAY;AACd;AACA;;EAEE,2CAA2C;AAC7C;AACA;;;;EAIE,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;;EAEE,iBAAiB;AACnB;AACA;;;;;;EAME,2BAA2B;AAC7B;AACA;;;;EAIE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;;;;EAIE,WAAW;EACX,UAAU;AACZ;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,wCAAwC;AAC1C;AACA;;;;EAIE,WAAW;EACX,OAAO;AACT;AACA;;;;;;;;EAQE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,QAAQ;EACR,OAAO;EACP,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oHAAoH;EACpH,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE;IACE,iBAAiB;IACjB,YAAY;IACZ,UAAU;EACZ;EACA;IACE,aAAa;IACb,UAAU;IACV,UAAU;EACZ;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;AACtB;AACA;;EAEE,eAAe;EACf,UAAU;EACV,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,oHAAoH;EACpH,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;;EAEE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,MAAM;EACN,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,OAAO;EACT;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,oHAAoH;AACtH;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kDAAkD;EAClD,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,+DAA+D;EAC/D,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,+DAA+D;EAC/D,yBAAyB;EACzB,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,+DAA+D;EAC/D,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;;EAEE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,OAAO;IACP,UAAU;EACZ;AACF;AACA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;EAEE,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,wCAAwC;AAC1C;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;;;;EAIE,sCAAsC;AACxC;AACA;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,aAAa;IACb,UAAU;EACZ;AACF;AACA;EACE;IACE,oBAAoB;IACpB,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF;AACA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kMAAkM;EAClM,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;;EAIE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kMAAkM;EAClM,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;;EAEE,yCAAyC;EACzC,UAAU;AACZ;AACA;;EAEE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE;;IAEE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;;EAEE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;;;;;EAME,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,6BAA6B;EAC7B,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,iBAAiB;AACnB;AACA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;;IAEE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;;;EAIE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;;;EAGE,4BAA4B;AAC9B;AACA;;;EAGE,0BAA0B;AAC5B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,oHAAoH;AACtH;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,oHAAoH;EACtH;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;EAC9C,4BAA4B;EAC5B,gCAAgC;EAChC,WAAW;EACX,yBAAyB;EACzB,8WAA8W;AAChX;AACA;;;EAGE,SAAS;EACT,2BAA2B;AAC7B;AACA;;;EAGE,2CAA2C;EAC3C,0CAA0C;AAC5C;AACA;EACE,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;EAGE,OAAO;EACP,4BAA4B;AAC9B;AACA;;;EAGE,2CAA2C;EAC3C,0CAA0C;AAC5C;AACA;EACE,QAAQ;EACR,6CAA6C;AAC/C;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;;;EAGE,MAAM;EACN,4BAA4B;AAC9B;AACA;;;EAGE,2CAA2C;EAC3C,2CAA2C;AAC7C;AACA;EACE,SAAS;EACT,6CAA6C;AAC/C;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;EAGE,QAAQ;EACR,2BAA2B;AAC7B;AACA;;;EAGE,2CAA2C;EAC3C,2CAA2C;AAC7C;AACA;EACE,QAAQ;EACR,4CAA4C;AAC9C;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;EACpB,yDAAyD;AAC3D;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,2EAA2E;EAC3E,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,SAAS;EACT,UAAU;EACV,cAAc;EACd,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,sCAAsC;IACtC,YAAY;EACd;EACA;IACE,sCAAsC;IACtC,YAAY;EACd;EACA;IACE,kCAAkC;IAClC,UAAU;EACZ;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;;EAEE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,yDAAyD;EACzD,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,2EAA2E;AAC7E;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,4CAA4C;AAC9C;AACA;;;EAGE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iHAAiH;AACnH;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;EACZ,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,2DAA2D;AAC7D;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iHAAiH;EACjH,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iHAAiH;EACjH,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;AACA;EACE,gHAAgH;EAChH,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;EAEE,UAAU;EACV,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;;EAGE,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;;;EAGE;AACF;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yDAAyD;EACzD,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;AACA;;EAEE,cAAc;EACd,kMAAkM;EAClM,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,uBAAuB;EACvB,UAAU;AACZ;AACA;;;;EAIE,WAAW;AACb;AACA;;;;EAIE,mBAAmB;AACrB;AACA,6BAA6B;AAC7B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;;IAEE,UAAU;EACZ;AACF;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE;;IAEE,UAAU;EACZ;AACF;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,+CAA+C;EAC/C,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,oHAAoH;AACtH;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,oBAAoB;AACtB;AACA;;;;;;EAME,kBAAkB;EAClB,iFAAiF;EACjF,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;;;;EAME,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,SAAS;EACT,WAAW;EACX,6HAA6H;EAC7H,kDAAkD;EAClD,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mGAAmG;AACrG;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gDAAgD;AAClD;AACA;;EAEE,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,+DAA+D;AACjE;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,mDAAmD;AACrD;AACA;EACE,MAAM;EACN,OAAO;AACT;AACA;EACE,MAAM;EACN,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,OAAO;EACP,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kMAAkM;AACpM;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kMAAkM;EAClM,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,oDAAoD;AACtD;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;;;;EAIE,sBAAsB;AACxB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,wBAAwB;EACxB,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,WAAW;AACb;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,OAAO;AACT;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,MAAM;EACN,QAAQ;EACR,WAAW;EACX,cAAc;EACd,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,UAAU;EACV,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;;EAEE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,qCAAqC;EACrC,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,wCAAwC;AAC1C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;;;;;;EAME,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;;;;;;;;;;;;;;;;EAgBE,+BAA+B;AACjC;AACA;;;;EAIE,gCAAgC;AAClC;AACA;;;;EAIE,wCAAwC;AAC1C;AACA;;;;;;;;;;;;EAYE,+BAA+B;AACjC;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,SAAS;EACT,+BAA+B;EAC/B,WAAW;AACb;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;AACnB;AACA;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,gBAAgB;AAClB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;AACT;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,oHAAoH;AACtH;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,0BAA0B;AAC5B;AACA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,QAAQ;EACR,UAAU;EACV,SAAS;EACT,WAAW;AACb;AACA;EACE,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,OAAO;EACP,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,8BAA8B;EAC9B,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qDAAqD;AACvD;AACA;;EAEE,qDAAqD;AACvD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sDAAsD;AACxD;AACA;;EAEE,sDAAsD;AACxD;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;;;;EAIE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;;;;EAIE,iBAAiB;EACjB,cAAc;AAChB;AACA;;;;EAIE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,sBAAsB;AACxB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,gCAAgC;EAChC,WAAW;AACb;AACA;;;;EAIE,WAAW;AACb;AACA;;;;EAIE,6CAA6C;AAC/C;AACA;;;;;;;;EAQE,MAAM;EACN,SAAS;EACT,WAAW;AACb;AACA;;;;EAIE,OAAO;EACP,qDAAqD;AACvD;AACA;;;;EAIE,QAAQ;EACR,sDAAsD;AACxD;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,MAAM;AACR;AACA;;EAEE,MAAM;AACR;AACA;;EAEE,QAAQ;AACV;AACA;;;;EAIE,sBAAsB;EACtB,eAAe;AACjB;AACA;;;;EAIE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;;;EAIE,sBAAsB;AACxB;AACA;;;;;;;;EAQE,QAAQ;EACR,OAAO;EACP,YAAY;AACd;AACA;;;;EAIE,MAAM;EACN,qDAAqD;AACvD;AACA;;;;EAIE,SAAS;EACT,sDAAsD;AACxD;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,iCAAiC;AACnC;AACA;;;;;;;;EAQE,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,QAAQ;AACV;AACA;;EAEE,iBAAiB;EACjB,8BAA8B;AAChC;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,QAAQ;AACV;AACA;;EAEE,OAAO;AACT;AACA;;EAEE,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;AACjC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,oHAAoH;AACtH;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yDAAyD;AAC3D;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,sBAAsB;AACxB;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;AAC5B;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;AACX;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,2BAA2B;EAC3B,WAAW;AACb;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,yDAAyD;AAC3D;AACA;;EAEE,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;AACjB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;EAKE,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;EASE,SAAS;AACX;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;;EAGE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;;;EAGE,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;EACV,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;;;;EASE,UAAU;EACV,UAAU;AACZ;AACA;;;EAGE,kBAAkB;EAClB,cAAc;AAChB;AACA;;;EAGE,iBAAiB;EACjB,cAAc;AAChB;AACA;;;EAGE,sBAAsB;EACtB,UAAU;EACV,iBAAiB;AACnB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;;;EAGE,4BAA4B;AAC9B;AACA;;;EAGE,0BAA0B;AAC5B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,oHAAoH;AACtH;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,yGAAyG;EACzG,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;EAC9C,4BAA4B;EAC5B,gCAAgC;EAChC,WAAW;EACX,yBAAyB;EACzB,8WAA8W;AAChX;AACA;;;EAGE,SAAS;EACT,2BAA2B;AAC7B;AACA;;;EAGE,2CAA2C;EAC3C,0CAA0C;AAC5C;AACA;EACE,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;EAGE,OAAO;EACP,4BAA4B;AAC9B;AACA;;;EAGE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,QAAQ;EACR,6CAA6C;AAC/C;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;;;EAGE,QAAQ;EACR,2BAA2B;AAC7B;AACA;;;EAGE,4CAA4C;EAC5C,2CAA2C;AAC7C;AACA;EACE,QAAQ;EACR,4CAA4C;AAC9C;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;;;EAGE,MAAM;EACN,4BAA4B;AAC9B;AACA;;;EAGE,6CAA6C;EAC7C,0CAA0C;AAC5C;AACA;EACE,SAAS;EACT,6CAA6C;AAC/C;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;AACA;EACE,UAAU;EACV,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,OAAO;EACP,iCAAiC;EACjC,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,8BAA8B;EAC9B,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,uEAAuE;EACvE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,yCAAyC;EACzC,UAAU;EACV,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,UAAU;EACV,2CAA2C;EAC3C,6BAA6B;EAC7B,6BAA6B;EAC7B,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,wBAAwB;AAC1B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,8DAA8D;AAChE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,8BAA8B;EAC9B,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,uEAAuE;EACvE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,yCAAyC;EACzC,UAAU;EACV,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,UAAU;EACV,2CAA2C;EAC3C,6BAA6B;EAC7B,6BAA6B;EAC7B,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,wBAAwB;AAC1B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,8DAA8D;AAChE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;;;;EAIE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;;;;EAIE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;;;;EAIE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;;;;EAIE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;EAIE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;EAKE,iBAAiB;AACnB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6CE,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,eAAe;AACjB;AACA;;EAEE,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;AACvB;AACA;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;;;;;;;EAQE,0BAA0B;AAC5B;AACA;;;;EAIE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,qCAAqC;EACrC,0CAA0C;EAC1C,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;;EAEE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,0DAA0D;EAC1D,qBAAqB;AACvB;AACA;;EAEE,eAAe;EACf,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,+CAA+C;EAC/C,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,uDAAuD;EACvD,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,cAAc;AAChB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;EACV,oBAAoB;AACtB;AACA;;;EAGE,WAAW;EACX,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;AACA;;;EAGE,WAAW;AACb;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;;;EAGE,aAAa;AACf;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,eAAe;AACjB;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,cAAc;EACd,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;;EAEE,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,SAAS;EACT,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,wBAAwB;EACxB,+DAA+D;EAC/D,6BAA6B;AAC/B;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,QAAQ;IACR,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;EACZ;AACF;AACA;EACE;IACE,QAAQ;IACR,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;EACZ;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,UAAU;EACV,+BAA+B;AACjC;AACA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA,kBAAkB;AAClB;EACE,qDAAqD;AACvD;AACA;;EAEE,qDAAqD;AACvD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uDAAuD;AACzD;AACA;;EAEE,uDAAuD;AACzD;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;;EAEE,0CAA0C;AAC5C;AACA;EACE,4CAA4C;AAC9C;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iDAAiD;AACnD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;;;EAGE,yBAAyB;EACzB,qDAAqD;EACrD,iDAAiD;AACnD;AACA;;;;;;EAME,yBAAyB;EACzB,qDAAqD;EACrD,iDAAiD;AACnD;AACA;;;;;;EAME,qDAAqD;EACrD,iDAAiD;AACnD;AACA;;;;;;EAME,cAAc;EACd,qDAAqD;EACrD,iDAAiD;AACnD;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;;;;;;EAME,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,uDAAuD;EACvD,mDAAmD;AACrD;AACA;;;;EAIE,cAAc;EACd,uDAAuD;EACvD,mDAAmD;AACrD;AACA;;;;EAIE,uDAAuD;EACvD,mDAAmD;AACrD;AACA;;;;EAIE,cAAc;EACd,uDAAuD;EACvD,mDAAmD;AACrD;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;;;EAQE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;;;EAQE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;;;EAQE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,0CAA0C;EAC1C,wCAAwC;EACxC,iDAAiD;AACnD;AACA;;;;EAIE,yBAAyB;EACzB,qDAAqD;EACrD,iDAAiD;AACnD;AACA;;;;EAIE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;;EAEE,4CAA4C;EAC5C,wCAAwC;EACxC,mDAAmD;AACrD;AACA;;;;EAIE,yBAAyB;EACzB,uDAAuD;EACvD,mDAAmD;AACrD;AACA;;;;EAIE,4CAA4C;EAC5C,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;;;;;EAQE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;;;EAQE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uDAAuD;AACzD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,UAAU;EACV,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;AACA;EACE,cAAc;EACd,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;EACxC,4BAA4B;AAC9B;AACA;EACE;IACE,kDAAkD;EACpD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,+CAA+C;IAC/C,0CAA0C;EAC5C;EACA;IACE,gDAAgD;IAChD,2CAA2C;EAC7C;EACA;IACE,6CAA6C;IAC7C,wCAAwC;EAC1C;AACF;AACA;EACE,cAAc;EACd,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE;IACE,kDAAkD;EACpD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,+CAA+C;IAC/C,0CAA0C;EAC5C;EACA;IACE,gDAAgD;IAChD,2CAA2C;EAC7C;EACA;IACE,6CAA6C;IAC7C,wCAAwC;EAC1C;AACF;AACA;EACE,cAAc;EACd,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE;IACE,mDAAmD;EACrD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,iDAAiD;EACnD;AACF;AACA;EACE;IACE,gDAAgD;IAChD,2CAA2C;EAC7C;EACA;IACE,iDAAiD;IACjD,4CAA4C;EAC9C;EACA;IACE,8CAA8C;IAC9C,yCAAyC;EAC3C;AACF;AACA;EACE,cAAc;EACd,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE;IACE,mDAAmD;EACrD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,iDAAiD;EACnD;AACF;AACA;EACE;IACE,gDAAgD;IAChD,2CAA2C;EAC7C;EACA;IACE,iDAAiD;IACjD,4CAA4C;EAC9C;EACA;IACE,8CAA8C;IAC9C,yCAAyC;EAC3C;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;AACA;EACE,mDAAmD;EACnD,2CAA2C;AAC7C;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA,qDAAqD;AACrD;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;AACA,mEAAmE;AACnE;;;;EAIE,qDAAqD;AACvD;AACA,2BAA2B;AAC3B,kCAAkC;AAClC;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA,sBAAsB;AACtB;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,iCAAiC;AACnC;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,+CAA+C;EAC/C,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,OAAO;IACP,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,yBAAyB;EAC3B;AACF;AACA;EACE,iDAAiD;EACjD,2CAA2C;AAC7C;AACA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,uDAAuD;EACvD,iDAAiD;AACnD;AACA;EACE,uDAAuD;AACzD;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;AAChC;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,uDAAuD;EACvD,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,uDAAuD;EACvD,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;AACxB;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,qDAAqD;AACvD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE;IACE,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;AACA;EACE,sBAAsB;AACxB;AACA,qCAAqC;AACrC;EACE;IACE,UAAU;IACV,WAAW;EACb;EACA,UAAU;EACV;IACE,mBAAmB;EACrB;EACA,WAAW;EACX;IACE,gBAAgB;EAClB;EACA,oBAAoB;EACpB;IACE,gBAAgB;EAClB;AACF;AACA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qDAAqD;AACvD;AACA;;EAEE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iDAAiD;AACnD;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,+CAA+C;AACjD;AACA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,8BAA8B;AAChC;AACA;EACE,qDAAqD;AACvD;AACA;;EAEE,0CAA0C;EAC1C,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA,6BAA6B;AAC7B;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;AACF;AACA,kBAAkB;AAClB;EACE;IACE,eAAe;IACf,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;AACF;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uDAAuD;EACvD,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,uDAAuD;AACzD;AACA,cAAc;AACd;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;EACd,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;IACb,mCAAmC;IACnC,gCAAgC;IAChC,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,2BAA2B;EAC7B;AACF;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,+BAA+B;AACjC;AACA;;;;EAIE,+BAA+B;AACjC;AACA;EACE,qBAAqB;AACvB;AACA;;;EAGE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA,eAAe;AACf;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;AACA;;;;EAIE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;;;;;;;;;;;EAWE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;AACf;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;;;;;EAKE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA,kBAAkB;AAClB;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA,WAAW;AACX;EACE,sCAAsC;EACtC,cAAc;AAChB;AACA,eAAe;AACf;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;AAChC;AACA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;AAChC;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0CAA0C;EAC1C,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,6MAA6M;AAC/M;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA,cAAc;AACd;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA,uBAAuB;AACvB;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;EACjC,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,sCAAsC;AACxC;AACA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,yCAAyC;AAC3C;AACA;EACE,gDAAgD;EAChD,4CAA4C;EAC5C,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,uCAAuC;AACzC;AACA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,sCAAsC;AACxC;AACA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwHE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA,wBAAwB;AACxB;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,kCAAkC;AACpC;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;AACA,oBAAoB;AACpB;;;;;;;;;;;;EAYE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE;;IAEE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;AACF;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,qCAAqC;AACvC;AACA,oBAAoB;AACpB,MAAM;AACN;EACE,cAAc;AAChB;AACA,OAAO;AACP;EACE,eAAe;AACjB;AACA,OAAO;AACP;EACE,eAAe;AACjB;AACA,OAAO;AACP;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA,OAAO;AACP;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,OAAO;AACP;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,MAAM;EACN,OAAO;EACP,oBAAoB;EACpB,OAAO;AACT;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA,iBAAiB;AACjB;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,iDAAiD;EACjD,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE;;IAEE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;;IAEE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;EAC9B,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;IACX,aAAa;EACf;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;;;EAGE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;EAEE,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,0CAA0C;EAC1C,sCAAsC;EACtC,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,0CAA0C;EAC1C,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,+BAA+B;EAC/B,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;;IAEE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA,kBAAkB;AAClB;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;EACT,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,wDAAwD;AAC1D;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,uDAAuD;AACzD;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,wDAAwD;AAC1D;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,6CAA6C;EAC/C;AACF;AACA;EACE;IACE,6CAA6C;EAC/C;AACF;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,+CAA+C;EAC/C,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA,mBAAmB;AACnB;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;;;;;EAKE,+BAA+B;AACjC;AACA;;;EAGE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,+BAA+B;AACjC;AACA;;;;;;EAME,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,cAAc;EAChB;AACF;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,UAAU;AACZ;AACA;EACE;;IAEE,UAAU;EACZ;AACF;AACA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,cAAc;EAChB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,UAAU;EACV,WAAW;AACb;AACA;;;;EAIE,UAAU;EACV,WAAW;AACb;AACA;;;;;;;;EAQE,6DAA6D;AAC/D;AACA;;;;;;;;EAQE,UAAU;AACZ;AACA;;;;;;;;EAQE,yFAAyF;AAC3F;AACA;;;EAGE,+BAA+B;AACjC;AACA;;;EAGE,+BAA+B;AACjC;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,oCAAoC;AACtC;AACA;;;;;;;;EAQE,iDAAiD;EACjD,+BAA+B;AACjC;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,YAAY;AACd;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,gDAAgD;AAClD;AACA;;;;;;;;EAQE,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;;EAgBE,6BAA6B;AAC/B;AACA;;;;;;;;EAQE,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;;;;;;;;;;;;EAgBE,kBAAkB;EAClB,QAAQ;AACV;AACA;;;;;;;;EAQE,YAAY;EACZ,qBAAqB;EACrB,UAAU;AACZ;AACA;;;;;;;;EAQE,aAAa;AACf;AACA;;;;;;;;EAQE,6CAA6C;AAC/C;AACA;;;;EAIE,6BAA6B;AAC/B;AACA;;;;;;;;EAQE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;;;EAGE,OAAO;EACP,8BAA8B;AAChC;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,YAAY;EACZ,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,yFAAyF;AAC3F;AACA;;EAEE,cAAc;EACd,oCAAoC;AACtC;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,6CAA6C;AAC/C;AACA;;EAEE,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;AACA;;;;;;EAME,iCAAiC;AACnC;AACA;;;;;;EAME,iCAAiC;AACnC;AACA;;;;;;;;;;;;EAYE,mBAAmB;AACrB;AACA;;;;;;;;;;;;EAYE,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;AACA;;EAEE,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;;;EAIE,2CAA2C;AAC7C;AACA;;EAEE,2CAA2C;AAC7C;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,eAAe;AACjB;AACA;;;;EAIE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,+FAA+F;AACjG;AACA;;;;;;;;;;;;EAYE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,0CAA0C;EAC1C,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,cAAc;EAChB;AACF;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;;;;;;EAQE,+CAA+C;EAC/C,iCAAiC;AACnC;AACA;;;;;;;;EAQE,iCAAiC;AACnC;AACA;;;;;;;;EAQE,gCAAgC;AAClC;AACA;;EAEE,qBAAqB;EACrB,aAAa;EACb,MAAM;AACR;AACA;;;;;;;;EAQE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;;;;;;;EAQE,kBAAkB;AACpB;AACA;;;;;;;;EAQE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;;EAQE,+BAA+B;AACjC;AACA;;;;;;;;EAQE,gCAAgC;AAClC;AACA;;;;;;;;;;EAUE,iCAAiC;AACnC;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;;EAEE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,4CAA4C;EAC5C,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;;EAEE,mGAAmG;AACrG;AACA;;;;;;;;;;EAUE,mGAAmG;AACrG;AACA;;;;;;EAME,iCAAiC;AACnC;AACA;;;EAGE,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;;;EAGE,iCAAiC;AACnC;AACA;EACE,oBAAoB;AACtB;AACA;;;EAGE,0BAA0B;AAC5B;AACA;;;EAGE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;;EAEE,+BAA+B;EAC/B,4CAA4C;EAC5C,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;;;;;;;EAQE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA,iBAAiB;AACjB;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA,qBAAqB;AACrB;EACE,qCAAqC;AACvC;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,gDAAgD;AAClD;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,cAAc;EACd,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE;IACE,MAAM;IACN,SAAS;IACT,aAAa;IACb,mCAAmC;IACnC,gCAAgC;IAChC,2BAA2B;EAC7B;AACF;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE;IACE,MAAM;IACN,SAAS;IACT,aAAa;IACb,mCAAmC;IACnC,gCAAgC;IAChC,2BAA2B;EAC7B;AACF;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;;;;EAIE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;;IAEE,kBAAkB;EACpB;AACF;AACA;EACE;;IAEE,kBAAkB;EACpB;AACF;AACA;EACE;;IAEE,WAAW;IACX,UAAU;IACV,SAAS;EACX;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,eAAe;AACjB;AACA,eAAe;AACf;EACE,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA,gBAAgB;AAChB;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;AACpB;AACA,eAAe;AACf;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;EAEE,eAAe;AACjB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,qFAAqF;EACrF,2DAA2D;EAC3D,wDAAwD;EACxD,uDAAuD;EACvD,sDAAsD;EACtD,cAAc;EACd,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,qFAAqF;EACrF,2DAA2D;EAC3D,wDAAwD;EACxD,uDAAuD;EACvD,sDAAsD;AACxD;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,iDAAiD;EACjD,0CAA0C;AAC5C;AACA;;EAEE,qDAAqD;EACrD,iDAAiD;EACjD,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE;;IAEE,kBAAkB;EACpB;AACF;AACA;EACE;;IAEE,mBAAmB;EACrB;AACF;AACA;;;;EAIE,qBAAqB;AACvB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,kBAAkB;AACpB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;EAEE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA,cAAc;AACd;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;EACV,YAAY;EACZ,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,4HAA4H;EAC5H,yHAAyH;EACzH,oHAAoH;EACpH,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE,aAAa;AACf;AACA;EACE;;IAEE,aAAa;EACf;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,+CAA+C;EAC/C,4CAA4C;EAC5C,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;AACA;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gCAAgC;AAClC;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;;EAEE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;;;EAGE,eAAe;AACjB;AACA,kBAAkB;AAClB;EACE,WAAW;AACb;AACA,eAAe;AACf;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,qDAAqD;EACrD,iCAAiC;AACnC;AACA;EACE,0CAA0C;AAC5C;AACA,cAAc;AACd;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,WAAW;IACX,cAAc;EAChB;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;;IAEE,cAAc;IACd,2BAA2B;EAC7B;AACF;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;AACA,eAAe;AACf;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE;IACE,YAAY;IACZ,0BAA0B;EAC5B;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,OAAO;EACP,WAAW;AACb;AACA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,qCAAqC;IACrC,kCAAkC;IAClC,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;;;;;;IAME,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,yCAAyC;EAC3C;AACF;AACA,cAAc;AACd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,cAAc;EACd,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,eAAe;EACf,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA,cAAc;AACd;EACE,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;;;;EAIE,iBAAiB;AACnB;AACA,iBAAiB;AACjB;;;;EAIE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA,gBAAgB;AAChB;;;;;;EAME,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;AACA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;AACb;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;AACF;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA,gBAAgB;AAChB;EACE,6BAA6B;AAC/B;AACA;;;;;;;;EAQE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,4CAA4C;IAC5C,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,gCAAgC;EAClC;EACA;IACE,qBAAqB;EACvB;EACA;;;;IAIE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,6BAA6B;EAC/B;EACA;;IAEE,oBAAoB;EACtB;EACA;;;;;;IAME,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE;;IAEE,6BAA6B;EAC/B;AACF;AACA;EACE;;IAEE,wBAAwB;EAC1B;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA,mBAAmB;AACnB,wBAAwB;AACxB;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,MAAM;EACN,cAAc;EACd,eAAe;EACf,WAAW;EACX,OAAO;EACP,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;AAC3B;AACA,0BAA0B;AAC1B;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,UAAU;EACV,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,OAAO;AACT;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,UAAU;EACV,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,UAAU;EACV,UAAU;AACZ;AACA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,SAAS;EACT,YAAY;AACd;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,OAAO;EACT;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,oBAAoB;IACpB,UAAU;IACV,WAAW;EACb;EACA;IACE,WAAW;IACX,OAAO;EACT;EACA;IACE,yCAAyC;IACzC,WAAW;IACX,WAAW;EACb;EACA;IACE,yCAAyC;IACzC,WAAW;IACX,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,SAAS;IACT,aAAa;IACb,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;;IAEE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB;EACpB;EACA;;IAEE,SAAS;EACX;AACF;AACA;EACE;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;AACA,cAAc;AACd;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE;IACE,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE;IACE,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF;AACA,eAAe;AACf;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,OAAO;AACT;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,mCAAmC;AACrC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,+BAA+B;IAC/B,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,WAAW;EACX,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,cAAc;IACd,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,yBAAyB;IACzB,iBAAiB;EACnB;AACF;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;IAC3B,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;AACF;AACA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,sCAAsC;AACxC;AACA;;EAEE,iDAAiD;AACnD;AACA;EACE;;IAEE,sCAAsC;EACxC;EACA;;IAEE,sCAAsC;EACxC;AACF;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,iDAAiD;EACnD;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,uCAAuC;EACvC,oCAAoC;EACpC,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,sBAAsB;AACtB;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,QAAQ;IACR,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,QAAQ;EACV;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;AACxC;AACA;;;;;;EAME,cAAc;EACd,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;AACA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,2GAA2G;EAC3G,8EAA8E;EAC9E,2EAA2E;EAC3E,0EAA0E;EAC1E,yEAAyE;AAC3E;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,gCAAgC;EAChC,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,UAAU;EACV,WAAW;EACX,WAAW;EACX,0CAA0C;AAC5C;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,oCAAoC;EACpC,8GAA8G;EAC9G,iFAAiF;EACjF,8EAA8E;EAC9E,6EAA6E;EAC7E,4EAA4E;EAC5E,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,MAAM;EACN,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,+GAA+G;EAC/G,kFAAkF;EAClF,+EAA+E;EAC/E,8EAA8E;EAC9E,6EAA6E;AAC/E;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,oBAAoB;EACpB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;IAC5B,wBAAwB;IACxB,sCAAsC;IACtC,kCAAkC;IAClC,8BAA8B;IAC9B,kCAAkC;IAClC,8BAA8B;IAC9B,0BAA0B;IAC1B,sCAAsC;IACtC,kCAAkC;IAClC,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;AACrB;AACA,iBAAiB;AACjB,4DAA4D;AAC5D;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,QAAQ;IACR,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,QAAQ;IACR,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,eAAe;AACjB;AACA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;;EAGE,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,+CAA+C;EAC/C,4CAA4C;EAC5C,uCAAuC;AACzC;AACA;;;EAGE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,OAAO;EACP,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;;;;IAIE,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;IACb,YAAY;EACd;AACF;AACA,eAAe;AACf;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,OAAO;EACP,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;IACjB,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;;EAEE,SAAS;AACX;AACA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;;EAEE,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,mBAAmB;AACnB;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;IACX,eAAe;IACf,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,cAAc;EAChB;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE;IACE,QAAQ;IACR,WAAW;IACX,8BAA8B;IAC9B,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,oBAAoB;EACpB,QAAQ;AACV;AACA;EACE;IACE,QAAQ;IACR,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE;IACE,QAAQ;IACR,gBAAgB;EAClB;AACF;AACA;EACE,QAAQ;AACV;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,yBAAyB;EACzB,qFAAqF;EACrF,2DAA2D;EAC3D,wDAAwD;EACxD,uDAAuD;EACvD,sDAAsD;AACxD;AACA;EACE,yBAAyB;EACzB,qFAAqF;EACrF,2DAA2D;EAC3D,wDAAwD;EACxD,uDAAuD;EACvD,sDAAsD;AACxD;AACA;EACE,kEAAkE;EAClE,gHAAgH;EAChH,qEAAqE;EACrE,gEAAgE;EAChE,iEAAiE;EACjE,6DAA6D;EAC7D,0HAA0H;AAC5H;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;EACf,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,WAAW;AACb;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,qFAAqF;EACrF,2DAA2D;EAC3D,wDAAwD;EACxD,uDAAuD;EACvD,sDAAsD;EACtD,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,2CAA2C;AAC7C;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;IACV,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,8BAA8B;AAChC;AACA;EACE;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;EACnB;AACF;AACA;EACE;IACE,yCAAyC;IACzC,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE;IACE,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;IAC3B,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;IAC3B,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;IACb,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;EACZ;AACF;AACA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qCAAqC;AACvC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA,iBAAiB;AACjB;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;;;;EAUE,0CAA0C;AAC5C;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,0CAA0C;AAC5C;AACA;;;;;EAKE,+BAA+B;AACjC;AACA;;;;;;;;;;EAUE,+BAA+B;AACjC;AACA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;AACA,eAAe;AACf;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,gBAAgB;AAChB;EACE,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB;;;;;;;IAOE;AACJ;AACA;;;EAGE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;AACF;AACA;EACE;IACE,OAAO;IACP,WAAW;EACb;AACF;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,OAAO;EACP,uCAAuC;AACzC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,QAAQ;EACR,UAAU;EACV,sCAAsC;AACxC;AACA;EACE,mCAAmC;AACrC;AACA;;;;;;EAME,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;;EAGE,oBAAoB;EACpB,8BAA8B;AAChC;AACA;;;;;;EAME,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;;EAEE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;;EAEE,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;;;;EAIE,WAAW;EACX,UAAU;AACZ;AACA;;;;;;;;EAQE,UAAU;EACV,WAAW;AACb;AACA;;;;;;;;EAQE,UAAU;EACV,WAAW;AACb;AACA;;;;EAIE,oBAAoB;EACpB,+CAA+C;AACjD;AACA;;;;;;;;EAQE,iCAAiC;AACnC;AACA;;;;;;;;EAQE,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;;;;;;;;;;;;EAgBE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;;;;;;;;EAQE,6CAA6C;AAC/C;AACA;;;;EAIE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;;;;;;;;EAQE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;;;;EAIE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;;EAEE,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,QAAQ;EACR,uDAAuD;EACvD,oDAAoD;EACpD,+CAA+C;AACjD;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,OAAO;EACP,sDAAsD;EACtD,mDAAmD;EACnD,8CAA8C;AAChD;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,UAAU;EACV,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,UAAU;EACV,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE,QAAQ;AACV;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;AACF;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE;IACE,UAAU;IACV,QAAQ;EACV;AACF;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE;IACE,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,WAAW;AACb;AACA;EACE;IACE,yCAAyC;IACzC,YAAY;IACZ,UAAU;EACZ;AACF;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,WAAW;AACb;AACA;EACE;IACE,YAAY;IACZ,UAAU;IACV,yCAAyC;EAC3C;AACF;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;;;;;;;;;EASE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;;;;;;;;;EASE,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;;EAEE,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,OAAO;EACT;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE;IACE,OAAO;EACT;AACF;AACA;EACE,WAAW;EACX,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,WAAW;EACX,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,WAAW;EACX,OAAO;EACP,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,OAAO;AACT;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,0CAA0C;EAC5C;AACF;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,OAAO;EACT;AACF;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;;EAEE,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE;IACE,OAAO;EACT;AACF;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,UAAU;EACV,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE;IACE,WAAW;IACX,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE;IACE,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,UAAU;AACZ;AACA;;EAEE,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;;;;;;;EAOE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;EACA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;EACA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;EACA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;EACA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;EACA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;EACA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;EACA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;EACA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;EACA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;EACA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;AACF","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n/*\nAuthor         : G-axon\nTemplate Name  : Wieldy Antd React - Admin Template\nVersion        : 1.0\n*/\n/*=============================================================\n    Table of Contents:\n    =============================\n    A. Globals\n        01. Custom Animation\n        02. Colors Class\n\n    B. Base\n        01. Base Styles\n        02. Row Col Styles\n        03. Margin Padding Styles\n        04. Typography Styles\n        05. Flex Styles\n\n    C. Layouts\n        01. Ant Layout Style\n        02. Header Style\n        03. Sidebar Style\n        04. Navbar(Ant Menu) Style\n        05. Footer Styles\n        06. Customizer Style\n        07. Drawer Style\n\n    D. UI Components\n        01. Alert Styles\n        02. Avatar Styles\n        03. BackTop Styles\n        04. Badges Styles\n        05. Button Styles\n        06. Cards Styles\n        07. Cascader Styles\n        08. Chart Styles\n        09. Form Styles\n        10. Icon Styles\n        11. Input Styles\n        12. List Styles\n        13. Loader Styles\n        14. Pagination Styles\n        15. Pickers Styles\n        16. Progress Styles\n        17. Slider Styles\n        18. Steps Styles\n        19. Tables Styles\n        20. Tabs Styles\n        21. Time Lines Style\n\n    E. Apps\n        01. Apps Style\n        02. Mails Apps Styles\n        03. Chat Apps Styles\n        04. Contact Apps Styles\n        05. Calendar Apps Style\n        06. Profile App Style\n        07. Wall App Style\n\n    F. Pages\n        01. Callout Styles\n        02. E-commerce Styles\n        03. Pricing Tables Styles\n        04. Login Styles\n        05. Dashboard Styles\n        06. Error Styles\n        07. Editor Styles\n        08. Testimonial Styles\n        09. Algolia Styles\n\n  =============================================================*/\n[class^=ant-]::-ms-clear,\n[class*= ant-]::-ms-clear,\n[class^=ant-] input::-ms-clear,\n[class*= ant-] input::-ms-clear,\n[class^=ant-] input::-ms-reveal,\n[class*= ant-] input::-ms-reveal {\n  display: none;\n}\n/* stylelint-disable property-no-vendor-prefix, at-rule-no-vendor-prefix */\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n}\ninput::-ms-clear,\ninput::-ms-reveal {\n  display: none;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n@-ms-viewport {\n  width: device-width;\n}\nbody {\n  margin: 0;\n  color: #545454;\n  font-size: 14px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  background-color: #f5f5f5;\n  font-feature-settings: 'tnum';\n}\n[tabindex='-1']:focus {\n  outline: none !important;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 500;\n}\np {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  border-bottom: 0;\n  cursor: help;\n}\naddress {\n  margin-bottom: 1em;\n  font-style: normal;\n  line-height: inherit;\n}\ninput[type='text'],\ninput[type='password'],\ninput[type='number'],\ntextarea {\n  -webkit-appearance: none;\n}\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\ndt {\n  font-weight: 500;\n}\ndd {\n  margin-bottom: 0.5em;\n  margin-left: 0;\n}\nblockquote {\n  margin: 0 0 1em;\n}\ndfn {\n  font-style: italic;\n}\nb,\nstrong {\n  font-weight: bolder;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\na {\n  color: var(--app-primary-color);\n  text-decoration: none;\n  background-color: transparent;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  -webkit-text-decoration-skip: objects;\n}\na:hover {\n  color: #0d0d0d;\n}\na:active {\n  color: #000000;\n}\na:active,\na:hover {\n  text-decoration: none;\n  outline: 0;\n}\na:focus {\n  text-decoration: none;\n  outline: 0;\n}\na[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\npre,\ncode,\nkbd,\nsamp {\n  font-size: 1em;\n  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;\n}\npre {\n  margin-top: 0;\n  margin-bottom: 1em;\n  overflow: auto;\n}\nfigure {\n  margin: 0 0 1em;\n}\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\na,\narea,\nbutton,\n[role='button'],\ninput:not([type='range']),\nlabel,\nselect,\nsummary,\ntextarea {\n  touch-action: manipulation;\n}\ntable {\n  border-collapse: collapse;\n}\ncaption {\n  padding-top: 0.75em;\n  padding-bottom: 0.3em;\n  color: #595959;\n  text-align: left;\n  caption-side: bottom;\n}\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: inherit;\n}\nbutton,\ninput {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\ninput[type='radio'],\ninput[type='checkbox'] {\n  box-sizing: border-box;\n  padding: 0;\n}\ninput[type='date'],\ninput[type='time'],\ninput[type='datetime-local'],\ninput[type='month'] {\n  -webkit-appearance: listbox;\n}\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\nfieldset {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0.5em;\n  padding: 0;\n  color: inherit;\n  font-size: 1.5em;\n  line-height: inherit;\n  white-space: normal;\n}\nprogress {\n  vertical-align: baseline;\n}\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n  height: auto;\n}\n[type='search'] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n[type='search']::-webkit-search-cancel-button,\n[type='search']::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\noutput {\n  display: inline-block;\n}\nsummary {\n  display: list-item;\n}\ntemplate {\n  display: none;\n}\n[hidden] {\n  display: none !important;\n}\nmark {\n  padding: 0.2em;\n  background-color: #feffe6;\n}\n::selection {\n  color: #fff;\n  background: #351a55;\n}\n.clearfix::before {\n  display: table;\n  content: '';\n}\n.clearfix::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.anticon > * {\n  line-height: 1;\n}\n.anticon svg {\n  display: inline-block;\n}\n.anticon::before {\n  display: none;\n}\n.anticon .anticon-icon {\n  display: block;\n}\n.anticon > .anticon {\n  line-height: 0;\n  vertical-align: 0;\n}\n.anticon[tabindex] {\n  cursor: pointer;\n}\n.anticon-spin,\n.anticon-spin::before {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n}\n.ant-fade-enter,\n.ant-fade-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-fade-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-fade-enter.ant-fade-enter-active,\n.ant-fade-appear.ant-fade-appear-active {\n  animation-name: antFadeIn;\n  animation-play-state: running;\n}\n.ant-fade-leave.ant-fade-leave-active {\n  animation-name: antFadeOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-fade-enter,\n.ant-fade-appear {\n  opacity: 0;\n  animation-timing-function: linear;\n}\n.ant-fade-leave {\n  animation-timing-function: linear;\n}\n@keyframes antFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes antFadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.ant-move-up-enter,\n.ant-move-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-move-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-move-up-enter.ant-move-up-enter-active,\n.ant-move-up-appear.ant-move-up-appear-active {\n  animation-name: antMoveUpIn;\n  animation-play-state: running;\n}\n.ant-move-up-leave.ant-move-up-leave-active {\n  animation-name: antMoveUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-move-up-enter,\n.ant-move-up-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-move-up-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.ant-move-down-enter,\n.ant-move-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-move-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-move-down-enter.ant-move-down-enter-active,\n.ant-move-down-appear.ant-move-down-appear-active {\n  animation-name: antMoveDownIn;\n  animation-play-state: running;\n}\n.ant-move-down-leave.ant-move-down-leave-active {\n  animation-name: antMoveDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-move-down-enter,\n.ant-move-down-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-move-down-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.ant-move-left-enter,\n.ant-move-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-move-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-move-left-enter.ant-move-left-enter-active,\n.ant-move-left-appear.ant-move-left-appear-active {\n  animation-name: antMoveLeftIn;\n  animation-play-state: running;\n}\n.ant-move-left-leave.ant-move-left-leave-active {\n  animation-name: antMoveLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-move-left-enter,\n.ant-move-left-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-move-left-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.ant-move-right-enter,\n.ant-move-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-move-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-move-right-enter.ant-move-right-enter-active,\n.ant-move-right-appear.ant-move-right-appear-active {\n  animation-name: antMoveRightIn;\n  animation-play-state: running;\n}\n.ant-move-right-leave.ant-move-right-leave-active {\n  animation-name: antMoveRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-move-right-enter,\n.ant-move-right-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-move-right-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n@keyframes antMoveDownIn {\n  0% {\n    transform: translateY(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveDownOut {\n  0% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveLeftIn {\n  0% {\n    transform: translateX(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveLeftOut {\n  0% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveRightIn {\n  0% {\n    transform: translateX(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveRightOut {\n  0% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveUpIn {\n  0% {\n    transform: translateY(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveUpOut {\n  0% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes loadingCircle {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n[ant-click-animating='true'],\n[ant-click-animating-without-extra-node='true'] {\n  position: relative;\n}\nhtml {\n  --antd-wave-shadow-color: #351a55;\n  --scroll-bar: 0;\n}\n[ant-click-animating-without-extra-node='true']::after,\n.ant-click-animating-node {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  border-radius: inherit;\n  box-shadow: 0 0 0 0 #351a55;\n  box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);\n  opacity: 0.2;\n  animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);\n  animation-fill-mode: forwards;\n  content: '';\n  pointer-events: none;\n}\n@keyframes waveEffect {\n  100% {\n    box-shadow: 0 0 0 #351a55;\n    box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);\n  }\n}\n@keyframes fadeEffect {\n  100% {\n    opacity: 0;\n  }\n}\n.ant-slide-up-enter,\n.ant-slide-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-slide-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-slide-up-enter.ant-slide-up-enter-active,\n.ant-slide-up-appear.ant-slide-up-appear-active {\n  animation-name: antSlideUpIn;\n  animation-play-state: running;\n}\n.ant-slide-up-leave.ant-slide-up-leave-active {\n  animation-name: antSlideUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-slide-up-enter,\n.ant-slide-up-appear {\n  transform: scale(0);\n  transform-origin: 0% 0%;\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.ant-slide-up-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.ant-slide-down-enter,\n.ant-slide-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-slide-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-slide-down-enter.ant-slide-down-enter-active,\n.ant-slide-down-appear.ant-slide-down-appear-active {\n  animation-name: antSlideDownIn;\n  animation-play-state: running;\n}\n.ant-slide-down-leave.ant-slide-down-leave-active {\n  animation-name: antSlideDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-slide-down-enter,\n.ant-slide-down-appear {\n  transform: scale(0);\n  transform-origin: 0% 0%;\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.ant-slide-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.ant-slide-left-enter,\n.ant-slide-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-slide-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-slide-left-enter.ant-slide-left-enter-active,\n.ant-slide-left-appear.ant-slide-left-appear-active {\n  animation-name: antSlideLeftIn;\n  animation-play-state: running;\n}\n.ant-slide-left-leave.ant-slide-left-leave-active {\n  animation-name: antSlideLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-slide-left-enter,\n.ant-slide-left-appear {\n  transform: scale(0);\n  transform-origin: 0% 0%;\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.ant-slide-left-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.ant-slide-right-enter,\n.ant-slide-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-slide-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-slide-right-enter.ant-slide-right-enter-active,\n.ant-slide-right-appear.ant-slide-right-appear-active {\n  animation-name: antSlideRightIn;\n  animation-play-state: running;\n}\n.ant-slide-right-leave.ant-slide-right-leave-active {\n  animation-name: antSlideRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-slide-right-enter,\n.ant-slide-right-appear {\n  transform: scale(0);\n  transform-origin: 0% 0%;\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.ant-slide-right-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n@keyframes antSlideUpIn {\n  0% {\n    transform: scaleY(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideUpOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideDownIn {\n  0% {\n    transform: scaleY(0.8);\n    transform-origin: 100% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideDownOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0.8);\n    transform-origin: 100% 100%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideLeftIn {\n  0% {\n    transform: scaleX(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideLeftOut {\n  0% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideRightIn {\n  0% {\n    transform: scaleX(0.8);\n    transform-origin: 100% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 100% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideRightOut {\n  0% {\n    transform: scaleX(1);\n    transform-origin: 100% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0.8);\n    transform-origin: 100% 0%;\n    opacity: 0;\n  }\n}\n.ant-zoom-enter,\n.ant-zoom-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-enter.ant-zoom-enter-active,\n.ant-zoom-appear.ant-zoom-appear-active {\n  animation-name: antZoomIn;\n  animation-play-state: running;\n}\n.ant-zoom-leave.ant-zoom-leave-active {\n  animation-name: antZoomOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-zoom-enter,\n.ant-zoom-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-zoom-enter-prepare,\n.ant-zoom-appear-prepare {\n  transform: none;\n}\n.ant-zoom-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-zoom-big-enter,\n.ant-zoom-big-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-big-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-big-enter.ant-zoom-big-enter-active,\n.ant-zoom-big-appear.ant-zoom-big-appear-active {\n  animation-name: antZoomBigIn;\n  animation-play-state: running;\n}\n.ant-zoom-big-leave.ant-zoom-big-leave-active {\n  animation-name: antZoomBigOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-zoom-big-enter,\n.ant-zoom-big-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-zoom-big-enter-prepare,\n.ant-zoom-big-appear-prepare {\n  transform: none;\n}\n.ant-zoom-big-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-zoom-big-fast-enter,\n.ant-zoom-big-fast-appear {\n  animation-duration: 0.1s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-big-fast-leave {\n  animation-duration: 0.1s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-big-fast-enter.ant-zoom-big-fast-enter-active,\n.ant-zoom-big-fast-appear.ant-zoom-big-fast-appear-active {\n  animation-name: antZoomBigIn;\n  animation-play-state: running;\n}\n.ant-zoom-big-fast-leave.ant-zoom-big-fast-leave-active {\n  animation-name: antZoomBigOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-zoom-big-fast-enter,\n.ant-zoom-big-fast-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-zoom-big-fast-enter-prepare,\n.ant-zoom-big-fast-appear-prepare {\n  transform: none;\n}\n.ant-zoom-big-fast-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-zoom-up-enter,\n.ant-zoom-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-up-enter.ant-zoom-up-enter-active,\n.ant-zoom-up-appear.ant-zoom-up-appear-active {\n  animation-name: antZoomUpIn;\n  animation-play-state: running;\n}\n.ant-zoom-up-leave.ant-zoom-up-leave-active {\n  animation-name: antZoomUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-zoom-up-enter,\n.ant-zoom-up-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-zoom-up-enter-prepare,\n.ant-zoom-up-appear-prepare {\n  transform: none;\n}\n.ant-zoom-up-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-zoom-down-enter,\n.ant-zoom-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-down-enter.ant-zoom-down-enter-active,\n.ant-zoom-down-appear.ant-zoom-down-appear-active {\n  animation-name: antZoomDownIn;\n  animation-play-state: running;\n}\n.ant-zoom-down-leave.ant-zoom-down-leave-active {\n  animation-name: antZoomDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-zoom-down-enter,\n.ant-zoom-down-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-zoom-down-enter-prepare,\n.ant-zoom-down-appear-prepare {\n  transform: none;\n}\n.ant-zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-zoom-left-enter,\n.ant-zoom-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-left-enter.ant-zoom-left-enter-active,\n.ant-zoom-left-appear.ant-zoom-left-appear-active {\n  animation-name: antZoomLeftIn;\n  animation-play-state: running;\n}\n.ant-zoom-left-leave.ant-zoom-left-leave-active {\n  animation-name: antZoomLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-zoom-left-enter,\n.ant-zoom-left-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-zoom-left-enter-prepare,\n.ant-zoom-left-appear-prepare {\n  transform: none;\n}\n.ant-zoom-left-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-zoom-right-enter,\n.ant-zoom-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-zoom-right-enter.ant-zoom-right-enter-active,\n.ant-zoom-right-appear.ant-zoom-right-appear-active {\n  animation-name: antZoomRightIn;\n  animation-play-state: running;\n}\n.ant-zoom-right-leave.ant-zoom-right-leave-active {\n  animation-name: antZoomRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.ant-zoom-right-enter,\n.ant-zoom-right-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.ant-zoom-right-enter-prepare,\n.ant-zoom-right-appear-prepare {\n  transform: none;\n}\n.ant-zoom-right-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n@keyframes antZoomIn {\n  0% {\n    transform: scale(0.2);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes antZoomOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.2);\n    opacity: 0;\n  }\n}\n@keyframes antZoomBigIn {\n  0% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes antZoomBigOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n}\n@keyframes antZoomUpIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 50% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 50% 0%;\n  }\n}\n@keyframes antZoomUpOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 50% 0%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 50% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomLeftIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 0% 50%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 0% 50%;\n  }\n}\n@keyframes antZoomLeftOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 0% 50%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 0% 50%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomRightIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 100% 50%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 100% 50%;\n  }\n}\n@keyframes antZoomRightOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 100% 50%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 100% 50%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomDownIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 50% 100%;\n  }\n}\n@keyframes antZoomDownOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 50% 100%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n}\n.ant-motion-collapse-legacy {\n  overflow: hidden;\n}\n.ant-motion-collapse-legacy-active {\n  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.ant-motion-collapse {\n  overflow: hidden;\n  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.ant-affix {\n  position: fixed;\n  z-index: 10;\n}\n.ant-alert {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 8px 15px;\n  word-wrap: break-word;\n  border-radius: 6px;\n}\n.ant-alert-content {\n  flex: 1;\n  min-width: 0;\n}\n.ant-alert-icon {\n  margin-right: 8px;\n}\n.ant-alert-description {\n  display: none;\n  font-size: 14px;\n  line-height: 22px;\n}\n.ant-alert-success {\n  background-color: #f6ffed;\n  border: 1px solid #b7eb8f;\n}\n.ant-alert-success .ant-alert-icon {\n  color: #52c41a;\n}\n.ant-alert-info {\n  background-color: #e6f7ff;\n  border: 1px solid #91d5ff;\n}\n.ant-alert-info .ant-alert-icon {\n  color: #1890ff;\n}\n.ant-alert-warning {\n  background-color: #fff7e6;\n  border: 1px solid #ffd591;\n}\n.ant-alert-warning .ant-alert-icon {\n  color: #fa8c16;\n}\n.ant-alert-error {\n  background-color: #fff1f0;\n  border: 1px solid #ffa39e;\n}\n.ant-alert-error .ant-alert-icon {\n  color: #f5222d;\n}\n.ant-alert-error .ant-alert-description > pre {\n  margin: 0;\n  padding: 0;\n}\n.ant-alert-action {\n  margin-left: 8px;\n}\n.ant-alert-close-icon {\n  margin-left: 8px;\n  padding: 0;\n  overflow: hidden;\n  font-size: 12px;\n  line-height: 12px;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n.ant-alert-close-icon .anticon-close {\n  color: #595959;\n  transition: color 0.3s;\n}\n.ant-alert-close-icon .anticon-close:hover {\n  color: rgba(0, 0, 0, 0.75);\n}\n.ant-alert-close-text {\n  color: #595959;\n  transition: color 0.3s;\n}\n.ant-alert-close-text:hover {\n  color: rgba(0, 0, 0, 0.75);\n}\n.ant-alert-with-description {\n  align-items: flex-start;\n  padding: 15px 15px 15px 24px;\n}\n.ant-alert-with-description.ant-alert-no-icon {\n  padding: 15px 15px;\n}\n.ant-alert-with-description .ant-alert-icon {\n  margin-right: 15px;\n  font-size: 24px;\n}\n.ant-alert-with-description .ant-alert-message {\n  display: block;\n  margin-bottom: 4px;\n  color: #535353;\n  font-size: 16px;\n}\n.ant-alert-message {\n  color: #535353;\n}\n.ant-alert-with-description .ant-alert-description {\n  display: block;\n}\n.ant-alert.ant-alert-motion-leave {\n  overflow: hidden;\n  opacity: 1;\n  transition: max-height 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), opacity 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), padding-top 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), padding-bottom 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), margin-bottom 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-alert.ant-alert-motion-leave-active {\n  max-height: 0;\n  margin-bottom: 0 !important;\n  padding-top: 0;\n  padding-bottom: 0;\n  opacity: 0;\n}\n.ant-alert-banner {\n  margin-bottom: 0;\n  border: 0;\n  border-radius: 0;\n}\n.ant-alert.ant-alert-rtl {\n  direction: rtl;\n}\n.ant-alert-rtl .ant-alert-icon {\n  margin-right: auto;\n  margin-left: 8px;\n}\n.ant-alert-rtl .ant-alert-action {\n  margin-right: 8px;\n  margin-left: auto;\n}\n.ant-alert-rtl .ant-alert-close-icon {\n  margin-right: 8px;\n  margin-left: auto;\n}\n.ant-alert-rtl.ant-alert-with-description {\n  padding-right: 24px;\n  padding-left: 15px;\n}\n.ant-alert-rtl.ant-alert-with-description .ant-alert-icon {\n  margin-right: auto;\n  margin-left: 15px;\n}\n.ant-anchor {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  padding-left: 2px;\n}\n.ant-anchor-wrapper {\n  margin-left: -4px;\n  padding-left: 4px;\n  overflow: auto;\n  background-color: transparent;\n}\n.ant-anchor-ink {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n}\n.ant-anchor-ink::before {\n  position: relative;\n  display: block;\n  width: 2px;\n  height: 100%;\n  margin: 0 auto;\n  background-color: #e8e8e8;\n  content: ' ';\n}\n.ant-anchor-ink-ball {\n  position: absolute;\n  left: 50%;\n  display: none;\n  width: 8px;\n  height: 8px;\n  background-color: #fff;\n  border: 2px solid #351a55;\n  border-radius: 8px;\n  transform: translateX(-50%);\n  transition: top 0.3s ease-in-out;\n}\n.ant-anchor-ink-ball.ant-anchor-ink-ball-visible {\n  display: inline-block;\n}\n.ant-anchor-fixed .ant-anchor-ink .ant-anchor-ink-ball {\n  display: none;\n}\n.ant-anchor-link {\n  padding: 4px 0 4px 16px;\n}\n.ant-anchor-link-title {\n  position: relative;\n  display: block;\n  margin-bottom: 3px;\n  overflow: hidden;\n  color: #545454;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: all 0.3s;\n}\n.ant-anchor-link-title:only-child {\n  margin-bottom: 0;\n}\n.ant-anchor-link-active > .ant-anchor-link-title {\n  color: #351a55;\n}\n.ant-anchor-link .ant-anchor-link {\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n.ant-anchor-rtl {\n  direction: rtl;\n}\n.ant-anchor-rtl.ant-anchor-wrapper {\n  margin-right: -4px;\n  margin-left: 0;\n  padding-right: 4px;\n  padding-left: 0;\n}\n.ant-anchor-rtl .ant-anchor-ink {\n  right: 0;\n  left: auto;\n}\n.ant-anchor-rtl .ant-anchor-ink-ball {\n  right: 50%;\n  left: 0;\n  transform: translateX(50%);\n}\n.ant-anchor-rtl .ant-anchor-link {\n  padding: 4px 16px 4px 0;\n}\n.ant-select-auto-complete {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-select-auto-complete .ant-select-clear {\n  right: 13px;\n}\n.ant-avatar {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  overflow: hidden;\n  color: #fff;\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: middle;\n  background: #ccc;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  border-radius: 50%;\n}\n.ant-avatar-image {\n  background: transparent;\n}\n.ant-avatar .ant-image-img {\n  display: block;\n}\n.ant-avatar-string {\n  position: absolute;\n  left: 50%;\n  transform-origin: 0 center;\n}\n.ant-avatar.ant-avatar-icon {\n  font-size: 18px;\n}\n.ant-avatar.ant-avatar-icon > .anticon {\n  margin: 0;\n}\n.ant-avatar-lg {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  border-radius: 50%;\n}\n.ant-avatar-lg-string {\n  position: absolute;\n  left: 50%;\n  transform-origin: 0 center;\n}\n.ant-avatar-lg.ant-avatar-icon {\n  font-size: 24px;\n}\n.ant-avatar-lg.ant-avatar-icon > .anticon {\n  margin: 0;\n}\n.ant-avatar-sm {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  border-radius: 50%;\n}\n.ant-avatar-sm-string {\n  position: absolute;\n  left: 50%;\n  transform-origin: 0 center;\n}\n.ant-avatar-sm.ant-avatar-icon {\n  font-size: 14px;\n}\n.ant-avatar-sm.ant-avatar-icon > .anticon {\n  margin: 0;\n}\n.ant-avatar-square {\n  border-radius: 6px;\n}\n.ant-avatar > img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.ant-avatar-group {\n  display: inline-flex;\n}\n.ant-avatar-group .ant-avatar {\n  border: 1px solid #fff;\n}\n.ant-avatar-group .ant-avatar:not(:first-child) {\n  margin-left: -8px;\n}\n.ant-avatar-group-popover .ant-avatar + .ant-avatar {\n  margin-left: 3px;\n}\n.ant-avatar-group-rtl .ant-avatar:not(:first-child) {\n  margin-right: -8px;\n  margin-left: 0;\n}\n.ant-avatar-group-popover.ant-popover-rtl .ant-avatar + .ant-avatar {\n  margin-right: 3px;\n  margin-left: 0;\n}\n.ant-back-top {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: fixed;\n  right: 100px;\n  bottom: 50px;\n  z-index: 10;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n}\n.ant-back-top:empty {\n  display: none;\n}\n.ant-back-top-rtl {\n  right: auto;\n  left: 100px;\n  direction: rtl;\n}\n.ant-back-top-content {\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  background-color: #595959;\n  border-radius: 20px;\n  transition: all 0.3s;\n}\n.ant-back-top-content:hover {\n  background-color: #545454;\n  transition: all 0.3s;\n}\n.ant-back-top-icon {\n  font-size: 24px;\n  line-height: 40px;\n}\n@media screen and (max-width: 768px) {\n  .ant-back-top {\n    right: 60px;\n  }\n  .ant-back-top-rtl {\n    right: auto;\n    left: 60px;\n  }\n}\n@media screen and (max-width: 480px) {\n  .ant-back-top {\n    right: 20px;\n  }\n  .ant-back-top-rtl {\n    right: auto;\n    left: 20px;\n  }\n}\n.ant-badge {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  line-height: 1;\n}\n.ant-badge-count {\n  z-index: auto;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  color: #fff;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: nowrap;\n  text-align: center;\n  background: #f5222d;\n  border-radius: 10px;\n  box-shadow: 0 0 0 1px #fff;\n}\n.ant-badge-count a,\n.ant-badge-count a:hover {\n  color: #fff;\n}\n.ant-badge-count-sm {\n  min-width: 14px;\n  height: 14px;\n  padding: 0;\n  font-size: 12px;\n  line-height: 14px;\n  border-radius: 7px;\n}\n.ant-badge-multiple-words {\n  padding: 0 8px;\n}\n.ant-badge-dot {\n  z-index: auto;\n  width: 6px;\n  min-width: 6px;\n  height: 6px;\n  background: #f5222d;\n  border-radius: 100%;\n  box-shadow: 0 0 0 1px #fff;\n}\n.ant-badge-dot.ant-scroll-number {\n  transition: background 1.5s;\n}\n.ant-badge-count,\n.ant-badge-dot,\n.ant-badge .ant-scroll-number-custom-component {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(50%, -50%);\n  transform-origin: 100% 0%;\n}\n.ant-badge-count.anticon-spin,\n.ant-badge-dot.anticon-spin,\n.ant-badge .ant-scroll-number-custom-component.anticon-spin {\n  animation: antBadgeLoadingCircle 1s infinite linear;\n}\n.ant-badge-status {\n  line-height: inherit;\n  vertical-align: baseline;\n}\n.ant-badge-status-dot {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  vertical-align: middle;\n  border-radius: 50%;\n}\n.ant-badge-status-success {\n  background-color: #52c41a;\n}\n.ant-badge-status-processing {\n  position: relative;\n  background-color: var(--app-primary-color);\n}\n.ant-badge-status-processing::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--app-primary-color);\n  border-radius: 50%;\n  animation: antStatusProcessing 1.2s infinite ease-in-out;\n  content: '';\n}\n.ant-badge-status-default {\n  background-color: #d9d9d9;\n}\n.ant-badge-status-error {\n  background-color: #f5222d;\n}\n.ant-badge-status-warning {\n  background-color: #fa8c16;\n}\n.ant-badge-status-pink {\n  background: #eb2f96;\n}\n.ant-badge-status-magenta {\n  background: #eb2f96;\n}\n.ant-badge-status-red {\n  background: #f5222d;\n}\n.ant-badge-status-volcano {\n  background: #fa541c;\n}\n.ant-badge-status-orange {\n  background: #fa8c16;\n}\n.ant-badge-status-yellow {\n  background: #fadb14;\n}\n.ant-badge-status-gold {\n  background: #faad14;\n}\n.ant-badge-status-cyan {\n  background: #13c2c2;\n}\n.ant-badge-status-lime {\n  background: #a0d911;\n}\n.ant-badge-status-green {\n  background: #52c41a;\n}\n.ant-badge-status-blue {\n  background: #1890ff;\n}\n.ant-badge-status-geekblue {\n  background: #2f54eb;\n}\n.ant-badge-status-purple {\n  background: #722ed1;\n}\n.ant-badge-status-text {\n  margin-left: 8px;\n  color: #545454;\n  font-size: 14px;\n}\n.ant-badge-zoom-appear,\n.ant-badge-zoom-enter {\n  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  animation-fill-mode: both;\n}\n.ant-badge-zoom-leave {\n  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);\n  animation-fill-mode: both;\n}\n.ant-badge-not-a-wrapper .ant-badge-zoom-appear,\n.ant-badge-not-a-wrapper .ant-badge-zoom-enter {\n  animation: antNoWrapperZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n}\n.ant-badge-not-a-wrapper .ant-badge-zoom-leave {\n  animation: antNoWrapperZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);\n}\n.ant-badge-not-a-wrapper:not(.ant-badge-status) {\n  vertical-align: middle;\n}\n.ant-badge-not-a-wrapper .ant-scroll-number-custom-component,\n.ant-badge-not-a-wrapper .ant-badge-count {\n  transform: none;\n}\n.ant-badge-not-a-wrapper .ant-scroll-number-custom-component,\n.ant-badge-not-a-wrapper .ant-scroll-number {\n  position: relative;\n  top: auto;\n  display: block;\n  transform-origin: 50% 50%;\n}\n@keyframes antStatusProcessing {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(2.4);\n    opacity: 0;\n  }\n}\n.ant-scroll-number {\n  overflow: hidden;\n  direction: ltr;\n}\n.ant-scroll-number-only {\n  position: relative;\n  display: inline-block;\n  height: 20px;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  /* stylelint-disable property-no-vendor-prefix */\n  -webkit-transform-style: preserve-3d;\n  -webkit-backface-visibility: hidden;\n  /* stylelint-enable property-no-vendor-prefix */\n}\n.ant-scroll-number-only > p.ant-scroll-number-only-unit {\n  height: 20px;\n  margin: 0;\n  /* stylelint-disable property-no-vendor-prefix */\n  -webkit-transform-style: preserve-3d;\n  -webkit-backface-visibility: hidden;\n  /* stylelint-enable property-no-vendor-prefix */\n}\n.ant-scroll-number-symbol {\n  vertical-align: top;\n}\n@keyframes antZoomBadgeIn {\n  0% {\n    transform: scale(0) translate(50%, -50%);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1) translate(50%, -50%);\n  }\n}\n@keyframes antZoomBadgeOut {\n  0% {\n    transform: scale(1) translate(50%, -50%);\n  }\n  100% {\n    transform: scale(0) translate(50%, -50%);\n    opacity: 0;\n  }\n}\n@keyframes antNoWrapperZoomBadgeIn {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes antNoWrapperZoomBadgeOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0);\n    opacity: 0;\n  }\n}\n@keyframes antBadgeLoadingCircle {\n  0% {\n    transform-origin: 50%;\n  }\n  100% {\n    transform: translate(50%, -50%) rotate(360deg);\n    transform-origin: 50%;\n  }\n}\n.ant-ribbon-wrapper {\n  position: relative;\n}\n.ant-ribbon {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: 8px;\n  height: 22px;\n  padding: 0 8px;\n  color: #fff;\n  line-height: 22px;\n  white-space: nowrap;\n  background-color: #351a55;\n  border-radius: 4px;\n}\n.ant-ribbon-text {\n  color: #fff;\n}\n.ant-ribbon-corner {\n  position: absolute;\n  top: 100%;\n  width: 8px;\n  height: 8px;\n  color: currentcolor;\n  border: 4px solid;\n  transform: scaleY(0.75);\n  transform-origin: top;\n}\n.ant-ribbon-corner::after {\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  width: inherit;\n  height: inherit;\n  color: rgba(0, 0, 0, 0.25);\n  border: inherit;\n  content: '';\n}\n.ant-ribbon-color-pink {\n  color: #eb2f96;\n  background: #eb2f96;\n}\n.ant-ribbon-color-magenta {\n  color: #eb2f96;\n  background: #eb2f96;\n}\n.ant-ribbon-color-red {\n  color: #f5222d;\n  background: #f5222d;\n}\n.ant-ribbon-color-volcano {\n  color: #fa541c;\n  background: #fa541c;\n}\n.ant-ribbon-color-orange {\n  color: #fa8c16;\n  background: #fa8c16;\n}\n.ant-ribbon-color-yellow {\n  color: #fadb14;\n  background: #fadb14;\n}\n.ant-ribbon-color-gold {\n  color: #faad14;\n  background: #faad14;\n}\n.ant-ribbon-color-cyan {\n  color: #13c2c2;\n  background: #13c2c2;\n}\n.ant-ribbon-color-lime {\n  color: #a0d911;\n  background: #a0d911;\n}\n.ant-ribbon-color-green {\n  color: #52c41a;\n  background: #52c41a;\n}\n.ant-ribbon-color-blue {\n  color: #1890ff;\n  background: #1890ff;\n}\n.ant-ribbon-color-geekblue {\n  color: #2f54eb;\n  background: #2f54eb;\n}\n.ant-ribbon-color-purple {\n  color: #722ed1;\n  background: #722ed1;\n}\n.ant-ribbon.ant-ribbon-placement-end {\n  right: -8px;\n  border-bottom-right-radius: 0;\n}\n.ant-ribbon.ant-ribbon-placement-end .ant-ribbon-corner {\n  right: 0;\n  border-color: currentcolor transparent transparent currentcolor;\n}\n.ant-ribbon.ant-ribbon-placement-start {\n  left: -8px;\n  border-bottom-left-radius: 0;\n}\n.ant-ribbon.ant-ribbon-placement-start .ant-ribbon-corner {\n  left: 0;\n  border-color: currentcolor currentcolor transparent transparent;\n}\n.ant-badge-rtl {\n  direction: rtl;\n}\n.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-badge-count,\n.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-badge-dot,\n.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-scroll-number-custom-component {\n  right: auto;\n  left: 0;\n  direction: ltr;\n  transform: translate(-50%, -50%);\n  transform-origin: 0% 0%;\n}\n.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-scroll-number-custom-component {\n  right: auto;\n  left: 0;\n  transform: translate(-50%, -50%);\n  transform-origin: 0% 0%;\n}\n.ant-badge-rtl .ant-badge-status-text {\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-appear,\n.ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-enter {\n  animation-name: antZoomBadgeInRtl;\n}\n.ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-leave {\n  animation-name: antZoomBadgeOutRtl;\n}\n.ant-ribbon-rtl {\n  direction: rtl;\n}\n.ant-ribbon-rtl.ant-ribbon-placement-end {\n  right: unset;\n  left: -8px;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 0;\n}\n.ant-ribbon-rtl.ant-ribbon-placement-end .ant-ribbon-corner {\n  right: unset;\n  left: 0;\n  border-color: currentcolor currentcolor transparent transparent;\n}\n.ant-ribbon-rtl.ant-ribbon-placement-end .ant-ribbon-corner::after {\n  border-color: currentcolor currentcolor transparent transparent;\n}\n.ant-ribbon-rtl.ant-ribbon-placement-start {\n  right: -8px;\n  left: unset;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 4px;\n}\n.ant-ribbon-rtl.ant-ribbon-placement-start .ant-ribbon-corner {\n  right: 0;\n  left: unset;\n  border-color: currentcolor transparent transparent currentcolor;\n}\n.ant-ribbon-rtl.ant-ribbon-placement-start .ant-ribbon-corner::after {\n  border-color: currentcolor transparent transparent currentcolor;\n}\n@keyframes antZoomBadgeInRtl {\n  0% {\n    transform: scale(0) translate(-50%, -50%);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1) translate(-50%, -50%);\n  }\n}\n@keyframes antZoomBadgeOutRtl {\n  0% {\n    transform: scale(1) translate(-50%, -50%);\n  }\n  100% {\n    transform: scale(0) translate(-50%, -50%);\n    opacity: 0;\n  }\n}\n.ant-breadcrumb {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  color: #595959;\n  font-size: 14px;\n}\n.ant-breadcrumb .anticon {\n  font-size: 14px;\n}\n.ant-breadcrumb ol {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-breadcrumb a {\n  color: #595959;\n  transition: color 0.3s;\n}\n.ant-breadcrumb a:hover {\n  color: #545454;\n}\n.ant-breadcrumb li:last-child {\n  color: #545454;\n}\n.ant-breadcrumb li:last-child a {\n  color: #545454;\n}\nli:last-child > .ant-breadcrumb-separator {\n  display: none;\n}\n.ant-breadcrumb-separator {\n  margin: 0 8px;\n  color: #595959;\n}\n.ant-breadcrumb-link > .anticon + span,\n.ant-breadcrumb-link > .anticon + a {\n  margin-left: 4px;\n}\n.ant-breadcrumb-overlay-link > .anticon {\n  margin-left: 4px;\n}\n.ant-breadcrumb-rtl {\n  direction: rtl;\n}\n.ant-breadcrumb-rtl::before {\n  display: table;\n  content: '';\n}\n.ant-breadcrumb-rtl::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-breadcrumb-rtl::before {\n  display: table;\n  content: '';\n}\n.ant-breadcrumb-rtl::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-breadcrumb-rtl > span {\n  float: right;\n}\n.ant-breadcrumb-rtl .ant-breadcrumb-link > .anticon + span,\n.ant-breadcrumb-rtl .ant-breadcrumb-link > .anticon + a {\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-breadcrumb-rtl .ant-breadcrumb-overlay-link > .anticon {\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-btn {\n  line-height: 1.3;\n  position: relative;\n  background-image: none;\n  border: 1px solid transparent;\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n  touch-action: manipulation;\n  padding: 7.9px 15px;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: solid 1px #d9d9d9;\n  padding: 0 15px;\n  height: 36px;\n  font-size: 14px;\n  line-height: 34px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  color: #545454;\n  border-color: #d9d9d9;\n  background: #fff;\n}\n.ant-btn > .anticon {\n  line-height: 1;\n}\n.ant-btn,\n.ant-btn:active,\n.ant-btn:focus {\n  outline: 0;\n}\n.ant-btn:not([disabled]):hover {\n  text-decoration: none;\n}\n.ant-btn:not([disabled]):active {\n  outline: 0;\n  box-shadow: none;\n}\n.ant-btn[disabled] {\n  cursor: not-allowed;\n}\n.ant-btn[disabled] > * {\n  pointer-events: none;\n}\n.ant-btn-lg {\n  height: 40px;\n  padding: 8.6px 15px;\n  font-size: 16px;\n  border-radius: 4px;\n}\n.ant-btn-sm {\n  height: 24px;\n  padding: 3.2px 7px;\n  font-size: 12px;\n  border-radius: 4px;\n}\n.ant-btn:not(:last-child) {\n  margin-right: 15px;\n}\n@media screen and (max-width: 575px) {\n  .ant-btn:not(:last-child) {\n    margin-right: 10px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-btn {\n    margin-bottom: 10px;\n  }\n}\n.ant-btn:focus,\n.ant-btn:hover {\n  text-decoration: none;\n}\n.ant-btn:focus,\n.ant-btn.focus {\n  outline: 0;\n}\n.ant-btn.disabled,\n.ant-btn:disabled {\n  opacity: 0.65;\n}\n.ant-btn:not([disabled]):not(.disabled) {\n  cursor: pointer;\n}\n.gx-btn-list .ant-btn {\n  margin-bottom: 6px;\n}\n.gx-sub-popover .ant-btn {\n  border: 0 none;\n  margin-bottom: 5px;\n}\n.gx-sub-popover .ant-btn:focus,\n.gx-sub-popover .ant-btn:hover {\n  background-color: #f5f5f5;\n}\n.gx-sub-popover .ant-btn:not(:last-child) {\n  margin-right: 5px;\n}\n.gx-login-content .ant-btn {\n  padding: 9px 20px !important;\n  height: auto;\n  line-height: 1;\n}\n.ant-btn > a:only-child {\n  color: currentcolor;\n}\n.ant-btn > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:hover,\n.ant-btn:focus {\n  color: #462e61;\n  border-color: #462e61;\n  background: #fff;\n}\n.ant-btn:hover > a:only-child,\n.ant-btn:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn:hover > a:only-child::after,\n.ant-btn:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:active {\n  color: #1a0c2e;\n  border-color: #1a0c2e;\n  background: #fff;\n}\n.ant-btn:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn[disabled],\n.ant-btn[disabled]:hover,\n.ant-btn[disabled]:focus,\n.ant-btn[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn[disabled] > a:only-child,\n.ant-btn[disabled]:hover > a:only-child,\n.ant-btn[disabled]:focus > a:only-child,\n.ant-btn[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn[disabled] > a:only-child::after,\n.ant-btn[disabled]:hover > a:only-child::after,\n.ant-btn[disabled]:focus > a:only-child::after,\n.ant-btn[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:hover,\n.ant-btn:focus,\n.ant-btn:active {\n  text-decoration: none;\n  background: #fff;\n}\n.ant-btn > span {\n  display: inline-block;\n}\n.ant-btn-primary {\n  color: #fff;\n  border-color: #351a55;\n  background: #351a55;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n  color: #ffffff !important;\n  background-color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n}\n.ant-btn-primary > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-primary > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary:hover,\n.ant-btn-primary:focus {\n  color: #fff;\n  border-color: #462e61;\n  background: #462e61;\n}\n.ant-btn-primary:hover > a:only-child,\n.ant-btn-primary:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-primary:hover > a:only-child::after,\n.ant-btn-primary:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary:active {\n  color: #fff;\n  border-color: #1a0c2e;\n  background: #1a0c2e;\n}\n.ant-btn-primary:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-primary:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary[disabled],\n.ant-btn-primary[disabled]:hover,\n.ant-btn-primary[disabled]:focus,\n.ant-btn-primary[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-primary[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-primary[disabled] > a:only-child::after,\n.ant-btn-primary[disabled]:hover > a:only-child::after,\n.ant-btn-primary[disabled]:focus > a:only-child::after,\n.ant-btn-primary[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary:hover,\n.ant-btn-primary:focus {\n  color: #ffffff !important;\n  background-color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n}\n.ant-btn-primary.disabled,\n.ant-btn-primary:disabled {\n  background-color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n}\n.ant-btn-primary:not([disabled]):not(.disabled):active,\n.ant-btn-primary:not([disabled]):not(.disabled).active {\n  color: #ffffff;\n  background-color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n}\n.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {\n  border-right-color: #462e61;\n  border-left-color: #462e61;\n}\n.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {\n  border-color: #d9d9d9;\n}\n.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {\n  border-right-color: #462e61;\n}\n.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {\n  border-right-color: #d9d9d9;\n}\n.ant-btn-group .ant-btn-primary:last-child:not(:first-child),\n.ant-btn-group .ant-btn-primary + .ant-btn-primary {\n  border-left-color: #462e61;\n}\n.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],\n.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {\n  border-left-color: #d9d9d9;\n}\n.ant-btn-ghost {\n  color: #545454;\n  border-color: #d9d9d9;\n  background: transparent;\n}\n.ant-btn-ghost > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-ghost > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost:hover,\n.ant-btn-ghost:focus {\n  color: #462e61;\n  border-color: #462e61;\n  background: transparent;\n}\n.ant-btn-ghost:hover > a:only-child,\n.ant-btn-ghost:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-ghost:hover > a:only-child::after,\n.ant-btn-ghost:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost:active {\n  color: #1a0c2e;\n  border-color: #1a0c2e;\n  background: transparent;\n}\n.ant-btn-ghost:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-ghost:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost[disabled],\n.ant-btn-ghost[disabled]:hover,\n.ant-btn-ghost[disabled]:focus,\n.ant-btn-ghost[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-ghost[disabled] > a:only-child,\n.ant-btn-ghost[disabled]:hover > a:only-child,\n.ant-btn-ghost[disabled]:focus > a:only-child,\n.ant-btn-ghost[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-ghost[disabled] > a:only-child::after,\n.ant-btn-ghost[disabled]:hover > a:only-child::after,\n.ant-btn-ghost[disabled]:focus > a:only-child::after,\n.ant-btn-ghost[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed {\n  color: #545454;\n  border-color: #d9d9d9;\n  background: #fff;\n  border-style: dashed;\n}\n.ant-btn-dashed > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dashed > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed:hover,\n.ant-btn-dashed:focus {\n  color: #462e61;\n  border-color: #462e61;\n  background: #fff;\n}\n.ant-btn-dashed:hover > a:only-child,\n.ant-btn-dashed:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dashed:hover > a:only-child::after,\n.ant-btn-dashed:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed:active {\n  color: #1a0c2e;\n  border-color: #1a0c2e;\n  background: #fff;\n}\n.ant-btn-dashed:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dashed:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed[disabled],\n.ant-btn-dashed[disabled]:hover,\n.ant-btn-dashed[disabled]:focus,\n.ant-btn-dashed[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-dashed[disabled] > a:only-child,\n.ant-btn-dashed[disabled]:hover > a:only-child,\n.ant-btn-dashed[disabled]:focus > a:only-child,\n.ant-btn-dashed[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dashed[disabled] > a:only-child::after,\n.ant-btn-dashed[disabled]:hover > a:only-child::after,\n.ant-btn-dashed[disabled]:focus > a:only-child::after,\n.ant-btn-dashed[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger {\n  color: #fff;\n  border-color: #f5222d;\n  background: #f5222d;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n}\n.ant-btn-danger > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-danger > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger:hover,\n.ant-btn-danger:focus {\n  color: #fff;\n  border-color: #ff4d4f;\n  background: #ff4d4f;\n}\n.ant-btn-danger:hover > a:only-child,\n.ant-btn-danger:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-danger:hover > a:only-child::after,\n.ant-btn-danger:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger:active {\n  color: #fff;\n  border-color: #cf1322;\n  background: #cf1322;\n}\n.ant-btn-danger:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-danger:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger[disabled],\n.ant-btn-danger[disabled]:hover,\n.ant-btn-danger[disabled]:focus,\n.ant-btn-danger[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-danger[disabled] > a:only-child,\n.ant-btn-danger[disabled]:hover > a:only-child,\n.ant-btn-danger[disabled]:focus > a:only-child,\n.ant-btn-danger[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-danger[disabled] > a:only-child::after,\n.ant-btn-danger[disabled]:hover > a:only-child::after,\n.ant-btn-danger[disabled]:focus > a:only-child::after,\n.ant-btn-danger[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link {\n  color: var(--app-primary-color);\n  border-color: transparent;\n  background: transparent;\n  box-shadow: none;\n}\n.ant-btn-link > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-link > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:hover,\n.ant-btn-link:focus {\n  color: #462e61;\n  border-color: #462e61;\n  background: transparent;\n}\n.ant-btn-link:hover > a:only-child,\n.ant-btn-link:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-link:hover > a:only-child::after,\n.ant-btn-link:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:active {\n  color: #1a0c2e;\n  border-color: #1a0c2e;\n  background: transparent;\n}\n.ant-btn-link:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-link:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link[disabled],\n.ant-btn-link[disabled]:hover,\n.ant-btn-link[disabled]:focus,\n.ant-btn-link[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-link[disabled] > a:only-child,\n.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-link[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-link[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:hover {\n  background: transparent;\n}\n.ant-btn-link:hover,\n.ant-btn-link:focus,\n.ant-btn-link:active {\n  border-color: transparent;\n}\n.ant-btn-link[disabled],\n.ant-btn-link[disabled]:hover,\n.ant-btn-link[disabled]:focus,\n.ant-btn-link[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: transparent;\n  background: transparent;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-link[disabled] > a:only-child,\n.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-link[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-link[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-text {\n  color: #545454;\n  border-color: transparent;\n  background: transparent;\n  box-shadow: none;\n}\n.ant-btn-text > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-text > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-text:hover,\n.ant-btn-text:focus {\n  color: #462e61;\n  border-color: #462e61;\n  background: transparent;\n}\n.ant-btn-text:hover > a:only-child,\n.ant-btn-text:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-text:hover > a:only-child::after,\n.ant-btn-text:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-text:active {\n  color: #1a0c2e;\n  border-color: #1a0c2e;\n  background: transparent;\n}\n.ant-btn-text:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-text:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-text[disabled],\n.ant-btn-text[disabled]:hover,\n.ant-btn-text[disabled]:focus,\n.ant-btn-text[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-text[disabled] > a:only-child,\n.ant-btn-text[disabled]:hover > a:only-child,\n.ant-btn-text[disabled]:focus > a:only-child,\n.ant-btn-text[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-text[disabled] > a:only-child::after,\n.ant-btn-text[disabled]:hover > a:only-child::after,\n.ant-btn-text[disabled]:focus > a:only-child::after,\n.ant-btn-text[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-text:hover,\n.ant-btn-text:focus {\n  color: #545454;\n  background: rgba(0, 0, 0, 0.018);\n  border-color: transparent;\n}\n.ant-btn-text:active {\n  color: #545454;\n  background: rgba(0, 0, 0, 0.028);\n  border-color: transparent;\n}\n.ant-btn-text[disabled],\n.ant-btn-text[disabled]:hover,\n.ant-btn-text[disabled]:focus,\n.ant-btn-text[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: transparent;\n  background: transparent;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-text[disabled] > a:only-child,\n.ant-btn-text[disabled]:hover > a:only-child,\n.ant-btn-text[disabled]:focus > a:only-child,\n.ant-btn-text[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-text[disabled] > a:only-child::after,\n.ant-btn-text[disabled]:hover > a:only-child::after,\n.ant-btn-text[disabled]:focus > a:only-child::after,\n.ant-btn-text[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous {\n  color: #f5222d;\n  border-color: #f5222d;\n  background: #fff;\n}\n.ant-btn-dangerous > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous:hover,\n.ant-btn-dangerous:focus {\n  color: #ff4d4f;\n  border-color: #ff4d4f;\n  background: #fff;\n}\n.ant-btn-dangerous:hover > a:only-child,\n.ant-btn-dangerous:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous:hover > a:only-child::after,\n.ant-btn-dangerous:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous:active {\n  color: #cf1322;\n  border-color: #cf1322;\n  background: #fff;\n}\n.ant-btn-dangerous:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous[disabled],\n.ant-btn-dangerous[disabled]:hover,\n.ant-btn-dangerous[disabled]:focus,\n.ant-btn-dangerous[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-dangerous[disabled] > a:only-child,\n.ant-btn-dangerous[disabled]:hover > a:only-child,\n.ant-btn-dangerous[disabled]:focus > a:only-child,\n.ant-btn-dangerous[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous[disabled] > a:only-child::after,\n.ant-btn-dangerous[disabled]:hover > a:only-child::after,\n.ant-btn-dangerous[disabled]:focus > a:only-child::after,\n.ant-btn-dangerous[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-primary {\n  color: #fff;\n  border-color: #f5222d;\n  background: #f5222d;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n}\n.ant-btn-dangerous.ant-btn-primary > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-primary > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-primary:hover,\n.ant-btn-dangerous.ant-btn-primary:focus {\n  color: #fff;\n  border-color: #ff4d4f;\n  background: #ff4d4f;\n}\n.ant-btn-dangerous.ant-btn-primary:hover > a:only-child,\n.ant-btn-dangerous.ant-btn-primary:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-primary:hover > a:only-child::after,\n.ant-btn-dangerous.ant-btn-primary:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-primary:active {\n  color: #fff;\n  border-color: #cf1322;\n  background: #cf1322;\n}\n.ant-btn-dangerous.ant-btn-primary:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-primary:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-primary[disabled],\n.ant-btn-dangerous.ant-btn-primary[disabled]:hover,\n.ant-btn-dangerous.ant-btn-primary[disabled]:focus,\n.ant-btn-dangerous.ant-btn-primary[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-dangerous.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-dangerous.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-dangerous.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-dangerous.ant-btn-primary[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-primary[disabled] > a:only-child::after,\n.ant-btn-dangerous.ant-btn-primary[disabled]:hover > a:only-child::after,\n.ant-btn-dangerous.ant-btn-primary[disabled]:focus > a:only-child::after,\n.ant-btn-dangerous.ant-btn-primary[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-link {\n  color: #f5222d;\n  border-color: transparent;\n  background: transparent;\n  box-shadow: none;\n}\n.ant-btn-dangerous.ant-btn-link > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-link > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-link:hover,\n.ant-btn-dangerous.ant-btn-link:focus {\n  color: #462e61;\n  border-color: #462e61;\n  background: transparent;\n}\n.ant-btn-dangerous.ant-btn-link:hover > a:only-child,\n.ant-btn-dangerous.ant-btn-link:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-link:hover > a:only-child::after,\n.ant-btn-dangerous.ant-btn-link:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-link:active {\n  color: #1a0c2e;\n  border-color: #1a0c2e;\n  background: transparent;\n}\n.ant-btn-dangerous.ant-btn-link:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-link:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-link[disabled],\n.ant-btn-dangerous.ant-btn-link[disabled]:hover,\n.ant-btn-dangerous.ant-btn-link[disabled]:focus,\n.ant-btn-dangerous.ant-btn-link[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child,\n.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-link:hover,\n.ant-btn-dangerous.ant-btn-link:focus {\n  color: #ff4d4f;\n  border-color: transparent;\n  background: transparent;\n}\n.ant-btn-dangerous.ant-btn-link:hover > a:only-child,\n.ant-btn-dangerous.ant-btn-link:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-link:hover > a:only-child::after,\n.ant-btn-dangerous.ant-btn-link:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-link:active {\n  color: #cf1322;\n  border-color: transparent;\n  background: transparent;\n}\n.ant-btn-dangerous.ant-btn-link:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-link:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-link[disabled],\n.ant-btn-dangerous.ant-btn-link[disabled]:hover,\n.ant-btn-dangerous.ant-btn-link[disabled]:focus,\n.ant-btn-dangerous.ant-btn-link[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: transparent;\n  background: transparent;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child,\n.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-text {\n  color: #f5222d;\n  border-color: transparent;\n  background: transparent;\n  box-shadow: none;\n}\n.ant-btn-dangerous.ant-btn-text > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-text > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-text:hover,\n.ant-btn-dangerous.ant-btn-text:focus {\n  color: #462e61;\n  border-color: #462e61;\n  background: transparent;\n}\n.ant-btn-dangerous.ant-btn-text:hover > a:only-child,\n.ant-btn-dangerous.ant-btn-text:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-text:hover > a:only-child::after,\n.ant-btn-dangerous.ant-btn-text:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-text:active {\n  color: #1a0c2e;\n  border-color: #1a0c2e;\n  background: transparent;\n}\n.ant-btn-dangerous.ant-btn-text:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-text:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-text[disabled],\n.ant-btn-dangerous.ant-btn-text[disabled]:hover,\n.ant-btn-dangerous.ant-btn-text[disabled]:focus,\n.ant-btn-dangerous.ant-btn-text[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child,\n.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child,\n.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child,\n.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child::after,\n.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child::after,\n.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child::after,\n.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-text:hover,\n.ant-btn-dangerous.ant-btn-text:focus {\n  color: #ff4d4f;\n  border-color: transparent;\n  background: rgba(0, 0, 0, 0.018);\n}\n.ant-btn-dangerous.ant-btn-text:hover > a:only-child,\n.ant-btn-dangerous.ant-btn-text:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-text:hover > a:only-child::after,\n.ant-btn-dangerous.ant-btn-text:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-text:active {\n  color: #cf1322;\n  border-color: transparent;\n  background: rgba(0, 0, 0, 0.028);\n}\n.ant-btn-dangerous.ant-btn-text:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-text:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dangerous.ant-btn-text[disabled],\n.ant-btn-dangerous.ant-btn-text[disabled]:hover,\n.ant-btn-dangerous.ant-btn-text[disabled]:focus,\n.ant-btn-dangerous.ant-btn-text[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: transparent;\n  background: transparent;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child,\n.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child,\n.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child,\n.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child::after,\n.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child::after,\n.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child::after,\n.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-icon-only {\n  width: 36px;\n  height: 36px;\n  padding: 6.6px 0;\n  font-size: 16px;\n  border-radius: 4px;\n  vertical-align: -3px;\n}\n.ant-btn-icon-only > * {\n  font-size: 16px;\n}\n.ant-btn-icon-only.ant-btn-lg {\n  width: 40px;\n  height: 40px;\n  padding: 7.3px 0;\n  font-size: 18px;\n  border-radius: 4px;\n}\n.ant-btn-icon-only.ant-btn-lg > * {\n  font-size: 18px;\n}\n.ant-btn-icon-only.ant-btn-sm {\n  width: 24px;\n  height: 24px;\n  padding: 1.9px 0;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.ant-btn-icon-only.ant-btn-sm > * {\n  font-size: 14px;\n}\n.ant-btn-icon-only > .anticon {\n  display: flex;\n  justify-content: center;\n}\n.ant-btn-icon-only .anticon-loading {\n  padding: 0 !important;\n}\na.ant-btn-icon-only {\n  vertical-align: -1px;\n}\na.ant-btn-icon-only > .anticon {\n  display: inline;\n}\n.ant-btn-round {\n  height: 36px;\n  padding: 7.9px 18px;\n  font-size: 14px;\n  border-radius: 36px;\n}\n.ant-btn-round.ant-btn-lg {\n  height: 40px;\n  padding: 8.6px 20px;\n  font-size: 16px;\n  border-radius: 40px;\n}\n.ant-btn-round.ant-btn-sm {\n  height: 24px;\n  padding: 1.9px 12px;\n  font-size: 14px;\n  border-radius: 24px;\n}\n.ant-btn-round.ant-btn-icon-only {\n  width: auto;\n}\n.ant-btn-circle {\n  min-width: 36px;\n  padding-right: 0;\n  padding-left: 0;\n  text-align: center;\n  border-radius: 50%;\n}\n.ant-btn-circle.ant-btn-lg {\n  min-width: 40px;\n  border-radius: 50%;\n}\n.ant-btn-circle.ant-btn-sm {\n  min-width: 24px;\n  border-radius: 50%;\n}\n.ant-btn::before {\n  position: absolute;\n  top: -1px;\n  right: -1px;\n  bottom: -1px;\n  left: -1px;\n  z-index: 1;\n  display: none;\n  background: #fff;\n  border-radius: inherit;\n  opacity: 0.35;\n  transition: opacity 0.2s;\n  content: '';\n  pointer-events: none;\n}\n.ant-btn .anticon {\n  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-btn .anticon.anticon-plus > svg,\n.ant-btn .anticon.anticon-minus > svg {\n  shape-rendering: optimizespeed;\n}\n.ant-btn.ant-btn-loading {\n  position: relative;\n  cursor: default;\n}\n.ant-btn.ant-btn-loading::before {\n  display: block;\n}\n.ant-btn > .ant-btn-loading-icon {\n  transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-btn > .ant-btn-loading-icon .anticon {\n  padding-right: 8px;\n  animation: none;\n}\n.ant-btn > .ant-btn-loading-icon .anticon svg {\n  animation: loadingCircle 1s infinite linear;\n}\n.ant-btn-group {\n  position: relative;\n  display: inline-flex;\n}\n.ant-btn-group > .ant-btn,\n.ant-btn-group > span > .ant-btn {\n  position: relative;\n}\n.ant-btn-group > .ant-btn:hover,\n.ant-btn-group > span > .ant-btn:hover,\n.ant-btn-group > .ant-btn:focus,\n.ant-btn-group > span > .ant-btn:focus,\n.ant-btn-group > .ant-btn:active,\n.ant-btn-group > span > .ant-btn:active {\n  z-index: 2;\n}\n.ant-btn-group > .ant-btn[disabled],\n.ant-btn-group > span > .ant-btn[disabled] {\n  z-index: 0;\n}\n.ant-btn-group .ant-btn-icon-only {\n  font-size: 14px;\n}\n.ant-btn-group .ant-btn + .ant-btn,\n.ant-btn + .ant-btn-group,\n.ant-btn-group span + .ant-btn,\n.ant-btn-group .ant-btn + span,\n.ant-btn-group > span + span,\n.ant-btn-group + .ant-btn,\n.ant-btn-group + .ant-btn-group {\n  margin-left: -1px;\n}\n.ant-btn-group .ant-btn-primary + .ant-btn:not(.ant-btn-primary):not([disabled]) {\n  border-left-color: transparent;\n}\n.ant-btn-group .ant-btn {\n  border-radius: 0;\n}\n.ant-btn-group > .ant-btn:first-child,\n.ant-btn-group > span:first-child > .ant-btn {\n  margin-left: 0;\n}\n.ant-btn-group > .ant-btn:only-child {\n  border-radius: 4px;\n}\n.ant-btn-group > span:only-child > .ant-btn {\n  border-radius: 4px;\n}\n.ant-btn-group > .ant-btn:first-child:not(:last-child),\n.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-btn-group > .ant-btn:last-child:not(:first-child),\n.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:only-child {\n  border-radius: 4px;\n}\n.ant-btn-group-sm > span:only-child > .ant-btn {\n  border-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),\n.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),\n.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-btn-group > .ant-btn-group {\n  float: left;\n}\n.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {\n  border-radius: 0;\n}\n.ant-btn-group > .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {\n  padding-right: 8px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-btn-group > .ant-btn-group:last-child:not(:first-child) > .ant-btn:first-child {\n  padding-left: 8px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-btn-rtl.ant-btn-group .ant-btn + .ant-btn,\n.ant-btn-rtl.ant-btn + .ant-btn-group,\n.ant-btn-rtl.ant-btn-group span + .ant-btn,\n.ant-btn-rtl.ant-btn-group .ant-btn + span,\n.ant-btn-rtl.ant-btn-group > span + span,\n.ant-btn-rtl.ant-btn-group + .ant-btn,\n.ant-btn-rtl.ant-btn-group + .ant-btn-group,\n.ant-btn-group-rtl.ant-btn-group .ant-btn + .ant-btn,\n.ant-btn-group-rtl.ant-btn + .ant-btn-group,\n.ant-btn-group-rtl.ant-btn-group span + .ant-btn,\n.ant-btn-group-rtl.ant-btn-group .ant-btn + span,\n.ant-btn-group-rtl.ant-btn-group > span + span,\n.ant-btn-group-rtl.ant-btn-group + .ant-btn,\n.ant-btn-group-rtl.ant-btn-group + .ant-btn-group {\n  margin-right: -1px;\n  margin-left: auto;\n}\n.ant-btn-group.ant-btn-group-rtl {\n  direction: rtl;\n}\n.ant-btn-group-rtl.ant-btn-group > .ant-btn:first-child:not(:last-child),\n.ant-btn-group-rtl.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {\n  border-radius: 0 4px 4px 0;\n}\n.ant-btn-group-rtl.ant-btn-group > .ant-btn:last-child:not(:first-child),\n.ant-btn-group-rtl.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {\n  border-radius: 4px 0 0 4px;\n}\n.ant-btn-group-rtl.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),\n.ant-btn-group-rtl.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {\n  border-radius: 0 4px 4px 0;\n}\n.ant-btn-group-rtl.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),\n.ant-btn-group-rtl.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {\n  border-radius: 4px 0 0 4px;\n}\n.ant-btn:focus > span,\n.ant-btn:active > span {\n  position: relative;\n}\n.ant-btn > .anticon + span,\n.ant-btn > span + .anticon {\n  margin-left: 8px;\n}\n.ant-btn.ant-btn-background-ghost {\n  color: #fff;\n  border-color: #fff;\n}\n.ant-btn.ant-btn-background-ghost,\n.ant-btn.ant-btn-background-ghost:hover,\n.ant-btn.ant-btn-background-ghost:active,\n.ant-btn.ant-btn-background-ghost:focus {\n  background: transparent;\n}\n.ant-btn.ant-btn-background-ghost:hover,\n.ant-btn.ant-btn-background-ghost:focus {\n  color: #462e61;\n  border-color: #462e61;\n}\n.ant-btn.ant-btn-background-ghost:active {\n  color: #1a0c2e;\n  border-color: #1a0c2e;\n}\n.ant-btn.ant-btn-background-ghost[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background: transparent;\n  border-color: #d9d9d9;\n}\n.ant-btn-background-ghost.ant-btn-primary {\n  color: #351a55;\n  border-color: #351a55;\n  text-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-primary > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-primary > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary:hover,\n.ant-btn-background-ghost.ant-btn-primary:focus {\n  color: #462e61;\n  border-color: #462e61;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary:active {\n  color: #1a0c2e;\n  border-color: #1a0c2e;\n}\n.ant-btn-background-ghost.ant-btn-primary:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-primary:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary[disabled],\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger {\n  color: #f5222d;\n  border-color: #f5222d;\n  text-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-danger > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-danger > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger:hover,\n.ant-btn-background-ghost.ant-btn-danger:focus {\n  color: #ff4d4f;\n  border-color: #ff4d4f;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger:active {\n  color: #cf1322;\n  border-color: #cf1322;\n}\n.ant-btn-background-ghost.ant-btn-danger:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-danger:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger[disabled],\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-dangerous {\n  color: #f5222d;\n  border-color: #f5222d;\n  text-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-dangerous > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-dangerous > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-dangerous:hover,\n.ant-btn-background-ghost.ant-btn-dangerous:focus {\n  color: #ff4d4f;\n  border-color: #ff4d4f;\n}\n.ant-btn-background-ghost.ant-btn-dangerous:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-dangerous:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-dangerous:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-dangerous:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-dangerous:active {\n  color: #cf1322;\n  border-color: #cf1322;\n}\n.ant-btn-background-ghost.ant-btn-dangerous:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-dangerous:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-dangerous[disabled],\n.ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-dangerous[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-dangerous[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link {\n  color: #f5222d;\n  border-color: transparent;\n  text-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus {\n  color: #ff4d4f;\n  border-color: transparent;\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active {\n  color: #cf1322;\n  border-color: transparent;\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled],\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  background: #f5f5f5;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child {\n  color: currentcolor;\n}\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-two-chinese-chars::first-letter {\n  letter-spacing: 0.34em;\n}\n.ant-btn-two-chinese-chars > *:not(.anticon) {\n  margin-right: -0.34em;\n  letter-spacing: 0.34em;\n}\n.ant-btn.ant-btn-block {\n  width: 100%;\n}\n.ant-btn:empty {\n  display: inline-block;\n  width: 0;\n  visibility: hidden;\n  content: '\\a0';\n}\na.ant-btn {\n  padding-top: 0.01px !important;\n  line-height: 34px;\n}\na.ant-btn-disabled {\n  cursor: not-allowed;\n}\na.ant-btn-disabled > * {\n  pointer-events: none;\n}\na.ant-btn-disabled,\na.ant-btn-disabled:hover,\na.ant-btn-disabled:focus,\na.ant-btn-disabled:active {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: transparent;\n  background: transparent;\n  text-shadow: none;\n  box-shadow: none;\n}\na.ant-btn-disabled > a:only-child,\na.ant-btn-disabled:hover > a:only-child,\na.ant-btn-disabled:focus > a:only-child,\na.ant-btn-disabled:active > a:only-child {\n  color: currentcolor;\n}\na.ant-btn-disabled > a:only-child::after,\na.ant-btn-disabled:hover > a:only-child::after,\na.ant-btn-disabled:focus > a:only-child::after,\na.ant-btn-disabled:active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\na.ant-btn-lg {\n  line-height: 38px;\n}\na.ant-btn-sm {\n  line-height: 22px;\n}\n.ant-btn-compact-item:not(.ant-btn-compact-last-item):not(.ant-btn-compact-item-rtl) {\n  margin-right: -1px;\n}\n.ant-btn-compact-item:not(.ant-btn-compact-last-item).ant-btn-compact-item-rtl {\n  margin-left: -1px;\n}\n.ant-btn-compact-item:hover,\n.ant-btn-compact-item:focus,\n.ant-btn-compact-item:active {\n  z-index: 2;\n}\n.ant-btn-compact-item[disabled] {\n  z-index: 0;\n}\n.ant-btn-compact-item:not(.ant-btn-compact-first-item):not(.ant-btn-compact-last-item).ant-btn {\n  border-radius: 0;\n}\n.ant-btn-compact-item.ant-btn.ant-btn-compact-first-item:not(.ant-btn-compact-last-item):not(.ant-btn-compact-item-rtl) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-btn-compact-item.ant-btn.ant-btn-compact-last-item:not(.ant-btn-compact-first-item):not(.ant-btn-compact-item-rtl) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-btn-compact-item.ant-btn.ant-btn-compact-item-rtl.ant-btn-compact-first-item:not(.ant-btn-compact-last-item) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-btn-compact-item.ant-btn.ant-btn-compact-item-rtl.ant-btn-compact-last-item:not(.ant-btn-compact-first-item) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-btn-icon-only.ant-btn-compact-item {\n  flex: none;\n}\n.ant-btn-compact-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-item.ant-btn-primary:not([disabled]) {\n  position: relative;\n}\n.ant-btn-compact-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-item.ant-btn-primary:not([disabled])::after {\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  display: inline-block;\n  width: 1px;\n  height: calc(100% + 1px * 2);\n  background-color: #462e61;\n  content: ' ';\n}\n.ant-btn-compact-item-rtl.ant-btn-compact-first-item.ant-btn-compact-item-rtl:not(.ant-btn-compact-last-item) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-btn-compact-item-rtl.ant-btn-compact-last-item.ant-btn-compact-item-rtl:not(.ant-btn-compact-first-item) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-btn-compact-item-rtl.ant-btn-sm.ant-btn-compact-first-item.ant-btn-compact-item-rtl.ant-btn-sm:not(.ant-btn-compact-last-item) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-btn-compact-item-rtl.ant-btn-sm.ant-btn-compact-last-item.ant-btn-compact-item-rtl.ant-btn-sm:not(.ant-btn-compact-first-item) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-btn-compact-item-rtl.ant-btn-primary:not([disabled]) + .ant-btn-compact-item-rtl.ant-btn-primary:not([disabled])::after {\n  right: -1px;\n}\n.ant-btn-compact-vertical-item:not(.ant-btn-compact-vertical-last-item) {\n  margin-bottom: -1px;\n}\n.ant-btn-compact-vertical-item:hover,\n.ant-btn-compact-vertical-item:focus,\n.ant-btn-compact-vertical-item:active {\n  z-index: 2;\n}\n.ant-btn-compact-vertical-item[disabled] {\n  z-index: 0;\n}\n.ant-btn-compact-vertical-item:not(.ant-btn-compact-vertical-first-item):not(.ant-btn-compact-vertical-last-item) {\n  border-radius: 0;\n}\n.ant-btn-compact-vertical-item.ant-btn-compact-vertical-first-item:not(.ant-btn-compact-vertical-last-item) {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-btn-compact-vertical-item.ant-btn-compact-vertical-last-item:not(.ant-btn-compact-vertical-first-item) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) {\n  position: relative;\n}\n.ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-vertical-item.ant-btn-primary:not([disabled])::after {\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  display: inline-block;\n  width: calc(100% + 1px * 2);\n  height: 1px;\n  background-color: #462e61;\n  content: ' ';\n}\n.ant-btn-rtl {\n  direction: rtl;\n}\n.ant-btn-group-rtl.ant-btn-group .ant-btn-primary:last-child:not(:first-child),\n.ant-btn-group-rtl.ant-btn-group .ant-btn-primary + .ant-btn-primary {\n  border-right-color: #462e61;\n  border-left-color: #d9d9d9;\n}\n.ant-btn-group-rtl.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],\n.ant-btn-group-rtl.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {\n  border-right-color: #d9d9d9;\n  border-left-color: #462e61;\n}\n.ant-btn-rtl.ant-btn > .ant-btn-loading-icon .anticon {\n  padding-right: 0;\n  padding-left: 8px;\n}\n.ant-btn-rtl.ant-btn > .anticon + span,\n.ant-btn-rtl.ant-btn > span + .anticon {\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-picker-calendar {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  background: #fff;\n}\n.ant-picker-calendar-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 12px 0;\n}\n.ant-picker-calendar-header .ant-picker-calendar-year-select {\n  min-width: 80px;\n}\n.ant-picker-calendar-header .ant-picker-calendar-month-select {\n  min-width: 70px;\n  margin-left: 8px;\n}\n.ant-picker-calendar-header .ant-picker-calendar-mode-switch {\n  margin-left: 8px;\n}\n.ant-picker-calendar .ant-picker-panel {\n  background: #fff;\n  border: 0;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0;\n}\n.ant-picker-calendar .ant-picker-panel .ant-picker-month-panel,\n.ant-picker-calendar .ant-picker-panel .ant-picker-date-panel {\n  width: auto;\n}\n.ant-picker-calendar .ant-picker-panel .ant-picker-body {\n  padding: 8px 0;\n}\n.ant-picker-calendar .ant-picker-panel .ant-picker-content {\n  width: 100%;\n}\n.ant-picker-calendar-mini {\n  border-radius: 6px;\n}\n.ant-picker-calendar-mini .ant-picker-calendar-header {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-picker-calendar-mini .ant-picker-panel {\n  border-radius: 0 0 6px 6px;\n}\n.ant-picker-calendar-mini .ant-picker-content {\n  height: 256px;\n}\n.ant-picker-calendar-mini .ant-picker-content th {\n  height: auto;\n  padding: 0;\n  line-height: 18px;\n}\n.ant-picker-calendar-mini .ant-picker-cell::before {\n  pointer-events: none;\n}\n.ant-picker-calendar-full .ant-picker-panel {\n  display: block;\n  width: 100%;\n  text-align: right;\n  background: #fff;\n  border: 0;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th,\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-body td {\n  padding: 0;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {\n  height: auto;\n  padding: 0 12px 5px 0;\n  line-height: 18px;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell::before {\n  display: none;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell:hover .ant-picker-calendar-date {\n  background: #f5f5f5;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell .ant-picker-calendar-date-today::before {\n  display: none;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date,\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date,\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today,\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today {\n  background: #908b94;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date .ant-picker-calendar-date-value,\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date .ant-picker-calendar-date-value,\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today .ant-picker-calendar-date-value,\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today .ant-picker-calendar-date-value {\n  color: #351a55;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date {\n  display: block;\n  width: auto;\n  height: auto;\n  margin: 0 4px;\n  padding: 4px 8px 0;\n  border: 0;\n  border-top: 2px solid #e8e8e8;\n  border-radius: 0;\n  transition: background 0.3s;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-value {\n  line-height: 24px;\n  transition: color 0.3s;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content {\n  position: static;\n  width: auto;\n  height: 86px;\n  overflow-y: auto;\n  color: #545454;\n  line-height: 1.3;\n  text-align: left;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-today {\n  border-color: #351a55;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-today .ant-picker-calendar-date-value {\n  color: #545454;\n}\n@media only screen and (max-width: 480px) {\n  .ant-picker-calendar-header {\n    display: block;\n  }\n  .ant-picker-calendar-header .ant-picker-calendar-year-select {\n    width: 50%;\n  }\n  .ant-picker-calendar-header .ant-picker-calendar-month-select {\n    width: calc(50% - 8px);\n  }\n  .ant-picker-calendar-header .ant-picker-calendar-mode-switch {\n    width: 100%;\n    margin-top: 8px;\n    margin-left: 0;\n  }\n  .ant-picker-calendar-header .ant-picker-calendar-mode-switch > label {\n    width: 50%;\n    text-align: center;\n  }\n}\n.ant-picker-calendar-rtl {\n  direction: rtl;\n}\n.ant-picker-calendar-rtl .ant-picker-calendar-header .ant-picker-calendar-month-select {\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-picker-calendar-rtl .ant-picker-calendar-header .ant-picker-calendar-mode-switch {\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel {\n  text-align: left;\n}\n.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {\n  padding: 0 0 5px 12px;\n}\n.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content {\n  text-align: right;\n}\n.ant-card {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  background: #fff;\n  border-radius: 6px;\n}\n.ant-card-rtl {\n  direction: rtl;\n}\n.ant-card-hoverable {\n  cursor: pointer;\n  transition: box-shadow 0.3s, border-color 0.3s;\n}\n.ant-card-hoverable:hover {\n  border-color: transparent;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);\n}\n.ant-card-bordered {\n  border: 1px solid #e8e8e8;\n}\n.ant-card-head {\n  min-height: 48px;\n  margin-bottom: -1px;\n  padding: 0 24px;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 6px 6px 0 0;\n}\n.ant-card-head::before {\n  display: table;\n  content: '';\n}\n.ant-card-head::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-card-head::before {\n  display: table;\n  content: '';\n}\n.ant-card-head::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-card-head-wrapper {\n  display: flex;\n  align-items: center;\n}\n.ant-card-head-title {\n  display: inline-block;\n  flex: 1;\n  padding: 16px 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-card-head-title > .ant-typography,\n.ant-card-head-title > .ant-typography-edit-content {\n  left: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.ant-card-head .ant-tabs-top {\n  clear: both;\n  margin-bottom: -17px;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n}\n.ant-card-head .ant-tabs-top-bar {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-card-extra {\n  margin-left: auto;\n  padding: 16px 0;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n}\n.ant-card-rtl .ant-card-extra {\n  margin-right: auto;\n  margin-left: 0;\n}\n.ant-card-body {\n  padding: 24px;\n}\n.ant-card-body::before {\n  display: table;\n  content: '';\n}\n.ant-card-body::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-card-body::before {\n  display: table;\n  content: '';\n}\n.ant-card-body::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-card-contain-grid .ant-card-body {\n  display: flex;\n  flex-wrap: wrap;\n}\n.ant-card-contain-grid:not(.ant-card-loading) .ant-card-body {\n  margin: -1px 0 0 -1px;\n  padding: 0;\n}\n.ant-card-grid {\n  width: 33.33%;\n  padding: 24px;\n  border: 0;\n  border-radius: 0;\n  box-shadow: 1px 0 0 0 #e8e8e8, 0 1px 0 0 #e8e8e8, 1px 1px 0 0 #e8e8e8, 1px 0 0 0 #e8e8e8 inset, 0 1px 0 0 #e8e8e8 inset;\n  transition: all 0.3s;\n}\n.ant-card-grid-hoverable:hover {\n  position: relative;\n  z-index: 1;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);\n}\n.ant-card-contain-tabs > .ant-card-head .ant-card-head-title {\n  min-height: 32px;\n  padding-bottom: 0;\n}\n.ant-card-contain-tabs > .ant-card-head .ant-card-extra {\n  padding-bottom: 0;\n}\n.ant-card-bordered .ant-card-cover {\n  margin-top: -1px;\n  margin-right: -1px;\n  margin-left: -1px;\n}\n.ant-card-cover > * {\n  display: block;\n  width: 100%;\n}\n.ant-card-cover img {\n  border-radius: 6px 6px 0 0;\n}\n.ant-card-actions {\n  display: flex;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  background: #fafafa;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-card-actions::before {\n  display: table;\n  content: '';\n}\n.ant-card-actions::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-card-actions::before {\n  display: table;\n  content: '';\n}\n.ant-card-actions::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-card-actions > li {\n  margin: 12px 0;\n  color: #595959;\n  text-align: center;\n}\n.ant-card-actions > li > span {\n  position: relative;\n  display: block;\n  min-width: 32px;\n  font-size: 14px;\n  line-height: 1.3;\n  cursor: pointer;\n}\n.ant-card-actions > li > span:hover {\n  color: #351a55;\n  transition: color 0.3s;\n}\n.ant-card-actions > li > span a:not(.ant-btn),\n.ant-card-actions > li > span > .anticon {\n  display: inline-block;\n  width: 100%;\n  color: #595959;\n  line-height: 22px;\n  transition: color 0.3s;\n}\n.ant-card-actions > li > span a:not(.ant-btn):hover,\n.ant-card-actions > li > span > .anticon:hover {\n  color: #351a55;\n}\n.ant-card-actions > li > span > .anticon {\n  font-size: 16px;\n  line-height: 22px;\n}\n.ant-card-actions > li:not(:last-child) {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-card-rtl .ant-card-actions > li:not(:last-child) {\n  border-right: none;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-card-type-inner .ant-card-head {\n  padding: 0 24px;\n  background: #fafafa;\n}\n.ant-card-type-inner .ant-card-head-title {\n  padding: 12px 0;\n  font-size: 14px;\n}\n.ant-card-type-inner .ant-card-body {\n  padding: 16px 24px;\n}\n.ant-card-type-inner .ant-card-extra {\n  padding: 13.5px 0;\n}\n.ant-card-meta {\n  display: flex;\n  margin: -4px 0;\n}\n.ant-card-meta::before {\n  display: table;\n  content: '';\n}\n.ant-card-meta::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-card-meta::before {\n  display: table;\n  content: '';\n}\n.ant-card-meta::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-card-meta-avatar {\n  padding-right: 16px;\n}\n.ant-card-rtl .ant-card-meta-avatar {\n  padding-right: 0;\n  padding-left: 16px;\n}\n.ant-card-meta-detail {\n  flex: 1;\n  overflow: hidden;\n}\n.ant-card-meta-detail > div:not(:last-child) {\n  margin-bottom: 8px;\n}\n.ant-card-meta-title {\n  overflow: hidden;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-card-meta-description {\n  color: #595959;\n}\n.ant-card-loading {\n  overflow: hidden;\n}\n.ant-card-loading .ant-card-body {\n  user-select: none;\n}\n.ant-card-small > .ant-card-head {\n  min-height: 36px;\n  padding: 0 12px;\n  font-size: 14px;\n}\n.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-head-title {\n  padding: 8px 0;\n}\n.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-extra {\n  padding: 8px 0;\n  font-size: 14px;\n}\n.ant-card-small > .ant-card-body {\n  padding: 12px;\n}\n.ant-carousel {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-carousel .slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  touch-action: pan-y;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n}\n.ant-carousel .slick-list {\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.ant-carousel .slick-list:focus {\n  outline: none;\n}\n.ant-carousel .slick-list.dragging {\n  cursor: pointer;\n}\n.ant-carousel .slick-list .slick-slide {\n  pointer-events: none;\n}\n.ant-carousel .slick-list .slick-slide input.ant-radio-input,\n.ant-carousel .slick-list .slick-slide input.ant-checkbox-input {\n  visibility: hidden;\n}\n.ant-carousel .slick-list .slick-slide.slick-active {\n  pointer-events: auto;\n}\n.ant-carousel .slick-list .slick-slide.slick-active input.ant-radio-input,\n.ant-carousel .slick-list .slick-slide.slick-active input.ant-checkbox-input {\n  visibility: visible;\n}\n.ant-carousel .slick-list .slick-slide > div > div {\n  vertical-align: bottom;\n}\n.ant-carousel .slick-slider .slick-track,\n.ant-carousel .slick-slider .slick-list {\n  transform: translate3d(0, 0, 0);\n  touch-action: pan-y;\n}\n.ant-carousel .slick-track {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n}\n.ant-carousel .slick-track::before,\n.ant-carousel .slick-track::after {\n  display: table;\n  content: '';\n}\n.ant-carousel .slick-track::after {\n  clear: both;\n}\n.slick-loading .ant-carousel .slick-track {\n  visibility: hidden;\n}\n.ant-carousel .slick-slide {\n  display: none;\n  float: left;\n  height: 100%;\n  min-height: 1px;\n}\n.ant-carousel .slick-slide img {\n  display: block;\n}\n.ant-carousel .slick-slide.slick-loading img {\n  display: none;\n}\n.ant-carousel .slick-slide.dragging img {\n  pointer-events: none;\n}\n.ant-carousel .slick-initialized .slick-slide {\n  display: block;\n}\n.ant-carousel .slick-loading .slick-slide {\n  visibility: hidden;\n}\n.ant-carousel .slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n}\n.ant-carousel .slick-arrow.slick-hidden {\n  display: none;\n}\n.ant-carousel .slick-prev,\n.ant-carousel .slick-next {\n  position: absolute;\n  top: 50%;\n  display: block;\n  width: 20px;\n  height: 20px;\n  margin-top: -10px;\n  padding: 0;\n  color: transparent;\n  font-size: 0;\n  line-height: 0;\n  background: transparent;\n  border: 0;\n  outline: none;\n  cursor: pointer;\n}\n.ant-carousel .slick-prev:hover,\n.ant-carousel .slick-next:hover,\n.ant-carousel .slick-prev:focus,\n.ant-carousel .slick-next:focus {\n  color: transparent;\n  background: transparent;\n  outline: none;\n}\n.ant-carousel .slick-prev:hover::before,\n.ant-carousel .slick-next:hover::before,\n.ant-carousel .slick-prev:focus::before,\n.ant-carousel .slick-next:focus::before {\n  opacity: 1;\n}\n.ant-carousel .slick-prev.slick-disabled::before,\n.ant-carousel .slick-next.slick-disabled::before {\n  opacity: 0.25;\n}\n.ant-carousel .slick-prev {\n  left: -25px;\n}\n.ant-carousel .slick-prev::before {\n  content: '←';\n}\n.ant-carousel .slick-next {\n  right: -25px;\n}\n.ant-carousel .slick-next::before {\n  content: '→';\n}\n.ant-carousel .slick-dots {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex !important;\n  justify-content: center;\n  margin-right: 15%;\n  margin-bottom: 0;\n  margin-left: 15%;\n  padding-left: 0;\n  list-style: none;\n}\n.ant-carousel .slick-dots-bottom {\n  bottom: 12px;\n}\n.ant-carousel .slick-dots-top {\n  top: 12px;\n  bottom: auto;\n}\n.ant-carousel .slick-dots li {\n  position: relative;\n  display: inline-block;\n  flex: 0 1 auto;\n  box-sizing: content-box;\n  width: 16px;\n  height: 3px;\n  margin: 0 4px;\n  padding: 0;\n  text-align: center;\n  text-indent: -999px;\n  vertical-align: top;\n  transition: all 0.5s;\n}\n.ant-carousel .slick-dots li button {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 3px;\n  padding: 0;\n  color: transparent;\n  font-size: 0;\n  background: #fff;\n  border: 0;\n  border-radius: 1px;\n  outline: none;\n  cursor: pointer;\n  opacity: 0.3;\n  transition: all 0.5s;\n}\n.ant-carousel .slick-dots li button:hover,\n.ant-carousel .slick-dots li button:focus {\n  opacity: 0.75;\n}\n.ant-carousel .slick-dots li button::after {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  bottom: -4px;\n  left: -4px;\n  content: '';\n}\n.ant-carousel .slick-dots li.slick-active {\n  width: 24px;\n}\n.ant-carousel .slick-dots li.slick-active button {\n  background: #fff;\n  opacity: 1;\n}\n.ant-carousel .slick-dots li.slick-active:hover,\n.ant-carousel .slick-dots li.slick-active:focus {\n  opacity: 1;\n}\n.ant-carousel-vertical .slick-dots {\n  top: 50%;\n  bottom: auto;\n  flex-direction: column;\n  width: 3px;\n  height: auto;\n  margin: 0;\n  transform: translateY(-50%);\n}\n.ant-carousel-vertical .slick-dots-left {\n  right: auto;\n  left: 12px;\n}\n.ant-carousel-vertical .slick-dots-right {\n  right: 12px;\n  left: auto;\n}\n.ant-carousel-vertical .slick-dots li {\n  width: 3px;\n  height: 16px;\n  margin: 4px 0;\n  vertical-align: baseline;\n}\n.ant-carousel-vertical .slick-dots li button {\n  width: 3px;\n  height: 16px;\n}\n.ant-carousel-vertical .slick-dots li.slick-active {\n  width: 3px;\n  height: 24px;\n}\n.ant-carousel-vertical .slick-dots li.slick-active button {\n  width: 3px;\n  height: 24px;\n}\n.ant-carousel-rtl {\n  direction: rtl;\n}\n.ant-carousel-rtl .ant-carousel .slick-track {\n  right: 0;\n  left: auto;\n}\n.ant-carousel-rtl .ant-carousel .slick-prev {\n  right: -25px;\n  left: auto;\n}\n.ant-carousel-rtl .ant-carousel .slick-prev::before {\n  content: '→';\n}\n.ant-carousel-rtl .ant-carousel .slick-next {\n  right: auto;\n  left: -25px;\n}\n.ant-carousel-rtl .ant-carousel .slick-next::before {\n  content: '←';\n}\n.ant-carousel-rtl.ant-carousel .slick-dots {\n  flex-direction: row-reverse;\n}\n.ant-carousel-rtl.ant-carousel-vertical .slick-dots {\n  flex-direction: column;\n}\n@keyframes antCheckboxEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n.ant-cascader-checkbox {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: 0.2em;\n  line-height: 1;\n  white-space: nowrap;\n  outline: none;\n  cursor: pointer;\n}\n.ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox-inner,\n.ant-cascader-checkbox:hover .ant-cascader-checkbox-inner,\n.ant-cascader-checkbox-input:focus + .ant-cascader-checkbox-inner {\n  border-color: #351a55;\n}\n.ant-cascader-checkbox-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #351a55;\n  border-radius: 4px;\n  visibility: hidden;\n  animation: antCheckboxEffect 0.36s ease-in-out;\n  animation-fill-mode: backwards;\n  content: '';\n}\n.ant-cascader-checkbox:hover::after,\n.ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox::after {\n  visibility: visible;\n}\n.ant-cascader-checkbox-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  direction: ltr;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  border-collapse: separate;\n  transition: all 0.3s;\n}\n.ant-cascader-checkbox-inner::after {\n  position: absolute;\n  top: 50%;\n  left: 21.5%;\n  display: table;\n  width: 5.71428571px;\n  height: 9.14285714px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(0) translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;\n  content: ' ';\n}\n.ant-cascader-checkbox-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner::after {\n  position: absolute;\n  display: table;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(1) translate(-50%, -50%);\n  opacity: 1;\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n  content: ' ';\n}\n.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner {\n  background-color: #351a55;\n  border-color: #351a55;\n}\n.ant-cascader-checkbox-disabled {\n  cursor: not-allowed;\n}\n.ant-cascader-checkbox-disabled.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner::after {\n  border-color: rgba(0, 0, 0, 0.25);\n  animation-name: none;\n}\n.ant-cascader-checkbox-disabled .ant-cascader-checkbox-input {\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner {\n  background-color: #f5f5f5;\n  border-color: #d9d9d9 !important;\n}\n.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner::after {\n  border-color: #f5f5f5;\n  border-collapse: separate;\n  animation-name: none;\n}\n.ant-cascader-checkbox-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-cascader-checkbox-disabled:hover::after,\n.ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox-disabled::after {\n  visibility: hidden;\n}\n.ant-cascader-checkbox-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-flex;\n  align-items: baseline;\n  line-height: unset;\n  cursor: pointer;\n}\n.ant-cascader-checkbox-wrapper::after {\n  display: inline-block;\n  width: 0;\n  overflow: hidden;\n  content: '\\a0';\n}\n.ant-cascader-checkbox-wrapper.ant-cascader-checkbox-wrapper-disabled {\n  cursor: not-allowed;\n}\n.ant-cascader-checkbox-wrapper + .ant-cascader-checkbox-wrapper {\n  margin-left: 8px;\n}\n.ant-cascader-checkbox-wrapper.ant-cascader-checkbox-wrapper-in-form-item input[type='checkbox'] {\n  width: 14px;\n  height: 14px;\n}\n.ant-cascader-checkbox + span {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-cascader-checkbox-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-cascader-checkbox-group-item {\n  margin-right: 8px;\n}\n.ant-cascader-checkbox-group-item:last-child {\n  margin-right: 0;\n}\n.ant-cascader-checkbox-group-item + .ant-cascader-checkbox-group-item {\n  margin-left: 0;\n}\n.ant-cascader-checkbox-indeterminate .ant-cascader-checkbox-inner {\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-cascader-checkbox-indeterminate .ant-cascader-checkbox-inner::after {\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background-color: #351a55;\n  border: 0;\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n  content: ' ';\n}\n.ant-cascader-checkbox-indeterminate.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner::after {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-cascader-checkbox-rtl {\n  direction: rtl;\n}\n.ant-cascader-checkbox-group-rtl .ant-cascader-checkbox-group-item {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-cascader-checkbox-group-rtl .ant-cascader-checkbox-group-item:last-child {\n  margin-left: 0 !important;\n}\n.ant-cascader-checkbox-group-rtl .ant-cascader-checkbox-group-item + .ant-cascader-checkbox-group-item {\n  margin-left: 8px;\n}\n.ant-cascader {\n  width: 184px;\n}\n.ant-cascader-checkbox {\n  top: 0;\n  margin-right: 8px;\n}\n.ant-cascader-menus {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n}\n.ant-cascader-menus.ant-cascader-menu-empty .ant-cascader-menu {\n  width: 100%;\n  height: auto;\n}\n.ant-cascader-menu {\n  flex-grow: 1;\n  min-width: 111px;\n  height: 180px;\n  margin: 0;\n  margin: -4px 0;\n  padding: 4px 0;\n  overflow: auto;\n  vertical-align: top;\n  list-style: none;\n  border-right: 1px solid #e8e8e8;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.ant-cascader-menu-item {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  padding: 5px 12px;\n  overflow: hidden;\n  line-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-cascader-menu-item:hover {\n  background: #f5f5f5;\n}\n.ant-cascader-menu-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-cascader-menu-item-disabled:hover {\n  background: transparent;\n}\n.ant-cascader-menu-empty .ant-cascader-menu-item {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: default;\n  pointer-events: none;\n}\n.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled),\n.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {\n  font-weight: 600;\n  background-color: #908b94;\n}\n.ant-cascader-menu-item-content {\n  flex: auto;\n}\n.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon,\n.ant-cascader-menu-item-loading-icon {\n  margin-left: 4px;\n  color: #595959;\n  font-size: 10px;\n}\n.ant-cascader-menu-item-disabled.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon,\n.ant-cascader-menu-item-disabled.ant-cascader-menu-item-loading-icon {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-cascader-menu-item-keyword {\n  color: #f5222d;\n}\n.ant-cascader-compact-item:not(.ant-cascader-compact-last-item):not(.ant-cascader-compact-item-rtl) {\n  margin-right: -1px;\n}\n.ant-cascader-compact-item:not(.ant-cascader-compact-last-item).ant-cascader-compact-item-rtl {\n  margin-left: -1px;\n}\n.ant-cascader-compact-item:hover,\n.ant-cascader-compact-item:focus,\n.ant-cascader-compact-item:active {\n  z-index: 2;\n}\n.ant-cascader-compact-item[disabled] {\n  z-index: 0;\n}\n.ant-cascader-compact-item:not(.ant-cascader-compact-first-item):not(.ant-cascader-compact-last-item).ant-cascader {\n  border-radius: 0;\n}\n.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-first-item:not(.ant-cascader-compact-last-item):not(.ant-cascader-compact-item-rtl) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-last-item:not(.ant-cascader-compact-first-item):not(.ant-cascader-compact-item-rtl) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-item-rtl.ant-cascader-compact-first-item:not(.ant-cascader-compact-last-item) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-item-rtl.ant-cascader-compact-last-item:not(.ant-cascader-compact-first-item) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-cascader-rtl .ant-cascader-menu-item-expand-icon,\n.ant-cascader-rtl .ant-cascader-menu-item-loading-icon {\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-cascader-rtl .ant-cascader-checkbox {\n  top: 0;\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-checkbox {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: 0.2em;\n  line-height: 1;\n  white-space: nowrap;\n  outline: none;\n  cursor: pointer;\n}\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n  border-color: #351a55;\n}\n.ant-checkbox-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #351a55;\n  border-radius: 4px;\n  visibility: hidden;\n  animation: antCheckboxEffect 0.36s ease-in-out;\n  animation-fill-mode: backwards;\n  content: '';\n}\n.ant-checkbox:hover::after,\n.ant-checkbox-wrapper:hover .ant-checkbox::after {\n  visibility: visible;\n}\n.ant-checkbox-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  direction: ltr;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  border-collapse: separate;\n  transition: all 0.3s;\n}\n.ant-checkbox-inner::after {\n  position: absolute;\n  top: 50%;\n  left: 21.5%;\n  display: table;\n  width: 5.71428571px;\n  height: 9.14285714px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(0) translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;\n  content: ' ';\n}\n.ant-checkbox-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-checkbox-checked .ant-checkbox-inner::after {\n  position: absolute;\n  display: table;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(1) translate(-50%, -50%);\n  opacity: 1;\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n  content: ' ';\n}\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #351a55;\n  border-color: #351a55;\n}\n.ant-checkbox-disabled {\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {\n  border-color: rgba(0, 0, 0, 0.25);\n  animation-name: none;\n}\n.ant-checkbox-disabled .ant-checkbox-input {\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.ant-checkbox-disabled .ant-checkbox-inner {\n  background-color: #f5f5f5;\n  border-color: #d9d9d9 !important;\n}\n.ant-checkbox-disabled .ant-checkbox-inner::after {\n  border-color: #f5f5f5;\n  border-collapse: separate;\n  animation-name: none;\n}\n.ant-checkbox-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled:hover::after,\n.ant-checkbox-wrapper:hover .ant-checkbox-disabled::after {\n  visibility: hidden;\n}\n.ant-checkbox-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-flex;\n  align-items: baseline;\n  line-height: unset;\n  cursor: pointer;\n}\n.ant-checkbox-wrapper::after {\n  display: inline-block;\n  width: 0;\n  overflow: hidden;\n  content: '\\a0';\n}\n.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {\n  cursor: not-allowed;\n}\n.ant-checkbox-wrapper + .ant-checkbox-wrapper {\n  margin-left: 8px;\n}\n.ant-checkbox-wrapper.ant-checkbox-wrapper-in-form-item input[type='checkbox'] {\n  width: 14px;\n  height: 14px;\n}\n.ant-checkbox + span {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-checkbox-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-checkbox-group-item {\n  margin-right: 8px;\n}\n.ant-checkbox-group-item:last-child {\n  margin-right: 0;\n}\n.ant-checkbox-group-item + .ant-checkbox-group-item {\n  margin-left: 0;\n}\n.ant-checkbox-indeterminate .ant-checkbox-inner {\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-checkbox-indeterminate .ant-checkbox-inner::after {\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background-color: #351a55;\n  border: 0;\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n  content: ' ';\n}\n.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner::after {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-checkbox-rtl {\n  direction: rtl;\n}\n.ant-checkbox-group-rtl .ant-checkbox-group-item {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-checkbox-group-rtl .ant-checkbox-group-item:last-child {\n  margin-left: 0 !important;\n}\n.ant-checkbox-group-rtl .ant-checkbox-group-item + .ant-checkbox-group-item {\n  margin-left: 8px;\n}\n.ant-collapse {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  background-color: #fafafa;\n  border: 1px solid #d9d9d9;\n  border-bottom: 0;\n  border-radius: 6px;\n}\n.ant-collapse > .ant-collapse-item {\n  border-bottom: 1px solid #d9d9d9;\n}\n.ant-collapse > .ant-collapse-item:last-child,\n.ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {\n  border-radius: 0 0 6px 6px;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  position: relative;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  padding: 12px 16px;\n  color: #535353;\n  line-height: 1.3;\n  cursor: pointer;\n  transition: all 0.3s, visibility 0s;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n  display: inline-block;\n  margin-right: 12px;\n  font-size: 12px;\n  vertical-align: -1px;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {\n  transition: transform 0.24s;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-header-text {\n  flex: auto;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {\n  margin-left: auto;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header:focus {\n  outline: none;\n}\n.ant-collapse > .ant-collapse-item .ant-collapse-header-collapsible-only {\n  cursor: default;\n}\n.ant-collapse > .ant-collapse-item .ant-collapse-header-collapsible-only .ant-collapse-header-text {\n  flex: none;\n  cursor: pointer;\n}\n.ant-collapse > .ant-collapse-item .ant-collapse-icon-collapsible-only {\n  cursor: default;\n}\n.ant-collapse > .ant-collapse-item .ant-collapse-icon-collapsible-only .ant-collapse-expand-icon {\n  cursor: pointer;\n}\n.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {\n  padding-left: 12px;\n}\n.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {\n  position: relative;\n  padding: 12px 16px;\n  padding-right: 40px;\n}\n.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n  position: absolute;\n  top: 50%;\n  right: 16px;\n  left: auto;\n  margin: 0;\n  transform: translateY(-50%);\n}\n.ant-collapse-content {\n  color: #545454;\n  background-color: #fff;\n  border-top: 1px solid #d9d9d9;\n}\n.ant-collapse-content > .ant-collapse-content-box {\n  padding: 16px;\n}\n.ant-collapse-content-hidden {\n  display: none;\n}\n.ant-collapse-item:last-child > .ant-collapse-content {\n  border-radius: 0 0 6px 6px;\n}\n.ant-collapse-borderless {\n  background-color: #fafafa;\n  border: 0;\n}\n.ant-collapse-borderless > .ant-collapse-item {\n  border-bottom: 1px solid #d9d9d9;\n}\n.ant-collapse-borderless > .ant-collapse-item:last-child,\n.ant-collapse-borderless > .ant-collapse-item:last-child .ant-collapse-header {\n  border-radius: 0;\n}\n.ant-collapse-borderless > .ant-collapse-item:last-child {\n  border-bottom: 0;\n}\n.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {\n  background-color: transparent;\n  border-top: 0;\n}\n.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {\n  padding-top: 4px;\n}\n.ant-collapse-ghost {\n  background-color: transparent;\n  border: 0;\n}\n.ant-collapse-ghost > .ant-collapse-item {\n  border-bottom: 0;\n}\n.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content {\n  background-color: transparent;\n  border-top: 0;\n}\n.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header,\n.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-collapse-rtl {\n  direction: rtl;\n}\n.ant-collapse-rtl.ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {\n  position: relative;\n  padding: 12px 16px;\n  padding-left: 40px;\n}\n.ant-collapse-rtl.ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n  position: absolute;\n  top: 50%;\n  right: auto;\n  left: 16px;\n  margin: 0;\n  transform: translateY(-50%);\n}\n.ant-collapse-rtl .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  padding: 12px 16px;\n  padding-right: 40px;\n}\n.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n  margin-right: 0;\n  margin-left: 12px;\n}\n.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {\n  transform: rotate(180deg);\n}\n.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {\n  margin-right: auto;\n  margin-left: 0;\n}\n.ant-collapse-rtl.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {\n  padding-right: 12px;\n  padding-left: 0;\n}\n.ant-comment {\n  position: relative;\n  background-color: inherit;\n}\n.ant-comment-inner {\n  display: flex;\n  padding: 16px 0;\n}\n.ant-comment-avatar {\n  position: relative;\n  flex-shrink: 0;\n  margin-right: 12px;\n  cursor: pointer;\n}\n.ant-comment-avatar img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n}\n.ant-comment-content {\n  position: relative;\n  flex: 1 1 auto;\n  min-width: 1px;\n  font-size: 14px;\n  word-wrap: break-word;\n}\n.ant-comment-content-author {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  margin-bottom: 4px;\n  font-size: 14px;\n}\n.ant-comment-content-author > a,\n.ant-comment-content-author > span {\n  padding-right: 8px;\n  font-size: 12px;\n  line-height: 18px;\n}\n.ant-comment-content-author-name {\n  color: #595959;\n  font-size: 14px;\n  transition: color 0.3s;\n}\n.ant-comment-content-author-name > * {\n  color: #595959;\n}\n.ant-comment-content-author-name > *:hover {\n  color: #595959;\n}\n.ant-comment-content-author-time {\n  color: #ccc;\n  white-space: nowrap;\n  cursor: auto;\n}\n.ant-comment-content-detail p {\n  margin-bottom: inherit;\n  white-space: pre-wrap;\n}\n.ant-comment-actions {\n  margin-top: 12px;\n  margin-bottom: inherit;\n  padding-left: 0;\n}\n.ant-comment-actions > li {\n  display: inline-block;\n  color: #595959;\n}\n.ant-comment-actions > li > span {\n  margin-right: 10px;\n  color: #595959;\n  font-size: 12px;\n  cursor: pointer;\n  transition: color 0.3s;\n  user-select: none;\n}\n.ant-comment-actions > li > span:hover {\n  color: #595959;\n}\n.ant-comment-nested {\n  margin-left: 44px;\n}\n.ant-comment-rtl {\n  direction: rtl;\n}\n.ant-comment-rtl .ant-comment-avatar {\n  margin-right: 0;\n  margin-left: 12px;\n}\n.ant-comment-rtl .ant-comment-content-author > a,\n.ant-comment-rtl .ant-comment-content-author > span {\n  padding-right: 0;\n  padding-left: 8px;\n}\n.ant-comment-rtl .ant-comment-actions {\n  padding-right: 0;\n}\n.ant-comment-rtl .ant-comment-actions > li > span {\n  margin-right: 0;\n  margin-left: 10px;\n}\n.ant-comment-rtl .ant-comment-nested {\n  margin-right: 44px;\n  margin-left: 0;\n}\n.ant-picker-status-error.ant-picker,\n.ant-picker-status-error.ant-picker:not(.ant-picker-disabled):hover {\n  background-color: #fff;\n  border-color: #f5222d;\n}\n.ant-picker-status-error.ant-picker-focused,\n.ant-picker-status-error.ant-picker:focus {\n  border-color: #ff4d4f;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-picker-status-error.ant-picker .ant-picker-active-bar {\n  background: #ff4d4f;\n}\n.ant-picker-status-warning.ant-picker,\n.ant-picker-status-warning.ant-picker:not(.ant-picker-disabled):hover {\n  background-color: #fff;\n  border-color: #fa8c16;\n}\n.ant-picker-status-warning.ant-picker-focused,\n.ant-picker-status-warning.ant-picker:focus {\n  border-color: #ffa940;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-picker-status-warning.ant-picker .ant-picker-active-bar {\n  background: #ffa940;\n}\n.ant-picker {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  padding: 8px 11px 8px;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  background: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: border 0.3s, box-shadow 0.3s;\n}\n.ant-picker:hover,\n.ant-picker-focused {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-picker:hover,\n.ant-input-rtl .ant-picker-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-picker-focused {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-picker-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-picker.ant-picker-disabled {\n  background: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-picker.ant-picker-disabled .ant-picker-suffix {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-picker.ant-picker-borderless {\n  background-color: transparent !important;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.ant-picker-input {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n}\n.ant-picker-input > input {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  min-width: 0;\n  padding: 7.9px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n  flex: auto;\n  min-width: 1px;\n  height: auto;\n  padding: 0;\n  background: transparent;\n  border: 0;\n}\n.ant-picker-input > input::placeholder {\n  color: #bfbfbf;\n  user-select: none;\n}\n.ant-picker-input > input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-picker-input > input:hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-picker-input > input:hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-picker-input > input:focus,\n.ant-picker-input > input-focused {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-picker-input > input:focus,\n.ant-input-rtl .ant-picker-input > input-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-picker-input > input-disabled {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-picker-input > input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-picker-input > input[disabled] {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-picker-input > input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-picker-input > input-borderless,\n.ant-picker-input > input-borderless:hover,\n.ant-picker-input > input-borderless:focus,\n.ant-picker-input > input-borderless-focused,\n.ant-picker-input > input-borderless-disabled,\n.ant-picker-input > input-borderless[disabled] {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\ntextarea.ant-picker-input > input {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-picker-input > input-lg {\n  padding: 8.6px 11px;\n  font-size: 16px;\n}\n.ant-picker-input > input-sm {\n  padding: 1.9px 7px;\n}\n.ant-picker-input > input-rtl {\n  direction: rtl;\n}\n.ant-picker-input > input:focus {\n  box-shadow: none;\n}\n.ant-picker-input > input[disabled] {\n  background: transparent;\n}\n.ant-picker-input:hover .ant-picker-clear {\n  opacity: 1;\n}\n.ant-picker-input-placeholder > input {\n  color: #bfbfbf;\n}\n.ant-picker-large {\n  padding: 9px 11px 9px;\n}\n.ant-picker-large .ant-picker-input > input {\n  font-size: 16px;\n}\n.ant-picker-small {\n  padding: 2px 7px 2px;\n}\n.ant-picker-suffix {\n  display: flex;\n  flex: none;\n  align-self: center;\n  margin-left: 4px;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 1;\n  pointer-events: none;\n}\n.ant-picker-suffix > * {\n  vertical-align: top;\n}\n.ant-picker-suffix > *:not(:last-child) {\n  margin-right: 8px;\n}\n.ant-picker-clear {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 1;\n  background: #fff;\n  transform: translateY(-50%);\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.3s, color 0.3s;\n}\n.ant-picker-clear > * {\n  vertical-align: top;\n}\n.ant-picker-clear:hover {\n  color: #595959;\n}\n.ant-picker-separator {\n  position: relative;\n  display: inline-block;\n  width: 1em;\n  height: 16px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 16px;\n  vertical-align: top;\n  cursor: default;\n}\n.ant-picker-focused .ant-picker-separator {\n  color: #595959;\n}\n.ant-picker-disabled .ant-picker-range-separator .ant-picker-separator {\n  cursor: not-allowed;\n}\n.ant-picker-range {\n  position: relative;\n  display: inline-flex;\n}\n.ant-picker-range .ant-picker-clear {\n  right: 11px;\n}\n.ant-picker-range:hover .ant-picker-clear {\n  opacity: 1;\n}\n.ant-picker-range .ant-picker-active-bar {\n  bottom: -1px;\n  height: 2px;\n  margin-left: 11px;\n  background: #351a55;\n  opacity: 0;\n  transition: all 0.3s ease-out;\n  pointer-events: none;\n}\n.ant-picker-range.ant-picker-focused .ant-picker-active-bar {\n  opacity: 1;\n}\n.ant-picker-range-separator {\n  align-items: center;\n  padding: 0 8px;\n  line-height: 1;\n}\n.ant-picker-range.ant-picker-small .ant-picker-clear {\n  right: 7px;\n}\n.ant-picker-range.ant-picker-small .ant-picker-active-bar {\n  margin-left: 7px;\n}\n.ant-picker-dropdown {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n}\n.ant-picker-dropdown-hidden {\n  display: none;\n}\n.ant-picker-dropdown-placement-bottomLeft .ant-picker-range-arrow {\n  top: 2.58561808px;\n  display: block;\n  transform: rotate(-135deg) translateY(1px);\n}\n.ant-picker-dropdown-placement-topLeft .ant-picker-range-arrow {\n  bottom: 2.58561808px;\n  display: block;\n  transform: rotate(45deg);\n}\n.ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-topLeft,\n.ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-topRight,\n.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-topLeft,\n.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-bottomLeft,\n.ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-bottomRight,\n.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-bottomLeft,\n.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-topLeft,\n.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-bottomLeft,\n.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-picker-dropdown-range {\n  padding: 7.54247233px 0;\n}\n.ant-picker-dropdown-range-hidden {\n  display: none;\n}\n.ant-picker-dropdown .ant-picker-panel > .ant-picker-time-panel {\n  padding-top: 4px;\n}\n.ant-picker-ranges {\n  margin-bottom: 0;\n  padding: 4px 12px;\n  overflow: hidden;\n  line-height: 34px;\n  text-align: left;\n  list-style: none;\n}\n.ant-picker-ranges > li {\n  display: inline-block;\n}\n.ant-picker-ranges .ant-picker-preset > .ant-tag-blue {\n  color: #351a55;\n  background: #908b94;\n  border-color: #6f617a;\n  cursor: pointer;\n}\n.ant-picker-ranges .ant-picker-ok {\n  float: right;\n  margin-left: 8px;\n}\n.ant-picker-range-wrapper {\n  display: flex;\n}\n.ant-picker-range-arrow {\n  position: absolute;\n  z-index: 1;\n  width: 11.3137085px;\n  height: 11.3137085px;\n  margin-left: 16.5px;\n  box-shadow: 2px 2px 6px -2px rgba(0, 0, 0, 0.1);\n  transition: left 0.3s ease-out;\n  border-radius: 0 0 2px;\n  pointer-events: none;\n}\n.ant-picker-range-arrow::before {\n  position: absolute;\n  top: -11.3137085px;\n  left: -11.3137085px;\n  width: 33.9411255px;\n  height: 33.9411255px;\n  background: #fff;\n  background-repeat: no-repeat;\n  background-position: -10px -10px;\n  content: '';\n  clip-path: inset(33% 33%);\n  clip-path: path('M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z');\n}\n.ant-picker-panel-container {\n  overflow: hidden;\n  vertical-align: top;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  transition: margin 0.3s;\n}\n.ant-picker-panel-container .ant-picker-panels {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  direction: ltr;\n}\n.ant-picker-panel-container .ant-picker-panel {\n  vertical-align: top;\n  background: transparent;\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n.ant-picker-panel-container .ant-picker-panel .ant-picker-content,\n.ant-picker-panel-container .ant-picker-panel table {\n  text-align: center;\n}\n.ant-picker-panel-container .ant-picker-panel-focused {\n  border-color: #e8e8e8;\n}\n.ant-picker-compact-item:not(.ant-picker-compact-last-item):not(.ant-picker-compact-item-rtl) {\n  margin-right: -1px;\n}\n.ant-picker-compact-item:not(.ant-picker-compact-last-item).ant-picker-compact-item-rtl {\n  margin-left: -1px;\n}\n.ant-picker-compact-item:hover,\n.ant-picker-compact-item:focus,\n.ant-picker-compact-item:active {\n  z-index: 2;\n}\n.ant-picker-compact-item.ant-picker-focused {\n  z-index: 2;\n}\n.ant-picker-compact-item[disabled] {\n  z-index: 0;\n}\n.ant-picker-compact-item:not(.ant-picker-compact-first-item):not(.ant-picker-compact-last-item).ant-picker {\n  border-radius: 0;\n}\n.ant-picker-compact-item.ant-picker.ant-picker-compact-first-item:not(.ant-picker-compact-last-item):not(.ant-picker-compact-item-rtl) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-picker-compact-item.ant-picker.ant-picker-compact-last-item:not(.ant-picker-compact-first-item):not(.ant-picker-compact-item-rtl) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-picker-compact-item.ant-picker.ant-picker-compact-item-rtl.ant-picker-compact-first-item:not(.ant-picker-compact-last-item) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-picker-compact-item.ant-picker.ant-picker-compact-item-rtl.ant-picker-compact-last-item:not(.ant-picker-compact-first-item) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-picker-panel {\n  display: inline-flex;\n  flex-direction: column;\n  text-align: center;\n  background: #fff;\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  outline: none;\n}\n.ant-picker-panel-focused {\n  border-color: #351a55;\n}\n.ant-picker-decade-panel,\n.ant-picker-year-panel,\n.ant-picker-quarter-panel,\n.ant-picker-month-panel,\n.ant-picker-week-panel,\n.ant-picker-date-panel,\n.ant-picker-time-panel {\n  display: flex;\n  flex-direction: column;\n  width: 280px;\n}\n.ant-picker-header {\n  display: flex;\n  padding: 0 8px;\n  color: #535353;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-picker-header > * {\n  flex: none;\n}\n.ant-picker-header button {\n  padding: 0;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 40px;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n.ant-picker-header > button {\n  min-width: 1.6em;\n  font-size: 14px;\n}\n.ant-picker-header > button:hover {\n  color: #545454;\n}\n.ant-picker-header-view {\n  flex: auto;\n  font-weight: 500;\n  line-height: 40px;\n}\n.ant-picker-header-view button {\n  color: inherit;\n  font-weight: inherit;\n}\n.ant-picker-header-view button:not(:first-child) {\n  margin-left: 8px;\n}\n.ant-picker-header-view button:hover {\n  color: #351a55;\n}\n.ant-picker-prev-icon,\n.ant-picker-next-icon,\n.ant-picker-super-prev-icon,\n.ant-picker-super-next-icon {\n  position: relative;\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n}\n.ant-picker-prev-icon::before,\n.ant-picker-next-icon::before,\n.ant-picker-super-prev-icon::before,\n.ant-picker-super-next-icon::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border: 0 solid currentcolor;\n  border-width: 1.5px 0 0 1.5px;\n  content: '';\n}\n.ant-picker-super-prev-icon::after,\n.ant-picker-super-next-icon::after {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border: 0 solid currentcolor;\n  border-width: 1.5px 0 0 1.5px;\n  content: '';\n}\n.ant-picker-prev-icon,\n.ant-picker-super-prev-icon {\n  transform: rotate(-45deg);\n}\n.ant-picker-next-icon,\n.ant-picker-super-next-icon {\n  transform: rotate(135deg);\n}\n.ant-picker-content {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n.ant-picker-content th,\n.ant-picker-content td {\n  position: relative;\n  min-width: 24px;\n  font-weight: 400;\n}\n.ant-picker-content th {\n  height: 30px;\n  color: #545454;\n  line-height: 30px;\n}\n.ant-picker-cell {\n  padding: 3px 0;\n  color: rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n.ant-picker-cell-in-view {\n  color: #545454;\n}\n.ant-picker-cell::before {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: 24px;\n  transform: translateY(-50%);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-picker-cell .ant-picker-cell-inner {\n  position: relative;\n  z-index: 2;\n  display: inline-block;\n  min-width: 24px;\n  height: 24px;\n  line-height: 24px;\n  border-radius: 6px;\n  transition: background 0.3s, border 0.3s;\n}\n.ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,\n.ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner {\n  background: #f5f5f5;\n}\n.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  border: 1px solid #351a55;\n  border-radius: 6px;\n  content: '';\n}\n.ant-picker-cell-in-view.ant-picker-cell-in-range {\n  position: relative;\n}\n.ant-picker-cell-in-view.ant-picker-cell-in-range::before {\n  background: #908b94;\n}\n.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,\n.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,\n.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {\n  color: #fff;\n  background: #351a55;\n}\n.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,\n.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {\n  background: #908b94;\n}\n.ant-picker-cell-in-view.ant-picker-cell-range-start::before {\n  left: 50%;\n}\n.ant-picker-cell-in-view.ant-picker-cell-range-end::before {\n  right: 50%;\n}\n.ant-picker-cell-in-view.ant-picker-cell-range-hover-start:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,\n.ant-picker-cell-in-view.ant-picker-cell-range-hover-end:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,\n.ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start-single::after,\n.ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-end-near-hover::after,\n.ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-start-near-hover::after,\n.ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-end-single::after,\n.ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-in-range)::after {\n  position: absolute;\n  top: 50%;\n  z-index: 0;\n  height: 24px;\n  border-top: 1px dashed #6632a3;\n  border-bottom: 1px dashed #6632a3;\n  transform: translateY(-50%);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-picker-cell-range-hover-start::after,\n.ant-picker-cell-range-hover-end::after,\n.ant-picker-cell-range-hover::after {\n  right: 0;\n  left: 2px;\n}\n.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before,\n.ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-hover::before,\n.ant-picker-cell-in-view.ant-picker-cell-range-end.ant-picker-cell-range-hover::before,\n.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before,\n.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before,\n.ant-picker-panel > :not(.ant-picker-date-panel) .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start::before,\n.ant-picker-panel > :not(.ant-picker-date-panel) .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end::before {\n  background: #8c56cb;\n}\n.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {\n  border-radius: 6px 0 0 6px;\n}\n.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):not(.ant-picker-cell-range-start) .ant-picker-cell-inner {\n  border-radius: 0 6px 6px 0;\n}\n.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after,\n.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: -1;\n  background: #8c56cb;\n  transition: all 0.3s;\n  content: '';\n}\n.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after {\n  right: -6px;\n  left: 0;\n}\n.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after {\n  right: 0;\n  left: -6px;\n}\n.ant-picker-cell-range-hover.ant-picker-cell-range-start::after {\n  right: 50%;\n}\n.ant-picker-cell-range-hover.ant-picker-cell-range-end::after {\n  left: 50%;\n}\ntr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:first-child::after,\ntr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child::after,\n.ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range::after,\n.ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range)::after,\n.ant-picker-cell-in-view.ant-picker-cell-range-hover-start::after {\n  left: 6px;\n  border-left: 1px dashed #6632a3;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\ntr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:last-child::after,\ntr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child::after,\n.ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range::after,\n.ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range)::after,\n.ant-picker-cell-in-view.ant-picker-cell-range-hover-end::after {\n  right: 6px;\n  border-right: 1px dashed #6632a3;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.ant-picker-cell-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  pointer-events: none;\n}\n.ant-picker-cell-disabled .ant-picker-cell-inner {\n  background: transparent;\n}\n.ant-picker-cell-disabled::before {\n  background: rgba(0, 0, 0, 0.04);\n}\n.ant-picker-cell-disabled.ant-picker-cell-today .ant-picker-cell-inner::before {\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-picker-decade-panel .ant-picker-content,\n.ant-picker-year-panel .ant-picker-content,\n.ant-picker-quarter-panel .ant-picker-content,\n.ant-picker-month-panel .ant-picker-content {\n  height: 264px;\n}\n.ant-picker-decade-panel .ant-picker-cell-inner,\n.ant-picker-year-panel .ant-picker-cell-inner,\n.ant-picker-quarter-panel .ant-picker-cell-inner,\n.ant-picker-month-panel .ant-picker-cell-inner {\n  padding: 0 8px;\n}\n.ant-picker-quarter-panel .ant-picker-content {\n  height: 56px;\n}\n.ant-picker-footer {\n  width: min-content;\n  min-width: 100%;\n  line-height: 38px;\n  text-align: center;\n  border-bottom: 1px solid transparent;\n}\n.ant-picker-panel .ant-picker-footer {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-picker-footer-extra {\n  padding: 0 12px;\n  line-height: 38px;\n  text-align: left;\n}\n.ant-picker-footer-extra:not(:last-child) {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-picker-now {\n  text-align: left;\n}\n.ant-picker-today-btn {\n  color: var(--app-primary-color);\n}\n.ant-picker-today-btn:hover {\n  color: #0d0d0d;\n}\n.ant-picker-today-btn:active {\n  color: #000000;\n}\n.ant-picker-today-btn.ant-picker-today-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-picker-decade-panel .ant-picker-cell-inner {\n  padding: 0 4px;\n}\n.ant-picker-decade-panel .ant-picker-cell::before {\n  display: none;\n}\n.ant-picker-year-panel .ant-picker-body,\n.ant-picker-quarter-panel .ant-picker-body,\n.ant-picker-month-panel .ant-picker-body {\n  padding: 0 8px;\n}\n.ant-picker-year-panel .ant-picker-cell-inner,\n.ant-picker-quarter-panel .ant-picker-cell-inner,\n.ant-picker-month-panel .ant-picker-cell-inner {\n  width: 60px;\n}\n.ant-picker-year-panel .ant-picker-cell-range-hover-start::after,\n.ant-picker-quarter-panel .ant-picker-cell-range-hover-start::after,\n.ant-picker-month-panel .ant-picker-cell-range-hover-start::after {\n  left: 14px;\n  border-left: 1px dashed #6632a3;\n  border-radius: 6px 0 0 6px;\n}\n.ant-picker-panel-rtl .ant-picker-year-panel .ant-picker-cell-range-hover-start::after,\n.ant-picker-panel-rtl .ant-picker-quarter-panel .ant-picker-cell-range-hover-start::after,\n.ant-picker-panel-rtl .ant-picker-month-panel .ant-picker-cell-range-hover-start::after {\n  right: 14px;\n  border-right: 1px dashed #6632a3;\n  border-radius: 0 6px 6px 0;\n}\n.ant-picker-year-panel .ant-picker-cell-range-hover-end::after,\n.ant-picker-quarter-panel .ant-picker-cell-range-hover-end::after,\n.ant-picker-month-panel .ant-picker-cell-range-hover-end::after {\n  right: 14px;\n  border-right: 1px dashed #6632a3;\n  border-radius: 0 6px 6px 0;\n}\n.ant-picker-panel-rtl .ant-picker-year-panel .ant-picker-cell-range-hover-end::after,\n.ant-picker-panel-rtl .ant-picker-quarter-panel .ant-picker-cell-range-hover-end::after,\n.ant-picker-panel-rtl .ant-picker-month-panel .ant-picker-cell-range-hover-end::after {\n  left: 14px;\n  border-left: 1px dashed #6632a3;\n  border-radius: 6px 0 0 6px;\n}\n.ant-picker-week-panel .ant-picker-body {\n  padding: 8px 12px;\n}\n.ant-picker-week-panel .ant-picker-cell:hover .ant-picker-cell-inner,\n.ant-picker-week-panel .ant-picker-cell-selected .ant-picker-cell-inner,\n.ant-picker-week-panel .ant-picker-cell .ant-picker-cell-inner {\n  background: transparent !important;\n}\n.ant-picker-week-panel-row td {\n  transition: background 0.3s;\n}\n.ant-picker-week-panel-row:hover td {\n  background: #f5f5f5;\n}\n.ant-picker-week-panel-row-selected td,\n.ant-picker-week-panel-row-selected:hover td {\n  background: #351a55;\n}\n.ant-picker-week-panel-row-selected td.ant-picker-cell-week,\n.ant-picker-week-panel-row-selected:hover td.ant-picker-cell-week {\n  color: rgba(255, 255, 255, 0.5);\n}\n.ant-picker-week-panel-row-selected td.ant-picker-cell-today .ant-picker-cell-inner::before,\n.ant-picker-week-panel-row-selected:hover td.ant-picker-cell-today .ant-picker-cell-inner::before {\n  border-color: #fff;\n}\n.ant-picker-week-panel-row-selected td .ant-picker-cell-inner,\n.ant-picker-week-panel-row-selected:hover td .ant-picker-cell-inner {\n  color: #fff;\n}\n.ant-picker-date-panel .ant-picker-body {\n  padding: 8px 12px;\n}\n.ant-picker-date-panel .ant-picker-content {\n  width: 252px;\n}\n.ant-picker-date-panel .ant-picker-content th {\n  width: 36px;\n}\n.ant-picker-datetime-panel {\n  display: flex;\n}\n.ant-picker-datetime-panel .ant-picker-time-panel {\n  border-left: 1px solid #e8e8e8;\n}\n.ant-picker-datetime-panel .ant-picker-date-panel,\n.ant-picker-datetime-panel .ant-picker-time-panel {\n  transition: opacity 0.3s;\n}\n.ant-picker-datetime-panel-active .ant-picker-date-panel,\n.ant-picker-datetime-panel-active .ant-picker-time-panel {\n  opacity: 0.3;\n}\n.ant-picker-datetime-panel-active .ant-picker-date-panel-active,\n.ant-picker-datetime-panel-active .ant-picker-time-panel-active {\n  opacity: 1;\n}\n.ant-picker-time-panel {\n  width: auto;\n  min-width: auto;\n}\n.ant-picker-time-panel .ant-picker-content {\n  display: flex;\n  flex: auto;\n  height: 224px;\n}\n.ant-picker-time-panel-column {\n  flex: 1 0 auto;\n  width: 56px;\n  margin: 0;\n  padding: 0;\n  overflow-y: hidden;\n  text-align: left;\n  list-style: none;\n  transition: background 0.3s;\n}\n.ant-picker-time-panel-column::after {\n  display: block;\n  height: 196px;\n  content: '';\n}\n.ant-picker-datetime-panel .ant-picker-time-panel-column::after {\n  height: 198px;\n}\n.ant-picker-time-panel-column:not(:first-child) {\n  border-left: 1px solid #e8e8e8;\n}\n.ant-picker-time-panel-column-active {\n  background: rgba(144, 139, 148, 0.2);\n}\n.ant-picker-time-panel-column:hover {\n  overflow-y: auto;\n}\n.ant-picker-time-panel-column > li {\n  margin: 0;\n  padding: 0;\n}\n.ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner {\n  display: block;\n  width: 100%;\n  height: 28px;\n  margin: 0;\n  padding: 0 0 0 14px;\n  color: #545454;\n  line-height: 28px;\n  border-radius: 0;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n.ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover {\n  background: #f5f5f5;\n}\n.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {\n  background: #908b94;\n}\n.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-disabled .ant-picker-time-panel-cell-inner {\n  color: rgba(0, 0, 0, 0.25);\n  background: transparent;\n  cursor: not-allowed;\n}\n/* stylelint-disable selector-type-no-unknown,selector-no-vendor-prefix */\n_:-ms-fullscreen .ant-picker-range-wrapper .ant-picker-month-panel .ant-picker-cell,\n:root .ant-picker-range-wrapper .ant-picker-month-panel .ant-picker-cell,\n_:-ms-fullscreen .ant-picker-range-wrapper .ant-picker-year-panel .ant-picker-cell,\n:root .ant-picker-range-wrapper .ant-picker-year-panel .ant-picker-cell {\n  padding: 21px 0;\n}\n.ant-picker-rtl {\n  direction: rtl;\n}\n.ant-picker-rtl .ant-picker-suffix {\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-picker-rtl .ant-picker-clear {\n  right: auto;\n  left: 0;\n}\n.ant-picker-rtl .ant-picker-separator {\n  transform: rotate(180deg);\n}\n.ant-picker-panel-rtl .ant-picker-header-view button:not(:first-child) {\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-picker-rtl.ant-picker-range .ant-picker-clear {\n  right: auto;\n  left: 11px;\n}\n.ant-picker-rtl.ant-picker-range .ant-picker-active-bar {\n  margin-right: 11px;\n  margin-left: 0;\n}\n.ant-picker-rtl.ant-picker-range.ant-picker-small .ant-picker-active-bar {\n  margin-right: 7px;\n}\n.ant-picker-dropdown-rtl .ant-picker-ranges {\n  text-align: right;\n}\n.ant-picker-dropdown-rtl .ant-picker-ranges .ant-picker-ok {\n  float: left;\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-picker-panel-rtl {\n  direction: rtl;\n}\n.ant-picker-panel-rtl .ant-picker-prev-icon,\n.ant-picker-panel-rtl .ant-picker-super-prev-icon {\n  transform: rotate(135deg);\n}\n.ant-picker-panel-rtl .ant-picker-next-icon,\n.ant-picker-panel-rtl .ant-picker-super-next-icon {\n  transform: rotate(-45deg);\n}\n.ant-picker-cell .ant-picker-cell-inner {\n  position: relative;\n  z-index: 2;\n  display: inline-block;\n  min-width: 24px;\n  height: 24px;\n  line-height: 24px;\n  border-radius: 6px;\n  transition: background 0.3s, border 0.3s;\n}\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start::before {\n  right: 50%;\n  left: 0;\n}\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-end::before {\n  right: 0;\n  left: 50%;\n}\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-end::before {\n  right: 50%;\n  left: 50%;\n}\n.ant-picker-panel-rtl .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after {\n  right: 0;\n  left: -6px;\n}\n.ant-picker-panel-rtl .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after {\n  right: -6px;\n  left: 0;\n}\n.ant-picker-panel-rtl .ant-picker-cell-range-hover.ant-picker-cell-range-start::after {\n  right: 0;\n  left: 50%;\n}\n.ant-picker-panel-rtl .ant-picker-cell-range-hover.ant-picker-cell-range-end::after {\n  right: 50%;\n  left: 0;\n}\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {\n  border-radius: 0 6px 6px 0;\n}\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):not(.ant-picker-cell-range-start) .ant-picker-cell-inner {\n  border-radius: 6px 0 0 6px;\n}\n.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-selected):first-child::after,\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range::after,\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range)::after,\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-start::after {\n  right: 6px;\n  left: 0;\n  border-right: 1px dashed #6632a3;\n  border-left: none;\n  border-radius: 0 6px 6px 0;\n}\n.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-selected):last-child::after,\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range::after,\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range)::after,\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-end::after {\n  right: 0;\n  left: 6px;\n  border-right: none;\n  border-left: 1px dashed #6632a3;\n  border-radius: 6px 0 0 6px;\n}\n.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child::after,\n.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child::after,\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover)::after,\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-end.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover)::after,\n.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-start.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover)::after,\n.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover.ant-picker-cell-range-hover-edge-start:last-child::after,\n.ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover.ant-picker-cell-range-hover-edge-end:first-child::after {\n  right: 6px;\n  left: 6px;\n  border-right: 1px dashed #6632a3;\n  border-left: 1px dashed #6632a3;\n  border-radius: 6px;\n}\n.ant-picker-dropdown-rtl .ant-picker-footer-extra {\n  direction: rtl;\n  text-align: right;\n}\n.ant-picker-panel-rtl .ant-picker-time-panel {\n  direction: ltr;\n}\n.ant-descriptions-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.ant-descriptions-title {\n  flex: auto;\n  overflow: hidden;\n  color: #535353;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 1.3;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-descriptions-extra {\n  margin-left: auto;\n  color: #545454;\n  font-size: 14px;\n}\n.ant-descriptions-view {\n  width: 100%;\n  border-radius: 6px;\n}\n.ant-descriptions-view table {\n  width: 100%;\n  table-layout: fixed;\n}\n.ant-descriptions-row > th,\n.ant-descriptions-row > td {\n  padding-bottom: 16px;\n}\n.ant-descriptions-row:last-child {\n  border-bottom: none;\n}\n.ant-descriptions-item-label {\n  color: #535353;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1.3;\n  text-align: start;\n}\n.ant-descriptions-item-label::after {\n  content: ':';\n  position: relative;\n  top: -0.5px;\n  margin: 0 8px 0 2px;\n}\n.ant-descriptions-item-label.ant-descriptions-item-no-colon::after {\n  content: ' ';\n}\n.ant-descriptions-item-no-label::after {\n  margin: 0;\n  content: '';\n}\n.ant-descriptions-item-content {\n  display: table-cell;\n  flex: 1;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n.ant-descriptions-item {\n  padding-bottom: 0;\n  vertical-align: top;\n}\n.ant-descriptions-item-container {\n  display: flex;\n}\n.ant-descriptions-item-container .ant-descriptions-item-label,\n.ant-descriptions-item-container .ant-descriptions-item-content {\n  display: inline-flex;\n  align-items: baseline;\n}\n.ant-descriptions-middle .ant-descriptions-row > th,\n.ant-descriptions-middle .ant-descriptions-row > td {\n  padding-bottom: 12px;\n}\n.ant-descriptions-small .ant-descriptions-row > th,\n.ant-descriptions-small .ant-descriptions-row > td {\n  padding-bottom: 8px;\n}\n.ant-descriptions-bordered .ant-descriptions-view {\n  border: 1px solid #e8e8e8;\n}\n.ant-descriptions-bordered .ant-descriptions-view > table {\n  table-layout: auto;\n  border-collapse: collapse;\n}\n.ant-descriptions-bordered .ant-descriptions-item-label,\n.ant-descriptions-bordered .ant-descriptions-item-content {\n  padding: 16px 24px;\n  border-right: 1px solid #e8e8e8;\n}\n.ant-descriptions-bordered .ant-descriptions-item-label:last-child,\n.ant-descriptions-bordered .ant-descriptions-item-content:last-child {\n  border-right: none;\n}\n.ant-descriptions-bordered .ant-descriptions-item-label {\n  background-color: #fafafa;\n}\n.ant-descriptions-bordered .ant-descriptions-item-label::after {\n  display: none;\n}\n.ant-descriptions-bordered .ant-descriptions-row {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-descriptions-bordered .ant-descriptions-row:last-child {\n  border-bottom: none;\n}\n.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-label,\n.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-content {\n  padding: 12px 24px;\n}\n.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-label,\n.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-content {\n  padding: 8px 16px;\n}\n.ant-descriptions-rtl {\n  direction: rtl;\n}\n.ant-descriptions-rtl .ant-descriptions-item-label::after {\n  margin: 0 2px 0 8px;\n}\n.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-label,\n.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-content {\n  border-right: none;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-label:last-child,\n.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-content:last-child {\n  border-left: none;\n}\n.ant-divider {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n.ant-divider-vertical {\n  position: relative;\n  top: -0.06em;\n  display: inline-block;\n  height: 0.9em;\n  margin: 0 8px;\n  vertical-align: middle;\n  border-top: 0;\n  border-left: 1px solid rgba(0, 0, 0, 0.06);\n}\n.ant-divider-horizontal {\n  display: flex;\n  clear: both;\n  width: 100%;\n  min-width: 100%;\n  margin: 24px 0;\n}\n.ant-divider-horizontal.ant-divider-with-text {\n  display: flex;\n  align-items: center;\n  margin: 16px 0;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  white-space: nowrap;\n  text-align: center;\n  border-top: 0;\n  border-top-color: rgba(0, 0, 0, 0.06);\n}\n.ant-divider-horizontal.ant-divider-with-text::before,\n.ant-divider-horizontal.ant-divider-with-text::after {\n  position: relative;\n  width: 50%;\n  border-top: 1px solid transparent;\n  border-top-color: inherit;\n  border-bottom: 0;\n  transform: translateY(50%);\n  content: '';\n}\n.ant-divider-horizontal.ant-divider-with-text-left::before {\n  width: 5%;\n}\n.ant-divider-horizontal.ant-divider-with-text-left::after {\n  width: 95%;\n}\n.ant-divider-horizontal.ant-divider-with-text-right::before {\n  width: 95%;\n}\n.ant-divider-horizontal.ant-divider-with-text-right::after {\n  width: 5%;\n}\n.ant-divider-inner-text {\n  display: inline-block;\n  padding: 0 1em;\n}\n.ant-divider-dashed {\n  background: none;\n  border-color: rgba(0, 0, 0, 0.06);\n  border-style: dashed;\n  border-width: 1px 0 0;\n}\n.ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed::before,\n.ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed::after {\n  border-style: dashed none none;\n}\n.ant-divider-vertical.ant-divider-dashed {\n  border-width: 0 0 0 1px;\n}\n.ant-divider-plain.ant-divider-with-text {\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n}\n.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left::before {\n  width: 0;\n}\n.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left::after {\n  width: 100%;\n}\n.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left .ant-divider-inner-text {\n  padding-left: 0;\n}\n.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right::before {\n  width: 100%;\n}\n.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right::after {\n  width: 0;\n}\n.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right .ant-divider-inner-text {\n  padding-right: 0;\n}\n.ant-divider-rtl {\n  direction: rtl;\n}\n.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-left::before {\n  width: 95%;\n}\n.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-left::after {\n  width: 5%;\n}\n.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-right::before {\n  width: 5%;\n}\n.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-right::after {\n  width: 95%;\n}\n.ant-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  pointer-events: none;\n}\n.ant-drawer-inline {\n  position: absolute;\n}\n.ant-drawer-mask {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.45);\n  pointer-events: auto;\n}\n.ant-drawer-content-wrapper {\n  position: absolute;\n  z-index: 1000;\n  transition: all 0.3s;\n}\n.ant-drawer-content-wrapper-hidden {\n  display: none;\n}\n.ant-drawer-left > .ant-drawer-content-wrapper {\n  top: 0;\n  bottom: 0;\n  left: 0;\n  box-shadow: 6px 0 16px -8px rgba(0, 0, 0, 0.08), 9px 0 28px 0 rgba(0, 0, 0, 0.05), 12px 0 48px 16px rgba(0, 0, 0, 0.03);\n}\n.ant-drawer-right > .ant-drawer-content-wrapper {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  box-shadow: -6px 0 16px -8px rgba(0, 0, 0, 0.08), -9px 0 28px 0 rgba(0, 0, 0, 0.05), -12px 0 48px 16px rgba(0, 0, 0, 0.03);\n}\n.ant-drawer-top > .ant-drawer-content-wrapper {\n  top: 0;\n  right: 0;\n  left: 0;\n  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px 0 rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);\n}\n.ant-drawer-bottom > .ant-drawer-content-wrapper {\n  right: 0;\n  bottom: 0;\n  left: 0;\n  box-shadow: 0 -6px 16px -8px rgba(0, 0, 0, 0.08), 0 -9px 28px 0 rgba(0, 0, 0, 0.05), 0 -12px 48px 16px rgba(0, 0, 0, 0.03);\n}\n.ant-drawer-content {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: #fff;\n  pointer-events: auto;\n}\n.ant-drawer-wrapper-body {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n.ant-drawer-header {\n  display: flex;\n  flex: 0;\n  align-items: center;\n  padding: 16px 24px;\n  font-size: 16px;\n  line-height: 22px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-drawer-header-title {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  min-width: 0;\n  min-height: 0;\n}\n.ant-drawer-extra {\n  flex: none;\n}\n.ant-drawer-close {\n  display: inline-block;\n  margin-right: 12px;\n  color: #595959;\n  font-weight: 700;\n  font-size: 16px;\n  font-style: normal;\n  line-height: 1;\n  text-align: center;\n  text-transform: none;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  transition: color 0.3s;\n  text-rendering: auto;\n}\n.ant-drawer-close:focus,\n.ant-drawer-close:hover {\n  color: rgba(0, 0, 0, 0.75);\n  text-decoration: none;\n}\n.ant-drawer-title {\n  flex: 1;\n  margin: 0;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n}\n.ant-drawer-body {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  padding: 24px;\n  overflow: auto;\n}\n.ant-drawer-footer {\n  flex-shrink: 0;\n  padding: 10px 16px;\n  border-top: 1px solid #e8e8e8;\n}\n.panel-motion-enter-start,\n.panel-motion-appear-start,\n.panel-motion-leave-start {\n  transition: none;\n}\n.panel-motion-enter-active,\n.panel-motion-appear-active,\n.panel-motion-leave-active {\n  transition: all 0.3s;\n}\n.ant-drawer-mask-motion-enter-active,\n.ant-drawer-mask-motion-appear-active,\n.ant-drawer-mask-motion-leave-active {\n  transition: all 0.3s;\n}\n.ant-drawer-mask-motion-enter,\n.ant-drawer-mask-motion-appear {\n  opacity: 0;\n}\n.ant-drawer-mask-motion-enter-active,\n.ant-drawer-mask-motion-appear-active {\n  opacity: 1;\n}\n.ant-drawer-mask-motion-leave {\n  opacity: 1;\n}\n.ant-drawer-mask-motion-leave-active {\n  opacity: 0;\n}\n.ant-drawer-panel-motion-left-enter-start,\n.ant-drawer-panel-motion-left-appear-start,\n.ant-drawer-panel-motion-left-leave-start {\n  transition: none;\n}\n.ant-drawer-panel-motion-left-enter-active,\n.ant-drawer-panel-motion-left-appear-active,\n.ant-drawer-panel-motion-left-leave-active {\n  transition: all 0.3s;\n}\n.ant-drawer-panel-motion-left-enter-start,\n.ant-drawer-panel-motion-left-appear-start {\n  transform: translateX(-100%) !important;\n}\n.ant-drawer-panel-motion-left-enter-active,\n.ant-drawer-panel-motion-left-appear-active {\n  transform: translateX(0);\n}\n.ant-drawer-panel-motion-left-leave {\n  transform: translateX(0);\n}\n.ant-drawer-panel-motion-left-leave-active {\n  transform: translateX(-100%);\n}\n.ant-drawer-panel-motion-right-enter-start,\n.ant-drawer-panel-motion-right-appear-start,\n.ant-drawer-panel-motion-right-leave-start {\n  transition: none;\n}\n.ant-drawer-panel-motion-right-enter-active,\n.ant-drawer-panel-motion-right-appear-active,\n.ant-drawer-panel-motion-right-leave-active {\n  transition: all 0.3s;\n}\n.ant-drawer-panel-motion-right-enter-start,\n.ant-drawer-panel-motion-right-appear-start {\n  transform: translateX(100%) !important;\n}\n.ant-drawer-panel-motion-right-enter-active,\n.ant-drawer-panel-motion-right-appear-active {\n  transform: translateX(0);\n}\n.ant-drawer-panel-motion-right-leave {\n  transform: translateX(0);\n}\n.ant-drawer-panel-motion-right-leave-active {\n  transform: translateX(100%);\n}\n.ant-drawer-panel-motion-top-enter-start,\n.ant-drawer-panel-motion-top-appear-start,\n.ant-drawer-panel-motion-top-leave-start {\n  transition: none;\n}\n.ant-drawer-panel-motion-top-enter-active,\n.ant-drawer-panel-motion-top-appear-active,\n.ant-drawer-panel-motion-top-leave-active {\n  transition: all 0.3s;\n}\n.ant-drawer-panel-motion-top-enter-start,\n.ant-drawer-panel-motion-top-appear-start {\n  transform: translateY(-100%) !important;\n}\n.ant-drawer-panel-motion-top-enter-active,\n.ant-drawer-panel-motion-top-appear-active {\n  transform: translateY(0);\n}\n.ant-drawer-panel-motion-top-leave {\n  transform: translateY(0);\n}\n.ant-drawer-panel-motion-top-leave-active {\n  transform: translateY(-100%);\n}\n.ant-drawer-panel-motion-bottom-enter-start,\n.ant-drawer-panel-motion-bottom-appear-start,\n.ant-drawer-panel-motion-bottom-leave-start {\n  transition: none;\n}\n.ant-drawer-panel-motion-bottom-enter-active,\n.ant-drawer-panel-motion-bottom-appear-active,\n.ant-drawer-panel-motion-bottom-leave-active {\n  transition: all 0.3s;\n}\n.ant-drawer-panel-motion-bottom-enter-start,\n.ant-drawer-panel-motion-bottom-appear-start {\n  transform: translateY(100%) !important;\n}\n.ant-drawer-panel-motion-bottom-enter-active,\n.ant-drawer-panel-motion-bottom-appear-active {\n  transform: translateY(0);\n}\n.ant-drawer-panel-motion-bottom-leave {\n  transform: translateY(0);\n}\n.ant-drawer-panel-motion-bottom-leave-active {\n  transform: translateY(100%);\n}\n.ant-drawer-rtl {\n  direction: rtl;\n}\n.ant-drawer-rtl .ant-drawer-close {\n  margin-right: 0;\n  margin-left: 12px;\n}\n.ant-dropdown-menu-item.ant-dropdown-menu-item-danger {\n  color: #f5222d;\n}\n.ant-dropdown-menu-item.ant-dropdown-menu-item-danger:hover {\n  color: #fff;\n  background-color: #f5222d;\n}\n.ant-dropdown {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  display: block;\n}\n.ant-dropdown::before {\n  position: absolute;\n  top: -4px;\n  right: 0;\n  bottom: -4px;\n  left: -7px;\n  z-index: -9999;\n  opacity: 0.0001;\n  content: ' ';\n}\n.ant-dropdown-wrap {\n  position: relative;\n}\n.ant-dropdown-wrap .ant-btn > .anticon-down {\n  font-size: 10px;\n}\n.ant-dropdown-wrap .anticon-down::before {\n  transition: transform 0.2s;\n}\n.ant-dropdown-wrap-open .anticon-down::before {\n  transform: rotate(180deg);\n}\n.ant-dropdown-hidden,\n.ant-dropdown-menu-hidden,\n.ant-dropdown-menu-submenu-hidden {\n  display: none;\n}\n.ant-dropdown-show-arrow.ant-dropdown-placement-topLeft,\n.ant-dropdown-show-arrow.ant-dropdown-placement-top,\n.ant-dropdown-show-arrow.ant-dropdown-placement-topRight {\n  padding-bottom: 15.3137085px;\n}\n.ant-dropdown-show-arrow.ant-dropdown-placement-bottomLeft,\n.ant-dropdown-show-arrow.ant-dropdown-placement-bottom,\n.ant-dropdown-show-arrow.ant-dropdown-placement-bottomRight {\n  padding-top: 15.3137085px;\n}\n.ant-dropdown-arrow {\n  position: absolute;\n  z-index: 1;\n  display: block;\n  width: 11.3137085px;\n  height: 11.3137085px;\n  border-radius: 0 0 2px;\n  pointer-events: none;\n}\n.ant-dropdown-arrow::before {\n  position: absolute;\n  top: -11.3137085px;\n  left: -11.3137085px;\n  width: 33.9411255px;\n  height: 33.9411255px;\n  background: #fff;\n  background-repeat: no-repeat;\n  background-position: -10px -10px;\n  content: '';\n  clip-path: inset(33% 33%);\n  clip-path: path('M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z');\n}\n.ant-dropdown-placement-top > .ant-dropdown-arrow,\n.ant-dropdown-placement-topLeft > .ant-dropdown-arrow,\n.ant-dropdown-placement-topRight > .ant-dropdown-arrow {\n  bottom: 10px;\n  box-shadow: 3px 3px 7px -3px rgba(0, 0, 0, 0.1);\n  transform: rotate(45deg);\n}\n.ant-dropdown-placement-top > .ant-dropdown-arrow {\n  left: 50%;\n  transform: translateX(-50%) rotate(45deg);\n}\n.ant-dropdown-placement-topLeft > .ant-dropdown-arrow {\n  left: 16px;\n}\n.ant-dropdown-placement-topRight > .ant-dropdown-arrow {\n  right: 16px;\n}\n.ant-dropdown-placement-bottom > .ant-dropdown-arrow,\n.ant-dropdown-placement-bottomLeft > .ant-dropdown-arrow,\n.ant-dropdown-placement-bottomRight > .ant-dropdown-arrow {\n  top: 9.41421356px;\n  box-shadow: 2px 2px 5px -2px rgba(0, 0, 0, 0.1);\n  transform: rotate(-135deg) translateY(-0.5px);\n}\n.ant-dropdown-placement-bottom > .ant-dropdown-arrow {\n  left: 50%;\n  transform: translateX(-50%) rotate(-135deg) translateY(-0.5px);\n}\n.ant-dropdown-placement-bottomLeft > .ant-dropdown-arrow {\n  left: 16px;\n}\n.ant-dropdown-placement-bottomRight > .ant-dropdown-arrow {\n  right: 16px;\n}\n.ant-dropdown-menu {\n  position: relative;\n  margin: 0;\n  padding: 4px 0;\n  text-align: left;\n  list-style-type: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n.ant-dropdown-menu-item-group-title {\n  padding: 5px 12px;\n  color: #595959;\n  transition: all 0.3s;\n}\n.ant-dropdown-menu-submenu-popup {\n  position: absolute;\n  z-index: 1050;\n  background: transparent;\n  box-shadow: none;\n  transform-origin: 0 0;\n}\n.ant-dropdown-menu-submenu-popup ul,\n.ant-dropdown-menu-submenu-popup li {\n  list-style: none;\n}\n.ant-dropdown-menu-submenu-popup ul {\n  margin-right: 0.3em;\n  margin-left: 0.3em;\n}\n.ant-dropdown-menu-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.ant-dropdown-menu-item-icon {\n  min-width: 12px;\n  margin-right: 8px;\n  font-size: 12px;\n}\n.ant-dropdown-menu-title-content {\n  flex: auto;\n}\n.ant-dropdown-menu-title-content > a {\n  color: inherit;\n  transition: all 0.3s;\n}\n.ant-dropdown-menu-title-content > a:hover {\n  color: inherit;\n}\n.ant-dropdown-menu-title-content > a::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  content: '';\n}\n.ant-dropdown-menu-item,\n.ant-dropdown-menu-submenu-title {\n  clear: both;\n  margin: 0;\n  padding: 5px 12px;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-submenu-title-selected {\n  color: #351a55;\n  background-color: #908b94;\n}\n.ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-submenu-title:hover,\n.ant-dropdown-menu-item.ant-dropdown-menu-item-active,\n.ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-active,\n.ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-active,\n.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-active {\n  background-color: #f5f5f5;\n}\n.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled,\n.ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled,\n.ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled,\n.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover,\n.ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled:hover,\n.ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled:hover,\n.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled a,\n.ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled a,\n.ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled a,\n.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled a {\n  pointer-events: none;\n}\n.ant-dropdown-menu-item-divider,\n.ant-dropdown-menu-submenu-title-divider {\n  height: 1px;\n  margin: 4px 0;\n  overflow: hidden;\n  line-height: 0;\n  background-color: #e8e8e8;\n}\n.ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon,\n.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon {\n  position: absolute;\n  right: 8px;\n}\n.ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon,\n.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon {\n  margin-right: 0 !important;\n  color: #595959;\n  font-size: 10px;\n  font-style: normal;\n}\n.ant-dropdown-menu-item-group-list {\n  margin: 0 8px;\n  padding: 0;\n  list-style: none;\n}\n.ant-dropdown-menu-submenu-title {\n  padding-right: 24px;\n}\n.ant-dropdown-menu-submenu-vertical {\n  position: relative;\n}\n.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  min-width: 100%;\n  margin-left: 4px;\n  transform-origin: 0 0;\n}\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-submenu-selected .ant-dropdown-menu-submenu-title {\n  color: #351a55;\n}\n.ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottom,\n.ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottom,\n.ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottomRight,\n.ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-top,\n.ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-top,\n.ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-topRight,\n.ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottom,\n.ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-top,\n.ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-dropdown-trigger > .anticon.anticon-down,\n.ant-dropdown-link > .anticon.anticon-down,\n.ant-dropdown-button > .anticon.anticon-down {\n  font-size: 10px;\n  vertical-align: baseline;\n}\n.ant-dropdown-button {\n  white-space: nowrap;\n}\n.ant-dropdown-button.ant-btn-group > .ant-btn-loading,\n.ant-dropdown-button.ant-btn-group > .ant-btn-loading + .ant-btn {\n  cursor: default;\n  pointer-events: none;\n}\n.ant-dropdown-button.ant-btn-group > .ant-btn-loading + .ant-btn::before {\n  display: block;\n}\n.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child):not(.ant-btn-icon-only) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-dropdown-menu-dark,\n.ant-dropdown-menu-dark .ant-dropdown-menu {\n  background: var(--app-primary-color);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a {\n  color: rgba(255, 255, 255, 0.65);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow::after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow::after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a .ant-dropdown-menu-submenu-arrow::after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a .ant-dropdown-menu-submenu-arrow::after {\n  color: rgba(255, 255, 255, 0.65);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a:hover {\n  color: #fff;\n  background: transparent;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {\n  color: #fff;\n  background: #351a55;\n}\n.ant-dropdown-rtl {\n  direction: rtl;\n}\n.ant-dropdown-rtl.ant-dropdown::before {\n  right: -7px;\n  left: 0;\n}\n.ant-dropdown-menu.ant-dropdown-menu-rtl {\n  direction: rtl;\n  text-align: right;\n}\n.ant-dropdown-rtl .ant-dropdown-menu-item-group-title,\n.ant-dropdown-menu-submenu-rtl .ant-dropdown-menu-item-group-title {\n  direction: rtl;\n  text-align: right;\n}\n.ant-dropdown-menu-submenu-popup.ant-dropdown-menu-submenu-rtl {\n  transform-origin: 100% 0;\n}\n.ant-dropdown-rtl .ant-dropdown-menu-submenu-popup ul,\n.ant-dropdown-rtl .ant-dropdown-menu-submenu-popup li {\n  text-align: right;\n}\n.ant-dropdown-rtl .ant-dropdown-menu-item,\n.ant-dropdown-rtl .ant-dropdown-menu-submenu-title {\n  text-align: right;\n}\n.ant-dropdown-rtl .ant-dropdown-menu-item > .anticon:first-child,\n.ant-dropdown-rtl .ant-dropdown-menu-submenu-title > .anticon:first-child,\n.ant-dropdown-rtl .ant-dropdown-menu-item > span > .anticon:first-child,\n.ant-dropdown-rtl .ant-dropdown-menu-submenu-title > span > .anticon:first-child {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-dropdown-rtl .ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon,\n.ant-dropdown-rtl .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon {\n  right: auto;\n  left: 8px;\n}\n.ant-dropdown-rtl .ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon,\n.ant-dropdown-rtl .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon {\n  margin-left: 0 !important;\n  transform: scaleX(-1);\n}\n.ant-dropdown-rtl .ant-dropdown-menu-submenu-title {\n  padding-right: 12px;\n  padding-left: 24px;\n}\n.ant-dropdown-rtl .ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {\n  right: 100%;\n  left: 0;\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-empty {\n  margin: 0 8px;\n  font-size: 14px;\n  line-height: 1.3;\n  text-align: center;\n}\n.ant-empty-image {\n  height: 100px;\n  margin-bottom: 8px;\n}\n.ant-empty-image img {\n  height: 100%;\n}\n.ant-empty-image svg {\n  height: 100%;\n  margin: auto;\n}\n.ant-empty-footer {\n  margin-top: 16px;\n}\n.ant-empty-normal {\n  margin: 32px 0;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-empty-normal .ant-empty-image {\n  height: 40px;\n}\n.ant-empty-small {\n  margin: 8px 0;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-empty-small .ant-empty-image {\n  height: 35px;\n}\n.ant-empty-img-default-ellipse {\n  fill: #f5f5f5;\n  fill-opacity: 0.8;\n}\n.ant-empty-img-default-path-1 {\n  fill: #aeb8c2;\n}\n.ant-empty-img-default-path-2 {\n  fill: url('#linearGradient-1');\n}\n.ant-empty-img-default-path-3 {\n  fill: #f5f5f7;\n}\n.ant-empty-img-default-path-4 {\n  fill: #dce0e6;\n}\n.ant-empty-img-default-path-5 {\n  fill: #dce0e6;\n}\n.ant-empty-img-default-g {\n  fill: #fff;\n}\n.ant-empty-img-simple-ellipse {\n  fill: #f5f5f5;\n}\n.ant-empty-img-simple-g {\n  stroke: #d9d9d9;\n}\n.ant-empty-img-simple-path {\n  fill: #fafafa;\n}\n.ant-empty-rtl {\n  direction: rtl;\n}\n.ant-form-item .ant-input-number + .ant-form-text {\n  margin-left: 8px;\n}\n.ant-form-inline {\n  display: flex;\n  flex-wrap: wrap;\n}\n.ant-form-inline .ant-form-item {\n  flex: none;\n  flex-wrap: nowrap;\n  margin-right: 16px;\n  margin-bottom: 0;\n}\n.ant-form-inline .ant-form-item-with-help {\n  margin-bottom: 20px;\n}\n.ant-form-inline .ant-form-item > .ant-form-item-label,\n.ant-form-inline .ant-form-item > .ant-form-item-control {\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-form-inline .ant-form-item > .ant-form-item-label {\n  flex: none;\n}\n.ant-form-inline .ant-form-item .ant-form-text {\n  display: inline-block;\n}\n.ant-form-inline .ant-form-item .ant-form-item-has-feedback {\n  display: inline-block;\n}\n.ant-form-horizontal .ant-form-item-label {\n  flex-grow: 0;\n}\n.ant-form-horizontal .ant-form-item-control {\n  flex: 1 1 0;\n  min-width: 0;\n}\n.ant-form-horizontal .ant-form-item-label[class$='-24'] + .ant-form-item-control,\n.ant-form-horizontal .ant-form-item-label[class*='-24 '] + .ant-form-item-control {\n  min-width: unset;\n}\n.ant-form-vertical .ant-form-item-row {\n  flex-direction: column;\n}\n.ant-form-vertical .ant-form-item-label > label {\n  height: auto;\n}\n.ant-form-vertical .ant-form-item .ant-form-item-control {\n  width: 100%;\n}\n.ant-form-vertical .ant-form-item-label,\n.ant-col-24.ant-form-item-label,\n.ant-col-xl-24.ant-form-item-label {\n  padding: 0 0 8px;\n  line-height: 1.3;\n  white-space: initial;\n  text-align: left;\n}\n.ant-form-vertical .ant-form-item-label > label,\n.ant-col-24.ant-form-item-label > label,\n.ant-col-xl-24.ant-form-item-label > label {\n  margin: 0;\n}\n.ant-form-vertical .ant-form-item-label > label::after,\n.ant-col-24.ant-form-item-label > label::after,\n.ant-col-xl-24.ant-form-item-label > label::after {\n  display: none;\n}\n.ant-form-rtl.ant-form-vertical .ant-form-item-label,\n.ant-form-rtl.ant-col-24.ant-form-item-label,\n.ant-form-rtl.ant-col-xl-24.ant-form-item-label {\n  text-align: right;\n}\n@media (max-width: 575px) {\n  .ant-form-item .ant-form-item-label {\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-form-item .ant-form-item-label > label {\n    margin: 0;\n  }\n  .ant-form-item .ant-form-item-label > label::after {\n    display: none;\n  }\n  .ant-form-rtl.ant-form-item .ant-form-item-label {\n    text-align: right;\n  }\n  .ant-form .ant-form-item {\n    flex-wrap: wrap;\n  }\n  .ant-form .ant-form-item .ant-form-item-label,\n  .ant-form .ant-form-item .ant-form-item-control {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .ant-col-xs-24.ant-form-item-label {\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-xs-24.ant-form-item-label > label {\n    margin: 0;\n  }\n  .ant-col-xs-24.ant-form-item-label > label::after {\n    display: none;\n  }\n  .ant-form-rtl.ant-col-xs-24.ant-form-item-label {\n    text-align: right;\n  }\n}\n@media (max-width: 767px) {\n  .ant-col-sm-24.ant-form-item-label {\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-sm-24.ant-form-item-label > label {\n    margin: 0;\n  }\n  .ant-col-sm-24.ant-form-item-label > label::after {\n    display: none;\n  }\n  .ant-form-rtl.ant-col-sm-24.ant-form-item-label {\n    text-align: right;\n  }\n}\n@media (max-width: 991px) {\n  .ant-col-md-24.ant-form-item-label {\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-md-24.ant-form-item-label > label {\n    margin: 0;\n  }\n  .ant-col-md-24.ant-form-item-label > label::after {\n    display: none;\n  }\n  .ant-form-rtl.ant-col-md-24.ant-form-item-label {\n    text-align: right;\n  }\n}\n@media (max-width: 1199px) {\n  .ant-col-lg-24.ant-form-item-label {\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-lg-24.ant-form-item-label > label {\n    margin: 0;\n  }\n  .ant-col-lg-24.ant-form-item-label > label::after {\n    display: none;\n  }\n  .ant-form-rtl.ant-col-lg-24.ant-form-item-label {\n    text-align: right;\n  }\n}\n@media (max-width: 1599px) {\n  .ant-col-xl-24.ant-form-item-label {\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-xl-24.ant-form-item-label > label {\n    margin: 0;\n  }\n  .ant-col-xl-24.ant-form-item-label > label::after {\n    display: none;\n  }\n  .ant-form-rtl.ant-col-xl-24.ant-form-item-label {\n    text-align: right;\n  }\n}\n.ant-form-item {\n  /* Some non-status related component style is in `components.less` */\n  /* To support leave along ErrorList. We add additional className to handle explain style */\n}\n.ant-form-item-explain-error {\n  color: #f5222d;\n}\n.ant-form-item-explain-warning {\n  color: #fa8c16;\n}\n.ant-form-item-has-feedback .ant-switch {\n  margin: 2px 0 4px;\n}\n.ant-form-item-has-warning .ant-form-item-split {\n  color: #fa8c16;\n}\n.ant-form-item-has-error .ant-form-item-split {\n  color: #f5222d;\n}\n.ant-form {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-form legend {\n  display: block;\n  width: 100%;\n  margin-bottom: 20px;\n  padding: 0;\n  color: #595959;\n  font-size: 16px;\n  line-height: inherit;\n  border: 0;\n  border-bottom: 1px solid #d9d9d9;\n}\n.ant-form label {\n  font-size: 14px;\n}\n.ant-form input[type='search'] {\n  box-sizing: border-box;\n}\n.ant-form input[type='radio'],\n.ant-form input[type='checkbox'] {\n  line-height: normal;\n}\n.ant-form input[type='file'] {\n  display: block;\n}\n.ant-form input[type='range'] {\n  display: block;\n  width: 100%;\n}\n.ant-form select[multiple],\n.ant-form select[size] {\n  height: auto;\n}\n.ant-form input[type='file']:focus,\n.ant-form input[type='radio']:focus,\n.ant-form input[type='checkbox']:focus {\n  outline: thin dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n.ant-form output {\n  display: block;\n  padding-top: 15px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n}\n.ant-form .ant-form-text {\n  display: inline-block;\n  padding-right: 8px;\n}\n.ant-form-small .ant-form-item-label > label {\n  height: 24px;\n}\n.ant-form-small .ant-form-item-control-input {\n  min-height: 24px;\n}\n.ant-form-large .ant-form-item-label > label {\n  height: 40px;\n}\n.ant-form-large .ant-form-item-control-input {\n  min-height: 40px;\n}\n.ant-form-item {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  margin-bottom: 20px;\n  vertical-align: top;\n}\n.ant-form-item-with-help {\n  transition: none;\n}\n.ant-form-item-hidden,\n.ant-form-item-hidden.ant-row {\n  display: none;\n}\n.ant-form-item-label {\n  display: inline-block;\n  flex-grow: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-align: right;\n  vertical-align: middle;\n}\n.ant-form-item-label-left {\n  text-align: left;\n}\n.ant-form-item-label-wrap {\n  overflow: unset;\n  line-height: 1.05em;\n  white-space: unset;\n}\n.ant-form-item-label > label {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  height: 36px;\n  color: #535353;\n  font-size: 14px;\n}\n.ant-form-item-label > label > .anticon {\n  font-size: 14px;\n  vertical-align: top;\n}\n.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n  display: inline-block;\n  margin-right: 4px;\n  color: #f5222d;\n  font-size: 14px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: '*';\n}\n.ant-form-hide-required-mark .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n  display: none;\n}\n.ant-form-item-label > label .ant-form-item-optional {\n  display: inline-block;\n  margin-left: 4px;\n  color: #595959;\n}\n.ant-form-hide-required-mark .ant-form-item-label > label .ant-form-item-optional {\n  display: none;\n}\n.ant-form-item-label > label .ant-form-item-tooltip {\n  color: #595959;\n  cursor: help;\n  writing-mode: horizontal-tb;\n  margin-inline-start: 4px;\n}\n.ant-form-item-label > label::after {\n  content: ':';\n  position: relative;\n  top: -0.5px;\n  margin: 0 8px 0 2px;\n}\n.ant-form-item-label > label.ant-form-item-no-colon::after {\n  content: ' ';\n}\n.ant-form-item-control {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n.ant-form-item-control:first-child:not([class^='ant-col-']):not([class*=' ant-col-']) {\n  width: 100%;\n}\n.ant-form-item-control-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-height: 36px;\n}\n.ant-form-item-control-input-content {\n  flex: auto;\n  max-width: 100%;\n}\n.ant-form-item-explain,\n.ant-form-item-extra {\n  clear: both;\n  color: #595959;\n  font-size: 14px;\n  line-height: 1.3;\n  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n.ant-form-item-explain-connected {\n  width: 100%;\n}\n.ant-form-item-extra {\n  min-height: 20px;\n}\n.ant-form-item-with-help .ant-form-item-explain {\n  height: auto;\n  opacity: 1;\n}\n.ant-form-item-feedback-icon {\n  font-size: 14px;\n  text-align: center;\n  visibility: visible;\n  animation: zoomIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  pointer-events: none;\n}\n.ant-form-item-feedback-icon-success {\n  color: #52c41a;\n}\n.ant-form-item-feedback-icon-error {\n  color: #f5222d;\n}\n.ant-form-item-feedback-icon-warning {\n  color: #fa8c16;\n}\n.ant-form-item-feedback-icon-validating {\n  color: #351a55;\n}\n.ant-show-help {\n  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-show-help-appear,\n.ant-show-help-enter {\n  opacity: 0;\n}\n.ant-show-help-appear-active,\n.ant-show-help-enter-active {\n  opacity: 1;\n}\n.ant-show-help-leave {\n  opacity: 1;\n}\n.ant-show-help-leave-active {\n  opacity: 0;\n}\n.ant-show-help-item {\n  overflow: hidden;\n  transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.ant-show-help-item-appear,\n.ant-show-help-item-enter {\n  transform: translateY(-5px);\n  opacity: 0;\n}\n.ant-show-help-item-appear-active,\n.ant-show-help-item-enter-active {\n  transform: translateY(0);\n  opacity: 1;\n}\n.ant-show-help-item-leave {\n  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.ant-show-help-item-leave-active {\n  transform: translateY(-5px);\n}\n@keyframes diffZoomIn1 {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes diffZoomIn2 {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes diffZoomIn3 {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.ant-form-rtl {\n  direction: rtl;\n}\n.ant-form-rtl .ant-form-item-label {\n  text-align: left;\n}\n.ant-form-rtl .ant-form-item-label > label.ant-form-item-required::before {\n  margin-right: 0;\n  margin-left: 4px;\n}\n.ant-form-rtl .ant-form-item-label > label::after {\n  margin: 0 2px 0 8px;\n}\n.ant-form-rtl .ant-form-item-label > label .ant-form-item-optional {\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-col-rtl .ant-form-item-control:first-child {\n  width: 100%;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-input {\n  padding-right: 11px;\n  padding-left: 24px;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-input-affix-wrapper .ant-input-suffix {\n  padding-right: 11px;\n  padding-left: 18px;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-input-affix-wrapper .ant-input {\n  padding: 0;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-input-number-affix-wrapper .ant-input-number {\n  padding: 0;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-input-search:not(.ant-input-search-enter-button) .ant-input-suffix {\n  right: auto;\n  left: 28px;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-input-number {\n  padding-left: 18px;\n}\n.ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-arrow,\n.ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-clear,\n.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow,\n.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-clear,\n.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-arrow,\n.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-clear {\n  right: auto;\n  left: 32px;\n}\n.ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-selection-selected-value,\n.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection-selected-value,\n.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-selection-selected-value {\n  padding-right: 0;\n  padding-left: 42px;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-cascader-picker-arrow {\n  margin-right: 0;\n  margin-left: 19px;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-cascader-picker-clear {\n  right: auto;\n  left: 32px;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-picker {\n  padding-right: 11px;\n  padding-left: 29.2px;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-picker-large {\n  padding-right: 11px;\n  padding-left: 29.2px;\n}\n.ant-form-rtl .ant-form-item-has-feedback .ant-picker-small {\n  padding-right: 7px;\n  padding-left: 25.2px;\n}\n.ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-success .ant-form-item-children-icon,\n.ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-warning .ant-form-item-children-icon,\n.ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-error .ant-form-item-children-icon,\n.ant-form-rtl .ant-form-item-has-feedback.ant-form-item-is-validating .ant-form-item-children-icon {\n  right: auto;\n  left: 0;\n}\n.ant-form-rtl.ant-form-inline .ant-form-item {\n  margin-right: 0;\n  margin-left: 16px;\n}\n.ant-row {\n  display: flex;\n  flex-flow: row wrap;\n  min-width: 0;\n}\n.ant-row::before,\n.ant-row::after {\n  display: flex;\n}\n.ant-row-no-wrap {\n  flex-wrap: nowrap;\n}\n.ant-row-start {\n  justify-content: flex-start;\n}\n.ant-row-center {\n  justify-content: center;\n}\n.ant-row-end {\n  justify-content: flex-end;\n}\n.ant-row-space-between {\n  justify-content: space-between;\n}\n.ant-row-space-around {\n  justify-content: space-around;\n}\n.ant-row-space-evenly {\n  justify-content: space-evenly;\n}\n.ant-row-top {\n  align-items: flex-start;\n}\n.ant-row-middle {\n  align-items: center;\n}\n.ant-row-bottom {\n  align-items: flex-end;\n}\n.ant-col {\n  position: relative;\n  max-width: 100%;\n  min-height: 1px;\n}\n.ant-col-24 {\n  display: block;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n.ant-col-push-24 {\n  left: 100%;\n}\n.ant-col-pull-24 {\n  right: 100%;\n}\n.ant-col-offset-24 {\n  margin-left: 100%;\n}\n.ant-col-order-24 {\n  order: 24;\n}\n.ant-col-23 {\n  display: block;\n  flex: 0 0 95.83333333%;\n  max-width: 95.83333333%;\n}\n.ant-col-push-23 {\n  left: 95.83333333%;\n}\n.ant-col-pull-23 {\n  right: 95.83333333%;\n}\n.ant-col-offset-23 {\n  margin-left: 95.83333333%;\n}\n.ant-col-order-23 {\n  order: 23;\n}\n.ant-col-22 {\n  display: block;\n  flex: 0 0 91.66666667%;\n  max-width: 91.66666667%;\n}\n.ant-col-push-22 {\n  left: 91.66666667%;\n}\n.ant-col-pull-22 {\n  right: 91.66666667%;\n}\n.ant-col-offset-22 {\n  margin-left: 91.66666667%;\n}\n.ant-col-order-22 {\n  order: 22;\n}\n.ant-col-21 {\n  display: block;\n  flex: 0 0 87.5%;\n  max-width: 87.5%;\n}\n.ant-col-push-21 {\n  left: 87.5%;\n}\n.ant-col-pull-21 {\n  right: 87.5%;\n}\n.ant-col-offset-21 {\n  margin-left: 87.5%;\n}\n.ant-col-order-21 {\n  order: 21;\n}\n.ant-col-20 {\n  display: block;\n  flex: 0 0 83.33333333%;\n  max-width: 83.33333333%;\n}\n.ant-col-push-20 {\n  left: 83.33333333%;\n}\n.ant-col-pull-20 {\n  right: 83.33333333%;\n}\n.ant-col-offset-20 {\n  margin-left: 83.33333333%;\n}\n.ant-col-order-20 {\n  order: 20;\n}\n.ant-col-19 {\n  display: block;\n  flex: 0 0 79.16666667%;\n  max-width: 79.16666667%;\n}\n.ant-col-push-19 {\n  left: 79.16666667%;\n}\n.ant-col-pull-19 {\n  right: 79.16666667%;\n}\n.ant-col-offset-19 {\n  margin-left: 79.16666667%;\n}\n.ant-col-order-19 {\n  order: 19;\n}\n.ant-col-18 {\n  display: block;\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n.ant-col-push-18 {\n  left: 75%;\n}\n.ant-col-pull-18 {\n  right: 75%;\n}\n.ant-col-offset-18 {\n  margin-left: 75%;\n}\n.ant-col-order-18 {\n  order: 18;\n}\n.ant-col-17 {\n  display: block;\n  flex: 0 0 70.83333333%;\n  max-width: 70.83333333%;\n}\n.ant-col-push-17 {\n  left: 70.83333333%;\n}\n.ant-col-pull-17 {\n  right: 70.83333333%;\n}\n.ant-col-offset-17 {\n  margin-left: 70.83333333%;\n}\n.ant-col-order-17 {\n  order: 17;\n}\n.ant-col-16 {\n  display: block;\n  flex: 0 0 66.66666667%;\n  max-width: 66.66666667%;\n}\n.ant-col-push-16 {\n  left: 66.66666667%;\n}\n.ant-col-pull-16 {\n  right: 66.66666667%;\n}\n.ant-col-offset-16 {\n  margin-left: 66.66666667%;\n}\n.ant-col-order-16 {\n  order: 16;\n}\n.ant-col-15 {\n  display: block;\n  flex: 0 0 62.5%;\n  max-width: 62.5%;\n}\n.ant-col-push-15 {\n  left: 62.5%;\n}\n.ant-col-pull-15 {\n  right: 62.5%;\n}\n.ant-col-offset-15 {\n  margin-left: 62.5%;\n}\n.ant-col-order-15 {\n  order: 15;\n}\n.ant-col-14 {\n  display: block;\n  flex: 0 0 58.33333333%;\n  max-width: 58.33333333%;\n}\n.ant-col-push-14 {\n  left: 58.33333333%;\n}\n.ant-col-pull-14 {\n  right: 58.33333333%;\n}\n.ant-col-offset-14 {\n  margin-left: 58.33333333%;\n}\n.ant-col-order-14 {\n  order: 14;\n}\n.ant-col-13 {\n  display: block;\n  flex: 0 0 54.16666667%;\n  max-width: 54.16666667%;\n}\n.ant-col-push-13 {\n  left: 54.16666667%;\n}\n.ant-col-pull-13 {\n  right: 54.16666667%;\n}\n.ant-col-offset-13 {\n  margin-left: 54.16666667%;\n}\n.ant-col-order-13 {\n  order: 13;\n}\n.ant-col-12 {\n  display: block;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n.ant-col-push-12 {\n  left: 50%;\n}\n.ant-col-pull-12 {\n  right: 50%;\n}\n.ant-col-offset-12 {\n  margin-left: 50%;\n}\n.ant-col-order-12 {\n  order: 12;\n}\n.ant-col-11 {\n  display: block;\n  flex: 0 0 45.83333333%;\n  max-width: 45.83333333%;\n}\n.ant-col-push-11 {\n  left: 45.83333333%;\n}\n.ant-col-pull-11 {\n  right: 45.83333333%;\n}\n.ant-col-offset-11 {\n  margin-left: 45.83333333%;\n}\n.ant-col-order-11 {\n  order: 11;\n}\n.ant-col-10 {\n  display: block;\n  flex: 0 0 41.66666667%;\n  max-width: 41.66666667%;\n}\n.ant-col-push-10 {\n  left: 41.66666667%;\n}\n.ant-col-pull-10 {\n  right: 41.66666667%;\n}\n.ant-col-offset-10 {\n  margin-left: 41.66666667%;\n}\n.ant-col-order-10 {\n  order: 10;\n}\n.ant-col-9 {\n  display: block;\n  flex: 0 0 37.5%;\n  max-width: 37.5%;\n}\n.ant-col-push-9 {\n  left: 37.5%;\n}\n.ant-col-pull-9 {\n  right: 37.5%;\n}\n.ant-col-offset-9 {\n  margin-left: 37.5%;\n}\n.ant-col-order-9 {\n  order: 9;\n}\n.ant-col-8 {\n  display: block;\n  flex: 0 0 33.33333333%;\n  max-width: 33.33333333%;\n}\n.ant-col-push-8 {\n  left: 33.33333333%;\n}\n.ant-col-pull-8 {\n  right: 33.33333333%;\n}\n.ant-col-offset-8 {\n  margin-left: 33.33333333%;\n}\n.ant-col-order-8 {\n  order: 8;\n}\n.ant-col-7 {\n  display: block;\n  flex: 0 0 29.16666667%;\n  max-width: 29.16666667%;\n}\n.ant-col-push-7 {\n  left: 29.16666667%;\n}\n.ant-col-pull-7 {\n  right: 29.16666667%;\n}\n.ant-col-offset-7 {\n  margin-left: 29.16666667%;\n}\n.ant-col-order-7 {\n  order: 7;\n}\n.ant-col-6 {\n  display: block;\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n.ant-col-push-6 {\n  left: 25%;\n}\n.ant-col-pull-6 {\n  right: 25%;\n}\n.ant-col-offset-6 {\n  margin-left: 25%;\n}\n.ant-col-order-6 {\n  order: 6;\n}\n.ant-col-5 {\n  display: block;\n  flex: 0 0 20.83333333%;\n  max-width: 20.83333333%;\n}\n.ant-col-push-5 {\n  left: 20.83333333%;\n}\n.ant-col-pull-5 {\n  right: 20.83333333%;\n}\n.ant-col-offset-5 {\n  margin-left: 20.83333333%;\n}\n.ant-col-order-5 {\n  order: 5;\n}\n.ant-col-4 {\n  display: block;\n  flex: 0 0 16.66666667%;\n  max-width: 16.66666667%;\n}\n.ant-col-push-4 {\n  left: 16.66666667%;\n}\n.ant-col-pull-4 {\n  right: 16.66666667%;\n}\n.ant-col-offset-4 {\n  margin-left: 16.66666667%;\n}\n.ant-col-order-4 {\n  order: 4;\n}\n.ant-col-3 {\n  display: block;\n  flex: 0 0 12.5%;\n  max-width: 12.5%;\n}\n.ant-col-push-3 {\n  left: 12.5%;\n}\n.ant-col-pull-3 {\n  right: 12.5%;\n}\n.ant-col-offset-3 {\n  margin-left: 12.5%;\n}\n.ant-col-order-3 {\n  order: 3;\n}\n.ant-col-2 {\n  display: block;\n  flex: 0 0 8.33333333%;\n  max-width: 8.33333333%;\n}\n.ant-col-push-2 {\n  left: 8.33333333%;\n}\n.ant-col-pull-2 {\n  right: 8.33333333%;\n}\n.ant-col-offset-2 {\n  margin-left: 8.33333333%;\n}\n.ant-col-order-2 {\n  order: 2;\n}\n.ant-col-1 {\n  display: block;\n  flex: 0 0 4.16666667%;\n  max-width: 4.16666667%;\n}\n.ant-col-push-1 {\n  left: 4.16666667%;\n}\n.ant-col-pull-1 {\n  right: 4.16666667%;\n}\n.ant-col-offset-1 {\n  margin-left: 4.16666667%;\n}\n.ant-col-order-1 {\n  order: 1;\n}\n.ant-col-0 {\n  display: none;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-offset-0 {\n  margin-left: 0;\n}\n.ant-col-order-0 {\n  order: 0;\n}\n.ant-col-push-0.ant-col-rtl {\n  right: auto;\n}\n.ant-col-pull-0.ant-col-rtl {\n  left: auto;\n}\n.ant-col-push-0.ant-col-rtl {\n  right: auto;\n}\n.ant-col-pull-0.ant-col-rtl {\n  left: auto;\n}\n.ant-col-offset-0.ant-col-rtl {\n  margin-right: 0;\n}\n.ant-col-push-1.ant-col-rtl {\n  right: 4.16666667%;\n  left: auto;\n}\n.ant-col-pull-1.ant-col-rtl {\n  right: auto;\n  left: 4.16666667%;\n}\n.ant-col-offset-1.ant-col-rtl {\n  margin-right: 4.16666667%;\n  margin-left: 0;\n}\n.ant-col-push-2.ant-col-rtl {\n  right: 8.33333333%;\n  left: auto;\n}\n.ant-col-pull-2.ant-col-rtl {\n  right: auto;\n  left: 8.33333333%;\n}\n.ant-col-offset-2.ant-col-rtl {\n  margin-right: 8.33333333%;\n  margin-left: 0;\n}\n.ant-col-push-3.ant-col-rtl {\n  right: 12.5%;\n  left: auto;\n}\n.ant-col-pull-3.ant-col-rtl {\n  right: auto;\n  left: 12.5%;\n}\n.ant-col-offset-3.ant-col-rtl {\n  margin-right: 12.5%;\n  margin-left: 0;\n}\n.ant-col-push-4.ant-col-rtl {\n  right: 16.66666667%;\n  left: auto;\n}\n.ant-col-pull-4.ant-col-rtl {\n  right: auto;\n  left: 16.66666667%;\n}\n.ant-col-offset-4.ant-col-rtl {\n  margin-right: 16.66666667%;\n  margin-left: 0;\n}\n.ant-col-push-5.ant-col-rtl {\n  right: 20.83333333%;\n  left: auto;\n}\n.ant-col-pull-5.ant-col-rtl {\n  right: auto;\n  left: 20.83333333%;\n}\n.ant-col-offset-5.ant-col-rtl {\n  margin-right: 20.83333333%;\n  margin-left: 0;\n}\n.ant-col-push-6.ant-col-rtl {\n  right: 25%;\n  left: auto;\n}\n.ant-col-pull-6.ant-col-rtl {\n  right: auto;\n  left: 25%;\n}\n.ant-col-offset-6.ant-col-rtl {\n  margin-right: 25%;\n  margin-left: 0;\n}\n.ant-col-push-7.ant-col-rtl {\n  right: 29.16666667%;\n  left: auto;\n}\n.ant-col-pull-7.ant-col-rtl {\n  right: auto;\n  left: 29.16666667%;\n}\n.ant-col-offset-7.ant-col-rtl {\n  margin-right: 29.16666667%;\n  margin-left: 0;\n}\n.ant-col-push-8.ant-col-rtl {\n  right: 33.33333333%;\n  left: auto;\n}\n.ant-col-pull-8.ant-col-rtl {\n  right: auto;\n  left: 33.33333333%;\n}\n.ant-col-offset-8.ant-col-rtl {\n  margin-right: 33.33333333%;\n  margin-left: 0;\n}\n.ant-col-push-9.ant-col-rtl {\n  right: 37.5%;\n  left: auto;\n}\n.ant-col-pull-9.ant-col-rtl {\n  right: auto;\n  left: 37.5%;\n}\n.ant-col-offset-9.ant-col-rtl {\n  margin-right: 37.5%;\n  margin-left: 0;\n}\n.ant-col-push-10.ant-col-rtl {\n  right: 41.66666667%;\n  left: auto;\n}\n.ant-col-pull-10.ant-col-rtl {\n  right: auto;\n  left: 41.66666667%;\n}\n.ant-col-offset-10.ant-col-rtl {\n  margin-right: 41.66666667%;\n  margin-left: 0;\n}\n.ant-col-push-11.ant-col-rtl {\n  right: 45.83333333%;\n  left: auto;\n}\n.ant-col-pull-11.ant-col-rtl {\n  right: auto;\n  left: 45.83333333%;\n}\n.ant-col-offset-11.ant-col-rtl {\n  margin-right: 45.83333333%;\n  margin-left: 0;\n}\n.ant-col-push-12.ant-col-rtl {\n  right: 50%;\n  left: auto;\n}\n.ant-col-pull-12.ant-col-rtl {\n  right: auto;\n  left: 50%;\n}\n.ant-col-offset-12.ant-col-rtl {\n  margin-right: 50%;\n  margin-left: 0;\n}\n.ant-col-push-13.ant-col-rtl {\n  right: 54.16666667%;\n  left: auto;\n}\n.ant-col-pull-13.ant-col-rtl {\n  right: auto;\n  left: 54.16666667%;\n}\n.ant-col-offset-13.ant-col-rtl {\n  margin-right: 54.16666667%;\n  margin-left: 0;\n}\n.ant-col-push-14.ant-col-rtl {\n  right: 58.33333333%;\n  left: auto;\n}\n.ant-col-pull-14.ant-col-rtl {\n  right: auto;\n  left: 58.33333333%;\n}\n.ant-col-offset-14.ant-col-rtl {\n  margin-right: 58.33333333%;\n  margin-left: 0;\n}\n.ant-col-push-15.ant-col-rtl {\n  right: 62.5%;\n  left: auto;\n}\n.ant-col-pull-15.ant-col-rtl {\n  right: auto;\n  left: 62.5%;\n}\n.ant-col-offset-15.ant-col-rtl {\n  margin-right: 62.5%;\n  margin-left: 0;\n}\n.ant-col-push-16.ant-col-rtl {\n  right: 66.66666667%;\n  left: auto;\n}\n.ant-col-pull-16.ant-col-rtl {\n  right: auto;\n  left: 66.66666667%;\n}\n.ant-col-offset-16.ant-col-rtl {\n  margin-right: 66.66666667%;\n  margin-left: 0;\n}\n.ant-col-push-17.ant-col-rtl {\n  right: 70.83333333%;\n  left: auto;\n}\n.ant-col-pull-17.ant-col-rtl {\n  right: auto;\n  left: 70.83333333%;\n}\n.ant-col-offset-17.ant-col-rtl {\n  margin-right: 70.83333333%;\n  margin-left: 0;\n}\n.ant-col-push-18.ant-col-rtl {\n  right: 75%;\n  left: auto;\n}\n.ant-col-pull-18.ant-col-rtl {\n  right: auto;\n  left: 75%;\n}\n.ant-col-offset-18.ant-col-rtl {\n  margin-right: 75%;\n  margin-left: 0;\n}\n.ant-col-push-19.ant-col-rtl {\n  right: 79.16666667%;\n  left: auto;\n}\n.ant-col-pull-19.ant-col-rtl {\n  right: auto;\n  left: 79.16666667%;\n}\n.ant-col-offset-19.ant-col-rtl {\n  margin-right: 79.16666667%;\n  margin-left: 0;\n}\n.ant-col-push-20.ant-col-rtl {\n  right: 83.33333333%;\n  left: auto;\n}\n.ant-col-pull-20.ant-col-rtl {\n  right: auto;\n  left: 83.33333333%;\n}\n.ant-col-offset-20.ant-col-rtl {\n  margin-right: 83.33333333%;\n  margin-left: 0;\n}\n.ant-col-push-21.ant-col-rtl {\n  right: 87.5%;\n  left: auto;\n}\n.ant-col-pull-21.ant-col-rtl {\n  right: auto;\n  left: 87.5%;\n}\n.ant-col-offset-21.ant-col-rtl {\n  margin-right: 87.5%;\n  margin-left: 0;\n}\n.ant-col-push-22.ant-col-rtl {\n  right: 91.66666667%;\n  left: auto;\n}\n.ant-col-pull-22.ant-col-rtl {\n  right: auto;\n  left: 91.66666667%;\n}\n.ant-col-offset-22.ant-col-rtl {\n  margin-right: 91.66666667%;\n  margin-left: 0;\n}\n.ant-col-push-23.ant-col-rtl {\n  right: 95.83333333%;\n  left: auto;\n}\n.ant-col-pull-23.ant-col-rtl {\n  right: auto;\n  left: 95.83333333%;\n}\n.ant-col-offset-23.ant-col-rtl {\n  margin-right: 95.83333333%;\n  margin-left: 0;\n}\n.ant-col-push-24.ant-col-rtl {\n  right: 100%;\n  left: auto;\n}\n.ant-col-pull-24.ant-col-rtl {\n  right: auto;\n  left: 100%;\n}\n.ant-col-offset-24.ant-col-rtl {\n  margin-right: 100%;\n  margin-left: 0;\n}\n.ant-col-xs-24 {\n  display: block;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n.ant-col-xs-push-24 {\n  left: 100%;\n}\n.ant-col-xs-pull-24 {\n  right: 100%;\n}\n.ant-col-xs-offset-24 {\n  margin-left: 100%;\n}\n.ant-col-xs-order-24 {\n  order: 24;\n}\n.ant-col-xs-23 {\n  display: block;\n  flex: 0 0 95.83333333%;\n  max-width: 95.83333333%;\n}\n.ant-col-xs-push-23 {\n  left: 95.83333333%;\n}\n.ant-col-xs-pull-23 {\n  right: 95.83333333%;\n}\n.ant-col-xs-offset-23 {\n  margin-left: 95.83333333%;\n}\n.ant-col-xs-order-23 {\n  order: 23;\n}\n.ant-col-xs-22 {\n  display: block;\n  flex: 0 0 91.66666667%;\n  max-width: 91.66666667%;\n}\n.ant-col-xs-push-22 {\n  left: 91.66666667%;\n}\n.ant-col-xs-pull-22 {\n  right: 91.66666667%;\n}\n.ant-col-xs-offset-22 {\n  margin-left: 91.66666667%;\n}\n.ant-col-xs-order-22 {\n  order: 22;\n}\n.ant-col-xs-21 {\n  display: block;\n  flex: 0 0 87.5%;\n  max-width: 87.5%;\n}\n.ant-col-xs-push-21 {\n  left: 87.5%;\n}\n.ant-col-xs-pull-21 {\n  right: 87.5%;\n}\n.ant-col-xs-offset-21 {\n  margin-left: 87.5%;\n}\n.ant-col-xs-order-21 {\n  order: 21;\n}\n.ant-col-xs-20 {\n  display: block;\n  flex: 0 0 83.33333333%;\n  max-width: 83.33333333%;\n}\n.ant-col-xs-push-20 {\n  left: 83.33333333%;\n}\n.ant-col-xs-pull-20 {\n  right: 83.33333333%;\n}\n.ant-col-xs-offset-20 {\n  margin-left: 83.33333333%;\n}\n.ant-col-xs-order-20 {\n  order: 20;\n}\n.ant-col-xs-19 {\n  display: block;\n  flex: 0 0 79.16666667%;\n  max-width: 79.16666667%;\n}\n.ant-col-xs-push-19 {\n  left: 79.16666667%;\n}\n.ant-col-xs-pull-19 {\n  right: 79.16666667%;\n}\n.ant-col-xs-offset-19 {\n  margin-left: 79.16666667%;\n}\n.ant-col-xs-order-19 {\n  order: 19;\n}\n.ant-col-xs-18 {\n  display: block;\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n.ant-col-xs-push-18 {\n  left: 75%;\n}\n.ant-col-xs-pull-18 {\n  right: 75%;\n}\n.ant-col-xs-offset-18 {\n  margin-left: 75%;\n}\n.ant-col-xs-order-18 {\n  order: 18;\n}\n.ant-col-xs-17 {\n  display: block;\n  flex: 0 0 70.83333333%;\n  max-width: 70.83333333%;\n}\n.ant-col-xs-push-17 {\n  left: 70.83333333%;\n}\n.ant-col-xs-pull-17 {\n  right: 70.83333333%;\n}\n.ant-col-xs-offset-17 {\n  margin-left: 70.83333333%;\n}\n.ant-col-xs-order-17 {\n  order: 17;\n}\n.ant-col-xs-16 {\n  display: block;\n  flex: 0 0 66.66666667%;\n  max-width: 66.66666667%;\n}\n.ant-col-xs-push-16 {\n  left: 66.66666667%;\n}\n.ant-col-xs-pull-16 {\n  right: 66.66666667%;\n}\n.ant-col-xs-offset-16 {\n  margin-left: 66.66666667%;\n}\n.ant-col-xs-order-16 {\n  order: 16;\n}\n.ant-col-xs-15 {\n  display: block;\n  flex: 0 0 62.5%;\n  max-width: 62.5%;\n}\n.ant-col-xs-push-15 {\n  left: 62.5%;\n}\n.ant-col-xs-pull-15 {\n  right: 62.5%;\n}\n.ant-col-xs-offset-15 {\n  margin-left: 62.5%;\n}\n.ant-col-xs-order-15 {\n  order: 15;\n}\n.ant-col-xs-14 {\n  display: block;\n  flex: 0 0 58.33333333%;\n  max-width: 58.33333333%;\n}\n.ant-col-xs-push-14 {\n  left: 58.33333333%;\n}\n.ant-col-xs-pull-14 {\n  right: 58.33333333%;\n}\n.ant-col-xs-offset-14 {\n  margin-left: 58.33333333%;\n}\n.ant-col-xs-order-14 {\n  order: 14;\n}\n.ant-col-xs-13 {\n  display: block;\n  flex: 0 0 54.16666667%;\n  max-width: 54.16666667%;\n}\n.ant-col-xs-push-13 {\n  left: 54.16666667%;\n}\n.ant-col-xs-pull-13 {\n  right: 54.16666667%;\n}\n.ant-col-xs-offset-13 {\n  margin-left: 54.16666667%;\n}\n.ant-col-xs-order-13 {\n  order: 13;\n}\n.ant-col-xs-12 {\n  display: block;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n.ant-col-xs-push-12 {\n  left: 50%;\n}\n.ant-col-xs-pull-12 {\n  right: 50%;\n}\n.ant-col-xs-offset-12 {\n  margin-left: 50%;\n}\n.ant-col-xs-order-12 {\n  order: 12;\n}\n.ant-col-xs-11 {\n  display: block;\n  flex: 0 0 45.83333333%;\n  max-width: 45.83333333%;\n}\n.ant-col-xs-push-11 {\n  left: 45.83333333%;\n}\n.ant-col-xs-pull-11 {\n  right: 45.83333333%;\n}\n.ant-col-xs-offset-11 {\n  margin-left: 45.83333333%;\n}\n.ant-col-xs-order-11 {\n  order: 11;\n}\n.ant-col-xs-10 {\n  display: block;\n  flex: 0 0 41.66666667%;\n  max-width: 41.66666667%;\n}\n.ant-col-xs-push-10 {\n  left: 41.66666667%;\n}\n.ant-col-xs-pull-10 {\n  right: 41.66666667%;\n}\n.ant-col-xs-offset-10 {\n  margin-left: 41.66666667%;\n}\n.ant-col-xs-order-10 {\n  order: 10;\n}\n.ant-col-xs-9 {\n  display: block;\n  flex: 0 0 37.5%;\n  max-width: 37.5%;\n}\n.ant-col-xs-push-9 {\n  left: 37.5%;\n}\n.ant-col-xs-pull-9 {\n  right: 37.5%;\n}\n.ant-col-xs-offset-9 {\n  margin-left: 37.5%;\n}\n.ant-col-xs-order-9 {\n  order: 9;\n}\n.ant-col-xs-8 {\n  display: block;\n  flex: 0 0 33.33333333%;\n  max-width: 33.33333333%;\n}\n.ant-col-xs-push-8 {\n  left: 33.33333333%;\n}\n.ant-col-xs-pull-8 {\n  right: 33.33333333%;\n}\n.ant-col-xs-offset-8 {\n  margin-left: 33.33333333%;\n}\n.ant-col-xs-order-8 {\n  order: 8;\n}\n.ant-col-xs-7 {\n  display: block;\n  flex: 0 0 29.16666667%;\n  max-width: 29.16666667%;\n}\n.ant-col-xs-push-7 {\n  left: 29.16666667%;\n}\n.ant-col-xs-pull-7 {\n  right: 29.16666667%;\n}\n.ant-col-xs-offset-7 {\n  margin-left: 29.16666667%;\n}\n.ant-col-xs-order-7 {\n  order: 7;\n}\n.ant-col-xs-6 {\n  display: block;\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n.ant-col-xs-push-6 {\n  left: 25%;\n}\n.ant-col-xs-pull-6 {\n  right: 25%;\n}\n.ant-col-xs-offset-6 {\n  margin-left: 25%;\n}\n.ant-col-xs-order-6 {\n  order: 6;\n}\n.ant-col-xs-5 {\n  display: block;\n  flex: 0 0 20.83333333%;\n  max-width: 20.83333333%;\n}\n.ant-col-xs-push-5 {\n  left: 20.83333333%;\n}\n.ant-col-xs-pull-5 {\n  right: 20.83333333%;\n}\n.ant-col-xs-offset-5 {\n  margin-left: 20.83333333%;\n}\n.ant-col-xs-order-5 {\n  order: 5;\n}\n.ant-col-xs-4 {\n  display: block;\n  flex: 0 0 16.66666667%;\n  max-width: 16.66666667%;\n}\n.ant-col-xs-push-4 {\n  left: 16.66666667%;\n}\n.ant-col-xs-pull-4 {\n  right: 16.66666667%;\n}\n.ant-col-xs-offset-4 {\n  margin-left: 16.66666667%;\n}\n.ant-col-xs-order-4 {\n  order: 4;\n}\n.ant-col-xs-3 {\n  display: block;\n  flex: 0 0 12.5%;\n  max-width: 12.5%;\n}\n.ant-col-xs-push-3 {\n  left: 12.5%;\n}\n.ant-col-xs-pull-3 {\n  right: 12.5%;\n}\n.ant-col-xs-offset-3 {\n  margin-left: 12.5%;\n}\n.ant-col-xs-order-3 {\n  order: 3;\n}\n.ant-col-xs-2 {\n  display: block;\n  flex: 0 0 8.33333333%;\n  max-width: 8.33333333%;\n}\n.ant-col-xs-push-2 {\n  left: 8.33333333%;\n}\n.ant-col-xs-pull-2 {\n  right: 8.33333333%;\n}\n.ant-col-xs-offset-2 {\n  margin-left: 8.33333333%;\n}\n.ant-col-xs-order-2 {\n  order: 2;\n}\n.ant-col-xs-1 {\n  display: block;\n  flex: 0 0 4.16666667%;\n  max-width: 4.16666667%;\n}\n.ant-col-xs-push-1 {\n  left: 4.16666667%;\n}\n.ant-col-xs-pull-1 {\n  right: 4.16666667%;\n}\n.ant-col-xs-offset-1 {\n  margin-left: 4.16666667%;\n}\n.ant-col-xs-order-1 {\n  order: 1;\n}\n.ant-col-xs-0 {\n  display: none;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-xs-push-0 {\n  left: auto;\n}\n.ant-col-xs-pull-0 {\n  right: auto;\n}\n.ant-col-xs-offset-0 {\n  margin-left: 0;\n}\n.ant-col-xs-order-0 {\n  order: 0;\n}\n.ant-col-push-0.ant-col-rtl {\n  right: auto;\n}\n.ant-col-pull-0.ant-col-rtl {\n  left: auto;\n}\n.ant-col-xs-push-0.ant-col-rtl {\n  right: auto;\n}\n.ant-col-xs-pull-0.ant-col-rtl {\n  left: auto;\n}\n.ant-col-xs-offset-0.ant-col-rtl {\n  margin-right: 0;\n}\n.ant-col-xs-push-1.ant-col-rtl {\n  right: 4.16666667%;\n  left: auto;\n}\n.ant-col-xs-pull-1.ant-col-rtl {\n  right: auto;\n  left: 4.16666667%;\n}\n.ant-col-xs-offset-1.ant-col-rtl {\n  margin-right: 4.16666667%;\n  margin-left: 0;\n}\n.ant-col-xs-push-2.ant-col-rtl {\n  right: 8.33333333%;\n  left: auto;\n}\n.ant-col-xs-pull-2.ant-col-rtl {\n  right: auto;\n  left: 8.33333333%;\n}\n.ant-col-xs-offset-2.ant-col-rtl {\n  margin-right: 8.33333333%;\n  margin-left: 0;\n}\n.ant-col-xs-push-3.ant-col-rtl {\n  right: 12.5%;\n  left: auto;\n}\n.ant-col-xs-pull-3.ant-col-rtl {\n  right: auto;\n  left: 12.5%;\n}\n.ant-col-xs-offset-3.ant-col-rtl {\n  margin-right: 12.5%;\n  margin-left: 0;\n}\n.ant-col-xs-push-4.ant-col-rtl {\n  right: 16.66666667%;\n  left: auto;\n}\n.ant-col-xs-pull-4.ant-col-rtl {\n  right: auto;\n  left: 16.66666667%;\n}\n.ant-col-xs-offset-4.ant-col-rtl {\n  margin-right: 16.66666667%;\n  margin-left: 0;\n}\n.ant-col-xs-push-5.ant-col-rtl {\n  right: 20.83333333%;\n  left: auto;\n}\n.ant-col-xs-pull-5.ant-col-rtl {\n  right: auto;\n  left: 20.83333333%;\n}\n.ant-col-xs-offset-5.ant-col-rtl {\n  margin-right: 20.83333333%;\n  margin-left: 0;\n}\n.ant-col-xs-push-6.ant-col-rtl {\n  right: 25%;\n  left: auto;\n}\n.ant-col-xs-pull-6.ant-col-rtl {\n  right: auto;\n  left: 25%;\n}\n.ant-col-xs-offset-6.ant-col-rtl {\n  margin-right: 25%;\n  margin-left: 0;\n}\n.ant-col-xs-push-7.ant-col-rtl {\n  right: 29.16666667%;\n  left: auto;\n}\n.ant-col-xs-pull-7.ant-col-rtl {\n  right: auto;\n  left: 29.16666667%;\n}\n.ant-col-xs-offset-7.ant-col-rtl {\n  margin-right: 29.16666667%;\n  margin-left: 0;\n}\n.ant-col-xs-push-8.ant-col-rtl {\n  right: 33.33333333%;\n  left: auto;\n}\n.ant-col-xs-pull-8.ant-col-rtl {\n  right: auto;\n  left: 33.33333333%;\n}\n.ant-col-xs-offset-8.ant-col-rtl {\n  margin-right: 33.33333333%;\n  margin-left: 0;\n}\n.ant-col-xs-push-9.ant-col-rtl {\n  right: 37.5%;\n  left: auto;\n}\n.ant-col-xs-pull-9.ant-col-rtl {\n  right: auto;\n  left: 37.5%;\n}\n.ant-col-xs-offset-9.ant-col-rtl {\n  margin-right: 37.5%;\n  margin-left: 0;\n}\n.ant-col-xs-push-10.ant-col-rtl {\n  right: 41.66666667%;\n  left: auto;\n}\n.ant-col-xs-pull-10.ant-col-rtl {\n  right: auto;\n  left: 41.66666667%;\n}\n.ant-col-xs-offset-10.ant-col-rtl {\n  margin-right: 41.66666667%;\n  margin-left: 0;\n}\n.ant-col-xs-push-11.ant-col-rtl {\n  right: 45.83333333%;\n  left: auto;\n}\n.ant-col-xs-pull-11.ant-col-rtl {\n  right: auto;\n  left: 45.83333333%;\n}\n.ant-col-xs-offset-11.ant-col-rtl {\n  margin-right: 45.83333333%;\n  margin-left: 0;\n}\n.ant-col-xs-push-12.ant-col-rtl {\n  right: 50%;\n  left: auto;\n}\n.ant-col-xs-pull-12.ant-col-rtl {\n  right: auto;\n  left: 50%;\n}\n.ant-col-xs-offset-12.ant-col-rtl {\n  margin-right: 50%;\n  margin-left: 0;\n}\n.ant-col-xs-push-13.ant-col-rtl {\n  right: 54.16666667%;\n  left: auto;\n}\n.ant-col-xs-pull-13.ant-col-rtl {\n  right: auto;\n  left: 54.16666667%;\n}\n.ant-col-xs-offset-13.ant-col-rtl {\n  margin-right: 54.16666667%;\n  margin-left: 0;\n}\n.ant-col-xs-push-14.ant-col-rtl {\n  right: 58.33333333%;\n  left: auto;\n}\n.ant-col-xs-pull-14.ant-col-rtl {\n  right: auto;\n  left: 58.33333333%;\n}\n.ant-col-xs-offset-14.ant-col-rtl {\n  margin-right: 58.33333333%;\n  margin-left: 0;\n}\n.ant-col-xs-push-15.ant-col-rtl {\n  right: 62.5%;\n  left: auto;\n}\n.ant-col-xs-pull-15.ant-col-rtl {\n  right: auto;\n  left: 62.5%;\n}\n.ant-col-xs-offset-15.ant-col-rtl {\n  margin-right: 62.5%;\n  margin-left: 0;\n}\n.ant-col-xs-push-16.ant-col-rtl {\n  right: 66.66666667%;\n  left: auto;\n}\n.ant-col-xs-pull-16.ant-col-rtl {\n  right: auto;\n  left: 66.66666667%;\n}\n.ant-col-xs-offset-16.ant-col-rtl {\n  margin-right: 66.66666667%;\n  margin-left: 0;\n}\n.ant-col-xs-push-17.ant-col-rtl {\n  right: 70.83333333%;\n  left: auto;\n}\n.ant-col-xs-pull-17.ant-col-rtl {\n  right: auto;\n  left: 70.83333333%;\n}\n.ant-col-xs-offset-17.ant-col-rtl {\n  margin-right: 70.83333333%;\n  margin-left: 0;\n}\n.ant-col-xs-push-18.ant-col-rtl {\n  right: 75%;\n  left: auto;\n}\n.ant-col-xs-pull-18.ant-col-rtl {\n  right: auto;\n  left: 75%;\n}\n.ant-col-xs-offset-18.ant-col-rtl {\n  margin-right: 75%;\n  margin-left: 0;\n}\n.ant-col-xs-push-19.ant-col-rtl {\n  right: 79.16666667%;\n  left: auto;\n}\n.ant-col-xs-pull-19.ant-col-rtl {\n  right: auto;\n  left: 79.16666667%;\n}\n.ant-col-xs-offset-19.ant-col-rtl {\n  margin-right: 79.16666667%;\n  margin-left: 0;\n}\n.ant-col-xs-push-20.ant-col-rtl {\n  right: 83.33333333%;\n  left: auto;\n}\n.ant-col-xs-pull-20.ant-col-rtl {\n  right: auto;\n  left: 83.33333333%;\n}\n.ant-col-xs-offset-20.ant-col-rtl {\n  margin-right: 83.33333333%;\n  margin-left: 0;\n}\n.ant-col-xs-push-21.ant-col-rtl {\n  right: 87.5%;\n  left: auto;\n}\n.ant-col-xs-pull-21.ant-col-rtl {\n  right: auto;\n  left: 87.5%;\n}\n.ant-col-xs-offset-21.ant-col-rtl {\n  margin-right: 87.5%;\n  margin-left: 0;\n}\n.ant-col-xs-push-22.ant-col-rtl {\n  right: 91.66666667%;\n  left: auto;\n}\n.ant-col-xs-pull-22.ant-col-rtl {\n  right: auto;\n  left: 91.66666667%;\n}\n.ant-col-xs-offset-22.ant-col-rtl {\n  margin-right: 91.66666667%;\n  margin-left: 0;\n}\n.ant-col-xs-push-23.ant-col-rtl {\n  right: 95.83333333%;\n  left: auto;\n}\n.ant-col-xs-pull-23.ant-col-rtl {\n  right: auto;\n  left: 95.83333333%;\n}\n.ant-col-xs-offset-23.ant-col-rtl {\n  margin-right: 95.83333333%;\n  margin-left: 0;\n}\n.ant-col-xs-push-24.ant-col-rtl {\n  right: 100%;\n  left: auto;\n}\n.ant-col-xs-pull-24.ant-col-rtl {\n  right: auto;\n  left: 100%;\n}\n.ant-col-xs-offset-24.ant-col-rtl {\n  margin-right: 100%;\n  margin-left: 0;\n}\n@media (min-width: 576px) {\n  .ant-col-sm-24 {\n    display: block;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .ant-col-sm-push-24 {\n    left: 100%;\n  }\n  .ant-col-sm-pull-24 {\n    right: 100%;\n  }\n  .ant-col-sm-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-sm-order-24 {\n    order: 24;\n  }\n  .ant-col-sm-23 {\n    display: block;\n    flex: 0 0 95.83333333%;\n    max-width: 95.83333333%;\n  }\n  .ant-col-sm-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-sm-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-sm-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-sm-order-23 {\n    order: 23;\n  }\n  .ant-col-sm-22 {\n    display: block;\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .ant-col-sm-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-sm-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-sm-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-sm-order-22 {\n    order: 22;\n  }\n  .ant-col-sm-21 {\n    display: block;\n    flex: 0 0 87.5%;\n    max-width: 87.5%;\n  }\n  .ant-col-sm-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-sm-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-sm-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-sm-order-21 {\n    order: 21;\n  }\n  .ant-col-sm-20 {\n    display: block;\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .ant-col-sm-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-sm-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-sm-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-sm-order-20 {\n    order: 20;\n  }\n  .ant-col-sm-19 {\n    display: block;\n    flex: 0 0 79.16666667%;\n    max-width: 79.16666667%;\n  }\n  .ant-col-sm-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-sm-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-sm-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-sm-order-19 {\n    order: 19;\n  }\n  .ant-col-sm-18 {\n    display: block;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .ant-col-sm-push-18 {\n    left: 75%;\n  }\n  .ant-col-sm-pull-18 {\n    right: 75%;\n  }\n  .ant-col-sm-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-sm-order-18 {\n    order: 18;\n  }\n  .ant-col-sm-17 {\n    display: block;\n    flex: 0 0 70.83333333%;\n    max-width: 70.83333333%;\n  }\n  .ant-col-sm-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-sm-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-sm-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-sm-order-17 {\n    order: 17;\n  }\n  .ant-col-sm-16 {\n    display: block;\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .ant-col-sm-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-sm-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-sm-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-sm-order-16 {\n    order: 16;\n  }\n  .ant-col-sm-15 {\n    display: block;\n    flex: 0 0 62.5%;\n    max-width: 62.5%;\n  }\n  .ant-col-sm-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-sm-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-sm-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-sm-order-15 {\n    order: 15;\n  }\n  .ant-col-sm-14 {\n    display: block;\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .ant-col-sm-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-sm-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-sm-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-sm-order-14 {\n    order: 14;\n  }\n  .ant-col-sm-13 {\n    display: block;\n    flex: 0 0 54.16666667%;\n    max-width: 54.16666667%;\n  }\n  .ant-col-sm-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-sm-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-sm-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-sm-order-13 {\n    order: 13;\n  }\n  .ant-col-sm-12 {\n    display: block;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .ant-col-sm-push-12 {\n    left: 50%;\n  }\n  .ant-col-sm-pull-12 {\n    right: 50%;\n  }\n  .ant-col-sm-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-sm-order-12 {\n    order: 12;\n  }\n  .ant-col-sm-11 {\n    display: block;\n    flex: 0 0 45.83333333%;\n    max-width: 45.83333333%;\n  }\n  .ant-col-sm-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-sm-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-sm-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-sm-order-11 {\n    order: 11;\n  }\n  .ant-col-sm-10 {\n    display: block;\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .ant-col-sm-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-sm-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-sm-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-sm-order-10 {\n    order: 10;\n  }\n  .ant-col-sm-9 {\n    display: block;\n    flex: 0 0 37.5%;\n    max-width: 37.5%;\n  }\n  .ant-col-sm-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-sm-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-sm-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-sm-order-9 {\n    order: 9;\n  }\n  .ant-col-sm-8 {\n    display: block;\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .ant-col-sm-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-sm-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-sm-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-sm-order-8 {\n    order: 8;\n  }\n  .ant-col-sm-7 {\n    display: block;\n    flex: 0 0 29.16666667%;\n    max-width: 29.16666667%;\n  }\n  .ant-col-sm-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-sm-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-sm-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-sm-order-7 {\n    order: 7;\n  }\n  .ant-col-sm-6 {\n    display: block;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .ant-col-sm-push-6 {\n    left: 25%;\n  }\n  .ant-col-sm-pull-6 {\n    right: 25%;\n  }\n  .ant-col-sm-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-sm-order-6 {\n    order: 6;\n  }\n  .ant-col-sm-5 {\n    display: block;\n    flex: 0 0 20.83333333%;\n    max-width: 20.83333333%;\n  }\n  .ant-col-sm-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-sm-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-sm-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-sm-order-5 {\n    order: 5;\n  }\n  .ant-col-sm-4 {\n    display: block;\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .ant-col-sm-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-sm-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-sm-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-sm-order-4 {\n    order: 4;\n  }\n  .ant-col-sm-3 {\n    display: block;\n    flex: 0 0 12.5%;\n    max-width: 12.5%;\n  }\n  .ant-col-sm-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-sm-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-sm-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-sm-order-3 {\n    order: 3;\n  }\n  .ant-col-sm-2 {\n    display: block;\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .ant-col-sm-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-sm-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-sm-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-sm-order-2 {\n    order: 2;\n  }\n  .ant-col-sm-1 {\n    display: block;\n    flex: 0 0 4.16666667%;\n    max-width: 4.16666667%;\n  }\n  .ant-col-sm-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-sm-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-sm-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-sm-order-1 {\n    order: 1;\n  }\n  .ant-col-sm-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-sm-push-0 {\n    left: auto;\n  }\n  .ant-col-sm-pull-0 {\n    right: auto;\n  }\n  .ant-col-sm-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-sm-order-0 {\n    order: 0;\n  }\n  .ant-col-push-0.ant-col-rtl {\n    right: auto;\n  }\n  .ant-col-pull-0.ant-col-rtl {\n    left: auto;\n  }\n  .ant-col-sm-push-0.ant-col-rtl {\n    right: auto;\n  }\n  .ant-col-sm-pull-0.ant-col-rtl {\n    left: auto;\n  }\n  .ant-col-sm-offset-0.ant-col-rtl {\n    margin-right: 0;\n  }\n  .ant-col-sm-push-1.ant-col-rtl {\n    right: 4.16666667%;\n    left: auto;\n  }\n  .ant-col-sm-pull-1.ant-col-rtl {\n    right: auto;\n    left: 4.16666667%;\n  }\n  .ant-col-sm-offset-1.ant-col-rtl {\n    margin-right: 4.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-2.ant-col-rtl {\n    right: 8.33333333%;\n    left: auto;\n  }\n  .ant-col-sm-pull-2.ant-col-rtl {\n    right: auto;\n    left: 8.33333333%;\n  }\n  .ant-col-sm-offset-2.ant-col-rtl {\n    margin-right: 8.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-3.ant-col-rtl {\n    right: 12.5%;\n    left: auto;\n  }\n  .ant-col-sm-pull-3.ant-col-rtl {\n    right: auto;\n    left: 12.5%;\n  }\n  .ant-col-sm-offset-3.ant-col-rtl {\n    margin-right: 12.5%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-4.ant-col-rtl {\n    right: 16.66666667%;\n    left: auto;\n  }\n  .ant-col-sm-pull-4.ant-col-rtl {\n    right: auto;\n    left: 16.66666667%;\n  }\n  .ant-col-sm-offset-4.ant-col-rtl {\n    margin-right: 16.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-5.ant-col-rtl {\n    right: 20.83333333%;\n    left: auto;\n  }\n  .ant-col-sm-pull-5.ant-col-rtl {\n    right: auto;\n    left: 20.83333333%;\n  }\n  .ant-col-sm-offset-5.ant-col-rtl {\n    margin-right: 20.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-6.ant-col-rtl {\n    right: 25%;\n    left: auto;\n  }\n  .ant-col-sm-pull-6.ant-col-rtl {\n    right: auto;\n    left: 25%;\n  }\n  .ant-col-sm-offset-6.ant-col-rtl {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-7.ant-col-rtl {\n    right: 29.16666667%;\n    left: auto;\n  }\n  .ant-col-sm-pull-7.ant-col-rtl {\n    right: auto;\n    left: 29.16666667%;\n  }\n  .ant-col-sm-offset-7.ant-col-rtl {\n    margin-right: 29.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-8.ant-col-rtl {\n    right: 33.33333333%;\n    left: auto;\n  }\n  .ant-col-sm-pull-8.ant-col-rtl {\n    right: auto;\n    left: 33.33333333%;\n  }\n  .ant-col-sm-offset-8.ant-col-rtl {\n    margin-right: 33.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-9.ant-col-rtl {\n    right: 37.5%;\n    left: auto;\n  }\n  .ant-col-sm-pull-9.ant-col-rtl {\n    right: auto;\n    left: 37.5%;\n  }\n  .ant-col-sm-offset-9.ant-col-rtl {\n    margin-right: 37.5%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-10.ant-col-rtl {\n    right: 41.66666667%;\n    left: auto;\n  }\n  .ant-col-sm-pull-10.ant-col-rtl {\n    right: auto;\n    left: 41.66666667%;\n  }\n  .ant-col-sm-offset-10.ant-col-rtl {\n    margin-right: 41.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-11.ant-col-rtl {\n    right: 45.83333333%;\n    left: auto;\n  }\n  .ant-col-sm-pull-11.ant-col-rtl {\n    right: auto;\n    left: 45.83333333%;\n  }\n  .ant-col-sm-offset-11.ant-col-rtl {\n    margin-right: 45.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-12.ant-col-rtl {\n    right: 50%;\n    left: auto;\n  }\n  .ant-col-sm-pull-12.ant-col-rtl {\n    right: auto;\n    left: 50%;\n  }\n  .ant-col-sm-offset-12.ant-col-rtl {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-13.ant-col-rtl {\n    right: 54.16666667%;\n    left: auto;\n  }\n  .ant-col-sm-pull-13.ant-col-rtl {\n    right: auto;\n    left: 54.16666667%;\n  }\n  .ant-col-sm-offset-13.ant-col-rtl {\n    margin-right: 54.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-14.ant-col-rtl {\n    right: 58.33333333%;\n    left: auto;\n  }\n  .ant-col-sm-pull-14.ant-col-rtl {\n    right: auto;\n    left: 58.33333333%;\n  }\n  .ant-col-sm-offset-14.ant-col-rtl {\n    margin-right: 58.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-15.ant-col-rtl {\n    right: 62.5%;\n    left: auto;\n  }\n  .ant-col-sm-pull-15.ant-col-rtl {\n    right: auto;\n    left: 62.5%;\n  }\n  .ant-col-sm-offset-15.ant-col-rtl {\n    margin-right: 62.5%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-16.ant-col-rtl {\n    right: 66.66666667%;\n    left: auto;\n  }\n  .ant-col-sm-pull-16.ant-col-rtl {\n    right: auto;\n    left: 66.66666667%;\n  }\n  .ant-col-sm-offset-16.ant-col-rtl {\n    margin-right: 66.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-17.ant-col-rtl {\n    right: 70.83333333%;\n    left: auto;\n  }\n  .ant-col-sm-pull-17.ant-col-rtl {\n    right: auto;\n    left: 70.83333333%;\n  }\n  .ant-col-sm-offset-17.ant-col-rtl {\n    margin-right: 70.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-18.ant-col-rtl {\n    right: 75%;\n    left: auto;\n  }\n  .ant-col-sm-pull-18.ant-col-rtl {\n    right: auto;\n    left: 75%;\n  }\n  .ant-col-sm-offset-18.ant-col-rtl {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-19.ant-col-rtl {\n    right: 79.16666667%;\n    left: auto;\n  }\n  .ant-col-sm-pull-19.ant-col-rtl {\n    right: auto;\n    left: 79.16666667%;\n  }\n  .ant-col-sm-offset-19.ant-col-rtl {\n    margin-right: 79.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-20.ant-col-rtl {\n    right: 83.33333333%;\n    left: auto;\n  }\n  .ant-col-sm-pull-20.ant-col-rtl {\n    right: auto;\n    left: 83.33333333%;\n  }\n  .ant-col-sm-offset-20.ant-col-rtl {\n    margin-right: 83.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-21.ant-col-rtl {\n    right: 87.5%;\n    left: auto;\n  }\n  .ant-col-sm-pull-21.ant-col-rtl {\n    right: auto;\n    left: 87.5%;\n  }\n  .ant-col-sm-offset-21.ant-col-rtl {\n    margin-right: 87.5%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-22.ant-col-rtl {\n    right: 91.66666667%;\n    left: auto;\n  }\n  .ant-col-sm-pull-22.ant-col-rtl {\n    right: auto;\n    left: 91.66666667%;\n  }\n  .ant-col-sm-offset-22.ant-col-rtl {\n    margin-right: 91.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-23.ant-col-rtl {\n    right: 95.83333333%;\n    left: auto;\n  }\n  .ant-col-sm-pull-23.ant-col-rtl {\n    right: auto;\n    left: 95.83333333%;\n  }\n  .ant-col-sm-offset-23.ant-col-rtl {\n    margin-right: 95.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-sm-push-24.ant-col-rtl {\n    right: 100%;\n    left: auto;\n  }\n  .ant-col-sm-pull-24.ant-col-rtl {\n    right: auto;\n    left: 100%;\n  }\n  .ant-col-sm-offset-24.ant-col-rtl {\n    margin-right: 100%;\n    margin-left: 0;\n  }\n}\n@media (min-width: 768px) {\n  .ant-col-md-24 {\n    display: block;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .ant-col-md-push-24 {\n    left: 100%;\n  }\n  .ant-col-md-pull-24 {\n    right: 100%;\n  }\n  .ant-col-md-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-md-order-24 {\n    order: 24;\n  }\n  .ant-col-md-23 {\n    display: block;\n    flex: 0 0 95.83333333%;\n    max-width: 95.83333333%;\n  }\n  .ant-col-md-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-md-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-md-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-md-order-23 {\n    order: 23;\n  }\n  .ant-col-md-22 {\n    display: block;\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .ant-col-md-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-md-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-md-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-md-order-22 {\n    order: 22;\n  }\n  .ant-col-md-21 {\n    display: block;\n    flex: 0 0 87.5%;\n    max-width: 87.5%;\n  }\n  .ant-col-md-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-md-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-md-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-md-order-21 {\n    order: 21;\n  }\n  .ant-col-md-20 {\n    display: block;\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .ant-col-md-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-md-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-md-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-md-order-20 {\n    order: 20;\n  }\n  .ant-col-md-19 {\n    display: block;\n    flex: 0 0 79.16666667%;\n    max-width: 79.16666667%;\n  }\n  .ant-col-md-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-md-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-md-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-md-order-19 {\n    order: 19;\n  }\n  .ant-col-md-18 {\n    display: block;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .ant-col-md-push-18 {\n    left: 75%;\n  }\n  .ant-col-md-pull-18 {\n    right: 75%;\n  }\n  .ant-col-md-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-md-order-18 {\n    order: 18;\n  }\n  .ant-col-md-17 {\n    display: block;\n    flex: 0 0 70.83333333%;\n    max-width: 70.83333333%;\n  }\n  .ant-col-md-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-md-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-md-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-md-order-17 {\n    order: 17;\n  }\n  .ant-col-md-16 {\n    display: block;\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .ant-col-md-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-md-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-md-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-md-order-16 {\n    order: 16;\n  }\n  .ant-col-md-15 {\n    display: block;\n    flex: 0 0 62.5%;\n    max-width: 62.5%;\n  }\n  .ant-col-md-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-md-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-md-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-md-order-15 {\n    order: 15;\n  }\n  .ant-col-md-14 {\n    display: block;\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .ant-col-md-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-md-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-md-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-md-order-14 {\n    order: 14;\n  }\n  .ant-col-md-13 {\n    display: block;\n    flex: 0 0 54.16666667%;\n    max-width: 54.16666667%;\n  }\n  .ant-col-md-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-md-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-md-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-md-order-13 {\n    order: 13;\n  }\n  .ant-col-md-12 {\n    display: block;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .ant-col-md-push-12 {\n    left: 50%;\n  }\n  .ant-col-md-pull-12 {\n    right: 50%;\n  }\n  .ant-col-md-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-md-order-12 {\n    order: 12;\n  }\n  .ant-col-md-11 {\n    display: block;\n    flex: 0 0 45.83333333%;\n    max-width: 45.83333333%;\n  }\n  .ant-col-md-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-md-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-md-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-md-order-11 {\n    order: 11;\n  }\n  .ant-col-md-10 {\n    display: block;\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .ant-col-md-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-md-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-md-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-md-order-10 {\n    order: 10;\n  }\n  .ant-col-md-9 {\n    display: block;\n    flex: 0 0 37.5%;\n    max-width: 37.5%;\n  }\n  .ant-col-md-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-md-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-md-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-md-order-9 {\n    order: 9;\n  }\n  .ant-col-md-8 {\n    display: block;\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .ant-col-md-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-md-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-md-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-md-order-8 {\n    order: 8;\n  }\n  .ant-col-md-7 {\n    display: block;\n    flex: 0 0 29.16666667%;\n    max-width: 29.16666667%;\n  }\n  .ant-col-md-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-md-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-md-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-md-order-7 {\n    order: 7;\n  }\n  .ant-col-md-6 {\n    display: block;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .ant-col-md-push-6 {\n    left: 25%;\n  }\n  .ant-col-md-pull-6 {\n    right: 25%;\n  }\n  .ant-col-md-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-md-order-6 {\n    order: 6;\n  }\n  .ant-col-md-5 {\n    display: block;\n    flex: 0 0 20.83333333%;\n    max-width: 20.83333333%;\n  }\n  .ant-col-md-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-md-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-md-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-md-order-5 {\n    order: 5;\n  }\n  .ant-col-md-4 {\n    display: block;\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .ant-col-md-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-md-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-md-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-md-order-4 {\n    order: 4;\n  }\n  .ant-col-md-3 {\n    display: block;\n    flex: 0 0 12.5%;\n    max-width: 12.5%;\n  }\n  .ant-col-md-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-md-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-md-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-md-order-3 {\n    order: 3;\n  }\n  .ant-col-md-2 {\n    display: block;\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .ant-col-md-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-md-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-md-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-md-order-2 {\n    order: 2;\n  }\n  .ant-col-md-1 {\n    display: block;\n    flex: 0 0 4.16666667%;\n    max-width: 4.16666667%;\n  }\n  .ant-col-md-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-md-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-md-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-md-order-1 {\n    order: 1;\n  }\n  .ant-col-md-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-md-push-0 {\n    left: auto;\n  }\n  .ant-col-md-pull-0 {\n    right: auto;\n  }\n  .ant-col-md-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-md-order-0 {\n    order: 0;\n  }\n  .ant-col-push-0.ant-col-rtl {\n    right: auto;\n  }\n  .ant-col-pull-0.ant-col-rtl {\n    left: auto;\n  }\n  .ant-col-md-push-0.ant-col-rtl {\n    right: auto;\n  }\n  .ant-col-md-pull-0.ant-col-rtl {\n    left: auto;\n  }\n  .ant-col-md-offset-0.ant-col-rtl {\n    margin-right: 0;\n  }\n  .ant-col-md-push-1.ant-col-rtl {\n    right: 4.16666667%;\n    left: auto;\n  }\n  .ant-col-md-pull-1.ant-col-rtl {\n    right: auto;\n    left: 4.16666667%;\n  }\n  .ant-col-md-offset-1.ant-col-rtl {\n    margin-right: 4.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-2.ant-col-rtl {\n    right: 8.33333333%;\n    left: auto;\n  }\n  .ant-col-md-pull-2.ant-col-rtl {\n    right: auto;\n    left: 8.33333333%;\n  }\n  .ant-col-md-offset-2.ant-col-rtl {\n    margin-right: 8.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-3.ant-col-rtl {\n    right: 12.5%;\n    left: auto;\n  }\n  .ant-col-md-pull-3.ant-col-rtl {\n    right: auto;\n    left: 12.5%;\n  }\n  .ant-col-md-offset-3.ant-col-rtl {\n    margin-right: 12.5%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-4.ant-col-rtl {\n    right: 16.66666667%;\n    left: auto;\n  }\n  .ant-col-md-pull-4.ant-col-rtl {\n    right: auto;\n    left: 16.66666667%;\n  }\n  .ant-col-md-offset-4.ant-col-rtl {\n    margin-right: 16.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-5.ant-col-rtl {\n    right: 20.83333333%;\n    left: auto;\n  }\n  .ant-col-md-pull-5.ant-col-rtl {\n    right: auto;\n    left: 20.83333333%;\n  }\n  .ant-col-md-offset-5.ant-col-rtl {\n    margin-right: 20.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-6.ant-col-rtl {\n    right: 25%;\n    left: auto;\n  }\n  .ant-col-md-pull-6.ant-col-rtl {\n    right: auto;\n    left: 25%;\n  }\n  .ant-col-md-offset-6.ant-col-rtl {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-7.ant-col-rtl {\n    right: 29.16666667%;\n    left: auto;\n  }\n  .ant-col-md-pull-7.ant-col-rtl {\n    right: auto;\n    left: 29.16666667%;\n  }\n  .ant-col-md-offset-7.ant-col-rtl {\n    margin-right: 29.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-8.ant-col-rtl {\n    right: 33.33333333%;\n    left: auto;\n  }\n  .ant-col-md-pull-8.ant-col-rtl {\n    right: auto;\n    left: 33.33333333%;\n  }\n  .ant-col-md-offset-8.ant-col-rtl {\n    margin-right: 33.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-9.ant-col-rtl {\n    right: 37.5%;\n    left: auto;\n  }\n  .ant-col-md-pull-9.ant-col-rtl {\n    right: auto;\n    left: 37.5%;\n  }\n  .ant-col-md-offset-9.ant-col-rtl {\n    margin-right: 37.5%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-10.ant-col-rtl {\n    right: 41.66666667%;\n    left: auto;\n  }\n  .ant-col-md-pull-10.ant-col-rtl {\n    right: auto;\n    left: 41.66666667%;\n  }\n  .ant-col-md-offset-10.ant-col-rtl {\n    margin-right: 41.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-11.ant-col-rtl {\n    right: 45.83333333%;\n    left: auto;\n  }\n  .ant-col-md-pull-11.ant-col-rtl {\n    right: auto;\n    left: 45.83333333%;\n  }\n  .ant-col-md-offset-11.ant-col-rtl {\n    margin-right: 45.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-12.ant-col-rtl {\n    right: 50%;\n    left: auto;\n  }\n  .ant-col-md-pull-12.ant-col-rtl {\n    right: auto;\n    left: 50%;\n  }\n  .ant-col-md-offset-12.ant-col-rtl {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-13.ant-col-rtl {\n    right: 54.16666667%;\n    left: auto;\n  }\n  .ant-col-md-pull-13.ant-col-rtl {\n    right: auto;\n    left: 54.16666667%;\n  }\n  .ant-col-md-offset-13.ant-col-rtl {\n    margin-right: 54.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-14.ant-col-rtl {\n    right: 58.33333333%;\n    left: auto;\n  }\n  .ant-col-md-pull-14.ant-col-rtl {\n    right: auto;\n    left: 58.33333333%;\n  }\n  .ant-col-md-offset-14.ant-col-rtl {\n    margin-right: 58.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-15.ant-col-rtl {\n    right: 62.5%;\n    left: auto;\n  }\n  .ant-col-md-pull-15.ant-col-rtl {\n    right: auto;\n    left: 62.5%;\n  }\n  .ant-col-md-offset-15.ant-col-rtl {\n    margin-right: 62.5%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-16.ant-col-rtl {\n    right: 66.66666667%;\n    left: auto;\n  }\n  .ant-col-md-pull-16.ant-col-rtl {\n    right: auto;\n    left: 66.66666667%;\n  }\n  .ant-col-md-offset-16.ant-col-rtl {\n    margin-right: 66.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-17.ant-col-rtl {\n    right: 70.83333333%;\n    left: auto;\n  }\n  .ant-col-md-pull-17.ant-col-rtl {\n    right: auto;\n    left: 70.83333333%;\n  }\n  .ant-col-md-offset-17.ant-col-rtl {\n    margin-right: 70.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-18.ant-col-rtl {\n    right: 75%;\n    left: auto;\n  }\n  .ant-col-md-pull-18.ant-col-rtl {\n    right: auto;\n    left: 75%;\n  }\n  .ant-col-md-offset-18.ant-col-rtl {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-19.ant-col-rtl {\n    right: 79.16666667%;\n    left: auto;\n  }\n  .ant-col-md-pull-19.ant-col-rtl {\n    right: auto;\n    left: 79.16666667%;\n  }\n  .ant-col-md-offset-19.ant-col-rtl {\n    margin-right: 79.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-20.ant-col-rtl {\n    right: 83.33333333%;\n    left: auto;\n  }\n  .ant-col-md-pull-20.ant-col-rtl {\n    right: auto;\n    left: 83.33333333%;\n  }\n  .ant-col-md-offset-20.ant-col-rtl {\n    margin-right: 83.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-21.ant-col-rtl {\n    right: 87.5%;\n    left: auto;\n  }\n  .ant-col-md-pull-21.ant-col-rtl {\n    right: auto;\n    left: 87.5%;\n  }\n  .ant-col-md-offset-21.ant-col-rtl {\n    margin-right: 87.5%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-22.ant-col-rtl {\n    right: 91.66666667%;\n    left: auto;\n  }\n  .ant-col-md-pull-22.ant-col-rtl {\n    right: auto;\n    left: 91.66666667%;\n  }\n  .ant-col-md-offset-22.ant-col-rtl {\n    margin-right: 91.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-23.ant-col-rtl {\n    right: 95.83333333%;\n    left: auto;\n  }\n  .ant-col-md-pull-23.ant-col-rtl {\n    right: auto;\n    left: 95.83333333%;\n  }\n  .ant-col-md-offset-23.ant-col-rtl {\n    margin-right: 95.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-md-push-24.ant-col-rtl {\n    right: 100%;\n    left: auto;\n  }\n  .ant-col-md-pull-24.ant-col-rtl {\n    right: auto;\n    left: 100%;\n  }\n  .ant-col-md-offset-24.ant-col-rtl {\n    margin-right: 100%;\n    margin-left: 0;\n  }\n}\n@media (min-width: 992px) {\n  .ant-col-lg-24 {\n    display: block;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .ant-col-lg-push-24 {\n    left: 100%;\n  }\n  .ant-col-lg-pull-24 {\n    right: 100%;\n  }\n  .ant-col-lg-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-lg-order-24 {\n    order: 24;\n  }\n  .ant-col-lg-23 {\n    display: block;\n    flex: 0 0 95.83333333%;\n    max-width: 95.83333333%;\n  }\n  .ant-col-lg-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-lg-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-lg-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-lg-order-23 {\n    order: 23;\n  }\n  .ant-col-lg-22 {\n    display: block;\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .ant-col-lg-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-lg-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-lg-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-lg-order-22 {\n    order: 22;\n  }\n  .ant-col-lg-21 {\n    display: block;\n    flex: 0 0 87.5%;\n    max-width: 87.5%;\n  }\n  .ant-col-lg-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-lg-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-lg-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-lg-order-21 {\n    order: 21;\n  }\n  .ant-col-lg-20 {\n    display: block;\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .ant-col-lg-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-lg-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-lg-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-lg-order-20 {\n    order: 20;\n  }\n  .ant-col-lg-19 {\n    display: block;\n    flex: 0 0 79.16666667%;\n    max-width: 79.16666667%;\n  }\n  .ant-col-lg-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-lg-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-lg-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-lg-order-19 {\n    order: 19;\n  }\n  .ant-col-lg-18 {\n    display: block;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .ant-col-lg-push-18 {\n    left: 75%;\n  }\n  .ant-col-lg-pull-18 {\n    right: 75%;\n  }\n  .ant-col-lg-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-lg-order-18 {\n    order: 18;\n  }\n  .ant-col-lg-17 {\n    display: block;\n    flex: 0 0 70.83333333%;\n    max-width: 70.83333333%;\n  }\n  .ant-col-lg-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-lg-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-lg-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-lg-order-17 {\n    order: 17;\n  }\n  .ant-col-lg-16 {\n    display: block;\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .ant-col-lg-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-lg-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-lg-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-lg-order-16 {\n    order: 16;\n  }\n  .ant-col-lg-15 {\n    display: block;\n    flex: 0 0 62.5%;\n    max-width: 62.5%;\n  }\n  .ant-col-lg-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-lg-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-lg-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-lg-order-15 {\n    order: 15;\n  }\n  .ant-col-lg-14 {\n    display: block;\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .ant-col-lg-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-lg-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-lg-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-lg-order-14 {\n    order: 14;\n  }\n  .ant-col-lg-13 {\n    display: block;\n    flex: 0 0 54.16666667%;\n    max-width: 54.16666667%;\n  }\n  .ant-col-lg-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-lg-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-lg-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-lg-order-13 {\n    order: 13;\n  }\n  .ant-col-lg-12 {\n    display: block;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .ant-col-lg-push-12 {\n    left: 50%;\n  }\n  .ant-col-lg-pull-12 {\n    right: 50%;\n  }\n  .ant-col-lg-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-lg-order-12 {\n    order: 12;\n  }\n  .ant-col-lg-11 {\n    display: block;\n    flex: 0 0 45.83333333%;\n    max-width: 45.83333333%;\n  }\n  .ant-col-lg-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-lg-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-lg-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-lg-order-11 {\n    order: 11;\n  }\n  .ant-col-lg-10 {\n    display: block;\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .ant-col-lg-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-lg-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-lg-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-lg-order-10 {\n    order: 10;\n  }\n  .ant-col-lg-9 {\n    display: block;\n    flex: 0 0 37.5%;\n    max-width: 37.5%;\n  }\n  .ant-col-lg-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-lg-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-lg-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-lg-order-9 {\n    order: 9;\n  }\n  .ant-col-lg-8 {\n    display: block;\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .ant-col-lg-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-lg-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-lg-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-lg-order-8 {\n    order: 8;\n  }\n  .ant-col-lg-7 {\n    display: block;\n    flex: 0 0 29.16666667%;\n    max-width: 29.16666667%;\n  }\n  .ant-col-lg-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-lg-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-lg-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-lg-order-7 {\n    order: 7;\n  }\n  .ant-col-lg-6 {\n    display: block;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .ant-col-lg-push-6 {\n    left: 25%;\n  }\n  .ant-col-lg-pull-6 {\n    right: 25%;\n  }\n  .ant-col-lg-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-lg-order-6 {\n    order: 6;\n  }\n  .ant-col-lg-5 {\n    display: block;\n    flex: 0 0 20.83333333%;\n    max-width: 20.83333333%;\n  }\n  .ant-col-lg-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-lg-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-lg-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-lg-order-5 {\n    order: 5;\n  }\n  .ant-col-lg-4 {\n    display: block;\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .ant-col-lg-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-lg-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-lg-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-lg-order-4 {\n    order: 4;\n  }\n  .ant-col-lg-3 {\n    display: block;\n    flex: 0 0 12.5%;\n    max-width: 12.5%;\n  }\n  .ant-col-lg-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-lg-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-lg-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-lg-order-3 {\n    order: 3;\n  }\n  .ant-col-lg-2 {\n    display: block;\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .ant-col-lg-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-lg-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-lg-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-lg-order-2 {\n    order: 2;\n  }\n  .ant-col-lg-1 {\n    display: block;\n    flex: 0 0 4.16666667%;\n    max-width: 4.16666667%;\n  }\n  .ant-col-lg-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-lg-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-lg-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-lg-order-1 {\n    order: 1;\n  }\n  .ant-col-lg-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-lg-push-0 {\n    left: auto;\n  }\n  .ant-col-lg-pull-0 {\n    right: auto;\n  }\n  .ant-col-lg-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-lg-order-0 {\n    order: 0;\n  }\n  .ant-col-push-0.ant-col-rtl {\n    right: auto;\n  }\n  .ant-col-pull-0.ant-col-rtl {\n    left: auto;\n  }\n  .ant-col-lg-push-0.ant-col-rtl {\n    right: auto;\n  }\n  .ant-col-lg-pull-0.ant-col-rtl {\n    left: auto;\n  }\n  .ant-col-lg-offset-0.ant-col-rtl {\n    margin-right: 0;\n  }\n  .ant-col-lg-push-1.ant-col-rtl {\n    right: 4.16666667%;\n    left: auto;\n  }\n  .ant-col-lg-pull-1.ant-col-rtl {\n    right: auto;\n    left: 4.16666667%;\n  }\n  .ant-col-lg-offset-1.ant-col-rtl {\n    margin-right: 4.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-2.ant-col-rtl {\n    right: 8.33333333%;\n    left: auto;\n  }\n  .ant-col-lg-pull-2.ant-col-rtl {\n    right: auto;\n    left: 8.33333333%;\n  }\n  .ant-col-lg-offset-2.ant-col-rtl {\n    margin-right: 8.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-3.ant-col-rtl {\n    right: 12.5%;\n    left: auto;\n  }\n  .ant-col-lg-pull-3.ant-col-rtl {\n    right: auto;\n    left: 12.5%;\n  }\n  .ant-col-lg-offset-3.ant-col-rtl {\n    margin-right: 12.5%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-4.ant-col-rtl {\n    right: 16.66666667%;\n    left: auto;\n  }\n  .ant-col-lg-pull-4.ant-col-rtl {\n    right: auto;\n    left: 16.66666667%;\n  }\n  .ant-col-lg-offset-4.ant-col-rtl {\n    margin-right: 16.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-5.ant-col-rtl {\n    right: 20.83333333%;\n    left: auto;\n  }\n  .ant-col-lg-pull-5.ant-col-rtl {\n    right: auto;\n    left: 20.83333333%;\n  }\n  .ant-col-lg-offset-5.ant-col-rtl {\n    margin-right: 20.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-6.ant-col-rtl {\n    right: 25%;\n    left: auto;\n  }\n  .ant-col-lg-pull-6.ant-col-rtl {\n    right: auto;\n    left: 25%;\n  }\n  .ant-col-lg-offset-6.ant-col-rtl {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-7.ant-col-rtl {\n    right: 29.16666667%;\n    left: auto;\n  }\n  .ant-col-lg-pull-7.ant-col-rtl {\n    right: auto;\n    left: 29.16666667%;\n  }\n  .ant-col-lg-offset-7.ant-col-rtl {\n    margin-right: 29.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-8.ant-col-rtl {\n    right: 33.33333333%;\n    left: auto;\n  }\n  .ant-col-lg-pull-8.ant-col-rtl {\n    right: auto;\n    left: 33.33333333%;\n  }\n  .ant-col-lg-offset-8.ant-col-rtl {\n    margin-right: 33.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-9.ant-col-rtl {\n    right: 37.5%;\n    left: auto;\n  }\n  .ant-col-lg-pull-9.ant-col-rtl {\n    right: auto;\n    left: 37.5%;\n  }\n  .ant-col-lg-offset-9.ant-col-rtl {\n    margin-right: 37.5%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-10.ant-col-rtl {\n    right: 41.66666667%;\n    left: auto;\n  }\n  .ant-col-lg-pull-10.ant-col-rtl {\n    right: auto;\n    left: 41.66666667%;\n  }\n  .ant-col-lg-offset-10.ant-col-rtl {\n    margin-right: 41.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-11.ant-col-rtl {\n    right: 45.83333333%;\n    left: auto;\n  }\n  .ant-col-lg-pull-11.ant-col-rtl {\n    right: auto;\n    left: 45.83333333%;\n  }\n  .ant-col-lg-offset-11.ant-col-rtl {\n    margin-right: 45.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-12.ant-col-rtl {\n    right: 50%;\n    left: auto;\n  }\n  .ant-col-lg-pull-12.ant-col-rtl {\n    right: auto;\n    left: 50%;\n  }\n  .ant-col-lg-offset-12.ant-col-rtl {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-13.ant-col-rtl {\n    right: 54.16666667%;\n    left: auto;\n  }\n  .ant-col-lg-pull-13.ant-col-rtl {\n    right: auto;\n    left: 54.16666667%;\n  }\n  .ant-col-lg-offset-13.ant-col-rtl {\n    margin-right: 54.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-14.ant-col-rtl {\n    right: 58.33333333%;\n    left: auto;\n  }\n  .ant-col-lg-pull-14.ant-col-rtl {\n    right: auto;\n    left: 58.33333333%;\n  }\n  .ant-col-lg-offset-14.ant-col-rtl {\n    margin-right: 58.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-15.ant-col-rtl {\n    right: 62.5%;\n    left: auto;\n  }\n  .ant-col-lg-pull-15.ant-col-rtl {\n    right: auto;\n    left: 62.5%;\n  }\n  .ant-col-lg-offset-15.ant-col-rtl {\n    margin-right: 62.5%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-16.ant-col-rtl {\n    right: 66.66666667%;\n    left: auto;\n  }\n  .ant-col-lg-pull-16.ant-col-rtl {\n    right: auto;\n    left: 66.66666667%;\n  }\n  .ant-col-lg-offset-16.ant-col-rtl {\n    margin-right: 66.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-17.ant-col-rtl {\n    right: 70.83333333%;\n    left: auto;\n  }\n  .ant-col-lg-pull-17.ant-col-rtl {\n    right: auto;\n    left: 70.83333333%;\n  }\n  .ant-col-lg-offset-17.ant-col-rtl {\n    margin-right: 70.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-18.ant-col-rtl {\n    right: 75%;\n    left: auto;\n  }\n  .ant-col-lg-pull-18.ant-col-rtl {\n    right: auto;\n    left: 75%;\n  }\n  .ant-col-lg-offset-18.ant-col-rtl {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-19.ant-col-rtl {\n    right: 79.16666667%;\n    left: auto;\n  }\n  .ant-col-lg-pull-19.ant-col-rtl {\n    right: auto;\n    left: 79.16666667%;\n  }\n  .ant-col-lg-offset-19.ant-col-rtl {\n    margin-right: 79.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-20.ant-col-rtl {\n    right: 83.33333333%;\n    left: auto;\n  }\n  .ant-col-lg-pull-20.ant-col-rtl {\n    right: auto;\n    left: 83.33333333%;\n  }\n  .ant-col-lg-offset-20.ant-col-rtl {\n    margin-right: 83.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-21.ant-col-rtl {\n    right: 87.5%;\n    left: auto;\n  }\n  .ant-col-lg-pull-21.ant-col-rtl {\n    right: auto;\n    left: 87.5%;\n  }\n  .ant-col-lg-offset-21.ant-col-rtl {\n    margin-right: 87.5%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-22.ant-col-rtl {\n    right: 91.66666667%;\n    left: auto;\n  }\n  .ant-col-lg-pull-22.ant-col-rtl {\n    right: auto;\n    left: 91.66666667%;\n  }\n  .ant-col-lg-offset-22.ant-col-rtl {\n    margin-right: 91.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-23.ant-col-rtl {\n    right: 95.83333333%;\n    left: auto;\n  }\n  .ant-col-lg-pull-23.ant-col-rtl {\n    right: auto;\n    left: 95.83333333%;\n  }\n  .ant-col-lg-offset-23.ant-col-rtl {\n    margin-right: 95.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-lg-push-24.ant-col-rtl {\n    right: 100%;\n    left: auto;\n  }\n  .ant-col-lg-pull-24.ant-col-rtl {\n    right: auto;\n    left: 100%;\n  }\n  .ant-col-lg-offset-24.ant-col-rtl {\n    margin-right: 100%;\n    margin-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .ant-col-xl-24 {\n    display: block;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .ant-col-xl-push-24 {\n    left: 100%;\n  }\n  .ant-col-xl-pull-24 {\n    right: 100%;\n  }\n  .ant-col-xl-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-xl-order-24 {\n    order: 24;\n  }\n  .ant-col-xl-23 {\n    display: block;\n    flex: 0 0 95.83333333%;\n    max-width: 95.83333333%;\n  }\n  .ant-col-xl-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-xl-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-xl-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-xl-order-23 {\n    order: 23;\n  }\n  .ant-col-xl-22 {\n    display: block;\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .ant-col-xl-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-xl-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-xl-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-xl-order-22 {\n    order: 22;\n  }\n  .ant-col-xl-21 {\n    display: block;\n    flex: 0 0 87.5%;\n    max-width: 87.5%;\n  }\n  .ant-col-xl-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-xl-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-xl-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-xl-order-21 {\n    order: 21;\n  }\n  .ant-col-xl-20 {\n    display: block;\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .ant-col-xl-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-xl-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-xl-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-xl-order-20 {\n    order: 20;\n  }\n  .ant-col-xl-19 {\n    display: block;\n    flex: 0 0 79.16666667%;\n    max-width: 79.16666667%;\n  }\n  .ant-col-xl-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-xl-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-xl-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-xl-order-19 {\n    order: 19;\n  }\n  .ant-col-xl-18 {\n    display: block;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .ant-col-xl-push-18 {\n    left: 75%;\n  }\n  .ant-col-xl-pull-18 {\n    right: 75%;\n  }\n  .ant-col-xl-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-xl-order-18 {\n    order: 18;\n  }\n  .ant-col-xl-17 {\n    display: block;\n    flex: 0 0 70.83333333%;\n    max-width: 70.83333333%;\n  }\n  .ant-col-xl-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-xl-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-xl-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-xl-order-17 {\n    order: 17;\n  }\n  .ant-col-xl-16 {\n    display: block;\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .ant-col-xl-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-xl-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-xl-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-xl-order-16 {\n    order: 16;\n  }\n  .ant-col-xl-15 {\n    display: block;\n    flex: 0 0 62.5%;\n    max-width: 62.5%;\n  }\n  .ant-col-xl-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-xl-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-xl-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-xl-order-15 {\n    order: 15;\n  }\n  .ant-col-xl-14 {\n    display: block;\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .ant-col-xl-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-xl-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-xl-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-xl-order-14 {\n    order: 14;\n  }\n  .ant-col-xl-13 {\n    display: block;\n    flex: 0 0 54.16666667%;\n    max-width: 54.16666667%;\n  }\n  .ant-col-xl-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-xl-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-xl-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-xl-order-13 {\n    order: 13;\n  }\n  .ant-col-xl-12 {\n    display: block;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .ant-col-xl-push-12 {\n    left: 50%;\n  }\n  .ant-col-xl-pull-12 {\n    right: 50%;\n  }\n  .ant-col-xl-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-xl-order-12 {\n    order: 12;\n  }\n  .ant-col-xl-11 {\n    display: block;\n    flex: 0 0 45.83333333%;\n    max-width: 45.83333333%;\n  }\n  .ant-col-xl-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-xl-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-xl-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-xl-order-11 {\n    order: 11;\n  }\n  .ant-col-xl-10 {\n    display: block;\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .ant-col-xl-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-xl-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-xl-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-xl-order-10 {\n    order: 10;\n  }\n  .ant-col-xl-9 {\n    display: block;\n    flex: 0 0 37.5%;\n    max-width: 37.5%;\n  }\n  .ant-col-xl-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-xl-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-xl-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-xl-order-9 {\n    order: 9;\n  }\n  .ant-col-xl-8 {\n    display: block;\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .ant-col-xl-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-xl-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-xl-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-xl-order-8 {\n    order: 8;\n  }\n  .ant-col-xl-7 {\n    display: block;\n    flex: 0 0 29.16666667%;\n    max-width: 29.16666667%;\n  }\n  .ant-col-xl-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-xl-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-xl-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-xl-order-7 {\n    order: 7;\n  }\n  .ant-col-xl-6 {\n    display: block;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .ant-col-xl-push-6 {\n    left: 25%;\n  }\n  .ant-col-xl-pull-6 {\n    right: 25%;\n  }\n  .ant-col-xl-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-xl-order-6 {\n    order: 6;\n  }\n  .ant-col-xl-5 {\n    display: block;\n    flex: 0 0 20.83333333%;\n    max-width: 20.83333333%;\n  }\n  .ant-col-xl-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-xl-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-xl-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-xl-order-5 {\n    order: 5;\n  }\n  .ant-col-xl-4 {\n    display: block;\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .ant-col-xl-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-xl-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-xl-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-xl-order-4 {\n    order: 4;\n  }\n  .ant-col-xl-3 {\n    display: block;\n    flex: 0 0 12.5%;\n    max-width: 12.5%;\n  }\n  .ant-col-xl-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-xl-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-xl-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-xl-order-3 {\n    order: 3;\n  }\n  .ant-col-xl-2 {\n    display: block;\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .ant-col-xl-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-xl-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-xl-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-xl-order-2 {\n    order: 2;\n  }\n  .ant-col-xl-1 {\n    display: block;\n    flex: 0 0 4.16666667%;\n    max-width: 4.16666667%;\n  }\n  .ant-col-xl-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-xl-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-xl-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-xl-order-1 {\n    order: 1;\n  }\n  .ant-col-xl-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-xl-push-0 {\n    left: auto;\n  }\n  .ant-col-xl-pull-0 {\n    right: auto;\n  }\n  .ant-col-xl-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-xl-order-0 {\n    order: 0;\n  }\n  .ant-col-push-0.ant-col-rtl {\n    right: auto;\n  }\n  .ant-col-pull-0.ant-col-rtl {\n    left: auto;\n  }\n  .ant-col-xl-push-0.ant-col-rtl {\n    right: auto;\n  }\n  .ant-col-xl-pull-0.ant-col-rtl {\n    left: auto;\n  }\n  .ant-col-xl-offset-0.ant-col-rtl {\n    margin-right: 0;\n  }\n  .ant-col-xl-push-1.ant-col-rtl {\n    right: 4.16666667%;\n    left: auto;\n  }\n  .ant-col-xl-pull-1.ant-col-rtl {\n    right: auto;\n    left: 4.16666667%;\n  }\n  .ant-col-xl-offset-1.ant-col-rtl {\n    margin-right: 4.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-2.ant-col-rtl {\n    right: 8.33333333%;\n    left: auto;\n  }\n  .ant-col-xl-pull-2.ant-col-rtl {\n    right: auto;\n    left: 8.33333333%;\n  }\n  .ant-col-xl-offset-2.ant-col-rtl {\n    margin-right: 8.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-3.ant-col-rtl {\n    right: 12.5%;\n    left: auto;\n  }\n  .ant-col-xl-pull-3.ant-col-rtl {\n    right: auto;\n    left: 12.5%;\n  }\n  .ant-col-xl-offset-3.ant-col-rtl {\n    margin-right: 12.5%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-4.ant-col-rtl {\n    right: 16.66666667%;\n    left: auto;\n  }\n  .ant-col-xl-pull-4.ant-col-rtl {\n    right: auto;\n    left: 16.66666667%;\n  }\n  .ant-col-xl-offset-4.ant-col-rtl {\n    margin-right: 16.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-5.ant-col-rtl {\n    right: 20.83333333%;\n    left: auto;\n  }\n  .ant-col-xl-pull-5.ant-col-rtl {\n    right: auto;\n    left: 20.83333333%;\n  }\n  .ant-col-xl-offset-5.ant-col-rtl {\n    margin-right: 20.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-6.ant-col-rtl {\n    right: 25%;\n    left: auto;\n  }\n  .ant-col-xl-pull-6.ant-col-rtl {\n    right: auto;\n    left: 25%;\n  }\n  .ant-col-xl-offset-6.ant-col-rtl {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-7.ant-col-rtl {\n    right: 29.16666667%;\n    left: auto;\n  }\n  .ant-col-xl-pull-7.ant-col-rtl {\n    right: auto;\n    left: 29.16666667%;\n  }\n  .ant-col-xl-offset-7.ant-col-rtl {\n    margin-right: 29.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-8.ant-col-rtl {\n    right: 33.33333333%;\n    left: auto;\n  }\n  .ant-col-xl-pull-8.ant-col-rtl {\n    right: auto;\n    left: 33.33333333%;\n  }\n  .ant-col-xl-offset-8.ant-col-rtl {\n    margin-right: 33.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-9.ant-col-rtl {\n    right: 37.5%;\n    left: auto;\n  }\n  .ant-col-xl-pull-9.ant-col-rtl {\n    right: auto;\n    left: 37.5%;\n  }\n  .ant-col-xl-offset-9.ant-col-rtl {\n    margin-right: 37.5%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-10.ant-col-rtl {\n    right: 41.66666667%;\n    left: auto;\n  }\n  .ant-col-xl-pull-10.ant-col-rtl {\n    right: auto;\n    left: 41.66666667%;\n  }\n  .ant-col-xl-offset-10.ant-col-rtl {\n    margin-right: 41.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-11.ant-col-rtl {\n    right: 45.83333333%;\n    left: auto;\n  }\n  .ant-col-xl-pull-11.ant-col-rtl {\n    right: auto;\n    left: 45.83333333%;\n  }\n  .ant-col-xl-offset-11.ant-col-rtl {\n    margin-right: 45.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-12.ant-col-rtl {\n    right: 50%;\n    left: auto;\n  }\n  .ant-col-xl-pull-12.ant-col-rtl {\n    right: auto;\n    left: 50%;\n  }\n  .ant-col-xl-offset-12.ant-col-rtl {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-13.ant-col-rtl {\n    right: 54.16666667%;\n    left: auto;\n  }\n  .ant-col-xl-pull-13.ant-col-rtl {\n    right: auto;\n    left: 54.16666667%;\n  }\n  .ant-col-xl-offset-13.ant-col-rtl {\n    margin-right: 54.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-14.ant-col-rtl {\n    right: 58.33333333%;\n    left: auto;\n  }\n  .ant-col-xl-pull-14.ant-col-rtl {\n    right: auto;\n    left: 58.33333333%;\n  }\n  .ant-col-xl-offset-14.ant-col-rtl {\n    margin-right: 58.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-15.ant-col-rtl {\n    right: 62.5%;\n    left: auto;\n  }\n  .ant-col-xl-pull-15.ant-col-rtl {\n    right: auto;\n    left: 62.5%;\n  }\n  .ant-col-xl-offset-15.ant-col-rtl {\n    margin-right: 62.5%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-16.ant-col-rtl {\n    right: 66.66666667%;\n    left: auto;\n  }\n  .ant-col-xl-pull-16.ant-col-rtl {\n    right: auto;\n    left: 66.66666667%;\n  }\n  .ant-col-xl-offset-16.ant-col-rtl {\n    margin-right: 66.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-17.ant-col-rtl {\n    right: 70.83333333%;\n    left: auto;\n  }\n  .ant-col-xl-pull-17.ant-col-rtl {\n    right: auto;\n    left: 70.83333333%;\n  }\n  .ant-col-xl-offset-17.ant-col-rtl {\n    margin-right: 70.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-18.ant-col-rtl {\n    right: 75%;\n    left: auto;\n  }\n  .ant-col-xl-pull-18.ant-col-rtl {\n    right: auto;\n    left: 75%;\n  }\n  .ant-col-xl-offset-18.ant-col-rtl {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-19.ant-col-rtl {\n    right: 79.16666667%;\n    left: auto;\n  }\n  .ant-col-xl-pull-19.ant-col-rtl {\n    right: auto;\n    left: 79.16666667%;\n  }\n  .ant-col-xl-offset-19.ant-col-rtl {\n    margin-right: 79.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-20.ant-col-rtl {\n    right: 83.33333333%;\n    left: auto;\n  }\n  .ant-col-xl-pull-20.ant-col-rtl {\n    right: auto;\n    left: 83.33333333%;\n  }\n  .ant-col-xl-offset-20.ant-col-rtl {\n    margin-right: 83.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-21.ant-col-rtl {\n    right: 87.5%;\n    left: auto;\n  }\n  .ant-col-xl-pull-21.ant-col-rtl {\n    right: auto;\n    left: 87.5%;\n  }\n  .ant-col-xl-offset-21.ant-col-rtl {\n    margin-right: 87.5%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-22.ant-col-rtl {\n    right: 91.66666667%;\n    left: auto;\n  }\n  .ant-col-xl-pull-22.ant-col-rtl {\n    right: auto;\n    left: 91.66666667%;\n  }\n  .ant-col-xl-offset-22.ant-col-rtl {\n    margin-right: 91.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-23.ant-col-rtl {\n    right: 95.83333333%;\n    left: auto;\n  }\n  .ant-col-xl-pull-23.ant-col-rtl {\n    right: auto;\n    left: 95.83333333%;\n  }\n  .ant-col-xl-offset-23.ant-col-rtl {\n    margin-right: 95.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-xl-push-24.ant-col-rtl {\n    right: 100%;\n    left: auto;\n  }\n  .ant-col-xl-pull-24.ant-col-rtl {\n    right: auto;\n    left: 100%;\n  }\n  .ant-col-xl-offset-24.ant-col-rtl {\n    margin-right: 100%;\n    margin-left: 0;\n  }\n}\n@media (min-width: 1600px) {\n  .ant-col-xxl-24 {\n    display: block;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .ant-col-xxl-push-24 {\n    left: 100%;\n  }\n  .ant-col-xxl-pull-24 {\n    right: 100%;\n  }\n  .ant-col-xxl-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-xxl-order-24 {\n    order: 24;\n  }\n  .ant-col-xxl-23 {\n    display: block;\n    flex: 0 0 95.83333333%;\n    max-width: 95.83333333%;\n  }\n  .ant-col-xxl-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-xxl-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-xxl-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-xxl-order-23 {\n    order: 23;\n  }\n  .ant-col-xxl-22 {\n    display: block;\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .ant-col-xxl-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-xxl-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-xxl-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-xxl-order-22 {\n    order: 22;\n  }\n  .ant-col-xxl-21 {\n    display: block;\n    flex: 0 0 87.5%;\n    max-width: 87.5%;\n  }\n  .ant-col-xxl-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-xxl-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-xxl-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-xxl-order-21 {\n    order: 21;\n  }\n  .ant-col-xxl-20 {\n    display: block;\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .ant-col-xxl-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-xxl-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-xxl-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-xxl-order-20 {\n    order: 20;\n  }\n  .ant-col-xxl-19 {\n    display: block;\n    flex: 0 0 79.16666667%;\n    max-width: 79.16666667%;\n  }\n  .ant-col-xxl-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-xxl-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-xxl-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-xxl-order-19 {\n    order: 19;\n  }\n  .ant-col-xxl-18 {\n    display: block;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .ant-col-xxl-push-18 {\n    left: 75%;\n  }\n  .ant-col-xxl-pull-18 {\n    right: 75%;\n  }\n  .ant-col-xxl-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-xxl-order-18 {\n    order: 18;\n  }\n  .ant-col-xxl-17 {\n    display: block;\n    flex: 0 0 70.83333333%;\n    max-width: 70.83333333%;\n  }\n  .ant-col-xxl-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-xxl-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-xxl-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-xxl-order-17 {\n    order: 17;\n  }\n  .ant-col-xxl-16 {\n    display: block;\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .ant-col-xxl-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-xxl-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-xxl-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-xxl-order-16 {\n    order: 16;\n  }\n  .ant-col-xxl-15 {\n    display: block;\n    flex: 0 0 62.5%;\n    max-width: 62.5%;\n  }\n  .ant-col-xxl-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-xxl-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-xxl-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-xxl-order-15 {\n    order: 15;\n  }\n  .ant-col-xxl-14 {\n    display: block;\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .ant-col-xxl-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-xxl-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-xxl-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-xxl-order-14 {\n    order: 14;\n  }\n  .ant-col-xxl-13 {\n    display: block;\n    flex: 0 0 54.16666667%;\n    max-width: 54.16666667%;\n  }\n  .ant-col-xxl-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-xxl-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-xxl-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-xxl-order-13 {\n    order: 13;\n  }\n  .ant-col-xxl-12 {\n    display: block;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .ant-col-xxl-push-12 {\n    left: 50%;\n  }\n  .ant-col-xxl-pull-12 {\n    right: 50%;\n  }\n  .ant-col-xxl-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-xxl-order-12 {\n    order: 12;\n  }\n  .ant-col-xxl-11 {\n    display: block;\n    flex: 0 0 45.83333333%;\n    max-width: 45.83333333%;\n  }\n  .ant-col-xxl-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-xxl-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-xxl-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-xxl-order-11 {\n    order: 11;\n  }\n  .ant-col-xxl-10 {\n    display: block;\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .ant-col-xxl-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-xxl-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-xxl-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-xxl-order-10 {\n    order: 10;\n  }\n  .ant-col-xxl-9 {\n    display: block;\n    flex: 0 0 37.5%;\n    max-width: 37.5%;\n  }\n  .ant-col-xxl-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-xxl-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-xxl-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-xxl-order-9 {\n    order: 9;\n  }\n  .ant-col-xxl-8 {\n    display: block;\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .ant-col-xxl-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-xxl-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-xxl-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-xxl-order-8 {\n    order: 8;\n  }\n  .ant-col-xxl-7 {\n    display: block;\n    flex: 0 0 29.16666667%;\n    max-width: 29.16666667%;\n  }\n  .ant-col-xxl-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-xxl-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-xxl-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-xxl-order-7 {\n    order: 7;\n  }\n  .ant-col-xxl-6 {\n    display: block;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .ant-col-xxl-push-6 {\n    left: 25%;\n  }\n  .ant-col-xxl-pull-6 {\n    right: 25%;\n  }\n  .ant-col-xxl-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-xxl-order-6 {\n    order: 6;\n  }\n  .ant-col-xxl-5 {\n    display: block;\n    flex: 0 0 20.83333333%;\n    max-width: 20.83333333%;\n  }\n  .ant-col-xxl-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-xxl-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-xxl-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-xxl-order-5 {\n    order: 5;\n  }\n  .ant-col-xxl-4 {\n    display: block;\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .ant-col-xxl-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-xxl-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-xxl-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-xxl-order-4 {\n    order: 4;\n  }\n  .ant-col-xxl-3 {\n    display: block;\n    flex: 0 0 12.5%;\n    max-width: 12.5%;\n  }\n  .ant-col-xxl-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-xxl-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-xxl-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-xxl-order-3 {\n    order: 3;\n  }\n  .ant-col-xxl-2 {\n    display: block;\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .ant-col-xxl-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-xxl-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-xxl-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-xxl-order-2 {\n    order: 2;\n  }\n  .ant-col-xxl-1 {\n    display: block;\n    flex: 0 0 4.16666667%;\n    max-width: 4.16666667%;\n  }\n  .ant-col-xxl-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-xxl-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-xxl-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-xxl-order-1 {\n    order: 1;\n  }\n  .ant-col-xxl-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-xxl-push-0 {\n    left: auto;\n  }\n  .ant-col-xxl-pull-0 {\n    right: auto;\n  }\n  .ant-col-xxl-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-xxl-order-0 {\n    order: 0;\n  }\n  .ant-col-push-0.ant-col-rtl {\n    right: auto;\n  }\n  .ant-col-pull-0.ant-col-rtl {\n    left: auto;\n  }\n  .ant-col-xxl-push-0.ant-col-rtl {\n    right: auto;\n  }\n  .ant-col-xxl-pull-0.ant-col-rtl {\n    left: auto;\n  }\n  .ant-col-xxl-offset-0.ant-col-rtl {\n    margin-right: 0;\n  }\n  .ant-col-xxl-push-1.ant-col-rtl {\n    right: 4.16666667%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-1.ant-col-rtl {\n    right: auto;\n    left: 4.16666667%;\n  }\n  .ant-col-xxl-offset-1.ant-col-rtl {\n    margin-right: 4.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-2.ant-col-rtl {\n    right: 8.33333333%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-2.ant-col-rtl {\n    right: auto;\n    left: 8.33333333%;\n  }\n  .ant-col-xxl-offset-2.ant-col-rtl {\n    margin-right: 8.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-3.ant-col-rtl {\n    right: 12.5%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-3.ant-col-rtl {\n    right: auto;\n    left: 12.5%;\n  }\n  .ant-col-xxl-offset-3.ant-col-rtl {\n    margin-right: 12.5%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-4.ant-col-rtl {\n    right: 16.66666667%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-4.ant-col-rtl {\n    right: auto;\n    left: 16.66666667%;\n  }\n  .ant-col-xxl-offset-4.ant-col-rtl {\n    margin-right: 16.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-5.ant-col-rtl {\n    right: 20.83333333%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-5.ant-col-rtl {\n    right: auto;\n    left: 20.83333333%;\n  }\n  .ant-col-xxl-offset-5.ant-col-rtl {\n    margin-right: 20.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-6.ant-col-rtl {\n    right: 25%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-6.ant-col-rtl {\n    right: auto;\n    left: 25%;\n  }\n  .ant-col-xxl-offset-6.ant-col-rtl {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-7.ant-col-rtl {\n    right: 29.16666667%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-7.ant-col-rtl {\n    right: auto;\n    left: 29.16666667%;\n  }\n  .ant-col-xxl-offset-7.ant-col-rtl {\n    margin-right: 29.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-8.ant-col-rtl {\n    right: 33.33333333%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-8.ant-col-rtl {\n    right: auto;\n    left: 33.33333333%;\n  }\n  .ant-col-xxl-offset-8.ant-col-rtl {\n    margin-right: 33.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-9.ant-col-rtl {\n    right: 37.5%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-9.ant-col-rtl {\n    right: auto;\n    left: 37.5%;\n  }\n  .ant-col-xxl-offset-9.ant-col-rtl {\n    margin-right: 37.5%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-10.ant-col-rtl {\n    right: 41.66666667%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-10.ant-col-rtl {\n    right: auto;\n    left: 41.66666667%;\n  }\n  .ant-col-xxl-offset-10.ant-col-rtl {\n    margin-right: 41.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-11.ant-col-rtl {\n    right: 45.83333333%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-11.ant-col-rtl {\n    right: auto;\n    left: 45.83333333%;\n  }\n  .ant-col-xxl-offset-11.ant-col-rtl {\n    margin-right: 45.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-12.ant-col-rtl {\n    right: 50%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-12.ant-col-rtl {\n    right: auto;\n    left: 50%;\n  }\n  .ant-col-xxl-offset-12.ant-col-rtl {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-13.ant-col-rtl {\n    right: 54.16666667%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-13.ant-col-rtl {\n    right: auto;\n    left: 54.16666667%;\n  }\n  .ant-col-xxl-offset-13.ant-col-rtl {\n    margin-right: 54.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-14.ant-col-rtl {\n    right: 58.33333333%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-14.ant-col-rtl {\n    right: auto;\n    left: 58.33333333%;\n  }\n  .ant-col-xxl-offset-14.ant-col-rtl {\n    margin-right: 58.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-15.ant-col-rtl {\n    right: 62.5%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-15.ant-col-rtl {\n    right: auto;\n    left: 62.5%;\n  }\n  .ant-col-xxl-offset-15.ant-col-rtl {\n    margin-right: 62.5%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-16.ant-col-rtl {\n    right: 66.66666667%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-16.ant-col-rtl {\n    right: auto;\n    left: 66.66666667%;\n  }\n  .ant-col-xxl-offset-16.ant-col-rtl {\n    margin-right: 66.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-17.ant-col-rtl {\n    right: 70.83333333%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-17.ant-col-rtl {\n    right: auto;\n    left: 70.83333333%;\n  }\n  .ant-col-xxl-offset-17.ant-col-rtl {\n    margin-right: 70.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-18.ant-col-rtl {\n    right: 75%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-18.ant-col-rtl {\n    right: auto;\n    left: 75%;\n  }\n  .ant-col-xxl-offset-18.ant-col-rtl {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-19.ant-col-rtl {\n    right: 79.16666667%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-19.ant-col-rtl {\n    right: auto;\n    left: 79.16666667%;\n  }\n  .ant-col-xxl-offset-19.ant-col-rtl {\n    margin-right: 79.16666667%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-20.ant-col-rtl {\n    right: 83.33333333%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-20.ant-col-rtl {\n    right: auto;\n    left: 83.33333333%;\n  }\n  .ant-col-xxl-offset-20.ant-col-rtl {\n    margin-right: 83.33333333%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-21.ant-col-rtl {\n    right: 87.5%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-21.ant-col-rtl {\n    right: auto;\n    left: 87.5%;\n  }\n  .ant-col-xxl-offset-21.ant-col-rtl {\n    margin-right: 87.5%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-22.ant-col-rtl {\n    right: 91.66666667%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-22.ant-col-rtl {\n    right: auto;\n    left: 91.66666667%;\n  }\n  .ant-col-xxl-offset-22.ant-col-rtl {\n    margin-right: 91.66666667%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-23.ant-col-rtl {\n    right: 95.83333333%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-23.ant-col-rtl {\n    right: auto;\n    left: 95.83333333%;\n  }\n  .ant-col-xxl-offset-23.ant-col-rtl {\n    margin-right: 95.83333333%;\n    margin-left: 0;\n  }\n  .ant-col-xxl-push-24.ant-col-rtl {\n    right: 100%;\n    left: auto;\n  }\n  .ant-col-xxl-pull-24.ant-col-rtl {\n    right: auto;\n    left: 100%;\n  }\n  .ant-col-xxl-offset-24.ant-col-rtl {\n    margin-right: 100%;\n    margin-left: 0;\n  }\n}\n.ant-row-rtl {\n  direction: rtl;\n}\n.ant-image {\n  position: relative;\n  display: inline-block;\n}\n.ant-image-img {\n  width: 100%;\n  height: auto;\n  vertical-align: middle;\n}\n.ant-image-img-placeholder {\n  background-color: #f5f5f5;\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=');\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 30%;\n}\n.ant-image-mask {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.5);\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n.ant-image-mask-info {\n  padding: 0 4px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-image-mask-info .anticon {\n  margin-inline-end: 4px;\n}\n.ant-image-mask:hover {\n  opacity: 1;\n}\n.ant-image-placeholder {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.ant-image-preview {\n  pointer-events: none;\n  height: 100%;\n  text-align: center;\n}\n.ant-image-preview.ant-zoom-enter,\n.ant-image-preview.ant-zoom-appear {\n  transform: none;\n  opacity: 0;\n  animation-duration: 0.3s;\n  user-select: none;\n}\n.ant-image-preview-mask {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.45);\n}\n.ant-image-preview-mask-hidden {\n  display: none;\n}\n.ant-image-preview-wrap {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: auto;\n  outline: 0;\n}\n.ant-image-preview-body {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n}\n.ant-image-preview-img {\n  max-width: 100%;\n  max-height: 100%;\n  vertical-align: middle;\n  transform: scale3d(1, 1, 1);\n  cursor: grab;\n  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  user-select: none;\n  pointer-events: auto;\n}\n.ant-image-preview-img-wrapper {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n}\n.ant-image-preview-img-wrapper::before {\n  display: inline-block;\n  width: 1px;\n  height: 50%;\n  margin-right: -1px;\n  content: '';\n}\n.ant-image-preview-moving .ant-image-preview-img {\n  cursor: grabbing;\n}\n.ant-image-preview-moving .ant-image-preview-img-wrapper {\n  transition-duration: 0s;\n}\n.ant-image-preview-wrap {\n  z-index: 1080;\n}\n.ant-image-preview-operations-wrapper {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1081;\n  width: 100%;\n}\n.ant-image-preview-operations {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  font-feature-settings: 'tnum';\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  color: rgba(255, 255, 255, 0.85);\n  list-style: none;\n  background: rgba(0, 0, 0, 0.1);\n  pointer-events: auto;\n}\n.ant-image-preview-operations-operation {\n  margin-left: 12px;\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-image-preview-operations-operation:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n.ant-image-preview-operations-operation-disabled {\n  color: rgba(255, 255, 255, 0.25);\n  pointer-events: none;\n}\n.ant-image-preview-operations-operation:last-of-type {\n  margin-left: 0;\n}\n.ant-image-preview-operations-progress {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.ant-image-preview-operations-icon {\n  font-size: 18px;\n}\n.ant-image-preview-switch-left,\n.ant-image-preview-switch-right {\n  position: fixed;\n  top: 50%;\n  right: 8px;\n  z-index: 1081;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  color: rgba(255, 255, 255, 0.85);\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  transition: all 0.3s;\n  pointer-events: auto;\n}\n.ant-image-preview-switch-left:hover,\n.ant-image-preview-switch-right:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n.ant-image-preview-switch-left-disabled,\n.ant-image-preview-switch-right-disabled,\n.ant-image-preview-switch-left-disabled:hover,\n.ant-image-preview-switch-right-disabled:hover {\n  color: rgba(255, 255, 255, 0.25);\n  background: rgba(0, 0, 0, 0.1);\n  cursor: not-allowed;\n}\n.ant-image-preview-switch-left-disabled > .anticon,\n.ant-image-preview-switch-right-disabled > .anticon,\n.ant-image-preview-switch-left-disabled:hover > .anticon,\n.ant-image-preview-switch-right-disabled:hover > .anticon {\n  cursor: not-allowed;\n}\n.ant-image-preview-switch-left > .anticon,\n.ant-image-preview-switch-right > .anticon {\n  font-size: 18px;\n}\n.ant-image-preview-switch-left {\n  left: 8px;\n}\n.ant-image-preview-switch-right {\n  right: 8px;\n}\n.ant-input-affix-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  min-width: 0;\n  padding: 7.9px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n  display: inline-flex;\n}\n.ant-input-affix-wrapper::placeholder {\n  color: #bfbfbf;\n  user-select: none;\n}\n.ant-input-affix-wrapper:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input-affix-wrapper:hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-input-affix-wrapper:hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input-affix-wrapper:focus,\n.ant-input-affix-wrapper-focused {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-input-affix-wrapper:focus,\n.ant-input-rtl .ant-input-affix-wrapper-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input-affix-wrapper-disabled {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-affix-wrapper-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-input-affix-wrapper[disabled] {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-affix-wrapper[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-input-affix-wrapper-borderless,\n.ant-input-affix-wrapper-borderless:hover,\n.ant-input-affix-wrapper-borderless:focus,\n.ant-input-affix-wrapper-borderless-focused,\n.ant-input-affix-wrapper-borderless-disabled,\n.ant-input-affix-wrapper-borderless[disabled] {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\ntextarea.ant-input-affix-wrapper {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-input-affix-wrapper-lg {\n  padding: 8.6px 11px;\n  font-size: 16px;\n}\n.ant-input-affix-wrapper-sm {\n  padding: 1.9px 7px;\n}\n.ant-input-affix-wrapper-rtl {\n  direction: rtl;\n}\n.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n  z-index: 1;\n}\n.ant-input-rtl .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input-search-with-button .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n  z-index: 0;\n}\n.ant-input-affix-wrapper-focused,\n.ant-input-affix-wrapper:focus {\n  z-index: 1;\n}\n.ant-input-affix-wrapper-disabled .ant-input[disabled] {\n  background: rgba(255, 255, 255, 0);\n}\n.ant-input-affix-wrapper > .ant-input {\n  font-size: inherit;\n  border: none;\n  outline: none;\n}\n.ant-input-affix-wrapper > .ant-input:focus {\n  box-shadow: none !important;\n}\n.ant-input-affix-wrapper > .ant-input:not(textarea) {\n  padding: 0;\n}\n.ant-input-affix-wrapper::before {\n  display: inline-block;\n  width: 0;\n  visibility: hidden;\n  content: '\\a0';\n}\n.ant-input-prefix,\n.ant-input-suffix {\n  display: flex;\n  flex: none;\n  align-items: center;\n}\n.ant-input-prefix > *:not(:last-child),\n.ant-input-suffix > *:not(:last-child) {\n  margin-right: 8px;\n}\n.ant-input-show-count-suffix {\n  color: #595959;\n}\n.ant-input-show-count-has-suffix {\n  margin-right: 2px;\n}\n.ant-input-prefix {\n  margin-right: 4px;\n}\n.ant-input-suffix {\n  margin-left: 4px;\n}\n.anticon.ant-input-clear-icon,\n.ant-input-clear-icon {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  vertical-align: -1px;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n.anticon.ant-input-clear-icon:hover,\n.ant-input-clear-icon:hover {\n  color: #595959;\n}\n.anticon.ant-input-clear-icon:active,\n.ant-input-clear-icon:active {\n  color: #545454;\n}\n.anticon.ant-input-clear-icon-hidden,\n.ant-input-clear-icon-hidden {\n  visibility: hidden;\n}\n.anticon.ant-input-clear-icon-has-suffix,\n.ant-input-clear-icon-has-suffix {\n  margin: 0 4px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn {\n  padding: 0;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn .ant-input-clear-icon {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 1;\n}\n.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input,\n.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {\n  background: #fff;\n  border-color: #f5222d;\n}\n.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus,\n.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-focused {\n  border-color: #ff4d4f;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-status-error .ant-input-prefix {\n  color: #f5222d;\n}\n.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input,\n.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {\n  background: #fff;\n  border-color: #fa8c16;\n}\n.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus,\n.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-focused {\n  border-color: #ffa940;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-status-warning .ant-input-prefix {\n  color: #fa8c16;\n}\n.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,\n.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {\n  background: #fff;\n  border-color: #f5222d;\n}\n.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:focus,\n.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused {\n  border-color: #ff4d4f;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-affix-wrapper-status-error .ant-input-prefix {\n  color: #f5222d;\n}\n.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,\n.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {\n  background: #fff;\n  border-color: #fa8c16;\n}\n.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:focus,\n.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused {\n  border-color: #ffa940;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-affix-wrapper-status-warning .ant-input-prefix {\n  color: #fa8c16;\n}\n.ant-input-textarea-status-error.ant-input-textarea-has-feedback .ant-input,\n.ant-input-textarea-status-warning.ant-input-textarea-has-feedback .ant-input,\n.ant-input-textarea-status-success.ant-input-textarea-has-feedback .ant-input,\n.ant-input-textarea-status-validating.ant-input-textarea-has-feedback .ant-input {\n  padding-right: 24px;\n}\n.ant-input-group-wrapper-status-error .ant-input-group-addon {\n  color: #f5222d;\n  border-color: #f5222d;\n}\n.ant-input-group-wrapper-status-warning .ant-input-group-addon {\n  color: #fa8c16;\n  border-color: #fa8c16;\n}\n.ant-input {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  min-width: 0;\n  padding: 7.9px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n}\n.ant-input::placeholder {\n  color: #bfbfbf;\n  user-select: none;\n}\n.ant-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input:hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-input:hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input:focus,\n.ant-input-focused {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-input:focus,\n.ant-input-rtl .ant-input-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input-disabled {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-input[disabled] {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-input-borderless,\n.ant-input-borderless:hover,\n.ant-input-borderless:focus,\n.ant-input-borderless-focused,\n.ant-input-borderless-disabled,\n.ant-input-borderless[disabled] {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\ntextarea.ant-input {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-input-lg {\n  padding: 8.6px 11px;\n  font-size: 16px;\n}\n.ant-input-sm {\n  padding: 1.9px 7px;\n}\n.ant-input-rtl {\n  direction: rtl;\n}\n.ant-input-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.ant-input-group[class*='col-'] {\n  float: none;\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-input-group > [class*='col-'] {\n  padding-right: 8px;\n}\n.ant-input-group > [class*='col-']:last-child {\n  padding-right: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap,\n.ant-input-group > .ant-input {\n  display: table-cell;\n}\n.ant-input-group-addon:not(:first-child):not(:last-child),\n.ant-input-group-wrap:not(:first-child):not(:last-child),\n.ant-input-group > .ant-input:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap {\n  width: 1px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.ant-input-group-wrap > * {\n  display: block !important;\n}\n.ant-input-group .ant-input {\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n  text-align: inherit;\n}\n.ant-input-group .ant-input:focus {\n  z-index: 1;\n  border-right-width: 1px;\n}\n.ant-input-group .ant-input:hover {\n  z-index: 1;\n  border-right-width: 1px;\n}\n.ant-input-search-with-button .ant-input-group .ant-input:hover {\n  z-index: 0;\n}\n.ant-input-group-addon {\n  position: relative;\n  padding: 0 11px;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n  text-align: center;\n  background-color: #fafafa;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n}\n.ant-input-group-addon .ant-select {\n  margin: -8.9px -11px;\n}\n.ant-input-group-addon .ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  background-color: inherit;\n  border: 1px solid transparent;\n  box-shadow: none;\n}\n.ant-input-group-addon .ant-select-open .ant-select-selector,\n.ant-input-group-addon .ant-select-focused .ant-select-selector {\n  color: #351a55;\n}\n.ant-input-group-addon .ant-cascader-picker {\n  margin: -9px -12px;\n  background-color: transparent;\n}\n.ant-input-group-addon .ant-cascader-picker .ant-cascader-input {\n  text-align: left;\n  border: 0;\n  box-shadow: none;\n}\n.ant-input-group > .ant-input:first-child,\n.ant-input-group-addon:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-group > .ant-input:first-child .ant-select .ant-select-selector,\n.ant-input-group-addon:first-child .ant-select .ant-select-selector {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-group-addon:first-child {\n  border-right: 0;\n}\n.ant-input-group-addon:last-child {\n  border-left: 0;\n}\n.ant-input-group > .ant-input:last-child,\n.ant-input-group-addon:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-group > .ant-input:last-child .ant-select .ant-select-selector,\n.ant-input-group-addon:last-child .ant-select .ant-select-selector {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-group-lg .ant-input,\n.ant-input-group-lg > .ant-input-group-addon {\n  padding: 8.6px 11px;\n  font-size: 16px;\n}\n.ant-input-group-sm .ant-input,\n.ant-input-group-sm > .ant-input-group-addon {\n  padding: 1.9px 7px;\n}\n.ant-input-group-lg .ant-select-single .ant-select-selector {\n  height: 40px;\n}\n.ant-input-group-sm .ant-select-single .ant-select-selector {\n  height: 24px;\n}\n.ant-input-group .ant-input-affix-wrapper:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:last-child) {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.ant-input-group .ant-input-affix-wrapper:not(:first-child),\n.ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-group.ant-input-group-compact {\n  display: block;\n}\n.ant-input-group.ant-input-group-compact::before {\n  display: table;\n  content: '';\n}\n.ant-input-group.ant-input-group-compact::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-input-group.ant-input-group-compact::before {\n  display: table;\n  content: '';\n}\n.ant-input-group.ant-input-group-compact::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child),\n.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child),\n.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child) {\n  border-right-width: 1px;\n}\n.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):hover,\n.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):hover,\n.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):hover {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):focus,\n.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):focus,\n.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):focus {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > * {\n  display: inline-block;\n  float: none;\n  vertical-align: top;\n  border-radius: 0;\n}\n.ant-input-group.ant-input-group-compact > .ant-input-affix-wrapper,\n.ant-input-group.ant-input-group-compact > .ant-input-number-affix-wrapper,\n.ant-input-group.ant-input-group-compact > .ant-picker-range {\n  display: inline-flex;\n}\n.ant-input-group.ant-input-group-compact > *:not(:last-child) {\n  margin-right: -1px;\n  border-right-width: 1px;\n}\n.ant-input-group.ant-input-group-compact .ant-input {\n  float: none;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input {\n  border-right-width: 1px;\n  border-radius: 0;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector:hover,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:hover,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:hover,\n.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:hover {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector:focus,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:focus,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:focus,\n.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:focus {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > .ant-select-focused {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-arrow {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > *:first-child,\n.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selector,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.ant-input-group.ant-input-group-compact > *:last-child,\n.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selector,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input {\n  border-right-width: 1px;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input {\n  vertical-align: top;\n}\n.ant-input-group.ant-input-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper {\n  margin-left: -1px;\n}\n.ant-input-group.ant-input-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper .ant-input-affix-wrapper {\n  border-radius: 0;\n}\n.ant-input-group.ant-input-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input-group-addon > .ant-input-search-button {\n  border-radius: 0;\n}\n.ant-input-group.ant-input-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input {\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-group > .ant-input-rtl:first-child,\n.ant-input-group-rtl .ant-input-group-addon:first-child {\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-group-rtl .ant-input-group-addon:first-child {\n  border-right: 1px solid #d9d9d9;\n  border-left: 0;\n}\n.ant-input-group-rtl .ant-input-group-addon:last-child {\n  border-right: 0;\n  border-left: 1px solid #d9d9d9;\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-group-rtl.ant-input-group > .ant-input:last-child,\n.ant-input-group-rtl.ant-input-group-addon:last-child {\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-group-rtl.ant-input-group .ant-input-affix-wrapper:not(:first-child) {\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-group-rtl.ant-input-group .ant-input-affix-wrapper:not(:last-child) {\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-group-rtl.ant-input-group.ant-input-group-compact > *:not(:last-child) {\n  margin-right: 0;\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n.ant-input-group-rtl.ant-input-group.ant-input-group-compact > *:first-child,\n.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selector,\n.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,\n.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input {\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-group-rtl.ant-input-group.ant-input-group-compact > *:last-child,\n.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selector,\n.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,\n.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,\n.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input {\n  border-left-width: 1px;\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-group.ant-input-group-compact .ant-input-group-wrapper-rtl + .ant-input-group-wrapper-rtl {\n  margin-right: -1px;\n  margin-left: 0;\n}\n.ant-input-group.ant-input-group-compact .ant-input-group-wrapper-rtl:not(:last-child).ant-input-search > .ant-input-group > .ant-input {\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-group > .ant-input-rtl:first-child {\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-group > .ant-input-rtl:last-child {\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-group-rtl .ant-input-group-addon:first-child {\n  border-right: 1px solid #d9d9d9;\n  border-left: 0;\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-group-rtl .ant-input-group-addon:last-child {\n  border-right: 0;\n  border-left: 1px solid #d9d9d9;\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-group-wrapper {\n  display: inline-block;\n  width: 100%;\n  text-align: start;\n  vertical-align: top;\n}\n.ant-input-password-icon.anticon {\n  color: #595959;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-input-password-icon.anticon:hover {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-input[type='color'] {\n  height: 36px;\n}\n.ant-input[type='color'].ant-input-lg {\n  height: 40px;\n}\n.ant-input[type='color'].ant-input-sm {\n  height: 24px;\n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n.ant-input-textarea-show-count > .ant-input {\n  height: 100%;\n}\n.ant-input-textarea-show-count::after {\n  float: right;\n  color: #595959;\n  white-space: nowrap;\n  content: attr(data-count);\n  pointer-events: none;\n}\n.ant-input-textarea-show-count.ant-input-textarea-in-form-item::after {\n  margin-bottom: -22px;\n}\n.ant-input-textarea-suffix {\n  position: absolute;\n  top: 0;\n  right: 11px;\n  bottom: 0;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  margin: auto;\n}\n.ant-input-compact-item:not(.ant-input-compact-last-item):not(.ant-input-compact-item-rtl) {\n  margin-right: -1px;\n}\n.ant-input-compact-item:not(.ant-input-compact-last-item).ant-input-compact-item-rtl {\n  margin-left: -1px;\n}\n.ant-input-compact-item:hover,\n.ant-input-compact-item:focus,\n.ant-input-compact-item:active {\n  z-index: 2;\n}\n.ant-input-compact-item[disabled] {\n  z-index: 0;\n}\n.ant-input-compact-item:not(.ant-input-compact-first-item):not(.ant-input-compact-last-item).ant-input {\n  border-radius: 0;\n}\n.ant-input-compact-item.ant-input.ant-input-compact-first-item:not(.ant-input-compact-last-item):not(.ant-input-compact-item-rtl) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-compact-item.ant-input.ant-input-compact-last-item:not(.ant-input-compact-first-item):not(.ant-input-compact-item-rtl) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-compact-item.ant-input.ant-input-compact-item-rtl.ant-input-compact-first-item:not(.ant-input-compact-last-item) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-compact-item.ant-input.ant-input-compact-item-rtl.ant-input-compact-last-item:not(.ant-input-compact-first-item) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-search .ant-input:hover,\n.ant-input-search .ant-input:focus {\n  border-color: #462e61;\n}\n.ant-input-search .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary),\n.ant-input-search .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary) {\n  border-left-color: #462e61;\n}\n.ant-input-search .ant-input-affix-wrapper {\n  border-radius: 0;\n}\n.ant-input-search .ant-input-lg {\n  line-height: 1.2998;\n}\n.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {\n  left: -1px;\n  padding: 0;\n  border: 0;\n}\n.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {\n  padding-top: 0;\n  padding-bottom: 0;\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button:not(.ant-btn-primary) {\n  color: #595959;\n}\n.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button:not(.ant-btn-primary).ant-btn-loading::before {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.ant-input-search-button {\n  height: 36px;\n}\n.ant-input-search-button:hover,\n.ant-input-search-button:focus {\n  z-index: 1;\n}\n.ant-input-search-large .ant-input-search-button {\n  height: 40px;\n}\n.ant-input-search-small .ant-input-search-button {\n  height: 24px;\n}\n.ant-input-search.ant-input-compact-item:not(.ant-input-compact-item-rtl):not(.ant-input-compact-last-item) .ant-input-group-addon .ant-input-search-button {\n  margin-right: -1px;\n  border-radius: 0;\n}\n.ant-input-search.ant-input-compact-item:not(.ant-input-compact-first-item) .ant-input,\n.ant-input-search.ant-input-compact-item:not(.ant-input-compact-first-item) .ant-input-affix-wrapper {\n  border-radius: 0;\n}\n.ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:hover,\n.ant-input-search.ant-input-compact-item > .ant-input:hover,\n.ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:hover,\n.ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:focus,\n.ant-input-search.ant-input-compact-item > .ant-input:focus,\n.ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:focus,\n.ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:active,\n.ant-input-search.ant-input-compact-item > .ant-input:active,\n.ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:active {\n  z-index: 2;\n}\n.ant-input-search.ant-input-compact-item > .ant-input-affix-wrapper-focused {\n  z-index: 2;\n}\n.ant-input-search.ant-input-compact-item-rtl:not(.ant-input-compact-last-item) .ant-input-group-addon:last-child .ant-input-search-button {\n  margin-left: -1px;\n  border-radius: 0;\n}\n.ant-input-group-wrapper-rtl {\n  direction: rtl;\n}\n.ant-input-group-rtl {\n  direction: rtl;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-rtl > input.ant-input {\n  border: none;\n  outline: none;\n}\n.ant-input-affix-wrapper-rtl .ant-input-prefix {\n  margin: 0 0 0 4px;\n}\n.ant-input-affix-wrapper-rtl .ant-input-suffix {\n  margin: 0 4px 0 0;\n}\n.ant-input-textarea-rtl {\n  direction: rtl;\n}\n.ant-input-textarea-rtl.ant-input-textarea-show-count::after {\n  text-align: left;\n}\n.ant-input-affix-wrapper-rtl .ant-input-clear-icon-has-suffix {\n  margin-right: 0;\n  margin-left: 4px;\n}\n.ant-input-affix-wrapper-rtl .ant-input-clear-icon {\n  right: auto;\n  left: 8px;\n}\n.ant-input-search-rtl {\n  direction: rtl;\n}\n.ant-input-search-rtl .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary),\n.ant-input-search-rtl .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary) {\n  border-left-color: #d9d9d9;\n}\n.ant-input-search-rtl .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary):hover,\n.ant-input-search-rtl .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary):hover {\n  border-left-color: #462e61;\n}\n.ant-input-search-rtl > .ant-input-group > .ant-input-affix-wrapper:hover,\n.ant-input-search-rtl > .ant-input-group > .ant-input-affix-wrapper-focused {\n  border-right-color: #462e61;\n}\n.ant-input-search-rtl > .ant-input-group > .ant-input-group-addon:last-child {\n  right: -1px;\n  left: auto;\n}\n.ant-input-search-rtl > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {\n  border-radius: 6px 0 0 6px;\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ant-input {\n    height: 36px;\n  }\n  .ant-input-lg {\n    height: 40px;\n  }\n  .ant-input-sm {\n    height: 24px;\n  }\n  .ant-input-affix-wrapper > input.ant-input {\n    height: auto;\n  }\n}\n.ant-input-number-affix-wrapper {\n  display: inline-block;\n  width: 100%;\n  min-width: 0;\n  padding: 7.9px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n  position: relative;\n  display: inline-flex;\n  width: 90px;\n  padding: 0;\n  padding-inline-start: 11px;\n}\n.ant-input-number-affix-wrapper::placeholder {\n  color: #bfbfbf;\n  user-select: none;\n}\n.ant-input-number-affix-wrapper:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input-number-affix-wrapper:hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-input-number-affix-wrapper:hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input-number-affix-wrapper:focus,\n.ant-input-number-affix-wrapper-focused {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-input-number-affix-wrapper:focus,\n.ant-input-rtl .ant-input-number-affix-wrapper-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input-number-affix-wrapper-disabled {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number-affix-wrapper-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-input-number-affix-wrapper[disabled] {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number-affix-wrapper[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-input-number-affix-wrapper-borderless,\n.ant-input-number-affix-wrapper-borderless:hover,\n.ant-input-number-affix-wrapper-borderless:focus,\n.ant-input-number-affix-wrapper-borderless-focused,\n.ant-input-number-affix-wrapper-borderless-disabled,\n.ant-input-number-affix-wrapper-borderless[disabled] {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\ntextarea.ant-input-number-affix-wrapper {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-input-number-affix-wrapper-lg {\n  padding: 8.6px 11px;\n  font-size: 16px;\n}\n.ant-input-number-affix-wrapper-sm {\n  padding: 1.9px 7px;\n}\n.ant-input-number-affix-wrapper-rtl {\n  direction: rtl;\n}\n.ant-input-number-affix-wrapper:not(.ant-input-number-affix-wrapper-disabled):hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n  z-index: 1;\n}\n.ant-input-rtl .ant-input-number-affix-wrapper:not(.ant-input-number-affix-wrapper-disabled):hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input-number-affix-wrapper-focused,\n.ant-input-number-affix-wrapper:focus {\n  z-index: 1;\n}\n.ant-input-number-affix-wrapper-disabled .ant-input-number[disabled] {\n  background: transparent;\n}\n.ant-input-number-affix-wrapper > div.ant-input-number {\n  width: 100%;\n  border: none;\n  outline: none;\n}\n.ant-input-number-affix-wrapper > div.ant-input-number.ant-input-number-focused {\n  box-shadow: none !important;\n}\n.ant-input-number-affix-wrapper input.ant-input-number-input {\n  padding: 0;\n}\n.ant-input-number-affix-wrapper::before {\n  display: inline-block;\n  width: 0;\n  visibility: hidden;\n  content: '\\a0';\n}\n.ant-input-number-affix-wrapper .ant-input-number-handler-wrap {\n  z-index: 2;\n}\n.ant-input-number-prefix,\n.ant-input-number-suffix {\n  display: flex;\n  flex: none;\n  align-items: center;\n  pointer-events: none;\n}\n.ant-input-number-prefix {\n  margin-inline-end: 4px;\n}\n.ant-input-number-suffix {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  height: 100%;\n  margin-right: 11px;\n  margin-left: 4px;\n}\n.ant-input-number-group-wrapper .ant-input-number-affix-wrapper {\n  width: 100%;\n}\n.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number,\n.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover {\n  background: #fff;\n  border-color: #f5222d;\n}\n.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:focus,\n.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number-focused {\n  border-color: #ff4d4f;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-number-status-error .ant-input-number-prefix {\n  color: #f5222d;\n}\n.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number,\n.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover {\n  background: #fff;\n  border-color: #fa8c16;\n}\n.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:focus,\n.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number-focused {\n  border-color: #ffa940;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-number-status-warning .ant-input-number-prefix {\n  color: #fa8c16;\n}\n.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper,\n.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:hover {\n  background: #fff;\n  border-color: #f5222d;\n}\n.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:focus,\n.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper-focused {\n  border-color: #ff4d4f;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-number-affix-wrapper-status-error .ant-input-number-prefix {\n  color: #f5222d;\n}\n.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper,\n.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:hover {\n  background: #fff;\n  border-color: #fa8c16;\n}\n.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:focus,\n.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper-focused {\n  border-color: #ffa940;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-number-affix-wrapper-status-warning .ant-input-number-prefix {\n  color: #fa8c16;\n}\n.ant-input-number-group-wrapper-status-error .ant-input-number-group-addon {\n  color: #f5222d;\n  border-color: #f5222d;\n}\n.ant-input-number-group-wrapper-status-warning .ant-input-number-group-addon {\n  color: #fa8c16;\n  border-color: #fa8c16;\n}\n.ant-input-number {\n  box-sizing: border-box;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  width: 100%;\n  min-width: 0;\n  padding: 7.9px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  transition: all 0.3s;\n  display: inline-block;\n  width: 90px;\n  margin: 0;\n  padding: 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n.ant-input-number::placeholder {\n  color: #bfbfbf;\n  user-select: none;\n}\n.ant-input-number:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input-number:hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-input-number:hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input-number:focus,\n.ant-input-number-focused {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-input-number:focus,\n.ant-input-rtl .ant-input-number-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input-number-disabled {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-input-number[disabled] {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-input-number-borderless,\n.ant-input-number-borderless:hover,\n.ant-input-number-borderless:focus,\n.ant-input-number-borderless-focused,\n.ant-input-number-borderless-disabled,\n.ant-input-number-borderless[disabled] {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\ntextarea.ant-input-number {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-input-number-lg {\n  padding: 8.6px 11px;\n  font-size: 16px;\n}\n.ant-input-number-sm {\n  padding: 1.9px 7px;\n}\n.ant-input-number-rtl {\n  direction: rtl;\n}\n.ant-input-number-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.ant-input-number-group[class*='col-'] {\n  float: none;\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-input-number-group > [class*='col-'] {\n  padding-right: 8px;\n}\n.ant-input-number-group > [class*='col-']:last-child {\n  padding-right: 0;\n}\n.ant-input-number-group-addon,\n.ant-input-number-group-wrap,\n.ant-input-number-group > .ant-input-number {\n  display: table-cell;\n}\n.ant-input-number-group-addon:not(:first-child):not(:last-child),\n.ant-input-number-group-wrap:not(:first-child):not(:last-child),\n.ant-input-number-group > .ant-input-number:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.ant-input-number-group-addon,\n.ant-input-number-group-wrap {\n  width: 1px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.ant-input-number-group-wrap > * {\n  display: block !important;\n}\n.ant-input-number-group .ant-input-number {\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n  text-align: inherit;\n}\n.ant-input-number-group .ant-input-number:focus {\n  z-index: 1;\n  border-right-width: 1px;\n}\n.ant-input-number-group .ant-input-number:hover {\n  z-index: 1;\n  border-right-width: 1px;\n}\n.ant-input-search-with-button .ant-input-number-group .ant-input-number:hover {\n  z-index: 0;\n}\n.ant-input-number-group-addon {\n  position: relative;\n  padding: 0 11px;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n  text-align: center;\n  background-color: #fafafa;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n}\n.ant-input-number-group-addon .ant-select {\n  margin: -8.9px -11px;\n}\n.ant-input-number-group-addon .ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  background-color: inherit;\n  border: 1px solid transparent;\n  box-shadow: none;\n}\n.ant-input-number-group-addon .ant-select-open .ant-select-selector,\n.ant-input-number-group-addon .ant-select-focused .ant-select-selector {\n  color: #351a55;\n}\n.ant-input-number-group-addon .ant-cascader-picker {\n  margin: -9px -12px;\n  background-color: transparent;\n}\n.ant-input-number-group-addon .ant-cascader-picker .ant-cascader-input {\n  text-align: left;\n  border: 0;\n  box-shadow: none;\n}\n.ant-input-number-group > .ant-input-number:first-child,\n.ant-input-number-group-addon:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-number-group > .ant-input-number:first-child .ant-select .ant-select-selector,\n.ant-input-number-group-addon:first-child .ant-select .ant-select-selector {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-number-group > .ant-input-number-affix-wrapper:not(:first-child) .ant-input-number {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-number-group > .ant-input-number-affix-wrapper:not(:last-child) .ant-input-number {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-number-group-addon:first-child {\n  border-right: 0;\n}\n.ant-input-number-group-addon:last-child {\n  border-left: 0;\n}\n.ant-input-number-group > .ant-input-number:last-child,\n.ant-input-number-group-addon:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-number-group > .ant-input-number:last-child .ant-select .ant-select-selector,\n.ant-input-number-group-addon:last-child .ant-select .ant-select-selector {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-number-group-lg .ant-input-number,\n.ant-input-number-group-lg > .ant-input-number-group-addon {\n  padding: 8.6px 11px;\n  font-size: 16px;\n}\n.ant-input-number-group-sm .ant-input-number,\n.ant-input-number-group-sm > .ant-input-number-group-addon {\n  padding: 1.9px 7px;\n}\n.ant-input-number-group-lg .ant-select-single .ant-select-selector {\n  height: 40px;\n}\n.ant-input-number-group-sm .ant-select-single .ant-select-selector {\n  height: 24px;\n}\n.ant-input-number-group .ant-input-number-affix-wrapper:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-search .ant-input-number-group .ant-input-number-affix-wrapper:not(:last-child) {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.ant-input-number-group .ant-input-number-affix-wrapper:not(:first-child),\n.ant-input-search .ant-input-number-group .ant-input-number-affix-wrapper:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-number-group.ant-input-number-group-compact {\n  display: block;\n}\n.ant-input-number-group.ant-input-number-group-compact::before {\n  display: table;\n  content: '';\n}\n.ant-input-number-group.ant-input-number-group-compact::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-input-number-group.ant-input-number-group-compact::before {\n  display: table;\n  content: '';\n}\n.ant-input-number-group.ant-input-number-group-compact::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child),\n.ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child),\n.ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child) {\n  border-right-width: 1px;\n}\n.ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child):hover,\n.ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child):hover,\n.ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child):hover {\n  z-index: 1;\n}\n.ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child):focus,\n.ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child):focus,\n.ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child):focus {\n  z-index: 1;\n}\n.ant-input-number-group.ant-input-number-group-compact > * {\n  display: inline-block;\n  float: none;\n  vertical-align: top;\n  border-radius: 0;\n}\n.ant-input-number-group.ant-input-number-group-compact > .ant-input-number-affix-wrapper,\n.ant-input-number-group.ant-input-number-group-compact > .ant-input-number-number-affix-wrapper,\n.ant-input-number-group.ant-input-number-group-compact > .ant-picker-range {\n  display: inline-flex;\n}\n.ant-input-number-group.ant-input-number-group-compact > *:not(:last-child) {\n  margin-right: -1px;\n  border-right-width: 1px;\n}\n.ant-input-number-group.ant-input-number-group-compact .ant-input-number {\n  float: none;\n}\n.ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector,\n.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input,\n.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input,\n.ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input {\n  border-right-width: 1px;\n  border-radius: 0;\n}\n.ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector:hover,\n.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input:hover,\n.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input:hover,\n.ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input:hover {\n  z-index: 1;\n}\n.ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector:focus,\n.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input:focus,\n.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input:focus,\n.ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input:focus {\n  z-index: 1;\n}\n.ant-input-number-group.ant-input-number-group-compact > .ant-select-focused {\n  z-index: 1;\n}\n.ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-arrow {\n  z-index: 1;\n}\n.ant-input-number-group.ant-input-number-group-compact > *:first-child,\n.ant-input-number-group.ant-input-number-group-compact > .ant-select:first-child > .ant-select-selector,\n.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete:first-child .ant-input,\n.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:first-child .ant-input {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.ant-input-number-group.ant-input-number-group-compact > *:last-child,\n.ant-input-number-group.ant-input-number-group-compact > .ant-select:last-child > .ant-select-selector,\n.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:last-child .ant-input,\n.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker-focused:last-child .ant-input {\n  border-right-width: 1px;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input {\n  vertical-align: top;\n}\n.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper {\n  margin-left: -1px;\n}\n.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper .ant-input-affix-wrapper {\n  border-radius: 0;\n}\n.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input-group-addon > .ant-input-search-button {\n  border-radius: 0;\n}\n.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input {\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-number-group > .ant-input-number-rtl:first-child,\n.ant-input-number-group-rtl .ant-input-number-group-addon:first-child {\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-number-group-rtl .ant-input-number-group-addon:first-child {\n  border-right: 1px solid #d9d9d9;\n  border-left: 0;\n}\n.ant-input-number-group-rtl .ant-input-number-group-addon:last-child {\n  border-right: 0;\n  border-left: 1px solid #d9d9d9;\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-number-group-rtl.ant-input-number-group > .ant-input-number:last-child,\n.ant-input-number-group-rtl.ant-input-number-group-addon:last-child {\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-number-group-rtl.ant-input-number-group .ant-input-number-affix-wrapper:not(:first-child) {\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-number-group-rtl.ant-input-number-group .ant-input-number-affix-wrapper:not(:last-child) {\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > *:not(:last-child) {\n  margin-right: 0;\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > *:first-child,\n.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-select:first-child > .ant-select-selector,\n.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete:first-child .ant-input,\n.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:first-child .ant-input {\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > *:last-child,\n.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-select:last-child > .ant-select-selector,\n.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete:last-child .ant-input,\n.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:last-child .ant-input,\n.ant-input-number-group-rtl.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker-focused:last-child .ant-input {\n  border-left-width: 1px;\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper-rtl + .ant-input-group-wrapper-rtl {\n  margin-right: -1px;\n  margin-left: 0;\n}\n.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper-rtl:not(:last-child).ant-input-search > .ant-input-group > .ant-input {\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-number-group > .ant-input-number-rtl:first-child {\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-number-group > .ant-input-number-rtl:last-child {\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-number-group-rtl .ant-input-number-group-addon:first-child {\n  border-right: 1px solid #d9d9d9;\n  border-left: 0;\n  border-radius: 0 6px 6px 0;\n}\n.ant-input-number-group-rtl .ant-input-number-group-addon:last-child {\n  border-right: 0;\n  border-left: 1px solid #d9d9d9;\n  border-radius: 6px 0 0 6px;\n}\n.ant-input-number-group-wrapper {\n  display: inline-block;\n  text-align: start;\n  vertical-align: top;\n}\n.ant-input-number-handler {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 50%;\n  overflow: hidden;\n  color: #595959;\n  font-weight: bold;\n  line-height: 0;\n  text-align: center;\n  border-left: 1px solid #d9d9d9;\n  transition: all 0.1s linear;\n}\n.ant-input-number-handler:active {\n  background: #f4f4f4;\n}\n.ant-input-number-handler:hover .ant-input-number-handler-up-inner,\n.ant-input-number-handler:hover .ant-input-number-handler-down-inner {\n  color: #462e61;\n}\n.ant-input-number-handler-up-inner,\n.ant-input-number-handler-down-inner {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 4px;\n  width: 12px;\n  height: 12px;\n  color: #595959;\n  line-height: 12px;\n  transition: all 0.1s linear;\n  user-select: none;\n}\n.ant-input-number-handler-up-inner > *,\n.ant-input-number-handler-down-inner > * {\n  line-height: 1;\n}\n.ant-input-number-handler-up-inner svg,\n.ant-input-number-handler-down-inner svg {\n  display: inline-block;\n}\n.ant-input-number-handler-up-inner::before,\n.ant-input-number-handler-down-inner::before {\n  display: none;\n}\n.ant-input-number-handler-up-inner .ant-input-number-handler-up-inner-icon,\n.ant-input-number-handler-up-inner .ant-input-number-handler-down-inner-icon,\n.ant-input-number-handler-down-inner .ant-input-number-handler-up-inner-icon,\n.ant-input-number-handler-down-inner .ant-input-number-handler-down-inner-icon {\n  display: block;\n}\n.ant-input-number:hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-number:hover + .ant-form-item-children-icon {\n  opacity: 0;\n  transition: opacity 0.24s linear 0.24s;\n}\n.ant-input-number-focused {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-input-number-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-input-number-disabled {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-input-number-disabled .ant-input-number-input {\n  cursor: not-allowed;\n}\n.ant-input-number-disabled .ant-input-number-handler-wrap {\n  display: none;\n}\n.ant-input-number-readonly .ant-input-number-handler-wrap {\n  display: none;\n}\n.ant-input-number-input {\n  width: 100%;\n  height: 34px;\n  padding: 0 11px;\n  text-align: left;\n  background-color: transparent;\n  border: 0;\n  border-radius: 6px;\n  outline: 0;\n  transition: all 0.3s linear;\n  appearance: textfield !important;\n}\n.ant-input-number-input::placeholder {\n  color: #bfbfbf;\n  user-select: none;\n}\n.ant-input-number-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input-number-input[type='number']::-webkit-inner-spin-button,\n.ant-input-number-input[type='number']::-webkit-outer-spin-button {\n  margin: 0;\n  /* stylelint-disable-next-line property-no-vendor-prefix */\n  -webkit-appearance: none;\n  appearance: none;\n}\n.ant-input-number-lg {\n  padding: 0;\n  font-size: 16px;\n}\n.ant-input-number-lg input {\n  height: 38px;\n}\n.ant-input-number-sm {\n  padding: 0;\n}\n.ant-input-number-sm input {\n  height: 22px;\n  padding: 0 7px;\n}\n.ant-input-number-handler-wrap {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 22px;\n  height: 100%;\n  background: #fff;\n  border-radius: 0 6px 6px 0;\n  opacity: 0;\n  transition: opacity 0.24s linear 0.1s;\n}\n.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner,\n.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: auto;\n  margin-right: 0;\n  font-size: 7px;\n}\n.ant-input-number-borderless .ant-input-number-handler-wrap {\n  border-left-width: 0;\n}\n.ant-input-number-handler-wrap:hover .ant-input-number-handler {\n  height: 40%;\n}\n.ant-input-number:hover .ant-input-number-handler-wrap,\n.ant-input-number-focused .ant-input-number-handler-wrap {\n  opacity: 1;\n}\n.ant-input-number-handler-up {\n  border-top-right-radius: 6px;\n  cursor: pointer;\n}\n.ant-input-number-handler-up-inner {\n  top: 50%;\n  margin-top: -5px;\n  text-align: center;\n}\n.ant-input-number-handler-up:hover {\n  height: 60% !important;\n}\n.ant-input-number-handler-down {\n  top: 0;\n  border-top: 1px solid #d9d9d9;\n  border-bottom-right-radius: 6px;\n  cursor: pointer;\n}\n.ant-input-number-handler-down-inner {\n  top: 50%;\n  text-align: center;\n  transform: translateY(-50%);\n}\n.ant-input-number-handler-down:hover {\n  height: 60% !important;\n}\n.ant-input-number-borderless .ant-input-number-handler-down {\n  border-top-width: 0;\n}\n.ant-input-number:hover:not(.ant-input-number-borderless) .ant-input-number-handler-down,\n.ant-input-number-focused:not(.ant-input-number-borderless) .ant-input-number-handler-down {\n  border-top: 1px solid #d9d9d9;\n}\n.ant-input-number-handler-up-disabled,\n.ant-input-number-handler-down-disabled {\n  cursor: not-allowed;\n}\n.ant-input-number-handler-up-disabled:hover .ant-input-number-handler-up-inner,\n.ant-input-number-handler-down-disabled:hover .ant-input-number-handler-down-inner {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-number-borderless {\n  box-shadow: none;\n}\n.ant-input-number-out-of-range input {\n  color: #f5222d;\n}\n.ant-input-number-compact-item:not(.ant-input-number-compact-last-item):not(.ant-input-number-compact-item-rtl) {\n  margin-right: -1px;\n}\n.ant-input-number-compact-item:not(.ant-input-number-compact-last-item).ant-input-number-compact-item-rtl {\n  margin-left: -1px;\n}\n.ant-input-number-compact-item:hover,\n.ant-input-number-compact-item:focus,\n.ant-input-number-compact-item:active {\n  z-index: 2;\n}\n.ant-input-number-compact-item.ant-input-number-focused {\n  z-index: 2;\n}\n.ant-input-number-compact-item[disabled] {\n  z-index: 0;\n}\n.ant-input-number-compact-item:not(.ant-input-number-compact-first-item):not(.ant-input-number-compact-last-item).ant-input-number {\n  border-radius: 0;\n}\n.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-first-item:not(.ant-input-number-compact-last-item):not(.ant-input-number-compact-item-rtl) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-last-item:not(.ant-input-number-compact-first-item):not(.ant-input-number-compact-item-rtl) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-item-rtl.ant-input-number-compact-first-item:not(.ant-input-number-compact-last-item) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-item-rtl.ant-input-number-compact-last-item:not(.ant-input-number-compact-first-item) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-number-rtl {\n  direction: rtl;\n}\n.ant-input-number-rtl .ant-input-number-handler {\n  border-right: 1px solid #d9d9d9;\n  border-left: 0;\n}\n.ant-input-number-rtl .ant-input-number-handler-wrap {\n  right: auto;\n  left: 0;\n}\n.ant-input-number-rtl.ant-input-number-borderless .ant-input-number-handler-wrap {\n  border-right-width: 0;\n}\n.ant-input-number-rtl .ant-input-number-handler-up {\n  border-top-right-radius: 0;\n}\n.ant-input-number-rtl .ant-input-number-handler-down {\n  border-bottom-right-radius: 0;\n}\n.ant-input-number-rtl .ant-input-number-input {\n  direction: ltr;\n  text-align: right;\n}\n.ant-layout {\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n  /* fix firefox can't set height smaller than content on flex item */\n  min-height: 0;\n  background: #f5f5f5;\n}\n.ant-layout,\n.ant-layout * {\n  box-sizing: border-box;\n}\n.ant-layout.ant-layout-has-sider {\n  flex-direction: row;\n}\n.ant-layout.ant-layout-has-sider > .ant-layout,\n.ant-layout.ant-layout-has-sider > .ant-layout-content {\n  width: 0;\n}\n.ant-layout-header,\n.ant-layout-footer {\n  flex: 0 0 auto;\n}\n.ant-layout-header {\n  height: 72px;\n  padding: 0 32px;\n  color: #545454;\n  line-height: 72px;\n  background: #fefefe;\n}\n.ant-layout-footer {\n  padding: 14px 32px;\n  color: #545454;\n  font-size: 14px;\n  background: #fffffe;\n}\n.ant-layout-content {\n  flex: auto;\n  /* fix firefox can't set height smaller than content on flex item */\n  min-height: 0;\n}\n.ant-layout-sider {\n  position: relative;\n  /* fix firefox can't set width smaller than content on flex item */\n  min-width: 0;\n  background: var(--app-primary-color);\n  transition: all 0.2s;\n}\n.ant-layout-sider-children {\n  height: 100%;\n  margin-top: -0.1px;\n  padding-top: 0.1px;\n}\n.ant-layout-sider-children .ant-menu.ant-menu-inline-collapsed {\n  width: auto;\n}\n.ant-layout-sider-has-trigger {\n  padding-bottom: 30px;\n}\n.ant-layout-sider-right {\n  order: 1;\n}\n.ant-layout-sider-trigger {\n  position: fixed;\n  bottom: 0;\n  z-index: 1;\n  height: 30px;\n  color: #ffffff;\n  line-height: 30px;\n  text-align: center;\n  background: #002140;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.ant-layout-sider-zero-width > * {\n  overflow: hidden;\n}\n.ant-layout-sider-zero-width-trigger {\n  position: absolute;\n  top: 72px;\n  right: -36px;\n  z-index: 1;\n  width: 36px;\n  height: 28px;\n  color: #ffffff;\n  font-size: 18px;\n  line-height: 28px;\n  text-align: center;\n  background: var(--app-primary-color);\n  border-radius: 0 6px 6px 0;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n.ant-layout-sider-zero-width-trigger::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  transition: all 0.3s;\n  content: '';\n}\n.ant-layout-sider-zero-width-trigger:hover::after {\n  background: rgba(255, 255, 255, 0.1);\n}\n.ant-layout-sider-zero-width-trigger-right {\n  left: -36px;\n  border-radius: 6px 0 0 6px;\n}\n.ant-layout-sider-light {\n  background: #fff;\n}\n.ant-layout-sider-light .ant-layout-sider-trigger {\n  color: #545454;\n  background: #fff;\n}\n.ant-layout-sider-light .ant-layout-sider-zero-width-trigger {\n  color: #545454;\n  background: #fff;\n}\n.ant-layout-rtl {\n  direction: rtl;\n}\n.ant-list {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n}\n.ant-list * {\n  outline: none;\n}\n.ant-list-pagination {\n  margin-top: 24px;\n  text-align: right;\n}\n.ant-list-pagination .ant-pagination-options {\n  text-align: left;\n}\n.ant-list-more {\n  margin-top: 12px;\n  text-align: center;\n}\n.ant-list-more button {\n  padding-right: 32px;\n  padding-left: 32px;\n}\n.ant-list-spin {\n  min-height: 40px;\n  text-align: center;\n}\n.ant-list-empty-text {\n  padding: 16px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  text-align: center;\n}\n.ant-list-items {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n  color: #545454;\n}\n.ant-list-item-meta {\n  display: flex;\n  flex: 1;\n  align-items: flex-start;\n  max-width: 100%;\n}\n.ant-list-item-meta-avatar {\n  margin-right: 16px;\n}\n.ant-list-item-meta-content {\n  flex: 1 0;\n  width: 0;\n  color: #545454;\n}\n.ant-list-item-meta-title {\n  margin-bottom: 4px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n}\n.ant-list-item-meta-title > a {\n  color: #545454;\n  transition: all 0.3s;\n}\n.ant-list-item-meta-title > a:hover {\n  color: #351a55;\n}\n.ant-list-item-meta-description {\n  color: #595959;\n  font-size: 14px;\n  line-height: 1.3;\n}\n.ant-list-item-action {\n  flex: 0 0 auto;\n  margin-left: 48px;\n  padding: 0;\n  font-size: 0;\n  list-style: none;\n}\n.ant-list-item-action > li {\n  position: relative;\n  display: inline-block;\n  padding: 0 8px;\n  color: #595959;\n  font-size: 14px;\n  line-height: 1.3;\n  text-align: center;\n}\n.ant-list-item-action > li:first-child {\n  padding-left: 0;\n}\n.ant-list-item-action-split {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: 1px;\n  height: 14px;\n  margin-top: -7px;\n  background-color: #e8e8e8;\n}\n.ant-list-header {\n  background: transparent;\n}\n.ant-list-footer {\n  background: transparent;\n}\n.ant-list-header,\n.ant-list-footer {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.ant-list-empty {\n  padding: 16px 0;\n  color: #595959;\n  font-size: 12px;\n  text-align: center;\n}\n.ant-list-split .ant-list-item {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-split .ant-list-item:last-child {\n  border-bottom: none;\n}\n.ant-list-split .ant-list-header {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-split.ant-list-empty .ant-list-footer {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-list-loading .ant-list-spin-nested-loading {\n  min-height: 32px;\n}\n.ant-list-split.ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-lg .ant-list-item {\n  padding: 16px 24px;\n}\n.ant-list-sm .ant-list-item {\n  padding: 8px 16px;\n}\n.ant-list-vertical .ant-list-item {\n  align-items: initial;\n}\n.ant-list-vertical .ant-list-item-main {\n  display: block;\n  flex: 1;\n}\n.ant-list-vertical .ant-list-item-extra {\n  margin-left: 40px;\n}\n.ant-list-vertical .ant-list-item-meta {\n  margin-bottom: 16px;\n}\n.ant-list-vertical .ant-list-item-meta-title {\n  margin-bottom: 12px;\n  color: #535353;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-list-vertical .ant-list-item-action {\n  margin-top: 16px;\n  margin-left: auto;\n}\n.ant-list-vertical .ant-list-item-action > li {\n  padding: 0 16px;\n}\n.ant-list-vertical .ant-list-item-action > li:first-child {\n  padding-left: 0;\n}\n.ant-list-grid .ant-col > .ant-list-item {\n  display: block;\n  max-width: 100%;\n  margin-bottom: 16px;\n  padding-top: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n.ant-list-item-no-flex {\n  display: block;\n}\n.ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {\n  float: right;\n}\n.ant-list-bordered {\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n.ant-list-bordered .ant-list-header {\n  padding-right: 24px;\n  padding-left: 24px;\n}\n.ant-list-bordered .ant-list-footer {\n  padding-right: 24px;\n  padding-left: 24px;\n}\n.ant-list-bordered .ant-list-item {\n  padding-right: 24px;\n  padding-left: 24px;\n}\n.ant-list-bordered .ant-list-pagination {\n  margin: 16px 24px;\n}\n.ant-list-bordered.ant-list-sm .ant-list-item {\n  padding: 8px 16px;\n}\n.ant-list-bordered.ant-list-sm .ant-list-header,\n.ant-list-bordered.ant-list-sm .ant-list-footer {\n  padding: 8px 16px;\n}\n.ant-list-bordered.ant-list-lg .ant-list-item {\n  padding: 16px 24px;\n}\n.ant-list-bordered.ant-list-lg .ant-list-header,\n.ant-list-bordered.ant-list-lg .ant-list-footer {\n  padding: 16px 24px;\n}\n@media screen and (max-width: 768px) {\n  .ant-list-item-action {\n    margin-left: 24px;\n  }\n  .ant-list-vertical .ant-list-item-extra {\n    margin-left: 24px;\n  }\n}\n@media screen and (max-width: 576px) {\n  .ant-list-item {\n    flex-wrap: wrap;\n  }\n  .ant-list-item-action {\n    margin-left: 12px;\n  }\n  .ant-list-vertical .ant-list-item {\n    flex-wrap: wrap-reverse;\n  }\n  .ant-list-vertical .ant-list-item-main {\n    min-width: 220px;\n  }\n  .ant-list-vertical .ant-list-item-extra {\n    margin: auto auto 16px;\n  }\n}\n.ant-list-rtl {\n  direction: rtl;\n  text-align: right;\n}\n.ant-list-rtl .ReactVirtualized__List .ant-list-item {\n  direction: rtl;\n}\n.ant-list-rtl .ant-list-pagination {\n  text-align: left;\n}\n.ant-list-rtl .ant-list-item-meta-avatar {\n  margin-right: 0;\n  margin-left: 16px;\n}\n.ant-list-rtl .ant-list-item-action {\n  margin-right: 48px;\n  margin-left: 0;\n}\n.ant-list.ant-list-rtl .ant-list-item-action > li:first-child {\n  padding-right: 0;\n  padding-left: 16px;\n}\n.ant-list-rtl .ant-list-item-action-split {\n  right: auto;\n  left: 0;\n}\n.ant-list-rtl.ant-list-vertical .ant-list-item-extra {\n  margin-right: 40px;\n  margin-left: 0;\n}\n.ant-list-rtl.ant-list-vertical .ant-list-item-action {\n  margin-right: auto;\n}\n.ant-list-rtl .ant-list-vertical .ant-list-item-action > li:first-child {\n  padding-right: 0;\n  padding-left: 16px;\n}\n.ant-list-rtl .ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {\n  float: left;\n}\n@media screen and (max-width: 768px) {\n  .ant-list-rtl .ant-list-item-action {\n    margin-right: 24px;\n    margin-left: 0;\n  }\n  .ant-list-rtl .ant-list-vertical .ant-list-item-extra {\n    margin-right: 24px;\n    margin-left: 0;\n  }\n}\n@media screen and (max-width: 576px) {\n  .ant-list-rtl .ant-list-item-action {\n    margin-right: 22px;\n    margin-left: 0;\n  }\n  .ant-list-rtl.ant-list-vertical .ant-list-item-extra {\n    margin: auto auto 16px;\n  }\n}\n.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions,\n.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:hover {\n  background: #fff;\n  border-color: #f5222d;\n}\n.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:focus,\n.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions-focused {\n  border-color: #ff4d4f;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-mentions-status-error .ant-input-prefix {\n  color: #f5222d;\n}\n.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions,\n.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:hover {\n  background: #fff;\n  border-color: #fa8c16;\n}\n.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:focus,\n.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions-focused {\n  border-color: #ffa940;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-mentions-status-warning .ant-input-prefix {\n  color: #fa8c16;\n}\n.ant-mentions {\n  box-sizing: border-box;\n  margin: 0;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  width: 100%;\n  min-width: 0;\n  padding: 7.9px 11px;\n  color: #545454;\n  font-size: 14px;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n  position: relative;\n  display: inline-block;\n  height: auto;\n  padding: 0;\n  overflow: hidden;\n  line-height: 1.3;\n  white-space: pre-wrap;\n  vertical-align: bottom;\n}\n.ant-mentions::placeholder {\n  color: #bfbfbf;\n  user-select: none;\n}\n.ant-mentions:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-mentions:hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-mentions:hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-mentions:focus,\n.ant-mentions-focused {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-mentions:focus,\n.ant-input-rtl .ant-mentions-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-mentions-disabled {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-mentions-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-mentions[disabled] {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-mentions[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-mentions-borderless,\n.ant-mentions-borderless:hover,\n.ant-mentions-borderless:focus,\n.ant-mentions-borderless-focused,\n.ant-mentions-borderless-disabled,\n.ant-mentions-borderless[disabled] {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\ntextarea.ant-mentions {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-mentions-lg {\n  padding: 8.6px 11px;\n  font-size: 16px;\n}\n.ant-mentions-sm {\n  padding: 1.9px 7px;\n}\n.ant-mentions-rtl {\n  direction: rtl;\n}\n.ant-mentions-disabled > textarea {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-mentions-disabled > textarea:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-mentions-focused {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-mentions-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-mentions > textarea,\n.ant-mentions-measure {\n  min-height: 34px;\n  margin: 0;\n  padding: 7.9px 11px;\n  overflow: inherit;\n  overflow-x: hidden;\n  overflow-y: auto;\n  /* stylelint-disable declaration-block-no-redundant-longhand-properties */\n  font-weight: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  font-style: inherit;\n  font-variant: inherit;\n  font-size-adjust: inherit;\n  font-stretch: inherit;\n  line-height: inherit;\n  /* stylelint-enable declaration-block-no-redundant-longhand-properties */\n  direction: inherit;\n  letter-spacing: inherit;\n  white-space: inherit;\n  text-align: inherit;\n  vertical-align: top;\n  word-wrap: break-word;\n  word-break: inherit;\n  tab-size: inherit;\n}\n.ant-mentions > textarea {\n  width: 100%;\n  border: none;\n  outline: none;\n  resize: none;\n}\n.ant-mentions > textarea::placeholder {\n  color: #bfbfbf;\n  user-select: none;\n}\n.ant-mentions > textarea:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-mentions-measure {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n  color: transparent;\n  pointer-events: none;\n}\n.ant-mentions-measure > span {\n  display: inline-block;\n  min-height: 1em;\n}\n.ant-mentions-dropdown {\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-variant: initial;\n  background-color: #fff;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n.ant-mentions-dropdown-hidden {\n  display: none;\n}\n.ant-mentions-dropdown-menu {\n  max-height: 250px;\n  margin-bottom: 0;\n  padding-left: 0;\n  overflow: auto;\n  list-style: none;\n  outline: none;\n}\n.ant-mentions-dropdown-menu-item {\n  position: relative;\n  display: block;\n  min-width: 100px;\n  padding: 5px 12px;\n  overflow: hidden;\n  color: #545454;\n  font-weight: normal;\n  line-height: 1.3;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n.ant-mentions-dropdown-menu-item:hover {\n  background-color: #f5f5f5;\n}\n.ant-mentions-dropdown-menu-item:first-child {\n  border-radius: 6px 6px 0 0;\n}\n.ant-mentions-dropdown-menu-item:last-child {\n  border-radius: 0 0 6px 6px;\n}\n.ant-mentions-dropdown-menu-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-mentions-dropdown-menu-item-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-mentions-dropdown-menu-item-selected {\n  color: #545454;\n  font-weight: 600;\n  background-color: #fafafa;\n}\n.ant-mentions-dropdown-menu-item-active {\n  background-color: #f5f5f5;\n}\n.ant-mentions-suffix {\n  position: absolute;\n  top: 0;\n  right: 11px;\n  bottom: 0;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  margin: auto;\n}\n.ant-mentions-rtl {\n  direction: rtl;\n}\n.ant-menu-item-danger.ant-menu-item {\n  color: #f5222d;\n}\n.ant-menu-item-danger.ant-menu-item:hover,\n.ant-menu-item-danger.ant-menu-item-active {\n  color: #f5222d;\n}\n.ant-menu-item-danger.ant-menu-item:active {\n  background: #fff1f0;\n}\n.ant-menu-item-danger.ant-menu-item-selected {\n  color: #f5222d;\n}\n.ant-menu-item-danger.ant-menu-item-selected > a,\n.ant-menu-item-danger.ant-menu-item-selected > a:hover {\n  color: #f5222d;\n}\n.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-danger.ant-menu-item-selected {\n  background-color: #fff1f0;\n}\n.ant-menu-inline .ant-menu-item-danger.ant-menu-item::after {\n  border-right-color: #f5222d;\n}\n.ant-menu-dark .ant-menu-item-danger.ant-menu-item,\n.ant-menu-dark .ant-menu-item-danger.ant-menu-item:hover,\n.ant-menu-dark .ant-menu-item-danger.ant-menu-item > a {\n  color: #f5222d;\n}\n.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-danger.ant-menu-item-selected {\n  color: var(--app-secondary-color);\n  background-color: #f5222d;\n}\n.ant-menu {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  font-feature-settings: 'tnum';\n  margin-bottom: 0;\n  padding-left: 0;\n  color: #545454;\n  font-size: 14px;\n  line-height: 0;\n  text-align: left;\n  list-style: none;\n  background: #fff;\n  outline: none;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  transition: background 0.3s, width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;\n}\n.ant-menu::before {\n  display: table;\n  content: '';\n}\n.ant-menu::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-menu::before {\n  display: table;\n  content: '';\n}\n.ant-menu::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-menu.ant-menu-root:focus-visible {\n  box-shadow: 0 0 0 2px #847f87;\n}\n.ant-menu ul,\n.ant-menu ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-menu-overflow {\n  display: flex;\n}\n.ant-menu-overflow-item {\n  flex: none;\n}\n.ant-menu-hidden,\n.ant-menu-submenu-hidden {\n  display: none;\n}\n.ant-menu-item-group-title {\n  height: 1.3;\n  padding: 8px 16px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  transition: all 0.3s;\n}\n.ant-menu-horizontal .ant-menu-submenu {\n  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu,\n.ant-menu-submenu-inline {\n  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu-selected {\n  color: var(--app-primary-color);\n}\n.ant-menu-item:active,\n.ant-menu-submenu-title:active {\n  background: #908b94;\n}\n.ant-menu-submenu .ant-menu-sub {\n  cursor: initial;\n  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-title-content {\n  transition: color 0.3s;\n}\n.ant-menu-item a {\n  color: #545454;\n}\n.ant-menu-item a:hover {\n  color: var(--app-primary-color);\n}\n.ant-menu-item a::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: transparent;\n  content: '';\n}\n.ant-menu-item > .ant-badge a {\n  color: #545454;\n}\n.ant-menu-item > .ant-badge a:hover {\n  color: var(--app-primary-color);\n}\n.ant-menu-item-divider {\n  overflow: hidden;\n  line-height: 0;\n  border-color: #e8e8e8;\n  border-style: solid;\n  border-width: 1px 0 0;\n}\n.ant-menu-item-divider-dashed {\n  border-style: dashed;\n}\n.ant-menu-horizontal .ant-menu-item,\n.ant-menu-horizontal .ant-menu-submenu {\n  margin-top: -1px;\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {\n  background-color: transparent;\n}\n.ant-menu-item-selected {\n  color: var(--app-primary-color);\n}\n.ant-menu-item-selected a,\n.ant-menu-item-selected a:hover {\n  color: var(--app-primary-color);\n}\n.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #908b94;\n}\n.ant-menu-inline,\n.ant-menu-vertical,\n.ant-menu-vertical-left {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-menu-vertical-right {\n  border-left: 1px solid #e8e8e8;\n}\n.ant-menu-vertical.ant-menu-sub,\n.ant-menu-vertical-left.ant-menu-sub,\n.ant-menu-vertical-right.ant-menu-sub {\n  min-width: 160px;\n  max-height: calc(100vh - 100px);\n  padding: 0;\n  overflow: hidden;\n  border-right: 0;\n}\n.ant-menu-vertical.ant-menu-sub:not([class*='-active']),\n.ant-menu-vertical-left.ant-menu-sub:not([class*='-active']),\n.ant-menu-vertical-right.ant-menu-sub:not([class*='-active']) {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.ant-menu-vertical.ant-menu-sub .ant-menu-item,\n.ant-menu-vertical-left.ant-menu-sub .ant-menu-item,\n.ant-menu-vertical-right.ant-menu-sub .ant-menu-item {\n  left: 0;\n  margin-left: 0;\n  border-right: 0;\n}\n.ant-menu-vertical.ant-menu-sub .ant-menu-item::after,\n.ant-menu-vertical-left.ant-menu-sub .ant-menu-item::after,\n.ant-menu-vertical-right.ant-menu-sub .ant-menu-item::after {\n  border-right: 0;\n}\n.ant-menu-vertical.ant-menu-sub > .ant-menu-item,\n.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item,\n.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item,\n.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu,\n.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu,\n.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu {\n  transform-origin: 0 0;\n}\n.ant-menu-horizontal.ant-menu-sub {\n  min-width: 114px;\n}\n.ant-menu-horizontal .ant-menu-item,\n.ant-menu-horizontal .ant-menu-submenu-title {\n  transition: border-color 0.3s, background 0.3s;\n}\n.ant-menu-item,\n.ant-menu-submenu-title {\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0 20px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item .ant-menu-item-icon,\n.ant-menu-submenu-title .ant-menu-item-icon,\n.ant-menu-item .anticon,\n.ant-menu-submenu-title .anticon {\n  min-width: 14px;\n  font-size: 14px;\n  transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s;\n}\n.ant-menu-item .ant-menu-item-icon + span,\n.ant-menu-submenu-title .ant-menu-item-icon + span,\n.ant-menu-item .anticon + span,\n.ant-menu-submenu-title .anticon + span {\n  margin-left: 10px;\n  opacity: 1;\n  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), margin 0.3s, color 0.3s;\n}\n.ant-menu-item .ant-menu-item-icon.svg,\n.ant-menu-submenu-title .ant-menu-item-icon.svg {\n  vertical-align: -0.125em;\n}\n.ant-menu-item.ant-menu-item-only-child > .anticon,\n.ant-menu-submenu-title.ant-menu-item-only-child > .anticon,\n.ant-menu-item.ant-menu-item-only-child > .ant-menu-item-icon,\n.ant-menu-submenu-title.ant-menu-item-only-child > .ant-menu-item-icon {\n  margin-right: 0;\n}\n.ant-menu-item:not(.ant-menu-item-disabled):focus-visible,\n.ant-menu-submenu-title:not(.ant-menu-item-disabled):focus-visible {\n  box-shadow: 0 0 0 2px #847f87;\n}\n.ant-menu > .ant-menu-item-divider {\n  margin: 1px 0;\n  padding: 0;\n}\n.ant-menu-submenu-popup {\n  position: absolute;\n  z-index: 1050;\n  background: transparent;\n  border-radius: 6px;\n  box-shadow: none;\n  transform-origin: 0 0;\n}\n.ant-menu-submenu-popup::before {\n  position: absolute;\n  top: -7px;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  opacity: 0.0001;\n  content: ' ';\n}\n.ant-menu-submenu-placement-rightTop::before {\n  top: 0;\n  left: -7px;\n}\n.ant-menu-submenu > .ant-menu {\n  background-color: #fff;\n  border-radius: 6px;\n}\n.ant-menu-submenu > .ant-menu-submenu-title::after {\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu-popup > .ant-menu {\n  background-color: #fff;\n}\n.ant-menu-submenu-expand-icon,\n.ant-menu-submenu-arrow {\n  position: absolute;\n  top: 50%;\n  right: 16px;\n  width: 10px;\n  color: #545454;\n  transform: translateY(-50%);\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu-arrow::before,\n.ant-menu-submenu-arrow::after {\n  position: absolute;\n  width: 6px;\n  height: 1.5px;\n  background-color: currentcolor;\n  border-radius: 2px;\n  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  content: '';\n}\n.ant-menu-submenu-arrow::before {\n  transform: rotate(45deg) translateY(-2.5px);\n}\n.ant-menu-submenu-arrow::after {\n  transform: rotate(-45deg) translateY(2.5px);\n}\n.ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-expand-icon,\n.ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {\n  color: var(--app-primary-color);\n}\n.ant-menu-inline-collapsed .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-inline .ant-menu-submenu-arrow::before {\n  transform: rotate(-45deg) translateX(2.5px);\n}\n.ant-menu-inline-collapsed .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-inline .ant-menu-submenu-arrow::after {\n  transform: rotate(45deg) translateX(-2.5px);\n}\n.ant-menu-submenu-horizontal .ant-menu-submenu-arrow {\n  display: none;\n}\n.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow {\n  transform: translateY(-2px);\n}\n.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {\n  transform: rotate(-45deg) translateX(-2.5px);\n}\n.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before {\n  transform: rotate(45deg) translateX(2.5px);\n}\n.ant-menu-vertical .ant-menu-submenu-selected,\n.ant-menu-vertical-left .ant-menu-submenu-selected,\n.ant-menu-vertical-right .ant-menu-submenu-selected {\n  color: var(--app-primary-color);\n}\n.ant-menu-horizontal {\n  line-height: 46px;\n  border: 0;\n  border-bottom: 1px solid #e8e8e8;\n  box-shadow: none;\n}\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {\n  margin-top: -1px;\n  margin-bottom: 0;\n  padding: 0 20px;\n}\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected {\n  color: var(--app-primary-color);\n}\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover::after,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active::after,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active::after,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open::after,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open::after,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected::after {\n  border-bottom: 2px solid var(--app-primary-color);\n}\n.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-horizontal > .ant-menu-submenu {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  vertical-align: bottom;\n}\n.ant-menu-horizontal > .ant-menu-item::after,\n.ant-menu-horizontal > .ant-menu-submenu::after {\n  position: absolute;\n  right: 20px;\n  bottom: 0;\n  left: 20px;\n  border-bottom: 2px solid transparent;\n  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  content: '';\n}\n.ant-menu-horizontal > .ant-menu-submenu > .ant-menu-submenu-title {\n  padding: 0;\n}\n.ant-menu-horizontal > .ant-menu-item a {\n  color: #545454;\n}\n.ant-menu-horizontal > .ant-menu-item a:hover {\n  color: var(--app-primary-color);\n}\n.ant-menu-horizontal > .ant-menu-item a::before {\n  bottom: -2px;\n}\n.ant-menu-horizontal > .ant-menu-item-selected a {\n  color: var(--app-primary-color);\n}\n.ant-menu-horizontal::after {\n  display: block;\n  clear: both;\n  height: 0;\n  content: '\\20';\n}\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-vertical-right .ant-menu-item,\n.ant-menu-inline .ant-menu-item {\n  position: relative;\n}\n.ant-menu-vertical .ant-menu-item::after,\n.ant-menu-vertical-left .ant-menu-item::after,\n.ant-menu-vertical-right .ant-menu-item::after,\n.ant-menu-inline .ant-menu-item::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  border-right: 3px solid var(--app-primary-color);\n  transform: scaleY(0.0001);\n  opacity: 0;\n  transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);\n  content: '';\n}\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-vertical-right .ant-menu-item,\n.ant-menu-inline .ant-menu-item,\n.ant-menu-vertical .ant-menu-submenu-title,\n.ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-menu-inline .ant-menu-submenu-title {\n  height: 42px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  padding: 0 16px;\n  overflow: hidden;\n  line-height: 42px;\n  text-overflow: ellipsis;\n}\n.ant-menu-vertical .ant-menu-submenu,\n.ant-menu-vertical-left .ant-menu-submenu,\n.ant-menu-vertical-right .ant-menu-submenu,\n.ant-menu-inline .ant-menu-submenu {\n  padding-bottom: 0.02px;\n}\n.ant-menu-vertical .ant-menu-item:not(:last-child),\n.ant-menu-vertical-left .ant-menu-item:not(:last-child),\n.ant-menu-vertical-right .ant-menu-item:not(:last-child),\n.ant-menu-inline .ant-menu-item:not(:last-child) {\n  margin-bottom: 8px;\n}\n.ant-menu-vertical > .ant-menu-item,\n.ant-menu-vertical-left > .ant-menu-item,\n.ant-menu-vertical-right > .ant-menu-item,\n.ant-menu-inline > .ant-menu-item,\n.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n  height: 42px;\n  line-height: 42px;\n}\n.ant-menu-vertical .ant-menu-item-group-list .ant-menu-submenu-title,\n.ant-menu-vertical .ant-menu-submenu-title {\n  padding-right: 34px;\n}\n.ant-menu-inline {\n  width: 100%;\n}\n.ant-menu-inline .ant-menu-selected::after,\n.ant-menu-inline .ant-menu-item-selected::after {\n  transform: scaleY(1);\n  opacity: 1;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-inline .ant-menu-item,\n.ant-menu-inline .ant-menu-submenu-title {\n  width: calc(100% + 1px);\n}\n.ant-menu-inline .ant-menu-item-group-list .ant-menu-submenu-title,\n.ant-menu-inline .ant-menu-submenu-title {\n  padding-right: 34px;\n}\n.ant-menu-inline.ant-menu-root .ant-menu-item,\n.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {\n  display: flex;\n  align-items: center;\n  transition: border-color 0.3s, background 0.3s, padding 0.1s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n.ant-menu-inline.ant-menu-root .ant-menu-item > .ant-menu-title-content,\n.ant-menu-inline.ant-menu-root .ant-menu-submenu-title > .ant-menu-title-content {\n  flex: auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ant-menu-inline.ant-menu-root .ant-menu-item > *,\n.ant-menu-inline.ant-menu-root .ant-menu-submenu-title > * {\n  flex: none;\n}\n.ant-menu.ant-menu-inline-collapsed {\n  width: 80px;\n}\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n  left: 0;\n  padding: 0 calc(50% - 16px / 2);\n  text-overflow: clip;\n}\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  opacity: 0;\n}\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .anticon,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon {\n  margin: 0;\n  font-size: 16px;\n  line-height: 42px;\n}\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon + span,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon + span,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .anticon + span,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon + span,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span,\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span {\n  display: inline-block;\n  opacity: 0;\n}\n.ant-menu.ant-menu-inline-collapsed .ant-menu-item-icon,\n.ant-menu.ant-menu-inline-collapsed .anticon {\n  display: inline-block;\n}\n.ant-menu.ant-menu-inline-collapsed-tooltip {\n  pointer-events: none;\n}\n.ant-menu.ant-menu-inline-collapsed-tooltip .ant-menu-item-icon,\n.ant-menu.ant-menu-inline-collapsed-tooltip .anticon {\n  display: none;\n}\n.ant-menu.ant-menu-inline-collapsed-tooltip a {\n  color: rgba(255, 255, 255, 0.85);\n}\n.ant-menu.ant-menu-inline-collapsed .ant-menu-item-group-title {\n  padding-right: 4px;\n  padding-left: 4px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-menu-item-group-list {\n  margin: 0;\n  padding: 0;\n}\n.ant-menu-item-group-list .ant-menu-item,\n.ant-menu-item-group-list .ant-menu-submenu-title {\n  padding: 0 16px 0 28px;\n}\n.ant-menu-root.ant-menu-vertical,\n.ant-menu-root.ant-menu-vertical-left,\n.ant-menu-root.ant-menu-vertical-right,\n.ant-menu-root.ant-menu-inline {\n  box-shadow: none;\n}\n.ant-menu-root.ant-menu-inline-collapsed .ant-menu-item > .ant-menu-inline-collapsed-noicon,\n.ant-menu-root.ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-submenu-title > .ant-menu-inline-collapsed-noicon {\n  font-size: 16px;\n  text-align: center;\n}\n.ant-menu-sub.ant-menu-inline {\n  padding: 0;\n  background: #fafafa;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n.ant-menu-sub.ant-menu-inline > .ant-menu-item,\n.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n  height: 42px;\n  line-height: 42px;\n  list-style-position: inside;\n  list-style-type: disc;\n}\n.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {\n  padding-left: 32px;\n}\n.ant-menu-item-disabled,\n.ant-menu-submenu-disabled {\n  color: rgba(0, 0, 0, 0.25) !important;\n  background: none;\n  cursor: not-allowed;\n}\n.ant-menu-item-disabled::after,\n.ant-menu-submenu-disabled::after {\n  border-color: transparent !important;\n}\n.ant-menu-item-disabled a,\n.ant-menu-submenu-disabled a {\n  color: rgba(0, 0, 0, 0.25) !important;\n  pointer-events: none;\n}\n.ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(0, 0, 0, 0.25) !important;\n  cursor: not-allowed;\n}\n.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {\n  background: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-layout-header .ant-menu {\n  line-height: inherit;\n}\n.ant-menu-inline-collapsed-tooltip a,\n.ant-menu-inline-collapsed-tooltip a:hover {\n  color: #fff;\n}\n.ant-menu-light .ant-menu-item:hover,\n.ant-menu-light .ant-menu-item-active,\n.ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,\n.ant-menu-light .ant-menu-submenu-active,\n.ant-menu-light .ant-menu-submenu-title:hover {\n  color: var(--app-primary-color);\n}\n.ant-menu.ant-menu-root:focus-visible {\n  box-shadow: 0 0 0 2px #1a0c2e;\n}\n.ant-menu-dark .ant-menu-item:focus-visible,\n.ant-menu-dark .ant-menu-submenu-title:focus-visible {\n  box-shadow: 0 0 0 2px #1a0c2e;\n}\n.ant-menu.ant-menu-dark,\n.ant-menu-dark .ant-menu-sub,\n.ant-menu.ant-menu-dark .ant-menu-sub {\n  color: #ffffff;\n  background: var(--app-primary-color);\n}\n.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  opacity: 0.45;\n  transition: all 0.3s;\n}\n.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  background: #ffffff;\n}\n.ant-menu-dark.ant-menu-submenu-popup {\n  background: transparent;\n}\n.ant-menu-dark .ant-menu-inline.ant-menu-sub {\n  background: #000c17;\n}\n.ant-menu-dark.ant-menu-horizontal {\n  border-bottom: 0;\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {\n  top: 0;\n  margin-top: 0;\n  padding: 0 20px;\n  border-color: var(--app-primary-color);\n  border-bottom: 0;\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item:hover {\n  background-color: #ffffff;\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item > a::before {\n  bottom: 0;\n}\n.ant-menu-dark .ant-menu-item,\n.ant-menu-dark .ant-menu-item-group-title,\n.ant-menu-dark .ant-menu-item > a,\n.ant-menu-dark .ant-menu-item > span > a {\n  color: #ffffff;\n}\n.ant-menu-dark.ant-menu-inline,\n.ant-menu-dark.ant-menu-vertical,\n.ant-menu-dark.ant-menu-vertical-left,\n.ant-menu-dark.ant-menu-vertical-right {\n  border-right: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item,\n.ant-menu-dark.ant-menu-vertical .ant-menu-item,\n.ant-menu-dark.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-dark.ant-menu-vertical-right .ant-menu-item {\n  left: 0;\n  margin-left: 0;\n  border-right: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item::after,\n.ant-menu-dark.ant-menu-vertical .ant-menu-item::after,\n.ant-menu-dark.ant-menu-vertical-left .ant-menu-item::after,\n.ant-menu-dark.ant-menu-vertical-right .ant-menu-item::after {\n  border-right: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item,\n.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {\n  width: 100%;\n}\n.ant-menu-dark .ant-menu-item:hover,\n.ant-menu-dark .ant-menu-item-active,\n.ant-menu-dark .ant-menu-submenu-active,\n.ant-menu-dark .ant-menu-submenu-open,\n.ant-menu-dark .ant-menu-submenu-selected,\n.ant-menu-dark .ant-menu-submenu-title:hover {\n  color: var(--app-secondary-color);\n  background-color: transparent;\n}\n.ant-menu-dark .ant-menu-item:hover > a,\n.ant-menu-dark .ant-menu-item-active > a,\n.ant-menu-dark .ant-menu-submenu-active > a,\n.ant-menu-dark .ant-menu-submenu-open > a,\n.ant-menu-dark .ant-menu-submenu-selected > a,\n.ant-menu-dark .ant-menu-submenu-title:hover > a,\n.ant-menu-dark .ant-menu-item:hover > span > a,\n.ant-menu-dark .ant-menu-item-active > span > a,\n.ant-menu-dark .ant-menu-submenu-active > span > a,\n.ant-menu-dark .ant-menu-submenu-open > span > a,\n.ant-menu-dark .ant-menu-submenu-selected > span > a,\n.ant-menu-dark .ant-menu-submenu-title:hover > span > a {\n  color: var(--app-secondary-color);\n}\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {\n  opacity: 1;\n}\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before {\n  background: var(--app-secondary-color);\n}\n.ant-menu-dark .ant-menu-item:hover {\n  background-color: transparent;\n}\n.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #ffffff;\n}\n.ant-menu-dark .ant-menu-item-selected {\n  color: var(--app-secondary-color);\n  border-right: 0;\n}\n.ant-menu-dark .ant-menu-item-selected::after {\n  border-right: 0;\n}\n.ant-menu-dark .ant-menu-item-selected > a,\n.ant-menu-dark .ant-menu-item-selected > span > a,\n.ant-menu-dark .ant-menu-item-selected > a:hover,\n.ant-menu-dark .ant-menu-item-selected > span > a:hover {\n  color: var(--app-secondary-color);\n}\n.ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon,\n.ant-menu-dark .ant-menu-item-selected .anticon {\n  color: #fff;\n}\n.ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon + span,\n.ant-menu-dark .ant-menu-item-selected .anticon + span {\n  color: #fff;\n}\n.ant-menu.ant-menu-dark .ant-menu-item-selected,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {\n  background-color: #ffffff;\n}\n.ant-menu-dark .ant-menu-item-disabled,\n.ant-menu-dark .ant-menu-submenu-disabled,\n.ant-menu-dark .ant-menu-item-disabled > a,\n.ant-menu-dark .ant-menu-submenu-disabled > a,\n.ant-menu-dark .ant-menu-item-disabled > span > a,\n.ant-menu-dark .ant-menu-submenu-disabled > span > a {\n  color: rgba(255, 255, 255, 0.35) !important;\n  opacity: 0.8;\n}\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(255, 255, 255, 0.35) !important;\n}\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {\n  background: rgba(255, 255, 255, 0.35) !important;\n}\n.ant-menu.ant-menu-rtl {\n  direction: rtl;\n  text-align: right;\n}\n.ant-menu-rtl .ant-menu-item-group-title {\n  text-align: right;\n}\n.ant-menu-rtl.ant-menu-inline,\n.ant-menu-rtl.ant-menu-vertical {\n  border-right: none;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-menu-rtl.ant-menu-dark.ant-menu-inline,\n.ant-menu-rtl.ant-menu-dark.ant-menu-vertical {\n  border-left: none;\n}\n.ant-menu-rtl.ant-menu-vertical.ant-menu-sub > .ant-menu-item,\n.ant-menu-rtl.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item,\n.ant-menu-rtl.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item,\n.ant-menu-rtl.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu,\n.ant-menu-rtl.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu,\n.ant-menu-rtl.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu {\n  transform-origin: top right;\n}\n.ant-menu-rtl .ant-menu-item .ant-menu-item-icon,\n.ant-menu-rtl .ant-menu-submenu-title .ant-menu-item-icon,\n.ant-menu-rtl .ant-menu-item .anticon,\n.ant-menu-rtl .ant-menu-submenu-title .anticon {\n  margin-right: auto;\n  margin-left: 10px;\n}\n.ant-menu-rtl .ant-menu-item.ant-menu-item-only-child > .ant-menu-item-icon,\n.ant-menu-rtl .ant-menu-submenu-title.ant-menu-item-only-child > .ant-menu-item-icon,\n.ant-menu-rtl .ant-menu-item.ant-menu-item-only-child > .anticon,\n.ant-menu-rtl .ant-menu-submenu-title.ant-menu-item-only-child > .anticon {\n  margin-left: 0;\n}\n.ant-menu-submenu-rtl.ant-menu-submenu-popup {\n  transform-origin: 100% 0;\n}\n.ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-rtl .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  right: auto;\n  left: 16px;\n}\n.ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  transform: rotate(-45deg) translateY(-2px);\n}\n.ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  transform: rotate(45deg) translateY(2px);\n}\n.ant-menu-rtl.ant-menu-vertical .ant-menu-item::after,\n.ant-menu-rtl.ant-menu-vertical-left .ant-menu-item::after,\n.ant-menu-rtl.ant-menu-vertical-right .ant-menu-item::after,\n.ant-menu-rtl.ant-menu-inline .ant-menu-item::after {\n  right: auto;\n  left: 0;\n}\n.ant-menu-rtl.ant-menu-vertical .ant-menu-item,\n.ant-menu-rtl.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-rtl.ant-menu-vertical-right .ant-menu-item,\n.ant-menu-rtl.ant-menu-inline .ant-menu-item,\n.ant-menu-rtl.ant-menu-vertical .ant-menu-submenu-title,\n.ant-menu-rtl.ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-menu-rtl.ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-menu-rtl.ant-menu-inline .ant-menu-submenu-title {\n  text-align: right;\n}\n.ant-menu-rtl.ant-menu-inline .ant-menu-submenu-title {\n  padding-right: 0;\n  padding-left: 34px;\n}\n.ant-menu-rtl.ant-menu-vertical .ant-menu-submenu-title {\n  padding-right: 16px;\n  padding-left: 34px;\n}\n.ant-menu-rtl.ant-menu-inline-collapsed.ant-menu-vertical .ant-menu-submenu-title {\n  padding: 0 calc(50% - 16px / 2);\n}\n.ant-menu-rtl .ant-menu-item-group-list .ant-menu-item,\n.ant-menu-rtl .ant-menu-item-group-list .ant-menu-submenu-title {\n  padding: 0 28px 0 16px;\n}\n.ant-menu-sub.ant-menu-inline {\n  border: 0;\n}\n.ant-menu-rtl.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {\n  padding-right: 32px;\n  padding-left: 0;\n}\n.ant-message {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: fixed;\n  top: 8px;\n  left: 0;\n  z-index: 1010;\n  width: 100%;\n  pointer-events: none;\n}\n.ant-message-notice {\n  padding: 8px;\n  text-align: center;\n}\n.ant-message-notice-content {\n  display: inline-block;\n  padding: 10px 16px;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  pointer-events: all;\n}\n.ant-message-success .anticon {\n  color: #52c41a;\n}\n.ant-message-error .anticon {\n  color: #f5222d;\n}\n.ant-message-warning .anticon {\n  color: #fa8c16;\n}\n.ant-message-info .anticon,\n.ant-message-loading .anticon {\n  color: #1890ff;\n}\n.ant-message .anticon {\n  position: relative;\n  top: 1px;\n  margin-right: 8px;\n  font-size: 16px;\n}\n.ant-message-notice.ant-move-up-leave.ant-move-up-leave-active {\n  animation-name: MessageMoveOut;\n  animation-duration: 0.3s;\n}\n@keyframes MessageMoveOut {\n  0% {\n    max-height: 150px;\n    padding: 8px;\n    opacity: 1;\n  }\n  100% {\n    max-height: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n.ant-message-rtl {\n  direction: rtl;\n}\n.ant-message-rtl span {\n  direction: rtl;\n}\n.ant-message-rtl .anticon {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-modal {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  pointer-events: none;\n  position: relative;\n  top: 100px;\n  width: auto;\n  max-width: calc(100vw - 32px);\n  margin: 0 auto;\n  padding-bottom: 24px;\n}\n.ant-modal.ant-zoom-enter,\n.ant-modal.ant-zoom-appear {\n  transform: none;\n  opacity: 0;\n  animation-duration: 0.3s;\n  user-select: none;\n}\n.ant-modal-mask {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.45);\n}\n.ant-modal-mask-hidden {\n  display: none;\n}\n.ant-modal-wrap {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: auto;\n  outline: 0;\n}\n.ant-modal-wrap {\n  z-index: 1000;\n}\n.ant-modal-title {\n  margin: 0;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  word-wrap: break-word;\n}\n.ant-modal-content {\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-radius: 6px;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  pointer-events: auto;\n}\n.ant-modal-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 10;\n  padding: 0;\n  color: #595959;\n  font-weight: 700;\n  line-height: 1;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n.ant-modal-close-x {\n  display: block;\n  width: 54px;\n  height: 54px;\n  font-size: 16px;\n  font-style: normal;\n  line-height: 54px;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n}\n.ant-modal-close:focus,\n.ant-modal-close:hover {\n  color: rgba(0, 0, 0, 0.75);\n  text-decoration: none;\n}\n.ant-modal-header {\n  padding: 16px 24px;\n  color: #545454;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 6px 6px 0 0;\n}\n.ant-modal-body {\n  padding: 24px;\n  font-size: 14px;\n  line-height: 1.3;\n  word-wrap: break-word;\n}\n.ant-modal-footer {\n  padding: 10px 16px;\n  text-align: right;\n  background: transparent;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0 0 6px 6px;\n}\n.ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {\n  margin-bottom: 0;\n  margin-left: 8px;\n}\n.ant-modal-open {\n  overflow: hidden;\n}\n.ant-modal-centered {\n  text-align: center;\n}\n.ant-modal-centered::before {\n  display: inline-block;\n  width: 0;\n  height: 100%;\n  vertical-align: middle;\n  content: '';\n}\n.ant-modal-centered .ant-modal {\n  top: 0;\n  display: inline-block;\n  padding-bottom: 0;\n  text-align: left;\n  vertical-align: middle;\n}\n@media (max-width: 767px) {\n  .ant-modal {\n    max-width: calc(100vw - 16px);\n    margin: 8px auto;\n  }\n  .ant-modal-centered .ant-modal {\n    flex: 1;\n  }\n}\n.ant-modal-confirm .ant-modal-header {\n  display: none;\n}\n.ant-modal-confirm .ant-modal-body {\n  padding: 32px 32px 24px;\n}\n.ant-modal-confirm-body-wrapper::before {\n  display: table;\n  content: '';\n}\n.ant-modal-confirm-body-wrapper::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-modal-confirm-body-wrapper::before {\n  display: table;\n  content: '';\n}\n.ant-modal-confirm-body-wrapper::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-modal-confirm-body .ant-modal-confirm-title {\n  display: block;\n  overflow: hidden;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.4;\n}\n.ant-modal-confirm-body .ant-modal-confirm-content {\n  margin-top: 8px;\n  color: #545454;\n  font-size: 14px;\n}\n.ant-modal-confirm-body > .anticon {\n  float: left;\n  margin-right: 16px;\n  font-size: 22px;\n}\n.ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {\n  margin-left: 38px;\n}\n.ant-modal-confirm .ant-modal-confirm-btns {\n  margin-top: 24px;\n  text-align: right;\n}\n.ant-modal-confirm .ant-modal-confirm-btns .ant-btn + .ant-btn {\n  margin-bottom: 0;\n  margin-left: 8px;\n}\n.ant-modal-confirm-error .ant-modal-confirm-body > .anticon {\n  color: #f5222d;\n}\n.ant-modal-confirm-warning .ant-modal-confirm-body > .anticon,\n.ant-modal-confirm-confirm .ant-modal-confirm-body > .anticon {\n  color: #fa8c16;\n}\n.ant-modal-confirm-info .ant-modal-confirm-body > .anticon {\n  color: #1890ff;\n}\n.ant-modal-confirm-success .ant-modal-confirm-body > .anticon {\n  color: #52c41a;\n}\n.ant-modal-confirm .ant-zoom-leave .ant-modal-confirm-btns {\n  pointer-events: none;\n}\n.ant-modal-wrap-rtl {\n  direction: rtl;\n}\n.ant-modal-wrap-rtl .ant-modal-close {\n  right: initial;\n  left: 0;\n}\n.ant-modal-wrap-rtl .ant-modal-footer {\n  text-align: left;\n}\n.ant-modal-wrap-rtl .ant-modal-footer .ant-btn + .ant-btn {\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-modal-wrap-rtl .ant-modal-confirm-body {\n  direction: rtl;\n}\n.ant-modal-wrap-rtl .ant-modal-confirm-body > .anticon {\n  float: right;\n  margin-right: 0;\n  margin-left: 16px;\n}\n.ant-modal-wrap-rtl .ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {\n  margin-right: 38px;\n  margin-left: 0;\n}\n.ant-modal-wrap-rtl .ant-modal-confirm-btns {\n  text-align: left;\n}\n.ant-modal-wrap-rtl .ant-modal-confirm-btns .ant-btn + .ant-btn {\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-modal-wrap-rtl.ant-modal-centered .ant-modal {\n  text-align: right;\n}\n.ant-notification {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: fixed;\n  z-index: 1010;\n  margin-right: 24px;\n}\n.ant-notification-close-icon {\n  font-size: 14px;\n  cursor: pointer;\n}\n.ant-notification-hook-holder {\n  position: relative;\n}\n.ant-notification-notice {\n  position: relative;\n  width: 384px;\n  max-width: calc(100vw - 24px * 2);\n  margin-bottom: 16px;\n  margin-left: auto;\n  padding: 16px 24px;\n  overflow: hidden;\n  line-height: 1.3;\n  word-wrap: break-word;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n.ant-notification-top .ant-notification-notice,\n.ant-notification-bottom .ant-notification-notice {\n  margin-right: auto;\n  margin-left: auto;\n}\n.ant-notification-topLeft .ant-notification-notice,\n.ant-notification-bottomLeft .ant-notification-notice {\n  margin-right: auto;\n  margin-left: 0;\n}\n.ant-notification-notice-message {\n  margin-bottom: 8px;\n  color: #535353;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-notification-notice-message-single-line-auto-margin {\n  display: block;\n  width: calc(384px - 24px * 2 - 24px - 48px - 100%);\n  max-width: 4px;\n  background-color: transparent;\n  pointer-events: none;\n}\n.ant-notification-notice-message-single-line-auto-margin::before {\n  display: block;\n  content: '';\n}\n.ant-notification-notice-description {\n  font-size: 14px;\n}\n.ant-notification-notice-closable .ant-notification-notice-message {\n  padding-right: 24px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-message {\n  margin-bottom: 4px;\n  margin-left: 48px;\n  font-size: 16px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-left: 48px;\n  font-size: 14px;\n}\n.ant-notification-notice-icon {\n  position: absolute;\n  margin-left: 4px;\n  font-size: 24px;\n  line-height: 24px;\n}\n.anticon.ant-notification-notice-icon-success {\n  color: #52c41a;\n}\n.anticon.ant-notification-notice-icon-info {\n  color: #1890ff;\n}\n.anticon.ant-notification-notice-icon-warning {\n  color: #fa8c16;\n}\n.anticon.ant-notification-notice-icon-error {\n  color: #f5222d;\n}\n.ant-notification-notice-close {\n  position: absolute;\n  top: 16px;\n  right: 22px;\n  color: #595959;\n  outline: none;\n}\n.ant-notification-notice-close:hover {\n  color: #353535;\n}\n.ant-notification-notice-btn {\n  float: right;\n  margin-top: 16px;\n}\n.ant-notification .notification-fade-effect {\n  animation-duration: 0.24s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-fill-mode: both;\n}\n.ant-notification-fade-enter,\n.ant-notification-fade-appear {\n  animation-duration: 0.24s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-fill-mode: both;\n  opacity: 0;\n  animation-play-state: paused;\n}\n.ant-notification-fade-leave {\n  animation-duration: 0.24s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-fill-mode: both;\n  animation-duration: 0.2s;\n  animation-play-state: paused;\n}\n.ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationFadeIn;\n  animation-play-state: running;\n}\n.ant-notification-fade-leave.ant-notification-fade-leave-active {\n  animation-name: NotificationFadeOut;\n  animation-play-state: running;\n}\n@keyframes NotificationFadeIn {\n  0% {\n    left: 384px;\n    opacity: 0;\n  }\n  100% {\n    left: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationFadeOut {\n  0% {\n    max-height: 150px;\n    margin-bottom: 16px;\n    opacity: 1;\n  }\n  100% {\n    max-height: 0;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    opacity: 0;\n  }\n}\n.ant-notification-rtl {\n  direction: rtl;\n}\n.ant-notification-rtl .ant-notification-notice-closable .ant-notification-notice-message {\n  padding-right: 0;\n  padding-left: 24px;\n}\n.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-message {\n  margin-right: 48px;\n  margin-left: 0;\n}\n.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-right: 48px;\n  margin-left: 0;\n}\n.ant-notification-rtl .ant-notification-notice-icon {\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-notification-rtl .ant-notification-notice-close {\n  right: auto;\n  left: 22px;\n}\n.ant-notification-rtl .ant-notification-notice-btn {\n  float: left;\n}\n.ant-notification-top,\n.ant-notification-bottom {\n  margin-right: 0;\n  margin-left: 0;\n}\n.ant-notification-top .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-top .ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationTopFadeIn;\n}\n.ant-notification-bottom .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-bottom .ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationBottomFadeIn;\n}\n.ant-notification-topLeft,\n.ant-notification-bottomLeft {\n  margin-right: 0;\n  margin-left: 24px;\n}\n.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,\n.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationLeftFadeIn;\n}\n@keyframes NotificationTopFadeIn {\n  0% {\n    margin-top: -100%;\n    opacity: 0;\n  }\n  100% {\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationBottomFadeIn {\n  0% {\n    margin-bottom: -100%;\n    opacity: 0;\n  }\n  100% {\n    margin-bottom: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationLeftFadeIn {\n  0% {\n    right: 384px;\n    opacity: 0;\n  }\n  100% {\n    right: 0;\n    opacity: 1;\n  }\n}\n.ant-page-header {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  padding: 16px 24px;\n  background-color: #fff;\n}\n.ant-page-header-ghost {\n  background-color: inherit;\n}\n.ant-page-header.has-breadcrumb {\n  padding-top: 12px;\n}\n.ant-page-header.has-footer {\n  padding-bottom: 0;\n}\n.ant-page-header-back {\n  margin-right: 16px;\n  font-size: 16px;\n  line-height: 1;\n}\n.ant-page-header-back-button {\n  color: var(--app-primary-color);\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  color: #000;\n}\n.ant-page-header-back-button:focus-visible,\n.ant-page-header-back-button:hover {\n  color: #0d0d0d;\n}\n.ant-page-header-back-button:active {\n  color: #000000;\n}\n.ant-page-header .ant-divider-vertical {\n  height: 14px;\n  margin: 0 12px;\n  vertical-align: middle;\n}\n.ant-breadcrumb + .ant-page-header-heading {\n  margin-top: 8px;\n}\n.ant-page-header-heading {\n  display: flex;\n  justify-content: space-between;\n}\n.ant-page-header-heading-left {\n  display: flex;\n  align-items: center;\n  margin: 4px 0;\n  overflow: hidden;\n}\n.ant-page-header-heading-title {\n  margin-right: 12px;\n  margin-bottom: 0;\n  color: #535353;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 32px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-page-header-heading .ant-avatar {\n  margin-right: 12px;\n}\n.ant-page-header-heading-sub-title {\n  margin-right: 12px;\n  color: #595959;\n  font-size: 14px;\n  line-height: 1.3;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-page-header-heading-extra {\n  margin: 4px 0;\n  white-space: nowrap;\n}\n.ant-page-header-heading-extra > * {\n  white-space: unset;\n}\n.ant-page-header-content {\n  padding-top: 12px;\n}\n.ant-page-header-footer {\n  margin-top: 16px;\n}\n.ant-page-header-footer .ant-tabs > .ant-tabs-nav {\n  margin: 0;\n}\n.ant-page-header-footer .ant-tabs > .ant-tabs-nav::before {\n  border: none;\n}\n.ant-page-header-footer .ant-tabs .ant-tabs-tab {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  font-size: 16px;\n}\n.ant-page-header-compact .ant-page-header-heading {\n  flex-wrap: wrap;\n}\n.ant-page-header-rtl {\n  direction: rtl;\n}\n.ant-page-header-rtl .ant-page-header-back {\n  float: right;\n  margin-right: 0;\n  margin-left: 16px;\n}\n.ant-page-header-rtl .ant-page-header-heading-title {\n  margin-right: 0;\n  margin-left: 12px;\n}\n.ant-page-header-rtl .ant-page-header-heading .ant-avatar {\n  margin-right: 0;\n  margin-left: 12px;\n}\n.ant-page-header-rtl .ant-page-header-heading-sub-title {\n  float: right;\n  margin-right: 0;\n  margin-left: 12px;\n}\n.ant-page-header-rtl .ant-page-header-heading-tags {\n  float: right;\n}\n.ant-page-header-rtl .ant-page-header-heading-extra {\n  float: left;\n}\n.ant-page-header-rtl .ant-page-header-heading-extra > * {\n  margin-right: 12px;\n  margin-left: 0;\n}\n.ant-page-header-rtl .ant-page-header-heading-extra > *:first-child {\n  margin-right: 0;\n}\n.ant-page-header-rtl .ant-page-header-footer .ant-tabs-bar .ant-tabs-nav {\n  float: right;\n}\n.ant-pagination {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-pagination ul,\n.ant-pagination ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-pagination::after {\n  display: block;\n  clear: both;\n  height: 0;\n  overflow: hidden;\n  visibility: hidden;\n  content: ' ';\n}\n.ant-pagination-total-text {\n  display: inline-block;\n  height: 32px;\n  margin-right: 8px;\n  line-height: 30px;\n  vertical-align: middle;\n}\n.ant-pagination-item {\n  display: inline-block;\n  min-width: 32px;\n  height: 32px;\n  margin-right: 8px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  line-height: 30px;\n  text-align: center;\n  vertical-align: middle;\n  list-style: none;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  outline: 0;\n  cursor: pointer;\n  user-select: none;\n}\n.ant-pagination-item a {\n  display: block;\n  padding: 0 6px;\n  color: #545454;\n  transition: none;\n}\n.ant-pagination-item a:hover {\n  text-decoration: none;\n}\n.ant-pagination-item:hover {\n  border-color: #351a55;\n  transition: all 0.3s;\n}\n.ant-pagination-item:hover a {\n  color: #351a55;\n}\n.ant-pagination-item:focus-visible {\n  border-color: #351a55;\n  transition: all 0.3s;\n}\n.ant-pagination-item:focus-visible a {\n  color: #351a55;\n}\n.ant-pagination-item-active {\n  font-weight: 500;\n  background: #fff;\n  border-color: #351a55;\n}\n.ant-pagination-item-active a {\n  color: #351a55;\n}\n.ant-pagination-item-active:hover {\n  border-color: #462e61;\n}\n.ant-pagination-item-active:focus-visible {\n  border-color: #462e61;\n}\n.ant-pagination-item-active:hover a {\n  color: #462e61;\n}\n.ant-pagination-item-active:focus-visible a {\n  color: #462e61;\n}\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  outline: 0;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container,\n.ant-pagination-jump-next .ant-pagination-item-container {\n  position: relative;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n  color: #351a55;\n  font-size: 12px;\n  letter-spacing: -1px;\n  opacity: 0;\n  transition: all 0.2s;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon-svg,\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon-svg {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  margin: auto;\n  color: rgba(0, 0, 0, 0.25);\n  font-family: Arial, Helvetica, sans-serif;\n  letter-spacing: 2px;\n  text-align: center;\n  text-indent: 0.13em;\n  opacity: 1;\n  transition: all 0.2s;\n}\n.ant-pagination-jump-prev:hover .ant-pagination-item-link-icon,\n.ant-pagination-jump-next:hover .ant-pagination-item-link-icon {\n  opacity: 1;\n}\n.ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis,\n.ant-pagination-jump-next:hover .ant-pagination-item-ellipsis {\n  opacity: 0;\n}\n.ant-pagination-jump-prev:focus-visible .ant-pagination-item-link-icon,\n.ant-pagination-jump-next:focus-visible .ant-pagination-item-link-icon {\n  opacity: 1;\n}\n.ant-pagination-jump-prev:focus-visible .ant-pagination-item-ellipsis,\n.ant-pagination-jump-next:focus-visible .ant-pagination-item-ellipsis {\n  opacity: 0;\n}\n.ant-pagination-prev,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  margin-right: 8px;\n}\n.ant-pagination-prev,\n.ant-pagination-next,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  display: inline-block;\n  min-width: 32px;\n  height: 32px;\n  color: #545454;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  line-height: 32px;\n  text-align: center;\n  vertical-align: middle;\n  list-style: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-pagination-prev,\n.ant-pagination-next {\n  font-family: Arial, Helvetica, sans-serif;\n  outline: 0;\n}\n.ant-pagination-prev button,\n.ant-pagination-next button {\n  color: #545454;\n  cursor: pointer;\n  user-select: none;\n}\n.ant-pagination-prev:hover button,\n.ant-pagination-next:hover button {\n  border-color: #462e61;\n}\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link {\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  font-size: 12px;\n  text-align: center;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  outline: none;\n  transition: all 0.3s;\n}\n.ant-pagination-prev:focus-visible .ant-pagination-item-link,\n.ant-pagination-next:focus-visible .ant-pagination-item-link {\n  color: #351a55;\n  border-color: #351a55;\n}\n.ant-pagination-prev:hover .ant-pagination-item-link,\n.ant-pagination-next:hover .ant-pagination-item-link {\n  color: #351a55;\n  border-color: #351a55;\n}\n.ant-pagination-disabled,\n.ant-pagination-disabled:hover {\n  cursor: not-allowed;\n}\n.ant-pagination-disabled .ant-pagination-item-link,\n.ant-pagination-disabled:hover .ant-pagination-item-link {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination-disabled:focus-visible {\n  cursor: not-allowed;\n}\n.ant-pagination-disabled:focus-visible .ant-pagination-item-link {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination-slash {\n  margin: 0 10px 0 5px;\n}\n.ant-pagination-options {\n  display: inline-block;\n  margin-left: 16px;\n  vertical-align: middle;\n}\n@media all and (-ms-high-contrast: none) {\n  .ant-pagination-options *::-ms-backdrop,\n  .ant-pagination-options {\n    vertical-align: top;\n  }\n}\n.ant-pagination-options-size-changer.ant-select {\n  display: inline-block;\n  width: auto;\n}\n.ant-pagination-options-quick-jumper {\n  display: inline-block;\n  height: 36px;\n  margin-left: 8px;\n  line-height: 36px;\n  vertical-align: top;\n}\n.ant-pagination-options-quick-jumper input {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  min-width: 0;\n  padding: 7.9px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n  width: 50px;\n  height: 36px;\n  margin: 0 8px;\n}\n.ant-pagination-options-quick-jumper input::placeholder {\n  color: #bfbfbf;\n  user-select: none;\n}\n.ant-pagination-options-quick-jumper input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-pagination-options-quick-jumper input:hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-pagination-options-quick-jumper input:hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-pagination-options-quick-jumper input:focus,\n.ant-pagination-options-quick-jumper input-focused {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-pagination-options-quick-jumper input:focus,\n.ant-input-rtl .ant-pagination-options-quick-jumper input-focused {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-pagination-options-quick-jumper input-disabled {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-pagination-options-quick-jumper input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-pagination-options-quick-jumper input[disabled] {\n  color: #999;\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-pagination-options-quick-jumper input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px;\n}\n.ant-pagination-options-quick-jumper input-borderless,\n.ant-pagination-options-quick-jumper input-borderless:hover,\n.ant-pagination-options-quick-jumper input-borderless:focus,\n.ant-pagination-options-quick-jumper input-borderless-focused,\n.ant-pagination-options-quick-jumper input-borderless-disabled,\n.ant-pagination-options-quick-jumper input-borderless[disabled] {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\ntextarea.ant-pagination-options-quick-jumper input {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-pagination-options-quick-jumper input-lg {\n  padding: 8.6px 11px;\n  font-size: 16px;\n}\n.ant-pagination-options-quick-jumper input-sm {\n  padding: 1.9px 7px;\n}\n.ant-pagination-options-quick-jumper input-rtl {\n  direction: rtl;\n}\n.ant-pagination-simple .ant-pagination-prev,\n.ant-pagination-simple .ant-pagination-next {\n  height: 24px;\n  line-height: 24px;\n  vertical-align: top;\n}\n.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link {\n  height: 24px;\n  background-color: transparent;\n  border: 0;\n}\n.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link::after,\n.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link::after {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination-simple .ant-pagination-simple-pager {\n  display: inline-block;\n  height: 24px;\n  margin-right: 8px;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input {\n  box-sizing: border-box;\n  height: 100%;\n  margin-right: 8px;\n  padding: 0 6px;\n  text-align: center;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  outline: none;\n  transition: border-color 0.3s;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input:hover {\n  border-color: #351a55;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input:focus {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n}\n.ant-pagination-simple .ant-pagination-simple-pager input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-total-text,\n.ant-pagination.ant-pagination-mini .ant-pagination-simple-pager {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-item {\n  min-width: 24px;\n  height: 24px;\n  margin: 0;\n  line-height: 22px;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-item:not(.ant-pagination-item-active) {\n  background: transparent;\n  border-color: transparent;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-prev,\n.ant-pagination.ant-pagination-mini .ant-pagination-next {\n  min-width: 24px;\n  height: 24px;\n  margin: 0;\n  line-height: 24px;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination.ant-pagination-mini .ant-pagination-next .ant-pagination-item-link {\n  background: transparent;\n  border-color: transparent;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-prev .ant-pagination-item-link::after,\n.ant-pagination.ant-pagination-mini .ant-pagination-next .ant-pagination-item-link::after {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-jump-prev,\n.ant-pagination.ant-pagination-mini .ant-pagination-jump-next {\n  height: 24px;\n  margin-right: 0;\n  line-height: 24px;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-options {\n  margin-left: 2px;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-options-size-changer {\n  top: 0px;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-options-quick-jumper {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-options-quick-jumper input {\n  padding: 1.9px 7px;\n  width: 44px;\n  height: 24px;\n}\n.ant-pagination.ant-pagination-disabled {\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item {\n  background: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item a {\n  color: rgba(0, 0, 0, 0.25);\n  background: transparent;\n  border: none;\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-active {\n  background: #e6e6e6;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-link {\n  color: rgba(0, 0, 0, 0.25);\n  background: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination-simple.ant-pagination.ant-pagination-disabled .ant-pagination-item-link {\n  background: transparent;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-link-icon {\n  opacity: 0;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-ellipsis {\n  opacity: 1;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-simple-pager {\n  color: rgba(0, 0, 0, 0.25);\n}\n@media only screen and (max-width: 992px) {\n  .ant-pagination-item-after-jump-prev,\n  .ant-pagination-item-before-jump-next {\n    display: none;\n  }\n}\n@media only screen and (max-width: 576px) {\n  .ant-pagination-options {\n    display: none;\n  }\n}\n.ant-pagination-rtl .ant-pagination-total-text {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-pagination-rtl .ant-pagination-item,\n.ant-pagination-rtl .ant-pagination-prev,\n.ant-pagination-rtl .ant-pagination-jump-prev,\n.ant-pagination-rtl .ant-pagination-jump-next {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-pagination-rtl .ant-pagination-slash {\n  margin: 0 5px 0 10px;\n}\n.ant-pagination-rtl .ant-pagination-options {\n  margin-right: 16px;\n  margin-left: 0;\n}\n.ant-pagination-rtl .ant-pagination-options .ant-pagination-options-size-changer.ant-select {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-pagination-rtl .ant-pagination-options .ant-pagination-options-quick-jumper {\n  margin-left: 0;\n}\n.ant-pagination-rtl.ant-pagination-simple .ant-pagination-simple-pager {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-pagination-rtl.ant-pagination-simple .ant-pagination-simple-pager input {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-pagination-rtl.ant-pagination.mini .ant-pagination-options {\n  margin-right: 2px;\n  margin-left: 0;\n}\n.ant-popconfirm {\n  z-index: 1060;\n}\n.ant-popover {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1030;\n  max-width: 100vw;\n  font-weight: normal;\n  white-space: normal;\n  text-align: left;\n  cursor: auto;\n  user-select: text;\n}\n.ant-popover-content {\n  position: relative;\n}\n.ant-popover::after {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.01);\n  content: '';\n}\n.ant-popover-hidden {\n  display: none;\n}\n.ant-popover-placement-top,\n.ant-popover-placement-topLeft,\n.ant-popover-placement-topRight {\n  padding-bottom: 15.3137085px;\n}\n.ant-popover-placement-right,\n.ant-popover-placement-rightTop,\n.ant-popover-placement-rightBottom {\n  padding-left: 15.3137085px;\n}\n.ant-popover-placement-bottom,\n.ant-popover-placement-bottomLeft,\n.ant-popover-placement-bottomRight {\n  padding-top: 15.3137085px;\n}\n.ant-popover-placement-left,\n.ant-popover-placement-leftTop,\n.ant-popover-placement-leftBottom {\n  padding-right: 15.3137085px;\n}\n.ant-popover-inner {\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 6px;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ant-popover {\n    /* IE10+ */\n  }\n  .ant-popover-inner {\n    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  }\n}\n.ant-popover-title {\n  min-width: 177px;\n  min-height: 32px;\n  margin: 0;\n  padding: 5px 16px 4px;\n  color: #535353;\n  font-weight: 500;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-popover-inner-content {\n  width: max-content;\n  max-width: 100%;\n  padding: 12px 16px;\n  color: #545454;\n}\n.ant-popover-message {\n  display: flex;\n  padding: 4px 0 12px;\n  color: #545454;\n  font-size: 14px;\n}\n.ant-popover-message-icon {\n  display: inline-block;\n  margin-right: 8px;\n  color: #fa8c16;\n  font-size: 14px;\n}\n.ant-popover-buttons {\n  margin-bottom: 4px;\n  text-align: right;\n}\n.ant-popover-buttons button:not(:first-child) {\n  margin-left: 8px;\n}\n.ant-popover-arrow {\n  position: absolute;\n  display: block;\n  width: 22px;\n  height: 22px;\n  overflow: hidden;\n  background: transparent;\n  pointer-events: none;\n}\n.ant-popover-arrow-content {\n  --antd-arrow-background-color: #fff;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: 11.3137085px;\n  height: 11.3137085px;\n  margin: auto;\n  content: '';\n  pointer-events: auto;\n  border-radius: 0 0 2px;\n  pointer-events: none;\n}\n.ant-popover-arrow-content::before {\n  position: absolute;\n  top: -11.3137085px;\n  left: -11.3137085px;\n  width: 33.9411255px;\n  height: 33.9411255px;\n  background: var(--antd-arrow-background-color);\n  background-repeat: no-repeat;\n  background-position: -10px -10px;\n  content: '';\n  clip-path: inset(33% 33%);\n  clip-path: path('M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z');\n}\n.ant-popover-placement-top .ant-popover-arrow,\n.ant-popover-placement-topLeft .ant-popover-arrow,\n.ant-popover-placement-topRight .ant-popover-arrow {\n  bottom: 0;\n  transform: translateY(100%);\n}\n.ant-popover-placement-top .ant-popover-arrow-content,\n.ant-popover-placement-topLeft .ant-popover-arrow-content,\n.ant-popover-placement-topRight .ant-popover-arrow-content {\n  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateY(-11px) rotate(45deg);\n}\n.ant-popover-placement-top .ant-popover-arrow {\n  left: 50%;\n  transform: translateY(100%) translateX(-50%);\n}\n.ant-popover-placement-topLeft .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-topRight .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-right .ant-popover-arrow,\n.ant-popover-placement-rightTop .ant-popover-arrow,\n.ant-popover-placement-rightBottom .ant-popover-arrow {\n  left: 0;\n  transform: translateX(-100%);\n}\n.ant-popover-placement-right .ant-popover-arrow-content,\n.ant-popover-placement-rightTop .ant-popover-arrow-content,\n.ant-popover-placement-rightBottom .ant-popover-arrow-content {\n  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateX(11px) rotate(135deg);\n}\n.ant-popover-placement-right .ant-popover-arrow {\n  top: 50%;\n  transform: translateX(-100%) translateY(-50%);\n}\n.ant-popover-placement-rightTop .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-rightBottom .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover-placement-bottom .ant-popover-arrow,\n.ant-popover-placement-bottomLeft .ant-popover-arrow,\n.ant-popover-placement-bottomRight .ant-popover-arrow {\n  top: 0;\n  transform: translateY(-100%);\n}\n.ant-popover-placement-bottom .ant-popover-arrow-content,\n.ant-popover-placement-bottomLeft .ant-popover-arrow-content,\n.ant-popover-placement-bottomRight .ant-popover-arrow-content {\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.06);\n  transform: translateY(11px) rotate(-135deg);\n}\n.ant-popover-placement-bottom .ant-popover-arrow {\n  left: 50%;\n  transform: translateY(-100%) translateX(-50%);\n}\n.ant-popover-placement-bottomLeft .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-bottomRight .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-left .ant-popover-arrow,\n.ant-popover-placement-leftTop .ant-popover-arrow,\n.ant-popover-placement-leftBottom .ant-popover-arrow {\n  right: 0;\n  transform: translateX(100%);\n}\n.ant-popover-placement-left .ant-popover-arrow-content,\n.ant-popover-placement-leftTop .ant-popover-arrow-content,\n.ant-popover-placement-leftBottom .ant-popover-arrow-content {\n  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateX(-11px) rotate(-45deg);\n}\n.ant-popover-placement-left .ant-popover-arrow {\n  top: 50%;\n  transform: translateX(100%) translateY(-50%);\n}\n.ant-popover-placement-leftTop .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-leftBottom .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover-pink .ant-popover-inner {\n  background-color: #eb2f96;\n}\n.ant-popover-pink .ant-popover-arrow-content {\n  background-color: #eb2f96;\n}\n.ant-popover-magenta .ant-popover-inner {\n  background-color: #eb2f96;\n}\n.ant-popover-magenta .ant-popover-arrow-content {\n  background-color: #eb2f96;\n}\n.ant-popover-red .ant-popover-inner {\n  background-color: #f5222d;\n}\n.ant-popover-red .ant-popover-arrow-content {\n  background-color: #f5222d;\n}\n.ant-popover-volcano .ant-popover-inner {\n  background-color: #fa541c;\n}\n.ant-popover-volcano .ant-popover-arrow-content {\n  background-color: #fa541c;\n}\n.ant-popover-orange .ant-popover-inner {\n  background-color: #fa8c16;\n}\n.ant-popover-orange .ant-popover-arrow-content {\n  background-color: #fa8c16;\n}\n.ant-popover-yellow .ant-popover-inner {\n  background-color: #fadb14;\n}\n.ant-popover-yellow .ant-popover-arrow-content {\n  background-color: #fadb14;\n}\n.ant-popover-gold .ant-popover-inner {\n  background-color: #faad14;\n}\n.ant-popover-gold .ant-popover-arrow-content {\n  background-color: #faad14;\n}\n.ant-popover-cyan .ant-popover-inner {\n  background-color: #13c2c2;\n}\n.ant-popover-cyan .ant-popover-arrow-content {\n  background-color: #13c2c2;\n}\n.ant-popover-lime .ant-popover-inner {\n  background-color: #a0d911;\n}\n.ant-popover-lime .ant-popover-arrow-content {\n  background-color: #a0d911;\n}\n.ant-popover-green .ant-popover-inner {\n  background-color: #52c41a;\n}\n.ant-popover-green .ant-popover-arrow-content {\n  background-color: #52c41a;\n}\n.ant-popover-blue .ant-popover-inner {\n  background-color: #1890ff;\n}\n.ant-popover-blue .ant-popover-arrow-content {\n  background-color: #1890ff;\n}\n.ant-popover-geekblue .ant-popover-inner {\n  background-color: #2f54eb;\n}\n.ant-popover-geekblue .ant-popover-arrow-content {\n  background-color: #2f54eb;\n}\n.ant-popover-purple .ant-popover-inner {\n  background-color: #722ed1;\n}\n.ant-popover-purple .ant-popover-arrow-content {\n  background-color: #722ed1;\n}\n.ant-popover-rtl {\n  direction: rtl;\n  text-align: right;\n}\n.ant-popover-rtl .ant-popover-message-icon {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-popover-rtl .ant-popover-message-title {\n  padding-left: 16px;\n}\n.ant-popover-rtl .ant-popover-buttons {\n  text-align: left;\n}\n.ant-popover-rtl .ant-popover-buttons button {\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-progress {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-progress-line {\n  position: relative;\n  width: 100%;\n  font-size: 14px;\n}\n.ant-progress-steps {\n  display: inline-block;\n}\n.ant-progress-steps-outer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.ant-progress-steps-item {\n  flex-shrink: 0;\n  min-width: 2px;\n  margin-right: 2px;\n  background: #f3f3f3;\n  transition: all 0.3s;\n}\n.ant-progress-steps-item-active {\n  background: var(--app-primary-color);\n}\n.ant-progress-small.ant-progress-line,\n.ant-progress-small.ant-progress-line .ant-progress-text .anticon {\n  font-size: 12px;\n}\n.ant-progress-outer {\n  display: inline-block;\n  width: 100%;\n  margin-right: 0;\n  padding-right: 0;\n}\n.ant-progress-show-info .ant-progress-outer {\n  margin-right: calc(-2em - 8px);\n  padding-right: calc(2em + 8px);\n}\n.ant-progress-inner {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  vertical-align: middle;\n  background-color: #f5f5f5;\n  border-radius: 100px;\n}\n.ant-progress-circle-trail {\n  stroke: #f5f5f5;\n}\n.ant-progress-circle-path {\n  animation: ant-progress-appear 0.3s;\n}\n.ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {\n  stroke: var(--app-primary-color);\n}\n.ant-progress-success-bg,\n.ant-progress-bg {\n  position: relative;\n  background-color: var(--app-primary-color);\n  border-radius: 100px;\n  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;\n}\n.ant-progress-success-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #52c41a;\n}\n.ant-progress-text {\n  display: inline-block;\n  width: 2em;\n  margin-left: 8px;\n  color: #545454;\n  font-size: 1em;\n  line-height: 1;\n  white-space: nowrap;\n  text-align: left;\n  vertical-align: middle;\n  word-break: normal;\n}\n.ant-progress-text .anticon {\n  font-size: 14px;\n}\n.ant-progress-status-active .ant-progress-bg::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #fff;\n  border-radius: 10px;\n  opacity: 0;\n  animation: ant-progress-active 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;\n  content: '';\n}\n.ant-progress-status-exception .ant-progress-bg {\n  background-color: #f5222d;\n}\n.ant-progress-status-exception .ant-progress-text {\n  color: #f5222d;\n}\n.ant-progress-status-exception .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {\n  stroke: #f5222d;\n}\n.ant-progress-status-success .ant-progress-bg {\n  background-color: #52c41a;\n}\n.ant-progress-status-success .ant-progress-text {\n  color: #52c41a;\n}\n.ant-progress-status-success .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {\n  stroke: #52c41a;\n}\n.ant-progress-circle .ant-progress-inner {\n  position: relative;\n  line-height: 1;\n  background-color: transparent;\n}\n.ant-progress-circle .ant-progress-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 1em;\n  line-height: 1;\n  white-space: normal;\n  text-align: center;\n  transform: translate(-50%, -50%);\n}\n.ant-progress-circle .ant-progress-text .anticon {\n  font-size: 1.16666667em;\n}\n.ant-progress-circle.ant-progress-status-exception .ant-progress-text {\n  color: #f5222d;\n}\n.ant-progress-circle.ant-progress-status-success .ant-progress-text {\n  color: #52c41a;\n}\n@keyframes ant-progress-active {\n  0% {\n    transform: translateX(-100%) scaleX(0);\n    opacity: 0.1;\n  }\n  20% {\n    transform: translateX(-100%) scaleX(0);\n    opacity: 0.5;\n  }\n  100% {\n    transform: translateX(0) scaleX(1);\n    opacity: 0;\n  }\n}\n.ant-progress-rtl {\n  direction: rtl;\n}\n.ant-progress-rtl.ant-progress-show-info .ant-progress-outer {\n  margin-right: 0;\n  margin-left: calc(-2em - 8px);\n  padding-right: 0;\n  padding-left: calc(2em + 8px);\n}\n.ant-progress-rtl .ant-progress-success-bg {\n  right: 0;\n  left: auto;\n}\n.ant-progress-rtl.ant-progress-line .ant-progress-text,\n.ant-progress-rtl.ant-progress-steps .ant-progress-text {\n  margin-right: 8px;\n  margin-left: 0;\n  text-align: right;\n}\n.ant-radio-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  font-size: 0;\n}\n.ant-radio-group .ant-badge-count {\n  z-index: 1;\n}\n.ant-radio-group > .ant-badge:not(:first-child) > .ant-radio-button-wrapper {\n  border-left: none;\n}\n.ant-radio-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-flex;\n  align-items: baseline;\n  margin-right: 8px;\n  cursor: pointer;\n}\n.ant-radio-wrapper-disabled {\n  cursor: not-allowed;\n}\n.ant-radio-wrapper::after {\n  display: inline-block;\n  width: 0;\n  overflow: hidden;\n  content: '\\a0';\n}\n.ant-radio-wrapper.ant-radio-wrapper-in-form-item input[type='radio'] {\n  width: 14px;\n  height: 14px;\n}\n.ant-radio {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: 0.2em;\n  display: inline-block;\n  outline: none;\n  cursor: pointer;\n}\n.ant-radio-wrapper:hover .ant-radio,\n.ant-radio:hover .ant-radio-inner,\n.ant-radio-input:focus + .ant-radio-inner {\n  border-color: #351a55;\n}\n.ant-radio-input:focus + .ant-radio-inner {\n  box-shadow: 0 0 0 3px rgba(53, 26, 85, 0.12);\n}\n.ant-radio-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #351a55;\n  border-radius: 50%;\n  visibility: hidden;\n  animation: antRadioEffect 0.36s ease-in-out;\n  animation-fill-mode: both;\n  content: '';\n}\n.ant-radio:hover::after,\n.ant-radio-wrapper:hover .ant-radio::after {\n  visibility: visible;\n}\n.ant-radio-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  border-color: #d9d9d9;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 50%;\n  transition: all 0.3s;\n}\n.ant-radio-inner::after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  width: 16px;\n  height: 16px;\n  margin-top: -8px;\n  margin-left: -8px;\n  background-color: #351a55;\n  border-top: 0;\n  border-left: 0;\n  border-radius: 16px;\n  transform: scale(0);\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  content: ' ';\n}\n.ant-radio-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-radio.ant-radio-disabled .ant-radio-inner {\n  border-color: #d9d9d9;\n}\n.ant-radio-checked .ant-radio-inner {\n  border-color: #351a55;\n}\n.ant-radio-checked .ant-radio-inner::after {\n  transform: scale(0.5);\n  opacity: 1;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-radio-disabled {\n  cursor: not-allowed;\n}\n.ant-radio-disabled .ant-radio-inner {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n.ant-radio-disabled .ant-radio-inner::after {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.ant-radio-disabled .ant-radio-input {\n  cursor: not-allowed;\n}\n.ant-radio-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\nspan.ant-radio + * {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-radio-button-wrapper {\n  position: relative;\n  display: inline-block;\n  height: 36px;\n  margin: 0;\n  padding: 0 15px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 34px;\n  background: #fff;\n  border: 1px solid #d9d9d9;\n  border-top-width: 1.02px;\n  border-left-width: 0;\n  cursor: pointer;\n  transition: color 0.3s, background 0.3s, border-color 0.3s, box-shadow 0.3s;\n}\n.ant-radio-button-wrapper a {\n  color: #545454;\n}\n.ant-radio-button-wrapper > .ant-radio-button {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n}\n.ant-radio-group-large .ant-radio-button-wrapper {\n  height: 40px;\n  font-size: 16px;\n  line-height: 38px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper {\n  height: 24px;\n  padding: 0 7px;\n  line-height: 22px;\n}\n.ant-radio-button-wrapper:not(:first-child)::before {\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  display: block;\n  box-sizing: content-box;\n  width: 1px;\n  height: 100%;\n  padding: 1px 0;\n  background-color: #d9d9d9;\n  transition: background-color 0.3s;\n  content: '';\n}\n.ant-radio-button-wrapper:first-child {\n  border-left: 1px solid #d9d9d9;\n  border-radius: 6px 0 0 6px;\n}\n.ant-radio-button-wrapper:last-child {\n  border-radius: 0 6px 6px 0;\n}\n.ant-radio-button-wrapper:first-child:last-child {\n  border-radius: 6px;\n}\n.ant-radio-button-wrapper:hover {\n  position: relative;\n  color: #351a55;\n}\n.ant-radio-button-wrapper:focus-within {\n  box-shadow: 0 0 0 3px rgba(53, 26, 85, 0.12);\n}\n.ant-radio-button-wrapper .ant-radio-inner,\n.ant-radio-button-wrapper input[type='checkbox'],\n.ant-radio-button-wrapper input[type='radio'] {\n  width: 0;\n  height: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  z-index: 1;\n  color: #351a55;\n  background: #fff;\n  border-color: #351a55;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {\n  background-color: #351a55;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {\n  border-color: #351a55;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n  color: #462e61;\n  border-color: #462e61;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover::before {\n  background-color: #462e61;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {\n  color: #1a0c2e;\n  border-color: #1a0c2e;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active::before {\n  background-color: #1a0c2e;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {\n  box-shadow: 0 0 0 3px rgba(53, 26, 85, 0.12);\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  color: #fff;\n  background: #351a55;\n  border-color: #351a55;\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n  color: #fff;\n  background: #462e61;\n  border-color: #462e61;\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {\n  color: #fff;\n  background: #1a0c2e;\n  border-color: #1a0c2e;\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {\n  box-shadow: 0 0 0 3px rgba(53, 26, 85, 0.12);\n}\n.ant-radio-button-wrapper-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-radio-button-wrapper-disabled:first-child,\n.ant-radio-button-wrapper-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n}\n.ant-radio-button-wrapper-disabled:first-child {\n  border-left-color: #d9d9d9;\n}\n.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #e6e6e6;\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n@keyframes antRadioEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n.ant-radio-group.ant-radio-group-rtl {\n  direction: rtl;\n}\n.ant-radio-wrapper.ant-radio-wrapper-rtl {\n  margin-right: 0;\n  margin-left: 8px;\n  direction: rtl;\n}\n.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl {\n  border-right-width: 0;\n  border-left-width: 1px;\n}\n.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:not(:first-child)::before {\n  right: -1px;\n  left: 0;\n}\n.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:first-child {\n  border-right: 1px solid #d9d9d9;\n  border-radius: 0 6px 6px 0;\n}\n.ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {\n  border-right-color: #462e61;\n}\n.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:last-child {\n  border-radius: 6px 0 0 6px;\n}\n.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper-disabled:first-child {\n  border-right-color: #d9d9d9;\n}\n.ant-rate {\n  box-sizing: border-box;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  color: #fadb14;\n  font-size: 20px;\n  line-height: unset;\n  list-style: none;\n  outline: none;\n}\n.ant-rate-disabled .ant-rate-star {\n  cursor: default;\n}\n.ant-rate-disabled .ant-rate-star > div:hover {\n  transform: scale(1);\n}\n.ant-rate-star {\n  position: relative;\n  display: inline-block;\n  color: inherit;\n  cursor: pointer;\n}\n.ant-rate-star:not(:last-child) {\n  margin-right: 8px;\n}\n.ant-rate-star > div {\n  transition: all 0.3s, outline 0s;\n}\n.ant-rate-star > div:hover {\n  transform: scale(1.1);\n}\n.ant-rate-star > div:focus {\n  outline: 0;\n}\n.ant-rate-star > div:focus-visible {\n  outline: 1px dashed #fadb14;\n  transform: scale(1.1);\n}\n.ant-rate-star-first,\n.ant-rate-star-second {\n  color: #e8e8e8;\n  transition: all 0.3s;\n  user-select: none;\n}\n.ant-rate-star-first .anticon,\n.ant-rate-star-second .anticon {\n  vertical-align: middle;\n}\n.ant-rate-star-first {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 50%;\n  height: 100%;\n  overflow: hidden;\n  opacity: 0;\n}\n.ant-rate-star-half .ant-rate-star-first,\n.ant-rate-star-half .ant-rate-star-second {\n  opacity: 1;\n}\n.ant-rate-star-half .ant-rate-star-first,\n.ant-rate-star-full .ant-rate-star-second {\n  color: inherit;\n}\n.ant-rate-text {\n  display: inline-block;\n  margin: 0 8px;\n  font-size: 14px;\n}\n.ant-rate-rtl {\n  direction: rtl;\n}\n.ant-rate-rtl .ant-rate-star:not(:last-child) {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-rate-rtl .ant-rate-star-first {\n  right: 0;\n  left: auto;\n}\n.ant-result {\n  padding: 48px 32px;\n}\n.ant-result-success .ant-result-icon > .anticon {\n  color: #52c41a;\n}\n.ant-result-error .ant-result-icon > .anticon {\n  color: #f5222d;\n}\n.ant-result-info .ant-result-icon > .anticon {\n  color: #1890ff;\n}\n.ant-result-warning .ant-result-icon > .anticon {\n  color: #fa8c16;\n}\n.ant-result-image {\n  width: 250px;\n  height: 295px;\n  margin: auto;\n}\n.ant-result-icon {\n  margin-bottom: 24px;\n  text-align: center;\n}\n.ant-result-icon > .anticon {\n  font-size: 72px;\n}\n.ant-result-title {\n  color: #535353;\n  font-size: 24px;\n  line-height: 1.8;\n  text-align: center;\n}\n.ant-result-subtitle {\n  color: #595959;\n  font-size: 14px;\n  line-height: 1.6;\n  text-align: center;\n}\n.ant-result-extra {\n  margin: 24px 0 0 0;\n  text-align: center;\n}\n.ant-result-extra > * {\n  margin-right: 8px;\n}\n.ant-result-extra > *:last-child {\n  margin-right: 0;\n}\n.ant-result-content {\n  margin-top: 24px;\n  padding: 24px 40px;\n  background-color: #fafafa;\n}\n.ant-result-rtl {\n  direction: rtl;\n}\n.ant-result-rtl .ant-result-extra > * {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-result-rtl .ant-result-extra > *:last-child {\n  margin-left: 0;\n}\n.segmented-disabled-item,\n.segmented-disabled-item:hover,\n.segmented-disabled-item:focus {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.segmented-item-selected {\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);\n}\n.segmented-text-ellipsis {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  word-break: keep-all;\n}\n.ant-segmented {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  padding: 2px;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: rgba(0, 0, 0, 0.04);\n  border-radius: 6px;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-segmented-group {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-items: flex-start;\n  width: 100%;\n}\n.ant-segmented.ant-segmented-block {\n  display: flex;\n}\n.ant-segmented.ant-segmented-block .ant-segmented-item {\n  flex: 1;\n  min-width: 0;\n}\n.ant-segmented:not(.ant-segmented-disabled):hover,\n.ant-segmented:not(.ant-segmented-disabled):focus {\n  background-color: rgba(0, 0, 0, 0.06);\n}\n.ant-segmented-item {\n  position: relative;\n  text-align: center;\n  cursor: pointer;\n  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-segmented-item-selected {\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);\n  color: #262626;\n}\n.ant-segmented-item:hover,\n.ant-segmented-item:focus {\n  color: #262626;\n}\n.ant-segmented-item-label {\n  min-height: 32px;\n  padding: 0 11px;\n  line-height: 32px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  word-break: keep-all;\n}\n.ant-segmented-item-icon + * {\n  margin-left: 6px;\n}\n.ant-segmented-item-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-segmented.ant-segmented-lg .ant-segmented-item-label {\n  min-height: 36px;\n  padding: 0 11px;\n  font-size: 16px;\n  line-height: 36px;\n}\n.ant-segmented.ant-segmented-sm .ant-segmented-item-label {\n  min-height: 20px;\n  padding: 0 7px;\n  line-height: 20px;\n}\n.ant-segmented-item-disabled,\n.ant-segmented-item-disabled:hover,\n.ant-segmented-item-disabled:focus {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-segmented-thumb {\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  padding: 4px 0;\n}\n.ant-segmented-thumb-motion-appear-active {\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  will-change: transform, width;\n}\n.ant-segmented.ant-segmented-rtl {\n  direction: rtl;\n}\n.ant-segmented.ant-segmented-rtl .ant-segmented-item-icon {\n  margin-right: 0;\n  margin-left: 6px;\n}\n.ant-select-single .ant-select-selector {\n  display: flex;\n}\n.ant-select-single .ant-select-selector .ant-select-selection-search {\n  position: absolute;\n  top: 0;\n  right: 11px;\n  bottom: 0;\n  left: 11px;\n}\n.ant-select-single .ant-select-selector .ant-select-selection-search-input {\n  width: 100%;\n}\n.ant-select-single .ant-select-selector .ant-select-selection-item,\n.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  padding: 0;\n  line-height: 34px;\n  transition: all 0.3s, visibility 0s;\n}\n.ant-select-single .ant-select-selector .ant-select-selection-item {\n  position: relative;\n  user-select: none;\n}\n.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  transition: none;\n  pointer-events: none;\n}\n.ant-select-single .ant-select-selector::after,\n.ant-select-single .ant-select-selector .ant-select-selection-item::after,\n.ant-select-single .ant-select-selector .ant-select-selection-placeholder::after {\n  display: inline-block;\n  width: 0;\n  visibility: hidden;\n  content: '\\a0';\n}\n.ant-select-single.ant-select-show-arrow .ant-select-selection-search {\n  right: 25px;\n}\n.ant-select-single.ant-select-show-arrow .ant-select-selection-item,\n.ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {\n  padding-right: 18px;\n}\n.ant-select-single.ant-select-open .ant-select-selection-item {\n  color: #bfbfbf;\n}\n.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  width: 100%;\n  height: 36px;\n  padding: 0 11px;\n}\n.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {\n  height: 34px;\n}\n.ant-select-single:not(.ant-select-customize-input) .ant-select-selector::after {\n  line-height: 34px;\n}\n.ant-select-single.ant-select-customize-input .ant-select-selector::after {\n  display: none;\n}\n.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-search {\n  position: static;\n  width: 100%;\n}\n.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-placeholder {\n  position: absolute;\n  right: 0;\n  left: 0;\n  padding: 0 11px;\n}\n.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-placeholder::after {\n  display: none;\n}\n.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {\n  height: 40px;\n}\n.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector::after,\n.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item,\n.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder {\n  line-height: 38px;\n}\n.ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input) .ant-select-selection-search-input {\n  height: 38px;\n}\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {\n  height: 24px;\n}\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector::after,\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item,\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder {\n  line-height: 22px;\n}\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input):not(.ant-select-customize-input) .ant-select-selection-search-input {\n  height: 22px;\n}\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selection-search {\n  right: 7px;\n  left: 7px;\n}\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {\n  padding: 0 7px;\n}\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-search {\n  right: 28px;\n}\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-item,\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-placeholder {\n  padding-right: 21px;\n}\n.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {\n  padding: 0 11px;\n}\n/**\n * Do not merge `height` & `line-height` under style with `selection` & `search`,\n * since chrome may update to redesign with its align logic.\n */\n.ant-select-selection-overflow {\n  position: relative;\n  display: flex;\n  flex: auto;\n  flex-wrap: wrap;\n  max-width: 100%;\n}\n.ant-select-selection-overflow-item {\n  flex: none;\n  align-self: center;\n  max-width: 100%;\n}\n.ant-select-multiple .ant-select-selector {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 2.9px 7.9px;\n}\n.ant-select-show-search.ant-select-multiple .ant-select-selector {\n  cursor: text;\n}\n.ant-select-disabled.ant-select-multiple .ant-select-selector {\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n.ant-select-multiple .ant-select-selector::after {\n  display: inline-block;\n  width: 0;\n  margin: 4px 0;\n  line-height: 20.2px;\n  visibility: hidden;\n  content: '\\a0';\n}\n.ant-select-multiple.ant-select-show-arrow .ant-select-selector,\n.ant-select-multiple.ant-select-allow-clear .ant-select-selector {\n  padding-right: 24px;\n}\n.ant-select-multiple .ant-select-selection-item {\n  position: relative;\n  display: flex;\n  flex: none;\n  box-sizing: border-box;\n  max-width: 100%;\n  height: 20.2px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  line-height: 18.2px;\n  background: #f5f5f5;\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  cursor: default;\n  transition: font-size 0.3s, line-height 0.3s, height 0.3s;\n  user-select: none;\n  margin-inline-end: 7.9px;\n  padding-inline-start: 8px;\n  padding-inline-end: 4px;\n}\n.ant-select-disabled.ant-select-multiple .ant-select-selection-item {\n  color: #bfbfbf;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-select-multiple .ant-select-selection-item-content {\n  display: inline-block;\n  margin-right: 4px;\n  overflow: hidden;\n  white-space: pre;\n  text-overflow: ellipsis;\n}\n.ant-select-multiple .ant-select-selection-item-remove {\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-flex;\n  align-items: center;\n  color: #595959;\n  font-weight: bold;\n  font-size: 10px;\n  line-height: inherit;\n  cursor: pointer;\n}\n.ant-select-multiple .ant-select-selection-item-remove > * {\n  line-height: 1;\n}\n.ant-select-multiple .ant-select-selection-item-remove svg {\n  display: inline-block;\n}\n.ant-select-multiple .ant-select-selection-item-remove::before {\n  display: none;\n}\n.ant-select-multiple .ant-select-selection-item-remove .ant-select-multiple .ant-select-selection-item-remove-icon {\n  display: block;\n}\n.ant-select-multiple .ant-select-selection-item-remove > .anticon {\n  vertical-align: middle;\n}\n.ant-select-multiple .ant-select-selection-item-remove:hover {\n  color: rgba(0, 0, 0, 0.75);\n}\n.ant-select-multiple .ant-select-selection-overflow-item + .ant-select-selection-overflow-item .ant-select-selection-search {\n  margin-inline-start: 0;\n}\n.ant-select-multiple .ant-select-selection-search {\n  position: relative;\n  max-width: 100%;\n  margin-inline-start: 3.1px;\n}\n.ant-select-multiple .ant-select-selection-search-input,\n.ant-select-multiple .ant-select-selection-search-mirror {\n  height: 20.2px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  line-height: 20.2px;\n  transition: all 0.3s;\n}\n.ant-select-multiple .ant-select-selection-search-input {\n  width: 100%;\n  min-width: 4.1px;\n}\n.ant-select-multiple .ant-select-selection-search-mirror {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  white-space: pre;\n  visibility: hidden;\n}\n.ant-select-multiple .ant-select-selection-placeholder {\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  left: 11px;\n  transform: translateY(-50%);\n  transition: all 0.3s;\n}\n.ant-select-multiple.ant-select-lg .ant-select-selector::after {\n  line-height: 24.2px;\n}\n.ant-select-multiple.ant-select-lg .ant-select-selection-item {\n  height: 24.2px;\n  line-height: 22.2px;\n}\n.ant-select-multiple.ant-select-lg .ant-select-selection-search {\n  height: 24.2px;\n  line-height: 24.2px;\n}\n.ant-select-multiple.ant-select-lg .ant-select-selection-search-input,\n.ant-select-multiple.ant-select-lg .ant-select-selection-search-mirror {\n  height: 24.2px;\n  line-height: 22.2px;\n}\n.ant-select-multiple.ant-select-sm .ant-select-selector::after {\n  line-height: 8.2px;\n}\n.ant-select-multiple.ant-select-sm .ant-select-selection-item {\n  height: 8.2px;\n  line-height: 6.2px;\n}\n.ant-select-multiple.ant-select-sm .ant-select-selection-search {\n  height: 8.2px;\n  line-height: 8.2px;\n}\n.ant-select-multiple.ant-select-sm .ant-select-selection-search-input,\n.ant-select-multiple.ant-select-sm .ant-select-selection-search-mirror {\n  height: 8.2px;\n  line-height: 6.2px;\n}\n.ant-select-multiple.ant-select-sm .ant-select-selection-placeholder {\n  left: 7px;\n}\n.ant-select-multiple.ant-select-sm .ant-select-selection-search {\n  margin-inline-start: 3px;\n}\n.ant-select-disabled .ant-select-selection-item-remove {\n  display: none;\n}\n.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {\n  background-color: #fff;\n  border-color: #f5222d !important;\n}\n.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector,\n.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector {\n  border-color: #ff4d4f;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {\n  background-color: #fff;\n  border-color: #fa8c16 !important;\n}\n.ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector,\n.ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector {\n  border-color: #ffa940;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-select-status-error.ant-select-has-feedback .ant-select-clear,\n.ant-select-status-warning.ant-select-has-feedback .ant-select-clear,\n.ant-select-status-success.ant-select-has-feedback .ant-select-clear,\n.ant-select-status-validating.ant-select-has-feedback .ant-select-clear {\n  right: 32px;\n}\n.ant-select-status-error.ant-select-has-feedback .ant-select-selection-selected-value,\n.ant-select-status-warning.ant-select-has-feedback .ant-select-selection-selected-value,\n.ant-select-status-success.ant-select-has-feedback .ant-select-selection-selected-value,\n.ant-select-status-validating.ant-select-has-feedback .ant-select-selection-selected-value {\n  padding-right: 42px;\n}\n/* Reset search input style */\n.ant-select {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  position: relative;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-select:not(.ant-select-customize-input) .ant-select-selector input {\n  cursor: pointer;\n}\n.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  cursor: text;\n}\n.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector input {\n  cursor: auto;\n}\n.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  color: rgba(0, 0, 0, 0.25);\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n.ant-select-multiple.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  background: #f5f5f5;\n}\n.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector input {\n  cursor: not-allowed;\n}\n.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  border: none;\n  outline: none;\n  appearance: none;\n}\n.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input::-webkit-search-cancel-button {\n  display: none;\n  /* stylelint-disable-next-line property-no-vendor-prefix */\n  -webkit-appearance: none;\n}\n.ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-select-selection-item {\n  flex: 1;\n  overflow: hidden;\n  font-weight: normal;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n@media all and (-ms-high-contrast: none) {\n  .ant-select-selection-item *::-ms-backdrop,\n  .ant-select-selection-item {\n    flex: auto;\n  }\n}\n.ant-select-selection-placeholder {\n  flex: 1;\n  overflow: hidden;\n  color: #bfbfbf;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  pointer-events: none;\n}\n@media all and (-ms-high-contrast: none) {\n  .ant-select-selection-placeholder *::-ms-backdrop,\n  .ant-select-selection-placeholder {\n    flex: auto;\n  }\n}\n.ant-select-arrow {\n  display: inline-flex;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  display: flex;\n  align-items: center;\n  height: 12px;\n  margin-top: -6px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  pointer-events: none;\n}\n.ant-select-arrow > * {\n  line-height: 1;\n}\n.ant-select-arrow svg {\n  display: inline-block;\n}\n.ant-select-arrow::before {\n  display: none;\n}\n.ant-select-arrow .ant-select-arrow-icon {\n  display: block;\n}\n.ant-select-arrow .anticon {\n  vertical-align: top;\n  transition: transform 0.3s;\n}\n.ant-select-arrow .anticon > svg {\n  vertical-align: top;\n}\n.ant-select-arrow .anticon:not(.ant-select-suffix) {\n  pointer-events: auto;\n}\n.ant-select-disabled .ant-select-arrow {\n  cursor: not-allowed;\n}\n.ant-select-arrow > *:not(:last-child) {\n  margin-inline-end: 8px;\n}\n.ant-select-clear {\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  z-index: 1;\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-top: -6px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  font-style: normal;\n  line-height: 1;\n  text-align: center;\n  text-transform: none;\n  background: #fff;\n  cursor: pointer;\n  opacity: 0;\n  transition: color 0.3s ease, opacity 0.15s ease;\n  text-rendering: auto;\n}\n.ant-select-clear::before {\n  display: block;\n}\n.ant-select-clear:hover {\n  color: #595959;\n}\n.ant-select:hover .ant-select-clear {\n  opacity: 1;\n}\n.ant-select-dropdown {\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  box-sizing: border-box;\n  padding: 4px 0;\n  overflow: hidden;\n  font-size: 14px;\n  font-variant: initial;\n  background-color: #fff;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n.ant-select-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-select-dropdown-placement-bottomLeft,\n.ant-select-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-select-dropdown-placement-bottomLeft {\n  animation-name: antSlideUpIn;\n}\n.ant-select-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-select-dropdown-placement-topLeft,\n.ant-select-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-select-dropdown-placement-topLeft {\n  animation-name: antSlideDownIn;\n}\n.ant-select-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {\n  animation-name: antSlideUpOut;\n}\n.ant-select-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-select-dropdown-placement-topLeft {\n  animation-name: antSlideDownOut;\n}\n.ant-select-dropdown-hidden {\n  display: none;\n}\n.ant-select-dropdown-empty {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-item-empty {\n  position: relative;\n  display: block;\n  min-height: 32px;\n  padding: 5px 12px;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-item {\n  position: relative;\n  display: block;\n  min-height: 32px;\n  padding: 5px 12px;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n.ant-select-item-group {\n  color: #595959;\n  font-size: 12px;\n  cursor: default;\n}\n.ant-select-item-option {\n  display: flex;\n}\n.ant-select-item-option-content {\n  flex: auto;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-select-item-option-state {\n  flex: none;\n}\n.ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n  background-color: #f5f5f5;\n}\n.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n  color: #545454;\n  font-weight: 600;\n  background-color: #908b94;\n}\n.ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {\n  color: #351a55;\n}\n.ant-select-item-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-select-item-option-disabled.ant-select-item-option-selected {\n  background-color: #f5f5f5;\n}\n.ant-select-item-option-grouped {\n  padding-left: 24px;\n}\n.ant-select-lg {\n  font-size: 16px;\n}\n.ant-select-borderless .ant-select-selector {\n  background-color: transparent !important;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.ant-select.ant-select-in-form-item {\n  width: 100%;\n}\n.ant-select-compact-item:not(.ant-select-compact-last-item) {\n  margin-right: -1px;\n}\n.ant-select-compact-item:not(.ant-select-compact-last-item).ant-select-compact-item-rtl {\n  margin-right: 0;\n  margin-left: -1px;\n}\n.ant-select-compact-item:hover > *,\n.ant-select-compact-item:focus > *,\n.ant-select-compact-item:active > * {\n  z-index: 2;\n}\n.ant-select-compact-item.ant-select-focused > * {\n  z-index: 2;\n}\n.ant-select-compact-item[disabled] > * {\n  z-index: 0;\n}\n.ant-select-compact-item:not(.ant-select-compact-first-item):not(.ant-select-compact-last-item).ant-select > .ant-select-selector {\n  border-radius: 0;\n}\n.ant-select-compact-item.ant-select-compact-first-item.ant-select:not(.ant-select-compact-last-item):not(.ant-select-compact-item-rtl) > .ant-select-selector {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-select-compact-item.ant-select-compact-last-item.ant-select:not(.ant-select-compact-first-item):not(.ant-select-compact-item-rtl) > .ant-select-selector {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-select-compact-item.ant-select.ant-select-compact-first-item.ant-select-compact-item-rtl:not(.ant-select-compact-last-item) > .ant-select-selector {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-select-compact-item.ant-select.ant-select-compact-last-item.ant-select-compact-item-rtl:not(.ant-select-compact-first-item) > .ant-select-selector {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-select-rtl {\n  direction: rtl;\n}\n.ant-select-rtl .ant-select-arrow {\n  right: initial;\n  left: 11px;\n}\n.ant-select-rtl .ant-select-clear {\n  right: initial;\n  left: 11px;\n}\n.ant-select-dropdown-rtl {\n  direction: rtl;\n}\n.ant-select-dropdown-rtl .ant-select-item-option-grouped {\n  padding-right: 24px;\n  padding-left: 12px;\n}\n.ant-select-rtl.ant-select-multiple.ant-select-show-arrow .ant-select-selector,\n.ant-select-rtl.ant-select-multiple.ant-select-allow-clear .ant-select-selector {\n  padding-right: 7.9px;\n  padding-left: 24px;\n}\n.ant-select-rtl.ant-select-multiple .ant-select-selection-item {\n  text-align: right;\n}\n.ant-select-rtl.ant-select-multiple .ant-select-selection-item-content {\n  margin-right: 0;\n  margin-left: 4px;\n  text-align: right;\n}\n.ant-select-rtl.ant-select-multiple .ant-select-selection-search-mirror {\n  right: 0;\n  left: auto;\n}\n.ant-select-rtl.ant-select-multiple .ant-select-selection-placeholder {\n  right: 11px;\n  left: auto;\n}\n.ant-select-rtl.ant-select-multiple.ant-select-sm .ant-select-selection-placeholder {\n  right: 7px;\n}\n.ant-select-rtl.ant-select-single .ant-select-selector .ant-select-selection-item,\n.ant-select-rtl.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  right: 0;\n  left: 9px;\n  text-align: right;\n}\n.ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-search {\n  right: 11px;\n  left: 25px;\n}\n.ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-item,\n.ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {\n  padding-right: 0;\n  padding-left: 18px;\n}\n.ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-search {\n  right: 6px;\n}\n.ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-item,\n.ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-placeholder {\n  padding-right: 0;\n  padding-left: 21px;\n}\n.ant-skeleton {\n  display: table;\n  width: 100%;\n}\n.ant-skeleton-header {\n  display: table-cell;\n  padding-right: 16px;\n  vertical-align: top;\n}\n.ant-skeleton-header .ant-skeleton-avatar {\n  display: inline-block;\n  vertical-align: top;\n  background: rgba(190, 190, 190, 0.2);\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n.ant-skeleton-header .ant-skeleton-avatar.ant-skeleton-avatar-circle {\n  border-radius: 50%;\n}\n.ant-skeleton-header .ant-skeleton-avatar-lg {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n}\n.ant-skeleton-header .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {\n  border-radius: 50%;\n}\n.ant-skeleton-header .ant-skeleton-avatar-sm {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n.ant-skeleton-header .ant-skeleton-avatar-sm.ant-skeleton-avatar-circle {\n  border-radius: 50%;\n}\n.ant-skeleton-content {\n  display: table-cell;\n  width: 100%;\n  vertical-align: top;\n}\n.ant-skeleton-content .ant-skeleton-title {\n  width: 100%;\n  height: 16px;\n  background: rgba(190, 190, 190, 0.2);\n  border-radius: 6px;\n}\n.ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {\n  margin-top: 24px;\n}\n.ant-skeleton-content .ant-skeleton-paragraph {\n  padding: 0;\n}\n.ant-skeleton-content .ant-skeleton-paragraph > li {\n  width: 100%;\n  height: 16px;\n  list-style: none;\n  background: rgba(190, 190, 190, 0.2);\n  border-radius: 6px;\n}\n.ant-skeleton-content .ant-skeleton-paragraph > li:last-child:not(:first-child):not(:nth-child(2)) {\n  width: 61%;\n}\n.ant-skeleton-content .ant-skeleton-paragraph > li + li {\n  margin-top: 16px;\n}\n.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title {\n  margin-top: 12px;\n}\n.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {\n  margin-top: 28px;\n}\n.ant-skeleton-round .ant-skeleton-content .ant-skeleton-title,\n.ant-skeleton-round .ant-skeleton-content .ant-skeleton-paragraph > li {\n  border-radius: 100px;\n}\n.ant-skeleton-active .ant-skeleton-title,\n.ant-skeleton-active .ant-skeleton-paragraph > li,\n.ant-skeleton-active .ant-skeleton-avatar,\n.ant-skeleton-active .ant-skeleton-button,\n.ant-skeleton-active .ant-skeleton-input,\n.ant-skeleton-active .ant-skeleton-image {\n  position: relative;\n  /* stylelint-disable-next-line property-no-vendor-prefix,value-no-vendor-prefix */\n  z-index: 0;\n  overflow: hidden;\n  background: transparent;\n}\n.ant-skeleton-active .ant-skeleton-title::after,\n.ant-skeleton-active .ant-skeleton-paragraph > li::after,\n.ant-skeleton-active .ant-skeleton-avatar::after,\n.ant-skeleton-active .ant-skeleton-button::after,\n.ant-skeleton-active .ant-skeleton-input::after,\n.ant-skeleton-active .ant-skeleton-image::after {\n  position: absolute;\n  top: 0;\n  right: -150%;\n  bottom: 0;\n  left: -150%;\n  background: linear-gradient(90deg, rgba(190, 190, 190, 0.2) 25%, rgba(129, 129, 129, 0.24) 37%, rgba(190, 190, 190, 0.2) 63%);\n  animation: ant-skeleton-loading 1.4s ease infinite;\n  content: '';\n}\n.ant-skeleton.ant-skeleton-block {\n  width: 100%;\n}\n.ant-skeleton.ant-skeleton-block .ant-skeleton-button {\n  width: 100%;\n}\n.ant-skeleton.ant-skeleton-block .ant-skeleton-input {\n  width: 100%;\n}\n.ant-skeleton-element {\n  display: inline-block;\n  width: auto;\n}\n.ant-skeleton-element .ant-skeleton-button {\n  display: inline-block;\n  vertical-align: top;\n  background: rgba(190, 190, 190, 0.2);\n  border-radius: 6px;\n  width: 72px;\n  min-width: 72px;\n  height: 36px;\n  line-height: 36px;\n}\n.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-square {\n  width: 36px;\n  min-width: 36px;\n}\n.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-circle {\n  width: 36px;\n  min-width: 36px;\n  border-radius: 50%;\n}\n.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-round {\n  border-radius: 36px;\n}\n.ant-skeleton-element .ant-skeleton-button-lg {\n  width: 80px;\n  min-width: 80px;\n  height: 40px;\n  line-height: 40px;\n}\n.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-square {\n  width: 40px;\n  min-width: 40px;\n}\n.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-circle {\n  width: 40px;\n  min-width: 40px;\n  border-radius: 50%;\n}\n.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-round {\n  border-radius: 40px;\n}\n.ant-skeleton-element .ant-skeleton-button-sm {\n  width: 48px;\n  min-width: 48px;\n  height: 24px;\n  line-height: 24px;\n}\n.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-square {\n  width: 24px;\n  min-width: 24px;\n}\n.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-circle {\n  width: 24px;\n  min-width: 24px;\n  border-radius: 50%;\n}\n.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-round {\n  border-radius: 24px;\n}\n.ant-skeleton-element .ant-skeleton-avatar {\n  display: inline-block;\n  vertical-align: top;\n  background: rgba(190, 190, 190, 0.2);\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n.ant-skeleton-element .ant-skeleton-avatar.ant-skeleton-avatar-circle {\n  border-radius: 50%;\n}\n.ant-skeleton-element .ant-skeleton-avatar-lg {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n}\n.ant-skeleton-element .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {\n  border-radius: 50%;\n}\n.ant-skeleton-element .ant-skeleton-avatar-sm {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n.ant-skeleton-element .ant-skeleton-avatar-sm.ant-skeleton-avatar-circle {\n  border-radius: 50%;\n}\n.ant-skeleton-element .ant-skeleton-input {\n  display: inline-block;\n  vertical-align: top;\n  background: rgba(190, 190, 190, 0.2);\n  width: 180px;\n  min-width: 180px;\n  height: 36px;\n  line-height: 36px;\n}\n.ant-skeleton-element .ant-skeleton-input-lg {\n  width: 200px;\n  min-width: 200px;\n  height: 40px;\n  line-height: 40px;\n}\n.ant-skeleton-element .ant-skeleton-input-sm {\n  width: 120px;\n  min-width: 120px;\n  height: 24px;\n  line-height: 24px;\n}\n.ant-skeleton-element .ant-skeleton-image {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: top;\n  background: rgba(190, 190, 190, 0.2);\n  width: 96px;\n  height: 96px;\n  line-height: 96px;\n}\n.ant-skeleton-element .ant-skeleton-image.ant-skeleton-image-circle {\n  border-radius: 50%;\n}\n.ant-skeleton-element .ant-skeleton-image-path {\n  fill: #bfbfbf;\n}\n.ant-skeleton-element .ant-skeleton-image-svg {\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n  max-width: 192px;\n  max-height: 192px;\n}\n.ant-skeleton-element .ant-skeleton-image-svg.ant-skeleton-image-circle {\n  border-radius: 50%;\n}\n@keyframes ant-skeleton-loading {\n  0% {\n    transform: translateX(-37.5%);\n  }\n  100% {\n    transform: translateX(37.5%);\n  }\n}\n.ant-skeleton-rtl {\n  direction: rtl;\n}\n.ant-skeleton-rtl .ant-skeleton-header {\n  padding-right: 0;\n  padding-left: 16px;\n}\n.ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title,\n.ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph > li {\n  animation-name: ant-skeleton-loading-rtl;\n}\n.ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-avatar {\n  animation-name: ant-skeleton-loading-rtl;\n}\n@keyframes ant-skeleton-loading-rtl {\n  0% {\n    background-position: 0% 50%;\n  }\n  100% {\n    background-position: 100% 50%;\n  }\n}\n.ant-slider {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  height: 12px;\n  margin: 10px 6px 10px;\n  padding: 4px 0;\n  cursor: pointer;\n  touch-action: none;\n}\n.ant-slider-vertical {\n  width: 12px;\n  height: 100%;\n  margin: 6px 10px;\n  padding: 0 4px;\n}\n.ant-slider-vertical .ant-slider-rail {\n  width: 4px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-track {\n  width: 4px;\n}\n.ant-slider-vertical .ant-slider-handle {\n  margin-top: -6px;\n  margin-left: -5px;\n}\n.ant-slider-vertical .ant-slider-mark {\n  top: 0;\n  left: 12px;\n  width: 18px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-mark-text {\n  left: 4px;\n  white-space: nowrap;\n}\n.ant-slider-vertical .ant-slider-step {\n  width: 4px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-dot {\n  top: auto;\n  margin-left: -2px;\n}\n.ant-slider-tooltip .ant-tooltip-inner {\n  min-width: unset;\n}\n.ant-slider-rtl.ant-slider-vertical .ant-slider-handle {\n  margin-right: -5px;\n  margin-left: 0;\n}\n.ant-slider-rtl.ant-slider-vertical .ant-slider-mark {\n  right: 12px;\n  left: auto;\n}\n.ant-slider-rtl.ant-slider-vertical .ant-slider-mark-text {\n  right: 4px;\n  left: auto;\n}\n.ant-slider-rtl.ant-slider-vertical .ant-slider-dot {\n  right: 2px;\n  left: auto;\n}\n.ant-slider-with-marks {\n  margin-bottom: 28px;\n}\n.ant-slider-rail {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background-color: #f5f5f5;\n  border-radius: 6px;\n  transition: background-color 0.3s;\n}\n.ant-slider-track {\n  position: absolute;\n  height: 4px;\n  background-color: #6f617a;\n  border-radius: 6px;\n  transition: background-color 0.3s;\n}\n.ant-slider-handle {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin-top: -5px;\n  background-color: #fff;\n  border: solid 2px #6f617a;\n  border-radius: 50%;\n  box-shadow: 0;\n  cursor: pointer;\n  transition: border-color 0.3s, box-shadow 0.6s, transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n}\n.ant-slider-handle-dragging {\n  z-index: 1;\n}\n.ant-slider-handle:focus {\n  border-color: #5d4877;\n  outline: none;\n  box-shadow: 0 0 0 5px rgba(53, 26, 85, 0.12);\n}\n.ant-slider-handle.ant-tooltip-open {\n  border-color: #351a55;\n}\n.ant-slider-handle::after {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  bottom: -6px;\n  left: -6px;\n  content: '';\n}\n.ant-slider:hover .ant-slider-rail {\n  background-color: #e1e1e1;\n}\n.ant-slider:hover .ant-slider-track {\n  background-color: #5a456e;\n}\n.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {\n  border-color: #5a456e;\n}\n.ant-slider-mark {\n  position: absolute;\n  top: 14px;\n  left: 0;\n  width: 100%;\n  font-size: 14px;\n}\n.ant-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  color: #595959;\n  text-align: center;\n  word-break: keep-all;\n  cursor: pointer;\n  user-select: none;\n}\n.ant-slider-mark-text-active {\n  color: #545454;\n}\n.ant-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n  pointer-events: none;\n}\n.ant-slider-dot {\n  position: absolute;\n  top: -2px;\n  width: 8px;\n  height: 8px;\n  background-color: #fff;\n  border: 2px solid #e8e8e8;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.ant-slider-dot-active {\n  border-color: #9a8daa;\n}\n.ant-slider-disabled {\n  cursor: not-allowed;\n}\n.ant-slider-disabled .ant-slider-rail {\n  background-color: #f5f5f5 !important;\n}\n.ant-slider-disabled .ant-slider-track {\n  background-color: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-slider-disabled .ant-slider-handle,\n.ant-slider-disabled .ant-slider-dot {\n  background-color: #fff;\n  border-color: rgba(0, 0, 0, 0.25) !important;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n.ant-slider-disabled .ant-slider-mark-text,\n.ant-slider-disabled .ant-slider-dot {\n  cursor: not-allowed !important;\n}\n.ant-slider-rtl {\n  direction: rtl;\n}\n.ant-slider-rtl .ant-slider-mark {\n  right: 0;\n  left: auto;\n}\n.ant-space {\n  display: inline-flex;\n}\n.ant-space-vertical {\n  flex-direction: column;\n}\n.ant-space-align-center {\n  align-items: center;\n}\n.ant-space-align-start {\n  align-items: flex-start;\n}\n.ant-space-align-end {\n  align-items: flex-end;\n}\n.ant-space-align-baseline {\n  align-items: baseline;\n}\n.ant-space-item:empty {\n  display: none;\n}\n.ant-space-compact {\n  display: inline-flex;\n}\n.ant-space-compact-block {\n  display: flex;\n  width: 100%;\n}\n.ant-space-compact-vertical {\n  flex-direction: column;\n}\n.ant-space-rtl {\n  direction: rtl;\n}\n.ant-space-compact-rtl {\n  direction: rtl;\n}\n.ant-spin {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  display: none;\n  color: #351a55;\n  font-size: 0;\n  text-align: center;\n  vertical-align: middle;\n  opacity: 0;\n  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-spin-spinning {\n  position: static;\n  display: inline-block;\n  opacity: 1;\n}\n.ant-spin-nested-loading {\n  position: relative;\n}\n.ant-spin-nested-loading > div > .ant-spin {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 4;\n  display: block;\n  width: 100%;\n  height: 100%;\n  max-height: 400px;\n}\n.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -10px;\n}\n.ant-spin-nested-loading > div > .ant-spin .ant-spin-text {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  padding-top: 5px;\n  font-size: 14px;\n  text-shadow: 0 1px 2px #fff;\n}\n.ant-spin-nested-loading > div > .ant-spin.ant-spin-show-text .ant-spin-dot {\n  margin-top: -20px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-dot {\n  margin: -7px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-text {\n  padding-top: 2px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm.ant-spin-show-text .ant-spin-dot {\n  margin-top: -17px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-dot {\n  margin: -16px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {\n  padding-top: 11px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg.ant-spin-show-text .ant-spin-dot {\n  margin-top: -26px;\n}\n.ant-spin-container {\n  position: relative;\n  transition: opacity 0.3s;\n}\n.ant-spin-container::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  display: none \\9;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  opacity: 0;\n  transition: all 0.3s;\n  content: '';\n  pointer-events: none;\n}\n.ant-spin-blur {\n  clear: both;\n  opacity: 0.5;\n  user-select: none;\n  pointer-events: none;\n}\n.ant-spin-blur::after {\n  opacity: 0.4;\n  pointer-events: auto;\n}\n.ant-spin-tip {\n  color: #595959;\n}\n.ant-spin-dot {\n  position: relative;\n  display: inline-block;\n  font-size: 20px;\n  width: 1em;\n  height: 1em;\n}\n.ant-spin-dot-item {\n  position: absolute;\n  display: block;\n  width: 9px;\n  height: 9px;\n  background-color: #351a55;\n  border-radius: 100%;\n  transform: scale(0.75);\n  transform-origin: 50% 50%;\n  opacity: 0.3;\n  animation: antSpinMove 1s infinite linear alternate;\n}\n.ant-spin-dot-item:nth-child(1) {\n  top: 0;\n  left: 0;\n}\n.ant-spin-dot-item:nth-child(2) {\n  top: 0;\n  right: 0;\n  animation-delay: 0.4s;\n}\n.ant-spin-dot-item:nth-child(3) {\n  right: 0;\n  bottom: 0;\n  animation-delay: 0.8s;\n}\n.ant-spin-dot-item:nth-child(4) {\n  bottom: 0;\n  left: 0;\n  animation-delay: 1.2s;\n}\n.ant-spin-dot-spin {\n  transform: rotate(0deg);\n  animation: antRotate 1.2s infinite linear;\n}\n.ant-spin-sm .ant-spin-dot {\n  font-size: 14px;\n}\n.ant-spin-sm .ant-spin-dot i {\n  width: 6px;\n  height: 6px;\n}\n.ant-spin-lg .ant-spin-dot {\n  font-size: 32px;\n}\n.ant-spin-lg .ant-spin-dot i {\n  width: 14px;\n  height: 14px;\n}\n.ant-spin.ant-spin-show-text .ant-spin-text {\n  display: block;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /* IE10+ */\n  .ant-spin-blur {\n    background: #fff;\n    opacity: 0.5;\n  }\n}\n@keyframes antSpinMove {\n  to {\n    opacity: 1;\n  }\n}\n@keyframes antRotate {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.ant-spin-rtl {\n  direction: rtl;\n}\n.ant-spin-rtl .ant-spin-dot-spin {\n  transform: rotate(-45deg);\n  animation-name: antRotateRtl;\n}\n@keyframes antRotateRtl {\n  to {\n    transform: rotate(-405deg);\n  }\n}\n.ant-statistic {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-statistic-title {\n  margin-bottom: 4px;\n  color: #595959;\n  font-size: 14px;\n}\n.ant-statistic-skeleton {\n  padding-top: 16px;\n}\n.ant-statistic-content {\n  color: #535353;\n  font-size: 24px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n}\n.ant-statistic-content-value {\n  display: inline-block;\n  direction: ltr;\n}\n.ant-statistic-content-prefix,\n.ant-statistic-content-suffix {\n  display: inline-block;\n}\n.ant-statistic-content-prefix {\n  margin-right: 4px;\n}\n.ant-statistic-content-suffix {\n  margin-left: 4px;\n}\n.ant-statistic-rtl {\n  direction: rtl;\n}\n.ant-statistic-rtl .ant-statistic-content-prefix {\n  margin-right: 0;\n  margin-left: 4px;\n}\n.ant-statistic-rtl .ant-statistic-content-suffix {\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-steps {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: flex;\n  width: 100%;\n  font-size: 0;\n  text-align: initial;\n}\n.ant-steps-item {\n  position: relative;\n  display: inline-block;\n  flex: 1;\n  overflow: hidden;\n  vertical-align: top;\n}\n.ant-steps-item-container {\n  outline: none;\n}\n.ant-steps-item:last-child {\n  flex: none;\n}\n.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-tail,\n.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-item-icon,\n.ant-steps-item-content {\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-steps-item-icon {\n  width: 32px;\n  height: 32px;\n  margin: 0 8px 0 0;\n  font-size: 16px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  line-height: 32px;\n  text-align: center;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-radius: 32px;\n  transition: background-color 0.3s, border-color 0.3s;\n}\n.ant-steps-item-icon .ant-steps-icon {\n  position: relative;\n  top: -0.5px;\n  color: #351a55;\n  line-height: 1;\n}\n.ant-steps-item-tail {\n  position: absolute;\n  top: 12px;\n  left: 0;\n  width: 100%;\n  padding: 0 10px;\n}\n.ant-steps-item-tail::after {\n  display: inline-block;\n  width: 100%;\n  height: 1px;\n  background: #e8e8e8;\n  border-radius: 1px;\n  transition: background 0.3s;\n  content: '';\n}\n.ant-steps-item-title {\n  position: relative;\n  display: inline-block;\n  padding-right: 16px;\n  color: #545454;\n  font-size: 16px;\n  line-height: 32px;\n}\n.ant-steps-item-title::after {\n  position: absolute;\n  top: 16px;\n  left: 100%;\n  display: block;\n  width: 9999px;\n  height: 1px;\n  background: #e8e8e8;\n  content: '';\n}\n.ant-steps-item-subtitle {\n  display: inline;\n  margin-left: 8px;\n  color: #595959;\n  font-weight: normal;\n  font-size: 14px;\n}\n.ant-steps-item-description {\n  color: #595959;\n  font-size: 14px;\n}\n.ant-steps-item-wait .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: rgba(0, 0, 0, 0.25);\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: #595959;\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: #595959;\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-process .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: #351a55;\n}\n.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {\n  color: #351a55;\n}\n.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #351a55;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: #535353;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: #545454;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {\n  background: #351a55;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon .ant-steps-icon {\n  color: #fff;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-title {\n  font-weight: 500;\n}\n.ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: #351a55;\n}\n.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {\n  color: #351a55;\n}\n.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #351a55;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: #545454;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #351a55;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: #595959;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #351a55;\n}\n.ant-steps-item-error .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: #f5222d;\n}\n.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon {\n  color: #f5222d;\n}\n.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #f5222d;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: #f5222d;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: #f5222d;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item.ant-steps-next-error .ant-steps-item-title::after {\n  background: #f5222d;\n}\n.ant-steps-item-disabled {\n  cursor: not-allowed;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] {\n  cursor: pointer;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-title,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-subtitle,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-description,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-icon .ant-steps-icon {\n  transition: color 0.3s;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-title,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-subtitle,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-description {\n  color: #351a55;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon {\n  border-color: #351a55;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon .ant-steps-icon {\n  color: #351a55;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {\n  padding-left: 16px;\n  white-space: nowrap;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {\n  padding-left: 0;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {\n  padding-right: 0;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-tail {\n  display: none;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {\n  max-width: 140px;\n  white-space: normal;\n}\n.ant-steps-item-custom > .ant-steps-item-container > .ant-steps-item-icon {\n  height: auto;\n  background: none;\n  border: 0;\n}\n.ant-steps-item-custom > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {\n  top: 0px;\n  left: 0.5px;\n  width: 32px;\n  height: 32px;\n  font-size: 24px;\n  line-height: 32px;\n}\n.ant-steps-item-custom.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {\n  color: #351a55;\n}\n.ant-steps:not(.ant-steps-vertical) .ant-steps-item-custom .ant-steps-item-icon {\n  width: auto;\n  background: none;\n}\n.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {\n  padding-left: 12px;\n}\n.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {\n  padding-left: 0;\n}\n.ant-steps-small .ant-steps-item-icon {\n  width: 24px;\n  height: 24px;\n  margin: 0 8px 0 0;\n  font-size: 12px;\n  line-height: 24px;\n  text-align: center;\n  border-radius: 24px;\n}\n.ant-steps-small .ant-steps-item-title {\n  padding-right: 12px;\n  font-size: 14px;\n  line-height: 24px;\n}\n.ant-steps-small .ant-steps-item-title::after {\n  top: 12px;\n}\n.ant-steps-small .ant-steps-item-description {\n  color: #595959;\n  font-size: 14px;\n}\n.ant-steps-small .ant-steps-item-tail {\n  top: 8px;\n}\n.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon {\n  width: inherit;\n  height: inherit;\n  line-height: inherit;\n  background: none;\n  border: 0;\n  border-radius: 0;\n}\n.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {\n  font-size: 24px;\n  line-height: 24px;\n  transform: none;\n}\n.ant-steps-vertical {\n  display: flex;\n  flex-direction: column;\n}\n.ant-steps-vertical > .ant-steps-item {\n  display: block;\n  flex: 1 0 auto;\n  padding-left: 0;\n  overflow: visible;\n}\n.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {\n  float: left;\n  margin-right: 16px;\n}\n.ant-steps-vertical > .ant-steps-item .ant-steps-item-content {\n  display: block;\n  min-height: 48px;\n  overflow: hidden;\n}\n.ant-steps-vertical > .ant-steps-item .ant-steps-item-title {\n  line-height: 32px;\n}\n.ant-steps-vertical > .ant-steps-item .ant-steps-item-description {\n  padding-bottom: 12px;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  position: absolute;\n  top: 0;\n  left: 15px;\n  width: 1px;\n  height: 100%;\n  padding: 38px 0 6px;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after {\n  width: 1px;\n  height: 100%;\n}\n.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail {\n  display: block;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {\n  position: absolute;\n  top: 0;\n  left: 11px;\n  padding: 30px 0 6px;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-title {\n  line-height: 24px;\n}\n.ant-steps-label-vertical .ant-steps-item {\n  overflow: visible;\n}\n.ant-steps-label-vertical .ant-steps-item-tail {\n  margin-left: 58px;\n  padding: 3.5px 24px;\n}\n.ant-steps-label-vertical .ant-steps-item-content {\n  display: block;\n  width: 116px;\n  margin-top: 8px;\n  text-align: center;\n}\n.ant-steps-label-vertical .ant-steps-item-icon {\n  display: inline-block;\n  margin-left: 42px;\n}\n.ant-steps-label-vertical .ant-steps-item-title {\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-steps-label-vertical .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-label-vertical .ant-steps-item-subtitle {\n  display: block;\n  margin-bottom: 4px;\n  margin-left: 0;\n  line-height: 1.3;\n}\n.ant-steps-label-vertical.ant-steps-small:not(.ant-steps-dot) .ant-steps-item-icon {\n  margin-left: 46px;\n}\n.ant-steps-dot .ant-steps-item-title,\n.ant-steps-dot.ant-steps-small .ant-steps-item-title {\n  line-height: 1.3;\n}\n.ant-steps-dot .ant-steps-item-tail,\n.ant-steps-dot.ant-steps-small .ant-steps-item-tail {\n  top: 2px;\n  width: 100%;\n  margin: 0 0 0 70px;\n  padding: 0;\n}\n.ant-steps-dot .ant-steps-item-tail::after,\n.ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {\n  width: calc(100% - 20px);\n  height: 3px;\n  margin-left: 12px;\n}\n.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot,\n.ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {\n  left: 2px;\n}\n.ant-steps-dot .ant-steps-item-icon,\n.ant-steps-dot.ant-steps-small .ant-steps-item-icon {\n  width: 8px;\n  height: 8px;\n  margin-left: 67px;\n  padding-right: 0;\n  line-height: 8px;\n  background: transparent;\n  border: 0;\n}\n.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot,\n.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {\n  position: relative;\n  float: left;\n  width: 100%;\n  height: 100%;\n  border-radius: 100px;\n  transition: all 0.3s;\n  /* expand hover area */\n}\n.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot::after,\n.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot::after {\n  position: absolute;\n  top: -12px;\n  left: -26px;\n  width: 60px;\n  height: 32px;\n  background: rgba(0, 0, 0, 0.001);\n  content: '';\n}\n.ant-steps-dot .ant-steps-item-content,\n.ant-steps-dot.ant-steps-small .ant-steps-item-content {\n  width: 140px;\n}\n.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon,\n.ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon {\n  position: relative;\n  top: -1px;\n  width: 10px;\n  height: 10px;\n  line-height: 10px;\n  background: none;\n}\n.ant-steps-dot .ant-steps-item-process .ant-steps-icon:first-child .ant-steps-icon-dot,\n.ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-icon:first-child .ant-steps-icon-dot {\n  left: 0;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {\n  margin-top: 13px;\n  margin-left: 0;\n  background: none;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  top: 6.5px;\n  left: -9px;\n  margin: 0;\n  padding: 22px 0 4px;\n}\n.ant-steps-vertical.ant-steps-dot.ant-steps-small .ant-steps-item-icon {\n  margin-top: 10px;\n}\n.ant-steps-vertical.ant-steps-dot.ant-steps-small .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  top: 3.5px;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {\n  left: 0;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item-content {\n  width: inherit;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-item-container .ant-steps-item-icon .ant-steps-icon-dot {\n  top: -1px;\n  left: -1px;\n}\n.ant-steps-navigation {\n  padding-top: 12px;\n}\n.ant-steps-navigation.ant-steps-small .ant-steps-item-container {\n  margin-left: -12px;\n}\n.ant-steps-navigation .ant-steps-item {\n  overflow: visible;\n  text-align: center;\n}\n.ant-steps-navigation .ant-steps-item-container {\n  display: inline-block;\n  height: 100%;\n  margin-left: -16px;\n  padding-bottom: 12px;\n  text-align: left;\n  transition: opacity 0.3s;\n}\n.ant-steps-navigation .ant-steps-item-container .ant-steps-item-content {\n  max-width: auto;\n}\n.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {\n  max-width: 100%;\n  padding-right: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role='button'] {\n  cursor: pointer;\n}\n.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role='button']:hover {\n  opacity: 0.85;\n}\n.ant-steps-navigation .ant-steps-item:last-child {\n  flex: 1;\n}\n.ant-steps-navigation .ant-steps-item:last-child::after {\n  display: none;\n}\n.ant-steps-navigation .ant-steps-item::after {\n  position: absolute;\n  top: 50%;\n  left: 100%;\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-top: -14px;\n  margin-left: -2px;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-bottom: none;\n  border-left: none;\n  transform: rotate(45deg);\n  content: '';\n}\n.ant-steps-navigation .ant-steps-item::before {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  display: inline-block;\n  width: 0;\n  height: 2px;\n  background-color: #351a55;\n  transition: width 0.3s, left 0.3s;\n  transition-timing-function: ease-out;\n  content: '';\n}\n.ant-steps-navigation .ant-steps-item.ant-steps-item-active::before {\n  left: 0;\n  width: 100%;\n}\n.ant-steps-navigation.ant-steps-vertical > .ant-steps-item {\n  margin-right: 0 !important;\n}\n.ant-steps-navigation.ant-steps-vertical > .ant-steps-item::before {\n  display: none;\n}\n.ant-steps-navigation.ant-steps-vertical > .ant-steps-item.ant-steps-item-active::before {\n  top: 0;\n  right: 0;\n  left: unset;\n  display: block;\n  width: 3px;\n  height: calc(100% - 24px);\n}\n.ant-steps-navigation.ant-steps-vertical > .ant-steps-item::after {\n  position: relative;\n  top: -2px;\n  left: 50%;\n  display: block;\n  width: 8px;\n  height: 8px;\n  margin-bottom: 8px;\n  text-align: center;\n  transform: rotate(135deg);\n}\n.ant-steps-navigation.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  visibility: hidden;\n}\n.ant-steps-navigation.ant-steps-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  visibility: hidden;\n}\n.ant-steps-rtl {\n  direction: rtl;\n}\n.ant-steps.ant-steps-rtl .ant-steps-item-icon {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-steps-rtl .ant-steps-item-tail {\n  right: 0;\n  left: auto;\n}\n.ant-steps-rtl .ant-steps-item-title {\n  padding-right: 0;\n  padding-left: 16px;\n}\n.ant-steps-rtl .ant-steps-item-title .ant-steps-item-subtitle {\n  float: left;\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-steps-rtl .ant-steps-item-title::after {\n  right: 100%;\n  left: auto;\n}\n.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {\n  padding-right: 16px;\n  padding-left: 0;\n}\n.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {\n  padding-right: 0;\n}\n.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {\n  padding-left: 0;\n}\n.ant-steps-rtl .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {\n  right: 0.5px;\n  left: auto;\n}\n.ant-steps-rtl.ant-steps-navigation.ant-steps-small .ant-steps-item-container {\n  margin-right: -12px;\n  margin-left: 0;\n}\n.ant-steps-rtl.ant-steps-navigation .ant-steps-item-container {\n  margin-right: -16px;\n  margin-left: 0;\n  text-align: right;\n}\n.ant-steps-rtl.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {\n  padding-left: 0;\n}\n.ant-steps-rtl.ant-steps-navigation .ant-steps-item::after {\n  right: 100%;\n  left: auto;\n  margin-right: -2px;\n  margin-left: 0;\n  transform: rotate(225deg);\n}\n.ant-steps-rtl.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {\n  padding-right: 12px;\n  padding-left: 0;\n}\n.ant-steps-rtl.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {\n  padding-right: 0;\n}\n.ant-steps-rtl.ant-steps-small .ant-steps-item-title {\n  padding-right: 0;\n  padding-left: 12px;\n}\n.ant-steps-rtl.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {\n  float: right;\n  margin-right: 0;\n  margin-left: 16px;\n}\n.ant-steps-rtl.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  right: 16px;\n  left: auto;\n}\n.ant-steps-rtl.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {\n  right: 12px;\n  left: auto;\n}\n.ant-steps-rtl.ant-steps-label-vertical .ant-steps-item-title {\n  padding-left: 0;\n}\n.ant-steps-rtl.ant-steps-dot .ant-steps-item-tail,\n.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-tail {\n  margin: 0 70px 0 0;\n}\n.ant-steps-rtl.ant-steps-dot .ant-steps-item-tail::after,\n.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {\n  margin-right: 12px;\n  margin-left: 0;\n}\n.ant-steps-rtl.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot,\n.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {\n  right: 2px;\n  left: auto;\n}\n.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon,\n.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon {\n  margin-right: 67px;\n  margin-left: 0;\n}\n.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot,\n.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {\n  /* expand hover area */\n}\n.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot,\n.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {\n  float: right;\n}\n.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot::after,\n.ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot::after {\n  right: -26px;\n  left: auto;\n}\n.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {\n  margin-right: 0;\n  margin-left: 16px;\n}\n.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  right: -9px;\n  left: auto;\n}\n.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {\n  right: 0;\n  left: auto;\n}\n.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-icon-dot {\n  right: -2px;\n  left: auto;\n}\n.ant-steps-rtl.ant-steps-with-progress.ant-steps-vertical > .ant-steps-item {\n  padding-right: 4px;\n}\n.ant-steps-rtl.ant-steps-with-progress.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  right: 19px;\n}\n.ant-steps-rtl.ant-steps-with-progress.ant-steps-small.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  right: 15px;\n}\n.ant-steps-rtl.ant-steps-with-progress.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item:first-child {\n  padding-right: 4px;\n  padding-left: 0;\n}\n.ant-steps-rtl.ant-steps-with-progress.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item:first-child.ant-steps-item-active {\n  padding-right: 4px;\n}\n.ant-steps-with-progress .ant-steps-item {\n  padding-top: 4px;\n}\n.ant-steps-with-progress .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  top: 4px;\n  left: 19px;\n}\n.ant-steps-with-progress.ant-steps-horizontal .ant-steps-item:first-child,\n.ant-steps-with-progress.ant-steps-small.ant-steps-horizontal .ant-steps-item:first-child {\n  padding-bottom: 4px;\n  padding-left: 4px;\n}\n.ant-steps-with-progress.ant-steps-small > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  left: 15px;\n}\n.ant-steps-with-progress.ant-steps-vertical .ant-steps-item {\n  padding-left: 4px;\n}\n.ant-steps-with-progress.ant-steps-label-vertical .ant-steps-item .ant-steps-item-tail {\n  top: 14px !important;\n}\n.ant-steps-with-progress .ant-steps-item-icon {\n  position: relative;\n}\n.ant-steps-with-progress .ant-steps-item-icon .ant-progress {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  bottom: -5px;\n  left: -5px;\n}\n.ant-switch {\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  min-width: 44px;\n  height: 22px;\n  line-height: 22px;\n  vertical-align: middle;\n  background-color: rgba(0, 0, 0, 0.25);\n  border: 0;\n  border-radius: 100px;\n  cursor: pointer;\n  transition: all 0.2s;\n  user-select: none;\n}\n.ant-switch:focus {\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);\n}\n.ant-switch-checked:focus {\n  box-shadow: 0 0 0 2px #908b94;\n}\n.ant-switch:focus:hover {\n  box-shadow: none;\n}\n.ant-switch-checked {\n  background-color: #351a55;\n}\n.ant-switch-loading,\n.ant-switch-disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n.ant-switch-loading *,\n.ant-switch-disabled * {\n  box-shadow: none;\n  cursor: not-allowed;\n}\n.ant-switch-inner {\n  display: block;\n  margin: 0 7px 0 25px;\n  color: #fff;\n  font-size: 12px;\n  transition: margin 0.2s;\n}\n.ant-switch-checked .ant-switch-inner {\n  margin: 0 25px 0 7px;\n}\n.ant-switch-handle {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  transition: all 0.2s ease-in-out;\n}\n.ant-switch-handle::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: #fff;\n  border-radius: 9px;\n  box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);\n  transition: all 0.2s ease-in-out;\n  content: '';\n}\n.ant-switch-checked .ant-switch-handle {\n  left: calc(100% - 18px - 2px);\n}\n.ant-switch:not(.ant-switch-disabled):active .ant-switch-handle::before {\n  right: -30%;\n  left: 0;\n}\n.ant-switch:not(.ant-switch-disabled):active.ant-switch-checked .ant-switch-handle::before {\n  right: 0;\n  left: -30%;\n}\n.ant-switch-loading-icon.anticon {\n  position: relative;\n  top: 2px;\n  color: rgba(0, 0, 0, 0.65);\n  vertical-align: top;\n}\n.ant-switch-checked .ant-switch-loading-icon {\n  color: #351a55;\n}\n.ant-switch-small {\n  min-width: 28px;\n  height: 16px;\n  line-height: 16px;\n}\n.ant-switch-small .ant-switch-inner {\n  margin: 0 5px 0 18px;\n  font-size: 12px;\n}\n.ant-switch-small .ant-switch-handle {\n  width: 12px;\n  height: 12px;\n}\n.ant-switch-small .ant-switch-loading-icon {\n  top: 1.5px;\n  font-size: 9px;\n}\n.ant-switch-small.ant-switch-checked .ant-switch-inner {\n  margin: 0 18px 0 5px;\n}\n.ant-switch-small.ant-switch-checked .ant-switch-handle {\n  left: calc(100% - 12px - 2px);\n}\n.ant-switch-rtl {\n  direction: rtl;\n}\n.ant-switch-rtl .ant-switch-inner {\n  margin: 0 25px 0 7px;\n}\n.ant-switch-rtl .ant-switch-handle {\n  right: 2px;\n  left: auto;\n}\n.ant-switch-rtl:not(.ant-switch-rtl-disabled):active .ant-switch-handle::before {\n  right: 0;\n  left: -30%;\n}\n.ant-switch-rtl:not(.ant-switch-rtl-disabled):active.ant-switch-checked .ant-switch-handle::before {\n  right: -30%;\n  left: 0;\n}\n.ant-switch-rtl.ant-switch-checked .ant-switch-inner {\n  margin: 0 7px 0 25px;\n}\n.ant-switch-rtl.ant-switch-checked .ant-switch-handle {\n  right: calc(100% - 18px - 2px);\n}\n.ant-switch-rtl.ant-switch-small.ant-switch-checked .ant-switch-handle {\n  right: calc(100% - 12px - 2px);\n}\n.ant-table.ant-table-middle {\n  font-size: 14px;\n}\n.ant-table.ant-table-middle .ant-table-title,\n.ant-table.ant-table-middle .ant-table-footer,\n.ant-table.ant-table-middle .ant-table-thead > tr > th,\n.ant-table.ant-table-middle .ant-table-tbody > tr > td,\n.ant-table.ant-table-middle tfoot > tr > th,\n.ant-table.ant-table-middle tfoot > tr > td {\n  padding: 12px 8px;\n}\n.ant-table.ant-table-middle .ant-table-filter-trigger {\n  margin-right: -4px;\n}\n.ant-table.ant-table-middle .ant-table-expanded-row-fixed {\n  margin: -12px -8px;\n}\n.ant-table.ant-table-middle .ant-table-tbody .ant-table-wrapper:only-child .ant-table {\n  margin: -12px -8px -12px 40px;\n}\n.ant-table.ant-table-middle .ant-table-selection-column {\n  padding-inline-start: 2px;\n}\n.ant-table.ant-table-small {\n  font-size: 14px;\n}\n.ant-table.ant-table-small .ant-table-title,\n.ant-table.ant-table-small .ant-table-footer,\n.ant-table.ant-table-small .ant-table-thead > tr > th,\n.ant-table.ant-table-small .ant-table-tbody > tr > td,\n.ant-table.ant-table-small tfoot > tr > th,\n.ant-table.ant-table-small tfoot > tr > td {\n  padding: 8px 8px;\n}\n.ant-table.ant-table-small .ant-table-filter-trigger {\n  margin-right: -4px;\n}\n.ant-table.ant-table-small .ant-table-expanded-row-fixed {\n  margin: -8px -8px;\n}\n.ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {\n  margin: -8px -8px -8px 40px;\n}\n.ant-table.ant-table-small .ant-table-selection-column {\n  padding-inline-start: 2px;\n}\n.ant-table.ant-table-bordered > .ant-table-title {\n  border: 1px solid #e8e8e8;\n  border-bottom: 0;\n}\n.ant-table.ant-table-bordered > .ant-table-container {\n  border-left: 1px solid #e8e8e8;\n}\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > td,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > td,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > td,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > td {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr:not(:last-child) > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr:not(:last-child) > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr:not(:last-child) > th,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr:not(:last-child) > th {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th::before,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th::before,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th::before,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th::before {\n  background-color: transparent !important;\n}\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > .ant-table-cell-fix-right-first::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > .ant-table-cell-fix-right-first::after {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td > .ant-table-expanded-row-fixed,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td > .ant-table-expanded-row-fixed {\n  margin: -16px -17px;\n}\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td > .ant-table-expanded-row-fixed::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed::after,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td > .ant-table-expanded-row-fixed::after {\n  position: absolute;\n  top: 0;\n  right: 1px;\n  bottom: 0;\n  border-right: 1px solid #e8e8e8;\n  content: '';\n}\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table,\n.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-table.ant-table-bordered.ant-table-scroll-horizontal > .ant-table-container > .ant-table-body > table > tbody > tr.ant-table-expanded-row > td,\n.ant-table.ant-table-bordered.ant-table-scroll-horizontal > .ant-table-container > .ant-table-body > table > tbody > tr.ant-table-placeholder > td {\n  border-right: 0;\n}\n.ant-table.ant-table-bordered.ant-table-middle > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed,\n.ant-table.ant-table-bordered.ant-table-middle > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed {\n  margin: -12px -9px;\n}\n.ant-table.ant-table-bordered.ant-table-small > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed,\n.ant-table.ant-table-bordered.ant-table-small > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed {\n  margin: -8px -9px;\n}\n.ant-table.ant-table-bordered > .ant-table-footer {\n  border: 1px solid #e8e8e8;\n  border-top: 0;\n}\n.ant-table-cell .ant-table-container:first-child {\n  border-top: 0;\n}\n.ant-table-cell-scrollbar:not([rowspan]) {\n  box-shadow: 0 1px 0 1px #fafafa;\n}\n.ant-table-wrapper {\n  clear: both;\n  max-width: 100%;\n}\n.ant-table-wrapper::before {\n  display: table;\n  content: '';\n}\n.ant-table-wrapper::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-table-wrapper::before {\n  display: table;\n  content: '';\n}\n.ant-table-wrapper::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-table {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  font-size: 14px;\n  background: #fff;\n  border-radius: 6px;\n}\n.ant-table table {\n  width: 100%;\n  text-align: left;\n  border-radius: 6px 6px 0 0;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.ant-table-thead > tr > th,\n.ant-table-tbody > tr > td,\n.ant-table tfoot > tr > th,\n.ant-table tfoot > tr > td {\n  position: relative;\n  padding: 16px 16px;\n  overflow-wrap: break-word;\n}\n.ant-table-cell-ellipsis {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  word-break: keep-all;\n}\n.ant-table-cell-ellipsis.ant-table-cell-fix-left-last,\n.ant-table-cell-ellipsis.ant-table-cell-fix-right-first {\n  overflow: visible;\n}\n.ant-table-cell-ellipsis.ant-table-cell-fix-left-last .ant-table-cell-content,\n.ant-table-cell-ellipsis.ant-table-cell-fix-right-first .ant-table-cell-content {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ant-table-cell-ellipsis .ant-table-column-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: keep-all;\n}\n.ant-table-title {\n  padding: 16px 16px;\n}\n.ant-table-footer {\n  padding: 16px 16px;\n  color: #535353;\n  background: #fafafa;\n}\n.ant-table-thead > tr > th {\n  position: relative;\n  color: #535353;\n  font-weight: 500;\n  text-align: left;\n  background: #fafafa;\n  border-bottom: 1px solid #e8e8e8;\n  transition: background 0.3s ease;\n}\n.ant-table-thead > tr > th[colspan]:not([colspan='1']) {\n  text-align: center;\n}\n.ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: 1px;\n  height: 1.6em;\n  background-color: rgba(0, 0, 0, 0.06);\n  transform: translateY(-50%);\n  transition: background-color 0.3s;\n  content: '';\n}\n.ant-table-thead > tr:not(:last-child) > th[colspan] {\n  border-bottom: 0;\n}\n.ant-table-tbody > tr > td {\n  border-bottom: 1px solid #e8e8e8;\n  transition: background 0.3s;\n}\n.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table,\n.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table {\n  margin: -16px -16px -16px 32px;\n}\n.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td,\n.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td {\n  border-bottom: 0;\n}\n.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:first-child,\n.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:first-child,\n.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:last-child,\n.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:last-child {\n  border-radius: 0;\n}\n.ant-table-tbody > tr.ant-table-row:hover > td,\n.ant-table-tbody > tr > td.ant-table-cell-row-hover {\n  background: #fafafa;\n}\n.ant-table-tbody > tr.ant-table-row-selected > td {\n  background: #908b94;\n  border-color: rgba(0, 0, 0, 0.03);\n}\n.ant-table-tbody > tr.ant-table-row-selected:hover > td {\n  background: #8b868f;\n}\n.ant-table-summary {\n  position: relative;\n  z-index: 2;\n  background: #fff;\n}\ndiv.ant-table-summary {\n  box-shadow: 0 -1px 0 #e8e8e8;\n}\n.ant-table-summary > tr > th,\n.ant-table-summary > tr > td {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-table-pagination.ant-pagination {\n  margin: 16px 0;\n}\n.ant-table-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  row-gap: 8px;\n}\n.ant-table-pagination > * {\n  flex: none;\n}\n.ant-table-pagination-left {\n  justify-content: flex-start;\n}\n.ant-table-pagination-center {\n  justify-content: center;\n}\n.ant-table-pagination-right {\n  justify-content: flex-end;\n}\n.ant-table-thead th.ant-table-column-has-sorters {\n  outline: none;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-table-thead th.ant-table-column-has-sorters:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n.ant-table-thead th.ant-table-column-has-sorters:hover::before {\n  background-color: transparent !important;\n}\n.ant-table-thead th.ant-table-column-has-sorters:focus-visible {\n  color: #351a55;\n}\n.ant-table-thead th.ant-table-column-has-sorters.ant-table-cell-fix-left:hover,\n.ant-table-thead th.ant-table-column-has-sorters.ant-table-cell-fix-right:hover {\n  background: #f5f5f5;\n}\n.ant-table-thead th.ant-table-column-sort {\n  background: #f5f5f5;\n}\n.ant-table-thead th.ant-table-column-sort::before {\n  background-color: transparent !important;\n}\ntd.ant-table-column-sort {\n  background: #fafafa;\n}\n.ant-table-column-title {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n}\n.ant-table-column-sorters {\n  display: flex;\n  flex: auto;\n  align-items: center;\n  justify-content: space-between;\n}\n.ant-table-column-sorters::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  content: '';\n}\n.ant-table-column-sorter {\n  margin-left: 4px;\n  color: #bfbfbf;\n  font-size: 0;\n  transition: color 0.3s;\n}\n.ant-table-column-sorter-inner {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n}\n.ant-table-column-sorter-up,\n.ant-table-column-sorter-down {\n  font-size: 11px;\n}\n.ant-table-column-sorter-up.active,\n.ant-table-column-sorter-down.active {\n  color: #351a55;\n}\n.ant-table-column-sorter-up + .ant-table-column-sorter-down {\n  margin-top: -0.3em;\n}\n.ant-table-column-sorters:hover .ant-table-column-sorter {\n  color: #a6a6a6;\n}\n.ant-table-filter-column {\n  display: flex;\n  justify-content: space-between;\n}\n.ant-table-filter-trigger {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin: -4px -8px -4px 4px;\n  padding: 0 4px;\n  color: #bfbfbf;\n  font-size: 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-table-filter-trigger:hover {\n  color: #595959;\n  background: rgba(0, 0, 0, 0.04);\n}\n.ant-table-filter-trigger.active {\n  color: #351a55;\n}\n.ant-table-filter-dropdown {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  min-width: 120px;\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n.ant-table-filter-dropdown .ant-dropdown-menu {\n  max-height: 264px;\n  overflow-x: hidden;\n  border: 0;\n  box-shadow: none;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu:empty::after {\n  display: block;\n  padding: 8px 0;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  text-align: center;\n  content: 'Not Found';\n}\n.ant-table-filter-dropdown-tree {\n  padding: 8px 8px 0;\n}\n.ant-table-filter-dropdown-tree .ant-tree-treenode .ant-tree-node-content-wrapper:hover {\n  background-color: #f5f5f5;\n}\n.ant-table-filter-dropdown-tree .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper,\n.ant-table-filter-dropdown-tree .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper:hover {\n  background-color: #847f87;\n}\n.ant-table-filter-dropdown-search {\n  padding: 8px;\n  border-bottom: 1px #e8e8e8 solid;\n}\n.ant-table-filter-dropdown-search-input input {\n  min-width: 140px;\n}\n.ant-table-filter-dropdown-search-input .anticon {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-table-filter-dropdown-checkall {\n  width: 100%;\n  margin-bottom: 4px;\n  margin-left: 4px;\n}\n.ant-table-filter-dropdown-submenu > ul {\n  max-height: calc(100vh - 130px);\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.ant-table-filter-dropdown .ant-checkbox-wrapper + span,\n.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span {\n  padding-left: 8px;\n}\n.ant-table-filter-dropdown-btns {\n  display: flex;\n  justify-content: space-between;\n  padding: 7px 8px;\n  overflow: hidden;\n  background-color: inherit;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-table-selection-col {\n  width: 32px;\n}\n.ant-table-bordered .ant-table-selection-col {\n  width: 50px;\n}\ntable tr th.ant-table-selection-column,\ntable tr td.ant-table-selection-column {\n  padding-right: 8px;\n  padding-left: 8px;\n  text-align: center;\n}\ntable tr th.ant-table-selection-column .ant-radio-wrapper,\ntable tr td.ant-table-selection-column .ant-radio-wrapper {\n  margin-right: 0;\n}\ntable tr th.ant-table-selection-column.ant-table-cell-fix-left {\n  z-index: 3;\n}\ntable tr th.ant-table-selection-column::after {\n  background-color: transparent !important;\n}\n.ant-table-selection {\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n}\n.ant-table-selection-extra {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  cursor: pointer;\n  transition: all 0.3s;\n  margin-inline-start: 100%;\n  padding-inline-start: 4px;\n}\n.ant-table-selection-extra .anticon {\n  color: #bfbfbf;\n  font-size: 10px;\n}\n.ant-table-selection-extra .anticon:hover {\n  color: #a6a6a6;\n}\n.ant-table-expand-icon-col {\n  width: 48px;\n}\n.ant-table-row-expand-icon-cell {\n  text-align: center;\n}\n.ant-table-row-expand-icon-cell .ant-table-row-expand-icon {\n  display: inline-flex;\n  float: none;\n  vertical-align: sub;\n}\n.ant-table-row-indent {\n  float: left;\n  height: 1px;\n}\n.ant-table-row-expand-icon {\n  color: var(--app-primary-color);\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  position: relative;\n  float: left;\n  box-sizing: border-box;\n  width: 17px;\n  height: 17px;\n  padding: 0;\n  color: inherit;\n  line-height: 17px;\n  background: #fff;\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  transform: scale(0.94117647);\n  transition: all 0.3s;\n  user-select: none;\n}\n.ant-table-row-expand-icon:focus-visible,\n.ant-table-row-expand-icon:hover {\n  color: #0d0d0d;\n}\n.ant-table-row-expand-icon:active {\n  color: #000000;\n}\n.ant-table-row-expand-icon:focus,\n.ant-table-row-expand-icon:hover,\n.ant-table-row-expand-icon:active {\n  border-color: currentcolor;\n}\n.ant-table-row-expand-icon::before,\n.ant-table-row-expand-icon::after {\n  position: absolute;\n  background: currentcolor;\n  transition: transform 0.3s ease-out;\n  content: '';\n}\n.ant-table-row-expand-icon::before {\n  top: 7px;\n  right: 3px;\n  left: 3px;\n  height: 1px;\n}\n.ant-table-row-expand-icon::after {\n  top: 3px;\n  bottom: 3px;\n  left: 7px;\n  width: 1px;\n  transform: rotate(90deg);\n}\n.ant-table-row-expand-icon-collapsed::before {\n  transform: rotate(-180deg);\n}\n.ant-table-row-expand-icon-collapsed::after {\n  transform: rotate(0deg);\n}\n.ant-table-row-expand-icon-spaced {\n  background: transparent;\n  border: 0;\n  visibility: hidden;\n}\n.ant-table-row-expand-icon-spaced::before,\n.ant-table-row-expand-icon-spaced::after {\n  display: none;\n  content: none;\n}\n.ant-table-row-indent + .ant-table-row-expand-icon {\n  margin-top: 0.6px;\n  margin-right: 8px;\n}\ntr.ant-table-expanded-row > td,\ntr.ant-table-expanded-row:hover > td {\n  background: #fbfbfb;\n}\ntr.ant-table-expanded-row .ant-descriptions-view {\n  display: flex;\n}\ntr.ant-table-expanded-row .ant-descriptions-view table {\n  flex: auto;\n  width: auto;\n}\n.ant-table .ant-table-expanded-row-fixed {\n  position: relative;\n  margin: -16px -16px;\n  padding: 16px 16px;\n}\n.ant-table-tbody > tr.ant-table-placeholder {\n  text-align: center;\n}\n.ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-table-tbody > tr.ant-table-placeholder:hover > td {\n  background: #fff;\n}\n.ant-table-cell-fix-left,\n.ant-table-cell-fix-right {\n  position: sticky !important;\n  z-index: 2;\n  background: #fff;\n}\n.ant-table-cell-fix-left-first::after,\n.ant-table-cell-fix-left-last::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: -1px;\n  width: 30px;\n  transform: translateX(100%);\n  transition: box-shadow 0.3s;\n  content: '';\n  pointer-events: none;\n}\n.ant-table-cell-fix-left-all::after {\n  display: none;\n}\n.ant-table-cell-fix-right-first::after,\n.ant-table-cell-fix-right-last::after {\n  position: absolute;\n  top: 0;\n  bottom: -1px;\n  left: 0;\n  width: 30px;\n  transform: translateX(-100%);\n  transition: box-shadow 0.3s;\n  content: '';\n  pointer-events: none;\n}\n.ant-table .ant-table-container::before,\n.ant-table .ant-table-container::after {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: calc(calc(2 + 1) + 1);\n  width: 30px;\n  transition: box-shadow 0.3s;\n  content: '';\n  pointer-events: none;\n}\n.ant-table .ant-table-container::before {\n  left: 0;\n}\n.ant-table .ant-table-container::after {\n  right: 0;\n}\n.ant-table-ping-left:not(.ant-table-has-fix-left) > .ant-table-container {\n  position: relative;\n}\n.ant-table-ping-left:not(.ant-table-has-fix-left) > .ant-table-container::before {\n  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);\n}\n.ant-table-ping-left .ant-table-cell-fix-left-first::after,\n.ant-table-ping-left .ant-table-cell-fix-left-last::after {\n  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);\n}\n.ant-table-ping-left .ant-table-cell-fix-left-last::before {\n  background-color: transparent !important;\n}\n.ant-table-ping-right:not(.ant-table-has-fix-right) > .ant-table-container {\n  position: relative;\n}\n.ant-table-ping-right:not(.ant-table-has-fix-right) > .ant-table-container::after {\n  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.15);\n}\n.ant-table-ping-right .ant-table-cell-fix-right-first::after,\n.ant-table-ping-right .ant-table-cell-fix-right-last::after {\n  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.15);\n}\n.ant-table-sticky-holder {\n  position: sticky;\n  z-index: calc(2 + 1);\n  background: #fff;\n}\n.ant-table-sticky-scroll {\n  position: sticky;\n  bottom: 0;\n  z-index: calc(2 + 1);\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n  border-top: 1px solid #e8e8e8;\n  opacity: 0.6;\n}\n.ant-table-sticky-scroll:hover {\n  transform-origin: center bottom;\n}\n.ant-table-sticky-scroll-bar {\n  height: 8px;\n  background-color: rgba(0, 0, 0, 0.35);\n  border-radius: 4px;\n}\n.ant-table-sticky-scroll-bar:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n.ant-table-sticky-scroll-bar-active {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n@media all and (-ms-high-contrast: none) {\n  .ant-table-ping-left .ant-table-cell-fix-left-last::after {\n    box-shadow: none !important;\n  }\n  .ant-table-ping-right .ant-table-cell-fix-right-first::after {\n    box-shadow: none !important;\n  }\n}\n.ant-table {\n  /* title + table */\n  /* table */\n  /* table + footer */\n}\n.ant-table-title {\n  border-radius: 6px 6px 0 0;\n}\n.ant-table-title + .ant-table-container {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-table-title + .ant-table-container table {\n  border-radius: 0;\n}\n.ant-table-title + .ant-table-container table > thead > tr:first-child th:first-child {\n  border-radius: 0;\n}\n.ant-table-title + .ant-table-container table > thead > tr:first-child th:last-child {\n  border-radius: 0;\n}\n.ant-table-container {\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n}\n.ant-table-container table > thead > tr:first-child th:first-child {\n  border-top-left-radius: 6px;\n}\n.ant-table-container table > thead > tr:first-child th:last-child {\n  border-top-right-radius: 6px;\n}\n.ant-table-footer {\n  border-radius: 0 0 6px 6px;\n}\n.ant-table-wrapper-rtl {\n  direction: rtl;\n}\n.ant-table-rtl {\n  direction: rtl;\n}\n.ant-table-wrapper-rtl .ant-table table {\n  text-align: right;\n}\n.ant-table-wrapper-rtl .ant-table-thead > tr > th[colspan]:not([colspan='1']) {\n  text-align: center;\n}\n.ant-table-wrapper-rtl .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n  right: auto;\n  left: 0;\n}\n.ant-table-wrapper-rtl .ant-table-thead > tr > th {\n  text-align: right;\n}\n.ant-table-tbody > tr .ant-table-wrapper:only-child .ant-table.ant-table-rtl {\n  margin: -16px 33px -16px -16px;\n}\n.ant-table-wrapper.ant-table-wrapper-rtl .ant-table-pagination-left {\n  justify-content: flex-end;\n}\n.ant-table-wrapper.ant-table-wrapper-rtl .ant-table-pagination-right {\n  justify-content: flex-start;\n}\n.ant-table-wrapper-rtl .ant-table-column-sorter {\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-table-wrapper-rtl .ant-table-filter-column-title {\n  padding: 16px 16px 16px 2.3em;\n}\n.ant-table-rtl .ant-table-thead tr th.ant-table-column-has-sorters .ant-table-filter-column-title {\n  padding: 0 0 0 2.3em;\n}\n.ant-table-wrapper-rtl .ant-table-filter-trigger {\n  margin: -4px 4px -4px -8px;\n}\n.ant-dropdown-rtl .ant-table-filter-dropdown .ant-checkbox-wrapper + span,\n.ant-dropdown-rtl .ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span,\n.ant-dropdown-menu-submenu-rtl.ant-table-filter-dropdown .ant-checkbox-wrapper + span,\n.ant-dropdown-menu-submenu-rtl.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span {\n  padding-right: 8px;\n  padding-left: 0;\n}\n.ant-table-wrapper-rtl .ant-table-selection {\n  text-align: center;\n}\n.ant-table-wrapper-rtl .ant-table-row-indent {\n  float: right;\n}\n.ant-table-wrapper-rtl .ant-table-row-expand-icon {\n  float: right;\n}\n.ant-table-wrapper-rtl .ant-table-row-indent + .ant-table-row-expand-icon {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-table-wrapper-rtl .ant-table-row-expand-icon::after {\n  transform: rotate(-90deg);\n}\n.ant-table-wrapper-rtl .ant-table-row-expand-icon-collapsed::before {\n  transform: rotate(180deg);\n}\n.ant-table-wrapper-rtl .ant-table-row-expand-icon-collapsed::after {\n  transform: rotate(0deg);\n}\n.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {\n  padding: 8px 0;\n  font-size: 14px;\n}\n.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {\n  padding: 16px 0;\n  font-size: 16px;\n}\n.ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {\n  padding: 6px 16px;\n}\n.ant-tabs-card.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {\n  padding: 7px 16px 6px;\n}\n.ant-tabs-rtl {\n  direction: rtl;\n}\n.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab {\n  margin: 0 0 0 32px;\n}\n.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab:last-of-type {\n  margin-left: 0;\n}\n.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .anticon {\n  margin-right: 0;\n  margin-left: 12px;\n}\n.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {\n  margin-right: 8px;\n  margin-left: -4px;\n}\n.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove .anticon {\n  margin: 0;\n}\n.ant-tabs-rtl.ant-tabs-left > .ant-tabs-nav {\n  order: 1;\n}\n.ant-tabs-rtl.ant-tabs-left > .ant-tabs-content-holder {\n  order: 0;\n}\n.ant-tabs-rtl.ant-tabs-right > .ant-tabs-nav {\n  order: 0;\n}\n.ant-tabs-rtl.ant-tabs-right > .ant-tabs-content-holder {\n  order: 1;\n}\n.ant-tabs-rtl.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-rtl.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {\n  margin-right: 2px;\n  margin-left: 0;\n}\n.ant-tabs-rtl.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-add,\n.ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-add,\n.ant-tabs-rtl.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-add,\n.ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-add {\n  margin-right: 2px;\n  margin-left: 0;\n}\n.ant-tabs-dropdown-rtl {\n  direction: rtl;\n}\n.ant-tabs-dropdown-rtl .ant-tabs-dropdown-menu-item {\n  text-align: right;\n}\n.ant-tabs-top,\n.ant-tabs-bottom {\n  flex-direction: column;\n}\n.ant-tabs-top > .ant-tabs-nav,\n.ant-tabs-bottom > .ant-tabs-nav,\n.ant-tabs-top > div > .ant-tabs-nav,\n.ant-tabs-bottom > div > .ant-tabs-nav {\n  margin: 0 0 16px 0;\n}\n.ant-tabs-top > .ant-tabs-nav::before,\n.ant-tabs-bottom > .ant-tabs-nav::before,\n.ant-tabs-top > div > .ant-tabs-nav::before,\n.ant-tabs-bottom > div > .ant-tabs-nav::before {\n  position: absolute;\n  right: 0;\n  left: 0;\n  border-bottom: 1px solid #e8e8e8;\n  content: '';\n}\n.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar {\n  height: 2px;\n}\n.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar-animated,\n.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar-animated,\n.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar-animated,\n.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar-animated {\n  transition: width 0.3s, left 0.3s, right 0.3s;\n}\n.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {\n  top: 0;\n  bottom: 0;\n  width: 30px;\n}\n.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap::before {\n  left: 0;\n  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.08);\n}\n.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {\n  right: 0;\n  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.08);\n}\n.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before,\n.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before,\n.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before,\n.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before {\n  opacity: 1;\n}\n.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after,\n.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after,\n.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after,\n.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after {\n  opacity: 1;\n}\n.ant-tabs-top > .ant-tabs-nav::before,\n.ant-tabs-top > div > .ant-tabs-nav::before {\n  bottom: 0;\n}\n.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar {\n  bottom: 0;\n}\n.ant-tabs-bottom > .ant-tabs-nav,\n.ant-tabs-bottom > div > .ant-tabs-nav {\n  order: 1;\n  margin-top: 16px;\n  margin-bottom: 0;\n}\n.ant-tabs-bottom > .ant-tabs-nav::before,\n.ant-tabs-bottom > div > .ant-tabs-nav::before {\n  top: 0;\n}\n.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar {\n  top: 0;\n}\n.ant-tabs-bottom > .ant-tabs-content-holder,\n.ant-tabs-bottom > div > .ant-tabs-content-holder {\n  order: 0;\n}\n.ant-tabs-left > .ant-tabs-nav,\n.ant-tabs-right > .ant-tabs-nav,\n.ant-tabs-left > div > .ant-tabs-nav,\n.ant-tabs-right > div > .ant-tabs-nav {\n  flex-direction: column;\n  min-width: 50px;\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab {\n  padding: 8px 24px;\n  text-align: center;\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {\n  margin: 16px 0 0 0;\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap {\n  flex-direction: column;\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {\n  right: 0;\n  left: 0;\n  height: 30px;\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap::before {\n  top: 0;\n  box-shadow: inset 0 10px 8px -8px rgba(0, 0, 0, 0.08);\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {\n  bottom: 0;\n  box-shadow: inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08);\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top::before,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top::before,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top::before,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top::before {\n  opacity: 1;\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom::after,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom::after,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom::after,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom::after {\n  opacity: 1;\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar {\n  width: 2px;\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar-animated,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar-animated,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar-animated,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar-animated {\n  transition: height 0.3s, top 0.3s;\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-list,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-list,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-list,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-list,\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-operations,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-operations,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-operations,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-operations {\n  flex: 1 0 auto;\n  flex-direction: column;\n}\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar {\n  right: 0;\n}\n.ant-tabs-left > .ant-tabs-content-holder,\n.ant-tabs-left > div > .ant-tabs-content-holder {\n  margin-left: -1px;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-tabs-left > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane,\n.ant-tabs-left > div > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {\n  padding-left: 24px;\n}\n.ant-tabs-right > .ant-tabs-nav,\n.ant-tabs-right > div > .ant-tabs-nav {\n  order: 1;\n}\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar {\n  left: 0;\n}\n.ant-tabs-right > .ant-tabs-content-holder,\n.ant-tabs-right > div > .ant-tabs-content-holder {\n  order: 0;\n  margin-right: -1px;\n  border-right: 1px solid #e8e8e8;\n}\n.ant-tabs-right > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane,\n.ant-tabs-right > div > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {\n  padding-right: 24px;\n}\n.ant-tabs-dropdown {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  display: block;\n}\n.ant-tabs-dropdown-hidden {\n  display: none;\n}\n.ant-tabs-dropdown-menu {\n  max-height: 200px;\n  margin: 0;\n  padding: 4px 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  text-align: left;\n  list-style-type: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n.ant-tabs-dropdown-menu-item {\n  display: flex;\n  align-items: center;\n  min-width: 120px;\n  margin: 0;\n  padding: 5px 12px;\n  overflow: hidden;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-tabs-dropdown-menu-item > span {\n  flex: 1;\n  white-space: nowrap;\n}\n.ant-tabs-dropdown-menu-item-remove {\n  flex: none;\n  margin-left: 12px;\n  color: #595959;\n  font-size: 12px;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n}\n.ant-tabs-dropdown-menu-item-remove:hover {\n  color: #462e61;\n}\n.ant-tabs-dropdown-menu-item:hover {\n  background: #f5f5f5;\n}\n.ant-tabs-dropdown-menu-item-disabled,\n.ant-tabs-dropdown-menu-item-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab,\n.ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {\n  margin: 0;\n  padding: 10px 16px;\n  background: #fafafa;\n  border: 1px solid #e8e8e8;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active,\n.ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {\n  color: #351a55;\n  background: #fff;\n}\n.ant-tabs-card > .ant-tabs-nav .ant-tabs-ink-bar,\n.ant-tabs-card > div > .ant-tabs-nav .ant-tabs-ink-bar {\n  visibility: hidden;\n}\n.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {\n  margin-left: 2px;\n}\n.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab {\n  border-radius: 6px 6px 0 0;\n}\n.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active,\n.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab-active {\n  border-bottom-color: #fff;\n}\n.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab {\n  border-radius: 0 0 6px 6px;\n}\n.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab-active,\n.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab-active {\n  border-top-color: #fff;\n}\n.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {\n  margin-top: 2px;\n}\n.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab {\n  border-radius: 6px 0 0 6px;\n}\n.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab-active,\n.ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab-active {\n  border-right-color: #fff;\n}\n.ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab {\n  border-radius: 0 6px 6px 0;\n}\n.ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab-active,\n.ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab-active {\n  border-left-color: #fff;\n}\n.ant-tabs {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: flex;\n}\n.ant-tabs > .ant-tabs-nav,\n.ant-tabs > div > .ant-tabs-nav {\n  position: relative;\n  display: flex;\n  flex: none;\n  align-items: center;\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap {\n  position: relative;\n  display: inline-block;\n  display: flex;\n  flex: auto;\n  align-self: stretch;\n  overflow: hidden;\n  white-space: nowrap;\n  transform: translate(0);\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {\n  position: absolute;\n  z-index: 1;\n  opacity: 0;\n  transition: opacity 0.3s;\n  content: '';\n  pointer-events: none;\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {\n  position: relative;\n  display: flex;\n  transition: transform 0.3s;\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-operations,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-operations {\n  display: flex;\n  align-self: stretch;\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-operations-hidden,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-operations-hidden {\n  position: absolute;\n  visibility: hidden;\n  pointer-events: none;\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-more,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more {\n  position: relative;\n  padding: 10px 16px;\n  background: transparent;\n  border: 0;\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-more::after,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more::after {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 5px;\n  transform: translateY(100%);\n  content: '';\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add {\n  min-width: 40px;\n  margin-left: 2px;\n  padding: 0 8px;\n  background: #fafafa;\n  border: 1px solid #e8e8e8;\n  border-radius: 6px 6px 0 0;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:hover,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:hover {\n  color: #462e61;\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:active,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:active,\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:focus,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:focus {\n  color: #1a0c2e;\n}\n.ant-tabs-extra-content {\n  flex: none;\n}\n.ant-tabs-centered > .ant-tabs-nav .ant-tabs-nav-wrap:not([class*='ant-tabs-nav-wrap-ping']),\n.ant-tabs-centered > div > .ant-tabs-nav .ant-tabs-nav-wrap:not([class*='ant-tabs-nav-wrap-ping']) {\n  justify-content: center;\n}\n.ant-tabs-ink-bar {\n  position: absolute;\n  background: #351a55;\n  pointer-events: none;\n}\n.ant-tabs-tab {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  padding: 12px 0;\n  font-size: 14px;\n  background: transparent;\n  border: 0;\n  outline: none;\n  cursor: pointer;\n}\n.ant-tabs-tab-btn:focus,\n.ant-tabs-tab-remove:focus,\n.ant-tabs-tab-btn:active,\n.ant-tabs-tab-remove:active {\n  color: #1a0c2e;\n}\n.ant-tabs-tab-btn {\n  outline: none;\n  transition: all 0.3s;\n}\n.ant-tabs-tab-remove {\n  flex: none;\n  margin-right: -4px;\n  margin-left: 8px;\n  color: #595959;\n  font-size: 12px;\n  background: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-tabs-tab-remove:hover {\n  color: #535353;\n}\n.ant-tabs-tab:hover {\n  color: #462e61;\n}\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #351a55;\n  text-shadow: 0 0 0.25px currentcolor;\n}\n.ant-tabs-tab.ant-tabs-tab-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn:focus,\n.ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-remove:focus,\n.ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn:active,\n.ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-remove:active {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-tabs-tab .ant-tabs-tab-remove .anticon {\n  margin: 0;\n}\n.ant-tabs-tab .anticon {\n  margin-right: 12px;\n}\n.ant-tabs-tab + .ant-tabs-tab {\n  margin: 0 0 0 32px;\n}\n.ant-tabs-content {\n  position: relative;\n  width: 100%;\n}\n.ant-tabs-content-holder {\n  flex: auto;\n  min-width: 0;\n  min-height: 0;\n}\n.ant-tabs-tabpane {\n  outline: none;\n}\n.ant-tabs-tabpane-hidden {\n  display: none;\n}\n.ant-tabs-switch-appear,\n.ant-tabs-switch-enter {\n  transition: none;\n}\n.ant-tabs-switch-appear-start,\n.ant-tabs-switch-enter-start {\n  opacity: 0;\n}\n.ant-tabs-switch-appear-active,\n.ant-tabs-switch-enter-active {\n  opacity: 1;\n  transition: opacity 0.3s;\n}\n.ant-tabs-switch-leave {\n  position: absolute;\n  transition: none;\n  inset: 0;\n}\n.ant-tabs-switch-leave-start {\n  opacity: 1;\n}\n.ant-tabs-switch-leave-active {\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n.ant-tag {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  height: auto;\n  margin-right: 8px;\n  padding: 0 7px;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: nowrap;\n  background: #fafafa;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  opacity: 1;\n  transition: all 0.3s;\n}\n.ant-tag,\n.ant-tag a,\n.ant-tag a:hover {\n  color: #545454;\n}\n.ant-tag > a:first-child:last-child {\n  display: inline-block;\n  margin: 0 -8px;\n  padding: 0 8px;\n}\n.ant-tag-close-icon {\n  margin-left: 3px;\n  color: #595959;\n  font-size: 10px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-tag-close-icon:hover {\n  color: #535353;\n}\n.ant-tag-has-color {\n  border-color: transparent;\n}\n.ant-tag-has-color,\n.ant-tag-has-color a,\n.ant-tag-has-color a:hover,\n.ant-tag-has-color .anticon-close,\n.ant-tag-has-color .anticon-close:hover {\n  color: #fff;\n}\n.ant-tag-checkable {\n  background-color: transparent;\n  border-color: transparent;\n  cursor: pointer;\n}\n.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {\n  color: #351a55;\n}\n.ant-tag-checkable:active,\n.ant-tag-checkable-checked {\n  color: #fff;\n}\n.ant-tag-checkable-checked {\n  background-color: #351a55;\n}\n.ant-tag-checkable:active {\n  background-color: #1a0c2e;\n}\n.ant-tag-hidden {\n  display: none;\n}\n.ant-tag-pink {\n  color: #c41d7f;\n  background: #fff0f6;\n  border-color: #ffadd2;\n}\n.ant-tag-pink-inverse {\n  color: #fff;\n  background: #eb2f96;\n  border-color: #eb2f96;\n}\n.ant-tag-magenta {\n  color: #c41d7f;\n  background: #fff0f6;\n  border-color: #ffadd2;\n}\n.ant-tag-magenta-inverse {\n  color: #fff;\n  background: #eb2f96;\n  border-color: #eb2f96;\n}\n.ant-tag-red {\n  color: #cf1322;\n  background: #fff1f0;\n  border-color: #ffa39e;\n}\n.ant-tag-red-inverse {\n  color: #fff;\n  background: #f5222d;\n  border-color: #f5222d;\n}\n.ant-tag-volcano {\n  color: #d4380d;\n  background: #fff2e8;\n  border-color: #ffbb96;\n}\n.ant-tag-volcano-inverse {\n  color: #fff;\n  background: #fa541c;\n  border-color: #fa541c;\n}\n.ant-tag-orange {\n  color: #d46b08;\n  background: #fff7e6;\n  border-color: #ffd591;\n}\n.ant-tag-orange-inverse {\n  color: #fff;\n  background: #fa8c16;\n  border-color: #fa8c16;\n}\n.ant-tag-yellow {\n  color: #d4b106;\n  background: #feffe6;\n  border-color: #fffb8f;\n}\n.ant-tag-yellow-inverse {\n  color: #fff;\n  background: #fadb14;\n  border-color: #fadb14;\n}\n.ant-tag-gold {\n  color: #d48806;\n  background: #fffbe6;\n  border-color: #ffe58f;\n}\n.ant-tag-gold-inverse {\n  color: #fff;\n  background: #faad14;\n  border-color: #faad14;\n}\n.ant-tag-cyan {\n  color: #08979c;\n  background: #e6fffb;\n  border-color: #87e8de;\n}\n.ant-tag-cyan-inverse {\n  color: #fff;\n  background: #13c2c2;\n  border-color: #13c2c2;\n}\n.ant-tag-lime {\n  color: #7cb305;\n  background: #fcffe6;\n  border-color: #eaff8f;\n}\n.ant-tag-lime-inverse {\n  color: #fff;\n  background: #a0d911;\n  border-color: #a0d911;\n}\n.ant-tag-green {\n  color: #389e0d;\n  background: #f6ffed;\n  border-color: #b7eb8f;\n}\n.ant-tag-green-inverse {\n  color: #fff;\n  background: #52c41a;\n  border-color: #52c41a;\n}\n.ant-tag-blue {\n  color: #096dd9;\n  background: #e6f7ff;\n  border-color: #91d5ff;\n}\n.ant-tag-blue-inverse {\n  color: #fff;\n  background: #1890ff;\n  border-color: #1890ff;\n}\n.ant-tag-geekblue {\n  color: #1d39c4;\n  background: #f0f5ff;\n  border-color: #adc6ff;\n}\n.ant-tag-geekblue-inverse {\n  color: #fff;\n  background: #2f54eb;\n  border-color: #2f54eb;\n}\n.ant-tag-purple {\n  color: #531dab;\n  background: #f9f0ff;\n  border-color: #d3adf7;\n}\n.ant-tag-purple-inverse {\n  color: #fff;\n  background: #722ed1;\n  border-color: #722ed1;\n}\n.ant-tag-success {\n  color: #52c41a;\n  background: #f6ffed;\n  border-color: #b7eb8f;\n}\n.ant-tag-processing {\n  color: #1890ff;\n  background: #e6f7ff;\n  border-color: #91d5ff;\n}\n.ant-tag-error {\n  color: #f5222d;\n  background: #fff1f0;\n  border-color: #ffa39e;\n}\n.ant-tag-warning {\n  color: #fa8c16;\n  background: #fff7e6;\n  border-color: #ffd591;\n}\n.ant-tag > .anticon + span,\n.ant-tag > span + .anticon {\n  margin-left: 7px;\n}\n.ant-tag.ant-tag-rtl {\n  margin-right: 0;\n  margin-left: 8px;\n  direction: rtl;\n  text-align: right;\n}\n.ant-tag-rtl .ant-tag-close-icon {\n  margin-right: 3px;\n  margin-left: 0;\n}\n.ant-tag-rtl.ant-tag > .anticon + span,\n.ant-tag-rtl.ant-tag > span + .anticon {\n  margin-right: 7px;\n  margin-left: 0;\n}\n.ant-timeline {\n  box-sizing: border-box;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  font-feature-settings: 'tnum';\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-timeline-item {\n  position: relative;\n  margin: 0;\n  padding-bottom: 20px;\n  font-size: 14px;\n  list-style: none;\n}\n.ant-timeline-item-tail {\n  position: absolute;\n  top: 10px;\n  left: 4px;\n  height: calc(100% - 10px);\n  border-left: 2px solid #e8e8e8;\n}\n.ant-timeline-item-pending .ant-timeline-item-head {\n  font-size: 12px;\n  background-color: transparent;\n}\n.ant-timeline-item-pending .ant-timeline-item-tail {\n  display: none;\n}\n.ant-timeline-item-head {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background-color: #fff;\n  border: 2px solid transparent;\n  border-radius: 100px;\n}\n.ant-timeline-item-head-blue {\n  color: #351a55;\n  border-color: #351a55;\n}\n.ant-timeline-item-head-red {\n  color: #f5222d;\n  border-color: #f5222d;\n}\n.ant-timeline-item-head-green {\n  color: #52c41a;\n  border-color: #52c41a;\n}\n.ant-timeline-item-head-gray {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-timeline-item-head-custom {\n  position: absolute;\n  top: 5.5px;\n  left: 5px;\n  width: auto;\n  height: auto;\n  margin-top: 0;\n  padding: 3px 1px;\n  line-height: 1;\n  text-align: center;\n  border: 0;\n  border-radius: 0;\n  transform: translate(-50%, -50%);\n}\n.ant-timeline-item-content {\n  position: relative;\n  top: -3.2px;\n  margin: 0 0 0 26px;\n  word-break: break-word;\n}\n.ant-timeline-item-last > .ant-timeline-item-tail {\n  display: none;\n}\n.ant-timeline-item-last > .ant-timeline-item-content {\n  min-height: 48px;\n}\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-tail,\n.ant-timeline.ant-timeline-right .ant-timeline-item-tail,\n.ant-timeline.ant-timeline-label .ant-timeline-item-tail,\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,\n.ant-timeline.ant-timeline-right .ant-timeline-item-head,\n.ant-timeline.ant-timeline-label .ant-timeline-item-head,\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,\n.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom,\n.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom {\n  left: 50%;\n}\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,\n.ant-timeline.ant-timeline-right .ant-timeline-item-head,\n.ant-timeline.ant-timeline-label .ant-timeline-item-head {\n  margin-left: -4px;\n}\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,\n.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom,\n.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom {\n  margin-left: 1px;\n}\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content,\n.ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content,\n.ant-timeline.ant-timeline-label .ant-timeline-item-left .ant-timeline-item-content {\n  left: calc(50% - 4px);\n  width: calc(50% - 14px);\n  text-align: left;\n}\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content,\n.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content,\n.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-content {\n  width: calc(50% - 12px);\n  margin: 0;\n  text-align: right;\n}\n.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-tail,\n.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head,\n.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head-custom {\n  left: calc(100% - 4px - 2px);\n}\n.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {\n  width: calc(100% - 18px);\n}\n.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail {\n  display: block;\n  height: calc(100% - 14px);\n  border-left: 2px dotted #e8e8e8;\n}\n.ant-timeline.ant-timeline-reverse .ant-timeline-item-last .ant-timeline-item-tail {\n  display: none;\n}\n.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-tail {\n  top: 15px;\n  display: block;\n  height: calc(100% - 15px);\n  border-left: 2px dotted #e8e8e8;\n}\n.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-content {\n  min-height: 48px;\n}\n.ant-timeline.ant-timeline-label .ant-timeline-item-label {\n  position: absolute;\n  top: -3.2px;\n  width: calc(50% - 12px);\n  text-align: right;\n}\n.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-label {\n  left: calc(50% + 14px);\n  width: calc(50% - 14px);\n  text-align: left;\n}\n.ant-timeline-rtl {\n  direction: rtl;\n}\n.ant-timeline-rtl .ant-timeline-item-tail {\n  right: 4px;\n  left: auto;\n  border-right: 2px solid #e8e8e8;\n  border-left: none;\n}\n.ant-timeline-rtl .ant-timeline-item-head-custom {\n  right: 5px;\n  left: auto;\n  transform: translate(50%, -50%);\n}\n.ant-timeline-rtl .ant-timeline-item-content {\n  margin: 0 18px 0 0;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-tail,\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-tail,\n.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-tail,\n.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head,\n.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head,\n.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom,\n.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom {\n  right: 50%;\n  left: auto;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head,\n.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head {\n  margin-right: -4px;\n  margin-left: 0;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom,\n.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom {\n  margin-right: 1px;\n  margin-left: 0;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content,\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content,\n.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-left .ant-timeline-item-content {\n  right: calc(50% - 4px);\n  left: auto;\n  text-align: right;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content,\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content,\n.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-content {\n  text-align: left;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-tail,\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head,\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head-custom {\n  right: 0;\n  left: auto;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {\n  width: 100%;\n  margin-right: 18px;\n  text-align: right;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail {\n  border-right: 2px dotted #e8e8e8;\n  border-left: none;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-tail {\n  border-right: 2px dotted #e8e8e8;\n  border-left: none;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-label {\n  text-align: left;\n}\n.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-label {\n  right: calc(50% + 14px);\n  text-align: right;\n}\n.ant-tooltip {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  width: max-content;\n  width: intrinsic;\n  max-width: 250px;\n  visibility: visible;\n}\n.ant-tooltip-content {\n  position: relative;\n}\n.ant-tooltip-hidden {\n  display: none;\n}\n.ant-tooltip-placement-top,\n.ant-tooltip-placement-topLeft,\n.ant-tooltip-placement-topRight {\n  padding-bottom: 14.3137085px;\n}\n.ant-tooltip-placement-right,\n.ant-tooltip-placement-rightTop,\n.ant-tooltip-placement-rightBottom {\n  padding-left: 14.3137085px;\n}\n.ant-tooltip-placement-bottom,\n.ant-tooltip-placement-bottomLeft,\n.ant-tooltip-placement-bottomRight {\n  padding-top: 14.3137085px;\n}\n.ant-tooltip-placement-left,\n.ant-tooltip-placement-leftTop,\n.ant-tooltip-placement-leftBottom {\n  padding-right: 14.3137085px;\n}\n.ant-tooltip-inner {\n  min-width: 30px;\n  min-height: 32px;\n  padding: 6px 8px;\n  color: #fff;\n  text-align: left;\n  text-decoration: none;\n  word-wrap: break-word;\n  background-color: rgba(0, 0, 0, 0.75);\n  border-radius: 6px;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n.ant-tooltip-arrow {\n  position: absolute;\n  z-index: 2;\n  display: block;\n  width: 22px;\n  height: 22px;\n  overflow: hidden;\n  background: transparent;\n  pointer-events: none;\n}\n.ant-tooltip-arrow-content {\n  --antd-arrow-background-color: linear-gradient(to right bottom, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.75));\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: 11.3137085px;\n  height: 11.3137085px;\n  margin: auto;\n  content: '';\n  pointer-events: auto;\n  border-radius: 0 0 2px;\n  pointer-events: none;\n}\n.ant-tooltip-arrow-content::before {\n  position: absolute;\n  top: -11.3137085px;\n  left: -11.3137085px;\n  width: 33.9411255px;\n  height: 33.9411255px;\n  background: var(--antd-arrow-background-color);\n  background-repeat: no-repeat;\n  background-position: -10px -10px;\n  content: '';\n  clip-path: inset(33% 33%);\n  clip-path: path('M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z');\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow,\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow,\n.ant-tooltip-placement-topRight .ant-tooltip-arrow {\n  bottom: 0;\n  transform: translateY(100%);\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow-content,\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow-content,\n.ant-tooltip-placement-topRight .ant-tooltip-arrow-content {\n  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateY(-11px) rotate(45deg);\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow {\n  left: 50%;\n  transform: translateY(100%) translateX(-50%);\n}\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow {\n  left: 13px;\n}\n.ant-tooltip-placement-topRight .ant-tooltip-arrow {\n  right: 13px;\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow,\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow,\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {\n  left: 0;\n  transform: translateX(-100%);\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow-content,\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow-content,\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow-content {\n  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateX(11px) rotate(135deg);\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow {\n  top: 50%;\n  transform: translateX(-100%) translateY(-50%);\n}\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow {\n  top: 5px;\n}\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {\n  bottom: 5px;\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow,\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow,\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {\n  right: 0;\n  transform: translateX(100%);\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow-content,\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow-content,\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow-content {\n  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateX(-11px) rotate(315deg);\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow {\n  top: 50%;\n  transform: translateX(100%) translateY(-50%);\n}\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow {\n  top: 5px;\n}\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {\n  bottom: 5px;\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow,\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n  top: 0;\n  transform: translateY(-100%);\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow-content,\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow-content,\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow-content {\n  box-shadow: -3px -3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateY(11px) rotate(225deg);\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow {\n  left: 50%;\n  transform: translateY(-100%) translateX(-50%);\n}\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow {\n  left: 13px;\n}\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n  right: 13px;\n}\n.ant-tooltip-pink .ant-tooltip-inner {\n  background-color: #eb2f96;\n}\n.ant-tooltip-pink .ant-tooltip-arrow-content::before {\n  background: #eb2f96;\n}\n.ant-tooltip-magenta .ant-tooltip-inner {\n  background-color: #eb2f96;\n}\n.ant-tooltip-magenta .ant-tooltip-arrow-content::before {\n  background: #eb2f96;\n}\n.ant-tooltip-red .ant-tooltip-inner {\n  background-color: #f5222d;\n}\n.ant-tooltip-red .ant-tooltip-arrow-content::before {\n  background: #f5222d;\n}\n.ant-tooltip-volcano .ant-tooltip-inner {\n  background-color: #fa541c;\n}\n.ant-tooltip-volcano .ant-tooltip-arrow-content::before {\n  background: #fa541c;\n}\n.ant-tooltip-orange .ant-tooltip-inner {\n  background-color: #fa8c16;\n}\n.ant-tooltip-orange .ant-tooltip-arrow-content::before {\n  background: #fa8c16;\n}\n.ant-tooltip-yellow .ant-tooltip-inner {\n  background-color: #fadb14;\n}\n.ant-tooltip-yellow .ant-tooltip-arrow-content::before {\n  background: #fadb14;\n}\n.ant-tooltip-gold .ant-tooltip-inner {\n  background-color: #faad14;\n}\n.ant-tooltip-gold .ant-tooltip-arrow-content::before {\n  background: #faad14;\n}\n.ant-tooltip-cyan .ant-tooltip-inner {\n  background-color: #13c2c2;\n}\n.ant-tooltip-cyan .ant-tooltip-arrow-content::before {\n  background: #13c2c2;\n}\n.ant-tooltip-lime .ant-tooltip-inner {\n  background-color: #a0d911;\n}\n.ant-tooltip-lime .ant-tooltip-arrow-content::before {\n  background: #a0d911;\n}\n.ant-tooltip-green .ant-tooltip-inner {\n  background-color: #52c41a;\n}\n.ant-tooltip-green .ant-tooltip-arrow-content::before {\n  background: #52c41a;\n}\n.ant-tooltip-blue .ant-tooltip-inner {\n  background-color: #1890ff;\n}\n.ant-tooltip-blue .ant-tooltip-arrow-content::before {\n  background: #1890ff;\n}\n.ant-tooltip-geekblue .ant-tooltip-inner {\n  background-color: #2f54eb;\n}\n.ant-tooltip-geekblue .ant-tooltip-arrow-content::before {\n  background: #2f54eb;\n}\n.ant-tooltip-purple .ant-tooltip-inner {\n  background-color: #722ed1;\n}\n.ant-tooltip-purple .ant-tooltip-arrow-content::before {\n  background: #722ed1;\n}\n.ant-tooltip-rtl {\n  direction: rtl;\n}\n.ant-tooltip-rtl .ant-tooltip-inner {\n  text-align: right;\n}\n.ant-transfer-customize-list .ant-transfer-list {\n  flex: 1 1 50%;\n  width: auto;\n  height: auto;\n  min-height: 200px;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small {\n  border: 0;\n  border-radius: 0;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-selection-column {\n  width: 40px;\n  min-width: 40px;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {\n  background: #fafafa;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content .ant-table-row:last-child td {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-body {\n  margin: 0;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-pagination.ant-pagination {\n  margin: 16px 0 4px;\n}\n.ant-transfer-customize-list .ant-input[disabled] {\n  background-color: transparent;\n}\n.ant-transfer-status-error .ant-transfer-list {\n  border-color: #f5222d;\n}\n.ant-transfer-status-error .ant-transfer-list-search:not([disabled]) {\n  border-color: #d9d9d9;\n}\n.ant-transfer-status-error .ant-transfer-list-search:not([disabled]):hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-transfer-status-error .ant-transfer-list-search:not([disabled]):hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-transfer-status-error .ant-transfer-list-search:not([disabled]):focus {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-transfer-status-error .ant-transfer-list-search:not([disabled]):focus {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-transfer-status-warning .ant-transfer-list {\n  border-color: #fa8c16;\n}\n.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]) {\n  border-color: #d9d9d9;\n}\n.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):hover {\n  border-color: #462e61;\n  border-right-width: 1px;\n}\n.ant-input-rtl .ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):hover {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):focus {\n  border-color: #462e61;\n  box-shadow: 0 0 0 2px rgba(53, 26, 85, 0.2);\n  border-right-width: 1px;\n  outline: 0;\n}\n.ant-input-rtl .ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):focus {\n  border-right-width: 0;\n  border-left-width: 1px !important;\n}\n.ant-transfer {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: flex;\n  align-items: stretch;\n}\n.ant-transfer-disabled .ant-transfer-list {\n  background: #f5f5f5;\n}\n.ant-transfer-list {\n  display: flex;\n  flex-direction: column;\n  width: 180px;\n  height: 200px;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n.ant-transfer-list-with-pagination {\n  width: 250px;\n  height: auto;\n}\n.ant-transfer-list-search .anticon-search {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-transfer-list-header {\n  display: flex;\n  flex: none;\n  align-items: center;\n  height: 40px;\n  padding: 10px 12px 11px;\n  color: #545454;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 6px 6px 0 0;\n}\n.ant-transfer-list-header > *:not(:last-child) {\n  margin-right: 4px;\n}\n.ant-transfer-list-header > * {\n  flex: none;\n}\n.ant-transfer-list-header-title {\n  flex: auto;\n  overflow: hidden;\n  white-space: nowrap;\n  text-align: right;\n  text-overflow: ellipsis;\n}\n.ant-transfer-list-header-dropdown {\n  font-size: 10px;\n  transform: translateY(10%);\n  cursor: pointer;\n}\n.ant-transfer-list-header-dropdown[disabled] {\n  cursor: not-allowed;\n}\n.ant-transfer-list-body {\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n  overflow: hidden;\n  font-size: 14px;\n}\n.ant-transfer-list-body-search-wrapper {\n  position: relative;\n  flex: none;\n  padding: 12px;\n}\n.ant-transfer-list-content {\n  flex: auto;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n  list-style: none;\n}\n.ant-transfer-list-content-item {\n  display: flex;\n  align-items: center;\n  min-height: 32px;\n  padding: 6px 12px;\n  line-height: 20px;\n  transition: all 0.3s;\n}\n.ant-transfer-list-content-item > *:not(:last-child) {\n  margin-right: 8px;\n}\n.ant-transfer-list-content-item > * {\n  flex: none;\n}\n.ant-transfer-list-content-item-text {\n  flex: auto;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-transfer-list-content-item-remove {\n  position: relative;\n  color: #d9d9d9;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-transfer-list-content-item-remove:hover {\n  color: #0d0d0d;\n}\n.ant-transfer-list-content-item-remove::after {\n  position: absolute;\n  top: -6px;\n  right: -50%;\n  bottom: -6px;\n  left: -50%;\n  content: '';\n}\n.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled).ant-transfer-list-content-item-checked:hover {\n  background-color: #8b868f;\n}\n.ant-transfer-list-content-show-remove .ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {\n  background: transparent;\n  cursor: default;\n}\n.ant-transfer-list-content-item-checked {\n  background-color: #908b94;\n}\n.ant-transfer-list-content-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-transfer-list-pagination {\n  padding: 8px 0;\n  text-align: right;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-transfer-list-body-not-found {\n  flex: none;\n  width: 100%;\n  margin: auto 0;\n  color: rgba(0, 0, 0, 0.25);\n  text-align: center;\n}\n.ant-transfer-list-footer {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-transfer-operation {\n  display: flex;\n  flex: none;\n  flex-direction: column;\n  align-self: center;\n  margin: 0 8px;\n  vertical-align: middle;\n}\n.ant-transfer-operation .ant-btn {\n  display: block;\n}\n.ant-transfer-operation .ant-btn:first-child {\n  margin-bottom: 4px;\n}\n.ant-transfer-operation .ant-btn .anticon {\n  font-size: 12px;\n}\n.ant-transfer .ant-empty-image {\n  max-height: -2px;\n}\n.ant-transfer-rtl {\n  direction: rtl;\n}\n.ant-transfer-rtl .ant-transfer-list-search {\n  padding-right: 8px;\n  padding-left: 24px;\n}\n.ant-transfer-rtl .ant-transfer-list-search-action {\n  right: auto;\n  left: 12px;\n}\n.ant-transfer-rtl .ant-transfer-list-header > *:not(:last-child) {\n  margin-right: 0;\n  margin-left: 4px;\n}\n.ant-transfer-rtl .ant-transfer-list-header {\n  right: 0;\n  left: auto;\n}\n.ant-transfer-rtl .ant-transfer-list-header-title {\n  text-align: left;\n}\n.ant-transfer-rtl .ant-transfer-list-content-item > *:not(:last-child) {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-transfer-rtl .ant-transfer-list-pagination {\n  text-align: left;\n}\n.ant-transfer-rtl .ant-transfer-list-footer {\n  right: 0;\n  left: auto;\n}\n@keyframes ant-tree-node-fx-do-not-use {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode {\n  position: relative;\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 4px;\n  left: 0;\n  transition: background-color 0.3s;\n  content: '';\n  pointer-events: none;\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode:hover::before {\n  background: #f5f5f5;\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode > * {\n  z-index: 1;\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-switcher {\n  transition: color 0.3s;\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper {\n  border-radius: 0;\n  user-select: none;\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper:hover {\n  background: transparent;\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper.ant-tree-node-selected {\n  color: #fff;\n  background: transparent;\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode-selected:hover::before,\n.ant-tree.ant-tree-directory .ant-tree-treenode-selected::before {\n  background: #351a55;\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode-selected .ant-tree-switcher {\n  color: #fff;\n}\n.ant-tree.ant-tree-directory .ant-tree-treenode-selected .ant-tree-node-content-wrapper {\n  color: #fff;\n  background: transparent;\n}\n.ant-tree-checkbox {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: 0.2em;\n  line-height: 1;\n  white-space: nowrap;\n  outline: none;\n  cursor: pointer;\n}\n.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner,\n.ant-tree-checkbox:hover .ant-tree-checkbox-inner,\n.ant-tree-checkbox-input:focus + .ant-tree-checkbox-inner {\n  border-color: #351a55;\n}\n.ant-tree-checkbox-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #351a55;\n  border-radius: 4px;\n  visibility: hidden;\n  animation: antCheckboxEffect 0.36s ease-in-out;\n  animation-fill-mode: backwards;\n  content: '';\n}\n.ant-tree-checkbox:hover::after,\n.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox::after {\n  visibility: visible;\n}\n.ant-tree-checkbox-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  direction: ltr;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  border-collapse: separate;\n  transition: all 0.3s;\n}\n.ant-tree-checkbox-inner::after {\n  position: absolute;\n  top: 50%;\n  left: 21.5%;\n  display: table;\n  width: 5.71428571px;\n  height: 9.14285714px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(0) translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;\n  content: ' ';\n}\n.ant-tree-checkbox-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {\n  position: absolute;\n  display: table;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(1) translate(-50%, -50%);\n  opacity: 1;\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n  content: ' ';\n}\n.ant-tree-checkbox-checked .ant-tree-checkbox-inner {\n  background-color: #351a55;\n  border-color: #351a55;\n}\n.ant-tree-checkbox-disabled {\n  cursor: not-allowed;\n}\n.ant-tree-checkbox-disabled.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {\n  border-color: rgba(0, 0, 0, 0.25);\n  animation-name: none;\n}\n.ant-tree-checkbox-disabled .ant-tree-checkbox-input {\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.ant-tree-checkbox-disabled .ant-tree-checkbox-inner {\n  background-color: #f5f5f5;\n  border-color: #d9d9d9 !important;\n}\n.ant-tree-checkbox-disabled .ant-tree-checkbox-inner::after {\n  border-color: #f5f5f5;\n  border-collapse: separate;\n  animation-name: none;\n}\n.ant-tree-checkbox-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-tree-checkbox-disabled:hover::after,\n.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-disabled::after {\n  visibility: hidden;\n}\n.ant-tree-checkbox-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-flex;\n  align-items: baseline;\n  line-height: unset;\n  cursor: pointer;\n}\n.ant-tree-checkbox-wrapper::after {\n  display: inline-block;\n  width: 0;\n  overflow: hidden;\n  content: '\\a0';\n}\n.ant-tree-checkbox-wrapper.ant-tree-checkbox-wrapper-disabled {\n  cursor: not-allowed;\n}\n.ant-tree-checkbox-wrapper + .ant-tree-checkbox-wrapper {\n  margin-left: 8px;\n}\n.ant-tree-checkbox-wrapper.ant-tree-checkbox-wrapper-in-form-item input[type='checkbox'] {\n  width: 14px;\n  height: 14px;\n}\n.ant-tree-checkbox + span {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-tree-checkbox-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-tree-checkbox-group-item {\n  margin-right: 8px;\n}\n.ant-tree-checkbox-group-item:last-child {\n  margin-right: 0;\n}\n.ant-tree-checkbox-group-item + .ant-tree-checkbox-group-item {\n  margin-left: 0;\n}\n.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after {\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background-color: #351a55;\n  border: 0;\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n  content: ' ';\n}\n.ant-tree-checkbox-indeterminate.ant-tree-checkbox-disabled .ant-tree-checkbox-inner::after {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-tree-checkbox-rtl {\n  direction: rtl;\n}\n.ant-tree-checkbox-group-rtl .ant-tree-checkbox-group-item {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-tree-checkbox-group-rtl .ant-tree-checkbox-group-item:last-child {\n  margin-left: 0 !important;\n}\n.ant-tree-checkbox-group-rtl .ant-tree-checkbox-group-item + .ant-tree-checkbox-group-item {\n  margin-left: 8px;\n}\n.ant-tree {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  background: #fff;\n  border-radius: 6px;\n  transition: background-color 0.3s;\n}\n.ant-tree-focused:not(:hover):not(.ant-tree-active-focused) {\n  background: #908b94;\n}\n.ant-tree-list-holder-inner {\n  align-items: flex-start;\n}\n.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner {\n  align-items: stretch;\n}\n.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-node-content-wrapper {\n  flex: auto;\n}\n.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-treenode.dragging {\n  position: relative;\n}\n.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-treenode.dragging::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 4px;\n  left: 0;\n  border: 1px solid #351a55;\n  opacity: 0;\n  animation: ant-tree-node-fx-do-not-use 0.3s;\n  animation-play-state: running;\n  animation-fill-mode: forwards;\n  content: '';\n  pointer-events: none;\n}\n.ant-tree .ant-tree-treenode {\n  display: flex;\n  align-items: flex-start;\n  padding: 0 0 4px 0;\n  outline: none;\n}\n.ant-tree .ant-tree-treenode-disabled .ant-tree-node-content-wrapper {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-tree .ant-tree-treenode-disabled .ant-tree-node-content-wrapper:hover {\n  background: transparent;\n}\n.ant-tree .ant-tree-treenode-active .ant-tree-node-content-wrapper {\n  background: #f5f5f5;\n}\n.ant-tree .ant-tree-treenode:not(.ant-tree .ant-tree-treenode-disabled).filter-node .ant-tree-title {\n  color: inherit;\n  font-weight: 500;\n}\n.ant-tree .ant-tree-treenode-draggable .ant-tree-draggable-icon {\n  width: 24px;\n  line-height: 24px;\n  text-align: center;\n  visibility: visible;\n  opacity: 0.2;\n  transition: opacity 0.3s;\n}\n.ant-tree-treenode:hover .ant-tree .ant-tree-treenode-draggable .ant-tree-draggable-icon {\n  opacity: 0.45;\n}\n.ant-tree .ant-tree-treenode-draggable.ant-tree-treenode-disabled .ant-tree-draggable-icon {\n  visibility: hidden;\n}\n.ant-tree-indent {\n  align-self: stretch;\n  white-space: nowrap;\n  user-select: none;\n}\n.ant-tree-indent-unit {\n  display: inline-block;\n  width: 24px;\n}\n.ant-tree-draggable-icon {\n  visibility: hidden;\n}\n.ant-tree-switcher {\n  position: relative;\n  flex: none;\n  align-self: stretch;\n  width: 24px;\n  margin: 0;\n  line-height: 24px;\n  text-align: center;\n  cursor: pointer;\n  user-select: none;\n}\n.ant-tree-switcher .ant-tree-switcher-icon,\n.ant-tree-switcher .ant-select-tree-switcher-icon {\n  display: inline-block;\n  font-size: 10px;\n  vertical-align: baseline;\n}\n.ant-tree-switcher .ant-tree-switcher-icon svg,\n.ant-tree-switcher .ant-select-tree-switcher-icon svg {\n  transition: transform 0.3s;\n}\n.ant-tree-switcher-noop {\n  cursor: default;\n}\n.ant-tree-switcher_close .ant-tree-switcher-icon svg {\n  transform: rotate(-90deg);\n}\n.ant-tree-switcher-loading-icon {\n  color: #351a55;\n}\n.ant-tree-switcher-leaf-line {\n  position: relative;\n  z-index: 1;\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n}\n.ant-tree-switcher-leaf-line::before {\n  position: absolute;\n  top: 0;\n  right: 12px;\n  bottom: -4px;\n  margin-left: -1px;\n  border-right: 1px solid #d9d9d9;\n  content: ' ';\n}\n.ant-tree-switcher-leaf-line::after {\n  position: absolute;\n  width: 10px;\n  height: 14px;\n  border-bottom: 1px solid #d9d9d9;\n  content: ' ';\n}\n.ant-tree-checkbox {\n  top: initial;\n  margin: 4px 8px 0 0;\n}\n.ant-tree .ant-tree-node-content-wrapper {\n  position: relative;\n  z-index: auto;\n  min-height: 24px;\n  margin: 0;\n  padding: 0 4px;\n  color: inherit;\n  line-height: 24px;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s, border 0s, line-height 0s, box-shadow 0s;\n}\n.ant-tree .ant-tree-node-content-wrapper:hover {\n  background-color: #f5f5f5;\n}\n.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {\n  background-color: #847f87;\n}\n.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  text-align: center;\n  vertical-align: top;\n}\n.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle:empty {\n  display: none;\n}\n.ant-tree-unselectable .ant-tree-node-content-wrapper:hover {\n  background-color: transparent;\n}\n.ant-tree-node-content-wrapper {\n  line-height: 24px;\n  user-select: none;\n}\n.ant-tree-node-content-wrapper .ant-tree-drop-indicator {\n  position: absolute;\n  z-index: 1;\n  height: 2px;\n  background-color: #351a55;\n  border-radius: 1px;\n  pointer-events: none;\n}\n.ant-tree-node-content-wrapper .ant-tree-drop-indicator::after {\n  position: absolute;\n  top: -3px;\n  left: -6px;\n  width: 8px;\n  height: 8px;\n  background-color: transparent;\n  border: 2px solid #351a55;\n  border-radius: 50%;\n  content: '';\n}\n.ant-tree .ant-tree-treenode.drop-container > [draggable] {\n  box-shadow: 0 0 0 2px #351a55;\n}\n.ant-tree-show-line .ant-tree-indent-unit {\n  position: relative;\n  height: 100%;\n}\n.ant-tree-show-line .ant-tree-indent-unit::before {\n  position: absolute;\n  top: 0;\n  right: 12px;\n  bottom: -4px;\n  border-right: 1px solid #d9d9d9;\n  content: '';\n}\n.ant-tree-show-line .ant-tree-indent-unit-end::before {\n  display: none;\n}\n.ant-tree-show-line .ant-tree-switcher {\n  background: #fff;\n}\n.ant-tree-show-line .ant-tree-switcher-line-icon {\n  vertical-align: -0.15em;\n}\n.ant-tree .ant-tree-treenode-leaf-last .ant-tree-switcher-leaf-line::before {\n  top: auto !important;\n  bottom: auto !important;\n  height: 14px !important;\n}\n.ant-tree-rtl {\n  direction: rtl;\n}\n.ant-tree-rtl .ant-tree-node-content-wrapper[draggable='true'] .ant-tree-drop-indicator::after {\n  right: -6px;\n  left: unset;\n}\n.ant-tree .ant-tree-treenode-rtl {\n  direction: rtl;\n}\n.ant-tree-rtl .ant-tree-switcher_close .ant-tree-switcher-icon svg {\n  transform: rotate(90deg);\n}\n.ant-tree-rtl.ant-tree-show-line .ant-tree-indent-unit::before {\n  right: auto;\n  left: -13px;\n  border-right: none;\n  border-left: 1px solid #d9d9d9;\n}\n.ant-tree-rtl .ant-tree-checkbox {\n  margin: 4px 0 0 8px;\n}\n.ant-tree-select-dropdown-rtl .ant-select-tree-checkbox {\n  margin: 4px 0 0 8px;\n}\n.ant-select-tree-checkbox {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: 0.2em;\n  line-height: 1;\n  white-space: nowrap;\n  outline: none;\n  cursor: pointer;\n}\n.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-inner,\n.ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner,\n.ant-select-tree-checkbox-input:focus + .ant-select-tree-checkbox-inner {\n  border-color: #351a55;\n}\n.ant-select-tree-checkbox-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #351a55;\n  border-radius: 4px;\n  visibility: hidden;\n  animation: antCheckboxEffect 0.36s ease-in-out;\n  animation-fill-mode: backwards;\n  content: '';\n}\n.ant-select-tree-checkbox:hover::after,\n.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox::after {\n  visibility: visible;\n}\n.ant-select-tree-checkbox-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  direction: ltr;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  border-collapse: separate;\n  transition: all 0.3s;\n}\n.ant-select-tree-checkbox-inner::after {\n  position: absolute;\n  top: 50%;\n  left: 21.5%;\n  display: table;\n  width: 5.71428571px;\n  height: 9.14285714px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(0) translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;\n  content: ' ';\n}\n.ant-select-tree-checkbox-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner::after {\n  position: absolute;\n  display: table;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(1) translate(-50%, -50%);\n  opacity: 1;\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n  content: ' ';\n}\n.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {\n  background-color: #351a55;\n  border-color: #351a55;\n}\n.ant-select-tree-checkbox-disabled {\n  cursor: not-allowed;\n}\n.ant-select-tree-checkbox-disabled.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner::after {\n  border-color: rgba(0, 0, 0, 0.25);\n  animation-name: none;\n}\n.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-input {\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner {\n  background-color: #f5f5f5;\n  border-color: #d9d9d9 !important;\n}\n.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner::after {\n  border-color: #f5f5f5;\n  border-collapse: separate;\n  animation-name: none;\n}\n.ant-select-tree-checkbox-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-select-tree-checkbox-disabled:hover::after,\n.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-disabled::after {\n  visibility: hidden;\n}\n.ant-select-tree-checkbox-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-flex;\n  align-items: baseline;\n  line-height: unset;\n  cursor: pointer;\n}\n.ant-select-tree-checkbox-wrapper::after {\n  display: inline-block;\n  width: 0;\n  overflow: hidden;\n  content: '\\a0';\n}\n.ant-select-tree-checkbox-wrapper.ant-select-tree-checkbox-wrapper-disabled {\n  cursor: not-allowed;\n}\n.ant-select-tree-checkbox-wrapper + .ant-select-tree-checkbox-wrapper {\n  margin-left: 8px;\n}\n.ant-select-tree-checkbox-wrapper.ant-select-tree-checkbox-wrapper-in-form-item input[type='checkbox'] {\n  width: 14px;\n  height: 14px;\n}\n.ant-select-tree-checkbox + span {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-select-tree-checkbox-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-select-tree-checkbox-group-item {\n  margin-right: 8px;\n}\n.ant-select-tree-checkbox-group-item:last-child {\n  margin-right: 0;\n}\n.ant-select-tree-checkbox-group-item + .ant-select-tree-checkbox-group-item {\n  margin-left: 0;\n}\n.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner::after {\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background-color: #351a55;\n  border: 0;\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n  content: ' ';\n}\n.ant-select-tree-checkbox-indeterminate.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner::after {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-tree-checkbox-rtl {\n  direction: rtl;\n}\n.ant-select-tree-checkbox-group-rtl .ant-select-tree-checkbox-group-item {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.ant-select-tree-checkbox-group-rtl .ant-select-tree-checkbox-group-item:last-child {\n  margin-left: 0 !important;\n}\n.ant-select-tree-checkbox-group-rtl .ant-select-tree-checkbox-group-item + .ant-select-tree-checkbox-group-item {\n  margin-left: 8px;\n}\n.ant-tree-select-dropdown {\n  padding: 8px 4px;\n}\n.ant-tree-select-dropdown-rtl {\n  direction: rtl;\n}\n.ant-tree-select-dropdown .ant-select-tree {\n  border-radius: 0;\n}\n.ant-tree-select-dropdown .ant-select-tree-list-holder-inner {\n  align-items: stretch;\n}\n.ant-tree-select-dropdown .ant-select-tree-list-holder-inner .ant-select-tree-treenode .ant-select-tree-node-content-wrapper {\n  flex: auto;\n}\n.ant-select-tree {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  background: #fff;\n  border-radius: 6px;\n  transition: background-color 0.3s;\n}\n.ant-select-tree-focused:not(:hover):not(.ant-select-tree-active-focused) {\n  background: #908b94;\n}\n.ant-select-tree-list-holder-inner {\n  align-items: flex-start;\n}\n.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner {\n  align-items: stretch;\n}\n.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-node-content-wrapper {\n  flex: auto;\n}\n.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-treenode.dragging {\n  position: relative;\n}\n.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-treenode.dragging::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 4px;\n  left: 0;\n  border: 1px solid #351a55;\n  opacity: 0;\n  animation: ant-tree-node-fx-do-not-use 0.3s;\n  animation-play-state: running;\n  animation-fill-mode: forwards;\n  content: '';\n  pointer-events: none;\n}\n.ant-select-tree .ant-select-tree-treenode {\n  display: flex;\n  align-items: flex-start;\n  padding: 0 0 4px 0;\n  outline: none;\n}\n.ant-select-tree .ant-select-tree-treenode-disabled .ant-select-tree-node-content-wrapper {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-select-tree .ant-select-tree-treenode-disabled .ant-select-tree-node-content-wrapper:hover {\n  background: transparent;\n}\n.ant-select-tree .ant-select-tree-treenode-active .ant-select-tree-node-content-wrapper {\n  background: #f5f5f5;\n}\n.ant-select-tree .ant-select-tree-treenode:not(.ant-select-tree .ant-select-tree-treenode-disabled).filter-node .ant-select-tree-title {\n  color: inherit;\n  font-weight: 500;\n}\n.ant-select-tree .ant-select-tree-treenode-draggable .ant-select-tree-draggable-icon {\n  width: 24px;\n  line-height: 24px;\n  text-align: center;\n  visibility: visible;\n  opacity: 0.2;\n  transition: opacity 0.3s;\n}\n.ant-select-tree-treenode:hover .ant-select-tree .ant-select-tree-treenode-draggable .ant-select-tree-draggable-icon {\n  opacity: 0.45;\n}\n.ant-select-tree .ant-select-tree-treenode-draggable.ant-select-tree-treenode-disabled .ant-select-tree-draggable-icon {\n  visibility: hidden;\n}\n.ant-select-tree-indent {\n  align-self: stretch;\n  white-space: nowrap;\n  user-select: none;\n}\n.ant-select-tree-indent-unit {\n  display: inline-block;\n  width: 24px;\n}\n.ant-select-tree-draggable-icon {\n  visibility: hidden;\n}\n.ant-select-tree-switcher {\n  position: relative;\n  flex: none;\n  align-self: stretch;\n  width: 24px;\n  margin: 0;\n  line-height: 24px;\n  text-align: center;\n  cursor: pointer;\n  user-select: none;\n}\n.ant-select-tree-switcher .ant-tree-switcher-icon,\n.ant-select-tree-switcher .ant-select-tree-switcher-icon {\n  display: inline-block;\n  font-size: 10px;\n  vertical-align: baseline;\n}\n.ant-select-tree-switcher .ant-tree-switcher-icon svg,\n.ant-select-tree-switcher .ant-select-tree-switcher-icon svg {\n  transition: transform 0.3s;\n}\n.ant-select-tree-switcher-noop {\n  cursor: default;\n}\n.ant-select-tree-switcher_close .ant-select-tree-switcher-icon svg {\n  transform: rotate(-90deg);\n}\n.ant-select-tree-switcher-loading-icon {\n  color: #351a55;\n}\n.ant-select-tree-switcher-leaf-line {\n  position: relative;\n  z-index: 1;\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n}\n.ant-select-tree-switcher-leaf-line::before {\n  position: absolute;\n  top: 0;\n  right: 12px;\n  bottom: -4px;\n  margin-left: -1px;\n  border-right: 1px solid #d9d9d9;\n  content: ' ';\n}\n.ant-select-tree-switcher-leaf-line::after {\n  position: absolute;\n  width: 10px;\n  height: 14px;\n  border-bottom: 1px solid #d9d9d9;\n  content: ' ';\n}\n.ant-select-tree-checkbox {\n  top: initial;\n  margin: 4px 8px 0 0;\n}\n.ant-select-tree .ant-select-tree-node-content-wrapper {\n  position: relative;\n  z-index: auto;\n  min-height: 24px;\n  margin: 0;\n  padding: 0 4px;\n  color: inherit;\n  line-height: 24px;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s, border 0s, line-height 0s, box-shadow 0s;\n}\n.ant-select-tree .ant-select-tree-node-content-wrapper:hover {\n  background-color: #f5f5f5;\n}\n.ant-select-tree .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {\n  background-color: #847f87;\n}\n.ant-select-tree .ant-select-tree-node-content-wrapper .ant-select-tree-iconEle {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  text-align: center;\n  vertical-align: top;\n}\n.ant-select-tree .ant-select-tree-node-content-wrapper .ant-select-tree-iconEle:empty {\n  display: none;\n}\n.ant-select-tree-unselectable .ant-select-tree-node-content-wrapper:hover {\n  background-color: transparent;\n}\n.ant-select-tree-node-content-wrapper {\n  line-height: 24px;\n  user-select: none;\n}\n.ant-select-tree-node-content-wrapper .ant-tree-drop-indicator {\n  position: absolute;\n  z-index: 1;\n  height: 2px;\n  background-color: #351a55;\n  border-radius: 1px;\n  pointer-events: none;\n}\n.ant-select-tree-node-content-wrapper .ant-tree-drop-indicator::after {\n  position: absolute;\n  top: -3px;\n  left: -6px;\n  width: 8px;\n  height: 8px;\n  background-color: transparent;\n  border: 2px solid #351a55;\n  border-radius: 50%;\n  content: '';\n}\n.ant-select-tree .ant-select-tree-treenode.drop-container > [draggable] {\n  box-shadow: 0 0 0 2px #351a55;\n}\n.ant-select-tree-show-line .ant-select-tree-indent-unit {\n  position: relative;\n  height: 100%;\n}\n.ant-select-tree-show-line .ant-select-tree-indent-unit::before {\n  position: absolute;\n  top: 0;\n  right: 12px;\n  bottom: -4px;\n  border-right: 1px solid #d9d9d9;\n  content: '';\n}\n.ant-select-tree-show-line .ant-select-tree-indent-unit-end::before {\n  display: none;\n}\n.ant-select-tree-show-line .ant-select-tree-switcher {\n  background: #fff;\n}\n.ant-select-tree-show-line .ant-select-tree-switcher-line-icon {\n  vertical-align: -0.15em;\n}\n.ant-select-tree .ant-select-tree-treenode-leaf-last .ant-select-tree-switcher-leaf-line::before {\n  top: auto !important;\n  bottom: auto !important;\n  height: 14px !important;\n}\n.ant-tree-select-dropdown-rtl .ant-select-tree .ant-select-tree-switcher_close .ant-select-tree-switcher-icon svg {\n  transform: rotate(90deg);\n}\n.ant-tree-select-dropdown-rtl .ant-select-tree .ant-select-tree-switcher-loading-icon {\n  transform: scaleY(-1);\n}\n.ant-typography {\n  color: #545454;\n  word-break: break-word;\n}\n.ant-typography.ant-typography-secondary {\n  color: #595959;\n}\n.ant-typography.ant-typography-success {\n  color: #52c41a;\n}\n.ant-typography.ant-typography-warning {\n  color: #fa8c16;\n}\n.ant-typography.ant-typography-danger {\n  color: #f5222d;\n}\na.ant-typography.ant-typography-danger:active,\na.ant-typography.ant-typography-danger:focus {\n  color: #cf1322;\n}\na.ant-typography.ant-typography-danger:hover {\n  color: #ff4d4f;\n}\n.ant-typography.ant-typography-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n  user-select: none;\n}\ndiv.ant-typography,\n.ant-typography p {\n  margin-bottom: 1em;\n}\nh1.ant-typography,\ndiv.ant-typography-h1,\ndiv.ant-typography-h1 > textarea,\n.ant-typography h1 {\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 600;\n  font-size: 38px;\n  line-height: 1.23;\n}\nh2.ant-typography,\ndiv.ant-typography-h2,\ndiv.ant-typography-h2 > textarea,\n.ant-typography h2 {\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 1.35;\n}\nh3.ant-typography,\ndiv.ant-typography-h3,\ndiv.ant-typography-h3 > textarea,\n.ant-typography h3 {\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 1.35;\n}\nh4.ant-typography,\ndiv.ant-typography-h4,\ndiv.ant-typography-h4 > textarea,\n.ant-typography h4 {\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n}\nh5.ant-typography,\ndiv.ant-typography-h5,\ndiv.ant-typography-h5 > textarea,\n.ant-typography h5 {\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.5;\n}\n.ant-typography + h1.ant-typography,\n.ant-typography + h2.ant-typography,\n.ant-typography + h3.ant-typography,\n.ant-typography + h4.ant-typography,\n.ant-typography + h5.ant-typography {\n  margin-top: 1.2em;\n}\n.ant-typography div + h1,\n.ant-typography ul + h1,\n.ant-typography li + h1,\n.ant-typography p + h1,\n.ant-typography h1 + h1,\n.ant-typography h2 + h1,\n.ant-typography h3 + h1,\n.ant-typography h4 + h1,\n.ant-typography h5 + h1,\n.ant-typography div + h2,\n.ant-typography ul + h2,\n.ant-typography li + h2,\n.ant-typography p + h2,\n.ant-typography h1 + h2,\n.ant-typography h2 + h2,\n.ant-typography h3 + h2,\n.ant-typography h4 + h2,\n.ant-typography h5 + h2,\n.ant-typography div + h3,\n.ant-typography ul + h3,\n.ant-typography li + h3,\n.ant-typography p + h3,\n.ant-typography h1 + h3,\n.ant-typography h2 + h3,\n.ant-typography h3 + h3,\n.ant-typography h4 + h3,\n.ant-typography h5 + h3,\n.ant-typography div + h4,\n.ant-typography ul + h4,\n.ant-typography li + h4,\n.ant-typography p + h4,\n.ant-typography h1 + h4,\n.ant-typography h2 + h4,\n.ant-typography h3 + h4,\n.ant-typography h4 + h4,\n.ant-typography h5 + h4,\n.ant-typography div + h5,\n.ant-typography ul + h5,\n.ant-typography li + h5,\n.ant-typography p + h5,\n.ant-typography h1 + h5,\n.ant-typography h2 + h5,\n.ant-typography h3 + h5,\n.ant-typography h4 + h5,\n.ant-typography h5 + h5 {\n  margin-top: 1.2em;\n}\na.ant-typography-ellipsis,\nspan.ant-typography-ellipsis {\n  display: inline-block;\n  max-width: 100%;\n}\na.ant-typography,\n.ant-typography a {\n  color: var(--app-primary-color);\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  text-decoration: none;\n}\na.ant-typography:focus-visible,\n.ant-typography a:focus-visible,\na.ant-typography:hover,\n.ant-typography a:hover {\n  color: #0d0d0d;\n}\na.ant-typography:active,\n.ant-typography a:active {\n  color: #000000;\n}\na.ant-typography:active,\n.ant-typography a:active,\na.ant-typography:hover,\n.ant-typography a:hover {\n  text-decoration: none;\n}\na.ant-typography[disabled],\n.ant-typography a[disabled],\na.ant-typography.ant-typography-disabled,\n.ant-typography a.ant-typography-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\na.ant-typography[disabled]:active,\n.ant-typography a[disabled]:active,\na.ant-typography.ant-typography-disabled:active,\n.ant-typography a.ant-typography-disabled:active,\na.ant-typography[disabled]:hover,\n.ant-typography a[disabled]:hover,\na.ant-typography.ant-typography-disabled:hover,\n.ant-typography a.ant-typography-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n}\na.ant-typography[disabled]:active,\n.ant-typography a[disabled]:active,\na.ant-typography.ant-typography-disabled:active,\n.ant-typography a.ant-typography-disabled:active {\n  pointer-events: none;\n}\n.ant-typography code {\n  margin: 0 0.2em;\n  padding: 0.2em 0.4em 0.1em;\n  font-size: 85%;\n  background: rgba(150, 150, 150, 0.1);\n  border: 1px solid rgba(100, 100, 100, 0.2);\n  border-radius: 3px;\n}\n.ant-typography kbd {\n  margin: 0 0.2em;\n  padding: 0.15em 0.4em 0.1em;\n  font-size: 90%;\n  background: rgba(150, 150, 150, 0.06);\n  border: 1px solid rgba(100, 100, 100, 0.2);\n  border-bottom-width: 2px;\n  border-radius: 3px;\n}\n.ant-typography mark {\n  padding: 0;\n  background-color: #ffe58f;\n}\n.ant-typography u,\n.ant-typography ins {\n  text-decoration: underline;\n  text-decoration-skip-ink: auto;\n}\n.ant-typography s,\n.ant-typography del {\n  text-decoration: line-through;\n}\n.ant-typography strong {\n  font-weight: 600;\n}\n.ant-typography-expand,\n.ant-typography-edit,\n.ant-typography-copy {\n  color: var(--app-primary-color);\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  margin-left: 4px;\n}\n.ant-typography-expand:focus-visible,\n.ant-typography-edit:focus-visible,\n.ant-typography-copy:focus-visible,\n.ant-typography-expand:hover,\n.ant-typography-edit:hover,\n.ant-typography-copy:hover {\n  color: #0d0d0d;\n}\n.ant-typography-expand:active,\n.ant-typography-edit:active,\n.ant-typography-copy:active {\n  color: #000000;\n}\n.ant-typography-copy-success,\n.ant-typography-copy-success:hover,\n.ant-typography-copy-success:focus {\n  color: #52c41a;\n}\n.ant-typography-edit-content {\n  position: relative;\n}\ndiv.ant-typography-edit-content {\n  left: -12px;\n  margin-top: -8.9px;\n  margin-bottom: calc(1em - 7.9px - 1px);\n}\n.ant-typography-edit-content-confirm {\n  position: absolute;\n  right: 10px;\n  bottom: 8px;\n  color: #595959;\n  font-weight: normal;\n  font-size: 14px;\n  font-style: normal;\n  pointer-events: none;\n}\n.ant-typography-edit-content textarea {\n  height: 1em;\n  margin: 0 !important;\n  /* stylelint-disable-next-line property-no-vendor-prefix */\n  -moz-transition: none;\n}\n.ant-typography ul,\n.ant-typography ol {\n  margin: 0 0 1em;\n  padding: 0;\n}\n.ant-typography ul li,\n.ant-typography ol li {\n  margin: 0 0 0 20px;\n  padding: 0 0 0 4px;\n}\n.ant-typography ul {\n  list-style-type: circle;\n}\n.ant-typography ul ul {\n  list-style-type: disc;\n}\n.ant-typography ol {\n  list-style-type: decimal;\n}\n.ant-typography pre,\n.ant-typography blockquote {\n  margin: 1em 0;\n}\n.ant-typography pre {\n  padding: 0.4em 0.6em;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  background: rgba(150, 150, 150, 0.1);\n  border: 1px solid rgba(100, 100, 100, 0.2);\n  border-radius: 3px;\n}\n.ant-typography pre code {\n  display: inline;\n  margin: 0;\n  padding: 0;\n  font-size: inherit;\n  font-family: inherit;\n  background: transparent;\n  border: 0;\n}\n.ant-typography blockquote {\n  padding: 0 0 0 0.6em;\n  border-left: 4px solid rgba(100, 100, 100, 0.2);\n  opacity: 0.85;\n}\n.ant-typography-single-line {\n  white-space: nowrap;\n}\n.ant-typography-ellipsis-single-line {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\na.ant-typography-ellipsis-single-line,\nspan.ant-typography-ellipsis-single-line {\n  vertical-align: bottom;\n}\n.ant-typography-ellipsis-multiple-line {\n  /* stylelint-disable-next-line value-no-vendor-prefix */\n  display: -webkit-box;\n  overflow: hidden;\n  -webkit-line-clamp: 3;\n  /*! autoprefixer: ignore next */\n  -webkit-box-orient: vertical;\n}\n.ant-typography-rtl {\n  direction: rtl;\n}\n.ant-typography-rtl .ant-typography-expand,\n.ant-typography-rtl .ant-typography-edit,\n.ant-typography-rtl .ant-typography-copy {\n  margin-right: 4px;\n  margin-left: 0;\n}\n.ant-typography-rtl .ant-typography-expand {\n  float: left;\n}\ndiv.ant-typography-edit-content.ant-typography-rtl {\n  right: -12px;\n  left: auto;\n}\n.ant-typography-rtl .ant-typography-edit-content-confirm {\n  right: auto;\n  left: 10px;\n}\n.ant-typography-rtl.ant-typography ul li,\n.ant-typography-rtl.ant-typography ol li {\n  margin: 0 20px 0 0;\n  padding: 0 4px 0 0;\n}\n.ant-upload {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  outline: 0;\n}\n.ant-upload p {\n  margin: 0;\n}\n.ant-upload-btn {\n  display: block;\n  width: 100%;\n  outline: none;\n}\n.ant-upload input[type='file'] {\n  cursor: pointer;\n}\n.ant-upload.ant-upload-select {\n  display: inline-block;\n}\n.ant-upload.ant-upload-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-upload.ant-upload-select-picture-card {\n  width: 104px;\n  height: 104px;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  text-align: center;\n  vertical-align: top;\n  background-color: #fafafa;\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.3s;\n}\n.ant-upload.ant-upload-select-picture-card > .ant-upload {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n}\n.ant-upload.ant-upload-select-picture-card:hover {\n  border-color: #351a55;\n}\n.ant-upload-disabled.ant-upload.ant-upload-select-picture-card:hover {\n  border-color: #d9d9d9;\n}\n.ant-upload.ant-upload-drag {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  background: #fafafa;\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.3s;\n}\n.ant-upload.ant-upload-drag .ant-upload {\n  padding: 16px 0;\n}\n.ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {\n  border-color: #1a0c2e;\n}\n.ant-upload.ant-upload-drag.ant-upload-disabled {\n  cursor: not-allowed;\n}\n.ant-upload.ant-upload-drag .ant-upload-btn {\n  display: table;\n  height: 100%;\n}\n.ant-upload.ant-upload-drag .ant-upload-drag-container {\n  display: table-cell;\n  vertical-align: middle;\n}\n.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {\n  border-color: #462e61;\n}\n.ant-upload.ant-upload-drag p.ant-upload-drag-icon {\n  margin-bottom: 20px;\n}\n.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {\n  color: #462e61;\n  font-size: 48px;\n}\n.ant-upload.ant-upload-drag p.ant-upload-text {\n  margin: 0 0 4px;\n  color: #535353;\n  font-size: 16px;\n}\n.ant-upload.ant-upload-drag p.ant-upload-hint {\n  color: #595959;\n  font-size: 14px;\n}\n.ant-upload.ant-upload-drag .anticon-plus {\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 30px;\n  transition: all 0.3s;\n}\n.ant-upload.ant-upload-drag .anticon-plus:hover {\n  color: #595959;\n}\n.ant-upload.ant-upload-drag:hover .anticon-plus {\n  color: #595959;\n}\n.ant-upload-picture-card-wrapper {\n  display: inline-block;\n  width: 100%;\n}\n.ant-upload-picture-card-wrapper::before {\n  display: table;\n  content: '';\n}\n.ant-upload-picture-card-wrapper::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-upload-picture-card-wrapper::before {\n  display: table;\n  content: '';\n}\n.ant-upload-picture-card-wrapper::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-upload-list {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  line-height: 1.3;\n}\n.ant-upload-list::before {\n  display: table;\n  content: '';\n}\n.ant-upload-list::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-upload-list::before {\n  display: table;\n  content: '';\n}\n.ant-upload-list::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.ant-upload-list-item {\n  position: relative;\n  height: 18.2px;\n  margin-top: 8px;\n  font-size: 14px;\n}\n.ant-upload-list-item-name {\n  display: inline-block;\n  width: 100%;\n  padding-left: 22px;\n  overflow: hidden;\n  line-height: 1.3;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-upload-list-item-card-actions {\n  position: absolute;\n  right: 0;\n}\n.ant-upload-list-item-card-actions-btn {\n  opacity: 0;\n}\n.ant-upload-list-item-card-actions-btn.ant-btn-sm {\n  height: 18.2px;\n  line-height: 1;\n  vertical-align: top;\n}\n.ant-upload-list-item-card-actions.picture {\n  top: 22px;\n  line-height: 0;\n}\n.ant-upload-list-item-card-actions-btn:focus,\n.ant-upload-list-item-card-actions.picture .ant-upload-list-item-card-actions-btn {\n  opacity: 1;\n}\n.ant-upload-list-item-card-actions .anticon {\n  color: #595959;\n  transition: all 0.3s;\n}\n.ant-upload-list-item-card-actions:hover .anticon {\n  color: #545454;\n}\n.ant-upload-list-item-info {\n  height: 100%;\n  transition: background-color 0.3s;\n}\n.ant-upload-list-item-info > span {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.ant-upload-list-item-info .anticon-loading .anticon,\n.ant-upload-list-item-info .ant-upload-text-icon .anticon {\n  position: absolute;\n  top: 5px;\n  color: #595959;\n  font-size: 14px;\n}\n.ant-upload-list-item:hover .ant-upload-list-item-info {\n  background-color: #f5f5f5;\n}\n.ant-upload-list-item:hover .ant-upload-list-item-card-actions-btn {\n  opacity: 1;\n}\n.ant-upload-list-item-error,\n.ant-upload-list-item-error .ant-upload-text-icon > .anticon,\n.ant-upload-list-item-error .ant-upload-list-item-name {\n  color: #f5222d;\n}\n.ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {\n  color: #f5222d;\n}\n.ant-upload-list-item-error .ant-upload-list-item-card-actions-btn {\n  opacity: 1;\n}\n.ant-upload-list-item-progress {\n  position: absolute;\n  bottom: -12px;\n  width: 100%;\n  padding-left: 26px;\n  font-size: 14px;\n  line-height: 0;\n}\n.ant-upload-list-picture .ant-upload-list-item,\n.ant-upload-list-picture-card .ant-upload-list-item {\n  position: relative;\n  height: 66px;\n  padding: 8px;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n.ant-upload-list-picture .ant-upload-list-item:hover,\n.ant-upload-list-picture-card .ant-upload-list-item:hover {\n  background: transparent;\n}\n.ant-upload-list-picture .ant-upload-list-item-error,\n.ant-upload-list-picture-card .ant-upload-list-item-error {\n  border-color: #f5222d;\n}\n.ant-upload-list-picture .ant-upload-list-item-info,\n.ant-upload-list-picture-card .ant-upload-list-item-info {\n  padding: 0;\n}\n.ant-upload-list-picture .ant-upload-list-item:hover .ant-upload-list-item-info,\n.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info {\n  background: transparent;\n}\n.ant-upload-list-picture .ant-upload-list-item-uploading,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading {\n  border-style: dashed;\n}\n.ant-upload-list-picture .ant-upload-list-item-thumbnail,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {\n  width: 48px;\n  height: 48px;\n  line-height: 60px;\n  text-align: center;\n  opacity: 0.8;\n}\n.ant-upload-list-picture .ant-upload-list-item-thumbnail .anticon,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail .anticon {\n  font-size: 26px;\n}\n.ant-upload-list-picture .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#e6f7ff'],\n.ant-upload-list-picture-card .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#e6f7ff'] {\n  fill: #fff1f0;\n}\n.ant-upload-list-picture .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#1890ff'],\n.ant-upload-list-picture-card .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#1890ff'] {\n  fill: #f5222d;\n}\n.ant-upload-list-picture .ant-upload-list-item-icon,\n.ant-upload-list-picture-card .ant-upload-list-item-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 26px;\n  transform: translate(-50%, -50%);\n}\n.ant-upload-list-picture .ant-upload-list-item-icon .anticon,\n.ant-upload-list-picture-card .ant-upload-list-item-icon .anticon {\n  font-size: 26px;\n}\n.ant-upload-list-picture .ant-upload-list-item-image,\n.ant-upload-list-picture-card .ant-upload-list-item-image {\n  max-width: 100%;\n}\n.ant-upload-list-picture .ant-upload-list-item-thumbnail img,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {\n  display: block;\n  width: 48px;\n  height: 48px;\n  overflow: hidden;\n}\n.ant-upload-list-picture .ant-upload-list-item-name,\n.ant-upload-list-picture-card .ant-upload-list-item-name {\n  display: inline-block;\n  box-sizing: border-box;\n  max-width: 100%;\n  margin: 0 0 0 8px;\n  padding-right: 8px;\n  padding-left: 48px;\n  overflow: hidden;\n  line-height: 44px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: all 0.3s;\n}\n.ant-upload-list-picture .ant-upload-list-item-uploading .ant-upload-list-item-name,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-name {\n  margin-bottom: 12px;\n}\n.ant-upload-list-picture .ant-upload-list-item-progress,\n.ant-upload-list-picture-card .ant-upload-list-item-progress {\n  bottom: 14px;\n  width: calc(100% - 24px);\n  margin-top: 0;\n  padding-left: 56px;\n}\n.ant-upload-list-picture-card-container {\n  display: inline-block;\n  width: 104px;\n  height: 104px;\n  margin: 0 8px 8px 0;\n  vertical-align: top;\n}\n.ant-upload-list-picture-card .ant-upload-list-item {\n  height: 100%;\n  margin: 0;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info {\n  position: relative;\n  height: 100%;\n  overflow: hidden;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info::before {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  transition: all 0.3s;\n  content: ' ';\n}\n.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info::before {\n  opacity: 1;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-actions {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 10;\n  white-space: nowrap;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.3s;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete {\n  z-index: 10;\n  width: 16px;\n  margin: 0 4px;\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye:hover,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download:hover,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete:hover {\n  color: #fff;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info:hover + .ant-upload-list-item-actions,\n.ant-upload-list-picture-card .ant-upload-list-item-actions:hover {\n  opacity: 1;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {\n  position: static;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-name {\n  display: none;\n  margin: 8px 0 0;\n  padding: 0;\n  line-height: 1.3;\n  text-align: center;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-file + .ant-upload-list-item-name {\n  position: absolute;\n  bottom: 10px;\n  display: block;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading.ant-upload-list-item {\n  background-color: #fafafa;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info {\n  height: auto;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info::before,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-eye,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-delete {\n  display: none;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-progress {\n  bottom: 32px;\n  width: calc(100% - 14px);\n  padding-left: 0;\n}\n.ant-upload-list-text-container,\n.ant-upload-list-picture-container {\n  transition: opacity 0.3s, height 0.3s;\n}\n.ant-upload-list-text-container::before,\n.ant-upload-list-picture-container::before {\n  display: table;\n  width: 0;\n  height: 0;\n  content: '';\n}\n.ant-upload-list-text-container .ant-upload-span,\n.ant-upload-list-picture-container .ant-upload-span {\n  display: block;\n  flex: auto;\n}\n.ant-upload-list-text .ant-upload-span,\n.ant-upload-list-picture .ant-upload-span {\n  display: flex;\n  align-items: center;\n}\n.ant-upload-list-text .ant-upload-span > *,\n.ant-upload-list-picture .ant-upload-span > * {\n  flex: none;\n}\n.ant-upload-list-text .ant-upload-list-item-name,\n.ant-upload-list-picture .ant-upload-list-item-name {\n  flex: auto;\n  margin: 0;\n  padding: 0 8px;\n}\n.ant-upload-list-text .ant-upload-list-item-card-actions,\n.ant-upload-list-picture .ant-upload-list-item-card-actions {\n  position: static;\n}\n.ant-upload-list-text .ant-upload-text-icon .anticon {\n  position: static;\n}\n.ant-upload-list .ant-upload-animate-inline-appear,\n.ant-upload-list .ant-upload-animate-inline-enter,\n.ant-upload-list .ant-upload-animate-inline-leave {\n  animation-duration: 0.3s;\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  animation-fill-mode: forwards;\n}\n.ant-upload-list .ant-upload-animate-inline-appear,\n.ant-upload-list .ant-upload-animate-inline-enter {\n  animation-name: uploadAnimateInlineIn;\n}\n.ant-upload-list .ant-upload-animate-inline-leave {\n  animation-name: uploadAnimateInlineOut;\n}\n@keyframes uploadAnimateInlineIn {\n  from {\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n@keyframes uploadAnimateInlineOut {\n  to {\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n.ant-upload-rtl {\n  direction: rtl;\n}\n.ant-upload-rtl.ant-upload.ant-upload-select-picture-card {\n  margin-right: auto;\n  margin-left: 8px;\n}\n.ant-upload-list-rtl {\n  direction: rtl;\n}\n.ant-upload-list-rtl .ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-1 {\n  padding-right: 22px;\n  padding-left: 14px;\n}\n.ant-upload-list-rtl .ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-2 {\n  padding-right: 22px;\n  padding-left: 28px;\n}\n.ant-upload-list-rtl .ant-upload-list-item-name {\n  padding-right: 22px;\n  padding-left: 0;\n}\n.ant-upload-list-rtl .ant-upload-list-item-name-icon-count-1 {\n  padding-left: 14px;\n}\n.ant-upload-list-rtl .ant-upload-list-item-card-actions {\n  right: auto;\n  left: 0;\n}\n.ant-upload-list-rtl .ant-upload-list-item-card-actions .anticon {\n  padding-right: 0;\n  padding-left: 5px;\n}\n.ant-upload-list-rtl .ant-upload-list-item-info {\n  padding: 0 4px 0 12px;\n}\n.ant-upload-list-rtl .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {\n  padding-right: 0;\n  padding-left: 5px;\n}\n.ant-upload-list-rtl .ant-upload-list-item-progress {\n  padding-right: 26px;\n  padding-left: 0;\n}\n.ant-upload-list-picture .ant-upload-list-item-info,\n.ant-upload-list-picture-card .ant-upload-list-item-info {\n  padding: 0;\n}\n.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-thumbnail,\n.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {\n  right: 8px;\n  left: auto;\n}\n.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-icon,\n.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-icon {\n  right: 50%;\n  left: auto;\n  transform: translate(50%, -50%);\n}\n.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name,\n.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name {\n  margin: 0 8px 0 0;\n  padding-right: 48px;\n  padding-left: 8px;\n}\n.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name-icon-count-1,\n.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-1 {\n  padding-right: 48px;\n  padding-left: 18px;\n}\n.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name-icon-count-2,\n.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-2 {\n  padding-right: 48px;\n  padding-left: 36px;\n}\n.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-progress,\n.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-progress {\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-upload-list-rtl .ant-upload-list-picture-card-container {\n  margin: 0 0 8px 8px;\n}\n.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-actions {\n  right: 50%;\n  left: auto;\n  transform: translate(50%, -50%);\n}\n.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-file + .ant-upload-list-item-name {\n  margin: 8px 0 0;\n  padding: 0;\n}\n/* color classes */\n.gx-bg-primary {\n  background-color: var(--app-primary-color) !important;\n}\na.gx-bg-primary:hover,\na.gx-bg-primary:focus {\n  background-color: var(--app-primary-color) !important;\n}\n.gx-bg-primary-light {\n  background-color: #5a456e !important;\n}\n.gx-bg-secondary {\n  background-color: var(--app-secondary-color) !important;\n}\na.gx-bg-secondary:hover,\na.gx-bg-secondary:focus {\n  background-color: var(--app-secondary-color) !important;\n}\n.gx-bg-success {\n  background-color: #52c41a !important;\n}\na.gx-bg-success:hover,\na.gx-bg-success:focus {\n  background-color: #3f9714 !important;\n}\n.gx-bg-success-dark {\n  background-color: #368011 !important;\n}\na.gx-bg-success-dark:hover,\na.gx-bg-success-dark:focus {\n  background-color: #2c6a0e !important;\n}\n.gx-bg-info {\n  background-color: #1890ff !important;\n}\na.gx-bg-info:hover,\na.gx-bg-info:focus {\n  background-color: #0076e4 !important;\n}\n.gx-bg-warning {\n  background-color: #fa8c16 !important;\n}\na.gx-bg-warning:hover,\na.gx-bg-warning:focus {\n  background-color: #d87205 !important;\n}\n.gx-bg-danger {\n  background-color: #f44336 !important;\n}\na.gx-bg-danger:hover,\na.gx-bg-danger:focus {\n  background-color: #ea1c0d !important;\n}\n.gx-bg-light {\n  background-color: #e8e8e8 !important;\n}\na.gx-bg-light:hover,\na.gx-bg-light:focus {\n  background-color: #d9d9d9 !important;\n}\n.gx-bg-dark {\n  background-color: #000000 !important;\n}\na.gx-bg-dark:hover,\na.gx-bg-dark:focus {\n  background-color: #1a1a1a !important;\n}\n.gx-bg-white {\n  background-color: #ffffff !important;\n}\na.gx-bg-white:hover,\na.gx-bg-white:focus {\n  background-color: #f2f2f2 !important;\n}\n.gx-bg-grey {\n  background-color: #cccccc !important;\n}\na.gx-bg-grey:hover,\na.gx-bg-grey:focus {\n  background-color: #b2b2b2 !important;\n}\n.gx-bg-light-grey {\n  background-color: #fafafa !important;\n}\n.gx-bg-transparent {\n  background-color: transparent !important;\n}\n.gx-bg-pink {\n  background-color: #eb2f96 !important;\n}\na.gx-bg-pink:hover,\na.gx-bg-pink:focus {\n  background-color: #d3147d !important;\n}\n.gx-bg-green {\n  background-color: #52c41a !important;\n}\na.gx-bg-green:hover,\na.gx-bg-green:focus {\n  background-color: #3f9714 !important;\n}\n.gx-bg-green-light {\n  background-color: #caf5b5 !important;\n}\na.gx-bg-green-light:hover,\na.gx-bg-green-light:focus {\n  background-color: #8ae95b !important;\n}\n.gx-bg-red {\n  background-color: #f5222d !important;\n}\na.gx-bg-red:hover,\na.gx-bg-red:focus {\n  background-color: #da0a15 !important;\n}\n.gx-bg-amber {\n  background-color: #fadb14 !important;\n}\na.gx-bg-amber:hover,\na.gx-bg-amber:focus {\n  background-color: #d6ba05 !important;\n}\n.gx-bg-amber-light {\n  background-color: #fdf2aa !important;\n}\na.gx-bg-amber-light:hover,\na.gx-bg-amber-light:focus {\n  background-color: #fcea78 !important;\n}\n.gx-bg-blue {\n  background-color: #1890ff !important;\n}\na.gx-bg-blue:hover,\na.gx-bg-blue:focus {\n  background-color: #0076e4 !important;\n}\n.gx-bg-light-blue {\n  background-color: #329cff !important;\n}\na.gx-bg-light-blue:hover,\na.gx-bg-light-blue:focus {\n  background-color: #4ba9ff !important;\n}\n.gx-bg-indigo {\n  background-color: #3c1991 !important;\n}\na.gx-bg-indigo:hover,\na.gx-bg-indigo:focus {\n  background-color: #2a1166 !important;\n}\n.gx-bg-purple {\n  background-color: #722ed1 !important;\n}\na.gx-bg-purple:hover,\na.gx-bg-purple:focus {\n  background-color: #5b25a7 !important;\n}\n.gx-bg-orange {\n  background-color: #fa8c16 !important;\n}\na.gx-bg-orange:hover,\na.gx-bg-orange:focus {\n  background-color: #d87205 !important;\n}\n.gx-bg-yellow {\n  background-color: #fadb14 !important;\n}\na.gx-bg-yellow:hover,\na.gx-bg-yellow:focus {\n  background-color: #d6ba05 !important;\n}\n.gx-bg-teal {\n  background-color: #20c997 !important;\n}\na.gx-bg-teal:hover,\na.gx-bg-teal:focus {\n  background-color: #199d76 !important;\n}\n.gx-bg-cyan {\n  background-color: #13c2c2 !important;\n}\na.gx-bg-cyan:hover,\na.gx-bg-cyan:focus {\n  background-color: #0e9494 !important;\n}\n.gx-bg-sepia {\n  background-color: #7c3535 !important;\n}\na.gx-bg-sepia:hover,\na.gx-bg-sepia:focus {\n  background-color: #582626 !important;\n}\n.gx-bg-geekblue {\n  background-color: #030852 !important;\n}\na.gx-bg-geekblue:hover,\na.gx-bg-geekblue:focus {\n  background-color: #010321 !important;\n}\n.gx-text-white {\n  color: #ffffff !important;\n}\n.gx-text-primary {\n  color: var(--app-primary-color) !important;\n}\na.gx-text-primary:hover,\na.gx-text-primary:focus {\n  color: var(--app-primary-color) !important;\n}\n.gx-text-secondary {\n  color: var(--app-secondary-color) !important;\n}\na.gx-text-secondary:hover,\na.gx-text-secondary:focus {\n  color: var(--app-secondary-color) !important;\n}\n.gx-text-success {\n  color: #52c41a !important;\n}\na.gx-text-success:hover,\na.gx-text-success:focus {\n  color: #49ad17 !important;\n}\n.gx-text-success-dark {\n  color: #368011 !important;\n}\na.gx-text-success-dark:hover,\na.gx-text-success-dark:focus {\n  color: #2c6a0e !important;\n}\n.gx-text-info {\n  color: #1890ff !important;\n}\na.gx-text-info:hover,\na.gx-text-info:focus {\n  color: #0084fe !important;\n}\n.gx-text-warning {\n  color: #fa8c16 !important;\n}\na.gx-text-warning:hover,\na.gx-text-warning:focus {\n  color: #f17f05 !important;\n}\n.gx-text-danger {\n  color: #f44336 !important;\n}\na.gx-text-danger:hover,\na.gx-text-danger:focus {\n  color: #f32c1e !important;\n}\n.gx-text-light {\n  color: #ababab !important;\n}\na.gx-text-light:hover,\na.gx-text-light:focus {\n  color: #787878 !important;\n}\n.gx-text-light-grey {\n  color: #cccccc !important;\n}\na.gx-text-light-grey:hover,\na.gx-text-light-grey:focus {\n  color: #bfbfbf !important;\n}\n.gx-text-grey {\n  color: #8c8c8c !important;\n}\na.gx-text-grey:hover,\na.gx-text-grey:focus {\n  color: #262626 !important;\n}\n.gx-text-dark {\n  color: #595959 !important;\n}\na.gx-text-dark:hover,\na.gx-text-dark:focus {\n  color: #4c4c4c !important;\n}\n.gx-text-black {\n  color: #000000 !important;\n}\na.gx-text-black:hover,\na.gx-text-black:focus {\n  color: #4c4c4c !important;\n}\n.gx-text-pink {\n  color: #eb2f96 !important;\n}\na.gx-text-pink:hover,\na.gx-text-pink:focus {\n  color: #e9188a !important;\n}\n.gx-text-green {\n  color: #52c41a !important;\n}\na.gx-text-green:hover,\na.gx-text-green:focus {\n  color: #49ad17 !important;\n}\n.gx-text-red {\n  color: #f5222d !important;\n}\na.gx-text-red:hover,\na.gx-text-red:focus {\n  color: #f30b17 !important;\n}\n.gx-text-amber {\n  color: #fadb14 !important;\n}\na.gx-text-amber:hover,\na.gx-text-amber:focus {\n  color: #efd005 !important;\n}\n.gx-text-blue {\n  color: #1890ff !important;\n}\na.gx-text-blue:hover,\na.gx-text-blue:focus {\n  color: #0084fe !important;\n}\n.gx-text-indigo {\n  color: #3c1991 !important;\n}\na.gx-text-indigo:hover,\na.gx-text-indigo:focus {\n  color: #33157b !important;\n}\n.gx-text-purple {\n  color: #722ed1 !important;\n}\na.gx-text-purple:hover,\na.gx-text-purple:focus {\n  color: #6729bc !important;\n}\n.gx-text-orange {\n  color: #fa8c16 !important;\n}\na.gx-text-orange:hover,\na.gx-text-orange:focus {\n  color: #f17f05 !important;\n}\n.gx-text-yellow {\n  color: #fadb14 !important;\n}\na.gx-text-yellow:hover,\na.gx-text-yellow:focus {\n  color: #efd005 !important;\n}\n.gx-text-teal {\n  color: #20c997 !important;\n}\na.gx-text-teal:hover,\na.gx-text-teal:focus {\n  color: #1cb386 !important;\n}\n.gx-text-cyan {\n  color: #13c2c2 !important;\n}\na.gx-text-cyan:hover,\na.gx-text-cyan:focus {\n  color: #11abab !important;\n}\n.gx-text-muted {\n  color: #8c8c8c !important;\n}\n.gx-text-geekblue {\n  color: #030852 !important;\n}\na.gx-text-geekblue:hover,\na.gx-text-geekblue:focus {\n  color: #10239e !important;\n}\n.gx-text-sepia {\n  color: #7c3535 !important;\n}\na.gx-text-sepia:hover,\na.gx-text-sepia:focus {\n  color: #7c3535 !important;\n}\n.gx-icon-white {\n  color: #ffffff !important;\n}\n.gx-border-primary {\n  border-color: var(--app-primary-color) !important;\n}\n.gx-border-secondary {\n  border-color: var(--app-secondary-color) !important;\n}\n.gx-border-success {\n  border-color: #52c41a !important;\n}\n.gx-border-success-dark {\n  border-color: #368011 !important;\n}\n.gx-border-info {\n  border-color: #1890ff !important;\n}\n.gx-border-warning {\n  border-color: #fa8c16 !important;\n}\n.gx-border-danger {\n  border-color: #f44336 !important;\n}\n.gx-border-light {\n  border-color: #bfbfbf !important;\n}\n.gx-border-dark {\n  border-color: #595959 !important;\n}\n.gx-border-white {\n  border-color: #ffffff !important;\n}\n.gx-border-grey {\n  border-color: #bfbfbf !important;\n}\n.gx-border-pink {\n  border-color: #eb2f96 !important;\n}\n.gx-border-green {\n  border-color: #52c41a !important;\n}\n.gx-border-red {\n  border-color: #f5222d !important;\n}\n.gx-border-amber {\n  border-color: #fadb14 !important;\n}\n.gx-border-blue {\n  border-color: #1890ff !important;\n}\n.gx-border-indigo {\n  border-color: #3c1991 !important;\n}\n.gx-border-purple {\n  border-color: #722ed1 !important;\n}\n.gx-border-orange {\n  border-color: #fa8c16 !important;\n}\n.gx-border-yellow {\n  border-color: #fadb14 !important;\n}\n.gx-border-teal {\n  border-color: #1890ff !important;\n}\n.gx-border-cyan {\n  border-color: #13c2c2 !important;\n}\n.gx-border-sepia {\n  border-color: #7c3535 !important;\n}\n.gx-border-geekblue {\n  border-color: #030852 !important;\n}\n.gx-btn-primary,\na.gx-btn-primary,\n.btn-primary {\n  color: #ffffff !important;\n  background-color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n}\n.gx-btn-primary:hover,\na.gx-btn-primary:hover,\n.btn-primary:hover,\n.gx-btn-primary:focus,\na.gx-btn-primary:focus,\n.btn-primary:focus {\n  color: #ffffff !important;\n  background-color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n}\n.gx-btn-primary.disabled,\na.gx-btn-primary.disabled,\n.btn-primary.disabled,\n.gx-btn-primary:disabled,\na.gx-btn-primary:disabled,\n.btn-primary:disabled {\n  background-color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n}\n.gx-btn-primary:not([disabled]):not(.disabled):active,\na.gx-btn-primary:not([disabled]):not(.disabled):active,\n.btn-primary:not([disabled]):not(.disabled):active,\n.gx-btn-primary:not([disabled]):not(.disabled).active,\na.gx-btn-primary:not([disabled]):not(.disabled).active,\n.btn-primary:not([disabled]):not(.disabled).active {\n  color: #ffffff;\n  background-color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n}\n.gx-btn-primary-light,\na.gx-btn-primary-light,\n.btn-primary-light {\n  color: #595959 !important;\n}\n.gx-btn-primary-light:hover,\na.gx-btn-primary-light:hover,\n.btn-primary-light:hover,\n.gx-btn-primary-light:focus,\na.gx-btn-primary-light:focus,\n.btn-primary-light:focus {\n  color: #595959 !important;\n}\n.gx-btn-primary-light:not([disabled]):not(.disabled):active,\na.gx-btn-primary-light:not([disabled]):not(.disabled):active,\n.btn-primary-light:not([disabled]):not(.disabled):active,\n.gx-btn-primary-light:not([disabled]):not(.disabled).active,\na.gx-btn-primary-light:not([disabled]):not(.disabled).active,\n.btn-primary-light:not([disabled]):not(.disabled).active {\n  color: #595959;\n}\n.gx-btn-secondary,\na.gx-btn-secondary {\n  color: #ffffff !important;\n  background-color: var(--app-secondary-color) !important;\n  border-color: var(--app-secondary-color) !important;\n}\n.gx-btn-secondary:hover,\na.gx-btn-secondary:hover,\n.gx-btn-secondary:focus,\na.gx-btn-secondary:focus {\n  color: #ffffff;\n  background-color: var(--app-secondary-color) !important;\n  border-color: var(--app-secondary-color) !important;\n}\n.gx-btn-secondary.disabled,\na.gx-btn-secondary.disabled,\n.gx-btn-secondary:disabled,\na.gx-btn-secondary:disabled {\n  background-color: var(--app-secondary-color) !important;\n  border-color: var(--app-secondary-color) !important;\n}\n.gx-btn-secondary:not([disabled]):not(.disabled):active,\na.gx-btn-secondary:not([disabled]):not(.disabled):active,\n.gx-btn-secondary:not([disabled]):not(.disabled).active,\na.gx-btn-secondary:not([disabled]):not(.disabled).active {\n  color: #ffffff;\n  background-color: var(--app-secondary-color) !important;\n  border-color: var(--app-secondary-color) !important;\n}\n.gx-btn-success,\na.gx-btn-success {\n  color: #ffffff !important;\n  background-color: #52c41a !important;\n  border-color: #52c41a !important;\n}\n.gx-btn-success:hover,\na.gx-btn-success:hover,\n.gx-btn-success:focus,\na.gx-btn-success:focus {\n  color: #ffffff !important;\n  background-color: #3f9714 !important;\n  border-color: #3f9714 !important;\n}\n.gx-btn-success.disabled,\na.gx-btn-success.disabled,\n.gx-btn-success:disabled,\na.gx-btn-success:disabled {\n  background-color: #52c41a !important;\n  border-color: #52c41a !important;\n}\n.gx-btn-success:not([disabled]):not(.disabled):active,\na.gx-btn-success:not([disabled]):not(.disabled):active,\n.gx-btn-success:not([disabled]):not(.disabled).active,\na.gx-btn-success:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #3f9714 !important;\n  border-color: #3f9714 !important;\n}\n.gx-btn-success-dark,\na.gx-btn-success-dark {\n  color: #ffffff !important;\n  background-color: #368011 !important;\n  border-color: #368011 !important;\n}\n.gx-btn-success-dark:hover,\na.gx-btn-success-dark:hover,\n.gx-btn-success-dark:focus,\na.gx-btn-success-dark:focus {\n  color: #ffffff !important;\n  background-color: #2c6a0e !important;\n  border-color: #2c6a0e !important;\n}\n.gx-btn-success-dark.disabled,\na.gx-btn-success-dark.disabled,\n.gx-btn-success-dark:disabled,\na.gx-btn-success-dark:disabled {\n  background-color: #52c41a !important;\n  border-color: #52c41a !important;\n}\n.gx-btn-success-dark:not([disabled]):not(.disabled):active,\na.gx-btn-success-dark:not([disabled]):not(.disabled):active,\n.gx-btn-success-dark:not([disabled]):not(.disabled).active,\na.gx-btn-success-dark:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #2c6a0e !important;\n  border-color: #2c6a0e !important;\n}\n.gx-btn-info,\na.gx-btn-info {\n  color: #ffffff !important;\n  background-color: #1890ff !important;\n  border-color: #1890ff !important;\n}\n.gx-btn-info:hover,\na.gx-btn-info:hover,\n.gx-btn-info:focus,\na.gx-btn-info:focus {\n  color: #ffffff !important;\n  background-color: #0076e4 !important;\n  border-color: #0076e4 !important;\n}\n.gx-btn-info.disabled,\na.gx-btn-info.disabled,\n.gx-btn-info:disabled,\na.gx-btn-info:disabled {\n  background-color: #1890ff !important;\n  border-color: #1890ff !important;\n}\n.gx-btn-info:not([disabled]):not(.disabled):active,\na.gx-btn-info:not([disabled]):not(.disabled):active,\n.gx-btn-info:not([disabled]):not(.disabled).active,\na.gx-btn-info:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #0076e4 !important;\n  border-color: #0076e4 !important;\n}\n.gx-btn-warning,\na.gx-btn-warning {\n  color: #ffffff !important;\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-warning:hover,\na.gx-btn-warning:hover,\n.gx-btn-warning:focus,\na.gx-btn-warning:focus {\n  color: #ffffff !important;\n  background-color: #d87205 !important;\n  border-color: #d87205 !important;\n}\n.gx-btn-warning.disabled,\na.gx-btn-warning.disabled,\n.gx-btn-warning:disabled,\na.gx-btn-warning:disabled {\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-warning:not([disabled]):not(.disabled):active,\na.gx-btn-warning:not([disabled]):not(.disabled):active,\n.gx-btn-warning:not([disabled]):not(.disabled).active,\na.gx-btn-warning:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #d87205 !important;\n  border-color: #d87205 !important;\n}\n.gx-btn-yellow,\na.gx-btn-yellow {\n  color: #262626 !important;\n  background-color: #fadb14 !important;\n  border-color: #fadb14 !important;\n}\n.gx-btn-yellow:hover,\na.gx-btn-yellow:hover,\n.gx-btn-yellow:focus,\na.gx-btn-yellow:focus {\n  color: #ffffff !important;\n  background-color: #d6ba05 !important;\n  border-color: #d6ba05 !important;\n}\n.gx-btn-yellow.disabled,\na.gx-btn-yellow.disabled,\n.gx-btn-yellow:disabled,\na.gx-btn-yellow:disabled {\n  background-color: #fadb14 !important;\n  border-color: #fadb14 !important;\n}\n.gx-btn-yellow:not([disabled]):not(.disabled):active,\na.gx-btn-yellow:not([disabled]):not(.disabled):active,\n.gx-btn-yellow:not([disabled]):not(.disabled).active,\na.gx-btn-yellow:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #d6ba05 !important;\n  border-color: #d6ba05 !important;\n}\n.gx-btn-danger,\na.gx-btn-danger,\n.gx-btn-red,\na.gx-btn-red {\n  color: #ffffff !important;\n  background-color: #f44336 !important;\n  border-color: #f44336 !important;\n}\n.gx-btn-danger:hover,\na.gx-btn-danger:hover,\n.gx-btn-red:hover,\na.gx-btn-red:hover,\n.gx-btn-danger:focus,\na.gx-btn-danger:focus,\n.gx-btn-red:focus,\na.gx-btn-red:focus {\n  color: #ffffff !important;\n  background-color: #ea1c0d !important;\n  border-color: #ea1c0d !important;\n}\n.gx-btn-danger.disabled,\na.gx-btn-danger.disabled,\n.gx-btn-red.disabled,\na.gx-btn-red.disabled,\n.gx-btn-danger:disabled,\na.gx-btn-danger:disabled,\n.gx-btn-red:disabled,\na.gx-btn-red:disabled {\n  background-color: #f44336 !important;\n  border-color: #f44336 !important;\n}\n.gx-btn-danger:not([disabled]):not(.disabled):active,\na.gx-btn-danger:not([disabled]):not(.disabled):active,\n.gx-btn-red:not([disabled]):not(.disabled):active,\na.gx-btn-red:not([disabled]):not(.disabled):active,\n.gx-btn-danger:not([disabled]):not(.disabled).active,\na.gx-btn-danger:not([disabled]):not(.disabled).active,\n.gx-btn-red:not([disabled]):not(.disabled).active,\na.gx-btn-red:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #ea1c0d !important;\n  border-color: #ea1c0d !important;\n}\n.gx-btn-light,\na.gx-btn-light {\n  color: #8c8c8c !important;\n  background-color: #e8e8e8 !important;\n  border-color: #e8e8e8 !important;\n}\n.gx-btn-light:hover,\na.gx-btn-light:hover,\n.gx-btn-light:focus,\na.gx-btn-light:focus {\n  color: #8c8c8c !important;\n  background-color: #d9d9d9 !important;\n  border-color: #d9d9d9 !important;\n}\n.gx-btn-light.disabled,\na.gx-btn-light.disabled,\n.gx-btn-light:disabled,\na.gx-btn-light:disabled {\n  background-color: #f5f5f5 !important;\n  border-color: #f5f5f5 !important;\n}\n.gx-btn-light:not([disabled]):not(.disabled):active,\na.gx-btn-light:not([disabled]):not(.disabled):active,\n.gx-btn-light:not([disabled]):not(.disabled).active,\na.gx-btn-light:not([disabled]):not(.disabled).active {\n  color: #262626 !important;\n  background-color: #e8e8e8 !important;\n  border-color: #e8e8e8 !important;\n}\n.gx-btn-dark,\na.gx-btn-dark {\n  color: #ffffff !important;\n  background-color: #262626 !important;\n  border-color: #262626 !important;\n}\n.gx-btn-dark:hover,\na.gx-btn-dark:hover,\n.gx-btn-dark:focus,\na.gx-btn-dark:focus {\n  color: #ffffff !important;\n  background-color: #0c0c0c !important;\n  border-color: #0c0c0c !important;\n}\n.gx-btn-dark.disabled,\na.gx-btn-dark.disabled,\n.gx-btn-dark:disabled,\na.gx-btn-dark:disabled {\n  background-color: #262626 !important;\n  border-color: #262626 !important;\n}\n.gx-btn-dark:not([disabled]):not(.disabled):active,\na.gx-btn-dark:not([disabled]):not(.disabled):active,\n.gx-btn-dark:not([disabled]):not(.disabled).active,\na.gx-btn-dark:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #0c0c0c !important;\n  border-color: #0c0c0c !important;\n}\n.gx-btn-purple,\na.gx-btn-purple {\n  color: #ffffff !important;\n  background-color: #722ed1 !important;\n  border-color: #722ed1 !important;\n}\n.gx-btn-purple:hover,\na.gx-btn-purple:hover,\n.gx-btn-purple:focus,\na.gx-btn-purple:focus {\n  color: #ffffff !important;\n  background-color: #5b25a7 !important;\n  border-color: #5b25a7 !important;\n}\n.gx-btn-purple.disabled,\na.gx-btn-purple.disabled,\n.gx-btn-purple:disabled,\na.gx-btn-purple:disabled {\n  background-color: #722ed1 !important;\n  border-color: #722ed1 !important;\n}\n.gx-btn-purple:not([disabled]):not(.disabled):active,\na.gx-btn-purple:not([disabled]):not(.disabled):active,\n.gx-btn-purple:not([disabled]):not(.disabled).active,\na.gx-btn-purple:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #5b25a7 !important;\n  border-color: #5b25a7 !important;\n}\n.gx-btn-sepia,\na.gx-btn-sepia {\n  color: #ffffff !important;\n  background-color: #7c3535 !important;\n  border-color: #7c3535 !important;\n}\n.gx-btn-sepia:hover,\na.gx-btn-sepia:hover,\n.gx-btn-sepia:focus,\na.gx-btn-sepia:focus {\n  color: #ffffff !important;\n  background-color: #461e1e !important;\n  border-color: #461e1e !important;\n}\n.gx-btn-sepia.disabled,\na.gx-btn-sepia.disabled,\n.gx-btn-sepia:disabled,\na.gx-btn-sepia:disabled {\n  background-color: #7c3535 !important;\n  border-color: #7c3535 !important;\n}\n.gx-btn-sepia:not([disabled]):not(.disabled):active,\na.gx-btn-sepia:not([disabled]):not(.disabled):active,\n.gx-btn-sepia:not([disabled]):not(.disabled).active,\na.gx-btn-sepia:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #461e1e !important;\n  border-color: #461e1e !important;\n}\n.gx-btn-geekblue,\na.gx-btn-geekblue {\n  color: #ffffff !important;\n  background-color: #10239e !important;\n  border-color: #10239e !important;\n}\n.gx-btn-geekblue:hover,\na.gx-btn-geekblue:hover,\n.gx-btn-geekblue:focus,\na.gx-btn-geekblue:focus {\n  color: #ffffff !important;\n  background-color: #0b1970 !important;\n  border-color: #0b1970 !important;\n}\n.gx-btn-geekblue.disabled,\na.gx-btn-geekblue.disabled,\n.gx-btn-geekblue:disabled,\na.gx-btn-geekblue:disabled {\n  background-color: #10239e !important;\n  border-color: #10239e !important;\n}\n.gx-btn-geekblue:not([disabled]):not(.disabled):active,\na.gx-btn-geekblue:not([disabled]):not(.disabled):active,\n.gx-btn-geekblue:not([disabled]):not(.disabled).active,\na.gx-btn-geekblue:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #091459 !important;\n  border-color: #091459 !important;\n}\n.gx-btn-cyan,\na.gx-btn-cyan {\n  color: #ffffff !important;\n  background-color: #13c2c2 !important;\n  border-color: #13c2c2 !important;\n}\n.gx-btn-cyan:hover,\na.gx-btn-cyan:hover,\n.gx-btn-cyan:focus,\na.gx-btn-cyan:focus {\n  color: #ffffff !important;\n  background-color: #0e9494 !important;\n  border-color: #0e9494 !important;\n}\n.gx-btn-cyan.disabled,\na.gx-btn-cyan.disabled,\n.gx-btn-cyan:disabled,\na.gx-btn-cyan:disabled {\n  background-color: #13c2c2 !important;\n  border-color: #13c2c2 !important;\n}\n.gx-btn-cyan:not([disabled]):not(.disabled):active,\na.gx-btn-cyan:not([disabled]):not(.disabled):active,\n.gx-btn-cyan:not([disabled]):not(.disabled).active,\na.gx-btn-cyan:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #0e8a8a !important;\n  border-color: #0e8a8a !important;\n}\n.gx-btn-white,\na.gx-btn-white {\n  color: #545454 !important;\n  background-color: #ffffff !important;\n  border-color: #ffffff !important;\n}\n.gx-btn-white:hover,\na.gx-btn-white:hover,\n.gx-btn-white:focus,\na.gx-btn-white:focus {\n  color: #545454 !important;\n  background-color: #e6e6e6 !important;\n  border-color: #e6e6e6 !important;\n}\n.gx-btn-white.disabled,\na.gx-btn-white.disabled,\n.gx-btn-white:disabled,\na.gx-btn-white:disabled {\n  background-color: #ffffff !important;\n  border-color: #ffffff !important;\n}\n.gx-btn-white:not([disabled]):not(.disabled):active,\na.gx-btn-white:not([disabled]):not(.disabled):active,\n.gx-btn-white:not([disabled]):not(.disabled).active,\na.gx-btn-white:not([disabled]):not(.disabled).active {\n  color: #545454 !important;\n  background-color: #e6e6e6 !important;\n  border-color: #e6e6e6 !important;\n}\n.gx-btn-orange,\na.gx-btn-orange {\n  color: #ffffff !important;\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-orange:hover,\na.gx-btn-orange:hover,\n.gx-btn-orange:focus,\na.gx-btn-orange:focus {\n  color: #ffffff !important;\n  background-color: #d87205 !important;\n  border-color: #d87205 !important;\n}\n.gx-btn-orange.disabled,\na.gx-btn-orange.disabled,\n.gx-btn-orange:disabled,\na.gx-btn-orange:disabled {\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-orange:not([disabled]):not(.disabled):active,\na.gx-btn-orange:not([disabled]):not(.disabled):active,\n.gx-btn-orange:not([disabled]):not(.disabled).active,\na.gx-btn-orange:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #ce6d04 !important;\n  border-color: #ce6d04 !important;\n}\n.gx-btn-outline-primary,\na.gx-btn-outline-primary {\n  color: var(--app-primary-color) !important;\n  background-color: transparent !important;\n  border-color: var(--app-primary-color) !important;\n}\n.gx-btn-outline-primary:hover,\na.gx-btn-outline-primary:hover,\n.gx-btn-outline-primary:focus,\na.gx-btn-outline-primary:focus {\n  color: #ffffff !important;\n  background-color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n}\n.gx-btn-outline-primary.disabled,\na.gx-btn-outline-primary.disabled,\n.gx-btn-outline-primary:disabled,\na.gx-btn-outline-primary:disabled {\n  color: var(--app-primary-color) !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-secondary,\na.gx-btn-outline-secondary {\n  color: var(--app-secondary-color) !important;\n  background-color: transparent !important;\n  border-color: var(--app-secondary-color) !important;\n}\n.gx-btn-outline-secondary:hover,\na.gx-btn-outline-secondary:hover,\n.gx-btn-outline-secondary:focus,\na.gx-btn-outline-secondary:focus {\n  color: #ffffff !important;\n  background-color: var(--app-secondary-color) !important;\n  border-color: var(--app-secondary-color) !important;\n}\n.gx-btn-outline-secondary.disabled,\na.gx-btn-outline-secondary.disabled,\n.gx-btn-outline-secondary:disabled,\na.gx-btn-outline-secondary:disabled {\n  color: var(--app-secondary-color) !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-success,\na.gx-btn-outline-success {\n  color: #52c41a !important;\n  background-color: transparent !important;\n  border-color: #52c41a !important;\n}\n.gx-btn-outline-success:hover,\na.gx-btn-outline-success:hover,\n.gx-btn-outline-success:focus,\na.gx-btn-outline-success:focus {\n  color: #ffffff !important;\n  background-color: #52c41a !important;\n  border-color: #52c41a !important;\n}\n.gx-btn-outline-success.disabled,\na.gx-btn-outline-success.disabled,\n.gx-btn-outline-success:disabled,\na.gx-btn-outline-success:disabled {\n  color: #52c41a !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-success-dark,\na.gx-btn-outline-success-dark {\n  color: #52c41a !important;\n  background-color: transparent !important;\n  border-color: #368011 !important;\n}\n.gx-btn-outline-success-dark:hover,\na.gx-btn-outline-success-dark:hover,\n.gx-btn-outline-success-dark:focus,\na.gx-btn-outline-success-dark:focus {\n  color: #ffffff !important;\n  background-color: #2c6a0e !important;\n  border-color: #2c6a0e !important;\n}\n.gx-btn-outline-success-dark.disabled,\na.gx-btn-outline-success-dark.disabled,\n.gx-btn-outline-success-dark:disabled,\na.gx-btn-outline-success-dark:disabled {\n  color: #2c6a0e !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-info,\na.gx-btn-outline-info {\n  color: #1890ff !important;\n  background-color: transparent !important;\n  border-color: #1890ff !important;\n}\n.gx-btn-outline-info:hover,\na.gx-btn-outline-info:hover,\n.gx-btn-outline-info:focus,\na.gx-btn-outline-info:focus {\n  color: #ffffff !important;\n  background-color: #1890ff !important;\n  border-color: #1890ff !important;\n}\n.gx-btn-outline-info.disabled,\na.gx-btn-outline-info.disabled,\n.gx-btn-outline-info:disabled,\na.gx-btn-outline-info:disabled {\n  color: #1890ff !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-warning,\na.gx-btn-outline-warning {\n  color: #fa8c16 !important;\n  background-color: transparent !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-outline-warning:hover,\na.gx-btn-outline-warning:hover,\n.gx-btn-outline-warning:focus,\na.gx-btn-outline-warning:focus {\n  color: #262626 !important;\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-outline-warning.disabled,\na.gx-btn-outline-warning.disabled,\n.gx-btn-outline-warning:disabled,\na.gx-btn-outline-warning:disabled {\n  color: #fa8c16 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-danger,\na.gx-btn-outline-danger,\n.gx-btn-outline-red,\na.gx-btn-outline-red {\n  color: #f44336 !important;\n  background-color: transparent !important;\n  border-color: #f44336 !important;\n}\n.gx-btn-outline-danger:hover,\na.gx-btn-outline-danger:hover,\n.gx-btn-outline-red:hover,\na.gx-btn-outline-red:hover,\n.gx-btn-outline-danger:focus,\na.gx-btn-outline-danger:focus,\n.gx-btn-outline-red:focus,\na.gx-btn-outline-red:focus {\n  color: #ffffff !important;\n  background-color: #f44336 !important;\n  border-color: #f44336 !important;\n}\n.gx-btn-outline-danger.disabled,\na.gx-btn-outline-danger.disabled,\n.gx-btn-outline-red.disabled,\na.gx-btn-outline-red.disabled,\n.gx-btn-outline-danger:disabled,\na.gx-btn-outline-danger:disabled,\n.gx-btn-outline-red:disabled,\na.gx-btn-outline-red:disabled {\n  color: #f44336 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-light,\na.gx-btn-outline-light {\n  color: #8c8c8c !important;\n  background-color: transparent !important;\n  border-color: #d9d9d9 !important;\n}\n.gx-btn-outline-light:hover,\na.gx-btn-outline-light:hover,\n.gx-btn-outline-light:focus,\na.gx-btn-outline-light:focus {\n  color: #8c8c8c !important;\n  background-color: #d9d9d9 !important;\n  border-color: #d9d9d9 !important;\n}\n.gx-btn-outline-light.disabled,\na.gx-btn-outline-light.disabled,\n.gx-btn-outline-light:disabled,\na.gx-btn-outline-light:disabled {\n  color: #e8e8e8 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-dark,\na.gx-btn-outline-dark {\n  color: #262626 !important;\n  background-color: transparent !important;\n  border-color: #262626 !important;\n}\n.gx-btn-outline-dark:hover,\na.gx-btn-outline-dark:hover,\n.gx-btn-outline-dark:focus,\na.gx-btn-outline-dark:focus {\n  color: #ffffff !important;\n  background-color: #262626 !important;\n  border-color: #262626 !important;\n}\n.gx-btn-outline-dark.disabled,\na.gx-btn-outline-dark.disabled,\n.gx-btn-outline-dark:disabled,\na.gx-btn-outline-dark:disabled {\n  color: #262626 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-sepia,\na.gx-btn-outline-sepia {\n  color: #ffffff !important;\n  background-color: transparent !important;\n  border-color: #7c3535 !important;\n}\n.gx-btn-outline-sepia:hover,\na.gx-btn-outline-sepia:hover,\n.gx-btn-outline-sepia:focus,\na.gx-btn-outline-sepia:focus {\n  color: #ffffff !important;\n  background-color: #7c3535 !important;\n  border-color: #7c3535 !important;\n}\n.gx-btn-outline-sepia.disabled,\na.gx-btn-outline-sepia.disabled,\n.gx-btn-outline-sepia:disabled,\na.gx-btn-outline-sepia:disabled {\n  color: #7c3535 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-geekblue,\na.gx-btn-outline-geekblue {\n  color: #ffffff !important;\n  background-color: transparent !important;\n  border-color: #030852 !important;\n}\n.gx-btn-outline-geekblue:hover,\na.gx-btn-outline-geekblue:hover,\n.gx-btn-outline-geekblue:focus,\na.gx-btn-outline-geekblue:focus {\n  color: #ffffff !important;\n  background-color: #030852 !important;\n  border-color: #030852 !important;\n}\n.gx-btn-outline-geekblue.disabled,\na.gx-btn-outline-geekblue.disabled,\n.gx-btn-outline-geekblue:disabled,\na.gx-btn-outline-geekblue:disabled {\n  color: #2f54eb !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-orange,\na.gx-btn-outline-orange {\n  color: #ffffff !important;\n  background-color: transparent !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-outline-orange:hover,\na.gx-btn-outline-orange:hover,\n.gx-btn-outline-orange:focus,\na.gx-btn-outline-orange:focus {\n  color: #ffffff !important;\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-outline-orange.disabled,\na.gx-btn-outline-orange.disabled,\n.gx-btn-outline-orange:disabled,\na.gx-btn-outline-orange:disabled {\n  color: #fa8c16 !important;\n  background-color: transparent !important;\n}\n.gx-badge-primary {\n  background-color: var(--app-primary-color) !important;\n}\n.gx-badge-primary-light {\n  background-color: #5a456e !important;\n}\n.gx-badge-secondary {\n  background-color: var(--app-secondary-color) !important;\n}\n.gx-badge-success {\n  background-color: #52c41a !important;\n}\n.gx-badge-success-dark {\n  background-color: #368011 !important;\n}\n.gx-badge-info {\n  background-color: #1890ff !important;\n}\n.gx-badge-warning {\n  background-color: #fa8c16 !important;\n}\n.gx-badge-danger {\n  background-color: #f44336 !important;\n}\n.gx-badge-light {\n  background-color: #e8e8e8 !important;\n}\n.gx-badge-dark {\n  background-color: #000000 !important;\n}\n.gx-badge-white {\n  background-color: #ffffff !important;\n}\n.gx-badge-grey {\n  background-color: #bfbfbf !important;\n}\n.gx-badge-light-grey {\n  background-color: #d9d9d9 !important;\n}\n.gx-badge-pink {\n  background-color: #eb2f96 !important;\n}\n.gx-badge-green {\n  background-color: #52c41a !important;\n}\n.gx-badge-green-light {\n  background-color: #caf5b5 !important;\n}\n.gx-badge-red {\n  background-color: #f5222d !important;\n}\n.gx-badge-amber {\n  background-color: #fadb14 !important;\n}\n.gx-badge-amber-light {\n  background-color: #fdf2aa !important;\n}\n.gx-badge-blue {\n  background-color: #1890ff !important;\n}\n.gx-badge-light-blue {\n  background-color: #329cff !important;\n}\n.gx-badge-indigo {\n  background-color: #3c1991 !important;\n}\n.gx-badge-purple {\n  background-color: #722ed1 !important;\n}\n.gx-badge-orange {\n  background-color: #fa8c16 !important;\n}\n.gx-badge-yellow {\n  background-color: #fadb14 !important;\n}\n.gx-badge-teal {\n  background-color: #20c997 !important;\n}\n.gx-badge-cyan {\n  background-color: #13c2c2 !important;\n}\n.gx-badge-sepia {\n  background-color: #7c3535 !important;\n}\n.gx-badge-geekblue {\n  background-color: #030852 !important;\n}\n/* Ripple magic */\n.gx-ripple-effect {\n  position: relative;\n  overflow: hidden;\n}\n.gx-ripple-effect:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 5px;\n  height: 5px;\n  background: rgba(255, 255, 255, 0.5);\n  opacity: 0;\n  -webkit-border-radius: 100%;\n  -moz-border-radius: 100%;\n  border-radius: 100%;\n  transform: scale(1, 1) translate(-50%);\n  transform-origin: 50% 50%;\n}\n.gx-ripple-effect:hover:after {\n  animation: ripple 1s ease-out;\n}\n@keyframes ripple {\n  0% {\n    transform: scale(0, 0);\n    opacity: 0.5;\n  }\n  20% {\n    transform: scale(60, 60);\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(100, 100);\n  }\n}\n@-webkit-keyframes ripple {\n  0% {\n    transform: scale(0, 0);\n    opacity: 0.5;\n  }\n  20% {\n    transform: scale(60, 60);\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(100, 100);\n  }\n}\n.gx-pulse-effect {\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);\n  box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);\n  animation: pulse 2s infinite;\n}\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);\n  }\n}\n@keyframes pulse {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);\n    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);\n    box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);\n    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);\n  }\n}\n.gx-online-effect {\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  animation: online 2s infinite;\n}\n@-webkit-keyframes online {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);\n  }\n}\n@keyframes online {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);\n    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);\n    box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);\n    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);\n  }\n}\n.gx-away-effect {\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  animation: away 2s infinite;\n}\n@-webkit-keyframes away {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);\n  }\n}\n@keyframes away {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);\n    box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);\n    box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);\n    box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);\n  }\n}\n.gx-orange-effect {\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  animation: away 2s infinite;\n}\n@-webkit-keyframes away {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);\n  }\n}\n@keyframes away {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);\n    box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);\n    box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);\n    box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);\n  }\n}\n@-webkit-keyframes fxicon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes fxicon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n.fxicon-hc-spin {\n  -webkit-animation: fxicon-spin 1.5s infinite linear;\n  animation: fxicon-spin 1.5s infinite linear;\n}\n@-webkit-keyframes fadein {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadein {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.fadein {\n  -webkit-animation-name: fadein;\n  animation-name: fadein;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n}\n@-webkit-keyframes fadeout {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeout {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.fadeout {\n  -webkit-animation-name: fadeout;\n  animation-name: fadeout;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n}\n/* global custom styles (overwritten by developers) */\n.card--height {\n  min-height: 75vh !important;\n}\n.card-title {\n  width: 100%;\n  float: right;\n  display: flex;\n  position: absolute;\n  top: 10px;\n  justify-content: center;\n  align-items: center;\n  padding-right: 50px;\n}\n.card-table-search {\n  margin-right: 25px;\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n/* Change input blue background color of chrome for input elements*/\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px white inset !important;\n}\n/* ant form global styles */\n/* form's button back and submit */\n.form-button {\n  float: right;\n  margin-top: 20px;\n}\n.form-button-pr {\n  padding-right: 40px;\n}\n.form-button-pr21 {\n  padding-right: 21px;\n}\n/* form search field */\n.card-list-data-wrapper {\n  width: 100%;\n  display: flex;\n}\n.card-list-data-container {\n  margin-right: 25px;\n  justify-content: flex-end;\n  width: 100%;\n  display: flex;\n}\n.ant-table-column-title,\n.ant-table-thead > tr > th {\n  color: #000000;\n  font-weight: bold;\n  background-color: #fff !important;\n}\n.ant-table-tbody > tr.ant-table-row:hover > td,\n.ant-table-tbody > tr > td.ant-table-cell-row-hover {\n  background: #ebe7e7 !important;\n}\n.ant-steps-item-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 36px !important;\n  height: 36px !important;\n  font-size: 13px !important;\n  line-height: 36px !important;\n}\n.ant-steps-item-process .ant-steps-item-icon {\n  background: var(--app-primary-color) !important;\n  border: var(--app-primary-color) !important;\n}\n.ant-steps-item-content {\n  width: 100% !important;\n  padding: 0% 10px;\n}\n.ant-steps-vertical {\n  display: flex;\n  flex-direction: row !important;\n}\n.ant-steps-item-title {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 112%;\n  letter-spacing: -0.04em;\n  color: #ffffff !important;\n  margin-left: 20px;\n}\n.ant-steps-item-finish .ant-steps-item-icon {\n  border-color: var(--app-primary-color) !important;\n}\n.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {\n  color: var(--app-primary-color) !important;\n}\n.ant-steps-item-tail {\n  position: absolute;\n  top: 13px;\n  left: 0;\n  width: 100%;\n}\n.ant-steps {\n  width: 100%;\n  padding: 0% 5% !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n@media only screen and (min-width: 300px) and (max-width: 600px) {\n  .ant-steps-vertical {\n    display: flex;\n    flex-direction: row !important;\n  }\n  .ant-steps-item-tail {\n    position: absolute;\n    top: 12px !important;\n    left: 0;\n    width: 100%;\n    transform-origin: top right;\n    transform: rotate(-90deg);\n  }\n  .ant-steps-item-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n  }\n  .ant-steps-item-icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 24px !important;\n    height: 24px !important;\n    font-size: 12px !important;\n    line-height: 32px !important;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 7px;\n    line-height: 112%;\n  }\n  .ant-steps {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0% !important;\n  }\n  .ant-steps-item-tail {\n    position: absolute;\n    top: 20px;\n    left: 0;\n    width: 100%;\n  }\n  .ant-steps-vertical > .ant-steps-item .ant-steps-item-content {\n    overflow: visible;\n  }\n  .ant-steps-item-content {\n    width: 100% !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .ant-steps-item-title {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 8.5px;\n    line-height: 90%;\n    text-align: center;\n    letter-spacing: -0.06em;\n    margin: 0%;\n  }\n  .ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n    position: absolute;\n    top: 15px;\n    left: auto;\n    height: 100%;\n    padding: 0px 0px 0px 12px;\n  }\n}\n.ant-steps-item-process .ant-steps-item-icon {\n  background: var(--app-secondary-color) !important;\n  border: var(--app-primary-color) !important;\n}\n.ant-steps-item-wait .ant-steps-item-icon {\n  background-color: #ffffff !important;\n  border-color: var(--app-primary-color);\n}\n.ant-steps-item-finish .ant-steps-item-icon {\n  background-color: var(--app-secondary-color) !important;\n  border-color: var(--app-primary-color) !important;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: var(--app-secondary-color) !important;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title,\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: var(--app-secondary-color) !important;\n}\n.ant-steps-icon {\n  color: #000000 !important;\n}\n.ant-menu {\n  padding: 10px !important;\n}\n.gx-app-sidebar .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  left: auto !important;\n  right: 22px !important;\n  margin-bottom: -20px !important;\n}\n.ant-menu-submenu-inline .ant-menu-title-content {\n  margin-left: -5px !important;\n}\n.ant-menu-sub .ant-menu-item .ant-menu-item-icon {\n  margin-left: -50px !important;\n  font-size: 17px !important;\n}\n.ant-menu-sub .ant-menu-item .ant-menu-title-content {\n  margin-left: 5px !important;\n}\n.ant-menu-item,\n.ant-menu-submenu-inline .ant-menu-item {\n  width: 100% !important;\n  margin: 5px 0px !important;\n  padding: 0px !important;\n  border-radius: 12px !important;\n}\n.ant-menu-item:hover,\n.ant-menu-submenu-inline .ant-menu-item:hover {\n  width: 100% !important;\n  margin: 5px 0px !important;\n  margin-right: 10px !important;\n  padding: 0px !important;\n  background-color: var(--app-secondary-color) !important;\n  font-weight: bold;\n  color: #ffffff !important;\n}\n.ant-menu-inline-collapsed .ant-menu-submenu-title {\n  margin-left: 15px !important;\n}\n.ant-menu-inline-collapsed .ant-menu-item .ant-menu-item-icon {\n  margin-left: -10px !important;\n}\n.ant-menu-item .ant-menu-item-icon,\n.ant-menu-submenu .ant-menu-item-icon {\n  margin-left: -25px !important;\n  font-size: 17px !important;\n}\n.ant-menu-item .ant-menu-title-content {\n  margin-left: -5px !important;\n}\n.ant-menu-item-selected,\n.ant-menu-item > .ant-menu-item-selected > .ant-menu-item-icon,\n.ant-menu-item > .ant-menu-item-selected > .ant-menu-title-content {\n  background-color: var(--app-secondary-color) !important;\n  font-weight: bold !important;\n  border-radius: 12px;\n  padding: 0% !important;\n}\n.gx-layout-sider-dark .gx-layout-sider-header,\n.gx-drawer-sidebar-dark .gx-layout-sider-header {\n  background-color: #ffffff !important;\n}\n.ant-select-item-option-selected {\n  color: #fff !important;\n  background-color: var(--app-primary-color) !important;\n}\n.ant-select .ant-select-selector:focus {\n  border-color: var(--app-secondary-color) !important;\n}\n.ant-select .ant-select-selector:hover {\n  border-color: var(--app-secondary-color) !important;\n}\n.ant-select.ant-select-focused .ant-select-selector {\n  border-color: var(--app-secondary-color) !important;\n}\n@media only screen and (max-width: 600px) {\n  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n    height: 30px !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n.ant-col {\n  width: 100% !important;\n}\n/* override chrome scrollbar styles */\n@media only screen and(min-width: 1200px) {\n  ::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n  }\n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: #888;\n  }\n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n}\n/* this styles is for all the listing pages */\n.entity-name {\n  font-weight: normal;\n  font-size: 14px;\n}\n.entity-name-selected {\n  font-weight: bolder;\n  font-size: 18px;\n  color: var(--app-primary-color) !important;\n  cursor: pointer;\n}\n.link {\n  cursor: pointer;\n  color: #038fde;\n  transition: all 0.2s ease-in-out;\n}\n.link:hover {\n  color: #A43072;\n}\n.ant-input-disabled {\n  color: #999 !important;\n}\n.ant-picker-disabled {\n  color: #999 !important;\n}\n.ant-select-disabled {\n  color: #999 !important;\n}\n.ant-picker-disabled > .ant-picker-input > input {\n  color: #999 !important;\n}\n.ant-select-disabled > .ant-select-selector > .ant-select-selection-item {\n  color: #999 !important;\n}\n.ant-form-item-label > label {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  height: 36px;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: -0.04em;\n  color: #000000 !important;\n}\n.ant-input-affix-wrapper-focused {\n  border-color: var(--app-primary-color) !important;\n}\n.ant-input-affix-wrapper:hover {\n  border-color: var(--app-primary-color) !important;\n}\n.ant-collapse-content > .ant-collapse-content-box {\n  padding: 0px !important;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  padding: 5px !important;\n}\n@media only screen and (min-width: 300px) and (max-width: 600px) {\n  font-size: 11px !important;\n}\n.icon-disabled {\n  color: grey !important;\n  cursor: not-allowed !important;\n}\n.spin-loadding {\n  margin-left: 10% !important;\n}\n.ant-spin-dot-item {\n  background-color: var(--app-primary-color) !important;\n}\n.ant-table-column-sorter-up.active,\n.ant-table-column-sorter-down.active {\n  color: var(--app-primary-color) !important;\n}\n.ant-pagination-item-active a {\n  color: var(--app-primary-color) !important;\n}\n.ant-pagination-item-active {\n  border-color: var(--app-primary-color) !important;\n}\n.button-gradiant {\n  background: var(--app-primary-color);\n  color: #ffffff;\n  border-radius: 6px;\n  border: 1px solid var(--app-primary-color);\n  transition: all 0.2s ease-in-out;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 100%;\n  text-align: center;\n}\n.button-gradiant:focus {\n  color: #ffffff !important;\n  border: 1px solid var(--app-primary-color);\n  background: var(--app-primary-color) !important;\n}\n.button-gradiant:hover {\n  color: var(--app-primary-color) !important;\n  border: 1px solid var(--app-primary-color);\n  background: #ffffff !important;\n}\n.ant-switch-checked {\n  background-color: var(--app-primary-color) !important;\n}\n.ant-input-search-button:hover,\n.ant-input-search-button:focus {\n  color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n  background: #fff;\n}\n.wordWrapWordBreak {\n  word-wrap: break-word;\n  word-break: break-word;\n}\n.display-flex {\n  display: flex;\n}\n.ml10 {\n  margin-left: 10px;\n}\n.color-red {\n  color: #f5222d;\n}\n.mb8 {\n  margin-bottom: 8px;\n}\n.search-component__width {\n  width: 320px !important;\n}\n.gx-title-container {\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.gx-title-right-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n}\n.gx-parking-history-filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  margin-top: -1rem;\n}\n.add-button {\n  font-weight: 500px;\n  min-width: 140px;\n  max-width: fit-content;\n}\n.card-title-style {\n  font-weight: bold;\n  text-transform: uppercase;\n  font-weight: 600px;\n}\n.select-option-dropdownStyle {\n  max-height: \"200px\";\n  overflow-y: \"auto\";\n}\n.mt0 {\n  margin-top: 0px;\n}\n.mb0 {\n  margin-bottom: 0px;\n}\n.mr17 {\n  margin-left: 17px;\n}\n.width100 {\n  width: 100%;\n}\n.columnChartHeading {\n  margin-bottom: 10px;\n  font-size: 14px;\n  text-align: center;\n}\n.fs15 {\n  font-size: 16px;\n}\n.modalForm {\n  margin-top: 0.2rem;\n  padding-bottom: 5rem;\n  padding-top: 2rem;\n}\n.modal-container {\n  cursor: move;\n}\n.table-data-ellipse {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n@media only screen and (max-width: 1600px) {\n  .search-component__width {\n    width: 270px !important;\n  }\n}\n/* For small mobile devices */\n@media (max-width: 580px) {\n  .gx-title-container,\n  .gx-title-right-section {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n}\n/* Mobile styles */\n@media (max-width: 480px) {\n  .gx-parking-history-filters {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  .gx-parking-history-filters > div {\n    width: calc(50% - 0.25rem);\n    /* 2 columns */\n  }\n}\n.gx-layout-sider-header {\n  padding: 10px 10px 10px 50px !important;\n}\n.ant-radio-button-checked {\n  background-color: var(--app-secondary-color) !important;\n  border-color: var(--app-secondary-color) !important;\n}\n.ant-radio-button-wrapper-checked {\n  border-color: var(--app-secondary-color) !important;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {\n  background-color: var(--app-secondary-color) !important;\n}\n/*Base Styles*/\nbody {\n  overflow: hidden;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  width: 100% !important;\n  position: relative;\n  font-weight: 400;\n}\nbody.framed-layout {\n  padding: 20px;\n  background-color: var(--app-primary-color);\n}\n@media screen and (max-width: 991px) {\n  body.framed-layout {\n    padding: 0;\n  }\n}\nbody.boxed-layout {\n  background-color: var(--app-primary-color);\n  max-width: 1280px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n}\n@media screen and (min-width: 1600px) {\n  body.boxed-layout {\n    max-width: 1500px;\n  }\n}\nbody.full-scroll #root {\n  overflow: auto;\n}\n#root {\n  height: 100vh;\n}\n.framed-layout #root {\n  height: calc(100vh - 2 * 20px);\n  overflow: hidden;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  border-radius: 12px;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout #root {\n    height: 100vh;\n    -webkit-box-shadow: none !important;\n    -moz-box-shadow: none !important;\n    box-shadow: none !important;\n    -webkit-border-radius: 0 !important;\n    -moz-border-radius: 0 !important;\n    border-radius: 0 !important;\n  }\n}\n.gx-pointer,\n.gx-link {\n  cursor: pointer;\n}\na,\n.gx-link {\n  color: var(--app-primary-color);\n}\na:hover,\n.gx-link:hover,\na:focus,\n.gx-link:focus {\n  color: var(--app-primary-color);\n}\na:focus {\n  text-decoration: none;\n}\nol,\nul,\ndl {\n  padding-left: 30px;\n  margin-bottom: 10px;\n}\nimg {\n  max-width: 100%;\n}\n.gx-w-25 {\n  width: 25% !important;\n}\n.gx-w-50 {\n  width: 50% !important;\n}\n.gx-w-75 {\n  width: 75% !important;\n}\n.gx-w-100 {\n  width: 100% !important;\n}\n.gx-h-25 {\n  height: 25% !important;\n}\n.gx-h-50 {\n  height: 50% !important;\n}\n.gx-h-75 {\n  height: 75% !important;\n}\n.gx-h-100 {\n  height: 100% !important;\n}\n.gx-mw-100 {\n  max-width: 100% !important;\n}\n.gx-mh-100 {\n  max-height: 100% !important;\n}\n.gx-minw50 {\n  min-width: 50px;\n}\n.gx-border {\n  border: solid 1px #e8e8e8;\n}\n.gx-border-2 {\n  border: solid 2px #e8e8e8;\n}\n.gx-border-top {\n  border-top: solid 1px #e8e8e8;\n}\n.gx-border-bottom {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-border-bottom-2 {\n  border-bottom: solid 2px #e8e8e8;\n}\n.gx-border-left {\n  border-left: solid 1px #e8e8e8;\n}\n.gx-border-right {\n  border-right: solid 1px #e8e8e8;\n}\n.gx-border-0 {\n  border: 0 none !important;\n}\n.gx-page-heading {\n  margin-bottom: 32px;\n}\n@media screen and (max-width: 575px) {\n  .gx-page-heading {\n    margin-bottom: 20px;\n  }\n}\n.gx-page-title {\n  font-size: 20px;\n  margin-bottom: 0;\n}\n.gx-size-200 {\n  height: 200px !important;\n  width: 200px !important;\n  line-height: 200px !important;\n}\n.gx-size-150 {\n  height: 150px !important;\n  width: 150px !important;\n  line-height: 150px !important;\n}\n.gx-size-120 {\n  height: 120px !important;\n  width: 120px !important;\n  line-height: 120px !important;\n}\n.gx-size-100 {\n  height: 100px !important;\n  width: 100px !important;\n  line-height: 100px !important;\n}\n.gx-size-90 {\n  height: 90px !important;\n  width: 90px !important;\n  line-height: 90px !important;\n}\n.gx-size-80 {\n  height: 80px !important;\n  width: 80px !important;\n  line-height: 80px !important;\n}\n.gx-size-60 {\n  height: 60px !important;\n  width: 60px !important;\n  line-height: 60px !important;\n}\n.gx-size-50 {\n  height: 50px !important;\n  width: 50px !important;\n  line-height: 50px !important;\n}\n.gx-size-40 {\n  height: 40px !important;\n  width: 40px !important;\n  line-height: 40px !important;\n}\n.gx-size-36 {\n  height: 36px !important;\n  width: 36px !important;\n  line-height: 36px !important;\n}\n.gx-size-30 {\n  height: 30px !important;\n  width: 30px !important;\n  line-height: 30px !important;\n}\n.gx-size-24 {\n  height: 24px !important;\n  width: 24px !important;\n  line-height: 24px !important;\n}\n.gx-size-20 {\n  height: 20px !important;\n  width: 20px !important;\n  line-height: 20px !important;\n}\n.gx-size-15 {\n  height: 15px !important;\n  width: 15px !important;\n  line-height: 14px !important;\n}\n.gx-size-10 {\n  height: 10px !important;\n  width: 10px !important;\n  line-height: 10px !important;\n}\n.gx-size-8 {\n  height: 8px !important;\n  width: 8px !important;\n  line-height: 8px !important;\n}\n.gx-width-175 {\n  width: 175px !important;\n}\n.gx-img-fluid,\n.gx-img-thumbnail {\n  max-width: 100%;\n  height: auto;\n}\n.gx-img-fluid-full {\n  width: 100%;\n}\n/*Social Style*/\n.gx-social-link {\n  list-style: none;\n  padding-left: 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin: 0 -5px 10px;\n}\n.gx-social-link li {\n  padding: 0 5px;\n  margin-bottom: 5px;\n  line-height: 1;\n}\n.gx-social-link li a,\n.gx-social-link li .gx-link,\n.gx-social-link li i,\n.gx-social-link li .anticon {\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  line-height: 34px;\n  font-size: 16px;\n  text-align: center;\n  color: var(--app-primary-color);\n  border: solid 1px var(--app-primary-color);\n  border-radius: 50%;\n}\n.gx-social-link li.active a,\n.gx-social-link li.active .gx-link,\n.gx-social-link li.active i,\n.gx-social-link li.active .anticon,\n.gx-social-link li a:hover,\n.gx-social-link li .gx-link:hover,\n.gx-social-link li i:hover,\n.gx-social-link li .anticon:hover,\n.gx-social-link li a:focus,\n.gx-social-link li .gx-link:focus,\n.gx-social-link li i:focus .gx-social-link li .anticon:focus {\n  color: #ffffff;\n  background: var(--app-primary-color);\n}\n.gx-card-social .gx-social-link {\n  margin-bottom: 0;\n  -webkit-justify-content: space-around;\n  -ms-justify-content: space-around;\n  justify-content: space-around;\n}\n.gx-float-left {\n  float: left !important;\n}\n.gx-float-right {\n  float: right !important;\n}\n.gx-float-none {\n  float: none !important;\n}\n@media (min-width: 576px) {\n  .gx-float-sm-left {\n    float: left !important;\n  }\n  .gx-float-sm-right {\n    float: right !important;\n  }\n  .gx-float-sm-none {\n    float: none !important;\n  }\n}\n@media (min-width: 768px) {\n  .gx-float-md-left {\n    float: left !important;\n  }\n  .gx-float-md-right {\n    float: right !important;\n  }\n  .gx-float-md-none {\n    float: none !important;\n  }\n}\n@media (min-width: 992px) {\n  .gx-float-lg-left {\n    float: left !important;\n  }\n  .gx-float-lg-right {\n    float: right !important;\n  }\n  .gx-float-lg-none {\n    float: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .gx-float-xl-left {\n    float: left !important;\n  }\n  .gx-float-xl-right {\n    float: right !important;\n  }\n  .gx-float-xl-none {\n    float: none !important;\n  }\n}\n.gx-position-static {\n  position: static !important;\n}\n.gx-position-relative {\n  position: relative !important;\n}\n.gx-position-absolute {\n  position: absolute !important;\n}\n.gx-position-fixed {\n  position: fixed !important;\n}\n.gx-position-sticky {\n  position: sticky !important;\n}\n.gx-fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n.gx-fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n.gx-top-0 {\n  top: 0 !important;\n}\n.gx-bottom-0 {\n  bottom: 0 !important;\n}\n.gx-left-0 {\n  left: 0 !important;\n}\n.gx-right-0 {\n  right: 0 !important;\n}\n/*Embed Responsive Classes*/\n.gx-embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n.gx-embed-responsive:before {\n  display: block;\n  content: \"\";\n}\n.gx-embed-responsive .gx-embed-responsive-item,\n.gx-embed-responsive iframe,\n.gx-embed-responsive embed,\n.gx-embed-responsive object,\n.gx-embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.gx-embed-responsive-21by9:before {\n  padding-top: 42.85714286%;\n}\n.gx-embed-responsive-16by9:before {\n  padding-top: 56.25%;\n}\n.gx-embed-responsive-4by3:before {\n  padding-top: 75%;\n}\n.gx-embed-responsive-1by1:before {\n  padding-top: 100%;\n}\n/*Media Object Classes*/\n.gx-media {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: flex-start;\n  -ms-align-items: flex-start;\n  align-items: flex-start;\n}\n.gx-media-body {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n/*Overflow styles*/\n.gx-overflow-auto {\n  overflow: auto;\n}\n.gx-z-index-20 {\n  position: relative;\n  z-index: 20;\n}\n/*Hr style*/\nhr {\n  border-color: rgba(250, 250, 250, 0.2);\n  margin: 15px 0;\n}\n/*Status style*/\n.gx-status-pos {\n  position: relative;\n}\n.gx-status-pos .gx-status {\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 2px;\n  z-index: 1;\n  width: 12px;\n  height: 12px;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n}\n.gx-status-pos .gx-status.gx-small {\n  width: 8px;\n  height: 8px;\n}\n.gx-status-pos .gx-status.gx-status-rtl {\n  top: -4px;\n  left: auto;\n  right: -4px;\n}\n.gx-status-pos .gx-status.gx-online {\n  background-color: #52c41a;\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  animation: online 2s infinite;\n}\n.gx-status-pos .gx-status.gx-offline {\n  background-color: #ffffff;\n  border: solid 1px #52c41a;\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  animation: online 2s infinite;\n}\n.gx-status-pos .gx-status.gx-away {\n  background-color: #fadb14;\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  animation: away 2s infinite;\n}\n.gx-status-pos .gx-status.gx-orange {\n  background-color: #fa8c16;\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  animation: away 2s infinite;\n}\n.gx-box-shadow {\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n}\n.gx-no-box-shadow {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n}\n.gx-rounded-xs {\n  -webkit-border-radius: 2px !important;\n  -moz-border-radius: 2px !important;\n  border-radius: 2px !important;\n}\n.gx-rounded-sm {\n  -webkit-border-radius: 4px !important;\n  -moz-border-radius: 4px !important;\n  border-radius: 4px !important;\n}\n.gx-rounded-base {\n  -webkit-border-radius: 6px !important;\n  -moz-border-radius: 6px !important;\n  border-radius: 6px !important;\n}\n.gx-rounded-lg {\n  -webkit-border-radius: 10px !important;\n  -moz-border-radius: 10px !important;\n  border-radius: 10px !important;\n}\n.gx-rounded-xxl {\n  -webkit-border-radius: 30px !important;\n  -moz-border-radius: 30px !important;\n  border-radius: 30px !important;\n}\n.gx-rounded-circle {\n  -webkit-border-radius: 50% !important;\n  -moz-border-radius: 50% !important;\n  border-radius: 50% !important;\n}\n.gx-border-radius-top-left-0 {\n  -moz-border-top-left-radius: 0;\n  -webkit-border-top-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.gx-border-radius-top-right-0 {\n  -moz-border-top-right-radius: 0;\n  -webkit-border-top-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.gx-border-radius-bottom-left-0 {\n  -moz-border-bottom-left-radius: 0;\n  -webkit-border-bottom-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.gx-border-radius-bottom-right-0 {\n  -moz-border-bottom-right-radius: 0;\n  -webkit-border-bottom-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.gx-vertical-align-top {\n  vertical-align: top;\n}\n.gx-vertical-align-middle {\n  vertical-align: middle;\n}\n.gx-vertical-align-bottom {\n  vertical-align: bottom;\n}\n.gx-separator {\n  background-color: var(--app-primary-color);\n  width: 20px;\n  height: 2px;\n  margin: 0 auto 10px;\n}\n.gx-loader-400 {\n  height: 400px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-loader-400 {\n    height: 300px;\n  }\n}\n.gx-object-cover {\n  object-fit: cover;\n}\n.cke_editable,\n.cke_editor_editor2 {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji' !important;\n}\n.gx-top2 {\n  position: relative;\n  top: 2px;\n}\n.ant-collapse-content-box > :last-child {\n  margin-bottom: 0;\n}\n.react-stickies-wrapper {\n  padding-bottom: 16px;\n}\n@media screen and (max-width: 1366px) {\n  .gx-hide-1366 {\n    display: none;\n  }\n}\n/*flex Styles*/\n.gx-d-flex {\n  display: flex !important;\n}\n.gx-d-none {\n  display: none !important;\n}\n.gx-d-inline-block {\n  display: inline-block !important;\n}\n.gx-d-block {\n  display: block !important;\n}\n.gx-d-inline-flex {\n  display: inline-flex !important;\n}\n.gx-flex-1 {\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n/*Display Flex Classes*/\n.gx-flex-row {\n  display: -webkit-flex !important;\n  display: -ms-flexbox !important;\n  display: -ms-flex !important;\n  display: flex !important;\n  -webkit-flex-direction: row !important;\n  -ms-flex-direction: row !important;\n  flex-direction: row !important;\n  -webkit-flex-wrap: wrap !important;\n  -ms-flex-wrap: wrap !important;\n  flex-wrap: wrap !important;\n}\n.gx-flex-column {\n  display: -webkit-flex !important;\n  display: -ms-flexbox !important;\n  display: -ms-flex !important;\n  display: flex !important;\n  -webkit-flex-direction: column !important;\n  -ms-flex-direction: column !important;\n  flex-direction: column !important;\n  -webkit-flex-wrap: nowrap !important;\n  -ms-flex-wrap: nowrap !important;\n  flex-wrap: nowrap !important;\n}\n.gx-flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n.gx-flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n.gx-flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n.gx-justify-content-start {\n  -webkit-justify-content: flex-start !important;\n  -ms-justify-content: flex-start !important;\n  justify-content: flex-start !important;\n}\n.gx-justify-content-end {\n  -webkit-justify-content: flex-end !important;\n  -ms-justify-content: flex-end !important;\n  justify-content: flex-end !important;\n}\n.gx-justify-content-center {\n  -webkit-justify-content: center !important;\n  -ms-justify-content: center !important;\n  justify-content: center !important;\n}\n.gx-justify-content-between {\n  -webkit-justify-content: space-between !important;\n  -ms-justify-content: space-between !important;\n  justify-content: space-between !important;\n}\n.gx-justify-content-around {\n  -webkit-justify-content: space-around !important;\n  -ms-justify-content: space-around !important;\n  justify-content: space-around !important;\n}\n.gx-align-items-start {\n  -webkit-align-items: flex-start !important;\n  -ms-align-items: flex-start !important;\n  align-items: flex-start !important;\n}\n.gx-align-items-end {\n  -webkit-align-items: flex-end !important;\n  -ms-align-items: flex-end !important;\n  align-items: flex-end !important;\n}\n.gx-align-items-center {\n  -webkit-align-items: center !important;\n  -ms-align-items: center !important;\n  align-items: center !important;\n}\n.gx-align-items-stretch {\n  -webkit-align-items: stretch !important;\n  -ms-align-items: stretch !important;\n  align-items: stretch !important;\n}\n.gx-align-content-start {\n  -webkit-align-content: flex-start !important;\n  -ms-align-content: flex-start !important;\n  align-content: flex-start !important;\n}\n.gx-align-content-end {\n  -webkit-align-content: flex-end !important;\n  -ms-align-content: flex-end !important;\n  align-content: flex-end !important;\n}\n.gx-align-content-center {\n  -webkit-align-content: center !important;\n  -ms-align-content: center !important;\n  align-content: center !important;\n}\n.gx-align-content-between {\n  -webkit-align-content: space-between !important;\n  -ms-align-content: space-between !important;\n  align-content: space-between !important;\n}\n.gx-align-content-around {\n  -webkit-align-content: space-around !important;\n  -ms-align-content: space-around !important;\n  align-content: space-around !important;\n}\n.gx-align-content-stretch {\n  -webkit-align-content: stretch !important;\n  -ms-align-content: stretch !important;\n  align-content: stretch !important;\n}\n.gx-align-self-auto {\n  -webkit-align-self: auto !important;\n  -ms-align-self: auto !important;\n  align-self: auto !important;\n}\n.gx-align-self-start {\n  -webkit-align-self: flex-start !important;\n  -ms-align-self: flex-start !important;\n  align-self: flex-start !important;\n}\n.gx-align-self-end {\n  -webkit-align-self: flex-end !important;\n  -ms-align-self: flex-end !important;\n  align-self: flex-end !important;\n}\n.gx-align-self-center {\n  -webkit-align-self: center !important;\n  -ms-align-self: center !important;\n  align-self: center !important;\n}\n.gx-align-self-baseline {\n  -webkit-align-self: baseline !important;\n  -ms-align-self: baseline !important;\n  align-self: baseline !important;\n}\n.gx-align-self-stretch {\n  -webkit-align-self: stretch !important;\n  -ms-align-self: stretch !important;\n  align-self: stretch !important;\n}\n.gx-order-first {\n  -ms-flex-order: -1;\n  order: -1;\n}\n.gx-order-1 {\n  -ms-flex-order: 1;\n  order: 1;\n}\n.gx-order-2 {\n  -ms-flex-order: 2;\n  order: 2;\n}\n.gx-order-3 {\n  -ms-flex-order: 3;\n  order: 3;\n}\n.gx-order-4 {\n  -ms-flex-order: 4;\n  order: 4;\n}\n.gx-order-5 {\n  -ms-flex-order: 5;\n  order: 5;\n}\n.gx-order-6 {\n  -ms-flex-order: 6;\n  order: 6;\n}\n.gx-order-7 {\n  -ms-flex-order: 7;\n  order: 7;\n}\n.gx-order-8 {\n  -ms-flex-order: 8;\n  order: 8;\n}\n.gx-order-9 {\n  -ms-flex-order: 9;\n  order: 9;\n}\n.gx-order-10 {\n  -ms-flex-order: 10;\n  order: 10;\n}\n.gx-order-11 {\n  -ms-flex-order: 11;\n  order: 11;\n}\n.gx-order-12 {\n  -ms-flex-order: 12;\n  order: 12;\n}\n.gx-offset-1 {\n  margin-left: 8.333333%;\n}\n.gx-offset-2 {\n  margin-left: 16.666667%;\n}\n.gx-offset-3 {\n  margin-left: 25%;\n}\n.gx-offset-4 {\n  margin-left: 33.333333%;\n}\n.gx-offset-5 {\n  margin-left: 41.666667%;\n}\n.gx-offset-6 {\n  margin-left: 50%;\n}\n.gx-offset-7 {\n  margin-left: 58.333333%;\n}\n.gx-offset-8 {\n  margin-left: 66.666667%;\n}\n.gx-offset-9 {\n  margin-left: 75%;\n}\n.gx-offset-10 {\n  margin-left: 83.333333%;\n}\n.gx-offset-11 {\n  margin-left: 91.666667%;\n}\n@media screen and (min-width: 576px) {\n  .gx-d-sm-none {\n    display: none !important;\n  }\n  .gx-d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .gx-d-sm-block {\n    display: block !important;\n  }\n  .gx-d-sm-flex {\n    display: flex !important;\n  }\n  .gx-d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .gx-flex-sm-row {\n    flex-direction: row !important;\n  }\n  .gx-flex-sm-column {\n    flex-direction: column !important;\n  }\n  .gx-flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .gx-flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .gx-flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .gx-flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .gx-flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gx-justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .gx-justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .gx-justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .gx-justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .gx-justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .gx-align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .gx-align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .gx-align-items-sm-center {\n    align-items: center !important;\n  }\n  .gx-align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .gx-align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .gx-align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .gx-align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .gx-align-content-sm-center {\n    align-content: center !important;\n  }\n  .gx-align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .gx-align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .gx-align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .gx-align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .gx-align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .gx-align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .gx-align-self-sm-center {\n    align-self: center !important;\n  }\n  .gx-align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .gx-align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .gx-order-sm-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .gx-order-sm-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .gx-order-sm-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .gx-order-sm-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .gx-order-sm-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .gx-order-sm-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .gx-order-sm-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .gx-order-sm-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .gx-order-sm-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .gx-order-sm-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .gx-order-sm-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .gx-order-sm-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .gx-order-sm-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .gx-offset-sm-0 {\n    margin-left: 0;\n  }\n  .gx-offset-sm-1 {\n    margin-left: 8.333333%;\n  }\n  .gx-offset-sm-2 {\n    margin-left: 16.666667%;\n  }\n  .gx-offset-sm-3 {\n    margin-left: 25%;\n  }\n  .gx-offset-sm-4 {\n    margin-left: 33.333333%;\n  }\n  .gx-offset-sm-5 {\n    margin-left: 41.666667%;\n  }\n  .gx-offset-sm-6 {\n    margin-left: 50%;\n  }\n  .gx-offset-sm-7 {\n    margin-left: 58.333333%;\n  }\n  .gx-offset-sm-8 {\n    margin-left: 66.666667%;\n  }\n  .gx-offset-sm-9 {\n    margin-left: 75%;\n  }\n  .gx-offset-sm-10 {\n    margin-left: 83.333333%;\n  }\n  .gx-offset-sm-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media screen and (min-width: 768px) {\n  .gx-d-md-none {\n    display: none !important;\n  }\n  .gx-d-md-inline-block {\n    display: inline-block !important;\n  }\n  .gx-d-md-block {\n    display: block !important;\n  }\n  .gx-d-md-flex {\n    display: flex !important;\n  }\n  .gx-d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .gx-flex-md-row {\n    flex-direction: row !important;\n  }\n  .gx-flex-md-column {\n    flex-direction: column !important;\n  }\n  .gx-flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .gx-flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .gx-flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .gx-flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .gx-flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gx-justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .gx-justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .gx-justify-content-md-center {\n    justify-content: center !important;\n  }\n  .gx-justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .gx-justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .gx-align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .gx-align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .gx-align-items-md-center {\n    align-items: center !important;\n  }\n  .gx-align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .gx-align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .gx-align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .gx-align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .gx-align-content-md-center {\n    align-content: center !important;\n  }\n  .gx-align-content-md-between {\n    align-content: space-between !important;\n  }\n  .gx-align-content-md-around {\n    align-content: space-around !important;\n  }\n  .gx-align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .gx-align-self-md-auto {\n    align-self: auto !important;\n  }\n  .gx-align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .gx-align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .gx-align-self-md-center {\n    align-self: center !important;\n  }\n  .gx-align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .gx-align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .gx-order-md-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .gx-order-md-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .gx-order-md-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .gx-order-md-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .gx-order-md-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .gx-order-md-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .gx-order-md-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .gx-order-md-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .gx-order-md-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .gx-order-md-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .gx-order-md-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .gx-order-md-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .gx-order-md-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .gx-offset-md-0 {\n    margin-left: 0;\n  }\n  .gx-offset-md-1 {\n    margin-left: 8.333333%;\n  }\n  .gx-offset-md-2 {\n    margin-left: 16.666667%;\n  }\n  .gx-offset-md-3 {\n    margin-left: 25%;\n  }\n  .gx-offset-md-4 {\n    margin-left: 33.333333%;\n  }\n  .gx-offset-md-5 {\n    margin-left: 41.666667%;\n  }\n  .gx-offset-md-6 {\n    margin-left: 50%;\n  }\n  .gx-offset-md-7 {\n    margin-left: 58.333333%;\n  }\n  .gx-offset-md-8 {\n    margin-left: 66.666667%;\n  }\n  .gx-offset-md-9 {\n    margin-left: 75%;\n  }\n  .gx-offset-md-10 {\n    margin-left: 83.333333%;\n  }\n  .gx-offset-md-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media screen and (min-width: 992px) {\n  .gx-d-lg-none {\n    display: none !important;\n  }\n  .gx-d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .gx-d-lg-block {\n    display: block !important;\n  }\n  .gx-d-lg-flex {\n    display: flex !important;\n  }\n  .gx-d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .gx-flex-lg-row {\n    flex-direction: row !important;\n  }\n  .gx-flex-lg-column {\n    flex-direction: column !important;\n  }\n  .gx-flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .gx-flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .gx-flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .gx-flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .gx-flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gx-justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .gx-justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .gx-justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .gx-justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .gx-justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .gx-align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .gx-align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .gx-align-items-lg-center {\n    align-items: center !important;\n  }\n  .gx-align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .gx-align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .gx-align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .gx-align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .gx-align-content-lg-center {\n    align-content: center !important;\n  }\n  .gx-align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .gx-align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .gx-align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .gx-align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .gx-align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .gx-align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .gx-align-self-lg-center {\n    align-self: center !important;\n  }\n  .gx-align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .gx-align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .gx-order-lg-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .gx-order-lg-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .gx-order-lg-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .gx-order-lg-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .gx-order-lg-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .gx-order-lg-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .gx-order-lg-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .gx-order-lg-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .gx-order-lg-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .gx-order-lg-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .gx-order-lg-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .gx-order-lg-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .gx-order-lg-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .gx-offset-lg-0 {\n    margin-left: 0;\n  }\n  .gx-offset-lg-1 {\n    margin-left: 8.333333%;\n  }\n  .gx-offset-lg-2 {\n    margin-left: 16.666667%;\n  }\n  .gx-offset-lg-3 {\n    margin-left: 25%;\n  }\n  .gx-offset-lg-4 {\n    margin-left: 33.333333%;\n  }\n  .gx-offset-lg-5 {\n    margin-left: 41.666667%;\n  }\n  .gx-offset-lg-6 {\n    margin-left: 50%;\n  }\n  .gx-offset-lg-7 {\n    margin-left: 58.333333%;\n  }\n  .gx-offset-lg-8 {\n    margin-left: 66.666667%;\n  }\n  .gx-offset-lg-9 {\n    margin-left: 75%;\n  }\n  .gx-offset-lg-10 {\n    margin-left: 83.333333%;\n  }\n  .gx-offset-lg-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .gx-d-xl-none {\n    display: none !important;\n  }\n  .gx-d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .gx-d-xl-block {\n    display: block !important;\n  }\n  .gx-d-xl-flex {\n    display: flex !important;\n  }\n  .gx-d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .gx-flex-xl-row {\n    flex-direction: row !important;\n  }\n  .gx-flex-xl-column {\n    flex-direction: column !important;\n  }\n  .gx-flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .gx-flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .gx-flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .gx-flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .gx-flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gx-justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .gx-justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .gx-justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .gx-justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .gx-align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .gx-align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .gx-align-items-xl-center {\n    align-items: center !important;\n  }\n  .gx-align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .gx-align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .gx-align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .gx-align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .gx-align-content-xl-center {\n    align-content: center !important;\n  }\n  .gx-align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .gx-align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .gx-align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .gx-align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .gx-align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .gx-align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .gx-align-self-xl-center {\n    align-self: center !important;\n  }\n  .gx-align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .gx-align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .gx-order-xl-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .gx-order-xl-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .gx-order-xl-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .gx-order-xl-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .gx-order-xl-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .gx-order-xl-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .gx-order-xl-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .gx-order-xl-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .gx-order-xl-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .gx-order-xl-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .gx-order-xl-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .gx-order-xl-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .gx-order-xl-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .gx-offset-xl-0 {\n    margin-left: 0;\n  }\n  .gx-offset-xl-1 {\n    margin-left: 8.333333%;\n  }\n  .gx-offset-xl-2 {\n    margin-left: 16.666667%;\n  }\n  .gx-offset-xl-3 {\n    margin-left: 25%;\n  }\n  .gx-offset-xl-4 {\n    margin-left: 33.333333%;\n  }\n  .gx-offset-xl-5 {\n    margin-left: 41.666667%;\n  }\n  .gx-offset-xl-6 {\n    margin-left: 50%;\n  }\n  .gx-offset-xl-7 {\n    margin-left: 58.333333%;\n  }\n  .gx-offset-xl-8 {\n    margin-left: 66.666667%;\n  }\n  .gx-offset-xl-9 {\n    margin-left: 75%;\n  }\n  .gx-offset-xl-10 {\n    margin-left: 83.333333%;\n  }\n  .gx-offset-xl-11 {\n    margin-left: 91.666667%;\n  }\n}\n.ant-row {\n  margin-left: -16px;\n  margin-right: -16px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.ant-row > [class*=ant-col-] {\n  margin: 0 -0.3px;\n}\n.ant-col-1,\n.ant-col-xs-1,\n.ant-col-sm-1,\n.ant-col-md-1,\n.ant-col-lg-1,\n.ant-col-2,\n.ant-col-xs-2,\n.ant-col-sm-2,\n.ant-col-md-2,\n.ant-col-lg-2,\n.ant-col-3,\n.ant-col-xs-3,\n.ant-col-sm-3,\n.ant-col-md-3,\n.ant-col-lg-3,\n.ant-col-4,\n.ant-col-xs-4,\n.ant-col-sm-4,\n.ant-col-md-4,\n.ant-col-lg-4,\n.ant-col-5,\n.ant-col-xs-5,\n.ant-col-sm-5,\n.ant-col-md-5,\n.ant-col-lg-5,\n.ant-col-6,\n.ant-col-xs-6,\n.ant-col-sm-6,\n.ant-col-md-6,\n.ant-col-lg-6,\n.ant-col-7,\n.ant-col-xs-7,\n.ant-col-sm-7,\n.ant-col-md-7,\n.ant-col-lg-7,\n.ant-col-8,\n.ant-col-xs-8,\n.ant-col-sm-8,\n.ant-col-md-8,\n.ant-col-lg-8,\n.ant-col-9,\n.ant-col-xs-9,\n.ant-col-sm-9,\n.ant-col-md-9,\n.ant-col-lg-9,\n.ant-col-10,\n.ant-col-xs-10,\n.ant-col-sm-10,\n.ant-col-md-10,\n.ant-col-lg-10,\n.ant-col-11,\n.ant-col-xs-11,\n.ant-col-sm-11,\n.ant-col-md-11,\n.ant-col-lg-11,\n.ant-col-12,\n.ant-col-xs-12,\n.ant-col-sm-12,\n.ant-col-md-12,\n.ant-col-lg-12,\n.ant-col-13,\n.ant-col-xs-13,\n.ant-col-sm-13,\n.ant-col-md-13,\n.ant-col-lg-13,\n.ant-col-14,\n.ant-col-xs-14,\n.ant-col-sm-14,\n.ant-col-md-14,\n.ant-col-lg-14,\n.ant-col-15,\n.ant-col-xs-15,\n.ant-col-sm-15,\n.ant-col-md-15,\n.ant-col-lg-15,\n.ant-col-16,\n.ant-col-xs-16,\n.ant-col-sm-16,\n.ant-col-md-16,\n.ant-col-lg-16,\n.ant-col-17,\n.ant-col-xs-17,\n.ant-col-sm-17,\n.ant-col-md-17,\n.ant-col-lg-17,\n.ant-col-18,\n.ant-col-xs-18,\n.ant-col-sm-18,\n.ant-col-md-18,\n.ant-col-lg-18,\n.ant-col-19,\n.ant-col-xs-19,\n.ant-col-sm-19,\n.ant-col-md-19,\n.ant-col-lg-19,\n.ant-col-20,\n.ant-col-xs-20,\n.ant-col-sm-20,\n.ant-col-md-20,\n.ant-col-lg-20,\n.ant-col-21,\n.ant-col-xs-21,\n.ant-col-sm-21,\n.ant-col-md-21,\n.ant-col-lg-21,\n.ant-col-22,\n.ant-col-xs-22,\n.ant-col-sm-22,\n.ant-col-md-22,\n.ant-col-lg-22,\n.ant-col-23,\n.ant-col-xs-23,\n.ant-col-sm-23,\n.ant-col-md-23,\n.ant-col-lg-23,\n.ant-col-24,\n.ant-col-xs-24,\n.ant-col-sm-24,\n.ant-col-md-24,\n.ant-col-lg-24 {\n  padding-right: 16px;\n  float: none !important;\n}\n.gx-col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n  padding-right: 16px;\n}\n@media screen and (max-width: 480px) {\n  .gx-col-full {\n    width: 100%;\n  }\n}\n.ant-row-flex {\n  display: flex;\n  flex-flow: row wrap;\n}\n/*Margin Padding Styles*/\n.gx-mb-30 {\n  margin-bottom: 30px !important;\n}\n.gx-mb-10 {\n  margin-bottom: 10px !important;\n}\n.gx-m-0 {\n  margin: 0 !important;\n}\n.gx-mt-0,\n.gx-my-0 {\n  margin-top: 0 !important;\n}\n.gx-mr-0,\n.gx-mx-0 {\n  margin-right: 0 !important;\n}\n.gx-mb-0,\n.gx-my-0 {\n  margin-bottom: 0 !important;\n}\n.gx-ml-0,\n.gx-mx-0 {\n  margin-left: 0 !important;\n}\n.gx-m-1 {\n  margin: 0.25rem !important;\n}\n.gx-mt-1,\n.gx-my-1 {\n  margin-top: 0.25rem !important;\n}\n.gx-mr-1,\n.gx-mx-1 {\n  margin-right: 0.25rem !important;\n}\n.gx-mb-1,\n.gx-my-1 {\n  margin-bottom: 0.25rem !important;\n}\n.gx-ml-1,\n.gx-mx-1 {\n  margin-left: 0.25rem !important;\n}\n.gx-m-2 {\n  margin: 0.5rem !important;\n}\n.gx-mt-2,\n.gx-my-2 {\n  margin-top: 0.5rem !important;\n}\n.gx-mr-2,\n.gx-mx-2 {\n  margin-right: 0.5rem !important;\n}\n.gx-mb-2,\n.gx-my-2 {\n  margin-bottom: 0.5rem !important;\n}\n.gx-ml-2,\n.gx-mx-2 {\n  margin-left: 0.5rem !important;\n}\n.gx-m-3 {\n  margin: 1rem !important;\n}\n.gx-mt-3,\n.gx-my-3 {\n  margin-top: 1rem !important;\n}\n.gx-mr-3,\n.gx-mx-3 {\n  margin-right: 1rem !important;\n}\n.gx-mb-3,\n.gx-my-3 {\n  margin-bottom: 1rem !important;\n}\n.gx-ml-3,\n.gx-mx-3 {\n  margin-left: 1rem !important;\n}\n.gx-m-4 {\n  margin: 1.5rem !important;\n}\n.gx-mt-4,\n.gx-my-4 {\n  margin-top: 1.5rem !important;\n}\n.gx-mr-4,\n.gx-mx-4 {\n  margin-right: 1.5rem !important;\n}\n.gx-mb-4,\n.gx-my-4 {\n  margin-bottom: 1.5rem !important;\n}\n.gx-ml-4,\n.gx-mx-4 {\n  margin-left: 1.5rem !important;\n}\n.gx-m-5 {\n  margin: 3rem !important;\n}\n.gx-mt-5,\n.gx-my-5 {\n  margin-top: 3rem !important;\n}\n.gx-mr-5,\n.gx-mx-5 {\n  margin-right: 3rem !important;\n}\n.gx-mb-5,\n.gx-my-5 {\n  margin-bottom: 3rem !important;\n}\n.gx-ml-5,\n.gx-mx-5 {\n  margin-left: 3rem !important;\n}\n.gx-p-0 {\n  padding: 0 !important;\n}\n.gx-pt-0,\n.gx-py-0 {\n  padding-top: 0 !important;\n}\n.gx-pr-0,\n.gx-px-0 {\n  padding-right: 0 !important;\n}\n.gx-pb-0,\n.gx-py-0 {\n  padding-bottom: 0 !important;\n}\n.gx-pl-0,\n.gx-px-0 {\n  padding-left: 0 !important;\n}\n.gx-p-1 {\n  padding: 0.25rem !important;\n}\n.gx-pt-1,\n.gx-py-1 {\n  padding-top: 0.25rem !important;\n}\n.gx-pr-1,\n.gx-px-1 {\n  padding-right: 0.25rem !important;\n}\n.gx-pb-1,\n.gx-py-1 {\n  padding-bottom: 0.25rem !important;\n}\n.gx-pl-1,\n.gx-px-1 {\n  padding-left: 0.25rem !important;\n}\n.gx-p-2 {\n  padding: 0.5rem !important;\n}\n.gx-pt-2,\n.gx-py-2 {\n  padding-top: 0.5rem !important;\n}\n.gx-pr-2,\n.gx-px-2 {\n  padding-right: 0.5rem !important;\n}\n.gx-pb-2,\n.gx-py-2 {\n  padding-bottom: 0.5rem !important;\n}\n.gx-pl-2,\n.gx-px-2 {\n  padding-left: 0.5rem !important;\n}\n.gx-p-3 {\n  padding: 1rem !important;\n}\n.gx-pt-3,\n.gx-py-3 {\n  padding-top: 1rem !important;\n}\n.gx-pr-3,\n.gx-px-3 {\n  padding-right: 1rem !important;\n}\n.gx-pb-3,\n.gx-py-3 {\n  padding-bottom: 1rem !important;\n}\n.gx-pl-3,\n.gx-px-3 {\n  padding-left: 1rem !important;\n}\n.gx-p-4 {\n  padding: 1.5rem !important;\n}\n.gx-pt-4,\n.gx-py-4 {\n  padding-top: 1.5rem !important;\n}\n.gx-pr-4,\n.gx-px-4 {\n  padding-right: 1.5rem !important;\n}\n.gx-pb-4,\n.gx-py-4 {\n  padding-bottom: 1.5rem !important;\n}\n.gx-pl-4,\n.gx-px-4 {\n  padding-left: 1.5rem !important;\n}\n.gx-p-5 {\n  padding: 2rem !important;\n}\n.gx-pt-5,\n.gx-py-5 {\n  padding-top: 2rem !important;\n}\n.gx-pr-5,\n.gx-px-5 {\n  padding-right: 2rem !important;\n}\n.gx-pb-5,\n.gx-py-5 {\n  padding-bottom: 2rem !important;\n}\n.gx-pl-5,\n.gx-px-5 {\n  padding-left: 2rem !important;\n}\n.gx-m-auto {\n  margin: auto !important;\n}\n.gx-mt-auto,\n.gx-my-auto {\n  margin-top: auto !important;\n}\n.gx-mr-auto,\n.gx-mx-auto {\n  margin-right: auto !important;\n}\n.gx-mb-auto,\n.gx-my-auto {\n  margin-bottom: auto !important;\n}\n.gx-ml-auto,\n.gx-mx-auto {\n  margin-left: auto !important;\n}\n@media (min-width: 576px) {\n  .gx-m-sm-0 {\n    margin: 0 !important;\n  }\n  .gx-mt-sm-0,\n  .gx-my-sm-0 {\n    margin-top: 0 !important;\n  }\n  .gx-mr-sm-0,\n  .gx-mx-sm-0 {\n    margin-right: 0 !important;\n  }\n  .gx-mb-sm-0,\n  .gx-my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .gx-ml-sm-0,\n  .gx-mx-sm-0 {\n    margin-left: 0 !important;\n  }\n  .gx-m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .gx-mt-sm-1,\n  .gx-my-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .gx-mr-sm-1,\n  .gx-mx-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .gx-mb-sm-1,\n  .gx-my-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .gx-ml-sm-1,\n  .gx-mx-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .gx-m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .gx-mt-sm-2,\n  .gx-my-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .gx-mr-sm-2,\n  .gx-mx-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .gx-mb-sm-2,\n  .gx-my-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .gx-ml-sm-2,\n  .gx-mx-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .gx-m-sm-3 {\n    margin: 1rem !important;\n  }\n  .gx-mt-sm-3,\n  .gx-my-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .gx-mr-sm-3,\n  .gx-mx-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .gx-mb-sm-3,\n  .gx-my-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .gx-ml-sm-3,\n  .gx-mx-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .gx-m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .gx-mt-sm-4,\n  .gx-my-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .gx-mr-sm-4,\n  .gx-mx-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .gx-mb-sm-4,\n  .gx-my-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .gx-ml-sm-4,\n  .gx-mx-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .gx-m-sm-5 {\n    margin: 3rem !important;\n  }\n  .gx-mt-sm-5,\n  .gx-my-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .gx-mr-sm-5,\n  .gx-mx-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .gx-mb-sm-5,\n  .gx-my-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .gx-ml-sm-5,\n  .gx-mx-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .gx-p-sm-0 {\n    padding: 0 !important;\n  }\n  .gx-pt-sm-0,\n  .gx-py-sm-0 {\n    padding-top: 0 !important;\n  }\n  .gx-pr-sm-0,\n  .gx-px-sm-0 {\n    padding-right: 0 !important;\n  }\n  .gx-pb-sm-0,\n  .gx-py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .gx-pl-sm-0,\n  .gx-px-sm-0 {\n    padding-left: 0 !important;\n  }\n  .gx-p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .gx-pt-sm-1,\n  .gx-py-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .gx-pr-sm-1,\n  .gx-px-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .gx-pb-sm-1,\n  .gx-py-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .gx-pl-sm-1,\n  .gx-px-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .gx-p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .gx-pt-sm-2,\n  .gx-py-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .gx-pr-sm-2,\n  .gx-px-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .gx-pb-sm-2,\n  .gx-py-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .gx-pl-sm-2,\n  .gx-px-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .gx-p-sm-3 {\n    padding: 1rem !important;\n  }\n  .gx-pt-sm-3,\n  .gx-py-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .gx-pr-sm-3,\n  .gx-px-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .gx-pb-sm-3,\n  .gx-py-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .gx-pl-sm-3,\n  .gx-px-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .gx-p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .gx-pt-sm-4,\n  .gx-py-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .gx-pr-sm-4,\n  .gx-px-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .gx-pb-sm-4,\n  .gx-py-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .gx-pl-sm-4,\n  .gx-px-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .gx-p-sm-5 {\n    padding: 2rem !important;\n  }\n  .gx-pt-sm-5,\n  .gx-py-sm-5 {\n    padding-top: 2rem !important;\n  }\n  .gx-pr-sm-5,\n  .gx-px-sm-5 {\n    padding-right: 2rem !important;\n  }\n  .gx-pb-sm-5,\n  .gx-py-sm-5 {\n    padding-bottom: 2rem !important;\n  }\n  .gx-pl-sm-5,\n  .gx-px-sm-5 {\n    padding-left: 2rem !important;\n  }\n  .gx-m-sm-auto {\n    margin: auto !important;\n  }\n  .gx-mt-sm-auto,\n  .gx-my-sm-auto {\n    margin-top: auto !important;\n  }\n  .gx-mr-sm-auto,\n  .gx-mx-sm-auto {\n    margin-right: auto !important;\n  }\n  .gx-mb-sm-auto,\n  .gx-my-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .gx-ml-sm-auto,\n  .gx-mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 768px) {\n  .gx-m-md-0 {\n    margin: 0 !important;\n  }\n  .gx-mt-md-0,\n  .gx-my-md-0 {\n    margin-top: 0 !important;\n  }\n  .gx-mr-md-0,\n  .gx-mx-md-0 {\n    margin-right: 0 !important;\n  }\n  .gx-mb-md-0,\n  .gx-my-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .gx-ml-md-0,\n  .gx-mx-md-0 {\n    margin-left: 0 !important;\n  }\n  .gx-m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .gx-mt-md-1,\n  .gx-my-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .gx-mr-md-1,\n  .gx-mx-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .gx-mb-md-1,\n  .gx-my-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .gx-ml-md-1,\n  .gx-mx-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .gx-m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .gx-mt-md-2,\n  .gx-my-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .gx-mr-md-2,\n  .gx-mx-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .gx-mb-md-2,\n  .gx-my-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .gx-ml-md-2,\n  .gx-mx-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .gx-m-md-3 {\n    margin: 1rem !important;\n  }\n  .gx-mt-md-3,\n  .gx-my-md-3 {\n    margin-top: 1rem !important;\n  }\n  .gx-mr-md-3,\n  .gx-mx-md-3 {\n    margin-right: 1rem !important;\n  }\n  .gx-mb-md-3,\n  .gx-my-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .gx-ml-md-3,\n  .gx-mx-md-3 {\n    margin-left: 1rem !important;\n  }\n  .gx-m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .gx-mt-md-4,\n  .gx-my-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .gx-mr-md-4,\n  .gx-mx-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .gx-mb-md-4,\n  .gx-my-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .gx-ml-md-4,\n  .gx-mx-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .gx-m-md-5 {\n    margin: 3rem !important;\n  }\n  .gx-mt-md-5,\n  .gx-my-md-5 {\n    margin-top: 3rem !important;\n  }\n  .gx-mr-md-5,\n  .gx-mx-md-5 {\n    margin-right: 3rem !important;\n  }\n  .gx-mb-md-5,\n  .gx-my-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .gx-ml-md-5,\n  .gx-mx-md-5 {\n    margin-left: 3rem !important;\n  }\n  .gx-p-md-0 {\n    padding: 0 !important;\n  }\n  .gx-pt-md-0,\n  .gx-py-md-0 {\n    padding-top: 0 !important;\n  }\n  .gx-pr-md-0,\n  .gx-px-md-0 {\n    padding-right: 0 !important;\n  }\n  .gx-pb-md-0,\n  .gx-py-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .gx-pl-md-0,\n  .gx-px-md-0 {\n    padding-left: 0 !important;\n  }\n  .gx-p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .gx-pt-md-1,\n  .gx-py-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .gx-pr-md-1,\n  .gx-px-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .gx-pb-md-1,\n  .gx-py-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .gx-pl-md-1,\n  .gx-px-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .gx-p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .gx-pt-md-2,\n  .gx-py-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .gx-pr-md-2,\n  .gx-px-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .gx-pb-md-2,\n  .gx-py-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .gx-pl-md-2,\n  .gx-px-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .gx-p-md-3 {\n    padding: 1rem !important;\n  }\n  .gx-pt-md-3,\n  .gx-py-md-3 {\n    padding-top: 1rem !important;\n  }\n  .gx-pr-md-3,\n  .gx-px-md-3 {\n    padding-right: 1rem !important;\n  }\n  .gx-pb-md-3,\n  .gx-py-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .gx-pl-md-3,\n  .gx-px-md-3 {\n    padding-left: 1rem !important;\n  }\n  .gx-p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .gx-pt-md-4,\n  .gx-py-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .gx-pr-md-4,\n  .gx-px-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .gx-pb-md-4,\n  .gx-py-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .gx-pl-md-4,\n  .gx-px-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .gx-p-md-5 {\n    padding: 2rem !important;\n  }\n  .gx-pt-md-5,\n  .gx-py-md-5 {\n    padding-top: 2rem !important;\n  }\n  .gx-pr-md-5,\n  .gx-px-md-5 {\n    padding-right: 2rem !important;\n  }\n  .gx-pb-md-5,\n  .gx-py-md-5 {\n    padding-bottom: 2rem !important;\n  }\n  .gx-pl-md-5,\n  .gx-px-md-5 {\n    padding-left: 2rem !important;\n  }\n  .gx-m-md-auto {\n    margin: auto !important;\n  }\n  .gx-mt-md-auto,\n  .gx-my-md-auto {\n    margin-top: auto !important;\n  }\n  .gx-mr-md-auto,\n  .gx-mx-md-auto {\n    margin-right: auto !important;\n  }\n  .gx-mb-md-auto,\n  .gx-my-md-auto {\n    margin-bottom: auto !important;\n  }\n  .gx-ml-md-auto,\n  .gx-mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .gx-m-lg-0 {\n    margin: 0 !important;\n  }\n  .gx-mt-lg-0,\n  .gx-my-lg-0 {\n    margin-top: 0 !important;\n  }\n  .gx-mr-lg-0,\n  .gx-mx-lg-0 {\n    margin-right: 0 !important;\n  }\n  .gx-mb-lg-0,\n  .gx-my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .gx-ml-lg-0,\n  .gx-mx-lg-0 {\n    margin-left: 0 !important;\n  }\n  .gx-m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .gx-mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .gx-mr-lg-1,\n  .gx-mx-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .gx-mb-lg-1,\n  .gx-my-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .gx-ml-lg-1,\n  .gx-mx-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .gx-m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .gx-mt-lg-2,\n  .gx-my-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .gx-mr-lg-2,\n  .gx-mx-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .gx-mb-lg-2,\n  .gx-my-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .gx-ml-lg-2,\n  .gx-mx-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .gx-m-lg-3 {\n    margin: 1rem !important;\n  }\n  .gx-mt-lg-3,\n  .gx-my-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .gx-mr-lg-3,\n  .gx-mx-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .gx-mb-lg-3,\n  .gx-my-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .gx-ml-lg-3,\n  .gx-mx-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .gx-m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .gx-mt-lg-4,\n  .gx-my-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .gx-mr-lg-4,\n  .gx-mx-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .gx-mb-lg-4,\n  .gx-my-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .gx-ml-lg-4,\n  .gx-mx-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .gx-m-lg-5 {\n    margin: 3rem !important;\n  }\n  .gx-mt-lg-5,\n  .gx-my-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .gx-mr-lg-5,\n  .gx-mx-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .gx-mb-lg-5,\n  .gx-my-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .gx-ml-lg-5,\n  .gx-mx-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .gx-p-lg-0 {\n    padding: 0 !important;\n  }\n  .gx-pt-lg-0,\n  .gx-py-lg-0 {\n    padding-top: 0 !important;\n  }\n  .gx-pr-lg-0,\n  .gx-px-lg-0 {\n    padding-right: 0 !important;\n  }\n  .gx-pb-lg-0,\n  .gx-py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .gx-pl-lg-0,\n  .gx-px-lg-0 {\n    padding-left: 0 !important;\n  }\n  .gx-p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .gx-pt-lg-1,\n  .gx-py-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .gx-pr-lg-1,\n  .gx-px-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .gx-pb-lg-1,\n  .gx-py-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .gx-pl-lg-1,\n  .gx-px-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .gx-p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .gx-pt-lg-2,\n  .gx-py-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .gx-pr-lg-2,\n  .gx-px-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .gx-pb-lg-2,\n  .gx-py-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .gx-pl-lg-2,\n  .gx-px-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .gx-p-lg-3 {\n    padding: 1rem !important;\n  }\n  .gx-pt-lg-3,\n  .gx-py-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .gx-pr-lg-3,\n  .gx-px-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .gx-pb-lg-3,\n  .gx-py-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .gx-pl-lg-3,\n  .gx-px-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .gx-p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .gx-pt-lg-4,\n  .gx-py-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .gx-pr-lg-4,\n  .gx-px-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .gx-pb-lg-4,\n  .gx-py-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .gx-pl-lg-4,\n  .gx-px-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .gx-p-lg-5 {\n    padding: 2rem !important;\n  }\n  .gx-pt-lg-5,\n  .gx-py-lg-5 {\n    padding-top: 2rem !important;\n  }\n  .gx-pr-lg-5,\n  .gx-px-lg-5 {\n    padding-right: 2rem !important;\n  }\n  .gx-pb-lg-5,\n  .gx-py-lg-5 {\n    padding-bottom: 2rem !important;\n  }\n  .gx-pl-lg-5,\n  .gx-px-lg-5 {\n    padding-left: 2rem !important;\n  }\n  .gx-m-lg-auto {\n    margin: auto !important;\n  }\n  .gx-mt-lg-auto,\n  .gx-my-lg-auto {\n    margin-top: auto !important;\n  }\n  .gx-mr-lg-auto,\n  .gx-mx-lg-auto {\n    margin-right: auto !important;\n  }\n  .gx-mb-lg-auto,\n  .gx-my-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .gx-ml-lg-auto,\n  .gx-mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 1200px) {\n  .gx-m-xl-0 {\n    margin: 0 !important;\n  }\n  .gx-mt-xl-0,\n  .gx-my-xl-0 {\n    margin-top: 0 !important;\n  }\n  .gx-mr-xl-0,\n  .gx-mx-xl-0 {\n    margin-right: 0 !important;\n  }\n  .gx-mb-xl-0,\n  .gx-my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .gx-ml-xl-0,\n  .gx-mx-xl-0 {\n    margin-left: 0 !important;\n  }\n  .gx-m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .gx-mt-xl-1,\n  .gx-my-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .gx-mr-xl-1,\n  .gx-mx-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .gx-mb-xl-1,\n  .gx-my-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .gx-ml-xl-1,\n  .gx-mx-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .gx-m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .gx-mt-xl-2,\n  .gx-my-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .gx-mr-xl-2,\n  .gx-mx-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .gx-mb-xl-2,\n  .gx-my-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .gx-ml-xl-2,\n  .gx-mx-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .gx-m-xl-3 {\n    margin: 1rem !important;\n  }\n  .gx-mt-xl-3,\n  .gx-my-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .gx-mr-xl-3,\n  .gx-mx-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .gx-mb-xl-3,\n  .gx-my-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .gx-ml-xl-3,\n  .gx-mx-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .gx-m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .gx-mt-xl-4,\n  .gx-my-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .gx-mr-xl-4,\n  .gx-mx-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .gx-mb-xl-4,\n  .gx-my-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .gx-ml-xl-4,\n  .gx-mx-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .gx-m-xl-5 {\n    margin: 3rem !important;\n  }\n  .gx-mt-xl-5,\n  .gx-my-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .gx-mr-xl-5,\n  .gx-mx-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .gx-mb-xl-5,\n  .gx-my-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .gx-ml-xl-5,\n  .gx-mx-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .gx-p-xl-0 {\n    padding: 0 !important;\n  }\n  .gx-pt-xl-0,\n  .gx-py-xl-0 {\n    padding-top: 0 !important;\n  }\n  .gx-pr-xl-0,\n  .gx-px-xl-0 {\n    padding-right: 0 !important;\n  }\n  .gx-pb-xl-0,\n  .gx-py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .gx-pl-xl-0,\n  .gx-px-xl-0 {\n    padding-left: 0 !important;\n  }\n  .gx-p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .gx-pt-xl-1,\n  .gx-py-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .gx-pr-xl-1,\n  .gx-px-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .gx-pb-xl-1,\n  .gx-py-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .gx-pl-xl-1,\n  .gx-px-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .gx-p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .gx-pt-xl-2,\n  .gx-py-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .gx-pr-xl-2,\n  .gx-px-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .gx-pb-xl-2,\n  .gx-py-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .gx-pl-xl-2,\n  .gx-px-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .gx-p-xl-3 {\n    padding: 1rem !important;\n  }\n  .gx-pt-xl-3,\n  .gx-py-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .gx-pr-xl-3,\n  .gx-px-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .gx-pb-xl-3,\n  .gx-py-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .gx-pl-xl-3,\n  .gx-px-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .gx-p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .gx-pt-xl-4,\n  .gx-py-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .gx-pr-xl-4,\n  .gx-px-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .gx-pb-xl-4,\n  .gx-py-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .gx-pl-xl-4,\n  .gx-px-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .gx-p-xl-5 {\n    padding: 2rem !important;\n  }\n  .gx-pt-xl-5,\n  .gx-py-xl-5 {\n    padding-top: 2rem !important;\n  }\n  .gx-pr-xl-5,\n  .gx-px-xl-5 {\n    padding-right: 2rem !important;\n  }\n  .gx-pb-xl-5,\n  .gx-py-xl-5 {\n    padding-bottom: 2rem !important;\n  }\n  .gx-pl-xl-5,\n  .gx-px-xl-5 {\n    padding-left: 2rem !important;\n  }\n  .gx-m-xl-auto {\n    margin: auto !important;\n  }\n  .gx-mt-xl-auto,\n  .gx-my-xl-auto {\n    margin-top: auto !important;\n  }\n  .gx-mr-xl-auto,\n  .gx-mx-xl-auto {\n    margin-right: auto !important;\n  }\n  .gx-mb-xl-auto,\n  .gx-my-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .gx-ml-xl-auto,\n  .gx-mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 1368px) {\n  .gx-m-xxl-0 {\n    margin: 0 !important;\n  }\n  .gx-mt-xxl-0,\n  .gx-my-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .gx-mr-xxl-0,\n  .gx-mx-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .gx-mb-xxl-0,\n  .gx-my-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .gx-ml-xxl-0,\n  .gx-mx-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .gx-m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .gx-mt-xxl-1,\n  .gx-my-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .gx-mr-xxl-1,\n  .gx-mx-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .gx-mb-xxl-1,\n  .gx-my-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .gx-ml-xxl-1,\n  .gx-mx-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .gx-m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .gx-mt-xxl-2,\n  .gx-my-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .gx-mr-xxl-2,\n  .gx-mx-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .gx-mb-xxl-2,\n  .gx-my-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .gx-ml-xxl-2,\n  .gx-mx-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .gx-m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .gx-mt-xxl-3,\n  .gx-my-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .gx-mr-xxl-3,\n  .gx-mx-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .gx-mb-xxl-3,\n  .gx-my-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .gx-ml-xxl-3,\n  .gx-mx-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .gx-m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .gx-mt-xxl-4,\n  .gx-my-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .gx-mr-xxl-4,\n  .gx-mx-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .gx-mb-xxl-4,\n  .gx-my-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .gx-ml-xxl-4,\n  .gx-mx-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .gx-m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .gx-mt-xxl-5,\n  .gx-my-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .gx-mr-xxl-5,\n  .gx-mx-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .gx-mb-xxl-5,\n  .gx-my-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .gx-ml-xxl-5,\n  .gx-mx-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .gx-p-xxl-0 {\n    padding: 0 !important;\n  }\n  .gx-pt-xxl-0,\n  .gx-py-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .gx-pr-xxl-0,\n  .gx-px-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .gx-pb-xxl-0,\n  .gx-py-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .gx-pl-xxl-0,\n  .gx-px-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .gx-p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .gx-pt-xxl-1,\n  .gx-py-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .gx-pr-xxl-1,\n  .gx-px-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .gx-pb-xxl-1,\n  .gx-py-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .gx-pl-xxl-1,\n  .gx-px-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .gx-p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .gx-pt-xxl-2,\n  .gx-py-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .gx-pr-xxl-2,\n  .gx-px-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .gx-pb-xxl-2,\n  .gx-py-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .gx-pl-xxl-2,\n  .gx-px-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .gx-p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .gx-pt-xxl-3,\n  .gx-py-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .gx-pr-xxl-3,\n  .gx-px-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .gx-pb-xxl-3,\n  .gx-py-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .gx-pl-xxl-3,\n  .gx-px-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .gx-p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .gx-pt-xxl-4,\n  .gx-py-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .gx-pr-xxl-4,\n  .gx-px-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .gx-pb-xxl-4,\n  .gx-py-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .gx-pl-xxl-4,\n  .gx-px-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .gx-p-xxl-5 {\n    padding: 2rem !important;\n  }\n  .gx-pt-xxl-5,\n  .gx-py-xxl-5 {\n    padding-top: 2rem !important;\n  }\n  .gx-pr-xxl-5,\n  .gx-px-xxl-5 {\n    padding-right: 2rem !important;\n  }\n  .gx-pb-xxl-5,\n  .gx-py-xxl-5 {\n    padding-bottom: 2rem !important;\n  }\n  .gx-pl-xxl-5,\n  .gx-px-xxl-5 {\n    padding-left: 2rem !important;\n  }\n  .gx-m-xxl-auto {\n    margin: auto !important;\n  }\n  .gx-mt-xxl-auto,\n  .gx-my-xxl-auto {\n    margin-top: auto !important;\n  }\n  .gx-mr-xxl-auto,\n  .gx-mx-xxl-auto {\n    margin-right: auto !important;\n  }\n  .gx-mb-xxl-auto,\n  .gx-my-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .gx-ml-xxl-auto,\n  .gx-mx-xxl-auto {\n    margin-left: auto !important;\n  }\n}\n/*Typography Styles*/\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  color: #262626;\n  font-weight: 400;\n  line-height: 1.2;\n}\nh1,\n.h1 {\n  font-size: 22px;\n}\n.framed-layout h1,\n.framed-layout .h1 {\n  font-size: 20px;\n}\n@media screen and (max-width: 767px) {\n  .framed-layout h1,\n  .framed-layout .h1 {\n    font-size: 18px;\n  }\n}\n.boxed-layout h1,\n.boxed-layout .h1 {\n  font-size: 18px;\n}\n@media screen and (max-width: 767px) {\n  .boxed-layout h1,\n  .boxed-layout .h1 {\n    font-size: 16px;\n  }\n}\n@media screen and (min-width: 1600px) {\n  h1,\n  .h1 {\n    font-size: 28px;\n  }\n  .boxed-layout h1,\n  .boxed-layout .h1 {\n    font-size: 18px;\n  }\n}\nh2,\n.h2 {\n  font-size: 20px;\n}\nh3,\n.h3 {\n  font-size: 18px;\n}\nh4,\n.h4 {\n  font-size: 16px;\n}\nh5,\n.h5 {\n  font-size: 14px;\n}\nh6,\n.h6 {\n  font-size: 12px;\n}\n.gx-h1-lg {\n  font-size: 28px;\n}\n.gx-text-strikethrough {\n  text-decoration: line-through !important;\n}\n.gx-text-underline {\n  text-decoration: underline !important;\n}\n/*Font size Classes*/\n/*8px*/\n.gx-fs-xxs {\n  font-size: 8px;\n}\n/*10px*/\n.gx-fs-xs {\n  font-size: 10px;\n}\n/*11px*/\n.gx-fs-11 {\n  font-size: 11px;\n}\n/*12px*/\n.gx-fs-sm {\n  font-size: 12px;\n  line-height: 1.5;\n}\n/*14px*/\n.gx-fs-md {\n  font-size: 14px;\n  line-height: 1;\n}\n/*16px*/\n.gx-fs-lg {\n  font-size: 16px;\n  line-height: 1;\n}\n/*20px*/\n.gx-fs-xl {\n  font-size: 20px;\n  line-height: 1;\n}\n/*24px*/\n.gx-fs-xxl {\n  font-size: 24px;\n  line-height: 1.3;\n}\n@media screen and (max-width: 1199px) {\n  .gx-fs-xxl {\n    font-size: 20px;\n  }\n}\n/*28px*/\n.gx-fs-2xl {\n  font-size: 28px !important;\n  line-height: 1;\n}\n@media screen and (max-width: 1199px) {\n  .gx-fs-2xl {\n    font-size: 20px !important;\n  }\n}\n/*30px*/\n.gx-fs-xxxl {\n  font-size: 30px;\n  line-height: 1;\n}\n@media screen and (max-width: 1366px) {\n  .gx-fs-xxxl {\n    font-size: 28px;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-fs-xxxl {\n    font-size: 26px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-fs-xxxl {\n    font-size: 24px;\n  }\n}\n/*40px*/\n.gx-fs-xlxl {\n  font-size: 40px;\n  line-height: 1;\n}\n@media screen and (max-width: 1199px) {\n  .gx-fs-xlxl {\n    font-size: 32px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-fs-xlxl {\n    font-size: 28px;\n  }\n}\n/*50px*/\n.gx-fs-icon-lg {\n  font-size: 50px;\n  line-height: 1;\n}\n@media screen and (max-width: 1366px) {\n  .gx-fs-icon-lg {\n    font-size: 38px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-fs-icon-lg {\n    font-size: 30px;\n  }\n}\n/*54px*/\n.gx-fs-iconcard {\n  font-size: 54px;\n  line-height: 1;\n}\n@media screen and (max-width: 1366px) {\n  .gx-fs-iconcard {\n    font-size: 34px;\n  }\n}\n.gx-text-lowercase {\n  text-transform: lowercase;\n}\n.gx-text-uppercase {\n  text-transform: uppercase;\n}\n.gx-text-capitalize {\n  text-transform: capitalize;\n}\n.gx-font-weight-light {\n  font-weight: 300;\n}\n.gx-font-weight-normal {\n  font-weight: 400;\n}\n.gx-font-weight-medium {\n  font-weight: 500;\n}\n.gx-font-weight-semi-bold {\n  font-weight: 600;\n}\n.gx-font-weight-bold {\n  font-weight: 700;\n}\n.gx-font-weight-heavy {\n  font-weight: 900;\n}\n.gx-font-italic {\n  font-style: italic;\n}\n.gx-letter-spacing-base {\n  letter-spacing: 3px;\n}\n.gx-letter-spacing-lg {\n  letter-spacing: 6px;\n}\n.gx-letter-spacing-xl {\n  letter-spacing: 8px;\n}\n.gx-text-justify {\n  text-align: justify !important;\n}\n.gx-text-nowrap {\n  white-space: nowrap !important;\n}\n.gx-text-left {\n  text-align: left !important;\n}\n.gx-text-right {\n  text-align: right !important;\n}\n.gx-text-center {\n  text-align: center !important;\n}\n.gx-text-truncate {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n/* Ant Layout Style */\n.ant-layout {\n  position: relative;\n  background: none;\n}\n.ant-layout > .gx-layout-content {\n  overflow-x: hidden;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.full-scroll .ant-layout > .gx-layout-content {\n  overflow-x: inherit;\n}\n.ant-layout.ant-layout-has-sider > .ant-layout {\n  position: relative;\n  background: #f5f5f5;\n}\n.framed-layout .ant-layout,\n.boxed-layout .ant-layout {\n  background: #f5f5f5;\n}\n.framed-layout .ant-layout,\n.boxed-layout .ant-layout {\n  background: #f5f5f5;\n}\n.ant-layout.gx-app-layout {\n  height: 100vh;\n}\n.framed-layout .ant-layout.gx-app-layout {\n  height: calc(100vh - 2 * 20px);\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-layout.gx-app-layout {\n    height: 100vh;\n  }\n}\n.framed-layout.full-scroll .ant-layout.gx-app-layout,\n.boxed-layout.full-scroll .ant-layout.gx-app-layout {\n  overflow-y: scroll;\n}\n.ant-layout.gx-app-layout > .ant-layout {\n  height: 100vh;\n}\n.framed-layout .ant-layout.gx-app-layout > .ant-layout {\n  height: calc(100vh - 2 * 20px);\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-layout.gx-app-layout > .ant-layout {\n    height: 100vh;\n  }\n}\n.full-scroll .ant-layout.ant-layout-has-sider > .ant-layout,\n.full-scroll .ant-layout.ant-layout-has-sider > .ant-layout-content {\n  overflow-x: inherit;\n}\n.gx-main-content-wrapper {\n  top: 0;\n  left: 0;\n  padding: 32px 16px 0;\n  flex: 1;\n}\n@media screen and (max-width: 575px) {\n  .gx-main-content-wrapper {\n    padding: 20px 15px 0;\n  }\n}\n.gx-container-wrap .gx-main-content-wrapper {\n  width: 94vw;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n@media screen and (min-width: 768px) {\n  .gx-container-wrap .gx-main-content-wrapper {\n    width: 720px;\n  }\n}\n@media screen and (min-width: 992px) {\n  .gx-container-wrap .gx-main-content-wrapper {\n    width: 920px;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .gx-container-wrap .gx-main-content-wrapper {\n    width: 1100px;\n  }\n}\n@media screen and (min-width: 1367px) {\n  .gx-container-wrap .gx-main-content-wrapper {\n    width: 1200px;\n  }\n}\n@media screen and (min-width: 1600px) {\n  .gx-container-wrap .gx-main-content-wrapper {\n    width: 1400px;\n  }\n}\n.gx-main-content {\n  height: 100%;\n}\n.gx-container {\n  width: 94vw;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n@media screen and (min-width: 768px) {\n  .gx-container {\n    width: 720px;\n  }\n}\n@media screen and (min-width: 992px) {\n  .gx-container {\n    width: 920px;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .gx-container {\n    width: 1100px;\n  }\n}\n@media screen and (min-width: 1367px) {\n  .gx-container {\n    width: 1200px;\n  }\n}\n@media screen and (min-width: 1600px) {\n  .gx-container {\n    width: 1400px;\n  }\n}\n/* Header Style */\n.ant-layout-header {\n  -webkit-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  -moz-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n  line-height: 1;\n  padding: 0 32px;\n  height: 72px;\n  position: relative;\n  z-index: 10;\n  color: #262626;\n}\n@media screen and (max-width: 991px) {\n  .ant-layout-header {\n    padding: 0 15px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-layout-header {\n    height: 50px;\n  }\n}\n.gx-nav-header {\n  padding: 0 32px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n  background-color: #fefefe;\n}\n.gx-nav-header .ant-menu-horizontal {\n  margin-bottom: -1px;\n  border-bottom-color: transparent;\n}\n.gx-nav-header-below {\n  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);\n  -moz-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);\n  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);\n  position: relative;\n  z-index: 999;\n}\n.ant-dropdown-menu-item {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-linebar {\n  font-size: 20px;\n}\n.gx-header-horizontal-dark .gx-linebar {\n  color: #ffffff;\n}\n.gx-header-notifications {\n  list-style: none;\n  margin: 0;\n  padding-left: 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-header-notifications > li {\n  font-size: 18px;\n}\n.gx-header-notifications > li:not(:last-child) {\n  margin-right: 42px;\n}\n.gx-inside-header-horizontal .gx-header-notifications > li:not(:last-child) {\n  margin-right: 20px;\n}\n.gx-header-horizontal-main .gx-header-notifications > li:not(:last-child),\n.gx-header-horizontal-nav .gx-header-notifications > li:not(:last-child) {\n  margin-right: 30px;\n}\n@media screen and (max-width: 991px) {\n  .gx-header-horizontal-main .gx-header-notifications > li:not(:last-child),\n  .gx-header-horizontal-nav .gx-header-notifications > li:not(:last-child) {\n    margin-right: 16px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-header-notifications > li:not(:last-child) {\n    margin-right: 16px;\n  }\n}\n.gx-header-notifications > li.gx-notify {\n  margin-right: 22px;\n}\n.gx-header-horizontal-main .gx-header-notifications > li.gx-notify {\n  margin-right: 30px;\n}\n@media screen and (max-width: 991px) {\n  .gx-header-horizontal-main .gx-header-notifications > li.gx-notify {\n    margin-right: 16px;\n  }\n}\n.gx-inside-header-horizontal .gx-header-notifications > li.gx-notify {\n  margin-right: 20px;\n}\n@media screen and (max-width: 991px) {\n  .gx-header-notifications > li.gx-notify {\n    margin-right: 16px;\n  }\n}\n.gx-header-notifications > li.gx-language {\n  font-size: 14px;\n}\n@media screen and (max-width: 575px) {\n  .gx-header-notifications > li.gx-language .gx-language-name,\n  .gx-header-notifications > li.gx-language .icon {\n    display: none;\n  }\n  .gx-header-notifications > li.gx-language .flag.flag-24 {\n    width: 20px;\n    height: 20px;\n    margin-top: -4px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-header-notifications > li.gx-notify,\n  .gx-header-notifications > li.gx-msg {\n    margin-top: 2px;\n  }\n  .gx-header-notifications > li.gx-language {\n    margin-bottom: 2px;\n  }\n}\n.gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {\n  margin-left: 50px;\n}\n@media screen and (max-width: 991px) {\n  .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {\n    margin-left: 0;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-inside-header-horizontal .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {\n    margin-left: 0;\n  }\n}\n.gx-header-horizontal-main .gx-header-notifications li > span {\n  color: #545454;\n}\n.gx-header-horizontal-dark .gx-header-horizontal-main .gx-header-notifications li > span {\n  color: var(--app-secondary-color);\n}\n.gx-popover-scroll {\n  height: 280px !important;\n  width: 300px !important;\n  margin: 0 -16px;\n}\n@media screen and (max-width: 575px) {\n  .gx-popover-scroll {\n    height: 280px !important;\n    width: 200px !important;\n  }\n}\n.gx-popover-lang-scroll {\n  height: 220px !important;\n  width: 160px !important;\n  margin: 0 -16px;\n}\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  right: 10px;\n}\n.gx-popover-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n  border-bottom: solid 1px #e8e8e8;\n  margin: 0 -16px;\n  padding: 0 16px 12px;\n}\n.gx-sub-popover {\n  list-style: none;\n  margin: 0 16px;\n  padding-left: 0;\n}\n.gx-sub-popover li {\n  padding: 20px 0 14px;\n}\n.gx-popover-lang-scroll .gx-sub-popover li {\n  padding: 5px 0;\n}\n.gx-sub-popover li:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-user-popover {\n  margin: -12px -16px;\n  padding: 7px 0;\n  list-style: none;\n}\n.gx-user-popover li {\n  cursor: pointer;\n  padding: 3px 15px;\n  width: 150px;\n}\n.gx-user-popover li:hover,\n.gx-user-popover li:focus {\n  background-color: #fafafa;\n}\n@media screen and (max-width: 575px) {\n  .gx-user-popover li {\n    width: 100%;\n  }\n}\n.gx-header-horizontal {\n  position: relative;\n  color: var(--app-secondary-color);\n  background-color: #ffffff;\n}\n.gx-header-horizontal-dark {\n  position: relative;\n  background-color: var(--app-primary-color);\n  color: var(--app-secondary-color);\n}\n.gx-header-horizontal-dark:before {\n  content: '';\n  position: absolute;\n  right: 169px;\n  top: -212px;\n  background-color: rgba(255, 255, 255, 0.2);\n  width: 280px;\n  height: 350px;\n  -webkit-border-radius: 0 0 135px 135px;\n  -moz-border-radius: 0 0 135px 135px;\n  border-radius: 0 0 135px 135px;\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  transform: rotate(45deg);\n  z-index: 1;\n}\n@media screen and (max-width: 1049px) {\n  .gx-header-horizontal-dark:before {\n    right: 110px;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-header-horizontal-dark:before {\n    top: -184px;\n    right: 80px;\n    height: 300px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-header-horizontal-dark:before {\n    top: -154px;\n    right: 140px;\n    height: 240px;\n    width: 200px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-header-horizontal-dark:before {\n    right: 60px;\n    display: none;\n  }\n}\n.gx-header-horizontal-dark > div {\n  position: relative;\n  z-index: 2;\n}\n.gx-header-horizontal-top {\n  padding: 12px 0;\n  font-size: 14px;\n}\n.gx-header-horizontal-top-flex,\n.gx-header-horizontal-nav-flex,\n.gx-header-horizontal-main-flex {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-header-horizontal-top-left {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin-right: 15px;\n}\n@media screen and (max-width: 767px) {\n  .gx-header-horizontal-top-left {\n    margin-right: 0;\n    width: 100%;\n  }\n}\n.gx-header-horizontal-main {\n  display: -webkit-block;\n  display: -ms-blockbox;\n  display: -ms-block;\n  display: block;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  padding: 25px 0 35px;\n  height: auto;\n  background-color: transparent;\n}\n@media screen and (max-width: 1199px) {\n  .gx-header-horizontal-main {\n    padding: 20px 0;\n  }\n  .gx-header-horizontal-main .gx-w-logo {\n    padding: 7px 5px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-header-horizontal-main {\n    padding: 0;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-header-horizontal-main .gx-w-logo {\n    padding-right: 0;\n  }\n}\n.gx-inside-header-horizontal .gx-header-horizontal-main {\n  padding: 0;\n}\n.gx-header-horizontal-nav {\n  background-color: var(--app-primary-color);\n  color: #fffffd;\n}\n.gx-header-horizontal-dark .gx-header-horizontal-nav {\n  background-color: transparent;\n}\n.gx-below-header-horizontal .gx-header-horizontal-nav,\n.gx-above-header-horizontal .gx-header-horizontal-nav {\n  background-color: #fefefe;\n  color: #7a7a7a;\n}\n.gx-inside-header-horizontal .gx-logo {\n  margin-right: 25px;\n}\n.gx-inside-header-horizontal:before {\n  top: -230px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-inside-header-horizontal:before {\n    top: -190px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-inside-header-horizontal:before {\n    top: -154px;\n  }\n}\n.gx-above-header-horizontal:before {\n  top: -165px;\n}\n@media screen and (max-width: 991px) {\n  .gx-above-header-horizontal:before {\n    top: -154px;\n  }\n}\n.gx-login-list {\n  list-style: none;\n  margin-left: auto;\n  margin-bottom: 0;\n  padding-left: 0;\n}\n.gx-login-list li {\n  padding: 0 10px;\n  text-transform: uppercase;\n  color: var(--app-secondary-color);\n  font-size: 12px;\n  line-height: 12px;\n  display: inline-block;\n  cursor: pointer;\n}\n.gx-login-list li:not(:first-child) {\n  border-left: solid 1px #e8e8e8;\n}\n.gx-header-horizontal-dark .gx-login-list li:not(:first-child) {\n  border: 0 none;\n}\n@media screen and (max-width: 767px) {\n  .gx-login-list {\n    display: none;\n  }\n}\n.gx-header-search {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin-left: 28px;\n}\n.gx-header-search .ant-select-selection,\n.gx-header-search .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  -webkit-border-radius: 0 4px 4px 0;\n  -moz-border-radius: 0 4px 4px 0;\n  border-radius: 0 4px 4px 0;\n  background-color: var(--app-primary-color);\n  border-color: var(--app-primary-color);\n  color: #fffffd;\n  margin-bottom: 0;\n}\n.gx-header-search .ant-select-selection:focus,\n.gx-header-search .ant-select-single:not(.ant-select-customize-input) .ant-select-selector:focus {\n  background-color: var(--app-primary-color);\n  border-color: var(--app-primary-color);\n  color: #fffffd;\n}\n.gx-header-horizontal-dark .gx-header-search .ant-select-selection,\n.gx-header-horizontal-dark .gx-header-search .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  color: #fffffd;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.2);\n  margin-left: 1px;\n}\n.gx-header-horizontal-dark .gx-header-search .ant-select-selection:focus,\n.gx-header-horizontal-dark .gx-header-search .ant-select-single:not(.ant-select-customize-input) .ant-select-selector:focus {\n  color: #fffffd;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.gx-header-search .ant-select-arrow {\n  color: #fffffd;\n}\n.gx-popover-horizantal .ant-btn {\n  margin: 0 !important;\n  border: 0 none;\n  border-right: solid 1px #e8e8e8;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n  height: 24px;\n  line-height: 24px;\n}\n.gx-popover-horizantal .gx-popover-search-bar {\n  margin: 0;\n}\n.gx-popover-horizantal .gx-popover-search-bar .ant-input {\n  height: 24px;\n  line-height: 24px;\n}\n@media screen and (max-width: 575px) {\n  .gx-popover-horizantal {\n    left: 0 !important;\n    padding-top: 0;\n    margin-top: -9px;\n  }\n  .gx-popover-horizantal .ant-popover-inner-content {\n    width: 100vw;\n  }\n  .gx-popover-horizantal .ant-popover-arrow {\n    display: none;\n  }\n  .gx-popover-horizantal .gx-popover-search-bar {\n    width: 100%;\n  }\n  .gx-popover-horizantal .gx-popover-scroll,\n  .gx-popover-horizantal .gx-popover-lang-scroll {\n    width: 100% !important;\n    margin: 0;\n  }\n  .gx-popover-horizantal .gx-sub-popover {\n    margin: 0;\n    padding-left: 5px;\n  }\n}\n.gx-no-header-horizontal {\n  padding: 14px 32px 13px 79px;\n  text-align: center;\n  position: relative;\n}\n.gx-no-header-horizontal-top {\n  padding: 10px 20px;\n  background-color: #d9f7be;\n  color: #237804;\n  border-radius: 4px;\n  display: inline-block;\n}\n@media screen and (max-width: 575px) {\n  .gx-no-header-horizontal-top {\n    width: 100%;\n    font-size: 12px;\n  }\n}\n.gx-no-header-horizontal-top-center {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-no-header-horizontal .gx-linebar {\n  position: absolute;\n  left: 32px;\n  top: 15px;\n  z-index: 1;\n}\n@media screen and (max-width: 575px) {\n  .gx-no-header-horizontal .gx-linebar {\n    left: 15px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-no-header-horizontal {\n    padding: 14px 15px 13px 60px;\n  }\n}\n/* Sidebar Style */\n.gx-app-sidebar {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  -ms-transition: all 0.2s ease;\n  -o-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.ant-layout-sider {\n  background-color: #fffffc;\n  color: #545454;\n  flex: 0 0 auto !important;\n  max-width: none !important;\n  min-width: 10px !important;\n  width: 240px !important;\n  overflow: hidden;\n}\n@media screen and (max-width: 1366px) {\n  .ant-layout-sider {\n    width: 200px !important;\n  }\n}\n.ant-layout-sider-collapsed {\n  width: 80px !important;\n}\n@media screen and (max-width: 991px) {\n  .ant-layout-sider-collapsed.gx-mini-custom-sidebar {\n    width: 0 !important;\n    min-width: 0 !important;\n  }\n}\n.ant-layout-sider.gx-collapsed-sidebar {\n  width: 0 !important;\n  min-width: 0 !important;\n}\n@media screen and (max-width: 991px) {\n  .ant-layout-sider {\n    width: 0 !important;\n    min-width: 0 !important;\n  }\n}\n.gx-layout-sider-dark {\n  background-color: var(--app-primary-color);\n  color: #ffffff;\n}\n.gx-layout-sider-header {\n  padding: 10px 30px 10px 70px;\n  height: 72px;\n  -webkit-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  -moz-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  position: relative;\n  z-index: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media screen and (max-width: 575px) {\n  .gx-layout-sider-header {\n    height: 50px;\n  }\n}\n.gx-layout-sider-header .gx-site-logo {\n  display: block;\n}\n.ant-layout-sider-collapsed .gx-layout-sider-header .gx-site-logo {\n  display: none;\n}\n.gx-mini-custom-sidebar .gx-layout-sider-header .gx-site-logo {\n  display: block;\n}\n.gx-layout-sider-header .gx-linebar {\n  position: absolute;\n  left: 20px;\n  z-index: 1;\n  top: 15px;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n}\n.ant-layout-sider-collapsed .gx-layout-sider-header .gx-linebar {\n  left: 20px;\n}\n@media screen and (max-width: 991px) {\n  .gx-layout-sider-header .gx-linebar {\n    display: none;\n  }\n}\n.ant-layout-sider-collapsed .gx-layout-sider-header {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.gx-drawer-sidebar .gx-layout-sider-header {\n  padding-left: 30px;\n}\n.gx-drawer-sidebar-dark .gx-layout-sider-header {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.gx-layout-sider-dark .gx-layout-sider-header {\n  background-color: rgba(0, 0, 0, 0.3);\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n}\n.gx-mini-custom-sidebar .gx-layout-sider-header {\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  background-color: transparent;\n}\n.gx-custom-sidebar .gx-layout-sider-header {\n  padding-left: 30px;\n  background-color: transparent;\n}\n.gx-mini-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header,\n.gx-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  border-right: 1px solid #e8e8e8;\n}\n@media screen and (max-width: 991px) {\n  .gx-layout-sider-header {\n    padding-left: 30px;\n  }\n}\n.gx-sidebar-content {\n  border-right: 1px solid #e8e8e8;\n}\n.gx-layout-sider-dark .gx-sidebar-content,\n.gx-drawer-sidebar-dark .gx-sidebar-content {\n  border-right: 0 none;\n}\n.gx-layout-sider-scrollbar {\n  height: calc(100vh - 72px - 145px) !important;\n}\n.framed-layout .gx-layout-sider-scrollbar {\n  height: calc(100vh - 72px - 2 * 20px - 145px) !important;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .gx-layout-sider-scrollbar {\n    height: calc(100vh - 72px) !important;\n  }\n}\n.ant-layout-sider-collapsed .gx-layout-sider-scrollbar {\n  height: calc(100vh - 72px - 91px) !important;\n}\n.framed-layout .ant-layout-sider-collapsed .gx-layout-sider-scrollbar {\n  height: calc(100vh - 72px - 2 * 20px - 91px) !important;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-layout-sider-collapsed .gx-layout-sider-scrollbar {\n    height: calc(100vh - 72px) !important;\n  }\n}\n@media screen and (max-width: 991px) {\n  .ant-layout-sider-collapsed .gx-layout-sider-scrollbar {\n    height: calc(100vh - 72px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-layout-sider-collapsed .gx-layout-sider-scrollbar {\n    height: calc(100vh - 50px) !important;\n  }\n}\n.gx-mini-custom-sidebar .gx-layout-sider-scrollbar {\n  height: calc(100vh - 72px - 206px) !important;\n}\n.framed-layout .gx-mini-custom-sidebar .gx-layout-sider-scrollbar {\n  height: calc(100vh - 72px - 2 * 20px - 206px) !important;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .gx-mini-custom-sidebar .gx-layout-sider-scrollbar {\n    height: calc(100vh - 72px) !important;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-layout-sider-scrollbar {\n    height: calc(100vh - 72px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-layout-sider-scrollbar {\n    height: calc(100vh - 50px) !important;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-no-header-notifications + .gx-layout-sider-scrollbar {\n    height: calc(100vh - 72px - 145px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-no-header-notifications + .gx-layout-sider-scrollbar {\n    height: calc(100vh - 50px - 145px) !important;\n  }\n}\n.gx-sidebar-notifications {\n  padding: 30px 10px 10px;\n  margin: 0 20px 10px;\n  border-bottom: solid 1px #e8e8e8;\n}\n.ant-layout-sider-dark .gx-sidebar-notifications,\n.gx-drawer-sidebar-dark .gx-sidebar-notifications {\n  border-bottom-color: #ffffff;\n}\n@media screen and (max-width: 991px) {\n  .gx-sidebar-notifications {\n    display: none;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-sidebar-notifications.gx-no-header-notifications {\n    display: block;\n  }\n}\n.gx-app-nav {\n  list-style: none;\n  padding-left: 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin: 0 -20px;\n  color: var(--app-primary-color);\n}\n.ant-layout-sider-dark .gx-app-nav,\n.gx-drawer-sidebar-dark .gx-app-nav {\n  color: #ffffff;\n}\n.gx-app-nav li {\n  padding: 0 20px;\n  font-size: 20px;\n}\n.gx-app-nav li .icon {\n  cursor: pointer;\n}\n.ant-layout-sider-collapsed .gx-app-nav {\n  display: none;\n}\n.gx-mini-custom-sidebar .gx-app-nav {\n  display: block;\n  margin-top: 15px;\n}\n.gx-mini-custom-sidebar .gx-app-nav li:not(:last-child) {\n  margin-bottom: 5px;\n}\n.gx-avatar-name {\n  cursor: pointer;\n}\n.ant-layout-sider-collapsed .gx-avatar-name {\n  display: none;\n}\n.ant-layout-sider-collapsed .gx-avatar-row {\n  margin-bottom: 0 !important;\n}\n.gx-avatar-row .ant-avatar {\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  position: relative;\n  left: 0;\n}\n.ant-layout-sider-collapsed .gx-avatar-row .ant-avatar {\n  margin: 0 !important;\n  left: -10px;\n}\n.gx-menu-group .ant-menu-item-group-title {\n  font-size: 16px;\n  padding-top: 30px !important;\n}\n.gx-layouts-view .gx-pointer {\n  display: block;\n  margin-bottom: 15px;\n}\n.gx-layouts-view .gx-pointer img {\n  width: 100%;\n}\n.gx-layouts-view .gx-pointer.active {\n  box-shadow: 0 0 10px 0 var(--app-primary-color);\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  border-radius: 8px;\n}\n/* Ant Menu Style */\n.ant-menu {\n  color: #545454;\n  background: #fff;\n}\n.ant-menu-horizontal {\n  background: none;\n}\n.ant-menu-item-group-title {\n  color: #545454;\n  font-size: 11px;\n  line-height: 1.3;\n  padding: 10px 30px;\n}\n.ant-menu-submenu-popup .ant-menu-item-group-title {\n  padding-left: 20px;\n}\n.ant-layout-sider .ant-menu-item-group-title {\n  padding-top: 40px;\n}\n.ant-menu-item:active,\n.ant-menu-submenu-title:active {\n  background: #908b94;\n}\n.ant-menu-item .icon {\n  min-width: 14px;\n  margin-right: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-item .icon[class*=\" icon-\"]::before {\n  position: relative;\n  top: 2px;\n}\n.ant-menu-sub .ant-menu-item .icon {\n  font-size: 12px;\n}\n.ant-menu-item > a {\n  color: #545454;\n}\n.ant-menu-item > a:hover {\n  color: var(--app-primary-color);\n}\n.ant-menu-item-divider {\n  background-color: #e8e8e8;\n}\n.ant-menu-submenu-inline {\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n}\n.ant-menu-item:hover,\n.ant-menu-item-active,\n.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,\n.ant-menu-submenu-active,\n.ant-menu-submenu-title:hover {\n  color: var(--app-primary-color);\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {\n  background-color: transparent;\n}\n.ant-menu-item-selected {\n  color: var(--app-primary-color);\n}\n.ant-menu-item-selected > a {\n  color: #545454;\n}\n.ant-menu-item-selected > a:hover {\n  color: var(--app-primary-color);\n}\n.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #908b94;\n}\n.ant-menu-inline,\n.ant-menu-vertical,\n.ant-menu-vertical-left {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-layout-sider .ant-menu-inline,\n.ant-layout-sider .ant-menu-vertical,\n.ant-layout-sider .ant-menu-vertical-left,\n.gx-drawer-sidebar .ant-menu-inline,\n.gx-drawer-sidebar .ant-menu-vertical,\n.gx-drawer-sidebar .ant-menu-vertical-left {\n  border-right: 0 none;\n}\n.ant-menu-vertical-right {\n  border-left: 1px solid #e8e8e8;\n}\n.ant-menu-item,\n.ant-menu-submenu-title {\n  padding: 0 20px;\n}\n.gx-inside-header-horizontal .ant-menu-item,\n.gx-inside-header-horizontal .ant-menu-submenu-title {\n  padding: 0 10px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-inside-header-horizontal .ant-menu-item,\n  .gx-inside-header-horizontal .ant-menu-submenu-title {\n    padding: 0 6px;\n  }\n}\n.ant-menu-item .anticon,\n.ant-menu-submenu-title .anticon {\n  margin-right: 20px;\n}\n.gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,\n.gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {\n  padding: 0;\n}\n@media screen and (max-width: 1199px) {\n  .gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,\n  .gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {\n    padding: 0;\n  }\n}\n.gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item .ant-menu-submenu-title,\n.gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu .ant-menu-submenu-title {\n  padding: 0 10px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item .ant-menu-submenu-title,\n  .gx-inside-header-horizontal .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu .ant-menu-submenu-title {\n    padding: 0 6px;\n  }\n}\n.ant-menu > .ant-menu-item-divider {\n  background-color: #e8e8e8;\n}\n.ant-menu-sub > li > a {\n  position: relative;\n}\n.ant-menu-submenu > .ant-menu {\n  background-color: #fff;\n  border-radius: 0;\n}\n.ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {\n  padding-left: 54px !important;\n}\n.ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item,\n.ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {\n  padding-left: 80px !important;\n}\n.ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item,\n.ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item {\n  padding-left: 106px !important;\n}\n.ant-menu-submenu-popup {\n  border-radius: 0;\n  z-index: 1050 !important;\n}\n.ant-menu-submenu-popup .ant-menu-sub.ant-menu .ant-menu-item {\n  padding-left: 20px !important;\n}\n.ant-menu-submenu-vertical .ant-menu-item:not(:last-child),\n.ant-menu-submenu-vertical-left .ant-menu-item:not(:last-child),\n.ant-menu-submenu-vertical-right .ant-menu-item:not(:last-child),\n.ant-menu-submenu-inline .ant-menu-item:not(:last-child) {\n  margin-bottom: 0;\n}\n.gx-app-sidebar .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  left: 22px;\n  right: auto;\n}\n.ant-drawer .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  left: 22px;\n  right: auto;\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow:after {\n  background-image: linear-gradient(to right, #545454, #545454);\n}\n.gx-app-sidebar .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  left: 60px;\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before {\n  background: linear-gradient(to right, var(--app-primary-color), var(--app-primary-color));\n}\n.ant-menu-vertical .ant-menu-submenu-selected,\n.ant-menu-vertical-left .ant-menu-submenu-selected,\n.ant-menu-vertical-right .ant-menu-submenu-selected {\n  color: var(--app-primary-color);\n}\n.ant-menu-vertical .ant-menu-submenu-selected > a,\n.ant-menu-vertical-left .ant-menu-submenu-selected > a,\n.ant-menu-vertical-right .ant-menu-submenu-selected > a {\n  color: var(--app-primary-color);\n}\n.ant-menu-horizontal {\n  border-bottom: 1px solid #e8e8e8;\n  line-height: 46px;\n  padding: 0;\n}\n.ant-layout-header .ant-menu-horizontal {\n  border-bottom: 0 none;\n  line-height: 70px;\n}\n.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-horizontal > .ant-menu-submenu {\n  border-bottom: 2px solid transparent;\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-submenu:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu-active,\n.ant-menu-horizontal > .ant-menu-item-open,\n.ant-menu-horizontal > .ant-menu-submenu-open,\n.ant-menu-horizontal > .ant-menu-item-selected,\n.ant-menu-horizontal > .ant-menu-submenu-selected {\n  border-bottom: 2px solid var(--app-primary-color);\n  color: var(--app-primary-color);\n}\n.ant-menu-horizontal > .ant-menu-item > a,\n.ant-menu-horizontal > .ant-menu-submenu > a {\n  color: #545454;\n}\n.ant-menu-horizontal > .ant-menu-item > a:hover,\n.ant-menu-horizontal > .ant-menu-submenu > a:hover {\n  color: var(--app-primary-color);\n}\n.ant-menu-horizontal > .ant-menu-item > a:before,\n.ant-menu-horizontal > .ant-menu-submenu > a:before {\n  bottom: -2px;\n}\n.ant-menu-vertical .ant-menu-item:not(:last-child),\n.ant-menu-vertical-left .ant-menu-item:not(:last-child),\n.ant-menu-vertical-right .ant-menu-item:not(:last-child),\n.ant-menu-inline .ant-menu-item:not(:last-child) {\n  margin-bottom: 0;\n}\n.ant-menu-vertical .ant-menu-item:after,\n.ant-menu-vertical-left .ant-menu-item:after,\n.ant-menu-vertical-right .ant-menu-item:after,\n.ant-menu-inline .ant-menu-item:after {\n  border-right: 3px solid var(--app-primary-color);\n}\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-vertical-right .ant-menu-item,\n.ant-menu-inline .ant-menu-item,\n.ant-menu-vertical .ant-menu-submenu-title,\n.ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-menu-inline .ant-menu-submenu-title {\n  padding: 0 30px 0 20px !important;\n  font-size: 14px;\n  margin-top: 0;\n  margin-bottom: 0;\n  text-overflow: inherit;\n}\n.ant-layout-sider .ant-menu-vertical .ant-menu-item,\n.ant-layout-sider .ant-menu-vertical-left .ant-menu-item,\n.ant-layout-sider .ant-menu-vertical-right .ant-menu-item,\n.ant-layout-sider .ant-menu-inline .ant-menu-item,\n.ant-layout-sider .ant-menu-vertical .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-inline .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical .ant-menu-item,\n.ant-drawer .ant-menu-vertical-left .ant-menu-item,\n.ant-drawer .ant-menu-vertical-right .ant-menu-item,\n.ant-drawer .ant-menu-inline .ant-menu-item,\n.ant-drawer .ant-menu-vertical .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-drawer .ant-menu-inline .ant-menu-submenu-title {\n  padding-left: 40px !important;\n}\n.ant-menu-vertical .ant-menu-item .icon,\n.ant-menu-vertical-left .ant-menu-item .icon,\n.ant-menu-vertical-right .ant-menu-item .icon,\n.ant-menu-inline .ant-menu-item .icon,\n.ant-menu-vertical .ant-menu-submenu-title .icon,\n.ant-menu-vertical-left .ant-menu-submenu-title .icon,\n.ant-menu-vertical-right .ant-menu-submenu-title .icon,\n.ant-menu-inline .ant-menu-submenu-title .icon {\n  min-width: 14px;\n  margin-right: 20px;\n}\n.ant-menu-vertical .ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical-left .ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical-right .ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-inline .ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical .ant-menu-submenu-title .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical-left .ant-menu-submenu-title .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical-right .ant-menu-submenu-title .icon[class^=\"icon-\"]::before,\n.ant-menu-inline .ant-menu-submenu-title .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical .ant-menu-item .icon[class*=\" icon-\"]::before,\n.ant-menu-vertical-left .ant-menu-item .icon[class*=\" icon-\"]::before,\n.ant-menu-vertical-right .ant-menu-item .icon[class*=\" icon-\"]::before,\n.ant-menu-inline .ant-menu-item .icon[class*=\" icon-\"]::before,\n.ant-menu-vertical .ant-menu-submenu-title .icon[class*=\" icon-\"]::before,\n.ant-menu-vertical-left .ant-menu-submenu-title .icon[class*=\" icon-\"]::before,\n.ant-menu-vertical-right .ant-menu-submenu-title .icon[class*=\" icon-\"]::before,\n.ant-menu-inline .ant-menu-submenu-title .icon[class*=\" icon-\"]::before {\n  position: relative;\n  top: 2px;\n}\n.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item .icon + span,\n.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item .icon + span,\n.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item .icon + span,\n.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item .icon + span,\n.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title .icon + span,\n.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title .icon + span,\n.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title .icon + span,\n.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title .icon + span {\n  max-width: 0;\n  display: inline-block;\n  opacity: 0;\n}\n.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  display: none;\n}\n.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item,\n.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item,\n.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item,\n.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item,\n.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title,\n.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title {\n  padding: 0 calc((80px - 20px) / 2) !important;\n}\n.ant-card .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,\n.ant-card .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,\n.ant-card .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,\n.ant-card .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {\n  padding-left: 54px !important;\n}\n.ant-layout-sider .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,\n.ant-drawer .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {\n  padding-left: 80px !important;\n}\n.ant-menu-inline .ant-menu-submenu-title {\n  padding-right: 30px !important;\n}\n.ant-menu-inline-collapsed {\n  width: 80px;\n}\n.ant-menu-inline-collapsed > .ant-menu-item,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n  left: 0;\n  padding: 0 64px / 2 !important;\n}\n.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  display: none;\n}\n.ant-menu-inline-collapsed > .ant-menu-item .icon + span,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .icon + span,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .icon + span {\n  max-width: 0;\n  display: inline-block;\n  opacity: 0;\n}\n.ant-menu-inline-collapsed-tooltip .icon {\n  display: none;\n}\n.ant-menu-inline-collapsed-tooltip a {\n  color: rgba(255, 255, 255, 0.85);\n}\n.ant-menu-inline-collapsed .ant-menu-item-group-title {\n  padding-left: 4px;\n  padding-right: 4px;\n  display: none;\n}\n.ant-menu-item-group-list .ant-menu-item,\n.ant-menu-item-group-list .ant-menu-submenu-title {\n  padding: 0 16px 0 28px;\n}\n.ant-menu-sub.ant-menu-inline > .ant-menu-item,\n.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n  line-height: 42px;\n  height: 42px;\n}\n.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {\n  padding: 0 30px 0 80px;\n  line-height: 42px;\n  height: 42px;\n  text-transform: uppercase;\n}\n.ant-menu-item-disabled,\n.ant-menu-submenu-disabled {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-menu-item-disabled > a,\n.ant-menu-submenu-disabled > a {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-menu-submenu-selected .ant-menu-submenu-title {\n  color: var(--app-primary-color);\n}\n.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow:before {\n  background: linear-gradient(to right, var(--app-primary-color), var(--app-primary-color));\n}\n.ant-menu-dark,\n.ant-menu-dark .ant-menu-sub {\n  color: #ffffff;\n  background: var(--app-primary-color);\n}\n.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:before {\n  background: #ffffff;\n}\n.ant-menu-dark .ant-menu-inline.ant-menu-sub {\n  background: none;\n  box-shadow: none;\n}\n.ant-menu-dark.ant-menu-horizontal {\n  border-bottom-color: var(--app-primary-color);\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {\n  border-color: var(--app-primary-color);\n}\n.ant-menu-dark .ant-menu-item .icon {\n  min-width: 14px;\n  margin-right: 20px;\n}\n.ant-menu-dark .ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-dark .ant-menu-item .icon[class*=\" icon-\"]::before {\n  position: relative;\n  top: 2px;\n}\n.ant-menu-dark .ant-menu-item-group-title {\n  color: #ffffff;\n}\n.ant-menu-dark .ant-menu-item {\n  color: #ffffff;\n}\n.ant-menu-dark .ant-menu-item > a {\n  color: #ffffff;\n}\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a {\n  color: #ffffff;\n}\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-item-selected > a {\n  color: var(--app-secondary-color);\n}\n.ant-menu-dark .ant-menu-item:hover,\n.ant-menu-dark .ant-menu-item-active,\n.ant-menu-dark .ant-menu-submenu-active,\n.ant-menu-dark .ant-menu-submenu-selected,\n.ant-menu-dark .ant-menu-submenu-title:hover,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover {\n  color: var(--app-secondary-color);\n}\n.ant-menu-dark .ant-menu-item:hover > a,\n.ant-menu-dark .ant-menu-item-active > a,\n.ant-menu-dark .ant-menu-submenu-active > a,\n.ant-menu-dark .ant-menu-submenu-selected > a,\n.ant-menu-dark .ant-menu-submenu-title:hover > a,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > a {\n  color: var(--app-secondary-color);\n}\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {\n  background: #ffffff;\n}\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before {\n  background: var(--app-secondary-color);\n}\n.ant-menu-dark .ant-menu-submenu-open {\n  color: #ffffff;\n}\n.ant-menu-dark.ant-menu-inline-collapsed .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open .ant-menu-submenu-title span,\n.ant-menu-dark.ant-menu-inline-collapsed .ant-menu-submenu-active .ant-menu-submenu-title span {\n  color: #ffffff;\n}\n.ant-menu-dark .ant-menu-item-selected {\n  color: var(--app-secondary-color);\n}\n.ant-menu-dark .ant-menu-item-selected > a,\n.ant-menu-dark .ant-menu-item-selected > a:hover {\n  color: var(--app-secondary-color);\n}\n.ant-menu-dark .ant-menu-item-selected span {\n  color: inherit;\n}\n.ant-menu.ant-menu-dark .ant-menu-item-selected,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {\n  background-color: transparent;\n}\n.ant-menu-dark .ant-menu-item-disabled,\n.ant-menu-dark .ant-menu-submenu-disabled,\n.ant-menu-dark .ant-menu-item-disabled > a,\n.ant-menu-dark .ant-menu-submenu-disabled > a {\n  color: rgba(255, 255, 255, 0.35) !important;\n}\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(255, 255, 255, 0.35) !important;\n}\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-title {\n  color: #ffffff;\n}\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-open .ant-menu-submenu-title,\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title,\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-submenu-title {\n  color: #ffffff;\n}\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-open .ant-menu-submenu-title:hover,\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title:hover,\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-submenu-title:hover {\n  color: var(--app-secondary-color);\n}\n.ant-menu-submenu-horizontal > .ant-menu-submenu-title {\n  color: #262626;\n}\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {\n  background: #ffffff;\n}\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-vertical:hover > .ant-menu-submenu-title {\n  color: #ffffff;\n}\n.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-submenu-title .icon,\n.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-submenu-title .icon,\n.ant-layout-sider .ant-menu .ant-menu-item .icon,\n.ant-drawer .ant-menu .ant-menu-item .icon {\n  font-size: 20px;\n}\n.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,\n.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,\n.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-item .icon,\n.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-item .icon {\n  font-size: 14px;\n  margin-right: 12px;\n}\n.ant-layout-sider .ant-menu .ant-menu-submenu-title span,\n.ant-drawer .ant-menu .ant-menu-submenu-title span {\n  display: flex;\n}\n.ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  background-image: linear-gradient(to right, var(--app-primary-color), var(--app-primary-color));\n}\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before {\n  background: #ffffff;\n}\n.gx-navbar-nav {\n  list-style: none;\n  padding-left: 0;\n  margin: 0 -5px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-navbar-nav li {\n  padding: 0 5px;\n}\n.gx-navbar-nav li a {\n  display: block;\n  padding: 4px 10px;\n  background-color: var(--app-primary-color);\n  color: #ffffff;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.gx-profile-banner .gx-navbar-nav li a {\n  background-color: transparent;\n  color: #ffffff;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n  padding: 0;\n}\n.gx-navbar-nav li a * {\n  color: #bfbfbf;\n}\n.gx-navbar-nav li a:hover,\n.gx-navbar-nav li a:focus {\n  color: #ffffff;\n}\n.gx-profile-banner .gx-navbar-nav li a:hover,\n.gx-profile-banner .gx-navbar-nav li a:focus {\n  background-color: transparent;\n  color: var(--app-secondary-color);\n}\n.gx-profile-banner .gx-navbar-nav li {\n  padding: 0 15px;\n}\n@media screen and (max-width: 575px) {\n  .gx-profile-banner .gx-navbar-nav li {\n    padding: 0 6px;\n  }\n}\n.gx-profile-banner .gx-navbar-nav {\n  margin: 0 -15px;\n}\n@media screen and (max-width: 575px) {\n  .gx-profile-banner .gx-navbar-nav {\n    -webkit-justify-content: center;\n    -ms-justify-content: center;\n    justify-content: center;\n    margin: 0 -6px;\n  }\n}\n.gx-menu-horizontal {\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.gx-menu-horizontal:before {\n  display: none;\n}\n.gx-header-horizontal-nav .ant-menu-horizontal {\n  border-bottom: 0 none;\n}\n.gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title {\n  color: #ffffff;\n}\n.gx-below-header-horizontal .gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title,\n.gx-above-header-horizontal .gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title {\n  color: #7a7a7a;\n}\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item:hover,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu:hover,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-active,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-active,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-open,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-open,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-selected,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-selected {\n  border-bottom-color: var(--app-secondary-color);\n  color: var(--app-secondary-color);\n}\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title {\n  color: var(--app-secondary-color);\n}\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item:hover::after,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu:hover::after,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-active::after,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-active::after,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-open::after,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-open::after,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-selected::after,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-selected::after {\n  border-bottom-color: transparent;\n}\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu {\n  border-bottom: 0 none;\n  margin-top: 0;\n  top: 0;\n}\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected {\n  position: relative;\n  border-bottom: 0 none;\n}\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title {\n  position: relative;\n}\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {\n  content: \"\\e049\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  text-align: center;\n  font-family: \"gaxon\" !important;\n  font-size: 31px;\n  line-height: 5px;\n}\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {\n  color: var(--app-primary-color);\n}\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover::after,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover::after,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active::after,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active::after,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open::after,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open::after,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected::after,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected::after {\n  border-bottom-color: transparent;\n}\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {\n  color: var(--app-secondary-color);\n}\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {\n  color: #ffffff;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu {\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  margin-top: -7px;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu .ant-menu-item:first-child {\n  -webkit-border-radius: 10px 10px 0 0;\n  -moz-border-radius: 10px 10px 0 0;\n  border-radius: 10px 10px 0 0;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu .ant-menu-item:last-child {\n  -webkit-border-radius: 0 0 10px 10px;\n  -moz-border-radius: 0 0 10px 10px;\n  border-radius: 0 0 10px 10px;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu > .ant-menu {\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: var(--app-secondary-color);\n  color: var(--app-primary-color);\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a {\n  color: var(--app-primary-color);\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title {\n  color: var(--app-secondary-color);\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  background-image: linear-gradient(to right, var(--app-secondary-color), var(--app-secondary-color));\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  background-image: linear-gradient(to right, var(--app-secondary-color), var(--app-secondary-color));\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item > a:hover,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item:hover,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item-active,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-active,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-title:hover {\n  color: var(--app-secondary-color);\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-inside-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-below-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-above-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: transparent;\n  color: var(--app-secondary-color);\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-inside-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a,\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-below-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a,\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-above-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a {\n  color: var(--app-secondary-color);\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed {\n  padding-bottom: 10px;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n  padding: 0 30px !important;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item > span,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item > span,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title > span {\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item > a,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item > a {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item.ant-menu-item-selected > a,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item.ant-menu-item-selected > a {\n  color: var(--app-primary-color);\n  background-color: var(--app-secondary-color);\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu.ant-menu-submenu-selected > .ant-menu-submenu-title > span {\n  color: var(--app-primary-color);\n  background-color: var(--app-secondary-color);\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n}\n.gx-mini-custom-sidebar .ant-menu-vertical .ant-menu-item .icon,\n.gx-mini-custom-sidebar .ant-menu-vertical-left .ant-menu-item .icon,\n.gx-mini-custom-sidebar .ant-menu-vertical-right .ant-menu-item .icon,\n.gx-mini-custom-sidebar .ant-menu-inline .ant-menu-item .icon,\n.gx-mini-custom-sidebar .ant-menu-vertical .ant-menu-submenu-title .icon,\n.gx-mini-custom-sidebar .ant-menu-vertical-left .ant-menu-submenu-title .icon,\n.gx-mini-custom-sidebar .ant-menu-vertical-right .ant-menu-submenu-title .icon,\n.gx-mini-custom-sidebar .ant-menu-inline .ant-menu-submenu-title .icon {\n  margin-right: 0;\n}\n.gx-no-header-submenu-popup .ant-menu-sub {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: transparent;\n}\n/* Footer Style */\n.ant-layout-footer {\n  border-top: solid 1px #e8e8e8;\n}\n@media screen and (max-width: 575px) {\n  .ant-layout-footer {\n    padding: 14px 15px;\n  }\n}\n.gx-container-wrap .ant-layout-footer {\n  padding-left: 0;\n  padding-right: 0;\n}\n.gx-container-wrap .gx-layout-footer-content {\n  width: 94vw;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n@media screen and (min-width: 768px) {\n  .gx-container-wrap .gx-layout-footer-content {\n    width: 720px;\n  }\n}\n@media screen and (min-width: 992px) {\n  .gx-container-wrap .gx-layout-footer-content {\n    width: 920px;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .gx-container-wrap .gx-layout-footer-content {\n    width: 1100px;\n  }\n}\n@media screen and (min-width: 1367px) {\n  .gx-container-wrap .gx-layout-footer-content {\n    width: 1200px;\n  }\n}\n@media screen and (min-width: 1600px) {\n  .gx-container-wrap .gx-layout-footer-content {\n    width: 1400px;\n  }\n}\n/* Customizer Style */\n.gx-customizer {\n  height: calc(100vh - 30px) !important;\n}\n.gx-customizer-item:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n}\n.gx-customizer-item .ant-radio-group .ant-radio-button {\n  display: none;\n}\n.gx-customizer-option {\n  position: absolute;\n  right: 0;\n  top: 150px;\n  z-index: 99;\n}\n.full-scroll .gx-customizer-option {\n  position: fixed;\n}\n.full-scroll.boxed-layout .gx-customizer-option {\n  position: absolute;\n}\n.full-scroll.framed-layout .gx-customizer-option {\n  right: 20px;\n}\n@media screen and (max-width: 991px) {\n  .full-scroll.framed-layout .gx-customizer-option {\n    right: 0;\n  }\n}\n.horizontal-layout.full-scroll .gx-customizer-option {\n  top: 200px;\n}\n@media screen and (max-width: 575px) {\n  .gx-customizer {\n    width: 250px !important;\n  }\n  .gx-customizer .ant-radio-button-wrapper {\n    padding: 0 10px;\n  }\n}\n.gx-customizer .gx-list-inline {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.framed-layout .gx-customizer {\n  height: calc(100vh - 30px - 2 * 20px) !important;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .gx-customizer {\n    height: calc(100vh - 30px) !important;\n  }\n}\n.gx-color-option {\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n}\n.gx-color-option li {\n  font-size: 36px;\n  line-height: 1;\n}\n.gx-color-option li .gx-link {\n  width: 40px;\n  height: 40px;\n  display: block;\n  position: relative;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  overflow: hidden;\n}\n.gx-color-option li .gx-link:before {\n  font-family: \"gaxon\";\n  font-size: 20px;\n  content: \"\\30\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 2;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  display: none;\n}\n.gx-color-option li .gx-link.active:before {\n  display: block;\n}\n.gx-color-option li .gx-link:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  width: 20px;\n  height: 40px;\n  background-color: #9283D4;\n}\n.gx-color-option li .gx-link.gx-color-red:after {\n  background-color: #FF2B7A;\n}\n.gx-color-option li .gx-link.gx-color-blue:after {\n  background-color: #3DA4E6;\n}\n.gx-color-option li .gx-link.gx-color-dark-blue:after {\n  background-color: #0469B9;\n}\n.gx-color-option li .gx-link.gx-color-orange:after {\n  background-color: #F18805;\n}\n.gx-color-option li .gx-link.gx-color-light-blue:after {\n  background-color: #6A95FF;\n}\n.gx-color-option li .gx-link.gx-color-deep-orange:after {\n  background-color: #F87060;\n}\n.gx-color-option li .gx-link.gx-color-light-purple1:after {\n  background-color: #A172E7;\n}\n.gx-color-option li .gx-link.gx-color-light-purple2:after {\n  background-color: #956FE7;\n}\n.gx-cus-customiz {\n  padding-right: 20px;\n}\n.gx-layout-option li,\n.gx-nav-option li {\n  margin-bottom: 10px;\n}\n.gx-layout-option li span,\n.gx-nav-option li span {\n  position: relative;\n  display: block;\n}\n.gx-layout-option li span:before,\n.gx-nav-option li span:before {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n  font-family: \"gaxon\" !important;\n  content: \"\\30\";\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  display: none;\n  width: 20px;\n  font-size: 12px;\n  height: 20px;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  background-color: var(--app-primary-color);\n  text-align: center;\n  padding: 2px;\n  color: #ffffff;\n}\n.gx-layout-option li span.active:before,\n.gx-nav-option li span.active:before {\n  display: block;\n}\n/* Drawer Style */\n.ant-drawer {\n  overflow: hidden;\n}\n.ant-drawer-body {\n  padding: 0;\n}\n.gx-drawer-sidebar-dark .ant-drawer-content {\n  background-color: var(--app-primary-color);\n  color: #ffffff;\n}\n.ant-drawer-content-wrapper {\n  width: 240px !important;\n}\n@media screen and (max-width: 991px) {\n  .ant-drawer-content-wrapper {\n    width: 220px !important;\n  }\n}\n.framed-layout .ant-drawer-content-wrapper {\n  top: 20px;\n  bottom: 20px;\n  height: calc(100vh - 2 * 20px);\n  -webkit-border-radius: 11px 0 0 11px;\n  -moz-border-radius: 11px 0 0 11px;\n  border-radius: 11px 0 0 11px;\n  overflow: hidden;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-drawer-content-wrapper {\n    top: 0;\n    bottom: 0;\n    height: 100vh;\n    -webkit-border-radius: 0 !important;\n    -moz-border-radius: 0 !important;\n    border-radius: 0 !important;\n  }\n}\n.ant-drawer-right .ant-drawer-content-wrapper {\n  width: 370px !important;\n  padding: 15px;\n  background: #ffffff;\n}\n@media screen and (max-width: 991px) {\n  .ant-drawer-right .ant-drawer-content-wrapper {\n    width: 300px !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-drawer-right .ant-drawer-content-wrapper {\n    width: 280px !important;\n  }\n}\n.framed-layout .ant-drawer-right .ant-drawer-content-wrapper {\n  top: 20px;\n  bottom: 20px;\n  height: calc(100vh - 2 * 20px);\n  -webkit-border-radius: 0 11px 11px 0;\n  -moz-border-radius: 0 11px 11px 0;\n  border-radius: 0 11px 11px 0;\n  overflow: hidden;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-drawer-right .ant-drawer-content-wrapper {\n    top: 0;\n    bottom: 0;\n    height: 100vh;\n    -webkit-border-radius: 0 !important;\n    -moz-border-radius: 0 !important;\n    border-radius: 0 !important;\n  }\n}\n.framed-layout .ant-drawer-content-wrapper,\n.boxed-layout .ant-drawer-content-wrapper {\n  position: absolute;\n}\n.boxed-layout .ant-drawer {\n  max-width: 1280px;\n  margin: 0 auto;\n}\n@media screen and (min-width: 1600px) {\n  .boxed-layout .ant-drawer {\n    max-width: 1500px;\n  }\n}\n.framed-layout .ant-drawer-open.ant-drawer-left,\n.framed-layout .ant-drawer-open.ant-drawer-right,\n.boxed-layout .ant-drawer-open.ant-drawer-left,\n.boxed-layout .ant-drawer-open.ant-drawer-right {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n.framed-layout .ant-drawer-open {\n  width: calc(100% - 2 * 20px);\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-drawer-open {\n    width: 100%;\n  }\n}\n@media screen and (min-width: 1600px) {\n  .boxed-layout .ant-drawer.ant-drawer-left,\n  .boxed-layout .ant-drawer.ant-drawer-right {\n    position: absolute;\n  }\n}\n@media screen and (min-width: 991px) {\n  .framed-layout .ant-drawer.ant-drawer-left,\n  .framed-layout .ant-drawer.ant-drawer-right {\n    position: absolute;\n  }\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-drawer.ant-drawer-left,\n  .framed-layout .ant-drawer.ant-drawer-right {\n    right: 20px;\n    left: 20px;\n    margin: 0;\n  }\n}\n.ant-drawer-close {\n  top: -11px;\n}\n.ant-drawer-close-x {\n  width: 35px;\n  height: 35px;\n  line-height: 35px;\n}\n.ant-drawer-mask {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  position: fixed;\n}\n/*Alert Styles*/\n.ant-alert {\n  margin-bottom: 16px;\n}\n.gx-custom-sweet-alert h2,\n.gx-custom-sweet-alert .text-muted {\n  color: #ffffff !important;\n}\n.notification {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.notification .title {\n  font-size: 18px;\n  font-weight: 500;\n  color: #ffffff;\n}\n.gx-sweet-alert-top-space {\n  padding-top: 40px !important;\n}\n.sweet-alert h2 {\n  font-size: 20px !important;\n  font-weight: 400 !important;\n}\n/*Avatar Styles*/\n.gx-avatar-img {\n  height: 50px;\n  width: 50px;\n  position: relative;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  border: solid 1px #e8e8e8;\n}\n.gx-avatar-img-lg {\n  height: 100px;\n  width: 100px;\n}\n.ant-avatar {\n  position: relative;\n}\n.ant-avatar.gx-size-150 > * {\n  line-height: 150px;\n}\n.ant-avatar.gx-size-120 > * {\n  line-height: 120px;\n}\n.ant-avatar.gx-size-100 > * {\n  line-height: 100px;\n}\n.ant-avatar.gx-size-80 > * {\n  line-height: 80px;\n}\n.ant-avatar.gx-size-60 > * {\n  line-height: 60px;\n}\n.ant-avatar.gx-size-50 > * {\n  line-height: 50px;\n}\n.ant-avatar.gx-size-40 > * {\n  line-height: 40px;\n}\n.ant-avatar.gx-size-36 > * {\n  line-height: 36px;\n}\n.ant-avatar.gx-size-30 > * {\n  line-height: 30px;\n}\n.ant-avatar.gx-size-24 > * {\n  line-height: 24px;\n}\n.ant-avatar.gx-size-20 > * {\n  line-height: 20px;\n}\n.ant-avatar.gx-size-15 > * {\n  line-height: 14px;\n}\n.gx-clients-list .ant-avatar {\n  width: 70px;\n  height: 70px;\n}\n@media (max-width: 1500px) {\n  .gx-clients-list .ant-avatar {\n    width: 60px;\n    height: 60px;\n  }\n}\n@media (max-width: 1366px) {\n  .gx-clients-list .ant-avatar {\n    width: 48px;\n    height: 48px;\n  }\n}\n@media (max-width: 1199px) {\n  .gx-clients-list .ant-avatar {\n    width: 60px;\n    height: 60px;\n  }\n}\n@media screen and (max-width: 400px) {\n  .gx-clients-list .ant-avatar {\n    width: 52px;\n    height: 52px;\n  }\n}\n.gx-avatar {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  overflow: hidden;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  height: 50px;\n  width: 50px;\n  position: relative;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  border: solid 1px #e8e8e8;\n}\n@media screen and (max-width: 991px) {\n  .gx-user-nav .gx-avatar {\n    height: 40px;\n    width: 40px;\n    line-height: 40px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-user-nav .gx-avatar {\n    height: 30px;\n    width: 30px;\n    line-height: 30px;\n  }\n}\n.gx-header-horizontal-main .gx-avatar {\n  height: 40px;\n  width: 40px;\n  line-height: 40px;\n}\n@media screen and (max-width: 991px) {\n  .gx-header-horizontal-main .gx-avatar {\n    height: 30px;\n    width: 30px;\n    line-height: 30px;\n  }\n}\n.gx-user-thumb {\n  position: relative;\n}\n/*Badge Styles*/\n.ant-badge {\n  margin-bottom: 6px;\n}\n.ant-badge:not(:last-child) {\n  margin-right: 12px;\n}\n.ant-tag {\n  margin-bottom: 8px;\n}\n.gx-badge {\n  display: inline-block;\n  padding: 5px 8px 4px;\n  font-size: 75%;\n  margin-bottom: 6px;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.gx-badge:not(:last-child) {\n  margin-right: 12px;\n}\n.gx-chat-date .gx-badge {\n  margin-bottom: 0;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 16px;\n  padding: 2px;\n}\n.gx-user-thumb .gx-badge {\n  position: absolute;\n  left: -4px;\n  top: -4px;\n  z-index: 1;\n  margin: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  line-height: 16px;\n}\n.gx-badge-outline {\n  background-color: transparent;\n  border: solid 1px #e8e8e8;\n}\n.gx-badge-radius-sm .ant-badge-count {\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n}\n#components-back-top-demo-custom .ant-back-top {\n  bottom: 100px;\n}\n#components-back-top-demo-custom .ant-back-top-inner {\n  height: 40px;\n  width: 40px;\n  line-height: 40px;\n  border-radius: 4px;\n  background-color: #1088e9;\n  color: #fff;\n  text-align: center;\n  font-size: 20px;\n}\n/*Button Styles*/\n.ant-btn {\n  line-height: 34px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.ant-btn-group-sm .ant-btn {\n  line-height: 24px;\n}\n.ant-btn-group-lg .ant-btn {\n  line-height: 40px;\n}\n.ant-btn-sm {\n  line-height: 24px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.ant-btn-group > .ant-btn-sm {\n  line-height: 24px;\n}\n.ant-btn-sm.ant-btn-icon-only {\n  line-height: 1;\n}\n.ant-btn-lg {\n  line-height: 40px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.ant-btn-group > .ant-btn-lg {\n  line-height: 40px;\n}\n.ant-btn-lg.ant-btn-icon-only {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.ant-btn-group-lg > .ant-btn,\n.ant-btn-group-lg > span > .ant-btn {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.ant-btn:not(:last-child) {\n  margin-right: 15px;\n}\n@media screen and (max-width: 575px) {\n  .ant-btn:not(:last-child) {\n    margin-right: 10px;\n  }\n}\n.ant-btn-group .ant-btn:not(:last-child),\n.ant-transfer-operation .ant-btn:not(:last-child) {\n  margin-right: 0;\n}\n@media (max-width: 1599px) {\n  .gx-product-footer .ant-btn:not(:last-child) {\n    margin-right: 6px;\n  }\n}\n.ant-input-group-addon .ant-btn {\n  margin-right: 0;\n}\n@media screen and (max-width: 575px) {\n  .ant-btn {\n    margin-bottom: 10px;\n  }\n}\n.ant-input-search .ant-btn {\n  margin-bottom: 0;\n}\n.gx-customizer-option .ant-btn {\n  padding: 0 18px;\n  font-size: 18px;\n  height: 42px;\n  line-height: 42px;\n  margin: 0;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);\n  -webkit-border-radius: 30px 0 0 30px;\n  -moz-border-radius: 30px 0 0 30px;\n  border-radius: 30px 0 0 30px;\n  background-color: #fa8c16;\n  background: -webkit-gradient(linear, left top, right top, from(#fa8c16), to(#f5222d));\n  background: -webkit-linear-gradient(left, #fa8c16, #f5222d);\n  background: -moz-linear-gradient(left, #fa8c16, #f5222d);\n  background: -ms-linear-gradient(left, #fa8c16, #f5222d);\n  background: -o-linear-gradient(left, #fa8c16, #f5222d);\n  border: 0 none;\n  color: #ffffff;\n}\n.gx-customizer-option .ant-btn:hover,\n.gx-customizer-option .ant-btn:focus {\n  background-color: #f5222d;\n  background: -webkit-gradient(linear, left top, right top, from(#f5222d), to(#fa8c16));\n  background: -webkit-linear-gradient(left, #f5222d, #fa8c16);\n  background: -moz-linear-gradient(left, #f5222d, #fa8c16);\n  background: -ms-linear-gradient(left, #f5222d, #fa8c16);\n  background: -o-linear-gradient(left, #f5222d, #fa8c16);\n}\n.gx-customizer-option .ant-btn .icon:before {\n  display: block;\n}\n.horizontal-layout.full-scroll .gx-customizer-option .ant-btn {\n  margin-right: 0;\n}\n.gx-module-add-task .ant-btn {\n  height: 36px;\n}\n.gx-module-add-task .ant-btn .icon:before {\n  position: relative;\n  top: 2px;\n}\n.ant-modal-footer .ant-btn,\n.ant-modal-confirm-btns .ant-btn {\n  margin-bottom: 0;\n}\n.gx-login-content .ant-btn {\n  padding: 9px 20px !important;\n  height: auto;\n  line-height: 1;\n}\n.boxed-layout .ant-btn-group .ant-btn {\n  padding: 0 12px;\n}\n@media (max-width: 1366px) {\n  .ant-btn-group .ant-btn {\n    padding: 0 12px;\n  }\n}\n@media (max-width: 1366px) {\n  .gx-product-footer .ant-btn {\n    padding: 0 10px;\n    height: 32px;\n    font-size: 12px;\n    line-height: 32px;\n  }\n}\n.ant-btn-background-ghost.ant-btn-primary {\n  border-color: var(--app-primary-color) !important;\n  color: var(--app-primary-color) !important;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover,\n.ant-btn-background-ghost.ant-btn-primary:focus {\n  background-color: var(--app-primary-color) !important;\n  border-color: var(--app-primary-color) !important;\n  color: #ffffff !important;\n}\n.ant-btn-group:not(:last-child) {\n  margin-right: 15px;\n}\n@media screen and (max-width: 575px) {\n  .ant-btn-group:not(:last-child) {\n    margin-right: 10px;\n  }\n}\n.ant-radio-group .ant-radio-button-wrapper {\n  margin-bottom: 6px;\n}\nbutton {\n  outline: none;\n}\n.ant-confirm .ant-confirm-btns button + button {\n  margin-bottom: 8px;\n}\n.ant-modal.ant-confirm .ant-confirm-btns button + button,\n.ant-modal.ant-confirm .ant-btn {\n  margin-bottom: 0;\n}\n.gx-btn,\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #545454;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: solid 1px #d9d9d9;\n  padding: 0 15px;\n  height: 36px;\n  font-size: 14px;\n  line-height: 34px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n.gx-btn:not(:last-child),\n.btn:not(:last-child) {\n  margin-right: 15px;\n}\n@media screen and (max-width: 575px) {\n  .gx-btn:not(:last-child),\n  .btn:not(:last-child) {\n    margin-right: 10px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-btn,\n  .btn {\n    margin-bottom: 10px;\n  }\n}\n.gx-btn:focus,\n.btn:focus,\n.gx-btn:hover,\n.btn:hover {\n  text-decoration: none;\n}\n.gx-btn:focus,\n.btn:focus,\n.gx-btn.focus,\n.btn.focus {\n  outline: 0;\n}\n.gx-btn.disabled,\n.btn.disabled,\n.gx-btn:disabled,\n.btn:disabled {\n  opacity: 0.65;\n}\n.gx-btn:not([disabled]):not(.disabled),\n.btn:not([disabled]):not(.disabled) {\n  cursor: pointer;\n}\n.gx-btn-list .gx-btn,\n.gx-btn-list .btn {\n  margin-bottom: 6px;\n}\n.gx-sub-popover .gx-btn,\n.gx-sub-popover .btn {\n  border: 0 none;\n  margin-bottom: 5px;\n}\n.gx-sub-popover .gx-btn:focus,\n.gx-sub-popover .btn:focus,\n.gx-sub-popover .gx-btn:hover,\n.gx-sub-popover .btn:hover {\n  background-color: #f5f5f5;\n}\n.gx-sub-popover .gx-btn:not(:last-child),\n.gx-sub-popover .btn:not(:last-child) {\n  margin-right: 5px;\n}\n.gx-login-content .gx-btn,\n.gx-login-content .btn {\n  padding: 9px 20px !important;\n  height: auto;\n  line-height: 1;\n}\n.gx-btn-block {\n  display: block;\n  width: 100%;\n}\na.gx-btn.disabled,\nfieldset[disabled] a.gx-btn {\n  pointer-events: none;\n}\n.gx-btn-rounded {\n  -webkit-border-radius: 50px !important;\n  -moz-border-radius: 50px !important;\n  border-radius: 50px !important;\n}\n.gx-btn-link {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--app-primary-color);\n  background-color: transparent;\n}\n.gx-btn-link:hover {\n  color: var(--app-primary-color);\n  text-decoration: underline;\n  background-color: transparent;\n  border-color: transparent;\n}\n.gx-btn-link:focus,\n.gx-btn-link.focus {\n  text-decoration: underline;\n  border-color: transparent;\n}\n.gx-btn-link:disabled,\n.gx-btn-link.disabled {\n  color: #bfbfbf;\n}\n.gx-btn-lg,\n.gx-btn-group-lg > .gx-btn {\n  padding: 0 15px;\n  font-size: 16px;\n  line-height: 40px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n  height: 40px;\n}\n.gx-btn-sm,\n.gx-btn-group-sm > .gx-btn {\n  padding: 0 7px;\n  font-size: 12px;\n  line-height: 24px;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n  height: 24px;\n}\n.gx-btn-xs {\n  font-size: 10px;\n  padding: 0 6px;\n  height: 26px;\n  line-height: 25px;\n}\n.gx-btn-block {\n  display: block;\n  width: 100%;\n}\n.gx-btn-block + .gx-btn-block {\n  margin-top: 0.5rem;\n}\n.gx-icon-btn {\n  width: 40px;\n  height: 40px;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  cursor: pointer;\n}\n.gx-icon-btn:focus,\n.gx-icon-btn:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.gx-layout-sider-dark .gx-icon-btn:focus,\n.gx-layout-sider-dark .gx-icon-btn:hover {\n  background-color: var(--app-primary-color);\n}\n.gx-popover-header .gx-icon-btn {\n  width: 30px;\n  height: 30px;\n}\n.gx-icon-btn .icon-star-o:before,\n.gx-icon-btn .icon-star:before {\n  position: relative;\n  top: 3px;\n}\n@media screen and (max-width: 575px) {\n  .gx-module-box-content .gx-icon-btn.icon {\n    font-size: 16px;\n  }\n}\n.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper {\n  height: 24px;\n  line-height: 24px;\n  border: 0 none;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n  margin-left: 0;\n}\n.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {\n  background-color: var(--app-primary-color);\n  color: #ffffff;\n}\n.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper:not(:first-child)::before {\n  display: none;\n}\n@media screen and (max-width: 575px) {\n  .gx-radio-group-link-news {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-radio-group-link .ant-radio-button-wrapper {\n    padding: 0 8px;\n  }\n}\n.gx-radio-group-link-bg-light {\n  margin-left: -5px;\n  margin-right: -5px;\n}\n.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper {\n  padding: 0 10px;\n  margin-left: 5px;\n  margin-right: 5px;\n  background-color: #e8e8e8;\n}\n.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {\n  background-color: var(--app-primary-color);\n  color: #ffffff;\n}\n.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper:not(:first-child)::before {\n  display: none;\n}\n/*Card Styles*/\n.ant-card {\n  margin-bottom: 32px;\n}\n.ant-card-head {\n  background: none;\n}\n.ant-card-head-title {\n  font-weight: 400;\n}\n.ant-card-grid {\n  text-align: center;\n  width: 25%;\n}\n@media screen and (max-width: 767px) {\n  .ant-card-grid {\n    width: 33.33%;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-card-grid {\n    width: 50%;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-card {\n    margin-bottom: 20px;\n  }\n}\n.ant-card-body .ant-card-head {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.ant-card-type-inner .ant-card-head {\n  padding-left: 24px !important;\n  padding-right: 24px !important;\n}\n.ant-card-wider-padding .ant-card-body > :last-child {\n  margin-bottom: 0;\n}\n.gx-card-center-vertical {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-card-img {\n  position: relative;\n  overflow: hidden;\n}\n.gx-card-img .ant-card-body {\n  position: relative;\n}\n.gx-card-img .gx-badge-up {\n  position: absolute;\n  right: 60px;\n  top: -20px;\n  z-index: 1;\n  padding: 5px;\n  margin: 0;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n  line-height: 36px;\n  text-align: center;\n}\n.gx-card-img .gx-badge-up-right {\n  right: 10px;\n  top: -15px;\n  -webkit-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  line-height: 32px !important;\n}\n.gx-card-img-center .ant-card-cover {\n  text-align: center;\n}\n.gx-card-img-center .ant-card-cover > * {\n  width: auto;\n  display: inline-block;\n}\n.gx-card-body-border-top .ant-card-cover {\n  padding-top: 24px;\n}\n.gx-card-body-border-top .ant-card-body {\n  border-top: solid 1px #e8e8e8;\n  margin-top: 32px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-body-border-top .ant-card-body {\n    margin-bottom: 20px;\n  }\n}\n.gx-ant-card-actions {\n  list-style: none;\n  margin: 0 -10px 10px;\n  padding-left: 0;\n}\n.gx-ant-card-actions li {\n  display: inline-block;\n  vertical-align: top;\n  padding: 0 10px;\n}\n.gx-ant-card-actions li:not(:last-child) {\n  border-right: solid 1px #e8e8e8;\n}\n.gx-card {\n  margin-bottom: 32px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  position: relative;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card {\n    margin-bottom: 20px;\n  }\n}\n.gx-card-head {\n  padding: 24px;\n}\n.gx-card-head .gx-card-title {\n  margin-bottom: 0;\n}\n.gx-card-head + .gx-card-body {\n  padding-top: 0;\n}\n.gx-card .ant-card-head {\n  border-bottom: 0 none;\n  min-height: 10px;\n  padding: 0 24px;\n}\n@media screen and (max-width: 991px) {\n  .gx-card .ant-card-head {\n    padding: 0 24px;\n  }\n}\n.gx-card .ant-card-head-title {\n  padding: 25px 0 0;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 600;\n}\n@media screen and (max-width: 991px) {\n  .gx-card .ant-card-head-title {\n    padding-top: 20px;\n  }\n}\n.gx-card-body,\n.gx-card .ant-card-body {\n  padding: 24px;\n}\n@media screen and (max-width: 991px) {\n  .gx-card-body,\n  .gx-card .ant-card-body {\n    padding: 24px;\n  }\n}\n.gx-card.ant-card-bordered {\n  border: 0 none;\n}\n.gx-card.ant-card-hoverable:hover {\n  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);\n  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);\n}\n.gx-card .ant-card-cover {\n  padding: 24px;\n  padding-bottom: 0;\n}\n@media screen and (max-width: 991px) {\n  .gx-card .ant-card-cover {\n    padding: 24px;\n    padding-bottom: 0;\n  }\n}\n.gx-card-metrics {\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.gx-card-metrics.ant-card-bordered {\n  border: 0 none;\n}\n.gx-card-metrics .ant-card-head {\n  border-bottom: 0 none;\n  min-height: 10px;\n}\n.gx-card-metrics .ant-card-head-title {\n  padding: 20px 0 0;\n  text-transform: uppercase;\n  font-size: 14px;\n}\n.gx-card-widget {\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.gx-card-widget.ant-card-bordered {\n  border: 0 none;\n}\n.gx-card-widget .ant-card-head {\n  border-bottom: 0 none;\n  min-height: 24px;\n  padding: 24px 24px 0;\n}\n.gx-card-widget .ant-card-head-wrapper {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-card-widget .ant-card-head-title {\n  padding: 0;\n  text-transform: uppercase;\n  font-size: 14px;\n}\n.gx-card-widget.gx-ch-capitalize .ant-card-head-title {\n  text-transform: capitalize;\n  font-size: 14px;\n}\n.gx-card-widget .ant-card-extra {\n  padding: 0;\n}\n.gx-card-widget .ant-card-extra .gx-btn {\n  margin-bottom: 0;\n}\n.gx-card-widget .ant-card-body {\n  padding: 24px;\n}\n.gx-card-equal-height {\n  height: calc(100% - 32px);\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-equal-height {\n    height: calc(100% - 20px);\n  }\n}\n.gx-card-equal-height .ant-card-body {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-card-equal-height .ant-card-body .gx-rechart {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-card-equal-height .ant-card-body .gx-rechart .recharts-responsive-container {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: flex;\n}\n.gx-card-sm-p .ant-card-head {\n  min-height: 10px;\n}\n.gx-card-sm-p .ant-card-head-title {\n  padding: 14px 14px 0;\n}\n.gx-card-sm-p .ant-card-body {\n  padding: 14px;\n}\n.gx-card-sm-px .ant-card-head {\n  min-height: 10px;\n}\n.gx-card-sm-px .ant-card-head-title {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.gx-card-sm-px .ant-card-body {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.gx-entry-header {\n  margin-bottom: 32px;\n}\n@media screen and (max-width: 575px) {\n  .gx-entry-header {\n    margin-bottom: 20px;\n  }\n}\n.gx-entry-header .gx-entry-heading {\n  margin-bottom: 0;\n}\n.gx-entry-header .gx-entry-description {\n  margin-bottom: 0;\n  font-size: 13px;\n}\n.gx-card-full {\n  overflow: hidden;\n}\n.gx-card-full .gx-card-body {\n  padding: 0;\n}\n.gx-card-full .gx-card-body .recharts-legend-wrapper {\n  padding: 0 24px;\n}\n.gx-card-full .ant-card-body {\n  padding: 0;\n}\n.gx-card-full .ant-card-body .recharts-legend-wrapper {\n  padding: 0 24px;\n}\n.gx-card-full .recharts-default-legend {\n  margin: 0 -10px !important;\n}\n.gx-card-full .recharts-default-legend li {\n  padding: 0 10px;\n  margin: 0 !important;\n  display: inline-block;\n  vertical-align: top;\n}\n.gx-card-full .recharts-default-legend li .recharts-legend-item-text {\n  margin-left: 10px;\n}\n.gx-card-overview {\n  margin-bottom: 32px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  position: relative;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  padding: 24px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-overview {\n    margin-bottom: 20px;\n  }\n}\n.gx-card-overview .gx-card-title {\n  margin-bottom: 20px;\n}\n.gx-card-profile .ant-card-head {\n  padding-top: 15px;\n  padding-bottom: 16px;\n}\n.gx-card-profile.gx-card-tabs .ant-card-head {\n  border-bottom: 1px solid #e8e8e8;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-profile.gx-card-tabs .ant-card-head {\n    border-bottom: 0 none;\n  }\n}\n.gx-card-profile .ant-card-body,\n.gx-card-profile.gx-card-tabs .ant-card-body {\n  padding-top: 0;\n}\n.gx-card-profile.gx-card-tabs .ant-tabs {\n  margin-top: -50px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-profile.gx-card-tabs .ant-tabs {\n    margin-top: 0;\n  }\n}\n.gx-card-profile .ant-tabs-tab {\n  padding-top: 15px;\n  padding-bottom: 18px;\n}\n.gx-card-profile .ant-card-head-title,\n.gx-card-profile.gx-card-tabs .ant-card-head-title {\n  font-size: 20px;\n  text-transform: capitalize;\n}\n.gx-card-profile.gx-card-tabs .ant-tabs-nav-container {\n  font-size: 14px;\n  color: #8c8c8c;\n}\n.gx-card-profile-sm.gx-card-widget .ant-card-body {\n  padding-top: 10px;\n}\n@media (max-width: 1366px) {\n  .gx-card-1367-p .ant-card-head {\n    min-height: 10px;\n  }\n  .gx-card-1367-p .ant-card-head-title {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n  .gx-card-1367-p .ant-card-body {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n}\n.ant-divider-horizontal.ant-divider-with-text,\n.ant-divider-horizontal.ant-divider-with-text-left,\n.ant-divider-horizontal.ant-divider-with-text-right {\n  font-size: 14px;\n}\n/*Cascader Styles*/\n.ant-cascader-picker {\n  width: 100%;\n}\n/*Chart Styles*/\n.recharts-default-tooltip {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.8) !important;\n  color: var(--app-secondary-color);\n}\n.recharts-tooltip-item-list li {\n  color: var(--app-primary-color) !important;\n}\n/*Form Styles*/\n.ant-form .ant-row {\n  margin-left: 0;\n  margin-right: 0;\n}\n.ant-form-inline {\n  margin-left: -8px;\n  margin-right: -8px;\n}\n.ant-form-inline .ant-row {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-form-inline .ant-form-item {\n  margin-bottom: 10px;\n}\n@media screen and (max-width: 575px) {\n  .ant-form-inline .ant-form-item {\n    display: block;\n  }\n}\n.ant-form-horizontal .ant-row {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n.ant-form-vertical .ant-form-item {\n  padding-bottom: 0;\n}\n.ant-form-vertical .ant-row {\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n.ant-form-extra {\n  word-break: break-all;\n}\n@media (max-width: 575px) {\n  .ant-form-item-label {\n    padding-bottom: 0;\n  }\n}\n.ant-form-item-with-help {\n  margin-bottom: 20px;\n}\n.ant-advanced-search-form .gx-btn-link:hover {\n  text-decoration: none;\n}\n.ant-form-item-control > .ant-form-item:last-child,\n.ant-form-item [class^=\"ant-col-\"] > .ant-form-item:only-child {\n  margin-bottom: 0;\n}\n.gx-form-row0 .ant-row {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.gx-login-form {\n  max-width: 350px;\n}\n.gx-login-form .ant-form-item-control-wrapper {\n  width: 100%;\n}\n.ant-form-inline .gx-form-item-one-fourth {\n  width: 25%;\n}\n@media (max-width: 575px) {\n  .ant-form-inline .gx-form-item-one-fourth {\n    width: 100%;\n  }\n}\n.ant-form-inline .gx-form-item-two-fourth {\n  width: 50%;\n}\n@media (max-width: 575px) {\n  .ant-form-inline .gx-form-item-two-fourth {\n    width: 100%;\n  }\n}\n.gx-form-inline-currency {\n  margin: 0 -8px;\n}\n.gx-form-inline-currency .ant-form-item {\n  padding: 0 8px;\n}\n.gx-form-inline-currency .gx-form-item-one-fourth {\n  width: 30%;\n}\n@media (max-width: 575px) {\n  .gx-form-inline-currency .gx-form-item-one-fourth {\n    width: 40%;\n    display: inline-block;\n  }\n}\n.gx-form-inline-currency .gx-form-item-two-fourth {\n  width: 40%;\n}\n@media (max-width: 575px) {\n  .gx-form-inline-currency .gx-form-item-two-fourth {\n    width: 100%;\n    display: block;\n  }\n}\n.gx-radio-wrapper {\n  white-space: normal;\n  margin-bottom: 10px;\n  margin-right: 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: flex-start;\n  -ms-align-items: flex-start;\n  align-items: flex-start;\n}\n@media (max-width: 1599px) {\n  .ant-form-item-label[class*='ant-col-'] {\n    padding: 0 0;\n  }\n}\n@media (max-width: 1199px) {\n  .ant-form-item-label[class*='ant-col-'] {\n    padding: 0 0;\n  }\n  .ant-form-item,\n  .ant-form-item-with-help {\n    margin-bottom: 12px;\n  }\n  .ant-advanced-search-form .ant-form-item {\n    margin-bottom: 12px;\n  }\n}\n@media (max-width: 991px) {\n  .ant-form-item-label[class*='ant-col-'] {\n    padding: 0 0;\n  }\n}\n@media (max-width: 767px) {\n  .ant-form-item-label[class*='ant-col-'] {\n    padding: 0 0;\n  }\n}\n@media (max-width: 575px) {\n  .ant-form-item-label[class*='ant-col-'] {\n    padding: 0 0;\n    margin-bottom: 8px;\n  }\n  .ant-advanced-search-form .ant-btn,\n  .ant-advanced-search-form .gx-btn-link {\n    display: block;\n    margin: 0 0 10px !important;\n  }\n}\n.secondary-color {\n  color: var(--app-secondary-color);\n}\n.primary-border {\n  border: 1px solid var(--app-primary-color) !important;\n  box-shadow: none !important;\n}\n/*Input Styles*/\n.ant-input-search {\n  margin-bottom: 16px;\n}\n.ant-input-search > .ant-input-suffix > .ant-input-search-button {\n  margin-right: 0;\n}\n.ant-input-group > [class*=\"col-\"] {\n  padding-left: 0;\n  float: left !important;\n}\n.ant-transfer-list {\n  margin-bottom: 10px;\n}\n.ant-input-number {\n  margin-right: 10px;\n}\n.gx-form-group {\n  margin-bottom: 10px;\n}\n.gx-search-bar {\n  position: relative;\n}\n.gx-search-bar .gx-form-group {\n  width: 100%;\n  height: 100%;\n  margin-bottom: 0;\n}\n.gx-search-bar input[type=\"search\"] {\n  padding-right: 35px;\n  background: rgba(250, 250, 250, 0.1);\n}\n.ant-layout-header .gx-search-bar input[type=\"search\"],\n.ant-popover-content .gx-search-bar input[type=\"search\"] {\n  border: 0 none;\n}\n.gx-search-bar input[type=\"search\"]:focus {\n  box-shadow: none;\n  background-color: rgba(250, 250, 250, 0.3);\n}\n.gx-search-bar .gx-search-icon {\n  background-color: transparent;\n  border: 0 none;\n  color: #d9d9d9;\n  height: 32px;\n  width: 30px;\n  line-height: 36px;\n  text-align: center;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.gx-algolia-header .gx-search-bar .gx-search-icon {\n  margin-top: 2px;\n  text-align: left;\n}\n.gx-search-bar .ant-input-lg + .gx-search-icon {\n  height: 40px;\n  line-height: 45px;\n}\n.gx-lt-icon-search-bar input[type=\"search\"] {\n  padding-right: 16px;\n  padding-left: 35px;\n  border: 0 none;\n}\n.gx-lt-icon-search-bar .gx-search-icon {\n  left: 0;\n  right: auto;\n}\n.gx-algolia-header .gx-lt-icon-search-bar {\n  margin-right: 10px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-algolia-header .gx-lt-icon-search-bar {\n    width: 140px;\n  }\n}\n@media screen and (max-width: 400px) {\n  .gx-algolia-header .gx-lt-icon-search-bar {\n    margin-right: 0;\n    margin-bottom: 10px;\n    width: auto;\n  }\n}\n.gx-lt-icon-search-bar-lg {\n  width: 350px;\n}\n.gx-lt-icon-search-bar-lg input[type=\"search\"] {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  height: 46px;\n  padding: 10px 18px 10px 40px;\n}\n@media screen and (max-width: 991px) {\n  .gx-lt-icon-search-bar-lg input[type=\"search\"] {\n    height: 38px;\n    padding: 5px 18px 5px 40px;\n  }\n}\n.gx-header-search .gx-lt-icon-search-bar-lg input[type=\"search\"] {\n  background-color: #f5f5f5;\n  height: 36px;\n  -webkit-border-radius: 4px 0 0 4px;\n  -moz-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n  border: solid 1px #e8e8e8;\n}\n.gx-header-search .gx-lt-icon-search-bar-lg input[type=\"search\"]:focus {\n  background-color: #f2f2f2;\n}\n.gx-header-horizontal-dark .gx-header-search .gx-lt-icon-search-bar-lg input[type=\"search\"] {\n  border-color: rgba(255, 255, 255, 0.2);\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n.gx-header-horizontal-dark .gx-header-search .gx-lt-icon-search-bar-lg input[type=\"search\"]:focus {\n  background-color: transparent;\n}\n.gx-lt-icon-search-bar-lg .gx-search-icon {\n  width: 35px;\n  height: 46px;\n  line-height: 50px;\n  font-size: 16px;\n  left: 0;\n  right: auto;\n}\n@media screen and (max-width: 991px) {\n  .gx-lt-icon-search-bar-lg .gx-search-icon {\n    height: 38px;\n    line-height: 40px;\n  }\n}\n.gx-header-search .gx-lt-icon-search-bar-lg .gx-search-icon {\n  height: 36px;\n  line-height: 40px;\n}\n.gx-inside-header-horizontal .gx-lt-icon-search-bar-lg {\n  width: 200px;\n  margin-right: 10px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-inside-header-horizontal .gx-lt-icon-search-bar-lg {\n    width: 120px;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-lt-icon-search-bar-lg {\n    width: 150px;\n  }\n}\n.gx-popover-search-bar {\n  width: 150px;\n  margin: -10px -14px;\n}\n.gx-chat-search-bar {\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  min-width: 100px;\n  width: auto;\n}\n.gx-chat-search-bar input[type=\"search\"] {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n  height: 40px;\n  border: 0 none;\n}\n.gx-chat-search-bar input[type=\"search\"]:focus {\n  background-color: #ffffff;\n}\n.gx-chat-search-bar .gx-search-icon {\n  height: 40px;\n  line-height: 44px;\n}\n.ant-transfer-list {\n  width: 150px;\n}\n@media screen and (max-width: 575px) {\n  .ant-transfer-list {\n    width: 100%;\n  }\n}\n.gx-select-sm {\n  font-size: 12px;\n}\n.gx-select-sm .ant-select-selection {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.gx-select-sm .ant-select-selection--single,\n.gx-select-sm.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  height: 24px;\n  padding: 0 7px;\n}\n.gx-select-sm.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {\n  height: 22px;\n}\n.gx-select-sm.ant-select-single .ant-select-selector .ant-select-selection-item,\n.gx-select-sm.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  line-height: 22px;\n}\n.gx-select-sm .ant-select-selection__rendered {\n  line-height: 22px;\n  margin-left: 6px;\n  margin-right: 6px;\n}\n.gx-select-sm .ant-select-selection-selected-value {\n  padding-right: 20px;\n}\n.gx-select-sm .ant-select-arrow {\n  right: 6px;\n}\n.gx-select-sm .ant-select-dropdown {\n  font-size: 12px;\n}\n.gx-form-inline-label-up .ant-form-item,\n.gx-form-inline-label-up .ant-form-item > .ant-form-item-control-wrapper,\n.gx-form-inline-label-up .ant-form-item > .ant-form-item-label {\n  display: block;\n}\n.gx-form-inline-label-up .ant-form-item-label {\n  text-align: left;\n  color: #bfbfbf;\n  line-height: 1;\n  margin-bottom: 4px;\n}\n.gx-form-inline-label-up .ant-select-selection--single,\n.gx-form-inline-label-up .ant-input {\n  height: 30px;\n}\n.gx-form-inline-label-up .ant-select-selection__rendered {\n  line-height: 28px;\n}\n.gx-form-inline-label-up .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  height: 30px;\n}\n.gx-form-inline-label-up .ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {\n  height: 28px;\n}\n.gx-form-inline-label-up .ant-select-single .ant-select-selector .ant-select-selection-item,\n.gx-form-inline-label-up .ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  line-height: 28px;\n}\n.gx-form-inline-label-up.ant-form-inline .ant-form-item > .ant-form-item-label,\n.gx-form-inline-label-up.ant-form-inline .ant-form-item > .ant-form-item-control {\n  display: block;\n}\n.gx-form-inline-label-up .ant-form-item-label > label {\n  height: auto;\n}\n.gx-input-lineheight {\n  line-height: 36px;\n}\n.ant-mention-wrapper {\n  border: solid 1px #e8e8e8;\n  padding: 8.6px 11px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n@media screen and (max-width: 575px) {\n  .gx-ant-transfer-width .ant-transfer-list {\n    width: 100% !important;\n  }\n}\n@media screen and (max-width: 475px) {\n  .ant-input-group.ant-input-group-compact > * {\n    -webkit-border-radius: 4px !important;\n    -moz-border-radius: 4px !important;\n    border-radius: 4px !important;\n    width: 100% !important;\n    border-right-width: 1px;\n  }\n  .ant-input-group.ant-input-group-compact > *:not(:last-child) {\n    margin-bottom: 10px;\n  }\n  .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,\n  .ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,\n  .ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,\n  .ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,\n  .ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,\n  .ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input {\n    border-radius: 4px;\n    border-right-width: 1px;\n  }\n  .ant-input-group.ant-input-group-compact .gx-border-lt-xs {\n    border-left: 1px solid #d9d9d9 !important;\n  }\n}\n/*Icon Styles*/\n.gx-icon-views {\n  position: relative;\n  text-align: center;\n  padding: 16px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  margin-bottom: 15px;\n  height: calc(100% - 15px);\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-icon-views .icon {\n  margin-bottom: 12px;\n  font-size: 20px;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  line-height: 1;\n  display: block;\n}\n.gx-icon-views:hover {\n  background-color: var(--app-primary-color);\n  cursor: pointer;\n  color: #ffffff;\n}\n.gx-icon-views:hover .icon {\n  -webkit-transform: scale(1.4);\n  -moz-transform: scale(1.4);\n  -ms-transform: scale(1.4);\n  -o-transform: scale(1.4);\n  transform: scale(1.4);\n}\n.gx-icon-text {\n  display: block;\n  font-size: 12px;\n}\n.ant-btn-icon-only {\n  padding: 0;\n}\n/*List Styles*/\n.ant-list-vertical .ant-list-item-main {\n  min-width: 200px;\n}\n@media screen and (max-width: 480px) {\n  .ant-list-vertical .ant-list-item-extra {\n    margin-bottom: 10px;\n  }\n}\n.gx-list-item .ant-list-item-extra-wrap {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra {\n  margin-left: 20px;\n}\n@media screen and (max-width: 575px) {\n  .gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra {\n    margin-left: 0;\n    margin-top: 10px;\n  }\n  .gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra img {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-list-item .ant-list-item-extra-wrap {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n.gx-user-list {\n  width: 100%;\n  padding-bottom: 10px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-user-list:not(:first-child) {\n  padding-top: 20px;\n}\n@media screen and (max-width: 575px) {\n  .gx-user-list:not(:first-child) {\n    padding-top: 0;\n  }\n}\n.gx-user-list.gx-card-list {\n  padding: 30px;\n  background: #fff;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  margin-bottom: 32px;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n}\n.gx-user-list.gx-card-list .gx-avatar-img {\n  margin-right: 25px;\n}\n@media screen and (max-width: 767px) {\n  .gx-user-list.gx-card-list {\n    padding: 20px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-user-list.gx-card-list {\n    margin-bottom: 20px;\n  }\n}\n.gx-user-list .gx-avatar-img {\n  margin-right: 20px;\n  margin-bottom: 10px;\n}\n.gx-user-list h3 {\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n.gx-user-list .gx-link[class*=\"gx-meta-\"] {\n  display: inline-block;\n  color: #545454;\n  font-size: 12px;\n  font-weight: 500;\n}\n.gx-user-list .gx-link[class*=\"gx-meta-\"] i {\n  margin-right: 6px;\n  vertical-align: middle;\n}\n.gx-user-list .gx-description {\n  width: calc(100% - 120px);\n}\n@media screen and (max-width: 575px) {\n  .gx-user-list .gx-description {\n    width: 100%;\n  }\n}\n.gx-user-list .gx-btn-list li:not(:last-child) {\n  margin-right: 10px;\n}\n.gx-list-inline {\n  margin-left: -5px;\n  margin-right: -5px;\n  padding-left: 0;\n  list-style: none;\n}\n.gx-list-inline li {\n  padding: 0 5px;\n  display: inline-block;\n}\n.gx-list-inline-lg {\n  margin-left: -10px;\n  margin-right: -10px;\n  padding-left: 0;\n  list-style: none;\n}\n.gx-list-inline-lg li {\n  padding: 0 10px;\n  display: inline-block;\n}\n.gx-card-strip {\n  margin-bottom: 10px;\n}\n.gx-card-strip:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-card-list .gx-description {\n  width: calc(100% - 230px);\n  margin-top: 5px;\n}\n@media screen and (max-width: 767px) {\n  .gx-card-list .gx-description {\n    width: calc(100% - 80px);\n  }\n}\n.gx-card-list .gx-card-list-footer {\n  padding-left: 15px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  min-width: 150px;\n}\n.gx-card-list .gx-card-list-footer .ant-btn {\n  display: block;\n  margin-right: 0;\n  width: 120px;\n}\n.gx-card-list .gx-card-list-footer .ant-btn:last-child {\n  margin-bottom: 0;\n}\n@media screen and (max-width: 767px) {\n  .gx-card-list .gx-card-list-footer {\n    padding-left: 0;\n    min-width: 10px;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .gx-card-list .gx-card-list-footer .ant-btn {\n    width: auto;\n    margin-right: 12px;\n    margin-bottom: 0;\n  }\n}\n.gx-list-group {\n  list-style: none;\n  padding-left: 0;\n}\n.gx-list-group li {\n  margin-bottom: 6px;\n}\n.gx-list-group li i,\n.gx-list-group li .anticon {\n  margin-right: 12px;\n}\n.gx-dot-list {\n  list-style: none;\n  margin: 0 -3px 10px;\n  padding-left: 0;\n}\n.gx-dot-list li {\n  display: inline-block;\n  vertical-align: top;\n  padding: 0 3px;\n}\n@media screen and (max-width: 575px) {\n  .gx-dot-list {\n    margin-bottom: 5px;\n  }\n}\n/*Loader Styles*/\n.ant-spin {\n  margin-right: 16px;\n  margin-bottom: 10px;\n}\n.gx-loader-container {\n  text-align: center;\n  background-color: #f5f5f5;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  padding: 30px 50px;\n  margin-right: 0;\n  display: block;\n}\n/*Pagination Styles*/\n.ant-pagination > li {\n  margin-bottom: 10px;\n}\n.ant-pagination.mini:not(:last-child) {\n  margin-bottom: 10px;\n}\n.ant-pagination.mini li {\n  margin-bottom: 5px !important;\n}\n.ant-pagination-prev,\n.ant-pagination-next,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  line-height: 30px;\n}\n/*Pickers Styles*/\n.photoshop-picker,\n.swatches-picker,\n.alpha-picker,\n.hue-picker {\n  width: 100% !important;\n}\n.gx-alpha-pickers {\n  position: relative;\n  min-height: 250px;\n}\n.ant-calendar-footer .ant-calendar-ok-btn {\n  margin-bottom: 0;\n}\n/*Progress Styles*/\n.ant-progress-line {\n  margin-right: 8px;\n  margin-bottom: 8px;\n}\n.ant-progress-circle {\n  margin-right: 8px;\n  margin-bottom: 8px;\n}\n/*Steps Styles*/\n.ant-steps-dot {\n  flex-wrap: wrap;\n  overflow: hidden;\n  padding: 10px 0;\n}\n.ant-steps-dot .ant-steps-item {\n  margin-bottom: 10px;\n}\n@media screen and (max-width: 575px) {\n  .ant-steps-dot .ant-steps-item-description {\n    display: none;\n  }\n}\n/*Slider Styles*/\n.ant-carousel h1,\n.ant-carousel h2,\n.ant-carousel h3,\n.ant-carousel h4,\n.ant-carousel h5,\n.ant-carousel h6 {\n  line-height: inherit;\n  margin-bottom: 0;\n}\n.ant-carousel .slick-dots {\n  margin-left: 0;\n  margin-right: 0;\n}\n.gx-vertical-slider {\n  position: relative;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0 -15px;\n}\n.gx-vertical-slider-item {\n  width: 33.33%;\n  padding: 0 15px;\n  height: 300px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media screen and (max-width: 575px) {\n  .gx-vertical-slider-item {\n    width: 50%;\n    margin-bottom: 15px;\n  }\n}\n.ant-carousel-vertical .gx-vertical-slide .slick-slide {\n  height: 160px;\n}\n.slick-slider {\n  margin-bottom: 32px;\n}\n@media screen and (max-width: 575px) {\n  .slick-slider {\n    margin-bottom: 20px;\n  }\n}\n.slick-slider .slick-prev {\n  left: -10px;\n}\n.slick-slider .slick-prev:before {\n  color: #000000;\n}\n.slick-slider .slick-next {\n  right: -10px;\n}\n.slick-slider .slick-next:before {\n  color: #000000;\n}\n.slick-slider img {\n  width: 100%;\n  object-fit: cover;\n}\n.slick-dots li button:before {\n  display: none;\n}\n.gx-slick-slider .slick-dots {\n  bottom: 26px;\n  padding: 0 24px;\n  text-align: left;\n}\n.gx-slick-slider .slick-dots li {\n  width: 10px !important;\n  height: 10px !important;\n}\n.gx-slick-slider .slick-dots li button {\n  width: 10px !important;\n  height: 10px !important;\n}\n.gx-slick-slider .slick-dots li button:before {\n  width: 10px !important;\n  height: 10px !important;\n  line-height: 10px !important;\n  color: transparent;\n  border: solid 2px #000000;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  display: block;\n}\n.gx-slick-slider .slick-dots li.slick-active button {\n  width: 12px !important;\n  height: 12px !important;\n}\n.gx-slick-slider .slick-dots li.slick-active button:before {\n  color: transparent;\n  border-color: var(--app-primary-color);\n  width: 12px !important;\n  height: 12px !important;\n  line-height: 12px !important;\n}\n.gx-slide-item {\n  margin-left: 15px;\n  margin-right: 15px;\n}\n@media screen and (max-width: 480px) {\n  .gx-slide-item {\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n}\n.gx-slider {\n  position: relative;\n}\n.gx-slider-img {\n  position: relative;\n  padding-bottom: 24px;\n}\n.gx-slider-img .gx-img-up {\n  position: absolute;\n  left: 24px;\n  bottom: -5px;\n  z-index: 1;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  width: auto;\n  max-width: 64px;\n}\n.gx-slider-content {\n  padding: 24px;\n}\n.gx-slick-slider {\n  margin-bottom: 0;\n  padding-bottom: 24px;\n}\n.gx-slick-slider-dot-top {\n  padding-top: 70px;\n  padding-right: 24px;\n  padding-bottom: 58px;\n}\n@media (max-width: 1366px) {\n  .gx-slick-slider-dot-top {\n    padding-top: 40px;\n    padding-bottom: 10px;\n  }\n}\n.gx-slick-slider-dot-top .slick-dots {\n  bottom: auto;\n  top: 30px;\n  padding-left: 0;\n}\n@media (max-width: 1366px) {\n  .gx-slick-slider-dot-top .slick-dots {\n    top: 10px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-slick-slider-dot-top {\n    padding-left: 24px;\n  }\n}\n.gx-slick-slider-lt-thumb {\n  height: 100%;\n  position: relative;\n}\n.gx-slick-slider-lt-thumb img {\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n}\n@media screen and (max-width: 575px) {\n  .gx-slick-slider-lt-thumb img {\n    position: relative;\n    left: auto;\n    top: auto;\n  }\n}\n.ant-modal .slides {\n  position: relative;\n}\n.ant-modal .slides .slick-prev,\n.ant-modal .slides .slick-next {\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n  margin-top: -10px;\n}\n.ant-modal .slides .slick-prev {\n  left: 20px;\n}\n.ant-modal .slides .slick-next {\n  right: 20px;\n}\n.ant-modal .slick-slider {\n  margin-bottom: 0;\n}\n/*Tables Styles*/\n.ant-table-small .ant-table-thead > tr > th {\n  background-color: transparent;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-body > table,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table {\n  padding: 0;\n}\n.ant-table-small > .ant-table-content > .ant-table-body {\n  margin: 0;\n}\n.ant-table-thead > tr > th,\n.ant-table-tbody > tr > td {\n  word-break: normal;\n}\n.gx-table-responsive .ant-table {\n  min-height: 0.01%;\n  overflow-x: auto;\n}\n@media screen and (max-width: 767px) {\n  .gx-table-responsive .ant-table {\n    width: 100%;\n    overflow-y: hidden;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: solid 1px #e8e8e8;\n  }\n  .ant-card-bordered.gx-card-full .gx-table-responsive .ant-table {\n    border: 0 none;\n    border-bottom: solid 1px #e8e8e8;\n  }\n  .gx-table-responsive .ant-table .ant-table-tbody > tr:last-child > td {\n    border-bottom: 0 none;\n  }\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-header > table,\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-body > table,\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-fixed-left table,\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-fixed-right table {\n    border-top: 0 none;\n    border-left: 0 none;\n  }\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-title {\n    border: 0 none;\n  }\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-footer {\n    border: 0 none;\n    border-top: solid 1px #e8e8e8;\n  }\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-thead > tr > th:last-child,\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-tbody > tr > td:last-child {\n    border-right: 0 none;\n  }\n  .gx-table-responsive .ant-table-body > table > thead > tr > th,\n  .gx-table-responsive .ant-table-body > table > tbody > tr > th,\n  .gx-table-responsive .ant-table-body > table > tfoot > tr > th,\n  .gx-table-responsive .ant-table-body > table > thead > tr > td,\n  .gx-table-responsive .ant-table-body > table > tbody > tr > td,\n  .gx-table-responsive .ant-table-body > table > tfoot > tr > td {\n    white-space: nowrap;\n  }\n}\n.gx-table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 1rem;\n  background-color: transparent;\n}\n.gx-table th,\n.gx-table td {\n  padding: 0.75rem;\n  vertical-align: top;\n  border-top: solid 1px #e8e8e8;\n}\n.gx-table thead th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #e8e8e8;\n}\n.gx-table tbody + tbody {\n  border-top: 2px solid #e8e8e8;\n}\n.gx-table-bordered {\n  border: 1px solid #e8e8e8;\n}\n.gx-table-bordered th,\n.gx-table-bordered td {\n  border: 1px solid #e8e8e8;\n}\n.gx-table-bordered thead th,\n.gx-table-bordered thead td {\n  border-bottom-width: 2px;\n}\n.gx-table-no-bordered {\n  border: 0 none;\n}\n.gx-table-no-bordered th,\n.gx-table-no-bordered td {\n  border: 0 none;\n}\n.gx-table-no-bordered thead th,\n.gx-table-no-bordered thead td {\n  border-bottom-width: 2px;\n}\n.gx-table-no-bordered .ant-table {\n  border: 0 none;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n.gx-table-no-bordered .ant-table-thead > tr > th {\n  font-weight: 300;\n  text-transform: uppercase;\n  font-size: 11px;\n}\n.gx-table-no-bordered .ant-table-tbody > tr > td {\n  border-bottom: 0 none;\n}\n.gx-table-thead-uppercase thead th {\n  text-transform: uppercase;\n}\n.gx-table-padding-lg thead th,\n.gx-table-padding-lg tbody td {\n  padding: 20px 30px !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-table-padding-lg thead th,\n  .gx-table-padding-lg tbody td {\n    padding: 15px 20px !important;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-table-padding-lg thead th,\n  .gx-table-padding-lg tbody td {\n    padding: 10px !important;\n  }\n}\n.gx-table-padding-lg .ant-table-pagination {\n  float: none;\n  text-align: center;\n  margin: 22px 0;\n}\n@media screen and (max-width: 991px) {\n  .gx-table-padding-lg .ant-table-pagination {\n    margin: 16px 0;\n  }\n}\n/*Time Lines Style*/\n/*Antd Time Lines Style*/\n.ant-timeline-item {\n  padding: 0;\n}\n.ant-timeline-item:not(:last-child) {\n  padding-bottom: 20px;\n}\n@media screen and (max-width: 575px) {\n  .ant-timeline-item:not(:last-child) {\n    padding-bottom: 15px;\n  }\n}\n.gx-timeline-info {\n  position: relative;\n}\n.gx-timeline-info:not(:last-child) {\n  padding-bottom: 20px;\n}\n.gx-timeline-info-day {\n  margin-bottom: 15px;\n  font-size: 12px;\n  color: #595959;\n}\n.gx-timeline-info .ant-timeline {\n  padding-top: 0;\n  padding-left: 0;\n}\n.gx-timeline-info .ant-timeline-item-head-custom {\n  padding: 0;\n  margin-right: 15px;\n  position: relative;\n  left: 0;\n  top: 0;\n  -webkit-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  transform: translate(0, 0);\n}\n.gx-timeline-info .ant-timeline-item {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: flex-start;\n  -ms-align-items: flex-start;\n  align-items: flex-start;\n}\n.gx-timeline-info .ant-timeline-item-content {\n  padding-left: 0;\n  top: 0;\n  margin-left: 0;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  color: #595959;\n}\n.gx-timeline-info .ant-timeline-item-content .gx-link {\n  color: #262626;\n}\n.gx-timeline-info .ant-timeline-item-content .gx-link:hover,\n.gx-timeline-info .ant-timeline-item-content .gx-link:focus {\n  color: var(--app-primary-color);\n}\n.gx-timeline-info .ant-timeline-item-tail {\n  display: none;\n}\n.gx-img-more {\n  width: 60px;\n  height: 40px;\n  background-color: #ffffff;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  border: solid 1px #e8e8e8;\n}\n/*Custom Time Lines Style*/\n.gx-timeline-left {\n  float: left;\n  margin-right: 20px;\n}\n.gx-timeline-right {\n  float: right;\n  margin-left: 20px;\n}\n.gx-timeline-circle {\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n}\n.gx-timeline-section {\n  margin-bottom: 25px;\n  overflow: hidden;\n}\n.gx-timeline-item {\n  padding-bottom: 25px;\n  padding-left: 80px;\n  position: relative;\n}\n.gx-timeline-item:before {\n  border-left: solid 2px #e8e8e8;\n  content: \"\";\n  left: 25px;\n  position: absolute;\n  top: 25px;\n  bottom: -20px;\n  width: 2px;\n  z-index: 1;\n}\n.gx-timeline-item:first-child:before {\n  border-left-style: dashed;\n}\n.gx-timeline-item:last-child:before {\n  border-left-style: dashed;\n  bottom: 25px;\n}\n.gx-timeline-badge {\n  height: 50px;\n  width: 50px;\n  position: absolute;\n  left: 0;\n  top: 16px;\n  z-index: 2;\n  font-size: 16px;\n  color: #ffffff;\n  text-align: center;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n}\n.gx-timeline-badge.gx-timeline-img {\n  background-color: transparent;\n}\n.gx-timeline-badge.gx-timeline-img:after {\n  display: none;\n}\n.gx-timeline-badge:after {\n  position: absolute;\n  content: \"\";\n  width: 42px;\n  height: 42px;\n  background-color: transparent;\n  border: 4px solid #e8e8e8;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  left: 4px;\n  top: 4px;\n  z-index: 1;\n}\n.gx-timeline-badge [class^=\"gx-\"]:before,\n.gx-timeline-badge [class*=\"gx-\"]:before {\n  line-height: 50px;\n}\n.gx-timeline-img > img,\n.gx-timeline-header-img > img {\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n}\n.gx-timeline-panel {\n  padding: 20px 30px;\n  position: relative;\n  background-color: #ffffff;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  border: solid 1px #e8e8e8;\n}\n.gx-timeline-panel:after,\n.gx-timeline-panel:before {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  display: inline-block;\n  top: 30px;\n}\n.gx-timeline-panel:before {\n  border-color: transparent #e8e8e8;\n  border-width: 10px 17px 10px 0;\n  left: -18px;\n}\n.gx-timeline-panel:after {\n  border-color: transparent #ffffff;\n  border-width: 10px 16px 10px 0;\n  left: -16px;\n}\n.gx-timeline-no-padding {\n  padding: 0;\n}\n.gx-timeline-panel-header {\n  margin-bottom: 10px;\n}\n.gx-timeline-header-img {\n  margin-bottom: 10px;\n}\n.gx-timeline-inverted .gx-timeline-left {\n  float: right;\n  margin-right: 0;\n  margin-left: 20px;\n}\n.gx-timeline-heading {\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n.gx-timeline-body {\n  clear: both;\n}\n/*Gxtl Center Style*/\n.gx-timeline-center .gx-timeline-item {\n  clear: both;\n  float: right;\n  width: 50%;\n  padding-left: 55px;\n}\n.gx-timeline-center .gx-timeline-item:before {\n  left: 0;\n}\n.gx-timeline-center .gx-timeline-badge {\n  left: -25px;\n  right: auto;\n}\n.gx-timeline-center .gx-timeline-time {\n  position: absolute;\n  top: 32px;\n  left: -150px;\n  right: auto;\n  z-index: 2;\n}\n.gx-timeline-center .gx-timeline-inverted {\n  float: left;\n  text-align: right;\n  padding-left: 0;\n  padding-right: 55px;\n}\n.gx-timeline-center .gx-timeline-inverted:before {\n  border-left: 0 none;\n  border-right: solid 2px #e8e8e8;\n  left: auto;\n  right: -2px;\n}\n.gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {\n  left: auto;\n  right: -25px;\n}\n.gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:before {\n  border-width: 10px 0 10px 17px;\n  left: auto;\n  right: -18px;\n}\n.gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:after {\n  border-width: 10px 0 10px 16px;\n  left: auto;\n  right: -16px;\n}\n.gx-timeline-center .gx-timeline-inverted .gx-timeline-time {\n  position: absolute;\n  top: 32px;\n  right: -150px;\n  left: auto;\n  z-index: 2;\n}\n/*Gxtl Zigzag Style*/\n.gx-timeline-zigzag .gx-timeline-item {\n  padding-left: 150px;\n}\n.gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {\n  margin-top: -80px;\n}\n.gx-timeline-zigzag .gx-timeline-img {\n  width: 90px;\n  height: 90px;\n  left: 5px;\n}\n.gx-timeline-zigzag .gx-timeline-img > img {\n  width: 100%;\n}\n.gx-timeline-zigzag .gx-timeline-inverted .gx-timeline-img {\n  right: 5px !important;\n}\n.gx-timeline-zigzag .gx-timeline-item:before {\n  -webkit-transform: rotate(35deg);\n  -moz-transform: rotate(35deg);\n  -ms-transform: rotate(35deg);\n  -o-transform: rotate(35deg);\n  transform: rotate(35deg);\n  top: 20px;\n  bottom: 20px;\n}\n.gx-timeline-zigzag .gx-timeline-inverted {\n  padding-left: 0;\n  padding-right: 150px;\n}\n.gx-timeline-zigzag .gx-timeline-inverted:before {\n  -webkit-transform: rotate(-35deg);\n  -moz-transform: rotate(-35deg);\n  -ms-transform: rotate(-35deg);\n  -o-transform: rotate(-35deg);\n  transform: rotate(-35deg);\n}\n.gx-timeline-zigzag .gx-timeline-item:first-child:before {\n  border-left-style: solid;\n}\n.gx-timeline-zigzag .gx-timeline-item:last-child:before {\n  display: none;\n}\n.gx-timeline-item:last-child:before {\n  bottom: 25px;\n}\n@media screen and (max-width: 991px) {\n  .gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {\n    margin-top: -60px;\n  }\n  .gx-timeline-zigzag .gx-timeline-item:before {\n    bottom: 0;\n  }\n  .gx-timeline-zigzag .gx-timeline-item {\n    padding-left: 120px;\n  }\n  .gx-timeline-zigzag .gx-timeline-inverted {\n    padding-right: 120px;\n    padding-left: 0;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-timeline-center .gx-timeline-item {\n    float: none;\n    padding-left: 80px;\n    width: auto;\n  }\n  .gx-timeline-center .gx-timeline-item:before {\n    left: 25px;\n  }\n  .gx-timeline-center .gx-timeline-badge {\n    left: 0;\n  }\n  .gx-timeline-center .gx-timeline-inverted {\n    float: none;\n    text-align: left;\n    padding-right: 0;\n  }\n  .gx-timeline-center .gx-timeline-inverted:before {\n    border-left: solid 2px #e8e8e8;\n    border-right: 0 none;\n    left: 24px;\n    right: auto;\n  }\n  .gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {\n    right: auto;\n    left: 0;\n  }\n  .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:before {\n    border-width: 10px 17px 10px 0 !important;\n    left: -18px;\n    right: auto;\n  }\n  .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:after {\n    border-width: 10px 16px 10px 0 !important;\n    left: -16px;\n    right: auto;\n  }\n  .gx-timeline-inverted .gx-timeline-panel-header {\n    float: none;\n  }\n  .gx-timeline-inverted .gx-timeline-left {\n    float: left;\n    margin-left: 0;\n    margin-right: 20px;\n  }\n  .gx-timeline-zigzag .gx-timeline-panel {\n    max-height: none;\n    min-height: 10px;\n    overflow-y: visible;\n  }\n  .gx-timeline-zigzag .gx-timeline-item {\n    padding-left: 100px;\n  }\n  .gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {\n    margin-top: 0;\n  }\n  .gx-timeline-zigzag .gx-timeline-item:before {\n    transform: none;\n    top: 25px;\n    bottom: -25px;\n    left: 45px;\n  }\n  .gx-timeline-zigzag .gx-timeline-item:last-child:before {\n    bottom: 0;\n  }\n  .gx-timeline-zigzag .gx-timeline-inverted:before {\n    transform: none;\n  }\n  .gx-timeline-center .gx-timeline-time,\n  .gx-timeline-center .gx-timeline-inverted .gx-timeline-time {\n    position: relative;\n    top: auto;\n    left: auto;\n    right: auto;\n    margin-bottom: 6px;\n  }\n  .gx-timeline-center .gx-timeline-time-item .gx-timeline-panel::before,\n  .gx-timeline-center .gx-timeline-time-item .gx-timeline-panel::after {\n    top: 10px;\n  }\n}\n@media screen and (max-width: 399px) {\n  .gx-timeline-left {\n    float: none;\n    margin-right: 0;\n  }\n  .gx-timeline-right {\n    float: none;\n    margin-left: 0;\n  }\n  .gx-timeline-inverted .gx-timeline-left {\n    float: none;\n    margin-right: 0;\n  }\n}\n/*Tabs Styles*/\n.gx-tabs-half .ant-tabs-bar {\n  margin-bottom: 0;\n}\n.gx-tabs-half .ant-tabs-nav {\n  display: block;\n}\n.gx-tabs-half .ant-tabs-nav .ant-tabs-tab {\n  margin: 0;\n  width: 50%;\n  text-align: center;\n  display: block;\n}\n.gx-tabs-half .ant-tabs-nav .ant-tabs-ink-bar {\n  width: 50%;\n}\n.gx-card-tabs .ant-card-head-title {\n  text-transform: capitalize;\n  font-size: 16px;\n}\n.gx-card-tabs .ant-card-extra {\n  position: relative;\n  z-index: 2;\n}\n.gx-card-tabs .ant-tabs {\n  margin-top: -40px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-tabs .ant-tabs {\n    margin-top: 0;\n  }\n}\n.gx-card-tabs .ant-tabs-tab {\n  padding-left: 5px;\n  padding-right: 5px;\n  margin-right: 15px;\n}\n.gx-card-tabs .ant-tabs-tab-active {\n  font-weight: 400;\n}\n.gx-card-tabs .ant-tabs-nav-wrap {\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  font-size: 16px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-tabs .ant-tabs-nav-wrap {\n    -webkit-justify-content: flex-start;\n    -ms-justify-content: flex-start;\n    justify-content: flex-start;\n  }\n}\n.gx-card-tabs .ant-card-body {\n  padding-top: 4px;\n}\n.gx-tabs-right .ant-tabs-nav-wrap {\n  -webkit-justify-content: flex-end;\n  -ms-justify-content: flex-end;\n  justify-content: flex-end;\n}\n@media screen and (max-width: 575px) {\n  .gx-tabs-right .ant-tabs-nav-wrap {\n    -webkit-justify-content: flex-start;\n    -ms-justify-content: flex-start;\n    justify-content: flex-start;\n  }\n}\n/* Apps Style */\n.gx-app-module {\n  position: relative;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: -32px -32px 0;\n  flex: 1;\n}\n@media screen and (max-width: 575px) {\n  .gx-app-module {\n    margin: -20px -15px 0;\n  }\n}\n.gx-container-wrap .gx-app-module {\n  margin: 0;\n  margin-bottom: 32px;\n}\n.gx-module-side {\n  position: relative;\n  z-index: 2;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 0 1 230px;\n  -ms-flex: 0 1 230px;\n  flex: 0 1 230px;\n  min-width: 230px;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-side {\n    min-width: 220px;\n    background-color: #ffffff;\n  }\n}\n.gx-module-side-header {\n  padding: 10px;\n  min-height: 79px;\n  border-bottom: solid 1px #e8e8e8;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  background-color: #fbfbfb;\n  color: #545454;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-side-header {\n    min-height: 72px;\n  }\n}\n.gx-module-logo {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  font-size: 20px;\n}\n.gx-module-logo i {\n  font-size: 28px;\n  line-height: 18px;\n}\n.gx-module-user-info,\n.gx-module-side-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-module-user-detail {\n  font-size: 12px;\n}\n.gx-module-add-task {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 24px;\n}\n.gx-module-add-task .ant-btn {\n  margin-bottom: 0;\n}\n.gx-module-nav {\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-module-nav li {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-module-nav li .gx-link {\n  padding: 5px 29px;\n  color: #999999;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  text-decoration: none;\n}\n.gx-module-nav li .gx-link:hover,\n.gx-module-nav li .gx-link:focus {\n  color: #000000;\n}\n.gx-module-nav li .gx-link.active {\n  color: var(--app-primary-color);\n}\n.gx-module-nav li i {\n  margin-right: 16px;\n  font-size: 16px;\n}\n.gx-module-nav li i[class^=\"icon-\"]::before,\n.gx-module-nav li i[class*=\" icon-\"]::before {\n  display: block;\n}\n.gx-module-nav li span {\n  display: inline-block;\n  vertical-align: middle;\n}\n.gx-module-nav li.gx-module-nav-label {\n  padding: 12px 29px;\n}\n.gx-module-box {\n  position: relative;\n  z-index: 2;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  max-width: calc(100% - 230px - 1px);\n}\n@media screen and (max-width: 991px) {\n  .gx-module-box {\n    max-width: 100%;\n  }\n}\n.gx-module-box-header {\n  padding: 10px 26px;\n  min-height: 79px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  background-color: #ffffff;\n  border-bottom: solid 1px #e8e8e8;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-box-header {\n    position: relative;\n    min-height: 58px;\n    padding: 5px 26px 5px 110px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-module-box-header .gx-drawer-btn {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 1;\n    border-right: solid 1px #e8e8e8;\n    height: 58px;\n    width: 98px;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    -webkit-justify-content: center;\n    -ms-justify-content: center;\n    justify-content: center;\n    -webkit-align-items: center;\n    -ms-align-items: center;\n    align-items: center;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    border-radius: 0;\n    font-size: 22px;\n    text-align: center;\n  }\n}\n.gx-module-box-header-inner {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n}\n.gx-module-box-header-right {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-left: auto;\n}\n.gx-module-box-content {\n  background-color: #ffffff;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n.gx-module-box-topbar {\n  padding: 8px 28px;\n  min-height: 65px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-module-box-topbar label.ant-checkbox-wrapper {\n  margin-right: 10px;\n}\n.gx-module-box-topbar .ant-dropdown-trigger {\n  cursor: pointer;\n  margin-right: 10px;\n}\n.gx-module-box-topbar .ant-dropdown-trigger .icon:before {\n  position: relative;\n  top: 3px;\n}\n.gx-module-box-topbar-todo {\n  padding-left: 28px;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-box-topbar {\n    min-height: 58px;\n    padding-left: 28px;\n    padding-right: 28px;\n  }\n}\n.gx-module-list-icon {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  padding-right: 10px;\n}\n.gx-module-list-icon .gx-bar-icon .gx-icon-menu:before {\n  top: 3px;\n  position: relative;\n}\n.gx-toolbar-separator {\n  border-left: solid 1px #e8e8e8;\n  height: 100%;\n  width: 1px;\n  margin: 0 12px;\n}\n.gx-module-list {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-module-list-item {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  padding: 15px 28px;\n  z-index: 5;\n  position: relative;\n  cursor: pointer;\n}\n.gx-module-list-item:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-module-list-item.gx-mail-cell {\n  -webkit-align-items: start;\n  -ms-align-items: start;\n  align-items: start;\n}\n@media screen and (max-width: 575px) {\n  .gx-module-list-item {\n    padding-bottom: 10px;\n    padding-top: 10px;\n  }\n}\n.gx-module-detail-header {\n  margin-bottom: 10px;\n}\n@media screen and (max-width: 575px) {\n  .gx-module-detail-header {\n    margin-bottom: 0;\n  }\n}\n.gx-module-list-info {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  max-width: calc(100% - 140px);\n}\n@media screen and (max-width: 575px) {\n  .gx-module-list-info {\n    max-width: calc(100% - 100px);\n  }\n}\n.gx-module-todo-content {\n  position: relative;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n.gx-module-todo-content .gx-subject {\n  margin-bottom: 5px;\n}\n.gx-module-todo-right {\n  margin-left: 8px;\n}\n.gx-module-sidenav {\n  background-color: #ffffff;\n  border-right: solid 1px #e8e8e8;\n  position: relative;\n  z-index: 9;\n}\n.gx-module-sidenav .gx-chat-sidenav-main {\n  max-width: 300px;\n  min-width: 300px;\n  width: 90%;\n}\n.gx-module-date {\n  max-width: 160px;\n}\n.gx-module-detail-item {\n  padding: 10px 28px;\n}\n.gx-task-title {\n  font-size: 18px;\n}\n@media screen and (max-width: 991px) {\n  .gx-task-title {\n    font-size: 16px;\n  }\n}\n.gx-chat-todo-avatar {\n  margin-right: 15px;\n}\n.gx-module-side-scroll {\n  height: calc(100vh - 201px) !important;\n}\n.framed-layout .gx-module-side-scroll {\n  height: calc(100vh - 201px - 2 * 20px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-side-scroll {\n    height: calc(100vh - 72px) !important;\n  }\n  .framed-layout .gx-module-side-scroll {\n    height: calc(100vh - 72px) !important;\n  }\n}\n.gx-module-side-scroll > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-module-content-scroll {\n  height: calc(100vh - 266px) !important;\n}\n.framed-layout .gx-module-content-scroll {\n  height: calc(100vh - 266px - 2 * 20px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-content-scroll {\n    height: calc(100vh - 238px) !important;\n  }\n  .framed-layout .gx-module-content-scroll {\n    height: calc(100vh - 238px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-module-content-scroll {\n    height: calc(100vh - 216px) !important;\n  }\n}\n.gx-module-content-scroll > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-todo-detail-content-scroll {\n  height: calc(100vh - 319px) !important;\n}\n.framed-layout .gx-todo-detail-content-scroll {\n  height: calc(100vh - 319px - 2 * 20px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-todo-detail-content-scroll {\n    height: calc(100vh - 291px) !important;\n  }\n  .framed-layout .gx-todo-detail-content-scroll {\n    height: calc(100vh - 291px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-todo-detail-content-scroll {\n    height: calc(100vh - 270px) !important;\n  }\n}\n.gx-todo-detail-content-scroll > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-loader-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n.gx-loader-view .ant-spin {\n  margin: 0;\n}\n.gx-app-module .gx-loader-view {\n  height: calc(100vh - 266px) !important;\n}\n.framed-layout .gx-app-module .gx-loader-view {\n  height: calc(100vh - 266px - 2 * 20px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-app-module .gx-loader-view {\n    height: calc(100vh - 238px) !important;\n  }\n  .framed-layout .gx-app-module .gx-loader-view {\n    height: calc(100vh - 238px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-app-module .gx-loader-view {\n    height: calc(100vh - 244px) !important;\n  }\n}\n.gx-chat-module .gx-loader-view {\n  height: calc(100vh - 122px) !important;\n}\n.framed-layout .gx-chat-module .gx-loader-view {\n  height: calc(100vh - 122px - 2 * 20px) !important;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .gx-chat-module .gx-loader-view {\n    height: calc(100vh - 122px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-chat-module .gx-loader-view {\n    height: calc(100vh - 100px) !important;\n  }\n}\n.gx-loader-position {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 10;\n  bottom: 0;\n}\n.gx-module-default {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  height: 100%;\n  padding: 15px;\n}\n.gx-no-content-found {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  font-size: 16px;\n}\n.gx-task-des,\n.gx-task-input {\n  padding-left: 0;\n}\n/*Mails Apps Styles*/\n.gx-module-box-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  width: 100%;\n}\n.gx-module-box-column,\n.gx-module-list-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  width: 100%;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-mail-list-info {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  padding-left: 10px;\n  max-width: calc(100% - 150px);\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n@media screen and (max-width: 575px) {\n  .gx-mail-list-info {\n    max-width: 100%;\n    margin-top: 10px;\n    padding-left: 0;\n  }\n}\n.gx-mail-user-info {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-left: 10px;\n}\n.gx-mail-user-info .gx-avatar {\n  margin-right: 10px;\n}\n.gx-mail-user-info .gx-badge {\n  margin-bottom: 0;\n}\n.gx-mail-user-des {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-bottom: 3px;\n}\n.gx-mail-user-des .gx-time,\n.gx-mail-user-des .gx-icon-btn {\n  margin-left: auto;\n}\n.gx-mail-detail-inner {\n  padding: 24px;\n}\n@media screen and (max-width: 991px) {\n  .gx-mail-detail-inner {\n    padding-right: 28px;\n    padding-left: 28px;\n  }\n}\n.gx-mail-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media screen and (max-width: 498px) {\n  .gx-mail-header {\n    display: block;\n    -webkit-align-items: flex-start;\n    -ms-align-items: flex-start;\n    align-items: flex-start;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n.gx-mail-header-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-mail-header-content .gx-subject {\n  margin-bottom: 5px;\n}\n.gx-show-link {\n  cursor: pointer;\n  margin-bottom: 8px;\n  color: var(--app-primary-color);\n}\n.gx-show-detail {\n  margin-bottom: 12px;\n}\n.gx-module-list-content .gx-subject {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gx-module-list-content .gx-message {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  color: #8d8d8d;\n  font-size: 13px;\n}\n.gx-module-list-content .gx-message p {\n  margin-bottom: 8px;\n}\n.gx-size {\n  margin: 5px 0;\n}\n.gx-sender-name {\n  margin-right: 0;\n  font-weight: 500;\n  font-size: 15px;\n}\n.gx-send-subject {\n  width: calc(100% - 220px);\n}\n@media screen and (max-width: 575px) {\n  .gx-send-subject {\n    width: calc(100% - 180px);\n    margin-right: 6px;\n  }\n}\n.gx-mail-header-actions {\n  -webkit-justify-content: flex-end;\n  -ms-justify-content: flex-end;\n  justify-content: flex-end;\n  min-width: 100px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-mail-header-actions .icon-btn:not(:last-child) {\n  margin-right: 3px;\n}\n@media screen and (max-width: 498px) {\n  .gx-mail-header-actions {\n    -webkit-justify-content: flex-start;\n    -ms-justify-content: flex-start;\n    justify-content: flex-start;\n    min-width: 10px;\n  }\n}\n.gx-attachment-block {\n  position: relative;\n}\n.gx-attachment-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0 -10px;\n}\n@media screen and (max-width: 575px) {\n  .gx-attachment-row {\n    margin: 0 -5px;\n  }\n}\n.gx-attachment-col {\n  padding: 0 10px;\n}\n.gx-attachment-col img {\n  width: 80px;\n}\n.gx-attachment-col .size {\n  padding-top: 5px;\n}\n@media screen and (max-width: 575px) {\n  .gx-attachment-col {\n    padding: 0 5px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-mail-list {\n    -webkit-flex: 1 1 auto;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    max-width: 100%;\n    border-right: 0 none;\n  }\n  .gx-mail-detail {\n    -webkit-flex: 1 1 auto;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    max-width: 100%;\n  }\n}\n/*Chat Apps Styles*/\n.gx-chat-module {\n  position: relative;\n}\n.gx-chat-module-box {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  background-color: #fafafa;\n  position: relative;\n  width: 100%;\n}\n.gx-chat-sidenav {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 0 1 315px;\n  -ms-flex: 0 1 315px;\n  flex: 0 1 315px;\n  min-width: 315px;\n  border-right: solid 1px #e8e8e8;\n}\n.gx-chat-sidenav-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  padding: 25px 20px 12px;\n  background-color: #fbfbfb;\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-chat-user-hd {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin-bottom: 25px;\n}\n.gx-chat-search-wrapper {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin-bottom: 0;\n}\n.gx-chat-avatar {\n  min-width: 50px;\n}\n.gx-chat-user-row .gx-chat-avatar {\n  padding: 0 5px;\n  min-width: 10px;\n}\n.gx-chat-user-hd .gx-chat-avatar {\n  cursor: pointer;\n}\n.gx-chat-sidenav-scroll {\n  height: calc(100vh - 295px) !important;\n}\n.framed-layout .gx-chat-sidenav-scroll {\n  height: calc(100vh - 295px - 2 * 20px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-chat-sidenav-scroll {\n    height: calc(100vh - 175px) !important;\n  }\n  .framed-layout .gx-chat-sidenav-scroll {\n    height: calc(100vh - 175px) !important;\n  }\n}\n.gx-chat-sidenav-scroll > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-chat-sidenav-scroll-tab-1,\n.gx-chat-sidenav-scroll-tab-2 {\n  height: calc(100vh - 320px) !important;\n}\n.framed-layout .gx-chat-sidenav-scroll-tab-1,\n.framed-layout .gx-chat-sidenav-scroll-tab-2 {\n  height: calc(100vh - 320px - 2 * 20px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-chat-sidenav-scroll-tab-1,\n  .gx-chat-sidenav-scroll-tab-2 {\n    height: calc(100vh - 198px) !important;\n  }\n  .framed-layout .gx-chat-sidenav-scroll-tab-1,\n  .framed-layout .gx-chat-sidenav-scroll-tab-2 {\n    height: calc(100vh - 198px) !important;\n  }\n}\n.gx-chat-sidenav-scroll-tab-1 > div:first-child,\n.gx-chat-sidenav-scroll-tab-2 > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-chat-list-scroll {\n  height: calc(100vh - 268px) !important;\n}\n.framed-layout .gx-chat-list-scroll {\n  height: calc(100vh - 268px - 2 * 20px) !important;\n}\n@media screen and (max-width: 1199px) {\n  .gx-chat-list-scroll {\n    height: calc(100vh - 242px) !important;\n  }\n  .framed-layout .gx-chat-list-scroll {\n    height: calc(100vh - 242px - 2 * 20px) !important;\n  }\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .gx-chat-list-scroll {\n    height: calc(100vh - 242px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-chat-list-scroll {\n    height: calc(100vh - 220px) !important;\n  }\n}\n.gx-chat-list-scroll > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-chat-sidenav-content {\n  background-color: #ffffff;\n}\n.gx-chat-sidenav-title {\n  padding: 10px 16px;\n  font-size: 14px;\n  color: #1890ff;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n@media screen and (max-width: 1199px) {\n  .gx-chat-sidenav-title {\n    font-size: 16px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-chat-sidenav-title {\n    font-size: 15px;\n  }\n}\n.gx-chat-tabs-header {\n  background-color: #fbfbfb !important;\n}\n.gx-chat-user {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-chat-user.gx-chat-user-center {\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-chat-user.gx-chat-user-center .gx-chat-avatar {\n  margin-left: auto;\n}\n.gx-chat-user-item {\n  padding: 16px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  cursor: pointer;\n  max-height: 96px;\n}\n.gx-chat-user-item:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-chat-user-item.active,\n.gx-chat-user-item:hover {\n  background-color: #908b94;\n}\n.gx-chat-user-row {\n  margin: 0 -5px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-tabs-half .ant-tabs-nav-list,\n.gx-tabs-half .ant-tabs-nav:before {\n  width: 100%;\n}\n.gx-chat-info {\n  max-width: calc(100% - 80px);\n  padding: 0 5px;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-chat-info p {\n  margin-bottom: 0;\n}\n.gx-chat-info .h4 {\n  display: block;\n  margin-bottom: 3px;\n}\n.gx-chat-info-des {\n  color: #595959;\n  font-size: 13px;\n}\n.gx-chat-contact-col {\n  max-width: calc(100% - 50px);\n  padding: 0 5px;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-chat-contact-col p {\n  margin-bottom: 0;\n}\n.gx-chat-contact-col .h4 {\n  display: block;\n  margin-bottom: 3px;\n}\n.gx-chat-date {\n  padding: 0 5px;\n  text-align: right;\n}\n.gx-fs-80 {\n  font-size: 80px !important;\n  line-height: 80px !important;\n}\n.gx-comment-box .gx-fs-80 {\n  text-align: center;\n  margin-bottom: 12px;\n}\n@media screen and (max-width: 575px) {\n  .gx-fs-80 {\n    font-size: 60px !important;\n    line-height: 60px !important;\n  }\n}\n.gx-comment-box {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  height: calc(100vh - 122px) !important;\n}\n.framed-layout .gx-comment-box {\n  height: calc(100vh - 122px - 2 * 20px) !important;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .gx-comment-box {\n    height: calc(100vh - 122px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-comment-box {\n    height: calc(100vh - 100px) !important;\n  }\n}\n.gx-chat-box {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  max-width: 100%;\n  position: relative;\n  z-index: 2;\n}\n.gx-chat-main {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-chat-main-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  border-bottom: solid 1px #e8e8e8;\n  padding: 16px;\n  background-color: #ffffff;\n  width: 100%;\n}\n@media screen and (max-width: 1199px) {\n  .gx-chat-main-header {\n    padding: 8px 16px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-chat-main-header {\n    padding: 8px 30px;\n  }\n}\n.gx-chat-main-header-info {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-right: auto;\n}\n.gx-chat-contact-name {\n  font-size: 20px;\n  font-weight: 500;\n}\n@media screen and (max-width: 1199px) {\n  .gx-chat-contact-name {\n    font-size: 16px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-chat-contact-name {\n    font-size: 15px;\n  }\n}\n.gx-chat-main-footer {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  border-top: solid 1px #e8e8e8;\n  padding: 6px 16px;\n  background-color: #ffffff;\n  width: 100%;\n}\n.gx-chat-main-footer .gx-form-group {\n  margin-bottom: 0;\n}\n.gx-chat-item {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  padding: 16px;\n}\n@media screen and (max-width: 991px) {\n  .gx-chat-item {\n    padding: 16px 30px;\n  }\n}\n.gx-chat-item .gx-bubble-block {\n  width: calc(100% - 40px);\n}\n.gx-chat-item .gx-bubble {\n  padding: 12px 15px;\n  background-color: #ffffff;\n  -webkit-border-radius: 20px 20px 20px 0px;\n  -moz-border-radius: 20px 20px 20px 0px;\n  border-radius: 20px 20px 20px 0px;\n  position: relative;\n  margin-left: 16px;\n  max-width: 600px;\n  border: solid 1px #d9d9d9;\n  display: inline-block;\n}\n.gx-chat-item.gx-flex-row-reverse .gx-bubble-block {\n  text-align: right;\n}\n.gx-chat-item.gx-flex-row-reverse .gx-bubble {\n  margin-right: 16px;\n  margin-left: 0;\n  background-color: #908b94;\n  -webkit-border-radius: 20px 20px 0 20px;\n  -moz-border-radius: 20px 20px 0 20px;\n  border-radius: 20px 20px 0 20px;\n  text-align: left;\n}\n.gx-chat-item .ant-avatar {\n  display: block;\n}\n.gx-chat-btn {\n  font-size: 38px !important;\n  margin-right: 20px;\n}\ntextarea.gx-chat-textarea {\n  height: 40px;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n.gx-chat-sent {\n  min-width: 40px;\n  line-height: 40px;\n  font-size: 18px;\n  text-align: center;\n  cursor: pointer;\n}\n.gx-last-message-time {\n  font-size: 11px;\n  color: #8c8c8c;\n}\n@media screen and (max-width: 1199px) {\n  .gx-chat-main-header .gx-size-60 {\n    height: 50px !important;\n    width: 50px !important;\n    line-height: 50px;\n  }\n  .gx-chat-main-header button {\n    margin-bottom: 0;\n  }\n  .gx-chat-main-header-info .gx-status-pos {\n    max-width: 50px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-module-default h1 {\n    font-size: 17px;\n  }\n}\n/*Contact Apps Styles*/\n.gx-contact-item {\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 8px 28px;\n}\n.gx-contact-item:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-dragndrop-item {\n  padding: 24px 16px;\n}\n.gx-dragndrop-item .gx-draggable-icon {\n  margin-left: -16px;\n}\n@media screen and (max-width: 575px) {\n  .gx-dragndrop-item {\n    padding-right: 5px;\n  }\n}\n.gx-contact-list-info {\n  padding-left: 10px;\n}\n.gx-contact-list-info .gx-email {\n  word-break: break-all;\n}\n.gx-contact-list-info .gx-toolbar-separator {\n  display: inline-block;\n}\n@media screen and (max-width: 575px) {\n  .gx-contact-list-info .gx-toolbar-separator {\n    display: none;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-contact-list-info {\n    padding-left: 0;\n    max-width: calc(100% - 50px);\n  }\n  .gx-contact-list-info .gx-job-title {\n    display: none;\n  }\n}\n.gx-module-contact-content {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-module-contact-right {\n  margin-left: 8px;\n}\n.gx-contact-name {\n  font-size: 15px;\n}\n.gx-draggable-icon {\n  cursor: all-scroll;\n  color: #8c8c8c;\n}\n.gx-draggable-icon:hover,\n.gx-draggable-icon:focus,\n.gx-draggable-icon:active {\n  cursor: all-scroll;\n  color: #262626;\n}\n.gx-module-side-nav {\n  padding: 20px 0;\n}\n.gx-modal-box-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-modal-box-row .gx-modal-box-avatar {\n  -webkit-order: 2;\n  -ms-order: 2;\n  order: 2;\n  margin-left: 16px;\n}\n.gx-modal-box-row .gx-modal-box-avatar .ant-avatar {\n  width: 120px;\n  height: 120px;\n}\n@media screen and (max-width: 575px) {\n  .gx-modal-box-row .gx-modal-box-avatar {\n    -webkit-order: 1;\n    -ms-order: 1;\n    order: 1;\n    margin-left: 0;\n    margin-bottom: 16px;\n    text-align: center;\n  }\n}\n.gx-modal-box-row .gx-modal-box-form-item {\n  -webkit-order: 1;\n  -ms-order: 1;\n  order: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n@media screen and (max-width: 575px) {\n  .gx-modal-box-row .gx-modal-box-form-item {\n    -webkit-order: 2;\n    -ms-order: 2;\n    order: 2;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-modal-box-row {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n.gx-dragndrop-actions {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n/* Calendar Apps Style */\n.gx-rbc-calendar {\n  overflow: hidden;\n  padding-bottom: 32px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n@media screen and (max-width: 575px) {\n  .gx-rbc-calendar {\n    margin-bottom: 20px;\n  }\n}\n.gx-rbc-calendar .rbc-calendar {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  height: 100%;\n}\n.rbc-event {\n  background-color: var(--app-primary-color);\n}\n.rbc-event.rbc-selected {\n  background-color: #1a0c2e;\n}\n.rbc-slot-selection {\n  background-color: #6f617a;\n}\n.rbc-toolbar button:active,\n.rbc-toolbar button.rbc-active {\n  color: #ffffff;\n  background-image: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  background-color: #5a456e;\n  border-color: var(--app-primary-color);\n}\n.rbc-toolbar button:active:hover,\n.rbc-toolbar button.rbc-active:hover,\n.rbc-toolbar button:active:focus,\n.rbc-toolbar button.rbc-active:focus,\n.rbc-toolbar button:focus,\n.rbc-toolbar button:hover {\n  color: #ffffff;\n  background-color: #5a456e;\n  border-color: var(--app-primary-color);\n}\n.rbc-month-row {\n  min-height: 100px;\n}\n.rbc-event {\n  min-height: 50px;\n}\n.rbc-btn-group button {\n  cursor: pointer;\n}\n@media screen and (max-width: 867px) {\n  .rbc-toolbar {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    -webkit-align-items: flex-start;\n    -ms-align-items: flex-start;\n    align-items: flex-start;\n  }\n  .rbc-toolbar .rbc-toolbar-label {\n    margin: 8px 0;\n  }\n}\n@media screen and (max-width: 467px) {\n  .rbc-toolbar {\n    font-size: 12px;\n  }\n  .rbc-toolbar button {\n    padding: 5px 10px;\n  }\n}\n/* Calendar Components Style */\n.gx-com-calendar .ant-fullcalendar-header .ant-select {\n  margin-left: 8px;\n  margin-bottom: 8px;\n}\n.gx-com-calendar .ant-picker-calendar-header {\n  flex-wrap: wrap;\n}\n.gx-com-calendar .ant-picker-calendar-header .ant-select {\n  margin-bottom: 8px;\n}\n@media screen and (max-width: 349px) {\n  .gx-com-calendar {\n    margin: 0 -20px;\n  }\n}\n.gx-com-calendar .ant-select .ant-select-arrow {\n  top: 50%;\n}\n.gx-com-calendar-card {\n  border: solid 1px #e8e8e8;\n  max-width: 300px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n@media screen and (max-width: 349px) {\n  .gx-com-calendar-card .gx-com-calendar {\n    margin: 0;\n  }\n}\n.gx-profileon {\n  margin-bottom: 20px;\n  position: relative;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.gx-profileon-content {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 15px 20px;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0);\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.9)));\n  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n}\n.gx-profileon-content * {\n  color: #ffffff;\n}\n.gx-agents-list .gx-profileon-content {\n  padding: 10px;\n}\n.gx-profileon-thumb {\n  position: relative;\n}\n.gx-profileon-thumb > img {\n  width: 100%;\n}\n.gx-profileon-thumb-htctrcrop {\n  overflow: hidden;\n  padding-bottom: 80%;\n  position: relative;\n}\n.gx-profileon-thumb-htctrcrop > img {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  width: 100%;\n}\n.gx-profileon-title {\n  margin-bottom: 5px;\n}\n.gx-agents-list .gx-profileon {\n  margin-bottom: 0;\n}\n.gx-follower {\n  border-bottom: solid 1px #d9d9d9;\n  padding-bottom: 20px;\n  margin-bottom: 15px;\n}\n.gx-follower-list {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  list-style: none;\n  padding-left: 0;\n  margin: 0 -5px;\n}\n.gx-profile-banner .gx-follower-list {\n  margin: 0 -20px;\n}\n.gx-follower-list li {\n  color: #8c8c8c;\n  font-size: 14px;\n  padding: 0 5px;\n  width: 33.33%;\n}\n.gx-profile-banner .gx-follower-list li {\n  color: #ffffff;\n  padding: 0 20px;\n  width: auto;\n}\n.gx-follower-list li:not(:first-child) {\n  border-left: solid 1px #d9d9d9;\n}\n.gx-profile-banner .gx-follower-list li:not(:first-child) {\n  border-left-color: #ffffff;\n}\n.gx-follower-title {\n  display: block;\n  color: #262626;\n  font-size: 14px;\n}\n.gx-profile-banner .gx-follower-title {\n  color: #ffffff;\n}\n.gx-wall-scroll {\n  height: calc(100vh - 154px) !important;\n}\n.framed-layout .gx-wall-scroll {\n  height: calc(100vh - 152px - 2 * 20px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-wall-scroll {\n    height: calc(100vh - 124px) !important;\n  }\n  .framed-layout .gx-wall-scroll {\n    height: calc(100vh - 124px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-wall-scroll {\n    height: calc(100vh - 132px) !important;\n  }\n}\n.gx-wall-postlist {\n  padding: 5px;\n}\n.gx-entry-sec {\n  position: relative;\n  margin-bottom: 20px;\n}\n.ant-card .gx-entry-sec,\n.gx-card .gx-entry-sec {\n  margin-bottom: 0;\n}\n.gx-entry-title {\n  border-bottom: solid 1px #d9d9d9;\n  padding-bottom: 15px;\n  margin-bottom: 20px;\n  font-size: 16px;\n  position: relative;\n}\n.gx-entry-title:before {\n  content: \"\";\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  z-index: 1;\n  height: 3px;\n  width: 42px;\n  background-color: var(--app-primary-color);\n}\n.ant-card .gx-entry-title:before,\n.gx-card .gx-entry-title:before {\n  display: none;\n}\n.ant-card .gx-entry-title,\n.gx-card .gx-entry-title {\n  border-bottom: 0 none;\n  margin-bottom: 15px;\n  padding-bottom: 0;\n}\n.gx-fnd-list {\n  list-style: none;\n  padding-left: 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0 -5px 20px;\n}\n.gx-fnd-list li {\n  width: 33.33%;\n  padding: 0 5px;\n}\n@media (max-width: 399px) {\n  .gx-fnd-list li {\n    width: 50%;\n  }\n}\n.gx-user-fnd {\n  position: relative;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.gx-user-fnd > img {\n  width: 100%;\n}\n.gx-user-fnd-content {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  padding: 10px;\n  background-color: rgba(0, 0, 0, 0.1);\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.1)), to(rgba(0, 0, 0, 0.95)));\n  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));\n  color: #ffffff;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-user-fnd-content h6 {\n  color: #ffffff;\n  -ms-flex-item-align: end;\n  align-self: flex-end;\n  margin-bottom: 0;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gx-user-fnd-content .ant-badge {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  z-index: 1;\n  margin: 0;\n  width: 10px;\n  height: 10px;\n  display: block;\n}\n.gx-user-fnd-content .ant-badge-status-dot {\n  width: 10px;\n  height: 10px;\n  display: block;\n  top: 0;\n  border: solid 1px #ffffff;\n}\n.gx-gallery-list {\n  list-style: none;\n  padding-left: 0;\n  margin: 0 -0.5px 15px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  overflow: hidden;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-gallery-list li {\n  padding: 0 0.5px;\n  margin-bottom: 1px;\n  width: 33.33%;\n}\n@media (max-width: 399px) {\n  .gx-gallery-list li {\n    width: 50%;\n  }\n}\n.gx-gallery-list li > img {\n  width: 100%;\n}\n.gx-gallery-thumb {\n  position: relative;\n  cursor: pointer;\n}\n.gx-gallery-thumb:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.01);\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.01)), to(rgba(0, 0, 0, 0.95)));\n  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));\n}\n.gx-gallery-thumb-content {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n  padding: 10px;\n  color: #ffffff;\n}\n.gx-gallery-thumb-content h6 {\n  color: #ffffff;\n  margin-bottom: 0;\n  font-size: 10px;\n}\n.gx-wall-user-info {\n  margin-bottom: 6px;\n}\n.gx-wall-user-title {\n  margin-bottom: 4px;\n}\n.gx-gallery-item {\n  position: relative;\n  margin-bottom: 15px;\n}\n.gx-gallery-item img {\n  width: 100%;\n  cursor: pointer;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.gx-gallery-item-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  color: #ffffff;\n}\n.gx-gallery-grid {\n  margin: 0 -5px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-gallery-grid .gx-gallery-item {\n  padding: 0 5px;\n}\n.gx-gallery-grid .gx-gallery-item-content {\n  left: 5px;\n  right: 5px;\n}\n.gx-gallery-2 .gx-gallery-item,\n.gx-gallery-4 .gx-gallery-item,\n.gx-gallery-4-more .gx-gallery-item {\n  width: 50%;\n}\n.gx-gallery-3 .gx-gallery-item {\n  width: 33.33%;\n}\n.gx-wall-comment-box {\n  padding: 0 30px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-wall-comment-box {\n    padding: 0 20px;\n  }\n}\n@media screen and (max-width: 1100px) {\n  .gx-wall-comment-box {\n    padding: 0;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-wall-comment-box {\n    padding: 0 30px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-wall-comment-box {\n    padding-right: 0;\n    padding-left: 15px;\n  }\n}\n.gx-profile-banner {\n  padding: 32px;\n  padding-bottom: 88px;\n  margin: -32px;\n  margin-bottom: -58px;\n  background-color: var(--app-primary-color);\n  color: #ffffff;\n  position: relative;\n}\n@media screen and (max-width: 575px) {\n  .gx-profile-banner {\n    padding: 20px 15px;\n    padding-bottom: 83px;\n    margin: -20px -15px;\n    margin-bottom: -58px;\n  }\n}\n.gx-profile-banner:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.gx-profile-banner > div {\n  position: relative;\n  z-index: 2;\n}\n.gx-profile-banner-top {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-bottom: 40px;\n}\n@media (max-width: 575px) {\n  .gx-profile-banner-top {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    margin-bottom: 25px;\n  }\n}\n.gx-profile-banner-top-left {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media (max-width: 575px) {\n  .gx-profile-banner-top-left {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    margin-bottom: 25px;\n  }\n}\n.gx-profile-banner-avatar {\n  margin-right: 1.5rem;\n}\n@media (max-width: 575px) {\n  .gx-profile-banner-avatar {\n    margin-bottom: 8px;\n    margin-right: 0;\n  }\n}\n.gx-profile-banner-top-right {\n  text-align: center;\n  margin-left: auto;\n}\n@media (max-width: 575px) {\n  .gx-profile-banner-top-right {\n    margin-left: 0;\n  }\n}\n.gx-profile-banner-bottom {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media (max-width: 575px) {\n  .gx-profile-banner-bottom {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .gx-profile-banner-bottom .gx-tab-list {\n    margin-bottom: 10px;\n  }\n}\n.gx-profile-banner h1,\n.gx-profile-banner h2,\n.gx-profile-banner h3,\n.gx-profile-banner h4,\n.gx-profile-banner h5,\n.gx-profile-banner h6,\n.gx-profile-banner .h1,\n.gx-profile-banner .h2,\n.gx-profile-banner .h3,\n.gx-profile-banner .h4,\n.gx-profile-banner .h5,\n.gx-profile-banner .h6 {\n  color: #ffffff;\n}\n.gx-profile-banner .gx-link {\n  color: #ffffff;\n}\n.gx-profile-banner .gx-link:hover,\n.gx-profile-banner .gx-link:focus {\n  color: var(--app-secondary-color);\n}\n.gx-profile-content {\n  position: relative;\n  z-index: 2;\n}\n.gx-profile-setting {\n  margin-left: auto;\n}\n@media (max-width: 575px) {\n  .gx-profile-setting {\n    margin-left: 0;\n  }\n}\n@media (max-width: 575px) {\n  .gx-profile-content-right {\n    display: -webkit-flex !important;\n    display: -ms-flexbox !important;\n    display: -ms-flex !important;\n    display: flex !important;\n    -webkit-flex-direction: row !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n    -webkit-flex-wrap: wrap !important;\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n    -webkit-align-items: center !important;\n    -ms-align-items: center !important;\n    align-items: center !important;\n  }\n  .gx-profile-content-right .gx-text-truncate {\n    width: auto;\n    margin-left: auto;\n  }\n}\n.gx-pro-contact-list:not(:last-child) {\n  margin-bottom: 1rem;\n}\n/*Callout Styles*/\n/*Different size images set in Equal block height and width*/\n.gx-thumb-equal,\n.gx-grid-thumb-equal {\n  position: relative;\n  padding-bottom: 68%;\n  height: 0;\n  width: 100%;\n  overflow: hidden;\n}\n.gx-thumb-cover,\n.gx-grid-thumb-cover {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.gx-thumb-cover-img,\n.gx-grid-thumb-cover img {\n  height: auto;\n  max-width: 100%;\n  min-height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n.gx-product-image .gx-grid-thumb-equal {\n  padding-bottom: 82%;\n}\n/*Product listing page styles*/\n.gx-product-row {\n  position: relative;\n  overflow: hidden;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  text-align: right;\n}\n.gx-product-row.even {\n  text-align: left;\n}\n.gx-product-col {\n  order: 1;\n  width: 50%;\n}\n.odd .gx-product-thumb {\n  order: 2;\n}\n.gx-product-content {\n  padding: 20px 55px;\n}\n.gx-product-content p {\n  margin-bottom: 10px;\n}\n.gx-product-row .gx-grid-thumb-equal {\n  padding-bottom: 69%;\n}\n.gx-product-thumb img {\n  width: 100%;\n}\n.gx-product-content h4 {\n  margin-bottom: 25px;\n}\n@media screen and (max-width: 1230px) {\n  .gx-product-row .gx-grid-thumb-equal {\n    padding-bottom: 71%;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-product-row {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    text-align: center;\n  }\n  .gx-product-row.even {\n    text-align: center;\n  }\n  .gx-product-content h4 {\n    margin-bottom: 10px;\n  }\n  .gx-product-content {\n    padding: 20px 35px;\n  }\n  .gx-product-col,\n  .odd .gx-product-thumb {\n    order: 1;\n    width: 100%;\n  }\n  .gx-product-row .gx-grid-thumb-equal {\n    padding-bottom: 40%;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-product-row {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    text-align: right;\n  }\n  .gx-product-row.even {\n    text-align: left;\n  }\n  .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 120%;\n  }\n  .gx-product-col,\n  .odd .gx-product-thumb {\n    order: 1;\n    width: 50%;\n  }\n  .odd .gx-product-thumb {\n    order: 2;\n  }\n  .gx-product-row .gx-grid-thumb-equal {\n    padding-bottom: 70%;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-product-row {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    text-align: center;\n  }\n  .gx-product-row.even {\n    text-align: center;\n  }\n  .gx-product-row:last-child .gx-product-col {\n    padding-bottom: 0;\n  }\n  .gx-product-row:last-child .ant-btn {\n    margin-bottom: 0;\n  }\n  .gx-product-content {\n    padding: 20px 0;\n  }\n  .gx-product-col,\n  .odd .gx-product-thumb {\n    order: 1;\n    width: 100%;\n  }\n  .gx-product-row .gx-grid-thumb-equal {\n    padding-bottom: 44%;\n  }\n  .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 44%;\n  }\n}\n/*E-commerce Styles*/\n.gx-product-item {\n  overflow: hidden;\n  background: #fff;\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  border-radius: 12px;\n  margin-bottom: 32px;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n}\n@media screen and (max-width: 575px) {\n  .gx-product-item {\n    margin-bottom: 20px;\n  }\n}\n.gx-product-body {\n  padding: 24px;\n}\n.gx-product-body + .gx-product-footer {\n  padding-top: 0;\n}\n.gx-product-body :last-child {\n  margin-bottom: 0;\n}\n.gx-product-image > img {\n  width: 100%;\n}\n.gx-product-footer {\n  padding: 24px;\n  padding-bottom: 15px;\n}\n.gx-product-horizontal {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-product-horizontal .gx-product-image {\n  width: 25%;\n}\n@media screen and (max-width: 1199px) {\n  .gx-product-horizontal .gx-product-image {\n    width: 33.33333%;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-product-horizontal .gx-product-image {\n    width: 25%;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-image {\n    width: 100%;\n  }\n}\n.gx-product-horizontal .gx-product-body {\n  width: 53%;\n}\n@media screen and (min-width: 1400px) {\n  .gx-product-horizontal .gx-product-body {\n    width: 55%;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-product-horizontal .gx-product-body {\n    width: 41.66667%;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-product-horizontal .gx-product-body {\n    width: 50%;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-body {\n    width: 100%;\n  }\n}\n.gx-product-horizontal .gx-product-body + .gx-product-footer {\n  padding-top: 24px;\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-body + .gx-product-footer {\n    padding-top: 0;\n  }\n}\n.gx-product-horizontal .gx-product-footer {\n  width: 22%;\n  text-align: center;\n}\n@media screen and (min-width: 1400px) {\n  .gx-product-horizontal .gx-product-footer {\n    width: 20%;\n  }\n}\n.gx-product-horizontal .gx-product-footer .ant-btn:not(:last-child) {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-footer .ant-btn:not(:last-child) {\n    margin-left: 0;\n  }\n}\n.gx-product-horizontal .gx-product-footer .ant-btn:last-child {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-footer {\n    width: 100%;\n    text-align: left;\n  }\n}\n.gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n  padding-bottom: 82%;\n}\n@media screen and (min-width: 1400px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 55%;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 80%;\n  }\n}\n@media screen and (max-width: 1080px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 90%;\n  }\n}\n@media screen and (max-width: 1000px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 110%;\n  }\n  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 80%;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 88%;\n  }\n  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 128%;\n  }\n}\n@media screen and (max-width: 849px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 110%;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 44%;\n  }\n  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 44%;\n  }\n}\n.gx-product-vertical {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  height: calc(100% - 32px);\n}\n@media screen and (max-width: 575px) {\n  .gx-product-vertical {\n    height: calc(100% - 20px);\n  }\n}\n.gx-product-vertical .gx-product-body {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-product-title {\n  font-size: 18px;\n}\n/*Pricing Tables Styles*/\n.gx-price-tables {\n  position: relative;\n}\n.gx-package {\n  position: relative;\n  margin-bottom: 15px;\n  overflow: hidden;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-transition: all 0.2s ease-in-out;\n  -moz-transition: all 0.2s ease-in-out;\n  -ms-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  height: calc(100% - 15px);\n  -webkit-transform: scale(0.95);\n  -moz-transform: scale(0.95);\n  -ms-transform: scale(0.95);\n  -o-transform: scale(0.95);\n  transform: scale(0.95);\n}\n.gx-package:hover,\n.gx-package:focus,\n.gx-package:active {\n  -webkit-transform: scale(1);\n  -moz-transform: scale(1);\n  -ms-transform: scale(1);\n  -o-transform: scale(1);\n  transform: scale(1);\n  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);\n  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);\n}\n.gx-pt-dark .gx-package:hover,\n.gx-pt-dark .gx-package:focus,\n.gx-pt-dark .gx-package:active {\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  border-radius: 20px;\n}\n.gx-pt-classic .gx-package {\n  border: 0 none;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n.gx-package.gx-highlight {\n  -webkit-transform: scale(1);\n  -moz-transform: scale(1);\n  -ms-transform: scale(1);\n  -o-transform: scale(1);\n  transform: scale(1);\n  z-index: 2;\n}\n.gx-package-header {\n  padding: 30px;\n  text-align: center;\n}\n.gx-package-header > .gx-price {\n  display: inline-block;\n  font-size: 36px;\n  font-weight: 500;\n  margin-left: 0;\n  margin-bottom: 12px;\n  color: #ffffff;\n}\n.gx-package-header > .gx-price > i {\n  display: inline-block;\n  margin-right: 6px;\n  font-weight: bold;\n}\n.gx-package-header h5 {\n  color: inherit;\n}\n.gx-package-header.gx-text-black > .gx-price {\n  color: #595959 !important;\n}\n@media only screen and (max-width: 991px) {\n  .gx-package-header {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n.gx-package-body {\n  padding: 50px 30px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media only screen and (max-width: 991px) {\n  .gx-package-body {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n.gx-package-items {\n  list-style: none;\n  font-size: 14px;\n  margin: 0 0 20px;\n  padding-left: 0;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-package-items li {\n  margin-bottom: 16px;\n  line-height: inherit;\n}\n.gx-package-items li::before {\n  display: table;\n  content: '';\n}\n.gx-package-items li::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.gx-package-items li::before {\n  display: table;\n  content: '';\n}\n.gx-package-items li::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.gx-package-items li i {\n  float: left;\n  min-width: 20px;\n  margin-right: 16px;\n  line-height: inherit;\n}\n.gx-package-items li span {\n  display: block;\n  overflow: hidden;\n}\n.gx-package-footer {\n  padding-top: 30px;\n}\n.gx-package-footer .ant-btn {\n  text-transform: capitalize;\n  border: 0 none;\n  margin-bottom: 0;\n}\n@media only screen and (max-width: 767px) {\n  .gx-package:hover,\n  .gx-package:focus,\n  .gx-package:active,\n  .gx-package.gx-highlight {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n.gx-text-black .gx-text-white {\n  color: #595959 !important;\n}\n.gx-pt-circle .gx-package-header {\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  height: 224px;\n  width: 224px;\n  margin: 40px auto 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-pt-circle .gx-package-header .gx-price {\n  margin-top: -5px;\n}\n@media only screen and (max-width: 991px) {\n  .gx-pt-circle .gx-package-header .gx-price {\n    font-size: 26px;\n    margin-bottom: 6px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .gx-pt-circle .gx-package-header .gx-letter-spacing-base {\n    letter-spacing: 1px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .gx-pt-circle .gx-package-header {\n    height: 150px;\n    width: 150px;\n  }\n}\n/*Login Styles*/\n.gx-login-container {\n  position: relative;\n  height: 100%;\n  padding-bottom: 30px;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-login-content {\n  max-width: 420px;\n  width: 94%;\n  margin: auto;\n  padding: 35px 35px 20px;\n  background-color: #ffffff;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  font-size: 14px;\n}\n.gx-login-content .ant-input {\n  background-color: #f5f5f5;\n  height: auto;\n  padding: 6px 12px;\n}\n.gx-login-content .ant-input:focus {\n  box-shadow: none;\n  border-color: var(--app-primary-color);\n}\n.gx-login-content .ant-input-affix-wrapper {\n  background-color: #f5f5f5;\n  max-height: none;\n}\n.gx-login-content .ant-form-item-control-wrapper {\n  width: 100%;\n}\n.gx-login-content .ant-form-item-children {\n  display: block;\n}\n@media screen and (max-width: 575px) {\n  .gx-login-content {\n    padding: 20px 20px 10px;\n  }\n}\n.gx-login-header {\n  margin-bottom: 30px;\n}\n@media screen and (max-width: 575px) {\n  .gx-login-header {\n    margin-bottom: 15px;\n  }\n}\n.gx-app-login-wrap {\n  height: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  overflow-x: hidden;\n}\n@media screen and (max-width: 575px) {\n  .gx-app-login-wrap {\n    padding-top: 20px;\n    -webkit-justify-content: flex-start;\n    -ms-justify-content: flex-start;\n    justify-content: flex-start;\n  }\n}\n.gx-app-login-container {\n  position: relative;\n  max-width: 1000px;\n  width: 100%;\n  margin: 0 auto;\n}\n@media screen and (max-width: 575px) {\n  .gx-app-login-container {\n    padding-bottom: 20px;\n  }\n}\n.gx-app-login-container .gx-loader-view {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  z-index: 2;\n}\n.gx-app-login-main-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  border-radius: 12px;\n  font-size: 14px;\n  overflow: hidden;\n}\n.gx-app-login-content {\n  padding: 35px 51px 20px;\n  width: 50%;\n}\n.gx-app-login-content .gx-btn {\n  padding: 6px 35px !important;\n  height: auto;\n}\n.gx-app-login-content .ant-form-item-control-wrapper {\n  width: 100%;\n}\n.gx-app-login-content .ant-form-item-children {\n  display: block;\n}\n@media screen and (max-width: 575px) {\n  .gx-app-login-content {\n    width: 100%;\n    padding: 20px 20px 10px;\n  }\n}\n.gx-app-login-header {\n  margin-bottom: 30px;\n}\n@media screen and (max-width: 575px) {\n  .gx-app-login-header {\n    margin-bottom: 15px;\n  }\n}\n.gx-app-logo-content {\n  color: #ffffff;\n  width: 50%;\n  position: relative;\n  overflow: hidden;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: nowrap;\n  -ms-flex-direction: nowrap;\n  flex-direction: nowrap;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-app-logo-content > * {\n  position: relative;\n  z-index: 2;\n}\n.gx-app-logo-content h1 {\n  color: #ffffff;\n}\n@media screen and (max-width: 575px) {\n  .gx-app-logo-content {\n    width: 100%;\n    padding: 20px 20px 10px;\n  }\n}\n.gx-app-logo-content-bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n.gx-app-logo-content-bg:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  right: 0;\n  bottom: 0;\n}\n.gx-app-logo-content-bg img {\n  width: 100%;\n  height: 100%;\n}\n.gx-app-logo-wid {\n  margin-bottom: auto;\n}\n.gx-app-social-block {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n}\n.gx-app-social-block .gx-social-link,\n.gx-app-social-block .gx-social-link li {\n  margin: 0;\n}\n.gx-app-social-block .gx-social-link span {\n  border: solid 1px var(--app-primary-color);\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  color: var(--app-primary-color);\n}\n.gx-app-social-block .gx-social-link span:hover,\n.gx-app-social-block .gx-social-link span:focus {\n  color: #ffffff;\n  background-color: var(--app-primary-color);\n}\n.gx-app-social-block p {\n  margin-bottom: 0;\n}\n.gx-signin-form .ant-form-item-control-input {\n  min-height: 40px;\n}\n/*Dashboard Styles*/\n.ant-list-item-meta {\n  flex-wrap: wrap;\n}\n.gx-task-list-item {\n  position: relative;\n}\n.gx-task-list-item:not(:last-child) {\n  margin-bottom: 15px;\n}\n.gx-card-ticketlist .gx-task-list-item:not(:last-child) {\n  margin-bottom: 20px;\n}\n.gx-card-tabs .gx-task-list-item:last-child {\n  margin-bottom: 15px;\n}\n.gx-card-ticketlist .gx-task-list-item .gx-hover {\n  display: none;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-ticketlist .gx-task-list-item .gx-hover {\n    display: block;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-card-ticketlist .gx-task-list-item .gx-nonhover {\n    display: none;\n  }\n}\n.gx-card-ticketlist .gx-task-list-item:hover .gx-hover {\n  display: inline-block;\n}\n.gx-card-ticketlist .gx-task-list-item:hover .gx-nonhover {\n  display: none;\n}\n.gx-card-ticketlist .gx-task-list-item:hover .gx-task-item-title {\n  color: var(--app-primary-color);\n}\n.gx-task-list-item:hover {\n  cursor: pointer;\n}\n.gx-task-list-item:hover .gx-text-hover {\n  color: var(--app-primary-color);\n}\n.gx-task-item-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n  max-width: calc(100% - 40px);\n}\n.gx-task-item-content-left {\n  width: calc(100% - 250px);\n}\n@media screen and (max-width: 575px) {\n  .gx-task-item-content-left {\n    width: 100%;\n    margin-bottom: 10px;\n    padding-right: 60px;\n  }\n}\n.gx-card-ticketlist .gx-task-item-content-left {\n  width: calc(100% - 100px);\n}\n@media screen and (max-width: 575px) {\n  .gx-card-ticketlist .gx-task-item-content-left {\n    width: 100%;\n    padding-right: 0;\n  }\n}\n.gx-task-item-content-right {\n  width: 250px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: flex-end;\n  -ms-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  padding-left: 10px;\n}\n@media screen and (max-width: 575px) {\n  .gx-task-item-content-right {\n    width: 100%;\n    padding-left: 0;\n    -webkit-justify-content: flex-start;\n    -ms-justify-content: flex-start;\n    justify-content: flex-start;\n  }\n}\n.gx-card-ticketlist .gx-task-item-content-right {\n  padding-top: 8px;\n  width: 100px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-ticketlist .gx-task-item-content-right {\n    width: 100%;\n    padding-top: 0;\n  }\n}\n.gx-card-ticketlist .gx-task-item-content {\n  max-width: calc(100% - 52px);\n}\n.gx-task-item-content .gx-task-date {\n  min-width: 55px;\n  text-align: right;\n}\n.gx-task-item-content .ant-tag {\n  min-width: 60px;\n  text-align: center;\n}\n@media screen and (max-width: 575px) {\n  .gx-task-item-content {\n    flex-direction: column;\n    position: relative;\n  }\n  .gx-task-item-content .gx-task-date {\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 1;\n  }\n  .gx-card-ticketlist .gx-task-item-content {\n    padding-right: 0;\n  }\n}\n.gx-card-ticketlist .gx-link {\n  color: var(--app-primary-color);\n}\n.gx-card-testimonial {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n.gx-card-testimonial-img {\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n.gx-card-testimonial-content {\n  background-color: #f5f5f5;\n  padding: 15px;\n  position: relative;\n  margin-left: 10px;\n  width: calc(100% - 70px);\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.gx-card-testimonial-content:before {\n  content: \"\";\n  position: absolute;\n  left: -10px;\n  top: 10px;\n  z-index: 1;\n  width: 0;\n  height: 0;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n  border-right: 10px solid #f5f5f5;\n}\n.gx-card-testimonial-content > :last-child {\n  margin-bottom: 0;\n}\n.gx-progress-task {\n  position: relative;\n}\n.gx-progress-task :last-child {\n  margin-bottom: 0;\n}\n.gx-progress-task-list {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-bottom: 15px;\n}\n.gx-progress-task-list + .gx-progress-task-list {\n  border-top: solid 1px #e8e8e8;\n  padding-top: 15px;\n}\n.gx-progress-task-list .ant-progress {\n  margin-bottom: 15px;\n}\n.gx-progress-task-list-content {\n  margin-left: 20px;\n  margin-bottom: 15px;\n}\n@media screen and (max-width: 575px) {\n  .gx-progress-task-list {\n    margin-bottom: 0;\n  }\n}\n.gx-act-task {\n  position: relative;\n}\n.gx-act-task-cell {\n  margin-bottom: 20px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n}\n@media screen and (max-width: 575px) {\n  .gx-act-task-cell {\n    margin-bottom: 10px;\n  }\n}\n.gx-act-task-content {\n  width: calc(100% - 72px);\n}\n.gx-act-task-content label.ant-checkbox-wrapper span {\n  display: block;\n  overflow: hidden;\n}\n.gx-act-task-content label.ant-checkbox-wrapper span.ant-checkbox {\n  float: left;\n  padding: 6px 5px 0 0;\n}\n.gx-act-task-btn-view {\n  margin-left: 8px;\n  width: 65px;\n  text-align: right;\n}\n@media screen and (max-width: 575px) {\n  .gx-act-task-btn-view {\n    margin-left: 0;\n    margin-top: 10px;\n  }\n}\n.gx-line-indicator {\n  list-style: none;\n  margin: 0;\n  padding-left: 0;\n}\n.gx-line-indicator li:not(:last-child) {\n  margin-bottom: 10px;\n}\n@media screen and (max-width: 575px) {\n  .gx-line-indicator li:not(:last-child) {\n    margin-bottom: 5px;\n  }\n}\n.gx-line-indicator li p {\n  margin-bottom: 0;\n}\n.gx-line-indicator-half {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0 -12px;\n}\n.gx-line-indicator-half li {\n  width: 50%;\n  padding: 0 12px;\n}\n.gx-line-indicator-col {\n  width: 25%;\n  padding-right: 10px;\n}\n@media screen and (max-width: 767px) {\n  .gx-line-indicator-col {\n    width: 100%;\n    padding-right: 0;\n  }\n}\n.gx-line-indi {\n  height: 3px;\n}\n.gx-line-indi-info {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-wel-ema {\n  position: relative;\n}\n.gx-overview-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n@media screen and (max-width: 767px) {\n  .gx-overview-row {\n    flex-direction: column;\n  }\n}\n.gx-overview-description {\n  width: 32%;\n  color: #8c8c8c;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin: -24px;\n  margin-left: 0;\n  border-left: solid 1px #e8e8e8;\n  order: 2;\n}\n@media screen and (max-width: 767px) {\n  .gx-overview-description {\n    order: 1;\n    width: 100%;\n    border-left: 0 none !important;\n    border-top: solid 1px #e8e8e8;\n    border-bottom: solid 1px #e8e8e8;\n    margin: 15px 0 0;\n  }\n}\n.gx-map-col {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  padding: 50px 10px 0;\n  order: 1;\n}\n@media screen and (max-width: 767px) {\n  .gx-map-col {\n    order: 2;\n    padding: 15px 0 0;\n  }\n}\n.gx-revenu {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  padding: 15px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-revenu-total {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-revenu-total h1 {\n  font-size: 34px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n@media screen and (max-width: 767px) {\n  .gx-revenu-total h1 {\n    font-size: 22px;\n  }\n}\n.gx-revenu-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  width: 100%;\n}\n.gx-revenu-col {\n  width: 50%;\n  padding: 0 15px;\n  text-align: center;\n}\n.gx-revenu-col:not(:last-child) {\n  border-right: solid 1px #e8e8e8;\n}\n.gx-revenu h3 {\n  font-size: 20px;\n  margin-bottom: 0;\n  font-weight: 500;\n}\n.ant-divider-horizontal {\n  margin: 12px 0;\n}\n.gx-visit-col {\n  order: 1;\n}\n@media screen and (max-width: 1199px) {\n  .gx-visit-col {\n    order: 2;\n    margin-top: 20px;\n  }\n}\n.gx-audi-col {\n  order: 2;\n}\n@media screen and (max-width: 1199px) {\n  .gx-audi-col {\n    order: 1;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-audi-col {\n    margin-top: 20px;\n  }\n}\n.gx-rechart {\n  position: relative;\n}\n.gx-rechart-prod {\n  position: absolute;\n  left: 30px;\n  top: 0;\n  z-index: 1;\n}\n@media (max-width: 1366px) {\n  .gx-rechart-prod {\n    left: 20px;\n  }\n}\n.gx-pink-purple-gradient {\n  background-color: #564093;\n  background: -webkit-gradient(linear, left top, right top, from(#564093), to(#d2449d));\n  background: -webkit-linear-gradient(left, #564093, #d2449d);\n  background: -moz-linear-gradient(left, #564093, #d2449d);\n  background: -ms-linear-gradient(left, #564093, #d2449d);\n  background: -o-linear-gradient(left, #564093, #d2449d);\n}\n.gx-pink-purple-gradient-reverse {\n  background-color: #872776;\n  background: -webkit-gradient(linear, left top, right top, from(#872776), to(#352883));\n  background: -webkit-linear-gradient(left, #872776, #352883);\n  background: -moz-linear-gradient(left, #872776, #352883);\n  background: -ms-linear-gradient(left, #872776, #352883);\n  background: -o-linear-gradient(left, #872776, #352883);\n}\n.gx-blue-cyan-gradient {\n  background: -moz-linear-gradient(125deg, #45d1e6 0%, #4363c6 100%);\n  background: -webkit-gradient(linear, left top, right bottom, color-stop(0%, #45d1e6), color-stop(100%, #4363c6));\n  background: -webkit-linear-gradient(125deg, #45d1e6 0%, #4363c6 100%);\n  background: -o-linear-gradient(125deg, #45d1e6 0%, #4363c6 100%);\n  background: -ms-linear-gradient(125deg, #45d1e6 0%, #4363c6 100%);\n  background: linear-gradient(325deg, #45d1e6 0%, #4363c6 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='@hstartColor', endColorstr='@hendColor', GradientType=0);\n}\n.gx-app-thumb {\n  display: inline-block;\n}\n.gx-card-cover-black .ant-card-head {\n  background-color: #000000;\n  color: #ffffff;\n  padding-top: 20px;\n}\n.gx-card-cover-black .ant-card-head h1 {\n  color: #ffffff;\n}\n.gx-card-cover-black .ant-card-head-title {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-card-cover-black .ant-card-body {\n  padding: 1rem;\n}\n.gx-dot-arrow-hover {\n  position: relative;\n  overflow: hidden;\n}\n.gx-dot-arrow-hover:hover .gx-hover-arrow {\n  left: -15px;\n}\n.gx-dot-arrow {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 2;\n  padding-right: 10px;\n  cursor: pointer;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-dot-arrow .gx-dot {\n  cursor: pointer;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-hover-arrow {\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  cursor: pointer;\n  -webkit-border-radius: 50% 0 0 50%;\n  -moz-border-radius: 50% 0 0 50%;\n  border-radius: 50% 0 0 50%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-justify-content: flex-start;\n  -ms-justify-content: flex-start;\n  justify-content: flex-start;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  width: 107px;\n  height: 107px;\n  position: absolute;\n  left: 15px;\n  padding: 10px;\n  font-size: 20px;\n}\n.gx-hover-arrow .icon {\n  display: flex;\n}\n.gx-actchart {\n  margin-bottom: -4px;\n}\n.gx-user-wid {\n  width: 80px;\n  position: relative;\n}\n.gx-user-wid img {\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n}\n.gx-user-wid-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-user-wid-body {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.boxed-layout .gx-build-box-lay,\n.framed-layout .gx-build-box-lay {\n  padding: 0 10px !important;\n}\n.boxed-layout .gx-build-box-lay img,\n.framed-layout .gx-build-box-lay img {\n  width: 50px;\n}\n@media (max-width: 1366px) {\n  .gx-build-box-lay {\n    padding: 0 10px !important;\n  }\n  .gx-build-box-lay img {\n    width: 50px;\n  }\n}\n.gx-build-box-lay-content {\n  max-width: calc(100% - 70px);\n}\n.gx-chart-title {\n  font-size: 14px;\n}\n@media (max-width: 1366px) {\n  .gx-chart-title {\n    font-size: 12px;\n  }\n}\n.gx-widget-bg {\n  background-color: #4c429a;\n  background: -webkit-gradient(linear, left top, right top, from(#4c429a), to(#9956ce));\n  background: -webkit-linear-gradient(left, #4c429a, #9956ce);\n  background: -moz-linear-gradient(left, #4c429a, #9956ce);\n  background: -ms-linear-gradient(left, #4c429a, #9956ce);\n  background: -o-linear-gradient(left, #4c429a, #9956ce);\n  color: #ffffff;\n  position: relative;\n}\n.gx-widget-bg h1 {\n  color: #ffffff;\n}\n.gx-widget-badge {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  background-color: #ff6bb3;\n  color: #ffffff;\n  padding: 5px 12px;\n  -webkit-border-radius: 0 10px 0 10px;\n  -moz-border-radius: 0 10px 0 10px;\n  border-radius: 0 10px 0 10px;\n}\n.gx-fnd-content {\n  padding-right: 40px;\n}\n@media (max-width: 1366px) {\n  .gx-fnd-content {\n    padding-right: 0;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-fnd-content {\n    margin-top: 20px;\n  }\n}\n.gx-fnd-gallery-list {\n  list-style: none;\n  padding-left: 0;\n  margin: 0 -6px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-fnd-gallery-list li {\n  padding: 0 6px;\n}\n.gx-fnd-gallery-list li > img {\n  width: 65px;\n}\n@media (max-width: 1366px) {\n  .gx-fnd-gallery-list li > img {\n    width: 50px;\n  }\n}\n.gx-fnd-title {\n  font-size: 24px;\n  margin-bottom: 15px;\n}\n@media (max-width: 1366px) {\n  .gx-fnd-title {\n    font-size: 20px;\n    margin-bottom: 5px;\n  }\n}\n.gx-chart-up {\n  color: #52c41a;\n}\n.gx-bg-geekblue .gx-chart-up {\n  color: #ffffff;\n}\n.gx-chart-down {\n  color: #f5222d;\n}\n.gx-chart-down .icon {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n  display: inline-block;\n}\n.gx-barchart {\n  margin-top: -15px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-barchart {\n    margin-top: 0;\n  }\n}\n.gx-clients {\n  margin-top: -7px;\n  margin-bottom: -7px;\n}\n@media (max-width: 1366px) {\n  .gx-clients {\n    margin-top: -2px;\n    margin-bottom: -2px;\n  }\n  .gx-clients .gx-size-60 {\n    height: 50px !important;\n    width: 50px !important;\n    line-height: 50px !important;\n  }\n}\n@media (max-width: 575px) {\n  .gx-clients {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n}\n.gx-fillchart {\n  position: relative;\n  color: #ffffff;\n  min-height: 122px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: flex-end;\n  -ms-align-items: flex-end;\n  align-items: flex-end;\n  -webkit-transition: all 0.7s ease-out;\n  -moz-transition: all 0.7s ease-out;\n  -ms-transition: all 0.7s ease-out;\n  -o-transition: all 0.7s ease-out;\n  transition: all 0.7s ease-out;\n}\n.gx-fillchart-content {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  padding: 15px 20px;\n}\n.gx-overlay-fillchart .gx-fillchart-content {\n  background-color: rgba(255, 255, 255, 0.35);\n}\n.gx-fillchart .ant-card-head-title,\n.gx-fillchart h2,\n.gx-fillchart .gx-chart-up,\n.gx-fillchart .gx-chart-down {\n  color: #ffffff;\n}\n.gx-fillchart .gx-chart-up,\n.gx-fillchart .gx-chart-down {\n  margin-right: 6px;\n}\n.gx-fillchart-btn {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  z-index: 1;\n  -webkit-opacity: 0;\n  -moz-opacity: 0;\n  opacity: 0;\n  visibility: hidden;\n  cursor: pointer;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n}\n.gx-fillchart-btn .icon:before {\n  line-height: 30px;\n}\n.gx-fillchart-btn-close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  color: var(--app-primary-color);\n  background-color: #ffffff;\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  -webkit-opacity: 0;\n  -moz-opacity: 0;\n  opacity: 0;\n  visibility: hidden;\n  cursor: pointer;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  font-size: 16px;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n}\n.gx-fillchart-btn-close .icon {\n  font-size: 24px;\n  width: 30px;\n  height: 30px;\n  line-height: 38px;\n}\n.gx-fillchart:hover .gx-fillchart-btn {\n  -webkit-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n  visibility: visible;\n}\n.gx-fillchart-nocontent .gx-fillchart-content,\n.gx-fillchart-nocontent .gx-fillchart-btn,\n.gx-fillchart-nocontent:hover .gx-fillchart-btn {\n  -webkit-opacity: 0;\n  -moz-opacity: 0;\n  opacity: 0;\n  visibility: hidden;\n}\n.gx-fillchart-nocontent .gx-fillchart-btn-close {\n  -webkit-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n  visibility: visible;\n}\n.gx-fillchart-nocontent .ant-card-head-title {\n  position: absolute;\n  left: 20px;\n  top: 15px;\n  z-index: 1;\n}\n.gx-agents-list {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0 -15px;\n  list-style: none;\n  padding-left: 0;\n}\n.gx-agents-list li {\n  width: 20%;\n  padding: 0 15px;\n  margin-bottom: 30px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-agents-list li {\n    width: 25%;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-agents-list li {\n    width: 20%;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-agents-list li {\n    width: 33.33%;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-agents-list li {\n    width: 50%;\n    padding: 0 10px;\n    margin-bottom: 20px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-agents-list {\n    margin: 0 -10px;\n  }\n}\n.gx-featured-item:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n  padding-bottom: 10px;\n  margin-bottom: 30px;\n}\n.gx-card-profile .gx-featured-item:not(:last-child) {\n  padding-bottom: 8px;\n  margin-bottom: 25px;\n}\n@media (max-width: 575px) {\n  .gx-featured-item:not(:last-child) {\n    margin-bottom: 27px;\n  }\n}\n.gx-featured-item:last-child .gx-featured-thumb {\n  margin-bottom: 0;\n}\n@media (max-width: 575px) {\n  .gx-featured-item:last-child .gx-featured-thumb {\n    margin-bottom: 15px;\n  }\n}\n@media (max-width: 575px) {\n  .gx-featured-item {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    -webkit-align-items: normal;\n    -ms-align-items: normal;\n    align-items: normal;\n  }\n}\n.gx-featured-thumb {\n  position: relative;\n  margin-right: 25px;\n  margin-bottom: 10px;\n}\n@media (max-width: 575px) {\n  .gx-featured-thumb {\n    margin-right: 0;\n    margin-bottom: 15px;\n  }\n  .gx-featured-thumb > img {\n    width: 100% !important;\n    height: auto !important;\n  }\n}\n.gx-featured-thumb .ant-tag {\n  position: absolute;\n  left: 15px;\n  top: 15px;\n  z-index: 1;\n  margin: 0;\n}\n.gx-card-profile .gx-featured-thumb {\n  max-width: 130px;\n}\n@media (max-width: 575px) {\n  .gx-card-profile .gx-featured-thumb {\n    max-width: none;\n  }\n}\n.gx-featured-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n@media (max-width: 1366px) {\n  .gx-featured-content {\n    font-size: 13px;\n  }\n}\n@media (max-width: 1199px) {\n  .gx-featured-content {\n    font-size: 14px;\n  }\n  .gx-card-profile .gx-featured-content {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n@media (max-width: 767px) {\n  .gx-featured-content {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n.gx-featured-content-right {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin-left: auto;\n  text-align: right;\n}\n.gx-card-profile .gx-featured-content-right {\n  font-size: 14px;\n}\n@media (max-width: 1199px) {\n  .gx-card-profile .gx-featured-content-right {\n    text-align: left;\n    margin-left: 0;\n  }\n  .gx-card-profile .gx-featured-content-right h2 {\n    font-size: 16px;\n  }\n  .gx-card-profile .gx-featured-content-right h2 .gx-fs-lg {\n    font-size: 14px;\n  }\n}\n@media (max-width: 767px) {\n  .gx-featured-content-right {\n    margin-left: 0;\n    text-align: left;\n    margin-top: 15px;\n  }\n}\n@media (max-width: 575px) {\n  .gx-card-profile .gx-featured-content-right h2 {\n    font-size: 14px;\n  }\n}\n.gx-news-item {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-news-item:not(:last-child) {\n  margin-bottom: 30px;\n}\n@media (max-width: 767px) {\n  .gx-news-item:not(:last-child) {\n    margin-bottom: 26px;\n  }\n}\n@media (max-width: 575px) {\n  .gx-news-item:not(:last-child) {\n    margin-bottom: 22px;\n  }\n}\n@media (max-width: 575px) {\n  .gx-news-item {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n.gx-news-thumb {\n  position: relative;\n  margin-right: 25px;\n}\n@media (max-width: 1366px) {\n  .gx-news-thumb {\n    margin-right: 15px;\n  }\n}\n@media (max-width: 575px) {\n  .gx-news-thumb {\n    margin-right: 0;\n    margin-bottom: 12px;\n  }\n  .gx-news-thumb > img {\n    width: 100% !important;\n    height: auto !important;\n  }\n}\n.gx-news-content {\n  color: #686868;\n  width: calc(100% - 200px);\n}\n@media (max-width: 1366px) {\n  .gx-news-content {\n    width: calc(100% - 190px);\n  }\n}\n@media (max-width: 575px) {\n  .gx-news-content {\n    width: 100%;\n  }\n}\n.gx-news-tags-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n@media (max-width: 1366px) {\n  .gx-news-tags-row {\n    font-size: 12px;\n  }\n}\n.gx-news-tags-left {\n  width: calc(100% - 180px);\n}\n@media (max-width: 1366px) {\n  .gx-news-tags-left {\n    width: calc(100% - 130px);\n  }\n}\n.gx-news-tags-right {\n  width: 180px;\n  padding-left: 8px;\n  text-align: right;\n}\n@media (max-width: 1366px) {\n  .gx-news-tags-right {\n    width: 130px;\n  }\n}\n.gx-currentplan-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0 -5px;\n}\n.gx-currentplan-col {\n  width: 50%;\n  padding: 0 5px;\n}\n@media (max-width: 1366px) {\n  .gx-currentplan-col {\n    width: 100%;\n  }\n}\n@media (max-width: 991px) {\n  .gx-currentplan-col {\n    width: 50%;\n  }\n}\n@media (max-width: 575px) {\n  .gx-currentplan-col {\n    width: 100%;\n  }\n}\n.gx-currentplan-right {\n  border-left: solid 1px #e8e8e8;\n}\n@media (max-width: 1366px) {\n  .gx-currentplan-right {\n    border-left: 0 none !important;\n    border-top: solid 1px #e8e8e8;\n    padding-top: 10px;\n  }\n}\n@media (max-width: 991px) {\n  .gx-currentplan-right {\n    border-left: solid 1px #e8e8e8 !important;\n    border-top: 0 none;\n    padding-top: 0;\n  }\n}\n@media (max-width: 575px) {\n  .gx-currentplan-right {\n    border-left: 0 none !important;\n    border-top: solid 1px #e8e8e8;\n    padding-top: 22px;\n  }\n}\n.gx-currentplan-right-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: flex-end;\n  -ms-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-align-items: flex-end;\n  align-items: flex-end;\n  height: 100%;\n  text-align: right;\n}\n@media (max-width: 1366px) {\n  .gx-currentplan-right-content {\n    -webkit-justify-content: flex-start;\n    -ms-justify-content: flex-start;\n    justify-content: flex-start;\n    -webkit-align-items: flex-start;\n    -ms-align-items: flex-start;\n    align-items: flex-start;\n    text-align: left;\n  }\n}\n@media (max-width: 991px) {\n  .gx-currentplan-right-content {\n    -webkit-justify-content: flex-end;\n    -ms-justify-content: flex-end;\n    justify-content: flex-end;\n    -webkit-align-items: flex-end;\n    -ms-align-items: flex-end;\n    align-items: flex-end;\n    text-align: right;\n  }\n}\n@media (max-width: 575px) {\n  .gx-currentplan-right-content {\n    -webkit-justify-content: flex-start;\n    -ms-justify-content: flex-start;\n    justify-content: flex-start;\n    -webkit-align-items: flex-start;\n    -ms-align-items: flex-start;\n    align-items: flex-start;\n    text-align: left;\n  }\n}\n.gx-oth-plans-down {\n  display: none;\n}\n@media (max-width: 1366px) {\n  .gx-oth-plans-down {\n    display: block;\n    margin-top: 15px;\n  }\n}\n@media (max-width: 991px) {\n  .gx-oth-plans-down {\n    display: none;\n    margin-top: 0;\n  }\n}\n@media (max-width: 575px) {\n  .gx-oth-plans-down {\n    display: block;\n    margin-top: 20px;\n  }\n}\n@media (max-width: 1366px) {\n  .gx-oth-plans-up {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .gx-oth-plans-up {\n    display: block;\n  }\n}\n@media (max-width: 575px) {\n  .gx-oth-plans-up {\n    display: none;\n  }\n}\n.gx-revenue-title {\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 1;\n  color: #000000;\n}\n@media (max-width: 1366px) {\n  .gx-revenue-title {\n    font-size: 28px;\n  }\n}\n@media (max-width: 575px) {\n  .gx-revenue-title {\n    padding-top: 15px;\n  }\n}\n.gx-dealclose-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-dealclose-header-right {\n  margin-left: auto;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n@media (max-width: 1366px) {\n  .gx-dealclose-header-right {\n    margin-left: 0;\n    margin-bottom: 20px;\n    margin-top: 15px;\n  }\n}\n@media (max-width: 991px) {\n  .gx-dealclose-header-right {\n    margin-left: auto;\n    margin-bottom: 0;\n    margin-top: 0;\n  }\n}\n@media (max-width: 575px) {\n  .gx-dealclose-header-right {\n    margin-left: 0;\n  }\n}\n@media (max-width: 1366px) {\n  .gx-dealclose-header {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n@media (max-width: 991px) {\n  .gx-dealclose-header {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n}\n@media (max-width: 575px) {\n  .gx-dealclose-header {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n@media (max-width: 1366px) {\n  .gx-order-history .ant-table {\n    font-size: 12px;\n  }\n}\n.gx-icon-img {\n  width: 60px;\n  height: 60px;\n}\n@media screen and (max-width: 1366px) {\n  .gx-icon-img {\n    width: 40px;\n    height: 40px;\n  }\n}\n.gx-smart-img {\n  max-height: 90px;\n  width: 100%;\n  object-fit: cover;\n}\n@media screen and (max-width: 575px) {\n  .gx-smart-img {\n    max-height: 180px;\n  }\n}\n.gx-ayurveda-thumb {\n  max-height: 150px;\n}\n.gx-ayurveda-thumb > img {\n  object-fit: cover;\n}\n.gx-dash-search {\n  position: relative;\n}\n@media screen and (max-width: 575px) {\n  .gx-dash-search {\n    padding-right: 30px;\n  }\n  .gx-dash-search .gx-search-icon {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 1;\n  }\n}\n.gx-bg-dark-primary {\n  background-color: var(--app-primary-color);\n  position: relative;\n  overflow: hidden;\n}\n.gx-bg-dark-primary > * {\n  position: relative;\n  z-index: 1;\n}\n.gx-bg-dark-primary:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.72);\n}\n@media screen and (max-width: 1366px) {\n  .recharts-text {\n    font-size: 12px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-list-item .ant-list-item-content {\n    flex-direction: column;\n  }\n}\n/*Algolia Styles*/\n.gx-algolia-sidebar {\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  margin-bottom: 32px;\n  width: 240px !important;\n}\n@media screen and (max-width: 767px) {\n  .gx-algolia-sidebar {\n    width: 100% !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-algolia-sidebar {\n    margin-bottom: 20px;\n  }\n}\n.gx-algolia-sidebar [class^=\"ais-\"] {\n  font-size: 14px;\n}\n.gx-algolia-sidebar-content {\n  padding: 24px;\n}\n.gx-algolia-sidebar .ais-ClearRefinements {\n  margin-bottom: 20px;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu {\n  margin-bottom: 20px;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-list li {\n  margin-bottom: 5px;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-list li a {\n  color: #545454;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-list li a:hover,\n.gx-algolia-sidebar .ais-HierarchicalMenu-list li a:focus {\n  color: var(--app-primary-color);\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-count {\n  padding: 0 5px;\n  font-size: 12px;\n  color: #8c8c8c;\n  background-color: transparent;\n  border-radius: 0;\n}\n.gx-algolia-sidebar .ais-Panel {\n  margin-bottom: 20px;\n}\n.gx-algolia-sidebar .ais-Panel-header {\n  margin-bottom: 8px;\n  padding-bottom: 0;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border-bottom: 0 none;\n}\n.gx-algolia-sidebar .ais-RefinementList-list li {\n  margin-bottom: 5px;\n}\n.gx-algolia-sidebar .ais-RefinementList-checkbox {\n  margin-right: 12px;\n}\n.gx-algolia-sidebar .ais-RefinementList-labelText {\n  font-size: 14px;\n}\n.gx-algolia-sidebar .ais-RefinementList-count {\n  padding: 0 5px;\n  font-size: 14px;\n  color: #8c8c8c;\n  background-color: transparent;\n  border-radius: 0;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Breadcrumb-item--selected,\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-HierarchicalMenu-item--selected,\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Menu-item--selected {\n  font-weight: normal;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Breadcrumb-item--selected > a,\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-HierarchicalMenu-item--selected > a,\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Menu-item--selected > a {\n  color: var(--app-primary-color);\n}\n.gx-algolia-sidebar .ais-RatingMenu-item--selected {\n  font-weight: 600;\n}\n.gx-algolia-layout-has-sider {\n  flex-wrap: nowrap;\n}\n@media screen and (max-width: 767px) {\n  .gx-algolia-layout-has-sider {\n    flex-wrap: wrap;\n  }\n}\n.gx-algolia-category-title {\n  font-size: 14px;\n  margin-bottom: 10px;\n  color: #8c8c8c;\n}\n.gx-algolia-main {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  width: 100%;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  padding-left: 30px;\n  margin-bottom: 32px;\n}\n.gx-algolia-main [class^=\"ais-\"] {\n  font-size: 14px;\n}\n@media screen and (max-width: 767px) {\n  .gx-algolia-main {\n    padding-left: 0;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-algolia-main {\n    margin-bottom: 20px;\n  }\n}\n.gx-algolia-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n.gx-algolia-sort-by {\n  margin-left: auto;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-algolia-sort-by label {\n  margin-right: 15px;\n}\n@media screen and (max-width: 400px) {\n  .gx-algolia-sort-by {\n    margin-left: 0;\n  }\n}\n.gx-algolia-footer {\n  padding: 10px;\n}\n.gx-algolia-footer .ais-Pagination-list {\n  flex-wrap: wrap;\n}\n.gx-algolia-footer .ais-Pagination-list li {\n  margin-bottom: 5px;\n}\n.gx-algolia-content .ais-Stats {\n  margin-bottom: 10px;\n}\n.gx-product-name [class^=\"ais-\"] {\n  font-size: 16px;\n}\n.gx-algolia-refinementList {\n  width: 100%;\n}\n.gx-algolia-refinementList li.ais-RefinementList-item {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ais-RangeInput-submit,\n.ais-ClearRefinements-button,\n.ais-CurrentRefinements-reset,\n.ais-GeoSearch-redo,\n.ais-GeoSearch-reset,\n.ais-HierarchicalMenu-showMore,\n.ais-InfiniteHits-loadMore,\n.ais-InfiniteResults-loadMore,\n.ais-Menu-showMore,\n.ais-RefinementList-showMore {\n  background-color: var(--app-primary-color);\n}\n.ais-RangeInput-submit:focus,\n.ais-ClearRefinements-button:focus,\n.ais-CurrentRefinements-reset:focus,\n.ais-GeoSearch-redo:focus,\n.ais-GeoSearch-reset:focus,\n.ais-HierarchicalMenu-showMore:focus,\n.ais-InfiniteHits-loadMore:focus,\n.ais-InfiniteResults-loadMore:focus,\n.ais-Menu-showMore:focus,\n.ais-RefinementList-showMore:focus,\n.ais-RangeInput-submit:hover,\n.ais-ClearRefinements-button:hover,\n.ais-CurrentRefinements-reset:hover,\n.ais-GeoSearch-redo:hover,\n.ais-GeoSearch-reset:hover,\n.ais-HierarchicalMenu-showMore:hover,\n.ais-InfiniteHits-loadMore:hover,\n.ais-InfiniteResults-loadMore:hover,\n.ais-Menu-showMore:hover,\n.ais-RefinementList-showMore:hover {\n  background-color: var(--app-primary-color);\n}\n.ais-Breadcrumb-link,\n.ais-HierarchicalMenu-link,\n.ais-Menu-link,\n.ais-Pagination-link,\n.ais-RatingMenu-link {\n  color: var(--app-primary-color);\n}\n.ais-Breadcrumb-link:focus,\n.ais-HierarchicalMenu-link:focus,\n.ais-Menu-link:focus,\n.ais-Pagination-link:focus,\n.ais-RatingMenu-link:focus,\n.ais-Breadcrumb-link:hover,\n.ais-HierarchicalMenu-link:hover,\n.ais-Menu-link:hover,\n.ais-Pagination-link:hover,\n.ais-RatingMenu-link:hover {\n  color: var(--app-primary-color);\n}\n.ais-Pagination-item--selected .ais-Pagination-link {\n  background-color: var(--app-primary-color);\n  border-color: var(--app-primary-color);\n}\n/*Error Styles*/\n.gx-page-error-container {\n  position: relative;\n  height: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-page-error-content {\n  margin: 0 auto;\n  width: 380px;\n  max-width: 94%;\n}\n.gx-page-error-content h2 {\n  margin-bottom: 50px;\n}\n@media screen and (max-width: 767px) {\n  .gx-page-error-content h2 {\n    margin-bottom: 20px;\n  }\n}\n.gx-error-code {\n  color: #595959;\n  font-size: 160px;\n  text-align: center;\n  line-height: 1;\n  font-weight: 500;\n  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);\n}\n@media screen and (max-width: 991px) {\n  .gx-error-code {\n    font-size: 130px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-error-code {\n    font-size: 100px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-error-code {\n    font-size: 80px;\n  }\n}\n/*Editor Styles*/\n.rdw-editor-toolbar .rdw-inline-wrapper {\n  flex-wrap: wrap;\n}\n@media screen and (max-width: 399px) {\n  .rdw-editor-toolbar .rdw-inline-wrapper .rdw-option-wrapper {\n    margin-bottom: 8px;\n  }\n}\n/*Testimonial Styles*/\n.gx-testimonial {\n  margin-bottom: 32px;\n}\n@media screen and (max-width: 575px) {\n  .gx-testimonial {\n    margin-bottom: 20px;\n  }\n}\n.gx-classic-testimonial .ant-avatar {\n  margin: 0 auto;\n  margin-bottom: 30px;\n  width: 120px;\n  height: 120px;\n}\n.gx-classic-testimonial .ant-avatar img {\n  width: 100%;\n  height: 100%;\n}\n@media screen and (max-width: 575px) {\n  .gx-classic-testimonial .ant-avatar {\n    width: 80px;\n    height: 80px;\n    margin-bottom: 15px;\n  }\n}\n.gx-testimonial-bg {\n  background-color: rgba(0, 0, 0, 0.8);\n  padding: 30px;\n  overflow: hidden;\n  position: relative;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n@media screen and (max-width: 575px) {\n  .gx-testimonial-bg {\n    padding: 16px;\n  }\n}\n.gx-testimonial-bg .ant-avatar {\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n  overflow: hidden;\n  border: 4px solid var(--app-primary-color);\n}\n.gx-testimonial-bg .ant-avatar img {\n  width: 100%;\n  height: 100%;\n}\n@media screen and (max-width: 450px) {\n  .gx-testimonial-bg .ant-avatar {\n    width: 50px;\n    height: 50px;\n  }\n}\n.gx-testimonial-bg .gx-description {\n  color: #d9d9d9;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 25px;\n  margin-bottom: 15px;\n}\n.gx-testimonial-bg .gx-title {\n  color: var(--app-primary-color);\n  margin-bottom: 2px;\n}\n.gx-testimonial-des {\n  position: relative;\n  padding-left: 30px;\n}\n.gx-testimonial-des:before {\n  font-family: \"gaxon\";\n  font-size: 20px;\n  content: \"\\e066\";\n  color: #ffffff;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n@media screen and (max-width: 475px) {\n  .gx-standard .gx-media {\n    flex-direction: column;\n  }\n}\n.rtl {\n  direction: rtl;\n  text-align: right;\n  unicode-bidi: bidi-override;\n  /*Status style*/\n  /* Customizer Style */\n  /* & .ant-popover-placement-bottomRight {\n    & > .ant-popover-content {\n      & > .ant-popover-arrow {\n        right: auto;\n        left: 10px;\n      }\n    }\n  }*/\n}\n.rtl ol,\n.rtl ul,\n.rtl dl {\n  padding-left: 0;\n  padding-right: 30px;\n}\n.rtl .gx-mr-1 {\n  margin-right: 0 !important;\n  margin-left: 0.25rem !important;\n}\n.rtl .gx-ml-1 {\n  margin-left: 0 !important;\n  margin-right: 0.25rem !important;\n}\n.rtl .gx-mr-2 {\n  margin-right: 0 !important;\n  margin-left: 0.5rem !important;\n}\n.rtl .gx-ml-2 {\n  margin-left: 0 !important;\n  margin-right: 0.5rem !important;\n}\n.rtl .gx-mr-3 {\n  margin-right: 0 !important;\n  margin-left: 1rem !important;\n}\n.rtl .gx-ml-3 {\n  margin-left: 0 !important;\n  margin-right: 1rem !important;\n}\n.rtl .gx-mr-4 {\n  margin-right: 0 !important;\n  margin-left: 1.5rem !important;\n}\n.rtl .gx-ml-4 {\n  margin-left: 0 !important;\n  margin-right: 1.5rem !important;\n}\n.rtl .gx-mr-5 {\n  margin-right: 0 !important;\n  margin-left: 3rem !important;\n}\n.rtl .gx-ml-5 {\n  margin-left: 0 !important;\n  margin-right: 3rem !important;\n}\n.rtl .gx-pr-1 {\n  padding-right: 0 !important;\n  padding-left: 0.25rem !important;\n}\n.rtl .gx-pl-1 {\n  padding-left: 0 !important;\n  padding-right: 0.25rem !important;\n}\n.rtl .gx-pr-2 {\n  padding-right: 0 !important;\n  padding-left: 0.5rem !important;\n}\n.rtl .gx-pl-2 {\n  padding-left: 0 !important;\n  padding-right: 0.5rem !important;\n}\n.rtl .gx-pr-3 {\n  padding-right: 0 !important;\n  padding-left: 1rem !important;\n}\n.rtl .gx-pl-3 {\n  padding-left: 0 !important;\n  padding-right: 1rem !important;\n}\n.rtl .gx-pr-4 {\n  padding-right: 0 !important;\n  padding-left: 1.5rem !important;\n}\n.rtl .gx-pl-4 {\n  padding-left: 0 !important;\n  padding-right: 1.5rem !important;\n}\n.rtl .gx-pr-5 {\n  padding-right: 0 !important;\n  padding-left: 2rem !important;\n}\n.rtl .gx-pl-5 {\n  padding-left: 0 !important;\n  padding-right: 2rem !important;\n}\n.rtl .gx-mr-auto {\n  margin-right: 0 !important;\n  margin-left: auto !important;\n}\n.rtl .gx-ml-auto {\n  margin-left: 0 !important;\n  margin-right: auto !important;\n}\n.rtl .gx-float-left {\n  float: right !important;\n}\n.rtl .gx-float-right {\n  float: left !important;\n}\n.rtl .gx-customizer-option {\n  right: auto;\n  left: 0;\n}\n.rtl .gx-customizer-option .ant-btn {\n  -webkit-border-radius: 0 30px 30px 0;\n  -moz-border-radius: 0 30px 30px 0;\n  border-radius: 0 30px 30px 0;\n  margin-left: 0;\n}\n.rtl .gx-app-nav {\n  padding-right: 0;\n}\n.rtl .gx-border-left {\n  border-left: 0 none;\n  border-right: solid 1px #e8e8e8;\n}\n.rtl .gx-border-right {\n  border-right: 0 none;\n  border-left: solid 1px #e8e8e8;\n}\n.rtl .gx-social-link {\n  padding-right: 0;\n}\n.rtl .gx-left-0 {\n  left: auto !important;\n  right: 0 !important;\n}\n.rtl .gx-right-0 {\n  right: auto !important;\n  left: 0 !important;\n}\n.rtl .gx-status-pos .gx-status {\n  left: auto;\n  right: 0;\n}\n.rtl .gx-status-pos .gx-status.gx-status-rtl {\n  right: auto;\n  left: -4px;\n}\n@media screen and (max-width: 991px) {\n  .rtl .framed-layout .ant-drawer-left {\n    right: 0;\n    left: auto;\n  }\n}\n@media screen and (max-width: 991px) {\n  .rtl .framed-layout .ant-drawer-right {\n    left: 0;\n    right: auto;\n  }\n}\n.rtl .framed-layout .ant-drawer-right .ant-drawer-content-wrapper {\n  -webkit-border-radius: 11px 0 0 11px;\n  -moz-border-radius: 11px 0 0 11px;\n  border-radius: 11px 0 0 11px;\n}\n.rtl .ant-drawer-right .ant-drawer-content-wrapper {\n  right: auto;\n  left: 0;\n  transform: translateX(-100%) !important;\n}\n.rtl .ant-drawer-right.ant-drawer-open .ant-drawer-content-wrapper {\n  transform: translateX(0) !important;\n}\n.rtl .ant-drawer-left .ant-drawer-content-wrapper {\n  right: 0;\n  left: auto;\n  transform: translateX(100%) !important;\n}\n.rtl .ant-drawer-left.ant-drawer-open .ant-drawer-content-wrapper {\n  transform: translateX(0) !important;\n}\n.rtl .ant-rate,\n.rtl .ant-menu-rtl,\n.rtl .ant-list-items,\n.rtl .ant-menu-rtl ul,\n.rtl .ant-list-item-action,\n.rtl .ant-transfer-list-content {\n  padding-right: 0 !important;\n}\n.rtl .ant-menu-submenu-popup .ant-menu-item-group-title {\n  padding-left: 30px;\n  padding-right: 20px;\n}\n.rtl .ant-menu-item .icon {\n  margin-right: 0;\n  margin-left: 20px;\n}\n.rtl .ant-menu-inline,\n.rtl .ant-menu-vertical,\n.rtl .ant-menu-vertical-left {\n  border-right: 0 none;\n  border-left: 1px solid #e8e8e8;\n}\n.rtl .ant-layout-sider .ant-menu-inline,\n.rtl .ant-layout-sider .ant-menu-vertical,\n.rtl .ant-layout-sider .ant-menu-vertical-left,\n.rtl .gx-drawer-sidebar .ant-menu-inline,\n.rtl .gx-drawer-sidebar .ant-menu-vertical,\n.rtl .gx-drawer-sidebar .ant-menu-vertical-left {\n  border-left: 0 none;\n}\n.rtl .ant-menu-vertical-right {\n  border-right: 0 none;\n  border-left: 1px solid #e8e8e8;\n}\n.rtl .ant-menu-sub.ant-menu-inline {\n  border-left: none !important;\n}\n.rtl .ant-menu-item .anticon,\n.rtl .ant-menu-submenu-title .anticon {\n  margin-right: 0;\n  margin-left: 20px;\n}\n.rtl .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {\n  padding-left: 30px !important;\n  padding-right: 54px !important;\n}\n.rtl .ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item,\n.rtl .ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {\n  padding-left: 30px !important;\n  padding-right: 80px !important;\n}\n.rtl .ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item,\n.rtl .ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item {\n  padding-left: 30px !important;\n  padding-right: 106px !important;\n}\n.rtl .ant-menu-submenu-popup .ant-menu-sub.ant-menu .ant-menu-item {\n  padding-left: 30px !important;\n  padding-right: 20px !important;\n  text-align: right;\n}\n.rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  right: auto;\n  left: 16px;\n}\n.rtl .gx-app-sidebar .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .gx-app-sidebar .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .gx-app-sidebar .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .gx-app-sidebar .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-drawer .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-drawer .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-drawer .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-drawer .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  left: auto;\n  right: 22px;\n}\n.rtl .gx-app-sidebar .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .gx-app-sidebar .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .gx-app-sidebar .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .gx-app-sidebar .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-drawer .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-drawer .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-drawer .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.rtl .ant-drawer .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  left: auto;\n  right: 60px;\n}\n.rtl .ant-menu-vertical .ant-menu-item:after,\n.rtl .ant-menu-vertical-left .ant-menu-item:after,\n.rtl .ant-menu-vertical-right .ant-menu-item:after,\n.rtl .ant-menu-inline .ant-menu-item:after {\n  border-right: 0 none;\n  border-left: 3px solid var(--app-primary-color);\n}\n.rtl .ant-menu-vertical .ant-menu-item,\n.rtl .ant-menu-vertical-left .ant-menu-item,\n.rtl .ant-menu-vertical-right .ant-menu-item,\n.rtl .ant-menu-inline .ant-menu-item,\n.rtl .ant-menu-vertical .ant-menu-submenu-title,\n.rtl .ant-menu-vertical-left .ant-menu-submenu-title,\n.rtl .ant-menu-vertical-right .ant-menu-submenu-title,\n.rtl .ant-menu-inline .ant-menu-submenu-title {\n  padding: 0 20px 0 30px !important;\n}\n.rtl .ant-menu-vertical .ant-menu-item .icon,\n.rtl .ant-menu-vertical-left .ant-menu-item .icon,\n.rtl .ant-menu-vertical-right .ant-menu-item .icon,\n.rtl .ant-menu-inline .ant-menu-item .icon,\n.rtl .ant-menu-vertical .ant-menu-submenu-title .icon,\n.rtl .ant-menu-vertical-left .ant-menu-submenu-title .icon,\n.rtl .ant-menu-vertical-right .ant-menu-submenu-title .icon,\n.rtl .ant-menu-inline .ant-menu-submenu-title .icon {\n  margin-right: 0;\n  margin-left: 20px;\n}\n.rtl .ant-layout-sider .ant-menu-vertical .ant-menu-item,\n.rtl .ant-layout-sider .ant-menu-vertical-left .ant-menu-item,\n.rtl .ant-layout-sider .ant-menu-vertical-right .ant-menu-item,\n.rtl .ant-layout-sider .ant-menu-inline .ant-menu-item,\n.rtl .ant-drawer .ant-menu-vertical .ant-menu-item,\n.rtl .ant-drawer .ant-menu-vertical-left .ant-menu-item,\n.rtl .ant-drawer .ant-menu-vertical-right .ant-menu-item,\n.rtl .ant-drawer .ant-menu-inline .ant-menu-item,\n.rtl .ant-layout-sider .ant-menu-vertical .ant-menu-submenu-title,\n.rtl .ant-layout-sider .ant-menu-vertical-left .ant-menu-submenu-title,\n.rtl .ant-layout-sider .ant-menu-vertical-right .ant-menu-submenu-title,\n.rtl .ant-layout-sider .ant-menu-inline .ant-menu-submenu-title,\n.rtl .ant-drawer .ant-menu-vertical .ant-menu-submenu-title,\n.rtl .ant-drawer .ant-menu-vertical-left .ant-menu-submenu-title,\n.rtl .ant-drawer .ant-menu-vertical-right .ant-menu-submenu-title,\n.rtl .ant-drawer .ant-menu-inline .ant-menu-submenu-title {\n  padding-left: 30px !important;\n  padding-right: 40px !important;\n}\n.rtl .ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item,\n.rtl .ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item,\n.rtl .ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item,\n.rtl .ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item,\n.rtl .ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title,\n.rtl .ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title,\n.rtl .ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title,\n.rtl .ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title {\n  padding: 0 calc((80px - 20px) / 2) !important;\n}\n.rtl .ant-card .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,\n.rtl .ant-card .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,\n.rtl .ant-card .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,\n.rtl .ant-card .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {\n  padding-left: 30px !important;\n  padding-right: 54px !important;\n}\n.rtl .ant-layout-sider .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,\n.rtl .ant-layout-sider.ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,\n.rtl .ant-layout-sider .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,\n.rtl .ant-layout-sider .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title,\n.rtl .ant-drawer .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,\n.rtl .ant-drawer .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,\n.rtl .ant-drawer .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,\n.rtl .ant-drawer .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {\n  padding-left: 30px !important;\n  padding-right: 80px !important;\n}\n.rtl .ant-menu-inline .ant-menu-submenu-title {\n  padding-right: 20px !important;\n  padding-left: 30px !important;\n}\n.rtl .ant-menu-item-group-list .ant-menu-item,\n.rtl .ant-menu-item-group-list .ant-menu-submenu-title {\n  padding: 0 28px 0 16px;\n}\n.rtl .ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {\n  padding: 0 80px 0 30px;\n}\n.rtl .ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,\n.rtl .ant-drawer .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,\n.rtl .ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-item .icon,\n.rtl .ant-drawer .ant-menu .ant-menu-submenu .ant-menu-item .icon {\n  margin-right: 0;\n  margin-left: 12px;\n}\n.rtl .ant-menu-dark .ant-menu-item .icon {\n  margin-right: 0;\n  margin-left: 20px;\n}\n.rtl .ant-btn:not(:last-child) {\n  margin-right: 0;\n  margin-left: 15px;\n}\n@media screen and (max-width: 575px) {\n  .rtl .ant-btn:not(:last-child) {\n    margin-right: 0;\n    margin-left: 10px;\n  }\n}\n.rtl .ant-btn-group .ant-btn:not(:last-child),\n.rtl .ant-transfer-operation .ant-btn:not(:last-child) {\n  margin-left: 0;\n}\n@media (max-width: 1599px) {\n  .rtl .gx-product-footer .ant-btn:not(:last-child) {\n    margin-right: 0;\n    margin-left: 6px;\n  }\n}\n.rtl .ant-radio-button-wrapper:last-child {\n  border-radius: 6px 0 0 6px;\n}\n.rtl .ant-radio-button-wrapper:first-child {\n  border-radius: 0 6px 6px 0;\n}\n.rtl .ant-table-thead > tr > th,\n.rtl .ant-table table {\n  text-align: right;\n}\n.rtl .ant-table-pagination.ant-pagination {\n  float: left;\n}\n.rtl .ant-pagination-item,\n.rtl .ant-pagination-prev,\n.rtl .ant-pagination-jump-prev,\n.rtl .ant-pagination-jump-next {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.rtl .anticon-left,\n.rtl .anticon-right {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rtl .ant-table-thead > tr > th.ant-table-selection-column,\n.rtl .ant-table-tbody > tr > td.ant-table-selection-column {\n  text-align: center;\n}\n.rtl .ant-table-thead > tr > th.ant-table-selection-column-custom .ant-table-selection {\n  margin-right: 0;\n  margin-left: -15px;\n}\n.rtl .ant-table-selection-select-all-custom {\n  margin-right: 0 !important;\n  margin-left: 4px !important;\n}\n.rtl .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters,\n.rtl .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters {\n  padding-right: 16px !important;\n  padding-left: 30px !important;\n}\n.rtl .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters.ant-table-column-has-filters {\n  padding-right: 16px !important;\n  padding-left: 54px !important;\n}\n.rtl .ant-table-thead > tr > th .ant-table-column-sorter {\n  right: auto;\n  left: 6px;\n}\n.rtl .ant-table-thead > tr > th.ant-table-column-has-filters .ant-table-column-sorter {\n  right: auto;\n  left: 34px;\n}\n.rtl .ant-table-thead > tr > th .anticon-filter,\n.rtl .ant-table-thead > tr > th .ant-table-filter-icon {\n  right: auto;\n  left: 0;\n}\n.rtl .ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {\n  padding-right: 8px;\n  padding-left: 0;\n}\n.rtl .ant-table-filter-dropdown-link.confirm {\n  float: right;\n}\n.rtl .ant-table-filter-dropdown-link.clear {\n  float: left;\n}\n.rtl .ant-table .ant-table-row-indent + .ant-table-row-expand-icon {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.rtl .ant-table-fixed-left {\n  left: auto;\n  right: 0;\n  -webkit-box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.15);\n  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.15);\n}\n.rtl .ant-table.ant-table-scroll-position-left .ant-table-fixed-left {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n}\n.rtl .ant-table-fixed-right {\n  right: auto;\n  left: 0;\n  -webkit-box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.15);\n  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.15);\n}\n.rtl .ant-table.ant-table-scroll-position-right .ant-table-fixed-right {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n}\n.rtl .ant-select-selection-selected-value {\n  float: right;\n  padding-right: 0;\n  padding-left: 20px;\n}\n.rtl .ant-select-arrow {\n  right: auto;\n  left: 11px;\n}\n.rtl .ant-badge:not(:last-child),\n.rtl .gx-badge:not(:last-child) {\n  margin-right: 0;\n  margin-left: 12px;\n}\n.rtl .gx-user-list .gx-avatar-img {\n  margin-right: 0;\n  margin-left: 20px;\n}\n.rtl .gx-user-list .gx-link[class*=\"gx-meta-\"] i {\n  margin-right: 0;\n  margin-left: 6px;\n}\n.rtl .gx-user-list .gx-btn-list li:not(:last-child) {\n  margin-right: 0;\n  margin-left: 10px;\n}\n.rtl .gx-card-list .gx-card-list-footer {\n  padding-left: 0;\n  padding-right: 15px;\n}\n.rtl .gx-card-list .gx-card-list-footer .ant-btn {\n  margin-left: 0;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-card-list .gx-card-list-footer {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .rtl .gx-card-list .gx-card-list-footer .ant-btn {\n    margin-left: 12px;\n    margin-right: 0;\n  }\n}\n.rtl .ant-timeline {\n  padding-right: 0;\n}\n.rtl .ant-timeline-item-head-custom {\n  margin-right: 0;\n  right: 0;\n  left: auto;\n}\n.rtl .gx-timeline-panel::before {\n  border-width: 10px 0 10px 17px;\n  left: auto;\n  right: -18px;\n}\n.rtl .gx-timeline-panel::after {\n  border-width: 10px 0 10px 16px;\n  left: auto;\n  right: -16px;\n}\n.rtl .gx-timeline-item {\n  padding-right: 80px;\n  padding-left: 0;\n}\n.rtl .gx-timeline-item::before {\n  right: 25px;\n  left: auto;\n}\n.rtl .gx-timeline-badge {\n  right: 0;\n  left: auto;\n}\n.rtl .gx-timeline-badge .icon {\n  display: inline !important;\n}\n.rtl .gx-timeline-center .gx-timeline-item {\n  float: left;\n  padding-left: 0;\n  padding-right: 55px;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-timeline-center .gx-timeline-item {\n    float: none;\n    padding-right: 80px;\n  }\n}\n.rtl .gx-timeline-center .gx-timeline-item .gx-timeline-badge {\n  right: -25px;\n  left: auto;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-timeline-center .gx-timeline-item .gx-timeline-badge {\n    right: 0;\n  }\n}\n.rtl .gx-timeline-center .gx-timeline-item::before {\n  right: 0;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-timeline-center .gx-timeline-item::before {\n    right: 25px;\n  }\n}\n.rtl .gx-timeline-center .gx-timeline-time {\n  left: auto;\n  right: -150px;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-timeline-center .gx-timeline-time {\n    right: auto;\n  }\n}\n.rtl .gx-timeline-center .gx-timeline-inverted {\n  float: right;\n  padding-left: 55px;\n  padding-right: 0;\n  text-align: left;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-timeline-center .gx-timeline-inverted {\n    float: none;\n    padding-left: 0;\n    padding-right: 80px;\n    text-align: right;\n  }\n}\n.rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {\n  left: -25px;\n  right: auto;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {\n    left: auto;\n    right: 0;\n  }\n}\n.rtl .gx-timeline-center .gx-timeline-inverted::before {\n  left: -2px;\n  right: auto;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-timeline-center .gx-timeline-inverted::before {\n    left: auto;\n    right: 25px;\n  }\n}\n.rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel::before {\n  border-width: 10px 16px 10px 0;\n  left: -18px;\n  right: auto;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel::before {\n    border-width: 10px 0 10px 17px !important;\n    right: -18px;\n    left: auto;\n  }\n}\n.rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel::after {\n  border-width: 10px 0 10px 16px;\n  left: -16px;\n  right: auto;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel::after {\n    right: -16px;\n    left: auto;\n    border-width: 10px 0 10px 16px !important;\n  }\n}\n.rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-time {\n  left: -150px;\n  right: auto;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-timeline-center .gx-timeline-inverted .gx-timeline-time {\n    left: auto;\n  }\n}\n.rtl .gx-timeline-left {\n  float: right;\n  margin-left: 20px;\n  margin-right: 0;\n}\n.rtl .gx-timeline-right {\n  float: left;\n  margin-right: 20px;\n  margin-left: 0;\n}\n.rtl .gx-customizer > div:first-child,\n.rtl .gx-wall-scroll > div:first-child,\n.rtl .gx-popover-scroll > div:first-child,\n.rtl .gx-popover-lang-scroll > div:first-child,\n.rtl .gx-module-side-scroll > div:first-child,\n.rtl .gx-module-content-scroll > div:first-child,\n.rtl .gx-layout-sider-scrollbar > div:first-child,\n.rtl .gx-chat-sidenav-scroll-tab-1 > div:first-child,\n.rtl .gx-chat-sidenav-scroll-tab-2 > div:first-child {\n  margin-left: -17px;\n  margin-right: 0 !important;\n}\n.rtl .gx-customizer > div:last-child,\n.rtl .gx-wall-scroll > div:last-child,\n.rtl .gx-popover-scroll > div:last-child,\n.rtl .gx-popover-lang-scroll > div:last-child,\n.rtl .gx-module-side-scroll > div:last-child,\n.rtl .gx-module-content-scroll > div:last-child,\n.rtl .gx-layout-sider-scrollbar > div:last-child,\n.rtl .gx-chat-sidenav-scroll-tab-1 > div:last-child,\n.rtl .gx-chat-sidenav-scroll-tab-2 > div:last-child {\n  right: auto !important;\n  left: 2px;\n}\n.rtl .icon:not(.gx-icon-btn) {\n  display: inline-block;\n  vertical-align: middle;\n}\n.rtl .ant-menu-inline-collapsed-tooltip .icon {\n  display: none;\n}\n.rtl .icon-ellipse-v::before {\n  content: \"\\7b\";\n}\n.rtl .icon-editor::before {\n  content: \"\\7d\";\n}\n.rtl .gx-module-sidenav {\n  border-left: solid 1px #e8e8e8;\n  border-right: none;\n}\n.rtl .gx-module-list-icon {\n  padding-right: 0;\n  padding-left: 10px;\n}\n.rtl .gx-module-nav {\n  padding-right: 0;\n}\n.rtl .gx-module-nav li i {\n  margin-left: 16px;\n  margin-right: 0;\n}\n.rtl .gx-module-box-topbar label.ant-checkbox-wrapper,\n.rtl .gx-module-box-topbar .ant-dropdown-trigger {\n  margin-right: 0;\n  margin-left: 10px;\n}\n.rtl .gx-mail-list-info {\n  padding-right: 10px;\n  padding-left: 0;\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-mail-list-info {\n    padding-right: 0;\n  }\n}\n.rtl .gx-chat-sidenav {\n  border-left: solid 1px #e8e8e8;\n  border-right: none;\n}\n.rtl .gx-profile-banner-avatar {\n  margin-right: 0;\n  margin-left: 1.5rem;\n}\n@media (max-width: 575px) {\n  .rtl .gx-profile-banner-avatar {\n    margin-left: 0;\n  }\n}\n.rtl .gx-profile-banner-top-right {\n  margin-right: auto;\n  margin-left: 0;\n}\n.rtl .gx-profile-banner .gx-navbar-nav {\n  padding-right: 0;\n}\n.rtl .gx-profile-banner .gx-follower-list {\n  padding-right: 0;\n}\n.rtl .gx-profile-banner .gx-follower-list li:not(:first-child) {\n  border-left: none;\n  border-right: solid 1px #ffffff;\n}\n.rtl .gx-profile-setting {\n  margin-left: 0;\n  margin-right: auto;\n}\n.rtl .gx-algolia-sidebar ul {\n  padding-right: 0;\n}\n.rtl .gx-algolia-sidebar .ais-RefinementList-checkbox {\n  margin-left: 12px;\n  margin-right: 0;\n}\n.rtl .gx-algolia-sidebar .ais-RefinementList-labelText {\n  display: inline-block;\n  vertical-align: top;\n}\n.rtl .gx-algolia-main {\n  padding-right: 30px;\n  padding-left: 0;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-algolia-main {\n    padding-right: 0;\n  }\n}\n.rtl .gx-algolia-sort-by {\n  margin-right: auto;\n  margin-left: 0;\n}\n.rtl .gx-algolia-sort-by label {\n  margin-right: 0;\n  margin-left: 15px;\n}\n.rtl .gx-algolia-header .gx-lt-icon-search-bar {\n  margin-left: 10px;\n  margin-right: 0;\n}\n.rtl .ais-RangeInput-submit {\n  margin-right: 0.3rem;\n  margin-left: 0;\n}\n.rtl .gx-testimonial-des {\n  padding-right: 30px;\n  padding-left: 0;\n}\n.rtl .gx-testimonial-des:before {\n  left: auto;\n  right: 0;\n}\n.rtl .slick-slider .gx-slide-item {\n  direction: rtl;\n}\n.rtl .login-form-forgot {\n  float: left;\n}\n.rtl .ant-input-number {\n  margin-left: 10px;\n  margin-right: 0;\n}\n.rtl .ant-input-group > [class*=\"col-\"] {\n  float: right !important;\n  padding-left: 8px;\n  padding-right: 0;\n}\n.rtl .ant-input-group > [class*=\"col-\"]:last-child {\n  padding-left: 0;\n}\n.rtl .gx-search-bar:not(.gx-lt-icon-search-bar-lg) input[type=\"search\"] {\n  padding-left: 35px;\n  padding-right: 9px;\n}\n.rtl .gx-search-bar:not(.gx-lt-icon-search-bar-lg) .gx-search-icon {\n  right: auto;\n  left: 0;\n}\n.rtl .gx-header-search .ant-select-selection,\n.rtl .gx-header-search .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  -webkit-border-radius: 4px 0 0 4px;\n  -moz-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n}\n.rtl .gx-header-search .gx-lt-icon-search-bar-lg input[type=\"search\"] {\n  -webkit-border-radius: 0 4px 4px 0;\n  -moz-border-radius: 0 4px 4px 0;\n  border-radius: 0 4px 4px 0;\n}\n.rtl .ant-input-group > .ant-input:last-child,\n.rtl .ant-input-group-addon:last-child {\n  border-radius: 6px 0 0 6px;\n}\n.rtl .ant-input-search-rtl > .ant-input-group > .ant-input-group-addon .ant-input-search-button {\n  border-radius: 6px 0 0 6px;\n}\n.rtl .rbc-btn-group button + button {\n  margin-right: -1px;\n  margin-left: 0;\n}\n.rtl .rbc-btn-group button:last-child:not(:first-child) {\n  border-radius: 4px 0 0 4px;\n}\n.rtl .rbc-btn-group button:first-child:not(:last-child) {\n  border-radius: 0 4px 4px 0;\n}\n.rtl .rbc-header + .rbc-header,\n.rtl .rbc-day-bg + .rbc-day-bg {\n  border-right: 1px solid #DDD;\n  border-left: none;\n}\n.rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n.rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-right: 1px solid #DDD;\n}\n.rtl .gx-entry-title::before {\n  right: 0;\n  left: auto;\n}\n.rtl .ant-btn {\n  margin-left: 8px;\n  margin-right: 0;\n}\n.rtl .ant-btn-group:not(:last-child) {\n  margin-left: 15px;\n  margin-right: 0;\n}\n.rtl .ant-menu {\n  text-align: right;\n}\n.rtl .ant-dropdown-menu {\n  padding-right: 4px;\n}\n.rtl .ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon,\n.rtl .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon {\n  right: auto;\n  left: 8px;\n}\n.rtl .ant-pagination,\n.rtl .ant-cascader-menu,\n.rtl .ant-menu-item-group-list {\n  padding-right: 0;\n}\n.rtl .gx-package-items li i {\n  float: right;\n  margin-right: 0;\n  margin-left: 16px;\n}\n.rtl .gx-product-row {\n  text-align: left;\n}\n.rtl .gx-product-row.even {\n  text-align: right;\n}\n.rtl .gx-product-row .ant-btn {\n  margin-left: 0;\n}\n.rtl .amcharts-export-menu ul {\n  padding-right: 0;\n}\n.rtl .amcharts-export-menu .export-main > a,\n.rtl .amcharts-export-menu .export-drawing > a,\n.rtl .amcharts-export-menu .export-delayed-capturing > a {\n  text-indent: 13333337px;\n}\n.rtl .public-DraftStyleDefault-ltr {\n  direction: rtl;\n  text-align: right;\n}\n.rtl .rdw-dropdown-carettoopen {\n  left: 10%;\n  right: auto;\n}\n.rtl .gx-dragndrop-item .gx-draggable-icon {\n  margin-right: -16px;\n  margin-left: 0;\n}\n.rtl .ant-select-dropdown-menu,\n.rtl .gx-fnd-gallery-list,\n.rtl .gx-agents-list,\n.rtl .gx-sub-popover,\n.rtl .gx-user-popover,\n.rtl .gx-app-nav {\n  padding-right: 0;\n}\n.rtl .gx-form-inline-label-up .ant-form-item-label {\n  text-align: right;\n}\n.rtl .ant-form-rtl.ant-form-inline .ant-form-item {\n  margin-left: 0;\n}\n.rtl .gx-news-thumb {\n  margin-right: 0;\n  margin-left: 25px;\n}\n@media (max-width: 1366px) {\n  .rtl .gx-news-thumb {\n    margin-right: 0;\n    margin-left: 15px;\n  }\n}\n@media (max-width: 575px) {\n  .rtl .gx-news-thumb {\n    margin-left: 0;\n  }\n}\n.rtl .gx-news-tags-right {\n  padding-left: 0;\n  padding-right: 8px;\n  text-align: left;\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-card-ticketlist .gx-task-item-content {\n    padding-left: 0;\n  }\n}\n.rtl .gx-task-item-content .gx-task-date {\n  text-align: left;\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-task-item-content .gx-task-date {\n    right: auto;\n    left: 0;\n  }\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-task-item-content-left {\n    padding-right: 0;\n    padding-left: 60px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-card-ticketlist .gx-task-item-content-left {\n    padding-left: 0;\n  }\n}\n.rtl .gx-task-item-content-right {\n  padding-left: 0;\n  padding-right: 10px;\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-task-item-content-right {\n    padding-right: 0;\n  }\n}\n.rtl .gx-card-testimonial-img {\n  margin-right: 0;\n  margin-left: 10px;\n}\n.rtl .gx-card-testimonial-content {\n  margin-left: 0;\n  margin-right: 10px;\n}\n.rtl .gx-card-testimonial-content:before {\n  left: auto;\n  right: -10px;\n  border-right: 0 none;\n  border-left: 10px solid #f5f5f5;\n}\n.rtl .gx-progress-task-list-content {\n  margin-left: 0;\n  margin-right: 20px;\n}\n.rtl .gx-act-task-content label.ant-checkbox-wrapper span.ant-checkbox {\n  float: right;\n  padding-right: 0;\n  padding-left: 5px;\n}\n.rtl .gx-act-task-btn-view {\n  margin-left: 0;\n  margin-right: 8px;\n  text-align: left;\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-act-task-btn-view {\n    margin-right: 0;\n  }\n}\n.rtl .gx-line-indicator {\n  padding-right: 0;\n}\n.rtl .gx-line-indicator-col {\n  padding-right: 0;\n  padding-left: 10px;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-line-indicator-col {\n    padding-left: 0;\n  }\n}\n.rtl .gx-overview-description {\n  margin-left: -24px;\n  margin-right: 0;\n  border-left: 0 none;\n  border-right: solid 1px #e8e8e8;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-overview-description {\n    border-right: 0 none !important;\n  }\n}\n.rtl .gx-revenu-col:not(:last-child) {\n  border-right: 0 none;\n  border-left: solid 1px #e8e8e8;\n}\n.rtl .gx-rechart-prod {\n  left: 0;\n  right: 30px;\n}\n@media (max-width: 1366px) {\n  .rtl .gx-rechart-prod {\n    left: 0;\n  }\n}\n.rtl .gx-dot-arrow {\n  right: auto;\n  left: 0;\n  padding-right: 0;\n  padding-left: 10px;\n}\n.rtl .gx-hover-arrow {\n  left: 0;\n  right: 15px;\n  -webkit-border-radius: 0 50% 50% 0;\n  -moz-border-radius: 0 50% 50% 0;\n  border-radius: 0 50% 50% 0;\n}\n.rtl .gx-dot-arrow-hover:hover .gx-hover-arrow {\n  left: auto;\n  right: -15px;\n}\n.rtl .gx-user-wid img {\n  left: auto;\n  right: 0;\n}\n.rtl .gx-widget-badge {\n  right: auto;\n  left: 0;\n  -webkit-border-radius: 10px 0 10px 0;\n  -moz-border-radius: 10px 0 10px 0;\n  border-radius: 10px 0 10px 0;\n}\n.rtl .gx-fnd-content {\n  padding-right: 0;\n  padding-left: 40px;\n}\n@media (max-width: 1366px) {\n  .rtl .gx-fnd-content {\n    padding-left: 0;\n  }\n}\n.rtl .gx-fillchart-content {\n  left: auto;\n  right: 0;\n}\n.rtl .gx-fillchart .gx-chart-up,\n.rtl .gx-fillchart .gx-chart-down {\n  margin-right: 0;\n  margin-left: 6px;\n}\n.rtl .gx-fillchart-btn,\n.rtl .gx-fillchart-btn-close {\n  right: 0;\n  left: 10px;\n}\n.rtl .gx-fillchart-nocontent .ant-card-head-title {\n  left: 0;\n}\n.rtl .gx-featured-thumb {\n  margin-right: 0;\n  margin-left: 25px;\n}\n@media (max-width: 575px) {\n  .rtl .gx-featured-thumb {\n    margin-left: 0;\n  }\n}\n.rtl .gx-featured-thumb .ant-tag {\n  left: auto;\n  right: 15px;\n}\n.rtl .gx-featured-content-right {\n  margin-left: 0;\n  margin-right: auto;\n  text-align: left;\n}\n@media (max-width: 767px) {\n  .rtl .gx-featured-content-right {\n    margin-right: 0;\n    text-align: right;\n  }\n}\n@media (max-width: 1199px) {\n  .rtl .gx-card-profile .gx-featured-content-right {\n    text-align: right;\n    margin-right: 0;\n  }\n}\n.rtl .gx-currentplan-right {\n  border-left: 0 none;\n  border-right: solid 1px #e8e8e8;\n}\n@media (max-width: 1366px) {\n  .rtl .gx-currentplan-right {\n    border-right: 0 none !important;\n  }\n}\n@media (max-width: 991px) {\n  .rtl .gx-currentplan-right {\n    border-left: 0 none !important;\n    border-right: solid 1px #e8e8e8 !important;\n  }\n}\n@media (max-width: 575px) {\n  .rtl .gx-currentplan-right {\n    border-right: 0 none !important;\n  }\n}\n.rtl .gx-currentplan-right-content {\n  text-align: left;\n}\n@media (max-width: 1366px) {\n  .rtl .gx-currentplan-right-content {\n    text-align: right;\n  }\n}\n@media (max-width: 991px) {\n  .rtl .gx-currentplan-right-content {\n    text-align: left;\n  }\n}\n@media (max-width: 575px) {\n  .rtl .gx-currentplan-right-content {\n    text-align: right;\n  }\n}\n.rtl .gx-dealclose-header-right {\n  margin-left: 0;\n  margin-right: auto;\n}\n@media (max-width: 1366px) {\n  .rtl .gx-dealclose-header-right {\n    margin-right: 0;\n  }\n}\n@media (max-width: 991px) {\n  .rtl .gx-dealclose-header-right {\n    margin-left: 0;\n    margin-right: auto;\n  }\n}\n@media (max-width: 575px) {\n  .rtl .gx-dealclose-header-right {\n    margin-right: 0;\n  }\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-dash-search {\n    padding-right: 0;\n    padding-left: 30px;\n  }\n  .rtl .gx-dash-search .gx-search-icon {\n    right: auto;\n    left: 0;\n  }\n}\n.rtl .gx-bg-dark-primary:before {\n  left: auto;\n  right: 0;\n}\n.rtl .icon-long-arrow-right:before {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rtl .icon-search-new:before,\n.rtl .icon-search:before {\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n  display: inline-block;\n}\n.rtl span.gx-chart-up,\n.rtl span.gx-chart-down {\n  display: inline-block;\n}\n.rtl .gx-slick-slider-dot-top {\n  padding-left: 24px;\n  padding-right: 0;\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-slick-slider-dot-top {\n    padding-right: 24px;\n  }\n}\n.rtl .gx-customizer-option {\n  right: auto;\n  left: 0;\n}\n.rtl .full-scroll.framed-layout .gx-customizer-option {\n  right: auto;\n  left: 20px;\n}\n@media screen and (max-width: 991px) {\n  .rtl .full-scroll.framed-layout .gx-customizer-option {\n    left: 0;\n  }\n}\n.rtl .gx-color-option {\n  padding-right: 0;\n}\n.rtl .gx-color-option li .gx-link:before,\n.rtl .gx-color-option li .gx-link:after {\n  left: auto;\n  right: 0;\n}\n.rtl .gx-cus-customiz {\n  padding-right: 0;\n  padding-left: 20px;\n}\n.rtl .gx-header-notifications {\n  padding-right: 0;\n}\n.rtl .gx-header-notifications > li:not(:last-child) {\n  margin-right: 0;\n  margin-left: 42px;\n}\n@media screen and (max-width: 991px) {\n  .rtl .gx-header-notifications > li:not(:last-child) {\n    margin-right: 0;\n    margin-left: 16px;\n  }\n}\n.rtl .gx-inside-header-horizontal .gx-header-notifications > li:not(:last-child) {\n  margin-right: 0;\n  margin-left: 20px;\n}\n.rtl .gx-header-horizontal-main .gx-header-notifications > li:not(:last-child),\n.rtl .gx-header-horizontal-nav .gx-header-notifications > li:not(:last-child) {\n  margin-right: 0;\n  margin-left: 30px;\n}\n@media screen and (max-width: 991px) {\n  .rtl .gx-header-horizontal-main .gx-header-notifications > li:not(:last-child),\n  .rtl .gx-header-horizontal-nav .gx-header-notifications > li:not(:last-child) {\n    margin-right: 0;\n    margin-left: 16px;\n  }\n}\n.rtl .gx-header-notifications > li.gx-notify {\n  margin-right: 0;\n  margin-left: 22px;\n}\n@media screen and (max-width: 991px) {\n  .rtl .gx-header-notifications > li.gx-notify {\n    margin-right: 0;\n    margin-left: 16px;\n  }\n}\n.rtl .gx-header-horizontal-main .gx-header-notifications > li.gx-notify {\n  margin-right: 0;\n  margin-left: 30px;\n}\n@media screen and (max-width: 991px) {\n  .rtl .gx-header-horizontal-main .gx-header-notifications > li.gx-notify {\n    margin-right: 0;\n    margin-left: 16px;\n  }\n}\n.rtl .gx-inside-header-horizontal .gx-header-notifications > li.gx-notify {\n  margin-right: 0;\n  margin-left: 20px;\n}\n.rtl .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {\n  margin-left: 0;\n  margin-right: 50px;\n}\n@media screen and (max-width: 991px) {\n  .rtl .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {\n    margin-right: 0;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .rtl .gx-inside-header-horizontal .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {\n    margin-right: 0;\n  }\n}\n.rtl .gx-header-horizontal-dark:before {\n  right: auto;\n  left: 169px;\n}\n@media screen and (max-width: 1049px) {\n  .rtl .gx-header-horizontal-dark:before {\n    right: auto;\n    left: 110px;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .rtl .gx-header-horizontal-dark:before {\n    right: auto;\n    left: 80px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .rtl .gx-header-horizontal-dark:before {\n    right: auto;\n    left: 140px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-header-horizontal-dark:before {\n    right: auto;\n    left: 60px;\n  }\n}\n.rtl .gx-header-horizontal-top-left {\n  margin-right: 0;\n  margin-left: 15px;\n}\n@media screen and (max-width: 767px) {\n  .rtl .gx-header-horizontal-top-left {\n    margin-left: 0;\n  }\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-header-horizontal-main .gx-w-logo {\n    padding-left: 0;\n  }\n}\n.rtl .gx-inside-header-horizontal .gx-logo {\n  margin-right: 0;\n  margin-left: 25px;\n}\n.rtl .gx-login-list {\n  margin-left: 0;\n  margin-right: auto;\n  padding-right: 0;\n}\n.rtl .gx-login-list li:not(:first-child) {\n  border-left: 0 none;\n  border-right: solid 1px #e8e8e8;\n}\n.rtl .gx-header-horizontal-dark .gx-login-list li:not(:first-child) {\n  border: 0 none;\n}\n.rtl .gx-header-search {\n  margin-left: 0;\n  margin-right: 28px;\n}\n.rtl .gx-header-horizontal-dark .gx-header-search .ant-select-selection {\n  margin-left: 0;\n  margin-right: 1px;\n}\n.rtl .gx-popover-horizantal .ant-btn {\n  border-right: 0 none;\n  border-left: solid 1px #e8e8e8;\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-popover-horizantal {\n    left: auto !important;\n    right: 0 !important;\n  }\n  .rtl .gx-popover-horizantal .gx-sub-popover {\n    padding-left: 0;\n    padding-right: 5px;\n  }\n}\n.rtl .gx-no-header-horizontal {\n  padding-right: 79px;\n  padding-left: 32px;\n}\n.rtl .gx-no-header-horizontal .gx-linebar {\n  left: auto;\n  right: 32px;\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-no-header-horizontal .gx-linebar {\n    left: auto;\n    right: 15px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .rtl .gx-no-header-horizontal {\n    padding-right: 60px;\n    padding-left: 15px;\n  }\n}\n.rtl .gx-layout-sider-header {\n  padding-right: 70px;\n  padding-left: 30px;\n}\n.rtl .gx-layout-sider-header .gx-linebar {\n  left: auto;\n  right: 20px;\n}\n@media screen and (max-width: 991px) {\n  .rtl .gx-layout-sider-header {\n    padding-right: 30px;\n  }\n}\n.rtl .ant-layout-sider-collapsed .gx-layout-sider-header {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.rtl .gx-drawer-sidebar .gx-layout-sider-header,\n.rtl .gx-custom-sidebar .gx-layout-sider-header {\n  padding-left: 30px;\n}\n.rtl .gx-mini-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header,\n.rtl .gx-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header {\n  border-right: 1px solid #e8e8e8;\n}\n.rtl .ant-layout-sider-collapsed .gx-layout-sider-header .gx-linebar {\n  left: auto;\n}\n.rtl .gx-mini-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header,\n.rtl .gx-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header {\n  border-right: 0 none;\n  border-left: 1px solid #e8e8e8;\n}\n.rtl .gx-sidebar-content {\n  border-right: 0 none;\n  border-left: 1px solid #e8e8e8;\n}\n.rtl .gx-layout-sider-dark .gx-sidebar-content,\n.rtl .gx-drawer-sidebar-dark .gx-sidebar-content {\n  border-left: 0 none;\n}\n.rtl .gx-avatar-row .ant-avatar {\n  left: auto;\n  right: 0;\n}\n.rtl .ant-layout-sider-collapsed .gx-avatar-row .ant-avatar {\n  left: auto;\n  right: -10px;\n}\n.rtl .gx-list-group,\n.rtl .gx-dot-list,\n.rtl .gx-fnd-list,\n.rtl .gx-follower-list,\n.rtl .gx-gallery-list,\n.rtl .gx-package-items,\n.rtl .gx-list-inline {\n  padding-right: 0;\n}\n.rtl .gx-list-group li i,\n.rtl .gx-list-group li .anticon {\n  margin-left: 12px;\n  margin-right: 0;\n}\n.rtl .gx-dot-list {\n  margin-right: -3px !important;\n}\n.rtl .gx-text-left {\n  text-align: right !important;\n}\n.rtl .gx-text-right {\n  text-align: left !important;\n}\n@media (min-width: 576px) {\n  .rtl .gx-mr-sm-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n  .rtl .gx-ml-sm-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n  .rtl .gx-mr-sm-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n  .rtl .gx-ml-sm-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n  .rtl .gx-mr-sm-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n  .rtl .gx-ml-sm-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n  .rtl .gx-mr-sm-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n  .rtl .gx-ml-sm-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n  .rtl .gx-mr-sm-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n  .rtl .gx-ml-sm-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n  .rtl .gx-pr-sm-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n  .rtl .gx-pl-sm-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n  .rtl .gx-pr-sm-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n  .rtl .gx-pl-sm-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n  .rtl .gx-pr-sm-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n  .rtl .gx-pl-sm-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n  .rtl .gx-pr-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .rtl .gx-pl-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .rtl .gx-pr-sm-5 {\n    padding-right: 0 !important;\n    padding-left: 2rem !important;\n  }\n  .rtl .gx-pl-sm-5 {\n    padding-left: 0 !important;\n    padding-right: 2rem !important;\n  }\n  .rtl .gx-mr-sm-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n  .rtl .gx-ml-sm-auto {\n    margin-left: 0 !important;\n    margin-right: auto !important;\n  }\n  .rtl .gx-float-sm-left {\n    float: right !important;\n  }\n  .rtl .gx-float-sm-right {\n    float: left !important;\n  }\n}\n@media (min-width: 768px) {\n  .rtl .gx-mr-md-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n  .rtl .gx-ml-md-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n  .rtl .gx-mr-md-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n  .rtl .gx-ml-md-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n  .rtl .gx-mr-md-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n  .rtl .gx-ml-md-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n  .rtl .gx-mr-md-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n  .rtl .gx-ml-md-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n  .rtl .gx-mr-md-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n  .rtl .gx-ml-md-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n  .rtl .gx-pr-md-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n  .rtl .gx-pl-md-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n  .rtl .gx-pr-md-2,\n  .rtl .gx-px-md-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n  .rtl .gx-pl-md-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n  .rtl .gx-pr-md-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n  .rtl .gx-pl-md-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n  .rtl .gx-pr-md-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n  .rtl .gx-pl-md-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n  .rtl .gx-pr-md-5 {\n    padding-right: 0 !important;\n    padding-left: 2rem !important;\n  }\n  .rtl .gx-pl-md-5 {\n    padding-left: 0 !important;\n    padding-right: 2rem !important;\n  }\n  .rtl .gx-mr-md-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n  .rtl .gx-ml-md-auto {\n    margin-left: 0 !important;\n    margin-right: auto !important;\n  }\n  .rtl .gx-float-md-left {\n    float: right !important;\n  }\n  .rtl .gx-float-md-right {\n    float: left !important;\n  }\n  .rtl .ant-col-rtl.ant-col-md-15.gx-pr-md-2 {\n    padding-right: 16px !important;\n  }\n}\n@media (min-width: 992px) {\n  .rtl .gx-mr-lg-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n  .rtl .gx-ml-lg-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n  .rtl .gx-mr-lg-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n  .rtl .gx-ml-lg-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n  .rtl .gx-mr-lg-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n  .rtl .gx-ml-lg-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n  .rtl .gx-mr-lg-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n  .rtl .gx-ml-lg-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n  .rtl .gx-mr-lg-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n  .rtl .gx-ml-lg-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n  .rtl .gx-pr-lg-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n  .rtl .gx-pl-lg-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n  .rtl .gx-pr-lg-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n  .rtl .gx-pl-lg-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n  .rtl .gx-pr-lg-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n  .rtl .gx-pl-lg-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n  .rtl .gx-pr-lg-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n  .rtl .gx-pl-lg-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n  .rtl .gx-pr-lg-5 {\n    padding-right: 0 !important;\n    padding-left: 2rem !important;\n  }\n  .rtl .gx-pl-lg-5 {\n    padding-left: 0 !important;\n    padding-right: 2rem !important;\n  }\n  .rtl .gx-mr-lg-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n  .rtl .gx-ml-lg-auto {\n    margin-left: 0 !important;\n    margin-right: auto !important;\n  }\n  .rtl .gx-float-lg-left {\n    float: right !important;\n  }\n  .rtl .gx-float-lg-right {\n    float: left !important;\n  }\n}\n@media (min-width: 1200px) {\n  .rtl .gx-mr-xl-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n  .rtl .gx-ml-xl-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n  .rtl .gx-mr-xl-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n  .rtl .gx-ml-xl-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n  .rtl .gx-mr-xl-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n  .rtl .gx-ml-xl-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n  .rtl .gx-mr-xl-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n  .rtl .gx-ml-xl-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n  .rtl .gx-mr-xl-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n  .rtl .gx-ml-xl-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n  .rtl .gx-pr-xl-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n  .rtl .gx-pl-xl-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n  .rtl .gx-pr-xl-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n  .rtl .gx-pl-xl-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n  .rtl .gx-pr-xl-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n  .rtl .gx-pl-xl-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n  .rtl .gx-pr-xl-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n  .rtl .gx-pl-xl-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n  .rtl .gx-pr-xl-5 {\n    padding-right: 0 !important;\n    padding-left: 2rem !important;\n  }\n  .rtl .gx-pl-xl-5 {\n    padding-left: 0 !important;\n    padding-right: 2rem !important;\n  }\n  .rtl .gx-mr-xl-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n  .rtl .gx-ml-xl-auto {\n    margin-left: 0 !important;\n    margin-right: auto !important;\n  }\n  .rtl .gx-float-xl-left {\n    float: right !important;\n  }\n  .rtl .gx-float-xl-right {\n    float: left !important;\n  }\n}\n@media (min-width: 1368px) {\n  .rtl .gx-mr-xxl-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n  .rtl .gx-ml-xxl-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n  .rtl .gx-mr-xxl-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n  .rtl .gx-ml-xxl-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n  .rtl .gx-mr-xxl-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n  .rtl .gx-ml-xxl-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n  .rtl .gx-mr-xxl-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n  .rtl .gx-ml-xxl-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n  .rtl .gx-mr-xxl-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n  .rtl .gx-ml-xxl-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n  .rtl .gx-pr-xxl-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n  .rtl .gx-pl-xxl-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n  .rtl .gx-pr-xxl-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n  .rtl .gx-pl-xxl-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n  .rtl .gx-pr-xxl-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n  .rtl .gx-pl-xxl-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n  .rtl .gx-pr-xxl-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n  .rtl .gx-pl-xxl-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n  .rtl .gx-pr-xxl-5 {\n    padding-right: 0 !important;\n    padding-left: 2rem !important;\n  }\n  .rtl .gx-pl-xxl-5 {\n    padding-left: 0 !important;\n    padding-right: 2rem !important;\n  }\n  .rtl .gx-mr-xxl-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n  .rtl .gx-ml-xxl-auto {\n    margin-left: 0 !important;\n    margin-right: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
